
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire02e5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire02e5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});




parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});



parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $040dbb9c344a508d$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $040dbb9c344a508d$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.12.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $2vsP7.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(form);
        // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $040dbb9c344a508d$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $aphAM.UNSAFE_mapRouteProperties)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message);
            // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
// Webpack + React 17 fails to compile on the usage of `React.startTransition` or
// `React["startTransition"]` even if it's behind a feature detection of
// `"startTransition" in React`. Moving this to a constant avoids the issue :/
const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $040dbb9c344a508d$var$START_TRANSITION in $acw62 ? $acw62[$040dbb9c344a508d$var$START_TRANSITION](()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $040dbb9c344a508d$var$START_TRANSITION in $acw62 ? $acw62[$040dbb9c344a508d$var$START_TRANSITION](()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $040dbb9c344a508d$var$START_TRANSITION in $acw62 ? $acw62[$040dbb9c344a508d$var$START_TRANSITION](()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    return $040dbb9c344a508d$var$useSubmitImpl();
}
function $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let currentRouteId = (0, $aphAM.UNSAFE_useRouteId)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action, method: method, encType: encType, formData: formData } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, options, basename);
        // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $040dbb9c344a508d$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $2vsP7.UNSAFE_invariant)(false);
            !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $aphAM.unstable_useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", () => $1d34d5c4a288b213$export$90ba53ce1c7fdff2);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "ErrorResponse", () => $1d34d5c4a288b213$export$acf1a680051f5031);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.6.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star];
            // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Missing \":" + key + "\" param");
            return param;
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        }
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $1d34d5c4a288b213$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = {
                state: "idle",
                data: actionResult.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, $1d34d5c4a288b213$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key);
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error && !$1d34d5c4a288b213$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $1d34d5c4a288b213$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    }
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    let searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $1d34d5c4a288b213$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) : formData;
    }
    // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return result;
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $1d34d5c4a288b213$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useMatch", () => $7939e29d663dd3ed$export$6c330e8992e8a295);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $7939e29d663dd3ed$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "unstable_useBlocker", () => $7939e29d663dd3ed$export$2af03a1de5c0910);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "Route", () => $7939e29d663dd3ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $7939e29d663dd3ed$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $7939e29d663dd3ed$export$52b333d321859367);
/**
 * React Router v6.12.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($7939e29d663dd3ed$var$DataRouterHook || ($7939e29d663dd3ed$var$DataRouterHook = {}));
var $7939e29d663dd3ed$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($7939e29d663dd3ed$var$DataRouterStateHook || ($7939e29d663dd3ed$var$DataRouterStateHook = {}));
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $acw62.useState(()=>String(++$7939e29d663dd3ed$var$blockerId));
    let blockerFunction = $acw62.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction);
    // Cleanup on unmount
    $acw62.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]);
    // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
// Webpack + React 17 fails to compile on the usage of `React.startTransition` or
// `React["startTransition"]` even if it's behind a feature detection of
// `"startTransition" in React`. Moving this to a constant avoids the issue :/
const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $acw62.useState(router.state);
    let setState = $acw62.useCallback((newState)=>{
        $7939e29d663dd3ed$var$START_TRANSITION in $acw62 ? $acw62[$7939e29d663dd3ed$var$START_TRANSITION](()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $7939e29d663dd3ed$var$START_TRANSITION in $acw62 ? $acw62[$7939e29d663dd3ed$var$START_TRANSITION](()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2vsP7.resolveTo)(to, (0, $2vsP7.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($7939e29d663dd3ed$var$AwaitRenderStatus || ($7939e29d663dd3ed$var$AwaitRenderStatus = {}));
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("lmFrL", function(module, exports) {

$parcel$export(module.exports, "css", () => $f8dbcd8598db1f0b$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");

var $acw62 = parcelRequire("acw62");

var $i5C3F = parcelRequire("i5C3F");

var $demXJ = parcelRequire("demXJ");

var $iDSBG = parcelRequire("iDSBG");

var $lLrnU = parcelRequire("lLrnU");

var $9ORqK = parcelRequire("9ORqK");
function $f8dbcd8598db1f0b$var$v() {
    return ($f8dbcd8598db1f0b$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $4jPKB.typeOf)(t);
}, $f8dbcd8598db1f0b$var$w = Object.freeze([]), $f8dbcd8598db1f0b$var$E = Object.freeze({});
function $f8dbcd8598db1f0b$var$b(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$A = "data-styled", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.3", $f8dbcd8598db1f0b$var$I = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $f8dbcd8598db1f0b$var$O = {}, $f8dbcd8598db1f0b$var$R = {};
function $f8dbcd8598db1f0b$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f8dbcd8598db1f0b$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = new Map, $f8dbcd8598db1f0b$var$V = 1, $f8dbcd8598db1f0b$var$B = function(e) {
    if ($f8dbcd8598db1f0b$var$x.has(e)) return $f8dbcd8598db1f0b$var$x.get(e);
    for(; $f8dbcd8598db1f0b$var$k.has($f8dbcd8598db1f0b$var$V);)$f8dbcd8598db1f0b$var$V++;
    var t = $f8dbcd8598db1f0b$var$V++;
    return $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e), t;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$k.get(e);
}, $f8dbcd8598db1f0b$var$M = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$V && ($f8dbcd8598db1f0b$var$V = t + 1), $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e);
}, $f8dbcd8598db1f0b$var$G = "style[" + $f8dbcd8598db1f0b$var$A + '][data-styled-version="5.3.3"]', $f8dbcd8598db1f0b$var$L = new RegExp("^" + $f8dbcd8598db1f0b$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$M(u, c), $f8dbcd8598db1f0b$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$A, "active"), r.setAttribute("data-styled-version", "5.3.3");
    var i = $f8dbcd8598db1f0b$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$J = $f8dbcd8598db1f0b$var$I, $f8dbcd8598db1f0b$var$X = {
    isServer: !$f8dbcd8598db1f0b$var$I,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$P
}, $f8dbcd8598db1f0b$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$E), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$v({}, $f8dbcd8598db1f0b$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$I && $f8dbcd8598db1f0b$var$J && ($f8dbcd8598db1f0b$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$A) && ($f8dbcd8598db1f0b$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$U(o) : r ? new $f8dbcd8598db1f0b$var$$(o) : new $f8dbcd8598db1f0b$var$W(o), new $f8dbcd8598db1f0b$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$K = /(a)(d)/gi, $f8dbcd8598db1f0b$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$Q(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$Q(t % 52) + n).replace($f8dbcd8598db1f0b$var$K, "$1-$2");
}
var $f8dbcd8598db1f0b$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$ne = function(e) {
    return $f8dbcd8598db1f0b$var$te(5381, e);
};
function $f8dbcd8598db1f0b$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$b(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$oe = $f8dbcd8598db1f0b$var$ne("5.3.3"), $f8dbcd8598db1f0b$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$re(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$oe, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$Ne(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$ie = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$E : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$E : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$w : c, l = new (0, $demXJ.default)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$j(15), $f8dbcd8598db1f0b$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$he = ($f8dbcd8598db1f0b$var$de.Consumer, new $f8dbcd8598db1f0b$var$Z), $f8dbcd8598db1f0b$var$pe = $f8dbcd8598db1f0b$var$ce();
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$var$me() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$de) || $f8dbcd8598db1f0b$var$pe;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$fe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $f8dbcd8598db1f0b$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$pe), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ge = /([A-Z])/, $f8dbcd8598db1f0b$var$Se = /([A-Z])/g, $f8dbcd8598db1f0b$var$we = /^ms-/, $f8dbcd8598db1f0b$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$be(e) {
    return $f8dbcd8598db1f0b$var$ge.test(e) ? e.replace($f8dbcd8598db1f0b$var$Se, $f8dbcd8598db1f0b$var$Ee).replace($f8dbcd8598db1f0b$var$we, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$_e(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f8dbcd8598db1f0b$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$b(t[i]) ? s.push($f8dbcd8598db1f0b$var$be(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $iDSBG.default) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$b(e) || $f8dbcd8598db1f0b$var$S(e) ? $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g($f8dbcd8598db1f0b$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g(e, n)));
}
var $f8dbcd8598db1f0b$var$Ie = /invalid hook call/i, $f8dbcd8598db1f0b$var$Pe = new Set, $f8dbcd8598db1f0b$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $f8dbcd8598db1f0b$var$Re = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$je = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$Te(e) {
    return e.replace($f8dbcd8598db1f0b$var$De, "-").replace($f8dbcd8598db1f0b$var$je, "");
}
var $f8dbcd8598db1f0b$var$xe = function(e) {
    return $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$ne(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$ke(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$ze(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$Ve(t) && $f8dbcd8598db1f0b$var$Ve(r) ? $f8dbcd8598db1f0b$var$Me(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$Ve(i)) for(var a in i)$f8dbcd8598db1f0b$var$Be(a) && $f8dbcd8598db1f0b$var$ze(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$j(14);
            if ($f8dbcd8598db1f0b$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$j(8) : t ? $f8dbcd8598db1f0b$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ye = {};
function $f8dbcd8598db1f0b$var$qe(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$ke(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$Te(e);
        $f8dbcd8598db1f0b$var$Ye[n] = ($f8dbcd8598db1f0b$var$Ye[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$xe("5.3.3" + n + $f8dbcd8598db1f0b$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $f8dbcd8598db1f0b$var$ke(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $f8dbcd8598db1f0b$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$E);
                var r = $f8dbcd8598db1f0b$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Re(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$fe(), s = $f8dbcd8598db1f0b$var$me(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $f8dbcd8598db1f0b$var$ke(_), A = g !== t ? $f8dbcd8598db1f0b$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $lLrnU.default), _) : !N || (0, $lLrnU.default)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $f8dbcd8598db1f0b$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $acw62.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$ke(e) ? e : $f8dbcd8598db1f0b$var$Te($f8dbcd8598db1f0b$var$_(e)));
        return $f8dbcd8598db1f0b$var$qe(e, $f8dbcd8598db1f0b$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $f8dbcd8598db1f0b$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$E), !(0, $4jPKB.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$j(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$He[e] = $f8dbcd8598db1f0b$var$He(e);
});
var $f8dbcd8598db1f0b$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$re(e), $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$xe(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$$e(i, a);
    function l(e) {
        var t = $f8dbcd8598db1f0b$var$fe(), n = $f8dbcd8598db1f0b$var$me(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), l = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$O, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$v({}, t, {
                theme: $f8dbcd8598db1f0b$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$xe(o);
    return new $f8dbcd8598db1f0b$var$ve(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$A + '="true"',
                'data-styled-version="5.3.3"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$j(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$A] = "", t["data-styled-version"] = "5.3.3", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$j(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$_(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Z,
    masterSheet: $f8dbcd8598db1f0b$var$he
};
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$He;

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = 60103, $6b3372b60d35b33f$var$c = 60106, $6b3372b60d35b33f$var$d = 60107, $6b3372b60d35b33f$var$e = 60108, $6b3372b60d35b33f$var$f = 60114, $6b3372b60d35b33f$var$g = 60109, $6b3372b60d35b33f$var$h = 60110, $6b3372b60d35b33f$var$k = 60112, $6b3372b60d35b33f$var$l = 60113, $6b3372b60d35b33f$var$m = 60120, $6b3372b60d35b33f$var$n = 60115, $6b3372b60d35b33f$var$p = 60116, $6b3372b60d35b33f$var$q = 60121, $6b3372b60d35b33f$var$r = 60122, $6b3372b60d35b33f$var$u = 60117, $6b3372b60d35b33f$var$v = 60129, $6b3372b60d35b33f$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $6b3372b60d35b33f$var$x = Symbol.for;
    $6b3372b60d35b33f$var$b = $6b3372b60d35b33f$var$x("react.element");
    $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$x("react.portal");
    $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$x("react.fragment");
    $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$x("react.strict_mode");
    $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$x("react.profiler");
    $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$x("react.provider");
    $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$x("react.context");
    $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$x("react.forward_ref");
    $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$x("react.suspense");
    $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$x("react.suspense_list");
    $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$x("react.memo");
    $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$x("react.lazy");
    $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$x("react.block");
    $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$x("react.server.block");
    $6b3372b60d35b33f$var$u = $6b3372b60d35b33f$var$x("react.fundamental");
    $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$x("react.debug_trace_mode");
    $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$x("react.legacy_hidden");
}
function $6b3372b60d35b33f$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return t;
        }
    }
}
var $6b3372b60d35b33f$var$z = $6b3372b60d35b33f$var$g, $6b3372b60d35b33f$var$A = $6b3372b60d35b33f$var$b, $6b3372b60d35b33f$var$B = $6b3372b60d35b33f$var$k, $6b3372b60d35b33f$var$C = $6b3372b60d35b33f$var$d, $6b3372b60d35b33f$var$D = $6b3372b60d35b33f$var$p, $6b3372b60d35b33f$var$E = $6b3372b60d35b33f$var$n, $6b3372b60d35b33f$var$F = $6b3372b60d35b33f$var$c, $6b3372b60d35b33f$var$G = $6b3372b60d35b33f$var$f, $6b3372b60d35b33f$var$H = $6b3372b60d35b33f$var$e, $6b3372b60d35b33f$var$I = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$z;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$B;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$C;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$D;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$E;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$F;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$G;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$H;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$I;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$y(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$v || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$l || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$w || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$u || a.$$typeof === $6b3372b60d35b33f$var$q || a[0] === $6b3372b60d35b33f$var$r) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$y;

});


parcelRegister("i5C3F", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("demXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1e650477d9d52e$export$2e2bcd8739ae039);
function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;

});

parcelRegister("iDSBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9263a4c6739b952$export$2e2bcd8739ae039);
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;

});

parcelRegister("lLrnU", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd833ac96e60404e$export$2e2bcd8739ae039);

var $marvo = parcelRequire("marvo");
var $fd833ac96e60404e$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $fd833ac96e60404e$var$index = (0, $marvo.default)(function(prop) {
    return $fd833ac96e60404e$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $fd833ac96e60404e$export$2e2bcd8739ae039 = $fd833ac96e60404e$var$index;

});
parcelRegister("marvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $042a27e0d68f1307$export$2e2bcd8739ae039);
function $042a27e0d68f1307$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $042a27e0d68f1307$export$2e2bcd8739ae039 = $042a27e0d68f1307$var$memoize;

});


parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("gijsP", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $bdcd6ced2cdccd72$export$a7c73072b1a182ae, (v) => $bdcd6ced2cdccd72$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bdcd6ced2cdccd72$export$9f27bc3417b4524d, (v) => $bdcd6ced2cdccd72$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac, (v) => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35, (v) => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bdcd6ced2cdccd72$export$ffb0004e005737fa, (v) => $bdcd6ced2cdccd72$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bdcd6ced2cdccd72$export$b624eff549462981, (v) => $bdcd6ced2cdccd72$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bdcd6ced2cdccd72$export$7897aa7841a5380c, (v) => $bdcd6ced2cdccd72$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bdcd6ced2cdccd72$export$602eac185826482c, (v) => $bdcd6ced2cdccd72$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bdcd6ced2cdccd72$export$e2c29f18771995cb, (v) => $bdcd6ced2cdccd72$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bdcd6ced2cdccd72$export$5f8d39834fd61797, (v) => $bdcd6ced2cdccd72$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5, (v) => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $bdcd6ced2cdccd72$export$998bcd577473dd93, (v) => $bdcd6ced2cdccd72$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bdcd6ced2cdccd72$export$b706b080d889d2c9, (v) => $bdcd6ced2cdccd72$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bdcd6ced2cdccd72$export$5be5a87408f70ddc, (v) => $bdcd6ced2cdccd72$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d, (v) => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bdcd6ced2cdccd72$export$455c2e768291efa6, (v) => $bdcd6ced2cdccd72$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bdcd6ced2cdccd72$export$9522e17588c12572, (v) => $bdcd6ced2cdccd72$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bdcd6ced2cdccd72$export$2110ac352bb060b9, (v) => $bdcd6ced2cdccd72$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bdcd6ced2cdccd72$export$56885ab8b9c456ab, (v) => $bdcd6ced2cdccd72$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de, (v) => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bdcd6ced2cdccd72$export$b82d16f27459e05a, (v) => $bdcd6ced2cdccd72$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bdcd6ced2cdccd72$export$522c17b4f5e123e8, (v) => $bdcd6ced2cdccd72$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6, (v) => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $bdcd6ced2cdccd72$export$3d6c20d97e46b957, (v) => $bdcd6ced2cdccd72$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $bdcd6ced2cdccd72$export$9b621391a187a31a, (v) => $bdcd6ced2cdccd72$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f, (v) => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bdcd6ced2cdccd72$export$a7c73072b1a182ae;
var $bdcd6ced2cdccd72$export$9f27bc3417b4524d;
var $bdcd6ced2cdccd72$export$db77ccec0bb4ccac;
var $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35;
var $bdcd6ced2cdccd72$export$ffb0004e005737fa;
var $bdcd6ced2cdccd72$export$b624eff549462981;
var $bdcd6ced2cdccd72$export$7897aa7841a5380c;
var $bdcd6ced2cdccd72$export$602eac185826482c;
var $bdcd6ced2cdccd72$export$e2c29f18771995cb;
var $bdcd6ced2cdccd72$export$5f8d39834fd61797;
var $bdcd6ced2cdccd72$export$74bf444e3cd11ea5;
var $bdcd6ced2cdccd72$export$998bcd577473dd93;
var $bdcd6ced2cdccd72$export$b706b080d889d2c9;
var $bdcd6ced2cdccd72$export$5be5a87408f70ddc;
var $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d;
var $bdcd6ced2cdccd72$export$455c2e768291efa6;
var $bdcd6ced2cdccd72$export$9522e17588c12572;
var $bdcd6ced2cdccd72$export$2110ac352bb060b9;
var $bdcd6ced2cdccd72$export$56885ab8b9c456ab;
var $bdcd6ced2cdccd72$export$d927fcb6adf8f9de;
var $bdcd6ced2cdccd72$export$b82d16f27459e05a;
var $bdcd6ced2cdccd72$export$522c17b4f5e123e8;
var $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6;
var $bdcd6ced2cdccd72$export$3d6c20d97e46b957;
var $bdcd6ced2cdccd72$export$9b621391a187a31a;
var $bdcd6ced2cdccd72$export$f5bbd400c2f4426f;
"use strict";
var $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bdcd6ced2cdccd72$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE:
                                return object;
                            case $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$bdcd6ced2cdccd72$export$a7c73072b1a182ae = $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
$bdcd6ced2cdccd72$export$9f27bc3417b4524d = $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
$bdcd6ced2cdccd72$export$db77ccec0bb4ccac = $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
$bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
$bdcd6ced2cdccd72$export$ffb0004e005737fa = $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
$bdcd6ced2cdccd72$export$b624eff549462981 = $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
$bdcd6ced2cdccd72$export$7897aa7841a5380c = $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
$bdcd6ced2cdccd72$export$602eac185826482c = $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
$bdcd6ced2cdccd72$export$e2c29f18771995cb = $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
$bdcd6ced2cdccd72$export$5f8d39834fd61797 = $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
$bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
$bdcd6ced2cdccd72$export$998bcd577473dd93 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
$bdcd6ced2cdccd72$export$b706b080d889d2c9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
};
$bdcd6ced2cdccd72$export$5be5a87408f70ddc = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
};
$bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
};
$bdcd6ced2cdccd72$export$455c2e768291efa6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
};
$bdcd6ced2cdccd72$export$9522e17588c12572 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
};
$bdcd6ced2cdccd72$export$2110ac352bb060b9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
};
$bdcd6ced2cdccd72$export$56885ab8b9c456ab = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
};
$bdcd6ced2cdccd72$export$d927fcb6adf8f9de = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
};
$bdcd6ced2cdccd72$export$b82d16f27459e05a = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
};
$bdcd6ced2cdccd72$export$522c17b4f5e123e8 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
};
$bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
};
$bdcd6ced2cdccd72$export$3d6c20d97e46b957 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
};
$bdcd6ced2cdccd72$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE || type === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE || type === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$bdcd6ced2cdccd72$export$f5bbd400c2f4426f = $bdcd6ced2cdccd72$var$typeOf;

});

parcelRegister("d8seH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0277c5e26ff0d56c$export$2e2bcd8739ae039);

var $dgmWB = parcelRequire("dgmWB");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $8Uq77 = parcelRequire("8Uq77");

'use client';
const $0277c5e26ff0d56c$var$styled = (0, $dgmWB.default)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $jR9F1.default,
    rootShouldForwardProp: $8Uq77.default
});
var $0277c5e26ff0d56c$export$2e2bcd8739ae039 = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("dgmWB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a7e913a82f46e5c$export$2e2bcd8739ae039);

var $bOOlK = parcelRequire("bOOlK");

var $3z1Ay = parcelRequire("3z1Ay");

var $gxvzd = parcelRequire("gxvzd");

var $eWm0o = parcelRequire("eWm0o");

var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");

var $aFFCY = parcelRequire("aFFCY");
const $9a7e913a82f46e5c$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $9a7e913a82f46e5c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $9a7e913a82f46e5c$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $9a7e913a82f46e5c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $9a7e913a82f46e5c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $9a7e913a82f46e5c$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$9a7e913a82f46e5c$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $9a7e913a82f46e5c$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $9a7e913a82f46e5c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $9a7e913a82f46e5c$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $9a7e913a82f46e5c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9a7e913a82f46e5c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $9dZwz.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9a7e913a82f46e5c$var$defaultOverridesResolver($9a7e913a82f46e5c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $9a7e913a82f46e5c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9a7e913a82f46e5c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $bOOlK.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $9a7e913a82f46e5c$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $3z1Ay.isPlainObject)(style)) {
                const serialized = (0, $aFFCY.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $9a7e913a82f46e5c$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $9a7e913a82f46e5c$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $9a7e913a82f46e5c$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $9a7e913a82f46e5c$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $9dZwz.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $9a7e913a82f46e5c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $gxvzd.default)(componentSlot || '')}`;
    return `Styled(${(0, $eWm0o.default)(tag)})`;
}
function $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $9a7e913a82f46e5c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9a7e913a82f46e5c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9a7e913a82f46e5c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("bOOlK", function(module, exports) {

$parcel$export(module.exports, "default", () => $89ab6b9e702438b4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_mutateStyles", () => $89ab6b9e702438b4$export$592c7226e4cb0171);
$parcel$export(module.exports, "internal_serializeStyles", () => $89ab6b9e702438b4$export$13a2d3ef13012b32);
/**
 * @mui/styled-engine v6.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable no-underscore-dangle */ 
var $1Bnx5 = parcelRequire("1Bnx5");

var $8rteH = parcelRequire("8rteH");

var $8zogs = parcelRequire("8zogs");
var $NxDAE = parcelRequire("NxDAE");

var $2BuCw = parcelRequire("2BuCw");

var $bBbjn = parcelRequire("bBbjn");
function $89ab6b9e702438b4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $1Bnx5.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $89ab6b9e702438b4$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
function $89ab6b9e702438b4$export$13a2d3ef13012b32(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
}

});
parcelRegister("1Bnx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ab803fa905d303$export$2e2bcd8739ae039);
parcelRequire("3p9rK");
parcelRequire("acw62");
parcelRequire("gd942");

var $8jRlF = parcelRequire("8jRlF");

parcelRequire("8ajhZ");
parcelRequire("8rteH");
parcelRequire("2cQcJ");
var $12ab803fa905d303$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $12ab803fa905d303$var$newStyled = (0, $8jRlF.default).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$var$newStyled[tagName] = $12ab803fa905d303$var$newStyled(tagName);
});
var $12ab803fa905d303$export$2e2bcd8739ae039 = $12ab803fa905d303$var$newStyled;

});
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$var$isPropValid = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = $bcd4e42ca4163639$var$isPropValid;

});
parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $6bb1e54ce1bc6efa$export$2e2bcd8739ae039 = $6bb1e54ce1bc6efa$var$memoize;

});


parcelRegister("8jRlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e97af874e8cdaa$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
parcelRequire("8zogs");
var $NxDAE = parcelRequire("NxDAE");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2cQcJ = parcelRequire("2cQcJ");
var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $NxDAE.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $acw62.useContext)((0, $NxDAE.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $acw62.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = $60e97af874e8cdaa$var$createStyled;

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8zogs", function(module, exports) {

$parcel$export(module.exports, "Global", () => $63d46a01db878c10$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $63d46a01db878c10$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $63d46a01db878c10$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("NxDAE")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("NxDAE")).w);

var $acw62 = parcelRequire("acw62");
parcelRequire("a9M6v");

var $NxDAE = parcelRequire("NxDAE");
parcelRequire("3p9rK");
parcelRequire("55EI3");
parcelRequire("9ORqK");


var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.8.2",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.13.10",
        "@emotion/babel-plugin": "^11.7.1",
        "@emotion/cache": "^11.7.1",
        "@emotion/serialize": "^1.0.2",
        "@emotion/utils": "^1.1.0",
        "@emotion/weak-memoize": "^0.2.5",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        "@babel/core": "^7.0.0",
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@babel/core": {
            optional: true
        },
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@babel/core": "^7.13.10",
        "@emotion/css": "11.7.1",
        "@emotion/css-prettifier": "1.0.1",
        "@emotion/server": "11.4.0",
        "@emotion/styled": "11.8.1",
        "@types/react": "^16.9.11",
        dtslint: "^4.2.1",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact"
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $NxDAE.h).call(props, 'css')) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $NxDAE.E);
    createElementArgArray[1] = (0, $NxDAE.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : (0, $acw62.useLayoutEffect);
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $NxDAE.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, (0, $acw62.useContext)((0, $NxDAE.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $acw62.useRef)();
    $63d46a01db878c10$var$useInsertionEffect(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    $63d46a01db878c10$var$useInsertionEffect(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $NxDAE.u)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $NxDAE.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $acw62.useContext)((0, $NxDAE.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isJest, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $6Fque = parcelRequire("6Fque");

var $aJJpq = parcelRequire("aJJpq");

var $5VskT = parcelRequire("5VskT");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $6Fque.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $6Fque.token)(character)) break;
        (0, $6Fque.next)();
    }
    return (0, $6Fque.slice)(begin, (0, $6Fque.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $6Fque.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $6Fque.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $6Fque.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $6Fque.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $6Fque.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $6Fque.from)(character);
    }
    while (character = (0, $6Fque.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $6Fque.dealloc)($76500f1a9bc57c92$var$toRules((0, $6Fque.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $6Fque.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $6Fque.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $6Fque.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MOZ) + value + (0, $6Fque.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + value + value;
        // order
        case 6165:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.replace)(value, /(\w+).+(:[^]+)/, (0, $6Fque.WEBKIT) + 'box-$1$2' + (0, $6Fque.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + 'flex-item-' + (0, $6Fque.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + 'flex-line-pack' + (0, $6Fque.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + (0, $6Fque.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + (0, $6Fque.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $6Fque.WEBKIT) + 'box-' + (0, $6Fque.replace)(value, '-grow', '') + (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + (0, $6Fque.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $6Fque.WEBKIT) + (0, $6Fque.replace)(value, /([^-])(transform)/g, '$1' + (0, $6Fque.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $6Fque.replace)((0, $6Fque.replace)((0, $6Fque.replace)(value, /(zoom-|grab)/, (0, $6Fque.WEBKIT) + '$1'), /(image-set)/, (0, $6Fque.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $6Fque.replace)(value, /(image-set\([^]*)/, (0, $6Fque.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $6Fque.replace)((0, $6Fque.replace)(value, /(.+:)(flex-)?(.*)/, (0, $6Fque.WEBKIT) + 'box-pack:$3' + (0, $6Fque.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $6Fque.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $6Fque.replace)(value, /(.+)-inline(.+)/, (0, $6Fque.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $6Fque.strlen)(value) - 1 - length > 6) switch((0, $6Fque.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $6Fque.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $6Fque.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $6Fque.WEBKIT) + '$2-$3' + '$1' + (0, $6Fque.MOZ) + ((0, $6Fque.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $6Fque.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $6Fque.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $6Fque.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $6Fque.charat)(value, (0, $6Fque.strlen)(value) - 3 - (~(0, $6Fque.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $6Fque.replace)(value, ':', ':' + (0, $6Fque.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $6Fque.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $6Fque.WEBKIT) + ((0, $6Fque.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $6Fque.WEBKIT) + '$2$3' + '$1' + (0, $6Fque.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $6Fque.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + (0, $6Fque.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + (0, $6Fque.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + (0, $6Fque.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $6Fque.WEBKIT) + value + (0, $6Fque.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $6Fque.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $6Fque.KEYFRAMES:
                return (0, $6Fque.serialize)([
                    (0, $6Fque.copy)(element, {
                        value: (0, $6Fque.replace)(element.value, '@', '@' + (0, $6Fque.WEBKIT))
                    })
                ], callback);
            case 0, $6Fque.RULESET:
                if (element.length) return (0, $6Fque.combine)(element.props, function(value) {
                    switch((0, $6Fque.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $6Fque.serialize)([
                                (0, $6Fque.copy)(element, {
                                    props: [
                                        (0, $6Fque.replace)(value, /:(read-\w+)/, ':' + (0, $6Fque.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $6Fque.serialize)([
                                (0, $6Fque.copy)(element, {
                                    props: [
                                        (0, $6Fque.replace)(value, /:(plac\w+)/, ':' + (0, $6Fque.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $6Fque.copy)(element, {
                                    props: [
                                        (0, $6Fque.replace)(value, /:(plac\w+)/, ':' + (0, $6Fque.MOZ) + '$1')
                                    ]
                                }),
                                (0, $6Fque.copy)(element, {
                                    props: [
                                        (0, $6Fque.replace)(value, /:(plac\w+)/, (0, $6Fque.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $aJJpq.default)(function() {
    return (0, $5VskT.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $6Fque.stringify),
            (0, $6Fque.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $6Fque.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $6Fque.serialize)((0, $6Fque.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $6Fque.stringify)
        ];
        var _serializer = (0, $6Fque.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $6Fque.serialize)((0, $6Fque.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("6Fque", function(module, exports) {

$parcel$export(module.exports, "MS", () => $51193a2fd236caea$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $51193a2fd236caea$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $51193a2fd236caea$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $51193a2fd236caea$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $51193a2fd236caea$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $51193a2fd236caea$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $51193a2fd236caea$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $51193a2fd236caea$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $51193a2fd236caea$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $51193a2fd236caea$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $51193a2fd236caea$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $51193a2fd236caea$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $51193a2fd236caea$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $51193a2fd236caea$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $51193a2fd236caea$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $51193a2fd236caea$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $51193a2fd236caea$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $51193a2fd236caea$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $51193a2fd236caea$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $51193a2fd236caea$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $51193a2fd236caea$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $51193a2fd236caea$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $51193a2fd236caea$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $51193a2fd236caea$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $51193a2fd236caea$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $51193a2fd236caea$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $51193a2fd236caea$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $51193a2fd236caea$export$38bcb760f1d4871c);
var $51193a2fd236caea$export$71ad59f2e432cfe8 = "-ms-";
var $51193a2fd236caea$export$2c0f367103c8d01c = "-moz-";
var $51193a2fd236caea$export$39dfd62a25e0fe93 = "-webkit-";
var $51193a2fd236caea$export$a29989082612d0d9 = "comm";
var $51193a2fd236caea$export$aa3a2e812ca8570d = "rule";
var $51193a2fd236caea$export$527d108ccf083c2b = "decl";
var $51193a2fd236caea$export$d3d35020fa5b54f0 = "@page";
var $51193a2fd236caea$export$500415a86c544f73 = "@media";
var $51193a2fd236caea$export$a763edbf796b780a = "@import";
var $51193a2fd236caea$export$2790aeb8b4e5c826 = "@charset";
var $51193a2fd236caea$export$1cc683e23b84b133 = "@viewport";
var $51193a2fd236caea$export$9447a5efea57e862 = "@supports";
var $51193a2fd236caea$export$ef011b4e114b1fba = "@document";
var $51193a2fd236caea$export$6aad947bda0f3f46 = "@namespace";
var $51193a2fd236caea$export$b44a8529a35fcb60 = "@keyframes";
var $51193a2fd236caea$export$2c16de31893252e6 = "@font-face";
var $51193a2fd236caea$export$3d846dd52e150c6f = "@counter-style";
var $51193a2fd236caea$export$22314bfbb57653fe = "@font-feature-values";
var $51193a2fd236caea$export$d773506282b3cfe6 = "@layer";
var $51193a2fd236caea$export$2335f513bbd82c6d = Math.abs;
var $51193a2fd236caea$export$6788812c4e6611e6 = String.fromCharCode;
var $51193a2fd236caea$export$e6e34fd1f2686227 = Object.assign;
function $51193a2fd236caea$export$d6af199866bfb566(e, r) {
    return $51193a2fd236caea$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $51193a2fd236caea$export$a9db5e087081082d(e, 0)) << 2 ^ $51193a2fd236caea$export$a9db5e087081082d(e, 1)) << 2 ^ $51193a2fd236caea$export$a9db5e087081082d(e, 2)) << 2 ^ $51193a2fd236caea$export$a9db5e087081082d(e, 3) : 0;
}
function $51193a2fd236caea$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $51193a2fd236caea$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $51193a2fd236caea$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $51193a2fd236caea$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $51193a2fd236caea$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $51193a2fd236caea$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $51193a2fd236caea$export$36776f635604f274(e) {
    return e.length;
}
function $51193a2fd236caea$export$f9084667e487ed46(e) {
    return e.length;
}
function $51193a2fd236caea$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $51193a2fd236caea$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $51193a2fd236caea$export$53f1d5ea8de3d7c = 1;
var $51193a2fd236caea$export$4e0c71f277ca26b3 = 1;
var $51193a2fd236caea$export$f24224f1c91d8156 = 0;
var $51193a2fd236caea$export$5880b8b5730aff45 = 0;
var $51193a2fd236caea$export$c0306caf338ac095 = 0;
var $51193a2fd236caea$export$30a86d91af8ff6e6 = "";
function $51193a2fd236caea$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $51193a2fd236caea$export$53f1d5ea8de3d7c,
        column: $51193a2fd236caea$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $51193a2fd236caea$export$784d13d8ee351f07(e, r) {
    return $51193a2fd236caea$export$e6e34fd1f2686227($51193a2fd236caea$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $51193a2fd236caea$export$eba6f6f03b0a92e7() {
    return $51193a2fd236caea$export$c0306caf338ac095;
}
function $51193a2fd236caea$export$232faf9add678146() {
    $51193a2fd236caea$export$c0306caf338ac095 = $51193a2fd236caea$export$5880b8b5730aff45 > 0 ? $51193a2fd236caea$export$a9db5e087081082d($51193a2fd236caea$export$30a86d91af8ff6e6, --$51193a2fd236caea$export$5880b8b5730aff45) : 0;
    if ($51193a2fd236caea$export$4e0c71f277ca26b3--, $51193a2fd236caea$export$c0306caf338ac095 === 10) $51193a2fd236caea$export$4e0c71f277ca26b3 = 1, $51193a2fd236caea$export$53f1d5ea8de3d7c--;
    return $51193a2fd236caea$export$c0306caf338ac095;
}
function $51193a2fd236caea$export$48cfd1e771a65c4f() {
    $51193a2fd236caea$export$c0306caf338ac095 = $51193a2fd236caea$export$5880b8b5730aff45 < $51193a2fd236caea$export$f24224f1c91d8156 ? $51193a2fd236caea$export$a9db5e087081082d($51193a2fd236caea$export$30a86d91af8ff6e6, $51193a2fd236caea$export$5880b8b5730aff45++) : 0;
    if ($51193a2fd236caea$export$4e0c71f277ca26b3++, $51193a2fd236caea$export$c0306caf338ac095 === 10) $51193a2fd236caea$export$4e0c71f277ca26b3 = 1, $51193a2fd236caea$export$53f1d5ea8de3d7c++;
    return $51193a2fd236caea$export$c0306caf338ac095;
}
function $51193a2fd236caea$export$4d3fb11e950abb9e() {
    return $51193a2fd236caea$export$a9db5e087081082d($51193a2fd236caea$export$30a86d91af8ff6e6, $51193a2fd236caea$export$5880b8b5730aff45);
}
function $51193a2fd236caea$export$e88cb2efb12ae807() {
    return $51193a2fd236caea$export$5880b8b5730aff45;
}
function $51193a2fd236caea$export$58adb3bec8346d0f(e, r) {
    return $51193a2fd236caea$export$2f35ab04d2335697($51193a2fd236caea$export$30a86d91af8ff6e6, e, r);
}
function $51193a2fd236caea$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $51193a2fd236caea$export$2de70f21292aac9e(e) {
    return $51193a2fd236caea$export$53f1d5ea8de3d7c = $51193a2fd236caea$export$4e0c71f277ca26b3 = 1, $51193a2fd236caea$export$f24224f1c91d8156 = $51193a2fd236caea$export$36776f635604f274($51193a2fd236caea$export$30a86d91af8ff6e6 = e), $51193a2fd236caea$export$5880b8b5730aff45 = 0, [];
}
function $51193a2fd236caea$export$45918ac1574455b1(e) {
    return $51193a2fd236caea$export$30a86d91af8ff6e6 = "", e;
}
function $51193a2fd236caea$export$410ac95b9ec204b8(e) {
    return $51193a2fd236caea$export$87c2784dc9fc4ab($51193a2fd236caea$export$58adb3bec8346d0f($51193a2fd236caea$export$5880b8b5730aff45 - 1, $51193a2fd236caea$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $51193a2fd236caea$export$660b2ee2d4fb4eff(e) {
    return $51193a2fd236caea$export$45918ac1574455b1($51193a2fd236caea$export$5f8c09e3ae6f64e1($51193a2fd236caea$export$2de70f21292aac9e(e)));
}
function $51193a2fd236caea$export$7af1228ff777d175(e) {
    while($51193a2fd236caea$export$c0306caf338ac095 = $51193a2fd236caea$export$4d3fb11e950abb9e())if ($51193a2fd236caea$export$c0306caf338ac095 < 33) $51193a2fd236caea$export$48cfd1e771a65c4f();
    else break;
    return $51193a2fd236caea$export$9e1725a4cfeada27(e) > 2 || $51193a2fd236caea$export$9e1725a4cfeada27($51193a2fd236caea$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $51193a2fd236caea$export$5f8c09e3ae6f64e1(e) {
    while($51193a2fd236caea$export$48cfd1e771a65c4f())switch($51193a2fd236caea$export$9e1725a4cfeada27($51193a2fd236caea$export$c0306caf338ac095)){
        case 0:
            $51193a2fd236caea$export$10d8903dec122b9d($51193a2fd236caea$export$c2ab62c7bf24634($51193a2fd236caea$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $51193a2fd236caea$export$10d8903dec122b9d($51193a2fd236caea$export$410ac95b9ec204b8($51193a2fd236caea$export$c0306caf338ac095), e);
            break;
        default:
            $51193a2fd236caea$export$10d8903dec122b9d($51193a2fd236caea$export$6788812c4e6611e6($51193a2fd236caea$export$c0306caf338ac095), e);
    }
    return e;
}
function $51193a2fd236caea$export$955ba06d119e085e(e, r) {
    while(--r && $51193a2fd236caea$export$48cfd1e771a65c4f())if ($51193a2fd236caea$export$c0306caf338ac095 < 48 || $51193a2fd236caea$export$c0306caf338ac095 > 102 || $51193a2fd236caea$export$c0306caf338ac095 > 57 && $51193a2fd236caea$export$c0306caf338ac095 < 65 || $51193a2fd236caea$export$c0306caf338ac095 > 70 && $51193a2fd236caea$export$c0306caf338ac095 < 97) break;
    return $51193a2fd236caea$export$58adb3bec8346d0f(e, $51193a2fd236caea$export$e88cb2efb12ae807() + (r < 6 && $51193a2fd236caea$export$4d3fb11e950abb9e() == 32 && $51193a2fd236caea$export$48cfd1e771a65c4f() == 32));
}
function $51193a2fd236caea$export$c889f2fcc19dbf12(e) {
    while($51193a2fd236caea$export$48cfd1e771a65c4f())switch($51193a2fd236caea$export$c0306caf338ac095){
        case e:
            return $51193a2fd236caea$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $51193a2fd236caea$export$c889f2fcc19dbf12($51193a2fd236caea$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $51193a2fd236caea$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $51193a2fd236caea$export$48cfd1e771a65c4f();
            break;
    }
    return $51193a2fd236caea$export$5880b8b5730aff45;
}
function $51193a2fd236caea$export$4254d4e2b3745c4c(e, r) {
    while($51193a2fd236caea$export$48cfd1e771a65c4f())if (e + $51193a2fd236caea$export$c0306caf338ac095 === 57) break;
    else if (e + $51193a2fd236caea$export$c0306caf338ac095 === 84 && $51193a2fd236caea$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $51193a2fd236caea$export$58adb3bec8346d0f(r, $51193a2fd236caea$export$5880b8b5730aff45 - 1) + "*" + $51193a2fd236caea$export$6788812c4e6611e6(e === 47 ? e : $51193a2fd236caea$export$48cfd1e771a65c4f());
}
function $51193a2fd236caea$export$c2ab62c7bf24634(e) {
    while(!$51193a2fd236caea$export$9e1725a4cfeada27($51193a2fd236caea$export$4d3fb11e950abb9e()))$51193a2fd236caea$export$48cfd1e771a65c4f();
    return $51193a2fd236caea$export$58adb3bec8346d0f(e, $51193a2fd236caea$export$5880b8b5730aff45);
}
function $51193a2fd236caea$export$ef7acd7185315e22(e) {
    return $51193a2fd236caea$export$45918ac1574455b1($51193a2fd236caea$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $51193a2fd236caea$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $51193a2fd236caea$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $51193a2fd236caea$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $51193a2fd236caea$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($51193a2fd236caea$export$f8e21b1e77979a08(j += $51193a2fd236caea$export$77ad94ebf1c2b9ed($51193a2fd236caea$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $51193a2fd236caea$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $51193a2fd236caea$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $51193a2fd236caea$export$955ba06d119e085e($51193a2fd236caea$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($51193a2fd236caea$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $51193a2fd236caea$export$10d8903dec122b9d($51193a2fd236caea$export$4a34f930e789283c($51193a2fd236caea$export$4254d4e2b3745c4c($51193a2fd236caea$export$48cfd1e771a65c4f(), $51193a2fd236caea$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $51193a2fd236caea$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $51193a2fd236caea$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $51193a2fd236caea$export$36776f635604f274(j) - l) $51193a2fd236caea$export$10d8903dec122b9d(p > 32 ? $51193a2fd236caea$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $51193a2fd236caea$export$f8483753829ec8f3($51193a2fd236caea$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $51193a2fd236caea$export$10d8903dec122b9d(y = $51193a2fd236caea$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $51193a2fd236caea$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $51193a2fd236caea$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $51193a2fd236caea$export$98e6a39c04603d36(e, y, y, n && $51193a2fd236caea$export$10d8903dec122b9d($51193a2fd236caea$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $51193a2fd236caea$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $51193a2fd236caea$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $51193a2fd236caea$export$232faf9add678146() == 125) continue;
            }
            switch(j += $51193a2fd236caea$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($51193a2fd236caea$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($51193a2fd236caea$export$4d3fb11e950abb9e() === 45) j += $51193a2fd236caea$export$410ac95b9ec204b8($51193a2fd236caea$export$48cfd1e771a65c4f());
                    v = $51193a2fd236caea$export$4d3fb11e950abb9e(), o = l = $51193a2fd236caea$export$36776f635604f274(g = j += $51193a2fd236caea$export$c2ab62c7bf24634($51193a2fd236caea$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $51193a2fd236caea$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $51193a2fd236caea$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $51193a2fd236caea$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $51193a2fd236caea$export$2f35ab04d2335697(e, v + 1, v = $51193a2fd236caea$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $51193a2fd236caea$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $51193a2fd236caea$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $51193a2fd236caea$export$35059013cd4a06db(e, r, a, s === 0 ? $51193a2fd236caea$export$aa3a2e812ca8570d : i, f, o, l);
}
function $51193a2fd236caea$export$4a34f930e789283c(e, r, a) {
    return $51193a2fd236caea$export$35059013cd4a06db(e, r, a, $51193a2fd236caea$export$a29989082612d0d9, $51193a2fd236caea$export$6788812c4e6611e6($51193a2fd236caea$export$eba6f6f03b0a92e7()), $51193a2fd236caea$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $51193a2fd236caea$export$f8483753829ec8f3(e, r, a, n) {
    return $51193a2fd236caea$export$35059013cd4a06db(e, r, a, $51193a2fd236caea$export$527d108ccf083c2b, $51193a2fd236caea$export$2f35ab04d2335697(e, 0, n), $51193a2fd236caea$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $51193a2fd236caea$export$82e9f45cca5ba907(n, c, s) {
    switch($51193a2fd236caea$export$d6af199866bfb566(n, c)){
        case 5103:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $51193a2fd236caea$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$2c0f367103c8d01c + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($51193a2fd236caea$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $51193a2fd236caea$export$39dfd62a25e0fe93 + "box-$1$2" + $51193a2fd236caea$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + "flex-item-" + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$51193a2fd236caea$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $51193a2fd236caea$export$71ad59f2e432cfe8 + "grid-row-" + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + "flex-line-pack" + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + "box-" + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "-grow", "") + $51193a2fd236caea$export$39dfd62a25e0fe93 + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $51193a2fd236caea$export$39dfd62a25e0fe93 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $51193a2fd236caea$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $51193a2fd236caea$export$77ad94ebf1c2b9ed($51193a2fd236caea$export$77ad94ebf1c2b9ed($51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $51193a2fd236caea$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $51193a2fd236caea$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $51193a2fd236caea$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $51193a2fd236caea$export$77ad94ebf1c2b9ed($51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $51193a2fd236caea$export$39dfd62a25e0fe93 + "box-pack:$3" + $51193a2fd236caea$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $51193a2fd236caea$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$51193a2fd236caea$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $51193a2fd236caea$export$71ad59f2e432cfe8 + "grid-column-align" + $51193a2fd236caea$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $51193a2fd236caea$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$51193a2fd236caea$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $51193a2fd236caea$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$51193a2fd236caea$export$f8e21b1e77979a08(s, "span") ? $51193a2fd236caea$export$4659b591c19bdf3d(s, /\d+/) : +$51193a2fd236caea$export$4659b591c19bdf3d(s, /\d+/) - +$51193a2fd236caea$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $51193a2fd236caea$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $51193a2fd236caea$export$71ad59f2e432cfe8 + $51193a2fd236caea$export$77ad94ebf1c2b9ed($51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $51193a2fd236caea$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($51193a2fd236caea$export$36776f635604f274(n) - 1 - c > 6) switch($51193a2fd236caea$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($51193a2fd236caea$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $51193a2fd236caea$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $51193a2fd236caea$export$2c0f367103c8d01c + ($51193a2fd236caea$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$51193a2fd236caea$export$f8e21b1e77979a08(n, "stretch") ? $51193a2fd236caea$export$82e9f45cca5ba907($51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $51193a2fd236caea$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $51193a2fd236caea$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($51193a2fd236caea$export$a9db5e087081082d(n, c + 6) === 121) return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, ":", ":" + $51193a2fd236caea$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($51193a2fd236caea$export$a9db5e087081082d(n, $51193a2fd236caea$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $51193a2fd236caea$export$39dfd62a25e0fe93 + ($51193a2fd236caea$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $51193a2fd236caea$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $51193a2fd236caea$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, ":", ":" + $51193a2fd236caea$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $51193a2fd236caea$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $51193a2fd236caea$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $51193a2fd236caea$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $51193a2fd236caea$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $51193a2fd236caea$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $51193a2fd236caea$export$a763edbf796b780a:
        case $51193a2fd236caea$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $51193a2fd236caea$export$a29989082612d0d9:
            return "";
        case $51193a2fd236caea$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $51193a2fd236caea$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $51193a2fd236caea$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $51193a2fd236caea$export$36776f635604f274(a = $51193a2fd236caea$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $51193a2fd236caea$export$5a7767152ae0305f(e) {
    var r = $51193a2fd236caea$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $51193a2fd236caea$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $51193a2fd236caea$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $51193a2fd236caea$export$527d108ccf083c2b:
                n.return = $51193a2fd236caea$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $51193a2fd236caea$export$b44a8529a35fcb60:
                return $51193a2fd236caea$export$dfdc1655ccc5b9cb([
                    $51193a2fd236caea$export$784d13d8ee351f07(n, {
                        value: $51193a2fd236caea$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $51193a2fd236caea$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $51193a2fd236caea$export$aa3a2e812ca8570d:
                if (n.length) return $51193a2fd236caea$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($51193a2fd236caea$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $51193a2fd236caea$export$dfdc1655ccc5b9cb([
                                $51193a2fd236caea$export$784d13d8ee351f07(n, {
                                    props: [
                                        $51193a2fd236caea$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $51193a2fd236caea$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $51193a2fd236caea$export$dfdc1655ccc5b9cb([
                                $51193a2fd236caea$export$784d13d8ee351f07(n, {
                                    props: [
                                        $51193a2fd236caea$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $51193a2fd236caea$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $51193a2fd236caea$export$784d13d8ee351f07(n, {
                                    props: [
                                        $51193a2fd236caea$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $51193a2fd236caea$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $51193a2fd236caea$export$784d13d8ee351f07(n, {
                                    props: [
                                        $51193a2fd236caea$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $51193a2fd236caea$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $51193a2fd236caea$export$76a88f7de6507443(e) {
    switch(e.type){
        case $51193a2fd236caea$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $51193a2fd236caea$export$1be1fc439b849fdf($51193a2fd236caea$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($51193a2fd236caea$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $51193a2fd236caea$export$2f35ab04d2335697(r, 1, $51193a2fd236caea$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $51193a2fd236caea$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $51193a2fd236caea$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $51193a2fd236caea$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("aJJpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d1154ab70079230$export$2e2bcd8739ae039);
var $7d1154ab70079230$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("5VskT", function(module, exports) {

$parcel$export(module.exports, "default", () => $450841926b174265$export$2e2bcd8739ae039);
function $450841926b174265$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("NxDAE", function(module, exports) {

$parcel$export(module.exports, "h", () => $094eab6f6c422d65$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $094eab6f6c422d65$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $094eab6f6c422d65$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $094eab6f6c422d65$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $094eab6f6c422d65$export$3b14a55fb2447963);
$parcel$export(module.exports, "c", () => $094eab6f6c422d65$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $094eab6f6c422d65$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $55EI3 = parcelRequire("55EI3");

var $kKN31 = parcelRequire("kKN31");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");
var $094eab6f6c422d65$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $094eab6f6c422d65$var$EmotionCacheContext = /* #__PURE__ */ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $094eab6f6c422d65$export$e7094788287c5e9b = $094eab6f6c422d65$var$EmotionCacheContext.Provider;
var $094eab6f6c422d65$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($094eab6f6c422d65$var$EmotionCacheContext);
};
var $094eab6f6c422d65$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($094eab6f6c422d65$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $094eab6f6c422d65$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $acw62.createContext)({});
var $094eab6f6c422d65$export$407448d2b89b1813 = function useTheme() {
    return (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7);
};
var $094eab6f6c422d65$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $094eab6f6c422d65$var$createCacheWithTheme = /* #__PURE__ */ (0, $55EI3.default)(function(outerTheme) {
    return (0, $55EI3.default)(function(theme) {
        return $094eab6f6c422d65$var$getTheme(outerTheme, theme);
    });
});
var $094eab6f6c422d65$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $094eab6f6c422d65$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $acw62.createElement)($094eab6f6c422d65$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $094eab6f6c422d65$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $acw62.createElement)(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $acw62.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kKN31.default)(WithTheme, Component);
}
var $094eab6f6c422d65$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $094eab6f6c422d65$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $094eab6f6c422d65$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $094eab6f6c422d65$var$getLastPart(match[1]);
    return undefined;
};
var $094eab6f6c422d65$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $094eab6f6c422d65$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $094eab6f6c422d65$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $094eab6f6c422d65$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($094eab6f6c422d65$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $094eab6f6c422d65$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $094eab6f6c422d65$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : function useInsertionEffect(create) {
    create();
};
function $094eab6f6c422d65$export$3b14a55fb2447963(create) {
    $094eab6f6c422d65$var$useInsertionEffect(create);
}
var $094eab6f6c422d65$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $094eab6f6c422d65$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $094eab6f6c422d65$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($094eab6f6c422d65$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$094eab6f6c422d65$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $094eab6f6c422d65$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = $094eab6f6c422d65$export$3b14a55fb2447963(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $094eab6f6c422d65$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $094eab6f6c422d65$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$094eab6f6c422d65$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, (0, $acw62.useContext)($094eab6f6c422d65$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($094eab6f6c422d65$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $094eab6f6c422d65$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($094eab6f6c422d65$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ (0, $acw62.createElement)(WrappedComponent, newProps));
});

});
parcelRegister("55EI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4cff6eff59c4cb$export$2e2bcd8739ae039);
var $3b4cff6eff59c4cb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $3b4cff6eff59c4cb$export$2e2bcd8739ae039 = $3b4cff6eff59c4cb$var$weakMemoize;

});

parcelRegister("kKN31", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1be2661c8fac766$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};
var $f1be2661c8fac766$export$2e2bcd8739ae039 = $f1be2661c8fac766$var$hoistNonReactStatics;

});

parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4fp5l = parcelRequire("4fp5l");

var $bojqG = parcelRequire("bojqG");

var $4qIpm = parcelRequire("4qIpm");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $4qIpm.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $bojqG.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4fp5l.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4fp5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $317c058ababa1d9f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $317c058ababa1d9f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("bojqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b101df16c1118f$export$2e2bcd8739ae039);
var $84b101df16c1118f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("4qIpm", function(module, exports) {

$parcel$export(module.exports, "default", () => $339c09a2686ce0d6$export$2e2bcd8739ae039);
function $339c09a2686ce0d6$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("2cQcJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $19b532704a3a90e7$export$db21c7ffa21794e7);

var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || (0, $acw62.useLayoutEffect);

});



parcelRegister("2BuCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e56ca0825dc344f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $NxDAE = parcelRequire("NxDAE");

var $a9M6v = parcelRequire("a9M6v");

var $jmRmf = parcelRequire("jmRmf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1e56ca0825dc344f$var$cacheMap = new Map();
const $1e56ca0825dc344f$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $1e56ca0825dc344f$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $a9M6v.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $1e56ca0825dc344f$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $1e56ca0825dc344f$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$1e56ca0825dc344f$var$insertionPoint) {
        $1e56ca0825dc344f$var$insertionPoint = document.createElement('meta');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($1e56ca0825dc344f$var$insertionPoint);
    }
}
function $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $jmRmf.StyleSheet) {
            insert(rule, options) {
                if ($1e56ca0825dc344f$export$5a3f4e255fc47e86.insert) return $1e56ca0825dc344f$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $1e56ca0825dc344f$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $1e56ca0825dc344f$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $1e56ca0825dc344f$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $1e56ca0825dc344f$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $acw62.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1e56ca0825dc344f$var$cacheMap.has(cacheKey)) return $1e56ca0825dc344f$var$cacheMap.get(cacheKey);
        const fresh = $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer);
        $1e56ca0825dc344f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $NxDAE.C), {
        value: cache,
        children: children
    }) : children;
}

});

parcelRegister("bBbjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $871beca1e2477cf0$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $8zogs = parcelRequire("8zogs");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8zogs.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $19Aa2 = parcelRequire("19Aa2");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $19Aa2.isValidElementType)(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $19Aa2.isValidElementType)(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("19Aa2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gijsP"));

});


parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("eWm0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $19Aa2 = parcelRequire("19Aa2");
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $19Aa2.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $19Aa2.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $aGAln = parcelRequire("aGAln");

var $cvKfd = parcelRequire("cvKfd");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $aGAln.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $bVuw0.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $cvKfd.default)(muiTheme);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("aGAln", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7a04bfefec7c88$export$2e2bcd8739ae039);
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $7c7a04bfefec7c88$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $7c7a04bfefec7c88$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $7c7a04bfefec7c88$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $7c7a04bfefec7c88$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("cvKfd", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", () => $91bc4077911678f2$export$456f6c1142f990db);
$parcel$export(module.exports, "isCqShorthand", () => $91bc4077911678f2$export$77c7c3e357f440e7);
$parcel$export(module.exports, "getContainerQuery", () => $91bc4077911678f2$export$10a9745dfa00d15);
$parcel$export(module.exports, "default", () => $91bc4077911678f2$export$2e2bcd8739ae039);

function $91bc4077911678f2$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $91bc4077911678f2$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $91bc4077911678f2$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $91bc4077911678f2$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $7kpn1 = parcelRequire("7kpn1");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $7kpn1.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("7kpn1", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $555e14aafbcd0190$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $555e14aafbcd0190$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $555e14aafbcd0190$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $555e14aafbcd0190$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $555e14aafbcd0190$export$6f98e8eaf0be1996);


var $82aMg = parcelRequire("82aMg");

var $ii7BS = parcelRequire("ii7BS");

var $jIr7d = parcelRequire("jIr7d");

var $hjkc5 = parcelRequire("hjkc5");
const $555e14aafbcd0190$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $555e14aafbcd0190$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $555e14aafbcd0190$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $555e14aafbcd0190$var$getCssProperties = (0, $hjkc5.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($555e14aafbcd0190$var$aliases[prop]) prop = $555e14aafbcd0190$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $555e14aafbcd0190$var$properties[a];
    const direction = $555e14aafbcd0190$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $555e14aafbcd0190$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $555e14aafbcd0190$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $555e14aafbcd0190$var$spacingKeys = [
    ...$555e14aafbcd0190$export$aab52a0dde05ad8a,
    ...$555e14aafbcd0190$export$f8397d44f03ab6ad
];
function $555e14aafbcd0190$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $ii7BS.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') return `calc(${val} * ${themeSpacing})`;
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $555e14aafbcd0190$export$1def6f833384e3d1(theme) {
    return $555e14aafbcd0190$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $555e14aafbcd0190$var$getCssProperties(prop);
    const styleFromPropValue = $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $82aMg.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $555e14aafbcd0190$var$style(props, keys) {
    const transformer = $555e14aafbcd0190$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $jIr7d.default), {});
}
function $555e14aafbcd0190$export$7ede87f9b603dd3c(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$aab52a0dde05ad8a);
}
$555e14aafbcd0190$export$7ede87f9b603dd3c.propTypes = {};
$555e14aafbcd0190$export$7ede87f9b603dd3c.filterProps = $555e14aafbcd0190$export$aab52a0dde05ad8a;
function $555e14aafbcd0190$export$6f98e8eaf0be1996(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$f8397d44f03ab6ad);
}
$555e14aafbcd0190$export$6f98e8eaf0be1996.propTypes = {};
$555e14aafbcd0190$export$6f98e8eaf0be1996.filterProps = $555e14aafbcd0190$export$f8397d44f03ab6ad;
function $555e14aafbcd0190$var$spacing(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$var$spacingKeys);
}
$555e14aafbcd0190$var$spacing.propTypes = {};
$555e14aafbcd0190$var$spacing.filterProps = $555e14aafbcd0190$var$spacingKeys;
var $555e14aafbcd0190$export$2e2bcd8739ae039 = $555e14aafbcd0190$var$spacing;

});
parcelRegister("82aMg", function(module, exports) {

$parcel$export(module.exports, "values", () => $5d96decff5ccffcb$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $5d96decff5ccffcb$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $5d96decff5ccffcb$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $5d96decff5ccffcb$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $5d96decff5ccffcb$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $5d96decff5ccffcb$export$980e6a259d807490);


var $3z1Ay = parcelRequire("3z1Ay");

var $jIr7d = parcelRequire("jIr7d");

var $cvKfd = parcelRequire("cvKfd");
const $5d96decff5ccffcb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $5d96decff5ccffcb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$5d96decff5ccffcb$export$68c286be0e7e55b7[key]}px)`
};
const $5d96decff5ccffcb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $5d96decff5ccffcb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $5d96decff5ccffcb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $cvKfd.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $cvKfd.getContainerQuery)(theme.containerQueries ? theme : $5d96decff5ccffcb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $5d96decff5ccffcb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $5d96decff5ccffcb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $jIr7d.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $5d96decff5ccffcb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $5d96decff5ccffcb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $5d96decff5ccffcb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $5d96decff5ccffcb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $5d96decff5ccffcb$export$2e2bcd8739ae039 = $5d96decff5ccffcb$var$breakpoints;

});
parcelRegister("jIr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a728ecb1a1c3c0$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $e5a728ecb1a1c3c0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e5a728ecb1a1c3c0$export$2e2bcd8739ae039 = $e5a728ecb1a1c3c0$var$merge;

});


parcelRegister("ii7BS", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $d50fcf9a3ec00b94$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $d50fcf9a3ec00b94$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $82aMg = parcelRequire("82aMg");
function $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $d50fcf9a3ec00b94$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d50fcf9a3ec00b94$export$2e2bcd8739ae039 = $d50fcf9a3ec00b94$var$style;

});

parcelRegister("hjkc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9a3e017c1fe4096$export$2e2bcd8739ae039);
function $c9a3e017c1fe4096$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $jIr7d = parcelRequire("jIr7d");

var $ii7BS = parcelRequire("ii7BS");

var $82aMg = parcelRequire("82aMg");

var $cvKfd = parcelRequire("cvKfd");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $ii7BS.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ii7BS.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $ii7BS.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $82aMg.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $jIr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $82aMg.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $jIr7d.default)(css, breakpointsValues);
                        }
                    } else css = (0, $jIr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $cvKfd.sortContainerQueries)(theme, (0, $82aMg.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $cvKfd.sortContainerQueries)(theme, (0, $82aMg.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $7kpn1 = parcelRequire("7kpn1");

var $gIpS2 = parcelRequire("gIpS2");

var $f70is = parcelRequire("f70is");

var $f9Ko1 = parcelRequire("f9Ko1");

var $8j2JW = parcelRequire("8j2JW");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $gIpS2.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $f9Ko1.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $f9Ko1.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $f9Ko1.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $7kpn1.padding)
    },
    pt: {
        style: (0, $7kpn1.padding)
    },
    pr: {
        style: (0, $7kpn1.padding)
    },
    pb: {
        style: (0, $7kpn1.padding)
    },
    pl: {
        style: (0, $7kpn1.padding)
    },
    px: {
        style: (0, $7kpn1.padding)
    },
    py: {
        style: (0, $7kpn1.padding)
    },
    padding: {
        style: (0, $7kpn1.padding)
    },
    paddingTop: {
        style: (0, $7kpn1.padding)
    },
    paddingRight: {
        style: (0, $7kpn1.padding)
    },
    paddingBottom: {
        style: (0, $7kpn1.padding)
    },
    paddingLeft: {
        style: (0, $7kpn1.padding)
    },
    paddingX: {
        style: (0, $7kpn1.padding)
    },
    paddingY: {
        style: (0, $7kpn1.padding)
    },
    paddingInline: {
        style: (0, $7kpn1.padding)
    },
    paddingInlineStart: {
        style: (0, $7kpn1.padding)
    },
    paddingInlineEnd: {
        style: (0, $7kpn1.padding)
    },
    paddingBlock: {
        style: (0, $7kpn1.padding)
    },
    paddingBlockStart: {
        style: (0, $7kpn1.padding)
    },
    paddingBlockEnd: {
        style: (0, $7kpn1.padding)
    },
    m: {
        style: (0, $7kpn1.margin)
    },
    mt: {
        style: (0, $7kpn1.margin)
    },
    mr: {
        style: (0, $7kpn1.margin)
    },
    mb: {
        style: (0, $7kpn1.margin)
    },
    ml: {
        style: (0, $7kpn1.margin)
    },
    mx: {
        style: (0, $7kpn1.margin)
    },
    my: {
        style: (0, $7kpn1.margin)
    },
    margin: {
        style: (0, $7kpn1.margin)
    },
    marginTop: {
        style: (0, $7kpn1.margin)
    },
    marginRight: {
        style: (0, $7kpn1.margin)
    },
    marginBottom: {
        style: (0, $7kpn1.margin)
    },
    marginLeft: {
        style: (0, $7kpn1.margin)
    },
    marginX: {
        style: (0, $7kpn1.margin)
    },
    marginY: {
        style: (0, $7kpn1.margin)
    },
    marginInline: {
        style: (0, $7kpn1.margin)
    },
    marginInlineStart: {
        style: (0, $7kpn1.margin)
    },
    marginInlineEnd: {
        style: (0, $7kpn1.margin)
    },
    marginBlock: {
        style: (0, $7kpn1.margin)
    },
    marginBlockStart: {
        style: (0, $7kpn1.margin)
    },
    marginBlockEnd: {
        style: (0, $7kpn1.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $f70is.gap)
    },
    rowGap: {
        style: (0, $f70is.rowGap)
    },
    columnGap: {
        style: (0, $f70is.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8j2JW.sizingTransform)
    },
    maxWidth: {
        style: (0, $8j2JW.maxWidth)
    },
    minWidth: {
        transform: (0, $8j2JW.sizingTransform)
    },
    height: {
        transform: (0, $8j2JW.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8j2JW.sizingTransform)
    },
    minHeight: {
        transform: (0, $8j2JW.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("gIpS2", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $c2b4d2c425fe2f29$export$7a57f79000377ca2);


var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $7kpn1 = parcelRequire("7kpn1");

var $82aMg = parcelRequire("82aMg");
function $c2b4d2c425fe2f29$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c2b4d2c425fe2f29$var$createBorderStyle(prop, transform) {
    return (0, $ii7BS.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c2b4d2c425fe2f29$export$1edee58a52776cd9 = $c2b4d2c425fe2f29$var$createBorderStyle('border', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$f9a7b6bd24892946 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTop', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$5abca33e6be905d2 = $c2b4d2c425fe2f29$var$createBorderStyle('borderRight', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e2ce9f12a980a822 = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottom', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$47658cca1a909427 = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeft', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e7fb0694ba2404fc = $c2b4d2c425fe2f29$var$createBorderStyle('borderColor');
const $c2b4d2c425fe2f29$export$126a92c968acdb85 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTopColor');
const $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e = $c2b4d2c425fe2f29$var$createBorderStyle('borderRightColor');
const $c2b4d2c425fe2f29$export$340b0327727f6d1a = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottomColor');
const $c2b4d2c425fe2f29$export$60beef91a985b4bf = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeftColor');
const $c2b4d2c425fe2f29$export$f9258c55612cbed7 = $c2b4d2c425fe2f29$var$createBorderStyle('outline', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$621fe586efeb64b9 = $c2b4d2c425fe2f29$var$createBorderStyle('outlineColor');
const $c2b4d2c425fe2f29$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.propTypes = {};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c2b4d2c425fe2f29$var$borders = (0, $hIpso.default)($c2b4d2c425fe2f29$export$1edee58a52776cd9, $c2b4d2c425fe2f29$export$f9a7b6bd24892946, $c2b4d2c425fe2f29$export$5abca33e6be905d2, $c2b4d2c425fe2f29$export$e2ce9f12a980a822, $c2b4d2c425fe2f29$export$47658cca1a909427, $c2b4d2c425fe2f29$export$e7fb0694ba2404fc, $c2b4d2c425fe2f29$export$126a92c968acdb85, $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e, $c2b4d2c425fe2f29$export$340b0327727f6d1a, $c2b4d2c425fe2f29$export$60beef91a985b4bf, $c2b4d2c425fe2f29$export$7a57f79000377ca2, $c2b4d2c425fe2f29$export$f9258c55612cbed7, $c2b4d2c425fe2f29$export$621fe586efeb64b9);
var $c2b4d2c425fe2f29$export$2e2bcd8739ae039 = $c2b4d2c425fe2f29$var$borders;

});
parcelRegister("hIpso", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a4af256600fcc$export$2e2bcd8739ae039);

var $jIr7d = parcelRequire("jIr7d");
function $ce5a4af256600fcc$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $jIr7d.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $ce5a4af256600fcc$export$2e2bcd8739ae039 = $ce5a4af256600fcc$var$compose;

});


parcelRegister("f70is", function(module, exports) {

$parcel$export(module.exports, "gap", () => $b007bd6739310ca0$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $b007bd6739310ca0$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $b007bd6739310ca0$export$8a833ffa5f5dbeda);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $7kpn1 = parcelRequire("7kpn1");

var $82aMg = parcelRequire("82aMg");

const $b007bd6739310ca0$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$5df9adcb0db95e1e.propTypes = {};
$b007bd6739310ca0$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $b007bd6739310ca0$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$ec60d70ff941a580.propTypes = {};
$b007bd6739310ca0$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $b007bd6739310ca0$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.propTypes = {};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $b007bd6739310ca0$export$baf44164ca3a34e8 = (0, $ii7BS.default)({
    prop: 'gridColumn'
});
const $b007bd6739310ca0$export$8f7213a1cd01e832 = (0, $ii7BS.default)({
    prop: 'gridRow'
});
const $b007bd6739310ca0$export$b0e0abbc49ba668 = (0, $ii7BS.default)({
    prop: 'gridAutoFlow'
});
const $b007bd6739310ca0$export$bcd8b929d4b4142 = (0, $ii7BS.default)({
    prop: 'gridAutoColumns'
});
const $b007bd6739310ca0$export$e5039a674e14c828 = (0, $ii7BS.default)({
    prop: 'gridAutoRows'
});
const $b007bd6739310ca0$export$42bd9088661ffb03 = (0, $ii7BS.default)({
    prop: 'gridTemplateColumns'
});
const $b007bd6739310ca0$export$920682ae05b999bc = (0, $ii7BS.default)({
    prop: 'gridTemplateRows'
});
const $b007bd6739310ca0$export$1b88fbdd482fd33a = (0, $ii7BS.default)({
    prop: 'gridTemplateAreas'
});
const $b007bd6739310ca0$export$bdb486e40d52d26f = (0, $ii7BS.default)({
    prop: 'gridArea'
});
const $b007bd6739310ca0$var$grid = (0, $hIpso.default)($b007bd6739310ca0$export$5df9adcb0db95e1e, $b007bd6739310ca0$export$ec60d70ff941a580, $b007bd6739310ca0$export$8a833ffa5f5dbeda, $b007bd6739310ca0$export$baf44164ca3a34e8, $b007bd6739310ca0$export$8f7213a1cd01e832, $b007bd6739310ca0$export$b0e0abbc49ba668, $b007bd6739310ca0$export$bcd8b929d4b4142, $b007bd6739310ca0$export$e5039a674e14c828, $b007bd6739310ca0$export$42bd9088661ffb03, $b007bd6739310ca0$export$920682ae05b999bc, $b007bd6739310ca0$export$1b88fbdd482fd33a, $b007bd6739310ca0$export$bdb486e40d52d26f);
var $b007bd6739310ca0$export$2e2bcd8739ae039 = $b007bd6739310ca0$var$grid;

});

parcelRegister("f9Ko1", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $b08badac1d124df3$export$dbaffd4420ea0ac6);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");
function $b08badac1d124df3$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b08badac1d124df3$export$35e9368ef982300f = (0, $ii7BS.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$2506f56c10355b33 = (0, $ii7BS.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$8c5a050822fd698c = (0, $ii7BS.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$var$palette = (0, $hIpso.default)($b08badac1d124df3$export$35e9368ef982300f, $b08badac1d124df3$export$2506f56c10355b33, $b08badac1d124df3$export$8c5a050822fd698c);
var $b08badac1d124df3$export$2e2bcd8739ae039 = $b08badac1d124df3$var$palette;

});

parcelRegister("8j2JW", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $60c239303eb89b20$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $60c239303eb89b20$export$488fda99655ff65a);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $82aMg = parcelRequire("82aMg");
function $60c239303eb89b20$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $60c239303eb89b20$export$7e3df82ee760448c = (0, $ii7BS.default)({
    prop: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $82aMg.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $60c239303eb89b20$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$60c239303eb89b20$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $60c239303eb89b20$export$ee148fbbe8357dd2 = (0, $ii7BS.default)({
    prop: 'minWidth',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ac607276a8fe9f0a = (0, $ii7BS.default)({
    prop: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$dc0d8bd0b94f8570 = (0, $ii7BS.default)({
    prop: 'maxHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$a43cf604e12f3b17 = (0, $ii7BS.default)({
    prop: 'minHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ffed9f14fb65e276 = (0, $ii7BS.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$905076ed6620e671 = (0, $ii7BS.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$6ccc93f785106a58 = (0, $ii7BS.default)({
    prop: 'boxSizing'
});
const $60c239303eb89b20$var$sizing = (0, $hIpso.default)($60c239303eb89b20$export$7e3df82ee760448c, $60c239303eb89b20$export$488fda99655ff65a, $60c239303eb89b20$export$ee148fbbe8357dd2, $60c239303eb89b20$export$ac607276a8fe9f0a, $60c239303eb89b20$export$dc0d8bd0b94f8570, $60c239303eb89b20$export$a43cf604e12f3b17, $60c239303eb89b20$export$6ccc93f785106a58);
var $60c239303eb89b20$export$2e2bcd8739ae039 = $60c239303eb89b20$var$sizing;

});



parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("aFFCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4e0616915ca3a0$export$2e2bcd8739ae039);

var $bOOlK = parcelRequire("bOOlK");
function $7c4e0616915ca3a0$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bOOlK.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bOOlK.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("jR9F1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74a75f0176cf8e3$export$2e2bcd8739ae039);

var $ijOKP = parcelRequire("ijOKP");
'use client';
const $e74a75f0176cf8e3$var$defaultTheme = (0, $ijOKP.default)();
var $e74a75f0176cf8e3$export$2e2bcd8739ae039 = $e74a75f0176cf8e3$var$defaultTheme;

});
parcelRegister("ijOKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5615f18e5cd04fc$export$2e2bcd8739ae039);

var $4Gk6P = parcelRequire("4Gk6P");

var $eLI0w = parcelRequire("eLI0w");

var $8v3fy = parcelRequire("8v3fy");
// eslint-disable-next-line consistent-return
function $d5615f18e5cd04fc$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $4Gk6P.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $d5615f18e5cd04fc$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $8v3fy.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $8v3fy.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $eLI0w.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("4Gk6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $368aaef25f6a2997$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $aSEG4 = parcelRequire("aSEG4");

var $dzxhF = parcelRequire("dzxhF");

var $eU5ou = parcelRequire("eU5ou");

var $kSXRh = parcelRequire("kSXRh");

var $ln9F4 = parcelRequire("ln9F4");

var $dMYym = parcelRequire("dMYym");

var $bKnBV = parcelRequire("bKnBV");

var $iDVue = parcelRequire("iDVue");

var $e4nxq = parcelRequire("e4nxq");
function $368aaef25f6a2997$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $dzxhF.default).white,
            default: (0, $dzxhF.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $368aaef25f6a2997$export$a43af521ac8c3202 = $368aaef25f6a2997$var$getLight();
function $368aaef25f6a2997$var$getDark() {
    return {
        text: {
            primary: (0, $dzxhF.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $dzxhF.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $368aaef25f6a2997$export$55ce6f3a06c59543 = $368aaef25f6a2997$var$getDark();
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $aSEG4.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $aSEG4.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bKnBV.default)[200],
        light: (0, $bKnBV.default)[50],
        dark: (0, $bKnBV.default)[400]
    };
    return {
        main: (0, $bKnBV.default)[700],
        light: (0, $bKnBV.default)[400],
        dark: (0, $bKnBV.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kSXRh.default)[200],
        light: (0, $kSXRh.default)[50],
        dark: (0, $kSXRh.default)[400]
    };
    return {
        main: (0, $kSXRh.default)[500],
        light: (0, $kSXRh.default)[300],
        dark: (0, $kSXRh.default)[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ln9F4.default)[500],
        light: (0, $ln9F4.default)[300],
        dark: (0, $ln9F4.default)[700]
    };
    return {
        main: (0, $ln9F4.default)[700],
        light: (0, $ln9F4.default)[400],
        dark: (0, $ln9F4.default)[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $iDVue.default)[400],
        light: (0, $iDVue.default)[300],
        dark: (0, $iDVue.default)[700]
    };
    return {
        main: (0, $iDVue.default)[700],
        light: (0, $iDVue.default)[500],
        dark: (0, $iDVue.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4nxq.default)[400],
        light: (0, $e4nxq.default)[300],
        dark: (0, $e4nxq.default)[700]
    };
    return {
        main: (0, $e4nxq.default)[800],
        light: (0, $e4nxq.default)[500],
        dark: (0, $e4nxq.default)[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dMYym.default)[400],
        light: (0, $dMYym.default)[300],
        dark: (0, $dMYym.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dMYym.default)[500],
        dark: (0, $dMYym.default)[900]
    };
}
function $368aaef25f6a2997$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $aSEG4.getContrastRatio)(background, $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $368aaef25f6a2997$export$55ce6f3a06c59543.text.primary : $368aaef25f6a2997$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $368aaef25f6a2997$var$getLight();
    else if (mode === 'dark') modeHydrated = $368aaef25f6a2997$var$getDark();
    const paletteOutput = (0, $3z1Ay.default)({
        // A collection of common colors.
        common: {
            ...(0, $dzxhF.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $eU5ou.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("aSEG4", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", () => $7ebe803ced17df29$export$427365fc3db6fc5e);
$parcel$export(module.exports, "hslToRgb", () => $7ebe803ced17df29$export$29fb7152bd3f781a);
$parcel$export(module.exports, "getContrastRatio", () => $7ebe803ced17df29$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $7ebe803ced17df29$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "private_safeAlpha", () => $7ebe803ced17df29$export$34109543fc7f43f8);
$parcel$export(module.exports, "darken", () => $7ebe803ced17df29$export$4b073707ff63303);
$parcel$export(module.exports, "private_safeDarken", () => $7ebe803ced17df29$export$eaaef2dca3e9e512);
$parcel$export(module.exports, "lighten", () => $7ebe803ced17df29$export$c0816ed86df316af);
$parcel$export(module.exports, "private_safeLighten", () => $7ebe803ced17df29$export$aeeda94ef1d01275);
$parcel$export(module.exports, "private_safeEmphasize", () => $7ebe803ced17df29$export$11bb74ba10c85505);

var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7ebe803ced17df29$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $7ebe803ced17df29$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7ebe803ced17df29$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $7ebe803ced17df29$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $7ebe803ced17df29$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $7ebe803ced17df29$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $7ebe803ced17df29$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $7ebe803ced17df29$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $7ebe803ced17df29$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $7ebe803ced17df29$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $7ebe803ced17df29$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$7ebe803ced17df29$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $7ebe803ced17df29$export$29fb7152bd3f781a(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $7ebe803ced17df29$export$c852d90bf7403b62(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $7ebe803ced17df29$export$d061e26956a60b0a(foreground, background) {
    const lumA = $7ebe803ced17df29$export$c852d90bf7403b62(foreground);
    const lumB = $7ebe803ced17df29$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    value = $7ebe803ced17df29$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $7ebe803ced17df29$export$c852d90bf7403b62(color) > 0.5 ? $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) : $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
}
function $7ebe803ced17df29$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7ebe803ced17df29$export$677b39864803984e(background);
    const overlayColor = $7ebe803ced17df29$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("dzxhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e185cbbdd17e0f7$export$2e2bcd8739ae039);
const $9e185cbbdd17e0f7$var$common = {
    black: '#000',
    white: '#fff'
};
var $9e185cbbdd17e0f7$export$2e2bcd8739ae039 = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad9a7ac9db04746c$export$2e2bcd8739ae039);
const $ad9a7ac9db04746c$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $ad9a7ac9db04746c$export$2e2bcd8739ae039 = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34748703626d0dc$export$2e2bcd8739ae039);
const $f34748703626d0dc$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $f34748703626d0dc$export$2e2bcd8739ae039 = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f33d825c71610f$export$2e2bcd8739ae039);
const $f8f33d825c71610f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $f8f33d825c71610f$export$2e2bcd8739ae039 = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {

$parcel$export(module.exports, "default", () => $a09ebaae00c386da$export$2e2bcd8739ae039);
const $a09ebaae00c386da$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $a09ebaae00c386da$export$2e2bcd8739ae039 = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d64e288ac9a70b$export$2e2bcd8739ae039);
const $88d64e288ac9a70b$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $88d64e288ac9a70b$export$2e2bcd8739ae039 = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9287623794ffe70$export$2e2bcd8739ae039);
const $d9287623794ffe70$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d9287623794ffe70$export$2e2bcd8739ae039 = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e3b29cd31a116f$export$2e2bcd8739ae039);
const $a3e3b29cd31a116f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $a3e3b29cd31a116f$export$2e2bcd8739ae039 = $a3e3b29cd31a116f$var$green;

});


parcelRegister("eLI0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07976fc01fdfa9$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $2GcsG = parcelRequire("2GcsG");
var $fOmBr = parcelRequire("fOmBr");

var $7kpn1 = parcelRequire("7kpn1");

var $3sIPp = parcelRequire("3sIPp");
var $6UPjt = parcelRequire("6UPjt");
var $8OyjJ = parcelRequire("8OyjJ");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $aSEG4 = parcelRequire("aSEG4");

var $8v3fy = parcelRequire("8v3fy");

var $2JzIB = parcelRequire("2JzIB");

var $fPRn6 = parcelRequire("fPRn6");

var $9yYvT = parcelRequire("9yYvT");

var $2ICMq = parcelRequire("2ICMq");
function $ac07976fc01fdfa9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ac07976fc01fdfa9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ac07976fc01fdfa9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $aSEG4.hslToRgb)(color);
}
function $ac07976fc01fdfa9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $aSEG4.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ac07976fc01fdfa9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ac07976fc01fdfa9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ac07976fc01fdfa9$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $fOmBr.default)(cssVarPrefix);
function $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $2JzIB.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $8v3fy.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $2JzIB.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $2JzIB.getOverlays)(mode)
    };
    return muiTheme;
}
function $ac07976fc01fdfa9$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $fPRn6.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ac07976fc01fdfa9$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $cpmCj.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ac07976fc01fdfa9$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $8OyjJ.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ac07976fc01fdfa9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#fff');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#000');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $ac07976fc01fdfa9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', (0, $aSEG4.private_safeDarken)(palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', (0, $aSEG4.private_safeDarken)(palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', (0, $aSEG4.private_safeDarken)(palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', (0, $aSEG4.private_safeDarken)(palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', (0, $aSEG4.private_safeLighten)(palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', (0, $aSEG4.private_safeLighten)(palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', (0, $aSEG4.private_safeLighten)(palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', (0, $aSEG4.private_safeLighten)(palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $aSEG4.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $aSEG4.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', (0, $aSEG4.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', (0, $aSEG4.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', (0, $aSEG4.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', (0, $aSEG4.private_safeLighten)(palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', (0, $aSEG4.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', (0, $aSEG4.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', (0, $aSEG4.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', (0, $aSEG4.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', (0, $aSEG4.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', (0, $aSEG4.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $aSEG4.private_safeEmphasize)(palette.background.default, 0.8);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $aSEG4.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $aSEG4.private_safeLighten)(palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $aSEG4.private_safeLighten)(palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $aSEG4.private_safeLighten)(palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $aSEG4.private_safeLighten)(palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', (0, $aSEG4.private_safeLighten)(palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $aSEG4.private_safeLighten)(palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', (0, $aSEG4.private_safeLighten)((0, $aSEG4.private_safeAlpha)(palette.divider, 1), 0.88));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', (0, $aSEG4.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', (0, $aSEG4.private_safeLighten)(palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', (0, $aSEG4.private_safeLighten)(palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', (0, $aSEG4.private_safeLighten)(palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', (0, $aSEG4.private_safeLighten)(palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', (0, $aSEG4.private_safeDarken)(palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', (0, $aSEG4.private_safeDarken)(palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', (0, $aSEG4.private_safeDarken)(palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', (0, $aSEG4.private_safeDarken)(palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', (0, $aSEG4.private_safeDarken)(palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $aSEG4.private_safeDarken)(palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', (0, $aSEG4.private_safeDarken)(palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', (0, $aSEG4.private_safeDarken)(palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', (0, $aSEG4.private_safeDarken)(palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', (0, $aSEG4.private_safeDarken)(palette.warning.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', (0, $aSEG4.private_safeDarken)(palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', (0, $aSEG4.private_safeDarken)(palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', (0, $aSEG4.private_safeDarken)(palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', (0, $aSEG4.private_safeDarken)(palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', (0, $aSEG4.private_safeDarken)(palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', (0, $aSEG4.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $aSEG4.private_safeEmphasize)(palette.background.default, 0.98);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $aSEG4.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $aSEG4.private_safeDarken)(palette.primary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $aSEG4.private_safeDarken)(palette.secondary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', (0, $aSEG4.private_safeDarken)(palette.error.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', (0, $aSEG4.private_safeDarken)(palette.info.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', (0, $aSEG4.private_safeDarken)(palette.success.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', (0, $aSEG4.private_safeDarken)(palette.warning.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', (0, $aSEG4.private_safeDarken)((0, $aSEG4.private_safeAlpha)(palette.divider, 1), 0.68));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', (0, $aSEG4.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'paper');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'background');
        $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'onBackground');
        $ac07976fc01fdfa9$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ac07976fc01fdfa9$var$setColor(palette[color], 'mainChannel', (0, $aSEG4.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.main)));
                if (colors.light) $ac07976fc01fdfa9$var$setColor(palette[color], 'lightChannel', (0, $aSEG4.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.light)));
                if (colors.dark) $ac07976fc01fdfa9$var$setColor(palette[color], 'darkChannel', (0, $aSEG4.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.dark)));
                if (colors.contrastText) $ac07976fc01fdfa9$var$setColor(palette[color], 'contrastTextChannel', (0, $aSEG4.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'primary');
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $9yYvT.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $6UPjt.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $2GcsG.default)(input.spacing, (0, $7kpn1.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $3sIPp.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $2ICMq.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fOmBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b82d0f0117f79ef3$export$2e2bcd8739ae039);
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $b82d0f0117f79ef3$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("3sIPp", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", () => $2856c28c5d84ba80$export$858538ff6c0d421d);
/* eslint-disable import/prefer-default-export */ function $2856c28c5d84ba80$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("6UPjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $508fc6c60afa1bca$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $3JNYS = parcelRequire("3JNYS");
function $508fc6c60afa1bca$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3JNYS.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3JNYS.default)(scheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3JNYS.default)(defaultScheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3z1Ay.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $508fc6c60afa1bca$export$2e2bcd8739ae039 = $508fc6c60afa1bca$var$prepareCssVars;

});
parcelRegister("3JNYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8c5837678016ea$export$2e2bcd8739ae039);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $2b8c5837678016ea$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $2b8c5837678016ea$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $2b8c5837678016ea$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $2b8c5837678016ea$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $2b8c5837678016ea$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $2b8c5837678016ea$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $2b8c5837678016ea$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $2b8c5837678016ea$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("8OyjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ad9cf01c4526b5$export$2e2bcd8739ae039);
function $66ad9cf01c4526b5$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("8v3fy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6303bd594dbbe1c5$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $6o2lr = parcelRequire("6o2lr");


var $6plKN = parcelRequire("6plKN");

var $4Gk6P = parcelRequire("4Gk6P");

var $d6q8u = parcelRequire("d6q8u");

var $jtCFx = parcelRequire("jtCFx");

var $bmoVh = parcelRequire("bmoVh");

var $lhXgK = parcelRequire("lhXgK");

var $2ICMq = parcelRequire("2ICMq");
function $6303bd594dbbe1c5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $cpmCj.default)(20));
    const palette = (0, $4Gk6P.default)(paletteInput);
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $6plKN.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $jtCFx.default).slice(),
        typography: (0, $d6q8u.default)(palette, typographyInput),
        transitions: (0, $bmoVh.default)(transitionsInput),
        zIndex: {
            ...(0, $lhXgK.default)
        }
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $2ICMq.stringifyTheme); // for Pigment CSS integration
    return muiTheme;
}
let $6303bd594dbbe1c5$var$warnedOnce = false;
function $6303bd594dbbe1c5$export$c469355549431d9b(...args) {
    return $6303bd594dbbe1c5$var$createThemeNoVars(...args);
}
var $6303bd594dbbe1c5$export$2e2bcd8739ae039 = $6303bd594dbbe1c5$var$createThemeNoVars;

});
parcelRegister("6plKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa5f3b4975f3e4c$export$2e2bcd8739ae039);
function $4aa5f3b4975f3e4c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("d6q8u", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a01bf22de9dc59$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $98a01bf22de9dc59$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
                letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2deb8a0bbe5ea21$export$2e2bcd8739ae039);
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$export$2e2bcd8739ae039 = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {

$parcel$export(module.exports, "duration", () => $845514f3678d3888$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $845514f3678d3888$export$2e2bcd8739ae039);
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $845514f3678d3888$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $845514f3678d3888$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $845514f3678d3888$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$845514f3678d3888$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$845514f3678d3888$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("lhXgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9291b6f07cefb$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$export$2e2bcd8739ae039 = $f7f9291b6f07cefb$var$zIndex;

});

parcelRegister("2ICMq", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", () => $1fadc5be6a14f8c8$export$32c2afa5f91892aa);
/* eslint-disable import/prefer-default-export */ 
var $3z1Ay = parcelRequire("3z1Ay");
function $1fadc5be6a14f8c8$var$isSerializable(val) {
    return (0, $3z1Ay.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $1fadc5be6a14f8c8$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$1fadc5be6a14f8c8$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $3z1Ay.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("2JzIB", function(module, exports) {

$parcel$export(module.exports, "getOpacity", () => $1fdb7dab8864519b$export$c85e0347fceb69ba);
$parcel$export(module.exports, "getOverlays", () => $1fdb7dab8864519b$export$dd191566510330d3);
$parcel$export(module.exports, "default", () => $1fdb7dab8864519b$export$2e2bcd8739ae039);

var $4Gk6P = parcelRequire("4Gk6P");

var $35vyj = parcelRequire("35vyj");
const $1fdb7dab8864519b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $35vyj.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $1fdb7dab8864519b$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $1fdb7dab8864519b$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $1fdb7dab8864519b$var$defaultDarkOverlays : [];
}
function $1fdb7dab8864519b$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $4Gk6P.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$1fdb7dab8864519b$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $1fdb7dab8864519b$export$dd191566510330d3(palette.mode),
        ...rest
    };
}

});
parcelRegister("35vyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $23fa506264c010ed$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $23fa506264c010ed$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("fPRn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b87504e8f71bd950$export$2e2bcd8739ae039);
function $b87504e8f71bd950$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9yYvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f663abbabfb57a0$export$2e2bcd8739ae039);

var $kKEhy = parcelRequire("kKEhy");
var $6f663abbabfb57a0$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $kKEhy.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("kKEhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1b759b2363a287f$export$2e2bcd8739ae039);
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$export$2e2bcd8739ae039 = $f1b759b2363a287f$var$excludeVariablesFromRoot;

});





parcelRegister("4jPsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3250d9bb994a2d02$export$2e2bcd8739ae039);
var $3250d9bb994a2d02$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("8Uq77", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7cf568a060c3d$export$2e2bcd8739ae039);

var $PJRTc = parcelRequire("PJRTc");
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$export$2e2bcd8739ae039 = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b8580029d7f562$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$export$2e2bcd8739ae039 = $09b8580029d7f562$var$slotShouldForwardProp;

});



parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7Ekty", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bbT5Q.default;
    }
});

var $bbT5Q = parcelRequire("bbT5Q");

});
parcelRegister("bbT5Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $825b752ac2a74c27$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $3ErGR = parcelRequire("3ErGR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $825b752ac2a74c27$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3ErGR.default), {
            "data-testid": `${displayName}Icon`,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $3ErGR.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("3ErGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8a963e5702921b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $aiIP4 = parcelRequire("aiIP4");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2a8a963e5702921b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $jTnBY.default)(color)}`,
            `fontSize${(0, $jTnBY.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $aiIP4.getSvgIconUtilityClass), classes);
};
const $2a8a963e5702921b$var$SvgIconRoot = (0, $d8seH.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jTnBY.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $2a8a963e5702921b$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2a8a963e5702921b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2a8a963e5702921b$var$SvgIconRoot, {
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$2a8a963e5702921b$var$SvgIcon.muiName = 'SvgIcon';
var $2a8a963e5702921b$export$2e2bcd8739ae039 = $2a8a963e5702921b$var$SvgIcon;

});
parcelRegister("5FMfE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d4ac8f5598bbabd$export$2e2bcd8739ae039);
function $1d4ac8f5598bbabd$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $1d4ac8f5598bbabd$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $1d4ac8f5598bbabd$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $1d4ac8f5598bbabd$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $1d4ac8f5598bbabd$export$2e2bcd8739ae039 = $1d4ac8f5598bbabd$export$4f5d2d50c9deca37;

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("jTnBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7b578196486f177$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $e7b578196486f177$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("aeD7H", function(module, exports) {

$parcel$export(module.exports, "default", () => $77398f38c6229912$export$2e2bcd8739ae039);

var $jgzqq = parcelRequire("jgzqq");
const $77398f38c6229912$var$memoTheme = (0, $jgzqq.default);
var $77398f38c6229912$export$2e2bcd8739ae039 = $77398f38c6229912$var$memoTheme;

});
parcelRegister("jgzqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06afda6b2197864$export$2e2bcd8739ae039);

var $aFFCY = parcelRequire("aFFCY");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $e06afda6b2197864$var$arg = {
    theme: undefined
};
function $e06afda6b2197864$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $e06afda6b2197864$var$arg.theme = props.theme;
            value = (0, $aFFCY.default)(styleFn($e06afda6b2197864$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("1iOpW", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f2e94b8fca67639$export$2440da353cedad43);
parcelRequire("acw62");


var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), {
        ...props
    });
}
var $0f2e94b8fca67639$export$2e2bcd8739ae039 = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$export$2440da353cedad43(params) {
    return (0, $aMyfV.useDefaultProps)(params);
}

});
parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7d98f590ab80e73c$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});
parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("aiIP4", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $77fe5ab326d42cdb$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $77fe5ab326d42cdb$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $77fe5ab326d42cdb$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $77fe5ab326d42cdb$export$2e2bcd8739ae039 = $77fe5ab326d42cdb$var$svgIconClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});







parcelRegister("3a7ni", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $24d806c00316f755$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24d806c00316f755$var$_createSvgIcon = $24d806c00316f755$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $24d806c00316f755$var$_default = module.exports.default = (0, $24d806c00316f755$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1"
}), 'AddRounded');

});

parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("2iAqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ac984bce84b2164$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $6n0Ko = parcelRequire("6n0Ko");

var $khjmj = parcelRequire("khjmj");

var $9Rgf1 = parcelRequire("9Rgf1");

var $cbVYE = parcelRequire("cbVYE");

var $doXfV = parcelRequire("doXfV");

var $guz4p = parcelRequire("guz4p");

var $eWb0W = parcelRequire("eWb0W");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1ac984bce84b2164$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $1ac984bce84b2164$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $eWb0W.getMenuItemUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $1ac984bce84b2164$var$MenuItemRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $1ac984bce84b2164$export$4334bb34c76fef24
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $eWb0W.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $eWb0W.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $eWb0W.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $eWb0W.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $cbVYE.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $cbVYE.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $guz4p.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $guz4p.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $doXfV.default).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $doXfV.default).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $1ac984bce84b2164$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $khjmj.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $1ac984bce84b2164$var$useUtilityClasses(props);
    const handleRef = (0, $9Rgf1.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ac984bce84b2164$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $5FMfE.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $5FMfE.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $1ac984bce84b2164$export$2e2bcd8739ae039 = $1ac984bce84b2164$var$MenuItem;

});
parcelRegister("3W6ht", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ddba918a398c481$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2ddba918a398c481$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $2ddba918a398c481$export$2e2bcd8739ae039 = $2ddba918a398c481$var$ListContext;

});

parcelRegister("6n0Ko", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a35786d89db9dda$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");



var $8Indx = parcelRequire("8Indx");

var $52FI1 = parcelRequire("52FI1");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $4o7uD = parcelRequire("4o7uD");

var $ju2Oo = parcelRequire("ju2Oo");

var $brF9L = parcelRequire("brF9L");

var $5JO1P = parcelRequire("5JO1P");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a35786d89db9dda$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5JO1P.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a35786d89db9dda$export$7ec0dcc5e3cdcd36 = (0, $d8seH.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $5JO1P.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a35786d89db9dda$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $acw62.useRef(null);
    const ripple = (0, $ju2Oo.default)();
    const handleRippleRef = (0, $9Rgf1.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $4a35786d89db9dda$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $4a35786d89db9dda$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $52FI1.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $4o7uD.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $52FI1.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $4o7uD.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $4o7uD.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $9Rgf1.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $4a35786d89db9dda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a35786d89db9dda$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $brF9L.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $4a35786d89db9dda$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $4o7uD.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $4a35786d89db9dda$export$2e2bcd8739ae039 = $4a35786d89db9dda$var$ButtonBase;

});
parcelRegister("52FI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3abd7e3358fc5f35$export$2e2bcd8739ae039);
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $3abd7e3358fc5f35$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("9Rgf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d5a979b2ad8bc9$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");
'use client';
var $72d5a979b2ad8bc9$export$2e2bcd8739ae039 = (0, $3qSdM.default);

});
parcelRegister("3qSdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fddc0219860a83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("4o7uD", function(module, exports) {

$parcel$export(module.exports, "default", () => $331f3746e6346411$export$2e2bcd8739ae039);

var $13KXh = parcelRequire("13KXh");
'use client';
var $331f3746e6346411$export$2e2bcd8739ae039 = (0, $13KXh.default);

});
parcelRegister("13KXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a7e8ccbc07697$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $eEJPp.default)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;

});
parcelRegister("eEJPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab859a020ad749e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;

});



parcelRegister("ju2Oo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f30007e7be7ff3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");
'use client';
class $e2f30007e7be7ff3$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $e2f30007e7be7ff3$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $iYIN2.default)($e2f30007e7be7ff3$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $e2f30007e7be7ff3$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $e2f30007e7be7ff3$export$2e2bcd8739ae039() {
    return $e2f30007e7be7ff3$export$f5de0641c7db4154.use();
}
function $e2f30007e7be7ff3$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("iYIN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1092ee97d527c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("brF9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $855224273a002a0f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $jEvxL = parcelRequire("jEvxL");

var $5FMfE = parcelRequire("5FMfE");

var $lHOu3 = parcelRequire("lHOu3");

var $8zogs = parcelRequire("8zogs");
var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hruNq = parcelRequire("hruNq");

var $a4Mf7 = parcelRequire("a4Mf7");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $855224273a002a0f$var$DURATION = 550;
const $855224273a002a0f$export$95d0c9356b2231a3 = 80;
const $855224273a002a0f$var$enterKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $855224273a002a0f$var$exitKeyframe = (0, $8zogs.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $855224273a002a0f$var$pulsateKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $855224273a002a0f$export$f6b7418508c72c25 = (0, $d8seH.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $855224273a002a0f$export$676cfe7b12693c4b = (0, $d8seH.default)((0, $hruNq.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $a4Mf7.default).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$855224273a002a0f$var$enterKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $a4Mf7.default).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $a4Mf7.default).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $a4Mf7.default).childLeaving} {
    opacity: 0;
    animation-name: ${$855224273a002a0f$var$exitKeyframe};
    animation-duration: ${$855224273a002a0f$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $a4Mf7.default).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$855224273a002a0f$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $855224273a002a0f$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $lHOu3.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $5FMfE.default)(classes.ripple, (0, $a4Mf7.default).ripple),
                        rippleVisible: (0, $5FMfE.default)(classes.rippleVisible, (0, $a4Mf7.default).rippleVisible),
                        ripplePulsate: (0, $5FMfE.default)(classes.ripplePulsate, (0, $a4Mf7.default).ripplePulsate),
                        child: (0, $5FMfE.default)(classes.child, (0, $a4Mf7.default).child),
                        childLeaving: (0, $5FMfE.default)(classes.childLeaving, (0, $a4Mf7.default).childLeaving),
                        childPulsate: (0, $5FMfE.default)(classes.childPulsate, (0, $a4Mf7.default).childPulsate)
                    },
                    timeout: $855224273a002a0f$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($855224273a002a0f$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($855224273a002a0f$export$f6b7418508c72c25, {
        className: (0, $5FMfE.default)((0, $a4Mf7.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEvxL.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $855224273a002a0f$export$2e2bcd8739ae039 = $855224273a002a0f$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hDpcU.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $8nd05.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $1En50.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("lHOu3", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $fcd4c6205d65c7df$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $fcd4c6205d65c7df$export$2e2bcd8739ae039);

var $iYIN2 = parcelRequire("iYIN2");

var $dOphX = parcelRequire("dOphX");
'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $iYIN2.default)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $dOphX.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("dOphX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e38fa988f617e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("hruNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2cd8c78d72bd92$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cb2cd8c78d72bd92$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $5FMfE.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $5FMfE.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $cb2cd8c78d72bd92$export$2e2bcd8739ae039 = $cb2cd8c78d72bd92$var$Ripple;

});

parcelRegister("a4Mf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $755fb323846f60d4$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $755fb323846f60d4$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $755fb323846f60d4$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $755fb323846f60d4$export$2e2bcd8739ae039 = $755fb323846f60d4$var$touchRippleClasses;

});


parcelRegister("5JO1P", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $42d7f65840078ec1$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $42d7f65840078ec1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $42d7f65840078ec1$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $42d7f65840078ec1$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $42d7f65840078ec1$export$2e2bcd8739ae039 = $42d7f65840078ec1$var$buttonBaseClasses;

});


parcelRegister("khjmj", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec346974df496fc5$export$2e2bcd8739ae039);

var $eEJPp = parcelRequire("eEJPp");
'use client';
var $ec346974df496fc5$export$2e2bcd8739ae039 = (0, $eEJPp.default);

});

parcelRegister("cbVYE", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", () => $024a60f892d3fa61$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $024a60f892d3fa61$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $024a60f892d3fa61$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $024a60f892d3fa61$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $024a60f892d3fa61$export$2e2bcd8739ae039 = $024a60f892d3fa61$var$dividerClasses;

});

parcelRegister("doXfV", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $9c1b7b40cd19f5fe$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $9c1b7b40cd19f5fe$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9c1b7b40cd19f5fe$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $9c1b7b40cd19f5fe$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $9c1b7b40cd19f5fe$export$2e2bcd8739ae039 = $9c1b7b40cd19f5fe$var$listItemIconClasses;

});

parcelRegister("guz4p", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $c01aa6ddbe5e68bd$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $c01aa6ddbe5e68bd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c01aa6ddbe5e68bd$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $c01aa6ddbe5e68bd$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $c01aa6ddbe5e68bd$export$2e2bcd8739ae039 = $c01aa6ddbe5e68bd$var$listItemTextClasses;

});

parcelRegister("eWb0W", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $adff06ac3b11e066$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $adff06ac3b11e066$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adff06ac3b11e066$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$export$2e2bcd8739ae039 = $adff06ac3b11e066$var$menuItemClasses;

});


parcelRegister("9Lykx", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c322247f7fbf93$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $5A6d3 = parcelRequire("5A6d3");

var $aSEG4 = parcelRequire("aSEG4");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $2cPwN = parcelRequire("2cPwN");

var $jTnBY = parcelRequire("jTnBY");

var $jzUw6 = parcelRequire("jzUw6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71c322247f7fbf93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jzUw6.getIconButtonUtilityClass), classes);
};
const $71c322247f7fbf93$var$IconButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $aeD7H.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.vars ? `rgba(${(theme.vars || theme).palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)((theme.vars || theme).palette[color].main, theme.palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $jzUw6.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $jzUw6.default).loading}`]: {
            color: 'transparent'
        }
    })));
const $71c322247f7fbf93$var$IconButtonLoadingIndicator = (0, $d8seH.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $71c322247f7fbf93$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $5A6d3.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $71c322247f7fbf93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($71c322247f7fbf93$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $5FMfE.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($71c322247f7fbf93$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $71c322247f7fbf93$export$2e2bcd8739ae039 = $71c322247f7fbf93$var$IconButton;

});
parcelRegister("5A6d3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4105219ee6538ed1$export$2e2bcd8739ae039);

var $auC0X = parcelRequire("auC0X");
'use client';
var $4105219ee6538ed1$export$2e2bcd8739ae039 = (0, $auC0X.default);

});
parcelRegister("auC0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3a319e7e555608$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $7a3a319e7e555608$var$safeReact = {
    ...$acw62
};
const $7a3a319e7e555608$var$maybeReactUseId = $7a3a319e7e555608$var$safeReact.useId;
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}

});


parcelRegister("1Anyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $127b6c47a683862d$export$2e2bcd8739ae039);
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $127b6c47a683862d$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $127b6c47a683862d$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$127b6c47a683862d$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $127b6c47a683862d$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $127b6c47a683862d$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("2cPwN", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b4ac261663afa8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $8zogs = parcelRequire("8zogs");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $fPJfA = parcelRequire("fPJfA");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $19b4ac261663afa8$var$SIZE = 44;
const $19b4ac261663afa8$var$circularRotateKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $19b4ac261663afa8$var$circularDashKeyframe = (0, $8zogs.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $19b4ac261663afa8$var$rotateAnimation = typeof $19b4ac261663afa8$var$circularRotateKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $19b4ac261663afa8$var$dashAnimation = typeof $19b4ac261663afa8$var$circularDashKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $19b4ac261663afa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $jTnBY.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $jTnBY.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fPJfA.getCircularProgressUtilityClass), classes);
};
const $19b4ac261663afa8$var$CircularProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $19b4ac261663afa8$var$rotateAnimation || {
                    animation: `${$19b4ac261663afa8$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $19b4ac261663afa8$var$CircularProgressSVG = (0, $d8seH.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $19b4ac261663afa8$var$CircularProgressCircle = (0, $d8seH.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $19b4ac261663afa8$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$19b4ac261663afa8$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $19b4ac261663afa8$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $19b4ac261663afa8$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($19b4ac261663afa8$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE / 2} ${$19b4ac261663afa8$var$SIZE} ${$19b4ac261663afa8$var$SIZE}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($19b4ac261663afa8$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $19b4ac261663afa8$var$SIZE,
                cy: $19b4ac261663afa8$var$SIZE,
                r: ($19b4ac261663afa8$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $19b4ac261663afa8$export$2e2bcd8739ae039 = $19b4ac261663afa8$var$CircularProgress;

});
parcelRegister("fPJfA", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $b86eb8364bb4993c$export$29cad1383b3f235d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b86eb8364bb4993c$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $b86eb8364bb4993c$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $b86eb8364bb4993c$export$2e2bcd8739ae039 = $b86eb8364bb4993c$var$circularProgressClasses;

});


parcelRegister("jzUw6", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $e40d2047b7c1e09d$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $e40d2047b7c1e09d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e40d2047b7c1e09d$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $e40d2047b7c1e09d$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $e40d2047b7c1e09d$export$2e2bcd8739ae039 = $e40d2047b7c1e09d$var$iconButtonClasses;

});


parcelRegister("cVXaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a8b4f445fd9172$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $58lXc = parcelRequire("58lXc");

var $52FI1 = parcelRequire("52FI1");

var $2xc7G = parcelRequire("2xc7G");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $iscuz = parcelRequire("iscuz");

var $e76iu = parcelRequire("e76iu");

var $4o7uD = parcelRequire("4o7uD");

var $9Rgf1 = parcelRequire("9Rgf1");

var $5A6d3 = parcelRequire("5A6d3");

var $3yddg = parcelRequire("3yddg");

var $6lpak = parcelRequire("6lpak");

var $eVjpW = parcelRequire("eVjpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $96a8b4f445fd9172$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $96a8b4f445fd9172$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $jTnBY.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eVjpW.getTooltipUtilityClass), classes);
};
const $96a8b4f445fd9172$var$TooltipPopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $eVjpW.default).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $eVjpW.default).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $eVjpW.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $eVjpW.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipTooltip = (0, $d8seH.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $jTnBY.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $aSEG4.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $eVjpW.default).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$96a8b4f445fd9172$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $eVjpW.default).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $96a8b4f445fd9172$var$TooltipArrow = (0, $d8seH.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $aSEG4.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $96a8b4f445fd9172$var$hystersisOpen = false;
const $96a8b4f445fd9172$var$hystersisTimer = new (0, $lHOu3.Timeout)();
let $96a8b4f445fd9172$var$cursorPosition = {
    x: 0,
    y: 0
};
function $96a8b4f445fd9172$export$b9ee5a7ace0541f8() {
    $96a8b4f445fd9172$var$hystersisOpen = false;
    $96a8b4f445fd9172$var$hystersisTimer.clear();
}
function $96a8b4f445fd9172$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $96a8b4f445fd9172$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $lHOu3.default)();
    const enterTimer = (0, $lHOu3.default)();
    const leaveTimer = (0, $lHOu3.default)();
    const touchTimer = (0, $lHOu3.default)();
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $5A6d3.default)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $4o7uD.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.clear();
        $96a8b4f445fd9172$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $4o7uD.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $96a8b4f445fd9172$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $96a8b4f445fd9172$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $96a8b4f445fd9172$var$hystersisOpen && enterNextDelay) enterTimer.start($96a8b4f445fd9172$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $52FI1.default)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $52FI1.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $9Rgf1.default)((0, $2xc7G.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $96a8b4f445fd9172$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $5FMfE.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $96a8b4f445fd9172$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $96a8b4f445fd9172$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $96a8b4f445fd9172$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $96a8b4f445fd9172$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $acw62.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $96a8b4f445fd9172$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $6lpak.default)('popper', {
        elementType: $96a8b4f445fd9172$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $iscuz.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $6lpak.default)('tooltip', {
        elementType: $96a8b4f445fd9172$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $6lpak.default)('arrow', {
        elementType: $96a8b4f445fd9172$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $e76iu.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $96a8b4f445fd9172$var$cursorPosition.y,
                            left: $96a8b4f445fd9172$var$cursorPosition.x,
                            right: $96a8b4f445fd9172$var$cursorPosition.x,
                            bottom: $96a8b4f445fd9172$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $96a8b4f445fd9172$export$2e2bcd8739ae039 = $96a8b4f445fd9172$var$Tooltip;

});
parcelRegister("58lXc", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $3bcebab40d8ce666$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $3bcebab40d8ce666$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value ?? false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;

});

parcelRegister("2xc7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d88113360503233$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});

parcelRegister("14H9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c87a2f38cd49c7a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $eM1DJ = parcelRequire("eM1DJ");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $0c87a2f38cd49c7a$export$2e2bcd8739ae039() {
    const theme = (0, $eM1DJ.default)((0, $jR9F1.default));
    return theme[0, $4jPsi.default] || theme;
}

});
parcelRegister("eM1DJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac16d208682bdb3f$export$2e2bcd8739ae039);

var $6o2lr = parcelRequire("6o2lr");

var $g6Om4 = parcelRequire("g6Om4");
'use client';
const $ac16d208682bdb3f$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $ac16d208682bdb3f$var$useTheme(defaultTheme = $ac16d208682bdb3f$export$35e57303dbd8a66) {
    return (0, $g6Om4.default)(defaultTheme);
}
var $ac16d208682bdb3f$export$2e2bcd8739ae039 = $ac16d208682bdb3f$var$useTheme;

});
parcelRegister("g6Om4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba4444e1ea571ca$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("8zogs");
var $NxDAE = parcelRequire("NxDAE");
'use client';
function $bba4444e1ea571ca$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $bba4444e1ea571ca$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $NxDAE.T));
    return !contextTheme || $bba4444e1ea571ca$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $bba4444e1ea571ca$export$2e2bcd8739ae039 = $bba4444e1ea571ca$var$useTheme;

});



parcelRegister("iscuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f4882a3b1c59f2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $lHOu3 = parcelRequire("lHOu3");


var $2xc7G = parcelRequire("2xc7G");

var $1mPeS = parcelRequire("1mPeS");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $d6f4882a3b1c59f2$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $d6f4882a3b1c59f2$var$styles = {
    entering: {
        opacity: 1,
        transform: $d6f4882a3b1c59f2$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $d6f4882a3b1c59f2$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $d6f4882a3b1c59f2$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const timer = (0, $lHOu3.default)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $14H9o.default)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $d6f4882a3b1c59f2$var$isWebKit154 ? duration : duration * 0.666,
                delay: $d6f4882a3b1c59f2$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $d6f4882a3b1c59f2$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $d6f4882a3b1c59f2$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$d6f4882a3b1c59f2$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($d6f4882a3b1c59f2$var$Grow) $d6f4882a3b1c59f2$var$Grow.muiSupportAuto = true;
var $d6f4882a3b1c59f2$export$2e2bcd8739ae039 = $d6f4882a3b1c59f2$var$Grow;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});

parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("hweuE", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $cc10aae84e3e4b9c$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $cc10aae84e3e4b9c$export$8cb1e9b404609ae9);
const $cc10aae84e3e4b9c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $cc10aae84e3e4b9c$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});


parcelRegister("e76iu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4669aa090d445bd$export$2e2bcd8739ae039);

var $58lXc = parcelRequire("58lXc");




var $acw62 = parcelRequire("acw62");

var $7JHF2 = parcelRequire("7JHF2");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a4669aa090d445bd$var$PopperRoot = (0, $d8seH.default)((0, $7JHF2.default), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://v6.mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 * - [Popper](https://v6.mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://v6.mui.com/material-ui/api/popper/)
 */ const $a4669aa090d445bd$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $58lXc.useRtl)();
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a4669aa090d445bd$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $a4669aa090d445bd$export$2e2bcd8739ae039 = $a4669aa090d445bd$var$Popper;

});
parcelRegister("7JHF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1e9a841ed0d0fc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");

var $3tUi5 = parcelRequire("3tUi5");


var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $2Q995 = parcelRequire("2Q995");

var $g3XLf = parcelRequire("g3XLf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $5a1e9a841ed0d0fc$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $5a1e9a841ed0d0fc$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $5a1e9a841ed0d0fc$var$isVirtualElement(element) {
    return !$5a1e9a841ed0d0fc$var$isHTMLElement(element);
}
const $5a1e9a841ed0d0fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $g3XLf.getPopperUtilityClass), classes);
};
const $5a1e9a841ed0d0fc$var$defaultPopperOptions = {};
const $5a1e9a841ed0d0fc$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $3qSdM.default)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $3qSdM.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $eEJPp.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $5a1e9a841ed0d0fc$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $eEJPp.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $5a1e9a841ed0d0fc$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $eD6Co.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $5a1e9a841ed0d0fc$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $5a1e9a841ed0d0fc$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $5a1e9a841ed0d0fc$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $5a1e9a841ed0d0fc$var$isHTMLElement(resolvedAnchorEl) ? (0, $6zeBo.default)(resolvedAnchorEl).body : (0, $6zeBo.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5a1e9a841ed0d0fc$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $5a1e9a841ed0d0fc$export$2e2bcd8739ae039 = $5a1e9a841ed0d0fc$var$Popper;

});
parcelRegister("6zeBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8156a231c9130b$export$2e2bcd8739ae039);
function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("eD6Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa69d7725f45330b$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $1ESci = parcelRequire("1ESci");

var $8bslU = parcelRequire("8bslU");
'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $8bslU.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $1ESci.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $gEUd4.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;

});
parcelRegister("gEUd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20bfbd9e98e2eff$export$2e2bcd8739ae039);

var $awhpc = parcelRequire("awhpc");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $awhpc.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;

});
parcelRegister("awhpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a64e8a5211ee5$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;

});


parcelRegister("1ESci", function(module, exports) {

$parcel$export(module.exports, "default", () => $135391549c807611$export$2e2bcd8739ae039);

var $dKL4S = parcelRequire("dKL4S");

var $f56pe = parcelRequire("f56pe");

var $5nUQA = parcelRequire("5nUQA");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $dKL4S.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f56pe.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $5nUQA.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $5nUQA.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $dKL4S.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;

});
parcelRegister("dKL4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b07543ab3dfe3c0$export$2e2bcd8739ae039);
function $8b07543ab3dfe3c0$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $8b07543ab3dfe3c0$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $8b07543ab3dfe3c0$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $8b07543ab3dfe3c0$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $8b07543ab3dfe3c0$export$2e2bcd8739ae039 = $8b07543ab3dfe3c0$export$4f5d2d50c9deca37;

});

parcelRegister("f56pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $afac4abdaa8d83ea$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;

});

parcelRegister("5nUQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebb326a10a78a15$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;

});


parcelRegister("8bslU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5557fdc8e8d8fa$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;

});


parcelRegister("2Q995", function(module, exports) {

$parcel$export(module.exports, "default", () => $2117883cc21a32b2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $2xc7G = parcelRequire("2xc7G");
var $hervl = parcelRequire("hervl");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");
'use client';
function $2117883cc21a32b2$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://v6.mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://v6.mui.com/material-ui/api/portal/)
 */ const $2117883cc21a32b2$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $3qSdM.default)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $2xc7G.default)(children) : null, forwardedRef);
    (0, $eEJPp.default)(()=>{
        if (!disablePortal) setMountNode($2117883cc21a32b2$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $eEJPp.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hervl.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hervl.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode;
});
var $2117883cc21a32b2$export$2e2bcd8739ae039 = $2117883cc21a32b2$var$Portal;

});
parcelRegister("hervl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b9145416f64bb2$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("g3XLf", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bb1b487b0ea8f7b1$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $bb1b487b0ea8f7b1$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $bb1b487b0ea8f7b1$export$2e2bcd8739ae039 = $bb1b487b0ea8f7b1$var$popperClasses;

});



parcelRegister("3yddg", function(module, exports) {

$parcel$export(module.exports, "default", () => $295ecbe78b5bad73$export$2e2bcd8739ae039);

var $agZ85 = parcelRequire("agZ85");
'use client';
var $295ecbe78b5bad73$export$2e2bcd8739ae039 = (0, $agZ85.default);

});
parcelRegister("agZ85", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aad105771eb889$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("6lpak", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e8399bd2388464$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $8bslU = parcelRequire("8bslU");

var $1ESci = parcelRequire("1ESci");
'use client';
function $49e8399bd2388464$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $8bslU.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $1ESci.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $gEUd4.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});

parcelRegister("eVjpW", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $add5737403c6a16a$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $add5737403c6a16a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $add5737403c6a16a$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $add5737403c6a16a$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $add5737403c6a16a$export$2e2bcd8739ae039 = $add5737403c6a16a$var$tooltipClasses;

});


parcelRegister("gZwVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $03718d3379a37d9e$export$2e2bcd8739ae039);
const $03718d3379a37d9e$var$prod = {
    // endpoints; no trailing slashes in API endpoints
    beehive: 'https://data.sagecontinuum.org/api/v1',
    beekeeper: 'https://api.sagecontinuum.org',
    ecr: 'https://ecr.sagecontinuum.org/api',
    es: 'https://es.sagecontinuum.org/api/v1',
    jenkins: 'https://ecr.sagecontinuum.org/jenkins',
    auth: 'https://auth.sagecontinuum.org',
    imageSearch: 'https://sage-hybrid-search.nrp-nautilus.io',
    deviceRegistration: 'https://registration.sagecontinuum.org',
    experimentalData: 'https://portal.sagecontinuum.org/experimental-data',
    // links
    home: 'https://sagecontinuum.org',
    portal: 'https://portal.sagecontinuum.org',
    dockerRegistry: 'registry.sagecontinuum.org',
    influxDashboard: 'https://influxdb.sagecontinuum.org/orgs/6aa7e344b342bea3/dashboards',
    adminURL: 'https://admin.sagecontinuum.org',
    wifireData: 'https://wifire-data.sdsc.edu/api',
    dataDownload: 'https://sage-commons.sdsc.edu/sageinterface/dump',
    docs: 'https://sagecontinuum.org/docs',
    contactUs: 'https://sagecontinuum.org/docs/contact-us',
    officeHours: 'https://sagecontinuum.org/docs/events/office-hours',
    labs: 'https://sagecontinuum.org/labs'
};
const $03718d3379a37d9e$var$dev = {
    ...$03718d3379a37d9e$var$prod,
    auth: 'http://0.0.0.0:8000'
};
const $03718d3379a37d9e$var$config = {
    ...$03718d3379a37d9e$var$prod,
    disableMaps: false,
    noticeURL: 'https://raw.githubusercontent.com/waggle-sensor/portal-notice/main/notice.json'
};
var $03718d3379a37d9e$export$2e2bcd8739ae039 = $03718d3379a37d9e$var$config;

});

parcelRegister("6lXkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a02bab8c70a697b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $5A6d3 = parcelRequire("5A6d3");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $2cPwN = parcelRequire("2cPwN");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $1xAC3 = parcelRequire("1xAC3");

var $bwtSM = parcelRequire("bwtSM");

var $3eDio = parcelRequire("3eDio");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4a02bab8c70a697b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`,
            `${variant}Size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $jTnBY.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $jTnBY.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $1xAC3.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $4a02bab8c70a697b$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $4a02bab8c70a697b$var$ButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $1xAC3.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $1xAC3.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $1xAC3.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $1xAC3.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $aSEG4.alpha)(theme.palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1xAC3.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1xAC3.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $1xAC3.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $4a02bab8c70a697b$var$ButtonStartIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonEndIcon = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$4a02bab8c70a697b$var$commonIconStyles
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIndicator = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator',
    overridesResolver: (props, styles)=>styles.loadingIndicator
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder = (0, $d8seH.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder',
    overridesResolver: (props, styles)=>styles.loadingIconPlaceholder
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $4a02bab8c70a697b$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $bwtSM.default));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $3eDio.default));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $5A6d3.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $4a02bab8c70a697b$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($4a02bab8c70a697b$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a02bab8c70a697b$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $5FMfE.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $5FMfE.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $4a02bab8c70a697b$export$2e2bcd8739ae039 = $4a02bab8c70a697b$var$Button;

});
parcelRegister("1xAC3", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", () => $11f546081ba06ace$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $11f546081ba06ace$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $11f546081ba06ace$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $11f546081ba06ace$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $11f546081ba06ace$export$2e2bcd8739ae039 = $11f546081ba06ace$var$buttonClasses;

});

parcelRegister("bwtSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8639dcef822d5d4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $8639dcef822d5d4c$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $8639dcef822d5d4c$export$2e2bcd8739ae039 = $8639dcef822d5d4c$var$ButtonGroupContext;

});

parcelRegister("3eDio", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b1293270900846$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $25b1293270900846$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $25b1293270900846$export$2e2bcd8739ae039 = $25b1293270900846$var$ButtonGroupButtonContext;

});


parcelRegister("c3pId", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f2e86d7cf61d6b$export$2e2bcd8739ae039);

var $gZwVy = parcelRequire("gZwVy");

var $gA7Iw = parcelRequire("gA7Iw");
const $f3f2e86d7cf61d6b$var$webOrigin = window.location.origin;
class $f3f2e86d7cf61d6b$var$Auth {
    constructor(){
        this.url = (0, $gZwVy.default).auth;
        this.user = this.getUser();
        this.isSignedIn = this.hasToken();
        this.token = this.getToken();
        $gA7Iw.onChange('sage_username', ()=>this.signOut());
    }
    getUser() {
        return $f3f2e86d7cf61d6b$var$_getCookieValue('sage_username');
    }
    getToken() {
        return $f3f2e86d7cf61d6b$var$_getCookieValue('sage_token');
    }
    hasToken() {
        return $f3f2e86d7cf61d6b$var$_getCookieValue('sage_token') !== undefined;
    }
    signIn(user, token) {
        document.cookie = `sage_username=${user};path=/`;
        document.cookie = `sage_token=${token};path=/`;
        // for signing out of all tabs
        $gA7Iw.set('sage_username', token);
    }
    signOut() {
        const host = window.location.hostname;
        const domain = host.includes('.') ? `${host.slice(host.indexOf('.'))}` : host;
        document.cookie = `sage_username=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${domain}`;
        document.cookie = `sage_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${domain}`;
        $gA7Iw.rm('sage_username');
        const signOutUrl = `${this.url}/portal-logout`;
        window.location.href = `${signOutUrl}/?callback=${$f3f2e86d7cf61d6b$var$webOrigin}`;
    }
}
var // singleton
$f3f2e86d7cf61d6b$export$2e2bcd8739ae039 = new $f3f2e86d7cf61d6b$var$Auth();
function $f3f2e86d7cf61d6b$var$_getCookieValue(key) {
    const match = document.cookie.split('; ').find((row)=>row.startsWith(`${key}=`));
    if (!match) return undefined;
    return match.split('=')[1].replace(/^"(.*)"$/, '$1');
}

});
parcelRegister("gA7Iw", function(module, exports) {

$parcel$export(module.exports, "get", () => $51071b880a9f30e9$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $51071b880a9f30e9$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "rm", () => $51071b880a9f30e9$export$a1f77f18af3aebd5);
$parcel$export(module.exports, "onChange", () => $51071b880a9f30e9$export$bd913411069e59d3);
const $51071b880a9f30e9$var$keys = [
    'sage_username',
    'sage-table-columns-/nodes',
    'sage-table-columns-/all-nodes',
    'sage-table-columns-/sensors',
    'sage-table-columns-task-listing',
    'sage-assistant',
    'mui-color-scheme-dark',
    'mui-color-scheme-light',
    'mui-mode',
    'nodeTabs.state'
];
function $51071b880a9f30e9$export$3988ae62b71be9a3(key) {
    return localStorage.getItem(key);
}
function $51071b880a9f30e9$export$adaa4cf7ef1b65be(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}
function $51071b880a9f30e9$export$a1f77f18af3aebd5(key) {
    localStorage.removeItem(key);
}
function $51071b880a9f30e9$export$bd913411069e59d3(key, callback) {
    window.addEventListener('storage', (event)=>{
        if (event.key !== key) return;
        if (event.newValue == null) callback();
    });
}
// todo(nc): clean based on routes, or something like that
function $51071b880a9f30e9$var$_clean() {
    for(const key in localStorage)if (!$51071b880a9f30e9$var$keys.includes(key)) $51071b880a9f30e9$export$a1f77f18af3aebd5(key);
}
$51071b880a9f30e9$var$_clean();

});


parcelRegister("hw4Z0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d580a4c9e651eac2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");
function $d580a4c9e651eac2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d580a4c9e651eac2$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
            severity: "error",
            children: props.children
        })
    });
}
const $d580a4c9e651eac2$var$Root = (0, $lmFrL.default).div`
  margin-top: 20px;
`;

});
parcelRegister("iwiZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b9f0ef25189a24$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $7Frhn = parcelRequire("7Frhn");

var $2xI7c = parcelRequire("2xI7c");

var $9Lykx = parcelRequire("9Lykx");

var $1hqLn = parcelRequire("1hqLn");

var $8kXp7 = parcelRequire("8kXp7");

var $f42XJ = parcelRequire("f42XJ");

var $a8MtG = parcelRequire("a8MtG");

var $ldBGF = parcelRequire("ldBGF");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d7b9f0ef25189a24$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color || severity)}`,
            `${variant}${(0, $jTnBY.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2xI7c.getAlertUtilityClass), classes);
};
const $d7b9f0ef25189a24$var$AlertRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $jTnBY.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $aSEG4.darken) : (0, $aSEG4.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $aSEG4.lighten) : (0, $aSEG4.darken);
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $2xI7c.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $2xI7c.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $d7b9f0ef25189a24$var$AlertIcon = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $d7b9f0ef25189a24$var$AlertMessage = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $d7b9f0ef25189a24$var$AlertAction = (0, $d8seH.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $d7b9f0ef25189a24$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1hqLn.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8kXp7.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f42XJ.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8MtG.default), {
        fontSize: "inherit"
    })
};
const $d7b9f0ef25189a24$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $d7b9f0ef25189a24$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $d7b9f0ef25189a24$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $5FMfE.default)(classes.root, className),
        elementType: $d7b9f0ef25189a24$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $6lpak.default)('icon', {
        className: classes.icon,
        elementType: $d7b9f0ef25189a24$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $6lpak.default)('message', {
        className: classes.message,
        elementType: $d7b9f0ef25189a24$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $6lpak.default)('action', {
        className: classes.action,
        elementType: $d7b9f0ef25189a24$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $6lpak.default)('closeButton', {
        elementType: (0, $9Lykx.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $6lpak.default)('closeIcon', {
        elementType: (0, $ldBGF.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $d7b9f0ef25189a24$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $d7b9f0ef25189a24$export$2e2bcd8739ae039 = $d7b9f0ef25189a24$var$Alert;

});
parcelRegister("7Frhn", function(module, exports) {

$parcel$export(module.exports, "default", () => $595185d0d7275c3b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");



var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $35vyj = parcelRequire("35vyj");

var $6LfkK = parcelRequire("6LfkK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $595185d0d7275c3b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6LfkK.getPaperUtilityClass), classes);
};
const $595185d0d7275c3b$var$PaperRoot = (0, $d8seH.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $595185d0d7275c3b$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $14H9o.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $595185d0d7275c3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($595185d0d7275c3b$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $aSEG4.alpha)('#fff', (0, $35vyj.default)(elevation))}, ${(0, $aSEG4.alpha)('#fff', (0, $35vyj.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $595185d0d7275c3b$export$2e2bcd8739ae039 = $595185d0d7275c3b$var$Paper;

});
parcelRegister("6LfkK", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", () => $4ec306d48089c2c9$export$29cdb466b9b6f20b);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec306d48089c2c9$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $4ec306d48089c2c9$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $4ec306d48089c2c9$export$2e2bcd8739ae039 = $4ec306d48089c2c9$var$paperClasses;

});


parcelRegister("2xI7c", function(module, exports) {

$parcel$export(module.exports, "getAlertUtilityClass", () => $1da0e229d53b4459$export$69aecd24bc2cf7e3);
$parcel$export(module.exports, "default", () => $1da0e229d53b4459$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1da0e229d53b4459$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $1da0e229d53b4459$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $1da0e229d53b4459$export$2e2bcd8739ae039 = $1da0e229d53b4459$var$alertClasses;

});

parcelRegister("1hqLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eec239707c48bf2$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0eec239707c48bf2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("8kXp7", function(module, exports) {

$parcel$export(module.exports, "default", () => $611e456547a52fc7$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $611e456547a52fc7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("f42XJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $af7987087272cca1$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $af7987087272cca1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("a8MtG", function(module, exports) {

$parcel$export(module.exports, "default", () => $76204164d2201318$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $76204164d2201318$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});

parcelRegister("ldBGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7280bbf95507cba$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $f7280bbf95507cba$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});



parcelRegister("gOa8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $5172a89e0b9c08d3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "TableSkeleton", () => (parcelRequire("eqsnC")).default);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $81yMd = parcelRequire("81yMd");

var $30hyv = parcelRequire("30hyv");

var $QpuKB = parcelRequire("QpuKB");

var $elyLx = parcelRequire("elyLx");

var $hjXJ8 = parcelRequire("hjXJ8");

var $kBtCg = parcelRequire("kBtCg");

var $2XjE0 = parcelRequire("2XjE0");

var $cVXaD = parcelRequire("cVXaD");

var $9Lykx = parcelRequire("9Lykx");

var $lkxXU = parcelRequire("lkxXU");

var $4D8ul = parcelRequire("4D8ul");

var $ipR47 = parcelRequire("ipR47");

var $3JK9z = parcelRequire("3JK9z");

var $1CO8b = parcelRequire("1CO8b");

var $74El0 = parcelRequire("74El0");

var $i2aXm = parcelRequire("i2aXm");

var $2NJq1 = parcelRequire("2NJq1");

var $5xexf = parcelRequire("5xexf");

var $gA7Iw = parcelRequire("gA7Iw");

var $kRBt4 = parcelRequire("kRBt4");

var $8xxjV = parcelRequire("8xxjV");

var $fFFhS = parcelRequire("fFFhS");

var $eqsnC = parcelRequire("eqsnC");

var $03mUs = parcelRequire("03mUs");

var $bnA1h = parcelRequire("bnA1h");

var $kfwWK = parcelRequire("kfwWK");

var $ce4ic = parcelRequire("ce4ic");
// prefix for saving table state in localstorage
const $5172a89e0b9c08d3$var$STORAGE_PREFEX = 'sage-table-columns-';
const $5172a89e0b9c08d3$var$Cell = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
        ...props,
        children: props.children
    });
const $5172a89e0b9c08d3$var$RowCells = ({ columns: columns, row: row })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: columns.map((col)=>{
            const val = row[col.id];
            return /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$Cell, {
                align: col.type == 'number' ? 'right' : col.align,
                style: {
                    width: col.width
                },
                children: col.format ? col.format(val, row) : val ? val : '-'
            }, col.id);
        })
    });
const $5172a89e0b9c08d3$var$Row = (props)=>{
    const { columns: columns, row: row, id: id, emptyCell: emptyCell, selected: selected, checkboxes: checkboxes, onSelect: onSelect, onDoubleClick: onDoubleClick, onMore: onMore, greyRow: greyRow, collapsible: collapsible } = props;
    const { rowID: rowID } = row;
    const [open, setOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($5172a89e0b9c08d3$var$TableRowComponent, {
                hover: true,
                className: greyRow(row) && 'grey',
                tabIndex: -1,
                onClick: (evt)=>onSelect(evt, rowID, row),
                onDoubleClick: (evt)=>onDoubleClick(evt, row),
                selected: selected.ids.includes(rowID),
                children: [
                    emptyCell && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$Cell, {}),
                    checkboxes && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$Cell, {
                        style: {
                            padding: 0,
                            width: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                            checked: selected.ids.includes(rowID),
                            onClick: (evt)=>onSelect(evt, rowID, row)
                        })
                    }, id + '-checkbox'),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$RowCells, {
                        columns: columns,
                        row: row
                    }),
                    onMore && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$More, {
                        className: "more-btn",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4D8ul))), {})
                        })
                    }),
                    collapsible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                        style: {
                            padding: 0,
                            width: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            "aria-label": "expand row",
                            size: "small",
                            onClick: ()=>setOpen(!open),
                            children: open ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ce4ic))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kfwWK))), {})
                        })
                    }, id + '-collapse')
                ]
            }, id),
            collapsible && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$TableRowComponent, {
                style: {
                    backgroundColor: 'initial'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                    style: {
                        paddingBottom: 0,
                        paddingTop: 0
                    },
                    colSpan: columns.length + (checkboxes ? 1 : 0) + 1,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bnA1h.default), {
                        in: open,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                margin: 1
                            },
                            children: collapsible
                        })
                    })
                })
            })
        ]
    });
};
$5172a89e0b9c08d3$var$Row.displayName = 'TableComponent-Row';
const $5172a89e0b9c08d3$var$TableRowComponent = (0, $d8seH.default)((0, $2XjE0.default))`
  // todo(nc)?: remove more button option
  &:hover {
    .more-btn {
      display: block;
    }
  }

  // disabledRowSelect Styling
  &.grey {
    background: #fcfcfc;

    td {
      color: #c7c7c7;
    }
  }
  &.disabled:hover {
    cursor: not-allowed;
  }
`;
// todo(nc)?: remove more button option
const $5172a89e0b9c08d3$var$More = (0, $d8seH.default)('span')`
  position: absolute;
  background: #f5f5f5;
  padding: 0 20px;
  right: 20;
  display: none;
`;
const $5172a89e0b9c08d3$var$TableRows = (props)=>{
    const { rows: rows, columns: columns, checkboxes: checkboxes } = props;
    return rows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$Row, {
            id: row.rowID,
            row: row,
            columns: columns,
            checkboxes: checkboxes,
            ...props
        }, row.rowID));
};
const $5172a89e0b9c08d3$var$getSortArrow = (colID, sort)=>/*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$SortArrow, {
        children: colID in sort && (sort[colID] == 'dsc' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3JK9z))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1CO8b))), {}))
    });
const $5172a89e0b9c08d3$var$SortArrow = (0, $d8seH.default)('span')`
  position: absolute;
  & svg {
    width: .9em;
    height: .9em;
  }
`;
const $5172a89e0b9c08d3$var$TableHeadComponent = (props)=>{
    const { checkboxes: checkboxes, columns: columns, handleSelectAll: handleSelectAll, allSelected: allSelected, enableSorting: enableSorting, sortBy: sortBy, handleSort: handleSort } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2XjE0.default), {
        children: [
            checkboxes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $elyLx.default), {
                style: {
                    padding: 0,
                    width: 1
                },
                onClick: handleSelectAll,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                    checked: allSelected
                })
            }),
            columns.map((col)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $elyLx.default), {
                    align: col.type == 'number' ? 'right' : col.align,
                    style: {
                        width: col.width,
                        cursor: enableSorting ? 'pointer' : ''
                    },
                    onClick: ()=>handleSort(col),
                    children: [
                        col.label ? col.label : col.id,
                        " ",
                        $5172a89e0b9c08d3$var$getSortArrow(col.id, sortBy)
                    ]
                }, col.id))
        ]
    });
};
const $5172a89e0b9c08d3$var$indexData = (data)=>data.map((row, i)=>({
            ...row,
            rowID: i
        }));
const $5172a89e0b9c08d3$var$clientSideSort = (data, id, direction)=>{
    let isArrayCol, isObject, isNumeric;
    try {
        isArrayCol = Array.isArray(data[0][id]);
        isObject = typeof data[0][id] === 'object';
        isNumeric = data.some((o)=>typeof o[id] === 'number');
    } catch  {
        isArrayCol = false;
        isObject = false;
        isNumeric = false;
    }
    if (isArrayCol) // just use array lengths for now
    data.sort((a, b)=>direction == 'asc' ? a[id].length - b[id].length : b[id].length - a[id].length);
    else if (isNumeric) data.sort((a, b)=>direction == 'asc' ? (a[id] || -Infinity).toString().localeCompare((b[id] || -Infinity).toString(), undefined, {
            numeric: true
        }) : (b[id] || -Infinity).toString().localeCompare((a[id] || -Infinity).toString(), undefined, {
            numeric: true
        }));
    else if (isObject) ;
    else data.sort((a, b)=>direction == 'asc' ? (a[id] || '').localeCompare(b[id] || '') : (b[id] || '').localeCompare(a[id] || ''));
    return data;
};
const $5172a89e0b9c08d3$var$parseSort = (str)=>({
        [str.slice(1)]: str.charAt(0) == '-' ? 'dsc' : 'asc'
    });
const $5172a89e0b9c08d3$var$decodeSort = (sortObj)=>{
    if (!sortObj) return '';
    const id = Object.keys(sortObj)[0], order = sortObj[id];
    return `${order == 'dsc' ? '-' : '+'}${id}`;
};
function $5172a89e0b9c08d3$var$getActiveTableCols(key, allCols) {
    const shownCols = allCols.filter((o)=>!o.hide);
    if (!key) return shownCols;
    const cols = $gA7Iw.get(`${$5172a89e0b9c08d3$var$STORAGE_PREFEX}${key}`);
    return !cols ? shownCols : allCols.filter((o)=>cols.includes(o.id));
}
// initial state of columns includes "hide". we'll manage hidden columns with "activeColumns"
const $5172a89e0b9c08d3$var$getVisibleColumns = (columns, activeColumns = null)=>{
    if (activeColumns) {
        const activeIDs = activeColumns.map((o)=>o.id);
        return columns.filter((o)=>activeIDs.includes(o.id));
    }
    return columns.filter((o)=>!o.hide);
};
function $5172a89e0b9c08d3$export$2e2bcd8739ae039(props) {
    const { primaryKey: primaryKey = 'rowID', pagination: pagination, offsetHeight: offsetHeight, checkboxes: checkboxes, emptyNotice: emptyNotice, stripes: stripes = true, enableSorting: enableSorting = false, enableDownload: enableDownload = false, storageKey: storageKey, onSearch: onSearch, onSort: onSort, onSelect: onSelect, onDoubleClick: onDoubleClick, onColumnMenuChange: onColumnMenuChange, onShowDetails: onShowDetails, greyRow: greyRow = ()=>false, disableRowSelect: disableRowSelect = ()=>false, collapsible: collapsible } = props;
    if (pagination && (props.page === undefined || props.limit === undefined)) throw `Grid component must provide 'page' and 'limit' when 'pagination' is used.
      page value was: ${props.page}; limit value was: ${props.limit}.`;
    const tableRef = (0, $acw62.useRef)(null);
    const [columns, setColumns] = (0, $acw62.useState)($5172a89e0b9c08d3$var$getVisibleColumns(props.columns));
    const [page, setPage] = (0, $acw62.useState)(Number(props.page));
    const [sortBy, setSortBy] = (0, $acw62.useState)(props.sort && $5172a89e0b9c08d3$var$parseSort(props.sort) || {});
    const [rowsPerPage, setRowsPerPage] = (0, $acw62.useState)(props.rowsPerPage || 100);
    let data = $5172a89e0b9c08d3$var$indexData(props.rows);
    if (pagination) data = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    // may contain subset of rows via pagination, filtering, etc
    const [rows, setRows] = (0, $acw62.useState)(data);
    // keep state on shown/hidden columns
    // initial columns are defined in `columns` spec.
    const [activeColumns, setActiveColumns] = (0, $acw62.useState)($5172a89e0b9c08d3$var$getActiveTableCols(storageKey, props.columns));
    // disable user-select when shift+click is happening
    const [userSelect, setUserSelect] = (0, $acw62.useState)(true);
    // selected/checkbox state
    const [allSelected, setAllSelected] = (0, $acw62.useState)(false);
    const [selected, dispatch] = (0, $acw62.useReducer)((0, $8xxjV.default), (0, $8xxjV.getInitSelectedState)(props.selected, props.rows, primaryKey));
    (0, $acw62.useEffect)(()=>{
        // when rows change, reindex
        let newRows = $5172a89e0b9c08d3$var$indexData(props.rows);
        // need to re-sort if updating table dynamically
        const sortID = Object.keys(sortBy).length ? Object.keys(sortBy)[0] : null;
        if (sortID) newRows = $5172a89e0b9c08d3$var$clientSideSort(newRows, sortID, sortBy[sortID]);
        if (pagination) newRows = newRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
        setRows(newRows);
    }, [
        props.rows,
        page,
        rowsPerPage
    ]);
    // listen to column configs
    (0, $acw62.useEffect)(()=>{
        setColumns($5172a89e0b9c08d3$var$getVisibleColumns(props.columns, activeColumns));
    }, [
        activeColumns,
        props.columns,
        storageKey
    ]);
    // if column config, or storageKey changes, we need to reset the active columns
    (0, $acw62.useEffect)(()=>{
        setActiveColumns($5172a89e0b9c08d3$var$getActiveTableCols(storageKey, props.columns));
    }, [
        props.columns,
        storageKey
    ]);
    // listen to page changes
    (0, $acw62.useEffect)(()=>{
        setPage(Number(props.page));
    }, [
        props.page
    ]);
    // listen to rowsPerPage
    (0, $acw62.useEffect)(()=>{
        setRowsPerPage(props.rowsPerPage);
    }, [
        props.rowsPerPage
    ]);
    // listen to sort changes
    (0, $acw62.useEffect)(()=>{
        if (!props.sort) return;
        setSortBy($5172a89e0b9c08d3$var$parseSort(props.sort));
    }, [
        props.sort
    ]);
    // listen to selected
    (0, $acw62.useEffect)(()=>{
        if (!onSelect) return;
        onSelect(selected);
    // eslint-disable-next-line
    }, [
        selected
    ]);
    // enable/disable userSelect durring ctrl/shift+click
    const handleKeyDown = (0, $acw62.useCallback)((evt)=>{
        if (evt.shiftKey) setUserSelect(false);
    }, [
        setUserSelect
    ]);
    (0, $acw62.useEffect)(()=>{
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown
    ]);
    (0, $fFFhS.default)(tableRef, ()=>{
        if (props.disableClickOutside) return;
        dispatch({
            type: 'CLEAR'
        });
    }, [
        'button',
        'a',
        'input',
        '.ignore-click-outside',
        '.MuiDialog-container',
        '.MuiAutocomplete-popper',
        '.mapboxgl-canvas-container'
    ]);
    const handlePageChange = (event, newPage)=>{
        setPage(newPage);
        if (props.onPage) props.onPage(newPage);
    };
    const handleSelect = (event, rowID, obj)=>{
        if (disableRowSelect && disableRowSelect(obj)) return;
        let type;
        if (event.metaKey) type = 'CTRL_SET';
        else if (event.shiftKey) type = 'SHIFT_SET';
        else {
            type = 'SET';
            setAllSelected(false);
        }
        dispatch({
            type: type,
            id: rowID,
            obj: obj,
            rows: rows,
            event: event
        });
        // enable text-selection again
        setUserSelect(true);
    };
    const handleSelectAll = ()=>{
        setAllSelected((prev)=>{
            if (prev) dispatch({
                type: 'CLEAR'
            });
            else dispatch({
                type: 'SELECT_ALL',
                rows: rows
            });
            return !prev;
        });
    };
    const handleSort = (colObj)=>{
        const { id: id } = colObj;
        const direction = sortBy[id] == 'asc' ? 'dsc' : 'asc';
        const newState = {
            [id]: direction
        };
        // if server-side sorting
        if (onSort) onSort($5172a89e0b9c08d3$var$decodeSort(newState));
        // client-side sorting
        if (enableSorting) {
            let allRows = $5172a89e0b9c08d3$var$indexData(props.rows);
            allRows = $5172a89e0b9c08d3$var$clientSideSort(allRows, id, direction);
            const newRows = pagination ? allRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : allRows;
            setRows(newRows);
            setSortBy(newState);
        }
        // deselect everything
        dispatch({
            type: 'CLEAR'
        });
    };
    const onColumnChange = (activeCols)=>{
        setActiveColumns(activeCols);
        if (storageKey) $gA7Iw.set(`${$5172a89e0b9c08d3$var$STORAGE_PREFEX}${storageKey}`, activeCols.map((o)=>o.id));
        onColumnMenuChange(activeCols);
    };
    const handleDoubleClick = (evt, row)=>{
        if (onDoubleClick) onDoubleClick(evt, row);
    };
    const handleShowDetails = ()=>{
        if (onShowDetails) onShowDetails();
    };
    const handleDLOption = (getData)=>{
        // todo(nc): could add support for other options/formats if needed.
        const header = columns.map((o)=>o.label).join(', ');
        const rows = (getData ? getData() : props.rows).map((row)=>columns.map((col)=>{
                const val = row[col.id];
                return col.dlFormat ? `"${col.dlFormat(val, row)}"` : (0, $74El0.formatDownloadCol)(val);
            }));
        const csvStr = `${header}\n${rows.map((v)=>v ? v.join(',') : '').join('\n')}`;
        const blob = (0, $kRBt4.strToBlob)(csvStr, 'text/csv');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($5172a89e0b9c08d3$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($5172a89e0b9c08d3$var$CtrlContainer, {
                children: [
                    props.leftComponent && props.leftComponent,
                    onSearch && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2NJq1.default), {
                        value: props.search,
                        onSearch: onSearch,
                        placeholder: props.searchPlaceholder
                    }),
                    props.middleComponent && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$MiddleComponent, {
                        children: props.middleComponent
                    }),
                    enableDownload && /*#__PURE__*/ (0, $ayMG0.jsxs)($5172a89e0b9c08d3$var$TableOption, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74El0.default), {
                                onDownload: ()=>handleDLOption(props.getDownloadableData)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                orientation: "vertical",
                                flexItem: true,
                                sx: {
                                    margin: '5px 15px'
                                }
                            })
                        ]
                    }),
                    onColumnMenuChange && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$TableOption, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i2aXm.default), {
                            options: props.columns,
                            value: activeColumns,
                            onChange: onColumnChange,
                            onRestoreDefaults: ()=>{
                                if (storageKey) $gA7Iw.rm(`${$5172a89e0b9c08d3$var$STORAGE_PREFEX}${storageKey}`);
                                setColumns($5172a89e0b9c08d3$var$getVisibleColumns(props.columns));
                                setActiveColumns($5172a89e0b9c08d3$var$getActiveTableCols(storageKey, props.columns));
                            }
                        })
                    }),
                    pagination && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$Pagination, {
                            rowsPerPageOptions: [
                                rowsPerPage
                            ],
                            count: props.total || props.limit || rows?.length,
                            rowsPerPage: rowsPerPage,
                            page: page,
                            onPageChange: handlePageChange
                        })
                    }),
                    props.rightComponent && props.rightComponent,
                    onShowDetails && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Show/hide details",
                        placement: "top",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: handleShowDetails,
                            style: {
                                background: selected.ids.length ? '#ecf4fb' : '#fff'
                            },
                            className: "hover",
                            disableRipple: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {
                                htmlColor: selected.ids.length ? '#3a8cc2' : ''
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($5172a89e0b9c08d3$var$Container, {
                offset: offsetHeight ? offsetHeight : '0px',
                sx: {
                    ...stripes && {
                        '& tr:nth-of-type(odd)': {
                            background: (theme)=>theme.palette.mode === 'dark' ? '#161616' : '#fafafa'
                        }
                    },
                    ...!userSelect && {
                        '& tr': {
                            userSelect: 'none'
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30hyv.default), {
                        stickyHeader: true,
                        "aria-label": "table",
                        size: "small",
                        ref: tableRef,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hjXJ8.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$TableHeadComponent, {
                                    columns: columns,
                                    allSelected: allSelected,
                                    handleSelectAll: handleSelectAll,
                                    checkboxes: checkboxes,
                                    enableSorting: true,
                                    sortBy: sortBy,
                                    handleSort: handleSort
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $QpuKB.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$TableRows, {
                                    rows: rows,
                                    columns: columns,
                                    checkboxes: checkboxes,
                                    onSelect: handleSelect,
                                    selected: selected,
                                    onDoubleClick: handleDoubleClick,
                                    onMore: props.onMore,
                                    greyRow: greyRow,
                                    disableRowSelect: disableRowSelect,
                                    collapsible: collapsible
                                })
                            })
                        ]
                    }),
                    rows.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($5172a89e0b9c08d3$var$NoneFoundNotice, {
                        children: emptyNotice || 'No results found'
                    })
                ]
            })
        ]
    });
}
const $5172a89e0b9c08d3$var$Root = (0, $d8seH.default)('div')`
`;
const $5172a89e0b9c08d3$var$CtrlContainer = (0, $d8seH.default)('div')`
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  flex: 1;

  .MuiTablePagination-actions {
    user-select: none;
  }
`;
const $5172a89e0b9c08d3$var$MiddleComponent = (0, $d8seH.default)('div')`
  flex: 1;
`;
const $5172a89e0b9c08d3$var$Pagination = (0, $d8seH.default)((0, $kBtCg.default))`
  .MuiToolbar-root {
    padding-left: 0;
  }
`;
const $5172a89e0b9c08d3$var$Container = (0, $d8seH.default)((0, $81yMd.default))`
  /* remove height of control panel */
  max-height: ${(props)=>`calc(100% - ${props.offset || '60px'})`};
  height: 100%;

  /* handled with stickyHeader */
  border-collapse: separate;

  .on-row-hover {
    visibility: hidden;
  }

  tr:hover .on-row-hover {
    visibility: visible;
  }

  td {
    font-size: 13px;
  }

  td.MuiTableCell-sizeSmall {
    padding: 6px 12px;
  }

  tr.MuiTableRow-root:hover {
    background-color: ${(props)=>props.theme.palette.action.hover || 'rgba(0, 0, 0, 0.04)'};
  }

  tr.MuiTableRow-root.Mui-selected,
  tr.MuiTableRow-root.Mui-selected:hover {
    background-color: ${(props)=>props.theme.palette.action.selected || 'rgba(0, 0, 0, 0.08)'};
  }

  /* todo(nc): workaround for production build styling issue.
    similar to: https://github.com/gregnb/mui-datatables/issues/1074 */
  th {
    top: 0;
    left: 0;
    z-index: 2;
    position: sticky;
    user-select: none;
    padding: 0px 12px 6px 12px;
    font-weight: 800;
  }
`;
const $5172a89e0b9c08d3$var$TableOption = (0, $d8seH.default)('div')`
  display: flex;
  margin-left: auto;
`;
const $5172a89e0b9c08d3$var$NoneFoundNotice = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: center;
  transform: translate(0%, 20%);
  color: #666;
  font-size: 1.5em;
  margin: 50px 0;
`;

});
parcelRegister("81yMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7964a6269b66c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $lNHXc = parcelRequire("lNHXc");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5d7964a6269b66c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lNHXc.getTableContainerUtilityClass), classes);
};
const $5d7964a6269b66c8$var$TableContainerRoot = (0, $d8seH.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $5d7964a6269b66c8$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $5d7964a6269b66c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5d7964a6269b66c8$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $5d7964a6269b66c8$export$2e2bcd8739ae039 = $5d7964a6269b66c8$var$TableContainer;

});
parcelRegister("lNHXc", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", () => $fdf044e88b1c9ad4$export$eed427986a7abdf9);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fdf044e88b1c9ad4$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $fdf044e88b1c9ad4$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $fdf044e88b1c9ad4$export$2e2bcd8739ae039 = $fdf044e88b1c9ad4$var$tableContainerClasses;

});


parcelRegister("30hyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $22fefd5f207422b3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $jWrFr = parcelRequire("jWrFr");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $5kXxI = parcelRequire("5kXxI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22fefd5f207422b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5kXxI.getTableUtilityClass), classes);
};
const $22fefd5f207422b3$var$TableRoot = (0, $d8seH.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $22fefd5f207422b3$var$defaultComponent = 'table';
const $22fefd5f207422b3$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $22fefd5f207422b3$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $22fefd5f207422b3$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jWrFr.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($22fefd5f207422b3$var$TableRoot, {
            as: component,
            role: component === $22fefd5f207422b3$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $5FMfE.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $22fefd5f207422b3$export$2e2bcd8739ae039 = $22fefd5f207422b3$var$Table;

});
parcelRegister("jWrFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e848e543ed3bf349$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e848e543ed3bf349$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $e848e543ed3bf349$export$2e2bcd8739ae039 = $e848e543ed3bf349$var$TableContext;

});

parcelRegister("5kXxI", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", () => $3e2d01fd3f88b8c8$export$315cb19215f77ce0);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3e2d01fd3f88b8c8$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $3e2d01fd3f88b8c8$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $3e2d01fd3f88b8c8$export$2e2bcd8739ae039 = $3e2d01fd3f88b8c8$var$tableClasses;

});


parcelRegister("QpuKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d8a23708c3ccc9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $dfSTK = parcelRequire("dfSTK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09d8a23708c3ccc9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dfSTK.getTableBodyUtilityClass), classes);
};
const $09d8a23708c3ccc9$var$TableBodyRoot = (0, $d8seH.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $09d8a23708c3ccc9$var$tablelvl2 = {
    variant: 'body'
};
const $09d8a23708c3ccc9$var$defaultComponent = 'tbody';
const $09d8a23708c3ccc9$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $09d8a23708c3ccc9$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $09d8a23708c3ccc9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RbMj7.default).Provider, {
        value: $09d8a23708c3ccc9$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($09d8a23708c3ccc9$var$TableBodyRoot, {
            className: (0, $5FMfE.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $09d8a23708c3ccc9$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $09d8a23708c3ccc9$export$2e2bcd8739ae039 = $09d8a23708c3ccc9$var$TableBody;

});
parcelRegister("RbMj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $09fe163f52c859c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $09fe163f52c859c8$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $09fe163f52c859c8$export$2e2bcd8739ae039 = $09fe163f52c859c8$var$Tablelvl2Context;

});

parcelRegister("dfSTK", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", () => $9a6742b7048414d1$export$98bd2a9b566ec665);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a6742b7048414d1$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $9a6742b7048414d1$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $9a6742b7048414d1$export$2e2bcd8739ae039 = $9a6742b7048414d1$var$tableBodyClasses;

});


parcelRegister("elyLx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71dfe9e22152ea2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $jTnBY = parcelRequire("jTnBY");

var $jWrFr = parcelRequire("jWrFr");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $ev9nI = parcelRequire("ev9nI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a71dfe9e22152ea2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            padding !== 'normal' && `padding${(0, $jTnBY.default)(padding)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ev9nI.getTableCellUtilityClass), classes);
};
const $a71dfe9e22152ea2$var$TableCellRoot = (0, $d8seH.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $jTnBY.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $aSEG4.lighten)((0, $aSEG4.alpha)(theme.palette.divider, 1), 0.88) : (0, $aSEG4.darken)((0, $aSEG4.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $ev9nI.default).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $a71dfe9e22152ea2$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $acw62.useContext((0, $jWrFr.default));
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $a71dfe9e22152ea2$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a71dfe9e22152ea2$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $5FMfE.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $a71dfe9e22152ea2$export$2e2bcd8739ae039 = $a71dfe9e22152ea2$var$TableCell;

});
parcelRegister("ev9nI", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", () => $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b);
$parcel$export(module.exports, "default", () => $a8eb3ce62ab46dc7$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a8eb3ce62ab46dc7$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $a8eb3ce62ab46dc7$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $a8eb3ce62ab46dc7$export$2e2bcd8739ae039 = $a8eb3ce62ab46dc7$var$tableCellClasses;

});


parcelRegister("hjXJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9c28a8e795911dc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $hMbPk = parcelRequire("hMbPk");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c9c28a8e795911dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hMbPk.getTableHeadUtilityClass), classes);
};
const $c9c28a8e795911dc$var$TableHeadRoot = (0, $d8seH.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c9c28a8e795911dc$var$tablelvl2 = {
    variant: 'head'
};
const $c9c28a8e795911dc$var$defaultComponent = 'thead';
const $c9c28a8e795911dc$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c9c28a8e795911dc$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $c9c28a8e795911dc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $RbMj7.default).Provider, {
        value: $c9c28a8e795911dc$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c9c28a8e795911dc$var$TableHeadRoot, {
            as: component,
            className: (0, $5FMfE.default)(classes.root, className),
            ref: ref,
            role: component === $c9c28a8e795911dc$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $c9c28a8e795911dc$export$2e2bcd8739ae039 = $c9c28a8e795911dc$var$TableHead;

});
parcelRegister("hMbPk", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", () => $cf1017f12785ebe4$export$2e731cea2d1c2392);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $cf1017f12785ebe4$export$2e731cea2d1c2392(slot) {
    return (0, $4Cod0.default)('MuiTableHead', slot);
}
const $cf1017f12785ebe4$var$tableHeadClasses = (0, $beCSm.default)('MuiTableHead', [
    'root'
]);
var $cf1017f12785ebe4$export$2e2bcd8739ae039 = $cf1017f12785ebe4$var$tableHeadClasses;

});


parcelRegister("kBtCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $effe3c7e7b91170d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");



var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $95gUw = parcelRequire("95gUw");

var $2iAqv = parcelRequire("2iAqv");

var $cX7V2 = parcelRequire("cX7V2");

var $elyLx = parcelRequire("elyLx");

var $kyRsi = parcelRequire("kyRsi");

var $dLLxV = parcelRequire("dLLxV");

var $5A6d3 = parcelRequire("5A6d3");

var $inBkn = parcelRequire("inBkn");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $effe3c7e7b91170d$var$_InputBase;
const $effe3c7e7b91170d$var$TablePaginationRoot = (0, $d8seH.default)((0, $elyLx.default), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationToolbar = (0, $d8seH.default)((0, $kyRsi.default), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $inBkn.default).actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $aeD7H.default)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $inBkn.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $effe3c7e7b91170d$var$TablePaginationSpacer = (0, $d8seH.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $effe3c7e7b91170d$var$TablePaginationSelectLabel = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $effe3c7e7b91170d$var$TablePaginationSelect = (0, $d8seH.default)((0, $cX7V2.default), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $inBkn.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $inBkn.default).select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $inBkn.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $effe3c7e7b91170d$var$TablePaginationMenuItem = (0, $d8seH.default)((0, $2iAqv.default), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $effe3c7e7b91170d$var$TablePaginationDisplayedRows = (0, $d8seH.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $effe3c7e7b91170d$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $effe3c7e7b91170d$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $effe3c7e7b91170d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $inBkn.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $effe3c7e7b91170d$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $dLLxV.default), backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = (0, $elyLx.default), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $effe3c7e7b91170d$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $effe3c7e7b91170d$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $effe3c7e7b91170d$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $effe3c7e7b91170d$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $elyLx.default) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $5A6d3.default)(selectProps.id);
    const labelId = (0, $5A6d3.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        className: classes.root,
        elementType: $effe3c7e7b91170d$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $6lpak.default)('toolbar', {
        className: classes.toolbar,
        elementType: $effe3c7e7b91170d$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $6lpak.default)('spacer', {
        className: classes.spacer,
        elementType: $effe3c7e7b91170d$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $6lpak.default)('selectLabel', {
        className: classes.selectLabel,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $6lpak.default)('select', {
        className: classes.select,
        elementType: $effe3c7e7b91170d$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $6lpak.default)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $6lpak.default)('displayedRows', {
        className: classes.displayedRows,
        elementType: $effe3c7e7b91170d$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $effe3c7e7b91170d$var$_InputBase || ($effe3c7e7b91170d$var$_InputBase = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $5FMfE.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $5FMfE.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $5FMfE.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
var $effe3c7e7b91170d$export$2e2bcd8739ae039 = $effe3c7e7b91170d$var$TablePagination;

});
parcelRegister("95gUw", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $69d1b2c99a8dc649$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $69d1b2c99a8dc649$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $69d1b2c99a8dc649$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseInput", () => $69d1b2c99a8dc649$export$ee10465db6ff6017);
$parcel$export(module.exports, "default", () => $69d1b2c99a8dc649$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");



var $8Indx = parcelRequire("8Indx");

var $gSRTE = parcelRequire("gSRTE");

var $c1jOg = parcelRequire("c1jOg");

var $aaphR = parcelRequire("aaphR");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $aAbgT = parcelRequire("aAbgT");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $2BbKU = parcelRequire("2BbKU");

var $dmljZ = parcelRequire("dmljZ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $69d1b2c99a8dc649$var$_InputGlobalStyles;
const $69d1b2c99a8dc649$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $69d1b2c99a8dc649$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $jTnBY.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dmljZ.getInputBaseUtilityClass), classes);
};
const $69d1b2c99a8dc649$export$298a043133d72a38 = (0, $d8seH.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$export$965edad20a84fa75
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $dmljZ.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $69d1b2c99a8dc649$export$ee10465db6ff6017 = (0, $d8seH.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$export$cf507b112810e72d
})((0, $aeD7H.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $dmljZ.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $dmljZ.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $69d1b2c99a8dc649$var$InputGlobalStyles = (0, $aAbgT.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $9Rgf1.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $khjmj.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $gSRTE.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $69d1b2c99a8dc649$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $69d1b2c99a8dc649$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $69d1b2c99a8dc649$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($69d1b2c99a8dc649$var$_InputGlobalStyles || ($69d1b2c99a8dc649$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $c1jOg.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $5FMfE.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $c1jOg.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $5FMfE.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $69d1b2c99a8dc649$export$2e2bcd8739ae039 = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("gSRTE", function(module, exports) {

$parcel$export(module.exports, "default", () => $032c0e7078a9cb7d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $aJ8G8 = parcelRequire("aJ8G8");
var $9KvVX = parcelRequire("9KvVX");
var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://v6.mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://v6.mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $9KvVX.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $13KXh.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $eEJPp.default)(()=>{
        const debouncedHandleResize = (0, $aJ8G8.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $9KvVX.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $eEJPp.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$032c0e7078a9cb7d$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $032c0e7078a9cb7d$export$2e2bcd8739ae039 = $032c0e7078a9cb7d$var$TextareaAutosize;

});
parcelRegister("aJ8G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf4d6c2077a48de$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("9KvVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $71912e551e227707$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $6zeBo.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("c1jOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c04f1d112fc50bc$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $8c04f1d112fc50bc$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $8c04f1d112fc50bc$export$2e2bcd8739ae039 = $8c04f1d112fc50bc$var$isHostComponent;

});

parcelRegister("aaphR", function(module, exports) {

$parcel$export(module.exports, "default", () => $766e740713576b8d$export$2e2bcd8739ae039);
function $766e740713576b8d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("blr6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $8426ae8303951a73$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $8426ae8303951a73$export$2e2bcd8739ae039 = $8426ae8303951a73$var$FormControlContext;

});

parcelRegister("cJQfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $946238fa82894619$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $blr6C = parcelRequire("blr6C");
'use client';
function $946238fa82894619$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $blr6C.default));
}

});

parcelRegister("aAbgT", function(module, exports) {

$parcel$export(module.exports, "globalCss", () => $7b460279bb5c09c1$export$db53682eef82cc11);
$parcel$export(module.exports, "internal_createExtendSxProp", () => $7b460279bb5c09c1$export$7e7f5719ff4debb1);
parcelRequire("acw62");

var $hcz0Q = parcelRequire("hcz0Q");

var $14H9o = parcelRequire("14H9o");

var $ldx2z = parcelRequire("ldx2z");

var $ayMG0 = parcelRequire("ayMG0");

var $8zogs = parcelRequire("8zogs");

var $d8seH = parcelRequire("d8seH");
function $7b460279bb5c09c1$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)((0, $ldx2z.default), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $7b460279bb5c09c1$export$7e7f5719ff4debb1() {
    return 0, $hcz0Q.default;
}

});
parcelRegister("hcz0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb76b78f8a14c$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});

parcelRegister("ldx2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $03fc756f7adfd498$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $92iK7 = parcelRequire("92iK7");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), {
        ...props,
        defaultTheme: (0, $jR9F1.default),
        themeId: (0, $4jPsi.default)
    });
}
var $03fc756f7adfd498$export$2e2bcd8739ae039 = $03fc756f7adfd498$var$GlobalStyles;

});
parcelRegister("92iK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942d6ec85232a9d$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $bBbjn = parcelRequire("bBbjn");
var $bOOlK = parcelRequire("bOOlK");

var $eM1DJ = parcelRequire("eM1DJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6942d6ec85232a9d$var$wrapGlobalLayer(styles) {
    const serialized = (0, $bOOlK.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $eM1DJ.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $6942d6ec85232a9d$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;

});



parcelRegister("2BbKU", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $1e4827e2a850b1f0$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $1e4827e2a850b1f0$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $1e4827e2a850b1f0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $1e4827e2a850b1f0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dmljZ", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $9b9dde6aa920e08c$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $9b9dde6aa920e08c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9b9dde6aa920e08c$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $9b9dde6aa920e08c$export$2e2bcd8739ae039 = $9b9dde6aa920e08c$var$inputBaseClasses;

});


parcelRegister("cX7V2", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e1233e8d06bb2d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $3z1Ay = parcelRequire("3z1Ay");

var $8Indx = parcelRequire("8Indx");

var $2xc7G = parcelRequire("2xc7G");

var $c0lH6 = parcelRequire("c0lH6");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $7LRfY = parcelRequire("7LRfY");

var $ab7Se = parcelRequire("ab7Se");

var $iOErJ = parcelRequire("iOErJ");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $1iOpW = parcelRequire("1iOpW");

var $9Rgf1 = parcelRequire("9Rgf1");

var $d8seH = parcelRequire("d8seH");

var $8Uq77 = parcelRequire("8Uq77");

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $96e1233e8d06bb2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $bmfPX.getSelectUtilityClasses), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $96e1233e8d06bb2d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $96e1233e8d06bb2d$var$StyledInput = (0, $d8seH.default)((0, $ab7Se.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledOutlinedInput = (0, $d8seH.default)((0, $imehR.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$StyledFilledInput = (0, $d8seH.default)((0, $g4sO2.default), $96e1233e8d06bb2d$var$styledRootConfig)('');
const $96e1233e8d06bb2d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7LRfY.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $iOErJ.default) : (0, $c0lH6.default);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $96e1233e8d06bb2d$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($96e1233e8d06bb2d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $9Rgf1.default)(ref, (0, $2xc7G.default)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $5FMfE.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$96e1233e8d06bb2d$var$Select.muiName = 'Select';
var $96e1233e8d06bb2d$export$2e2bcd8739ae039 = $96e1233e8d06bb2d$var$Select;

});
parcelRegister("c0lH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd650259be885cb$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $gzyUk = parcelRequire("gzyUk");

var $jTnBY = parcelRequire("jTnBY");

var $4F5tJ = parcelRequire("4F5tJ");

var $iOErJ = parcelRequire("iOErJ");

var $2BbKU = parcelRequire("2BbKU");

var $d8seH = parcelRequire("d8seH");

var $PJRTc = parcelRequire("PJRTc");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");

var $bmfPX = parcelRequire("bmfPX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $8bd650259be885cb$var$_span;
const $8bd650259be885cb$var$SelectSelect = (0, $d8seH.default)((0, $iOErJ.StyledSelectSelect), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $bmfPX.default).select}`]: styles.select
            },
            {
                [`&.${(0, $bmfPX.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $bmfPX.default).error}`]: styles.error
            },
            {
                [`&.${(0, $bmfPX.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $bmfPX.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $8bd650259be885cb$var$SelectIcon = (0, $d8seH.default)((0, $iOErJ.StyledSelectIcon), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $8bd650259be885cb$var$SelectNativeInput = (0, $d8seH.default)('input', {
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $8bd650259be885cb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8bd650259be885cb$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $8bd650259be885cb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bmfPX.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $8bd650259be885cb$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3yddg.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $9Rgf1.default)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $gzyUk.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2BbKU.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$8bd650259be885cb$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8bd650259be885cb$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $8bd650259be885cb$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...MenuProps.slotProps?.paper
    };
    const listboxId = (0, $auC0X.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $5FMfE.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8bd650259be885cb$var$isEmpty(display) ? $8bd650259be885cb$var$_span || ($8bd650259be885cb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8bd650259be885cb$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...MenuProps.MenuListProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $8bd650259be885cb$export$2e2bcd8739ae039 = $8bd650259be885cb$var$SelectInput;

});
parcelRegister("gzyUk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10afe25107351d9$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
var $c10afe25107351d9$export$2e2bcd8739ae039 = (0, $6zeBo.default);

});

parcelRegister("4F5tJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $364f3db28d8d2e79$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");


var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $lBOb7 = parcelRequire("lBOb7");

var $6el2W = parcelRequire("6el2W");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $lyHsQ = parcelRequire("lyHsQ");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $364f3db28d8d2e79$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $364f3db28d8d2e79$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $364f3db28d8d2e79$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lyHsQ.getMenuUtilityClass), classes);
};
const $364f3db28d8d2e79$var$MenuRoot = (0, $d8seH.default)((0, $6el2W.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $364f3db28d8d2e79$export$4f7c51a5920c9f33 = (0, $d8seH.default)((0, $6el2W.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $364f3db28d8d2e79$var$MenuMenuList = (0, $d8seH.default)((0, $lBOb7.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $364f3db28d8d2e79$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $364f3db28d8d2e79$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $eD6Co.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $6lpak.default)('paper', {
        className: classes.paper,
        elementType: $364f3db28d8d2e79$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $6lpak.default)('list', {
        className: (0, $5FMfE.default)(classes.list, MenuListProps.className),
        elementType: $364f3db28d8d2e79$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($364f3db28d8d2e79$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $364f3db28d8d2e79$var$RTL_ORIGIN : $364f3db28d8d2e79$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $364f3db28d8d2e79$export$2e2bcd8739ae039 = $364f3db28d8d2e79$var$Menu;

});
parcelRegister("lBOb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb3fa0cdc277971$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $gzyUk = parcelRequire("gzyUk");

var $8AyZl = parcelRequire("8AyZl");

var $19SuQ = parcelRequire("19SuQ");

var $9Rgf1 = parcelRequire("9Rgf1");

var $khjmj = parcelRequire("khjmj");

var $9Evvr = parcelRequire("9Evvr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $fbb3fa0cdc277971$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fbb3fa0cdc277971$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fbb3fa0cdc277971$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fbb3fa0cdc277971$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $khjmj.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $19SuQ.default)((0, $9Evvr.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $gzyUk.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fbb3fa0cdc277971$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fbb3fa0cdc277971$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fbb3fa0cdc277971$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fbb3fa0cdc277971$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fbb3fa0cdc277971$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $9Rgf1.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8AyZl.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $fbb3fa0cdc277971$export$2e2bcd8739ae039 = $fbb3fa0cdc277971$var$MenuList;

});
parcelRegister("8AyZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $640cd381f5e8b3ea$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $eUMjp = parcelRequire("eUMjp");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $640cd381f5e8b3ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eUMjp.getListUtilityClass), classes);
};
const $640cd381f5e8b3ea$var$ListRoot = (0, $d8seH.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $640cd381f5e8b3ea$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $640cd381f5e8b3ea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($640cd381f5e8b3ea$var$ListRoot, {
            as: component,
            className: (0, $5FMfE.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $640cd381f5e8b3ea$export$2e2bcd8739ae039 = $640cd381f5e8b3ea$var$List;

});
parcelRegister("eUMjp", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $adbbc5717e0d0350$export$c6bd6795ed6e3203);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $adbbc5717e0d0350$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $adbbc5717e0d0350$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $adbbc5717e0d0350$export$2e2bcd8739ae039 = $adbbc5717e0d0350$var$listClasses;

});


parcelRegister("19SuQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d80e79907b6bdbc$export$2e2bcd8739ae039);

var $aF4kJ = parcelRequire("aF4kJ");
var $0d80e79907b6bdbc$export$2e2bcd8739ae039 = (0, $aF4kJ.default);

});
parcelRegister("aF4kJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0200cab69b9251c8$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});


parcelRegister("9Evvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $707049eb9639aeac$export$2e2bcd8739ae039);

var $9KvVX = parcelRequire("9KvVX");
var $707049eb9639aeac$export$2e2bcd8739ae039 = (0, $9KvVX.default);

});


parcelRegister("6el2W", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $012baef8dc9ae9d0$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $012baef8dc9ae9d0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");






var $c1jOg = parcelRequire("c1jOg");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $1iGrQ = parcelRequire("1iGrQ");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $iscuz = parcelRequire("iscuz");

var $118QM = parcelRequire("118QM");

var $7Frhn = parcelRequire("7Frhn");

var $k6uEG = parcelRequire("k6uEG");

var $6lpak = parcelRequire("6lpak");

var $f8X1n = parcelRequire("f8X1n");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $012baef8dc9ae9d0$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $012baef8dc9ae9d0$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $012baef8dc9ae9d0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $k6uEG.getPopoverUtilityClass), classes);
};
const $012baef8dc9ae9d0$export$bcce13685275fc99 = (0, $d8seH.default)((0, $118QM.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $012baef8dc9ae9d0$export$821346c38a2d9390 = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $012baef8dc9ae9d0$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $acw62.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $012baef8dc9ae9d0$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $gzyUk.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $012baef8dc9ae9d0$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $012baef8dc9ae9d0$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $012baef8dc9ae9d0$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $9Evvr.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $012baef8dc9ae9d0$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $1iGrQ.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $9Evvr.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $iscuz.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $gzyUk.default)($012baef8dc9ae9d0$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $012baef8dc9ae9d0$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $f8X1n.default)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $6lpak.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $012baef8dc9ae9d0$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $c1jOg.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $012baef8dc9ae9d0$export$2e2bcd8739ae039 = $012baef8dc9ae9d0$var$Popover;

});
parcelRegister("1iGrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2866359d6621f3$export$2e2bcd8739ae039);

var $aJ8G8 = parcelRequire("aJ8G8");
var $0f2866359d6621f3$export$2e2bcd8739ae039 = (0, $aJ8G8.default);

});

parcelRegister("118QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdcbfecdf3275a2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");



var $8Indx = parcelRequire("8Indx");

var $kRwxQ = parcelRequire("kRwxQ");

var $2Q995 = parcelRequire("2Q995");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6cr7d = parcelRequire("6cr7d");

var $lkowv = parcelRequire("lkowv");

var $16KGQ = parcelRequire("16KGQ");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0bdcbfecdf3275a2$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $16KGQ.getModalUtilityClass), classes);
};
const $0bdcbfecdf3275a2$var$ModalRoot = (0, $d8seH.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $0bdcbfecdf3275a2$var$ModalBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0bdcbfecdf3275a2$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0bdcbfecdf3275a2$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $lkowv.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $0bdcbfecdf3275a2$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $0bdcbfecdf3275a2$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $6lpak.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (onBackdropClick) onBackdropClick(event);
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $5FMfE.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Q995.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kRwxQ.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $0bdcbfecdf3275a2$export$2e2bcd8739ae039 = $0bdcbfecdf3275a2$var$Modal;

});
parcelRegister("kRwxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f30200a1e85b3f20$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $2xc7G = parcelRequire("2xc7G");
var $6zeBo = parcelRequire("6zeBo");
var $3qSdM = parcelRequire("3qSdM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $f30200a1e85b3f20$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $f30200a1e85b3f20$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $f30200a1e85b3f20$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $f30200a1e85b3f20$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $f30200a1e85b3f20$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($f30200a1e85b3f20$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $f30200a1e85b3f20$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$f30200a1e85b3f20$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $f30200a1e85b3f20$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $f30200a1e85b3f20$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $f30200a1e85b3f20$var$defaultGetTabbable, isEnabled: isEnabled = $f30200a1e85b3f20$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $f30200a1e85b3f20$export$2e2bcd8739ae039 = $f30200a1e85b3f20$var$FocusTrap;

});

parcelRegister("6cr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $4838e5a14e330013$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $86f4a = parcelRequire("86f4a");

var $7ViEK = parcelRequire("7ViEK");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4838e5a14e330013$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7ViEK.getBackdropUtilityClass), classes);
};
const $4838e5a14e330013$var$BackdropRoot = (0, $d8seH.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $4838e5a14e330013$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $4838e5a14e330013$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $4838e5a14e330013$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $86f4a.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $4838e5a14e330013$export$2e2bcd8739ae039 = $4838e5a14e330013$var$Backdrop;

});
parcelRegister("86f4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5a92158e7d9bd4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1mPeS = parcelRequire("1mPeS");


var $2xc7G = parcelRequire("2xc7G");

var $14H9o = parcelRequire("14H9o");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5e5a92158e7d9bd4$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5e5a92158e7d9bd4$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $14H9o.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $hweuE.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5e5a92158e7d9bd4$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $5e5a92158e7d9bd4$export$2e2bcd8739ae039 = $5e5a92158e7d9bd4$var$Fade;

});

parcelRegister("7ViEK", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $5c4c540114ae85ab$export$9927a91fd93152bd);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5c4c540114ae85ab$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $5c4c540114ae85ab$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $5c4c540114ae85ab$export$2e2bcd8739ae039 = $5c4c540114ae85ab$var$backdropClasses;

});


parcelRegister("lkowv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86e7d122c1fa324$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hPGQj = parcelRequire("hPGQj");
var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $f56pe = parcelRequire("f56pe");

var $75CP6 = parcelRequire("75CP6");
'use client';
function $f86e7d122c1fa324$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $f86e7d122c1fa324$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $f86e7d122c1fa324$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $f86e7d122c1fa324$var$manager = new (0, $75CP6.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $f86e7d122c1fa324$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $f86e7d122c1fa324$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6zeBo.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $f86e7d122c1fa324$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $13KXh.default)(()=>{
        const resolvedContainer = $f86e7d122c1fa324$var$getContainer(container) || getDoc().body;
        $f86e7d122c1fa324$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$f86e7d122c1fa324$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $13KXh.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $75CP6.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        $f86e7d122c1fa324$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f56pe.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $hPGQj.default)(handleEnter, children?.props.onEnter ?? $f86e7d122c1fa324$var$noop),
            onExited: (0, $hPGQj.default)(handleExited, children?.props.onExited ?? $f86e7d122c1fa324$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $f86e7d122c1fa324$export$2e2bcd8739ae039 = $f86e7d122c1fa324$var$useModal;

});
parcelRegister("hPGQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("75CP6", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $52971d86e2bcd483$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $52971d86e2bcd483$export$ce11c4ecd08cea67);

var $aF4kJ = parcelRequire("aF4kJ");
var $6zeBo = parcelRequire("6zeBo");
var $9KvVX = parcelRequire("9KvVX");
// Is a vertical scrollbar displayed?
function $52971d86e2bcd483$var$isOverflowing(container) {
    const doc = (0, $6zeBo.default)(container);
    if (doc.body === container) return (0, $9KvVX.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $52971d86e2bcd483$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $52971d86e2bcd483$var$getPaddingRight(element) {
    return parseInt((0, $9KvVX.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $52971d86e2bcd483$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$52971d86e2bcd483$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $52971d86e2bcd483$export$e1bd0c6150f13d96(element, hide);
    });
}
function $52971d86e2bcd483$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $52971d86e2bcd483$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($52971d86e2bcd483$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $aF4kJ.default)((0, $9KvVX.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6zeBo.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$52971d86e2bcd483$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6zeBo.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9KvVX.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $52971d86e2bcd483$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $52971d86e2bcd483$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $52971d86e2bcd483$var$getHiddenSiblings(container);
        $52971d86e2bcd483$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $52971d86e2bcd483$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $52971d86e2bcd483$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $52971d86e2bcd483$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $52971d86e2bcd483$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $52971d86e2bcd483$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRegister("16KGQ", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $0cea91a79e26c98a$export$67960e22b12a638d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0cea91a79e26c98a$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $0cea91a79e26c98a$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $0cea91a79e26c98a$export$2e2bcd8739ae039 = $0cea91a79e26c98a$var$modalClasses;

});


parcelRegister("k6uEG", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $ea2c25a800e729b1$export$88f455dd56c95edb);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ea2c25a800e729b1$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $ea2c25a800e729b1$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ea2c25a800e729b1$export$2e2bcd8739ae039 = $ea2c25a800e729b1$var$popoverClasses;

});

parcelRegister("f8X1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06562c0a3ca8f02$export$2e2bcd8739ae039);

var $5FMfE = parcelRequire("5FMfE");
function $b06562c0a3ca8f02$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $5FMfE.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const className = (0, $5FMfE.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("lyHsQ", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $fb1e7d0ac8fac824$export$2cf86a63a84fe23d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fb1e7d0ac8fac824$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $fb1e7d0ac8fac824$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $fb1e7d0ac8fac824$export$2e2bcd8739ae039 = $fb1e7d0ac8fac824$var$menuClasses;

});


parcelRegister("iOErJ", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", () => $db2c454fb2e8bc3c$export$50b3545a8ccd87af);
$parcel$export(module.exports, "StyledSelectIcon", () => $db2c454fb2e8bc3c$export$7dd4d92f143902e3);
$parcel$export(module.exports, "default", () => $db2c454fb2e8bc3c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $6jVRo = parcelRequire("6jVRo");

var $d8seH = parcelRequire("d8seH");

var $8Uq77 = parcelRequire("8Uq77");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db2c454fb2e8bc3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6jVRo.getNativeSelectUtilityClasses), classes);
};
const $db2c454fb2e8bc3c$export$50b3545a8ccd87af = (0, $d8seH.default)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $6jVRo.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectSelect = (0, $d8seH.default)($db2c454fb2e8bc3c$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $8Uq77.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $6jVRo.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $db2c454fb2e8bc3c$export$7dd4d92f143902e3 = (0, $d8seH.default)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $6jVRo.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $db2c454fb2e8bc3c$var$NativeSelectIcon = (0, $d8seH.default)($db2c454fb2e8bc3c$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $jTnBY.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $db2c454fb2e8bc3c$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $db2c454fb2e8bc3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $5FMfE.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($db2c454fb2e8bc3c$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $db2c454fb2e8bc3c$export$2e2bcd8739ae039 = $db2c454fb2e8bc3c$var$NativeSelectInput;

});
parcelRegister("6jVRo", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $49a1663d7631a8fa$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $49a1663d7631a8fa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $49a1663d7631a8fa$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$export$2e2bcd8739ae039 = $49a1663d7631a8fa$var$nativeSelectClasses;

});


parcelRegister("bmfPX", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $844e08aea9053c4b$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $844e08aea9053c4b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $844e08aea9053c4b$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $844e08aea9053c4b$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $844e08aea9053c4b$export$2e2bcd8739ae039 = $844e08aea9053c4b$var$selectClasses;

});


parcelRegister("7LRfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a863bd9b12ca76b$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5a863bd9b12ca76b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("ab7Se", function(module, exports) {

$parcel$export(module.exports, "default", () => $76910a07fd4ac4fe$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $95gUw = parcelRequire("95gUw");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $b3ugU = parcelRequire("b3ugU");

var $95gUw = parcelRequire("95gUw");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $76910a07fd4ac4fe$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $b3ugU.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $76910a07fd4ac4fe$var$InputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $b3ugU.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $b3ugU.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $b3ugU.default).disabled}, .${(0, $b3ugU.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $b3ugU.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $76910a07fd4ac4fe$var$InputInput = (0, $d8seH.default)((0, $95gUw.InputBaseInput), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})({});
const $76910a07fd4ac4fe$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $76910a07fd4ac4fe$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3z1Ay.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $76910a07fd4ac4fe$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $76910a07fd4ac4fe$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$76910a07fd4ac4fe$var$Input.muiName = 'Input';
var $76910a07fd4ac4fe$export$2e2bcd8739ae039 = $76910a07fd4ac4fe$var$Input;

});
parcelRegister("b3ugU", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $80c774dd7f29b734$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $80c774dd7f29b734$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $80c774dd7f29b734$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = {
    ...(0, $dmljZ.default),
    ...(0, $beCSm.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $80c774dd7f29b734$export$2e2bcd8739ae039 = $80c774dd7f29b734$var$inputClasses;

});


parcelRegister("g4sO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb335d5457c07f5b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");

var $95gUw = parcelRequire("95gUw");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $faAxf = parcelRequire("faAxf");

var $95gUw = parcelRequire("95gUw");

var $jTnBY = parcelRequire("jTnBY");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bb335d5457c07f5b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $jTnBY.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $faAxf.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $bb335d5457c07f5b$var$FilledInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $95gUw.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $faAxf.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $faAxf.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $faAxf.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $faAxf.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $faAxf.default).disabled}, .${(0, $faAxf.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $faAxf.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $bb335d5457c07f5b$var$FilledInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseInput), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})((0, $aeD7H.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $bb335d5457c07f5b$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $bb335d5457c07f5b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $bb335d5457c07f5b$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $bb335d5457c07f5b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$bb335d5457c07f5b$var$FilledInput.muiName = 'Input';
var $bb335d5457c07f5b$export$2e2bcd8739ae039 = $bb335d5457c07f5b$var$FilledInput;

});
parcelRegister("faAxf", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $b0b42157daacd8b1$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $b0b42157daacd8b1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $b0b42157daacd8b1$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = {
    ...(0, $dmljZ.default),
    ...(0, $beCSm.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $b0b42157daacd8b1$export$2e2bcd8739ae039 = $b0b42157daacd8b1$var$filledInputClasses;

});


parcelRegister("imehR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d55d2dd82639e9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $9ZwEw = parcelRequire("9ZwEw");

var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $96QZi = parcelRequire("96QZi");

var $95gUw = parcelRequire("95gUw");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d5d55d2dd82639e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $96QZi.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $d5d55d2dd82639e9$var$OutlinedInputRoot = (0, $d8seH.default)((0, $95gUw.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $95gUw.rootOverridesResolver)
})((0, $aeD7H.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $96QZi.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $96QZi.default).focused} .${(0, $96QZi.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $96QZi.default).focused} .${(0, $96QZi.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to overide the above style
                style: {
                    [`&.${(0, $96QZi.default).error} .${(0, $96QZi.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $96QZi.default).disabled} .${(0, $96QZi.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $d5d55d2dd82639e9$var$NotchedOutlineRoot = (0, $d8seH.default)((0, $9ZwEw.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, $aeD7H.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
}));
const $d5d55d2dd82639e9$var$OutlinedInputInput = (0, $d8seH.default)((0, $95gUw.InputBaseInput), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $95gUw.inputOverridesResolver)
})((0, $aeD7H.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $d5d55d2dd82639e9$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $d5d55d2dd82639e9$var$useUtilityClasses(props);
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $d5d55d2dd82639e9$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $d5d55d2dd82639e9$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $6lpak.default)('notchedOutline', {
        elementType: $d5d55d2dd82639e9$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95gUw.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$d5d55d2dd82639e9$var$OutlinedInput.muiName = 'Input';
var $d5d55d2dd82639e9$export$2e2bcd8739ae039 = $d5d55d2dd82639e9$var$OutlinedInput;

});
parcelRegister("9ZwEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $746323a953600e78$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $746323a953600e78$var$_span;
const $746323a953600e78$var$NotchedOutlineRoot = (0, $d8seH.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $746323a953600e78$var$NotchedOutlineLegend = (0, $d8seH.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $8Uq77.default)
})((0, $aeD7H.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $746323a953600e78$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($746323a953600e78$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $746323a953600e78$var$_span || ($746323a953600e78$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("96QZi", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $6a1dc6d1d7e1816a$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $6a1dc6d1d7e1816a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $dmljZ = parcelRequire("dmljZ");
function $6a1dc6d1d7e1816a$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = {
    ...(0, $dmljZ.default),
    ...(0, $beCSm.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $6a1dc6d1d7e1816a$export$2e2bcd8739ae039 = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});



parcelRegister("kyRsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef8072c26f712b4c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $iaUmy = parcelRequire("iaUmy");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ef8072c26f712b4c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iaUmy.getToolbarUtilityClass), classes);
};
const $ef8072c26f712b4c$var$ToolbarRoot = (0, $d8seH.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $ef8072c26f712b4c$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $ef8072c26f712b4c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef8072c26f712b4c$var$ToolbarRoot, {
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $ef8072c26f712b4c$export$2e2bcd8739ae039 = $ef8072c26f712b4c$var$Toolbar;

});
parcelRegister("iaUmy", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", () => $d3b4e1a115786e57$export$b12cb262231eef32);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d3b4e1a115786e57$export$b12cb262231eef32(slot) {
    return (0, $4Cod0.default)('MuiToolbar', slot);
}
const $d3b4e1a115786e57$var$toolbarClasses = (0, $beCSm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d3b4e1a115786e57$export$2e2bcd8739ae039 = $d3b4e1a115786e57$var$toolbarClasses;

});


parcelRegister("dLLxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0648bcf9b9d5e9c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $58lXc = parcelRequire("58lXc");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $9Lykx = parcelRequire("9Lykx");

var $5izos = parcelRequire("5izos");

var $21SL6 = parcelRequire("21SL6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a0648bcf9b9d5e9c$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(props, ref) {
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $58lXc.useRtl)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? (0, $9Lykx.default);
    const LastButton = slots.lastButton ?? (0, $9Lykx.default);
    const NextButton = slots.nextButton ?? (0, $9Lykx.default);
    const PreviousButton = slots.previousButton ?? (0, $9Lykx.default);
    const FirstButtonIcon = slots.firstButtonIcon ?? (0, $21SL6.default);
    const LastButtonIcon = slots.lastButtonIcon ?? (0, $5izos.default);
    const NextButtonIcon = slots.nextButtonIcon ?? (0, $f46un.default);
    const PreviousButtonIcon = slots.previousButtonIcon ?? (0, $frMNQ.default);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        ref: ref,
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
var $a0648bcf9b9d5e9c$export$2e2bcd8739ae039 = $a0648bcf9b9d5e9c$var$TablePaginationActions;

});
parcelRegister("frMNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3ef3be5c947a70a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $b3ef3be5c947a70a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("f46un", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d495bb1a743bb2$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $02d495bb1a743bb2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("5izos", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dba169293b5f5f0$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $3dba169293b5f5f0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

});

parcelRegister("21SL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a626ba35acf52f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $17a626ba35acf52f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

});


parcelRegister("inBkn", function(module, exports) {

$parcel$export(module.exports, "getTablePaginationUtilityClass", () => $d6175477fd255470$export$909e637b22246f4c);
$parcel$export(module.exports, "default", () => $d6175477fd255470$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d6175477fd255470$export$909e637b22246f4c(slot) {
    return (0, $4Cod0.default)('MuiTablePagination', slot);
}
const $d6175477fd255470$var$tablePaginationClasses = (0, $beCSm.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $d6175477fd255470$export$2e2bcd8739ae039 = $d6175477fd255470$var$tablePaginationClasses;

});


parcelRegister("2XjE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $22705465ad6920f8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $RbMj7 = parcelRequire("RbMj7");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $4iLi6 = parcelRequire("4iLi6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $22705465ad6920f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4iLi6.getTableRowUtilityClass), classes);
};
const $22705465ad6920f8$var$TableRowRoot = (0, $d8seH.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $4iLi6.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $4iLi6.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    })));
const $22705465ad6920f8$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $22705465ad6920f8$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $22705465ad6920f8$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $acw62.useContext((0, $RbMj7.default));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $22705465ad6920f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($22705465ad6920f8$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $5FMfE.default)(classes.root, className),
        role: component === $22705465ad6920f8$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $22705465ad6920f8$export$2e2bcd8739ae039 = $22705465ad6920f8$var$TableRow;

});
parcelRegister("4iLi6", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", () => $321d86e199abda5b$export$ba0a6d6c28940107);
$parcel$export(module.exports, "default", () => $321d86e199abda5b$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $321d86e199abda5b$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $321d86e199abda5b$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $321d86e199abda5b$export$2e2bcd8739ae039 = $321d86e199abda5b$var$tableRowClasses;

});


parcelRegister("lkxXU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f875d00b2138afe4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $cbVYE = parcelRequire("cbVYE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f875d00b2138afe4$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cbVYE.getDividerUtilityClass), classes);
};
const $f875d00b2138afe4$var$DividerRoot = (0, $d8seH.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $aSEG4.alpha)(theme.palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$DividerWrapper = (0, $d8seH.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $f875d00b2138afe4$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $f875d00b2138afe4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerRoot, {
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($f875d00b2138afe4$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($f875d00b2138afe4$var$Divider) $f875d00b2138afe4$var$Divider.muiSkipListHighlight = true;
var $f875d00b2138afe4$export$2e2bcd8739ae039 = $f875d00b2138afe4$var$Divider;

});

parcelRegister("4D8ul", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $35f16394a96a7f2a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35f16394a96a7f2a$var$_createSvgIcon = $35f16394a96a7f2a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $35f16394a96a7f2a$var$_default = module.exports.default = (0, $35f16394a96a7f2a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');

});

parcelRegister("ipR47", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d683b97fd1dcbc68$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d683b97fd1dcbc68$var$_createSvgIcon = $d683b97fd1dcbc68$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d683b97fd1dcbc68$var$_default = module.exports.default = (0, $d683b97fd1dcbc68$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');

});

parcelRegister("3JK9z", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2b89602345ebb0fd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b89602345ebb0fd$var$_createSvgIcon = $2b89602345ebb0fd$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2b89602345ebb0fd$var$_default = module.exports.default = (0, $2b89602345ebb0fd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("1CO8b", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $12f03a0bc69c09a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12f03a0bc69c09a0$var$_createSvgIcon = $12f03a0bc69c09a0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $12f03a0bc69c09a0$var$_default = module.exports.default = (0, $12f03a0bc69c09a0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 14 5-5 5 5z"
}), 'ArrowDropUp');

});

parcelRegister("74El0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d2b1b6afaaa21a6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDownloadCol", () => $1d2b1b6afaaa21a6$export$c402ab076c9a9b32);

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $gqRfU = parcelRequire("gqRfU");

var $hBKHw = parcelRequire("hBKHw");

var $cVXaD = parcelRequire("cVXaD");

var $9Lykx = parcelRequire("9Lykx");

var $2iAqv = parcelRequire("2iAqv");
function $1d2b1b6afaaa21a6$export$2e2bcd8739ae039({ onDownload: onDownload }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1d2b1b6afaaa21a6$var$DownloadContainer, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gqRfU.default), {
            button: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "View download options...",
                placement: "top",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    "aria-label": "download",
                    size: "small",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {})
                })
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($1d2b1b6afaaa21a6$var$DownloadTitle, {
                    children: "Download Table As..."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                    onClick: ()=>onDownload('text/csv'),
                    children: "Displayed Data as CSV"
                })
            ]
        })
    });
}
function $1d2b1b6afaaa21a6$export$c402ab076c9a9b32(item) {
    if (typeof item == 'string') return item.includes(',') ? `"${item}"` : item;
    else if (Array.isArray(item)) {
        if (typeof item[0] == 'object') return item.map((o)=>JSON.stringify(o)).join(', ');
        else return item.join(', ');
    } else if (item && typeof item == 'object') return `"${Object.entries(item).map(([k, v])=>`${k}: ${v}`).join(', ')}"`;
    else return item;
}
const $1d2b1b6afaaa21a6$var$DownloadContainer = (0, $lmFrL.default).div`
  margin-left: 10px;
  padding-right: 5px;

  img {
    width: 20px;
    filter: contrast(40%);
  }
`;
const $1d2b1b6afaaa21a6$var$DownloadTitle = (0, $lmFrL.default).div`
  font-weight: bold;
  width: 100%;
  background: #2e76a3;
  color: #f2f2f2;
  padding: 4px 5px;
`;

});
parcelRegister("gqRfU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b448dd1f386a47cb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

var $4F5tJ = parcelRequire("4F5tJ");
function $b448dd1f386a47cb$export$2e2bcd8739ae039(props) {
    const { button: button } = props;
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const handleClick = (evt)=>{
        setAnchorEl(evt.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            button ? /*#__PURE__*/ (0, $acw62.cloneElement)(button, {
                onClick: handleClick
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                "aria-controls": "menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                disableRipple: true,
                children: "Menu"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                children: props.children
            })
        ]
    });
}

});

parcelRegister("hBKHw", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $cd1a1e337e281024$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd1a1e337e281024$var$_createSvgIcon = $cd1a1e337e281024$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $cd1a1e337e281024$var$_default = module.exports.default = (0, $cd1a1e337e281024$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3m-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"
}), 'CloudDownloadOutlined');

});


parcelRegister("i2aXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $840a29073ab524a4$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aSEG4 = parcelRequire("aSEG4");
var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $e76iu = parcelRequire("e76iu");

var $3iRcz = parcelRequire("3iRcz");

var $c38fS = parcelRequire("c38fS");

var $4VwvT = parcelRequire("4VwvT");

var $cFBau = parcelRequire("cFBau");

var $9Lykx = parcelRequire("9Lykx");

var $95gUw = parcelRequire("95gUw");

var $cVXaD = parcelRequire("cVXaD");

var $03mUs = parcelRequire("03mUs");
/* example options
const options = [
  { id: 'foo', label: 'Foo' },
  { id: 'bar', label: 'Bar' },
]
*/ const $840a29073ab524a4$var$StyledPopper = (0, $d8seH.default)((0, $e76iu.default))(()=>({
        border: '1px solid rgba(27,31,35,.15)',
        boxShadow: '0 3px 12px rgba(27,31,35,.15)',
        borderRadius: 3,
        width: 300,
        zIndex: 9999,
        fontSize: 13,
        color: '#586069',
        backgroundColor: '#f6f8fa'
    }));
const $840a29073ab524a4$var$DivHeader = (0, $d8seH.default)('div')(()=>({
        borderBottom: '1px solid #e1e4e8',
        padding: '8px 10px',
        fontWeight: 600
    }));
const $840a29073ab524a4$var$StyledInputBase = (0, $d8seH.default)((0, $95gUw.default))(({ theme: theme })=>({
        padding: 10,
        width: '100%',
        borderBottom: '1px solid #dfe2e5',
        '& input': {
            borderRadius: 4,
            backgroundColor: theme.palette.common.white,
            padding: 8,
            transition: theme.transitions.create([
                'border-color',
                'box-shadow'
            ]),
            border: '1px solid #ced4da',
            fontSize: 12,
            '&:focus': {
                boxShadow: `${(0, $aSEG4.alpha)(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
                borderColor: theme.palette.primary.main
            }
        }
    }));
function $840a29073ab524a4$export$2e2bcd8739ae039(props) {
    const { options: options, value: value, headerText: headerText, onRestoreDefaults: onRestoreDefaults, onChange: onChange, ...rest } = props;
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const theme = (0, $14H9o.default)();
    const handleClick = (event)=>{
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'column-search' : undefined;
    const defaultShownCount = (0, $acw62.useMemo)(()=>options.filter((o)=>!o.hide).length, [
        options
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            defaultShownCount != value.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Restore default columns",
                placement: "top",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    size: "small",
                    onClick: onRestoreDefaults,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c38fS))), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Show/hide columns...",
                placement: "top",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    size: "small",
                    onClick: handleClick,
                    disableRipple: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3iRcz))), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($840a29073ab524a4$var$StyledPopper, {
                id: id,
                open: open,
                anchorEl: anchorEl,
                placement: "bottom-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($840a29073ab524a4$var$DivHeader, {
                            className: "flex items-center justify-between",
                            children: headerText ? headerText : 'Select table columns'
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                            open: true,
                            onClose: handleClick,
                            multiple: true,
                            value: value,
                            onChange: (event, newValue)=>{
                                onChange(newValue);
                            },
                            disableCloseOnSelect: true,
                            disablePortal: true,
                            renderTags: ()=>null,
                            noOptionsText: "No labels",
                            renderOption: (props, option, { selected: selected })=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                    ...props,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            component: (0, (/*@__PURE__*/$parcel$interopDefault($4VwvT))),
                                            sx: {
                                                width: 17,
                                                height: 17,
                                                mr: '5px',
                                                ml: '-2px'
                                            },
                                            style: {
                                                visibility: selected ? 'visible' : 'hidden'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            sx: {
                                                flexGrow: 1,
                                                '& span': {
                                                    color: theme.palette.mode === 'light' ? '#586069' : '#8b949e'
                                                },
                                                fontSize: '.9em'
                                            },
                                            children: option.label || option.id
                                        })
                                    ]
                                });
                            },
                            options: options,
                            getOptionLabel: (option)=>option.label || option.id,
                            renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($840a29073ab524a4$var$StyledInputBase, {
                                    ref: params.InputProps.ref,
                                    inputProps: params.inputProps,
                                    autoFocus: true
                                }),
                            ...rest
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("3iRcz", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $267c524803caefd8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $267c524803caefd8$var$_createSvgIcon = $267c524803caefd8$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $267c524803caefd8$var$_default = module.exports.default = (0, $267c524803caefd8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1q-.09-.03-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1q.09.03.18.03c.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64zm-1.98-1.71c.04.31.05.52.05.73s-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}), 'SettingsOutlined');

});

parcelRegister("c38fS", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8c5c2b208fd1f610$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c5c2b208fd1f610$var$_createSvgIcon = $8c5c2b208fd1f610$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c5c2b208fd1f610$var$_default = module.exports.default = (0, $8c5c2b208fd1f610$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22.75 19c0-.22-.03-.42-.06-.63l.84-.73c.18-.16.22-.42.1-.63l-.59-1.02c-.12-.21-.37-.3-.59-.22l-1.06.36q-.48-.405-1.08-.63l-.22-1.09c-.05-.23-.25-.4-.49-.4h-1.18c-.24 0-.44.17-.49.4l-.22 1.09q-.6.225-1.08.63l-1.06-.36c-.23-.08-.47.02-.59.22l-.59 1.02c-.12.21-.08.47.1.63l.84.73c-.03.21-.06.41-.06.63s.03.42.06.63l-.84.73c-.18.16-.22.42-.1.63l.59 1.02c.12.21.37.3.59.22l1.06-.36q.48.405 1.08.63l.22 1.09c.05.23.25.4.49.4h1.18c.24 0 .44-.17.49-.4l.22-1.09q.6-.225 1.08-.63l1.06.36c.23.08.47-.02.59-.22l.59-1.02c.12-.21.08-.47-.1-.63l-.84-.73c.03-.21.06-.41.06-.63M19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M12 7c-.55 0-1 .45-1 1v4c0 .27.11.52.29.71l2.07 2.07 1.04-1.79-1.4-1.4V8c0-.55-.45-1-1-1m-7.74 6c-.65 0-1.14.61-.98 1.24C4.28 18.13 7.8 21 12 21h.07l-1.21-2.09c-2.75-.45-4.96-2.51-5.64-5.18-.11-.44-.51-.73-.96-.73M4 10c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v1.36C6.65 4.32 9.17 3 12 3c4.97 0 9 4.03 9 9h-2c0-3.86-3.14-7-7-7-2.37 0-4.47 1.19-5.74 3H8c.55 0 1 .45 1 1s-.45 1-1 1z"
}), 'ManageHistoryRounded');

});

parcelRegister("4VwvT", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $3965b4c1913a7284$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3965b4c1913a7284$var$_createSvgIcon = $3965b4c1913a7284$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $3965b4c1913a7284$var$_default = module.exports.default = (0, $3965b4c1913a7284$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), 'Done');

});

parcelRegister("cFBau", function(module, exports) {

$parcel$export(module.exports, "default", () => $9396253983985262$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");



var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $33DpT = parcelRequire("33DpT");

var $e76iu = parcelRequire("e76iu");

var $7djgP = parcelRequire("7djgP");

var $7Frhn = parcelRequire("7Frhn");

var $9Lykx = parcelRequire("9Lykx");

var $6ami2 = parcelRequire("6ami2");

var $b3ugU = parcelRequire("b3ugU");

var $dmljZ = parcelRequire("dmljZ");

var $96QZi = parcelRequire("96QZi");

var $faAxf = parcelRequire("faAxf");

var $ldBGF = parcelRequire("ldBGF");

var $7LRfY = parcelRequire("7LRfY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $9O25J = parcelRequire("9O25J");

var $jTnBY = parcelRequire("jTnBY");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $9396253983985262$var$_ClearIcon, $9396253983985262$var$_ArrowDropDownIcon;
const $9396253983985262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $jTnBY.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9O25J.getAutocompleteUtilityClass), classes);
};
const $9396253983985262$var$AutocompleteRoot = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $9O25J.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $9O25J.default).tag}`]: styles[`tagSize${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $9O25J.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $9O25J.default).input}`]: styles.input
            },
            {
                [`& .${(0, $9O25J.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $9O25J.default).focused} .${(0, $9O25J.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $9O25J.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $9O25J.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $9O25J.default).inputRoot}`]: {
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $9O25J.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $b3ugU.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $b3ugU.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $b3ugU.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $96QZi.default).root}`]: {
        padding: 9,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $9O25J.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $96QZi.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $9O25J.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $faAxf.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $9O25J.default).hasPopupIcon}&, .${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $9O25J.default).hasPopupIcon}.${(0, $9O25J.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $faAxf.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $9O25J.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $faAxf.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $faAxf.default).root}.${(0, $dmljZ.default).hiddenLabel}.${(0, $dmljZ.default).sizeSmall}`]: {
        [`& .${(0, $9O25J.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $9O25J.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $9O25J.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $9O25J.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $9O25J.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $9396253983985262$var$AutocompleteEndAdornment = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $9396253983985262$var$AutocompleteClearIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $9396253983985262$var$AutocompletePopupIndicator = (0, $d8seH.default)((0, $9Lykx.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $9396253983985262$var$AutocompletePopper = (0, $d8seH.default)((0, $e76iu.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9O25J.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $9396253983985262$var$AutocompletePaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $9396253983985262$var$AutocompleteLoading = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteNoOptions = (0, $d8seH.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $9396253983985262$var$AutocompleteListbox = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})((0, $aeD7H.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $9O25J.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $9O25J.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $9O25J.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $9O25J.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $9O25J.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    })));
const $9396253983985262$var$AutocompleteGroupLabel = (0, $d8seH.default)((0, $7djgP.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $9396253983985262$var$AutocompleteGroupUl = (0, $d8seH.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $9O25J.default).option}`]: {
        paddingLeft: 24
    }
});
const $9396253983985262$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $9396253983985262$var$_ClearIcon || ($9396253983985262$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldBGF.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $9396253983985262$var$_ArrowDropDownIcon || ($9396253983985262$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7LRfY.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $33DpT.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $9396253983985262$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $6lpak.default)('listbox', {
        elementType: $9396253983985262$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $6lpak.default)('paper', {
        elementType: (0, $7Frhn.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $6lpak.default)('popper', {
        elementType: (0, $e76iu.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>({
                className: classes.tag,
                disabled: disabled,
                ...getTagProps(params)
            });
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const { key: key, ...customTagProps } = getCustomizedTagProps({
                index: index
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: getOptionLabel(option),
                size: size,
                ...customTagProps,
                ...externalForwardedProps.slotProps.chip
            }, key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $5FMfE.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $5FMfE.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $5FMfE.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9396253983985262$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($9396253983985262$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $9396253983985262$export$2e2bcd8739ae039 = $9396253983985262$var$Autocomplete;

});
parcelRegister("33DpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $23a03a376a300fc5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hervl = parcelRequire("hervl");
var $agZ85 = parcelRequire("agZ85");
var $13KXh = parcelRequire("13KXh");
var $auC0X = parcelRequire("auC0X");
var $9D07P = parcelRequire("9D07P");
'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $23a03a376a300fc5$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $23a03a376a300fc5$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $23a03a376a300fc5$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $23a03a376a300fc5$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $23a03a376a300fc5$var$defaultFilterOptions = $23a03a376a300fc5$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $23a03a376a300fc5$var$pageSize = 5;
const $23a03a376a300fc5$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE = [];
function $23a03a376a300fc5$var$getInputValue(value, multiple, getOptionLabel) {
    if (multiple || value == null) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $23a03a376a300fc5$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $23a03a376a300fc5$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $23a03a376a300fc5$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $23a03a376a300fc5$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $auC0X.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedTag, setFocusedTag] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $acw62.useRef($23a03a376a300fc5$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $agZ85.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $23a03a376a300fc5$var$getInputValue(newValue, multiple, getOptionLabel);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $agZ85.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $9D07P.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $13KXh.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $13KXh.default)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $13KXh.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $13KXh.default)((node)=>{
        (0, $hervl.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$23a03a376a300fc5$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $23a03a376a300fc5$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleTagDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $23a03a376a300fc5$export$2e2bcd8739ae039 = $23a03a376a300fc5$var$useAutocomplete;

});
parcelRegister("9D07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7027da6f4b17de9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $7027da6f4b17de9d$var$usePreviousProps = (value)=>{
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;

});


parcelRegister("7djgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5408b2039b9d572c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $ixwSf = parcelRequire("ixwSf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5408b2039b9d572c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ixwSf.getListSubheaderUtilityClass), classes);
};
const $5408b2039b9d572c$var$ListSubheaderRoot = (0, $d8seH.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $5408b2039b9d572c$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $5408b2039b9d572c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5408b2039b9d572c$var$ListSubheaderRoot, {
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($5408b2039b9d572c$var$ListSubheader) $5408b2039b9d572c$var$ListSubheader.muiSkipListHighlight = true;
var $5408b2039b9d572c$export$2e2bcd8739ae039 = $5408b2039b9d572c$var$ListSubheader;

});
parcelRegister("ixwSf", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", () => $d7f4cf29715b69dd$export$6816d4fc0981ec7);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d7f4cf29715b69dd$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $d7f4cf29715b69dd$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $d7f4cf29715b69dd$export$2e2bcd8739ae039 = $d7f4cf29715b69dd$var$listSubheaderClasses;

});


parcelRegister("6ami2", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d4f79319086dc5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $8u0rE = parcelRequire("8u0rE");

var $9Rgf1 = parcelRequire("9Rgf1");


var $jTnBY = parcelRequire("jTnBY");

var $6n0Ko = parcelRequire("6n0Ko");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $iNSYf = parcelRequire("iNSYf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $47d4f79319086dc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $jTnBY.default)(size)}`,
            `color${(0, $jTnBY.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $jTnBY.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $jTnBY.default)(color)}`,
            `${variant}${(0, $jTnBY.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $jTnBY.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $jTnBY.default)(size)}`,
            `avatarColor${(0, $jTnBY.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $jTnBY.default)(size)}`,
            `iconColor${(0, $jTnBY.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $jTnBY.default)(size)}`,
            `deleteIconColor${(0, $jTnBY.default)(color)}`,
            `deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iNSYf.getChipUtilityClass), classes);
};
const $47d4f79319086dc5$var$ChipRoot = (0, $d8seH.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatar${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).avatar}`]: styles[`avatarColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`icon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).icon}`]: styles[`iconColor${(0, $jTnBY.default)(iconColor)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(size)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIconColor${(0, $jTnBY.default)(color)}`]
            },
            {
                [`& .${(0, $iNSYf.default).deleteIcon}`]: styles[`deleteIcon${(0, $jTnBY.default)(variant)}Color${(0, $jTnBY.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $jTnBY.default)(size)}`],
            styles[`color${(0, $jTnBY.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $jTnBY.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $jTnBY.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $jTnBY.default)(color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $iNSYf.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $iNSYf.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $iNSYf.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $iNSYf.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $iNSYf.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $iNSYf.default).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $aSEG4.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $aSEG4.alpha)(theme.palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].contrastTextChannel} / 0.7)` : (0, $aSEG4.alpha)(theme.palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $iNSYf.default).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aSEG4.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $iNSYf.default).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aSEG4.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
                    },
                    [`&.${(0, $iNSYf.default).focusVisible}`]: {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aSEG4.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $iNSYf.default).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $iNSYf.default).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $iNSYf.default).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $iNSYf.default).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $iNSYf.default).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $iNSYf.default).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $iNSYf.default).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $iNSYf.default).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $aSEG4.alpha)(theme.palette[color].main, 0.7)}`,
                        [`&.${(0, $iNSYf.default).clickable}:hover`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        },
                        [`&.${(0, $iNSYf.default).focusVisible}`]: {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.focusOpacity)
                        },
                        [`& .${(0, $iNSYf.default).deleteIcon}`]: {
                            color: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.7)` : (0, $aSEG4.alpha)(theme.palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $47d4f79319086dc5$var$ChipLabel = (0, $d8seH.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $jTnBY.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $47d4f79319086dc5$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $47d4f79319086dc5$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, // TODO v6: Rename to `focusableWhenDisabled`.
    ...other } = props;
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $47d4f79319086dc5$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $6n0Ko.default) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $47d4f79319086dc5$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $6n0Ko.default) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $5FMfE.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8u0rE.default), {
        className: (0, $5FMfE.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $5FMfE.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $5FMfE.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($47d4f79319086dc5$var$ChipRoot, {
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState,
        ...moreProps,
        ...other,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)($47d4f79319086dc5$var$ChipLabel, {
                className: (0, $5FMfE.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $47d4f79319086dc5$export$2e2bcd8739ae039 = $47d4f79319086dc5$var$Chip;

});
parcelRegister("8u0rE", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d1787512a69c15$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $62d1787512a69c15$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("iNSYf", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", () => $db0771a9e6a32b1d$export$31444911e4ee6fdd);
$parcel$export(module.exports, "default", () => $db0771a9e6a32b1d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $db0771a9e6a32b1d$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $db0771a9e6a32b1d$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $db0771a9e6a32b1d$export$2e2bcd8739ae039 = $db0771a9e6a32b1d$var$chipClasses;

});


parcelRegister("9O25J", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", () => $723a67e53eb4dc4c$export$8ee01529667e66d9);
$parcel$export(module.exports, "default", () => $723a67e53eb4dc4c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $723a67e53eb4dc4c$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$export$2e2bcd8739ae039 = $723a67e53eb4dc4c$var$autocompleteClasses;

});


parcelRegister("03mUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a20d475386f68c$export$2e2bcd8739ae039);

var $69Exs = parcelRequire("69Exs");


var $bnost = parcelRequire("bnost");

var $ijOKP = parcelRequire("ijOKP");

var $4jPsi = parcelRequire("4jPsi");

var $hOwN9 = parcelRequire("hOwN9");
'use client';
const $00a20d475386f68c$var$defaultTheme = (0, $ijOKP.default)();
const $00a20d475386f68c$var$Box = (0, $69Exs.default)({
    themeId: (0, $4jPsi.default),
    defaultTheme: $00a20d475386f68c$var$defaultTheme,
    defaultClassName: (0, $hOwN9.default).root,
    generateClassName: (0, $bnost.default).generate
});
var $00a20d475386f68c$export$2e2bcd8739ae039 = $00a20d475386f68c$var$Box;

});
parcelRegister("69Exs", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b3077c5e8d33a3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $umiYb = parcelRequire("umiYb");

var $bOOlK = parcelRequire("bOOlK");

var $9dZwz = parcelRequire("9dZwz");
var $hcz0Q = parcelRequire("hcz0Q");

var $eM1DJ = parcelRequire("eM1DJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $47b3077c5e8d33a3$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $bOOlK.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $eM1DJ.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $hcz0Q.default)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $umiYb.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});
parcelRegister("umiYb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75cb16b5d75ff3e$export$2e2bcd8739ae039);
function $f75cb16b5d75ff3e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f75cb16b5d75ff3e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f75cb16b5d75ff3e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f75cb16b5d75ff3e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f75cb16b5d75ff3e$export$2e2bcd8739ae039 = $f75cb16b5d75ff3e$export$4f5d2d50c9deca37;

});


parcelRegister("hOwN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf808af3a1d339c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");
const $cf808af3a1d339c9$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $cf808af3a1d339c9$export$2e2bcd8739ae039 = $cf808af3a1d339c9$var$boxClasses;

});



parcelRegister("2NJq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $861e3973517f6bb1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $iAtns = parcelRequire("iAtns");

var $hViLc = parcelRequire("hViLc");

var $9Lykx = parcelRequire("9Lykx");

var $kkEGh = parcelRequire("kkEGh");

var $i6Nna = parcelRequire("i6Nna");

var $MZbrQ = parcelRequire("MZbrQ");
var $861e3973517f6bb1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)(function TableSearch(props) {
    const { onSearch: onSearch, placeholder: placeholder, width: width } = props;
    const [query, setQuery] = (0, $acw62.useState)(props.value || '');
    const handleChange = ()=>{
        onSearch({
            query: query
        });
    };
    const debouncedOnChange = (0, $MZbrQ.default)(handleChange);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($861e3973517f6bb1$var$Search, {
            placeholder: placeholder || 'Search',
            value: query,
            onChange: (e)=>{
                debouncedOnChange();
                setQuery(e.target.value);
            },
            InputProps: {
                style: {
                    width: width || '275px'
                },
                startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                    position: "start",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkEGh))), {})
                }),
                endAdornment: query.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    size: "small",
                    onClick: ()=>{
                        debouncedOnChange();
                        setQuery('');
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i6Nna))), {
                        fontSize: "small"
                    })
                })
            },
            size: "small",
            variant: "outlined"
        })
    });
}, (prev, next)=>prev.value == next.value && prev.onSearch == next.onSearch);
const $861e3973517f6bb1$var$Search = (0, $lmFrL.default)((0, $iAtns.default))`
  .MuiOutlinedInput-adornedStart {
    padding-left: 8px;
  }
`;

});
parcelRegister("iAtns", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8826083c5af4ea7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $ab7Se = parcelRequire("ab7Se");

var $g4sO2 = parcelRequire("g4sO2");

var $imehR = parcelRequire("imehR");

var $OEVqP = parcelRequire("OEVqP");

var $gd5y7 = parcelRequire("gd5y7");

var $i32L9 = parcelRequire("i32L9");

var $cX7V2 = parcelRequire("cX7V2");

var $3epOE = parcelRequire("3epOE");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d8826083c5af4ea7$var$variantComponent = {
    standard: (0, $ab7Se.default),
    filled: (0, $g4sO2.default),
    outlined: (0, $imehR.default)
};
const $d8826083c5af4ea7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3epOE.getTextFieldUtilityClass), classes);
};
const $d8826083c5af4ea7$var$TextFieldRoot = (0, $d8seH.default)((0, $gd5y7.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $d8826083c5af4ea7$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $d8826083c5af4ea7$var$useUtilityClasses(ownerState);
    const id = (0, $auC0X.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $d8826083c5af4ea7$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $d8826083c5af4ea7$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $6lpak.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $6lpak.default)('inputLabel', {
        elementType: (0, $OEVqP.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $6lpak.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $6lpak.default)('formHelperText', {
        elementType: (0, $i32L9.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $6lpak.default)('select', {
        elementType: (0, $cX7V2.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $d8826083c5af4ea7$export$2e2bcd8739ae039 = $d8826083c5af4ea7$var$TextField;

});
parcelRegister("OEVqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $09846a8ab0aba36e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $5FMfE = parcelRequire("5FMfE");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $djhCy = parcelRequire("djhCy");
var $h2sOW = parcelRequire("h2sOW");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $cCThE = parcelRequire("cCThE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $09846a8ab0aba36e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $jTnBY.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $cCThE.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $09846a8ab0aba36e$var$InputLabelRoot = (0, $d8seH.default)((0, $djhCy.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $h2sOW.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $09846a8ab0aba36e$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $09846a8ab0aba36e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($09846a8ab0aba36e$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $5FMfE.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $09846a8ab0aba36e$export$2e2bcd8739ae039 = $09846a8ab0aba36e$var$InputLabel;

});
parcelRegister("djhCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0ab7de0d37835d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $h2sOW = parcelRequire("h2sOW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9b0ab7de0d37835d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $h2sOW.getFormLabelUtilityClasses), classes);
};
const $9b0ab7de0d37835d$export$aa5bc7f8a4705b27 = (0, $d8seH.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $h2sOW.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $h2sOW.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $h2sOW.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $9b0ab7de0d37835d$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $aeD7H.default)(({ theme: theme })=>({
        [`&.${(0, $h2sOW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $9b0ab7de0d37835d$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $9b0ab7de0d37835d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($9b0ab7de0d37835d$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $9b0ab7de0d37835d$export$2e2bcd8739ae039 = $9b0ab7de0d37835d$var$FormLabel;

});
parcelRegister("h2sOW", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $c678fac155df4fc3$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $c678fac155df4fc3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c678fac155df4fc3$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$export$2e2bcd8739ae039 = $c678fac155df4fc3$var$formLabelClasses;

});


parcelRegister("cCThE", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9313ead0c5e2e8ca$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $9313ead0c5e2e8ca$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9313ead0c5e2e8ca$export$2e2bcd8739ae039 = $9313ead0c5e2e8ca$var$inputLabelClasses;

});


parcelRegister("gd5y7", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd22a386c6068c0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $2BbKU = parcelRequire("2BbKU");

var $jTnBY = parcelRequire("jTnBY");

var $cpXNi = parcelRequire("cpXNi");

var $blr6C = parcelRequire("blr6C");

var $hGBKj = parcelRequire("hGBKj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcd22a386c6068c0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $jTnBY.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hGBKj.getFormControlUtilityClasses), classes);
};
const $bcd22a386c6068c0$var$FormControlRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $jTnBY.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bcd22a386c6068c0$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $bcd22a386c6068c0$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $cpXNi.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $2BbKU.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $cpXNi.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $2BbKU.isFilled)(child.props, true) || (0, $2BbKU.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $acw62.useRef(false);
    const onFilled = $acw62.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $acw62.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bcd22a386c6068c0$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $5FMfE.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $bcd22a386c6068c0$export$2e2bcd8739ae039 = $bcd22a386c6068c0$var$FormControl;

});
parcelRegister("cpXNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a633ad7a979daa$export$2e2bcd8739ae039);

var $4NpFa = parcelRequire("4NpFa");
var $90a633ad7a979daa$export$2e2bcd8739ae039 = (0, $4NpFa.default);

});
parcelRegister("4NpFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dfa52af4926933$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("hGBKj", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $ce03a37a8cfb980d$export$149c8b8bab2289d1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ce03a37a8cfb980d$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $ce03a37a8cfb980d$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ce03a37a8cfb980d$export$2e2bcd8739ae039 = $ce03a37a8cfb980d$var$formControlClasses;

});


parcelRegister("i32L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d23aa5c3ca6913fb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aaphR = parcelRequire("aaphR");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $e7ceb = parcelRequire("e7ceb");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d23aa5c3ca6913fb$var$_span;
const $d23aa5c3ca6913fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $jTnBY.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $e7ceb.getFormHelperTextUtilityClasses), classes);
};
const $d23aa5c3ca6913fb$var$FormHelperTextRoot = (0, $d8seH.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $e7ceb.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $e7ceb.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $d23aa5c3ca6913fb$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $d23aa5c3ca6913fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d23aa5c3ca6913fb$var$FormHelperTextRoot, {
        as: component,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $d23aa5c3ca6913fb$var$_span || ($d23aa5c3ca6913fb$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $d23aa5c3ca6913fb$export$2e2bcd8739ae039 = $d23aa5c3ca6913fb$var$FormHelperText;

});
parcelRegister("e7ceb", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $a46b344d341d82c0$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $a46b344d341d82c0$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a46b344d341d82c0$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$export$2e2bcd8739ae039 = $a46b344d341d82c0$var$formHelperTextClasses;

});


parcelRegister("3epOE", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $25a6b464d3ca38da$export$c1bdcbaf0596aeda);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $25a6b464d3ca38da$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $25a6b464d3ca38da$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $25a6b464d3ca38da$export$2e2bcd8739ae039 = $25a6b464d3ca38da$var$textFieldClasses;

});


parcelRegister("hViLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c64ff513a9933f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $3bYfT = parcelRequire("3bYfT");

var $blr6C = parcelRequire("blr6C");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $kWfSh = parcelRequire("kWfSh");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d0c64ff513a9933f$var$_span;
const $d0c64ff513a9933f$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $jTnBY.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d0c64ff513a9933f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $jTnBY.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kWfSh.getInputAdornmentUtilityClass), classes);
};
const $d0c64ff513a9933f$var$InputAdornmentRoot = (0, $d8seH.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $d0c64ff513a9933f$var$overridesResolver
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $kWfSh.default).positionStart}&:not(.${(0, $kWfSh.default).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $d0c64ff513a9933f$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $d0c64ff513a9933f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $blr6C.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d0c64ff513a9933f$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $5FMfE.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d0c64ff513a9933f$var$_span || ($d0c64ff513a9933f$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $d0c64ff513a9933f$export$2e2bcd8739ae039 = $d0c64ff513a9933f$var$InputAdornment;

});
parcelRegister("3bYfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2531239e3a525689$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aAbgT = parcelRequire("aAbgT");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $bhKtZ = parcelRequire("bhKtZ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2531239e3a525689$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $2531239e3a525689$var$extendSxProp = (0, $aAbgT.internal_createExtendSxProp)();
const $2531239e3a525689$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $jTnBY.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bhKtZ.getTypographyUtilityClass), classes);
};
const $2531239e3a525689$export$140e2f5526d3cad8 = (0, $d8seH.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $jTnBY.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $jTnBY.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $2531239e3a525689$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $2531239e3a525689$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$2531239e3a525689$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $2531239e3a525689$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $2531239e3a525689$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $2531239e3a525689$var$defaultVariantMapping[variant]) || 'span';
    const classes = $2531239e3a525689$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2531239e3a525689$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $5FMfE.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $2531239e3a525689$export$2e2bcd8739ae039 = $2531239e3a525689$var$Typography;

});
parcelRegister("bhKtZ", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $837556bdf75d281f$export$24c1f8f60cbac79e);
$parcel$export(module.exports, "default", () => $837556bdf75d281f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $837556bdf75d281f$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $837556bdf75d281f$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $837556bdf75d281f$export$2e2bcd8739ae039 = $837556bdf75d281f$var$typographyClasses;

});


parcelRegister("kWfSh", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", () => $f3e589c60baacdec$export$4b135a4b3a6c4550);
$parcel$export(module.exports, "default", () => $f3e589c60baacdec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f3e589c60baacdec$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $f3e589c60baacdec$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $f3e589c60baacdec$export$2e2bcd8739ae039 = $f3e589c60baacdec$var$inputAdornmentClasses;

});


parcelRegister("kkEGh", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ecd53b4d2c06d904$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ecd53b4d2c06d904$var$_createSvgIcon = $ecd53b4d2c06d904$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ecd53b4d2c06d904$var$_default = module.exports.default = (0, $ecd53b4d2c06d904$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'SearchOutlined');

});

parcelRegister("i6Nna", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d2ef15e747335f6e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2ef15e747335f6e$var$_createSvgIcon = $d2ef15e747335f6e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d2ef15e747335f6e$var$_default = module.exports.default = (0, $d2ef15e747335f6e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'ClearOutlined');

});

parcelRegister("MZbrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e253a31ee51b277$export$2e2bcd8739ae039);
/* 
 * A highly optimized and practical debounce for react
 * Great article: https://www.developerway.com/posts/debouncing-in-react
 */ 
var $acw62 = parcelRequire("acw62");

var $iI6LB = parcelRequire("iI6LB");
const $0e253a31ee51b277$var$useDebounce = (callback)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $acw62.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($iI6LB)))(func, 300);
    }, []);
    return debouncedCallback;
};
var $0e253a31ee51b277$export$2e2bcd8739ae039 = $0e253a31ee51b277$var$useDebounce;

});
parcelRegister("iI6LB", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $9nn6T = parcelRequire("9nn6T");

var $iV4PZ = parcelRequire("iV4PZ");
/** Error message constants. */ var $d9f195cb3938646c$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d9f195cb3938646c$var$nativeMax = Math.max, $d9f195cb3938646c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d9f195cb3938646c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d9f195cb3938646c$var$FUNC_ERROR_TEXT);
    wait = $iV4PZ(wait) || 0;
    if ($lsJ54(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d9f195cb3938646c$var$nativeMax($iV4PZ(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $d9f195cb3938646c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $9nn6T();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($9nn6T());
    }
    function debounced() {
        var time = $9nn6T(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $d9f195cb3938646c$var$debounce;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});

parcelRegister("9nn6T", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
module.exports = $6d38303b9c8735ba$var$now;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lsJ54(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});


parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});

parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});






parcelRegister("5xexf", function(module, exports) {

$parcel$export(module.exports, "default", () => $587f07f267a8999a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $1Aijw = parcelRequire("1Aijw");
const $587f07f267a8999a$var$BpIcon = (0, $d8seH.default)('span')(({ theme: theme })=>({
        borderRadius: 3,
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
            ...theme.applyStyles('dark', {
                backgroundColor: '#30404d'
            })
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
            ...theme.applyStyles('dark', {
                background: 'rgba(57,75,89,.5)'
            })
        },
        ...theme.applyStyles('dark', {
            boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
            backgroundColor: '#394b59',
            backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        })
    }));
const $587f07f267a8999a$var$BpCheckedIcon = (0, $d8seH.default)($587f07f267a8999a$var$BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""'
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3'
    }
});
function $587f07f267a8999a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1Aijw.default), {
        sx: {
            padding: '0px 9px',
            '&:hover': {
                bgcolor: 'transparent'
            }
        },
        disableRipple: true,
        color: "default",
        checkedIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($587f07f267a8999a$var$BpCheckedIcon, {}),
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($587f07f267a8999a$var$BpIcon, {}),
        inputProps: {
            'aria-label': 'checkbox'
        },
        ...props
    });
}

});
parcelRegister("1Aijw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12775c00f473d955$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $kVqvD = parcelRequire("kVqvD");

var $1yHUZ = parcelRequire("1yHUZ");

var $etWmn = parcelRequire("etWmn");

var $2rW38 = parcelRequire("2rW38");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $9s7Sp = parcelRequire("9s7Sp");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $f8X1n = parcelRequire("f8X1n");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $12775c00f473d955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $jTnBY.default)(color)}`,
            `size${(0, $jTnBY.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9s7Sp.getCheckboxUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $12775c00f473d955$var$CheckboxRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $9s7Sp.default).checked}, &.${(0, $9s7Sp.default).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $9s7Sp.default).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $12775c00f473d955$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $etWmn.default), {});
const $12775c00f473d955$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1yHUZ.default), {});
const $12775c00f473d955$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2rW38.default), {});
const $12775c00f473d955$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $12775c00f473d955$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $12775c00f473d955$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $12775c00f473d955$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $12775c00f473d955$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $12775c00f473d955$var$CheckboxRoot,
        className: (0, $5FMfE.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $f8X1n.default)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $12775c00f473d955$export$2e2bcd8739ae039 = $12775c00f473d955$var$Checkbox;

});
parcelRegister("kVqvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bdb1b636c81735$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $jTnBY = parcelRequire("jTnBY");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $3yddg = parcelRequire("3yddg");

var $cJQfW = parcelRequire("cJQfW");

var $6n0Ko = parcelRequire("6n0Ko");

var $bxhip = parcelRequire("bxhip");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f3bdb1b636c81735$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $jTnBY.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bxhip.getSwitchBaseUtilityClass), classes);
};
const $f3bdb1b636c81735$var$SwitchBaseRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $f3bdb1b636c81735$var$SwitchBaseInput = (0, $d8seH.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $8Uq77.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $f3bdb1b636c81735$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $3yddg.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $cJQfW.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $f3bdb1b636c81735$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $f3bdb1b636c81735$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $6lpak.default)('input', {
        ref: inputRef,
        elementType: $f3bdb1b636c81735$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $f3bdb1b636c81735$export$2e2bcd8739ae039 = $f3bdb1b636c81735$var$SwitchBase;

});
parcelRegister("bxhip", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $86603163591f910a$export$baa0faa0c7ad8085);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $86603163591f910a$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $86603163591f910a$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $86603163591f910a$export$2e2bcd8739ae039 = $86603163591f910a$var$switchBaseClasses;

});


parcelRegister("1yHUZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $122b08a8ae2faae5$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $122b08a8ae2faae5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("etWmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8b10b2b5aaa8e54$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $a8b10b2b5aaa8e54$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("2rW38", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8b21cdbf539e4f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1c8b21cdbf539e4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("9s7Sp", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $6e1cd6b997bc70d3$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $6e1cd6b997bc70d3$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e1cd6b997bc70d3$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$export$2e2bcd8739ae039 = $6e1cd6b997bc70d3$var$checkboxClasses;

});



parcelRegister("kRBt4", function(module, exports) {

$parcel$export(module.exports, "strToBlob", () => $bf6a83ad0c4d3033$export$150fcde5c54c0a05);
// efficient strToBlob (for downloadable data)
// see: https://stackoverflow.com/a/247261
const $bf6a83ad0c4d3033$export$150fcde5c54c0a05 = (str, contentType = '', sliceSize = 512)=>{
    const byteCharacters = str;
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for(let i = 0; i < slice.length; i++)byteNumbers[i] = slice.charCodeAt(i);
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
        type: contentType
    });
    return blob;
};

});

parcelRegister("8xxjV", function(module, exports) {

$parcel$export(module.exports, "getInitSelectedState", () => $744fc992787db266$export$4ae864b55882e7cd);
$parcel$export(module.exports, "default", () => $744fc992787db266$export$2e2bcd8739ae039);
const $744fc992787db266$var$initialSelectedState = {
    lastSelected: null,
    event: null,
    ids: [],
    objs: []
};
function $744fc992787db266$export$4ae864b55882e7cd(ids = [], data, primaryKey) {
    const objs = data.filter((o)=>ids.includes(o[primaryKey]));
    return {
        lastSelected: null,
        ids: ids,
        objs: objs
    };
}
function $744fc992787db266$export$2e2bcd8739ae039(state, action) {
    const { type: type, event: event } = action;
    if (type == 'SELECT_ALL') return {
        ...state,
        event: event,
        ids: action.rows.map((obj)=>obj.rowID),
        objs: action.rows
    };
    else if (type == 'CLEAR') return $744fc992787db266$var$initialSelectedState;
    else if (type == 'SET' || state.lastSelected == null) return {
        ...state,
        event: event,
        lastSelected: action.id,
        ids: [
            action.id
        ],
        objs: [
            action.obj
        ]
    };
    else if (type == 'SHIFT_SET' && state.lastSelected != null) {
        const { lastSelected: lastSelected } = state;
        let newObjs;
        if (action.id <= lastSelected) newObjs = action.rows.filter(({ rowID: rowID })=>rowID >= action.id && rowID <= lastSelected);
        else if (action.id > lastSelected) newObjs = action.rows.filter(({ rowID: rowID })=>rowID >= lastSelected && rowID <= action.id);
        return {
            ...state,
            event: event,
            lastSelected: action.id,
            ids: newObjs.map((o)=>o.rowID),
            objs: newObjs
        };
    } else if (type == 'CTRL_SET') {
        // don't allow things to be re-added; clear instead
        if (state.ids.includes(action.id)) return $744fc992787db266$var$initialSelectedState;
        return {
            ...state,
            event: event,
            lastSelected: action.id,
            ids: [
                ...state.ids,
                action.id
            ],
            objs: [
                ...state.objs,
                action.obj
            ]
        };
    } else throw `selected object reducer: theres no action for '${action.type}`;
}

});

parcelRegister("fFFhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $640a1c4bdbf6e0ac$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $640a1c4bdbf6e0ac$export$2e2bcd8739ae039(ref, callback, except = 'button') {
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (except && (Array.isArray(except) ? except : [
                except
            ]).filter((tag)=>event.target.closest(tag)).length) return;
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref,
        callback,
        except
    ]);
}

});

parcelRegister("eqsnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0599fb2b46db5df0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $5RIww = parcelRequire("5RIww");

var $30UGG = parcelRequire("30UGG");
function $0599fb2b46db5df0$export$2e2bcd8739ae039(props) {
    const { noSearch: noSearch, rows: rows = 20 } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0599fb2b46db5df0$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 2,
            children: [
                !noSearch && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 250,
                            animation: "wave"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 15,
                            animation: "wave"
                        })
                    ]
                }),
                [
                    ...Array(rows).keys()
                ].map((key)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                width: "100%",
                                animation: "wave"
                            })
                        ]
                    }, key))
            ]
        })
    });
}
const $0599fb2b46db5df0$var$Root = (0, $lmFrL.default).div`
  margin: 40px 10px 20px 10px;
`;

});
parcelRegister("5RIww", function(module, exports) {

$parcel$export(module.exports, "default", () => $445470756a9ff70a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");
var $18jQK = parcelRequire("18jQK");

var $8zogs = parcelRequire("8zogs");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $bWvDT = parcelRequire("bWvDT");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $445470756a9ff70a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bWvDT.getSkeletonUtilityClass), classes);
};
const $445470756a9ff70a$var$pulseKeyframe = (0, $8zogs.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $445470756a9ff70a$var$waveKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $445470756a9ff70a$var$pulseAnimation = typeof $445470756a9ff70a$var$pulseKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $445470756a9ff70a$var$waveAnimation = typeof $445470756a9ff70a$var$waveKeyframe !== 'string' ? (0, $8zogs.css)`
        &::after {
          animation: ${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $445470756a9ff70a$var$SkeletonRoot = (0, $d8seH.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const radiusUnit = (0, $18jQK.getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $18jQK.toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $445470756a9ff70a$var$pulseAnimation || {
                    animation: `${$445470756a9ff70a$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $445470756a9ff70a$var$waveAnimation || {
                    '&::after': {
                        animation: `${$445470756a9ff70a$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $445470756a9ff70a$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $445470756a9ff70a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($445470756a9ff70a$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $445470756a9ff70a$export$2e2bcd8739ae039 = $445470756a9ff70a$var$Skeleton;

});
parcelRegister("18jQK", function(module, exports) {

$parcel$export(module.exports, "getUnit", () => $0d35ef8a52a98e99$export$65f2564e9a9b9222);
$parcel$export(module.exports, "toUnitless", () => $0d35ef8a52a98e99$export$8af1d214c6c2f0f1);
function $0d35ef8a52a98e99$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $0d35ef8a52a98e99$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $0d35ef8a52a98e99$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(length) * $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $0d35ef8a52a98e99$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $0d35ef8a52a98e99$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("bWvDT", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", () => $8b1da808c4852549$export$c987db9fc844f86);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8b1da808c4852549$export$c987db9fc844f86(slot) {
    return (0, $4Cod0.default)('MuiSkeleton', slot);
}
const $8b1da808c4852549$var$skeletonClasses = (0, $beCSm.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $8b1da808c4852549$export$2e2bcd8739ae039 = $8b1da808c4852549$var$skeletonClasses;

});


parcelRegister("30UGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $231d58234d437bc0$export$2e2bcd8739ae039);


var $isyt6 = parcelRequire("isyt6");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $231d58234d437bc0$var$Stack = (0, $isyt6.default)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $231d58234d437bc0$export$2e2bcd8739ae039 = $231d58234d437bc0$var$Stack;

});
parcelRegister("isyt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70594339ba23534$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $umiYb = parcelRequire("umiYb");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $dxMBG = parcelRequire("dxMBG");

var $dFNG2 = parcelRequire("dFNG2");

var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $82aMg = parcelRequire("82aMg");

var $7kpn1 = parcelRequire("7kpn1");

var $ayMG0 = parcelRequire("ayMG0");
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $dxMBG.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $dFNG2.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $82aMg.handleBreakpoints)({
            theme: theme
        }, (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $7kpn1.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $7kpn1.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $7kpn1.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $82aMg.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $umiYb.default)(classes.root, className),
            ...other,
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});
parcelRegister("dxMBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dc40fba00dc8e3b$export$2e2bcd8739ae039);

var $dgmWB = parcelRequire("dgmWB");
const $9dc40fba00dc8e3b$var$styled = (0, $dgmWB.default)();
var $9dc40fba00dc8e3b$export$2e2bcd8739ae039 = $9dc40fba00dc8e3b$var$styled;

});

parcelRegister("dFNG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f45a3834bb6880f$export$2e2bcd8739ae039);

var $cfUWu = parcelRequire("cfUWu");

var $eM1DJ = parcelRequire("eM1DJ");
'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $eM1DJ.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $cfUWu.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("cfUWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec30e4d54713c84$export$2e2bcd8739ae039);

var $4FZD0 = parcelRequire("4FZD0");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}

});





parcelRegister("bnA1h", function(module, exports) {

$parcel$export(module.exports, "default", () => $848dc8709a4309c5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $5FMfE = parcelRequire("5FMfE");


var $1mPeS = parcelRequire("1mPeS");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $bmoVh = parcelRequire("bmoVh");

var $hweuE = parcelRequire("hweuE");

var $9Rgf1 = parcelRequire("9Rgf1");

var $38bi6 = parcelRequire("38bi6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $848dc8709a4309c5$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $38bi6.getCollapseUtilityClass), classes);
};
const $848dc8709a4309c5$var$CollapseRoot = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $848dc8709a4309c5$var$CollapseWrapper = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $848dc8709a4309c5$var$CollapseWrapperInner = (0, $d8seH.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $848dc8709a4309c5$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $bmoVh.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $848dc8709a4309c5$var$useUtilityClasses(ownerState);
    const theme = (0, $14H9o.default)();
    const timer = (0, $lHOu3.default)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $9Rgf1.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $hweuE.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseRoot, {
                as: component,
                className: (0, $5FMfE.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($848dc8709a4309c5$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($848dc8709a4309c5$var$Collapse) $848dc8709a4309c5$var$Collapse.muiSupportAuto = true;
var $848dc8709a4309c5$export$2e2bcd8739ae039 = $848dc8709a4309c5$var$Collapse;

});
parcelRegister("38bi6", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", () => $247ae09dccc3464c$export$5162da8f798e0959);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $247ae09dccc3464c$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $247ae09dccc3464c$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $247ae09dccc3464c$export$2e2bcd8739ae039 = $247ae09dccc3464c$var$collapseClasses;

});


parcelRegister("kfwWK", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ebdec3d621c029d6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ebdec3d621c029d6$var$_createSvgIcon = $ebdec3d621c029d6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ebdec3d621c029d6$var$_default = module.exports.default = (0, $ebdec3d621c029d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');

});

parcelRegister("ce4ic", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8e6a1f3d36d8c3d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e6a1f3d36d8c3d3$var$_createSvgIcon = $8e6a1f3d36d8c3d3$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8e6a1f3d36d8c3d3$var$_default = module.exports.default = (0, $8e6a1f3d36d8c3d3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');

});


parcelRegister("atFJM", function(module, exports) {

$parcel$export(module.exports, "url", () => $9f695a1f988544e0$export$128fa18b7194ef);
$parcel$export(module.exports, "dockerRegistry", () => $9f695a1f988544e0$export$e0e7625b7204d71e);
$parcel$export(module.exports, "register", () => $9f695a1f988544e0$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "build", () => $9f695a1f988544e0$export$3f8fe6489e95757d);
$parcel$export(module.exports, "registerAndBuild", () => $9f695a1f988544e0$export$3f2376c93350e968);
$parcel$export(module.exports, "deleteApp", () => $9f695a1f988544e0$export$6eec44aa53d5ea34);
$parcel$export(module.exports, "deleteRepo", () => $9f695a1f988544e0$export$ec1980c26286a539);
$parcel$export(module.exports, "makePublic", () => $9f695a1f988544e0$export$843b85bda9c220b0);
$parcel$export(module.exports, "share", () => $9f695a1f988544e0$export$ed80d9de1d9df928);
$parcel$export(module.exports, "listPermissions", () => $9f695a1f988544e0$export$bb2d8296b1de762);
$parcel$export(module.exports, "listApps", () => $9f695a1f988544e0$export$b6f278abb5a40afd);
$parcel$export(module.exports, "getBuildStatus", () => $9f695a1f988544e0$export$e88a4352aaf4f862);
$parcel$export(module.exports, "getRepo", () => $9f695a1f988544e0$export$971b7948bfdfe11b);
$parcel$export(module.exports, "getAppConfig", () => $9f695a1f988544e0$export$544aaded68bb6ae2);
$parcel$export(module.exports, "getSciMarkdown", () => $9f695a1f988544e0$export$6d229f6d4ed909d4);
$parcel$export(module.exports, "repoIsPublic", () => $9f695a1f988544e0$export$719dca200164a365);

var $gZwVy = parcelRequire("gZwVy");

var $5g1Ik = parcelRequire("5g1Ik");

var $c3pId = parcelRequire("c3pId");
const $9f695a1f988544e0$export$128fa18b7194ef = (0, $gZwVy.default).ecr;
const $9f695a1f988544e0$export$e0e7625b7204d71e = (0, $gZwVy.default).dockerRegistry;
const $9f695a1f988544e0$var$__token = (0, $c3pId.default).token;
const $9f695a1f988544e0$var$options = {
    headers: $9f695a1f988544e0$var$__token ? {
        Authorization: `sage ${$9f695a1f988544e0$var$__token}`
    } : {}
};
function $9f695a1f988544e0$var$get(endpoint) {
    return fetch(endpoint, $9f695a1f988544e0$var$options).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
function $9f695a1f988544e0$var$post(endpoint, data = '') {
    return fetch(endpoint, {
        method: 'POST',
        body: data,
        ...$9f695a1f988544e0$var$options
    }).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
function $9f695a1f988544e0$var$put(endpoint, data = {}) {
    return fetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(data),
        ...$9f695a1f988544e0$var$options
    }).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
function $9f695a1f988544e0$var$deleteReq(endpoint) {
    return fetch(endpoint, {
        method: 'DELETE',
        ...$9f695a1f988544e0$var$options
    }).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
function $9f695a1f988544e0$export$6503ec6e8aabbaf(appConfig) {
    return $9f695a1f988544e0$var$post(`${$9f695a1f988544e0$export$128fa18b7194ef}/submit`, appConfig);
}
function $9f695a1f988544e0$export$3f8fe6489e95757d(app, skipPush = false) {
    const { namespace: namespace, name: name, version: version } = app;
    return $9f695a1f988544e0$var$post(`${$9f695a1f988544e0$export$128fa18b7194ef}/builds/${namespace}/${name}/${version}${skipPush ? `?skip_image_push=true` : ''}`);
}
async function $9f695a1f988544e0$export$3f2376c93350e968(appConfig) {
    // note registerRes will contain the version generated by server if one was not provided
    const registerRes = await $9f695a1f988544e0$export$6503ec6e8aabbaf(appConfig);
    const buildRes = await $9f695a1f988544e0$export$3f8fe6489e95757d(registerRes);
    return buildRes;
}
async function $9f695a1f988544e0$export$6eec44aa53d5ea34(app) {
    const { namespace: namespace, name: name, version: version } = app;
    const res = await $9f695a1f988544e0$var$deleteReq(`${$9f695a1f988544e0$export$128fa18b7194ef}/apps/${namespace}/${name}/${version}`);
    return res;
}
async function $9f695a1f988544e0$export$ec1980c26286a539(repo) {
    const { namespace: namespace, name: name } = repo;
    // first, delete all versions
    const versions = await $9f695a1f988544e0$export$582aade0e1097ca3(repo);
    const proms = versions.map(({ version: version })=>$9f695a1f988544e0$export$6eec44aa53d5ea34({
            namespace: namespace,
            name: name,
            version: version
        }));
    // delete repo
    const res = Promise.all(proms).then(()=>$9f695a1f988544e0$var$deleteReq(`${$9f695a1f988544e0$export$128fa18b7194ef}/repositories/${namespace}/${name}`));
    return res;
}
function $9f695a1f988544e0$export$843b85bda9c220b0(repo, operation = 'add') {
    const { namespace: namespace, name: name } = repo;
    return $9f695a1f988544e0$var$put(`${$9f695a1f988544e0$export$128fa18b7194ef}/permissions/${namespace}/${name}`, {
        operation: operation,
        granteeType: 'GROUP',
        grantee: 'AllUsers',
        permission: 'READ'
    });
}
function $9f695a1f988544e0$export$ed80d9de1d9df928(repo, grantee, permission, operation = 'add') {
    const { namespace: namespace, name: name } = repo;
    return $9f695a1f988544e0$var$put(`${$9f695a1f988544e0$export$128fa18b7194ef}/permissions/${namespace}/${name}`, {
        operation: operation,
        granteeType: 'USER',
        grantee: grantee,
        permission: permission
    });
}
function $9f695a1f988544e0$export$bb2d8296b1de762(repo) {
    const { namespace: namespace, name: name } = repo;
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/permissions/${namespace}/${name}`);
}
function $9f695a1f988544e0$export$64f28126552508c0() {
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/apps`).then((data)=>data.data);
}
function $9f695a1f988544e0$export$582aade0e1097ca3(repo) {
    const { namespace: namespace, name: name } = repo;
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/apps/${namespace}/${name}`).then((data)=>data.data).then((d)=>d.sort($9f695a1f988544e0$var$timeCompare));
}
async function $9f695a1f988544e0$export$b6f278abb5a40afd(filter) {
    const repoFilters = [
        $9f695a1f988544e0$var$__token ? `view=permissions` : '',
        filter == 'mine' ? `nopublic=true` : ''
    ];
    const appFilters = [
        filter == 'public' ? 'public=true' : '',
        filter == 'mine' ? 'nopublic=true' : ''
    ];
    const repoPerm = $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/repositories?${repoFilters.join('&')}`);
    const appProm = $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/apps?${appFilters.join('&')}`);
    return Promise.all([
        repoPerm,
        appProm
    ]).then(([repoRes, appRes])=>{
        const repos = repoRes.data;
        // create lookup; todo?: could do merging on repos instead
        const repoMap = repos.reduce((acc, r)=>`${r.namepsace}/${r.name}` in acc ? acc : {
                ...acc,
                [`${r.namespace}/${r.name}`]: r
            }, {});
        // sort by last updated
        const allApps = appRes.data.sort($9f695a1f988544e0$var$timeCompare);
        // reduce to last updated (and get versions)
        const versions = {};
        let apps = allApps.reduce((acc, app)=>{
            const [repo, ver] = app.id.split(':');
            if (repo in versions) {
                versions[repo].push(ver);
                return acc;
            } else {
                versions[repo] = [
                    ver
                ];
                return [
                    ...acc,
                    app
                ];
            }
        }, []);
        // ignore any apps not in repoMap, and merge in additional data
        apps = apps.filter((app)=>app.id.split(':')[0] in repoMap).map((app)=>{
            const repo = app.id.split(':')[0];
            const { permissions: permissions = [] } = repoMap[repo];
            const isPublic = !!permissions.find((p)=>p.resourceType != 'namespace' && p.grantee === 'AllUsers');
            return {
                ...app,
                versions: versions[repo],
                permissions: permissions,
                isPublic: isPublic,
                isShared: false
            };
        });
        return apps;
    });
}
function $9f695a1f988544e0$export$e88a4352aaf4f862(app) {
    const { namespace: namespace, name: name, version: version } = app;
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/builds/${namespace}/${name}/${version}`);
}
function $9f695a1f988544e0$export$b5763354bd45a8f8(apps) {
    const proms = apps.map((app)=>$9f695a1f988544e0$export$e88a4352aaf4f862(app));
    return Promise.all(proms);
}
function $9f695a1f988544e0$export$971b7948bfdfe11b(repo) {
    const { namespace: namespace, name: name } = repo;
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/repositories/${namespace}/${name}`).then((data)=>{
        return {
            ...data,
            versions: data.versions.sort($9f695a1f988544e0$var$timeCompare)
        };
    });
}
function $9f695a1f988544e0$export$544aaded68bb6ae2(app) {
    // todo(wg): add `view=app` for repos(?)
    const { namespace: namespace, name: name, version: version } = app;
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/apps/${namespace}/${name}/${version}?view=app`);
}
function $9f695a1f988544e0$export$698a633fa7078071(app) {
    const { namespace: namespace, name: name, version: version } = app;
    return $9f695a1f988544e0$var$get(`${$9f695a1f988544e0$export$128fa18b7194ef}/apps/${namespace}/${name}/${version}`);
}
function $9f695a1f988544e0$export$6d229f6d4ed909d4(path) {
    return fetch(`${$9f695a1f988544e0$export$128fa18b7194ef}/meta-files/${path}`, $9f695a1f988544e0$var$options).then((0, $5g1Ik.handleErrors)).then((res)=>res.text());
}
function $9f695a1f988544e0$export$7a70c7ad4defaa5b(permissions) {
    return (permissions || []).filter((p)=>p.grantee === 'AllUsers').length > 0;
}
const $9f695a1f988544e0$var$timeCompare = (a, b)=>b.time_last_updated.localeCompare(a.time_last_updated);
const $9f695a1f988544e0$export$719dca200164a365 = (publicApps, name)=>publicApps.find((o)=>o.id.includes(name));

});
parcelRegister("5g1Ik", function(module, exports) {

$parcel$export(module.exports, "handleErrors", () => $40bbca62b158740c$export$1e36de371b2e3d5a);
$parcel$export(module.exports, "handleDjangoErrors", () => $40bbca62b158740c$export$e8c85ef7482ce0b8);
// other art: https://developers.google.com/web/updates/2017/09/abortable-fetch
function $40bbca62b158740c$export$d449336209e34573(request, opts) {
    const controller = new AbortController();
    const signal = controller.signal;
    return {
        abort: ()=>controller.abort(),
        ready: fetch(request, {
            ...opts,
            signal: signal
        })
    };
}
function $40bbca62b158740c$export$1e36de371b2e3d5a(res) {
    if (res.ok) return res;
    return res.json().then((errorObj)=>{
        throw Error(errorObj.error);
    });
}
function $40bbca62b158740c$export$e8c85ef7482ce0b8(res) {
    if (res.ok) return res;
    return res.json().then((errorObj)=>{
        throw Error(errorObj.detail);
    });
}

});


parcelRegister("gTmRg", function(module, exports) {

$parcel$export(module.exports, "Item", () => $189e374cf87277a5$export$6d08773d2e66f8f2);
$parcel$export(module.exports, "Title", () => $189e374cf87277a5$export$f99233281efd08a0);
$parcel$export(module.exports, "Top", () => $189e374cf87277a5$export$b5738e83c092973d);
$parcel$export(module.exports, "Controls", () => $189e374cf87277a5$export$c7c44baae9d9f25f);
$parcel$export(module.exports, "Divider", () => $189e374cf87277a5$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "Sidebar", () => $189e374cf87277a5$export$1ba59dacbcbf90fe);
$parcel$export(module.exports, "FilterTitle", () => $189e374cf87277a5$export$c86c334a40b43b7c);
$parcel$export(module.exports, "CardViewStyle", () => $189e374cf87277a5$export$4b07cbf98272abff);
$parcel$export(module.exports, "Card", () => $189e374cf87277a5$export$60332b2344f7fe41);

var $ayMG0 = parcelRequire("ayMG0");

var $5WjaY = parcelRequire("5WjaY");
var $ldx2z = parcelRequire("ldx2z");
var $d8seH = parcelRequire("d8seH");

var $lkxXU = parcelRequire("lkxXU");
const $189e374cf87277a5$export$6d08773d2e66f8f2 = (0, $d8seH.default)((0, $5WjaY.default))`
  position: relative;
  margin: 20px 1px; // 1px left/right for sticky header
  padding: 10px 15px;

  :hover {
    text-decoration: none;
    border: 1px solid ${(props)=>props.theme.palette.primary.main};
  }

  .actions {
    position: absolute;
    display: none;
    bottom: .5rem;
    right: .6rem;
  }

  :hover .actions {
    display: block;
  }
`;
const $189e374cf87277a5$export$f99233281efd08a0 = (0, $d8seH.default)('h2')`
  margin: 0;
`;
const $189e374cf87277a5$export$b5738e83c092973d = (0, $d8seH.default)('div')`
  position: sticky;
  top: ${(props)=>props.top || '60px'};
  z-index: 100;
`;
const $189e374cf87277a5$export$c7c44baae9d9f25f = (0, $d8seH.default)('div')`
  background-color: ${(props)=>props.theme.palette.background.paper};
  padding: 10px 0;
  border-bottom: 1px solid ${(props)=>props.theme.palette.divider};

  .checkboxes {
    margin-top: 17px;
  }
`;
const $189e374cf87277a5$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
        orientation: "vertical",
        flexItem: true,
        style: {
            margin: '0px 20px'
        }
    });
const $189e374cf87277a5$export$1ba59dacbcbf90fe = (0, $d8seH.default)('div')`
  position: sticky;
  top: 60px;
  height: calc(100vh);
  padding-top: 10px;
  width: ${(props)=>props.width || '250px'};
  min-width: ${(props)=>props.width || '250px'};
  border-right: 1px solid ${(props)=>props.theme.palette.divider};
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f8f8'};
  overflow-y: scroll;
`;
const $189e374cf87277a5$export$c86c334a40b43b7c = (0, $d8seH.default)('h2')`
  margin-left: 20px;
`;
const $189e374cf87277a5$export$4b07cbf98272abff = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ldx2z.default), {
    styles: (theme)=>({
            body: {
                // todo(nc): configure secondary light/dark mode background colors
                background: theme.palette.mode === 'dark' ? 'rgb(30, 30, 30)' : 'rgb(231, 235, 240)'
            }
        })
});
const $189e374cf87277a5$export$60332b2344f7fe41 = (props)=>{
    const { children: children, noPad: noPad, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WjaY.default), {
        sx: {
            padding: noPad ? 0 : '16px 16px 20px 16px'
        },
        ...rest,
        children: children
    });
};

});
parcelRegister("5WjaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $45313e7d506ce734$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $7Frhn = parcelRequire("7Frhn");

var $bOBRq = parcelRequire("bOBRq");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45313e7d506ce734$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bOBRq.getCardUtilityClass), classes);
};
const $45313e7d506ce734$var$CardRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    overflow: 'hidden'
});
const $45313e7d506ce734$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $45313e7d506ce734$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($45313e7d506ce734$var$CardRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $45313e7d506ce734$export$2e2bcd8739ae039 = $45313e7d506ce734$var$Card;

});
parcelRegister("bOBRq", function(module, exports) {

$parcel$export(module.exports, "getCardUtilityClass", () => $89a1bb9709695920$export$f3b76d2cce458caa);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $89a1bb9709695920$export$f3b76d2cce458caa(slot) {
    return (0, $4Cod0.default)('MuiCard', slot);
}
const $89a1bb9709695920$var$cardClasses = (0, $beCSm.default)('MuiCard', [
    'root'
]);
var $89a1bb9709695920$export$2e2bcd8739ae039 = $89a1bb9709695920$var$cardClasses;

});



parcelRegister("bFBmv", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $87f08158dd1faa53$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87f08158dd1faa53$var$_createSvgIcon = $87f08158dd1faa53$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $87f08158dd1faa53$var$_default = module.exports.default = (0, $87f08158dd1faa53$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1M14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V3h-6c-.55 0-1 .45-1 1"
}), 'LaunchRounded');

});

parcelRegister("ifEev", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ef89944b6fdb8a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");

var $6MV2p = parcelRequire("6MV2p");

var $2MUlQ = parcelRequire("2MUlQ");

var $6Q1H5 = parcelRequire("6Q1H5");

var $eFqab = parcelRequire("eFqab");

var $ejcfT = parcelRequire("ejcfT");

var $dqlTG = parcelRequire("dqlTG");
function $85ef89944b6fdb8a$export$2e2bcd8739ae039(props) {
    const { title: title = 'Are you sure you want to do that?', contentTitle: contentTitle, content: content, loadingText: loadingText = 'loading...', confirmBtnText: confirmBtnText = 'OK', confirmBtnStyle: confirmBtnStyle = {}, fullScreen: fullScreen, cancelBtn: cancelBtn, onClose: onClose, onConfirm: onConfirm, ...rest } = props;
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const handleSubmit = (evt)=>{
        evt.preventDefault();
        setLoading(true);
        const res = onConfirm();
        if (res instanceof Promise) res.then(()=>{
            setLoading(false);
            onClose();
        });
        else {
            onConfirm();
            setLoading(false);
            onClose();
        }
    };
    const handleClose = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6MV2p.default), {
        open: true,
        onClose: handleClose,
        "aria-labelledby": "dialog-title",
        fullScreen: fullScreen,
        style: fullScreen ? {
            marginTop: 60
        } : {},
        ...rest,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ejcfT.default), {
                id: "dialog-title",
                children: [
                    title,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {
                        "aria-label": "close",
                        onClick: handleClose,
                        sx: {
                            position: 'absolute',
                            right: 20,
                            top: 20,
                            color: (theme)=>theme.palette.grey[500]
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dqlTG))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6Q1H5.default), {
                children: [
                    contentTitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFqab.default), {
                        children: contentTitle
                    }),
                    content
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2MUlQ.default), {
                sx: {
                    borderTop: '1px solid #f2f2f2'
                },
                children: [
                    cancelBtn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleClose,
                        color: "primary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        type: "submit",
                        color: "primary",
                        variant: "contained",
                        disabled: loading,
                        style: !loading ? confirmBtnStyle : {},
                        onClick: handleSubmit,
                        children: loading && loadingText ? loadingText : confirmBtnText
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("6MV2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f13784bd714c44e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $jTnBY = parcelRequire("jTnBY");

var $118QM = parcelRequire("118QM");

var $86f4a = parcelRequire("86f4a");

var $7Frhn = parcelRequire("7Frhn");

var $gX5bM = parcelRequire("gX5bM");

var $8W68d = parcelRequire("8W68d");

var $6cr7d = parcelRequire("6cr7d");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4f13784bd714c44e$var$DialogBackdrop = (0, $d8seH.default)((0, $6cr7d.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $4f13784bd714c44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $jTnBY.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $jTnBY.default)(scroll)}`,
            `paperWidth${(0, $jTnBY.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $gX5bM.getDialogUtilityClass), classes);
};
const $4f13784bd714c44e$var$DialogRoot = (0, $d8seH.default)((0, $118QM.default), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $4f13784bd714c44e$var$DialogContainer = (0, $d8seH.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $jTnBY.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $4f13784bd714c44e$var$DialogPaper = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $jTnBY.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $gX5bM.default).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $4f13784bd714c44e$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $14H9o.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $7Frhn.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $86f4a.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $4f13784bd714c44e$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $auC0X.default)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        elementType: $4f13784bd714c44e$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $6lpak.default)('backdrop', {
        elementType: $4f13784bd714c44e$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $6lpak.default)('paper', {
        elementType: $4f13784bd714c44e$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $6lpak.default)('container', {
        elementType: $4f13784bd714c44e$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.container)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $86f4a.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8W68d.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $4f13784bd714c44e$export$2e2bcd8739ae039 = $4f13784bd714c44e$var$Dialog;

});
parcelRegister("gX5bM", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", () => $c5762e789acf7dcc$export$2177af0aa15c34c2);
$parcel$export(module.exports, "default", () => $c5762e789acf7dcc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c5762e789acf7dcc$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $c5762e789acf7dcc$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $c5762e789acf7dcc$export$2e2bcd8739ae039 = $c5762e789acf7dcc$var$dialogClasses;

});

parcelRegister("8W68d", function(module, exports) {

$parcel$export(module.exports, "default", () => $68187f174395cd28$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $68187f174395cd28$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $68187f174395cd28$export$2e2bcd8739ae039 = $68187f174395cd28$var$DialogContext;

});


parcelRegister("2MUlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $207bc6ab7c60f4b2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $4ZLz5 = parcelRequire("4ZLz5");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $207bc6ab7c60f4b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4ZLz5.getDialogActionsUtilityClass), classes);
};
const $207bc6ab7c60f4b2$var$DialogActionsRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $207bc6ab7c60f4b2$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $207bc6ab7c60f4b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($207bc6ab7c60f4b2$var$DialogActionsRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $207bc6ab7c60f4b2$export$2e2bcd8739ae039 = $207bc6ab7c60f4b2$var$DialogActions;

});
parcelRegister("4ZLz5", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", () => $3a31c1516a2c01e5$export$5e57a444791c63be);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $3a31c1516a2c01e5$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $3a31c1516a2c01e5$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3a31c1516a2c01e5$export$2e2bcd8739ae039 = $3a31c1516a2c01e5$var$dialogActionsClasses;

});


parcelRegister("6Q1H5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa8e9c420cdee0a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $hd5xz = parcelRequire("hd5xz");

var $kQXVi = parcelRequire("kQXVi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4fa8e9c420cdee0a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hd5xz.getDialogContentUtilityClass), classes);
};
const $4fa8e9c420cdee0a$var$DialogContentRoot = (0, $d8seH.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $kQXVi.default).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $4fa8e9c420cdee0a$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $4fa8e9c420cdee0a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fa8e9c420cdee0a$var$DialogContentRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $4fa8e9c420cdee0a$export$2e2bcd8739ae039 = $4fa8e9c420cdee0a$var$DialogContent;

});
parcelRegister("hd5xz", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", () => $c877f2cebcabf5cb$export$61b0ee1f05fb344e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c877f2cebcabf5cb$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $c877f2cebcabf5cb$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $c877f2cebcabf5cb$export$2e2bcd8739ae039 = $c877f2cebcabf5cb$var$dialogContentClasses;

});

parcelRegister("kQXVi", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", () => $f2e7257b2514744a$export$f5d2ec7e4c47e088);
$parcel$export(module.exports, "default", () => $f2e7257b2514744a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2e7257b2514744a$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $f2e7257b2514744a$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $f2e7257b2514744a$export$2e2bcd8739ae039 = $f2e7257b2514744a$var$dialogTitleClasses;

});


parcelRegister("eFqab", function(module, exports) {

$parcel$export(module.exports, "default", () => $aad93085434ac13f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $8ANtp = parcelRequire("8ANtp");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $aad93085434ac13f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $8ANtp.getDialogContentTextUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $aad93085434ac13f$var$DialogContentTextRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $aad93085434ac13f$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $aad93085434ac13f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($aad93085434ac13f$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $aad93085434ac13f$export$2e2bcd8739ae039 = $aad93085434ac13f$var$DialogContentText;

});
parcelRegister("8ANtp", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", () => $64180fe1152829a7$export$d9c6dc45f75b0e4f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64180fe1152829a7$export$d9c6dc45f75b0e4f(slot) {
    return (0, $4Cod0.default)('MuiDialogContentText', slot);
}
const $64180fe1152829a7$var$dialogContentTextClasses = (0, $beCSm.default)('MuiDialogContentText', [
    'root'
]);
var $64180fe1152829a7$export$2e2bcd8739ae039 = $64180fe1152829a7$var$dialogContentTextClasses;

});


parcelRegister("ejcfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6ac58aca374c76c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $3bYfT = parcelRequire("3bYfT");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $kQXVi = parcelRequire("kQXVi");

var $8W68d = parcelRequire("8W68d");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a6ac58aca374c76c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kQXVi.getDialogTitleUtilityClass), classes);
};
const $a6ac58aca374c76c$var$DialogTitleRoot = (0, $d8seH.default)((0, $3bYfT.default), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $a6ac58aca374c76c$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $a6ac58aca374c76c$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $8W68d.default));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a6ac58aca374c76c$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $a6ac58aca374c76c$export$2e2bcd8739ae039 = $a6ac58aca374c76c$var$DialogTitle;

});

parcelRegister("dqlTG", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9c5eb05f9740712a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c5eb05f9740712a$var$_createSvgIcon = $9c5eb05f9740712a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9c5eb05f9740712a$var$_default = module.exports.default = (0, $9c5eb05f9740712a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});


parcelRegister("bgK54", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8344ef041f969637$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8344ef041f969637$var$_createSvgIcon = $8344ef041f969637$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8344ef041f969637$var$_default = module.exports.default = (0, $8344ef041f969637$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2zM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1m6.5-5-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
}), 'DeleteOutlineRounded');

});

parcelRegister("24m81", function(module, exports) {

$parcel$export(module.exports, "SnackbarProvider", () => $181d1eb4be72417a$export$d1e619fddc3508ce);
$parcel$export(module.exports, "useSnackbar", () => $181d1eb4be72417a$export$1c97ac2c9a6e7c09);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $1SA7b = parcelRequire("1SA7b");

var $dwyUi = parcelRequire("dwyUi");

var $830hp = parcelRequire("830hp");
var $9GbWv = parcelRequire("9GbWv");
var $8WyyQ = parcelRequire("8WyyQ");
var $kQaj4 = parcelRequire("kQaj4");

var $i1h3S = parcelRequire("i1h3S");

var $8DzwJ = parcelRequire("8DzwJ");

var $bH9Sz = parcelRequire("bH9Sz");

var $9ORqK = parcelRequire("9ORqK");
function $181d1eb4be72417a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $181d1eb4be72417a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $181d1eb4be72417a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $181d1eb4be72417a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $181d1eb4be72417a$var$_extends() {
    $181d1eb4be72417a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $181d1eb4be72417a$var$_extends.apply(this, arguments);
}
function $181d1eb4be72417a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $181d1eb4be72417a$var$SnackbarContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext();
var $181d1eb4be72417a$var$allClasses = {
    mui: {
        root: {},
        anchorOriginTopCenter: {},
        anchorOriginBottomCenter: {},
        anchorOriginTopRight: {},
        anchorOriginBottomRight: {},
        anchorOriginTopLeft: {},
        anchorOriginBottomLeft: {}
    },
    container: {
        containerRoot: {},
        containerAnchorOriginTopCenter: {},
        containerAnchorOriginBottomCenter: {},
        containerAnchorOriginTopRight: {},
        containerAnchorOriginBottomRight: {},
        containerAnchorOriginTopLeft: {},
        containerAnchorOriginBottomLeft: {}
    }
};
var $181d1eb4be72417a$var$MESSAGES = {
    NO_PERSIST_ALL: 'WARNING - notistack: Reached maxSnack while all enqueued snackbars have \'persist\' flag. Notistack will dismiss the oldest snackbar anyway to allow other ones in the queue to be presented.'
};
var $181d1eb4be72417a$var$SNACKBAR_INDENTS = {
    view: {
        "default": 20,
        dense: 4
    },
    snackbar: {
        "default": 6,
        dense: 2
    }
};
var $181d1eb4be72417a$var$DEFAULTS = {
    maxSnack: 3,
    dense: false,
    hideIconVariant: false,
    variant: 'default',
    autoHideDuration: 5000,
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    TransitionComponent: (0, $dwyUi.default),
    transitionDuration: {
        enter: 225,
        exit: 195
    }
};
var $181d1eb4be72417a$var$capitalise = function capitalise(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
var $181d1eb4be72417a$var$originKeyExtractor = function originKeyExtractor(anchor) {
    return "" + $181d1eb4be72417a$var$capitalise(anchor.vertical) + $181d1eb4be72417a$var$capitalise(anchor.horizontal);
};
/**
 * Omit SnackbarContainer class keys that are not needed for SnackbarItem
 */ var $181d1eb4be72417a$var$omitContainerKeys = function omitContainerKeys(classes) {
    return Object.keys(classes).filter(function(key) {
        return !$181d1eb4be72417a$var$allClasses.container[key];
    }).reduce(function(obj, key) {
        var _extends2;
        return $181d1eb4be72417a$var$_extends({}, obj, (_extends2 = {}, _extends2[key] = classes[key], _extends2));
    }, {});
};
var $181d1eb4be72417a$var$REASONS = {
    TIMEOUT: 'timeout',
    CLICKAWAY: 'clickaway',
    MAXSNACK: 'maxsnack',
    INSTRUCTED: 'instructed'
};
/** Tranforms classes name */ var $181d1eb4be72417a$var$transformer = {
    toContainerAnchorOrigin: function toContainerAnchorOrigin(origin) {
        return "containerAnchorOrigin" + origin;
    },
    toAnchorOrigin: function toAnchorOrigin(_ref) {
        var vertical = _ref.vertical, horizontal = _ref.horizontal;
        return "anchorOrigin" + $181d1eb4be72417a$var$capitalise(vertical) + $181d1eb4be72417a$var$capitalise(horizontal);
    },
    toVariant: function toVariant(variant) {
        return "variant" + $181d1eb4be72417a$var$capitalise(variant);
    }
};
var $181d1eb4be72417a$var$isDefined = function isDefined(value) {
    return !!value || value === 0;
};
var $181d1eb4be72417a$var$numberOrNull = function numberOrNull(numberish) {
    return typeof numberish === 'number' || numberish === null;
}; // @ts-ignore
var $181d1eb4be72417a$var$merge = function merge(options, props, defaults) {
    return function(name) {
        if (name === 'autoHideDuration') {
            if ($181d1eb4be72417a$var$numberOrNull(options.autoHideDuration)) return options.autoHideDuration;
            if ($181d1eb4be72417a$var$numberOrNull(props.autoHideDuration)) return props.autoHideDuration;
            return $181d1eb4be72417a$var$DEFAULTS.autoHideDuration;
        }
        return options[name] || props[name] || defaults[name];
    };
};
function $181d1eb4be72417a$var$objectMerge(options, props, defaults) {
    if (options === void 0) options = {};
    if (props === void 0) props = {};
    if (defaults === void 0) defaults = {};
    return $181d1eb4be72417a$var$_extends({}, defaults, {}, props, {}, options);
}
var $181d1eb4be72417a$var$styles = function styles(theme) {
    var _root;
    return (0, $830hp.default)({
        root: (_root = {
            display: 'flex',
            flexWrap: 'wrap',
            flexGrow: 1
        }, _root[theme.breakpoints.up('sm')] = {
            flexGrow: 'initial',
            minWidth: 288
        }, _root)
    });
};
var $181d1eb4be72417a$var$SnackbarContent = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var classes = _ref.classes, className = _ref.className, props = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(_ref, [
        "classes",
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: ref,
        className: (0, $1SA7b.default)(classes.root, className)
    }, props));
});
var $181d1eb4be72417a$export$860cef82710cac7 = /*#__PURE__*/ (0, $kQaj4.default)($181d1eb4be72417a$var$styles)($181d1eb4be72417a$var$SnackbarContent);
var $181d1eb4be72417a$var$DIRECTION = {
    right: 'left',
    left: 'right',
    bottom: 'up',
    top: 'down'
};
var $181d1eb4be72417a$var$getTransitionDirection = function getTransitionDirection(anchorOrigin) {
    if (anchorOrigin.horizontal !== 'center') return $181d1eb4be72417a$var$DIRECTION[anchorOrigin.horizontal];
    return $181d1eb4be72417a$var$DIRECTION[anchorOrigin.vertical];
};
var $181d1eb4be72417a$var$CheckIcon = function CheckIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8DzwJ.default), Object.assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41\n        10.59L10 14.17L17.59 6.58L19 8L10 17Z"
    }));
};
var $181d1eb4be72417a$var$WarningIcon = function WarningIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8DzwJ.default), Object.assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"
    }));
};
var $181d1eb4be72417a$var$ErrorIcon = function ErrorIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8DzwJ.default), Object.assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,\n        6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,\n        13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
    }));
};
var $181d1eb4be72417a$var$InfoIcon = function InfoIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8DzwJ.default), Object.assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,\n        0 22,12A10,10 0 0,0 12,2Z"
    }));
};
var $181d1eb4be72417a$var$iconStyles = {
    fontSize: 20,
    marginInlineEnd: 8
};
var $181d1eb4be72417a$var$defaultIconVariants = {
    "default": undefined,
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$CheckIcon, {
        style: $181d1eb4be72417a$var$iconStyles
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$WarningIcon, {
        style: $181d1eb4be72417a$var$iconStyles
    }),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$ErrorIcon, {
        style: $181d1eb4be72417a$var$iconStyles
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$InfoIcon, {
        style: $181d1eb4be72417a$var$iconStyles
    })
};
/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/createChainedFunction.js
 */ function $181d1eb4be72417a$var$createChainedFunction(funcs, extraArg) {
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var argums = [].concat(args);
            if (extraArg && argums.indexOf(extraArg) === -1) argums.push(extraArg);
            acc.apply(this, argums);
            func.apply(this, argums);
        };
    }, function() {});
}
/**
 * @link https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/useEventCallback.js
 */ var $181d1eb4be72417a$var$useEnhancedEffect = typeof window !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $181d1eb4be72417a$var$useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn);
    $181d1eb4be72417a$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        return ref.current.apply(void 0, arguments);
    }, []);
}
var $181d1eb4be72417a$var$Snackbar = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var children = props.children, autoHideDuration = props.autoHideDuration, ClickAwayListenerProps = props.ClickAwayListenerProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, onClose = props.onClose, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, other = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(props, [
        "children",
        "autoHideDuration",
        "ClickAwayListenerProps",
        "disableWindowBlurListener",
        "onClose",
        "onMouseEnter",
        "onMouseLeave",
        "open",
        "resumeHideDuration"
    ]);
    var timerAutoHide = (0, $acw62.useRef)();
    var handleClose = $181d1eb4be72417a$var$useEventCallback(function() {
        if (onClose) onClose.apply(void 0, arguments);
    });
    var setAutoHideTimer = $181d1eb4be72417a$var$useEventCallback(function(autoHideDurationParam) {
        if (!onClose || autoHideDurationParam == null) return;
        clearTimeout(timerAutoHide.current);
        timerAutoHide.current = setTimeout(function() {
            handleClose(null, $181d1eb4be72417a$var$REASONS.TIMEOUT);
        }, autoHideDurationParam);
    });
    (0, $acw62.useEffect)(function() {
        if (open) setAutoHideTimer(autoHideDuration);
        return function() {
            clearTimeout(timerAutoHide.current);
        };
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer
    ]);
    /**
   * Pause the timer when the user is interacting with the Snackbar
   * or when the user hide the window.
   */ var handlePause = function handlePause() {
        clearTimeout(timerAutoHide.current);
    };
    /**
   * Restart the timer when the user is no longer interacting with the Snackbar
   * or when the window is shown back.
   */ var handleResume = (0, $acw62.useCallback)(function() {
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    var handleMouseEnter = function handleMouseEnter(event) {
        if (onMouseEnter) onMouseEnter(event);
        handlePause();
    };
    var handleMouseLeave = function handleMouseLeave(event) {
        if (onMouseLeave) onMouseLeave(event);
        handleResume();
    };
    var handleClickAway = function handleClickAway(event) {
        if (onClose) onClose(event, $181d1eb4be72417a$var$REASONS.CLICKAWAY);
    };
    (0, $acw62.useEffect)(function() {
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return function() {
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        handleResume,
        open
    ]);
    return (0, $acw62.createElement)((0, $bH9Sz.default), $181d1eb4be72417a$var$_extends({
        onClickAway: handleClickAway
    }, ClickAwayListenerProps), (0, $acw62.createElement)("div", $181d1eb4be72417a$var$_extends({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }, other), children));
});
var $181d1eb4be72417a$var$styles$1 = function styles(theme) {
    // @ts-ignore
    var mode = theme.palette.mode || theme.palette.type;
    var backgroundColor = (0, $9GbWv.emphasize)(theme.palette.background["default"], mode === 'light' ? 0.8 : 0.98);
    return (0, $830hp.default)($181d1eb4be72417a$var$_extends({}, $181d1eb4be72417a$var$allClasses.mui, {
        contentRoot: $181d1eb4be72417a$var$_extends({}, theme.typography.body2, {
            backgroundColor: backgroundColor,
            color: theme.palette.getContrastText(backgroundColor),
            alignItems: 'center',
            padding: '6px 16px',
            borderRadius: '4px',
            boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)'
        }),
        lessPadding: {
            paddingLeft: 20
        },
        variantSuccess: {
            backgroundColor: '#43a047',
            color: '#fff'
        },
        variantError: {
            backgroundColor: '#d32f2f',
            color: '#fff'
        },
        variantInfo: {
            backgroundColor: '#2196f3',
            color: '#fff'
        },
        variantWarning: {
            backgroundColor: '#ff9800',
            color: '#fff'
        },
        message: {
            display: 'flex',
            alignItems: 'center',
            padding: '8px 0'
        },
        action: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 16,
            marginRight: -8
        },
        wrappedRoot: {
            position: 'relative',
            transform: 'translateX(0)',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    }));
};
var $181d1eb4be72417a$var$SnackbarItem = function SnackbarItem(_ref) {
    var classes = _ref.classes, props = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(_ref, [
        "classes"
    ]);
    var timeout = (0, $acw62.useRef)();
    var _useState = (0, $acw62.useState)(true), collapsed = _useState[0], setCollapsed = _useState[1];
    (0, $acw62.useEffect)(function() {
        return function() {
            if (timeout.current) clearTimeout(timeout.current);
        };
    }, []);
    var handleClose = $181d1eb4be72417a$var$createChainedFunction([
        props.snack.onClose,
        props.onClose
    ], props.snack.key);
    var handleEntered = function handleEntered() {
        if (props.snack.requestClose) handleClose(null, $181d1eb4be72417a$var$REASONS.INSTRCUTED);
    };
    var handleExitedScreen = function handleExitedScreen() {
        timeout.current = setTimeout(function() {
            setCollapsed(!collapsed);
        }, 125);
    };
    var style = props.style, otherAriaAttributes = props.ariaAttributes, otherClassName = props.className, hideIconVariant = props.hideIconVariant, iconVariant = props.iconVariant, snack = props.snack, otherAction = props.action, otherContent = props.content, otherTranComponent = props.TransitionComponent, otherTranProps = props.TransitionProps, otherTranDuration = props.transitionDuration, other = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(props, [
        "style",
        "dense",
        "ariaAttributes",
        "className",
        "hideIconVariant",
        "iconVariant",
        "snack",
        "action",
        "content",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting"
    ]);
    var key = snack.key, open = snack.open, singleClassName = snack.className, variant = snack.variant, singleContent = snack.content, singleAction = snack.action, singleAriaAttributes = snack.ariaAttributes, anchorOrigin = snack.anchorOrigin, snackMessage = snack.message, singleTranComponent = snack.TransitionComponent, singleTranProps = snack.TransitionProps, singleTranDuration = snack.transitionDuration, singleSnackProps = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(snack, [
        "persist",
        "key",
        "open",
        "entered",
        "requestClose",
        "className",
        "variant",
        "content",
        "action",
        "ariaAttributes",
        "anchorOrigin",
        "message",
        "TransitionComponent",
        "TransitionProps",
        "transitionDuration",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting"
    ]);
    var icon = $181d1eb4be72417a$var$_extends({}, $181d1eb4be72417a$var$defaultIconVariants, {}, iconVariant)[variant];
    var ariaAttributes = $181d1eb4be72417a$var$_extends({
        'aria-describedby': 'notistack-snackbar'
    }, $181d1eb4be72417a$var$objectMerge(singleAriaAttributes, otherAriaAttributes));
    var TransitionComponent = singleTranComponent || otherTranComponent || $181d1eb4be72417a$var$DEFAULTS.TransitionComponent;
    var transitionDuration = $181d1eb4be72417a$var$objectMerge(singleTranDuration, otherTranDuration, $181d1eb4be72417a$var$DEFAULTS.transitionDuration);
    var transitionProps = $181d1eb4be72417a$var$_extends({
        direction: $181d1eb4be72417a$var$getTransitionDirection(anchorOrigin)
    }, $181d1eb4be72417a$var$objectMerge(singleTranProps, otherTranProps));
    var action = singleAction || otherAction;
    if (typeof action === 'function') action = action(key);
    var content = singleContent || otherContent;
    if (typeof content === 'function') content = content(key, snack.message);
    var callbacks = [
        'onEnter',
        'onEntering',
        'onEntered',
        'onExit',
        'onExiting',
        'onExited'
    ].reduce(function(acc, cbName) {
        var _extends2;
        return $181d1eb4be72417a$var$_extends({}, acc, (_extends2 = {}, _extends2[cbName] = $181d1eb4be72417a$var$createChainedFunction([
            props.snack[cbName],
            props[cbName]
        ], props.snack.key), _extends2));
    }, {});
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i1h3S.default), {
        unmountOnExit: true,
        timeout: 175,
        "in": collapsed,
        onExited: callbacks.onExited
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$Snackbar, Object.assign({}, other, singleSnackProps, {
        open: open,
        className: (0, $1SA7b.default)(classes.root, classes.wrappedRoot, classes[$181d1eb4be72417a$var$transformer.toAnchorOrigin(anchorOrigin)]),
        onClose: handleClose
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TransitionComponent, Object.assign({
        appear: true,
        "in": open,
        timeout: transitionDuration
    }, transitionProps, {
        onExit: callbacks.onExit,
        onExiting: callbacks.onExiting,
        onExited: handleExitedScreen,
        onEnter: callbacks.onEnter,
        onEntering: callbacks.onEntering,
        // order matters. first callbacks.onEntered to set entered: true,
        // then handleEntered to check if there's a request for closing
        onEntered: $181d1eb4be72417a$var$createChainedFunction([
            callbacks.onEntered,
            handleEntered
        ])
    }), content || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$export$860cef82710cac7, Object.assign({}, ariaAttributes, {
        role: "alert",
        style: style,
        className: (0, $1SA7b.default)(classes.contentRoot, classes[$181d1eb4be72417a$var$transformer.toVariant(variant)], otherClassName, singleClassName, !hideIconVariant && icon && classes.lessPadding)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: ariaAttributes['aria-describedby'],
        className: classes.message
    }, !hideIconVariant ? icon : null, snackMessage), action && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.action
    }, action)))));
};
var $181d1eb4be72417a$var$SnackbarItem$1 = /*#__PURE__*/ (0, $kQaj4.default)($181d1eb4be72417a$var$styles$1)($181d1eb4be72417a$var$SnackbarItem);
var $181d1eb4be72417a$var$collapse = {
    // Material-UI 4.12.x and above uses MuiCollapse-root; earlier versions use
    // Mui-Collapse-container.  https://github.com/mui-org/material-ui/pull/24084
    container: '& > .MuiCollapse-container, & > .MuiCollapse-root',
    wrapper: '& > .MuiCollapse-container > .MuiCollapse-wrapper, & > .MuiCollapse-root > .MuiCollapse-wrapper'
};
var $181d1eb4be72417a$var$xsWidthMargin = 16;
var $181d1eb4be72417a$var$useStyle = /*#__PURE__*/ (0, $8WyyQ.default)(function(theme) {
    var _root, _rootDense, _left, _right, _center;
    return {
        root: (_root = {
            boxSizing: 'border-box',
            display: 'flex',
            maxHeight: '100%',
            position: 'fixed',
            zIndex: theme.zIndex.snackbar,
            height: 'auto',
            width: 'auto',
            transition: 'top 300ms ease 0ms, right 300ms ease 0ms, bottom 300ms ease 0ms, left 300ms ease 0ms, margin 300ms ease 0ms, max-width 300ms ease 0ms',
            // container itself is invisible and should not block clicks, clicks should be passed to its children
            pointerEvents: 'none'
        }, _root[$181d1eb4be72417a$var$collapse.container] = {
            pointerEvents: 'all'
        }, _root[$181d1eb4be72417a$var$collapse.wrapper] = {
            padding: $181d1eb4be72417a$var$SNACKBAR_INDENTS.snackbar["default"] + "px 0px",
            transition: 'padding 300ms ease 0ms'
        }, _root.maxWidth = "calc(100% - " + $181d1eb4be72417a$var$SNACKBAR_INDENTS.view["default"] * 2 + "px)", _root[theme.breakpoints.down('xs')] = {
            width: '100%',
            maxWidth: "calc(100% - " + $181d1eb4be72417a$var$xsWidthMargin * 2 + "px)"
        }, _root),
        rootDense: (_rootDense = {}, _rootDense[$181d1eb4be72417a$var$collapse.wrapper] = {
            padding: $181d1eb4be72417a$var$SNACKBAR_INDENTS.snackbar.dense + "px 0px"
        }, _rootDense),
        top: {
            top: $181d1eb4be72417a$var$SNACKBAR_INDENTS.view["default"] - $181d1eb4be72417a$var$SNACKBAR_INDENTS.snackbar["default"],
            flexDirection: 'column'
        },
        bottom: {
            bottom: $181d1eb4be72417a$var$SNACKBAR_INDENTS.view["default"] - $181d1eb4be72417a$var$SNACKBAR_INDENTS.snackbar["default"],
            flexDirection: 'column-reverse'
        },
        left: (_left = {
            left: $181d1eb4be72417a$var$SNACKBAR_INDENTS.view["default"]
        }, _left[theme.breakpoints.up('sm')] = {
            alignItems: 'flex-start'
        }, _left[theme.breakpoints.down('xs')] = {
            left: $181d1eb4be72417a$var$xsWidthMargin + "px"
        }, _left),
        right: (_right = {
            right: $181d1eb4be72417a$var$SNACKBAR_INDENTS.view["default"]
        }, _right[theme.breakpoints.up('sm')] = {
            alignItems: 'flex-end'
        }, _right[theme.breakpoints.down('xs')] = {
            right: $181d1eb4be72417a$var$xsWidthMargin + "px"
        }, _right),
        center: (_center = {
            left: '50%',
            transform: 'translateX(-50%)'
        }, _center[theme.breakpoints.up('sm')] = {
            alignItems: 'center'
        }, _center)
    };
});
var $181d1eb4be72417a$var$SnackbarContainer = function SnackbarContainer(props) {
    var classes = $181d1eb4be72417a$var$useStyle();
    var className = props.className, anchorOrigin = props.anchorOrigin, dense = props.dense, other = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(props, [
        "className",
        "anchorOrigin",
        "dense"
    ]);
    var combinedClassname = (0, $1SA7b.default)(classes[anchorOrigin.vertical], classes[anchorOrigin.horizontal], classes.root, className, dense && classes.rootDense);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: combinedClassname
    }, other));
};
var $181d1eb4be72417a$var$SnackbarContainer$1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($181d1eb4be72417a$var$SnackbarContainer);
/* eslint-disable */ var $181d1eb4be72417a$var$__DEV__ = false;
var $181d1eb4be72417a$var$warning = function(message) {
    if (!$181d1eb4be72417a$var$__DEV__) return;
    if (typeof console !== 'undefined') console.error(message);
    try {
        throw new Error(message);
    } catch (x) {}
};
var $181d1eb4be72417a$export$d1e619fddc3508ce = /*#__PURE__*/ function(_Component) {
    $181d1eb4be72417a$var$_inheritsLoose(SnackbarProvider, _Component);
    function SnackbarProvider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        /**
     * Adds a new snackbar to the queue to be presented.
     * Returns generated or user defined key referencing the new snackbar or null
     */ _this.enqueueSnackbar = function(message, opts) {
            if (opts === void 0) opts = {};
            var _opts = opts, key = _opts.key, preventDuplicate = _opts.preventDuplicate, options = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(_opts, [
                "key",
                "preventDuplicate"
            ]);
            var hasSpecifiedKey = $181d1eb4be72417a$var$isDefined(key);
            var id = hasSpecifiedKey ? key : new Date().getTime() + Math.random();
            var merger = $181d1eb4be72417a$var$merge(options, _this.props, $181d1eb4be72417a$var$DEFAULTS);
            var snack = $181d1eb4be72417a$var$_extends({
                key: id
            }, options, {
                message: message,
                open: true,
                entered: false,
                requestClose: false,
                variant: merger('variant'),
                anchorOrigin: merger('anchorOrigin'),
                autoHideDuration: merger('autoHideDuration')
            });
            if (options.persist) snack.autoHideDuration = undefined;
            _this.setState(function(state) {
                if (preventDuplicate === undefined && _this.props.preventDuplicate || preventDuplicate) {
                    var compareFunction = function compareFunction(item) {
                        return hasSpecifiedKey ? item.key === key : item.message === message;
                    };
                    var inQueue = state.queue.findIndex(compareFunction) > -1;
                    var inView = state.snacks.findIndex(compareFunction) > -1;
                    if (inQueue || inView) return state;
                }
                return _this.handleDisplaySnack($181d1eb4be72417a$var$_extends({}, state, {
                    queue: [].concat(state.queue, [
                        snack
                    ])
                }));
            });
            return id;
        };
        /**
     * Reducer: Display snack if there's space for it. Otherwise, immediately
     * begin dismissing the oldest message to start showing the new one.
     */ _this.handleDisplaySnack = function(state) {
            var snacks = state.snacks;
            if (snacks.length >= _this.maxSnack) return _this.handleDismissOldest(state);
            return _this.processQueue(state);
        };
        /**
     * Reducer: Display items (notifications) in the queue if there's space for them.
     */ _this.processQueue = function(state) {
            var queue = state.queue, snacks = state.snacks;
            if (queue.length > 0) return $181d1eb4be72417a$var$_extends({}, state, {
                snacks: [].concat(snacks, [
                    queue[0]
                ]),
                queue: queue.slice(1, queue.length)
            });
            return state;
        };
        /**
     * Reducer: Hide oldest snackbar on the screen because there exists a new one which we have to display.
     * (ignoring the one with 'persist' flag. i.e. explicitly told by user not to get dismissed).
     *
     * Note 1: If there is already a message leaving the screen, no new messages are dismissed.
     * Note 2: If the oldest message has not yet entered the screen, only a request to close the
     *         snackbar is made. Once it entered the screen, it will be immediately dismissed.
     */ _this.handleDismissOldest = function(state) {
            if (state.snacks.some(function(item) {
                return !item.open || item.requestClose;
            })) return state;
            var popped = false;
            var ignore = false;
            var persistentCount = state.snacks.reduce(function(acc, current) {
                return acc + (current.open && current.persist ? 1 : 0);
            }, 0);
            if (persistentCount === _this.maxSnack) ignore = true;
            var snacks = state.snacks.map(function(item) {
                if (!popped && (!item.persist || ignore)) {
                    popped = true;
                    if (!item.entered) return $181d1eb4be72417a$var$_extends({}, item, {
                        requestClose: true
                    });
                    if (item.onClose) item.onClose(null, $181d1eb4be72417a$var$REASONS.MAXSNACK, item.key);
                    if (_this.props.onClose) _this.props.onClose(null, $181d1eb4be72417a$var$REASONS.MAXSNACK, item.key);
                    return $181d1eb4be72417a$var$_extends({}, item, {
                        open: false
                    });
                }
                return $181d1eb4be72417a$var$_extends({}, item);
            });
            return $181d1eb4be72417a$var$_extends({}, state, {
                snacks: snacks
            });
        };
        /**
     * Set the entered state of the snackbar with the given key.
     */ _this.handleEnteredSnack = function(node, isAppearing, key) {
            if (!$181d1eb4be72417a$var$isDefined(key)) throw new Error('handleEnteredSnack Cannot be called with undefined key');
            _this.setState(function(_ref) {
                var snacks = _ref.snacks;
                return {
                    snacks: snacks.map(function(item) {
                        return item.key === key ? $181d1eb4be72417a$var$_extends({}, item, {
                            entered: true
                        }) : $181d1eb4be72417a$var$_extends({}, item);
                    })
                };
            });
        };
        /**
     * Hide a snackbar after its timeout.
     */ _this.handleCloseSnack = function(event, reason, key) {
            // should not use createChainedFunction for onClose.
            // because this.closeSnackbar called this function
            if (_this.props.onClose) _this.props.onClose(event, reason, key);
            if (reason === $181d1eb4be72417a$var$REASONS.CLICKAWAY) return;
            var shouldCloseAll = key === undefined;
            _this.setState(function(_ref2) {
                var snacks = _ref2.snacks, queue = _ref2.queue;
                return {
                    snacks: snacks.map(function(item) {
                        if (!shouldCloseAll && item.key !== key) return $181d1eb4be72417a$var$_extends({}, item);
                        return item.entered ? $181d1eb4be72417a$var$_extends({}, item, {
                            open: false
                        }) : $181d1eb4be72417a$var$_extends({}, item, {
                            requestClose: true
                        });
                    }),
                    queue: queue.filter(function(item) {
                        return item.key !== key;
                    })
                };
            });
        };
        /**
     * Close snackbar with the given key
     */ _this.closeSnackbar = function(key) {
            // call individual snackbar onClose callback passed through options parameter
            var toBeClosed = _this.state.snacks.find(function(item) {
                return item.key === key;
            });
            if ($181d1eb4be72417a$var$isDefined(key) && toBeClosed && toBeClosed.onClose) toBeClosed.onClose(null, $181d1eb4be72417a$var$REASONS.INSTRUCTED, key);
            _this.handleCloseSnack(null, $181d1eb4be72417a$var$REASONS.INSTRUCTED, key);
        };
        /**
     * When we set open attribute of a snackbar to false (i.e. after we hide a snackbar),
     * it leaves the screen and immediately after leaving animation is done, this method
     * gets called. We remove the hidden snackbar from state and then display notifications
     * waiting in the queue (if any). If after this process the queue is not empty, the
     * oldest message is dismissed.
     */ // @ts-ignore
        _this.handleExitedSnack = function(event, key1, key2) {
            var key = key1 || key2;
            if (!$181d1eb4be72417a$var$isDefined(key)) throw new Error('handleExitedSnack Cannot be called with undefined key');
            _this.setState(function(state) {
                var newState = _this.processQueue($181d1eb4be72417a$var$_extends({}, state, {
                    snacks: state.snacks.filter(function(item) {
                        return item.key !== key;
                    })
                }));
                if (newState.queue.length === 0) return newState;
                return _this.handleDismissOldest(newState);
            });
        };
        _this.state = {
            snacks: [],
            queue: [],
            contextValue: {
                enqueueSnackbar: _this.enqueueSnackbar,
                closeSnackbar: _this.closeSnackbar
            }
        };
        return _this;
    }
    var _proto = SnackbarProvider.prototype;
    _proto.render = function render() {
        var _this2 = this;
        var contextValue = this.state.contextValue;
        var _this$props = this.props, iconVariant = _this$props.iconVariant, _this$props$dense = _this$props.dense, dense = _this$props$dense === void 0 ? $181d1eb4be72417a$var$DEFAULTS.dense : _this$props$dense, _this$props$hideIconV = _this$props.hideIconVariant, hideIconVariant = _this$props$hideIconV === void 0 ? $181d1eb4be72417a$var$DEFAULTS.hideIconVariant : _this$props$hideIconV, domRoot = _this$props.domRoot, children = _this$props.children, _this$props$classes = _this$props.classes, classes = _this$props$classes === void 0 ? {} : _this$props$classes, props = $181d1eb4be72417a$var$_objectWithoutPropertiesLoose(_this$props, [
            "maxSnack",
            "preventDuplicate",
            "variant",
            "anchorOrigin",
            "iconVariant",
            "dense",
            "hideIconVariant",
            "domRoot",
            "children",
            "classes"
        ]);
        var categ = this.state.snacks.reduce(function(acc, current) {
            var _extends2;
            var category = $181d1eb4be72417a$var$originKeyExtractor(current.anchorOrigin);
            var existingOfCategory = acc[category] || [];
            return $181d1eb4be72417a$var$_extends({}, acc, (_extends2 = {}, _extends2[category] = [].concat(existingOfCategory, [
                current
            ]), _extends2));
        }, {});
        var snackbars = Object.keys(categ).map(function(origin) {
            var snacks = categ[origin];
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$SnackbarContainer$1, {
                key: origin,
                dense: dense,
                anchorOrigin: snacks[0].anchorOrigin,
                className: (0, $1SA7b.default)(classes.containerRoot, classes[$181d1eb4be72417a$var$transformer.toContainerAnchorOrigin(origin)])
            }, snacks.map(function(snack) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$SnackbarItem$1, Object.assign({}, props, {
                    key: snack.key,
                    snack: snack,
                    dense: dense,
                    iconVariant: iconVariant,
                    hideIconVariant: hideIconVariant,
                    classes: $181d1eb4be72417a$var$omitContainerKeys(classes),
                    onClose: _this2.handleCloseSnack,
                    onExited: $181d1eb4be72417a$var$createChainedFunction([
                        _this2.handleExitedSnack,
                        _this2.props.onExited
                    ]),
                    onEntered: $181d1eb4be72417a$var$createChainedFunction([
                        _this2.handleEnteredSnack,
                        _this2.props.onEntered
                    ])
                }));
            }));
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$SnackbarContext.Provider, {
            value: contextValue
        }, children, domRoot ? (0, $1u0KT.createPortal)(snackbars, domRoot) : snackbars);
    };
    $181d1eb4be72417a$var$_createClass(SnackbarProvider, [
        {
            key: "maxSnack",
            get: function get() {
                return this.props.maxSnack || $181d1eb4be72417a$var$DEFAULTS.maxSnack;
            }
        }
    ]);
    return SnackbarProvider;
}((0, $acw62.Component));
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var $181d1eb4be72417a$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
var $181d1eb4be72417a$var$getFunctionName = function getFunctionName(fn) {
    var match = ("" + fn).match($181d1eb4be72417a$var$fnNameMatchRegex);
    var name = match && match[1];
    return name || '';
};
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */ var $181d1eb4be72417a$var$getFunctionComponentName = function getFunctionComponentName(Component, fallback) {
    if (fallback === void 0) fallback = '';
    return Component.displayName || Component.name || $181d1eb4be72417a$var$getFunctionName(Component) || fallback;
};
var $181d1eb4be72417a$var$getWrappedName = function getWrappedName(outerType, innerType, wrapperName) {
    var functionName = $181d1eb4be72417a$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
};
/** 
 * From react-is
 * @link https://github.com/facebook/react/blob/master/packages/shared/ReactSymbols.js
 */ var $181d1eb4be72417a$var$ForwardRef = function ForwardRef() {
    var symbolFor = typeof Symbol === 'function' && Symbol["for"];
    return symbolFor ? symbolFor('react.forward_ref') : 0xead0;
};
/**
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */ var $181d1eb4be72417a$var$getDisplayName = function(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $181d1eb4be72417a$var$getFunctionComponentName(Component, 'Component');
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $181d1eb4be72417a$var$ForwardRef():
            return $181d1eb4be72417a$var$getWrappedName(Component, Component.render, 'ForwardRef');
        default:
            return undefined;
    }
    return undefined;
};
var $181d1eb4be72417a$export$2476e1012a39384b = function withSnackbar(Component) {
    var WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($181d1eb4be72417a$var$SnackbarContext.Consumer, null, function(context) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, $181d1eb4be72417a$var$_extends({}, props, {
                ref: ref,
                enqueueSnackbar: context.enqueueSnackbar,
                closeSnackbar: context.closeSnackbar
            }));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(WrappedComponent, Component);
    return WrappedComponent;
};
var $181d1eb4be72417a$export$1c97ac2c9a6e7c09 = function() {
    return (0, $acw62.useContext)($181d1eb4be72417a$var$SnackbarContext);
};

});
parcelRegister("1SA7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;

});

parcelRegister("dwyUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d895755ad15492b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");

var $4nDBj = parcelRequire("4nDBj");

var $1mPeS = parcelRequire("1mPeS");


var $3Xov1 = parcelRequire("3Xov1");

var $c9eEd = parcelRequire("c9eEd");

var $3Z9df = parcelRequire("3Z9df");

var $8XARg = parcelRequire("8XARg");
// Later, we gonna translate back the node to his original location
// with `none`.`
function $9d895755ad15492b$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = window.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
    if (direction === 'right') return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    if (direction === 'up') return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
     // direction === 'down'
    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function $9d895755ad15492b$export$f820ccdc5b48abdf(direction, node) {
    var transform = $9d895755ad15492b$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $9d895755ad15492b$var$defaultTimeout = {
    enter: (0, $3Z9df.duration).enteringScreen,
    exit: (0, $3Z9df.duration).leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $9d895755ad15492b$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $9d895755ad15492b$var$defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $1mPeS.default) : _props$TransitionComp, other = (0, $9X7IJ.default)(props, [
        "children",
        "direction",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $c9eEd.default)();
    var childrenRef = $acw62.useRef(null);
    /**
   * used in cloneElement(children, { ref: handleRef })
   */ var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        childrenRef.current = $1u0KT.findDOMNode(instance);
    }, []);
    var handleRefIntermediary = (0, $3Xov1.default)(children.ref, handleOwnRef);
    var handleRef = (0, $3Xov1.default)(handleRefIntermediary, ref);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(isAppearing) {
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        $9d895755ad15492b$export$f820ccdc5b48abdf(direction, node);
        (0, $8XARg.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var transitionProps = (0, $8XARg.getTransitionProps)({
            timeout: timeout,
            style: style
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.transition = theme.transitions.create('transform', (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $8XARg.getTransitionProps)({
            timeout: timeout,
            style: style
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        node.style.transition = theme.transitions.create('transform', (0, $8nd05.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        $9d895755ad15492b$export$f820ccdc5b48abdf(direction, node);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(function(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    var updatePosition = $acw62.useCallback(function() {
        if (childrenRef.current) $9d895755ad15492b$export$f820ccdc5b48abdf(direction, childrenRef.current);
    }, [
        direction
    ]);
    $acw62.useEffect(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = (0, $4nDBj.default)(function() {
            if (childrenRef.current) $9d895755ad15492b$export$f820ccdc5b48abdf(direction, childrenRef.current);
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    $acw62.useEffect(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        appear: true,
        in: inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $acw62.cloneElement(children, (0, $8nd05.default)({
            ref: handleRef,
            style: (0, $8nd05.default)({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, children.props.style)
        }, childProps));
    });
});
var $9d895755ad15492b$export$2e2bcd8739ae039 = $9d895755ad15492b$var$Slide;

});
parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("4nDBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3308074b7cd66a5b$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $3308074b7cd66a5b$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("3Xov1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e19e2d9ab6312a7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iVhb0 = parcelRequire("iVhb0");
function $2e19e2d9ab6312a7$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $acw62.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $iVhb0.default)(refA, refValue);
            (0, $iVhb0.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("iVhb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc6adfc0d47b3cd2$export$2e2bcd8739ae039);
// TODO v5: consider to make it private
function $dc6adfc0d47b3cd2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("c9eEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d81b008787777c3$export$2e2bcd8739ae039);

var $gkNc2 = parcelRequire("gkNc2");
parcelRequire("acw62");

var $kpDC5 = parcelRequire("kpDC5");
function $8d81b008787777c3$export$2e2bcd8739ae039() {
    var theme = (0, $gkNc2.default)() || (0, $kpDC5.default);
    return theme;
}

});
parcelRegister("gkNc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $be44ac57ed98aab1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $k4AIz = parcelRequire("k4AIz");
function $be44ac57ed98aab1$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $k4AIz.default));
    return theme;
}

});
parcelRegister("k4AIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9d0a9c2589c7bd2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $e9d0a9c2589c7bd2$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $e9d0a9c2589c7bd2$export$2e2bcd8739ae039 = $e9d0a9c2589c7bd2$var$ThemeContext;

});


parcelRegister("kpDC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc4ded6dfec889f$export$2e2bcd8739ae039);

var $eOWQz = parcelRequire("eOWQz");
var $edc4ded6dfec889f$var$defaultTheme = (0, $eOWQz.default)();
var $edc4ded6dfec889f$export$2e2bcd8739ae039 = $edc4ded6dfec889f$var$defaultTheme;

});
parcelRegister("eOWQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca361f45e881e1e$export$2e2bcd8739ae039);
parcelRequire("kSlfw");

var $9X7IJ = parcelRequire("9X7IJ");

var $izL69 = parcelRequire("izL69");

var $jKDgp = parcelRequire("jKDgp");

var $egNiU = parcelRequire("egNiU");

var $gyFQg = parcelRequire("gyFQg");

var $6kj3D = parcelRequire("6kj3D");

var $eF57Y = parcelRequire("eF57Y");

var $lnT3F = parcelRequire("lnT3F");

var $gdeSj = parcelRequire("gdeSj");

var $3Z9df = parcelRequire("3Z9df");

var $efglq = parcelRequire("efglq");
function $aca361f45e881e1e$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $9X7IJ.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $gyFQg.default)(paletteInput);
    var breakpoints = (0, $jKDgp.default)(breakpointsInput);
    var spacing = (0, $gdeSj.default)(spacingInput);
    var muiTheme = (0, $izL69.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $egNiU.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $eF57Y.default),
        typography: (0, $6kj3D.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $lnT3F.default),
        transitions: (0, $3Z9df.default),
        zIndex: (0, $efglq.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $izL69.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $aca361f45e881e1e$var$warnedOnce = false;
function $aca361f45e881e1e$export$c469355549431d9b() {
    return $aca361f45e881e1e$var$createTheme.apply(void 0, arguments);
}
var $aca361f45e881e1e$export$2e2bcd8739ae039 = $aca361f45e881e1e$var$createTheme;

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("izL69", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8600793c65c158d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");
function $d8600793c65c158d$export$53b83ca8eaab0383(item) {
    return item && (0, $fSwVM.default)(item) === 'object' && item.constructor === Object;
}
function $d8600793c65c158d$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $8nd05.default)({}, target) : target;
    if ($d8600793c65c158d$export$53b83ca8eaab0383(target) && $d8600793c65c158d$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($d8600793c65c158d$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $d8600793c65c158d$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("jKDgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e610c528979d3b2e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");
var $e610c528979d3b2e$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $e610c528979d3b2e$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $9X7IJ.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $e610c528979d3b2e$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$e610c528979d3b2e$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $e610c528979d3b2e$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $e610c528979d3b2e$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $e610c528979d3b2e$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$e610c528979d3b2e$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$e610c528979d3b2e$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $8nd05.default)({
        keys: $e610c528979d3b2e$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("egNiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a638ce0ba59ac53f$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");
function $a638ce0ba59ac53f$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $8nd05.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $8nd05.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $kSlfw.default)({}, breakpoints.up('sm'), (0, $8nd05.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $kSlfw.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $kSlfw.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("gyFQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e04740eb31aaf4$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $izL69 = parcelRequire("izL69");
var $gMaRA = parcelRequire("gMaRA");

var $bQGos = parcelRequire("bQGos");

var $3gVaZ = parcelRequire("3gVaZ");

var $hClfA = parcelRequire("hClfA");

var $858Ql = parcelRequire("858Ql");

var $fMZcm = parcelRequire("fMZcm");

var $5UuqN = parcelRequire("5UuqN");

var $6LNdu = parcelRequire("6LNdu");

var $4kOxD = parcelRequire("4kOxD");

var $9GbWv = parcelRequire("9GbWv");
var $c0e04740eb31aaf4$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $bQGos.default).white,
        default: (0, $3gVaZ.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $c0e04740eb31aaf4$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $bQGos.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $3gVaZ.default)[800],
        default: '#303030'
    },
    action: {
        active: (0, $bQGos.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $c0e04740eb31aaf4$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $9GbWv.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $9GbWv.darken)(intent.main, tonalOffsetDark);
    }
}
function $c0e04740eb31aaf4$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $hClfA.default)[300],
        main: (0, $hClfA.default)[500],
        dark: (0, $hClfA.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $858Ql.default).A200,
        main: (0, $858Ql.default).A400,
        dark: (0, $858Ql.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $fMZcm.default)[300],
        main: (0, $fMZcm.default)[500],
        dark: (0, $fMZcm.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $5UuqN.default)[300],
        main: (0, $5UuqN.default)[500],
        dark: (0, $5UuqN.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $6LNdu.default)[300],
        main: (0, $6LNdu.default)[500],
        dark: (0, $6LNdu.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $4kOxD.default)[300],
        main: (0, $4kOxD.default)[500],
        dark: (0, $4kOxD.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $9X7IJ.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $9GbWv.getContrastRatio)(background, $c0e04740eb31aaf4$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c0e04740eb31aaf4$export$55ce6f3a06c59543.text.primary : $c0e04740eb31aaf4$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $8nd05.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $gMaRA.default)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $gMaRA.default)(5, JSON.stringify(color.main)));
        $c0e04740eb31aaf4$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $c0e04740eb31aaf4$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c0e04740eb31aaf4$export$55ce6f3a06c59543,
        light: $c0e04740eb31aaf4$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $izL69.default)((0, $8nd05.default)({
        // A collection of common colors.
        common: (0, $bQGos.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $3gVaZ.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("gMaRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3698e480604b2e2$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $c3698e480604b2e2$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://material-ui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});

parcelRegister("bQGos", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a056f7d70be33fa$export$2e2bcd8739ae039);
var $8a056f7d70be33fa$var$common = {
    black: '#000',
    white: '#fff'
};
var $8a056f7d70be33fa$export$2e2bcd8739ae039 = $8a056f7d70be33fa$var$common;

});

parcelRegister("3gVaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $261f37bcb99a0a85$export$2e2bcd8739ae039);
var $261f37bcb99a0a85$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $261f37bcb99a0a85$export$2e2bcd8739ae039 = $261f37bcb99a0a85$var$grey;

});

parcelRegister("hClfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd36782f8b31900d$export$2e2bcd8739ae039);
var $cd36782f8b31900d$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $cd36782f8b31900d$export$2e2bcd8739ae039 = $cd36782f8b31900d$var$indigo;

});

parcelRegister("858Ql", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e25a66d20ac5abf$export$2e2bcd8739ae039);
var $5e25a66d20ac5abf$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $5e25a66d20ac5abf$export$2e2bcd8739ae039 = $5e25a66d20ac5abf$var$pink;

});

parcelRegister("fMZcm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7eacf6dfa54ff7f$export$2e2bcd8739ae039);
var $b7eacf6dfa54ff7f$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $b7eacf6dfa54ff7f$export$2e2bcd8739ae039 = $b7eacf6dfa54ff7f$var$red;

});

parcelRegister("5UuqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d9c9b51d2e8ade$export$2e2bcd8739ae039);
var $44d9c9b51d2e8ade$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $44d9c9b51d2e8ade$export$2e2bcd8739ae039 = $44d9c9b51d2e8ade$var$orange;

});

parcelRegister("6LNdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edd4f399ca1309c$export$2e2bcd8739ae039);
var $4edd4f399ca1309c$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $4edd4f399ca1309c$export$2e2bcd8739ae039 = $4edd4f399ca1309c$var$blue;

});

parcelRegister("4kOxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $32803c282f51058e$export$2e2bcd8739ae039);
var $32803c282f51058e$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $32803c282f51058e$export$2e2bcd8739ae039 = $32803c282f51058e$var$green;

});

parcelRegister("9GbWv", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $70c14cd82f6bad00$export$d061e26956a60b0a);
$parcel$export(module.exports, "emphasize", () => $70c14cd82f6bad00$export$e665714f76e581fd);
$parcel$export(module.exports, "darken", () => $70c14cd82f6bad00$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $70c14cd82f6bad00$export$c0816ed86df316af);

var $gMaRA = parcelRequire("gMaRA");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $70c14cd82f6bad00$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $70c14cd82f6bad00$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $70c14cd82f6bad00$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $70c14cd82f6bad00$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $70c14cd82f6bad00$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $70c14cd82f6bad00$var$intToHex(n);
    }).join(''));
}
function $70c14cd82f6bad00$export$29fb7152bd3f781a(color) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $70c14cd82f6bad00$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $70c14cd82f6bad00$export$677b39864803984e($70c14cd82f6bad00$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $gMaRA.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $70c14cd82f6bad00$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $70c14cd82f6bad00$export$d061e26956a60b0a(foreground, background) {
    var lumA = $70c14cd82f6bad00$export$c852d90bf7403b62(foreground);
    var lumB = $70c14cd82f6bad00$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $70c14cd82f6bad00$export$c852d90bf7403b62(color) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $70c14cd82f6bad00$export$677b39864803984e($70c14cd82f6bad00$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $70c14cd82f6bad00$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $70c14cd82f6bad00$export$c852d90bf7403b62(color) > 0.5 ? $70c14cd82f6bad00$export$4b073707ff63303(color, coefficient) : $70c14cd82f6bad00$export$c0816ed86df316af(color, coefficient);
}
var $70c14cd82f6bad00$var$warnedOnce = false;
function $70c14cd82f6bad00$export$cbea29d068a2e18f(color, value) {
    return $70c14cd82f6bad00$export$58f0f39f63f3cf42(color, value);
}
function $70c14cd82f6bad00$export$58f0f39f63f3cf42(color, value) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    value = $70c14cd82f6bad00$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4(color);
}
function $70c14cd82f6bad00$export$4b073707ff63303(color, coefficient) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    coefficient = $70c14cd82f6bad00$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4(color);
}
function $70c14cd82f6bad00$export$c0816ed86df316af(color, coefficient) {
    color = $70c14cd82f6bad00$export$677b39864803984e(color);
    coefficient = $70c14cd82f6bad00$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $70c14cd82f6bad00$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("6kj3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b364cb8cb99087$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $izL69 = parcelRequire("izL69");
function $49b364cb8cb99087$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $49b364cb8cb99087$var$warnedOnce = false;
function $49b364cb8cb99087$var$roundWithDeprecationWarning(value) {
    return $49b364cb8cb99087$var$round(value);
}
var $49b364cb8cb99087$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $49b364cb8cb99087$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $49b364cb8cb99087$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $49b364cb8cb99087$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $9X7IJ.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $8nd05.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $49b364cb8cb99087$var$defaultFontFamily ? {
            letterSpacing: "".concat($49b364cb8cb99087$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $49b364cb8cb99087$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $49b364cb8cb99087$var$caseAllCaps)
    };
    return (0, $izL69.default)((0, $8nd05.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $49b364cb8cb99087$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("eF57Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aac8df47118989c3$export$2e2bcd8739ae039);
var $aac8df47118989c3$var$shadowKeyUmbraOpacity = 0.2;
var $aac8df47118989c3$var$shadowKeyPenumbraOpacity = 0.14;
var $aac8df47118989c3$var$shadowAmbientShadowOpacity = 0.12;
function $aac8df47118989c3$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($aac8df47118989c3$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($aac8df47118989c3$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($aac8df47118989c3$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $aac8df47118989c3$var$shadows = [
    'none',
    $aac8df47118989c3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $aac8df47118989c3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $aac8df47118989c3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $aac8df47118989c3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $aac8df47118989c3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $aac8df47118989c3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $aac8df47118989c3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $aac8df47118989c3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $aac8df47118989c3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $aac8df47118989c3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $aac8df47118989c3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $aac8df47118989c3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $aac8df47118989c3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $aac8df47118989c3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $aac8df47118989c3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $aac8df47118989c3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $aac8df47118989c3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $aac8df47118989c3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $aac8df47118989c3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $aac8df47118989c3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $aac8df47118989c3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $aac8df47118989c3$export$2e2bcd8739ae039 = $aac8df47118989c3$var$shadows;

});

parcelRegister("lnT3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $f916745da3cdbda0$export$2e2bcd8739ae039);
var $f916745da3cdbda0$var$shape = {
    borderRadius: 4
};
var $f916745da3cdbda0$export$2e2bcd8739ae039 = $f916745da3cdbda0$var$shape;

});

parcelRegister("gdeSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd96616285ed264$export$2e2bcd8739ae039);

var $azmQN = parcelRequire("azmQN");
var $bcd96616285ed264$var$warnOnce;
function $bcd96616285ed264$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $azmQN.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("azmQN", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", () => $7b1ee5eb83d90478$export$1def6f833384e3d1);

var $eUqlC = parcelRequire("eUqlC");


var $47Boo = parcelRequire("47Boo");

var $50JXT = parcelRequire("50JXT");

var $hATSm = parcelRequire("hATSm");
var $7b1ee5eb83d90478$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $7b1ee5eb83d90478$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $7b1ee5eb83d90478$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $7b1ee5eb83d90478$var$getCssProperties = (0, $hATSm.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($7b1ee5eb83d90478$var$aliases[prop]) prop = $7b1ee5eb83d90478$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $eUqlC.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $7b1ee5eb83d90478$var$properties[a];
    var direction = $7b1ee5eb83d90478$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $7b1ee5eb83d90478$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $7b1ee5eb83d90478$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $7b1ee5eb83d90478$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $7b1ee5eb83d90478$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $7b1ee5eb83d90478$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $7b1ee5eb83d90478$var$spacing(props) {
    var theme = props.theme;
    var transformer = $7b1ee5eb83d90478$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($7b1ee5eb83d90478$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $7b1ee5eb83d90478$var$getCssProperties(prop);
        var styleFromPropValue = $7b1ee5eb83d90478$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $47Boo.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $50JXT.default), {});
}
$7b1ee5eb83d90478$var$spacing.propTypes = {};
$7b1ee5eb83d90478$var$spacing.filterProps = $7b1ee5eb83d90478$var$spacingKeys;
var $7b1ee5eb83d90478$export$2e2bcd8739ae039 = $7b1ee5eb83d90478$var$spacing;

});
parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1uEeT.default)(r) || (0, $guSBA.default)(r, e) || (0, $abLc2.default)(r, e) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("47Boo", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", () => $3004d24072c2b669$export$88347efdb2e19abd);

var $kbxxf = parcelRequire("kbxxf");

var $8nd05 = parcelRequire("8nd05");

var $fSwVM = parcelRequire("fSwVM");


var $50JXT = parcelRequire("50JXT");
// For instance with the first breakpoint xs: [xs, sm[.
var $3004d24072c2b669$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $3004d24072c2b669$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($3004d24072c2b669$var$values[key], "px)");
    }
};
function $3004d24072c2b669$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $3004d24072c2b669$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $fSwVM.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $3004d24072c2b669$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $3004d24072c2b669$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $3004d24072c2b669$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $8nd05.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $50JXT.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $kbxxf.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $3004d24072c2b669$export$2e2bcd8739ae039 = $3004d24072c2b669$var$breakpoints;

});
parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("50JXT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a609b87cb3c2488$export$2e2bcd8739ae039);

var $izL69 = parcelRequire("izL69");
function $3a609b87cb3c2488$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $izL69.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $3a609b87cb3c2488$export$2e2bcd8739ae039 = $3a609b87cb3c2488$var$merge;

});


parcelRegister("hATSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf1243d1db5d9a5$export$2e2bcd8739ae039);
function $ccf1243d1db5d9a5$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("3Z9df", function(module, exports) {

$parcel$export(module.exports, "duration", () => $2e6e3712075ad2db$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $2e6e3712075ad2db$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");
var $2e6e3712075ad2db$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $2e6e3712075ad2db$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $2e6e3712075ad2db$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $2e6e3712075ad2db$export$2e2bcd8739ae039 = {
    easing: $2e6e3712075ad2db$export$24c5ac7c37452e7d,
    duration: $2e6e3712075ad2db$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $2e6e3712075ad2db$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $2e6e3712075ad2db$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $9X7IJ.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $2e6e3712075ad2db$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $2e6e3712075ad2db$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("efglq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ef251776b47b14$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $a5ef251776b47b14$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $a5ef251776b47b14$export$2e2bcd8739ae039 = $a5ef251776b47b14$var$zIndex;

});




parcelRegister("8XARg", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $68606cb156b7db52$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $68606cb156b7db52$export$8cb1e9b404609ae9);
var $68606cb156b7db52$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $68606cb156b7db52$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}

});


parcelRegister("830hp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dbed217b9b82c10$export$2e2bcd8739ae039);

var $eEI8q = parcelRequire("eEI8q");
function $5dbed217b9b82c10$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $eEI8q.default)(styles);
}

});
parcelRegister("eEI8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab70964ff9d4b98$export$2e2bcd8739ae039);
function $aab70964ff9d4b98$export$2e2bcd8739ae039(styles) {
    return styles;
}

});


parcelRegister("8WyyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $682e8c99752ec43b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $cp2NC = parcelRequire("cp2NC");

var $kpDC5 = parcelRequire("kpDC5");
function $682e8c99752ec43b$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $cp2NC.default)(stylesOrCreator, (0, $8nd05.default)({
        defaultTheme: (0, $kpDC5.default)
    }, options));
}
var $682e8c99752ec43b$export$2e2bcd8739ae039 = $682e8c99752ec43b$var$makeStyles;

});
parcelRegister("cp2NC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9079fdbaeaed29d2$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $f88hq = parcelRequire("f88hq");

var $fuTKz = parcelRequire("fuTKz");

var $elV9Y = parcelRequire("elV9Y");

var $gkNc2 = parcelRequire("gkNc2");

var $3WzLW = parcelRequire("3WzLW");

var $edKwj = parcelRequire("edKwj");

var $77xio = parcelRequire("77xio");

var $ei4PC = parcelRequire("ei4PC");
function $9079fdbaeaed29d2$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $fuTKz.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $9079fdbaeaed29d2$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $elV9Y.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $elV9Y.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $8nd05.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $elV9Y.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $8nd05.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $elV9Y.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $f88hq.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $8nd05.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $fuTKz.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $9079fdbaeaed29d2$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $9079fdbaeaed29d2$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $elV9Y.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $elV9Y.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $9079fdbaeaed29d2$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $9079fdbaeaed29d2$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $ei4PC.default) : _options$defaultTheme, stylesOptions2 = (0, $9X7IJ.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $77xio.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $edKwj.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $gkNc2.default)() || defaultTheme;
        var stylesOptions = (0, $8nd05.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3WzLW.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
        $9079fdbaeaed29d2$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $9079fdbaeaed29d2$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $9079fdbaeaed29d2$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
            if (shouldUpdate.current) $9079fdbaeaed29d2$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $9079fdbaeaed29d2$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("f88hq", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $8nd05 = parcelRequire("8nd05");

var $ja49S = parcelRequire("ja49S");

var $9RYKL = parcelRequire("9RYKL");

var $cHPF9 = parcelRequire("cHPF9");

var $g7ajw = parcelRequire("g7ajw");

var $hDpcU = parcelRequire("hDpcU");

var $1En50 = parcelRequire("1En50");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $g7ajw.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $hDpcU.default)((0, $hDpcU.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8nd05.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $cHPF9.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $8nd05.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $g7ajw.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $8nd05.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $8nd05.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $8nd05.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $8nd05.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $1En50.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $cHPF9.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $ja49S.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $8nd05.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $8nd05.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $8nd05.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $9RYKL.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $9RYKL.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $cHPF9.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $b03e06a37d110f0d$export$2e2bcd8739ae039 = index;

});
parcelRegister("ja49S", function(module, exports) {

$parcel$export(module.exports, "default", () => $df322d3da36c941f$export$2e2bcd8739ae039);
var $df322d3da36c941f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $df322d3da36c941f$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $df322d3da36c941f$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $df322d3da36c941f$export$2e2bcd8739ae039 = $df322d3da36c941f$export$4e09c449d6c407f7;

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});


parcelRegister("fuTKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b484e72b32d8ffe0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

function $b484e72b32d8ffe0$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $8nd05.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("elV9Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a72f5da279949b47$export$2e2bcd8739ae039);
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $a72f5da279949b47$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $a72f5da279949b47$export$2e2bcd8739ae039 = $a72f5da279949b47$var$multiKeyStore;

});

parcelRegister("3WzLW", function(module, exports) {

$parcel$export(module.exports, "StylesContext", () => $2df2897c2ec768dd$export$f4de434b269fe487);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");



var $c1WaC = parcelRequire("c1WaC");

var $f88hq = parcelRequire("f88hq");

var $hKuvS = parcelRequire("hKuvS");
var $2df2897c2ec768dd$var$jss = (0, $f88hq.create)((0, $hKuvS.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $2df2897c2ec768dd$var$generateClassName = (0, $c1WaC.default)(); // Exported for test purposes
var $2df2897c2ec768dd$export$70a8aea9ff58d1cd = new Map();
var $2df2897c2ec768dd$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $2df2897c2ec768dd$var$generateClassName,
    jss: $2df2897c2ec768dd$var$jss,
    sheetsCache: null,
    sheetsManager: $2df2897c2ec768dd$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $2df2897c2ec768dd$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($2df2897c2ec768dd$var$defaultOptions);
var $2df2897c2ec768dd$var$injectFirstNode;
function $2df2897c2ec768dd$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $9X7IJ.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($2df2897c2ec768dd$export$f4de434b269fe487);
    var context = (0, $8nd05.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$2df2897c2ec768dd$var$injectFirstNode) {
            var head = document.head;
            $2df2897c2ec768dd$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($2df2897c2ec768dd$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $f88hq.create)({
            plugins: (0, $hKuvS.default)().plugins,
            insertionPoint: $2df2897c2ec768dd$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2df2897c2ec768dd$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("c1WaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c22b3722ab1cf60$export$2e2bcd8739ae039);

var $bh5Jy = parcelRequire("bh5Jy");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $8c22b3722ab1cf60$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $8c22b3722ab1cf60$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($8c22b3722ab1cf60$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $bh5Jy.default] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("bh5Jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8355bad52e752880$export$2e2bcd8739ae039);
var $8355bad52e752880$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $8355bad52e752880$export$2e2bcd8739ae039 = $8355bad52e752880$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("hKuvS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cebe66cb81fac901$export$2e2bcd8739ae039);

var $f6oht = parcelRequire("f6oht");

var $29zp1 = parcelRequire("29zp1");

var $dj0fa = parcelRequire("dj0fa");

var $87e0Y = parcelRequire("87e0Y");

var $75add = parcelRequire("75add");

var $81Rrl = parcelRequire("81Rrl");

var $3TmXG = parcelRequire("3TmXG");
function $cebe66cb81fac901$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $f6oht.default)(),
            (0, $29zp1.default)(),
            (0, $dj0fa.default)(),
            (0, $87e0Y.default)(),
            (0, $75add.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $81Rrl.default)(),
            (0, $3TmXG.default)()
        ]
    };
}

});
parcelRegister("f6oht", function(module, exports) {

$parcel$export(module.exports, "default", () => $afea4036e4b96092$export$2e2bcd8739ae039);


var $f88hq = parcelRequire("f88hq");
var $afea4036e4b96092$var$now = Date.now();
var $afea4036e4b96092$var$fnValuesNs = "fnValues" + $afea4036e4b96092$var$now;
var $afea4036e4b96092$var$fnRuleNs = "fnStyle" + ++$afea4036e4b96092$var$now;
var $afea4036e4b96092$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $f88hq.createRule)(name, {}, options);
            rule[$afea4036e4b96092$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($afea4036e4b96092$var$fnValuesNs in rule || $afea4036e4b96092$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$afea4036e4b96092$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$afea4036e4b96092$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$afea4036e4b96092$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $afea4036e4b96092$export$2e2bcd8739ae039 = $afea4036e4b96092$var$functionPlugin;

});

parcelRegister("29zp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1917e24186a6046e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $f88hq = parcelRequire("f88hq");
var $1917e24186a6046e$var$at = '@global';
var $1917e24186a6046e$var$atPrefix = '@global ';
var $1917e24186a6046e$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $f88hq.RuleList)((0, $8nd05.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $1917e24186a6046e$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $1917e24186a6046e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($1917e24186a6046e$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $8nd05.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $1917e24186a6046e$var$separatorRegExp = /\s*,\s*/g;
function $1917e24186a6046e$var$addScope(selector, scope) {
    var parts = selector.split($1917e24186a6046e$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$1917e24186a6046e$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $8nd05.default)({}, options, {
        selector: $1917e24186a6046e$var$addScope(name, rule.selector)
    }));
    delete style[$1917e24186a6046e$var$at];
}
function $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $1917e24186a6046e$var$at.length) !== $1917e24186a6046e$var$at) continue;
        var selector = $1917e24186a6046e$var$addScope(prop.substr($1917e24186a6046e$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $8nd05.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $1917e24186a6046e$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $1917e24186a6046e$var$at) return new $1917e24186a6046e$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $1917e24186a6046e$var$atPrefix.length) === $1917e24186a6046e$var$atPrefix) return new $1917e24186a6046e$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $1917e24186a6046e$var$handleNestedGlobalContainerRule(rule, sheet);
        $1917e24186a6046e$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $1917e24186a6046e$export$2e2bcd8739ae039 = $1917e24186a6046e$var$jssGlobal;

});

parcelRegister("dj0fa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afd3d12d6cbc635$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9afd3d12d6cbc635$var$separatorRegExp = /\s*,\s*/g;
var $9afd3d12d6cbc635$var$parentRegExp = /&/g;
var $9afd3d12d6cbc635$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $9afd3d12d6cbc635$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($9afd3d12d6cbc635$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($9afd3d12d6cbc635$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $8nd05.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $8nd05.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($9afd3d12d6cbc635$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $8nd05.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $8nd05.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $9afd3d12d6cbc635$export$2e2bcd8739ae039 = $9afd3d12d6cbc635$var$jssNested;

});

parcelRegister("87e0Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e89d92f45e570c6$export$2e2bcd8739ae039);

var $hrHWs = parcelRequire("hrHWs");
/**
 * Convert camel cased property names to dash separated.
 */ function $5e89d92f45e570c6$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $hrHWs.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($5e89d92f45e570c6$var$convertCase);
        else converted.fallbacks = $5e89d92f45e570c6$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $5e89d92f45e570c6$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $5e89d92f45e570c6$var$convertCase(style[index]);
            return style;
        }
        return $5e89d92f45e570c6$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $hrHWs.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5e89d92f45e570c6$export$2e2bcd8739ae039 = $5e89d92f45e570c6$var$camelCase;

});
parcelRegister("hrHWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb370b3f4a9491f5$export$2e2bcd8739ae039);
/* eslint-disable no-var, prefer-template */ var $cb370b3f4a9491f5$var$uppercasePattern = /[A-Z]/g;
var $cb370b3f4a9491f5$var$msPattern = /^ms-/;
var $cb370b3f4a9491f5$var$cache = {};
function $cb370b3f4a9491f5$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $cb370b3f4a9491f5$var$hyphenateStyleName(name) {
    if ($cb370b3f4a9491f5$var$cache.hasOwnProperty(name)) return $cb370b3f4a9491f5$var$cache[name];
    var hName = name.replace($cb370b3f4a9491f5$var$uppercasePattern, $cb370b3f4a9491f5$var$toHyphenLower);
    return $cb370b3f4a9491f5$var$cache[name] = $cb370b3f4a9491f5$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $cb370b3f4a9491f5$export$2e2bcd8739ae039 = $cb370b3f4a9491f5$var$hyphenateStyleName;

});


parcelRegister("75add", function(module, exports) {

$parcel$export(module.exports, "default", () => $5280ebef38a3c5c6$export$2e2bcd8739ae039);

var $f88hq = parcelRequire("f88hq");
var $5280ebef38a3c5c6$var$px = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $5280ebef38a3c5c6$var$ms = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $5280ebef38a3c5c6$var$percent = (0, $f88hq.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $5280ebef38a3c5c6$var$defaultUnits = {
    // Animation properties
    'animation-delay': $5280ebef38a3c5c6$var$ms,
    'animation-duration': $5280ebef38a3c5c6$var$ms,
    // Background properties
    'background-position': $5280ebef38a3c5c6$var$px,
    'background-position-x': $5280ebef38a3c5c6$var$px,
    'background-position-y': $5280ebef38a3c5c6$var$px,
    'background-size': $5280ebef38a3c5c6$var$px,
    // Border Properties
    border: $5280ebef38a3c5c6$var$px,
    'border-bottom': $5280ebef38a3c5c6$var$px,
    'border-bottom-left-radius': $5280ebef38a3c5c6$var$px,
    'border-bottom-right-radius': $5280ebef38a3c5c6$var$px,
    'border-bottom-width': $5280ebef38a3c5c6$var$px,
    'border-left': $5280ebef38a3c5c6$var$px,
    'border-left-width': $5280ebef38a3c5c6$var$px,
    'border-radius': $5280ebef38a3c5c6$var$px,
    'border-right': $5280ebef38a3c5c6$var$px,
    'border-right-width': $5280ebef38a3c5c6$var$px,
    'border-top': $5280ebef38a3c5c6$var$px,
    'border-top-left-radius': $5280ebef38a3c5c6$var$px,
    'border-top-right-radius': $5280ebef38a3c5c6$var$px,
    'border-top-width': $5280ebef38a3c5c6$var$px,
    'border-width': $5280ebef38a3c5c6$var$px,
    'border-block': $5280ebef38a3c5c6$var$px,
    'border-block-end': $5280ebef38a3c5c6$var$px,
    'border-block-end-width': $5280ebef38a3c5c6$var$px,
    'border-block-start': $5280ebef38a3c5c6$var$px,
    'border-block-start-width': $5280ebef38a3c5c6$var$px,
    'border-block-width': $5280ebef38a3c5c6$var$px,
    'border-inline': $5280ebef38a3c5c6$var$px,
    'border-inline-end': $5280ebef38a3c5c6$var$px,
    'border-inline-end-width': $5280ebef38a3c5c6$var$px,
    'border-inline-start': $5280ebef38a3c5c6$var$px,
    'border-inline-start-width': $5280ebef38a3c5c6$var$px,
    'border-inline-width': $5280ebef38a3c5c6$var$px,
    'border-start-start-radius': $5280ebef38a3c5c6$var$px,
    'border-start-end-radius': $5280ebef38a3c5c6$var$px,
    'border-end-start-radius': $5280ebef38a3c5c6$var$px,
    'border-end-end-radius': $5280ebef38a3c5c6$var$px,
    // Margin properties
    margin: $5280ebef38a3c5c6$var$px,
    'margin-bottom': $5280ebef38a3c5c6$var$px,
    'margin-left': $5280ebef38a3c5c6$var$px,
    'margin-right': $5280ebef38a3c5c6$var$px,
    'margin-top': $5280ebef38a3c5c6$var$px,
    'margin-block': $5280ebef38a3c5c6$var$px,
    'margin-block-end': $5280ebef38a3c5c6$var$px,
    'margin-block-start': $5280ebef38a3c5c6$var$px,
    'margin-inline': $5280ebef38a3c5c6$var$px,
    'margin-inline-end': $5280ebef38a3c5c6$var$px,
    'margin-inline-start': $5280ebef38a3c5c6$var$px,
    // Padding properties
    padding: $5280ebef38a3c5c6$var$px,
    'padding-bottom': $5280ebef38a3c5c6$var$px,
    'padding-left': $5280ebef38a3c5c6$var$px,
    'padding-right': $5280ebef38a3c5c6$var$px,
    'padding-top': $5280ebef38a3c5c6$var$px,
    'padding-block': $5280ebef38a3c5c6$var$px,
    'padding-block-end': $5280ebef38a3c5c6$var$px,
    'padding-block-start': $5280ebef38a3c5c6$var$px,
    'padding-inline': $5280ebef38a3c5c6$var$px,
    'padding-inline-end': $5280ebef38a3c5c6$var$px,
    'padding-inline-start': $5280ebef38a3c5c6$var$px,
    // Mask properties
    'mask-position-x': $5280ebef38a3c5c6$var$px,
    'mask-position-y': $5280ebef38a3c5c6$var$px,
    'mask-size': $5280ebef38a3c5c6$var$px,
    // Width and height properties
    height: $5280ebef38a3c5c6$var$px,
    width: $5280ebef38a3c5c6$var$px,
    'min-height': $5280ebef38a3c5c6$var$px,
    'max-height': $5280ebef38a3c5c6$var$px,
    'min-width': $5280ebef38a3c5c6$var$px,
    'max-width': $5280ebef38a3c5c6$var$px,
    // Position properties
    bottom: $5280ebef38a3c5c6$var$px,
    left: $5280ebef38a3c5c6$var$px,
    top: $5280ebef38a3c5c6$var$px,
    right: $5280ebef38a3c5c6$var$px,
    inset: $5280ebef38a3c5c6$var$px,
    'inset-block': $5280ebef38a3c5c6$var$px,
    'inset-block-end': $5280ebef38a3c5c6$var$px,
    'inset-block-start': $5280ebef38a3c5c6$var$px,
    'inset-inline': $5280ebef38a3c5c6$var$px,
    'inset-inline-end': $5280ebef38a3c5c6$var$px,
    'inset-inline-start': $5280ebef38a3c5c6$var$px,
    // Shadow properties
    'box-shadow': $5280ebef38a3c5c6$var$px,
    'text-shadow': $5280ebef38a3c5c6$var$px,
    // Column properties
    'column-gap': $5280ebef38a3c5c6$var$px,
    'column-rule': $5280ebef38a3c5c6$var$px,
    'column-rule-width': $5280ebef38a3c5c6$var$px,
    'column-width': $5280ebef38a3c5c6$var$px,
    // Font and text properties
    'font-size': $5280ebef38a3c5c6$var$px,
    'font-size-delta': $5280ebef38a3c5c6$var$px,
    'letter-spacing': $5280ebef38a3c5c6$var$px,
    'text-decoration-thickness': $5280ebef38a3c5c6$var$px,
    'text-indent': $5280ebef38a3c5c6$var$px,
    'text-stroke': $5280ebef38a3c5c6$var$px,
    'text-stroke-width': $5280ebef38a3c5c6$var$px,
    'word-spacing': $5280ebef38a3c5c6$var$px,
    // Motion properties
    motion: $5280ebef38a3c5c6$var$px,
    'motion-offset': $5280ebef38a3c5c6$var$px,
    // Outline properties
    outline: $5280ebef38a3c5c6$var$px,
    'outline-offset': $5280ebef38a3c5c6$var$px,
    'outline-width': $5280ebef38a3c5c6$var$px,
    // Perspective properties
    perspective: $5280ebef38a3c5c6$var$px,
    'perspective-origin-x': $5280ebef38a3c5c6$var$percent,
    'perspective-origin-y': $5280ebef38a3c5c6$var$percent,
    // Transform properties
    'transform-origin': $5280ebef38a3c5c6$var$percent,
    'transform-origin-x': $5280ebef38a3c5c6$var$percent,
    'transform-origin-y': $5280ebef38a3c5c6$var$percent,
    'transform-origin-z': $5280ebef38a3c5c6$var$percent,
    // Transition properties
    'transition-delay': $5280ebef38a3c5c6$var$ms,
    'transition-duration': $5280ebef38a3c5c6$var$ms,
    // Alignment properties
    'vertical-align': $5280ebef38a3c5c6$var$px,
    'flex-basis': $5280ebef38a3c5c6$var$px,
    // Some random properties
    'shape-margin': $5280ebef38a3c5c6$var$px,
    size: $5280ebef38a3c5c6$var$px,
    gap: $5280ebef38a3c5c6$var$px,
    // Grid properties
    grid: $5280ebef38a3c5c6$var$px,
    'grid-gap': $5280ebef38a3c5c6$var$px,
    'row-gap': $5280ebef38a3c5c6$var$px,
    'grid-row-gap': $5280ebef38a3c5c6$var$px,
    'grid-column-gap': $5280ebef38a3c5c6$var$px,
    'grid-template-rows': $5280ebef38a3c5c6$var$px,
    'grid-template-columns': $5280ebef38a3c5c6$var$px,
    'grid-auto-rows': $5280ebef38a3c5c6$var$px,
    'grid-auto-columns': $5280ebef38a3c5c6$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $5280ebef38a3c5c6$var$px,
    'box-shadow-y': $5280ebef38a3c5c6$var$px,
    'box-shadow-blur': $5280ebef38a3c5c6$var$px,
    'box-shadow-spread': $5280ebef38a3c5c6$var$px,
    'font-line-height': $5280ebef38a3c5c6$var$px,
    'text-shadow-x': $5280ebef38a3c5c6$var$px,
    'text-shadow-y': $5280ebef38a3c5c6$var$px,
    'text-shadow-blur': $5280ebef38a3c5c6$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $5280ebef38a3c5c6$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $5280ebef38a3c5c6$var$units = $5280ebef38a3c5c6$var$addCamelCasedVersion($5280ebef38a3c5c6$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $5280ebef38a3c5c6$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $5280ebef38a3c5c6$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $5280ebef38a3c5c6$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $5280ebef38a3c5c6$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $5280ebef38a3c5c6$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $5280ebef38a3c5c6$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $5280ebef38a3c5c6$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $5280ebef38a3c5c6$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $5280ebef38a3c5c6$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $5280ebef38a3c5c6$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5280ebef38a3c5c6$export$2e2bcd8739ae039 = $5280ebef38a3c5c6$var$defaultUnit;

});

parcelRegister("81Rrl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d87dec9ac2db100$export$2e2bcd8739ae039);

var $WZ5By = parcelRequire("WZ5By");

var $f88hq = parcelRequire("f88hq");
/**
 * Add vendor prefix to a property name when needed.
 */ function $5d87dec9ac2db100$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $WZ5By.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $WZ5By.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $WZ5By.supportedValue)(supportedProp, (0, $f88hq.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $WZ5By.supportedValue)(prop, (0, $f88hq.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $5d87dec9ac2db100$export$2e2bcd8739ae039 = $5d87dec9ac2db100$var$jssVendorPrefixer;

});
parcelRegister("WZ5By", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", () => $0b14cdf9ea25e36f$export$b6aa0648d950180a);
$parcel$export(module.exports, "supportedProperty", () => $0b14cdf9ea25e36f$export$ce097f82c2e4551a);
$parcel$export(module.exports, "supportedValue", () => $0b14cdf9ea25e36f$export$511766124059c277);

var $ja49S = parcelRequire("ja49S");

var $kbxxf = parcelRequire("kbxxf");
// Export javascript style and css style vendor prefixes.
var $0b14cdf9ea25e36f$var$js = '';
var $0b14cdf9ea25e36f$var$css = '';
var $0b14cdf9ea25e36f$var$vendor = '';
var $0b14cdf9ea25e36f$var$browser = '';
var $0b14cdf9ea25e36f$var$isTouch = (0, $ja49S.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $ja49S.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $0b14cdf9ea25e36f$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $0b14cdf9ea25e36f$var$_document$createEleme = document.createElement('p'), $0b14cdf9ea25e36f$var$style = $0b14cdf9ea25e36f$var$_document$createEleme.style;
    var $0b14cdf9ea25e36f$var$testProp = 'Transform';
    for(var $0b14cdf9ea25e36f$var$key in $0b14cdf9ea25e36f$var$jsCssMap)if ($0b14cdf9ea25e36f$var$key + $0b14cdf9ea25e36f$var$testProp in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = $0b14cdf9ea25e36f$var$key;
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap[$0b14cdf9ea25e36f$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($0b14cdf9ea25e36f$var$js === 'Webkit' && 'msHyphens' in $0b14cdf9ea25e36f$var$style) {
        $0b14cdf9ea25e36f$var$js = 'ms';
        $0b14cdf9ea25e36f$var$css = $0b14cdf9ea25e36f$var$jsCssMap.ms;
        $0b14cdf9ea25e36f$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($0b14cdf9ea25e36f$var$js === 'Webkit' && '-apple-trailing-word' in $0b14cdf9ea25e36f$var$style) $0b14cdf9ea25e36f$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $0b14cdf9ea25e36f$export$82e9f45cca5ba907 = {
    js: $0b14cdf9ea25e36f$var$js,
    css: $0b14cdf9ea25e36f$var$css,
    vendor: $0b14cdf9ea25e36f$var$vendor,
    browser: $0b14cdf9ea25e36f$var$browser,
    isTouch: $0b14cdf9ea25e36f$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $0b14cdf9ea25e36f$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $0b14cdf9ea25e36f$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $0b14cdf9ea25e36f$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Webkit') return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$camelize(str) {
    return str.replace($0b14cdf9ea25e36f$var$regExp, $0b14cdf9ea25e36f$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$pascalize(str) {
    return $0b14cdf9ea25e36f$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $0b14cdf9ea25e36f$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($0b14cdf9ea25e36f$var$camelize(longhand) in style) return prop;
            if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(longhand) in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $0b14cdf9ea25e36f$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === 'apple' && !$0b14cdf9ea25e36f$export$82e9f45cca5ba907.isTouch) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $0b14cdf9ea25e36f$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $0b14cdf9ea25e36f$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $0b14cdf9ea25e36f$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Webkit' || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'ms' && $0b14cdf9ea25e36f$export$82e9f45cca5ba907.browser !== 'edge') return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $0b14cdf9ea25e36f$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Moz' || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'ms' || $0b14cdf9ea25e36f$export$82e9f45cca5ba907.vendor === 'apple') return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $0b14cdf9ea25e36f$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return jsProp in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $0b14cdf9ea25e36f$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $0b14cdf9ea25e36f$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $0b14cdf9ea25e36f$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $0b14cdf9ea25e36f$var$camelize(prop) in style ? prop : false;
    }
};
var $0b14cdf9ea25e36f$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $0b14cdf9ea25e36f$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + pascalized in style) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $0b14cdf9ea25e36f$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'ms') return "" + $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $0b14cdf9ea25e36f$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js === 'ms') return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $0b14cdf9ea25e36f$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $0b14cdf9ea25e36f$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $0b14cdf9ea25e36f$var$propMap[prop];
        if (!newProp) return false;
        return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $0b14cdf9ea25e36f$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $0b14cdf9ea25e36f$var$propKeys = Object.keys($0b14cdf9ea25e36f$var$propMap$1);
var $0b14cdf9ea25e36f$var$prefixCss = function prefixCss(p) {
    return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $0b14cdf9ea25e36f$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($0b14cdf9ea25e36f$var$propKeys.indexOf(prop) > -1) {
            var newProp = $0b14cdf9ea25e36f$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp) in style ? $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($0b14cdf9ea25e36f$export$82e9f45cca5ba907.js + $0b14cdf9ea25e36f$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($0b14cdf9ea25e36f$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $0b14cdf9ea25e36f$var$plugins = [
    $0b14cdf9ea25e36f$var$appearence,
    $0b14cdf9ea25e36f$var$colorAdjust,
    $0b14cdf9ea25e36f$var$mask,
    $0b14cdf9ea25e36f$var$textOrientation,
    $0b14cdf9ea25e36f$var$transform,
    $0b14cdf9ea25e36f$var$transition,
    $0b14cdf9ea25e36f$var$writingMode,
    $0b14cdf9ea25e36f$var$userSelect,
    $0b14cdf9ea25e36f$var$breakPropsOld,
    $0b14cdf9ea25e36f$var$inlineLogicalOld,
    $0b14cdf9ea25e36f$var$unprefixed,
    $0b14cdf9ea25e36f$var$prefixed,
    $0b14cdf9ea25e36f$var$scrollSnap,
    $0b14cdf9ea25e36f$var$overscrollBehavior,
    $0b14cdf9ea25e36f$var$flex2012,
    $0b14cdf9ea25e36f$var$flex2009
];
var $0b14cdf9ea25e36f$var$propertyDetectors = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $0b14cdf9ea25e36f$var$noPrefill = $0b14cdf9ea25e36f$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $kbxxf.default)(p.noPrefill));
    return a;
}, []);
var $0b14cdf9ea25e36f$var$el;
var $0b14cdf9ea25e36f$var$cache = {};
if (0, $ja49S.default) {
    $0b14cdf9ea25e36f$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $0b14cdf9ea25e36f$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $0b14cdf9ea25e36f$var$key$1 in $0b14cdf9ea25e36f$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($0b14cdf9ea25e36f$var$key$1)) $0b14cdf9ea25e36f$var$cache[$0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1]] = $0b14cdf9ea25e36f$var$computed[$0b14cdf9ea25e36f$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $0b14cdf9ea25e36f$var$noPrefill.forEach(function(x) {
        return delete $0b14cdf9ea25e36f$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$0b14cdf9ea25e36f$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($0b14cdf9ea25e36f$var$cache[prop] != null) return $0b14cdf9ea25e36f$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $0b14cdf9ea25e36f$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $0b14cdf9ea25e36f$var$propertyDetectors.length; i++){
        $0b14cdf9ea25e36f$var$cache[prop] = $0b14cdf9ea25e36f$var$propertyDetectors[i](prop, $0b14cdf9ea25e36f$var$el.style, options); // Break loop, if value found.
        if ($0b14cdf9ea25e36f$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $0b14cdf9ea25e36f$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $0b14cdf9ea25e36f$var$cache[prop];
}
var $0b14cdf9ea25e36f$var$cache$1 = {};
var $0b14cdf9ea25e36f$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $0b14cdf9ea25e36f$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $0b14cdf9ea25e36f$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $0b14cdf9ea25e36f$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p1) : ", " + $0b14cdf9ea25e36f$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $ja49S.default) $0b14cdf9ea25e36f$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $0b14cdf9ea25e36f$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$0b14cdf9ea25e36f$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($0b14cdf9ea25e36f$var$cache$1[cacheKey] != null) return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($0b14cdf9ea25e36f$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($0b14cdf9ea25e36f$var$transPropsRegExp, $0b14cdf9ea25e36f$var$prefixTransitionCallback);
    else if ($0b14cdf9ea25e36f$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $0b14cdf9ea25e36f$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $0b14cdf9ea25e36f$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $0b14cdf9ea25e36f$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($0b14cdf9ea25e36f$var$el$1.style[property] === '') {
            $0b14cdf9ea25e36f$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $0b14cdf9ea25e36f$var$el$1.style[property] = ''; // Write current value to cache.
    $0b14cdf9ea25e36f$var$cache$1[cacheKey] = prefixedValue;
    return $0b14cdf9ea25e36f$var$cache$1[cacheKey];
}

});


parcelRegister("3TmXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d5851d4b913d01d$export$2e2bcd8739ae039);
/**
 * Sort props by length.
 */ function $2d5851d4b913d01d$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $2d5851d4b913d01d$export$2e2bcd8739ae039 = $2d5851d4b913d01d$var$jssPropsSort;

});



parcelRegister("edKwj", function(module, exports) {

$parcel$export(module.exports, "increment", () => $a5a65d8b4db31f3c$export$a2647aa13413c947);
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $a5a65d8b4db31f3c$var$indexCounter = -1000000000;
function $a5a65d8b4db31f3c$export$a2647aa13413c947() {
    $a5a65d8b4db31f3c$var$indexCounter += 1;
    return $a5a65d8b4db31f3c$var$indexCounter;
}

});

parcelRegister("77xio", function(module, exports) {

$parcel$export(module.exports, "default", () => $52f303b00b2e0414$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("fSwVM");

var $izL69 = parcelRequire("izL69");

function $52f303b00b2e0414$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $8nd05.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $izL69.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});

parcelRegister("ei4PC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6767e97a39dccd9$export$2e2bcd8739ae039);
// We use the same empty object to ref count the styles that don't need a theme object.
var $a6767e97a39dccd9$var$noopTheme = {};
var $a6767e97a39dccd9$export$2e2bcd8739ae039 = $a6767e97a39dccd9$var$noopTheme;

});



parcelRegister("kQaj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2c0a8a0351a1ae8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $5MMTt = parcelRequire("5MMTt");

var $kpDC5 = parcelRequire("kpDC5");
function $f2c0a8a0351a1ae8$var$withStyles(stylesOrCreator, options) {
    return (0, $5MMTt.default)(stylesOrCreator, (0, $8nd05.default)({
        defaultTheme: (0, $kpDC5.default)
    }, options));
}
var $f2c0a8a0351a1ae8$export$2e2bcd8739ae039 = $f2c0a8a0351a1ae8$var$withStyles;

});
parcelRegister("5MMTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $43675cbaf8adb2d8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $9ORqK = parcelRequire("9ORqK");


var $cp2NC = parcelRequire("cp2NC");

var $kD2D5 = parcelRequire("kD2D5");

var $gkNc2 = parcelRequire("gkNc2");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $43675cbaf8adb2d8$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $9X7IJ.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $cp2NC.default)(stylesOrCreator, (0, $8nd05.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $9X7IJ.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $8nd05.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $gkNc2.default)() || defaultTheme;
                if (name) more = (0, $kD2D5.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(WithStyles, Component);
        return WithStyles;
    };
};
var $43675cbaf8adb2d8$export$2e2bcd8739ae039 = $43675cbaf8adb2d8$var$withStyles;

});
parcelRegister("kD2D5", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e0272eaaa661f3$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-syntax */ function $03e0272eaaa661f3$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});



parcelRegister("i1h3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1e58e0e7e6a39d9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");



var $1mPeS = parcelRequire("1mPeS");

var $kQaj4 = parcelRequire("kQaj4");

var $3Z9df = parcelRequire("3Z9df");


var $8XARg = parcelRequire("8XARg");

var $c9eEd = parcelRequire("c9eEd");

var $3Xov1 = parcelRequire("3Xov1");
var $d1e58e0e7e6a39d9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: 'hidden',
            transition: theme.transitions.create('height')
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: 'auto',
            overflow: 'visible'
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: 'hidden'
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: 'flex'
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: '100%'
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $d1e58e0e7e6a39d9$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $3Z9df.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $1mPeS.default) : _props$TransitionComp, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $c9eEd.default)();
    var timer = $acw62.useRef();
    var wrapperRef = $acw62.useRef(null);
    var autoTransitionDuration = $acw62.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === 'number' ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $acw62.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $acw62.useRef(null);
    var handleRef = (0, $3Xov1.default)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $eUqlC.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $8XARg.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $8XARg.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $acw62.createElement(TransitionComponent, (0, $8nd05.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            className: (0, $1SA7b.default)(classes.root, classes.container, className, {
                'entered': classes.entered,
                'exited': !inProp && collapsedSize === '0px' && classes.hidden
            }[state]),
            style: (0, $8nd05.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $acw62.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$d1e58e0e7e6a39d9$var$Collapse.muiSupportAuto = true;
var $d1e58e0e7e6a39d9$export$2e2bcd8739ae039 = (0, $kQaj4.default)($d1e58e0e7e6a39d9$export$9dd6ff9ea0189349, {
    name: 'MuiCollapse'
})($d1e58e0e7e6a39d9$var$Collapse);

});

parcelRegister("8DzwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $649d8625f2bd4c7a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $acw62 = parcelRequire("acw62");


var $1SA7b = parcelRequire("1SA7b");


var $kQaj4 = parcelRequire("kQaj4");

var $f9tk6 = parcelRequire("f9tk6");
var $649d8625f2bd4c7a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $649d8625f2bd4c7a$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $9X7IJ.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
        className: (0, $1SA7b.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $f9tk6.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $f9tk6.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $acw62.createElement("title", null, titleAccess) : null);
});
$649d8625f2bd4c7a$var$SvgIcon.muiName = 'SvgIcon';
var $649d8625f2bd4c7a$export$2e2bcd8739ae039 = (0, $kQaj4.default)($649d8625f2bd4c7a$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($649d8625f2bd4c7a$var$SvgIcon);

});
parcelRegister("f9tk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07e714550ec75bc$export$2e2bcd8739ae039);

var $gMaRA = parcelRequire("gMaRA");
function $b07e714550ec75bc$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $gMaRA.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("bH9Sz", function(module, exports) {

$parcel$export(module.exports, "default", () => $883b5fac682906d7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $bhX0S = parcelRequire("bhX0S");

var $3Xov1 = parcelRequire("3Xov1");

var $anQ6P = parcelRequire("anQ6P");

function $883b5fac682906d7$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $883b5fac682906d7$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $883b5fac682906d7$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
    var movedRef = $acw62.useRef(false);
    var nodeRef = $acw62.useRef(null);
    var activatedRef = $acw62.useRef(false);
    var syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $acw62.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $1u0KT.findDOMNode(instance);
    }, []);
    var handleRef = (0, $3Xov1.default)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $anQ6P.default)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $883b5fac682906d7$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $bhX0S.default)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $883b5fac682906d7$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $bhX0S.default)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $883b5fac682906d7$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $bhX0S.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.cloneElement(children, childrenProps));
}
var $883b5fac682906d7$export$2e2bcd8739ae039 = $883b5fac682906d7$var$ClickAwayListener;

});
parcelRegister("bhX0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $837f0f05a75630be$export$2e2bcd8739ae039);
function $837f0f05a75630be$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("anQ6P", function(module, exports) {

$parcel$export(module.exports, "default", () => $78f4792555064dc2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $78f4792555064dc2$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
function $78f4792555064dc2$export$2e2bcd8739ae039(fn) {
    var ref = $acw62.useRef(fn);
    $78f4792555064dc2$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $acw62.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});



parcelRegister("gsYK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2905bd5d6a67995d$export$2e2bcd8739ae039);
var $2905bd5d6a67995d$export$2e2bcd8739ae039 = {
    featuredApps: [
        'seonghapark/cloud-cover',
        'seonghapark/traffic-state',
        'seonghapark/solar-irradiance',
        'seonghapark/motion-analysis',
        'seonghapark/surface-water-detection',
        'seonghapark/motion-detector',
        'seonghapark/water-depth-estimator',
        'seonghapark/surface-water-classifier',
        'yonghokim/object-counter',
        'bhupendraraut/cloud-motion',
        'rjackson/weather-classification',
        'dariodematties/avian-diversity-monitoring',
        'dariodematties/sound-event-detection',
        'iperezx/wildfire-smoke-detection'
    ],
    samplers: [
        'theone/imagesampler',
        'theone/video-sampler',
        'seanshahkarami/audio-sampler',
        'seanshahkarami/air-quality',
        'bhupendraraut/mobotix-scan',
        'bhupendraraut/mobotix-sampler',
        'flozano/lorawan-listener'
    ],
    plugins: [
        'seanshahkarami/plugin-iio',
        'seanshahkarami/raingauge'
    ]
};

});

parcelRegister("gdr0J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("bcnr1", function(module, exports) {

$parcel$export(module.exports, "url", () => $e875f73a7a3f7f78$export$128fa18b7194ef);
$parcel$export(module.exports, "abort", () => $e875f73a7a3f7f78$export$5def58af4fd46132);
$parcel$export(module.exports, "cameraOrientations", () => $e875f73a7a3f7f78$export$16bc23fc60cd04a7);
$parcel$export(module.exports, "getData", () => $e875f73a7a3f7f78$export$7a171f172be0782e);
$parcel$export(module.exports, "NODE_STATUS_RANGE", () => $e875f73a7a3f7f78$export$e382fa75d599497f);
$parcel$export(module.exports, "getNodeData", () => $e875f73a7a3f7f78$export$caa1f1cf9a29e661);
$parcel$export(module.exports, "getSimpleNodeStatus", () => $e875f73a7a3f7f78$export$59c4cabd2ab65dad);
$parcel$export(module.exports, "aggregateMetrics", () => $e875f73a7a3f7f78$export$d418a95a5b003805);
$parcel$export(module.exports, "getSanityData", () => $e875f73a7a3f7f78$export$b0d7c94e89d9290f);
$parcel$export(module.exports, "getDeviceHealthSummary", () => $e875f73a7a3f7f78$export$f4b13377c914ef18);
$parcel$export(module.exports, "getRecentImagesV2", () => $e875f73a7a3f7f78$export$67cb11dab818877d);
$parcel$export(module.exports, "getLatestAudio", () => $e875f73a7a3f7f78$export$ccf183fdc19a5f5c);
$parcel$export(module.exports, "getRecentRecord", () => $e875f73a7a3f7f78$export$71ae6272801b40b8);
$parcel$export(module.exports, "getGPS", () => $e875f73a7a3f7f78$export$7d1686e7f267f929);
$parcel$export(module.exports, "getPluginCounts", () => $e875f73a7a3f7f78$export$6155498f975a2f4c);
$parcel$export(module.exports, "getMediaCounts", () => $e875f73a7a3f7f78$export$eb11e48bc95fa009);
$parcel$export(module.exports, "getLoraWithRssi", () => $e875f73a7a3f7f78$export$312ffb1baa4c3391);
$parcel$export(module.exports, "createEventSource", () => $e875f73a7a3f7f78$export$e2b92a0132f9586f);
$parcel$export(module.exports, "retryHead", () => $e875f73a7a3f7f78$export$b0a44ff8f10c1f22);

var $gZwVy = parcelRequire("gZwVy");

var $5g1Ik = parcelRequire("5g1Ik");

var $f1q41 = parcelRequire("f1q41");
const $e875f73a7a3f7f78$export$128fa18b7194ef = (0, $gZwVy.default).beehive;
let $e875f73a7a3f7f78$var$_controller;
function $e875f73a7a3f7f78$export$5def58af4fd46132() {
    if (!$e875f73a7a3f7f78$var$_controller) return;
    $e875f73a7a3f7f78$var$_controller.abort();
}
const $e875f73a7a3f7f78$export$16bc23fc60cd04a7 = [
    'top',
    'left',
    'right',
    'bottom'
];
function $e875f73a7a3f7f78$var$post(endpoint, data = {}, signal) {
    return fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify(data),
        ...signal ? {
            signal: signal
        } : {}
    }).then((0, $5g1Ik.handleErrors));
}
async function $e875f73a7a3f7f78$export$7a171f172be0782e(params, abortable) {
    let signal;
    if (abortable) {
        $e875f73a7a3f7f78$var$_controller = new AbortController();
        signal = $e875f73a7a3f7f78$var$_controller.signal;
    }
    const res = await $e875f73a7a3f7f78$var$post(`${$e875f73a7a3f7f78$export$128fa18b7194ef}/query`, params, signal);
    const text = await res.text();
    if (!text) return [];
    const metrics = text.trim().split('\n').map((str)=>JSON.parse(str));
    return metrics;
}
const $e875f73a7a3f7f78$export$e382fa75d599497f = '-30d';
function $e875f73a7a3f7f78$export$caa1f1cf9a29e661() {
    const proms = [
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: $e875f73a7a3f7f78$export$e382fa75d599497f,
            filter: {
                name: 'sys.uptime'
            },
            tail: 1
        }),
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: '-6m',
            filter: {
                name: 'sys.gps.*'
            },
            tail: 1
        })
    ];
    return Promise.all(proms).then((recs)=>(0, $f1q41.flatten)(recs));
}
function $e875f73a7a3f7f78$export$9c497353504ddcb4() {
    const proms = [
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: $e875f73a7a3f7f78$export$e382fa75d599497f,
            filter: {
                name: 'sys.uptime'
            },
            tail: 1
        }),
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: '-6m',
            filter: {
                name: 'sys.gps.*|sys.mem.*|sys.mem.*|sys.fs.*'
            },
            tail: 1
        }),
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: '-6m',
            filter: {
                sensor: 'bme280',
                name: 'iio.in_temp_input'
            },
            tail: 1
        })
    ];
    return Promise.all(proms).then((recs)=>(0, $f1q41.flatten)(recs));
}
function $e875f73a7a3f7f78$export$5374007c78a5de46() {
    const proms = [
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: '-30d',
            filter: {
                name: 'sys.uptime'
            },
            tail: 1
        }),
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: '-4d',
            filter: {
                name: 'sys.net.ip',
                device: 'wan0'
            },
            tail: 1
        }),
        $e875f73a7a3f7f78$export$7a171f172be0782e({
            start: '-6m',
            filter: {
                sensor: 'bme280',
                name: 'iio.in_temp_input'
            },
            tail: 1
        })
    ];
    return Promise.all(proms).then((recs)=>(0, $f1q41.flatten)(recs));
}
async function $e875f73a7a3f7f78$export$59c4cabd2ab65dad(vsn) {
    const params = {
        start: '-4d',
        filter: {
            name: 'sys.uptime',
            vsn: vsn
        },
        tail: 1
    };
    const metrics = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    return metrics;
}
function $e875f73a7a3f7f78$export$d418a95a5b003805(data) {
    if (!data.length) return null;
    const byNode = {};
    data.forEach((obj)=>{
        const { timestamp: timestamp, name: name, value: value, meta: meta } = obj;
        const { node: node, vsn: vsn } = meta;
        let { host: host } = meta;
        // todo(nc): temp solution since IPs don't have a host?
        if (name == 'sys.net.ip') host = `${node}.ws-nxcore`;
        // if no node or host, don't include in aggregation
        if (!vsn || !host) return;
        // add entry for node
        if (!(vsn in byNode)) byNode[vsn] = {};
        if (!(host in byNode[vsn])) byNode[vsn][host] = {};
        const nodeData = byNode[vsn][host];
        // append data
        const record = {
            timestamp: timestamp,
            value: value,
            meta: meta
        };
        if (name in nodeData) nodeData[name].push(record);
        else nodeData[name] = [
            record
        ];
    });
    return byNode;
}
async function $e875f73a7a3f7f78$export$dba13b44cad23301(args) {
    const { vsn: vsn, start: start } = args || {};
    const params = {
        start: start ?? '-60h',
        bucket: 'health-check-test',
        filter: {
            name: 'node_health_check',
            ...vsn && {
                vsn: vsn
            }
        }
    };
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    const byNode = (0, $f1q41.groupBy)(data, 'meta.vsn');
    return byNode;
}
async function $e875f73a7a3f7f78$export$b0d7c94e89d9290f(args) {
    const { vsn: vsn, start: start = '-2d', end: end, name: name, tail: tail } = args || {};
    const params = {
        start: start,
        ...end && {
            end: end
        },
        filter: {
            name: name || 'sys.sanity_status.*',
            ...vsn && {
                vsn: vsn
            }
        },
        ...tail && {
            tail: tail
        }
    };
    const sanityTests = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    const byNode = $e875f73a7a3f7f78$export$d418a95a5b003805(sanityTests);
    return byNode;
}
async function $e875f73a7a3f7f78$export$f4b13377c914ef18(args) {
    const { vsn: vsn, start: start, device: device, tail: tail } = args || {};
    const params = {
        start: start ?? '-60h',
        bucket: 'health-check-test',
        filter: {
            name: 'device_health_check',
            ...vsn && {
                vsn: vsn
            },
            ...device && {
                device: device
            }
        },
        ...tail && {
            tail: tail
        }
    };
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    const byNode = (0, $f1q41.groupBy)(data, 'meta.vsn');
    const byNodeByName = {};
    (0, $f1q41.mapValues)(byNode, (objs, id)=>byNodeByName[id] = (0, $f1q41.groupBy)(objs, 'meta.device'));
    return vsn ? byNodeByName[vsn] : byNodeByName;
}
async function $e875f73a7a3f7f78$export$ca67e906ee69dcc7(args) {
    const { vsn: vsn, start: start } = args || {};
    const params = {
        bucket: 'downsampled-test',
        start: start ?? '-60h',
        filter: {
            name: 'sanity_test_.*',
            ...vsn && {
                vsn: vsn
            }
        }
    };
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    const byNode = (0, $f1q41.groupBy)(data, 'meta.vsn');
    // group records on the names of counts. i.e.,
    // {sanity_test_fail_total: [...], sanity_test_pass_total: [...], sanity_test_total: [...]}
    const byNodeByName = {};
    (0, $f1q41.mapValues)(byNode, (objs, id)=>byNodeByName[id] = (0, $f1q41.groupBy)(objs, 'name'));
    // summarize the tests by node
    const summary = {};
    Object.entries(byNodeByName).forEach(([vsn, obj])=>{
        const failObjs = obj['sanity_test_fail_total'];
        const totalObjs = obj['sanity_test_total'];
        if (failObjs.length !== totalObjs.length) throw 'something has gone terribly wrong with the influxdb aggregator!';
        const mergedObjs = failObjs.map((o, i)=>({
                ...o,
                totalCount: totalObjs[i].value
            })).filter((o)=>o.totalCount !== 0);
        summary[vsn] = mergedObjs;
    });
    return summary;
}
async function $e875f73a7a3f7f78$var$_findLatestAvail(data, position, onProgress) {
    if (!data) return null;
    // we'll start with newest
    data.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
    // sequentially attempt to fetch data until we get a 200 response (and include size)
    let latest, i = 1;
    for (const obj of data){
        latest = await fetch(obj.value.toString(), {
            method: 'HEAD'
        }).then((res)=>{
            if (onProgress) onProgress(position, i);
            const size = parseInt(res.headers.get('x-object-content-length') || res.headers.get('content-length'));
            return res.ok ? {
                ...obj,
                size: size
            } : null;
        });
        i++;
        if (latest) break;
    }
    return latest;
}
async function $e875f73a7a3f7f78$export$7655f46ee4d21211(vsn, onStart, onProgress) {
    // requests for each orientation
    const reqs = $e875f73a7a3f7f78$export$16bc23fc60cd04a7.map((pos)=>{
        const params = {
            start: '-1d',
            filter: {
                name: 'upload',
                vsn: vsn,
                task: `imagesampler-${pos}`
            }
        };
        return $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    });
    // find latest in storage for each position
    const mapping = Promise.all(reqs).then(async (data)=>{
        if (onStart) $e875f73a7a3f7f78$export$16bc23fc60cd04a7.forEach((pos, i)=>{
            onStart(pos, data[i]?.length);
        });
        const proms = data.map((d, i)=>{
            const position = $e875f73a7a3f7f78$export$16bc23fc60cd04a7[i];
            d = d.filter((o)=>/\.jpg$/g.test(o.value)) // need to only consider images
            ;
            return $e875f73a7a3f7f78$var$_findLatestAvail(d, position, onProgress);
        });
        const dataList = await Promise.all(proms);
        // reduce into mapping: {top: {...}, left, {...}, ... ,}
        const dataByPos = $e875f73a7a3f7f78$export$16bc23fc60cd04a7.reduce((acc, pos, i)=>({
                ...acc,
                [pos]: dataList[i]
            }), {});
        return dataByPos;
    });
    return mapping;
}
async function $e875f73a7a3f7f78$export$67cb11dab818877d(vsn, cameras, onStart, onProgress) {
    // requests for each orientation
    const reqs = cameras.map((camera)=>{
        const params = {
            start: '-1d',
            filter: {
                name: 'upload',
                vsn: vsn,
                camera: camera
            }
        };
        return $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    });
    // find latest in storage for each position
    const mapping = Promise.all(reqs).then(async (data)=>{
        if (onStart) cameras.forEach((pos, i)=>{
            onStart(pos, data[i]?.length);
        });
        const proms = data.map((d, i)=>{
            const position = cameras[i];
            d = d.filter((o)=>/\.jpg$/g.test(o.value)) // need to only consider images
            ;
            return $e875f73a7a3f7f78$var$_findLatestAvail(d, position, onProgress);
        });
        const dataList = await Promise.all(proms);
        // reduce into mapping: {top: {...}, left, {...}, ... ,}
        const dataByPos = cameras.reduce((acc, name, i)=>({
                ...acc,
                [name]: dataList[i]
            }), {});
        return dataByPos;
    });
    return mapping;
}
async function $e875f73a7a3f7f78$export$ccf183fdc19a5f5c(vsn) {
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e({
        start: '-1d',
        filter: {
            name: 'upload',
            vsn: vsn,
            filename: '*.flac'
        }
    });
    const latestAvail = await $e875f73a7a3f7f78$var$_findLatestAvail(data);
    return latestAvail;
}
async function $e875f73a7a3f7f78$export$71ae6272801b40b8(args) {
    const { node: node, vsn: vsn, name: name, sensor: sensor, deviceName: deviceName, start: start = '-4d', tail: tail = null } = args;
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e({
        start: start,
        filter: {
            ...node && {
                node: node
            },
            ...vsn && {
                vsn: vsn
            },
            ...name && {
                name: name
            },
            ...sensor && {
                sensor: sensor
            },
            ...deviceName && {
                deviceName: deviceName
            } // lora
        },
        ...tail && {
            tail: tail
        }
    });
    // take sort in event that the VSN or id changed
    return data.sort((a, b)=>new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
}
async function $e875f73a7a3f7f78$export$7d1686e7f267f929(vsn) {
    const d = await $e875f73a7a3f7f78$export$7a171f172be0782e({
        start: '-30d',
        filter: {
            name: 'sys.gps.*',
            vsn: vsn
        },
        tail: 1
    });
    const latRecord = d.find((o)=>o.name === 'sys.gps.lat');
    const lonRecord = d.find((o)=>o.name === 'sys.gps.lon');
    const lat = latRecord?.value;
    const lon = lonRecord?.value;
    if (!lat || !lon) return null;
    return {
        lat: lat,
        lon: lon,
        timestamp: latRecord.timestamp // note: gps components have same timestamp
    };
}
async function $e875f73a7a3f7f78$export$6155498f975a2f4c(props) {
    const { start: start, end: end, vsn: vsn, plugin: plugin, tail: tail } = props;
    const params = {
        bucket: 'plugin-stats',
        start: start || '-30d',
        ...end && {
            end: end
        },
        ...tail && {
            tail: tail
        },
        filter: {
            ...vsn && {
                vsn: vsn
            },
            ...plugin && {
                plugin: plugin
            }
        }
    };
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    return data;
}
async function $e875f73a7a3f7f78$export$3865c5b8fe3c995e(props) {
    const { vsn: vsn, plugin: plugin } = props;
    const params = {
        bucket: 'plugin-stats',
        start: '-999y',
        head: 1,
        filter: {
            ...vsn && {
                vsn: vsn
            },
            ...plugin && {
                plugin: plugin
            }
        }
    };
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    return data;
}
async function $e875f73a7a3f7f78$export$eb11e48bc95fa009(props) {
    const { start: start, end: end, vsn: vsn, tail: tail } = props;
    const params = {
        bucket: 'upload-stats',
        start: start || '-30d',
        ...end && {
            end: end
        },
        ...tail && {
            tail: tail
        },
        filter: {
            ...vsn && {
                vsn: vsn
            }
        }
    };
    const data = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    return data;
}
async function $e875f73a7a3f7f78$var$getRssis(vsn, devEuis) {
    const devEui = Array.isArray(devEuis) ? devEuis.join('|') : devEuis;
    const params = {
        start: $e875f73a7a3f7f78$export$e382fa75d599497f,
        filter: {
            name: 'signal.rssi',
            vsn: vsn,
            devEui: devEui
        },
        tail: 1
    };
    const metrics = await $e875f73a7a3f7f78$export$7a171f172be0782e(params);
    const byDevEui = (0, $f1q41.groupBy)(metrics, 'meta.devEui');
    const rssiDict = Object.keys(byDevEui).reduce((acc, eui)=>({
            ...acc,
            [eui]: byDevEui[eui].pop()
        }), {});
    return rssiDict;
}
async function $e875f73a7a3f7f78$export$312ffb1baa4c3391(manifest) {
    const { vsn: vsn, lorawanconnections: lorawanconnections } = manifest;
    const devEuis = lorawanconnections.map((row)=>row.deveui);
    const rssiByDevEui = await $e875f73a7a3f7f78$var$getRssis(vsn, devEuis);
    const dataWithRssi = lorawanconnections.map((row)=>{
        const rssiDict = rssiByDevEui[row.deveui];
        const value = rssiDict ? rssiDict.value : null;
        return {
            ...row,
            rssi: value
        };
    });
    return dataWithRssi;
}
function $e875f73a7a3f7f78$export$e2b92a0132f9586f(props) {
    const { vsn: vsn, task: task } = props;
    const eventSource = new EventSource(`https://data.sagecontinuum.org/api/v0/stream?vsn=${vsn}&task=${task}`);
    return eventSource;
}
async function $e875f73a7a3f7f78$export$b0a44ff8f10c1f22(url, opts = {}) {
    const { retries: retries = 5, backoff: backoff = 1000 // milliseconds
     } = opts;
    // sequentially attempt to fetch data until we get a 200 response (and include size)
    let latest;
    for(let i = 0; i <= retries; i++)try {
        const res = await fetch(url, {
            method: 'HEAD'
        });
        if (!res.ok) throw new Error(`Could not fetch upload: ${res.status}`);
        const size = parseInt(res.headers.get('x-object-content-length') || res.headers.get('content-length'));
        return {
            url: url,
            size: size
        };
    } catch (error) {
        if (i < retries) // If not the last retry, wait for the backoff time
        await new Promise((resolve)=>setTimeout(resolve, backoff * (i + 1)));
        else // If it was the last retry, throw the error
        throw error;
    }
    return latest;
}

});

parcelRegister("kalwe", function(module, exports) {

$parcel$export(module.exports, "tabLabel", () => $0b602a5bce51d0d8$export$8a547cb57e68436d);
$parcel$export(module.exports, "Tabs", () => (parcelRequire("aDtBU")).default);
$parcel$export(module.exports, "Tab", () => (parcelRequire("jNGAr")).default);

var $ayMG0 = parcelRequire("ayMG0");

var $aDtBU = parcelRequire("aDtBU");

var $jNGAr = parcelRequire("jNGAr");
const $0b602a5bce51d0d8$export$8a547cb57e68436d = (icon, label, counts = {})=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            icon,
            "\xa0",
            label,
            "\xa0",
            label in counts && counts[label] === undefined && "(\u2026)",
            counts[label] !== undefined && `(${counts[label]})`
        ]
    });

});
parcelRegister("aDtBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be483edbed3b474$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $1iGrQ = parcelRequire("1iGrQ");

var $kRsYK = parcelRequire("kRsYK");

var $l0ZbI = parcelRequire("l0ZbI");

var $dz5QO = parcelRequire("dz5QO");

var $4o7uD = parcelRequire("4o7uD");

var $bTm2Q = parcelRequire("bTm2Q");

var $gzyUk = parcelRequire("gzyUk");

var $9Evvr = parcelRequire("9Evvr");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7be483edbed3b474$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $7be483edbed3b474$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $7be483edbed3b474$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $7be483edbed3b474$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bTm2Q.getTabsUtilityClass), classes);
};
const $7be483edbed3b474$var$TabsRoot = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $bTm2Q.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $bTm2Q.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $bTm2Q.default).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScroller = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $7be483edbed3b474$var$List = (0, $d8seH.default)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $7be483edbed3b474$var$TabsIndicator = (0, $d8seH.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $7be483edbed3b474$var$TabsScrollbarSize = (0, $d8seH.default)((0, $l0ZbI.default))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $7be483edbed3b474$var$defaultIndicatorStyle = {};
let $7be483edbed3b474$var$warnedOnceTabPresent = false;
const $7be483edbed3b474$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $14H9o.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $7be483edbed3b474$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($7be483edbed3b474$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $4o7uD.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $kRsYK.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $6lpak.default)('scrollbar', {
        className: (0, $5FMfE.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $7be483edbed3b474$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $6lpak.default)('scrollButtons', {
        className: (0, $5FMfE.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $dz5QO.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $4o7uD.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $4o7uD.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $9Evvr.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($7be483edbed3b474$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $6lpak.default)('indicator', {
        className: (0, $5FMfE.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $7be483edbed3b474$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $gzyUk.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, currentFocus, $7be483edbed3b474$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $7be483edbed3b474$var$moveFocus(list, null, $7be483edbed3b474$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        className: (0, $5FMfE.default)(classes.root, className),
        elementType: $7be483edbed3b474$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $6lpak.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $7be483edbed3b474$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $6lpak.default)('list', {
        ref: tabListRef,
        className: (0, $5FMfE.default)(classes.list, classes.flexContainer),
        elementType: $7be483edbed3b474$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $7be483edbed3b474$export$2e2bcd8739ae039 = $7be483edbed3b474$var$Tabs;

});
parcelRegister("kRsYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ff3c73ed46b37c$export$2e2bcd8739ae039);
function $f2ff3c73ed46b37c$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $f2ff3c73ed46b37c$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $f2ff3c73ed46b37c$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("l0ZbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c90fbbf54d23af$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1iGrQ = parcelRequire("1iGrQ");

var $9Evvr = parcelRequire("9Evvr");
var $khjmj = parcelRequire("khjmj");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f4c90fbbf54d23af$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $f4c90fbbf54d23af$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $khjmj.default)(()=>{
        const handleResize = (0, $1iGrQ.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $9Evvr.default)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $f4c90fbbf54d23af$var$styles,
        ...other,
        ref: nodeRef
    });
}

});

parcelRegister("dz5QO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e031514df70ea8e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $frMNQ = parcelRequire("frMNQ");

var $f46un = parcelRequire("f46un");

var $6n0Ko = parcelRequire("6n0Ko");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $4CguH = parcelRequire("4CguH");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9e031514df70ea8e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4CguH.getTabScrollButtonUtilityClass), classes);
};
const $9e031514df70ea8e$var$TabScrollButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $4CguH.default).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $9e031514df70ea8e$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $9e031514df70ea8e$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $frMNQ.default);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $f46un.default);
    const startButtonIconProps = (0, $eD6Co.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $eD6Co.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9e031514df70ea8e$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $9e031514df70ea8e$export$2e2bcd8739ae039 = $9e031514df70ea8e$var$TabScrollButton;

});
parcelRegister("4CguH", function(module, exports) {

$parcel$export(module.exports, "getTabScrollButtonUtilityClass", () => $35c7816ebadb07c9$export$34861783d3c2eef8);
$parcel$export(module.exports, "default", () => $35c7816ebadb07c9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $35c7816ebadb07c9$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $35c7816ebadb07c9$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $35c7816ebadb07c9$export$2e2bcd8739ae039 = $35c7816ebadb07c9$var$tabScrollButtonClasses;

});


parcelRegister("bTm2Q", function(module, exports) {

$parcel$export(module.exports, "getTabsUtilityClass", () => $8a85ee70c626268d$export$cdd93bd054dec359);
$parcel$export(module.exports, "default", () => $8a85ee70c626268d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8a85ee70c626268d$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $8a85ee70c626268d$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $8a85ee70c626268d$export$2e2bcd8739ae039 = $8a85ee70c626268d$var$tabsClasses;

});


parcelRegister("jNGAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6a3a0c577f6eee9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");


var $jHfLJ = parcelRequire("jHfLJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e6a3a0c577f6eee9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $jTnBY.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jHfLJ.getTabUtilityClass), classes);
};
const $e6a3a0c577f6eee9$var$TabRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $jTnBY.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $jHfLJ.default).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $jHfLJ.default).icon}`]: styles.icon
            }
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $jHfLJ.default).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $jHfLJ.default).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $jHfLJ.default).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $jHfLJ.default).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $jHfLJ.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $jHfLJ.default).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $jHfLJ.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $e6a3a0c577f6eee9$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $e6a3a0c577f6eee9$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $5FMfE.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6a3a0c577f6eee9$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $e6a3a0c577f6eee9$export$2e2bcd8739ae039 = $e6a3a0c577f6eee9$var$Tab;

});
parcelRegister("jHfLJ", function(module, exports) {

$parcel$export(module.exports, "getTabUtilityClass", () => $e56e43dd06ac0faa$export$72aef224d6115253);
$parcel$export(module.exports, "default", () => $e56e43dd06ac0faa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e56e43dd06ac0faa$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $e56e43dd06ac0faa$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $e56e43dd06ac0faa$export$2e2bcd8739ae039 = $e56e43dd06ac0faa$var$tabClasses;

});



parcelRegister("2mdyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b78273c1c27a2e1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $9t5XO = parcelRequire("9t5XO");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1b78273c1c27a2e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9t5XO.getAccordionDetailsUtilityClass), classes);
};
const $1b78273c1c27a2e1$var$AccordionDetailsRoot = (0, $d8seH.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $1b78273c1c27a2e1$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $1b78273c1c27a2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1b78273c1c27a2e1$var$AccordionDetailsRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $1b78273c1c27a2e1$export$2e2bcd8739ae039 = $1b78273c1c27a2e1$var$AccordionDetails;

});
parcelRegister("9t5XO", function(module, exports) {

$parcel$export(module.exports, "getAccordionDetailsUtilityClass", () => $6e4b72c3145e33d8$export$a6afb527becfac26);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4b72c3145e33d8$export$a6afb527becfac26(slot) {
    return (0, $4Cod0.default)('MuiAccordionDetails', slot);
}
const $6e4b72c3145e33d8$var$accordionDetailsClasses = (0, $beCSm.default)('MuiAccordionDetails', [
    'root'
]);
var $6e4b72c3145e33d8$export$2e2bcd8739ae039 = $6e4b72c3145e33d8$var$accordionDetailsClasses;

});


parcelRegister("2gURC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a792f5a0c37e2ab$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $6n0Ko = parcelRequire("6n0Ko");

var $7Snug = parcelRequire("7Snug");

var $ijHn9 = parcelRequire("ijHn9");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a792f5a0c37e2ab$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ijHn9.getAccordionSummaryUtilityClass), classes);
};
const $1a792f5a0c37e2ab$var$AccordionSummaryRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $ijHn9.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $ijHn9.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $ijHn9.default).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $ijHn9.default).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $1a792f5a0c37e2ab$var$AccordionSummaryContent = (0, $d8seH.default)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $ijHn9.default).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper = (0, $d8seH.default)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $ijHn9.default).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $1a792f5a0c37e2ab$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $7Snug.default));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $1a792f5a0c37e2ab$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $5FMfE.default)(classes.root, className),
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $5FMfE.default)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $6lpak.default)('content', {
        className: classes.content,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $6lpak.default)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $1a792f5a0c37e2ab$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $ayMG0.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var $1a792f5a0c37e2ab$export$2e2bcd8739ae039 = $1a792f5a0c37e2ab$var$AccordionSummary;

});
parcelRegister("7Snug", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bbfcb95732dc207$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $5bbfcb95732dc207$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $5bbfcb95732dc207$export$2e2bcd8739ae039 = $5bbfcb95732dc207$var$AccordionContext;

});

parcelRegister("ijHn9", function(module, exports) {

$parcel$export(module.exports, "getAccordionSummaryUtilityClass", () => $d55ba52db43b55df$export$282216ad123d6580);
$parcel$export(module.exports, "default", () => $d55ba52db43b55df$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d55ba52db43b55df$export$282216ad123d6580(slot) {
    return (0, $4Cod0.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $beCSm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$export$2e2bcd8739ae039 = $d55ba52db43b55df$var$accordionSummaryClasses;

});


parcelRegister("9khrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $70debbeb7af9f113$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAccordionStyles", () => $70debbeb7af9f113$export$d8716a81161bb5d8);

var $lmFrL = parcelRequire("lmFrL");

var $7UqNi = parcelRequire("7UqNi");

var $1GFtd = parcelRequire("1GFtd");

var $fWOqm = parcelRequire("fWOqm");
var $70debbeb7af9f113$export$2e2bcd8739ae039 = (0, $lmFrL.default)((0, $7UqNi.default))`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 0 2px 2px 0 ;
  border-left: 2px solid #ddd;

  :hover:not(.Mui-expanded) {
    border-left: 2px solid rgb(28, 140, 201);
    .caret {
      color: rgb(28, 140, 201);
    }
  }

  .MuiAccordionSummary-content {
    display: block;
    margin: 10px 0;
  }

  .tag-actions {
    visibility: hidden;
  }

  :hover .tag-actions {
    visibility: visible;
  }
`;
const $70debbeb7af9f113$export$d8716a81161bb5d8 = (0, $1GFtd.default)((theme)=>(0, $fWOqm.default)({
        root: {
            marginBottom: -1,
            boxShadow: 'none'
        },
        heading: {
            fontWeight: 'bold',
            fontSize: theme.typography.pxToRem(15),
            flexBasis: '33.33%',
            flexShrink: 0
        },
        secondaryHeading: {
            marginRight: 'auto',
            fontSize: theme.typography.pxToRem(14),
            color: theme.palette.text.secondary
        }
    }));

});
parcelRegister("7UqNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c228c234852d575$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $bnA1h = parcelRequire("bnA1h");

var $7Frhn = parcelRequire("7Frhn");

var $7Snug = parcelRequire("7Snug");

var $3yddg = parcelRequire("3yddg");

var $6lpak = parcelRequire("6lpak");

var $jliMD = parcelRequire("jliMD");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5c228c234852d575$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jliMD.getAccordionUtilityClass), classes);
};
const $5c228c234852d575$var$AccordionRoot = (0, $d8seH.default)((0, $7Frhn.default), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $jliMD.default).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $jliMD.default).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $jliMD.default).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $aeD7H.default)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $jliMD.default).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $5c228c234852d575$var$AccordionHeading = (0, $d8seH.default)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading',
    overridesResolver: (props, styles)=>styles.heading
})({
    all: 'unset'
});
const $5c228c234852d575$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $3yddg.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $5c228c234852d575$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $5c228c234852d575$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $5FMfE.default)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        additionalProps: {
            square: square
        }
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $6lpak.default)('heading', {
        elementType: $5c228c234852d575$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $6lpak.default)('transition', {
        elementType: (0, $bnA1h.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7Snug.default).Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            })
        ]
    });
});
var $5c228c234852d575$export$2e2bcd8739ae039 = $5c228c234852d575$var$Accordion;

});
parcelRegister("jliMD", function(module, exports) {

$parcel$export(module.exports, "getAccordionUtilityClass", () => $e14e8c767477d992$export$80fb6a2cb3f13b8b);
$parcel$export(module.exports, "default", () => $e14e8c767477d992$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e14e8c767477d992$export$80fb6a2cb3f13b8b(slot) {
    return (0, $4Cod0.default)('MuiAccordion', slot);
}
const $e14e8c767477d992$var$accordionClasses = (0, $beCSm.default)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $e14e8c767477d992$export$2e2bcd8739ae039 = $e14e8c767477d992$var$accordionClasses;

});


parcelRegister("1GFtd", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a9e1ccd58618d1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $f88hq = parcelRequire("f88hq");

var $3ZPKo = parcelRequire("3ZPKo");

var $bNC8T = parcelRequire("bNC8T");

var $7dXaW = parcelRequire("7dXaW");

var $8P1M4 = parcelRequire("8P1M4");

var $9p8NW = parcelRequire("9p8NW");

var $f5fvw = parcelRequire("f5fvw");

var $5EhBI = parcelRequire("5EhBI");
'use client';
function $13a9e1ccd58618d1$var$getClasses({ state: state, stylesOptions: stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $3ZPKo.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $13a9e1ccd58618d1$var$attach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator, name: name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, $bNC8T.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $bNC8T.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = {
        ...stylesCreator.options,
        ...stylesOptions,
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    };
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $bNC8T.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, {
                link: false,
                ...options
            });
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $bNC8T.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $f88hq.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, {
            link: true,
            ...options
        });
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $3ZPKo.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $13a9e1ccd58618d1$var$update({ state: state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $13a9e1ccd58618d1$var$detach({ state: state, theme: theme, stylesOptions: stylesOptions, stylesCreator: stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, $bNC8T.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $bNC8T.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $13a9e1ccd58618d1$var$useSynchronousEffect(func, values) {
    const key = $acw62.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    const currentKey = $acw62.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    $acw62.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $13a9e1ccd58618d1$export$2e2bcd8739ae039(stylesOrCreator, options = {}) {
    const { name: // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component: Component, defaultTheme: defaultTheme = (0, $5EhBI.default), ...stylesOptions2 } = options;
    const stylesCreator = (0, $f5fvw.default)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $9p8NW.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, $7dXaW.default)() || defaultTheme;
        const stylesOptions = {
            ...$acw62.useContext((0, $8P1M4.StylesContext)),
            ...stylesOptions2
        };
        const instance = $acw62.useRef();
        const shouldUpdate = $acw62.useRef();
        $13a9e1ccd58618d1$var$useSynchronousEffect(()=>{
            const current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $13a9e1ccd58618d1$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                $13a9e1ccd58618d1$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        $acw62.useEffect(()=>{
            if (shouldUpdate.current) $13a9e1ccd58618d1$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = $13a9e1ccd58618d1$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("3ZPKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e8f358add423b98$export$2e2bcd8739ae039);

function $2e8f358add423b98$export$2e2bcd8739ae039(options = {}) {
    const { baseClasses: baseClasses, newClasses: newClasses, Component: Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = {
        ...baseClasses
    };
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}

});

parcelRegister("bNC8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $8971db9eb9bb20fc$export$2e2bcd8739ae039);
// Used https://github.com/thinkloop/multi-key-cache as inspiration
const $8971db9eb9bb20fc$var$multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $8971db9eb9bb20fc$export$2e2bcd8739ae039 = $8971db9eb9bb20fc$var$multiKeyStore;

});

parcelRegister("7dXaW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5427a657c32785a2$export$2e2bcd8739ae039);

var $lT1cX = parcelRequire("lT1cX");
function $5427a657c32785a2$export$2e2bcd8739ae039() {
    const privateTheme = (0, $lT1cX.default)();
    return privateTheme?.$$material ?? privateTheme;
}

});
parcelRegister("lT1cX", function(module, exports) {

$parcel$export(module.exports, "default", () => $feefabedf550ce3f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $fHPaR = parcelRequire("fHPaR");
function $feefabedf550ce3f$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $fHPaR.default));
    return theme;
}

});
parcelRegister("fHPaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f2914bcc222460$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $b6f2914bcc222460$export$2e2bcd8739ae039 = $b6f2914bcc222460$var$ThemeContext;

});



parcelRegister("8P1M4", function(module, exports) {

$parcel$export(module.exports, "StylesContext", () => $66c47682defefc53$export$f4de434b269fe487);

var $acw62 = parcelRequire("acw62");



var $f88hq = parcelRequire("f88hq");

var $hpAJe = parcelRequire("hpAJe");

var $JEeE3 = parcelRequire("JEeE3");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $66c47682defefc53$var$defaultJSS = (0, $f88hq.create)((0, $JEeE3.default)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const $66c47682defefc53$var$defaultGenerateClassName = (0, $hpAJe.default)();
const $66c47682defefc53$export$70a8aea9ff58d1cd = new Map();
const $66c47682defefc53$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $66c47682defefc53$var$defaultGenerateClassName,
    jss: $66c47682defefc53$var$defaultJSS,
    sheetsCache: null,
    sheetsManager: $66c47682defefc53$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
const $66c47682defefc53$export$f4de434b269fe487 = /*#__PURE__*/ $acw62.createContext($66c47682defefc53$var$defaultOptions);
let $66c47682defefc53$var$injectFirstNode;
function $66c47682defefc53$export$2e2bcd8739ae039(props) {
    const { children: children, injectFirst: injectFirst = false, disableGeneration: disableGeneration = false, ...localOptions } = props;
    const outerOptions = $acw62.useContext($66c47682defefc53$export$f4de434b269fe487);
    const { generateClassName: generateClassName, jss: jss, serverGenerateClassName: serverGenerateClassName, sheetsCache: sheetsCache, sheetsManager: sheetsManager, sheetsRegistry: sheetsRegistry } = {
        ...outerOptions,
        ...localOptions
    };
    const value = $acw62.useMemo(()=>{
        const context = {
            disableGeneration: disableGeneration,
            generateClassName: generateClassName,
            jss: jss,
            serverGenerateClassName: serverGenerateClassName,
            sheetsCache: sheetsCache,
            sheetsManager: sheetsManager,
            sheetsRegistry: sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
            if (!$66c47682defefc53$var$injectFirstNode) {
                const head = document.head;
                // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- injectFirstNode is called inside callback
                $66c47682defefc53$var$injectFirstNode = document.createComment('mui-inject-first');
                head.insertBefore($66c47682defefc53$var$injectFirstNode, head.firstChild);
            }
            context.jss = (0, $f88hq.create)({
                plugins: (0, $JEeE3.default)().plugins,
                insertionPoint: $66c47682defefc53$var$injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($66c47682defefc53$export$f4de434b269fe487.Provider, {
        value: value,
        children: children
    });
}

});
parcelRegister("hpAJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad142f86b77d6d8$export$2e2bcd8739ae039);

var $2NPLA = parcelRequire("2NPLA");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const $cad142f86b77d6d8$var$stateClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
];
function $cad142f86b77d6d8$export$2e2bcd8739ae039(options = {}) {
    const { disableGlobal: disableGlobal = false, productionPrefix: productionPrefix = 'jss', seed: seed = '' } = options;
    const seedPrefix = seed === '' ? '' : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.startsWith('Mui') && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($cad142f86b77d6d8$var$stateClasses.includes(rule.key)) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, $2NPLA.default] || seed !== '') return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}

});
parcelRegister("2NPLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $20a8501e6e2f4912$export$2e2bcd8739ae039);
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$export$2e2bcd8739ae039 = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("JEeE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369f56021741c$export$2e2bcd8739ae039);

var $f6oht = parcelRequire("f6oht");

var $29zp1 = parcelRequire("29zp1");

var $dj0fa = parcelRequire("dj0fa");

var $87e0Y = parcelRequire("87e0Y");

var $75add = parcelRequire("75add");

var $81Rrl = parcelRequire("81Rrl");

var $3TmXG = parcelRequire("3TmXG");
function $089369f56021741c$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $f6oht.default)(),
            (0, $29zp1.default)(),
            (0, $dj0fa.default)(),
            (0, $87e0Y.default)(),
            (0, $75add.default)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $81Rrl.default)(),
            (0, $3TmXG.default)()
        ]
    };
}

});


parcelRegister("9p8NW", function(module, exports) {

$parcel$export(module.exports, "increment", () => $6d8d47425bc40907$export$a2647aa13413c947);
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
let $6d8d47425bc40907$var$indexCounter = -1000000000;
function $6d8d47425bc40907$export$a2647aa13413c947() {
    $6d8d47425bc40907$var$indexCounter += 1;
    return $6d8d47425bc40907$var$indexCounter;
}

});

parcelRegister("f5fvw", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb35a18e8b17e0a$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $l3DCH = parcelRequire("l3DCH");

function $afb35a18e8b17e0a$export$2e2bcd8739ae039(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = {
                ...styles
            };
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, $3z1Ay.default)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, $l3DCH.default)(definition.props);
                stylesWithOverrides[classKey] = (0, $3z1Ay.default)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("l3DCH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5489d1d50f78a43$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
function $f5489d1d50f78a43$var$isEmpty(string) {
    return string.length === 0;
}
function $f5489d1d50f78a43$export$2e2bcd8739ae039(props) {
    const { variant: variant, ...other } = props;
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += $f5489d1d50f78a43$var$isEmpty(classKey) ? props[key] : (0, $gxvzd.default)(props[key]);
        else classKey += `${$f5489d1d50f78a43$var$isEmpty(classKey) ? key : (0, $gxvzd.default)(key)}${(0, $gxvzd.default)(props[key].toString())}`;
    });
    return classKey;
}

});


parcelRegister("5EhBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $41ce589cb6180c8f$export$2e2bcd8739ae039);
// We use the same empty object to ref count the styles that don't need a theme object.
const $41ce589cb6180c8f$var$noopTheme = {};
var $41ce589cb6180c8f$export$2e2bcd8739ae039 = $41ce589cb6180c8f$var$noopTheme;

});


parcelRegister("fWOqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9c362fbce901abe$export$2e2bcd8739ae039);
function $b9c362fbce901abe$export$2e2bcd8739ae039(styles) {
    return styles;
}

});


parcelRegister("2sxTc", function(module, exports) {

module.exports = (parcelRequire("914k8")).YAML;

});
parcelRegister("914k8", function(module, exports) {

$parcel$export(module.exports, "YAML", () => $69078fac725591aa$export$866dfa75bd13a786);

var $1GDs0 = parcelRequire("1GDs0");

var $ggmYK = parcelRequire("ggmYK");

var $2U8gU = parcelRequire("2U8gU");

var $M2XUi = parcelRequire("M2XUi");

var $2UQ0T = parcelRequire("2UQ0T");
var $69078fac725591aa$var$defaultOptions = {
    anchorPrefix: 'a',
    customTags: null,
    indent: 2,
    indentSeq: true,
    keepCstNodes: false,
    keepNodeTypes: true,
    keepBlobsInJSON: true,
    mapAsMap: false,
    maxAliasCount: 100,
    prettyErrors: false,
    // TODO Set true in v2
    simpleKeys: false,
    version: '1.2'
};
var $69078fac725591aa$var$scalarOptions = {
    get binary () {
        return 0, $2U8gU.b;
    },
    set binary (opt){
        Object.assign((0, $2U8gU.b), opt);
    },
    get bool () {
        return 0, $2U8gU.a;
    },
    set bool (opt){
        Object.assign((0, $2U8gU.a), opt);
    },
    get int () {
        return 0, $2U8gU.i;
    },
    set int (opt){
        Object.assign((0, $2U8gU.i), opt);
    },
    get null () {
        return 0, $2U8gU.n;
    },
    set null (opt){
        Object.assign((0, $2U8gU.n), opt);
    },
    get str () {
        return 0, $2U8gU.s;
    },
    set str (opt){
        Object.assign((0, $2U8gU.s), opt);
    }
};
var $69078fac725591aa$var$documentOptions = {
    '1.0': {
        schema: 'yaml-1.1',
        merge: true,
        tagPrefixes: [
            {
                handle: '!',
                prefix: (0, $1GDs0.d)
            },
            {
                handle: '!!',
                prefix: 'tag:private.yaml.org,2002:'
            }
        ]
    },
    1.1: {
        schema: 'yaml-1.1',
        merge: true,
        tagPrefixes: [
            {
                handle: '!',
                prefix: '!'
            },
            {
                handle: '!!',
                prefix: (0, $1GDs0.d)
            }
        ]
    },
    1.2: {
        schema: 'core',
        merge: false,
        tagPrefixes: [
            {
                handle: '!',
                prefix: '!'
            },
            {
                handle: '!!',
                prefix: (0, $1GDs0.d)
            }
        ]
    }
};
function $69078fac725591aa$var$stringifyTag(doc, tag) {
    if ((doc.version || doc.options.version) === '1.0') {
        var priv = tag.match(/^tag:private\.yaml\.org,2002:([^:/]+)$/);
        if (priv) return '!' + priv[1];
        var vocab = tag.match(/^tag:([a-zA-Z0-9-]+)\.yaml\.org,2002:(.*)/);
        return vocab ? "!".concat(vocab[1], "/").concat(vocab[2]) : "!".concat(tag.replace(/^tag:/, ''));
    }
    var p = doc.tagPrefixes.find(function(p) {
        return tag.indexOf(p.prefix) === 0;
    });
    if (!p) {
        var dtp = doc.getDefaults().tagPrefixes;
        p = dtp && dtp.find(function(p) {
            return tag.indexOf(p.prefix) === 0;
        });
    }
    if (!p) return tag[0] === '!' ? tag : "!<".concat(tag, ">");
    var suffix = tag.substr(p.prefix.length).replace(/[!,[\]{}]/g, function(ch) {
        return ({
            '!': '%21',
            ',': '%2C',
            '[': '%5B',
            ']': '%5D',
            '{': '%7B',
            '}': '%7D'
        })[ch];
    });
    return p.handle + suffix;
}
function $69078fac725591aa$var$getTagObject(tags, item) {
    if (item instanceof (0, $2U8gU.A)) return 0, $2U8gU.A;
    if (item.tag) {
        var match = tags.filter(function(t) {
            return t.tag === item.tag;
        });
        if (match.length > 0) return match.find(function(t) {
            return t.format === item.format;
        }) || match[0];
    }
    var tagObj, obj;
    if (item instanceof (0, $2U8gU.S)) {
        obj = item.value; // TODO: deprecate/remove class check
        var _match = tags.filter(function(t) {
            return t.identify && t.identify(obj) || t.class && obj instanceof t.class;
        });
        tagObj = _match.find(function(t) {
            return t.format === item.format;
        }) || _match.find(function(t) {
            return !t.format;
        });
    } else {
        obj = item;
        tagObj = tags.find(function(t) {
            return t.nodeClass && obj instanceof t.nodeClass;
        });
    }
    if (!tagObj) {
        var name = obj && obj.constructor ? obj.constructor.name : (0, $1GDs0.a)(obj);
        throw new Error("Tag not resolved for ".concat(name, " value"));
    }
    return tagObj;
} // needs to be called before value stringifier to allow for circular anchor refs
function $69078fac725591aa$var$stringifyProps(node, tagObj, _ref) {
    var anchors = _ref.anchors, doc = _ref.doc;
    var props = [];
    var anchor = doc.anchors.getName(node);
    if (anchor) {
        anchors[anchor] = node;
        props.push("&".concat(anchor));
    }
    if (node.tag) props.push($69078fac725591aa$var$stringifyTag(doc, node.tag));
    else if (!tagObj.default) props.push($69078fac725591aa$var$stringifyTag(doc, tagObj.tag));
    return props.join(' ');
}
function $69078fac725591aa$var$stringify$1(item, ctx, onComment, onChompKeep) {
    var _ctx$doc = ctx.doc, anchors = _ctx$doc.anchors, schema = _ctx$doc.schema;
    var tagObj;
    if (!(item instanceof (0, $2U8gU.N))) {
        var createCtx = {
            aliasNodes: [],
            onTagObj: function onTagObj(o) {
                return tagObj = o;
            },
            prevObjects: new Map()
        };
        item = schema.createNode(item, true, null, createCtx);
        var _iterator = (0, $1GDs0._)(createCtx.aliasNodes), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var alias = _step.value;
                alias.source = alias.source.node;
                var name = anchors.getName(alias.source);
                if (!name) {
                    name = anchors.newName();
                    anchors.map[name] = alias.source;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    if (item instanceof (0, $2U8gU.P)) return item.toString(ctx, onComment, onChompKeep);
    if (!tagObj) tagObj = $69078fac725591aa$var$getTagObject(schema.tags, item);
    var props = $69078fac725591aa$var$stringifyProps(item, tagObj, ctx);
    if (props.length > 0) ctx.indentAtStart = (ctx.indentAtStart || 0) + props.length + 1;
    var str = typeof tagObj.stringify === 'function' ? tagObj.stringify(item, ctx, onComment, onChompKeep) : item instanceof (0, $2U8gU.S) ? (0, $2U8gU.c)(item, ctx, onComment, onChompKeep) : item.toString(ctx, onComment, onChompKeep);
    if (!props) return str;
    return item instanceof (0, $2U8gU.S) || str[0] === '{' || str[0] === '[' ? "".concat(props, " ").concat(str) : "".concat(props, "\n").concat(ctx.indent).concat(str);
}
var $69078fac725591aa$var$Anchors = /*#__PURE__*/ function() {
    function Anchors(prefix) {
        (0, $1GDs0.c)(this, Anchors);
        (0, $1GDs0.e)(this, "map", Object.create(null));
        this.prefix = prefix;
    }
    (0, $1GDs0.b)(Anchors, [
        {
            key: "createAlias",
            value: function createAlias(node, name) {
                this.setAnchor(node, name);
                return new (0, $2U8gU.A)(node);
            }
        },
        {
            key: "createMergePair",
            value: function createMergePair() {
                var _this = this;
                var merge = new (0, $2U8gU.M)();
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                merge.value.items = sources.map(function(s) {
                    if (s instanceof (0, $2U8gU.A)) {
                        if (s.source instanceof (0, $2U8gU.d)) return s;
                    } else if (s instanceof (0, $2U8gU.d)) return _this.createAlias(s);
                    throw new Error('Merge sources must be Map nodes or their Aliases');
                });
                return merge;
            }
        },
        {
            key: "getName",
            value: function getName(node) {
                var map = this.map;
                return Object.keys(map).find(function(a) {
                    return map[a] === node;
                });
            }
        },
        {
            key: "getNames",
            value: function getNames() {
                return Object.keys(this.map);
            }
        },
        {
            key: "getNode",
            value: function getNode(name) {
                return this.map[name];
            }
        },
        {
            key: "newName",
            value: function newName(prefix) {
                if (!prefix) prefix = this.prefix;
                var names = Object.keys(this.map);
                for(var i = 1;; ++i){
                    var name = "".concat(prefix).concat(i);
                    if (!names.includes(name)) return name;
                }
            } // During parsing, map & aliases contain CST nodes
        },
        {
            key: "resolveNodes",
            value: function resolveNodes() {
                var map = this.map, _cstAliases = this._cstAliases;
                Object.keys(map).forEach(function(a) {
                    map[a] = map[a].resolved;
                });
                _cstAliases.forEach(function(a) {
                    a.source = a.source.resolved;
                });
                delete this._cstAliases;
            }
        },
        {
            key: "setAnchor",
            value: function setAnchor(node, name) {
                if (node != null && !Anchors.validAnchorNode(node)) throw new Error('Anchors may only be set for Scalar, Seq and Map nodes');
                if (name && /[\x00-\x19\s,[\]{}]/.test(name)) throw new Error('Anchor names must not contain whitespace or control characters');
                var map = this.map;
                var prev = node && Object.keys(map).find(function(a) {
                    return map[a] === node;
                });
                if (prev) {
                    if (!name) return prev;
                    else if (prev !== name) {
                        delete map[prev];
                        map[name] = node;
                    }
                } else {
                    if (!name) {
                        if (!node) return null;
                        name = this.newName();
                    }
                    map[name] = node;
                }
                return name;
            }
        }
    ], [
        {
            key: "validAnchorNode",
            value: function validAnchorNode(node) {
                return node instanceof (0, $2U8gU.S) || node instanceof (0, $2U8gU.Y) || node instanceof (0, $2U8gU.d);
            }
        }
    ]);
    return Anchors;
}();
var $69078fac725591aa$var$visit = function visit(node, tags) {
    if (node && (0, $1GDs0.a)(node) === 'object') {
        var tag = node.tag;
        if (node instanceof (0, $2U8gU.C)) {
            if (tag) tags[tag] = true;
            node.items.forEach(function(n) {
                return visit(n, tags);
            });
        } else if (node instanceof (0, $2U8gU.P)) {
            visit(node.key, tags);
            visit(node.value, tags);
        } else if (node instanceof (0, $2U8gU.S)) {
            if (tag) tags[tag] = true;
        }
    }
    return tags;
};
var $69078fac725591aa$var$listTagNames = function listTagNames(node) {
    return Object.keys($69078fac725591aa$var$visit(node, {}));
};
function $69078fac725591aa$var$parseContents(doc, contents) {
    var comments = {
        before: [],
        after: []
    };
    var body = undefined;
    var spaceBefore = false;
    var _iterator = (0, $1GDs0._)(contents), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var node = _step.value;
            if (node.valueRange) {
                if (body !== undefined) {
                    var msg = 'Document contains trailing content not separated by a ... or --- line';
                    doc.errors.push(new (0, $1GDs0.Y)(node, msg));
                    break;
                }
                var res = (0, $2U8gU.r)(doc, node);
                if (spaceBefore) {
                    res.spaceBefore = true;
                    spaceBefore = false;
                }
                body = res;
            } else if (node.comment !== null) {
                var cc = body === undefined ? comments.before : comments.after;
                cc.push(node.comment);
            } else if (node.type === (0, $1GDs0.T).BLANK_LINE) {
                spaceBefore = true;
                if (body === undefined && comments.before.length > 0 && !doc.commentBefore) {
                    // space-separated comments at start are parsed as document comments
                    doc.commentBefore = comments.before.join('\n');
                    comments.before = [];
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    doc.contents = body || null;
    if (!body) doc.comment = comments.before.concat(comments.after).join('\n') || null;
    else {
        var cb = comments.before.join('\n');
        if (cb) {
            var cbNode = body instanceof (0, $2U8gU.C) && body.items[0] ? body.items[0] : body;
            cbNode.commentBefore = cbNode.commentBefore ? "".concat(cb, "\n").concat(cbNode.commentBefore) : cb;
        }
        doc.comment = comments.after.join('\n') || null;
    }
}
function $69078fac725591aa$var$resolveTagDirective(_ref, directive) {
    var tagPrefixes = _ref.tagPrefixes;
    var _directive$parameters = (0, $1GDs0.h)(directive.parameters, 2), handle = _directive$parameters[0], prefix = _directive$parameters[1];
    if (!handle || !prefix) {
        var msg = 'Insufficient parameters given for %TAG directive';
        throw new (0, $1GDs0.g)(directive, msg);
    }
    if (tagPrefixes.some(function(p) {
        return p.handle === handle;
    })) {
        var _msg = 'The %TAG directive must only be given at most once per handle in the same document.';
        throw new (0, $1GDs0.g)(directive, _msg);
    }
    return {
        handle: handle,
        prefix: prefix
    };
}
function $69078fac725591aa$var$resolveYamlDirective(doc, directive) {
    var _directive$parameters2 = (0, $1GDs0.h)(directive.parameters, 1), version = _directive$parameters2[0];
    if (directive.name === 'YAML:1.0') version = '1.0';
    if (!version) {
        var msg = 'Insufficient parameters given for %YAML directive';
        throw new (0, $1GDs0.g)(directive, msg);
    }
    if (!$69078fac725591aa$var$documentOptions[version]) {
        var v0 = doc.version || doc.options.version;
        var _msg2 = "Document will be parsed as YAML ".concat(v0, " rather than YAML ").concat(version);
        doc.warnings.push(new (0, $1GDs0.f)(directive, _msg2));
    }
    return version;
}
function $69078fac725591aa$var$parseDirectives(doc, directives, prevDoc) {
    var directiveComments = [];
    var hasDirectives = false;
    var _iterator = (0, $1GDs0._)(directives), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var directive = _step.value;
            var comment = directive.comment, name = directive.name;
            switch(name){
                case 'TAG':
                    try {
                        doc.tagPrefixes.push($69078fac725591aa$var$resolveTagDirective(doc, directive));
                    } catch (error) {
                        doc.errors.push(error);
                    }
                    hasDirectives = true;
                    break;
                case 'YAML':
                case 'YAML:1.0':
                    if (doc.version) {
                        var msg = 'The %YAML directive must only be given at most once per document.';
                        doc.errors.push(new (0, $1GDs0.g)(directive, msg));
                    }
                    try {
                        doc.version = $69078fac725591aa$var$resolveYamlDirective(doc, directive);
                    } catch (error) {
                        doc.errors.push(error);
                    }
                    hasDirectives = true;
                    break;
                default:
                    if (name) {
                        var _msg3 = "YAML only supports %TAG and %YAML directives, and not %".concat(name);
                        doc.warnings.push(new (0, $1GDs0.f)(directive, _msg3));
                    }
            }
            if (comment) directiveComments.push(comment);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (prevDoc && !hasDirectives && '1.1' === (doc.version || prevDoc.version || doc.options.version)) {
        var copyTagPrefix = function copyTagPrefix(_ref2) {
            var handle = _ref2.handle, prefix = _ref2.prefix;
            return {
                handle: handle,
                prefix: prefix
            };
        };
        doc.tagPrefixes = prevDoc.tagPrefixes.map(copyTagPrefix);
        doc.version = prevDoc.version;
    }
    doc.commentBefore = directiveComments.join('\n') || null;
}
function $69078fac725591aa$var$assertCollection(contents) {
    if (contents instanceof (0, $2U8gU.C)) return true;
    throw new Error('Expected a YAML collection as document contents');
}
var $69078fac725591aa$var$Document$1 = /*#__PURE__*/ function() {
    function Document(options) {
        (0, $1GDs0.c)(this, Document);
        this.anchors = new $69078fac725591aa$var$Anchors(options.anchorPrefix);
        this.commentBefore = null;
        this.comment = null;
        this.contents = null;
        this.directivesEndMarker = null;
        this.errors = [];
        this.options = options;
        this.schema = null;
        this.tagPrefixes = [];
        this.version = null;
        this.warnings = [];
    }
    (0, $1GDs0.b)(Document, [
        {
            key: "add",
            value: function add(value) {
                $69078fac725591aa$var$assertCollection(this.contents);
                return this.contents.add(value);
            }
        },
        {
            key: "addIn",
            value: function addIn(path, value) {
                $69078fac725591aa$var$assertCollection(this.contents);
                this.contents.addIn(path, value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                $69078fac725591aa$var$assertCollection(this.contents);
                return this.contents.delete(key);
            }
        },
        {
            key: "deleteIn",
            value: function deleteIn(path) {
                if ((0, $2U8gU.e)(path)) {
                    if (this.contents == null) return false;
                    this.contents = null;
                    return true;
                }
                $69078fac725591aa$var$assertCollection(this.contents);
                return this.contents.deleteIn(path);
            }
        },
        {
            key: "getDefaults",
            value: function getDefaults() {
                return Document.defaults[this.version] || Document.defaults[this.options.version] || {};
            }
        },
        {
            key: "get",
            value: function get(key, keepScalar) {
                return this.contents instanceof (0, $2U8gU.C) ? this.contents.get(key, keepScalar) : undefined;
            }
        },
        {
            key: "getIn",
            value: function getIn(path, keepScalar) {
                if ((0, $2U8gU.e)(path)) return !keepScalar && this.contents instanceof (0, $2U8gU.S) ? this.contents.value : this.contents;
                return this.contents instanceof (0, $2U8gU.C) ? this.contents.getIn(path, keepScalar) : undefined;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this.contents instanceof (0, $2U8gU.C) ? this.contents.has(key) : false;
            }
        },
        {
            key: "hasIn",
            value: function hasIn(path) {
                if ((0, $2U8gU.e)(path)) return this.contents !== undefined;
                return this.contents instanceof (0, $2U8gU.C) ? this.contents.hasIn(path) : false;
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                $69078fac725591aa$var$assertCollection(this.contents);
                this.contents.set(key, value);
            }
        },
        {
            key: "setIn",
            value: function setIn(path, value) {
                if ((0, $2U8gU.e)(path)) this.contents = value;
                else {
                    $69078fac725591aa$var$assertCollection(this.contents);
                    this.contents.setIn(path, value);
                }
            }
        },
        {
            key: "setSchema",
            value: function setSchema(id, customTags) {
                if (!id && !customTags && this.schema) return;
                if (typeof id === 'number') id = id.toFixed(1);
                if (id === '1.0' || id === '1.1' || id === '1.2') {
                    if (this.version) this.version = id;
                    else this.options.version = id;
                    delete this.options.schema;
                } else if (id && typeof id === 'string') this.options.schema = id;
                if (Array.isArray(customTags)) this.options.customTags = customTags;
                var opt1 = Object.assign({}, this.getDefaults(), this.options);
                this.schema = new (0, $M2XUi.S)(opt1);
            }
        },
        {
            key: "parse",
            value: function parse(node, prevDoc) {
                if (this.options.keepCstNodes) this.cstNode = node;
                if (this.options.keepNodeTypes) this.type = 'DOCUMENT';
                var _node$directives = node.directives, directives = _node$directives === void 0 ? [] : _node$directives, _node$contents = node.contents, contents = _node$contents === void 0 ? [] : _node$contents, directivesEndMarker = node.directivesEndMarker, error = node.error, valueRange = node.valueRange;
                if (error) {
                    if (!error.source) error.source = this;
                    this.errors.push(error);
                }
                $69078fac725591aa$var$parseDirectives(this, directives, prevDoc);
                if (directivesEndMarker) this.directivesEndMarker = true;
                this.range = valueRange ? [
                    valueRange.start,
                    valueRange.end
                ] : null;
                this.setSchema();
                this.anchors._cstAliases = [];
                $69078fac725591aa$var$parseContents(this, contents);
                this.anchors.resolveNodes();
                if (this.options.prettyErrors) {
                    var _iterator = (0, $1GDs0._)(this.errors), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _error = _step.value;
                            if (_error instanceof (0, $1GDs0.i)) _error.makePretty();
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    var _iterator2 = (0, $1GDs0._)(this.warnings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var warn = _step2.value;
                            if (warn instanceof (0, $1GDs0.i)) warn.makePretty();
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
                return this;
            }
        },
        {
            key: "listNonDefaultTags",
            value: function listNonDefaultTags() {
                return $69078fac725591aa$var$listTagNames(this.contents).filter(function(t) {
                    return t.indexOf((0, $M2XUi.S).defaultPrefix) !== 0;
                });
            }
        },
        {
            key: "setTagPrefix",
            value: function setTagPrefix(handle, prefix) {
                if (handle[0] !== '!' || handle[handle.length - 1] !== '!') throw new Error('Handle must start and end with !');
                if (prefix) {
                    var prev = this.tagPrefixes.find(function(p) {
                        return p.handle === handle;
                    });
                    if (prev) prev.prefix = prefix;
                    else this.tagPrefixes.push({
                        handle: handle,
                        prefix: prefix
                    });
                } else this.tagPrefixes = this.tagPrefixes.filter(function(p) {
                    return p.handle !== handle;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON$1(arg, onAnchor) {
                var _this = this;
                var _this$options = this.options, keepBlobsInJSON = _this$options.keepBlobsInJSON, mapAsMap = _this$options.mapAsMap, maxAliasCount = _this$options.maxAliasCount;
                var keep = keepBlobsInJSON && (typeof arg !== 'string' || !(this.contents instanceof (0, $2U8gU.S)));
                var ctx = {
                    doc: this,
                    indentStep: '  ',
                    keep: keep,
                    mapAsMap: keep && !!mapAsMap,
                    maxAliasCount: maxAliasCount,
                    stringify: $69078fac725591aa$var$stringify$1 // Requiring directly in Pair would create circular dependencies
                };
                var anchorNames = Object.keys(this.anchors.map);
                if (anchorNames.length > 0) ctx.anchors = new Map(anchorNames.map(function(name) {
                    return [
                        _this.anchors.map[name],
                        {
                            alias: [],
                            aliasCount: 0,
                            count: 1
                        }
                    ];
                }));
                var res = (0, $2U8gU.t)(this.contents, arg, ctx);
                if (typeof onAnchor === 'function' && ctx.anchors) {
                    var _iterator3 = (0, $1GDs0._)(ctx.anchors.values()), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var _step3$value = _step3.value, count = _step3$value.count, _res = _step3$value.res;
                            onAnchor(_res, count);
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                }
                return res;
            }
        },
        {
            key: "toString",
            value: function toString() {
                if (this.errors.length > 0) throw new Error('Document with errors cannot be stringified');
                var indentSize = this.options.indent;
                if (!Number.isInteger(indentSize) || indentSize <= 0) {
                    var s = JSON.stringify(indentSize);
                    throw new Error("\"indent\" option must be a positive integer, not ".concat(s));
                }
                this.setSchema();
                var lines = [];
                var hasDirectives = false;
                if (this.version) {
                    var vd = '%YAML 1.2';
                    if (this.schema.name === 'yaml-1.1') {
                        if (this.version === '1.0') vd = '%YAML:1.0';
                        else if (this.version === '1.1') vd = '%YAML 1.1';
                    }
                    lines.push(vd);
                    hasDirectives = true;
                }
                var tagNames = this.listNonDefaultTags();
                this.tagPrefixes.forEach(function(_ref) {
                    var handle = _ref.handle, prefix = _ref.prefix;
                    if (tagNames.some(function(t) {
                        return t.indexOf(prefix) === 0;
                    })) {
                        lines.push("%TAG ".concat(handle, " ").concat(prefix));
                        hasDirectives = true;
                    }
                });
                if (hasDirectives || this.directivesEndMarker) lines.push('---');
                if (this.commentBefore) {
                    if (hasDirectives || !this.directivesEndMarker) lines.unshift('');
                    lines.unshift(this.commentBefore.replace(/^/gm, '#'));
                }
                var ctx = {
                    anchors: Object.create(null),
                    doc: this,
                    indent: '',
                    indentStep: ' '.repeat(indentSize),
                    stringify: $69078fac725591aa$var$stringify$1 // Requiring directly in nodes would create circular dependencies
                };
                var chompKeep = false;
                var contentComment = null;
                if (this.contents) {
                    if (this.contents instanceof (0, $2U8gU.N)) {
                        if (this.contents.spaceBefore && (hasDirectives || this.directivesEndMarker)) lines.push('');
                        if (this.contents.commentBefore) lines.push(this.contents.commentBefore.replace(/^/gm, '#')); // top-level block scalars need to be indented if followed by a comment
                        ctx.forceBlockIndent = !!this.comment;
                        contentComment = this.contents.comment;
                    }
                    var onChompKeep = contentComment ? null : function() {
                        return chompKeep = true;
                    };
                    var body = $69078fac725591aa$var$stringify$1(this.contents, ctx, function() {
                        return contentComment = null;
                    }, onChompKeep);
                    lines.push((0, $2U8gU.f)(body, '', contentComment));
                } else if (this.contents !== undefined) lines.push($69078fac725591aa$var$stringify$1(this.contents, ctx));
                if (this.comment) {
                    if ((!chompKeep || contentComment) && lines[lines.length - 1] !== '') lines.push('');
                    lines.push(this.comment.replace(/^/gm, '#'));
                }
                return lines.join('\n') + '\n';
            }
        }
    ]);
    return Document;
}();
(0, $1GDs0.e)($69078fac725591aa$var$Document$1, "defaults", $69078fac725591aa$var$documentOptions);
function $69078fac725591aa$var$createNode(value) {
    var wrapScalars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var tag = arguments.length > 2 ? arguments[2] : undefined;
    if (tag === undefined && typeof wrapScalars === 'string') {
        tag = wrapScalars;
        wrapScalars = true;
    }
    var options = Object.assign({}, $69078fac725591aa$var$Document$1.defaults[$69078fac725591aa$var$defaultOptions.version], $69078fac725591aa$var$defaultOptions);
    var schema = new (0, $M2XUi.S)(options);
    return schema.createNode(value, wrapScalars, tag);
}
var $69078fac725591aa$var$Document = /*#__PURE__*/ function(_YAMLDocument) {
    (0, $1GDs0.j)(Document, _YAMLDocument);
    var _super = (0, $1GDs0.k)(Document);
    function Document(options) {
        (0, $1GDs0.c)(this, Document);
        return _super.call(this, Object.assign({}, $69078fac725591aa$var$defaultOptions, options));
    }
    return Document;
}($69078fac725591aa$var$Document$1);
function $69078fac725591aa$var$parseAllDocuments(src, options) {
    var stream = [];
    var prev;
    var _iterator = (0, $1GDs0._)((0, $ggmYK.parse)(src)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cstDoc = _step.value;
            var doc = new $69078fac725591aa$var$Document(options);
            doc.parse(cstDoc, prev);
            stream.push(doc);
            prev = doc;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return stream;
}
function $69078fac725591aa$var$parseDocument(src, options) {
    var cst = (0, $ggmYK.parse)(src);
    var doc = new $69078fac725591aa$var$Document(options).parse(cst[0]);
    if (cst.length > 1) {
        var errMsg = 'Source contains multiple documents; please use YAML.parseAllDocuments()';
        doc.errors.unshift(new (0, $1GDs0.g)(cst[1], errMsg));
    }
    return doc;
}
function $69078fac725591aa$var$parse(src, options) {
    var doc = $69078fac725591aa$var$parseDocument(src, options);
    doc.warnings.forEach(function(warning) {
        return (0, $2UQ0T.w)(warning);
    });
    if (doc.errors.length > 0) throw doc.errors[0];
    return doc.toJSON();
}
function $69078fac725591aa$var$stringify(value, options) {
    var doc = new $69078fac725591aa$var$Document(options);
    doc.contents = value;
    return String(doc);
}
var $69078fac725591aa$export$866dfa75bd13a786 = {
    createNode: $69078fac725591aa$var$createNode,
    defaultOptions: $69078fac725591aa$var$defaultOptions,
    Document: $69078fac725591aa$var$Document,
    parse: $69078fac725591aa$var$parse,
    parseAllDocuments: $69078fac725591aa$var$parseAllDocuments,
    parseCST: (0, $ggmYK.parse),
    parseDocument: $69078fac725591aa$var$parseDocument,
    scalarOptions: $69078fac725591aa$var$scalarOptions,
    stringify: $69078fac725591aa$var$stringify
};

});
parcelRegister("1GDs0", function(module, exports) {

$parcel$export(module.exports, "a", () => $13a850c9ddd992cf$export$407448d2b89b1813);
$parcel$export(module.exports, "c", () => $13a850c9ddd992cf$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $13a850c9ddd992cf$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "e", () => $13a850c9ddd992cf$export$f1e1789686576879);
$parcel$export(module.exports, "j", () => $13a850c9ddd992cf$export$35e795649ee09318);
$parcel$export(module.exports, "m", () => $13a850c9ddd992cf$export$953cecd6e717a553);
$parcel$export(module.exports, "p", () => $13a850c9ddd992cf$export$ffb5f4729a158638);
$parcel$export(module.exports, "r", () => $13a850c9ddd992cf$export$43caf9889c228507);
$parcel$export(module.exports, "k", () => $13a850c9ddd992cf$export$342063e11d6c3cad);
$parcel$export(module.exports, "l", () => $13a850c9ddd992cf$export$882b5998b3b9117c);
$parcel$export(module.exports, "h", () => $13a850c9ddd992cf$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "q", () => $13a850c9ddd992cf$export$9e5f44173e64f162);
$parcel$export(module.exports, "_", () => $13a850c9ddd992cf$export$71511d61b312f219);
$parcel$export(module.exports, "C", () => $13a850c9ddd992cf$export$e7094788287c5e9b);
$parcel$export(module.exports, "T", () => $13a850c9ddd992cf$export$971d5caa766a69d7);
$parcel$export(module.exports, "d", () => $13a850c9ddd992cf$export$4368d992c4eafac0);
$parcel$export(module.exports, "n", () => $13a850c9ddd992cf$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "R", () => $13a850c9ddd992cf$export$db202ddc8be9136);
$parcel$export(module.exports, "N", () => $13a850c9ddd992cf$export$a07804094c3ecf2d);
$parcel$export(module.exports, "i", () => $13a850c9ddd992cf$export$23f2a1d2818174ef);
$parcel$export(module.exports, "o", () => $13a850c9ddd992cf$export$ae1af26003f05816);
$parcel$export(module.exports, "g", () => $13a850c9ddd992cf$export$39b482c5e57630a8);
$parcel$export(module.exports, "Y", () => $13a850c9ddd992cf$export$8743009a87fcb00f);
$parcel$export(module.exports, "f", () => $13a850c9ddd992cf$export$2d1720544b23b823);
$parcel$export(module.exports, "P", () => $13a850c9ddd992cf$export$56c0d5a1e737357d);
function $13a850c9ddd992cf$export$407448d2b89b1813(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $13a850c9ddd992cf$export$407448d2b89b1813 = function(obj) {
        return typeof obj;
    };
    else $13a850c9ddd992cf$export$407448d2b89b1813 = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $13a850c9ddd992cf$export$407448d2b89b1813(obj);
}
function $13a850c9ddd992cf$export$db3b6bfb95261072(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13a850c9ddd992cf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $13a850c9ddd992cf$export$8b22cf2602fb60ce(Constructor, protoProps, staticProps) {
    if (protoProps) $13a850c9ddd992cf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $13a850c9ddd992cf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $13a850c9ddd992cf$export$f1e1789686576879(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $13a850c9ddd992cf$export$35e795649ee09318(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $13a850c9ddd992cf$var$_setPrototypeOf(subClass, superClass);
}
function $13a850c9ddd992cf$export$953cecd6e717a553(o) {
    $13a850c9ddd992cf$export$953cecd6e717a553 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $13a850c9ddd992cf$export$953cecd6e717a553(o);
}
function $13a850c9ddd992cf$var$_setPrototypeOf(o, p) {
    $13a850c9ddd992cf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $13a850c9ddd992cf$var$_setPrototypeOf(o, p);
}
function $13a850c9ddd992cf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $13a850c9ddd992cf$var$_construct(Parent, args, Class) {
    if ($13a850c9ddd992cf$var$_isNativeReflectConstruct()) $13a850c9ddd992cf$var$_construct = Reflect.construct;
    else $13a850c9ddd992cf$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $13a850c9ddd992cf$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $13a850c9ddd992cf$var$_construct.apply(null, arguments);
}
function $13a850c9ddd992cf$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $13a850c9ddd992cf$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $13a850c9ddd992cf$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$13a850c9ddd992cf$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $13a850c9ddd992cf$var$_construct(Class, arguments, $13a850c9ddd992cf$export$953cecd6e717a553(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $13a850c9ddd992cf$var$_setPrototypeOf(Wrapper, Class);
    };
    return $13a850c9ddd992cf$var$_wrapNativeSuper(Class);
}
function $13a850c9ddd992cf$export$ffb5f4729a158638(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $13a850c9ddd992cf$export$43caf9889c228507(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $13a850c9ddd992cf$export$ffb5f4729a158638(self);
}
function $13a850c9ddd992cf$export$342063e11d6c3cad(Derived) {
    var hasNativeReflectConstruct = $13a850c9ddd992cf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $13a850c9ddd992cf$export$953cecd6e717a553(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $13a850c9ddd992cf$export$953cecd6e717a553(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $13a850c9ddd992cf$export$43caf9889c228507(this, result);
    };
}
function $13a850c9ddd992cf$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $13a850c9ddd992cf$export$953cecd6e717a553(object);
        if (object === null) break;
    }
    return object;
}
function $13a850c9ddd992cf$export$882b5998b3b9117c(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $13a850c9ddd992cf$export$882b5998b3b9117c = Reflect.get;
    else $13a850c9ddd992cf$export$882b5998b3b9117c = function _get(target, property, receiver) {
        var base = $13a850c9ddd992cf$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $13a850c9ddd992cf$export$882b5998b3b9117c(target, property, receiver || target);
}
function $13a850c9ddd992cf$export$dda1d9f60106f0e9(arr, i) {
    return $13a850c9ddd992cf$var$_arrayWithHoles(arr) || $13a850c9ddd992cf$var$_iterableToArrayLimit(arr, i) || $13a850c9ddd992cf$var$_unsupportedIterableToArray(arr, i) || $13a850c9ddd992cf$var$_nonIterableRest();
}
function $13a850c9ddd992cf$export$9e5f44173e64f162(arr) {
    return $13a850c9ddd992cf$var$_arrayWithHoles(arr) || $13a850c9ddd992cf$var$_iterableToArray(arr) || $13a850c9ddd992cf$var$_unsupportedIterableToArray(arr) || $13a850c9ddd992cf$var$_nonIterableRest();
}
function $13a850c9ddd992cf$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $13a850c9ddd992cf$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $13a850c9ddd992cf$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $13a850c9ddd992cf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $13a850c9ddd992cf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $13a850c9ddd992cf$var$_arrayLikeToArray(o, minLen);
}
function $13a850c9ddd992cf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $13a850c9ddd992cf$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $13a850c9ddd992cf$export$71511d61b312f219(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $13a850c9ddd992cf$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = o[Symbol.iterator]();
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $13a850c9ddd992cf$export$e7094788287c5e9b = {
    ANCHOR: '&',
    COMMENT: '#',
    TAG: '!',
    DIRECTIVES_END: '-',
    DOCUMENT_END: '.'
};
var $13a850c9ddd992cf$export$971d5caa766a69d7 = {
    ALIAS: 'ALIAS',
    BLANK_LINE: 'BLANK_LINE',
    BLOCK_FOLDED: 'BLOCK_FOLDED',
    BLOCK_LITERAL: 'BLOCK_LITERAL',
    COMMENT: 'COMMENT',
    DIRECTIVE: 'DIRECTIVE',
    DOCUMENT: 'DOCUMENT',
    FLOW_MAP: 'FLOW_MAP',
    FLOW_SEQ: 'FLOW_SEQ',
    MAP: 'MAP',
    MAP_KEY: 'MAP_KEY',
    MAP_VALUE: 'MAP_VALUE',
    PLAIN: 'PLAIN',
    QUOTE_DOUBLE: 'QUOTE_DOUBLE',
    QUOTE_SINGLE: 'QUOTE_SINGLE',
    SEQ: 'SEQ',
    SEQ_ITEM: 'SEQ_ITEM'
};
var $13a850c9ddd992cf$export$4368d992c4eafac0 = 'tag:yaml.org,2002:';
var $13a850c9ddd992cf$export$7ccc53e8f1e7dfc5 = {
    MAP: 'tag:yaml.org,2002:map',
    SEQ: 'tag:yaml.org,2002:seq',
    STR: 'tag:yaml.org,2002:str'
};
function $13a850c9ddd992cf$var$findLineStarts(src) {
    var ls = [
        0
    ];
    var offset = src.indexOf('\n');
    while(offset !== -1){
        offset += 1;
        ls.push(offset);
        offset = src.indexOf('\n', offset);
    }
    return ls;
}
function $13a850c9ddd992cf$var$getSrcInfo(cst) {
    var lineStarts, src;
    if (typeof cst === 'string') {
        lineStarts = $13a850c9ddd992cf$var$findLineStarts(cst);
        src = cst;
    } else {
        if (Array.isArray(cst)) cst = cst[0];
        if (cst && cst.context) {
            if (!cst.lineStarts) cst.lineStarts = $13a850c9ddd992cf$var$findLineStarts(cst.context.src);
            lineStarts = cst.lineStarts;
            src = cst.context.src;
        }
    }
    return {
        lineStarts: lineStarts,
        src: src
    };
}
/**
 * @typedef {Object} LinePos - One-indexed position in the source
 * @property {number} line
 * @property {number} col
 */ /**
 * Determine the line/col position matching a character offset.
 *
 * Accepts a source string or a CST document as the second parameter. With
 * the latter, starting indices for lines are cached in the document as
 * `lineStarts: number[]`.
 *
 * Returns a one-indexed `{ line, col }` location if found, or
 * `undefined` otherwise.
 *
 * @param {number} offset
 * @param {string|Document|Document[]} cst
 * @returns {?LinePos}
 */ function $13a850c9ddd992cf$var$getLinePos(offset, cst) {
    if (typeof offset !== 'number' || offset < 0) return null;
    var _getSrcInfo = $13a850c9ddd992cf$var$getSrcInfo(cst), lineStarts = _getSrcInfo.lineStarts, src = _getSrcInfo.src;
    if (!lineStarts || !src || offset > src.length) return null;
    for(var i = 0; i < lineStarts.length; ++i){
        var start = lineStarts[i];
        if (offset < start) return {
            line: i,
            col: offset - lineStarts[i - 1] + 1
        };
        if (offset === start) return {
            line: i + 1,
            col: 1
        };
    }
    var line = lineStarts.length;
    return {
        line: line,
        col: offset - lineStarts[line - 1] + 1
    };
}
/**
 * Get a specified line from the source.
 *
 * Accepts a source string or a CST document as the second parameter. With
 * the latter, starting indices for lines are cached in the document as
 * `lineStarts: number[]`.
 *
 * Returns the line as a string if found, or `null` otherwise.
 *
 * @param {number} line One-indexed line number
 * @param {string|Document|Document[]} cst
 * @returns {?string}
 */ function $13a850c9ddd992cf$var$getLine(line, cst) {
    var _getSrcInfo2 = $13a850c9ddd992cf$var$getSrcInfo(cst), lineStarts = _getSrcInfo2.lineStarts, src = _getSrcInfo2.src;
    if (!lineStarts || !(line >= 1) || line > lineStarts.length) return null;
    var start = lineStarts[line - 1];
    var end = lineStarts[line]; // undefined for last line; that's ok for slice()
    while(end && end > start && src[end - 1] === '\n')--end;
    return src.slice(start, end);
}
/**
 * Pretty-print the starting line from the source indicated by the range `pos`
 *
 * Trims output to `maxWidth` chars while keeping the starting column visible,
 * using `…` at either end to indicate dropped characters.
 *
 * Returns a two-line string (or `null`) with `\n` as separator; the second line
 * will hold appropriately indented `^` marks indicating the column range.
 *
 * @param {Object} pos
 * @param {LinePos} pos.start
 * @param {LinePos} [pos.end]
 * @param {string|Document|Document[]*} cst
 * @param {number} [maxWidth=80]
 * @returns {?string}
 */ function $13a850c9ddd992cf$var$getPrettyContext(_ref, cst) {
    var start = _ref.start, end = _ref.end;
    var maxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 80;
    var src = $13a850c9ddd992cf$var$getLine(start.line, cst);
    if (!src) return null;
    var col = start.col;
    if (src.length > maxWidth) {
        if (col <= maxWidth - 10) src = src.substr(0, maxWidth - 1) + "\u2026";
        else {
            var halfWidth = Math.round(maxWidth / 2);
            if (src.length > col + halfWidth) src = src.substr(0, col + halfWidth - 1) + "\u2026";
            col -= src.length - maxWidth;
            src = "\u2026" + src.substr(1 - maxWidth);
        }
    }
    var errLen = 1;
    var errEnd = '';
    if (end) {
        if (end.line === start.line && col + (end.col - start.col) <= maxWidth + 1) errLen = end.col - start.col;
        else {
            errLen = Math.min(src.length + 1, maxWidth) - col;
            errEnd = "\u2026";
        }
    }
    var offset = col > 1 ? ' '.repeat(col - 1) : '';
    var err = '^'.repeat(errLen);
    return "".concat(src, "\n").concat(offset).concat(err).concat(errEnd);
}
var $13a850c9ddd992cf$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    function Range(start, end) {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, Range);
        this.start = start;
        this.end = end || start;
    }
    $13a850c9ddd992cf$export$8b22cf2602fb60ce(Range, [
        {
            key: "isEmpty",
            value: function isEmpty() {
                return typeof this.start !== 'number' || !this.end || this.end <= this.start;
            }
        },
        {
            key: "setOrigRange",
            value: function setOrigRange(cr, offset) {
                var start = this.start, end = this.end;
                if (cr.length === 0 || end <= cr[0]) {
                    this.origStart = start;
                    this.origEnd = end;
                    return offset;
                }
                var i = offset;
                while(i < cr.length){
                    if (cr[i] > start) break;
                    else ++i;
                }
                this.origStart = start + i;
                var nextOffset = i;
                while(i < cr.length){
                    // if end was at \n, it should now be at \r
                    if (cr[i] >= end) break;
                    else ++i;
                }
                this.origEnd = end + i;
                return nextOffset;
            }
        }
    ], [
        {
            key: "copy",
            value: function copy(orig) {
                return new Range(orig.start, orig.end);
            }
        }
    ]);
    return Range;
}();
/** Root class of all nodes */ var $13a850c9ddd992cf$export$a07804094c3ecf2d = /*#__PURE__*/ function() {
    function Node(type, props, context) {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, Node);
        Object.defineProperty(this, 'context', {
            value: context || null,
            writable: true
        });
        this.error = null;
        this.range = null;
        this.valueRange = null;
        this.props = props || [];
        this.type = type;
        this.value = null;
    }
    $13a850c9ddd992cf$export$8b22cf2602fb60ce(Node, [
        {
            key: "getPropValue",
            value: function getPropValue(idx, key, skipKey) {
                if (!this.context) return null;
                var src = this.context.src;
                var prop = this.props[idx];
                return prop && src[prop.start] === key ? src.slice(prop.start + (skipKey ? 1 : 0), prop.end) : null;
            }
        },
        {
            key: "anchor",
            get: function get() {
                for(var i = 0; i < this.props.length; ++i){
                    var anchor = this.getPropValue(i, $13a850c9ddd992cf$export$e7094788287c5e9b.ANCHOR, true);
                    if (anchor != null) return anchor;
                }
                return null;
            }
        },
        {
            key: "comment",
            get: function get() {
                var comments = [];
                for(var i = 0; i < this.props.length; ++i){
                    var comment = this.getPropValue(i, $13a850c9ddd992cf$export$e7094788287c5e9b.COMMENT, true);
                    if (comment != null) comments.push(comment);
                }
                return comments.length > 0 ? comments.join('\n') : null;
            }
        },
        {
            key: "commentHasRequiredWhitespace",
            value: function commentHasRequiredWhitespace(start) {
                var src = this.context.src;
                if (this.header && start === this.header.end) return false;
                if (!this.valueRange) return false;
                var end = this.valueRange.end;
                return start !== end || Node.atBlank(src, end - 1);
            }
        },
        {
            key: "hasComment",
            get: function get() {
                if (this.context) {
                    var src = this.context.src;
                    for(var i = 0; i < this.props.length; ++i){
                        if (src[this.props[i].start] === $13a850c9ddd992cf$export$e7094788287c5e9b.COMMENT) return true;
                    }
                }
                return false;
            }
        },
        {
            key: "hasProps",
            get: function get() {
                if (this.context) {
                    var src = this.context.src;
                    for(var i = 0; i < this.props.length; ++i){
                        if (src[this.props[i].start] !== $13a850c9ddd992cf$export$e7094788287c5e9b.COMMENT) return true;
                    }
                }
                return false;
            }
        },
        {
            key: "includesTrailingLines",
            get: function get() {
                return false;
            }
        },
        {
            key: "jsonLike",
            get: function get() {
                var jsonLikeTypes = [
                    $13a850c9ddd992cf$export$971d5caa766a69d7.FLOW_MAP,
                    $13a850c9ddd992cf$export$971d5caa766a69d7.FLOW_SEQ,
                    $13a850c9ddd992cf$export$971d5caa766a69d7.QUOTE_DOUBLE,
                    $13a850c9ddd992cf$export$971d5caa766a69d7.QUOTE_SINGLE
                ];
                return jsonLikeTypes.indexOf(this.type) !== -1;
            }
        },
        {
            key: "rangeAsLinePos",
            get: function get() {
                if (!this.range || !this.context) return undefined;
                var start = $13a850c9ddd992cf$var$getLinePos(this.range.start, this.context.root);
                if (!start) return undefined;
                var end = $13a850c9ddd992cf$var$getLinePos(this.range.end, this.context.root);
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            key: "rawValue",
            get: function get() {
                if (!this.valueRange || !this.context) return null;
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                return this.context.src.slice(start, end);
            }
        },
        {
            key: "tag",
            get: function get() {
                for(var i = 0; i < this.props.length; ++i){
                    var tag = this.getPropValue(i, $13a850c9ddd992cf$export$e7094788287c5e9b.TAG, false);
                    if (tag != null) {
                        if (tag[1] === '<') return {
                            verbatim: tag.slice(2, -1)
                        };
                        else {
                            // eslint-disable-next-line no-unused-vars
                            var _tag$match = tag.match(/^(.*!)([^!]*)$/), _tag$match2 = $13a850c9ddd992cf$export$dda1d9f60106f0e9(_tag$match, 3);
                            _tag$match2[0];
                            var handle = _tag$match2[1], suffix = _tag$match2[2];
                            return {
                                handle: handle,
                                suffix: suffix
                            };
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "valueRangeContainsNewline",
            get: function get() {
                if (!this.valueRange || !this.context) return false;
                var _this$valueRange2 = this.valueRange, start = _this$valueRange2.start, end = _this$valueRange2.end;
                var src = this.context.src;
                for(var i = start; i < end; ++i){
                    if (src[i] === '\n') return true;
                }
                return false;
            }
        },
        {
            key: "parseComment",
            value: function parseComment(start) {
                var src = this.context.src;
                if (src[start] === $13a850c9ddd992cf$export$e7094788287c5e9b.COMMENT) {
                    var end = Node.endOfLine(src, start + 1);
                    var commentRange = new $13a850c9ddd992cf$export$db202ddc8be9136(start, end);
                    this.props.push(commentRange);
                    return end;
                }
                return start;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                if (this.range) offset = this.range.setOrigRange(cr, offset);
                if (this.valueRange) this.valueRange.setOrigRange(cr, offset);
                this.props.forEach(function(prop) {
                    return prop.setOrigRange(cr, offset);
                });
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, range = this.range, value = this.value;
                if (value != null) return value;
                var str = src.slice(range.start, range.end);
                return Node.addStringTerminator(src, range.end, str);
            }
        }
    ], [
        {
            key: "addStringTerminator",
            value: function addStringTerminator(src, offset, str) {
                if (str[str.length - 1] === '\n') return str;
                var next = Node.endOfWhiteSpace(src, offset);
                return next >= src.length || src[next] === '\n' ? str + '\n' : str;
            } // ^(---|...)
        },
        {
            key: "atDocumentBoundary",
            value: function atDocumentBoundary(src, offset, sep) {
                var ch0 = src[offset];
                if (!ch0) return true;
                var prev = src[offset - 1];
                if (prev && prev !== '\n') return false;
                if (sep) {
                    if (ch0 !== sep) return false;
                } else {
                    if (ch0 !== $13a850c9ddd992cf$export$e7094788287c5e9b.DIRECTIVES_END && ch0 !== $13a850c9ddd992cf$export$e7094788287c5e9b.DOCUMENT_END) return false;
                }
                var ch1 = src[offset + 1];
                var ch2 = src[offset + 2];
                if (ch1 !== ch0 || ch2 !== ch0) return false;
                var ch3 = src[offset + 3];
                return !ch3 || ch3 === '\n' || ch3 === '\t' || ch3 === ' ';
            }
        },
        {
            key: "endOfIdentifier",
            value: function endOfIdentifier(src, offset) {
                var ch = src[offset];
                var isVerbatim = ch === '<';
                var notOk = isVerbatim ? [
                    '\n',
                    '\t',
                    ' ',
                    '>'
                ] : [
                    '\n',
                    '\t',
                    ' ',
                    '[',
                    ']',
                    '{',
                    '}',
                    ','
                ];
                while(ch && notOk.indexOf(ch) === -1)ch = src[offset += 1];
                if (isVerbatim && ch === '>') offset += 1;
                return offset;
            }
        },
        {
            key: "endOfIndent",
            value: function endOfIndent(src, offset) {
                var ch = src[offset];
                while(ch === ' ')ch = src[offset += 1];
                return offset;
            }
        },
        {
            key: "endOfLine",
            value: function endOfLine(src, offset) {
                var ch = src[offset];
                while(ch && ch !== '\n')ch = src[offset += 1];
                return offset;
            }
        },
        {
            key: "endOfWhiteSpace",
            value: function endOfWhiteSpace(src, offset) {
                var ch = src[offset];
                while(ch === '\t' || ch === ' ')ch = src[offset += 1];
                return offset;
            }
        },
        {
            key: "startOfLine",
            value: function startOfLine(src, offset) {
                var ch = src[offset - 1];
                if (ch === '\n') return offset;
                while(ch && ch !== '\n')ch = src[offset -= 1];
                return offset + 1;
            }
        },
        {
            key: "endOfBlockIndent",
            value: function endOfBlockIndent(src, indent, lineStart) {
                var inEnd = Node.endOfIndent(src, lineStart);
                if (inEnd > lineStart + indent) return inEnd;
                else {
                    var wsEnd = Node.endOfWhiteSpace(src, inEnd);
                    var ch = src[wsEnd];
                    if (!ch || ch === '\n') return wsEnd;
                }
                return null;
            }
        },
        {
            key: "atBlank",
            value: function atBlank(src, offset, endAsBlank) {
                var ch = src[offset];
                return ch === '\n' || ch === '\t' || ch === ' ' || endAsBlank && !ch;
            }
        },
        {
            key: "nextNodeIsIndented",
            value: function nextNodeIsIndented(ch, indentDiff, indicatorAsIndent) {
                if (!ch || indentDiff < 0) return false;
                if (indentDiff > 0) return true;
                return indicatorAsIndent && ch === '-';
            } // should be at line or string end, or at next non-whitespace char
        },
        {
            key: "normalizeOffset",
            value: function normalizeOffset(src, offset) {
                var ch = src[offset];
                return !ch ? offset : ch !== '\n' && src[offset - 1] === '\n' ? offset - 1 : Node.endOfWhiteSpace(src, offset);
            } // fold single newline into space, multiple newlines to N - 1 newlines
        },
        {
            key: "foldNewline",
            value: function foldNewline(src, offset, indent) {
                var inCount = 0;
                var error = false;
                var fold = '';
                var ch = src[offset + 1];
                while(ch === ' ' || ch === '\t' || ch === '\n'){
                    switch(ch){
                        case '\n':
                            inCount = 0;
                            offset += 1;
                            fold += '\n';
                            break;
                        case '\t':
                            if (inCount <= indent) error = true;
                            offset = Node.endOfWhiteSpace(src, offset + 2) - 1;
                            break;
                        case ' ':
                            inCount += 1;
                            offset += 1;
                            break;
                    }
                    ch = src[offset + 1];
                }
                if (!fold) fold = ' ';
                if (ch && inCount <= indent) error = true;
                return {
                    fold: fold,
                    offset: offset,
                    error: error
                };
            }
        }
    ]);
    return Node;
}();
var $13a850c9ddd992cf$export$23f2a1d2818174ef = /*#__PURE__*/ function(_Error) {
    $13a850c9ddd992cf$export$35e795649ee09318(YAMLError, _Error);
    var _super = $13a850c9ddd992cf$export$342063e11d6c3cad(YAMLError);
    function YAMLError(name, source, message) {
        var _this;
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, YAMLError);
        if (!message || !(source instanceof $13a850c9ddd992cf$export$a07804094c3ecf2d)) throw new Error("Invalid arguments for new ".concat(name));
        _this = _super.call(this);
        _this.name = name;
        _this.message = message;
        _this.source = source;
        return _this;
    }
    $13a850c9ddd992cf$export$8b22cf2602fb60ce(YAMLError, [
        {
            key: "makePretty",
            value: function makePretty() {
                if (!this.source) return;
                this.nodeType = this.source.type;
                var cst = this.source.context && this.source.context.root;
                if (typeof this.offset === 'number') {
                    this.range = new $13a850c9ddd992cf$export$db202ddc8be9136(this.offset, this.offset + 1);
                    var start = cst && $13a850c9ddd992cf$var$getLinePos(this.offset, cst);
                    if (start) {
                        var end = {
                            line: start.line,
                            col: start.col + 1
                        };
                        this.linePos = {
                            start: start,
                            end: end
                        };
                    }
                    delete this.offset;
                } else {
                    this.range = this.source.range;
                    this.linePos = this.source.rangeAsLinePos;
                }
                if (this.linePos) {
                    var _this$linePos$start = this.linePos.start, line = _this$linePos$start.line, col = _this$linePos$start.col;
                    this.message += " at line ".concat(line, ", column ").concat(col);
                    var ctx = cst && $13a850c9ddd992cf$var$getPrettyContext(this.linePos, cst);
                    if (ctx) this.message += ":\n\n".concat(ctx, "\n");
                }
                delete this.source;
            }
        }
    ]);
    return YAMLError;
}(/*#__PURE__*/ $13a850c9ddd992cf$var$_wrapNativeSuper(Error));
var $13a850c9ddd992cf$export$ae1af26003f05816 = /*#__PURE__*/ function(_YAMLError) {
    $13a850c9ddd992cf$export$35e795649ee09318(YAMLReferenceError, _YAMLError);
    var _super2 = $13a850c9ddd992cf$export$342063e11d6c3cad(YAMLReferenceError);
    function YAMLReferenceError(source, message) {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, YAMLReferenceError);
        return _super2.call(this, 'YAMLReferenceError', source, message);
    }
    return YAMLReferenceError;
}($13a850c9ddd992cf$export$23f2a1d2818174ef);
var $13a850c9ddd992cf$export$39b482c5e57630a8 = /*#__PURE__*/ function(_YAMLError2) {
    $13a850c9ddd992cf$export$35e795649ee09318(YAMLSemanticError, _YAMLError2);
    var _super3 = $13a850c9ddd992cf$export$342063e11d6c3cad(YAMLSemanticError);
    function YAMLSemanticError(source, message) {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, YAMLSemanticError);
        return _super3.call(this, 'YAMLSemanticError', source, message);
    }
    return YAMLSemanticError;
}($13a850c9ddd992cf$export$23f2a1d2818174ef);
var $13a850c9ddd992cf$export$8743009a87fcb00f = /*#__PURE__*/ function(_YAMLError3) {
    $13a850c9ddd992cf$export$35e795649ee09318(YAMLSyntaxError, _YAMLError3);
    var _super4 = $13a850c9ddd992cf$export$342063e11d6c3cad(YAMLSyntaxError);
    function YAMLSyntaxError(source, message) {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, YAMLSyntaxError);
        return _super4.call(this, 'YAMLSyntaxError', source, message);
    }
    return YAMLSyntaxError;
}($13a850c9ddd992cf$export$23f2a1d2818174ef);
var $13a850c9ddd992cf$export$2d1720544b23b823 = /*#__PURE__*/ function(_YAMLError4) {
    $13a850c9ddd992cf$export$35e795649ee09318(YAMLWarning, _YAMLError4);
    var _super5 = $13a850c9ddd992cf$export$342063e11d6c3cad(YAMLWarning);
    function YAMLWarning(source, message) {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, YAMLWarning);
        return _super5.call(this, 'YAMLWarning', source, message);
    }
    return YAMLWarning;
}($13a850c9ddd992cf$export$23f2a1d2818174ef);
var $13a850c9ddd992cf$export$56c0d5a1e737357d = /*#__PURE__*/ function(_Node) {
    $13a850c9ddd992cf$export$35e795649ee09318(PlainValue, _Node);
    var _super = $13a850c9ddd992cf$export$342063e11d6c3cad(PlainValue);
    function PlainValue() {
        $13a850c9ddd992cf$export$db3b6bfb95261072(this, PlainValue);
        return _super.apply(this, arguments);
    }
    $13a850c9ddd992cf$export$8b22cf2602fb60ce(PlainValue, [
        {
            key: "strValue",
            get: function get() {
                if (!this.valueRange || !this.context) return null;
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var src = this.context.src;
                var ch = src[end - 1];
                while(start < end && (ch === '\n' || ch === '\t' || ch === ' '))ch = src[--end - 1];
                var str = '';
                for(var i = start; i < end; ++i){
                    var _ch = src[i];
                    if (_ch === '\n') {
                        var _Node$foldNewline = $13a850c9ddd992cf$export$a07804094c3ecf2d.foldNewline(src, i, -1), fold = _Node$foldNewline.fold, offset = _Node$foldNewline.offset;
                        str += fold;
                        i = offset;
                    } else if (_ch === ' ' || _ch === '\t') {
                        // trim trailing whitespace
                        var wsStart = i;
                        var next = src[i + 1];
                        while(i < end && (next === ' ' || next === '\t')){
                            i += 1;
                            next = src[i + 1];
                        }
                        if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : _ch;
                    } else str += _ch;
                }
                var ch0 = src[start];
                switch(ch0){
                    case '\t':
                        var msg = 'Plain value cannot start with a tab character';
                        var errors = [
                            new $13a850c9ddd992cf$export$39b482c5e57630a8(this, msg)
                        ];
                        return {
                            errors: errors,
                            str: str
                        };
                    case '@':
                    case '`':
                        var _msg = "Plain value cannot start with reserved character ".concat(ch0);
                        var _errors = [
                            new $13a850c9ddd992cf$export$39b482c5e57630a8(this, _msg)
                        ];
                        return {
                            errors: _errors,
                            str: str
                        };
                    default:
                        return str;
                }
            }
        },
        {
            key: "parseBlockValue",
            value: function parseBlockValue(start) {
                var _this$context = this.context, indent = _this$context.indent, inFlow = _this$context.inFlow, src = _this$context.src;
                var offset = start;
                var valueEnd = start;
                for(var ch = src[offset]; ch === '\n'; ch = src[offset]){
                    if ($13a850c9ddd992cf$export$a07804094c3ecf2d.atDocumentBoundary(src, offset + 1)) break;
                    var end = $13a850c9ddd992cf$export$a07804094c3ecf2d.endOfBlockIndent(src, indent, offset + 1);
                    if (end === null || src[end] === '#') break;
                    if (src[end] === '\n') offset = end;
                    else {
                        valueEnd = PlainValue.endOfLine(src, end, inFlow);
                        offset = valueEnd;
                    }
                }
                if (this.valueRange.isEmpty()) this.valueRange.start = start;
                this.valueRange.end = valueEnd;
                return valueEnd;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var inFlow = context.inFlow, src = context.src;
                var offset = start;
                var ch = src[offset];
                if (ch && ch !== '#' && ch !== '\n') offset = PlainValue.endOfLine(src, start, inFlow);
                this.valueRange = new $13a850c9ddd992cf$export$db202ddc8be9136(start, offset);
                offset = $13a850c9ddd992cf$export$a07804094c3ecf2d.endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                if (!this.hasComment || this.valueRange.isEmpty()) offset = this.parseBlockValue(offset);
                return offset;
            }
        }
    ], [
        {
            key: "endOfLine",
            value: function endOfLine(src, start, inFlow) {
                var ch = src[start];
                var offset = start;
                while(ch && ch !== '\n'){
                    if (inFlow && (ch === '[' || ch === ']' || ch === '{' || ch === '}' || ch === ',')) break;
                    var next = src[offset + 1];
                    if (ch === ':' && (!next || next === '\n' || next === '\t' || next === ' ' || inFlow && next === ',')) break;
                    if ((ch === ' ' || ch === '\t') && next === '#') break;
                    offset += 1;
                    ch = next;
                }
                return offset;
            }
        }
    ]);
    return PlainValue;
}($13a850c9ddd992cf$export$a07804094c3ecf2d);

});

parcelRegister("ggmYK", function(module, exports) {

$parcel$export(module.exports, "parse", () => $bd6ff712eb378c79$export$98e6a39c04603d36);

var $1GDs0 = parcelRequire("1GDs0");
var $bd6ff712eb378c79$var$BlankLine = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(BlankLine, _Node);
    var _super = (0, $1GDs0.k)(BlankLine);
    function BlankLine() {
        (0, $1GDs0.c)(this, BlankLine);
        return _super.call(this, (0, $1GDs0.T).BLANK_LINE);
    }
    /* istanbul ignore next */ (0, $1GDs0.b)(BlankLine, [
        {
            key: "includesTrailingLines",
            get: function get() {
                // This is never called from anywhere, but if it were,
                // this is the value it should return.
                return true;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                this.range = new (0, $1GDs0.R)(start, start + 1);
                return start + 1;
            }
        }
    ]);
    return BlankLine;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$CollectionItem = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(CollectionItem, _Node);
    var _super = (0, $1GDs0.k)(CollectionItem);
    function CollectionItem(type, props) {
        var _this;
        (0, $1GDs0.c)(this, CollectionItem);
        _this = _super.call(this, type, props);
        _this.node = null;
        return _this;
    }
    (0, $1GDs0.b)(CollectionItem, [
        {
            key: "includesTrailingLines",
            get: function get() {
                return !!this.node && this.node.includesTrailingLines;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var parseNode = context.parseNode, src = context.src;
                var atLineStart = context.atLineStart, lineStart = context.lineStart;
                if (!atLineStart && this.type === (0, $1GDs0.T).SEQ_ITEM) this.error = new (0, $1GDs0.g)(this, 'Sequence items must not have preceding content on the same line');
                var indent = atLineStart ? start - lineStart : context.indent;
                var offset = (0, $1GDs0.N).endOfWhiteSpace(src, start + 1);
                var ch = src[offset];
                var inlineComment = ch === '#';
                var comments = [];
                var blankLine = null;
                while(ch === '\n' || ch === '#'){
                    if (ch === '#') {
                        var _end = (0, $1GDs0.N).endOfLine(src, offset + 1);
                        comments.push(new (0, $1GDs0.R)(offset, _end));
                        offset = _end;
                    } else {
                        atLineStart = true;
                        lineStart = offset + 1;
                        var wsEnd = (0, $1GDs0.N).endOfWhiteSpace(src, lineStart);
                        if (src[wsEnd] === '\n' && comments.length === 0) {
                            blankLine = new $bd6ff712eb378c79$var$BlankLine();
                            lineStart = blankLine.parse({
                                src: src
                            }, lineStart);
                        }
                        offset = (0, $1GDs0.N).endOfIndent(src, lineStart);
                    }
                    ch = src[offset];
                }
                if ((0, $1GDs0.N).nextNodeIsIndented(ch, offset - (lineStart + indent), this.type !== (0, $1GDs0.T).SEQ_ITEM)) this.node = parseNode({
                    atLineStart: atLineStart,
                    inCollection: false,
                    indent: indent,
                    lineStart: lineStart,
                    parent: this
                }, offset);
                else if (ch && lineStart > start + 1) offset = lineStart - 1;
                if (this.node) {
                    if (blankLine) {
                        // Only blank lines preceding non-empty nodes are captured. Note that
                        // this means that collection item range start indices do not always
                        // increase monotonically. -- eemeli/yaml#126
                        var items = context.parent.items || context.parent.contents;
                        if (items) items.push(blankLine);
                    }
                    if (comments.length) Array.prototype.push.apply(this.props, comments);
                    offset = this.node.range.end;
                } else if (inlineComment) {
                    var c = comments[0];
                    this.props.push(c);
                    offset = c.end;
                } else offset = (0, $1GDs0.N).endOfLine(src, start + 1);
                var end = this.node ? this.node.valueRange.end : offset;
                this.valueRange = new (0, $1GDs0.R)(start, end);
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $1GDs0.l)((0, $1GDs0.m)(CollectionItem.prototype), "setOrigRanges", this).call(this, cr, offset);
                return this.node ? this.node.setOrigRanges(cr, offset) : offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, node = this.node, range = this.range, value = this.value;
                if (value != null) return value;
                var str = node ? src.slice(range.start, node.range.start) + String(node) : src.slice(range.start, range.end);
                return (0, $1GDs0.N).addStringTerminator(src, range.end, str);
            }
        }
    ]);
    return CollectionItem;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$Comment = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Comment, _Node);
    var _super = (0, $1GDs0.k)(Comment);
    function Comment() {
        (0, $1GDs0.c)(this, Comment);
        return _super.call(this, (0, $1GDs0.T).COMMENT);
    }
    /**
   * Parses a comment line from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar
   */ (0, $1GDs0.b)(Comment, [
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var offset = this.parseComment(start);
                this.range = new (0, $1GDs0.R)(start, offset);
                return offset;
            }
        }
    ]);
    return Comment;
}((0, $1GDs0.N));
function $bd6ff712eb378c79$var$grabCollectionEndComments(node) {
    var cnode = node;
    while(cnode instanceof $bd6ff712eb378c79$var$CollectionItem)cnode = cnode.node;
    if (!(cnode instanceof $bd6ff712eb378c79$var$Collection)) return null;
    var len = cnode.items.length;
    var ci = -1;
    for(var i = len - 1; i >= 0; --i){
        var n = cnode.items[i];
        if (n.type === (0, $1GDs0.T).COMMENT) {
            // Keep sufficiently indented comments with preceding node
            var _n$context = n.context, indent = _n$context.indent, lineStart = _n$context.lineStart;
            if (indent > 0 && n.range.start >= lineStart + indent) break;
            ci = i;
        } else if (n.type === (0, $1GDs0.T).BLANK_LINE) ci = i;
        else break;
    }
    if (ci === -1) return null;
    var ca = cnode.items.splice(ci, len - ci);
    var prevEnd = ca[0].range.start;
    while(true){
        cnode.range.end = prevEnd;
        if (cnode.valueRange && cnode.valueRange.end > prevEnd) cnode.valueRange.end = prevEnd;
        if (cnode === node) break;
        cnode = cnode.context.parent;
    }
    return ca;
}
var $bd6ff712eb378c79$var$Collection = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Collection, _Node);
    var _super = (0, $1GDs0.k)(Collection);
    function Collection(firstItem) {
        var _this;
        (0, $1GDs0.c)(this, Collection);
        _this = _super.call(this, firstItem.type === (0, $1GDs0.T).SEQ_ITEM ? (0, $1GDs0.T).SEQ : (0, $1GDs0.T).MAP);
        for(var i = firstItem.props.length - 1; i >= 0; --i)if (firstItem.props[i].start < firstItem.context.lineStart) {
            // props on previous line are assumed by the collection
            _this.props = firstItem.props.slice(0, i + 1);
            firstItem.props = firstItem.props.slice(i + 1);
            var itemRange = firstItem.props[0] || firstItem.valueRange;
            firstItem.range.start = itemRange.start;
            break;
        }
        _this.items = [
            firstItem
        ];
        var ec = $bd6ff712eb378c79$var$grabCollectionEndComments(firstItem);
        if (ec) Array.prototype.push.apply(_this.items, ec);
        return _this;
    }
    (0, $1GDs0.b)(Collection, [
        {
            key: "includesTrailingLines",
            get: function get() {
                return this.items.length > 0;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var parseNode = context.parseNode, src = context.src; // It's easier to recalculate lineStart here rather than tracking down the
                // last context from which to read it -- eemeli/yaml#2
                var lineStart = (0, $1GDs0.N).startOfLine(src, start);
                var firstItem = this.items[0]; // First-item context needs to be correct for later comment handling
                // -- eemeli/yaml#17
                firstItem.context.parent = this;
                this.valueRange = (0, $1GDs0.R).copy(firstItem.valueRange);
                var indent = firstItem.range.start - firstItem.context.lineStart;
                var offset = start;
                offset = (0, $1GDs0.N).normalizeOffset(src, offset);
                var ch = src[offset];
                var atLineStart = (0, $1GDs0.N).endOfWhiteSpace(src, lineStart) === offset;
                var prevIncludesTrailingLines = false;
                while(ch){
                    while(ch === '\n' || ch === '#'){
                        if (atLineStart && ch === '\n' && !prevIncludesTrailingLines) {
                            var blankLine = new $bd6ff712eb378c79$var$BlankLine();
                            offset = blankLine.parse({
                                src: src
                            }, offset);
                            this.valueRange.end = offset;
                            if (offset >= src.length) {
                                ch = null;
                                break;
                            }
                            this.items.push(blankLine);
                            offset -= 1; // blankLine.parse() consumes terminal newline
                        } else if (ch === '#') {
                            if (offset < lineStart + indent && !Collection.nextContentHasIndent(src, offset, indent)) return offset;
                            var comment = new $bd6ff712eb378c79$var$Comment();
                            offset = comment.parse({
                                indent: indent,
                                lineStart: lineStart,
                                src: src
                            }, offset);
                            this.items.push(comment);
                            this.valueRange.end = offset;
                            if (offset >= src.length) {
                                ch = null;
                                break;
                            }
                        }
                        lineStart = offset + 1;
                        offset = (0, $1GDs0.N).endOfIndent(src, lineStart);
                        if ((0, $1GDs0.N).atBlank(src, offset)) {
                            var wsEnd = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                            var next = src[wsEnd];
                            if (!next || next === '\n' || next === '#') offset = wsEnd;
                        }
                        ch = src[offset];
                        atLineStart = true;
                    }
                    if (!ch) break;
                    if (offset !== lineStart + indent && (atLineStart || ch !== ':')) {
                        if (offset < lineStart + indent) {
                            if (lineStart > start) offset = lineStart;
                            break;
                        } else if (!this.error) {
                            var msg = 'All collection items must start at the same column';
                            this.error = new (0, $1GDs0.Y)(this, msg);
                        }
                    }
                    if (firstItem.type === (0, $1GDs0.T).SEQ_ITEM) {
                        if (ch !== '-') {
                            if (lineStart > start) offset = lineStart;
                            break;
                        }
                    } else if (ch === '-' && !this.error) {
                        // map key may start with -, as long as it's followed by a non-whitespace char
                        var _next = src[offset + 1];
                        if (!_next || _next === '\n' || _next === '\t' || _next === ' ') {
                            var _msg = 'A collection cannot be both a mapping and a sequence';
                            this.error = new (0, $1GDs0.Y)(this, _msg);
                        }
                    }
                    var node = parseNode({
                        atLineStart: atLineStart,
                        inCollection: true,
                        indent: indent,
                        lineStart: lineStart,
                        parent: this
                    }, offset);
                    if (!node) return offset; // at next document start
                    this.items.push(node);
                    this.valueRange.end = node.valueRange.end;
                    offset = (0, $1GDs0.N).normalizeOffset(src, node.range.end);
                    ch = src[offset];
                    atLineStart = false;
                    prevIncludesTrailingLines = node.includesTrailingLines; // Need to reset lineStart and atLineStart here if preceding node's range
                    // has advanced to check the current line's indentation level
                    // -- eemeli/yaml#10 & eemeli/yaml#38
                    if (ch) {
                        var ls = offset - 1;
                        var prev = src[ls];
                        while(prev === ' ' || prev === '\t')prev = src[--ls];
                        if (prev === '\n') {
                            lineStart = ls + 1;
                            atLineStart = true;
                        }
                    }
                    var ec = $bd6ff712eb378c79$var$grabCollectionEndComments(node);
                    if (ec) Array.prototype.push.apply(this.items, ec);
                }
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $1GDs0.l)((0, $1GDs0.m)(Collection.prototype), "setOrigRanges", this).call(this, cr, offset);
                this.items.forEach(function(node) {
                    offset = node.setOrigRanges(cr, offset);
                });
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, items = this.items, range = this.range, value = this.value;
                if (value != null) return value;
                var str = src.slice(range.start, items[0].range.start) + String(items[0]);
                for(var i = 1; i < items.length; ++i){
                    var item = items[i];
                    var _item$context = item.context, atLineStart = _item$context.atLineStart, indent = _item$context.indent;
                    if (atLineStart) for(var _i = 0; _i < indent; ++_i)str += ' ';
                    str += String(item);
                }
                return (0, $1GDs0.N).addStringTerminator(src, range.end, str);
            }
        }
    ], [
        {
            key: "nextContentHasIndent",
            value: function nextContentHasIndent(src, offset, indent) {
                var lineStart = (0, $1GDs0.N).endOfLine(src, offset) + 1;
                offset = (0, $1GDs0.N).endOfWhiteSpace(src, lineStart);
                var ch = src[offset];
                if (!ch) return false;
                if (offset >= lineStart + indent) return true;
                if (ch !== '#' && ch !== '\n') return false;
                return Collection.nextContentHasIndent(src, offset, indent);
            }
        }
    ]);
    return Collection;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$Directive = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Directive, _Node);
    var _super = (0, $1GDs0.k)(Directive);
    function Directive() {
        var _this;
        (0, $1GDs0.c)(this, Directive);
        _this = _super.call(this, (0, $1GDs0.T).DIRECTIVE);
        _this.name = null;
        return _this;
    }
    (0, $1GDs0.b)(Directive, [
        {
            key: "parameters",
            get: function get() {
                var raw = this.rawValue;
                return raw ? raw.trim().split(/[ \t]+/) : [];
            }
        },
        {
            key: "parseName",
            value: function parseName(start) {
                var src = this.context.src;
                var offset = start;
                var ch = src[offset];
                while(ch && ch !== '\n' && ch !== '\t' && ch !== ' ')ch = src[offset += 1];
                this.name = src.slice(start, offset);
                return offset;
            }
        },
        {
            key: "parseParameters",
            value: function parseParameters(start) {
                var src = this.context.src;
                var offset = start;
                var ch = src[offset];
                while(ch && ch !== '\n' && ch !== '#')ch = src[offset += 1];
                this.valueRange = new (0, $1GDs0.R)(start, offset);
                return offset;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var offset = this.parseName(start + 1);
                offset = this.parseParameters(offset);
                offset = this.parseComment(offset);
                this.range = new (0, $1GDs0.R)(start, offset);
                return offset;
            }
        }
    ]);
    return Directive;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$Document = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Document, _Node);
    var _super = (0, $1GDs0.k)(Document);
    function Document() {
        var _this;
        (0, $1GDs0.c)(this, Document);
        _this = _super.call(this, (0, $1GDs0.T).DOCUMENT);
        _this.directives = null;
        _this.contents = null;
        _this.directivesEndMarker = null;
        _this.documentEndMarker = null;
        return _this;
    }
    (0, $1GDs0.b)(Document, [
        {
            key: "parseDirectives",
            value: function parseDirectives(start) {
                var src = this.context.src;
                this.directives = [];
                var atLineStart = true;
                var hasDirectives = false;
                var offset = start;
                while(!(0, $1GDs0.N).atDocumentBoundary(src, offset, (0, $1GDs0.C).DIRECTIVES_END)){
                    offset = Document.startCommentOrEndBlankLine(src, offset);
                    switch(src[offset]){
                        case '\n':
                            if (atLineStart) {
                                var blankLine = new $bd6ff712eb378c79$var$BlankLine();
                                offset = blankLine.parse({
                                    src: src
                                }, offset);
                                if (offset < src.length) this.directives.push(blankLine);
                            } else {
                                offset += 1;
                                atLineStart = true;
                            }
                            break;
                        case '#':
                            var comment = new $bd6ff712eb378c79$var$Comment();
                            offset = comment.parse({
                                src: src
                            }, offset);
                            this.directives.push(comment);
                            atLineStart = false;
                            break;
                        case '%':
                            var directive = new $bd6ff712eb378c79$var$Directive();
                            offset = directive.parse({
                                parent: this,
                                src: src
                            }, offset);
                            this.directives.push(directive);
                            hasDirectives = true;
                            atLineStart = false;
                            break;
                        default:
                            if (hasDirectives) this.error = new (0, $1GDs0.g)(this, 'Missing directives-end indicator line');
                            else if (this.directives.length > 0) {
                                this.contents = this.directives;
                                this.directives = [];
                            }
                            return offset;
                    }
                }
                if (src[offset]) {
                    this.directivesEndMarker = new (0, $1GDs0.R)(offset, offset + 3);
                    return offset + 3;
                }
                if (hasDirectives) this.error = new (0, $1GDs0.g)(this, 'Missing directives-end indicator line');
                else if (this.directives.length > 0) {
                    this.contents = this.directives;
                    this.directives = [];
                }
                return offset;
            }
        },
        {
            key: "parseContents",
            value: function parseContents(start) {
                var _this$context = this.context, parseNode = _this$context.parseNode, src = _this$context.src;
                if (!this.contents) this.contents = [];
                var lineStart = start;
                while(src[lineStart - 1] === '-')lineStart -= 1;
                var offset = (0, $1GDs0.N).endOfWhiteSpace(src, start);
                var atLineStart = lineStart === start;
                this.valueRange = new (0, $1GDs0.R)(offset);
                while(!(0, $1GDs0.N).atDocumentBoundary(src, offset, (0, $1GDs0.C).DOCUMENT_END)){
                    switch(src[offset]){
                        case '\n':
                            if (atLineStart) {
                                var blankLine = new $bd6ff712eb378c79$var$BlankLine();
                                offset = blankLine.parse({
                                    src: src
                                }, offset);
                                if (offset < src.length) this.contents.push(blankLine);
                            } else {
                                offset += 1;
                                atLineStart = true;
                            }
                            lineStart = offset;
                            break;
                        case '#':
                            var comment = new $bd6ff712eb378c79$var$Comment();
                            offset = comment.parse({
                                src: src
                            }, offset);
                            this.contents.push(comment);
                            atLineStart = false;
                            break;
                        default:
                            var iEnd = (0, $1GDs0.N).endOfIndent(src, offset);
                            var context = {
                                atLineStart: atLineStart,
                                indent: -1,
                                inFlow: false,
                                inCollection: false,
                                lineStart: lineStart,
                                parent: this
                            };
                            var node = parseNode(context, iEnd);
                            if (!node) return this.valueRange.end = iEnd; // at next document start
                            this.contents.push(node);
                            offset = node.range.end;
                            atLineStart = false;
                            var ec = $bd6ff712eb378c79$var$grabCollectionEndComments(node);
                            if (ec) Array.prototype.push.apply(this.contents, ec);
                    }
                    offset = Document.startCommentOrEndBlankLine(src, offset);
                }
                this.valueRange.end = offset;
                if (src[offset]) {
                    this.documentEndMarker = new (0, $1GDs0.R)(offset, offset + 3);
                    offset += 3;
                    if (src[offset]) {
                        offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                        if (src[offset] === '#') {
                            var _comment = new $bd6ff712eb378c79$var$Comment();
                            offset = _comment.parse({
                                src: src
                            }, offset);
                            this.contents.push(_comment);
                        }
                        switch(src[offset]){
                            case '\n':
                                offset += 1;
                                break;
                            case undefined:
                                break;
                            default:
                                this.error = new (0, $1GDs0.Y)(this, 'Document end marker line cannot have a non-comment suffix');
                        }
                    }
                }
                return offset;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                context.root = this;
                this.context = context;
                var src = context.src;
                var offset = src.charCodeAt(start) === 0xfeff ? start + 1 : start; // skip BOM
                offset = this.parseDirectives(offset);
                offset = this.parseContents(offset);
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $1GDs0.l)((0, $1GDs0.m)(Document.prototype), "setOrigRanges", this).call(this, cr, offset);
                this.directives.forEach(function(node) {
                    offset = node.setOrigRanges(cr, offset);
                });
                if (this.directivesEndMarker) offset = this.directivesEndMarker.setOrigRange(cr, offset);
                this.contents.forEach(function(node) {
                    offset = node.setOrigRanges(cr, offset);
                });
                if (this.documentEndMarker) offset = this.documentEndMarker.setOrigRange(cr, offset);
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var contents = this.contents, directives = this.directives, value = this.value;
                if (value != null) return value;
                var str = directives.join('');
                if (contents.length > 0) {
                    if (directives.length > 0 || contents[0].type === (0, $1GDs0.T).COMMENT) str += '---\n';
                    str += contents.join('');
                }
                if (str[str.length - 1] !== '\n') str += '\n';
                return str;
            }
        }
    ], [
        {
            key: "startCommentOrEndBlankLine",
            value: function startCommentOrEndBlankLine(src, start) {
                var offset = (0, $1GDs0.N).endOfWhiteSpace(src, start);
                var ch = src[offset];
                return ch === '#' || ch === '\n' ? offset : start;
            }
        }
    ]);
    return Document;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$Alias = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Alias, _Node);
    var _super = (0, $1GDs0.k)(Alias);
    function Alias() {
        (0, $1GDs0.c)(this, Alias);
        return _super.apply(this, arguments);
    }
    (0, $1GDs0.b)(Alias, [
        {
            key: "parse",
            value: /**
     * Parses an *alias from the source
     *
     * @param {ParseContext} context
     * @param {number} start - Index of first character
     * @returns {number} - Index of the character after this scalar
     */ function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = (0, $1GDs0.N).endOfIdentifier(src, start + 1);
                this.valueRange = new (0, $1GDs0.R)(start + 1, offset);
                offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                return offset;
            }
        }
    ]);
    return Alias;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$Chomp = {
    CLIP: 'CLIP',
    KEEP: 'KEEP',
    STRIP: 'STRIP'
};
var $bd6ff712eb378c79$var$BlockValue = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(BlockValue, _Node);
    var _super = (0, $1GDs0.k)(BlockValue);
    function BlockValue(type, props) {
        var _this;
        (0, $1GDs0.c)(this, BlockValue);
        _this = _super.call(this, type, props);
        _this.blockIndent = null;
        _this.chomping = $bd6ff712eb378c79$var$Chomp.CLIP;
        _this.header = null;
        return _this;
    }
    (0, $1GDs0.b)(BlockValue, [
        {
            key: "includesTrailingLines",
            get: function get() {
                return this.chomping === $bd6ff712eb378c79$var$Chomp.KEEP;
            }
        },
        {
            key: "strValue",
            get: function get() {
                if (!this.valueRange || !this.context) return null;
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var _this$context = this.context, indent = _this$context.indent, src = _this$context.src;
                if (this.valueRange.isEmpty()) return '';
                var lastNewLine = null;
                var ch = src[end - 1];
                while(ch === '\n' || ch === '\t' || ch === ' '){
                    end -= 1;
                    if (end <= start) {
                        if (this.chomping === $bd6ff712eb378c79$var$Chomp.KEEP) break;
                        else return ''; // probably never happens
                    }
                    if (ch === '\n') lastNewLine = end;
                    ch = src[end - 1];
                }
                var keepStart = end + 1;
                if (lastNewLine) {
                    if (this.chomping === $bd6ff712eb378c79$var$Chomp.KEEP) {
                        keepStart = lastNewLine;
                        end = this.valueRange.end;
                    } else end = lastNewLine;
                }
                var bi = indent + this.blockIndent;
                var folded = this.type === (0, $1GDs0.T).BLOCK_FOLDED;
                var atStart = true;
                var str = '';
                var sep = '';
                var prevMoreIndented = false;
                for(var i = start; i < end; ++i){
                    for(var j = 0; j < bi; ++j){
                        if (src[i] !== ' ') break;
                        i += 1;
                    }
                    var _ch = src[i];
                    if (_ch === '\n') {
                        if (sep === '\n') str += '\n';
                        else sep = '\n';
                    } else {
                        var lineEnd = (0, $1GDs0.N).endOfLine(src, i);
                        var line = src.slice(i, lineEnd);
                        i = lineEnd;
                        if (folded && (_ch === ' ' || _ch === '\t') && i < keepStart) {
                            if (sep === ' ') sep = '\n';
                            else if (!prevMoreIndented && !atStart && sep === '\n') sep = '\n\n';
                            str += sep + line; //+ ((lineEnd < end && src[lineEnd]) || '')
                            sep = lineEnd < end && src[lineEnd] || '';
                            prevMoreIndented = true;
                        } else {
                            str += sep + line;
                            sep = folded && i < keepStart ? ' ' : '\n';
                            prevMoreIndented = false;
                        }
                        if (atStart && line !== '') atStart = false;
                    }
                }
                return this.chomping === $bd6ff712eb378c79$var$Chomp.STRIP ? str : str + '\n';
            }
        },
        {
            key: "parseBlockHeader",
            value: function parseBlockHeader(start) {
                var src = this.context.src;
                var offset = start + 1;
                var bi = '';
                while(true){
                    var ch = src[offset];
                    switch(ch){
                        case '-':
                            this.chomping = $bd6ff712eb378c79$var$Chomp.STRIP;
                            break;
                        case '+':
                            this.chomping = $bd6ff712eb378c79$var$Chomp.KEEP;
                            break;
                        case '0':
                        case '1':
                        case '2':
                        case '3':
                        case '4':
                        case '5':
                        case '6':
                        case '7':
                        case '8':
                        case '9':
                            bi += ch;
                            break;
                        default:
                            this.blockIndent = Number(bi) || null;
                            this.header = new (0, $1GDs0.R)(start, offset);
                            return offset;
                    }
                    offset += 1;
                }
            }
        },
        {
            key: "parseBlockValue",
            value: function parseBlockValue(start) {
                var _this$context2 = this.context, indent = _this$context2.indent, src = _this$context2.src;
                var explicit = !!this.blockIndent;
                var offset = start;
                var valueEnd = start;
                var minBlockIndent = 1;
                for(var ch = src[offset]; ch === '\n'; ch = src[offset]){
                    offset += 1;
                    if ((0, $1GDs0.N).atDocumentBoundary(src, offset)) break;
                    var end = (0, $1GDs0.N).endOfBlockIndent(src, indent, offset); // should not include tab?
                    if (end === null) break;
                    var _ch2 = src[end];
                    var lineIndent = end - (offset + indent);
                    if (!this.blockIndent) {
                        // no explicit block indent, none yet detected
                        if (src[end] !== '\n') {
                            // first line with non-whitespace content
                            if (lineIndent < minBlockIndent) {
                                var msg = 'Block scalars with more-indented leading empty lines must use an explicit indentation indicator';
                                this.error = new (0, $1GDs0.g)(this, msg);
                            }
                            this.blockIndent = lineIndent;
                        } else if (lineIndent > minBlockIndent) // empty line with more whitespace
                        minBlockIndent = lineIndent;
                    } else if (_ch2 && _ch2 !== '\n' && lineIndent < this.blockIndent) {
                        if (src[end] === '#') break;
                        if (!this.error) {
                            var _src = explicit ? 'explicit indentation indicator' : 'first line';
                            var _msg = "Block scalars must not be less indented than their ".concat(_src);
                            this.error = new (0, $1GDs0.g)(this, _msg);
                        }
                    }
                    if (src[end] === '\n') offset = end;
                    else offset = valueEnd = (0, $1GDs0.N).endOfLine(src, end);
                }
                if (this.chomping !== $bd6ff712eb378c79$var$Chomp.KEEP) offset = src[valueEnd] ? valueEnd + 1 : valueEnd;
                this.valueRange = new (0, $1GDs0.R)(start + 1, offset);
                return offset;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = this.parseBlockHeader(start);
                offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                offset = this.parseBlockValue(offset);
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $1GDs0.l)((0, $1GDs0.m)(BlockValue.prototype), "setOrigRanges", this).call(this, cr, offset);
                return this.header ? this.header.setOrigRange(cr, offset) : offset;
            }
        }
    ]);
    return BlockValue;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$FlowCollection = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(FlowCollection, _Node);
    var _super = (0, $1GDs0.k)(FlowCollection);
    function FlowCollection(type, props) {
        var _this;
        (0, $1GDs0.c)(this, FlowCollection);
        _this = _super.call(this, type, props);
        _this.items = null;
        return _this;
    }
    (0, $1GDs0.b)(FlowCollection, [
        {
            key: "prevNodeIsJsonLike",
            value: function prevNodeIsJsonLike() {
                var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items.length;
                var node = this.items[idx - 1];
                return !!node && (node.jsonLike || node.type === (0, $1GDs0.T).COMMENT && this.prevNodeIsJsonLike(idx - 1));
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var parseNode = context.parseNode, src = context.src;
                var indent = context.indent, lineStart = context.lineStart;
                var char = src[start]; // { or [
                this.items = [
                    {
                        char: char,
                        offset: start
                    }
                ];
                var offset = (0, $1GDs0.N).endOfWhiteSpace(src, start + 1);
                char = src[offset];
                while(char && char !== ']' && char !== '}'){
                    switch(char){
                        case '\n':
                            lineStart = offset + 1;
                            var wsEnd = (0, $1GDs0.N).endOfWhiteSpace(src, lineStart);
                            if (src[wsEnd] === '\n') {
                                var blankLine = new $bd6ff712eb378c79$var$BlankLine();
                                lineStart = blankLine.parse({
                                    src: src
                                }, lineStart);
                                this.items.push(blankLine);
                            }
                            offset = (0, $1GDs0.N).endOfIndent(src, lineStart);
                            if (offset <= lineStart + indent) {
                                char = src[offset];
                                if (offset < lineStart + indent || char !== ']' && char !== '}') {
                                    var msg = 'Insufficient indentation in flow collection';
                                    this.error = new (0, $1GDs0.g)(this, msg);
                                }
                            }
                            break;
                        case ',':
                            this.items.push({
                                char: char,
                                offset: offset
                            });
                            offset += 1;
                            break;
                        case '#':
                            var comment = new $bd6ff712eb378c79$var$Comment();
                            offset = comment.parse({
                                src: src
                            }, offset);
                            this.items.push(comment);
                            break;
                        case '?':
                        case ':':
                            var next = src[offset + 1];
                            if (next === '\n' || next === '\t' || next === ' ' || next === ',' || // in-flow : after JSON-like key does not need to be followed by whitespace
                            char === ':' && this.prevNodeIsJsonLike()) {
                                this.items.push({
                                    char: char,
                                    offset: offset
                                });
                                offset += 1;
                                break;
                            }
                        // fallthrough
                        default:
                            var node = parseNode({
                                atLineStart: false,
                                inCollection: false,
                                inFlow: true,
                                indent: -1,
                                lineStart: lineStart,
                                parent: this
                            }, offset);
                            if (!node) {
                                // at next document start
                                this.valueRange = new (0, $1GDs0.R)(start, offset);
                                return offset;
                            }
                            this.items.push(node);
                            offset = (0, $1GDs0.N).normalizeOffset(src, node.range.end);
                    }
                    offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                    char = src[offset];
                }
                this.valueRange = new (0, $1GDs0.R)(start, offset + 1);
                if (char) {
                    this.items.push({
                        char: char,
                        offset: offset
                    });
                    offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset + 1);
                    offset = this.parseComment(offset);
                }
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $1GDs0.l)((0, $1GDs0.m)(FlowCollection.prototype), "setOrigRanges", this).call(this, cr, offset);
                this.items.forEach(function(node) {
                    if (node instanceof (0, $1GDs0.N)) offset = node.setOrigRanges(cr, offset);
                    else if (cr.length === 0) node.origOffset = node.offset;
                    else {
                        var i = offset;
                        while(i < cr.length){
                            if (cr[i] > node.offset) break;
                            else ++i;
                        }
                        node.origOffset = node.offset + i;
                        offset = i;
                    }
                });
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, items = this.items, range = this.range, value = this.value;
                if (value != null) return value;
                var nodes = items.filter(function(item) {
                    return item instanceof (0, $1GDs0.N);
                });
                var str = '';
                var prevEnd = range.start;
                nodes.forEach(function(node) {
                    var prefix = src.slice(prevEnd, node.range.start);
                    prevEnd = node.range.end;
                    str += prefix + String(node);
                    if (str[str.length - 1] === '\n' && src[prevEnd - 1] !== '\n' && src[prevEnd] === '\n') // Comment range does not include the terminal newline, but its
                    // stringified value does. Without this fix, newlines at comment ends
                    // get duplicated.
                    prevEnd += 1;
                });
                str += src.slice(prevEnd, range.end);
                return (0, $1GDs0.N).addStringTerminator(src, range.end, str);
            }
        }
    ]);
    return FlowCollection;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$QuoteDouble = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(QuoteDouble, _Node);
    var _super = (0, $1GDs0.k)(QuoteDouble);
    function QuoteDouble() {
        (0, $1GDs0.c)(this, QuoteDouble);
        return _super.apply(this, arguments);
    }
    (0, $1GDs0.b)(QuoteDouble, [
        {
            key: "strValue",
            get: /**
     * @returns {string | { str: string, errors: YAMLSyntaxError[] }}
     */ function get() {
                if (!this.valueRange || !this.context) return null;
                var errors = [];
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var _this$context = this.context, indent = _this$context.indent, src = _this$context.src;
                if (src[end - 1] !== '"') errors.push(new (0, $1GDs0.Y)(this, 'Missing closing "quote')); // Using String#replace is too painful with escaped newlines preceded by
                // escaped backslashes; also, this should be faster.
                var str = '';
                for(var i = start + 1; i < end - 1; ++i){
                    var ch = src[i];
                    if (ch === '\n') {
                        if ((0, $1GDs0.N).atDocumentBoundary(src, i + 1)) errors.push(new (0, $1GDs0.g)(this, 'Document boundary indicators are not allowed within string values'));
                        var _Node$foldNewline = (0, $1GDs0.N).foldNewline(src, i, indent), fold = _Node$foldNewline.fold, offset = _Node$foldNewline.offset, error = _Node$foldNewline.error;
                        str += fold;
                        i = offset;
                        if (error) errors.push(new (0, $1GDs0.g)(this, 'Multi-line double-quoted string needs to be sufficiently indented'));
                    } else if (ch === '\\') {
                        i += 1;
                        switch(src[i]){
                            case '0':
                                str += '\0';
                                break;
                            // null character
                            case 'a':
                                str += '\x07';
                                break;
                            // bell character
                            case 'b':
                                str += '\b';
                                break;
                            // backspace
                            case 'e':
                                str += '\x1b';
                                break;
                            // escape character
                            case 'f':
                                str += '\f';
                                break;
                            // form feed
                            case 'n':
                                str += '\n';
                                break;
                            // line feed
                            case 'r':
                                str += '\r';
                                break;
                            // carriage return
                            case 't':
                                str += '\t';
                                break;
                            // horizontal tab
                            case 'v':
                                str += '\v';
                                break;
                            // vertical tab
                            case 'N':
                                str += "\x85";
                                break;
                            // Unicode next line
                            case '_':
                                str += "\xA0";
                                break;
                            // Unicode non-breaking space
                            case 'L':
                                str += "\u2028";
                                break;
                            // Unicode line separator
                            case 'P':
                                str += "\u2029";
                                break;
                            // Unicode paragraph separator
                            case ' ':
                                str += ' ';
                                break;
                            case '"':
                                str += '"';
                                break;
                            case '/':
                                str += '/';
                                break;
                            case '\\':
                                str += '\\';
                                break;
                            case '\t':
                                str += '\t';
                                break;
                            case 'x':
                                str += this.parseCharCode(i + 1, 2, errors);
                                i += 2;
                                break;
                            case 'u':
                                str += this.parseCharCode(i + 1, 4, errors);
                                i += 4;
                                break;
                            case 'U':
                                str += this.parseCharCode(i + 1, 8, errors);
                                i += 8;
                                break;
                            case '\n':
                                // skip escaped newlines, but still trim the following line
                                while(src[i + 1] === ' ' || src[i + 1] === '\t')i += 1;
                                break;
                            default:
                                errors.push(new (0, $1GDs0.Y)(this, "Invalid escape sequence ".concat(src.substr(i - 1, 2))));
                                str += '\\' + src[i];
                        }
                    } else if (ch === ' ' || ch === '\t') {
                        // trim trailing whitespace
                        var wsStart = i;
                        var next = src[i + 1];
                        while(next === ' ' || next === '\t'){
                            i += 1;
                            next = src[i + 1];
                        }
                        if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
                    } else str += ch;
                }
                return errors.length > 0 ? {
                    errors: errors,
                    str: str
                } : str;
            }
        },
        {
            key: "parseCharCode",
            value: function parseCharCode(offset, length, errors) {
                var src = this.context.src;
                var cc = src.substr(offset, length);
                var ok = cc.length === length && /^[0-9a-fA-F]+$/.test(cc);
                var code = ok ? parseInt(cc, 16) : NaN;
                if (isNaN(code)) {
                    errors.push(new (0, $1GDs0.Y)(this, "Invalid escape sequence ".concat(src.substr(offset - 2, length + 2))));
                    return src.substr(offset - 2, length + 2);
                }
                return String.fromCodePoint(code);
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = QuoteDouble.endOfQuote(src, start + 1);
                this.valueRange = new (0, $1GDs0.R)(start, offset);
                offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                return offset;
            }
        }
    ], [
        {
            key: "endOfQuote",
            value: function endOfQuote(src, offset) {
                var ch = src[offset];
                while(ch && ch !== '"'){
                    offset += ch === '\\' ? 2 : 1;
                    ch = src[offset];
                }
                return offset + 1;
            }
        }
    ]);
    return QuoteDouble;
}((0, $1GDs0.N));
var $bd6ff712eb378c79$var$QuoteSingle = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(QuoteSingle, _Node);
    var _super = (0, $1GDs0.k)(QuoteSingle);
    function QuoteSingle() {
        (0, $1GDs0.c)(this, QuoteSingle);
        return _super.apply(this, arguments);
    }
    (0, $1GDs0.b)(QuoteSingle, [
        {
            key: "strValue",
            get: /**
     * @returns {string | { str: string, errors: YAMLSyntaxError[] }}
     */ function get() {
                if (!this.valueRange || !this.context) return null;
                var errors = [];
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var _this$context = this.context, indent = _this$context.indent, src = _this$context.src;
                if (src[end - 1] !== "'") errors.push(new (0, $1GDs0.Y)(this, "Missing closing 'quote"));
                var str = '';
                for(var i = start + 1; i < end - 1; ++i){
                    var ch = src[i];
                    if (ch === '\n') {
                        if ((0, $1GDs0.N).atDocumentBoundary(src, i + 1)) errors.push(new (0, $1GDs0.g)(this, 'Document boundary indicators are not allowed within string values'));
                        var _Node$foldNewline = (0, $1GDs0.N).foldNewline(src, i, indent), fold = _Node$foldNewline.fold, offset = _Node$foldNewline.offset, error = _Node$foldNewline.error;
                        str += fold;
                        i = offset;
                        if (error) errors.push(new (0, $1GDs0.g)(this, 'Multi-line single-quoted string needs to be sufficiently indented'));
                    } else if (ch === "'") {
                        str += ch;
                        i += 1;
                        if (src[i] !== "'") errors.push(new (0, $1GDs0.Y)(this, 'Unescaped single quote? This should not happen.'));
                    } else if (ch === ' ' || ch === '\t') {
                        // trim trailing whitespace
                        var wsStart = i;
                        var next = src[i + 1];
                        while(next === ' ' || next === '\t'){
                            i += 1;
                            next = src[i + 1];
                        }
                        if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
                    } else str += ch;
                }
                return errors.length > 0 ? {
                    errors: errors,
                    str: str
                } : str;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = QuoteSingle.endOfQuote(src, start + 1);
                this.valueRange = new (0, $1GDs0.R)(start, offset);
                offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                return offset;
            }
        }
    ], [
        {
            key: "endOfQuote",
            value: function endOfQuote(src, offset) {
                var ch = src[offset];
                while(ch)if (ch === "'") {
                    if (src[offset + 1] !== "'") break;
                    ch = src[offset += 2];
                } else ch = src[offset += 1];
                return offset + 1;
            }
        }
    ]);
    return QuoteSingle;
}((0, $1GDs0.N));
function $bd6ff712eb378c79$var$createNewNode(type, props) {
    switch(type){
        case (0, $1GDs0.T).ALIAS:
            return new $bd6ff712eb378c79$var$Alias(type, props);
        case (0, $1GDs0.T).BLOCK_FOLDED:
        case (0, $1GDs0.T).BLOCK_LITERAL:
            return new $bd6ff712eb378c79$var$BlockValue(type, props);
        case (0, $1GDs0.T).FLOW_MAP:
        case (0, $1GDs0.T).FLOW_SEQ:
            return new $bd6ff712eb378c79$var$FlowCollection(type, props);
        case (0, $1GDs0.T).MAP_KEY:
        case (0, $1GDs0.T).MAP_VALUE:
        case (0, $1GDs0.T).SEQ_ITEM:
            return new $bd6ff712eb378c79$var$CollectionItem(type, props);
        case (0, $1GDs0.T).COMMENT:
        case (0, $1GDs0.T).PLAIN:
            return new (0, $1GDs0.P)(type, props);
        case (0, $1GDs0.T).QUOTE_DOUBLE:
            return new $bd6ff712eb378c79$var$QuoteDouble(type, props);
        case (0, $1GDs0.T).QUOTE_SINGLE:
            return new $bd6ff712eb378c79$var$QuoteSingle(type, props);
        /* istanbul ignore next */ default:
            return null;
    }
}
/**
 * @param {boolean} atLineStart - Node starts at beginning of line
 * @param {boolean} inFlow - true if currently in a flow context
 * @param {boolean} inCollection - true if currently in a collection context
 * @param {number} indent - Current level of indentation
 * @param {number} lineStart - Start of the current line
 * @param {Node} parent - The parent of the node
 * @param {string} src - Source of the YAML document
 */ var $bd6ff712eb378c79$var$ParseContext = /*#__PURE__*/ function() {
    function ParseContext() {
        var _this = this;
        var orig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, atLineStart = _ref.atLineStart, inCollection = _ref.inCollection, inFlow = _ref.inFlow, indent = _ref.indent, lineStart = _ref.lineStart, parent = _ref.parent;
        (0, $1GDs0.c)(this, ParseContext);
        (0, $1GDs0.e)(this, "parseNode", function(overlay, start) {
            if ((0, $1GDs0.N).atDocumentBoundary(_this.src, start)) return null;
            var context = new ParseContext(_this, overlay);
            var _context$parseProps = context.parseProps(start), props = _context$parseProps.props, type = _context$parseProps.type, valueStart = _context$parseProps.valueStart;
            var node = $bd6ff712eb378c79$var$createNewNode(type, props);
            var offset = node.parse(context, valueStart);
            node.range = new (0, $1GDs0.R)(start, offset);
            /* istanbul ignore if */ if (offset <= start) {
                // This should never happen, but if it does, let's make sure to at least
                // step one character forward to avoid a busy loop.
                node.error = new Error("Node#parse consumed no characters");
                node.error.parseEnd = offset;
                node.error.source = node;
                node.range.end = start + 1;
            }
            if (context.nodeStartsCollection(node)) {
                if (!node.error && !context.atLineStart && context.parent.type === (0, $1GDs0.T).DOCUMENT) node.error = new (0, $1GDs0.Y)(node, 'Block collection must not have preceding content here (e.g. directives-end indicator)');
                var collection = new $bd6ff712eb378c79$var$Collection(node);
                offset = collection.parse(new ParseContext(context), offset);
                collection.range = new (0, $1GDs0.R)(start, offset);
                return collection;
            }
            return node;
        });
        this.atLineStart = atLineStart != null ? atLineStart : orig.atLineStart || false;
        this.inCollection = inCollection != null ? inCollection : orig.inCollection || false;
        this.inFlow = inFlow != null ? inFlow : orig.inFlow || false;
        this.indent = indent != null ? indent : orig.indent;
        this.lineStart = lineStart != null ? lineStart : orig.lineStart;
        this.parent = parent != null ? parent : orig.parent || {};
        this.root = orig.root;
        this.src = orig.src;
    }
    (0, $1GDs0.b)(ParseContext, [
        {
            key: "nodeStartsCollection",
            value: function nodeStartsCollection(node) {
                var inCollection = this.inCollection, inFlow = this.inFlow, src = this.src;
                if (inCollection || inFlow) return false;
                if (node instanceof $bd6ff712eb378c79$var$CollectionItem) return true; // check for implicit key
                var offset = node.range.end;
                if (src[offset] === '\n' || src[offset - 1] === '\n') return false;
                offset = (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                return src[offset] === ':';
            } // Anchor and tag are before type, which determines the node implementation
        },
        {
            key: "parseProps",
            value: function parseProps(offset) {
                var inFlow = this.inFlow, parent = this.parent, src = this.src;
                var props = [];
                var lineHasProps = false;
                offset = this.atLineStart ? (0, $1GDs0.N).endOfIndent(src, offset) : (0, $1GDs0.N).endOfWhiteSpace(src, offset);
                var ch = src[offset];
                while(ch === (0, $1GDs0.C).ANCHOR || ch === (0, $1GDs0.C).COMMENT || ch === (0, $1GDs0.C).TAG || ch === '\n'){
                    if (ch === '\n') {
                        var inEnd = offset;
                        var lineStart = void 0;
                        do {
                            lineStart = inEnd + 1;
                            inEnd = (0, $1GDs0.N).endOfIndent(src, lineStart);
                        }while (src[inEnd] === '\n');
                        var indentDiff = inEnd - (lineStart + this.indent);
                        var noIndicatorAsIndent = parent.type === (0, $1GDs0.T).SEQ_ITEM && parent.context.atLineStart;
                        if (src[inEnd] !== '#' && !(0, $1GDs0.N).nextNodeIsIndented(src[inEnd], indentDiff, !noIndicatorAsIndent)) break;
                        this.atLineStart = true;
                        this.lineStart = lineStart;
                        lineHasProps = false;
                        offset = inEnd;
                    } else if (ch === (0, $1GDs0.C).COMMENT) {
                        var end = (0, $1GDs0.N).endOfLine(src, offset + 1);
                        props.push(new (0, $1GDs0.R)(offset, end));
                        offset = end;
                    } else {
                        var _end = (0, $1GDs0.N).endOfIdentifier(src, offset + 1);
                        if (ch === (0, $1GDs0.C).TAG && src[_end] === ',' && /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+,\d\d\d\d(-\d\d){0,2}\/\S/.test(src.slice(offset + 1, _end + 13))) // Let's presume we're dealing with a YAML 1.0 domain tag here, rather
                        // than an empty but 'foo.bar' private-tagged node in a flow collection
                        // followed without whitespace by a plain string starting with a year
                        // or date divided by something.
                        _end = (0, $1GDs0.N).endOfIdentifier(src, _end + 5);
                        props.push(new (0, $1GDs0.R)(offset, _end));
                        lineHasProps = true;
                        offset = (0, $1GDs0.N).endOfWhiteSpace(src, _end);
                    }
                    ch = src[offset];
                } // '- &a : b' has an anchor on an empty node
                if (lineHasProps && ch === ':' && (0, $1GDs0.N).atBlank(src, offset + 1, true)) offset -= 1;
                var type = ParseContext.parseType(src, offset, inFlow);
                return {
                    props: props,
                    type: type,
                    valueStart: offset
                };
            }
        }
    ], [
        {
            key: "parseType",
            value: function parseType(src, offset, inFlow) {
                switch(src[offset]){
                    case '*':
                        return (0, $1GDs0.T).ALIAS;
                    case '>':
                        return (0, $1GDs0.T).BLOCK_FOLDED;
                    case '|':
                        return (0, $1GDs0.T).BLOCK_LITERAL;
                    case '{':
                        return (0, $1GDs0.T).FLOW_MAP;
                    case '[':
                        return (0, $1GDs0.T).FLOW_SEQ;
                    case '?':
                        return !inFlow && (0, $1GDs0.N).atBlank(src, offset + 1, true) ? (0, $1GDs0.T).MAP_KEY : (0, $1GDs0.T).PLAIN;
                    case ':':
                        return !inFlow && (0, $1GDs0.N).atBlank(src, offset + 1, true) ? (0, $1GDs0.T).MAP_VALUE : (0, $1GDs0.T).PLAIN;
                    case '-':
                        return !inFlow && (0, $1GDs0.N).atBlank(src, offset + 1, true) ? (0, $1GDs0.T).SEQ_ITEM : (0, $1GDs0.T).PLAIN;
                    case '"':
                        return (0, $1GDs0.T).QUOTE_DOUBLE;
                    case "'":
                        return (0, $1GDs0.T).QUOTE_SINGLE;
                    default:
                        return (0, $1GDs0.T).PLAIN;
                }
            }
        }
    ]);
    return ParseContext;
}();
// Published as 'yaml/parse-cst'
function $bd6ff712eb378c79$export$98e6a39c04603d36(src) {
    var cr = [];
    if (src.indexOf('\r') !== -1) src = src.replace(/\r\n?/g, function(match, offset) {
        if (match.length > 1) cr.push(offset);
        return '\n';
    });
    var documents = [];
    var offset = 0;
    do {
        var doc = new $bd6ff712eb378c79$var$Document();
        var context = new $bd6ff712eb378c79$var$ParseContext({
            src: src
        });
        offset = doc.parse(context, offset);
        documents.push(doc);
    }while (offset < src.length);
    documents.setOrigRanges = function() {
        if (cr.length === 0) return false;
        for(var i = 1; i < cr.length; ++i)cr[i] -= i;
        var crOffset = 0;
        for(var _i = 0; _i < documents.length; ++_i)crOffset = documents[_i].setOrigRanges(cr, crOffset);
        cr.splice(0, cr.length);
        return true;
    };
    documents.toString = function() {
        return documents.join('...\n');
    };
    return documents;
}

});

parcelRegister("2U8gU", function(module, exports) {

$parcel$export(module.exports, "f", () => $21d73a50ab356f68$export$2d1720544b23b823);
$parcel$export(module.exports, "N", () => $21d73a50ab356f68$export$a07804094c3ecf2d);
$parcel$export(module.exports, "t", () => $21d73a50ab356f68$export$625550452a3fa3ec);
$parcel$export(module.exports, "S", () => $21d73a50ab356f68$export$25ce5a424b770e84);
$parcel$export(module.exports, "e", () => $21d73a50ab356f68$export$f1e1789686576879);
$parcel$export(module.exports, "C", () => $21d73a50ab356f68$export$e7094788287c5e9b);
$parcel$export(module.exports, "Y", () => $21d73a50ab356f68$export$8743009a87fcb00f);
$parcel$export(module.exports, "P", () => $21d73a50ab356f68$export$56c0d5a1e737357d);
$parcel$export(module.exports, "A", () => $21d73a50ab356f68$export$ebd11618f299a286);
$parcel$export(module.exports, "l", () => $21d73a50ab356f68$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $21d73a50ab356f68$export$4368d992c4eafac0);
$parcel$export(module.exports, "M", () => $21d73a50ab356f68$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "b", () => $21d73a50ab356f68$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "a", () => $21d73a50ab356f68$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $21d73a50ab356f68$export$23f2a1d2818174ef);
$parcel$export(module.exports, "n", () => $21d73a50ab356f68$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "s", () => $21d73a50ab356f68$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "c", () => $21d73a50ab356f68$export$db3b6bfb95261072);
$parcel$export(module.exports, "k", () => $21d73a50ab356f68$export$342063e11d6c3cad);
$parcel$export(module.exports, "j", () => $21d73a50ab356f68$export$35e795649ee09318);
$parcel$export(module.exports, "r", () => $21d73a50ab356f68$export$43caf9889c228507);
$parcel$export(module.exports, "g", () => $21d73a50ab356f68$export$39b482c5e57630a8);
$parcel$export(module.exports, "h", () => $21d73a50ab356f68$export$dda1d9f60106f0e9);

var $1GDs0 = parcelRequire("1GDs0");
function $21d73a50ab356f68$var$addCommentBefore(str, indent, comment) {
    if (!comment) return str;
    var cc = comment.replace(/[\s\S]^/gm, "$&".concat(indent, "#"));
    return "#".concat(cc, "\n").concat(indent).concat(str);
}
function $21d73a50ab356f68$export$2d1720544b23b823(str, indent, comment) {
    return !comment ? str : comment.indexOf('\n') === -1 ? "".concat(str, " #").concat(comment) : "".concat(str, "\n") + comment.replace(/^/gm, "".concat(indent || '', "#"));
}
var $21d73a50ab356f68$export$a07804094c3ecf2d = function Node() {
    (0, $1GDs0.c)(this, Node);
};
function $21d73a50ab356f68$export$625550452a3fa3ec(value, arg, ctx) {
    if (Array.isArray(value)) return value.map(function(v, i) {
        return $21d73a50ab356f68$export$625550452a3fa3ec(v, String(i), ctx);
    });
    if (value && typeof value.toJSON === 'function') {
        var anchor = ctx && ctx.anchors && ctx.anchors.get(value);
        if (anchor) ctx.onCreate = function(res) {
            anchor.res = res;
            delete ctx.onCreate;
        };
        var res = value.toJSON(arg, ctx);
        if (anchor && ctx.onCreate) ctx.onCreate(res);
        return res;
    }
    if ((!ctx || !ctx.keep) && typeof value === 'bigint') return Number(value);
    return value;
}
var $21d73a50ab356f68$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Scalar, _Node);
    var _super = (0, $1GDs0.k)(Scalar);
    function Scalar(value) {
        var _this;
        (0, $1GDs0.c)(this, Scalar);
        _this = _super.call(this);
        _this.value = value;
        return _this;
    }
    (0, $1GDs0.b)(Scalar, [
        {
            key: "toJSON",
            value: function toJSON$1(arg, ctx) {
                return ctx && ctx.keep ? this.value : $21d73a50ab356f68$export$625550452a3fa3ec(this.value, arg, ctx);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return String(this.value);
            }
        }
    ]);
    return Scalar;
}($21d73a50ab356f68$export$a07804094c3ecf2d);
function $21d73a50ab356f68$var$collectionFromPath(schema, path, value) {
    var v = value;
    for(var i = path.length - 1; i >= 0; --i){
        var k = path[i];
        if (Number.isInteger(k) && k >= 0) {
            var a = [];
            a[k] = v;
            v = a;
        } else {
            var o = {};
            Object.defineProperty(o, k, {
                value: v,
                writable: true,
                enumerable: true,
                configurable: true
            });
            v = o;
        }
    }
    return schema.createNode(v, false);
} // null, undefined, or an empty non-string iterable (e.g. [])
var $21d73a50ab356f68$export$f1e1789686576879 = function isEmptyPath(path) {
    return path == null || (0, $1GDs0.a)(path) === 'object' && path[Symbol.iterator]().next().done;
};
var $21d73a50ab356f68$export$e7094788287c5e9b = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Collection, _Node);
    var _super = (0, $1GDs0.k)(Collection);
    function Collection(schema) {
        var _this;
        (0, $1GDs0.c)(this, Collection);
        _this = _super.call(this);
        (0, $1GDs0.e)((0, $1GDs0.p)(_this), "items", []);
        _this.schema = schema;
        return _this;
    }
    (0, $1GDs0.b)(Collection, [
        {
            key: "addIn",
            value: function addIn(path, value) {
                if ($21d73a50ab356f68$export$f1e1789686576879(path)) this.add(value);
                else {
                    var _path = (0, $1GDs0.q)(path), key = _path[0], rest = _path.slice(1);
                    var node = this.get(key, true);
                    if (node instanceof Collection) node.addIn(rest, value);
                    else if (node === undefined && this.schema) this.set(key, $21d73a50ab356f68$var$collectionFromPath(this.schema, rest, value));
                    else throw new Error("Expected YAML collection at ".concat(key, ". Remaining path: ").concat(rest));
                }
            }
        },
        {
            key: "deleteIn",
            value: function deleteIn(_ref) {
                var _ref2 = (0, $1GDs0.q)(_ref), key = _ref2[0], rest = _ref2.slice(1);
                if (rest.length === 0) return this.delete(key);
                var node = this.get(key, true);
                if (node instanceof Collection) return node.deleteIn(rest);
                else throw new Error("Expected YAML collection at ".concat(key, ". Remaining path: ").concat(rest));
            }
        },
        {
            key: "getIn",
            value: function getIn(_ref3, keepScalar) {
                var _ref4 = (0, $1GDs0.q)(_ref3), key = _ref4[0], rest = _ref4.slice(1);
                var node = this.get(key, true);
                if (rest.length === 0) return !keepScalar && node instanceof $21d73a50ab356f68$export$25ce5a424b770e84 ? node.value : node;
                else return node instanceof Collection ? node.getIn(rest, keepScalar) : undefined;
            }
        },
        {
            key: "hasAllNullValues",
            value: function hasAllNullValues() {
                return this.items.every(function(node) {
                    if (!node || node.type !== 'PAIR') return false;
                    var n = node.value;
                    return n == null || n instanceof $21d73a50ab356f68$export$25ce5a424b770e84 && n.value == null && !n.commentBefore && !n.comment && !n.tag;
                });
            }
        },
        {
            key: "hasIn",
            value: function hasIn(_ref5) {
                var _ref6 = (0, $1GDs0.q)(_ref5), key = _ref6[0], rest = _ref6.slice(1);
                if (rest.length === 0) return this.has(key);
                var node = this.get(key, true);
                return node instanceof Collection ? node.hasIn(rest) : false;
            }
        },
        {
            key: "setIn",
            value: function setIn(_ref7, value) {
                var _ref8 = (0, $1GDs0.q)(_ref7), key = _ref8[0], rest = _ref8.slice(1);
                if (rest.length === 0) this.set(key, value);
                else {
                    var node = this.get(key, true);
                    if (node instanceof Collection) node.setIn(rest, value);
                    else if (node === undefined && this.schema) this.set(key, $21d73a50ab356f68$var$collectionFromPath(this.schema, rest, value));
                    else throw new Error("Expected YAML collection at ".concat(key, ". Remaining path: ").concat(rest));
                }
            } // overridden in implementations
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return null;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, _ref9, onComment, onChompKeep) {
                var _this2 = this;
                var blockItem = _ref9.blockItem, flowChars = _ref9.flowChars, isMap = _ref9.isMap, itemIndent = _ref9.itemIndent;
                var _ctx = ctx, indent = _ctx.indent, indentStep = _ctx.indentStep, stringify = _ctx.stringify;
                var inFlow = this.type === (0, $1GDs0.T).FLOW_MAP || this.type === (0, $1GDs0.T).FLOW_SEQ || ctx.inFlow;
                if (inFlow) itemIndent += indentStep;
                var allNullValues = isMap && this.hasAllNullValues();
                ctx = Object.assign({}, ctx, {
                    allNullValues: allNullValues,
                    indent: itemIndent,
                    inFlow: inFlow,
                    type: null
                });
                var chompKeep = false;
                var hasItemWithNewLine = false;
                var nodes = this.items.reduce(function(nodes, item, i) {
                    var comment;
                    if (item) {
                        if (!chompKeep && item.spaceBefore) nodes.push({
                            type: 'comment',
                            str: ''
                        });
                        if (item.commentBefore) item.commentBefore.match(/^.*$/gm).forEach(function(line) {
                            nodes.push({
                                type: 'comment',
                                str: "#".concat(line)
                            });
                        });
                        if (item.comment) comment = item.comment;
                        if (inFlow && (!chompKeep && item.spaceBefore || item.commentBefore || item.comment || item.key && (item.key.commentBefore || item.key.comment) || item.value && (item.value.commentBefore || item.value.comment))) hasItemWithNewLine = true;
                    }
                    chompKeep = false;
                    var str = stringify(item, ctx, function() {
                        return comment = null;
                    }, function() {
                        return chompKeep = true;
                    });
                    if (inFlow && !hasItemWithNewLine && str.includes('\n')) hasItemWithNewLine = true;
                    if (inFlow && i < _this2.items.length - 1) str += ',';
                    str = $21d73a50ab356f68$export$2d1720544b23b823(str, itemIndent, comment);
                    if (chompKeep && (comment || inFlow)) chompKeep = false;
                    nodes.push({
                        type: 'item',
                        str: str
                    });
                    return nodes;
                }, []);
                var str;
                if (nodes.length === 0) str = flowChars.start + flowChars.end;
                else if (inFlow) {
                    var start = flowChars.start, end = flowChars.end;
                    var strings = nodes.map(function(n) {
                        return n.str;
                    });
                    if (hasItemWithNewLine || strings.reduce(function(sum, str) {
                        return sum + str.length + 2;
                    }, 2) > Collection.maxFlowStringSingleLineLength) {
                        str = start;
                        var _iterator = (0, $1GDs0._)(strings), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var s = _step.value;
                                str += s ? "\n".concat(indentStep).concat(indent).concat(s) : '\n';
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        str += "\n".concat(indent).concat(end);
                    } else str = "".concat(start, " ").concat(strings.join(' '), " ").concat(end);
                } else {
                    var _strings = nodes.map(blockItem);
                    str = _strings.shift();
                    var _iterator2 = (0, $1GDs0._)(_strings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _s = _step2.value;
                            str += _s ? "\n".concat(indent).concat(_s) : '\n';
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
                if (this.comment) {
                    str += '\n' + this.comment.replace(/^/gm, "".concat(indent, "#"));
                    if (onComment) onComment();
                } else if (chompKeep && onChompKeep) onChompKeep();
                return str;
            }
        }
    ]);
    return Collection;
}($21d73a50ab356f68$export$a07804094c3ecf2d);
(0, $1GDs0.e)($21d73a50ab356f68$export$e7094788287c5e9b, "maxFlowStringSingleLineLength", 60);
function $21d73a50ab356f68$var$asItemIndex(key) {
    var idx = key instanceof $21d73a50ab356f68$export$25ce5a424b770e84 ? key.value : key;
    if (idx && typeof idx === 'string') idx = Number(idx);
    return Number.isInteger(idx) && idx >= 0 ? idx : null;
}
var $21d73a50ab356f68$export$8743009a87fcb00f = /*#__PURE__*/ function(_Collection) {
    (0, $1GDs0.j)(YAMLSeq, _Collection);
    var _super = (0, $1GDs0.k)(YAMLSeq);
    function YAMLSeq() {
        (0, $1GDs0.c)(this, YAMLSeq);
        return _super.apply(this, arguments);
    }
    (0, $1GDs0.b)(YAMLSeq, [
        {
            key: "add",
            value: function add(value) {
                this.items.push(value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var idx = $21d73a50ab356f68$var$asItemIndex(key);
                if (typeof idx !== 'number') return false;
                var del = this.items.splice(idx, 1);
                return del.length > 0;
            }
        },
        {
            key: "get",
            value: function get(key, keepScalar) {
                var idx = $21d73a50ab356f68$var$asItemIndex(key);
                if (typeof idx !== 'number') return undefined;
                var it = this.items[idx];
                return !keepScalar && it instanceof $21d73a50ab356f68$export$25ce5a424b770e84 ? it.value : it;
            }
        },
        {
            key: "has",
            value: function has(key) {
                var idx = $21d73a50ab356f68$var$asItemIndex(key);
                return typeof idx === 'number' && idx < this.items.length;
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var idx = $21d73a50ab356f68$var$asItemIndex(key);
                if (typeof idx !== 'number') throw new Error("Expected a valid index, not ".concat(key, "."));
                this.items[idx] = value;
            }
        },
        {
            key: "toJSON",
            value: function toJSON$1(_, ctx) {
                var seq = [];
                if (ctx && ctx.onCreate) ctx.onCreate(seq);
                var i = 0;
                var _iterator = (0, $1GDs0._)(this.items), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        seq.push($21d73a50ab356f68$export$625550452a3fa3ec(item, String(i++), ctx));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return seq;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx) return JSON.stringify(this);
                return (0, $1GDs0.l)((0, $1GDs0.m)(YAMLSeq.prototype), "toString", this).call(this, ctx, {
                    blockItem: function blockItem(n) {
                        return n.type === 'comment' ? n.str : "- ".concat(n.str);
                    },
                    flowChars: {
                        start: '[',
                        end: ']'
                    },
                    isMap: false,
                    itemIndent: (ctx.indent || '') + '  '
                }, onComment, onChompKeep);
            }
        }
    ]);
    return YAMLSeq;
}($21d73a50ab356f68$export$e7094788287c5e9b);
var $21d73a50ab356f68$var$stringifyKey = function stringifyKey(key, jsKey, ctx) {
    if (jsKey === null) return '';
    if ((0, $1GDs0.a)(jsKey) !== 'object') return String(jsKey);
    if (key instanceof $21d73a50ab356f68$export$a07804094c3ecf2d && ctx && ctx.doc) return key.toString({
        anchors: Object.create(null),
        doc: ctx.doc,
        indent: '',
        indentStep: ctx.indentStep,
        inFlow: true,
        inStringifyKey: true,
        stringify: ctx.stringify
    });
    return JSON.stringify(jsKey);
};
var $21d73a50ab356f68$export$56c0d5a1e737357d = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Pair, _Node);
    var _super = (0, $1GDs0.k)(Pair);
    function Pair(key) {
        var _this;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        (0, $1GDs0.c)(this, Pair);
        _this = _super.call(this);
        _this.key = key;
        _this.value = value;
        _this.type = Pair.Type.PAIR;
        return _this;
    }
    (0, $1GDs0.b)(Pair, [
        {
            key: "commentBefore",
            get: function get() {
                return this.key instanceof $21d73a50ab356f68$export$a07804094c3ecf2d ? this.key.commentBefore : undefined;
            },
            set: function set(cb) {
                if (this.key == null) this.key = new $21d73a50ab356f68$export$25ce5a424b770e84(null);
                if (this.key instanceof $21d73a50ab356f68$export$a07804094c3ecf2d) this.key.commentBefore = cb;
                else {
                    var msg = 'Pair.commentBefore is an alias for Pair.key.commentBefore. To set it, the key must be a Node.';
                    throw new Error(msg);
                }
            }
        },
        {
            key: "addToJSMap",
            value: function addToJSMap(ctx, map) {
                var key = $21d73a50ab356f68$export$625550452a3fa3ec(this.key, '', ctx);
                if (map instanceof Map) {
                    var value = $21d73a50ab356f68$export$625550452a3fa3ec(this.value, key, ctx);
                    map.set(key, value);
                } else if (map instanceof Set) map.add(key);
                else {
                    var stringKey = $21d73a50ab356f68$var$stringifyKey(this.key, key, ctx);
                    var _value = $21d73a50ab356f68$export$625550452a3fa3ec(this.value, stringKey, ctx);
                    if (stringKey in map) Object.defineProperty(map, stringKey, {
                        value: _value,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                    else map[stringKey] = _value;
                }
                return map;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, ctx) {
                var pair = ctx && ctx.mapAsMap ? new Map() : {};
                return this.addToJSMap(ctx, pair);
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx || !ctx.doc) return JSON.stringify(this);
                var _ctx$doc$options = ctx.doc.options, indentSize = _ctx$doc$options.indent, indentSeq = _ctx$doc$options.indentSeq, simpleKeys = _ctx$doc$options.simpleKeys;
                var key = this.key, value = this.value;
                var keyComment = key instanceof $21d73a50ab356f68$export$a07804094c3ecf2d && key.comment;
                if (simpleKeys) {
                    if (keyComment) throw new Error('With simple keys, key nodes cannot have comments');
                    if (key instanceof $21d73a50ab356f68$export$e7094788287c5e9b) {
                        var msg = 'With simple keys, collection cannot be used as a key value';
                        throw new Error(msg);
                    }
                }
                var explicitKey = !simpleKeys && (!key || keyComment || (key instanceof $21d73a50ab356f68$export$a07804094c3ecf2d ? key instanceof $21d73a50ab356f68$export$e7094788287c5e9b || key.type === (0, $1GDs0.T).BLOCK_FOLDED || key.type === (0, $1GDs0.T).BLOCK_LITERAL : (0, $1GDs0.a)(key) === 'object'));
                var _ctx = ctx, doc = _ctx.doc, indent = _ctx.indent, indentStep = _ctx.indentStep, stringify = _ctx.stringify;
                ctx = Object.assign({}, ctx, {
                    implicitKey: !explicitKey,
                    indent: indent + indentStep
                });
                var chompKeep = false;
                var str = stringify(key, ctx, function() {
                    return keyComment = null;
                }, function() {
                    return chompKeep = true;
                });
                str = $21d73a50ab356f68$export$2d1720544b23b823(str, ctx.indent, keyComment);
                if (!explicitKey && str.length > 1024) {
                    if (simpleKeys) throw new Error('With simple keys, single line scalar must not span more than 1024 characters');
                    explicitKey = true;
                }
                if (ctx.allNullValues && !simpleKeys) {
                    if (this.comment) {
                        str = $21d73a50ab356f68$export$2d1720544b23b823(str, ctx.indent, this.comment);
                        if (onComment) onComment();
                    } else if (chompKeep && !keyComment && onChompKeep) onChompKeep();
                    return ctx.inFlow && !explicitKey ? str : "? ".concat(str);
                }
                str = explicitKey ? "? ".concat(str, "\n").concat(indent, ":") : "".concat(str, ":");
                if (this.comment) {
                    // expected (but not strictly required) to be a single-line comment
                    str = $21d73a50ab356f68$export$2d1720544b23b823(str, ctx.indent, this.comment);
                    if (onComment) onComment();
                }
                var vcb = '';
                var valueComment = null;
                if (value instanceof $21d73a50ab356f68$export$a07804094c3ecf2d) {
                    if (value.spaceBefore) vcb = '\n';
                    if (value.commentBefore) {
                        var cs = value.commentBefore.replace(/^/gm, "".concat(ctx.indent, "#"));
                        vcb += "\n".concat(cs);
                    }
                    valueComment = value.comment;
                } else if (value && (0, $1GDs0.a)(value) === 'object') value = doc.schema.createNode(value, true);
                ctx.implicitKey = false;
                if (!explicitKey && !this.comment && value instanceof $21d73a50ab356f68$export$25ce5a424b770e84) ctx.indentAtStart = str.length + 1;
                chompKeep = false;
                if (!indentSeq && indentSize >= 2 && !ctx.inFlow && !explicitKey && value instanceof $21d73a50ab356f68$export$8743009a87fcb00f && value.type !== (0, $1GDs0.T).FLOW_SEQ && !value.tag && !doc.anchors.getName(value)) // If indentSeq === false, consider '- ' as part of indentation where possible
                ctx.indent = ctx.indent.substr(2);
                var valueStr = stringify(value, ctx, function() {
                    return valueComment = null;
                }, function() {
                    return chompKeep = true;
                });
                var ws = ' ';
                if (vcb || this.comment) ws = "".concat(vcb, "\n").concat(ctx.indent);
                else if (!explicitKey && value instanceof $21d73a50ab356f68$export$e7094788287c5e9b) {
                    var flow = valueStr[0] === '[' || valueStr[0] === '{';
                    if (!flow || valueStr.includes('\n')) ws = "\n".concat(ctx.indent);
                } else if (valueStr[0] === '\n') ws = '';
                if (chompKeep && !valueComment && onChompKeep) onChompKeep();
                return $21d73a50ab356f68$export$2d1720544b23b823(str + ws + valueStr, ctx.indent, valueComment);
            }
        }
    ]);
    return Pair;
}($21d73a50ab356f68$export$a07804094c3ecf2d);
(0, $1GDs0.e)($21d73a50ab356f68$export$56c0d5a1e737357d, "Type", {
    PAIR: 'PAIR',
    MERGE_PAIR: 'MERGE_PAIR'
});
var $21d73a50ab356f68$var$getAliasCount = function getAliasCount(node, anchors) {
    if (node instanceof $21d73a50ab356f68$export$ebd11618f299a286) {
        var anchor = anchors.get(node.source);
        return anchor.count * anchor.aliasCount;
    } else if (node instanceof $21d73a50ab356f68$export$e7094788287c5e9b) {
        var count = 0;
        var _iterator = (0, $1GDs0._)(node.items), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                var c = getAliasCount(item, anchors);
                if (c > count) count = c;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return count;
    } else if (node instanceof $21d73a50ab356f68$export$56c0d5a1e737357d) {
        var kc = getAliasCount(node.key, anchors);
        var vc = getAliasCount(node.value, anchors);
        return Math.max(kc, vc);
    }
    return 1;
};
var $21d73a50ab356f68$export$ebd11618f299a286 = /*#__PURE__*/ function(_Node) {
    (0, $1GDs0.j)(Alias, _Node);
    var _super = (0, $1GDs0.k)(Alias);
    function Alias(source) {
        var _this;
        (0, $1GDs0.c)(this, Alias);
        _this = _super.call(this);
        _this.source = source;
        _this.type = (0, $1GDs0.T).ALIAS;
        return _this;
    }
    (0, $1GDs0.b)(Alias, [
        {
            key: "tag",
            set: function set(t) {
                throw new Error('Alias nodes cannot have tags');
            }
        },
        {
            key: "toJSON",
            value: function toJSON$1(arg, ctx) {
                if (!ctx) return $21d73a50ab356f68$export$625550452a3fa3ec(this.source, arg, ctx);
                var anchors = ctx.anchors, maxAliasCount = ctx.maxAliasCount;
                var anchor = anchors.get(this.source);
                /* istanbul ignore if */ if (!anchor || anchor.res === undefined) {
                    var msg = 'This should not happen: Alias anchor was not resolved?';
                    if (this.cstNode) throw new (0, $1GDs0.o)(this.cstNode, msg);
                    else throw new ReferenceError(msg);
                }
                if (maxAliasCount >= 0) {
                    anchor.count += 1;
                    if (anchor.aliasCount === 0) anchor.aliasCount = $21d73a50ab356f68$var$getAliasCount(this.source, anchors);
                    if (anchor.count * anchor.aliasCount > maxAliasCount) {
                        var _msg = 'Excessive alias count indicates a resource exhaustion attack';
                        if (this.cstNode) throw new (0, $1GDs0.o)(this.cstNode, _msg);
                        else throw new ReferenceError(_msg);
                    }
                }
                return anchor.res;
            } // Only called when stringifying an alias mapping key while constructing
        },
        {
            key: "toString",
            value: function toString(ctx) {
                return Alias.stringify(this, ctx);
            }
        }
    ], [
        {
            key: "stringify",
            value: function stringify(_ref, _ref2) {
                var range = _ref.range, source = _ref.source;
                var anchors = _ref2.anchors, doc = _ref2.doc, implicitKey = _ref2.implicitKey, inStringifyKey = _ref2.inStringifyKey;
                var anchor = Object.keys(anchors).find(function(a) {
                    return anchors[a] === source;
                });
                if (!anchor && inStringifyKey) anchor = doc.anchors.getName(source) || doc.anchors.newName();
                if (anchor) return "*".concat(anchor).concat(implicitKey ? ' ' : '');
                var msg = doc.anchors.getName(source) ? 'Alias node must be after source node' : 'Source node not found for alias node';
                throw new Error("".concat(msg, " [").concat(range, "]"));
            }
        }
    ]);
    return Alias;
}($21d73a50ab356f68$export$a07804094c3ecf2d);
(0, $1GDs0.e)($21d73a50ab356f68$export$ebd11618f299a286, "default", true);
function $21d73a50ab356f68$export$882b5998b3b9117c(items, key) {
    var k = key instanceof $21d73a50ab356f68$export$25ce5a424b770e84 ? key.value : key;
    var _iterator = (0, $1GDs0._)(items), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var it = _step.value;
            if (it instanceof $21d73a50ab356f68$export$56c0d5a1e737357d) {
                if (it.key === key || it.key === k) return it;
                if (it.key && it.key.value === k) return it;
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
var $21d73a50ab356f68$export$4368d992c4eafac0 = /*#__PURE__*/ function(_Collection) {
    (0, $1GDs0.j)(YAMLMap, _Collection);
    var _super = (0, $1GDs0.k)(YAMLMap);
    function YAMLMap() {
        (0, $1GDs0.c)(this, YAMLMap);
        return _super.apply(this, arguments);
    }
    (0, $1GDs0.b)(YAMLMap, [
        {
            key: "add",
            value: function add(pair, overwrite) {
                if (!pair) pair = new $21d73a50ab356f68$export$56c0d5a1e737357d(pair);
                else if (!(pair instanceof $21d73a50ab356f68$export$56c0d5a1e737357d)) pair = new $21d73a50ab356f68$export$56c0d5a1e737357d(pair.key || pair, pair.value);
                var prev = $21d73a50ab356f68$export$882b5998b3b9117c(this.items, pair.key);
                var sortEntries = this.schema && this.schema.sortMapEntries;
                if (prev) {
                    if (overwrite) prev.value = pair.value;
                    else throw new Error("Key ".concat(pair.key, " already set"));
                } else if (sortEntries) {
                    var i = this.items.findIndex(function(item) {
                        return sortEntries(pair, item) < 0;
                    });
                    if (i === -1) this.items.push(pair);
                    else this.items.splice(i, 0, pair);
                } else this.items.push(pair);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var it = $21d73a50ab356f68$export$882b5998b3b9117c(this.items, key);
                if (!it) return false;
                var del = this.items.splice(this.items.indexOf(it), 1);
                return del.length > 0;
            }
        },
        {
            key: "get",
            value: function get(key, keepScalar) {
                var it = $21d73a50ab356f68$export$882b5998b3b9117c(this.items, key);
                var node = it && it.value;
                return !keepScalar && node instanceof $21d73a50ab356f68$export$25ce5a424b770e84 ? node.value : node;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return !!$21d73a50ab356f68$export$882b5998b3b9117c(this.items, key);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                this.add(new $21d73a50ab356f68$export$56c0d5a1e737357d(key, value), true);
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, ctx, Type) {
                var map = Type ? new Type() : ctx && ctx.mapAsMap ? new Map() : {};
                if (ctx && ctx.onCreate) ctx.onCreate(map);
                var _iterator2 = (0, $1GDs0._)(this.items), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var item = _step2.value;
                        item.addToJSMap(ctx, map);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return map;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx) return JSON.stringify(this);
                var _iterator3 = (0, $1GDs0._)(this.items), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var item = _step3.value;
                        if (!(item instanceof $21d73a50ab356f68$export$56c0d5a1e737357d)) throw new Error("Map items must all be pairs; found ".concat(JSON.stringify(item), " instead"));
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return (0, $1GDs0.l)((0, $1GDs0.m)(YAMLMap.prototype), "toString", this).call(this, ctx, {
                    blockItem: function blockItem(n) {
                        return n.str;
                    },
                    flowChars: {
                        start: '{',
                        end: '}'
                    },
                    isMap: true,
                    itemIndent: ctx.indent || ''
                }, onComment, onChompKeep);
            }
        }
    ]);
    return YAMLMap;
}($21d73a50ab356f68$export$e7094788287c5e9b);
var $21d73a50ab356f68$var$MERGE_KEY = '<<';
var $21d73a50ab356f68$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Pair) {
    (0, $1GDs0.j)(Merge, _Pair);
    var _super = (0, $1GDs0.k)(Merge);
    function Merge(pair) {
        var _this;
        (0, $1GDs0.c)(this, Merge);
        if (pair instanceof $21d73a50ab356f68$export$56c0d5a1e737357d) {
            var seq = pair.value;
            if (!(seq instanceof $21d73a50ab356f68$export$8743009a87fcb00f)) {
                seq = new $21d73a50ab356f68$export$8743009a87fcb00f();
                seq.items.push(pair.value);
                seq.range = pair.value.range;
            }
            _this = _super.call(this, pair.key, seq);
            _this.range = pair.range;
        } else _this = _super.call(this, new $21d73a50ab356f68$export$25ce5a424b770e84($21d73a50ab356f68$var$MERGE_KEY), new $21d73a50ab356f68$export$8743009a87fcb00f());
        _this.type = $21d73a50ab356f68$export$56c0d5a1e737357d.Type.MERGE_PAIR;
        return (0, $1GDs0.r)(_this);
    } // If the value associated with a merge key is a single mapping node, each of
    // its key/value pairs is inserted into the current mapping, unless the key
    // already exists in it. If the value associated with the merge key is a
    // sequence, then this sequence is expected to contain mapping nodes and each
    // of these nodes is merged in turn according to its order in the sequence.
    // Keys in mapping nodes earlier in the sequence override keys specified in
    // later mapping nodes. -- http://yaml.org/type/merge.html
    (0, $1GDs0.b)(Merge, [
        {
            key: "addToJSMap",
            value: function addToJSMap(ctx, map) {
                var _iterator = (0, $1GDs0._)(this.value.items), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var source = _step.value.source;
                        if (!(source instanceof $21d73a50ab356f68$export$4368d992c4eafac0)) throw new Error('Merge sources must be maps');
                        var srcMap = source.toJSON(null, ctx, Map);
                        var _iterator2 = (0, $1GDs0._)(srcMap), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var _step2$value = (0, $1GDs0.h)(_step2.value, 2), key = _step2$value[0], value = _step2$value[1];
                                if (map instanceof Map) {
                                    if (!map.has(key)) map.set(key, value);
                                } else if (map instanceof Set) map.add(key);
                                else if (!Object.prototype.hasOwnProperty.call(map, key)) Object.defineProperty(map, key, {
                                    value: value,
                                    writable: true,
                                    enumerable: true,
                                    configurable: true
                                });
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return map;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment) {
                var seq = this.value;
                if (seq.items.length > 1) return (0, $1GDs0.l)((0, $1GDs0.m)(Merge.prototype), "toString", this).call(this, ctx, onComment);
                this.value = seq.items[0];
                var str = (0, $1GDs0.l)((0, $1GDs0.m)(Merge.prototype), "toString", this).call(this, ctx, onComment);
                this.value = seq;
                return str;
            }
        }
    ]);
    return Merge;
}($21d73a50ab356f68$export$56c0d5a1e737357d);
var $21d73a50ab356f68$export$8b22cf2602fb60ce = {
    defaultType: (0, $1GDs0.T).BLOCK_LITERAL,
    lineWidth: 76
};
var $21d73a50ab356f68$export$407448d2b89b1813 = {
    trueStr: 'true',
    falseStr: 'false'
};
var $21d73a50ab356f68$export$23f2a1d2818174ef = {
    asBigInt: false
};
var $21d73a50ab356f68$export$7ccc53e8f1e7dfc5 = {
    nullStr: 'null'
};
var $21d73a50ab356f68$export$2408f22a0fab9ae5 = {
    defaultType: (0, $1GDs0.T).PLAIN,
    doubleQuoted: {
        jsonEncoding: false,
        minMultiLineLength: 40
    },
    fold: {
        lineWidth: 80,
        minContentWidth: 20
    }
};
function $21d73a50ab356f68$var$resolveScalar(str, tags, scalarFallback) {
    var _iterator = (0, $1GDs0._)(tags), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, format = _step$value.format, test = _step$value.test, resolve = _step$value.resolve;
            if (test) {
                var match = str.match(test);
                if (match) {
                    var res = resolve.apply(null, match);
                    if (!(res instanceof $21d73a50ab356f68$export$25ce5a424b770e84)) res = new $21d73a50ab356f68$export$25ce5a424b770e84(res);
                    if (format) res.format = format;
                    return res;
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (scalarFallback) str = scalarFallback(str);
    return new $21d73a50ab356f68$export$25ce5a424b770e84(str);
}
var $21d73a50ab356f68$var$FOLD_FLOW = 'flow';
var $21d73a50ab356f68$var$FOLD_BLOCK = 'block';
var $21d73a50ab356f68$var$FOLD_QUOTED = 'quoted'; // presumes i+1 is at the start of a line
// returns index of last newline in more-indented block
var $21d73a50ab356f68$var$consumeMoreIndentedLines = function consumeMoreIndentedLines(text, i) {
    var ch = text[i + 1];
    while(ch === ' ' || ch === '\t'){
        do ch = text[i += 1];
        while (ch && ch !== '\n');
        ch = text[i + 1];
    }
    return i;
};
/**
 * Tries to keep input at up to `lineWidth` characters, splitting only on spaces
 * not followed by newlines or spaces unless `mode` is `'quoted'`. Lines are
 * terminated with `\n` and started with `indent`.
 *
 * @param {string} text
 * @param {string} indent
 * @param {string} [mode='flow'] `'block'` prevents more-indented lines
 *   from being folded; `'quoted'` allows for `\` escapes, including escaped
 *   newlines
 * @param {Object} options
 * @param {number} [options.indentAtStart] Accounts for leading contents on
 *   the first line, defaulting to `indent.length`
 * @param {number} [options.lineWidth=80]
 * @param {number} [options.minContentWidth=20] Allow highly indented lines to
 *   stretch the line width or indent content from the start
 * @param {function} options.onFold Called once if the text is folded
 * @param {function} options.onFold Called once if any line of text exceeds
 *   lineWidth characters
 */ function $21d73a50ab356f68$var$foldFlowLines(text, indent, mode, _ref) {
    var indentAtStart = _ref.indentAtStart, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 80 : _ref$lineWidth, _ref$minContentWidth = _ref.minContentWidth, minContentWidth = _ref$minContentWidth === void 0 ? 20 : _ref$minContentWidth, onFold = _ref.onFold, onOverflow = _ref.onOverflow;
    if (!lineWidth || lineWidth < 0) return text;
    var endStep = Math.max(1 + minContentWidth, 1 + lineWidth - indent.length);
    if (text.length <= endStep) return text;
    var folds = [];
    var escapedFolds = {};
    var end = lineWidth - indent.length;
    if (typeof indentAtStart === 'number') {
        if (indentAtStart > lineWidth - Math.max(2, minContentWidth)) folds.push(0);
        else end = lineWidth - indentAtStart;
    }
    var split = undefined;
    var prev = undefined;
    var overflow = false;
    var i = -1;
    var escStart = -1;
    var escEnd = -1;
    if (mode === $21d73a50ab356f68$var$FOLD_BLOCK) {
        i = $21d73a50ab356f68$var$consumeMoreIndentedLines(text, i);
        if (i !== -1) end = i + endStep;
    }
    for(var ch; ch = text[i += 1];){
        if (mode === $21d73a50ab356f68$var$FOLD_QUOTED && ch === '\\') {
            escStart = i;
            switch(text[i + 1]){
                case 'x':
                    i += 3;
                    break;
                case 'u':
                    i += 5;
                    break;
                case 'U':
                    i += 9;
                    break;
                default:
                    i += 1;
            }
            escEnd = i;
        }
        if (ch === '\n') {
            if (mode === $21d73a50ab356f68$var$FOLD_BLOCK) i = $21d73a50ab356f68$var$consumeMoreIndentedLines(text, i);
            end = i + endStep;
            split = undefined;
        } else {
            if (ch === ' ' && prev && prev !== ' ' && prev !== '\n' && prev !== '\t') {
                // space surrounded by non-space can be replaced with newline + indent
                var next = text[i + 1];
                if (next && next !== ' ' && next !== '\n' && next !== '\t') split = i;
            }
            if (i >= end) {
                if (split) {
                    folds.push(split);
                    end = split + endStep;
                    split = undefined;
                } else if (mode === $21d73a50ab356f68$var$FOLD_QUOTED) {
                    // white-space collected at end may stretch past lineWidth
                    while(prev === ' ' || prev === '\t'){
                        prev = ch;
                        ch = text[i += 1];
                        overflow = true;
                    } // Account for newline escape, but don't break preceding escape
                    var j = i > escEnd + 1 ? i - 2 : escStart - 1; // Bail out if lineWidth & minContentWidth are shorter than an escape string
                    if (escapedFolds[j]) return text;
                    folds.push(j);
                    escapedFolds[j] = true;
                    end = j + endStep;
                    split = undefined;
                } else overflow = true;
            }
        }
        prev = ch;
    }
    if (overflow && onOverflow) onOverflow();
    if (folds.length === 0) return text;
    if (onFold) onFold();
    var res = text.slice(0, folds[0]);
    for(var _i = 0; _i < folds.length; ++_i){
        var fold = folds[_i];
        var _end = folds[_i + 1] || text.length;
        if (fold === 0) res = "\n".concat(indent).concat(text.slice(0, _end));
        else {
            if (mode === $21d73a50ab356f68$var$FOLD_QUOTED && escapedFolds[fold]) res += "".concat(text[fold], "\\");
            res += "\n".concat(indent).concat(text.slice(fold + 1, _end));
        }
    }
    return res;
}
var $21d73a50ab356f68$var$getFoldOptions = function getFoldOptions(_ref) {
    var indentAtStart = _ref.indentAtStart;
    return indentAtStart ? Object.assign({
        indentAtStart: indentAtStart
    }, $21d73a50ab356f68$export$2408f22a0fab9ae5.fold) : $21d73a50ab356f68$export$2408f22a0fab9ae5.fold;
}; // Also checks for lines starting with %, as parsing the output as YAML 1.1 will
// presume that's starting a new document.
var $21d73a50ab356f68$var$containsDocumentMarker = function containsDocumentMarker(str) {
    return /^(%|---|\.\.\.)/m.test(str);
};
function $21d73a50ab356f68$var$lineLengthOverLimit(str, lineWidth, indentLength) {
    if (!lineWidth || lineWidth < 0) return false;
    var limit = lineWidth - indentLength;
    var strLen = str.length;
    if (strLen <= limit) return false;
    for(var i = 0, start = 0; i < strLen; ++i)if (str[i] === '\n') {
        if (i - start > limit) return true;
        start = i + 1;
        if (strLen - start <= limit) return false;
    }
    return true;
}
function $21d73a50ab356f68$var$doubleQuotedString(value, ctx) {
    var implicitKey = ctx.implicitKey;
    var _strOptions$doubleQuo = $21d73a50ab356f68$export$2408f22a0fab9ae5.doubleQuoted, jsonEncoding = _strOptions$doubleQuo.jsonEncoding, minMultiLineLength = _strOptions$doubleQuo.minMultiLineLength;
    var json = JSON.stringify(value);
    if (jsonEncoding) return json;
    var indent = ctx.indent || ($21d73a50ab356f68$var$containsDocumentMarker(value) ? '  ' : '');
    var str = '';
    var start = 0;
    for(var i = 0, ch = json[i]; ch; ch = json[++i]){
        if (ch === ' ' && json[i + 1] === '\\' && json[i + 2] === 'n') {
            // space before newline needs to be escaped to not be folded
            str += json.slice(start, i) + '\\ ';
            i += 1;
            start = i;
            ch = '\\';
        }
        if (ch === '\\') switch(json[i + 1]){
            case 'u':
                str += json.slice(start, i);
                var code = json.substr(i + 2, 4);
                switch(code){
                    case '0000':
                        str += '\\0';
                        break;
                    case '0007':
                        str += '\\a';
                        break;
                    case '000b':
                        str += '\\v';
                        break;
                    case '001b':
                        str += '\\e';
                        break;
                    case '0085':
                        str += '\\N';
                        break;
                    case '00a0':
                        str += '\\_';
                        break;
                    case '2028':
                        str += '\\L';
                        break;
                    case '2029':
                        str += '\\P';
                        break;
                    default:
                        if (code.substr(0, 2) === '00') str += '\\x' + code.substr(2);
                        else str += json.substr(i, 6);
                }
                i += 5;
                start = i + 1;
                break;
            case 'n':
                if (implicitKey || json[i + 2] === '"' || json.length < minMultiLineLength) i += 1;
                else {
                    // folding will eat first newline
                    str += json.slice(start, i) + '\n\n';
                    while(json[i + 2] === '\\' && json[i + 3] === 'n' && json[i + 4] !== '"'){
                        str += '\n';
                        i += 2;
                    }
                    str += indent; // space after newline needs to be escaped to not be folded
                    if (json[i + 2] === ' ') str += '\\';
                    i += 1;
                    start = i + 1;
                }
                break;
            default:
                i += 1;
        }
    }
    str = start ? str + json.slice(start) : json;
    return implicitKey ? str : $21d73a50ab356f68$var$foldFlowLines(str, indent, $21d73a50ab356f68$var$FOLD_QUOTED, $21d73a50ab356f68$var$getFoldOptions(ctx));
}
function $21d73a50ab356f68$var$singleQuotedString(value, ctx) {
    if (ctx.implicitKey) {
        if (/\n/.test(value)) return $21d73a50ab356f68$var$doubleQuotedString(value, ctx);
    } else {
        // single quoted string can't have leading or trailing whitespace around newline
        if (/[ \t]\n|\n[ \t]/.test(value)) return $21d73a50ab356f68$var$doubleQuotedString(value, ctx);
    }
    var indent = ctx.indent || ($21d73a50ab356f68$var$containsDocumentMarker(value) ? '  ' : '');
    var res = "'" + value.replace(/'/g, "''").replace(/\n+/g, "$&\n".concat(indent)) + "'";
    return ctx.implicitKey ? res : $21d73a50ab356f68$var$foldFlowLines(res, indent, $21d73a50ab356f68$var$FOLD_FLOW, $21d73a50ab356f68$var$getFoldOptions(ctx));
}
function $21d73a50ab356f68$var$blockString(_ref2, ctx, onComment, onChompKeep) {
    var comment = _ref2.comment, type = _ref2.type, value = _ref2.value;
    // 1. Block can't end in whitespace unless the last line is non-empty.
    // 2. Strings consisting of only whitespace are best rendered explicitly.
    if (/\n[\t ]+$/.test(value) || /^\s*$/.test(value)) return $21d73a50ab356f68$var$doubleQuotedString(value, ctx);
    var indent = ctx.indent || (ctx.forceBlockIndent || $21d73a50ab356f68$var$containsDocumentMarker(value) ? '  ' : '');
    var indentSize = indent ? '2' : '1'; // root is at -1
    var literal = type === (0, $1GDs0.T).BLOCK_FOLDED ? false : type === (0, $1GDs0.T).BLOCK_LITERAL ? true : !$21d73a50ab356f68$var$lineLengthOverLimit(value, $21d73a50ab356f68$export$2408f22a0fab9ae5.fold.lineWidth, indent.length);
    var header = literal ? '|' : '>';
    if (!value) return header + '\n';
    var wsStart = '';
    var wsEnd = '';
    value = value.replace(/[\n\t ]*$/, function(ws) {
        var n = ws.indexOf('\n');
        if (n === -1) header += '-'; // strip
        else if (value === ws || n !== ws.length - 1) {
            header += '+'; // keep
            if (onChompKeep) onChompKeep();
        }
        wsEnd = ws.replace(/\n$/, '');
        return '';
    }).replace(/^[\n ]*/, function(ws) {
        if (ws.indexOf(' ') !== -1) header += indentSize;
        var m = ws.match(/ +$/);
        if (m) {
            wsStart = ws.slice(0, -m[0].length);
            return m[0];
        } else {
            wsStart = ws;
            return '';
        }
    });
    if (wsEnd) wsEnd = wsEnd.replace(/\n+(?!\n|$)/g, "$&".concat(indent));
    if (wsStart) wsStart = wsStart.replace(/\n+/g, "$&".concat(indent));
    if (comment) {
        header += ' #' + comment.replace(/ ?[\r\n]+/g, ' ');
        if (onComment) onComment();
    }
    if (!value) return "".concat(header).concat(indentSize, "\n").concat(indent).concat(wsEnd);
    if (literal) {
        value = value.replace(/\n+/g, "$&".concat(indent));
        return "".concat(header, "\n").concat(indent).concat(wsStart).concat(value).concat(wsEnd);
    }
    value = value.replace(/\n+/g, '\n$&').replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, '$1$2') // more-indented lines aren't folded
    //         ^ ind.line  ^ empty     ^ capture next empty lines only at end of indent
    .replace(/\n+/g, "$&".concat(indent));
    var body = $21d73a50ab356f68$var$foldFlowLines("".concat(wsStart).concat(value).concat(wsEnd), indent, $21d73a50ab356f68$var$FOLD_BLOCK, $21d73a50ab356f68$export$2408f22a0fab9ae5.fold);
    return "".concat(header, "\n").concat(indent).concat(body);
}
function $21d73a50ab356f68$var$plainString(item, ctx, onComment, onChompKeep) {
    var comment = item.comment, type = item.type, value = item.value;
    var actualString = ctx.actualString, implicitKey = ctx.implicitKey, indent = ctx.indent, inFlow = ctx.inFlow;
    if (implicitKey && /[\n[\]{},]/.test(value) || inFlow && /[[\]{},]/.test(value)) return $21d73a50ab356f68$var$doubleQuotedString(value, ctx);
    if (!value || /^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(value)) // not allowed:
    // - empty string, '-' or '?'
    // - start with an indicator character (except [?:-]) or /[?-] /
    // - '\n ', ': ' or ' \n' anywhere
    // - '#' not preceded by a non-space char
    // - end with ' ' or ':'
    return implicitKey || inFlow || value.indexOf('\n') === -1 ? value.indexOf('"') !== -1 && value.indexOf("'") === -1 ? $21d73a50ab356f68$var$singleQuotedString(value, ctx) : $21d73a50ab356f68$var$doubleQuotedString(value, ctx) : $21d73a50ab356f68$var$blockString(item, ctx, onComment, onChompKeep);
    if (!implicitKey && !inFlow && type !== (0, $1GDs0.T).PLAIN && value.indexOf('\n') !== -1) // Where allowed & type not set explicitly, prefer block style for multiline strings
    return $21d73a50ab356f68$var$blockString(item, ctx, onComment, onChompKeep);
    if (indent === '' && $21d73a50ab356f68$var$containsDocumentMarker(value)) {
        ctx.forceBlockIndent = true;
        return $21d73a50ab356f68$var$blockString(item, ctx, onComment, onChompKeep);
    }
    var str = value.replace(/\n+/g, "$&\n".concat(indent)); // Verify that output will be parsed as a string, as e.g. plain numbers and
    // booleans get parsed with those types in v1.2 (e.g. '42', 'true' & '0.9e-3'),
    // and others in v1.1.
    if (actualString) {
        var tags = ctx.doc.schema.tags;
        var resolved = $21d73a50ab356f68$var$resolveScalar(str, tags, tags.scalarFallback).value;
        if (typeof resolved !== 'string') return $21d73a50ab356f68$var$doubleQuotedString(value, ctx);
    }
    var body = implicitKey ? str : $21d73a50ab356f68$var$foldFlowLines(str, indent, $21d73a50ab356f68$var$FOLD_FLOW, $21d73a50ab356f68$var$getFoldOptions(ctx));
    if (comment && !inFlow && (body.indexOf('\n') !== -1 || comment.indexOf('\n') !== -1)) {
        if (onComment) onComment();
        return $21d73a50ab356f68$var$addCommentBefore(body, indent, comment);
    }
    return body;
}
function $21d73a50ab356f68$export$db3b6bfb95261072(item, ctx, onComment, onChompKeep) {
    var defaultType = $21d73a50ab356f68$export$2408f22a0fab9ae5.defaultType;
    var implicitKey = ctx.implicitKey, inFlow = ctx.inFlow;
    var _item = item, type = _item.type, value = _item.value;
    if (typeof value !== 'string') {
        value = String(value);
        item = Object.assign({}, item, {
            value: value
        });
    }
    var _stringify = function _stringify(_type) {
        switch(_type){
            case (0, $1GDs0.T).BLOCK_FOLDED:
            case (0, $1GDs0.T).BLOCK_LITERAL:
                return $21d73a50ab356f68$var$blockString(item, ctx, onComment, onChompKeep);
            case (0, $1GDs0.T).QUOTE_DOUBLE:
                return $21d73a50ab356f68$var$doubleQuotedString(value, ctx);
            case (0, $1GDs0.T).QUOTE_SINGLE:
                return $21d73a50ab356f68$var$singleQuotedString(value, ctx);
            case (0, $1GDs0.T).PLAIN:
                return $21d73a50ab356f68$var$plainString(item, ctx, onComment, onChompKeep);
            default:
                return null;
        }
    };
    if (type !== (0, $1GDs0.T).QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f]/.test(value)) // force double quotes on control characters
    type = (0, $1GDs0.T).QUOTE_DOUBLE;
    else if ((implicitKey || inFlow) && (type === (0, $1GDs0.T).BLOCK_FOLDED || type === (0, $1GDs0.T).BLOCK_LITERAL)) // should not happen; blocks are not valid inside flow containers
    type = (0, $1GDs0.T).QUOTE_DOUBLE;
    var res = _stringify(type);
    if (res === null) {
        res = _stringify(defaultType);
        if (res === null) throw new Error("Unsupported default string type ".concat(defaultType));
    }
    return res;
}
function $21d73a50ab356f68$export$342063e11d6c3cad(_ref) {
    var format = _ref.format, minFractionDigits = _ref.minFractionDigits, tag = _ref.tag, value = _ref.value;
    if (typeof value === 'bigint') return String(value);
    if (!isFinite(value)) return isNaN(value) ? '.nan' : value < 0 ? '-.inf' : '.inf';
    var n = JSON.stringify(value);
    if (!format && minFractionDigits && (!tag || tag === 'tag:yaml.org,2002:float') && /^\d/.test(n)) {
        var i = n.indexOf('.');
        if (i < 0) {
            i = n.length;
            n += '.';
        }
        var d = minFractionDigits - (n.length - i - 1);
        while(d-- > 0)n += '0';
    }
    return n;
}
function $21d73a50ab356f68$var$checkFlowCollectionEnd(errors, cst) {
    var char, name;
    switch(cst.type){
        case (0, $1GDs0.T).FLOW_MAP:
            char = '}';
            name = 'flow map';
            break;
        case (0, $1GDs0.T).FLOW_SEQ:
            char = ']';
            name = 'flow sequence';
            break;
        default:
            errors.push(new (0, $1GDs0.g)(cst, 'Not a flow collection!?'));
            return;
    }
    var lastItem;
    for(var i = cst.items.length - 1; i >= 0; --i){
        var item = cst.items[i];
        if (!item || item.type !== (0, $1GDs0.T).COMMENT) {
            lastItem = item;
            break;
        }
    }
    if (lastItem && lastItem.char !== char) {
        var msg = "Expected ".concat(name, " to end with ").concat(char);
        var err;
        if (typeof lastItem.offset === 'number') {
            err = new (0, $1GDs0.g)(cst, msg);
            err.offset = lastItem.offset + 1;
        } else {
            err = new (0, $1GDs0.g)(lastItem, msg);
            if (lastItem.range && lastItem.range.end) err.offset = lastItem.range.end - lastItem.range.start;
        }
        errors.push(err);
    }
}
function $21d73a50ab356f68$var$checkFlowCommentSpace(errors, comment) {
    var prev = comment.context.src[comment.range.start - 1];
    if (prev !== '\n' && prev !== '\t' && prev !== ' ') {
        var msg = 'Comments must be separated from other tokens by white space characters';
        errors.push(new (0, $1GDs0.g)(comment, msg));
    }
}
function $21d73a50ab356f68$var$getLongKeyError(source, key) {
    var sk = String(key);
    var k = sk.substr(0, 8) + '...' + sk.substr(-8);
    return new (0, $1GDs0.g)(source, "The \"".concat(k, "\" key is too long"));
}
function $21d73a50ab356f68$var$resolveComments(collection, comments) {
    var _iterator = (0, $1GDs0._)(comments), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, afterKey = _step$value.afterKey, before = _step$value.before, comment = _step$value.comment;
            var item = collection.items[before];
            if (!item) {
                if (comment !== undefined) {
                    if (collection.comment) collection.comment += '\n' + comment;
                    else collection.comment = comment;
                }
            } else {
                if (afterKey && item.value) item = item.value;
                if (comment === undefined) {
                    if (afterKey || !item.commentBefore) item.spaceBefore = true;
                } else if (item.commentBefore) item.commentBefore += '\n' + comment;
                else item.commentBefore = comment;
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
// on error, will return { str: string, errors: Error[] }
function $21d73a50ab356f68$export$35e795649ee09318(doc, node) {
    var res = node.strValue;
    if (!res) return '';
    if (typeof res === 'string') return res;
    res.errors.forEach(function(error) {
        if (!error.source) error.source = node;
        doc.errors.push(error);
    });
    return res.str;
}
function $21d73a50ab356f68$var$resolveTagHandle(doc, node) {
    var _node$tag = node.tag, handle = _node$tag.handle, suffix = _node$tag.suffix;
    var prefix = doc.tagPrefixes.find(function(p) {
        return p.handle === handle;
    });
    if (!prefix) {
        var dtp = doc.getDefaults().tagPrefixes;
        if (dtp) prefix = dtp.find(function(p) {
            return p.handle === handle;
        });
        if (!prefix) throw new (0, $1GDs0.g)(node, "The ".concat(handle, " tag handle is non-default and was not declared."));
    }
    if (!suffix) throw new (0, $1GDs0.g)(node, "The ".concat(handle, " tag has no suffix."));
    if (handle === '!' && (doc.version || doc.options.version) === '1.0') {
        if (suffix[0] === '^') {
            doc.warnings.push(new (0, $1GDs0.f)(node, 'YAML 1.0 ^ tag expansion is not supported'));
            return suffix;
        }
        if (/[:/]/.test(suffix)) {
            // word/foo -> tag:word.yaml.org,2002:foo
            var vocab = suffix.match(/^([a-z0-9-]+)\/(.*)/i);
            return vocab ? "tag:".concat(vocab[1], ".yaml.org,2002:").concat(vocab[2]) : "tag:".concat(suffix);
        }
    }
    return prefix.prefix + decodeURIComponent(suffix);
}
function $21d73a50ab356f68$var$resolveTagName(doc, node) {
    var tag = node.tag, type = node.type;
    var nonSpecific = false;
    if (tag) {
        var handle = tag.handle, suffix = tag.suffix, verbatim = tag.verbatim;
        if (verbatim) {
            if (verbatim !== '!' && verbatim !== '!!') return verbatim;
            var msg = "Verbatim tags aren't resolved, so ".concat(verbatim, " is invalid.");
            doc.errors.push(new (0, $1GDs0.g)(node, msg));
        } else if (handle === '!' && !suffix) nonSpecific = true;
        else try {
            return $21d73a50ab356f68$var$resolveTagHandle(doc, node);
        } catch (error) {
            doc.errors.push(error);
        }
    }
    switch(type){
        case (0, $1GDs0.T).BLOCK_FOLDED:
        case (0, $1GDs0.T).BLOCK_LITERAL:
        case (0, $1GDs0.T).QUOTE_DOUBLE:
        case (0, $1GDs0.T).QUOTE_SINGLE:
            return (0, $1GDs0.n).STR;
        case (0, $1GDs0.T).FLOW_MAP:
        case (0, $1GDs0.T).MAP:
            return (0, $1GDs0.n).MAP;
        case (0, $1GDs0.T).FLOW_SEQ:
        case (0, $1GDs0.T).SEQ:
            return (0, $1GDs0.n).SEQ;
        case (0, $1GDs0.T).PLAIN:
            return nonSpecific ? (0, $1GDs0.n).STR : null;
        default:
            return null;
    }
}
function $21d73a50ab356f68$var$resolveByTagName(doc, node, tagName) {
    var tags = doc.schema.tags;
    var matchWithTest = [];
    var _iterator = (0, $1GDs0._)(tags), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var tag = _step.value;
            if (tag.tag === tagName) {
                if (tag.test) matchWithTest.push(tag);
                else {
                    var res = tag.resolve(doc, node);
                    return res instanceof $21d73a50ab356f68$export$e7094788287c5e9b ? res : new $21d73a50ab356f68$export$25ce5a424b770e84(res);
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var str = $21d73a50ab356f68$export$35e795649ee09318(doc, node);
    if (typeof str === 'string' && matchWithTest.length > 0) return $21d73a50ab356f68$var$resolveScalar(str, matchWithTest, tags.scalarFallback);
    return null;
}
function $21d73a50ab356f68$var$getFallbackTagName(_ref) {
    var type = _ref.type;
    switch(type){
        case (0, $1GDs0.T).FLOW_MAP:
        case (0, $1GDs0.T).MAP:
            return (0, $1GDs0.n).MAP;
        case (0, $1GDs0.T).FLOW_SEQ:
        case (0, $1GDs0.T).SEQ:
            return (0, $1GDs0.n).SEQ;
        default:
            return (0, $1GDs0.n).STR;
    }
}
function $21d73a50ab356f68$var$resolveTag(doc, node, tagName) {
    try {
        var res = $21d73a50ab356f68$var$resolveByTagName(doc, node, tagName);
        if (res) {
            if (tagName && node.tag) res.tag = tagName;
            return res;
        }
    } catch (error) {
        /* istanbul ignore if */ if (!error.source) error.source = node;
        doc.errors.push(error);
        return null;
    }
    try {
        var fallback = $21d73a50ab356f68$var$getFallbackTagName(node);
        if (!fallback) throw new Error("The tag ".concat(tagName, " is unavailable"));
        var msg = "The tag ".concat(tagName, " is unavailable, falling back to ").concat(fallback);
        doc.warnings.push(new (0, $1GDs0.f)(node, msg));
        var _res = $21d73a50ab356f68$var$resolveByTagName(doc, node, fallback);
        _res.tag = tagName;
        return _res;
    } catch (error) {
        var refError = new (0, $1GDs0.o)(node, error.message);
        refError.stack = error.stack;
        doc.errors.push(refError);
        return null;
    }
}
var $21d73a50ab356f68$var$isCollectionItem = function isCollectionItem(node) {
    if (!node) return false;
    var type = node.type;
    return type === (0, $1GDs0.T).MAP_KEY || type === (0, $1GDs0.T).MAP_VALUE || type === (0, $1GDs0.T).SEQ_ITEM;
};
function $21d73a50ab356f68$var$resolveNodeProps(errors, node) {
    var comments = {
        before: [],
        after: []
    };
    var hasAnchor = false;
    var hasTag = false;
    var props = $21d73a50ab356f68$var$isCollectionItem(node.context.parent) ? node.context.parent.props.concat(node.props) : node.props;
    var _iterator = (0, $1GDs0._)(props), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, start = _step$value.start, end = _step$value.end;
            switch(node.context.src[start]){
                case (0, $1GDs0.C).COMMENT:
                    if (!node.commentHasRequiredWhitespace(start)) {
                        var msg = 'Comments must be separated from other tokens by white space characters';
                        errors.push(new (0, $1GDs0.g)(node, msg));
                    }
                    var header = node.header, valueRange = node.valueRange;
                    var cc = valueRange && (start > valueRange.start || header && start > header.start) ? comments.after : comments.before;
                    cc.push(node.context.src.slice(start + 1, end));
                    break;
                // Actual anchor & tag resolution is handled by schema, here we just complain
                case (0, $1GDs0.C).ANCHOR:
                    if (hasAnchor) {
                        var _msg = 'A node can have at most one anchor';
                        errors.push(new (0, $1GDs0.g)(node, _msg));
                    }
                    hasAnchor = true;
                    break;
                case (0, $1GDs0.C).TAG:
                    if (hasTag) {
                        var _msg2 = 'A node can have at most one tag';
                        errors.push(new (0, $1GDs0.g)(node, _msg2));
                    }
                    hasTag = true;
                    break;
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        comments: comments,
        hasAnchor: hasAnchor,
        hasTag: hasTag
    };
}
function $21d73a50ab356f68$var$resolveNodeValue(doc, node) {
    var anchors = doc.anchors, errors = doc.errors, schema = doc.schema;
    if (node.type === (0, $1GDs0.T).ALIAS) {
        var name = node.rawValue;
        var src = anchors.getNode(name);
        if (!src) {
            var msg = "Aliased anchor not found: ".concat(name);
            errors.push(new (0, $1GDs0.o)(node, msg));
            return null;
        } // Lazy resolution for circular references
        var res = new $21d73a50ab356f68$export$ebd11618f299a286(src);
        anchors._cstAliases.push(res);
        return res;
    }
    var tagName = $21d73a50ab356f68$var$resolveTagName(doc, node);
    if (tagName) return $21d73a50ab356f68$var$resolveTag(doc, node, tagName);
    if (node.type !== (0, $1GDs0.T).PLAIN) {
        var _msg3 = "Failed to resolve ".concat(node.type, " node here");
        errors.push(new (0, $1GDs0.Y)(node, _msg3));
        return null;
    }
    try {
        var str = $21d73a50ab356f68$export$35e795649ee09318(doc, node);
        return $21d73a50ab356f68$var$resolveScalar(str, schema.tags, schema.tags.scalarFallback);
    } catch (error) {
        if (!error.source) error.source = node;
        errors.push(error);
        return null;
    }
} // sets node.resolved on success
function $21d73a50ab356f68$export$43caf9889c228507(doc, node) {
    if (!node) return null;
    if (node.error) doc.errors.push(node.error);
    var _resolveNodeProps = $21d73a50ab356f68$var$resolveNodeProps(doc.errors, node), comments = _resolveNodeProps.comments, hasAnchor = _resolveNodeProps.hasAnchor, hasTag = _resolveNodeProps.hasTag;
    if (hasAnchor) {
        var anchors = doc.anchors;
        var name = node.anchor;
        var prev = anchors.getNode(name); // At this point, aliases for any preceding node with the same anchor
        // name have already been resolved, so it may safely be renamed.
        if (prev) anchors.map[anchors.newName(name)] = prev; // During parsing, we need to store the CST node in anchors.map as
        // anchors need to be available during resolution to allow for
        // circular references.
        anchors.map[name] = node;
    }
    if (node.type === (0, $1GDs0.T).ALIAS && (hasAnchor || hasTag)) {
        var msg = 'An alias node must not specify any properties';
        doc.errors.push(new (0, $1GDs0.g)(node, msg));
    }
    var res = $21d73a50ab356f68$var$resolveNodeValue(doc, node);
    if (res) {
        res.range = [
            node.range.start,
            node.range.end
        ];
        if (doc.options.keepCstNodes) res.cstNode = node;
        if (doc.options.keepNodeTypes) res.type = node.type;
        var cb = comments.before.join('\n');
        if (cb) res.commentBefore = res.commentBefore ? "".concat(res.commentBefore, "\n").concat(cb) : cb;
        var ca = comments.after.join('\n');
        if (ca) res.comment = res.comment ? "".concat(res.comment, "\n").concat(ca) : ca;
    }
    return node.resolved = res;
}
function $21d73a50ab356f68$export$39b482c5e57630a8(doc, cst) {
    if (cst.type !== (0, $1GDs0.T).MAP && cst.type !== (0, $1GDs0.T).FLOW_MAP) {
        var msg = "A ".concat(cst.type, " node cannot be resolved as a mapping");
        doc.errors.push(new (0, $1GDs0.Y)(cst, msg));
        return null;
    }
    var _ref = cst.type === (0, $1GDs0.T).FLOW_MAP ? $21d73a50ab356f68$var$resolveFlowMapItems(doc, cst) : $21d73a50ab356f68$var$resolveBlockMapItems(doc, cst), comments = _ref.comments, items = _ref.items;
    var map = new $21d73a50ab356f68$export$4368d992c4eafac0();
    map.items = items;
    $21d73a50ab356f68$var$resolveComments(map, comments);
    var hasCollectionKey = false;
    for(var i = 0; i < items.length; ++i){
        var iKey = items[i].key;
        if (iKey instanceof $21d73a50ab356f68$export$e7094788287c5e9b) hasCollectionKey = true;
        if (doc.schema.merge && iKey && iKey.value === $21d73a50ab356f68$var$MERGE_KEY) {
            items[i] = new $21d73a50ab356f68$export$3a1a48c8f6ef640e(items[i]);
            var sources = items[i].value.items;
            var error = null;
            sources.some(function(node) {
                if (node instanceof $21d73a50ab356f68$export$ebd11618f299a286) {
                    // During parsing, alias sources are CST nodes; to account for
                    // circular references their resolved values can't be used here.
                    var type = node.source.type;
                    if (type === (0, $1GDs0.T).MAP || type === (0, $1GDs0.T).FLOW_MAP) return false;
                    return error = 'Merge nodes aliases can only point to maps';
                }
                return error = 'Merge nodes can only have Alias nodes as values';
            });
            if (error) doc.errors.push(new (0, $1GDs0.g)(cst, error));
        } else for(var j = i + 1; j < items.length; ++j){
            var jKey = items[j].key;
            if (iKey === jKey || iKey && jKey && Object.prototype.hasOwnProperty.call(iKey, 'value') && iKey.value === jKey.value) {
                var _msg = "Map keys must be unique; \"".concat(iKey, "\" is repeated");
                doc.errors.push(new (0, $1GDs0.g)(cst, _msg));
                break;
            }
        }
    }
    if (hasCollectionKey && !doc.options.mapAsMap) {
        var warn = 'Keys with collection values will be stringified as YAML due to JS Object restrictions. Use mapAsMap: true to avoid this.';
        doc.warnings.push(new (0, $1GDs0.f)(cst, warn));
    }
    cst.resolved = map;
    return map;
}
var $21d73a50ab356f68$var$valueHasPairComment = function valueHasPairComment(_ref2) {
    var _ref2$context = _ref2.context, lineStart = _ref2$context.lineStart, node = _ref2$context.node, src = _ref2$context.src, props = _ref2.props;
    if (props.length === 0) return false;
    var start = props[0].start;
    if (node && start > node.valueRange.start) return false;
    if (src[start] !== (0, $1GDs0.C).COMMENT) return false;
    for(var i = lineStart; i < start; ++i){
        if (src[i] === '\n') return false;
    }
    return true;
};
function $21d73a50ab356f68$var$resolvePairComment(item, pair) {
    if (!$21d73a50ab356f68$var$valueHasPairComment(item)) return;
    var comment = item.getPropValue(0, (0, $1GDs0.C).COMMENT, true);
    var found = false;
    var cb = pair.value.commentBefore;
    if (cb && cb.startsWith(comment)) {
        pair.value.commentBefore = cb.substr(comment.length + 1);
        found = true;
    } else {
        var cc = pair.value.comment;
        if (!item.node && cc && cc.startsWith(comment)) {
            pair.value.comment = cc.substr(comment.length + 1);
            found = true;
        }
    }
    if (found) pair.comment = comment;
}
function $21d73a50ab356f68$var$resolveBlockMapItems(doc, cst) {
    var comments = [];
    var items = [];
    var key = undefined;
    var keyStart = null;
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        switch(item.type){
            case (0, $1GDs0.T).BLANK_LINE:
                comments.push({
                    afterKey: !!key,
                    before: items.length
                });
                break;
            case (0, $1GDs0.T).COMMENT:
                comments.push({
                    afterKey: !!key,
                    before: items.length,
                    comment: item.comment
                });
                break;
            case (0, $1GDs0.T).MAP_KEY:
                if (key !== undefined) items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
                if (item.error) doc.errors.push(item.error);
                key = $21d73a50ab356f68$export$43caf9889c228507(doc, item.node);
                keyStart = null;
                break;
            case (0, $1GDs0.T).MAP_VALUE:
                if (key === undefined) key = null;
                if (item.error) doc.errors.push(item.error);
                if (!item.context.atLineStart && item.node && item.node.type === (0, $1GDs0.T).MAP && !item.node.context.atLineStart) {
                    var msg = 'Nested mappings are not allowed in compact mappings';
                    doc.errors.push(new (0, $1GDs0.g)(item.node, msg));
                }
                var valueNode = item.node;
                if (!valueNode && item.props.length > 0) {
                    // Comments on an empty mapping value need to be preserved, so we
                    // need to construct a minimal empty node here to use instead of the
                    // missing `item.node`. -- eemeli/yaml#19
                    valueNode = new (0, $1GDs0.P)((0, $1GDs0.T).PLAIN, []);
                    valueNode.context = {
                        parent: item,
                        src: item.context.src
                    };
                    var pos = item.range.start + 1;
                    valueNode.range = {
                        start: pos,
                        end: pos
                    };
                    valueNode.valueRange = {
                        start: pos,
                        end: pos
                    };
                    if (typeof item.range.origStart === 'number') {
                        var origPos = item.range.origStart + 1;
                        valueNode.range.origStart = valueNode.range.origEnd = origPos;
                        valueNode.valueRange.origStart = valueNode.valueRange.origEnd = origPos;
                    }
                }
                var pair = new $21d73a50ab356f68$export$56c0d5a1e737357d(key, $21d73a50ab356f68$export$43caf9889c228507(doc, valueNode));
                $21d73a50ab356f68$var$resolvePairComment(item, pair);
                items.push(pair);
                if (key && typeof keyStart === 'number') {
                    if (item.range.start > keyStart + 1024) doc.errors.push($21d73a50ab356f68$var$getLongKeyError(cst, key));
                }
                key = undefined;
                keyStart = null;
                break;
            default:
                if (key !== undefined) items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
                key = $21d73a50ab356f68$export$43caf9889c228507(doc, item);
                keyStart = item.range.start;
                if (item.error) doc.errors.push(item.error);
                next: for(var j = i + 1;; ++j){
                    var nextItem = cst.items[j];
                    switch(nextItem && nextItem.type){
                        case (0, $1GDs0.T).BLANK_LINE:
                        case (0, $1GDs0.T).COMMENT:
                            continue next;
                        case (0, $1GDs0.T).MAP_VALUE:
                            break next;
                        default:
                            var _msg2 = 'Implicit map keys need to be followed by map values';
                            doc.errors.push(new (0, $1GDs0.g)(item, _msg2));
                            break next;
                    }
                }
                if (item.valueRangeContainsNewline) {
                    var _msg3 = 'Implicit map keys need to be on a single line';
                    doc.errors.push(new (0, $1GDs0.g)(item, _msg3));
                }
        }
    }
    if (key !== undefined) items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}
function $21d73a50ab356f68$var$resolveFlowMapItems(doc, cst) {
    var comments = [];
    var items = [];
    var key = undefined;
    var explicitKey = false;
    var next = '{';
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        if (typeof item.char === 'string') {
            var char = item.char, offset = item.offset;
            if (char === '?' && key === undefined && !explicitKey) {
                explicitKey = true;
                next = ':';
                continue;
            }
            if (char === ':') {
                if (key === undefined) key = null;
                if (next === ':') {
                    next = ',';
                    continue;
                }
            } else {
                if (explicitKey) {
                    if (key === undefined && char !== ',') key = null;
                    explicitKey = false;
                }
                if (key !== undefined) {
                    items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
                    key = undefined;
                    if (char === ',') {
                        next = ':';
                        continue;
                    }
                }
            }
            if (char === '}') {
                if (i === cst.items.length - 1) continue;
            } else if (char === next) {
                next = ':';
                continue;
            }
            var msg = "Flow map contains an unexpected ".concat(char);
            var err = new (0, $1GDs0.Y)(cst, msg);
            err.offset = offset;
            doc.errors.push(err);
        } else if (item.type === (0, $1GDs0.T).BLANK_LINE) comments.push({
            afterKey: !!key,
            before: items.length
        });
        else if (item.type === (0, $1GDs0.T).COMMENT) {
            $21d73a50ab356f68$var$checkFlowCommentSpace(doc.errors, item);
            comments.push({
                afterKey: !!key,
                before: items.length,
                comment: item.comment
            });
        } else if (key === undefined) {
            if (next === ',') doc.errors.push(new (0, $1GDs0.g)(item, 'Separator , missing in flow map'));
            key = $21d73a50ab356f68$export$43caf9889c228507(doc, item);
        } else {
            if (next !== ',') doc.errors.push(new (0, $1GDs0.g)(item, 'Indicator : missing in flow map entry'));
            items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key, $21d73a50ab356f68$export$43caf9889c228507(doc, item)));
            key = undefined;
            explicitKey = false;
        }
    }
    $21d73a50ab356f68$var$checkFlowCollectionEnd(doc.errors, cst);
    if (key !== undefined) items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}
function $21d73a50ab356f68$export$dda1d9f60106f0e9(doc, cst) {
    if (cst.type !== (0, $1GDs0.T).SEQ && cst.type !== (0, $1GDs0.T).FLOW_SEQ) {
        var msg = "A ".concat(cst.type, " node cannot be resolved as a sequence");
        doc.errors.push(new (0, $1GDs0.Y)(cst, msg));
        return null;
    }
    var _ref = cst.type === (0, $1GDs0.T).FLOW_SEQ ? $21d73a50ab356f68$var$resolveFlowSeqItems(doc, cst) : $21d73a50ab356f68$var$resolveBlockSeqItems(doc, cst), comments = _ref.comments, items = _ref.items;
    var seq = new $21d73a50ab356f68$export$8743009a87fcb00f();
    seq.items = items;
    $21d73a50ab356f68$var$resolveComments(seq, comments);
    if (!doc.options.mapAsMap && items.some(function(it) {
        return it instanceof $21d73a50ab356f68$export$56c0d5a1e737357d && it.key instanceof $21d73a50ab356f68$export$e7094788287c5e9b;
    })) {
        var warn = 'Keys with collection values will be stringified as YAML due to JS Object restrictions. Use mapAsMap: true to avoid this.';
        doc.warnings.push(new (0, $1GDs0.f)(cst, warn));
    }
    cst.resolved = seq;
    return seq;
}
function $21d73a50ab356f68$var$resolveBlockSeqItems(doc, cst) {
    var comments = [];
    var items = [];
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        switch(item.type){
            case (0, $1GDs0.T).BLANK_LINE:
                comments.push({
                    before: items.length
                });
                break;
            case (0, $1GDs0.T).COMMENT:
                comments.push({
                    comment: item.comment,
                    before: items.length
                });
                break;
            case (0, $1GDs0.T).SEQ_ITEM:
                if (item.error) doc.errors.push(item.error);
                items.push($21d73a50ab356f68$export$43caf9889c228507(doc, item.node));
                if (item.hasProps) {
                    var msg = 'Sequence items cannot have tags or anchors before the - indicator';
                    doc.errors.push(new (0, $1GDs0.g)(item, msg));
                }
                break;
            default:
                if (item.error) doc.errors.push(item.error);
                doc.errors.push(new (0, $1GDs0.Y)(item, "Unexpected ".concat(item.type, " node in sequence")));
        }
    }
    return {
        comments: comments,
        items: items
    };
}
function $21d73a50ab356f68$var$resolveFlowSeqItems(doc, cst) {
    var comments = [];
    var items = [];
    var explicitKey = false;
    var key = undefined;
    var keyStart = null;
    var next = '[';
    var prevItem = null;
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        if (typeof item.char === 'string') {
            var char = item.char, offset = item.offset;
            if (char !== ':' && (explicitKey || key !== undefined)) {
                if (explicitKey && key === undefined) key = next ? items.pop() : null;
                items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
                explicitKey = false;
                key = undefined;
                keyStart = null;
            }
            if (char === next) next = null;
            else if (!next && char === '?') explicitKey = true;
            else if (next !== '[' && char === ':' && key === undefined) {
                if (next === ',') {
                    key = items.pop();
                    if (key instanceof $21d73a50ab356f68$export$56c0d5a1e737357d) {
                        var msg = 'Chaining flow sequence pairs is invalid';
                        var err = new (0, $1GDs0.g)(cst, msg);
                        err.offset = offset;
                        doc.errors.push(err);
                    }
                    if (!explicitKey && typeof keyStart === 'number') {
                        var keyEnd = item.range ? item.range.start : item.offset;
                        if (keyEnd > keyStart + 1024) doc.errors.push($21d73a50ab356f68$var$getLongKeyError(cst, key));
                        var src = prevItem.context.src;
                        for(var _i = keyStart; _i < keyEnd; ++_i)if (src[_i] === '\n') {
                            var _msg = 'Implicit keys of flow sequence pairs need to be on a single line';
                            doc.errors.push(new (0, $1GDs0.g)(prevItem, _msg));
                            break;
                        }
                    }
                } else key = null;
                keyStart = null;
                explicitKey = false;
                next = null;
            } else if (next === '[' || char !== ']' || i < cst.items.length - 1) {
                var _msg2 = "Flow sequence contains an unexpected ".concat(char);
                var _err = new (0, $1GDs0.Y)(cst, _msg2);
                _err.offset = offset;
                doc.errors.push(_err);
            }
        } else if (item.type === (0, $1GDs0.T).BLANK_LINE) comments.push({
            before: items.length
        });
        else if (item.type === (0, $1GDs0.T).COMMENT) {
            $21d73a50ab356f68$var$checkFlowCommentSpace(doc.errors, item);
            comments.push({
                comment: item.comment,
                before: items.length
            });
        } else {
            if (next) {
                var _msg3 = "Expected a ".concat(next, " in flow sequence");
                doc.errors.push(new (0, $1GDs0.g)(item, _msg3));
            }
            var value = $21d73a50ab356f68$export$43caf9889c228507(doc, item);
            if (key === undefined) {
                items.push(value);
                prevItem = item;
            } else {
                items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key, value));
                key = undefined;
            }
            keyStart = item.range.start;
            next = ',';
        }
    }
    $21d73a50ab356f68$var$checkFlowCollectionEnd(doc.errors, cst);
    if (key !== undefined) items.push(new $21d73a50ab356f68$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}

});

parcelRegister("M2XUi", function(module, exports) {

$parcel$export(module.exports, "S", () => $0906c8a504e307d9$export$25ce5a424b770e84);

var $1GDs0 = parcelRequire("1GDs0");

var $2U8gU = parcelRequire("2U8gU");

var $2UQ0T = parcelRequire("2UQ0T");
function $0906c8a504e307d9$var$createMap(schema, obj, ctx) {
    var map = new (0, $2U8gU.d)(schema);
    if (obj instanceof Map) {
        var _iterator = (0, $1GDs0._)(obj), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, $1GDs0.h)(_step.value, 2), key = _step$value[0], value = _step$value[1];
                map.items.push(schema.createPair(key, value, ctx));
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    } else if (obj && (0, $1GDs0.a)(obj) === 'object') for(var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++){
        var _key = _Object$keys[_i];
        map.items.push(schema.createPair(_key, obj[_key], ctx));
    }
    if (typeof schema.sortMapEntries === 'function') map.items.sort(schema.sortMapEntries);
    return map;
}
var $0906c8a504e307d9$var$map = {
    createNode: $0906c8a504e307d9$var$createMap,
    default: true,
    nodeClass: (0, $2U8gU.d),
    tag: 'tag:yaml.org,2002:map',
    resolve: (0, $2U8gU.g)
};
function $0906c8a504e307d9$var$createSeq(schema, obj, ctx) {
    var seq = new (0, $2U8gU.Y)(schema);
    if (obj && obj[Symbol.iterator]) {
        var _iterator = (0, $1GDs0._)(obj), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var it = _step.value;
                var v = schema.createNode(it, ctx.wrapScalars, null, ctx);
                seq.items.push(v);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return seq;
}
var $0906c8a504e307d9$var$seq = {
    createNode: $0906c8a504e307d9$var$createSeq,
    default: true,
    nodeClass: (0, $2U8gU.Y),
    tag: 'tag:yaml.org,2002:seq',
    resolve: (0, $2U8gU.h)
};
var $0906c8a504e307d9$var$string = {
    identify: function identify(value) {
        return typeof value === 'string';
    },
    default: true,
    tag: 'tag:yaml.org,2002:str',
    resolve: (0, $2U8gU.j),
    stringify: function stringify(item, ctx, onComment, onChompKeep) {
        ctx = Object.assign({
            actualString: true
        }, ctx);
        return (0, $2U8gU.c)(item, ctx, onComment, onChompKeep);
    },
    options: (0, $2U8gU.s)
};
var $0906c8a504e307d9$var$failsafe = [
    $0906c8a504e307d9$var$map,
    $0906c8a504e307d9$var$seq,
    $0906c8a504e307d9$var$string
];
/* global BigInt */ var $0906c8a504e307d9$var$intIdentify$2 = function intIdentify(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
};
var $0906c8a504e307d9$var$intResolve$1 = function intResolve(src, part, radix) {
    return (0, $2U8gU.i).asBigInt ? BigInt(src) : parseInt(part, radix);
};
function $0906c8a504e307d9$var$intStringify$1(node, radix, prefix) {
    var value = node.value;
    if ($0906c8a504e307d9$var$intIdentify$2(value) && value >= 0) return prefix + value.toString(radix);
    return (0, $2U8gU.k)(node);
}
var $0906c8a504e307d9$var$nullObj = {
    identify: function identify(value) {
        return value == null;
    },
    createNode: function createNode(schema, value, ctx) {
        return ctx.wrapScalars ? new (0, $2U8gU.S)(null) : null;
    },
    default: true,
    tag: 'tag:yaml.org,2002:null',
    test: /^(?:~|[Nn]ull|NULL)?$/,
    resolve: function resolve() {
        return null;
    },
    options: (0, $2U8gU.n),
    stringify: function stringify() {
        return (0, $2U8gU.n).nullStr;
    }
};
var $0906c8a504e307d9$var$boolObj = {
    identify: function identify(value) {
        return typeof value === 'boolean';
    },
    default: true,
    tag: 'tag:yaml.org,2002:bool',
    test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/,
    resolve: function resolve(str) {
        return str[0] === 't' || str[0] === 'T';
    },
    options: (0, $2U8gU.a),
    stringify: function stringify(_ref) {
        var value = _ref.value;
        return value ? (0, $2U8gU.a).trueStr : (0, $2U8gU.a).falseStr;
    }
};
var $0906c8a504e307d9$var$octObj = {
    identify: function identify(value) {
        return $0906c8a504e307d9$var$intIdentify$2(value) && value >= 0;
    },
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'OCT',
    test: /^0o([0-7]+)$/,
    resolve: function resolve(str, oct) {
        return $0906c8a504e307d9$var$intResolve$1(str, oct, 8);
    },
    options: (0, $2U8gU.i),
    stringify: function stringify(node) {
        return $0906c8a504e307d9$var$intStringify$1(node, 8, '0o');
    }
};
var $0906c8a504e307d9$var$intObj = {
    identify: $0906c8a504e307d9$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    test: /^[-+]?[0-9]+$/,
    resolve: function resolve(str) {
        return $0906c8a504e307d9$var$intResolve$1(str, str, 10);
    },
    options: (0, $2U8gU.i),
    stringify: (0, $2U8gU.k)
};
var $0906c8a504e307d9$var$hexObj = {
    identify: function identify(value) {
        return $0906c8a504e307d9$var$intIdentify$2(value) && value >= 0;
    },
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'HEX',
    test: /^0x([0-9a-fA-F]+)$/,
    resolve: function resolve(str, hex) {
        return $0906c8a504e307d9$var$intResolve$1(str, hex, 16);
    },
    options: (0, $2U8gU.i),
    stringify: function stringify(node) {
        return $0906c8a504e307d9$var$intStringify$1(node, 16, '0x');
    }
};
var $0906c8a504e307d9$var$nanObj = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^(?:[-+]?\.inf|(\.nan))$/i,
    resolve: function resolve(str, nan) {
        return nan ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    },
    stringify: (0, $2U8gU.k)
};
var $0906c8a504e307d9$var$expObj = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'EXP',
    test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/,
    resolve: function resolve(str) {
        return parseFloat(str);
    },
    stringify: function stringify(_ref2) {
        var value = _ref2.value;
        return Number(value).toExponential();
    }
};
var $0906c8a504e307d9$var$floatObj = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^[-+]?(?:\.([0-9]+)|[0-9]+\.([0-9]*))$/,
    resolve: function resolve(str, frac1, frac2) {
        var frac = frac1 || frac2;
        var node = new (0, $2U8gU.S)(parseFloat(str));
        if (frac && frac[frac.length - 1] === '0') node.minFractionDigits = frac.length;
        return node;
    },
    stringify: (0, $2U8gU.k)
};
var $0906c8a504e307d9$var$core = $0906c8a504e307d9$var$failsafe.concat([
    $0906c8a504e307d9$var$nullObj,
    $0906c8a504e307d9$var$boolObj,
    $0906c8a504e307d9$var$octObj,
    $0906c8a504e307d9$var$intObj,
    $0906c8a504e307d9$var$hexObj,
    $0906c8a504e307d9$var$nanObj,
    $0906c8a504e307d9$var$expObj,
    $0906c8a504e307d9$var$floatObj
]);
/* global BigInt */ var $0906c8a504e307d9$var$intIdentify$1 = function intIdentify(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
};
var $0906c8a504e307d9$var$stringifyJSON = function stringifyJSON(_ref) {
    var value = _ref.value;
    return JSON.stringify(value);
};
var $0906c8a504e307d9$var$json = [
    $0906c8a504e307d9$var$map,
    $0906c8a504e307d9$var$seq,
    {
        identify: function identify(value) {
            return typeof value === 'string';
        },
        default: true,
        tag: 'tag:yaml.org,2002:str',
        resolve: (0, $2U8gU.j),
        stringify: $0906c8a504e307d9$var$stringifyJSON
    },
    {
        identify: function identify(value) {
            return value == null;
        },
        createNode: function createNode(schema, value, ctx) {
            return ctx.wrapScalars ? new (0, $2U8gU.S)(null) : null;
        },
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^null$/,
        resolve: function resolve() {
            return null;
        },
        stringify: $0906c8a504e307d9$var$stringifyJSON
    },
    {
        identify: function identify(value) {
            return typeof value === 'boolean';
        },
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^true|false$/,
        resolve: function resolve(str) {
            return str === 'true';
        },
        stringify: $0906c8a504e307d9$var$stringifyJSON
    },
    {
        identify: $0906c8a504e307d9$var$intIdentify$1,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^-?(?:0|[1-9][0-9]*)$/,
        resolve: function resolve(str) {
            return (0, $2U8gU.i).asBigInt ? BigInt(str) : parseInt(str, 10);
        },
        stringify: function stringify(_ref2) {
            var value = _ref2.value;
            return $0906c8a504e307d9$var$intIdentify$1(value) ? value.toString() : JSON.stringify(value);
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/,
        resolve: function resolve(str) {
            return parseFloat(str);
        },
        stringify: $0906c8a504e307d9$var$stringifyJSON
    }
];
$0906c8a504e307d9$var$json.scalarFallback = function(str) {
    throw new SyntaxError("Unresolved plain scalar ".concat(JSON.stringify(str)));
};
/* global BigInt */ var $0906c8a504e307d9$var$boolStringify = function boolStringify(_ref) {
    var value = _ref.value;
    return value ? (0, $2U8gU.a).trueStr : (0, $2U8gU.a).falseStr;
};
var $0906c8a504e307d9$var$intIdentify = function intIdentify(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
};
function $0906c8a504e307d9$var$intResolve(sign, src, radix) {
    var str = src.replace(/_/g, '');
    if ((0, $2U8gU.i).asBigInt) {
        switch(radix){
            case 2:
                str = "0b".concat(str);
                break;
            case 8:
                str = "0o".concat(str);
                break;
            case 16:
                str = "0x".concat(str);
                break;
        }
        var _n = BigInt(str);
        return sign === '-' ? BigInt(-1) * _n : _n;
    }
    var n = parseInt(str, radix);
    return sign === '-' ? -1 * n : n;
}
function $0906c8a504e307d9$var$intStringify(node, radix, prefix) {
    var value = node.value;
    if ($0906c8a504e307d9$var$intIdentify(value)) {
        var str = value.toString(radix);
        return value < 0 ? '-' + prefix + str.substr(1) : prefix + str;
    }
    return (0, $2U8gU.k)(node);
}
var $0906c8a504e307d9$var$yaml11 = $0906c8a504e307d9$var$failsafe.concat([
    {
        identify: function identify(value) {
            return value == null;
        },
        createNode: function createNode(schema, value, ctx) {
            return ctx.wrapScalars ? new (0, $2U8gU.S)(null) : null;
        },
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^(?:~|[Nn]ull|NULL)?$/,
        resolve: function resolve() {
            return null;
        },
        options: (0, $2U8gU.n),
        stringify: function stringify() {
            return (0, $2U8gU.n).nullStr;
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'boolean';
        },
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/,
        resolve: function resolve() {
            return true;
        },
        options: (0, $2U8gU.a),
        stringify: $0906c8a504e307d9$var$boolStringify
    },
    {
        identify: function identify(value) {
            return typeof value === 'boolean';
        },
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/i,
        resolve: function resolve() {
            return false;
        },
        options: (0, $2U8gU.a),
        stringify: $0906c8a504e307d9$var$boolStringify
    },
    {
        identify: $0906c8a504e307d9$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'BIN',
        test: /^([-+]?)0b([0-1_]+)$/,
        resolve: function resolve(str, sign, bin) {
            return $0906c8a504e307d9$var$intResolve(sign, bin, 2);
        },
        stringify: function stringify(node) {
            return $0906c8a504e307d9$var$intStringify(node, 2, '0b');
        }
    },
    {
        identify: $0906c8a504e307d9$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'OCT',
        test: /^([-+]?)0([0-7_]+)$/,
        resolve: function resolve(str, sign, oct) {
            return $0906c8a504e307d9$var$intResolve(sign, oct, 8);
        },
        stringify: function stringify(node) {
            return $0906c8a504e307d9$var$intStringify(node, 8, '0');
        }
    },
    {
        identify: $0906c8a504e307d9$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^([-+]?)([0-9][0-9_]*)$/,
        resolve: function resolve(str, sign, abs) {
            return $0906c8a504e307d9$var$intResolve(sign, abs, 10);
        },
        stringify: (0, $2U8gU.k)
    },
    {
        identify: $0906c8a504e307d9$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'HEX',
        test: /^([-+]?)0x([0-9a-fA-F_]+)$/,
        resolve: function resolve(str, sign, hex) {
            return $0906c8a504e307d9$var$intResolve(sign, hex, 16);
        },
        stringify: function stringify(node) {
            return $0906c8a504e307d9$var$intStringify(node, 16, '0x');
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^(?:[-+]?\.inf|(\.nan))$/i,
        resolve: function resolve(str, nan) {
            return nan ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        },
        stringify: (0, $2U8gU.k)
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        format: 'EXP',
        test: /^[-+]?([0-9][0-9_]*)?(\.[0-9_]*)?[eE][-+]?[0-9]+$/,
        resolve: function resolve(str) {
            return parseFloat(str.replace(/_/g, ''));
        },
        stringify: function stringify(_ref2) {
            var value = _ref2.value;
            return Number(value).toExponential();
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^[-+]?(?:[0-9][0-9_]*)?\.([0-9_]*)$/,
        resolve: function resolve(str, frac) {
            var node = new (0, $2U8gU.S)(parseFloat(str.replace(/_/g, '')));
            if (frac) {
                var f = frac.replace(/_/g, '');
                if (f[f.length - 1] === '0') node.minFractionDigits = f.length;
            }
            return node;
        },
        stringify: (0, $2U8gU.k)
    }
], (0, $2UQ0T.b), (0, $2UQ0T.o), (0, $2UQ0T.p), (0, $2UQ0T.s), (0, $2UQ0T.i), (0, $2UQ0T.f), (0, $2UQ0T.t));
var $0906c8a504e307d9$var$schemas = {
    core: $0906c8a504e307d9$var$core,
    failsafe: $0906c8a504e307d9$var$failsafe,
    json: $0906c8a504e307d9$var$json,
    yaml11: $0906c8a504e307d9$var$yaml11
};
var $0906c8a504e307d9$var$tags = {
    binary: (0, $2UQ0T.b),
    bool: $0906c8a504e307d9$var$boolObj,
    float: $0906c8a504e307d9$var$floatObj,
    floatExp: $0906c8a504e307d9$var$expObj,
    floatNaN: $0906c8a504e307d9$var$nanObj,
    floatTime: (0, $2UQ0T.f),
    int: $0906c8a504e307d9$var$intObj,
    intHex: $0906c8a504e307d9$var$hexObj,
    intOct: $0906c8a504e307d9$var$octObj,
    intTime: (0, $2UQ0T.i),
    map: $0906c8a504e307d9$var$map,
    null: $0906c8a504e307d9$var$nullObj,
    omap: (0, $2UQ0T.o),
    pairs: (0, $2UQ0T.p),
    seq: $0906c8a504e307d9$var$seq,
    set: (0, $2UQ0T.s),
    timestamp: (0, $2UQ0T.t)
};
function $0906c8a504e307d9$var$findTagObject(value, tagName, tags) {
    if (tagName) {
        var match = tags.filter(function(t) {
            return t.tag === tagName;
        });
        var tagObj = match.find(function(t) {
            return !t.format;
        }) || match[0];
        if (!tagObj) throw new Error("Tag ".concat(tagName, " not found"));
        return tagObj;
    } // TODO: deprecate/remove class check
    return tags.find(function(t) {
        return (t.identify && t.identify(value) || t.class && value instanceof t.class) && !t.format;
    });
}
function $0906c8a504e307d9$var$createNode(value, tagName, ctx) {
    if (value instanceof (0, $2U8gU.N)) return value;
    var defaultPrefix = ctx.defaultPrefix, onTagObj = ctx.onTagObj, prevObjects = ctx.prevObjects, schema = ctx.schema, wrapScalars = ctx.wrapScalars;
    if (tagName && tagName.startsWith('!!')) tagName = defaultPrefix + tagName.slice(2);
    var tagObj = $0906c8a504e307d9$var$findTagObject(value, tagName, schema.tags);
    if (!tagObj) {
        if (typeof value.toJSON === 'function') value = value.toJSON();
        if (!value || (0, $1GDs0.a)(value) !== 'object') return wrapScalars ? new (0, $2U8gU.S)(value) : value;
        tagObj = value instanceof Map ? $0906c8a504e307d9$var$map : value[Symbol.iterator] ? $0906c8a504e307d9$var$seq : $0906c8a504e307d9$var$map;
    }
    if (onTagObj) {
        onTagObj(tagObj);
        delete ctx.onTagObj;
    } // Detect duplicate references to the same object & use Alias nodes for all
    // after first. The `obj` wrapper allows for circular references to resolve.
    var obj = {
        value: undefined,
        node: undefined
    };
    if (value && (0, $1GDs0.a)(value) === 'object' && prevObjects) {
        var prev = prevObjects.get(value);
        if (prev) {
            var alias = new (0, $2U8gU.A)(prev); // leaves source dirty; must be cleaned by caller
            ctx.aliasNodes.push(alias); // defined along with prevObjects
            return alias;
        }
        obj.value = value;
        prevObjects.set(value, obj);
    }
    obj.node = tagObj.createNode ? tagObj.createNode(ctx.schema, value, ctx) : wrapScalars ? new (0, $2U8gU.S)(value) : value;
    if (tagName && obj.node instanceof (0, $2U8gU.N)) obj.node.tag = tagName;
    return obj.node;
}
function $0906c8a504e307d9$var$getSchemaTags(schemas, knownTags, customTags, schemaId) {
    var tags = schemas[schemaId.replace(/\W/g, '')]; // 'yaml-1.1' -> 'yaml11'
    if (!tags) {
        var keys = Object.keys(schemas).map(function(key) {
            return JSON.stringify(key);
        }).join(', ');
        throw new Error("Unknown schema \"".concat(schemaId, "\"; use one of ").concat(keys));
    }
    if (Array.isArray(customTags)) {
        var _iterator = (0, $1GDs0._)(customTags), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var tag = _step.value;
                tags = tags.concat(tag);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    } else if (typeof customTags === 'function') tags = customTags(tags.slice());
    for(var i = 0; i < tags.length; ++i){
        var _tag = tags[i];
        if (typeof _tag === 'string') {
            var tagObj = knownTags[_tag];
            if (!tagObj) {
                var _keys = Object.keys(knownTags).map(function(key) {
                    return JSON.stringify(key);
                }).join(', ');
                throw new Error("Unknown custom tag \"".concat(_tag, "\"; use one of ").concat(_keys));
            }
            tags[i] = tagObj;
        }
    }
    return tags;
}
var $0906c8a504e307d9$var$sortMapEntriesByKey = function sortMapEntriesByKey(a, b) {
    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
};
var $0906c8a504e307d9$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    // TODO: remove in v2
    // TODO: remove in v2
    function Schema(_ref) {
        var customTags = _ref.customTags, merge = _ref.merge, schema = _ref.schema, sortMapEntries = _ref.sortMapEntries, deprecatedCustomTags = _ref.tags;
        (0, $1GDs0.c)(this, Schema);
        this.merge = !!merge;
        this.name = schema;
        this.sortMapEntries = sortMapEntries === true ? $0906c8a504e307d9$var$sortMapEntriesByKey : sortMapEntries || null;
        if (!customTags && deprecatedCustomTags) (0, $2UQ0T.a)('tags', 'customTags');
        this.tags = $0906c8a504e307d9$var$getSchemaTags($0906c8a504e307d9$var$schemas, $0906c8a504e307d9$var$tags, customTags || deprecatedCustomTags, schema);
    }
    (0, $1GDs0.b)(Schema, [
        {
            key: "createNode",
            value: function createNode$1(value, wrapScalars, tagName, ctx) {
                var baseCtx = {
                    defaultPrefix: Schema.defaultPrefix,
                    schema: this,
                    wrapScalars: wrapScalars
                };
                var createCtx = ctx ? Object.assign(ctx, baseCtx) : baseCtx;
                return $0906c8a504e307d9$var$createNode(value, tagName, createCtx);
            }
        },
        {
            key: "createPair",
            value: function createPair(key, value, ctx) {
                if (!ctx) ctx = {
                    wrapScalars: true
                };
                var k = this.createNode(key, ctx.wrapScalars, null, ctx);
                var v = this.createNode(value, ctx.wrapScalars, null, ctx);
                return new (0, $2U8gU.P)(k, v);
            }
        }
    ]);
    return Schema;
}();
(0, $1GDs0.e)($0906c8a504e307d9$export$25ce5a424b770e84, "defaultPrefix", (0, $1GDs0.d));
(0, $1GDs0.e)($0906c8a504e307d9$export$25ce5a424b770e84, "defaultTags", (0, $1GDs0.n));

});
parcelRegister("2UQ0T", function(module, exports) {

$parcel$export(module.exports, "b", () => $21f9288149170794$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "p", () => $21f9288149170794$export$ffb5f4729a158638);
$parcel$export(module.exports, "o", () => $21f9288149170794$export$ae1af26003f05816);
$parcel$export(module.exports, "s", () => $21f9288149170794$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "i", () => $21f9288149170794$export$23f2a1d2818174ef);
$parcel$export(module.exports, "f", () => $21f9288149170794$export$2d1720544b23b823);
$parcel$export(module.exports, "t", () => $21f9288149170794$export$625550452a3fa3ec);
$parcel$export(module.exports, "w", () => $21f9288149170794$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "a", () => $21f9288149170794$export$407448d2b89b1813);

var $1GDs0 = parcelRequire("1GDs0");

var $2U8gU = parcelRequire("2U8gU");

var $6ZWSX = parcelRequire("6ZWSX");
var $21f9288149170794$require$Buffer = $6ZWSX.Buffer;
/* global atob, btoa, Buffer */ var $21f9288149170794$export$8b22cf2602fb60ce = {
    identify: function identify(value) {
        return value instanceof Uint8Array;
    },
    // Buffer inherits from Uint8Array
    default: false,
    tag: 'tag:yaml.org,2002:binary',
    /**
   * Returns a Buffer in node and an Uint8Array in browsers
   *
   * To use the resulting buffer as an image, you'll want to do something like:
   *
   *   const blob = new Blob([buffer], { type: 'image/jpeg' })
   *   document.querySelector('#photo').src = URL.createObjectURL(blob)
   */ resolve: function resolve(doc, node) {
        var src = (0, $2U8gU.j)(doc, node);
        if (typeof $21f9288149170794$require$Buffer === 'function') return $21f9288149170794$require$Buffer.from(src, 'base64');
        else if (typeof atob === 'function') {
            // On IE 11, atob() can't handle newlines
            var str = atob(src.replace(/[\n\r]/g, ''));
            var buffer = new Uint8Array(str.length);
            for(var i = 0; i < str.length; ++i)buffer[i] = str.charCodeAt(i);
            return buffer;
        } else {
            var msg = 'This environment does not support reading binary tags; either Buffer or atob is required';
            doc.errors.push(new (0, $1GDs0.o)(node, msg));
            return null;
        }
    },
    options: (0, $2U8gU.b),
    stringify: function stringify(_ref, ctx, onComment, onChompKeep) {
        var comment = _ref.comment, type = _ref.type, value = _ref.value;
        var src;
        if (typeof $21f9288149170794$require$Buffer === 'function') src = value instanceof $21f9288149170794$require$Buffer ? value.toString('base64') : $21f9288149170794$require$Buffer.from(value.buffer).toString('base64');
        else if (typeof btoa === 'function') {
            var s = '';
            for(var i = 0; i < value.length; ++i)s += String.fromCharCode(value[i]);
            src = btoa(s);
        } else throw new Error('This environment does not support writing binary tags; either Buffer or btoa is required');
        if (!type) type = (0, $2U8gU.b).defaultType;
        if (type === (0, $1GDs0.T).QUOTE_DOUBLE) value = src;
        else {
            var lineWidth = (0, $2U8gU.b).lineWidth;
            var n = Math.ceil(src.length / lineWidth);
            var lines = new Array(n);
            for(var _i = 0, o = 0; _i < n; ++_i, o += lineWidth)lines[_i] = src.substr(o, lineWidth);
            value = lines.join(type === (0, $1GDs0.T).BLOCK_LITERAL ? '\n' : ' ');
        }
        return (0, $2U8gU.c)({
            comment: comment,
            type: type,
            value: value
        }, ctx, onComment, onChompKeep);
    }
};
function $21f9288149170794$var$parsePairs(doc, cst) {
    var seq = (0, $2U8gU.h)(doc, cst);
    for(var i = 0; i < seq.items.length; ++i){
        var item = seq.items[i];
        if (item instanceof (0, $2U8gU.P)) continue;
        else if (item instanceof (0, $2U8gU.d)) {
            if (item.items.length > 1) {
                var msg = 'Each pair must have its own sequence indicator';
                throw new (0, $1GDs0.g)(cst, msg);
            }
            var pair = item.items[0] || new (0, $2U8gU.P)();
            if (item.commentBefore) pair.commentBefore = pair.commentBefore ? "".concat(item.commentBefore, "\n").concat(pair.commentBefore) : item.commentBefore;
            if (item.comment) pair.comment = pair.comment ? "".concat(item.comment, "\n").concat(pair.comment) : item.comment;
            item = pair;
        }
        seq.items[i] = item instanceof (0, $2U8gU.P) ? item : new (0, $2U8gU.P)(item);
    }
    return seq;
}
function $21f9288149170794$var$createPairs(schema, iterable, ctx) {
    var pairs = new (0, $2U8gU.Y)(schema);
    pairs.tag = 'tag:yaml.org,2002:pairs';
    var _iterator = (0, $1GDs0._)(iterable), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var it = _step.value;
            var key = void 0, value = void 0;
            if (Array.isArray(it)) {
                if (it.length === 2) {
                    key = it[0];
                    value = it[1];
                } else throw new TypeError("Expected [key, value] tuple: ".concat(it));
            } else if (it && it instanceof Object) {
                var keys = Object.keys(it);
                if (keys.length === 1) {
                    key = keys[0];
                    value = it[key];
                } else throw new TypeError("Expected { key: value } tuple: ".concat(it));
            } else key = it;
            var pair = schema.createPair(key, value, ctx);
            pairs.items.push(pair);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return pairs;
}
var $21f9288149170794$export$ffb5f4729a158638 = {
    default: false,
    tag: 'tag:yaml.org,2002:pairs',
    resolve: $21f9288149170794$var$parsePairs,
    createNode: $21f9288149170794$var$createPairs
};
var $21f9288149170794$var$YAMLOMap = /*#__PURE__*/ function(_YAMLSeq) {
    (0, $1GDs0.j)(YAMLOMap, _YAMLSeq);
    var _super = (0, $1GDs0.k)(YAMLOMap);
    function YAMLOMap() {
        var _this;
        (0, $1GDs0.c)(this, YAMLOMap);
        _this = _super.call(this);
        (0, $1GDs0.e)((0, $1GDs0.p)(_this), "add", (0, $2U8gU.d).prototype.add.bind((0, $1GDs0.p)(_this)));
        (0, $1GDs0.e)((0, $1GDs0.p)(_this), "delete", (0, $2U8gU.d).prototype.delete.bind((0, $1GDs0.p)(_this)));
        (0, $1GDs0.e)((0, $1GDs0.p)(_this), "get", (0, $2U8gU.d).prototype.get.bind((0, $1GDs0.p)(_this)));
        (0, $1GDs0.e)((0, $1GDs0.p)(_this), "has", (0, $2U8gU.d).prototype.has.bind((0, $1GDs0.p)(_this)));
        (0, $1GDs0.e)((0, $1GDs0.p)(_this), "set", (0, $2U8gU.d).prototype.set.bind((0, $1GDs0.p)(_this)));
        _this.tag = YAMLOMap.tag;
        return _this;
    }
    (0, $1GDs0.b)(YAMLOMap, [
        {
            key: "toJSON",
            value: function toJSON$1(_, ctx) {
                var map = new Map();
                if (ctx && ctx.onCreate) ctx.onCreate(map);
                var _iterator = (0, $1GDs0._)(this.items), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var pair = _step.value;
                        var key = void 0, value = void 0;
                        if (pair instanceof (0, $2U8gU.P)) {
                            key = (0, $2U8gU.t)(pair.key, '', ctx);
                            value = (0, $2U8gU.t)(pair.value, key, ctx);
                        } else key = (0, $2U8gU.t)(pair, '', ctx);
                        if (map.has(key)) throw new Error('Ordered maps must not include duplicate keys');
                        map.set(key, value);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return map;
            }
        }
    ]);
    return YAMLOMap;
}((0, $2U8gU.Y));
(0, $1GDs0.e)($21f9288149170794$var$YAMLOMap, "tag", 'tag:yaml.org,2002:omap');
function $21f9288149170794$var$parseOMap(doc, cst) {
    var pairs = $21f9288149170794$var$parsePairs(doc, cst);
    var seenKeys = [];
    var _iterator2 = (0, $1GDs0._)(pairs.items), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var key = _step2.value.key;
            if (key instanceof (0, $2U8gU.S)) {
                if (seenKeys.includes(key.value)) {
                    var msg = 'Ordered maps must not include duplicate keys';
                    throw new (0, $1GDs0.g)(cst, msg);
                } else seenKeys.push(key.value);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return Object.assign(new $21f9288149170794$var$YAMLOMap(), pairs);
}
function $21f9288149170794$var$createOMap(schema, iterable, ctx) {
    var pairs = $21f9288149170794$var$createPairs(schema, iterable, ctx);
    var omap = new $21f9288149170794$var$YAMLOMap();
    omap.items = pairs.items;
    return omap;
}
var $21f9288149170794$export$ae1af26003f05816 = {
    identify: function identify(value) {
        return value instanceof Map;
    },
    nodeClass: $21f9288149170794$var$YAMLOMap,
    default: false,
    tag: 'tag:yaml.org,2002:omap',
    resolve: $21f9288149170794$var$parseOMap,
    createNode: $21f9288149170794$var$createOMap
};
var $21f9288149170794$var$YAMLSet = /*#__PURE__*/ function(_YAMLMap) {
    (0, $1GDs0.j)(YAMLSet, _YAMLMap);
    var _super = (0, $1GDs0.k)(YAMLSet);
    function YAMLSet() {
        var _this;
        (0, $1GDs0.c)(this, YAMLSet);
        _this = _super.call(this);
        _this.tag = YAMLSet.tag;
        return _this;
    }
    (0, $1GDs0.b)(YAMLSet, [
        {
            key: "add",
            value: function add(key) {
                var pair = key instanceof (0, $2U8gU.P) ? key : new (0, $2U8gU.P)(key);
                var prev = (0, $2U8gU.l)(this.items, pair.key);
                if (!prev) this.items.push(pair);
            }
        },
        {
            key: "get",
            value: function get(key, keepPair) {
                var pair = (0, $2U8gU.l)(this.items, key);
                return !keepPair && pair instanceof (0, $2U8gU.P) ? pair.key instanceof (0, $2U8gU.S) ? pair.key.value : pair.key : pair;
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                if (typeof value !== 'boolean') throw new Error("Expected boolean value for set(key, value) in a YAML set, not ".concat((0, $1GDs0.a)(value)));
                var prev = (0, $2U8gU.l)(this.items, key);
                if (prev && !value) this.items.splice(this.items.indexOf(prev), 1);
                else if (!prev && value) this.items.push(new (0, $2U8gU.P)(key));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, ctx) {
                return (0, $1GDs0.l)((0, $1GDs0.m)(YAMLSet.prototype), "toJSON", this).call(this, _, ctx, Set);
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx) return JSON.stringify(this);
                if (this.hasAllNullValues()) return (0, $1GDs0.l)((0, $1GDs0.m)(YAMLSet.prototype), "toString", this).call(this, ctx, onComment, onChompKeep);
                else throw new Error('Set items must all have null values');
            }
        }
    ]);
    return YAMLSet;
}((0, $2U8gU.d));
(0, $1GDs0.e)($21f9288149170794$var$YAMLSet, "tag", 'tag:yaml.org,2002:set');
function $21f9288149170794$var$parseSet(doc, cst) {
    var map = (0, $2U8gU.g)(doc, cst);
    if (!map.hasAllNullValues()) throw new (0, $1GDs0.g)(cst, 'Set items must all have null values');
    return Object.assign(new $21f9288149170794$var$YAMLSet(), map);
}
function $21f9288149170794$var$createSet(schema, iterable, ctx) {
    var set = new $21f9288149170794$var$YAMLSet();
    var _iterator = (0, $1GDs0._)(iterable), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var value = _step.value;
            set.items.push(schema.createPair(value, null, ctx));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
}
var $21f9288149170794$export$2408f22a0fab9ae5 = {
    identify: function identify(value) {
        return value instanceof Set;
    },
    nodeClass: $21f9288149170794$var$YAMLSet,
    default: false,
    tag: 'tag:yaml.org,2002:set',
    resolve: $21f9288149170794$var$parseSet,
    createNode: $21f9288149170794$var$createSet
};
var $21f9288149170794$var$parseSexagesimal = function parseSexagesimal(sign, parts) {
    var n = parts.split(':').reduce(function(n, p) {
        return n * 60 + Number(p);
    }, 0);
    return sign === '-' ? -n : n;
}; // hhhh:mm:ss.sss
var $21f9288149170794$var$stringifySexagesimal = function stringifySexagesimal(_ref) {
    var value = _ref.value;
    if (isNaN(value) || !isFinite(value)) return (0, $2U8gU.k)(value);
    var sign = '';
    if (value < 0) {
        sign = '-';
        value = Math.abs(value);
    }
    var parts = [
        value % 60
    ]; // seconds, including ms
    if (value < 60) parts.unshift(0); // at least one : is required
    else {
        value = Math.round((value - parts[0]) / 60);
        parts.unshift(value % 60); // minutes
        if (value >= 60) {
            value = Math.round((value - parts[0]) / 60);
            parts.unshift(value); // hours
        }
    }
    return sign + parts.map(function(n) {
        return n < 10 ? '0' + String(n) : String(n);
    }).join(':').replace(/000000\d*$/, '') // % 60 may introduce error
    ;
};
var $21f9288149170794$export$23f2a1d2818174ef = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'TIME',
    test: /^([-+]?)([0-9][0-9_]*(?::[0-5]?[0-9])+)$/,
    resolve: function resolve(str, sign, parts) {
        return $21f9288149170794$var$parseSexagesimal(sign, parts.replace(/_/g, ''));
    },
    stringify: $21f9288149170794$var$stringifySexagesimal
};
var $21f9288149170794$export$2d1720544b23b823 = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'TIME',
    test: /^([-+]?)([0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*)$/,
    resolve: function resolve(str, sign, parts) {
        return $21f9288149170794$var$parseSexagesimal(sign, parts.replace(/_/g, ''));
    },
    stringify: $21f9288149170794$var$stringifySexagesimal
};
var $21f9288149170794$export$625550452a3fa3ec = {
    identify: function identify(value) {
        return value instanceof Date;
    },
    default: true,
    tag: 'tag:yaml.org,2002:timestamp',
    // If the time zone is omitted, the timestamp is assumed to be specified in UTC. The time part
    // may be omitted altogether, resulting in a date format. In such a case, the time part is
    // assumed to be 00:00:00Z (start of day, UTC).
    test: RegExp("^(?:([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?)$"),
    resolve: function resolve(str, year, month, day, hour, minute, second, millisec, tz) {
        if (millisec) millisec = (millisec + '00').substr(1, 3);
        var date = Date.UTC(year, month - 1, day, hour || 0, minute || 0, second || 0, millisec || 0);
        if (tz && tz !== 'Z') {
            var d = $21f9288149170794$var$parseSexagesimal(tz[0], tz.slice(1));
            if (Math.abs(d) < 30) d *= 60;
            date -= 60000 * d;
        }
        return new Date(date);
    },
    stringify: function stringify(_ref2) {
        var value = _ref2.value;
        return value.toISOString().replace(/((T00:00)?:00)?\.000Z$/, '');
    }
};
/* global console, process, YAML_SILENCE_DEPRECATION_WARNINGS, YAML_SILENCE_WARNINGS */ function $21f9288149170794$var$shouldWarn(deprecation) {
    var env = {};
    if (deprecation) {
        if (typeof YAML_SILENCE_DEPRECATION_WARNINGS !== 'undefined') return !YAML_SILENCE_DEPRECATION_WARNINGS;
        return !env.YAML_SILENCE_DEPRECATION_WARNINGS;
    }
    if (typeof YAML_SILENCE_WARNINGS !== 'undefined') return !YAML_SILENCE_WARNINGS;
    return !env.YAML_SILENCE_WARNINGS;
}
function $21f9288149170794$export$efccba1c4a2ef57b(warning, type) {
    if ($21f9288149170794$var$shouldWarn(false)) {
        var emit = false; // This will throw in Jest if `warning` is an Error instance due to
        // https://github.com/facebook/jest/issues/2549
        if (emit) emit(warning, type);
        else // eslint-disable-next-line no-console
        console.warn(type ? "".concat(type, ": ").concat(warning) : warning);
    }
}
function $21f9288149170794$export$db3b6bfb95261072(filename) {
    if ($21f9288149170794$var$shouldWarn(true)) {
        var path = filename.replace(/.*yaml[/\\]/i, '').replace(/\.js$/, '').replace(/\\/g, '/');
        $21f9288149170794$export$efccba1c4a2ef57b("The endpoint 'yaml/".concat(path, "' will be removed in a future release."), 'DeprecationWarning');
    }
}
var $21f9288149170794$var$warned = {};
function $21f9288149170794$export$407448d2b89b1813(name, alternative) {
    if (!$21f9288149170794$var$warned[name] && $21f9288149170794$var$shouldWarn(true)) {
        $21f9288149170794$var$warned[name] = true;
        var msg = "The option '".concat(name, "' will be removed in a future release");
        msg += alternative ? ", use '".concat(alternative, "' instead.") : '.';
        $21f9288149170794$export$efccba1c4a2ef57b(msg, 'DeprecationWarning');
    }
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});






parcelRegister("lDN4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $e12caff698a0e93b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $3wsqW = parcelRequire("3wsqW");
function $e12caff698a0e93b$export$2e2bcd8739ae039(props) {
    const { content: content, tooltip: tooltip = 'Copy content' } = props;
    const ref = (0, $acw62.useRef)(null);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(ref.current.innerText);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e12caff698a0e93b$var$Root, {
        className: "code text-xs",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: ref,
                className: "clipboard-content",
                children: content
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($e12caff698a0e93b$var$BtnContainer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3wsqW.default), {
                    tooltip: tooltip,
                    onClick: ()=>handleCopy()
                })
            })
        ]
    });
}
const $e12caff698a0e93b$var$Root = (0, $d8seH.default)('pre')`
  position: relative;
  padding-bottom: 0px !important;

  .clipboard-content {
    overflow-x: scroll;
    padding-bottom: 15px;
  }

  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f8f8'};
  border: 1px solid ${(props)=>props.theme.palette.divider};
`;
const $e12caff698a0e93b$var$BtnContainer = (0, $d8seH.default)('div')`
  position: absolute;
  right: 0;
  top: 0;
`;

});
parcelRegister("3wsqW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d341db252be0206e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $cVXaD = parcelRequire("cVXaD");

var $9Lykx = parcelRequire("9Lykx");

var $jPKtZ = parcelRequire("jPKtZ");

var $6N66Y = parcelRequire("6N66Y");
function $d341db252be0206e$export$2e2bcd8739ae039(props) {
    const { tooltip: tooltip, onClick: onClick } = props;
    const [isCopied, setIsCopied] = (0, $acw62.useState)(false);
    const handleCopy = ()=>{
        onClick();
        setIsCopied(true);
        setTimeout(()=>setIsCopied(false), 2000);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: isCopied ? 'Copied!' : tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d341db252be0206e$var$CopyButton, {
            onClick: ()=>handleCopy(),
            size: "small",
            children: isCopied ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6N66Y))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jPKtZ))), {})
        })
    });
}
const $d341db252be0206e$var$CopyButton = (0, $lmFrL.default)((0, $9Lykx.default))`
  background: inherit;

  :hover {
    background: #ddd;
  }
`;

});
parcelRegister("jPKtZ", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e706d63eda5ef5df$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e706d63eda5ef5df$var$_createSvgIcon = $e706d63eda5ef5df$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e706d63eda5ef5df$var$_default = module.exports.default = (0, $e706d63eda5ef5df$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11zM8 21V7h6v5h5v9z"
}), 'FileCopyOutlined');

});

parcelRegister("6N66Y", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4f1c0f4604e1f5a1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f1c0f4604e1f5a1$var$_createSvgIcon = $4f1c0f4604e1f5a1$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4f1c0f4604e1f5a1$var$_default = module.exports.default = (0, $4f1c0f4604e1f5a1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), 'DoneOutlined');

});



parcelRegister("7upBl", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $573f31a642341f92$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $573f31a642341f92$var$_createSvgIcon = $573f31a642341f92$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $573f31a642341f92$var$_default = module.exports.default = (0, $573f31a642341f92$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.88 9.29 12 13.17 8.12 9.29a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0"
}), 'ExpandMoreRounded');

});

parcelRegister("9bsRS", function(module, exports) {

$parcel$export(module.exports, "phaseMap", () => $563367685b2d236d$export$d35e04fbd73569bb);
$parcel$export(module.exports, "getBKState", () => $563367685b2d236d$export$db802e88b23a39b8);
$parcel$export(module.exports, "getManifest", () => $563367685b2d236d$export$39e873de56f329d8);
$parcel$export(module.exports, "getSimpleManifests", () => $563367685b2d236d$export$620c569486f3ba36);
$parcel$export(module.exports, "getAllSensors", () => $563367685b2d236d$export$672fef6624a1005f);
$parcel$export(module.exports, "getSensors", () => $563367685b2d236d$export$d4cef0abb1b35d6f);
$parcel$export(module.exports, "getSensor", () => $563367685b2d236d$export$14072fa7cbb1cea3);
$parcel$export(module.exports, "saveSensor", () => $563367685b2d236d$export$2c4d2d0bddfa93c);
$parcel$export(module.exports, "findHostWithSerial", () => $563367685b2d236d$export$ffdfc56694224584);
$parcel$export(module.exports, "getNodes", () => $563367685b2d236d$export$d668e62f6e0051f4);
$parcel$export(module.exports, "getUserNodesAndProjects", () => $563367685b2d236d$export$d59a707459811ecb);
$parcel$export(module.exports, "getNodeDict", () => $563367685b2d236d$export$f5e4c69b43eb5f5f);
$parcel$export(module.exports, "getNode", () => $563367685b2d236d$export$3f778c4e796a1f9c);
$parcel$export(module.exports, "getSiteIDs", () => $563367685b2d236d$export$a1c14c13f4df9073);
$parcel$export(module.exports, "getOntology", () => $563367685b2d236d$export$9eab4c482f6bd48e);

var $gZwVy = parcelRequire("gZwVy");

var $aQAPf = parcelRequire("aQAPf");

var $f1q41 = parcelRequire("f1q41");

var $5g1Ik = parcelRequire("5g1Ik");

var $cLnd8 = parcelRequire("cLnd8");

var $gtf2w = parcelRequire("gtf2w");

var $gLZWn = parcelRequire("gLZWn");

var $c3pId = parcelRequire("c3pId");

var $ecxdi = parcelRequire("ecxdi");
const $563367685b2d236d$var$PROJECT = (0, $aQAPf.default).project;
const $563367685b2d236d$var$url = (0, $gZwVy.default).beekeeper;
const $563367685b2d236d$var$API_URL = `${$563367685b2d236d$var$url}/api`;
const $563367685b2d236d$var$__token = (0, $c3pId.default).token;
const $563367685b2d236d$var$options = {
    headers: $563367685b2d236d$var$__token ? {
        Authorization: `sage ${$563367685b2d236d$var$__token}`
    } : {}
};
const $563367685b2d236d$export$671d0fa593843351 = [
    '1 Production',
    '2 Development',
    '3 Hacker',
    '4 Not Deployed'
];
const $563367685b2d236d$export$d35e04fbd73569bb = {
    'deployed': 'Deployed',
    'awaiting': 'Awaiting Deployment',
    'pending': 'Shipment Pending',
    'maintenance': 'Maintenance',
    'standby': 'Standby',
    'retired': 'Retired'
};
function $563367685b2d236d$var$get(endpoint, opts = {}) {
    return fetch(endpoint, opts).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
// special django error handling
function $563367685b2d236d$var$getDjangoData(endpoint, opts = {}) {
    return fetch(endpoint, opts).then((0, $5g1Ik.handleDjangoErrors)).then((res)=>res.json());
}
function $563367685b2d236d$var$put(endpoint, data) {
    const putOptions = {
        'headers': {
            ...$563367685b2d236d$var$options.headers,
            'Content-Type': 'application/json'
        },
        'method': 'PUT',
        'body': JSON.stringify(data)
    };
    return fetch(endpoint, putOptions).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
async function $563367685b2d236d$export$41f0c4d7adac1457() {
    const data = await $563367685b2d236d$var$get(`${$563367685b2d236d$var$API_URL}/state`);
    return data.data;
}
async function $563367685b2d236d$export$db802e88b23a39b8(id) {
    const data = await $563367685b2d236d$var$get(`${$563367685b2d236d$var$API_URL}/state/${id}`);
    return data.data;
}
// used for tables, such as in node tables
const $563367685b2d236d$var$toSimpleManifest = (o)=>({
        vsn: o.vsn,
        name: o.name,
        gps_lat: o.gps_lat,
        gps_lon: o.gps_lon,
        modem_model: o.modem?.model,
        modem_hw_model: o.resources.find((obj)=>obj.name == 'modem')?.hardware.hw_model,
        modem_sim_type: o.modem?.sim_type,
        modem_carrier: o.modem?.carrier,
        ...o.modem && {
            modem_carrier_name: (0, $gLZWn.getCarrierName)(o.modem?.carrier)
        },
        computes: o.computes.map(({ name: name, serial_no: serial_no, zone: zone })=>({
                name: name,
                serial_no: serial_no,
                zone: zone
            })),
        sensors: o.sensors.map(({ name: name, scope: scope, hardware: hardware })=>({
                name: name,
                scope: scope,
                hardware: hardware.hardware,
                hw_model: hardware.hw_model,
                description: hardware.description,
                capabilities: hardware.capabilities
            })).sort((a)=>a.name != a.hw_model.toLowerCase() ? -1 : 1)
    });
// a convenient, flattened representation
const $563367685b2d236d$var$flattenManifest = (o)=>({
        vsn: o.vsn,
        name: o.name,
        gps_lat: o.gps_lat,
        gps_lon: o.gps_lon,
        modem_model: o.modem?.model,
        modem_hw_model: o.resources.find((obj)=>obj.name == 'modem')?.hardware.hw_model,
        modem_sim_type: o.modem?.sim_type,
        modem_carrier: o.modem?.carrier,
        ...o.modem && {
            modem_carrier_name: (0, $gLZWn.getCarrierName)(o.modem?.carrier)
        },
        project: o.project,
        address: o.address,
        lorawanconnections: o.lorawanconnections.map(({ lorawandevice: lorawandevice, ...rest })=>({
                ...rest,
                ...lorawandevice,
                ...lorawandevice.hardware && {
                    ...lorawandevice.hardware
                }
            })),
        computes: o.computes.map(({ hardware: hardware, ...rest })=>({
                ...rest,
                ...hardware
            })),
        sensors: o.sensors.map(({ hardware: hardware, ...rest })=>({
                ...rest,
                ...hardware
            })).sort((a)=>a.name != a.hw_model.toLowerCase() ? -1 : 1),
        resources: o.resources.map(({ name: name, hardware: hardware })=>({
                name: name,
                ...hardware
            }))
    });
async function $563367685b2d236d$export$39e873de56f329d8(vsn) {
    let data = await $563367685b2d236d$var$get(`${(0, $gZwVy.default).auth}/manifests/${vsn}`);
    data = $563367685b2d236d$var$flattenManifest(data);
    return data;
}
async function $563367685b2d236d$export$620c569486f3ba36() {
    let data = await $563367685b2d236d$var$get(`${(0, $gZwVy.default).auth}/manifests/`);
    data = data.map($563367685b2d236d$var$toSimpleManifest);
    return data;
}
async function $563367685b2d236d$export$672fef6624a1005f() {
    const data = await $563367685b2d236d$var$get(`${(0, $gZwVy.default).auth}/sensors/`);
    return data;
}
async function $563367685b2d236d$export$d4cef0abb1b35d6f() {
    const project = $563367685b2d236d$var$PROJECT;
    const params = [
        project ? `project=${project}` : '',
        project?.toLowerCase() == 'sage' ? `phase=${[
            'Deployed',
            'Awaiting Deployment',
            'Maintenance'
        ].join(',')}` : ''
    ];
    const data = await $563367685b2d236d$var$get(`${(0, $gZwVy.default).auth}/sensors/?${params.join('&')}`);
    return data;
}
async function $563367685b2d236d$export$14072fa7cbb1cea3(hw_model) {
    const data = await $563367685b2d236d$export$d4cef0abb1b35d6f();
    return data.find((obj)=>obj.hw_model == hw_model);
}
function $563367685b2d236d$export$2c4d2d0bddfa93c(state) {
    return $563367685b2d236d$var$put(`${(0, $gZwVy.default).auth}/sensorhardwares/${state.hw_model}`, state);
}
function $563367685b2d236d$export$ffdfc56694224584(hosts, serial_no) {
    return hosts.find((host)=>host.split('.')[0].slice(4).toUpperCase() == serial_no?.toUpperCase());
}
async function $563367685b2d236d$export$d668e62f6e0051f4(args) {
    const { vsns: vsns, project: project } = args || {};
    let nodes = await $563367685b2d236d$var$_getNodeMetas({
        project: project,
        vsns: vsns
    });
    if (vsns) nodes = nodes.filter((o)=>vsns.includes(o.vsn));
    return nodes.filter((o)=>!!o.computes.length).map((obj)=>$563367685b2d236d$var$_sanitizeMeta(obj));
}
async function $563367685b2d236d$export$d59a707459811ecb(args) {
    const { vsns: vsns, project: project } = args || {};
    // get user's projects and nodes
    const prom = await Promise.all([
        (0, $ecxdi.listMyProjects)(),
        $563367685b2d236d$var$_getNodeMetas({
            project: project,
            vsns: vsns
        })
    ]);
    const myProjects = prom[0];
    let nodes = prom[1];
    nodes = nodes.filter((o)=>myProjects.vsns.includes(o.vsn));
    // include "access" info for each node
    const nodesWithAccess = nodes.map((n)=>({
            ...n,
            access: myProjects.access[n.vsn] || []
        }));
    return {
        nodes: nodesWithAccess.map((obj)=>$563367685b2d236d$var$_sanitizeMeta(obj)),
        projects: myProjects.projects
    };
}
async function $563367685b2d236d$export$f5e4c69b43eb5f5f(args) {
    const nodes = await $563367685b2d236d$export$d668e62f6e0051f4(args);
    return (0, $f1q41.keyBy)(nodes, 'vsn');
}
async function $563367685b2d236d$export$3f778c4e796a1f9c(vsn) {
    const node = await $563367685b2d236d$var$_getNodeMeta(vsn);
    return $563367685b2d236d$var$_sanitizeMeta(node);
}
async function $563367685b2d236d$export$a1c14c13f4df9073() {
    const nodes = await $563367685b2d236d$export$d668e62f6e0051f4();
    return nodes.reduce((acc, n)=>n.site_id ? {
            ...acc,
            [n.vsn]: n.site_id
        } : acc, {});
}
async function $563367685b2d236d$export$28dda9275253ea3() {
    const data = await $563367685b2d236d$var$get(`${$563367685b2d236d$var$url}/ontology`);
    return data;
}
async function $563367685b2d236d$export$9eab4c482f6bd48e(name) {
    const data = await $563367685b2d236d$export$28dda9275253ea3();
    return data.find((o)=>o.ontology == name);
}
async function $563367685b2d236d$export$4dc777407e7dc1ac() {
    const data = await $563367685b2d236d$var$get(`${$563367685b2d236d$var$url}/factory`);
    return (0, $f1q41.keyBy)(data, 'vsn');
}
async function $563367685b2d236d$var$_getNodeMetas(args) {
    const { project: project, vsns: vsns } = args || {};
    let url = `${(0, $gZwVy.default).auth}/api/v-beta/nodes/`;
    if (project) url += `?project__name=${project}`;
    let meta = await $563367685b2d236d$var$getDjangoData(url);
    if (vsns) meta = meta.filter((o)=>vsns.includes(o.vsn));
    return meta;
}
function $563367685b2d236d$var$_getNodeMeta(vsn) {
    return $563367685b2d236d$var$getDjangoData(`${(0, $gZwVy.default).auth}/api/v-beta/nodes/${vsn}`);
}
function $563367685b2d236d$var$_sanitizeMeta(obj) {
    const { city: city, state: state } = $563367685b2d236d$var$parseAddr(obj.address);
    const stateAbbrev = state?.toUpperCase();
    return {
        ...obj,
        state: stateAbbrev in (0, $gtf2w.default) ? `${(0, $gtf2w.default)[state]} (${stateAbbrev})` : stateAbbrev,
        city: city && state ? `${city}, ${state}` : undefined,
        stateStr: state,
        cityStr: city,
        hasStaticGPS: !!obj.gps_lat && !!obj.gps_lon,
        lat: obj.gps_lat,
        lng: obj.gps_lon,
        modem_carrier_name: obj.modem_carrier ? (0, $gLZWn.getCarrierName)(obj.modem_carrier) : null,
        top_camera: obj.sensors.find((o)=>o.name == 'top_camera')?.hw_model,
        bottom_camera: obj.sensors.find((o)=>o.name == 'bottom_camera')?.hw_model,
        left_camera: obj.sensors.find((o)=>o.name == 'left_camera')?.hw_model,
        right_camera: obj.sensors.find((o)=>o.name == 'right_camera')?.hw_model,
        sensor: obj.sensors.map((o)=>o.hw_model),
        sensorCapabilities: (0, $f1q41.uniq)(obj.sensors.flatMap((o)=>o.capabilities))
    };
}
function $563367685b2d236d$var$parseAddr(addressStr) {
    // ignore possible names, support 1 or 2 line addresses
    const lines = addressStr.split(/\r?\n/);
    let address;
    // if one line, assume only address
    if (lines.length == 1) address = lines[0];
    else if (lines.length == 2 || lines.length == 3) address = lines.slice(1).join(', ');
    else {
        console.error('address format not recognized:\n\n', address);
        return;
    }
    let parts = address.split(', ');
    let city, state;
    // if 4 parts, reduce to `<city>, <state> <zip?>`
    if (parts.length == 4) parts = parts.slice(2);
    const stateZip = parts[1]?.split(' ') // last part of address may or may not include zip
    ;
    if (parts.length == 2 && stateZip.length == 2) [city, state] = [
        parts[0],
        ...stateZip
    ];
    else if (parts.length == 2 && stateZip.length == 1) [city, state] = parts;
    else if (parts[0].split(' ').length == 1) [city, state] = parts.slice(1);
    else ({ city: city, state: state } = (0, (/*@__PURE__*/$parcel$interopDefault($cLnd8))).parseLocation(address) || {});
    return {
        city: city,
        state: state
    };
}

});
parcelRegister("aQAPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $875139f10718862b$export$2e2bcd8739ae039);
// use env variable to load corresponding config below
const $875139f10718862b$var$SAGE_UI_PROJECT = 'sage';
const $875139f10718862b$var$configs = {
    'sage': {
        project: 'SAGE,SGT'
    },
    'apiary': {
        project: 'APIARY'
    },
    'dawn': {
        project: 'DAWN',
        initialViewState: {
            latitude: 41.88,
            longitude: -87.66,
            zoom: 12.3
        }
    },
    'neon-mdp': {
        vsns: [
            'W038',
            'W01D',
            'W01F',
            'V008'
        ],
        dataStart: new Date('2022-04-05T12:00:00Z'),
        dataEnd: new Date('2022-05-05T12:00:00Z'),
        dataProductPath: '/data/product/neon-mdp-sage-wifire-bp3d-konza-prairie-burn-experiment'
    },
    'vto': {
        project: 'VTO',
        initialViewState: {
            latitude: 41.8,
            longitude: -87.9,
            zoom: 9.0
        }
    }
};
var $875139f10718862b$export$2e2bcd8739ae039 = {
    elapsedThresholds: {
        fail: 360000,
        warning: 180000
    },
    // merge in appropriate config from above
    ...$875139f10718862b$var$configs[$875139f10718862b$var$SAGE_UI_PROJECT.toLowerCase()]
};

});

parcelRegister("cLnd8", function(module, exports) {

$parcel$export(module.exports, "parseIntersection", () => $94abe10482943079$export$5939f39986f056a, (v) => $94abe10482943079$export$5939f39986f056a = v);
$parcel$export(module.exports, "parseLocation", () => $94abe10482943079$export$4909df247a32aad3, (v) => $94abe10482943079$export$4909df247a32aad3 = v);
$parcel$export(module.exports, "parseInformalAddress", () => $94abe10482943079$export$6ca983ec4b6ffc57, (v) => $94abe10482943079$export$6ca983ec4b6ffc57 = v);
$parcel$export(module.exports, "parseAddress", () => $94abe10482943079$export$6b5a4e2dc1897273, (v) => $94abe10482943079$export$6b5a4e2dc1897273 = v);
// Copyright (c) 2014-2015, hassansin
//
//Perl Ref: http://cpansearch.perl.org/src/TIMB/Geo-StreetAddress-US-1.04/US.pm
var $94abe10482943079$export$5939f39986f056a;
var $94abe10482943079$export$4909df247a32aad3;
var $94abe10482943079$export$6ca983ec4b6ffc57;
var $94abe10482943079$export$6b5a4e2dc1897273;
"use strict";

(function() {
    var root;
    root = this;
    var XRegExp;
    XRegExp = (parcelRequire("973rj"));
    var parser = {};
    var Addr_Match = {};
    var Directional = {
        north: "N",
        northeast: "NE",
        east: "E",
        southeast: "SE",
        south: "S",
        southwest: "SW",
        west: "W",
        northwest: "NW"
    };
    var Street_Type = {
        allee: "aly",
        alley: "aly",
        ally: "aly",
        anex: "anx",
        annex: "anx",
        annx: "anx",
        arcade: "arc",
        av: "ave",
        aven: "ave",
        avenu: "ave",
        avenue: "ave",
        avn: "ave",
        avnue: "ave",
        bayoo: "byu",
        bayou: "byu",
        beach: "bch",
        bend: "bnd",
        bluf: "blf",
        bluff: "blf",
        bluffs: "blfs",
        bot: "btm",
        bottm: "btm",
        bottom: "btm",
        boul: "blvd",
        boulevard: "blvd",
        boulv: "blvd",
        branch: "br",
        brdge: "brg",
        bridge: "brg",
        brnch: "br",
        brook: "brk",
        brooks: "brks",
        burg: "bg",
        burgs: "bgs",
        bypa: "byp",
        bypas: "byp",
        bypass: "byp",
        byps: "byp",
        camp: "cp",
        canyn: "cyn",
        canyon: "cyn",
        cape: "cpe",
        causeway: "cswy",
        causway: "cswy",
        causwa: "cswy",
        cen: "ctr",
        cent: "ctr",
        center: "ctr",
        centers: "ctrs",
        centr: "ctr",
        centre: "ctr",
        circ: "cir",
        circl: "cir",
        circle: "cir",
        circles: "cirs",
        ck: "crk",
        cliff: "clf",
        cliffs: "clfs",
        club: "clb",
        cmp: "cp",
        cnter: "ctr",
        cntr: "ctr",
        cnyn: "cyn",
        common: "cmn",
        commons: "cmns",
        corner: "cor",
        corners: "cors",
        course: "crse",
        court: "ct",
        courts: "cts",
        cove: "cv",
        coves: "cvs",
        cr: "crk",
        crcl: "cir",
        crcle: "cir",
        crecent: "cres",
        creek: "crk",
        crescent: "cres",
        cresent: "cres",
        crest: "crst",
        crossing: "xing",
        crossroad: "xrd",
        crossroads: "xrds",
        crscnt: "cres",
        crsent: "cres",
        crsnt: "cres",
        crssing: "xing",
        crssng: "xing",
        crt: "ct",
        curve: "curv",
        dale: "dl",
        dam: "dm",
        div: "dv",
        divide: "dv",
        driv: "dr",
        drive: "dr",
        drives: "drs",
        drv: "dr",
        dvd: "dv",
        estate: "est",
        estates: "ests",
        exp: "expy",
        expr: "expy",
        express: "expy",
        expressway: "expy",
        expw: "expy",
        extension: "ext",
        extensions: "exts",
        extn: "ext",
        extnsn: "ext",
        fall: "fall",
        falls: "fls",
        ferry: "fry",
        field: "fld",
        fields: "flds",
        flat: "flt",
        flats: "flts",
        ford: "frd",
        fords: "frds",
        forest: "frst",
        forests: "frst",
        forg: "frg",
        forge: "frg",
        forges: "frgs",
        fork: "frk",
        forks: "frks",
        fort: "ft",
        freeway: "fwy",
        freewy: "fwy",
        frry: "fry",
        frt: "ft",
        frway: "fwy",
        frwy: "fwy",
        garden: "gdn",
        gardens: "gdns",
        gardn: "gdn",
        gateway: "gtwy",
        gatewy: "gtwy",
        gatway: "gtwy",
        glen: "gln",
        glens: "glns",
        grden: "gdn",
        grdn: "gdn",
        grdns: "gdns",
        green: "grn",
        greens: "grns",
        grov: "grv",
        grove: "grv",
        groves: "grvs",
        gtway: "gtwy",
        harb: "hbr",
        harbor: "hbr",
        harbors: "hbrs",
        harbr: "hbr",
        haven: "hvn",
        havn: "hvn",
        height: "hts",
        heights: "hts",
        hgts: "hts",
        highway: "hwy",
        highwy: "hwy",
        hill: "hl",
        hills: "hls",
        hiway: "hwy",
        hiwy: "hwy",
        hllw: "holw",
        hollow: "holw",
        hollows: "holw",
        holws: "holw",
        hrbor: "hbr",
        ht: "hts",
        hway: "hwy",
        inlet: "inlt",
        island: "is",
        islands: "iss",
        isles: "isle",
        islnd: "is",
        islnds: "iss",
        jction: "jct",
        jctn: "jct",
        jctns: "jcts",
        junction: "jct",
        junctions: "jcts",
        junctn: "jct",
        juncton: "jct",
        key: "ky",
        keys: "kys",
        knol: "knl",
        knoll: "knl",
        knolls: "knls",
        la: "ln",
        lake: "lk",
        lakes: "lks",
        land: "land",
        landing: "lndg",
        lane: "ln",
        lanes: "ln",
        ldge: "ldg",
        light: "lgt",
        lights: "lgts",
        lndng: "lndg",
        loaf: "lf",
        lock: "lck",
        locks: "lcks",
        lodg: "ldg",
        lodge: "ldg",
        loops: "loop",
        mall: "mall",
        manor: "mnr",
        manors: "mnrs",
        meadow: "mdw",
        meadows: "mdws",
        medows: "mdws",
        mews: "mews",
        mill: "ml",
        mills: "mls",
        mission: "msn",
        missn: "msn",
        mnt: "mt",
        mntain: "mtn",
        mntn: "mtn",
        mntns: "mtns",
        motorway: "mtwy",
        mount: "mt",
        mountain: "mtn",
        mountains: "mtns",
        mountin: "mtn",
        mssn: "msn",
        mtin: "mtn",
        neck: "nck",
        orchard: "orch",
        orchrd: "orch",
        overpass: "opas",
        ovl: "oval",
        parks: "park",
        parkway: "pkwy",
        parkways: "pkwy",
        parkwy: "pkwy",
        pass: "pass",
        passage: "psge",
        paths: "path",
        pikes: "pike",
        pine: "pne",
        pines: "pnes",
        pk: "park",
        pkway: "pkwy",
        pkwys: "pkwy",
        pky: "pkwy",
        place: "pl",
        plain: "pln",
        plaines: "plns",
        plains: "plns",
        plaza: "plz",
        plza: "plz",
        point: "pt",
        points: "pts",
        port: "prt",
        ports: "prts",
        prairie: "pr",
        prarie: "pr",
        prk: "park",
        prr: "pr",
        rad: "radl",
        radial: "radl",
        radiel: "radl",
        ranch: "rnch",
        ranches: "rnch",
        rapid: "rpd",
        rapids: "rpds",
        rdge: "rdg",
        rest: "rst",
        ridge: "rdg",
        ridges: "rdgs",
        river: "riv",
        rivr: "riv",
        rnchs: "rnch",
        road: "rd",
        roads: "rds",
        route: "rte",
        rvr: "riv",
        row: "row",
        rue: "rue",
        run: "run",
        shoal: "shl",
        shoals: "shls",
        shoar: "shr",
        shoars: "shrs",
        shore: "shr",
        shores: "shrs",
        skyway: "skwy",
        spng: "spg",
        spngs: "spgs",
        spring: "spg",
        springs: "spgs",
        sprng: "spg",
        sprngs: "spgs",
        spurs: "spur",
        sqr: "sq",
        sqre: "sq",
        sqrs: "sqs",
        squ: "sq",
        square: "sq",
        squares: "sqs",
        station: "sta",
        statn: "sta",
        stn: "sta",
        str: "st",
        strav: "stra",
        strave: "stra",
        straven: "stra",
        stravenue: "stra",
        stravn: "stra",
        stream: "strm",
        street: "st",
        streets: "sts",
        streme: "strm",
        strt: "st",
        strvn: "stra",
        strvnue: "stra",
        sumit: "smt",
        sumitt: "smt",
        summit: "smt",
        terr: "ter",
        terrace: "ter",
        throughway: "trwy",
        tpk: "tpke",
        tr: "trl",
        trace: "trce",
        traces: "trce",
        track: "trak",
        tracks: "trak",
        trafficway: "trfy",
        trail: "trl",
        trails: "trl",
        trk: "trak",
        trks: "trak",
        trls: "trl",
        trnpk: "tpke",
        trpk: "tpke",
        tunel: "tunl",
        tunls: "tunl",
        tunnel: "tunl",
        tunnels: "tunl",
        tunnl: "tunl",
        turnpike: "tpke",
        turnpk: "tpke",
        underpass: "upas",
        union: "un",
        unions: "uns",
        valley: "vly",
        valleys: "vlys",
        vally: "vly",
        vdct: "via",
        viadct: "via",
        viaduct: "via",
        view: "vw",
        views: "vws",
        vill: "vlg",
        villag: "vlg",
        village: "vlg",
        villages: "vlgs",
        ville: "vl",
        villg: "vlg",
        villiage: "vlg",
        vist: "vis",
        vista: "vis",
        vlly: "vly",
        vst: "vis",
        vsta: "vis",
        wall: "wall",
        walks: "walk",
        well: "wl",
        wells: "wls",
        wy: "way"
    };
    var State_Code = {
        "alabama": "AL",
        "alaska": "AK",
        "american samoa": "AS",
        "arizona": "AZ",
        "arkansas": "AR",
        "california": "CA",
        "colorado": "CO",
        "connecticut": "CT",
        "delaware": "DE",
        "district of columbia": "DC",
        "federated states of micronesia": "FM",
        "florida": "FL",
        "georgia": "GA",
        "guam": "GU",
        "hawaii": "HI",
        "idaho": "ID",
        "illinois": "IL",
        "indiana": "IN",
        "iowa": "IA",
        "kansas": "KS",
        "kentucky": "KY",
        "louisiana": "LA",
        "maine": "ME",
        "marshall islands": "MH",
        "maryland": "MD",
        "massachusetts": "MA",
        "michigan": "MI",
        "minnesota": "MN",
        "mississippi": "MS",
        "missouri": "MO",
        "montana": "MT",
        "nebraska": "NE",
        "nevada": "NV",
        "new hampshire": "NH",
        "new jersey": "NJ",
        "new mexico": "NM",
        "new york": "NY",
        "north carolina": "NC",
        "north dakota": "ND",
        "northern mariana islands": "MP",
        "ohio": "OH",
        "oklahoma": "OK",
        "oregon": "OR",
        "palau": "PW",
        "pennsylvania": "PA",
        "puerto rico": "PR",
        "rhode island": "RI",
        "south carolina": "SC",
        "south dakota": "SD",
        "tennessee": "TN",
        "texas": "TX",
        "utah": "UT",
        "vermont": "VT",
        "virgin islands": "VI",
        "virginia": "VA",
        "washington": "WA",
        "west virginia": "WV",
        "wisconsin": "WI",
        "wyoming": "WY"
    };
    var Direction_Code;
    var initialized = false;
    var Normalize_Map = {
        prefix: Directional,
        prefix1: Directional,
        prefix2: Directional,
        suffix: Directional,
        suffix1: Directional,
        suffix2: Directional,
        type: Street_Type,
        type1: Street_Type,
        type2: Street_Type,
        state: State_Code
    };
    function capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    }
    function keys(o) {
        return Object.keys(o);
    }
    function values(o) {
        var v = [];
        keys(o).forEach(function(k) {
            v.push(o[k]);
        });
        return v;
    }
    function each(o, fn) {
        keys(o).forEach(function(k) {
            fn(o[k], k);
        });
    }
    function invert(o) {
        var o1 = {};
        keys(o).forEach(function(k) {
            o1[o[k]] = k;
        });
        return o1;
    }
    function flatten(o) {
        return keys(o).concat(values(o));
    }
    function lazyInit() {
        if (initialized) return;
        initialized = true;
        Direction_Code = invert(Directional);
        /*
    var Street_Type_Match = {};
    each(Street_Type,function(v,k){ Street_Type_Match[v] = XRegExp.escape(v) });
    each(Street_Type,function(v,k){ Street_Type_Match[v] = Street_Type_Match[v] + "|" + XRegExp.escape(k); });
    each(Street_Type_Match,function(v,k){ Street_Type_Match[k] = new RegExp( '\\b(?:' +  Street_Type_Match[k]  + ')\\b', 'i') });
    */ Addr_Match = {
            type: flatten(Street_Type).sort().filter(function(v, i, arr) {
                return arr.indexOf(v) === i;
            }).join('|'),
            fraction: '\\d+\\/\\d+',
            state: '\\b(?:' + keys(State_Code).concat(values(State_Code)).map(XRegExp.escape).join('|') + ')\\b',
            direct: values(Directional).sort(function(a, b) {
                return a.length < b.length;
            }).reduce(function(prev, curr) {
                return prev.concat([
                    XRegExp.escape(curr.replace(/\w/g, '$&.')),
                    curr
                ]);
            }, keys(Directional)).join('|'),
            dircode: keys(Direction_Code).join("|"),
            zip: '(?<zip>\\d{5})[- ]?(?<plus4>\\d{4})?',
            corner: '(?:\\band\\b|\\bat\\b|&|\\@)'
        };
        Addr_Match.number = '(?<number>(\\d+-?\\d*)|([N|S|E|W]\\d{1,3}[N|S|E|W]\\d{1,6}))(?=\\D)';
        Addr_Match.street = '                                       \n\
      (?:                                                       \n\
        (?:(?<street_0>' + Addr_Match.direct + ')\\W+               \n\
           (?<type_0>' + Addr_Match.type + ')\\b                    \n\
        )                                                       \n\
        |                                                       \n\
        (?:(?<prefix_0>' + Addr_Match.direct + ')\\W+)?             \n\
        (?:                                                     \n\
          (?<street_1>[^,]*\\d)                                 \n\
          (?:[^\\w,]*(?<suffix_1>' + Addr_Match.direct + ')\\b)     \n\
          |                                                     \n\
          (?<street_2>[^,]+)                                    \n\
          (?:[^\\w,]+(?<type_2>' + Addr_Match.type + ')\\b)         \n\
          (?:[^\\w,]+(?<suffix_2>' + Addr_Match.direct + ')\\b)?    \n\
          |                                                     \n\
          (?<street_3>[^,]+?)                                   \n\
          (?:[^\\w,]+(?<type_3>' + Addr_Match.type + ')\\b)?        \n\
          (?:[^\\w,]+(?<suffix_3>' + Addr_Match.direct + ')\\b)?    \n\
        )                                                       \n\
      )';
        Addr_Match.po_box = 'p\\W*(?:[om]|ost\\ ?office)\\W*b(?:ox)?';
        Addr_Match.sec_unit_type_numbered = '             \n\
      (?<sec_unit_type_1>su?i?te                      \n\
        |' + Addr_Match.po_box + '                        \n\
        |(?:ap|dep)(?:ar)?t(?:me?nt)?                 \n\
        |ro*m                                         \n\
        |flo*r?                                       \n\
        |uni?t                                        \n\
        |bu?i?ldi?n?g                                 \n\
        |ha?nga?r                                     \n\
        |lo?t                                         \n\
        |pier                                         \n\
        |slip                                         \n\
        |spa?ce?                                      \n\
        |stop                                         \n\
        |tra?i?le?r                                   \n\
        |box)(?![a-z]                                 \n\
      )                                               \n\
      ';
        Addr_Match.sec_unit_type_unnumbered = '           \n\
      (?<sec_unit_type_2>ba?se?me?n?t                 \n\
        |fro?nt                                       \n\
        |lo?bby                                       \n\
        |lowe?r                                       \n\
        |off?i?ce?                                    \n\
        |pe?n?t?ho?u?s?e?                             \n\
        |rear                                         \n\
        |side                                         \n\
        |uppe?r                                       \n\
      )\\b';
        Addr_Match.sec_unit = '                               \n\
      (?:                               #fix3             \n\
        (?:                             #fix1             \n\
          (?:                                             \n\
            (?:' + Addr_Match.sec_unit_type_numbered + '\\W*) \n\
            |(?<sec_unit_type_3>\\#)\\W*                  \n\
          )                                               \n\
          (?<sec_unit_num_1>[\\w-]+)                      \n\
        )                                                 \n\
        |                                                 \n\
        ' + Addr_Match.sec_unit_type_unnumbered + '           \n\
      )';
        Addr_Match.city_and_state = '                       \n\
      (?:                                               \n\
        (?<city>[^\\d,]+?)\\W+                          \n\
        (?<state>' + Addr_Match.state + ')                  \n\
      )                                                 \n\
      ';
        Addr_Match.place = '                                \n\
      (?:' + Addr_Match.city_and_state + '\\W*)?            \n\
      (?:' + Addr_Match.zip + ')?                           \n\
      ';
        Addr_Match.address = XRegExp('                      \n\
      ^                                                 \n\
      [^\\w\\#]*                                        \n\
      (' + Addr_Match.number + ')\\W*                       \n\
      (?:' + Addr_Match.fraction + '\\W*)?                  \n\
         ' + Addr_Match.street + '\\W+                      \n\
      (?:' + Addr_Match.sec_unit + ')?\\W*          #fix2   \n\
         ' + Addr_Match.place + '                           \n\
      \\W*$', 'ix');
        var sep = '(?:\\W+|$)'; // no support for \Z
        Addr_Match.informal_address = XRegExp('                   \n\
      ^                                                       \n\
      \\s*                                                    \n\
      (?:' + Addr_Match.sec_unit + sep + ')?                        \n\
      (?:' + Addr_Match.number + ')?\\W*                          \n\
      (?:' + Addr_Match.fraction + '\\W*)?                        \n\
         ' + Addr_Match.street + sep + '                            \n\
      (?:' + Addr_Match.sec_unit.replace(/_\d/g, '$&1') + sep + ')?  \n\
      (?:' + Addr_Match.place + ')?                               \n\
      ', 'ix');
        Addr_Match.po_address = XRegExp('                         \n\
      ^                                                       \n\
      \\s*                                                    \n\
      (?:' + Addr_Match.sec_unit.replace(/_\d/g, '$&1') + sep + ')?  \n\
      (?:' + Addr_Match.place + ')?                               \n\
      ', 'ix');
        Addr_Match.intersection = XRegExp('                     \n\
      ^\\W*                                                 \n\
      ' + Addr_Match.street.replace(/_\d/g, '1$&') + '\\W*?      \n\
      \\s+' + Addr_Match.corner + '\\s+                         \n\
      ' + Addr_Match.street.replace(/_\d/g, '2$&') + '\\W+     \n\
      ' + Addr_Match.place + '\\W*$', 'ix');
    }
    parser.normalize_address = function(parts) {
        lazyInit();
        if (!parts) return null;
        var parsed = {};
        Object.keys(parts).forEach(function(k) {
            if ([
                'input',
                'index'
            ].indexOf(k) !== -1 || isFinite(k)) return;
            var key = isFinite(k.split('_').pop()) ? k.split('_').slice(0, -1).join('_') : k;
            if (parts[k]) parsed[key] = parts[k].trim().replace(/^\s+|\s+$|[^\w\s\-#&]/g, '');
        });
        each(Normalize_Map, function(map, key) {
            if (parsed[key] && map[parsed[key].toLowerCase()]) parsed[key] = map[parsed[key].toLowerCase()];
        });
        [
            'type',
            'type1',
            'type2'
        ].forEach(function(key) {
            if (key in parsed) parsed[key] = parsed[key].charAt(0).toUpperCase() + parsed[key].slice(1).toLowerCase();
        });
        if (parsed.city) parsed.city = XRegExp.replace(parsed.city, XRegExp('^(?<dircode>' + Addr_Match.dircode + ')\\s+(?=\\S)', 'ix'), function(match) {
            return capitalize(Direction_Code[match.dircode.toUpperCase()]) + ' ';
        });
        return parsed;
    };
    parser.parseAddress = function(address) {
        lazyInit();
        var parts = XRegExp.exec(address, Addr_Match.address);
        return parser.normalize_address(parts);
    };
    parser.parseInformalAddress = function(address) {
        lazyInit();
        var parts = XRegExp.exec(address, Addr_Match.informal_address);
        return parser.normalize_address(parts);
    };
    parser.parsePoAddress = function(address) {
        lazyInit();
        var parts = XRegExp.exec(address, Addr_Match.po_address);
        return parser.normalize_address(parts);
    };
    parser.parseLocation = function(address) {
        lazyInit();
        if (XRegExp(Addr_Match.corner, 'xi').test(address)) return parser.parseIntersection(address);
        if (XRegExp('^' + Addr_Match.po_box, 'xi').test(address)) return parser.parsePoAddress(address);
        return parser.parseAddress(address) || parser.parseInformalAddress(address);
    };
    parser.parseIntersection = function(address) {
        lazyInit();
        var parts = XRegExp.exec(address, Addr_Match.intersection);
        parts = parser.normalize_address(parts);
        if (parts) {
            parts.type2 = parts.type2 || '';
            parts.type1 = parts.type1 || '';
            if (parts.type2 && !parts.type1 || parts.type1 === parts.type2) {
                var type = parts.type2;
                type = XRegExp.replace(type, /s\W*$/, '');
                if (XRegExp('^' + Addr_Match.type + '$', 'ix').test(type)) parts.type1 = parts.type2 = type;
            }
        }
        return parts;
    };
    // AMD / RequireJS
    if (typeof define !== 'undefined' && define.amd) define([], function() {
        return parser;
    });
    else {
        $94abe10482943079$export$5939f39986f056a = parser.parseIntersection;
        $94abe10482943079$export$4909df247a32aad3 = parser.parseLocation;
        $94abe10482943079$export$6ca983ec4b6ffc57 = parser.parseInformalAddress;
        $94abe10482943079$export$6b5a4e2dc1897273 = parser.parseAddress;
    }
})();

});
parcelRegister("973rj", function(module, exports) {
/*!
 * XRegExp 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2007-2017 MIT License
 */ 'use strict';
/**
 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
 * make your client-side grepping simpler and more powerful, while freeing you from related
 * cross-browser inconsistencies.
 */ // ==--------------------------==
// Private stuff
// ==--------------------------==
// Property name used for extended regex instance data
var $6a276f81ec1bd7fa$var$REGEX_DATA = 'xregexp';
// Optional features that can be installed and uninstalled
var $6a276f81ec1bd7fa$var$features = {
    astral: false,
    natives: false
};
// Native methods to use and restore ('native' is an ES3 reserved keyword)
var $6a276f81ec1bd7fa$var$nativ = {
    exec: RegExp.prototype.exec,
    test: RegExp.prototype.test,
    match: String.prototype.match,
    replace: String.prototype.replace,
    split: String.prototype.split
};
// Storage for fixed/extended native methods
var $6a276f81ec1bd7fa$var$fixed = {};
// Storage for regexes cached by `XRegExp.cache`
var $6a276f81ec1bd7fa$var$regexCache = {};
// Storage for pattern details cached by the `XRegExp` constructor
var $6a276f81ec1bd7fa$var$patternCache = {};
// Storage for regex syntax tokens added internally or by `XRegExp.addToken`
var $6a276f81ec1bd7fa$var$tokens = [];
// Token scopes
var $6a276f81ec1bd7fa$var$defaultScope = 'default';
var $6a276f81ec1bd7fa$var$classScope = 'class';
// Regexes that match native regex syntax, including octals
var $6a276f81ec1bd7fa$var$nativeTokens = {
    // Any native multicharacter token in default scope, or any single character
    'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
    // Any native multicharacter token in character class scope, or any single character
    'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
};
// Any backreference or dollar-prefixed character in replacement strings
var $6a276f81ec1bd7fa$var$replacementToken = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
// Check for correct `exec` handling of nonparticipating capturing groups
var $6a276f81ec1bd7fa$var$correctExecNpcg = $6a276f81ec1bd7fa$var$nativ.exec.call(/()??/, '')[1] === undefined;
// Check for ES6 `flags` prop support
var $6a276f81ec1bd7fa$var$hasFlagsProp = /x/.flags !== undefined;
// Shortcut to `Object.prototype.toString`
var $6a276f81ec1bd7fa$var$toString = {}.toString;
function $6a276f81ec1bd7fa$var$hasNativeFlag(flag) {
    // Can't check based on the presence of properties/getters since browsers might support such
    // properties even when they don't support the corresponding flag in regex construction (tested
    // in Chrome 48, where `'unicode' in /x/` is true but trying to construct a regex with flag `u`
    // throws an error)
    var isSupported = true;
    try {
        // Can't use regex literals for testing even in a `try` because regex literals with
        // unsupported flags cause a compilation error in IE
        new RegExp('', flag);
    } catch (exception) {
        isSupported = false;
    }
    return isSupported;
}
// Check for ES6 `u` flag support
var $6a276f81ec1bd7fa$var$hasNativeU = $6a276f81ec1bd7fa$var$hasNativeFlag('u');
// Check for ES6 `y` flag support
var $6a276f81ec1bd7fa$var$hasNativeY = $6a276f81ec1bd7fa$var$hasNativeFlag('y');
// Tracker for known flags, including addon flags
var $6a276f81ec1bd7fa$var$registeredFlags = {
    g: true,
    i: true,
    m: true,
    u: $6a276f81ec1bd7fa$var$hasNativeU,
    y: $6a276f81ec1bd7fa$var$hasNativeY
};
/**
 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to augment.
 * @param {Array} captureNames Array with capture names, or `null`.
 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *   skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {RegExp} Augmented regex.
 */ function $6a276f81ec1bd7fa$var$augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
    var p;
    regex[$6a276f81ec1bd7fa$var$REGEX_DATA] = {
        captureNames: captureNames
    };
    if (isInternalOnly) return regex;
    // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
    if (regex.__proto__) regex.__proto__ = $6a276f81ec1bd7fa$var$XRegExp.prototype;
    else for(p in $6a276f81ec1bd7fa$var$XRegExp.prototype)// An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since this
    // is performance sensitive, and enumerable `Object.prototype` or `RegExp.prototype`
    // extensions exist on `regex.prototype` anyway
    regex[p] = $6a276f81ec1bd7fa$var$XRegExp.prototype[p];
    regex[$6a276f81ec1bd7fa$var$REGEX_DATA].source = xSource;
    // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
    regex[$6a276f81ec1bd7fa$var$REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;
    return regex;
}
/**
 * Removes any duplicate characters from the provided string.
 *
 * @private
 * @param {String} str String to remove duplicate characters from.
 * @returns {String} String with any duplicate characters removed.
 */ function $6a276f81ec1bd7fa$var$clipDuplicates(str) {
    return $6a276f81ec1bd7fa$var$nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
}
/**
 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
 * flags g and y while copying the regex.
 *
 * @private
 * @param {RegExp} regex Regex to copy.
 * @param {Object} [options] Options object with optional properties:
 *   - `addG` {Boolean} Add flag g while copying the regex.
 *   - `addY` {Boolean} Add flag y while copying the regex.
 *   - `removeG` {Boolean} Remove flag g while copying the regex.
 *   - `removeY` {Boolean} Remove flag y while copying the regex.
 *   - `isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *     skipping some operations like attaching `XRegExp.prototype` properties.
 *   - `source` {String} Overrides `<regex>.source`, for special cases.
 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
 */ function $6a276f81ec1bd7fa$var$copyRegex(regex, options) {
    if (!$6a276f81ec1bd7fa$var$XRegExp.isRegExp(regex)) throw new TypeError('Type RegExp expected');
    var xData = regex[$6a276f81ec1bd7fa$var$REGEX_DATA] || {};
    var flags = $6a276f81ec1bd7fa$var$getNativeFlags(regex);
    var flagsToAdd = '';
    var flagsToRemove = '';
    var xregexpSource = null;
    var xregexpFlags = null;
    options = options || {};
    if (options.removeG) flagsToRemove += 'g';
    if (options.removeY) flagsToRemove += 'y';
    if (flagsToRemove) flags = $6a276f81ec1bd7fa$var$nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
    if (options.addG) flagsToAdd += 'g';
    if (options.addY) flagsToAdd += 'y';
    if (flagsToAdd) flags = $6a276f81ec1bd7fa$var$clipDuplicates(flags + flagsToAdd);
    if (!options.isInternalOnly) {
        if (xData.source !== undefined) xregexpSource = xData.source;
        // null or undefined; don't want to add to `flags` if the previous value was null, since
        // that indicates we're not tracking original precompilation flags
        if (xData.flags != null) // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are never
        // removed for non-internal regexes, so don't need to handle it
        xregexpFlags = flagsToAdd ? $6a276f81ec1bd7fa$var$clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
    }
    // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to avoid
    // searching for special tokens. That would be wrong for regexes constructed by `RegExp`, and
    // unnecessary for regexes constructed by `XRegExp` because the regex has already undergone the
    // translation to native regex syntax
    regex = $6a276f81ec1bd7fa$var$augment(new RegExp(options.source || regex.source, flags), $6a276f81ec1bd7fa$var$hasNamedCapture(regex) ? xData.captureNames.slice(0) : null, xregexpSource, xregexpFlags, options.isInternalOnly);
    return regex;
}
/**
 * Converts hexadecimal to decimal.
 *
 * @private
 * @param {String} hex
 * @returns {Number}
 */ function $6a276f81ec1bd7fa$var$dec(hex) {
    return parseInt(hex, 16);
}
/**
 * Returns a pattern that can be used in a native RegExp in place of an ignorable token such as an
 * inline comment or whitespace with flag x. This is used directly as a token handler function
 * passed to `XRegExp.addToken`.
 *
 * @private
 * @param {String} match Match arg of `XRegExp.addToken` handler
 * @param {String} scope Scope arg of `XRegExp.addToken` handler
 * @param {String} flags Flags arg of `XRegExp.addToken` handler
 * @returns {String} Either '' or '(?:)', depending on which is needed in the context of the match.
 */ function $6a276f81ec1bd7fa$var$getContextualTokenSeparator(match, scope, flags) {
    if (// No need to separate tokens if at the beginning or end of a group
    match.input.charAt(match.index - 1) === '(' || match.input.charAt(match.index + match[0].length) === ')' || // Avoid separating tokens when the following token is a quantifier
    $6a276f81ec1bd7fa$var$isPatternNext(match.input, match.index + match[0].length, flags, '[?*+]|{\\d+(?:,\\d*)?}')) return '';
    // Keep tokens separated. This avoids e.g. inadvertedly changing `\1 1` or `\1(?#)1` to `\11`.
    // This also ensures all tokens remain as discrete atoms, e.g. it avoids converting the syntax
    // error `(? :` into `(?:`.
    return '(?:)';
}
/**
 * Returns native `RegExp` flags used by a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {String} Native flags in use.
 */ function $6a276f81ec1bd7fa$var$getNativeFlags(regex) {
    return $6a276f81ec1bd7fa$var$hasFlagsProp ? regex.flags : // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
    // with an empty string) allows this to continue working predictably when
    // `XRegExp.proptotype.toString` is overridden
    $6a276f81ec1bd7fa$var$nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
}
/**
 * Determines whether a regex has extended instance data used to track capture names.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {Boolean} Whether the regex uses named capture.
 */ function $6a276f81ec1bd7fa$var$hasNamedCapture(regex) {
    return !!(regex[$6a276f81ec1bd7fa$var$REGEX_DATA] && regex[$6a276f81ec1bd7fa$var$REGEX_DATA].captureNames);
}
/**
 * Converts decimal to hexadecimal.
 *
 * @private
 * @param {Number|String} dec
 * @returns {String}
 */ function $6a276f81ec1bd7fa$var$hex(dec) {
    return parseInt(dec, 10).toString(16);
}
/**
 * Returns the first index at which a given value can be found in an array.
 *
 * @private
 * @param {Array} array Array to search.
 * @param {*} value Value to locate in the array.
 * @returns {Number} Zero-based index at which the item is found, or -1.
 */ function $6a276f81ec1bd7fa$var$indexOf(array, value) {
    var len = array.length;
    var i;
    for(i = 0; i < len; ++i){
        if (array[i] === value) return i;
    }
    return -1;
}
/**
 * Checks whether the next nonignorable token after the specified position matches the
 * `needlePattern`
 *
 * @private
 * @param {String} pattern Pattern to search within.
 * @param {Number} pos Index in `pattern` to search at.
 * @param {String} flags Flags used by the pattern.
 * @param {String} needlePattern Pattern to match the next token against.
 * @returns {Boolean} Whether the next nonignorable token matches `needlePattern`
 */ function $6a276f81ec1bd7fa$var$isPatternNext(pattern, pos, flags, needlePattern) {
    var inlineCommentPattern = '\\(\\?#[^)]*\\)';
    var lineCommentPattern = '#[^#\\n]*';
    var patternsToIgnore = flags.indexOf('x') > -1 ? // Ignore any leading whitespace, line comments, and inline comments
    [
        '\\s',
        lineCommentPattern,
        inlineCommentPattern
    ] : // Ignore any leading inline comments
    [
        inlineCommentPattern
    ];
    return $6a276f81ec1bd7fa$var$nativ.test.call(new RegExp('^(?:' + patternsToIgnore.join('|') + ')*(?:' + needlePattern + ')'), pattern.slice(pos));
}
/**
 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
 *
 * @private
 * @param {*} value Object to check.
 * @param {String} type Type to check for, in TitleCase.
 * @returns {Boolean} Whether the object matches the type.
 */ function $6a276f81ec1bd7fa$var$isType(value, type) {
    return $6a276f81ec1bd7fa$var$toString.call(value) === '[object ' + type + ']';
}
/**
 * Adds leading zeros if shorter than four characters. Used for fixed-length hexadecimal values.
 *
 * @private
 * @param {String} str
 * @returns {String}
 */ function $6a276f81ec1bd7fa$var$pad4(str) {
    while(str.length < 4)str = '0' + str;
    return str;
}
/**
 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
 * the flag preparation logic from the `XRegExp` constructor.
 *
 * @private
 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
 * @param {String} flags Any combination of flags.
 * @returns {Object} Object with properties `pattern` and `flags`.
 */ function $6a276f81ec1bd7fa$var$prepareFlags(pattern, flags) {
    var i;
    // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
    if ($6a276f81ec1bd7fa$var$clipDuplicates(flags) !== flags) throw new SyntaxError('Invalid duplicate regex flag ' + flags);
    // Strip and apply a leading mode modifier with any combination of flags except g or y
    pattern = $6a276f81ec1bd7fa$var$nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function($0, $1) {
        if ($6a276f81ec1bd7fa$var$nativ.test.call(/[gy]/, $1)) throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
        // Allow duplicate flags within the mode modifier
        flags = $6a276f81ec1bd7fa$var$clipDuplicates(flags + $1);
        return '';
    });
    // Throw on unknown native or nonnative flags
    for(i = 0; i < flags.length; ++i){
        if (!$6a276f81ec1bd7fa$var$registeredFlags[flags.charAt(i)]) throw new SyntaxError('Unknown regex flag ' + flags.charAt(i));
    }
    return {
        pattern: pattern,
        flags: flags
    };
}
/**
 * Prepares an options object from the given value.
 *
 * @private
 * @param {String|Object} value Value to convert to an options object.
 * @returns {Object} Options object.
 */ function $6a276f81ec1bd7fa$var$prepareOptions(value) {
    var options = {};
    if ($6a276f81ec1bd7fa$var$isType(value, 'String')) {
        $6a276f81ec1bd7fa$var$XRegExp.forEach(value, /[^\s,]+/, function(match) {
            options[match] = true;
        });
        return options;
    }
    return value;
}
/**
 * Registers a flag so it doesn't throw an 'unknown flag' error.
 *
 * @private
 * @param {String} flag Single-character flag to register.
 */ function $6a276f81ec1bd7fa$var$registerFlag(flag) {
    if (!/^[\w$]$/.test(flag)) throw new Error('Flag must be a single character A-Za-z0-9_$');
    $6a276f81ec1bd7fa$var$registeredFlags[flag] = true;
}
/**
 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
 * position, until a match is found.
 *
 * @private
 * @param {String} pattern Original pattern from which an XRegExp object is being built.
 * @param {String} flags Flags being used to construct the regex.
 * @param {Number} pos Position to search for tokens within `pattern`.
 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
 * @param {Object} context Context object to use for token handler functions.
 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
 */ function $6a276f81ec1bd7fa$var$runTokens(pattern, flags, pos, scope, context) {
    var i = $6a276f81ec1bd7fa$var$tokens.length;
    var leadChar = pattern.charAt(pos);
    var result = null;
    var match;
    var t;
    // Run in reverse insertion order
    while(i--){
        t = $6a276f81ec1bd7fa$var$tokens[i];
        if (t.leadChar && t.leadChar !== leadChar || t.scope !== scope && t.scope !== 'all' || t.flag && flags.indexOf(t.flag) === -1) continue;
        match = $6a276f81ec1bd7fa$var$XRegExp.exec(pattern, t.regex, pos, 'sticky');
        if (match) {
            result = {
                matchLength: match[0].length,
                output: t.handler.call(context, match, scope, flags),
                reparse: t.reparse
            };
            break;
        }
    }
    return result;
}
/**
 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
 * the Unicode Base addon is not available, since flag A is registered by that addon.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */ function $6a276f81ec1bd7fa$var$setAstral(on) {
    $6a276f81ec1bd7fa$var$features.astral = on;
}
/**
 * Enables or disables native method overrides.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */ function $6a276f81ec1bd7fa$var$setNatives(on) {
    RegExp.prototype.exec = (on ? $6a276f81ec1bd7fa$var$fixed : $6a276f81ec1bd7fa$var$nativ).exec;
    RegExp.prototype.test = (on ? $6a276f81ec1bd7fa$var$fixed : $6a276f81ec1bd7fa$var$nativ).test;
    String.prototype.match = (on ? $6a276f81ec1bd7fa$var$fixed : $6a276f81ec1bd7fa$var$nativ).match;
    String.prototype.replace = (on ? $6a276f81ec1bd7fa$var$fixed : $6a276f81ec1bd7fa$var$nativ).replace;
    String.prototype.split = (on ? $6a276f81ec1bd7fa$var$fixed : $6a276f81ec1bd7fa$var$nativ).split;
    $6a276f81ec1bd7fa$var$features.natives = on;
}
/**
 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
 * the ES5 abstract operation `ToObject`.
 *
 * @private
 * @param {*} value Object to check and return.
 * @returns {*} The provided object.
 */ function $6a276f81ec1bd7fa$var$toObject(value) {
    // null or undefined
    if (value == null) throw new TypeError('Cannot convert null or undefined to object');
    return value;
}
// ==--------------------------==
// Constructor
// ==--------------------------==
/**
 * Creates an extended regular expression object for matching text with a pattern. Differs from a
 * native regular expression in that additional syntax and flags are supported. The returned object
 * is in fact a native `RegExp` and works with all native methods.
 *
 * @class XRegExp
 * @constructor
 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
 * @param {String} [flags] Any combination of flags.
 *   Native flags:
 *     - `g` - global
 *     - `i` - ignore case
 *     - `m` - multiline anchors
 *     - `u` - unicode (ES6)
 *     - `y` - sticky (Firefox 3+, ES6)
 *   Additional XRegExp flags:
 *     - `n` - explicit capture
 *     - `s` - dot matches all (aka singleline)
 *     - `x` - free-spacing and line comments (aka extended)
 *     - `A` - astral (requires the Unicode Base addon)
 *   Flags cannot be provided when constructing one `RegExp` from another.
 * @returns {RegExp} Extended regular expression object.
 * @example
 *
 * // With named capture and flag x
 * XRegExp('(?<year>  [0-9]{4} ) -?  # year  \n\
 *          (?<month> [0-9]{2} ) -?  # month \n\
 *          (?<day>   [0-9]{2} )     # day   ', 'x');
 *
 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
 * // have fresh `lastIndex` properties (set to zero).
 * XRegExp(/regex/);
 */ function $6a276f81ec1bd7fa$var$XRegExp(pattern, flags) {
    if ($6a276f81ec1bd7fa$var$XRegExp.isRegExp(pattern)) {
        if (flags !== undefined) throw new TypeError('Cannot supply flags when copying a RegExp');
        return $6a276f81ec1bd7fa$var$copyRegex(pattern);
    }
    // Copy the argument behavior of `RegExp`
    pattern = pattern === undefined ? '' : String(pattern);
    flags = flags === undefined ? '' : String(flags);
    if ($6a276f81ec1bd7fa$var$XRegExp.isInstalled('astral') && flags.indexOf('A') === -1) // This causes an error to be thrown if the Unicode Base addon is not available
    flags += 'A';
    if (!$6a276f81ec1bd7fa$var$patternCache[pattern]) $6a276f81ec1bd7fa$var$patternCache[pattern] = {};
    if (!$6a276f81ec1bd7fa$var$patternCache[pattern][flags]) {
        var context = {
            hasNamedCapture: false,
            captureNames: []
        };
        var scope = $6a276f81ec1bd7fa$var$defaultScope;
        var output = '';
        var pos = 0;
        var result;
        // Check for flag-related errors, and strip/apply flags in a leading mode modifier
        var applied = $6a276f81ec1bd7fa$var$prepareFlags(pattern, flags);
        var appliedPattern = applied.pattern;
        var appliedFlags = applied.flags;
        // Use XRegExp's tokens to translate the pattern to a native regex pattern.
        // `appliedPattern.length` may change on each iteration if tokens use `reparse`
        while(pos < appliedPattern.length){
            do {
                // Check for custom tokens at the current position
                result = $6a276f81ec1bd7fa$var$runTokens(appliedPattern, appliedFlags, pos, scope, context);
                // If the matched token used the `reparse` option, splice its output into the
                // pattern before running tokens again at the same position
                if (result && result.reparse) appliedPattern = appliedPattern.slice(0, pos) + result.output + appliedPattern.slice(pos + result.matchLength);
            }while (result && result.reparse);
            if (result) {
                output += result.output;
                pos += result.matchLength || 1;
            } else {
                // Get the native token at the current position
                var token = $6a276f81ec1bd7fa$var$XRegExp.exec(appliedPattern, $6a276f81ec1bd7fa$var$nativeTokens[scope], pos, 'sticky')[0];
                output += token;
                pos += token.length;
                if (token === '[' && scope === $6a276f81ec1bd7fa$var$defaultScope) scope = $6a276f81ec1bd7fa$var$classScope;
                else if (token === ']' && scope === $6a276f81ec1bd7fa$var$classScope) scope = $6a276f81ec1bd7fa$var$defaultScope;
            }
        }
        $6a276f81ec1bd7fa$var$patternCache[pattern][flags] = {
            // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
            // groups are sometimes inserted during regex transpilation in order to keep tokens
            // separated. However, more than one empty group in a row is never needed.
            pattern: $6a276f81ec1bd7fa$var$nativ.replace.call(output, /(?:\(\?:\))+/g, '(?:)'),
            // Strip all but native flags
            flags: $6a276f81ec1bd7fa$var$nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
            // `context.captureNames` has an item for each capturing group, even if unnamed
            captures: context.hasNamedCapture ? context.captureNames : null
        };
    }
    var generated = $6a276f81ec1bd7fa$var$patternCache[pattern][flags];
    return $6a276f81ec1bd7fa$var$augment(new RegExp(generated.pattern, generated.flags), generated.captures, pattern, flags);
}
// Add `RegExp.prototype` to the prototype chain
$6a276f81ec1bd7fa$var$XRegExp.prototype = new RegExp();
// ==--------------------------==
// Public properties
// ==--------------------------==
/**
 * The XRegExp version number as a string containing three dot-separated parts. For example,
 * '2.0.0-beta-3'.
 *
 * @static
 * @memberOf XRegExp
 * @type String
 */ $6a276f81ec1bd7fa$var$XRegExp.version = '3.2.0';
// ==--------------------------==
// Public methods
// ==--------------------------==
// Intentionally undocumented; used in tests and addons
$6a276f81ec1bd7fa$var$XRegExp._clipDuplicates = $6a276f81ec1bd7fa$var$clipDuplicates;
$6a276f81ec1bd7fa$var$XRegExp._hasNativeFlag = $6a276f81ec1bd7fa$var$hasNativeFlag;
$6a276f81ec1bd7fa$var$XRegExp._dec = $6a276f81ec1bd7fa$var$dec;
$6a276f81ec1bd7fa$var$XRegExp._hex = $6a276f81ec1bd7fa$var$hex;
$6a276f81ec1bd7fa$var$XRegExp._pad4 = $6a276f81ec1bd7fa$var$pad4;
/**
 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
 * create XRegExp addons. If more than one token can match the same string, the last added wins.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex object that matches the new token.
 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
 *   properties of the regex being built, through `this`. Invoked with three arguments:
 *   - The match array, with named backreference properties.
 *   - The regex scope where the match was found: 'default' or 'class'.
 *   - The flags used by the regex, including any flags in a leading mode modifier.
 *   The handler function becomes part of the XRegExp construction process, so be careful not to
 *   construct XRegExps within the function or you will trigger infinite recursion.
 * @param {Object} [options] Options object with optional properties:
 *   - `scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
 *   - `flag` {String} Single-character flag that triggers the token. This also registers the
 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
 *   - `optionalFlags` {String} Any custom flags checked for within the token `handler` that are
 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
 *     throwing an 'unknown flag' error when any of the flags are used.
 *   - `reparse` {Boolean} Whether the `handler` function's output should not be treated as
 *     final, and instead be reparseable by other tokens (including the current token). Allows
 *     token chaining or deferring.
 *   - `leadChar` {String} Single character that occurs at the beginning of any successful match
 *     of the token (not always applicable). This doesn't change the behavior of the token unless
 *     you provide an erroneous value. However, providing it can increase the token's performance
 *     since the token can be skipped at any positions where this character doesn't appear.
 * @example
 *
 * // Basic usage: Add \a for the ALERT control code
 * XRegExp.addToken(
 *   /\\a/,
 *   function() {return '\\x07';},
 *   {scope: 'all'}
 * );
 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
 *
 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
 * // character classes only)
 * XRegExp.addToken(
 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
 *   function(match) {return match[1] + (match[2] ? '' : '?');},
 *   {flag: 'U'}
 * );
 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken = function(regex, handler, options) {
    options = options || {};
    var optionalFlags = options.optionalFlags;
    var i;
    if (options.flag) $6a276f81ec1bd7fa$var$registerFlag(options.flag);
    if (optionalFlags) {
        optionalFlags = $6a276f81ec1bd7fa$var$nativ.split.call(optionalFlags, '');
        for(i = 0; i < optionalFlags.length; ++i)$6a276f81ec1bd7fa$var$registerFlag(optionalFlags[i]);
    }
    // Add to the private list of syntax tokens
    $6a276f81ec1bd7fa$var$tokens.push({
        regex: $6a276f81ec1bd7fa$var$copyRegex(regex, {
            addG: true,
            addY: $6a276f81ec1bd7fa$var$hasNativeY,
            isInternalOnly: true
        }),
        handler: handler,
        scope: options.scope || $6a276f81ec1bd7fa$var$defaultScope,
        flag: options.flag,
        reparse: options.reparse,
        leadChar: options.leadChar
    });
    // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and flags
    // might now produce different results
    $6a276f81ec1bd7fa$var$XRegExp.cache.flush('patterns');
};
/**
 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
 * the same pattern and flag combination, the cached copy of the regex is returned.
 *
 * @memberOf XRegExp
 * @param {String} pattern Regex pattern string.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Cached XRegExp object.
 * @example
 *
 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
 *   // The regex is compiled once only
 * }
 */ $6a276f81ec1bd7fa$var$XRegExp.cache = function(pattern, flags) {
    if (!$6a276f81ec1bd7fa$var$regexCache[pattern]) $6a276f81ec1bd7fa$var$regexCache[pattern] = {};
    return $6a276f81ec1bd7fa$var$regexCache[pattern][flags] || ($6a276f81ec1bd7fa$var$regexCache[pattern][flags] = $6a276f81ec1bd7fa$var$XRegExp(pattern, flags));
};
// Intentionally undocumented; used in tests
$6a276f81ec1bd7fa$var$XRegExp.cache.flush = function(cacheName) {
    if (cacheName === 'patterns') // Flush the pattern cache used by the `XRegExp` constructor
    $6a276f81ec1bd7fa$var$patternCache = {};
    else // Flush the regex cache populated by `XRegExp.cache`
    $6a276f81ec1bd7fa$var$regexCache = {};
};
/**
 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
 * can safely be used at any point within a regex that uses any flags.
 *
 * @memberOf XRegExp
 * @param {String} str String to escape.
 * @returns {String} String with regex metacharacters escaped.
 * @example
 *
 * XRegExp.escape('Escaped? <.>');
 * // -> 'Escaped\?\ <\.>'
 */ $6a276f81ec1bd7fa$var$XRegExp.escape = function(str) {
    return $6a276f81ec1bd7fa$var$nativ.replace.call($6a276f81ec1bd7fa$var$toObject(str), /[-\[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
/**
 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
 * regex uses named capture, named backreference properties are included on the match array.
 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
 * must start at the specified position only. The `lastIndex` property of the provided regex is not
 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.exec` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Array} Match array with named backreference properties, or `null`.
 * @example
 *
 * // Basic use, with named backreference
 * var match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
 * match.hex; // -> '2620'
 *
 * // With pos and sticky, in a loop
 * var pos = 2, result = [], match;
 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
 *   result.push(match[1]);
 *   pos = match.index + match[0].length;
 * }
 * // result -> ['2', '3', '4']
 */ $6a276f81ec1bd7fa$var$XRegExp.exec = function(str, regex, pos, sticky) {
    var cacheKey = 'g';
    var addY = false;
    var fakeY = false;
    var match;
    var r2;
    addY = $6a276f81ec1bd7fa$var$hasNativeY && !!(sticky || regex.sticky && sticky !== false);
    if (addY) cacheKey += 'y';
    else if (sticky) {
        // Simulate sticky matching by appending an empty capture to the original regex. The
        // resulting regex will succeed no matter what at the current index (set with `lastIndex`),
        // and will not search the rest of the subject string. We'll know that the original regex
        // has failed if that last capture is `''` rather than `undefined` (i.e., if that last
        // capture participated in the match).
        fakeY = true;
        cacheKey += 'FakeY';
    }
    regex[$6a276f81ec1bd7fa$var$REGEX_DATA] = regex[$6a276f81ec1bd7fa$var$REGEX_DATA] || {};
    // Shares cached copies with `XRegExp.match`/`replace`
    r2 = regex[$6a276f81ec1bd7fa$var$REGEX_DATA][cacheKey] || (regex[$6a276f81ec1bd7fa$var$REGEX_DATA][cacheKey] = $6a276f81ec1bd7fa$var$copyRegex(regex, {
        addG: true,
        addY: addY,
        source: fakeY ? regex.source + '|()' : undefined,
        removeY: sticky === false,
        isInternalOnly: true
    }));
    pos = pos || 0;
    r2.lastIndex = pos;
    // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
    match = $6a276f81ec1bd7fa$var$fixed.exec.call(r2, str);
    // Get rid of the capture added by the pseudo-sticky matcher if needed. An empty string means
    // the original regexp failed (see above).
    if (fakeY && match && match.pop() === '') match = null;
    if (regex.global) regex.lastIndex = match ? r2.lastIndex : 0;
    return match;
};
/**
 * Executes a provided function once per regex match. Searches always start at the beginning of the
 * string and continue until the end, regardless of the state of the regex's `global` property and
 * initial `lastIndex`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
 *   - The match array, with named backreference properties.
 *   - The zero-based match index.
 *   - The string being traversed.
 *   - The regex object being used to traverse the string.
 * @example
 *
 * // Extracts every other digit from a string
 * var evens = [];
 * XRegExp.forEach('1a2345', /\d/, function(match, i) {
 *   if (i % 2) evens.push(+match[0]);
 * });
 * // evens -> [2, 4]
 */ $6a276f81ec1bd7fa$var$XRegExp.forEach = function(str, regex, callback) {
    var pos = 0;
    var i = -1;
    var match;
    while(match = $6a276f81ec1bd7fa$var$XRegExp.exec(str, regex, pos)){
        // Because `regex` is provided to `callback`, the function could use the deprecated/
        // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since `XRegExp.exec`
        // doesn't use `lastIndex` to set the search position, this can't lead to an infinite loop,
        // at least. Actually, because of the way `XRegExp.exec` caches globalized versions of
        // regexes, mutating the regex will not have any effect on the iteration or matched strings,
        // which is a nice side effect that brings extra safety.
        callback(match, ++i, str, regex);
        pos = match.index + (match[0].length || 1);
    }
};
/**
 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
 * regexes are not recompiled using XRegExp syntax.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex to globalize.
 * @returns {RegExp} Copy of the provided regex with flag `g` added.
 * @example
 *
 * var globalCopy = XRegExp.globalize(/regex/);
 * globalCopy.global; // -> true
 */ $6a276f81ec1bd7fa$var$XRegExp.globalize = function(regex) {
    return $6a276f81ec1bd7fa$var$copyRegex(regex, {
        addG: true
    });
};
/**
 * Installs optional features according to the specified options. Can be undone using
 * `XRegExp.uninstall`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.install({
 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
 *   astral: true,
 *
 *   // DEPRECATED: Overrides native regex methods with fixed/extended versions
 *   natives: true
 * });
 *
 * // With an options string
 * XRegExp.install('astral natives');
 */ $6a276f81ec1bd7fa$var$XRegExp.install = function(options) {
    options = $6a276f81ec1bd7fa$var$prepareOptions(options);
    if (!$6a276f81ec1bd7fa$var$features.astral && options.astral) $6a276f81ec1bd7fa$var$setAstral(true);
    if (!$6a276f81ec1bd7fa$var$features.natives && options.natives) $6a276f81ec1bd7fa$var$setNatives(true);
};
/**
 * Checks whether an individual optional feature is installed.
 *
 * @memberOf XRegExp
 * @param {String} feature Name of the feature to check. One of:
 *   - `astral`
 *   - `natives`
 * @returns {Boolean} Whether the feature is installed.
 * @example
 *
 * XRegExp.isInstalled('astral');
 */ $6a276f81ec1bd7fa$var$XRegExp.isInstalled = function(feature) {
    return !!$6a276f81ec1bd7fa$var$features[feature];
};
/**
 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
 * created in another frame, when `instanceof` and `constructor` checks would fail.
 *
 * @memberOf XRegExp
 * @param {*} value Object to check.
 * @returns {Boolean} Whether the object is a `RegExp` object.
 * @example
 *
 * XRegExp.isRegExp('string'); // -> false
 * XRegExp.isRegExp(/regex/i); // -> true
 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
 */ $6a276f81ec1bd7fa$var$XRegExp.isRegExp = function(value) {
    return $6a276f81ec1bd7fa$var$toString.call(value) === '[object RegExp]';
//return isType(value, 'RegExp');
};
/**
 * Returns the first matched string, or in global mode, an array containing all matched strings.
 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
 * the result types you actually want (string instead of `exec`-style array in match-first mode,
 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
 *   `scope` is 'all'.
 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
 *   mode: Array of all matched strings, or an empty array.
 * @example
 *
 * // Match first
 * XRegExp.match('abc', /\w/); // -> 'a'
 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
 * XRegExp.match('abc', /x/g, 'one'); // -> null
 *
 * // Match all
 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /x/, 'all'); // -> []
 */ $6a276f81ec1bd7fa$var$XRegExp.match = function(str, regex, scope) {
    var global = regex.global && scope !== 'one' || scope === 'all';
    var cacheKey = (global ? 'g' : '') + (regex.sticky ? 'y' : '') || 'noGY';
    var result;
    var r2;
    regex[$6a276f81ec1bd7fa$var$REGEX_DATA] = regex[$6a276f81ec1bd7fa$var$REGEX_DATA] || {};
    // Shares cached copies with `XRegExp.exec`/`replace`
    r2 = regex[$6a276f81ec1bd7fa$var$REGEX_DATA][cacheKey] || (regex[$6a276f81ec1bd7fa$var$REGEX_DATA][cacheKey] = $6a276f81ec1bd7fa$var$copyRegex(regex, {
        addG: !!global,
        removeG: scope === 'one',
        isInternalOnly: true
    }));
    result = $6a276f81ec1bd7fa$var$nativ.match.call($6a276f81ec1bd7fa$var$toObject(str), r2);
    if (regex.global) regex.lastIndex = scope === 'one' && result ? // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
    result.index + result[0].length : 0;
    return global ? result || [] : result && result[0];
};
/**
 * Retrieves the matches from searching a string using a chain of regexes that successively search
 * within previous matches. The provided `chain` array can contain regexes and or objects with
 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
 * backreference is passed forward to the next regex or returned.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} chain Regexes that each search for matches within preceding results.
 * @returns {Array} Matches by the last regex in the chain, or an empty array.
 * @example
 *
 * // Basic usage; matches numbers within <b> tags
 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
 *   XRegExp('(?is)<b>.*?</b>'),
 *   /\d+/
 * ]);
 * // -> ['2', '4', '56']
 *
 * // Passing forward and returning specific backreferences
 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
 *         <a href="http://www.google.com/">Google</a>';
 * XRegExp.matchChain(html, [
 *   {regex: /<a href="([^"]+)">/i, backref: 1},
 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
 * ]);
 * // -> ['xregexp.com', 'www.google.com']
 */ $6a276f81ec1bd7fa$var$XRegExp.matchChain = function(str, chain) {
    return function recurseChain(values, level) {
        var item = chain[level].regex ? chain[level] : {
            regex: chain[level]
        };
        var matches = [];
        function addMatch(match) {
            if (item.backref) {
                // Safari 4.0.5 (but not 5.0.5+) inappropriately uses sparse arrays to hold the
                // `undefined`s for backreferences to nonparticipating capturing groups. In such
                // cases, a `hasOwnProperty` or `in` check on its own would inappropriately throw
                // the exception, so also check if the backreference is a number that is within the
                // bounds of the array.
                if (!(match.hasOwnProperty(item.backref) || +item.backref < match.length)) throw new ReferenceError('Backreference to undefined group: ' + item.backref);
                matches.push(match[item.backref] || '');
            } else matches.push(match[0]);
        }
        for(var i = 0; i < values.length; ++i)$6a276f81ec1bd7fa$var$XRegExp.forEach(values[i], item.regex, addMatch);
        return level === chain.length - 1 || !matches.length ? matches : recurseChain(matches, level + 1);
    }([
        str
    ], 0);
};
/**
 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
 * or regex, and the replacement can be a string or a function to be called for each match. To
 * perform a global search and replace, use the optional `scope` argument or include flag g if using
 * a regex. Replacement strings can use `${n}` for named and numbered backreferences. Replacement
 * functions can use named backreferences via `arguments[0].name`. Also fixes browser bugs compared
 * to the native `String.prototype.replace` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 *   Replacement strings can include special replacement syntax:
 *     - $$ - Inserts a literal $ character.
 *     - $&, $0 - Inserts the matched substring.
 *     - $` - Inserts the string that precedes the matched substring (left context).
 *     - $' - Inserts the string that follows the matched substring (right context).
 *     - $n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
 *       backreference n/nn.
 *     - ${n} - Where n is a name or any number of digits that reference an existent capturing
 *       group, inserts backreference n.
 *   Replacement functions are invoked with three or more arguments:
 *     - The matched substring (corresponds to $& above). Named backreferences are accessible as
 *       properties of this first argument.
 *     - 0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
 *     - The zero-based index of the match within the total search string.
 *     - The total string being searched.
 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
 * @returns {String} New string with one or all matches replaced.
 * @example
 *
 * // Regex search, using named backreferences in replacement string
 * var name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
 * XRegExp.replace('John Smith', name, '${last}, ${first}');
 * // -> 'Smith, John'
 *
 * // Regex search, using named backreferences in replacement function
 * XRegExp.replace('John Smith', name, function(match) {
 *   return match.last + ', ' + match.first;
 * });
 * // -> 'Smith, John'
 *
 * // String search, with replace-all
 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
 * // -> 'XRegExp builds XRegExps'
 */ $6a276f81ec1bd7fa$var$XRegExp.replace = function(str, search, replacement, scope) {
    var isRegex = $6a276f81ec1bd7fa$var$XRegExp.isRegExp(search);
    var global = search.global && scope !== 'one' || scope === 'all';
    var cacheKey = (global ? 'g' : '') + (search.sticky ? 'y' : '') || 'noGY';
    var s2 = search;
    var result;
    if (isRegex) {
        search[$6a276f81ec1bd7fa$var$REGEX_DATA] = search[$6a276f81ec1bd7fa$var$REGEX_DATA] || {};
        // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
        // `lastIndex` isn't updated *during* replacement iterations
        s2 = search[$6a276f81ec1bd7fa$var$REGEX_DATA][cacheKey] || (search[$6a276f81ec1bd7fa$var$REGEX_DATA][cacheKey] = $6a276f81ec1bd7fa$var$copyRegex(search, {
            addG: !!global,
            removeG: scope === 'one',
            isInternalOnly: true
        }));
    } else if (global) s2 = new RegExp($6a276f81ec1bd7fa$var$XRegExp.escape(String(search)), 'g');
    // Fixed `replace` required for named backreferences, etc.
    result = $6a276f81ec1bd7fa$var$fixed.replace.call($6a276f81ec1bd7fa$var$toObject(str), s2, replacement);
    if (isRegex && search.global) // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
    search.lastIndex = 0;
    return result;
};
/**
 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
 * array of replacement details. Later replacements operate on the output of earlier replacements.
 * Replacement details are accepted as an array with a regex or string to search for, the
 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
 * replacement text syntax, which supports named backreference properties via `${name}`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} replacements Array of replacement detail arrays.
 * @returns {String} New string with all replacements.
 * @example
 *
 * str = XRegExp.replaceEach(str, [
 *   [XRegExp('(?<name>a)'), 'z${name}'],
 *   [/b/gi, 'y'],
 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
 *   [/f/g, function($0) {
 *     return $0.toUpperCase();
 *   }]
 * ]);
 */ $6a276f81ec1bd7fa$var$XRegExp.replaceEach = function(str, replacements) {
    var i;
    var r;
    for(i = 0; i < replacements.length; ++i){
        r = replacements[i];
        str = $6a276f81ec1bd7fa$var$XRegExp.replace(str, r[0], r[1], r[2]);
    }
    return str;
};
/**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * XRegExp.split('a b c', ' ');
 * // -> ['a', 'b', 'c']
 *
 * // With limit
 * XRegExp.split('a b c', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', '..']
 */ $6a276f81ec1bd7fa$var$XRegExp.split = function(str, separator, limit) {
    return $6a276f81ec1bd7fa$var$fixed.split.call($6a276f81ec1bd7fa$var$toObject(str), separator, limit);
};
/**
 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
 * `sticky` arguments specify the search start position, and whether the match must start at the
 * specified position only. The `lastIndex` property of the provided regex is not used, but is
 * updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.test` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Boolean} Whether the regex matched the provided value.
 * @example
 *
 * // Basic use
 * XRegExp.test('abc', /c/); // -> true
 *
 * // With pos and sticky
 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
 */ $6a276f81ec1bd7fa$var$XRegExp.test = function(str, regex, pos, sticky) {
    // Do this the easy way :-)
    return !!$6a276f81ec1bd7fa$var$XRegExp.exec(str, regex, pos, sticky);
};
/**
 * Uninstalls optional features according to the specified options. All optional features start out
 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.uninstall({
 *   // Disables support for astral code points in Unicode addons
 *   astral: true,
 *
 *   // DEPRECATED: Restores native regex methods
 *   natives: true
 * });
 *
 * // With an options string
 * XRegExp.uninstall('astral natives');
 */ $6a276f81ec1bd7fa$var$XRegExp.uninstall = function(options) {
    options = $6a276f81ec1bd7fa$var$prepareOptions(options);
    if ($6a276f81ec1bd7fa$var$features.astral && options.astral) $6a276f81ec1bd7fa$var$setAstral(false);
    if ($6a276f81ec1bd7fa$var$features.natives && options.natives) $6a276f81ec1bd7fa$var$setNatives(false);
};
/**
 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
 * Backreferences in provided regex objects are automatically renumbered to work correctly within
 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
 * `flags` argument.
 *
 * @memberOf XRegExp
 * @param {Array} patterns Regexes and strings to combine.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @param {Object} [options] Options object with optional properties:
 *   - `conjunction` {String} Type of conjunction to use: 'or' (default) or 'none'.
 * @returns {RegExp} Union of the provided regexes and strings.
 * @example
 *
 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
 *
 * XRegExp.union([/man/, /bear/, /pig/], 'i', {conjunction: 'none'});
 * // -> /manbearpig/i
 */ $6a276f81ec1bd7fa$var$XRegExp.union = function(patterns, flags, options) {
    options = options || {};
    var conjunction = options.conjunction || 'or';
    var numCaptures = 0;
    var numPriorCaptures;
    var captureNames;
    function rewrite(match, paren, backref) {
        var name = captureNames[numCaptures - numPriorCaptures];
        // Capturing group
        if (paren) {
            ++numCaptures;
            // If the current capture has a name, preserve the name
            if (name) return '(?<' + name + '>';
        // Backreference
        } else if (backref) // Rewrite the backreference
        return '\\' + (+backref + numPriorCaptures);
        return match;
    }
    if (!($6a276f81ec1bd7fa$var$isType(patterns, 'Array') && patterns.length)) throw new TypeError('Must provide a nonempty array of patterns to merge');
    var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var output = [];
    var pattern;
    for(var i = 0; i < patterns.length; ++i){
        pattern = patterns[i];
        if ($6a276f81ec1bd7fa$var$XRegExp.isRegExp(pattern)) {
            numPriorCaptures = numCaptures;
            captureNames = pattern[$6a276f81ec1bd7fa$var$REGEX_DATA] && pattern[$6a276f81ec1bd7fa$var$REGEX_DATA].captureNames || [];
            // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns are
            // independently valid; helps keep this simple. Named captures are put back
            output.push($6a276f81ec1bd7fa$var$nativ.replace.call($6a276f81ec1bd7fa$var$XRegExp(pattern.source).source, parts, rewrite));
        } else output.push($6a276f81ec1bd7fa$var$XRegExp.escape(pattern));
    }
    var separator = conjunction === 'none' ? '' : '|';
    return $6a276f81ec1bd7fa$var$XRegExp(output.join(separator), flags);
};
// ==--------------------------==
// Fixed/extended native methods
// ==--------------------------==
/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `RegExp.prototype.exec`. Calling `XRegExp.install('natives')` uses this to
 * override the native method. Use via `XRegExp.exec` without overriding natives.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Array} Match array with named backreference properties, or `null`.
 */ $6a276f81ec1bd7fa$var$fixed.exec = function(str) {
    var origLastIndex = this.lastIndex;
    var match = $6a276f81ec1bd7fa$var$nativ.exec.apply(this, arguments);
    var name;
    var r2;
    var i;
    if (match) {
        // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating capturing
        // groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of older IEs. IE 9
        // in standards mode follows the spec.
        if (!$6a276f81ec1bd7fa$var$correctExecNpcg && match.length > 1 && $6a276f81ec1bd7fa$var$indexOf(match, '') > -1) {
            r2 = $6a276f81ec1bd7fa$var$copyRegex(this, {
                removeG: true,
                isInternalOnly: true
            });
            // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
            // matching due to characters outside the match
            $6a276f81ec1bd7fa$var$nativ.replace.call(String(str).slice(match.index), r2, function() {
                var len = arguments.length;
                var i;
                // Skip index 0 and the last 2
                for(i = 1; i < len - 2; ++i)if (arguments[i] === undefined) match[i] = undefined;
            });
        }
        // Attach named capture properties
        if (this[$6a276f81ec1bd7fa$var$REGEX_DATA] && this[$6a276f81ec1bd7fa$var$REGEX_DATA].captureNames) // Skip index 0
        for(i = 1; i < match.length; ++i){
            name = this[$6a276f81ec1bd7fa$var$REGEX_DATA].captureNames[i - 1];
            if (name) match[name] = match[i];
        }
        // Fix browsers that increment `lastIndex` after zero-length matches
        if (this.global && !match[0].length && this.lastIndex > match.index) this.lastIndex = match.index;
    }
    if (!this.global) // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
    this.lastIndex = origLastIndex;
    return match;
};
/**
 * Fixes browser bugs in the native `RegExp.prototype.test`. Calling `XRegExp.install('natives')`
 * uses this to override the native method.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Boolean} Whether the regex matched the provided value.
 */ $6a276f81ec1bd7fa$var$fixed.test = function(str) {
    // Do this the easy way :-)
    return !!$6a276f81ec1bd7fa$var$fixed.exec.call(this, str);
};
/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `String.prototype.match`. Calling `XRegExp.install('natives')` uses this to
 * override the native method.
 *
 * @memberOf String
 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
 *   the result of calling `regex.exec(this)`.
 */ $6a276f81ec1bd7fa$var$fixed.match = function(regex) {
    var result;
    if (!$6a276f81ec1bd7fa$var$XRegExp.isRegExp(regex)) // Use the native `RegExp` rather than `XRegExp`
    regex = new RegExp(regex);
    else if (regex.global) {
        result = $6a276f81ec1bd7fa$var$nativ.match.apply(this, arguments);
        // Fixes IE bug
        regex.lastIndex = 0;
        return result;
    }
    return $6a276f81ec1bd7fa$var$fixed.exec.call(regex, $6a276f81ec1bd7fa$var$toObject(this));
};
/**
 * Adds support for `${n}` tokens for named and numbered backreferences in replacement text, and
 * provides named backreferences to replacement functions as `arguments[0].name`. Also fixes browser
 * bugs in replacement text syntax when performing a replacement using a nonregex search value, and
 * the value of a replacement regex's `lastIndex` property during replacement iterations and upon
 * completion. Calling `XRegExp.install('natives')` uses this to override the native method. Note
 * that this doesn't support SpiderMonkey's proprietary third (`flags`) argument. Use via
 * `XRegExp.replace` without overriding natives.
 *
 * @memberOf String
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 * @returns {String} New string with one or all matches replaced.
 */ $6a276f81ec1bd7fa$var$fixed.replace = function(search, replacement) {
    var isRegex = $6a276f81ec1bd7fa$var$XRegExp.isRegExp(search);
    var origLastIndex;
    var captureNames;
    var result;
    if (isRegex) {
        if (search[$6a276f81ec1bd7fa$var$REGEX_DATA]) captureNames = search[$6a276f81ec1bd7fa$var$REGEX_DATA].captureNames;
        // Only needed if `search` is nonglobal
        origLastIndex = search.lastIndex;
    } else search += ''; // Type-convert
    // Don't use `typeof`; some older browsers return 'function' for regex objects
    if ($6a276f81ec1bd7fa$var$isType(replacement, 'Function')) // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
    // functions isn't type-converted to a string
    result = $6a276f81ec1bd7fa$var$nativ.replace.call(String(this), search, function() {
        var args = arguments;
        var i;
        if (captureNames) {
            // Change the `arguments[0]` string primitive to a `String` object that can store
            // properties. This really does need to use `String` as a constructor
            args[0] = new String(args[0]);
            // Store named backreferences on the first argument
            for(i = 0; i < captureNames.length; ++i)if (captureNames[i]) args[0][captureNames[i]] = args[i + 1];
        }
        // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox, Safari
        // bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
        if (isRegex && search.global) search.lastIndex = args[args.length - 2] + args[0].length;
        // ES6 specs the context for replacement functions as `undefined`
        return replacement.apply(undefined, args);
    });
    else // Ensure that the last value of `args` will be a string when given nonstring `this`,
    // while still throwing on null or undefined context
    result = $6a276f81ec1bd7fa$var$nativ.replace.call(this == null ? this : String(this), search, function() {
        // Keep this function's `arguments` available through closure
        var args = arguments;
        return $6a276f81ec1bd7fa$var$nativ.replace.call(String(replacement), $6a276f81ec1bd7fa$var$replacementToken, function($0, $1, $2) {
            var n;
            // Named or numbered backreference with curly braces
            if ($1) {
                // XRegExp behavior for `${n}`:
                // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for the
                //    entire match. Any number of leading zeros may be used.
                // 2. Backreference to named capture `n`, if it exists and is not an integer
                //    overridden by numbered capture. In practice, this does not overlap with
                //    numbered capture since XRegExp does not allow named capture to use a bare
                //    integer as the name.
                // 3. If the name or number does not refer to an existing capturing group, it's
                //    an error.
                n = +$1; // Type-convert; drop leading zeros
                if (n <= args.length - 3) return args[n] || '';
                // Groups with the same name is an error, else would need `lastIndexOf`
                n = captureNames ? $6a276f81ec1bd7fa$var$indexOf(captureNames, $1) : -1;
                if (n < 0) throw new SyntaxError('Backreference to undefined group ' + $0);
                return args[n + 1] || '';
            }
            // Else, special variable or numbered backreference without curly braces
            if ($2 === '$') return '$';
            if ($2 === '&' || +$2 === 0) return args[0];
            if ($2 === '`') return args[args.length - 1].slice(0, args[args.length - 2]);
            if ($2 === "'") return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
            // Else, numbered backreference without curly braces
            $2 = +$2; // Type-convert; drop leading zero
            // XRegExp behavior for `$n` and `$nn`:
            // - Backrefs end after 1 or 2 digits. Use `${..}` for more digits.
            // - `$1` is an error if no capturing groups.
            // - `$10` is an error if less than 10 capturing groups. Use `${1}0` instead.
            // - `$01` is `$1` if at least one capturing group, else it's an error.
            // - `$0` (not followed by 1-9) and `$00` are the entire match.
            // Native behavior, for comparison:
            // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
            // - `$1` is a literal `$1` if no capturing groups.
            // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
            // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
            // - `$0` is a literal `$0`.
            if (!isNaN($2)) {
                if ($2 > args.length - 3) throw new SyntaxError('Backreference to undefined group ' + $0);
                return args[$2] || '';
            }
            // `$` followed by an unsupported char is an error, unlike native JS
            throw new SyntaxError('Invalid token ' + $0);
        });
    });
    if (isRegex) {
        if (search.global) // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
        search.lastIndex = 0;
        else // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
        search.lastIndex = origLastIndex;
    }
    return result;
};
/**
 * Fixes browser bugs in the native `String.prototype.split`. Calling `XRegExp.install('natives')`
 * uses this to override the native method. Use via `XRegExp.split` without overriding natives.
 *
 * @memberOf String
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 */ $6a276f81ec1bd7fa$var$fixed.split = function(separator, limit) {
    if (!$6a276f81ec1bd7fa$var$XRegExp.isRegExp(separator)) // Browsers handle nonregex split correctly, so use the faster native method
    return $6a276f81ec1bd7fa$var$nativ.split.apply(this, arguments);
    var str = String(this);
    var output = [];
    var origLastIndex = separator.lastIndex;
    var lastLastIndex = 0;
    var lastLength;
    // Values for `limit`, per the spec:
    // If undefined: pow(2,32) - 1
    // If 0, Infinity, or NaN: 0
    // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
    // If negative number: pow(2,32) - floor(abs(limit))
    // If other: Type-convert, then use the above rules
    // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63, unless
    // Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
    limit = (limit === undefined ? -1 : limit) >>> 0;
    $6a276f81ec1bd7fa$var$XRegExp.forEach(str, separator, function(match) {
        // This condition is not the same as `if (match[0].length)`
        if (match.index + match[0].length > lastLastIndex) {
            output.push(str.slice(lastLastIndex, match.index));
            if (match.length > 1 && match.index < str.length) Array.prototype.push.apply(output, match.slice(1));
            lastLength = match[0].length;
            lastLastIndex = match.index + lastLength;
        }
    });
    if (lastLastIndex === str.length) {
        if (!$6a276f81ec1bd7fa$var$nativ.test.call(separator, '') || lastLength) output.push('');
    } else output.push(str.slice(lastLastIndex));
    separator.lastIndex = origLastIndex;
    return output.length > limit ? output.slice(0, limit) : output;
};
// ==--------------------------==
// Built-in syntax/flag tokens
// ==--------------------------==
/*
 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
 * consistency and to reserve their syntax, but lets them be superseded by addons.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function(match, scope) {
    // \B is allowed in default scope only
    if (match[1] === 'B' && scope === $6a276f81ec1bd7fa$var$defaultScope) return match[0];
    throw new SyntaxError('Invalid escape ' + match[0]);
}, {
    scope: 'all',
    leadChar: '\\'
});
/*
 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
 * if you use the same in a character class.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\\u{([\dA-Fa-f]+)}/, function(match, scope, flags) {
    var code = $6a276f81ec1bd7fa$var$dec(match[1]);
    if (code > 0x10FFFF) throw new SyntaxError('Invalid Unicode code point ' + match[0]);
    if (code <= 0xFFFF) // Converting to \uNNNN avoids needing to escape the literal character and keep it
    // separate from preceding tokens
    return '\\u' + $6a276f81ec1bd7fa$var$pad4($6a276f81ec1bd7fa$var$hex(code));
    // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
    if ($6a276f81ec1bd7fa$var$hasNativeU && flags.indexOf('u') > -1) return match[0];
    throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
}, {
    scope: 'all',
    leadChar: '\\'
});
/*
 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
 * character class endings can't be determined.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\[(\^?)\]/, function(match) {
    // For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
    // (?!) should work like \b\B, but is unreliable in some versions of Firefox
    return match[1] ? '[\\s\\S]' : '\\b\\B';
}, {
    leadChar: '['
});
/*
 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
 * free-spacing mode (flag x).
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\(\?#[^)]*\)/, $6a276f81ec1bd7fa$var$getContextualTokenSeparator, {
    leadChar: '('
});
/*
 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\s+|#[^\n]*\n?/, $6a276f81ec1bd7fa$var$getContextualTokenSeparator, {
    flag: 'x'
});
/*
 * Dot, in dotall mode (aka singleline mode, flag s) only.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\./, function() {
    return '[\\s\\S]';
}, {
    flag: 's',
    leadChar: '.'
});
/*
 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
 * and $ only. Also allows numbered backreferences as `\k<n>`.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\\k<([\w$]+)>/, function(match) {
    // Groups with the same name is an error, else would need `lastIndexOf`
    var index = isNaN(match[1]) ? $6a276f81ec1bd7fa$var$indexOf(this.captureNames, match[1]) + 1 : +match[1];
    var endIndex = match.index + match[0].length;
    if (!index || index > this.captureNames.length) throw new SyntaxError('Backreference to undefined group ' + match[0]);
    // Keep backreferences separate from subsequent literal numbers. This avoids e.g.
    // inadvertedly changing `(?<n>)\k<n>1` to `()\11`.
    return '\\' + index + (endIndex === match.input.length || isNaN(match.input.charAt(endIndex)) ? '' : '(?:)');
}, {
    leadChar: '\\'
});
/*
 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\\(\d+)/, function(match, scope) {
    if (!(scope === $6a276f81ec1bd7fa$var$defaultScope && /^[1-9]/.test(match[1]) && +match[1] <= this.captureNames.length) && match[1] !== '0') throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' + match[0]);
    return match[0];
}, {
    scope: 'all',
    leadChar: '\\'
});
/*
 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
 * Python-style named capture as octals.
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\(\?P?<([\w$]+)>/, function(match) {
    // Disallow bare integers as names because named backreferences are added to match arrays
    // and therefore numeric properties may lead to incorrect lookups
    if (!isNaN(match[1])) throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
    if (match[1] === 'length' || match[1] === '__proto__') throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
    if ($6a276f81ec1bd7fa$var$indexOf(this.captureNames, match[1]) > -1) throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
    this.captureNames.push(match[1]);
    this.hasNamedCapture = true;
    return '(';
}, {
    leadChar: '('
});
/*
 * Capturing group; match the opening parenthesis only. Required for support of named capturing
 * groups. Also adds explicit capture mode (flag n).
 */ $6a276f81ec1bd7fa$var$XRegExp.addToken(/\((?!\?)/, function(match, scope, flags) {
    if (flags.indexOf('n') > -1) return '(?:';
    this.captureNames.push(null);
    return '(';
}, {
    optionalFlags: 'n',
    leadChar: '('
});
module.exports = $6a276f81ec1bd7fa$var$XRegExp;

});


parcelRegister("gtf2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfdb0558b5959256$export$2e2bcd8739ae039);
var $bfdb0558b5959256$export$2e2bcd8739ae039 = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
};

});

parcelRegister("gLZWn", function(module, exports) {

$parcel$export(module.exports, "getCarrierName", () => $1f83e5e3c75dc83b$export$b9a4b09b3485b5b4);
// Note: this is for rapid prototyping and might be not be accurate, and certainly isn't compleete.
const $1f83e5e3c75dc83b$var$carrierCodes = [
    {
        'name': 'Vodafone UK',
        'country': 'UK',
        'prefix': '894410',
        'codes': [
            '23415'
        ]
    },
    {
        'name': 'Orange UK',
        'country': 'UK',
        'prefix': '894412',
        'codes': [
            '23433'
        ]
    },
    {
        'name': '3 UK',
        'country': 'UK',
        'prefix': '894420',
        'codes': [
            '23420'
        ]
    },
    {
        'name': 'T-Mobile UK',
        'country': 'UK',
        'prefix': '894430',
        'codes': [
            '23430'
        ]
    },
    {
        'name': 'Telstra',
        'country': 'Australia',
        'prefix': '50501',
        'codes': [
            '01'
        ]
    },
    {
        'name': 'Optus',
        'country': 'Australia',
        'prefix': '50502',
        'codes': [
            '02'
        ]
    },
    {
        'name': 'Vodafone AU',
        'country': 'Australia',
        'prefix': '50503',
        'codes': [
            '03'
        ]
    },
    {
        'name': 'Singtel',
        'country': 'Singapore',
        'prefix': '52501',
        'codes': [
            '01'
        ]
    },
    {
        'name': 'StarHub',
        'country': 'Singapore',
        'prefix': '52505',
        'codes': [
            '05'
        ]
    },
    {
        'name': 'M1',
        'country': 'Singapore',
        'prefix': '52503',
        'codes': [
            '03'
        ]
    },
    {
        'name': 'NTT Docomo',
        'country': 'Japan',
        'prefix': '44010',
        'codes': [
            '10'
        ]
    },
    {
        'name': 'SoftBank',
        'country': 'Japan',
        'prefix': '44020',
        'codes': [
            '20'
        ]
    },
    {
        'name': 'KDDI',
        'country': 'Japan',
        'prefix': '44050',
        'codes': [
            '50'
        ]
    },
    {
        'name': 'AT&T',
        'country': 'US',
        'prefix': '8901',
        'codes': [
            '030',
            '280',
            '150',
            '170',
            '410',
            '560',
            '680'
        ]
    },
    {
        'name': 'T-Mobile',
        'country': 'US',
        'prefix': '8901',
        'codes': [
            '026',
            '160',
            '260',
            '490'
        ]
    },
    {
        'name': 'Verizon',
        'country': 'US',
        'prefix': '8914',
        'codes': [
            '004',
            '005',
            '012',
            '480'
        ]
    }
];
const $1f83e5e3c75dc83b$export$b9a4b09b3485b5b4 = (code)=>{
    const matchPrefix = $1f83e5e3c75dc83b$var$carrierCodes.find((obj)=>obj.prefix == code);
    const matchMNC = $1f83e5e3c75dc83b$var$carrierCodes.find((obj)=>obj.codes.includes(code.slice(3)));
    if (matchPrefix) return matchPrefix.name;
    else if (matchMNC) return matchMNC.name;
    else return code;
};

});

parcelRegister("ecxdi", function(module, exports) {

$parcel$export(module.exports, "getUserDetails", () => $21719d77ae23744e$export$714d3544202969b);
$parcel$export(module.exports, "getUserInfo", () => $21719d77ae23744e$export$801fe16824f675f7);
$parcel$export(module.exports, "saveUserInfo", () => $21719d77ae23744e$export$37e6de009881572c);
$parcel$export(module.exports, "saveSSHKey", () => $21719d77ae23744e$export$541170bb7a77c086);
$parcel$export(module.exports, "listMyNodes", () => $21719d77ae23744e$export$27f0a0a880259727);
$parcel$export(module.exports, "listMyProjects", () => $21719d77ae23744e$export$bc2eb9816a46cb42);
$parcel$export(module.exports, "listNodesWithPerm", () => $21719d77ae23744e$export$3315e516a066df08);
$parcel$export(module.exports, "hasCapability", () => $21719d77ae23744e$export$c76adb160242209c);
$parcel$export(module.exports, "getAllocationFormData", () => $21719d77ae23744e$export$a5975d5d8474d62f);

var $gZwVy = parcelRequire("gZwVy");

var $c3pId = parcelRequire("c3pId");
const $21719d77ae23744e$var$url = (0, $gZwVy.default).auth;
const $21719d77ae23744e$var$user = (0, $c3pId.default).user;
const $21719d77ae23744e$var$__token = (0, $c3pId.default).token;
const $21719d77ae23744e$var$options = {
    headers: $21719d77ae23744e$var$__token ? {
        Authorization: `sage ${$21719d77ae23744e$var$__token}`
    } : {}
};
function $21719d77ae23744e$var$handleErrors(res) {
    if (res.ok) return res;
    return res.json().then((errorObj)=>{
        // todo(nc): suggest a generic error handling on api
        throw Error(errorObj.detail);
    });
}
function $21719d77ae23744e$var$get(endpoint) {
    return fetch(endpoint, $21719d77ae23744e$var$options).then($21719d77ae23744e$var$handleErrors).then((res)=>res.json());
}
function $21719d77ae23744e$var$put(endpoint, data) {
    const putOptions = {
        'headers': {
            ...$21719d77ae23744e$var$options.headers,
            'Content-Type': 'application/json'
        },
        'method': 'PUT',
        'body': JSON.stringify(data)
    };
    return fetch(endpoint, putOptions).then($21719d77ae23744e$var$handleErrors).then((res)=>res.json());
}
function $21719d77ae23744e$export$714d3544202969b() {
    if (!$21719d77ae23744e$var$user) return new Promise((_, reject)=>{
        reject(Error('getUserDetails: no user available'));
    });
    return $21719d77ae23744e$var$get(`${$21719d77ae23744e$var$url}/users/${$21719d77ae23744e$var$user}`);
}
function $21719d77ae23744e$export$801fe16824f675f7() {
    return Promise.all([
        $21719d77ae23744e$export$714d3544202969b(),
        $21719d77ae23744e$var$get(`${$21719d77ae23744e$var$url}/user_profile/${$21719d77ae23744e$var$user}`)
    ]).then(([user, profile])=>({
            ...user,
            ...profile
        }));
}
function $21719d77ae23744e$export$37e6de009881572c(state) {
    return $21719d77ae23744e$var$put(`${$21719d77ae23744e$var$url}/user_profile/${$21719d77ae23744e$var$user}`, state);
}
function $21719d77ae23744e$export$541170bb7a77c086(state) {
    return $21719d77ae23744e$var$put(`${$21719d77ae23744e$var$url}/user_profile/${$21719d77ae23744e$var$user}`, state);
}
async function $21719d77ae23744e$export$27f0a0a880259727() {
    // just return nothing if not actually logged in
    if (!$21719d77ae23744e$var$user) return [];
    // return empty list if request can't be made
    let data;
    try {
        data = await $21719d77ae23744e$var$get(`${$21719d77ae23744e$var$url}/users/${$21719d77ae23744e$var$user}/access`);
    } catch (e) {
        return [];
    }
    data = data.map((obj)=>({
            ...obj,
            schedule: obj.access.includes('schedule'),
            develop: obj.access.includes('develop')
        }));
    return data;
}
async function $21719d77ae23744e$export$bc2eb9816a46cb42() {
    const data = await $21719d77ae23744e$var$get(`${$21719d77ae23744e$var$url}/users/${$21719d77ae23744e$var$user}/projects`);
    return data;
}
async function $21719d77ae23744e$export$3315e516a066df08(perm) {
    const nodes = await $21719d77ae23744e$export$27f0a0a880259727();
    return nodes.filter((obj)=>obj[perm]).map((obj)=>obj.vsn);
}
async function $21719d77ae23744e$export$c76adb160242209c(perm) {
    const perms = Array.isArray(perm) ? perm : [
        perm
    ];
    const nodes = await $21719d77ae23744e$export$27f0a0a880259727();
    const nodesWithSomePerm = perms.flatMap((perm)=>nodes.filter((obj)=>obj[perm]).map((obj)=>obj.vsn));
    return nodesWithSomePerm.length > 0;
}
async function $21719d77ae23744e$export$4afcfbb1824571e4() {
    const data = await $21719d77ae23744e$var$get(`${$21719d77ae23744e$var$url}/projects`);
    return data;
}
async function $21719d77ae23744e$export$a5975d5d8474d62f() {
    const data = await $21719d77ae23744e$var$get(`${$21719d77ae23744e$var$url}/allocation-requests/form-data/`);
    return data;
}

});


parcelRegister("eAebc", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a9df6d45ae184583$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9df6d45ae184583$var$_createSvgIcon = $a9df6d45ae184583$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a9df6d45ae184583$var$_default = module.exports.default = (0, $a9df6d45ae184583$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47"
}), 'HelpOutlineRounded');

});

parcelRegister("3X9tg", function(module, exports) {

$parcel$export(module.exports, "Step", () => $54fd26b72dedfdda$export$fd55ce593607084a);
$parcel$export(module.exports, "StepTitle", () => $54fd26b72dedfdda$export$2adea9ff51460424);
$parcel$export(module.exports, "StepForm", () => $54fd26b72dedfdda$export$fd5ea46806bcaacb);

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $NklxQ = parcelRequire("NklxQ");
const $54fd26b72dedfdda$export$861edd1ccea2f746 = (0, $lmFrL.default).div`
  margin: 10px 0 40px 0;
  flex-grow: 3;
`;
function $54fd26b72dedfdda$export$fd55ce593607084a(props) {
    const { className: className, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            props.label && /*#__PURE__*/ (0, $ayMG0.jsx)($54fd26b72dedfdda$export$2adea9ff51460424, {
                label: rest.label,
                icon: rest.icon,
                ...rest
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($54fd26b72dedfdda$var$StepContent, {
                className: "step-content",
                children: props.children
            })
        ]
    });
}
function $54fd26b72dedfdda$export$2adea9ff51460424(props) {
    const { label: label, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($54fd26b72dedfdda$var$StepTitleRoot, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $NklxQ.default), {
                active: true,
                ...rest
            }),
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: label
            })
        ]
    });
}
const $54fd26b72dedfdda$var$StepTitleRoot = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  font-weight: bold;
  .MuiStepIcon-root {
    margin-right: 5px;
  }
`;
const $54fd26b72dedfdda$var$step = (0, $lmFrL.css)`
  margin: 0px 25px 40px 25px;
`;
const $54fd26b72dedfdda$var$StepContent = (0, $lmFrL.default).div`
  ${$54fd26b72dedfdda$var$step}
`;
const $54fd26b72dedfdda$export$fd5ea46806bcaacb = (0, $lmFrL.default).form`
  ${$54fd26b72dedfdda$var$step}
`;

});
parcelRegister("NklxQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $09445c1bc5a83d17$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $9uq0C = parcelRequire("9uq0C");

var $7PGQc = parcelRequire("7PGQc");

var $3ErGR = parcelRequire("3ErGR");

var $7f59P = parcelRequire("7f59P");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $09445c1bc5a83d17$var$_circle;
const $09445c1bc5a83d17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7f59P.getStepIconUtilityClass), classes);
};
const $09445c1bc5a83d17$var$StepIconRoot = (0, $d8seH.default)((0, $3ErGR.default), {
    name: 'MuiStepIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $7f59P.default).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $7f59P.default).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $7f59P.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $09445c1bc5a83d17$var$StepIconText = (0, $d8seH.default)('text', {
    name: 'MuiStepIcon',
    slot: 'Text',
    overridesResolver: (props, styles)=>styles.text
})((0, $aeD7H.default)(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    })));
const $09445c1bc5a83d17$var$StepIcon = /*#__PURE__*/ $acw62.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon, ...other } = props;
    const ownerState = {
        ...props,
        active: active,
        completed: completed,
        error: error
    };
    const classes = $09445c1bc5a83d17$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $5FMfE.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, {
            as: (0, $7PGQc.default),
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        if (completed) return /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconRoot, {
            as: (0, $9uq0C.default),
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($09445c1bc5a83d17$var$StepIconRoot, {
            className: className,
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                $09445c1bc5a83d17$var$_circle || ($09445c1bc5a83d17$var$_circle = /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)($09445c1bc5a83d17$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        });
    }
    return icon;
});
var $09445c1bc5a83d17$export$2e2bcd8739ae039 = $09445c1bc5a83d17$var$StepIcon;

});
parcelRegister("9uq0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e8b174384ed5c4f$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $6e8b174384ed5c4f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');

});

parcelRegister("7PGQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3e87234e6d594a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $5b3e87234e6d594a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

});

parcelRegister("7f59P", function(module, exports) {

$parcel$export(module.exports, "getStepIconUtilityClass", () => $545def50b7760bec$export$62a6e0748bec9297);
$parcel$export(module.exports, "default", () => $545def50b7760bec$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $545def50b7760bec$export$62a6e0748bec9297(slot) {
    return (0, $4Cod0.default)('MuiStepIcon', slot);
}
const $545def50b7760bec$var$stepIconClasses = (0, $beCSm.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $545def50b7760bec$export$2e2bcd8739ae039 = $545def50b7760bec$var$stepIconClasses;

});



parcelRegister("eo4xm", function(module, exports) {

$parcel$export(module.exports, "default", () => $66d1555a4e6f5858$export$2e2bcd8739ae039);
// @ts-nocheck -- todo(nc): the string vs "Option" types for onChange _seem_ to
// be an issue with MUI; fix if needed

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $d8seH = parcelRequire("d8seH");
var $14H9o = parcelRequire("14H9o");

var $e76iu = parcelRequire("e76iu");

var $kGwBF = parcelRequire("kGwBF");

var $7upBl = parcelRequire("7upBl");

var $4VwvT = parcelRequire("4VwvT");

var $9O25J = parcelRequire("9O25J");
var $cFBau = parcelRequire("cFBau");

var $6lXkL = parcelRequire("6lXkL");

var $95gUw = parcelRequire("95gUw");

var $03mUs = parcelRequire("03mUs");
const $66d1555a4e6f5858$var$StyledAutocompletePopper = (0, $d8seH.default)('div')(({ theme: theme })=>({
        [`& .${(0, $9O25J.default).paper}`]: {
            boxShadow: 'none',
            margin: 0,
            color: 'inherit',
            fontSize: 13
        },
        [`& .${(0, $9O25J.default).listbox}`]: {
            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1c2128',
            padding: 0,
            [`& .${(0, $9O25J.default).option}`]: {
                minHeight: 'auto',
                alignItems: 'flex-start',
                padding: 8,
                borderBottom: `1px solid  ${theme.palette.mode === 'light' ? ' #eaecef' : '#30363d'}`,
                '&[aria-selected="true"]': {
                    backgroundColor: 'transparent'
                },
                '&[data-focus="true"], &[data-focus="true"][aria-selected="true"]': {
                    backgroundColor: theme.palette.action.hover
                }
            }
        },
        [`&.${(0, $9O25J.default).popperDisablePortal}`]: {
            position: 'relative'
        }
    }));
function $66d1555a4e6f5858$var$PopperComponent(props) {
    const { disablePortal: disablePortal, anchorEl: anchorEl, open: open, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($66d1555a4e6f5858$var$StyledAutocompletePopper, {
        ...other
    });
}
$66d1555a4e6f5858$var$PopperComponent.propTypes = {
    anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
const $66d1555a4e6f5858$var$StyledPopper = (0, $d8seH.default)((0, $e76iu.default))(({ theme: theme })=>({
        border: `1px solid ${theme.palette.mode === 'light' ? '#e1e4e8' : '#30363d'}`,
        boxShadow: `0 8px 24px ${theme.palette.mode === 'light' ? 'rgba(149, 157, 165, 0.2)' : 'rgb(1, 4, 9)'}`,
        borderRadius: 6,
        width: 300,
        zIndex: theme.zIndex.modal,
        fontSize: 13,
        color: theme.palette.mode === 'light' ? '#24292e' : '#c9d1d9',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1c2128',
        '& .title': {
            backgroundColor: theme.palette.mode === 'light' ? '#f5f5f5' : '#1c2128',
            color: theme.palette.mode === 'light' ? '#24292e' : '#c9d1d9',
            padding: 10
        }
    }));
const $66d1555a4e6f5858$var$StyledInput = (0, $d8seH.default)((0, $95gUw.default))(({ theme: theme })=>({
        padding: 10,
        width: '100%',
        borderBottom: `1px solid ${theme.palette.mode === 'light' ? '#eaecef' : '#30363d'}`,
        '& input': {
            borderRadius: 4,
            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#0d1117',
            padding: 8,
            transition: theme.transitions.create([
                'border-color',
                'box-shadow'
            ]),
            border: `1px solid ${theme.palette.mode === 'light' ? '#eaecef' : '#30363d'}`,
            fontSize: 14,
            '&:focus': {
                boxShadow: `0px 0px 0px 3px ${theme.palette.mode === 'light' ? 'rgba(3, 102, 214, 0.3)' : 'rgb(12, 45, 107)'}`,
                borderColor: theme.palette.mode === 'light' ? '#0366d6' : '#388bfd'
            }
        }
    }));
function $66d1555a4e6f5858$export$2e2bcd8739ae039(props) {
    const { ButtonComponent: ButtonComponent, options: options, multiple: multiple = true, label: label, onChange: onChange, headerText: headerText, noOptionsText: noOptionsText, noSelectedSort: noSelectedSort = false, disableCloseOnSelect: disableCloseOnSelect, disabled: disabled = false } = props;
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const [value, setValue] = (0, $acw62.useState)(props.value);
    const theme = (0, $14H9o.default)();
    (0, $acw62.useEffect)(()=>{
        setValue(props.value);
    }, [
        props.value
    ]);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        if (anchorEl) anchorEl.focus();
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'autocomplete-filter' : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                children: ButtonComponent ? /*#__PURE__*/ (0, $acw62.cloneElement)(ButtonComponent, {
                    onClick: handleClick,
                    disabled: disabled
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                    size: "medium",
                    onClick: handleClick,
                    children: [
                        label,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7upBl))), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($66d1555a4e6f5858$var$StyledPopper, {
                id: id,
                open: open,
                anchorEl: anchorEl,
                placement: "bottom-start",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
                    onClickAway: handleClose,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            headerText && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "title",
                                children: headerText
                            }),
                            !headerText && label && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "title",
                                children: [
                                    "Filter by ",
                                    label
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                open: true,
                                multiple: multiple,
                                onClose: (event, reason)=>{
                                    if (reason === 'escape') handleClose();
                                },
                                value: value,
                                onChange: (event, newValue)=>{
                                    onChange(newValue);
                                    if (disableCloseOnSelect === false) setAnchorEl(null);
                                },
                                disableCloseOnSelect: true,
                                PopperComponent: $66d1555a4e6f5858$var$PopperComponent,
                                renderTags: ()=>null,
                                noOptionsText: noOptionsText || 'No items found',
                                renderOption: (props, option, { selected: selected })=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        ...props,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                                component: (0, (/*@__PURE__*/$parcel$interopDefault($4VwvT))),
                                                sx: {
                                                    width: 17,
                                                    height: 17,
                                                    mr: '5px',
                                                    ml: '-2px'
                                                },
                                                style: {
                                                    visibility: selected ? 'visible' : 'hidden'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                                sx: {
                                                    flexGrow: 1,
                                                    '& span': {
                                                        color: theme.palette.mode === 'light' ? '#586069' : '#8b949e'
                                                    }
                                                },
                                                children: [
                                                    option.label || option.id,
                                                    option.subText ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                            className: "muted",
                                                            children: option.subText
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    });
                                },
                                options: multiple && noSelectedSort == false ? [
                                    ...options
                                ].sort((a, b)=>{
                                    // Display the selected labels first.
                                    let ai = value.indexOf(a.id);
                                    ai = ai === -1 ? value.length + options.indexOf(a) : ai;
                                    let bi = value.indexOf(b.id);
                                    bi = bi === -1 ? value.length + options.indexOf(b) : bi;
                                    return ai - bi;
                                }) : options,
                                // used for filtering
                                getOptionLabel: (option)=>{
                                    return option.label + (option.subText || '');
                                },
                                isOptionEqualToValue: (opt, val)=>{
                                    return multiple ? opt.id == val : opt.id == val.id;
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($66d1555a4e6f5858$var$StyledInput, {
                                        ref: params.InputProps.ref,
                                        inputProps: params.inputProps,
                                        autoFocus: true,
                                        placeholder: `Search for a ${label || 'filter'}`
                                    })
                            })
                        ]
                    })
                })
            })
        ]
    });
}

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});

parcelRegister("kGwBF", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", () => $f0f105dbd8c07c9e$export$58385c17fee43f89);

var $acw62 = parcelRequire("acw62");


var $6zeBo = parcelRequire("6zeBo");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");

var $2xc7G = parcelRequire("2xc7G");
'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $f0f105dbd8c07c9e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://v6.mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://v6.mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://v6.mui.com/material-ui/api/click-away-listener/)
 */ function $f0f105dbd8c07c9e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $13KXh.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6zeBo.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $f0f105dbd8c07c9e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $f0f105dbd8c07c9e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $acw62.cloneElement(children, childrenProps);
}

});


parcelRegister("1GQYh", function(module, exports) {
module.exports = import("lx7Lc").then(()=>parcelRequire('f2WZf'));

});

parcelRegister("9vfYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb366e006a8b659$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("3Umsa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d8804d7e615dc3e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $1Whvr = parcelRequire("1Whvr");

var $bQPWp = parcelRequire("bQPWp");

var $4LmDH = parcelRequire("4LmDH");

var $9gO0g = parcelRequire("9gO0g");
function $2d8804d7e615dc3e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var sign = (0, $bQPWp.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $1Whvr.default)(dateLeft, dateRight));
    var result; // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $bQPWp.default)(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month
        if ((0, $9gO0g.default)((0, $gdr0J.default)(dirtyDateLeft)) && difference === 1 && (0, $bQPWp.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    } // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("1Whvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1698c992e2cb67cc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $1698c992e2cb67cc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("bQPWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a0cd77776020c49$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8a0cd77776020c49$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}

});

parcelRegister("9gO0g", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bfc654d0d5b6f5d$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $6uyHy = parcelRequire("6uyHy");

var $l2vHo = parcelRequire("l2vHo");

var $4LmDH = parcelRequire("4LmDH");
function $6bfc654d0d5b6f5d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    return (0, $6uyHy.default)(date).getTime() === (0, $l2vHo.default)(date).getTime();
}

});
parcelRegister("6uyHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ba07667a7282b10$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("l2vHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5125f9e9edab43e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("8xDhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $637fe0a8b24e6f33$export$2e2bcd8739ae039);

var $bFuWZ = parcelRequire("bFuWZ");

var $4LmDH = parcelRequire("4LmDH");

var $hbRD3 = parcelRequire("hbRD3");
function $637fe0a8b24e6f33$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $bFuWZ.default)(dateLeft, dateRight) / 1000;
    return (0, $hbRD3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("bFuWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87eb8823ffa05467$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $87eb8823ffa05467$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $4LmDH.default)(2, arguments);
    return (0, $gdr0J.default)(dateLeft).getTime() - (0, $gdr0J.default)(dateRight).getTime();
}

});

parcelRegister("hbRD3", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $c83d105896c1098b$export$b6474a47258c1211);
var $c83d105896c1098b$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $c83d105896c1098b$var$defaultRoundingMethod = 'trunc';
function $c83d105896c1098b$export$b6474a47258c1211(method) {
    return method ? $c83d105896c1098b$var$roundingMap[method] : $c83d105896c1098b$var$roundingMap[$c83d105896c1098b$var$defaultRoundingMethod];
}

});


parcelRegister("15nwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca880ce53ce49f9$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $fW24Y = parcelRequire("fW24Y");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: 'en-US',
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $fW24Y.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;

});
parcelRegister("2qFQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4e78b8ee7f66d8$export$2e2bcd8739ae039);
var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;

});

parcelRegister("fW24Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99de2b03d4f39be$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $b99de2b03d4f39be$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;

});
parcelRegister("uq3Ff", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b7040d79e43f9d$export$2e2bcd8739ae039);
function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("1uXR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $117705cf2af2348d$export$2e2bcd8739ae039);
var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $117705cf2af2348d$var$formatRelative = function(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;

});

parcelRegister("cPhtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9567ced935a3b497$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9567ced935a3b497$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $9567ced935a3b497$var$ordinalNumber = function(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;

});
parcelRegister("kp3bq", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda89c8f88184c82$export$2e2bcd8739ae039);
function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2SJ52", function(module, exports) {

$parcel$export(module.exports, "default", () => $219397ebd8b56b11$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;

});
parcelRegister("gKbFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c309fdccb9ef673a$export$2e2bcd8739ae039);
function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("7pOAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $56621c36efca199b$export$2e2bcd8739ae039);
function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});



parcelRegister("6yoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c58fe0eb0761e95$export$2e2bcd8739ae039);
function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, dirtyObject) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
    return target;
}

});

parcelRegister("b8Rua", function(module, exports) {

$parcel$export(module.exports, "getEvents", () => $0b88f1bb1cefcdab$export$3f41ece7d7128238);
$parcel$export(module.exports, "getJobs", () => $0b88f1bb1cefcdab$export$a9242d464ae29af9);
$parcel$export(module.exports, "getTemplate", () => $0b88f1bb1cefcdab$export$9b1a70d8e05b0fa6);
$parcel$export(module.exports, "downloadTemplate", () => $0b88f1bb1cefcdab$export$2738968c94492694);
$parcel$export(module.exports, "submitJob", () => $0b88f1bb1cefcdab$export$7df3ac43e525a530);
$parcel$export(module.exports, "resubmitJobs", () => $0b88f1bb1cefcdab$export$adb28a3bb9f931ee);
$parcel$export(module.exports, "editJob", () => $0b88f1bb1cefcdab$export$8e466b77ccb4bef2);
$parcel$export(module.exports, "suspendJob", () => $0b88f1bb1cefcdab$export$ccaef82cc45f9ac8);
$parcel$export(module.exports, "suspendJobs", () => $0b88f1bb1cefcdab$export$7fa1b18dfaf8f1a3);
$parcel$export(module.exports, "removeJob", () => $0b88f1bb1cefcdab$export$3ac1ed42ccbdd18a);
$parcel$export(module.exports, "removeJobs", () => $0b88f1bb1cefcdab$export$dd8efc93d4568540);
$parcel$export(module.exports, "getJobStatus", () => $0b88f1bb1cefcdab$export$29d2ad33fc8c3498);

var $bcnr1 = parcelRequire("bcnr1");

var $9bsRS = parcelRequire("9bsRS");

var $f1q41 = parcelRequire("f1q41");

var $5g1Ik = parcelRequire("5g1Ik");

var $2oAaL = parcelRequire("2oAaL");

var $2sxTc = parcelRequire("2sxTc");

var $gZwVy = parcelRequire("gZwVy");

var $c3pId = parcelRequire("c3pId");
const $0b88f1bb1cefcdab$var$url = (0, $gZwVy.default).es;
const $0b88f1bb1cefcdab$var$__token = (0, $c3pId.default).token;
const $0b88f1bb1cefcdab$var$options = {
    headers: $0b88f1bb1cefcdab$var$__token ? {
        Authorization: `Sage ${$0b88f1bb1cefcdab$var$__token}`
    } : {}
};
function $0b88f1bb1cefcdab$var$get(endpoint, opts = $0b88f1bb1cefcdab$var$options) {
    return fetch(endpoint, opts).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
function $0b88f1bb1cefcdab$var$getYAML(endpoint, opts = $0b88f1bb1cefcdab$var$options) {
    return fetch(endpoint, opts).then((0, $5g1Ik.handleErrors)).then((res)=>res.text());
}
function $0b88f1bb1cefcdab$var$post(endpoint, data = '') {
    return fetch(endpoint, {
        method: 'POST',
        body: data,
        ...$0b88f1bb1cefcdab$var$options
    }).then((0, $5g1Ik.handleErrors)).then((res)=>res.json());
}
// todo(nc): update goals?  These aren't user-facing right now.
const $0b88f1bb1cefcdab$var$goalEventTypes = [
    'sys.scheduler.status.goal.submitted',
    'sys.scheduler.status.goal.updated',
    'sys.scheduler.status.goal.received',
    'sys.scheduler.status.goal.received.bulk',
    'sys.scheduler.status.goal.removed'
];
const $0b88f1bb1cefcdab$var$pluginEventTypes = [
    'sys.scheduler.status.plugin.queued',
    'sys.scheduler.status.plugin.selected',
    'sys.scheduler.status.plugin.scheduled',
    'sys.scheduler.status.plugin.initializing',
    'sys.scheduler.status.plugin.running',
    'sys.scheduler.status.plugin.completed',
    'sys.scheduler.plugin.lastexecution',
    'sys.scheduler.status.plugin.failed',
    'sys.scheduler.status.plugin.complete',
    'sys.scheduler.status.plugin.launched'
];
// todo(nc): handle user filtering in service
async function $0b88f1bb1cefcdab$var$listJobs(params) {
    const { user: user } = params || {};
    let data = user ? await $0b88f1bb1cefcdab$var$get(`${$0b88f1bb1cefcdab$var$url}/jobs/list`, $0b88f1bb1cefcdab$var$options) : await $0b88f1bb1cefcdab$var$get(`${$0b88f1bb1cefcdab$var$url}/jobs/list`, {
        headers: {}
    });
    // hashed by job_id; convert to array list
    data = Object.values(data);
    data = user ? data.filter((o)=>o.user == user) : data;
    data = data.map((obj)=>({
            ...obj,
            status: obj.state.last_state
        }));
    return data;
}
/* todo(nc): need linkage between various pod runs
const queuedSignals = [
  'sys.scheduler.status.plugin.promoted', // deprecated in favor of "queued"
  'sys.scheduler.status.plugin.queued'
]


const selectedSignals = [
  'sys.scheduler.status.plugin.scheduled', // deprecated in favor of "selected"?
  'sys.scheduler.status.plugin.selected'
]

const startStatuses = ['launched', 'initializing']
*/ const $0b88f1bb1cefcdab$var$startSignals = [
    'sys.scheduler.status.plugin.launched'
];
const $0b88f1bb1cefcdab$var$endSignals = [
    'sys.scheduler.status.plugin.complete',
    'sys.scheduler.status.plugin.completed',
    'sys.scheduler.status.plugin.failed'
];
const $0b88f1bb1cefcdab$var$filterEventsV2 = (o, startList, endList)=>startList.includes(o.name) || endList.includes(o.name);
const $0b88f1bb1cefcdab$var$isDevMode = false;
const $0b88f1bb1cefcdab$var$warnings = [];
function $0b88f1bb1cefcdab$var$findEventsByApp(data, startList, endList) {
    const filtered = data.filter((obj)=>$0b88f1bb1cefcdab$var$filterEventsV2(obj, startList, endList));
    if ($0b88f1bb1cefcdab$var$isDevMode && data.length != filtered.length) {
        const otherEvents = data.filter((o)=>!$0b88f1bb1cefcdab$var$filterEventsV2(o, startList, endList));
        $0b88f1bb1cefcdab$var$warnings.push(`SES events were filtered from ${data.length} to ${filtered.length}\n`, 'Other events:', (0, $f1q41.uniqBy)(otherEvents, 'name').map((o)=>o.name).join(', '));
    }
    const byPod = (0, $f1q41.groupBy)(filtered, 'value.k3s_pod_instance');
    // delete any runs with no k3s_pod_instance?  todo(nc): check with YK
    delete byPod.undefined;
    // create lookup by task name
    const byTaskName = {};
    for (const [podName, events] of Object.entries(byPod)){
        const taskName = podName.slice(0, podName.lastIndexOf('-'));
        events.sort((a, b)=>a.timestamp.localeCompare(b.timestamp));
        let hasStart, hasEnd = false;
        // assume at most two events (for now)
        if (events.length == 2) hasStart = hasEnd = true;
        else if (events.length == 1) {
            const name = events[0].name;
            hasStart = startList.includes(name);
            hasEnd = endList.includes(name);
        } else {
            $0b88f1bb1cefcdab$var$warnings.push(`parseEvents: wrong number of events for ${podName}.`, `found ${events.length} events.  was expecting at most 2`);
            continue;
        }
        let item;
        if (hasStart && hasEnd) {
            const [startObj, endObj] = events;
            const end = endObj.timestamp;
            item = {
                ...startObj,
                end: end,
                status: endObj.name.split('.').pop(),
                runtime: new Date(end).getTime() - new Date(startObj.timestamp).getTime()
            };
        } else if (hasEnd) {
            $0b88f1bb1cefcdab$var$warnings.push('todo: add representation for end times with no start?');
            continue;
        } else if (hasStart) {
            const startObj = events[0];
            const start = startObj.timestamp;
            item = {
                ...startObj,
                end: new Date().toISOString(),
                status: 'running',
                runtime: new Date().getTime() - new Date(start).getTime()
            };
            $0b88f1bb1cefcdab$var$warnings.push(`Note: No end signal found for taskName=${taskName}, timestamp=${start}`);
        }
        if (taskName in byTaskName) byTaskName[taskName].push(item);
        else byTaskName[taskName] = [
            item
        ];
    }
    if ($0b88f1bb1cefcdab$var$isDevMode) console.warn($0b88f1bb1cefcdab$var$warnings.join('\n'));
    return byTaskName;
}
function $0b88f1bb1cefcdab$export$93738ca0a9c2679b(taskEvents) {
    // first group by vsn
    const groupedByNode = (0, $f1q41.groupBy)(taskEvents, 'meta.vsn');
    // aggregate start/stops for each vsn
    const byNode = {};
    for (const [vsn, events] of Object.entries(groupedByNode)){
        const byApp = $0b88f1bb1cefcdab$var$findEventsByApp(events, $0b88f1bb1cefcdab$var$startSignals, $0b88f1bb1cefcdab$var$endSignals);
        byNode[vsn] = byApp;
    }
    // organize by orange/red statuses below 'complete'
    // High-level metrics could make this make this clear, in lieu of better design
    for (const [vsn, byApp] of Object.entries(byNode))for (const [app, objs] of Object.entries(byApp))byNode[vsn][app] = [
        ...objs.filter((obj)=>[
                'launched',
                'running'
            ].includes(obj.status)),
        ...objs.filter((obj)=>[
                'complete',
                'completed'
            ].includes(obj.status)),
        ...objs.filter((obj)=>obj.status == 'failed')
    ];
    return byNode;
}
// todo(nc): work in progress for new scheduler events
/*
export function reduceDataV2(taskEvents: PluginEvent[]) : EventsByNode {
  // first group by vsn
  const groupedByNode = groupBy(taskEvents, 'meta.vsn')

  // aggregate start/stops by vsn
  const byNode = {}
  for (const [vsn, events] of Object.entries(groupedByNode)) {
    const byAppScheduled = findEventsByApp(events, selectedSignals, startSignals)
    byNode[vsn] = byAppScheduled
  }

  // organize by orange/red statuses below 'complete'
  // High-level metrics could make this make this clear, in lieu of better design
  for (const [vsn, byApp] of Object.entries(byNode)) {
    for (const [app, objs] of Object.entries(byApp)) {
      byNode[vsn][app] = [
        ...objs.filter(obj => startStatuses.includes(obj.status)),
        ...objs.filter(obj => ['complete', 'completed'].includes(obj.status)),
        ...objs.filter(obj => obj.status == 'failed')
      ]
    }
  }

  return byNode
}
*/ const $0b88f1bb1cefcdab$var$parseESRecord = (data)=>data.map((o)=>({
            ...o,
            value: JSON.parse(o.value)
        }));
function $0b88f1bb1cefcdab$export$3f41ece7d7128238(args) {
    const { start: start, vsns: vsns } = args || {};
    return $bcnr1.getData({
        start: start || '-24h',
        filter: {
            name: 'sys.scheduler.status.plugin.*',
            ...vsns && {
                vsn: vsns.join('|')
            }
        }
    }).then((data)=>$0b88f1bb1cefcdab$var$parseESRecord(data)).then((pluginEvents)=>{
        const errors = pluginEvents.filter((obj)=>obj.value.k3s_pod_status == 'Failed');
        const errorsByGoalID = (0, $f1q41.groupBy)(errors, 'value.goal_id');
        return {
            events: $0b88f1bb1cefcdab$export$93738ca0a9c2679b(pluginEvents),
            errors: errorsByGoalID
        };
    });
}
async function $0b88f1bb1cefcdab$export$a9242d464ae29af9(params) {
    const { user: user, project: project } = params || {};
    const prom1 = project ? $9bsRS.getNodes({
        project: project
    }) : null;
    const [nodes, jobs] = await Promise.all([
        prom1,
        $0b88f1bb1cefcdab$var$listJobs({
            user: user
        })
    ]);
    let jobData;
    try {
        jobData = jobs.map((obj)=>{
            const { name: name, job_id: job_id, nodes: nodes, plugins: plugins, nodeTags: nodeTags } = obj;
            return {
                ...obj,
                ...obj.state,
                id: Number(job_id),
                name: name,
                nodes: nodes ? Object.keys(nodes) : nodeTags ? nodeTags : [],
                // list user-defined, "plugin" (app) names in object as well
                appNames: (plugins || []).map((o)=>o.name),
                // list full ECR app names in object as well
                apps: (plugins || []).map((o)=>{
                    return !o.plugin_spec ? null : o.plugin_spec.image.replace('registry.sagecontinuum.org/', '');
                })
            };
        });
    } catch (error) {
        console.error('error', error);
    }
    if (nodes) {
        const vsns = nodes.map((obj)=>obj.vsn);
        jobData = jobData.filter((job)=>job.nodes.filter((vsn)=>vsns.includes(vsn)).length);
    }
    return jobData;
}
async function $0b88f1bb1cefcdab$export$9b1a70d8e05b0fa6(jobID, type) {
    const yaml = await $0b88f1bb1cefcdab$var$getYAML(`${$0b88f1bb1cefcdab$var$url}/jobs/${jobID}/template`, $0b88f1bb1cefcdab$var$options);
    return type == 'yaml' ? yaml : $2sxTc.parse(yaml);
}
async function $0b88f1bb1cefcdab$export$2738968c94492694(jobID) {
    $0b88f1bb1cefcdab$export$9b1a70d8e05b0fa6(jobID, 'yaml').then((spec)=>{
        (0, $2oAaL.downloadFile)(spec, `sage-job-${jobID}.yaml`);
    });
}
async function $0b88f1bb1cefcdab$export$7df3ac43e525a530(spec) {
    const res = await $0b88f1bb1cefcdab$var$post(`${$0b88f1bb1cefcdab$var$url}/submit`, spec);
    return res;
}
async function $0b88f1bb1cefcdab$export$adb28a3bb9f931ee(ids) {
    const idList = Array.isArray(ids) ? ids : [
        ids
    ];
    return Promise.all(idList.map((id)=>$0b88f1bb1cefcdab$var$get(`${$0b88f1bb1cefcdab$var$url}/submit?id=${id}`)));
}
async function $0b88f1bb1cefcdab$export$8e466b77ccb4bef2(id, spec) {
    const res = await $0b88f1bb1cefcdab$var$post(`${$0b88f1bb1cefcdab$var$url}/edit?id=${id}`, spec);
    return res;
}
async function $0b88f1bb1cefcdab$export$ccaef82cc45f9ac8(id) {
    return await $0b88f1bb1cefcdab$var$get(`${$0b88f1bb1cefcdab$var$url}/jobs/${id}/rm?id=${id}&suspend=true`);
}
async function $0b88f1bb1cefcdab$export$7fa1b18dfaf8f1a3(ids) {
    return Promise.all(ids.map((id)=>$0b88f1bb1cefcdab$export$ccaef82cc45f9ac8(id)));
}
async function $0b88f1bb1cefcdab$export$3ac1ed42ccbdd18a(id) {
    return await $0b88f1bb1cefcdab$var$get(`${$0b88f1bb1cefcdab$var$url}/jobs/${id}/rm?id=${id}&force=true`);
}
async function $0b88f1bb1cefcdab$export$dd8efc93d4568540(ids) {
    return Promise.all(ids.map((id)=>$0b88f1bb1cefcdab$export$3ac1ed42ccbdd18a(id)));
}
async function $0b88f1bb1cefcdab$export$29d2ad33fc8c3498(id) {
    return await $0b88f1bb1cefcdab$var$get(`${$0b88f1bb1cefcdab$var$url}/jobs/${id}/status`);
}

});
parcelRegister("2oAaL", function(module, exports) {

$parcel$export(module.exports, "downloadFile", () => $f219673f8815d877$export$bb3b75778e3e272);
function $f219673f8815d877$export$bb3b75778e3e272(data, name, type = `text/plain`) {
    const blob = new Blob([
        data
    ], {
        type: `${type};charset=utf-8`
    });
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

});


parcelRegister("gDTZY", function(module, exports) {

module.exports = Promise.all([
    import("9HhN8"),
    (parcelRequire("fFMZG"))(import.meta.resolve("lVJmK")),
    import("43Gwo")
]).then(()=>parcelRequire('3KX5U'));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("1X18x", function(module, exports) {

$parcel$export(module.exports, "FileFormatDot", () => $d4884a6f062da7bc$export$5ee4f7a172326880);

var $ayMG0 = parcelRequire("ayMG0");

var $ia96H = parcelRequire("ia96H");
const $d4884a6f062da7bc$var$typeColorMap = {
    default: 'rgb(28,140,201)',
    JSON: '#efdb50',
    ndjson: '#efdb50',
    PDF: '#ac3535',
    TAR: '#4e4e4e',
    running: '#de9300'
};
function $d4884a6f062da7bc$export$5ee4f7a172326880(props) {
    const { format: format } = props;
    const color = $d4884a6f062da7bc$var$typeColorMap[format] || $d4884a6f062da7bc$var$typeColorMap.default;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ia96H.default), {
                color: color
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "muted",
                children: format.toLowerCase()
            })
        ]
    });
}

});
parcelRegister("ia96H", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dd3bde8a133e69c$export$2e2bcd8739ae039);

var $lmFrL = parcelRequire("lmFrL");
const $6dd3bde8a133e69c$var$Dot = (0, $lmFrL.default).div`
  display: inline-block;
  height: ${(props)=>props.size || '12'}px;
  width:  ${(props)=>props.size || '12'}px;
  border-radius: 50%;
  margin-right: 3px;
  background-color: ${(props)=>props.color || 'rgb(28, 140, 201)'};
`;
var $6dd3bde8a133e69c$export$2e2bcd8739ae039 = $6dd3bde8a133e69c$var$Dot;

});


parcelRegister("ioNxW", function(module, exports) {

$parcel$export(module.exports, "parseNodeMeta", () => $6317092af569b121$export$6bac868ccda0938a);
$parcel$export(module.exports, "default", () => $6317092af569b121$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $lmFrL = parcelRequire("lmFrL");

var $bFBmv = parcelRequire("bFBmv");

var $gOa8m = parcelRequire("gOa8m");

var $7L4OA = parcelRequire("7L4OA");

var $8IuK2 = parcelRequire("8IuK2");

var $9bsRS = parcelRequire("9bsRS");

var $bcnr1 = parcelRequire("bcnr1");

var $ecxdi = parcelRequire("ecxdi");

var $f1q41 = parcelRequire("f1q41");

var $6ami2 = parcelRequire("6ami2");
var $2esSG = parcelRequire("2esSG");

var $5xexf = parcelRequire("5xexf");

var $c3pId = parcelRequire("c3pId");
const $6317092af569b121$var$cameraTags = $bcnr1.cameraOrientations.map((pos)=>({
        id: `camera_${pos}`,
        tag: `camera_${pos}`
    }));
// todo(nc): note: we need nodeMetas for some of this
const $6317092af569b121$var$tags = [
    {
        id: 'type',
        tag: 'WSN'
    },
    {
        id: 'raingauge',
        tag: 'raingauge'
    },
    ...$6317092af569b121$var$cameraTags
];
const $6317092af569b121$var$queryByTag = (data, tagState)=>{
    // get corresponding keys
    const objKeys = $6317092af569b121$var$tags.filter((o)=>tagState.includes(o.tag)).map((o)=>o.id);
    // filter matches
    return data.filter((row)=>Object.values((0, $f1q41.pick)(row, objKeys)).join('').toLowerCase() == tagState.join('').toLowerCase());
};
const $6317092af569b121$var$columns = [
    {
        id: 'vsn',
        label: 'Node'
    },
    /* todo(nc): ignore for now {
  id: 'project',
  label: 'Project'
}, */ {
        id: 'city',
        label: 'City'
    },
    {
        id: 'View',
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: `/nodes/${obj.vsn}`,
                target: "_blank",
                children: [
                    "view node ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                        className: "external-link"
                    })
                ]
            })
    }
];
const $6317092af569b121$export$6bac868ccda0938a = (data)=>data.map((o)=>({
            ...o,
            top_camera: o.sensors.find((o)=>o.name == 'top_camera')?.hw_model,
            bottom_camera: o.sensors.find((o)=>o.name == 'bottom_camera')?.hw_model,
            left_camera: o.sensors.find((o)=>o.name == 'left_camera')?.hw_model,
            right_camera: o.sensors.find((o)=>o.name == 'right_camera')?.hw_model
        }));
function $6317092af569b121$export$2e2bcd8739ae039(props) {
    const { selected: selected = [], onSelected: onSelected, checkPerms: checkPerms = false } = props;
    const [data, setData] = (0, $acw62.useState)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [filtered, setFiltered] = (0, $acw62.useState)();
    const [page] = (0, $acw62.useState)(0);
    const [updateID, setUpdateID] = (0, $acw62.useState)(0);
    const [tagState, setTagState] = (0, $acw62.useState)([]);
    const [availNodes, setAvailNodes] = (0, $acw62.useState)();
    const [isSchedulable, setIsSchedulable] = (0, $acw62.useState)(checkPerms);
    (0, $acw62.useEffect)(()=>{
        const p1 = $9bsRS.getNodes();
        const p2 = isSchedulable ? $ecxdi.listNodesWithPerm('schedule') : null;
        Promise.all(isSchedulable ? [
            p1,
            p2
        ] : [
            p1
        ]).then(([objs, availNodes])=>{
            objs = $6317092af569b121$export$6bac868ccda0938a(objs);
            if (isSchedulable) objs = objs.filter((o)=>availNodes.includes(o.vsn));
            setAvailNodes(availNodes);
            setData(objs);
            setFiltered(objs);
        });
    }, [
        isSchedulable
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!data) return;
        const cols = [
            'vsn',
            'project',
            'location'
        ];
        let subset = (0, $8IuK2.queryData)(data, query, cols);
        subset = $6317092af569b121$var$queryByTag(subset, tagState);
        setFiltered(subset);
        // force update map
        setUpdateID((prev)=>prev + 1);
    }, [
        query,
        tagState,
        data
    ]);
    const handleSelection = (selected)=>{
        onSelected(selected.objs.map((o)=>o.vsn));
    };
    const handleTagFilter = (tag)=>{
        setTagState((prev)=>prev.includes(tag) ? prev.filter((v)=>v != tag) : [
                ...prev,
                tag
            ]);
    };
    const handleRemoveChip = (vsn)=>{
        onSelected(selected.filter((selVSN)=>selVSN != vsn));
    };
    const tableProps = (0, $c3pId.default).user & isSchedulable ? {
        disableRowSelect: (row)=>!availNodes.includes(row.vsn),
        greyRow: (row)=>!availNodes.includes(row.vsn),
        stripe: false
    } : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6317092af569b121$var$Root, {
        className: "flex column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    checkPerms && /*#__PURE__*/ (0, $ayMG0.jsx)($6317092af569b121$var$TagFilters, {
                        children: $6317092af569b121$var$tags.map(({ tag: tag })=>/*#__PURE__*/ (0, $ayMG0.jsx)($6317092af569b121$var$TagFilter, {
                                label: tag,
                                onClick: ()=>handleTagFilter(tag),
                                color: tagState.includes(tag) ? 'primary' : 'default',
                                variant: tagState.includes(tag) ? 'filled' : 'outlined'
                            }, tag))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: (0, $c3pId.default).user && checkPerms && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                checked: isSchedulable,
                                onChange: (evt)=>setIsSchedulable(evt.target.checked)
                            }),
                            label: "Schedulable"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    filtered && /*#__PURE__*/ (0, $ayMG0.jsx)($6317092af569b121$var$TableWrap, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "vsn",
                            enableSorting: true,
                            checkboxes: true,
                            disableClickOutside: true,
                            columns: $6317092af569b121$var$columns,
                            rows: filtered,
                            pagination: true,
                            page: page,
                            limit: filtered.length,
                            rowsPerPage: 10,
                            onSearch: ({ query: query })=>setQuery(query || ''),
                            middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-grow"
                            }),
                            // @ts-ignore: revisit "selected" and MapData types if this component is used
                            selected: selected,
                            onSelect: handleSelection,
                            ...tableProps
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($6317092af569b121$var$MapWrap, {
                        children: filtered && // @ts-ignore: revisit "selected" and MapData types if these component is used
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                            data: filtered,
                            updateID: updateID
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6317092af569b121$var$SelectedChips, {
                    className: "flex gap",
                    children: selected.map((node)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                            label: node,
                            variant: "filled",
                            color: "primary",
                            onDelete: ()=>handleRemoveChip(node)
                        }, node))
                })
            })
        ]
    });
}
const $6317092af569b121$var$Root = (0, $lmFrL.default).div`
  width: 100%;
`;
const $6317092af569b121$var$TagFilters = (0, $lmFrL.default).div``;
const $6317092af569b121$var$TagFilter = (0, $lmFrL.default)((0, $6ami2.default))`
  margin-right: 10px;
`;
const $6317092af569b121$var$TableWrap = (0, $lmFrL.default).div`
  width: 50%;
  padding-right: 20px;
`;
const $6317092af569b121$var$MapWrap = (0, $lmFrL.default).div`
  margin-top: 60px;
  width: 50%;
`;
const $6317092af569b121$var$SelectedChips = (0, $lmFrL.default).div`
  margin-top: 10px;
`;

});
parcelRegister("7L4OA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e295be6bff261f6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");
var $b0NgK = parcelRequire("b0NgK");

parcelRequire("5dILV");
var $dgn03 = parcelRequire("dgn03");
var $bEEeq = parcelRequire("bEEeq");
var $kCiwh = parcelRequire("kCiwh");
var $hFbNW = parcelRequire("hFbNW");
var $5ijfo = parcelRequire("5ijfo");
var $cHIgG = parcelRequire("cHIgG");
var $5FJvD = parcelRequire("5FJvD");

var $hgW6l = parcelRequire("hgW6l");

var $gZwVy = parcelRequire("gZwVy");

var $aQAPf = parcelRequire("aQAPf");

var $eOilY = parcelRequire("eOilY");
const { initialViewState: $1e295be6bff261f6$var$initialViewState } = (0, $aQAPf.default);
const $1e295be6bff261f6$var$DISABLE_MAP = (0, $gZwVy.default)['disableMaps'] || false;
const $1e295be6bff261f6$var$MAPBOX_TOKEN = "pk.eyJ1IjoibmNvbnJhZGFubCIsImEiOiJja3BmeWd4bmswMzA0MndsaWszbWVoZTk4In0.OIUluCDPj_j2wkohxk9Cug";
const $1e295be6bff261f6$var$markerSize = 10;
const $1e295be6bff261f6$var$mapSettings = {
    ...$1e295be6bff261f6$var$initialViewState ? {
        initialViewState: $1e295be6bff261f6$var$initialViewState
    } : {
        initialViewState: {
            longitude: -99,
            latitude: 38.5,
            zoom: 3.0
        }
    },
    mapboxAccessToken: $1e295be6bff261f6$var$MAPBOX_TOKEN,
    style: {
        height: '350px'
    },
    mapStyle: 'mapbox://styles/mapbox/dark-v9',
    cooperativeGestures: true
};
const $1e295be6bff261f6$var$fitBoundsPadding = {
    top: 35,
    bottom: 35,
    left: 35,
    right: 35
};
const $1e295be6bff261f6$var$getBBox = (coordinates)=>{
    const lngs = coordinates.map((o)=>o.lng);
    const lats = coordinates.map((o)=>o.lat);
    const lngMin = Math.min(...lngs);
    const lngMax = Math.max(...lngs);
    const latMin = Math.min(...lats);
    const latMax = Math.max(...lats);
    return [
        [
            lngMin,
            latMin
        ],
        [
            lngMax,
            latMax
        ]
    ];
};
const $1e295be6bff261f6$var$getValidCoords = (data)=>(data || []).filter(({ lat: lat, lng: lng })=>lat && lng).map(({ lat: lat, lng: lng })=>({
            lng: lng,
            lat: lat
        }));
const $1e295be6bff261f6$var$getGeoSpec = (data)=>{
    const features = (data || []).filter(({ lat: lat, lng: lng })=>lat && lng).map((obj)=>({
            type: 'Feature',
            status: obj.status,
            geometry: {
                type: 'Point',
                coordinates: [
                    obj.lng,
                    obj.lat
                ]
            },
            properties: {
                title: $eOilY.vsnToDisplayStrAlt(obj.vsn, obj.site_id),
                description: '',
                data: obj
            }
        }));
    return {
        type: 'FeatureCollection',
        features: features
    };
};
const $1e295be6bff261f6$var$getLayerStyle = (isDark)=>({
        'id': 'marker-labels',
        'type': 'symbol',
        'source': 'geoSpec',
        'layout': {
            'text-field': [
                'format',
                [
                    'upcase',
                    [
                        'get',
                        'title'
                    ]
                ],
                {
                    'font-scale': 0.9
                }
            ],
            'text-variable-anchor': [
                'top',
                'bottom',
                'left',
                'right'
            ],
            'text-radial-offset': 0.5,
            'text-justify': 'auto',
            'icon-image': [
                'get',
                'icon'
            ],
            'text-font': [
                'Open Sans Semibold',
                'Arial Unicode MS Bold'
            ]
        },
        paint: {
            'text-color': isDark ? '#ddd' : '#444'
        }
    });
function $1e295be6bff261f6$var$PopupInfo(props) {
    const { data: data, onClose: onClose, showUptime: showUptime } = props;
    // todo(nc): use new manifests endpoint when avail
    // @ts-ignore; use new manifests endpoint when avail
    const { vsn: vsn, focus: focus, city: city, cityStr: cityStr, state: state, status: status, lng: lng, lat: lat } = data || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cHIgG.default), {
        longitude: lng,
        latitude: lat,
        onClose: onClose,
        closeButton: false,
        closeOnClick: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "no-margin flex justify-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        vsn.charAt(0) == 'V' && 'Sage Blade',
                        vsn.charAt(0) == 'W' && 'Wild Sage Node',
                        "\xa0",
                        $eOilY.vsnLink(vsn, data)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap-2 items-center node-meta",
                children: [
                    showUptime && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex column status",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                className: "muted font-bold",
                                children: "Status"
                            }),
                            $eOilY.statusWithPhase(status, data)
                        ]
                    }),
                    focus && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                className: "muted font-bold",
                                children: "Focus"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                    to: `/nodes/?focus="${encodeURIComponent(focus)}"`,
                                    children: focus
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                className: "muted font-bold",
                                children: "City"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    city && cityStr && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                        to: `/nodes?city="${encodeURIComponent(city)}"`,
                                        children: cityStr
                                    }),
                                    state && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            ",",
                                            ' ',
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                                to: `/nodes?state="${encodeURIComponent(state)}"`,
                                                children: state
                                            })
                                        ]
                                    }),
                                    !(city && state) && '-'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hgW6l.default), {
                        data: data
                    })
                ]
            })
        ]
    });
}
function $1e295be6bff261f6$export$2e2bcd8739ae039(props) {
    const { data: data = null, markerClass: markerClass, updateID: updateID, showUptime: showUptime = true, autoFitBounds: autoFitBounds = true, mapSettings: mapSettingsOverride } = props;
    const { mode: mode, systemMode: systemMode } = (0, $b0NgK.useColorScheme)();
    const mapRef = (0, $acw62.useRef)(null);
    const [popup, setPopup] = (0, $acw62.useState)(null);
    const isDarkMode = (mode === 'system' ? systemMode : mode) === 'dark';
    const layerStyle = $1e295be6bff261f6$var$getLayerStyle(isDarkMode);
    const [geoData, setGeoData] = (0, $acw62.useState)(null);
    const [markers, setMarkers] = (0, $acw62.useState)([]);
    // keep track of primary keys
    const [lastID, setLastID] = (0, $acw62.useState)(-1);
    // just determine when to update for now
    (0, $acw62.useEffect)(()=>{
        if ($1e295be6bff261f6$var$DISABLE_MAP) return;
        const d = data;
        const geoData = $1e295be6bff261f6$var$getGeoSpec(d);
        const coords = $1e295be6bff261f6$var$getValidCoords(d);
        const bbox = $1e295be6bff261f6$var$getBBox(coords);
        setGeoData(geoData);
        setMarkers(d);
        if (autoFitBounds && mapRef.current && coords.length) mapRef.current.on('load', ()=>{
            mapRef.current.fitBounds(bbox, {
                padding: $1e295be6bff261f6$var$fitBoundsPadding,
                maxZoom: 10
            });
        });
        setLastID(updateID);
    }, [
        data,
        autoFitBounds
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!data?.length || lastID === updateID || !mapRef.current) return;
        const d = data;
        const coords = $1e295be6bff261f6$var$getValidCoords(d);
        if (!coords.length) return;
        const bbox = $1e295be6bff261f6$var$getBBox(coords);
        mapRef.current.fitBounds(bbox, {
            padding: $1e295be6bff261f6$var$fitBoundsPadding,
            maxZoom: 10
        });
    }, [
        updateID,
        data,
        lastID
    ]);
    const handleClick = (evt, obj)=>{
        evt.originalEvent.stopPropagation();
        setPopup(obj);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1e295be6bff261f6$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $dgn03.default), {
            ref: mapRef,
            ...$1e295be6bff261f6$var$mapSettings,
            ...mapSettingsOverride,
            mapStyle: `mapbox://styles/mapbox/${(mode === 'system' ? systemMode : mode) === 'dark' ? 'dark-v10' : 'light-v9'}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bEEeq.default), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ijfo.default), {
                    position: "bottom-right",
                    showCompass: false
                }),
                geoData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5FJvD.default), {
                    id: "markers",
                    type: "geojson",
                    data: geoData,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kCiwh.default), {
                        ...layerStyle
                    })
                }),
                (markers || []).filter((o)=>o.lng && o.lat).map((obj)=>{
                    const { vsn: vsn, lng: lng, lat: lat, status: status } = obj;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hFbNW.default), {
                        longitude: lng,
                        latitude: lat,
                        onClick: (evt)=>handleClick(evt, obj),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: `marker-dot ${markerClass ? `marker-${markerClass}` : `marker-${(status || '').replace(/ /g, '-')}`}`
                        })
                    }, vsn);
                }),
                popup && /*#__PURE__*/ (0, $ayMG0.jsx)($1e295be6bff261f6$var$PopupInfo, {
                    data: popup,
                    onClose: ()=>setPopup(null),
                    showUptime: showUptime
                })
            ]
        })
    });
}
const $1e295be6bff261f6$var$Root = (0, $d8seH.default)('div')(({ theme: theme })=>`
  width: 100%;

  .popup-title {
    margin-top: 0;
  }

  .mapboxgl-marker {
    cursor: pointer;
  }

  .marker-dot {
    height: ${$1e295be6bff261f6$var$markerSize}px;
    width: ${$1e295be6bff261f6$var$markerSize}px;
    border: 1px solid ${theme.palette.mode === 'dark' ? '#999' : '#666'};
    border-radius: 50%;
    display: inline-block;
  }

  .marker-reporting  {
    background: #3ac37e;
    border: 1px solid #2b9962;
    opacity: .65;
  }

  .marker-degraded {
    background: hsl(41, 83%, 35%);
  }

  .marker-not-reporting {
    background: #d72020;
    border: 1px solid #992727;
    opacity: .65;
  }

  .marker-blue-dot {
    background: rgb(31, 119, 180);
    border: 1px solid rgb(24, 99, 152);
    opacity: .65;
  }

  .mapboxgl-popup {
    max-width: 100% !important;

    .mapboxgl-popup-content {
      background: ${theme.palette.background.paper};
      color: ${theme.palette.text.primary};
    }

    .mapboxgl-popup-tip {
      border-top-color: ${theme.palette.background.paper};
    }

    .node-meta {
      white-space: nowrap;
      font-size: 1.2em;
    }

    .status {
      .MuiSvgIcon-root {
        font-size: 19px;
      }
    }

    .muted {
      color: ${theme.palette.text.secondary};
    }
  }

  .clipboard-content {
    margin-right: 20px;
  }
`);

});
parcelRegister("b0NgK", function(module, exports) {

$parcel$export(module.exports, "useColorScheme", () => $8045e99d413e4782$export$6343629ee1b29116);
$parcel$export(module.exports, "CssVarsProvider", () => $8045e99d413e4782$export$50ec01b133c61652);
parcelRequire("acw62");

var $9dZwz = parcelRequire("9dZwz");

var $cbPVn = parcelRequire("cbPVn");

var $ijOKP = parcelRequire("ijOKP");

var $d6q8u = parcelRequire("d6q8u");

var $4jPsi = parcelRequire("4jPsi");

var $3K3i6 = parcelRequire("3K3i6");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const { CssVarsProvider: $8045e99d413e4782$var$InternalCssVarsProvider, useColorScheme: $8045e99d413e4782$export$6343629ee1b29116, getInitColorSchemeScript: $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript } = (0, $cbPVn.default)({
    themeId: (0, $4jPsi.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $ijOKP.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $3K3i6.defaultConfig).colorSchemeStorageKey,
    modeStorageKey: (0, $3K3i6.defaultConfig).modeStorageKey,
    defaultColorScheme: {
        light: (0, $3K3i6.defaultConfig).defaultLightColorScheme,
        dark: (0, $3K3i6.defaultConfig).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $d6q8u.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $9dZwz.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $8045e99d413e4782$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $8045e99d413e4782$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8045e99d413e4782$var$InternalCssVarsProvider, {
        ...props
    });
}
let $8045e99d413e4782$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $8045e99d413e4782$export$f9a57b4a2abf8ed = (params)=>{
    if (!$8045e99d413e4782$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $8045e99d413e4782$var$warnedInitScriptOnce = true;
    }
    return $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript(params);
};
const $8045e99d413e4782$export$50ec01b133c61652 = $8045e99d413e4782$var$InternalCssVarsProvider;

});
parcelRegister("cbPVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dfeca3d89da820b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $bBbjn = parcelRequire("bBbjn");

var $lT1cX = parcelRequire("lT1cX");

var $eEJPp = parcelRequire("eEJPp");

var $6WOpW = parcelRequire("6WOpW");

var $1NWrJ = parcelRequire("1NWrJ");

var $iBtfI = parcelRequire("iBtfI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8dfeca3d89da820b$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dfeca3d89da820b$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $1NWrJ.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $1NWrJ.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>$acw62.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', noSsr: noSsr } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $lT1cX.default)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $acw62.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $acw62.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $iBtfI.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const memoTheme = $acw62.useMemo(()=>{
            // `colorScheme` is undefined on the server and hydration phase
            const calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            colorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $eEJPp.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dfeca3d89da820b$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6WOpW.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bBbjn.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $1NWrJ.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("6WOpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $50ef44b883b4d7f9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $lYrbz = parcelRequire("lYrbz");
var $lT1cX = parcelRequire("lT1cX");

parcelRequire("8zogs");
var $NxDAE = parcelRequire("NxDAE");

var $g6Om4 = parcelRequire("g6Om4");

var $58lXc = parcelRequire("58lXc");

var $aMyfV = parcelRequire("aMyfV");

var $4xpDS = parcelRequire("4xpDS");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $g6Om4.default)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $lT1cX.default)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $4xpDS.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lYrbz.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $NxDAE.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58lXc.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aMyfV.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;

});
parcelRegister("lYrbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff44a152eb20ab0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $fHPaR = parcelRequire("fHPaR");

var $lT1cX = parcelRequire("lT1cX");

var $2NPLA = parcelRequire("2NPLA");

var $ayMG0 = parcelRequire("ayMG0");
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $lT1cX.default)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $2NPLA.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fHPaR.default).Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$export$2e2bcd8739ae039 = $fff44a152eb20ab0$var$ThemeProvider;

});

parcelRegister("4xpDS", function(module, exports) {

$parcel$export(module.exports, "default", () => $34de227aaca64f99$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $auC0X = parcelRequire("auC0X");

var $92iK7 = parcelRequire("92iK7");

var $g6Om4 = parcelRequire("g6Om4");

var $ayMG0 = parcelRequire("ayMG0");
function $34de227aaca64f99$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $g6Om4.default)();
    const id = (0, $auC0X.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $eEJPp.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), {
        styles: layerOrder
    });
}

});


parcelRegister("1NWrJ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", () => $1507b440b55b1cf7$export$ff0fa3047d11164c);
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", () => $1507b440b55b1cf7$export$665054ea9d94dab9);
$parcel$export(module.exports, "default", () => $1507b440b55b1cf7$export$2e2bcd8739ae039);
/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $1507b440b55b1cf7$export$ff0fa3047d11164c = 'mode';
const $1507b440b55b1cf7$export$665054ea9d94dab9 = 'color-scheme';
const $1507b440b55b1cf7$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $1507b440b55b1cf7$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1507b440b55b1cf7$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $1507b440b55b1cf7$export$665054ea9d94dab9, attribute: initialAttribute = $1507b440b55b1cf7$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("iBtfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b25f9d3c9e642d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1NWrJ = parcelRequire("1NWrJ");

var $54Il9 = parcelRequire("54Il9");
'use client';
function $d8b25f9d3c9e642d$var$noop() {}
function $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d8b25f9d3c9e642d$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state) {
    return $d8b25f9d3c9e642d$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d8b25f9d3c9e642d$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $1NWrJ.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $1NWrJ.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $54Il9.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $acw62.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $acw62.useState(noSsr || !isMultiSchemes);
    $acw62.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $d8b25f9d3c9e642d$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("54Il9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1fb882896a7778$export$2e2bcd8739ae039);
function $3b1fb882896a7778$var$noop() {}
const $3b1fb882896a7778$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $3b1fb882896a7778$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $3b1fb882896a7778$export$2e2bcd8739ae039 = $3b1fb882896a7778$var$localStorageManager;

});



parcelRegister("3K3i6", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", () => $2b983880bbf899cb$export$f84bd70098573c5c);
parcelRequire("acw62");

var $1NWrJ = parcelRequire("1NWrJ");

var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $2b983880bbf899cb$export$2e2bcd8739ae039 = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1NWrJ.default), {
        ...$2b983880bbf899cb$export$f84bd70098573c5c,
        ...props
    });
};

});


parcelRegister("5dILV", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("dgn03")).default);
$parcel$export(module.exports, "Marker", () => (parcelRequire("hFbNW")).default);
$parcel$export(module.exports, "Popup", () => (parcelRequire("cHIgG")).default);
$parcel$export(module.exports, "FullscreenControl", () => (parcelRequire("bEEeq")).default);
$parcel$export(module.exports, "NavigationControl", () => (parcelRequire("5ijfo")).default);
$parcel$export(module.exports, "Source", () => (parcelRequire("5FJvD")).default);
$parcel$export(module.exports, "Layer", () => (parcelRequire("kCiwh")).default);

var $dgn03 = parcelRequire("dgn03");

var $hFbNW = parcelRequire("hFbNW");

var $cHIgG = parcelRequire("cHIgG");

var $a8Poz = parcelRequire("a8Poz");

var $bEEeq = parcelRequire("bEEeq");

var $bcvgN = parcelRequire("bcvgN");

var $5ijfo = parcelRequire("5ijfo");

var $5sMv5 = parcelRequire("5sMv5");

var $5FJvD = parcelRequire("5FJvD");

var $kCiwh = parcelRequire("kCiwh");

var $ewjtG = parcelRequire("ewjtG");

var $8ebmZ = parcelRequire("8ebmZ");
parcelRequire("9Dr9d");

});
parcelRegister("dgn03", function(module, exports) {

$parcel$export(module.exports, "MapContext", () => $9a7e9c45a3124243$export$dc7344301ae78f85);
$parcel$export(module.exports, "default", () => $9a7e9c45a3124243$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $8ebmZ = parcelRequire("8ebmZ");

var $gpf7b = parcelRequire("gpf7b");

var $2013U = parcelRequire("2013U");

var $4nil3 = parcelRequire("4nil3");

var $xJNCw = parcelRequire("xJNCw");
const $9a7e9c45a3124243$export$dc7344301ae78f85 = $acw62.createContext(null);
const $9a7e9c45a3124243$var$defaultProps = {
    // Constraints
    minZoom: 0,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    // Interaction handlers
    scrollZoom: true,
    boxZoom: true,
    dragRotate: true,
    dragPan: true,
    keyboard: true,
    doubleClickZoom: true,
    touchZoomRotate: true,
    touchPitch: true,
    // Style
    mapStyle: {
        version: 8,
        sources: {},
        layers: []
    },
    styleDiffing: true,
    projection: 'mercator',
    renderWorldCopies: true,
    // Callbacks
    onError: (e)=>console.error(e.error),
    // Globals
    RTLTextPlugin: 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js'
};

const $9a7e9c45a3124243$var$Map = (0, $acw62.forwardRef)((props, ref)=>{
    const mountedMapsContext = (0, $acw62.useContext)((0, $8ebmZ.MountedMapsContext));
    const [mapInstance, setMapInstance] = (0, $acw62.useState)(null);
    const containerRef = (0, $acw62.useRef)();
    const { current: contextValue } = (0, $acw62.useRef)({
        mapLib: null,
        map: null
    });
    (0, $acw62.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || (parcelRequire("1GQYh"))).then((mapboxgl)=>{
            if (!isMounted) return;
            if (!mapboxgl.Map) // commonjs style
            mapboxgl = mapboxgl.default;
            if (!mapboxgl || !mapboxgl.Map) throw new Error('Invalid mapLib');
            if (mapboxgl.supported(props)) {
                (0, $xJNCw.default)(mapboxgl, props);
                if (props.reuseMaps) mapbox = (0, $gpf7b.default).reuse(props, containerRef.current);
                if (!mapbox) mapbox = new (0, $gpf7b.default)(mapboxgl.Map, props, containerRef.current);
                contextValue.map = (0, $2013U.default)(mapbox, mapboxgl);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapMount(contextValue.map, props.id);
            } else throw new Error('Map is not supported by this browser');
        }).catch((error)=>{
            props.onError({
                type: 'error',
                target: null,
                originalEvent: null,
                error: error
            });
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $4nil3.default)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $acw62.useMemo)(()=>({
            position: 'relative',
            width: '100%',
            height: '100%',
            ...props.style
        }), [
        props.style
    ]);
    return $acw62.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $acw62.createElement($9a7e9c45a3124243$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, props.children));
});
$9a7e9c45a3124243$var$Map.displayName = 'Map';
$9a7e9c45a3124243$var$Map.defaultProps = $9a7e9c45a3124243$var$defaultProps;
var $9a7e9c45a3124243$export$2e2bcd8739ae039 = $9a7e9c45a3124243$var$Map;

});
parcelRegister("8ebmZ", function(module, exports) {

$parcel$export(module.exports, "MountedMapsContext", () => $5fd8735e227661c7$export$c6c68f6e4db55944);

var $acw62 = parcelRequire("acw62");

var $dgn03 = parcelRequire("dgn03");
const $5fd8735e227661c7$export$c6c68f6e4db55944 = $acw62.createContext(null);
const $5fd8735e227661c7$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $acw62.useState)({});
    const onMapMount = (0, $acw62.useCallback)((map, id = 'default')=>{
        setMaps((currMaps)=>{
            if (id === 'current') throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $acw62.useCallback)((id = 'default')=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $acw62.createElement($5fd8735e227661c7$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $5fd8735e227661c7$export$86f8f9f08863e403() {
    var _a;
    const maps = (_a = (0, $acw62.useContext)($5fd8735e227661c7$export$c6c68f6e4db55944)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = (0, $acw62.useContext)((0, $dgn03.MapContext));
    const mapsWithCurrent = (0, $acw62.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}

});

parcelRegister("gpf7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf1ab4a2bd68224e$export$2e2bcd8739ae039);

var $dsXVY = parcelRequire("dsXVY");

var $hWMDI = parcelRequire("hWMDI");

var $5MyJ5 = parcelRequire("5MyJ5");
const $bf1ab4a2bd68224e$var$pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const $bf1ab4a2bd68224e$var$cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const $bf1ab4a2bd68224e$var$otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const $bf1ab4a2bd68224e$var$settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const $bf1ab4a2bd68224e$var$handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
class $bf1ab4a2bd68224e$export$2e2bcd8739ae039 {
    constructor(MapClass, props, container){
        // mapboxgl.Map instance. Not using type here because we are accessing
        // private members and methods
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$bf1ab4a2bd68224e$var$otherEvents[e.type]];
            if (cb) cb(e);
        };
        this._onPointerEvent = (e)=>{
            if (e.type === 'mousemove' || e.type === 'mouseout') this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$bf1ab4a2bd68224e$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') {
                    const features = this._hoveredFeatures || this._map.queryRenderedFeatures(e.point, {
                        layers: this.props.interactiveLayerIds
                    });
                    e.features = features;
                }
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$bf1ab4a2bd68224e$var$cameraEvents[e.type]];
                if (cb) cb(e);
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createShadowTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $bf1ab4a2bd68224e$export$2e2bcd8739ae039.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // Step 3: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire('load');
        else map.once('styledata', ()=>map.fire('load'));
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $bf1ab4a2bd68224e$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $hWMDI.normalizeStyle)(props.mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg)=>{
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on('render', ()=>this._onAfterRepaint());
        // Insert code into map's event pipeline
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('resize', ()=>{
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on('styledata', ()=>this._updateStyleComponents(this.props, {}));
        map.on('sourcedata', ()=>this._updateStyleComponents(this.props, {}));
        for(const eventName in $bf1ab4a2bd68224e$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $bf1ab4a2bd68224e$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $bf1ab4a2bd68224e$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        $bf1ab4a2bd68224e$export$2e2bcd8739ae039.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = (0, $dsXVY.cloneTransform)(map.transform);
        map.painter.transform = renderTransform;
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) return false;
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) // All movement of the camera is done relative to the sea level
        tr.cameraElevationReference = 'sea';
        const changed = (0, $dsXVY.applyViewStateToTransform)(tr, {
            ...(0, $dsXVY.transformToViewState)(map.transform),
            ...nextProps
        });
        if (isMoving) // Reset camera reference
        tr.cameraElevationReference = 'ground';
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) (0, $dsXVY.applyViewStateToTransform)(map.transform, nextProps);
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $bf1ab4a2bd68224e$var$settingNames)if (propName in nextProps && !(0, $5MyJ5.deepEqual)(nextProps[propName], currProps[propName])) {
            changed = true;
            map[`set${propName[0].toUpperCase()}${propName.slice(1)}`](nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor;
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const options = {
                diff: nextProps.styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $hWMDI.normalizeStyle)(nextProps.mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.style.loaded()) {
            if ('light' in nextProps && !(0, $5MyJ5.deepEqual)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && !(0, $5MyJ5.deepEqual)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && !(0, $5MyJ5.deepEqual)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $bf1ab4a2bd68224e$var$handlerNames){
            const newValue = nextProps[propName];
            if (!(0, $5MyJ5.deepEqual)(newValue, currProps[propName])) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _updateHover(e) {
        var _a;
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            let features;
            if (eventType === 'mousemove') try {
                features = this._map.queryRenderedFeatures(e.point, {
                    layers: props.interactiveLayerIds
                });
            } catch (_b) {
                features = [];
            }
            else features = [];
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === 'string' ? event : event.type;
        if (eventType === 'move') this._updateViewState(this.props, false);
        if (eventType in $bf1ab4a2bd68224e$var$cameraEvents) {
            if (typeof event === 'object') event.viewState = (0, $dsXVY.transformToViewState)(tr);
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        this._map.transform = this._renderTransform;
        this._onAfterRepaint = ()=>{
            // Restores camera state before render/load events are fired
            this._map.transform = tr;
        };
    }
}
$bf1ab4a2bd68224e$export$2e2bcd8739ae039.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $bf1ab4a2bd68224e$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || undefined;
    } catch (_a) {
    // ignore
    }
    try {
        accessToken = accessToken || undefined;
    } catch (_b) {
    // ignore
    }
    return accessToken;
}

});
parcelRegister("dsXVY", function(module, exports) {

$parcel$export(module.exports, "cloneTransform", () => $9cdc618d3fb95628$export$dd516654c5f598fb);
$parcel$export(module.exports, "transformToViewState", () => $9cdc618d3fb95628$export$6a605c5aa5bd97a8);
$parcel$export(module.exports, "applyViewStateToTransform", () => $9cdc618d3fb95628$export$5cf06eaeb862e3ce);
/**
 * Make a copy of a transform
 * @param tr
 */ function $9cdc618d3fb95628$export$dd516654c5f598fb(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
function $9cdc618d3fb95628$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
function $9cdc618d3fb95628$export$5cf06eaeb862e3ce(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ('longitude' in v && 'latitude' in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    if ('zoom' in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ('bearing' in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ('pitch' in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    return changed;
}

});

parcelRegister("hWMDI", function(module, exports) {

$parcel$export(module.exports, "normalizeStyle", () => $d10d954053704841$export$8756898546458274);
const $d10d954053704841$var$refProps = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $d10d954053704841$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === 'string') return style;
    if ('toJS' in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        // @ts-expect-error
        const layerRef = layerIndex[layer.ref];
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = {
                ...layer
            };
            // Breaks style diffing :(
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        if (layerRef) {
            normalizedLayer = normalizedLayer || {
                ...layer
            };
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $d10d954053704841$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}

});

parcelRegister("5MyJ5", function(module, exports) {

$parcel$export(module.exports, "arePointsEqual", () => $435c5f5ee205423f$export$cb7477365ef68362);
$parcel$export(module.exports, "deepEqual", () => $435c5f5ee205423f$export$9cb4719e2e525b7a);
/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $435c5f5ee205423f$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $435c5f5ee205423f$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$435c5f5ee205423f$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$435c5f5ee205423f$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}

});


parcelRegister("2013U", function(module, exports) {

$parcel$export(module.exports, "default", () => $174c67bfc07fd180$export$2e2bcd8739ae039);
/** These methods may break the react binding if called directly */ const $174c67bfc07fd180$var$skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function $174c67bfc07fd180$export$2e2bcd8739ae039(mapInstance, mapLib) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const result = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
        },
        unproject: (point)=>{
            return mapInstance.transform.pointLocation(mapLib.Point.convert(point));
        },
        queryTerrainElevation: (lnglat, options)=>{
            // @ts-ignore transform not defined
            const tr = map.transform;
            // @ts-ignore transform not defined
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            // @ts-ignore transform not defined
            map.transform = tr;
            return result;
        }
    };
    for (const key of $174c67bfc07fd180$var$getMethodNames(map))// @ts-expect-error
    if (!(key in result) && !$174c67bfc07fd180$var$skipMethods.includes(key)) result[key] = map[key].bind(map);
    return result;
}
function $174c67bfc07fd180$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}

});

parcelRegister("4nil3", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f789160ca5499c$export$2e2bcd8739ae039);
// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $acw62 = parcelRequire("acw62");
const $32f789160ca5499c$var$useIsomorphicLayoutEffect = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $32f789160ca5499c$export$2e2bcd8739ae039 = $32f789160ca5499c$var$useIsomorphicLayoutEffect;

});

parcelRegister("xJNCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $06569bf976c6fb89$export$2e2bcd8739ae039);
const $06569bf976c6fb89$var$globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function $06569bf976c6fb89$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $06569bf976c6fb89$var$globalSettings)if (key in props) mapLib[key] = props[key];
    if (props.RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') mapLib.setRTLTextPlugin(props.RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, false);
}

});


parcelRegister("hFbNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdbf6c27f3138c21$export$2e2bcd8739ae039);
/* global document */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $7zSOl = parcelRequire("7zSOl");

var $dgn03 = parcelRequire("dgn03");

var $5MyJ5 = parcelRequire("5MyJ5");
const $cdbf6c27f3138c21$var$defaultProps = {
    draggable: false,
    popup: null,
    rotation: 0,
    rotationAlignment: 'auto',
    pitchAlignment: 'auto'
};
/* eslint-disable complexity,max-statements */ function $cdbf6c27f3138c21$var$Marker(props) {
    const { map: map, mapLib: mapLib } = (0, $acw62.useContext)((0, $dgn03.MapContext));
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const marker = (0, $acw62.useMemo)(()=>{
        let hasChildren = false;
        $acw62.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement('div') : null
        };
        const mk = new mapLib.Marker(options).setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener('click', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 || _b.call(_a, {
                type: 'click',
                target: mk,
                originalEvent: e
            });
        });
        mk.on('dragstart', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('drag', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on('dragend', (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 || _b.call(_a, evt);
        });
        return mk;
    }, []);
    (0, $acw62.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $7zSOl.applyReactStyle)(marker.getElement(), props.style);
    }, [
        props.style
    ]);
    if (marker.getLngLat().lng !== props.longitude || marker.getLngLat().lat !== props.latitude) marker.setLngLat([
        props.longitude,
        props.latitude
    ]);
    if (props.offset && !(0, $5MyJ5.arePointsEqual)(marker.getOffset(), props.offset)) marker.setOffset(props.offset);
    if (marker.isDraggable() !== props.draggable) marker.setDraggable(props.draggable);
    if (marker.getRotation() !== props.rotation) marker.setRotation(props.rotation);
    if (marker.getRotationAlignment() !== props.rotationAlignment) marker.setRotationAlignment(props.rotationAlignment);
    if (marker.getPitchAlignment() !== props.pitchAlignment) marker.setPitchAlignment(props.pitchAlignment);
    if (marker.getPopup() !== props.popup) marker.setPopup(props.popup);
    return (0, $1u0KT.createPortal)(props.children, marker.getElement());
}
$cdbf6c27f3138c21$var$Marker.defaultProps = $cdbf6c27f3138c21$var$defaultProps;
var // @ts-ignore
$cdbf6c27f3138c21$export$2e2bcd8739ae039 = $acw62.memo($cdbf6c27f3138c21$var$Marker);

});
parcelRegister("7zSOl", function(module, exports) {

$parcel$export(module.exports, "applyReactStyle", () => $5846519ef1dad138$export$cd93e47e6d398387);
// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $5846519ef1dad138$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $5846519ef1dad138$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$5846519ef1dad138$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}

});


parcelRegister("cHIgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fbd6eb6f705a53$export$2e2bcd8739ae039);
/* global document */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $7zSOl = parcelRequire("7zSOl");

var $dgn03 = parcelRequire("dgn03");

var $5MyJ5 = parcelRequire("5MyJ5");
// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function $93fbd6eb6f705a53$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */ function $93fbd6eb6f705a53$var$Popup(props) {
    const { map: map, mapLib: mapLib } = (0, $acw62.useContext)((0, $dgn03.MapContext));
    const container = (0, $acw62.useMemo)(()=>{
        return document.createElement('div');
    }, []);
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const popup = (0, $acw62.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options).setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once('open', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 || _b.call(_a, e);
        });
        return pp;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onClose = (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 || _b.call(_a, e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $7zSOl.applyReactStyle)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        // @ts-ignore
        if (props.offset && !(0, $5MyJ5.deepEqual)(popup.options.offset, props.offset)) popup.setOffset(props.offset);
        // @ts-ignore
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            // @ts-ignore
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        // @ts-ignore
        if (popup.options.className !== props.className) {
            // @ts-ignore
            const prevClassList = $93fbd6eb6f705a53$var$getClassList(popup.options.className);
            const nextClassList = $93fbd6eb6f705a53$var$getClassList(props.className);
            for (const c of prevClassList)if (!nextClassList.has(c)) popup.removeClassName(c);
            for (const c of nextClassList)if (!prevClassList.has(c)) popup.addClassName(c);
            // @ts-ignore
            popup.options.className = props.className;
        }
    }
    return (0, $1u0KT.createPortal)(props.children, container);
}
var // @ts-ignore
$93fbd6eb6f705a53$export$2e2bcd8739ae039 = $acw62.memo($93fbd6eb6f705a53$var$Popup);

});

parcelRegister("a8Poz", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $7zSOl = parcelRequire("7zSOl");

var $ewjtG = parcelRequire("ewjtG");
function $762284c258b78ce5$var$AttributionControl(props) {
    const ctrl = (0, $ewjtG.default)(({ mapLib: mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        // @ts-ignore
        (0, $7zSOl.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $762284c258b78ce5$export$2e2bcd8739ae039 = $acw62.memo($762284c258b78ce5$var$AttributionControl);

});
parcelRegister("ewjtG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92329bcc1c071f3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dgn03 = parcelRequire("dgn03");
function $a92329bcc1c071f3$var$useControl(onCreate, arg1, arg2, arg3) {
    const context = (0, $acw62.useContext)((0, $dgn03.MapContext));
    const ctrl = (0, $acw62.useMemo)(()=>onCreate(context), []);
    (0, $acw62.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === 'function' && typeof arg2 === 'function' ? arg1 : null;
        const onRemove = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}
var $a92329bcc1c071f3$export$2e2bcd8739ae039 = $a92329bcc1c071f3$var$useControl;

});


parcelRegister("bEEeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $87c2a3506cd722d5$export$2e2bcd8739ae039);
/* global document */ 
var $acw62 = parcelRequire("acw62");

var $7zSOl = parcelRequire("7zSOl");

var $ewjtG = parcelRequire("ewjtG");
function $87c2a3506cd722d5$var$FullscreenControl(props) {
    const ctrl = (0, $ewjtG.default)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        // @ts-ignore
        (0, $7zSOl.applyReactStyle)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $87c2a3506cd722d5$export$2e2bcd8739ae039 = $acw62.memo($87c2a3506cd722d5$var$FullscreenControl);

});

parcelRegister("bcvgN", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $7zSOl = parcelRequire("7zSOl");

var $ewjtG = parcelRequire("ewjtG");
const $827912441298a941$var$GeolocateControl = (0, $acw62.forwardRef)((props, ref)=>{
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    const ctrl = (0, $ewjtG.default)(({ mapLib: mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        const setupUI = gc._setupUI;
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on('geolocate', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('error', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('outofmaxbounds', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationstart', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on('trackuserlocationend', (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 || _b.call(_a, e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            trigger: ()=>ctrl.trigger()
        }), []);
    (0, $acw62.useEffect)(()=>{
        // @ts-ignore
        (0, $7zSOl.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
});
$827912441298a941$var$GeolocateControl.displayName = 'GeolocateControl';
var $827912441298a941$export$2e2bcd8739ae039 = $acw62.memo($827912441298a941$var$GeolocateControl);

});

parcelRegister("5ijfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dad904d5e4d490e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7zSOl = parcelRequire("7zSOl");

var $ewjtG = parcelRequire("ewjtG");
function $3dad904d5e4d490e$var$NavigationControl(props) {
    const ctrl = (0, $ewjtG.default)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        // @ts-ignore
        (0, $7zSOl.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $3dad904d5e4d490e$export$2e2bcd8739ae039 = $acw62.memo($3dad904d5e4d490e$var$NavigationControl);

});

parcelRegister("5sMv5", function(module, exports) {

var $acw62 = parcelRequire("acw62");

var $7zSOl = parcelRequire("7zSOl");

var $ewjtG = parcelRequire("ewjtG");
const $3fa5306cfc82cc01$var$defaultProps = {
    unit: 'metric',
    maxWidth: 100
};
function $3fa5306cfc82cc01$var$ScaleControl(props) {
    const ctrl = (0, $ewjtG.default)(({ mapLib: mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    // @ts-ignore
    if (ctrl.options.unit !== props.unit || ctrl.options.maxWidth !== props.maxWidth) {
        // @ts-ignore
        ctrl.options.maxWidth = props.maxWidth;
        // This method will trigger an update
        ctrl.setUnit(props.unit);
    }
    (0, $acw62.useEffect)(()=>{
        // @ts-ignore
        (0, $7zSOl.applyReactStyle)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
$3fa5306cfc82cc01$var$ScaleControl.defaultProps = $3fa5306cfc82cc01$var$defaultProps;
var $3fa5306cfc82cc01$export$2e2bcd8739ae039 = $acw62.memo($3fa5306cfc82cc01$var$ScaleControl);

});

parcelRegister("5FJvD", function(module, exports) {

$parcel$export(module.exports, "default", () => $42141548b276439f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dgn03 = parcelRequire("dgn03");

var $l4cNc = parcelRequire("l4cNc");

var $5MyJ5 = parcelRequire("5MyJ5");
let $42141548b276439f$var$sourceCounter = 0;
function $42141548b276439f$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $42141548b276439f$var$updateSource(source, props, prevProps) {
    (0, $l4cNc.default)(props.id === prevProps.id, 'source id changed');
    (0, $l4cNc.default)(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for(const key in props)if (key !== 'children' && key !== 'id' && !(0, $5MyJ5.deepEqual)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === 'geojson') source.setData(props.data);
    else if (type === 'image') source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ((type === 'canvas' || type === 'video') && changedKeyCount === 1 && changedKey === 'coordinates') source.setCoordinates(props.coordinates);
    else if (type === 'vector' && 'setUrl' in source) // Added in 1.12.0:
    // vectorTileSource.setTiles
    // vectorTileSource.setUrl
    switch(changedKey){
        case 'url':
            source.setUrl(props.url);
            break;
        case 'tiles':
            source.setTiles(props.tiles);
            break;
        default:
    }
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
/* eslint-enable complexity */ function $42141548b276439f$var$Source(props) {
    const map = (0, $acw62.useContext)((0, $dgn03.MapContext)).map.getMap();
    const propsRef = (0, $acw62.useRef)(props);
    const [, setStyleLoaded] = (0, $acw62.useState)(0);
    const id = (0, $acw62.useMemo)(()=>props.id || `jsx-source-${$42141548b276439f$var$sourceCounter++}`, []);
    (0, $acw62.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                var _a;
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $42141548b276439f$var$updateSource(source, props, propsRef.current);
    else source = $42141548b276439f$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $acw62.Children.map(props.children, (child)=>child && (0, $acw62.cloneElement)(child, {
            source: id
        })) || null;
}
var $42141548b276439f$export$2e2bcd8739ae039 = $42141548b276439f$var$Source;

});
parcelRegister("l4cNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f563e50514fa0b84$export$2e2bcd8739ae039);
function $f563e50514fa0b84$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}

});


parcelRegister("kCiwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f025b8e44d668910$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $dgn03 = parcelRequire("dgn03");

var $l4cNc = parcelRequire("l4cNc");

var $5MyJ5 = parcelRequire("5MyJ5");
/* eslint-disable complexity, max-statements */ function $f025b8e44d668910$var$updateLayer(map, id, props, prevProps) {
    (0, $l4cNc.default)(props.id === prevProps.id, 'layer id changed');
    (0, $l4cNc.default)(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') return;
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $5MyJ5.deepEqual)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $5MyJ5.deepEqual)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    if (!(0, $5MyJ5.deepEqual)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $f025b8e44d668910$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $f025b8e44d668910$var$layerCounter = 0;
function $f025b8e44d668910$var$Layer(props) {
    const map = (0, $acw62.useContext)((0, $dgn03.MapContext)).map.getMap();
    const propsRef = (0, $acw62.useRef)(props);
    const [, setStyleLoaded] = (0, $acw62.useState)(0);
    const id = (0, $acw62.useMemo)(()=>props.id || `jsx-layer-${$f025b8e44d668910$var$layerCounter++}`, []);
    (0, $acw62.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $f025b8e44d668910$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $f025b8e44d668910$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}
var $f025b8e44d668910$export$2e2bcd8739ae039 = $f025b8e44d668910$var$Layer;

});

parcelRegister("9Dr9d", function(module, exports) {

});


parcelRegister("hgW6l", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c7c87ac5ac382e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $lDN4l = parcelRequire("lDN4l");

var $eOilY = parcelRequire("eOilY");
const $e2c7c87ac5ac382e$var$GpsClipboard = (props)=>{
    const { data: data } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e2c7c87ac5ac382e$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
            content: $eOilY.gps(null, data, true),
            tooltip: "Copy coordinates"
        })
    });
};
const $e2c7c87ac5ac382e$var$Root = (0, $d8seH.default)('div')`
  display: inline-block;

  .gps-icon {
    margin-right: 1em;
  }

  pre {
    margin-bottom: 0;
    padding-right: 30px;
  }

  .clipboard-content {
    // less padding since scroll not needed
    padding-bottom: 8px;
  }
`;
var $e2c7c87ac5ac382e$export$2e2bcd8739ae039 = $e2c7c87ac5ac382e$var$GpsClipboard;

});
parcelRegister("eOilY", function(module, exports) {

$parcel$export(module.exports, "GPSIcon", () => $6ff2cd56daf2a731$export$bc464412ef24ea1);
$parcel$export(module.exports, "SensorIcons", () => $6ff2cd56daf2a731$export$775ef666b1f9c006);
$parcel$export(module.exports, "statusWithPhase", () => $6ff2cd56daf2a731$export$3e54079b8c19673);
$parcel$export(module.exports, "vsn", () => $6ff2cd56daf2a731$export$79d2fcaae6f983d2);
$parcel$export(module.exports, "vsnLink", () => $6ff2cd56daf2a731$export$a58c2e09e934e8de);
$parcel$export(module.exports, "vsnLinkWithEdit", () => $6ff2cd56daf2a731$export$87c5915dce4f3d55);
$parcel$export(module.exports, "vsnLinkNameOnly", () => $6ff2cd56daf2a731$export$5833d250cf25565);
$parcel$export(module.exports, "vsnToDisplayName", () => $6ff2cd56daf2a731$export$f9f335100cd793ae);
$parcel$export(module.exports, "vsnToDisplayStr", () => $6ff2cd56daf2a731$export$a2c7a7007afa5ce3);
$parcel$export(module.exports, "vsnToDisplayStrAlt", () => $6ff2cd56daf2a731$export$e33911e8509f994e);
$parcel$export(module.exports, "focus", () => $6ff2cd56daf2a731$export$d7ddd398f22d79ef);
$parcel$export(module.exports, "gps", () => $6ff2cd56daf2a731$export$f643ac6ce14a8380);
$parcel$export(module.exports, "lastUpdated", () => $6ff2cd56daf2a731$export$c60d1a715a48771d);
$parcel$export(module.exports, "uptimes", () => $6ff2cd56daf2a731$export$1a9b4dbc2de8b541);
$parcel$export(module.exports, "modem", () => $6ff2cd56daf2a731$export$e44cff07f1ac18a5);
$parcel$export(module.exports, "modemSim", () => $6ff2cd56daf2a731$export$244d7de2e4c18d10);
$parcel$export(module.exports, "HardwareListSimple", () => $6ff2cd56daf2a731$export$5e29c62e7b3a6e93);
$parcel$export(module.exports, "HardwareList", () => $6ff2cd56daf2a731$export$d87f54151884e13c);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $lzNIT = parcelRequire("lzNIT");

var $fagfG = parcelRequire("fagfG");
var $03mUs = parcelRequire("03mUs");
var $kGwBF = parcelRequire("kGwBF");
var $9Lykx = parcelRequire("9Lykx");
var $8AyZl = parcelRequire("8AyZl");
var $lofVM = parcelRequire("lofVM");
var $19ocJ = parcelRequire("19ocJ");
var $e76iu = parcelRequire("e76iu");
var $cVXaD = parcelRequire("cVXaD");

var $cpkHS = parcelRequire("cpkHS");
var $7oDS2 = parcelRequire("7oDS2");
var $jsmYD = parcelRequire("jsmYD");
var $hAiFn = parcelRequire("hAiFn");
var $3eYo8 = parcelRequire("3eYo8");
var $7wXDx = parcelRequire("7wXDx");
var $gMdoV = parcelRequire("gMdoV");
var $7tHF8 = parcelRequire("7tHF8");
var $h1Bqv = parcelRequire("h1Bqv");
var $32iEE = parcelRequire("32iEE");

var $bcnr1 = parcelRequire("bcnr1");

var $9Sf49 = parcelRequire("9Sf49");

var $ia96H = parcelRequire("ia96H");

var $7cKF8 = parcelRequire("7cKF8");

var $lffEs = parcelRequire("lffEs");

var $gZwVy = parcelRequire("gZwVy");
function $6ff2cd56daf2a731$export$bc464412ef24ea1(props) {
    const { hasLiveGPS: hasLiveGPS, hasStaticGPS: hasStaticGPS, lat: lat, lng: lng } = props.obj;
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const handleCopyGPS = (evt)=>{
        evt.stopPropagation();
        if (lat && lng) {
            navigator.clipboard.writeText(`${lat}, ${lng}`);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        }
    };
    const gpsCoords = lat && lng ? `${lat}, ${lng}` : 'No coordinates';
    if (hasStaticGPS) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        placement: "top",
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Static GPS",
                hasLiveGPS && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "\xa0\xa0\xa0\xa0\xa0",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ia96H.default), {
                            size: "8"
                        }),
                        " ",
                        '==',
                        " recent live GPS found",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                gpsCoords,
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        children: copied ? 'Copied!' : 'Click to copy'
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
            size: "small",
            onClick: handleCopyGPS,
            children: copied ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jsmYD.default), {
                fontSize: "small"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$LiveGPSDot, {
                invisible: !hasLiveGPS,
                color: "primary",
                variant: "dot",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h1Bqv.default), {
                    fontSize: "small"
                })
            })
        })
    });
    else if (!hasStaticGPS && hasLiveGPS) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        placement: "top",
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Live GPS\xa0\xa0\xa0\xa0\xa0(no static gps found)",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                gpsCoords,
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                        children: copied ? 'Copied!  ' : 'Click to copy'
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
            size: "small",
            onClick: handleCopyGPS,
            children: copied ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jsmYD.default), {
                fontSize: "small"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h1Bqv.default), {
                fontSize: "small",
                style: {
                    color: '#36b8ff'
                }
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
}
const $6ff2cd56daf2a731$var$LiveGPSDot = (0, $lmFrL.default)((0, $fagfG.default))`
  .MuiBadge-badge {
    right: 3px;
    top: 2px;
    padding: 0px;
  }
`;
const $6ff2cd56daf2a731$var$ThermalCameraIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            position: 'relative',
            display: 'inline-flex',
            alignItems: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cpkHS.default), {
                fontSize: "small"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32iEE.default), {
                fontSize: "inherit",
                sx: {
                    position: 'absolute',
                    top: -2,
                    right: -2,
                    background: ({ palette: palette })=>palette.background.paper,
                    color: ({ palette: palette })=>palette.error.main
                }
            })
        ]
    });
const $6ff2cd56daf2a731$export$775ef666b1f9c006 = /*#__PURE__*/ (0, $acw62.memo)(function SensorIcons({ data: data, showOnlyPresent: showOnlyPresent = false }) {
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const [popoverSensors, setPopoverSensors] = (0, $acw62.useState)([]);
    const [popoverCapability, setPopoverCapability] = (0, $acw62.useState)('');
    // Count sensors by capability and track thermal cameras
    const capabilityCounts = new Map();
    const sensorCapabilityMap = new Map();
    if (!data || data.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "-"
    });
    data.forEach((sensor)=>{
        sensorCapabilityMap.set(sensor.hw_model, new Set(sensor.capabilities));
        // If sensor has no capabilities, add to Special
        if (!sensor.capabilities || sensor.capabilities.length === 0) {
            if (!capabilityCounts.has('Additional Sensors/Capabilities')) capabilityCounts.set('Additional Sensors/Capabilities', []);
            if (!capabilityCounts.get('Additional Sensors/Capabilities').some((s)=>s.hw_model === sensor.hw_model)) capabilityCounts.get('Additional Sensors/Capabilities').push(sensor);
        } else sensor.capabilities?.forEach((cap)=>{
            // Merge Camera and Thermal Camera into Camera
            const normalizedCap = cap === 'Thermal Camera' ? 'Camera' : cap;
            if (!capabilityCounts.has(normalizedCap)) capabilityCounts.set(normalizedCap, []);
            if (!capabilityCounts.get(normalizedCap).some((s)=>s.hw_model === sensor.hw_model)) capabilityCounts.get(normalizedCap).push(sensor);
        });
    });
    const hasThermalCamera = data.some((sensor)=>sensor.capabilities?.includes('Thermal Camera'));
    const handleClick = (event, capability, sensors)=>{
        event.stopPropagation();
        if (sensors && sensors.length > 0) {
            setAnchorEl(event.currentTarget);
            // For Camera capability, check if each sensor is thermal
            const sensorsWithType = sensors.map((sensor)=>({
                    hw_model: sensor.hw_model,
                    name: sensor.name,
                    isThermal: sensorCapabilityMap.get(sensor.hw_model)?.has('Thermal Camera') || false
                }));
            setPopoverSensors(sensorsWithType);
            setPopoverCapability(capability);
        }
    };
    const handleClose = ()=>{
        setAnchorEl(null);
        setPopoverSensors([]);
        setPopoverCapability('');
    };
    const open = Boolean(anchorEl);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: '4px',
                    flexWrap: 'wrap',
                    alignItems: 'center'
                },
                children: Object.keys((0, $7cKF8.capabilityIcons)).map((capability)=>{
                    const Icon = (0, $7cKF8.capabilityIcons)[capability];
                    const sensors = capabilityCounts.get(capability);
                    const count = sensors ? sensors.length : 0;
                    const isPresent = count > 0;
                    // Don't show Additional Sensors/Capabilities icon if there aren't any
                    if (capability === 'Additional Sensors/Capabilities' && !isPresent) return null;
                    // Skip non-present capabilities if showOnlyPresent is true
                    if (showOnlyPresent && !isPresent) return null;
                    // Use ThermalCameraIcon for Camera if any thermal cameras exist
                    const DisplayIcon = capability === 'Camera' && hasThermalCamera ? $6ff2cd56daf2a731$var$ThermalCameraIcon : Icon;
                    // For Camera capability, count regular vs thermal
                    let cameraBreakdown = '';
                    if (capability === 'Camera' && isPresent) {
                        const thermalCount = sensors.filter((sensor)=>sensorCapabilityMap.get(sensor.hw_model)?.has('Thermal Camera')).length;
                        const regularCount = count - thermalCount;
                        if (thermalCount > 0 && regularCount > 0) cameraBreakdown = ` (${regularCount} regular, ${thermalCount} thermal)`;
                        else if (thermalCount > 0) cameraBreakdown = ` (${thermalCount} thermal)`;
                    }
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        disableInteractive: true,
                        enterDelay: 0,
                        title: isPresent ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: '16px',
                                        marginBottom: '8px',
                                        paddingBottom: '8px',
                                        borderBottom: '1px solid rgba(255, 255, 255, 0.3)'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            style: {
                                                fontSize: '1.1em'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                    children: capability
                                                }),
                                                " ",
                                                count > 1 && `(${count} total)`
                                            ]
                                        }),
                                        cameraBreakdown && /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            style: {
                                                whiteSpace: 'nowrap',
                                                fontSize: '0.9em'
                                            },
                                            children: cameraBreakdown.trim().replace(/[()]/g, '')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        marginTop: '8px',
                                        display: 'flex',
                                        gap: '12px',
                                        flexWrap: 'wrap',
                                        alignItems: 'flex-start'
                                    },
                                    children: sensors.map((sensor, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                idx > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5
                                                    },
                                                    children: "|"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        flexDirection: 'column'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: sensor.hw_model
                                                        }),
                                                        sensor.hw_model.toLowerCase() !== sensor.name.toLowerCase() && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                            style: {
                                                                opacity: 0.8,
                                                                whiteSpace: 'nowrap'
                                                            },
                                                            children: sensor.name
                                                        })
                                                    ]
                                                }, idx)
                                            ]
                                        }))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    style: {
                                        marginTop: '8px',
                                        display: 'block',
                                        opacity: 0.7
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                        children: "Click for details"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                    children: capability
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: "(not present)"
                                })
                            ]
                        }),
                        placement: "top",
                        slotProps: {
                            tooltip: {
                                sx: {
                                    fontSize: '.8rem'
                                }
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            onClick: (e)=>handleClick(e, capability, sensors),
                            sx: (theme)=>({
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '2px',
                                    minWidth: '28px',
                                    position: 'relative',
                                    opacity: isPresent ? 1 : 0.3,
                                    filter: isPresent ? 'none' : 'grayscale(100%)',
                                    cursor: isPresent ? 'pointer' : 'default',
                                    color: isPresent ? theme.palette.mode === 'dark' ? '#fff' : '#000' : theme.palette.mode === 'dark' ? '#555' : '#aaa',
                                    '&:hover': isPresent ? {
                                        color: theme.palette.primary.main
                                    } : {}
                                }),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        position: 'relative',
                                        display: 'inline-flex'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)(DisplayIcon, {
                                            fontSize: "small"
                                        }),
                                        !isPresent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            sx: (theme)=>({
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    width: '120%',
                                                    height: '2px',
                                                    bgcolor: theme.palette.mode === 'dark' ? '#555' : '#aaa',
                                                    transform: 'translate(-50%, -50%) rotate(-45deg)',
                                                    pointerEvents: 'none'
                                                })
                                        })
                                    ]
                                }),
                                count > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        fontSize: '0.7em',
                                        fontWeight: 500,
                                        minWidth: '16px'
                                    },
                                    children: [
                                        "x",
                                        count
                                    ]
                                }),
                                count <= 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        fontSize: '0.7em',
                                        minWidth: '16px',
                                        visibility: 'hidden'
                                    },
                                    children: "x1"
                                })
                            ]
                        })
                    }, capability);
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kGwBF.ClickAwayListener), {
                onClickAway: handleClose,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e76iu.default), {
                    open: open,
                    anchorEl: anchorEl,
                    placement: "bottom-end",
                    disablePortal: false,
                    sx: {
                        zIndex: 1300
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $8AyZl.default), {
                        dense: true,
                        sx: {
                            minWidth: 200,
                            py: 1,
                            bgcolor: 'background.paper',
                            boxShadow: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lofVM.default), {
                                sx: {
                                    pb: 1,
                                    borderBottom: 1,
                                    borderColor: 'divider'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                    primary: popoverCapability,
                                    primaryTypographyProps: {
                                        fontWeight: 600,
                                        fontSize: '0.9em'
                                    }
                                })
                            }),
                            popoverSensors.map((sensor, idx)=>{
                                const SensorIcon = popoverCapability === 'Camera' ? sensor.isThermal ? $6ff2cd56daf2a731$var$ThermalCameraIcon : (0, $cpkHS.default) : null;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lofVM.default), {
                                    component: (0, $lzNIT.Link),
                                    to: `/sensors/${sensor.hw_model}`,
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        '&:hover': {
                                            bgcolor: 'action.hover',
                                            textDecoration: 'none'
                                        }
                                    },
                                    children: [
                                        SensorIcon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                            sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                minWidth: 24
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(SensorIcon, {
                                                fontSize: "small"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19ocJ.default), {
                                            primary: sensor.hw_model,
                                            secondary: sensor.name,
                                            slotProps: {
                                                primary: {
                                                    fontSize: '0.9em',
                                                    fontWeight: 600
                                                },
                                                secondary: {
                                                    fontSize: '0.75em'
                                                }
                                            }
                                        })
                                    ]
                                }, idx);
                            })
                        ]
                    })
                })
            })
        ]
    });
});
function $6ff2cd56daf2a731$export$471f7ae5c4103ae1(val, obj) {
    if (!obj.elapsedTimes) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: `No sys.uptime(s) in ${(0, $bcnr1.NODE_STATUS_RANGE)}`,
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tHF8.default), {
            className: "inactive status-icon"
        })
    });
    let icon;
    if (val == 'reporting') icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7oDS2.default), {
        className: "success status-icon"
    });
    else icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3eYo8.default), {
        className: "failed status-icon"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Last reported metric",
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Sf49.default), {
                    computes: obj.computes,
                    elapsedTimes: obj.elapsedTimes
                })
            ]
        }),
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: icon
    });
}
const $6ff2cd56daf2a731$var$phaseNotes = {
    Maintenance: 'In Maintenance'
};
function $6ff2cd56daf2a731$export$3e54079b8c19673(val, obj) {
    const phase = obj.phase;
    const phaseTitle = $6ff2cd56daf2a731$var$phaseNotes[phase] || phase;
    let icon;
    if (phase == 'Deployed' && val == 'reporting') icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7oDS2.default), {
        className: "success status-icon"
    });
    else if (phase == 'Deployed' && val != 'reporting') icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3eYo8.default), {
        className: "failed status-icon"
    });
    else if (phase == 'Maintenance') icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tHF8.default), {
        className: "in-progress status-icon"
    });
    else if (phase == 'Awaiting Deployment') icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gMdoV.default), {
        className: "inactive status-icon"
    });
    else icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gMdoV.default), {
        className: "inactive status-icon"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: phaseTitle
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                phase == 'Deployed' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Last reported metrics:",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        obj.elapsedTimes ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Sf49.default), {
                            computes: obj.computes,
                            elapsedTimes: obj.elapsedTimes
                        }) : `No sys.uptime(s) in ${0, $bcnr1.NODE_STATUS_RANGE}`
                    ]
                })
            ]
        }),
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: icon
    });
}
function $6ff2cd56daf2a731$export$79d2fcaae6f983d2(vsn, node) {
    const { site_id: site_id } = node;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
        to: `/nodes/${vsn}`,
        children: site_id || vsn
    });
}
function $6ff2cd56daf2a731$export$a58c2e09e934e8de(vsn, node) {
    const { site_id: site_id } = node;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
        to: `/nodes/${vsn}`,
        children: [
            site_id || vsn,
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                className: "muted",
                children: site_id && `${vsn}`
            })
        ]
    });
}
function $6ff2cd56daf2a731$export$87c5915dce4f3d55(vsn, node) {
    const { site_id: site_id } = node;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: `/nodes/${vsn}`,
                children: [
                    site_id || vsn,
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                        className: "muted",
                        children: site_id && `${vsn}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                placement: "top",
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Edit node meta ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wXDx.default), {
                            style: {
                                fontSize: '1.1em'
                            }
                        })
                    ]
                }),
                className: "edit-btn" // show/hide on hover with css
                ,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    href: `${(0, $gZwVy.default).auth}/admin/manifests/nodedata/${node.id}`,
                    onClick: (evt)=>evt.stopPropagation(),
                    target: "_blank",
                    rel: "noreferrer",
                    size: "small",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {
                        fontSize: "small"
                    })
                })
            })
        ]
    });
}
function $6ff2cd56daf2a731$export$5833d250cf25565(vsn, node) {
    const { site_id: site_id } = node;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
        to: `/nodes/${vsn}`,
        children: site_id || vsn
    });
}
function $6ff2cd56daf2a731$export$f9f335100cd793ae(vsn, node) {
    const { site_id: site_id } = node;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            site_id || vsn,
            "\xa0",
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                className: "muted",
                children: site_id && vsn
            })
        ]
    });
}
function $6ff2cd56daf2a731$export$a2c7a7007afa5ce3(vsn, site_id) {
    return `${site_id || vsn}${site_id ? ` | ${vsn}` : ''}`;
}
function $6ff2cd56daf2a731$export$e33911e8509f994e(vsn, site_id) {
    return `${site_id || vsn}${site_id ? ` (${vsn})` : ''}`;
}
function $6ff2cd56daf2a731$export$d7ddd398f22d79ef(focus, { partner: partner }) {
    return !focus && !partner ? '-' : `${focus ? focus : ''}${partner ? ` (${partner})` : ''}`;
}
function $6ff2cd56daf2a731$export$f643ac6ce14a8380(_, obj, newline = false) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "gps-icon",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$export$bc464412ef24ea1, {
                    obj: obj
                })
            }),
            !obj.lat || !obj.lng ? '-' : `${obj.lat},` + (newline ? '\n' : '') + `${obj.lng}`
        ]
    });
}
function $6ff2cd56daf2a731$export$c60d1a715a48771d(elapsedTimes, obj) {
    if (!elapsedTimes) return '-';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Sf49.default), {
        computes: obj.computes,
        elapsedTimes: elapsedTimes
    });
}
function $6ff2cd56daf2a731$export$1a9b4dbc2de8b541(val) {
    if (!val) return '-';
    return Object.keys(val).map((host)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: $lffEs.prettyTime(val[host])
        }, host));
}
function $6ff2cd56daf2a731$export$e44cff07f1ac18a5(_, obj) {
    const hwModel = obj.modem_model;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                className: "muted font-bold",
                children: obj.modem_carrier ? 'Cellular Connected' : hwModel ? /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                    children: "No Sim Configured"
                }) : '-'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: hwModel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                    to: `/nodes/${obj.vsn}?tab=peripherals`,
                    children: hwModel
                })
            })
        ]
    });
}
function $6ff2cd56daf2a731$export$244d7de2e4c18d10(_, obj) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                className: "muted",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: obj.modem_carrier_name
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    obj.modem_carrier || '-',
                    ' ',
                    obj.modem_sim && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "muted",
                        children: obj.modem_sim
                    })
                ]
            })
        ]
    });
}
function $6ff2cd56daf2a731$export$5e29c62e7b3a6e93(props) {
    const { data: data, path: path } = props;
    if (!data.length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "-"
    });
    const len = data.length;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        children: data.map((sensor, i)=>{
            const { hw_model: hw_model, name: name } = sensor;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        placement: "top",
                        title: name,
                        children: path ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                            to: `${path}${hw_model}`,
                            children: hw_model
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: hw_model
                        })
                    }),
                    i < len - 1 && ', '
                ]
            }, i);
        })
    });
}
const $6ff2cd56daf2a731$var$HardwareRoot = (0, $lmFrL.default).ul`
  padding: 0;
  font-size: 9pt;
  list-style: none;
  li {
    white-space: nowrap;
  }
`;
const $6ff2cd56daf2a731$var$capabilityAbbrev = {
    'Temperature': 'Temp',
    'Humidity': 'RH',
    'Pressure': 'Pa',
    'Air Quality': 'AQ',
    'Particulate Matter': 'PM',
    'Wind Speed': 'Wind',
    'Wind Direction': 'Dir',
    'Precipitation': 'Precip',
    'Solar Radiation': 'Solar',
    'Microphone': 'Mic'
};
function $6ff2cd56daf2a731$export$d87f54151884e13c(props) {
    const { data: data, path: path } = props;
    if (!data.length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "-"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)'
        },
        children: data.map((sensor, i)=>{
            const { hw_model: hw_model, name: name, capabilities: capabilities } = sensor;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        placement: "top",
                        title: name,
                        children: path ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                            to: `${path}${hw_model}`,
                            children: hw_model
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: hw_model
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "muted",
                        style: {
                            fontSize: '8pt'
                        },
                        children: capabilities.map((v)=>$6ff2cd56daf2a731$var$capabilityAbbrev[v] || v).join(', ')
                    })
                ]
            }, i);
        })
    });
}
const $6ff2cd56daf2a731$var$TT = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        placement: "right",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: props.children
        })
    });
function $6ff2cd56daf2a731$export$aac50aa52f5e3109(v, obj) {
    const { sensors: sensors } = obj;
    const sens = sensors.filter(({ name: name })=>name.match(/top|raingauge/gi));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        children: sens.map(({ name: name, hw_model: hw_model, hardware: hardware }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$TT, {
                    title: `${name} | ${hardware}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${hw_model}`,
                        children: hw_model
                    })
                })
            }, i))
    });
}
function $6ff2cd56daf2a731$export$bfede27384866c0d(v, obj) {
    const { sensors: sensors } = obj;
    const sens = sensors.filter(({ name: name })=>name.match(/bottom/gi));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        children: sens.map(({ name: name, hw_model: hw_model, hardware: hardware }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$TT, {
                    title: `${name} | ${hardware}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${hw_model}`,
                        children: hw_model
                    })
                })
            }, i))
    });
}
function $6ff2cd56daf2a731$export$3bbc953b0539d336(v, obj) {
    const { sensors: sensors } = obj;
    const sens = sensors.filter(({ name: name })=>name?.match(/left/gi));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        children: sens.map(({ name: name, hw_model: hw_model, hardware: hardware }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$TT, {
                    title: `${name} | ${hardware}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${hw_model}`,
                        children: hw_model
                    })
                })
            }, i))
    });
}
function $6ff2cd56daf2a731$export$c5572b88f2a883c7(v, obj) {
    const { sensors: sensors } = obj;
    const sens = sensors.filter(({ name: name, scope: scope })=>(name.match(/right/gi) || (scope || '').match(/^rpi$/i)) && !name.match(/raingauge/gi));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        children: sens.map(({ name: name, hw_model: hw_model, hardware: hardware }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$TT, {
                    title: `${name} | ${hardware}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${hw_model}`,
                        children: hw_model
                    })
                })
            }, i))
    });
}
function $6ff2cd56daf2a731$export$243ab2730ef0997a(v, obj) {
    const { sensors: sensors } = obj;
    const sens = sensors.filter(({ name: name })=>!name?.match(/top|bottom|left|right|gps|bme280|microphone|raingauge|bme680/gi));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$HardwareRoot, {
        children: sens.map(({ name: name, hw_model: hw_model, hardware: hardware }, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6ff2cd56daf2a731$var$TT, {
                    title: `${name} | ${hardware}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${hw_model}`,
                        children: hw_model
                    })
                })
            }, i))
    });
}

});
parcelRegister("fagfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a465815ebe726f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $9D07P = parcelRequire("9D07P");

var $8Indx = parcelRequire("8Indx");

var $17KyE = parcelRequire("17KyE");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $8FqN6 = parcelRequire("8FqN6");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b0a465815ebe726f$var$RADIUS_STANDARD = 10;
const $b0a465815ebe726f$var$RADIUS_DOT = 4;
const $b0a465815ebe726f$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $jTnBY.default)(anchorOrigin.vertical)}${(0, $jTnBY.default)(anchorOrigin.horizontal)}${(0, $jTnBY.default)(overlap)}`,
            `overlap${(0, $jTnBY.default)(overlap)}`,
            color !== 'default' && `color${(0, $jTnBY.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8FqN6.getBadgeUtilityClass), classes);
};
const $b0a465815ebe726f$var$BadgeRoot = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $b0a465815ebe726f$var$BadgeBadge = (0, $d8seH.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $jTnBY.default)(ownerState.anchorOrigin.vertical)}${(0, $jTnBY.default)(ownerState.anchorOrigin.horizontal)}${(0, $jTnBY.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $b0a465815ebe726f$var$RADIUS_STANDARD * 2,
        borderRadius: $b0a465815ebe726f$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $b0a465815ebe726f$var$RADIUS_DOT,
                    height: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    minWidth: $b0a465815ebe726f$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $8FqN6.default).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $b0a465815ebe726f$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $b0a465815ebe726f$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $17KyE.default)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $9D07P.default)({
        anchorOrigin: $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $b0a465815ebe726f$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $b0a465815ebe726f$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $6lpak.default)('root', {
        elementType: $b0a465815ebe726f$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $6lpak.default)('badge', {
        elementType: $b0a465815ebe726f$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $b0a465815ebe726f$export$2e2bcd8739ae039 = $b0a465815ebe726f$var$Badge;

});
parcelRegister("17KyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1a8f518d4ece30$export$2e2bcd8739ae039);

var $9D07P = parcelRequire("9D07P");
'use client';
/**
 *
 * Demos:
 *
 * - [Badge](https://mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */ function $0d1a8f518d4ece30$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $9D07P.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $0d1a8f518d4ece30$export$2e2bcd8739ae039 = $0d1a8f518d4ece30$var$useBadge;

});

parcelRegister("8FqN6", function(module, exports) {

$parcel$export(module.exports, "getBadgeUtilityClass", () => $64f6ef338eb74fbc$export$aaccef17e6dab084);
$parcel$export(module.exports, "default", () => $64f6ef338eb74fbc$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64f6ef338eb74fbc$export$aaccef17e6dab084(slot) {
    return (0, $4Cod0.default)('MuiBadge', slot);
}
const $64f6ef338eb74fbc$var$badgeClasses = (0, $beCSm.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $64f6ef338eb74fbc$export$2e2bcd8739ae039 = $64f6ef338eb74fbc$var$badgeClasses;

});


parcelRegister("lofVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92832698674c928$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");



var $c1jOg = parcelRequire("c1jOg");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $cpXNi = parcelRequire("cpXNi");

var $9Rgf1 = parcelRequire("9Rgf1");

var $3W6ht = parcelRequire("3W6ht");

var $fiKZz = parcelRequire("fiKZz");

var $dUgGz = parcelRequire("dUgGz");

var $d9alg = parcelRequire("d9alg");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f92832698674c928$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $f92832698674c928$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fiKZz.getListItemUtilityClass), classes);
};
const $f92832698674c928$export$aed538f7519abe89 = (0, $d8seH.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $f92832698674c928$export$4334bb34c76fef24
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $dUgGz.default).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $f92832698674c928$var$ListItemContainer = (0, $d8seH.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $f92832698674c928$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in v7
    const hasSecondaryAction = children.length && (0, $cpXNi.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $f92832698674c928$var$useUtilityClasses(ownerState);
    const handleRef = (0, $9Rgf1.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $f92832698674c928$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $5FMfE.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in v7
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f92832698674c928$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $5FMfE.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $c1jOg.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3W6ht.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $c1jOg.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9alg.default), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $f92832698674c928$export$2e2bcd8739ae039 = $f92832698674c928$var$ListItem;

});
parcelRegister("fiKZz", function(module, exports) {

$parcel$export(module.exports, "getListItemUtilityClass", () => $b23cfd2067550897$export$5682c366c0c669d9);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b23cfd2067550897$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $b23cfd2067550897$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $b23cfd2067550897$export$2e2bcd8739ae039 = $b23cfd2067550897$var$listItemClasses;

});

parcelRegister("dUgGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1fd72c2634274a8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $a1fd72c2634274a8$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$export$2e2bcd8739ae039 = $a1fd72c2634274a8$var$listItemButtonClasses;

});

parcelRegister("d9alg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9924235485c5a222$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $3W6ht = parcelRequire("3W6ht");

var $7lon8 = parcelRequire("7lon8");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9924235485c5a222$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7lon8.getListItemSecondaryActionClassesUtilityClass), classes);
};
const $9924235485c5a222$var$ListItemSecondaryActionRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $9924235485c5a222$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $9924235485c5a222$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9924235485c5a222$var$ListItemSecondaryActionRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$9924235485c5a222$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $9924235485c5a222$export$2e2bcd8739ae039 = $9924235485c5a222$var$ListItemSecondaryAction;

});
parcelRegister("7lon8", function(module, exports) {

$parcel$export(module.exports, "getListItemSecondaryActionClassesUtilityClass", () => $558d665a4b71ad4c$export$ccdb26aeba48a86e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $558d665a4b71ad4c$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $558d665a4b71ad4c$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $558d665a4b71ad4c$export$2e2bcd8739ae039 = $558d665a4b71ad4c$var$listItemSecondaryActionClasses;

});



parcelRegister("19ocJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d696835f9b43a35$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $3bYfT = parcelRequire("3bYfT");
var $bhKtZ = parcelRequire("bhKtZ");

var $3W6ht = parcelRequire("3W6ht");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $guz4p = parcelRequire("guz4p");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d696835f9b43a35$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $guz4p.getListItemTextUtilityClass), classes);
};
const $0d696835f9b43a35$var$ListItemTextRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $guz4p.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $guz4p.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $bhKtZ.default).root}:where(& .${(0, $guz4p.default).primary})`]: {
        display: 'block'
    },
    [`.${(0, $bhKtZ.default).root}:where(& .${(0, $guz4p.default).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $0d696835f9b43a35$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $acw62.useContext((0, $3W6ht.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $0d696835f9b43a35$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        className: (0, $5FMfE.default)(classes.root, className),
        elementType: $0d696835f9b43a35$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $6lpak.default)('primary', {
        className: classes.primary,
        elementType: (0, $3bYfT.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $6lpak.default)('secondary', {
        className: classes.secondary,
        elementType: (0, $3bYfT.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $3bYfT.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $3bYfT.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $0d696835f9b43a35$export$2e2bcd8739ae039 = $0d696835f9b43a35$var$ListItemText;

});

parcelRegister("cpkHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9087e1bbffb7c4b4$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $9087e1bbffb7c4b4$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V6h4.05l1.83-2h4.24l1.83 2H20zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3"
}), 'CameraAltOutlined');

});

parcelRegister("7oDS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5629b3c2ff348f02$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5629b3c2ff348f02$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.29 16.29 5.7 12.7a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0"
}), 'CheckCircleRounded');

});

parcelRegister("jsmYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a2749bcbc8e781$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e2a2749bcbc8e781$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 5.53 12.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41a.996.996 0 0 0-1.41 0z"
}), 'CheckRounded');

});

parcelRegister("hAiFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd4473bf517ef36$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ccd4473bf517ef36$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');

});

parcelRegister("3eYo8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c185c416a73efe$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $25c185c416a73efe$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1m-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m1-3h-2v-2h2z"
}), 'ErrorOutlineRounded');

});

parcelRegister("7wXDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b9c827d6baebf4$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $57b9c827d6baebf4$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1M14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V3h-6c-.55 0-1 .45-1 1"
}), 'LaunchRounded');

});

parcelRegister("gMdoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36b8637c1e94077$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c36b8637c1e94077$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "7",
        cy: "12",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "1.5"
    }, "2"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "17",
        cy: "12",
        r: "1.5"
    }, "3")
], 'PendingOutlined');

});

parcelRegister("7tHF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $571d1c4f295b6861$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $571d1c4f295b6861$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
}), 'ReportProblemOutlined');

});

parcelRegister("h1Bqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64f8fcfb523b66f$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c64f8fcfb523b66f$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "12",
        cy: "9",
        r: "2.5"
    }, "1")
], 'RoomOutlined');

});

parcelRegister("32iEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $23600767524c22d8$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $23600767524c22d8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67M11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8"
}), 'Whatshot');

});

parcelRegister("9Sf49", function(module, exports) {

$parcel$export(module.exports, "default", () => $a093a6a6a6a8c8f9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $aQAPf = parcelRequire("aQAPf");

var $lffEs = parcelRequire("lffEs");

var $bcnr1 = parcelRequire("bcnr1");

var $9bsRS = parcelRequire("9bsRS");
const $a093a6a6a6a8c8f9$var$FAIL_THRES = (0, $aQAPf.default).elapsedThresholds.fail;
const $a093a6a6a6a8c8f9$var$WARNING_THRES = (0, $aQAPf.default).elapsedThresholds.warning;
function $a093a6a6a6a8c8f9$export$2e2bcd8739ae039(props) {
    const { computes: computes, elapsedTimes: elapsedTimes } = props;
    if (!computes || !elapsedTimes) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "muted",
        children: [
            "no sys.uptime(s) for ",
            (0, $bcnr1.NODE_STATUS_RANGE)
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: computes.map((obj, i)=>{
            const { serial_no: serial_no, name: name, is_active: is_active } = obj;
            const host = $9bsRS.findHostWithSerial(Object.keys(elapsedTimes), serial_no);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    name,
                    ": ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        className: is_active ? $a093a6a6a6a8c8f9$export$1e13103466f9ba7b(elapsedTimes[host], $a093a6a6a6a8c8f9$var$FAIL_THRES, $a093a6a6a6a8c8f9$var$WARNING_THRES, 'success font-bold') : 'inactive font-bold',
                        children: host in (elapsedTimes || {}) ? (0, $lffEs.msToTime)(elapsedTimes[host]) : `no sys.uptime for ${0, $bcnr1.NODE_STATUS_RANGE}`
                    })
                ]
            }, i);
        })
    });
}
function $a093a6a6a6a8c8f9$export$1e13103466f9ba7b(val, severe, warning, defaultClass) {
    if (!val || val >= severe) return 'severe font-bold';
    else if (val > warning) return 'warning font-bold';
    else if (defaultClass) return defaultClass;
    return '';
}

});
parcelRegister("lffEs", function(module, exports) {

$parcel$export(module.exports, "quickRanges", () => $eda3dce920186bdc$export$1945ae4f48e48202);
$parcel$export(module.exports, "prettyTime", () => $eda3dce920186bdc$export$c4b27eca7f2b6f82);
$parcel$export(module.exports, "prettyTimeMS", () => $eda3dce920186bdc$export$502e1442fc03e9b8);
$parcel$export(module.exports, "bytesToSizeSI", () => $eda3dce920186bdc$export$1eb93c870bb14f7);
$parcel$export(module.exports, "msToTime", () => $eda3dce920186bdc$export$967b849b2dd25d36);
$parcel$export(module.exports, "msToTimeApprox", () => $eda3dce920186bdc$export$d9ded27c5859ef7d);
$parcel$export(module.exports, "relativeTime", () => $eda3dce920186bdc$export$caddcc104251c1d7);
$parcel$export(module.exports, "isOldData", () => $eda3dce920186bdc$export$c37396df54f43724);
$parcel$export(module.exports, "prettyList", () => $eda3dce920186bdc$export$9ff07479f18510bd);
$parcel$export(module.exports, "getRangeTitle", () => $eda3dce920186bdc$export$9cda298bc6b45a8d);
const $eda3dce920186bdc$export$1945ae4f48e48202 = {
    'custom': 'Custom range',
    '-1m': 'last minute',
    '-5m': 'last 5 mins',
    '-30m': 'last 30 mins',
    '-1h': 'last hour',
    '-12h': 'last 12 hours',
    '-1d': 'last day',
    '-2d': 'last 2 days',
    '-7d': 'last 7 days',
    '-30d': 'last 30 days [slow]',
    '-90d': 'last 90 days [very slow]'
};
function $eda3dce920186bdc$export$c4b27eca7f2b6f82(secs) {
    if (!secs && secs != 0) return;
    const days = Math.floor(secs / 86400);
    const parts = new Date(secs * 1000).toISOString().slice(11, 19).split(':');
    const h = parseInt(parts[0]), m = parseInt(parts[1]), s = parseInt(parts[2]);
    const time = `${days > 0 ? days + 'd ' : ''}` + (h > 0 ? `${h}h ` : '') + (m > 0 ? `${m}m ` : '') + (s > 0 ? `${s}s ` : '');
    return time;
}
function $eda3dce920186bdc$export$502e1442fc03e9b8(secs) {
    if (!secs && secs != 0) return;
    const days = Math.floor(secs / 86400);
    const d = new Date(secs * 1000);
    const parts = d.toISOString().slice(11, 19).split(':');
    const h = parseInt(parts[0]), m = parseInt(parts[1]), s = parseInt(parts[2]);
    const ms = d.getMilliseconds();
    const time = `${days > 0 ? days + 'd ' : ''}` + (h > 0 ? `${h}h ` : '') + (m > 0 ? `${m}m ` : '') + (s > 0 ? `${s}s ` : '') + (ms > 0 ? `${ms}ms` : '');
    return time;
}
function $eda3dce920186bdc$export$7976203e4ba9fcf2(bytes) {
    if (!bytes && bytes != 0) return;
    const sizes = [
        'Bytes',
        'KiB',
        'MiB',
        'GiB',
        'TiB'
    ];
    if (bytes == 0) return '0 Byte';
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}
function $eda3dce920186bdc$export$1eb93c870bb14f7(bytes) {
    if (!bytes && bytes != 0) return;
    const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB'
    ];
    if (bytes == 0) return '0 Byte';
    const i = Math.floor(Math.log(bytes) / Math.log(1000));
    return (bytes / Math.pow(1000, i)).toFixed(2) + ' ' + sizes[i];
}
function $eda3dce920186bdc$export$967b849b2dd25d36(ms) {
    if (!ms && ms != 0) return;
    const secs = Number((ms / 1000).toFixed(1));
    const mins = Number((ms / 60000).toFixed(1));
    const hours = Number((ms / 3600000).toFixed(1));
    const days = Number((ms / 86400000).toFixed(1));
    if (secs < 60) return `${secs} sec${secs != 1 ? 's' : ''}  ago`;
    else if (mins < 60) return mins + ' min ago';
    else if (hours < 24) return hours + ' hrs ago';
    else return days + ' days ago';
}
function $eda3dce920186bdc$export$d9ded27c5859ef7d(ms) {
    if (!ms && ms != 0) return;
    const secs = Math.floor(ms / 1000);
    const mins = Math.floor(ms / 60000);
    const hours = Math.floor(ms / 3600000);
    const days = Math.floor(ms / 86400000);
    if (secs < 60) return `${secs} sec${secs != 1 ? 's' : ''}  ago`;
    else if (mins < 60) return `${mins} min${mins != 1 ? 's' : ''} ago`;
    else if (hours < 24) return `${hours} hr${hours != 1 ? 's' : ''} ago`;
    else return `${days} day${days != 1 ? 's' : ''} ago`;
}
function $eda3dce920186bdc$export$caddcc104251c1d7(val) {
    if (!val) return;
    return $eda3dce920186bdc$export$967b849b2dd25d36(new Date().getTime() - new Date(val).getTime());
}
function $eda3dce920186bdc$export$c37396df54f43724(timestamp, grain = 'hours', amount = 2) {
    const date = new Date(timestamp);
    let d;
    if (grain == 'hours') {
        d = new Date();
        d.setHours(d.getHours() - amount);
    } else if (grain == 'minutes') {
        d = new Date();
        d.setMinutes(d.getMinutes() - amount);
    }
    return date < d;
}
function $eda3dce920186bdc$export$9ff07479f18510bd(l) {
    return l.length > 1 ? `${l.slice(0, -1).join(', ')} and ${l.slice(-1)}` : l[0];
}
function $eda3dce920186bdc$export$9cda298bc6b45a8d(str) {
    if (str.match(/-[0-9]+d/)) return `Last ${str.replace(/-|d/g, '')} days of data`;
    else if (str.match(/-[0-9]+y/)) return `Last ${str.replace(/-|y/g, '')} year of data`;
    return str;
}

});


parcelRegister("7cKF8", function(module, exports) {

$parcel$export(module.exports, "capabilityIcons", () => $c0e187e54b5e79de$export$f1e14b870fdde156);
$parcel$export(module.exports, "getCapabilityIcon", () => $c0e187e54b5e79de$export$f7c72a4652ef2b0e);

var $ayMG0 = parcelRequire("ayMG0");

var $bKhW7 = parcelRequire("bKhW7");
var $7MzKe = parcelRequire("7MzKe");
var $cpkHS = parcelRequire("cpkHS");
var $9DQJ8 = parcelRequire("9DQJ8");
var $a8Oly = parcelRequire("a8Oly");
var $ghHtO = parcelRequire("ghHtO");
var $4qq6t = parcelRequire("4qq6t");
var $eBSuj = parcelRequire("eBSuj");
var $gvNLa = parcelRequire("gvNLa");
var $h1Bqv = parcelRequire("h1Bqv");
var $i2GhY = parcelRequire("i2GhY");
var $hBjej = parcelRequire("hBjej");
var $fhzQP = parcelRequire("fhzQP");

var $iZkyd = parcelRequire("iZkyd");

var $4Fns4 = parcelRequire("4Fns4");

var $kaw13 = parcelRequire("kaw13");
const $c0e187e54b5e79de$export$f1e14b870fdde156 = {
    Camera: (0, $cpkHS.default),
    Microphone: (0, $4qq6t.default),
    GPS: (0, $h1Bqv.default),
    Precipitation: (0, $iZkyd.default),
    Temperature: (0, $fhzQP.default),
    Pressure: (0, $9DQJ8.default),
    Humidity: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Fns4.default), {}),
    Gas: (0, $a8Oly.default),
    'Particulate Matter': (0, $ghHtO.default),
    Wind: (0, $bKhW7.default),
    Moisture: (0, $gvNLa.default),
    Biological: (0, $7MzKe.default),
    Chemical: (0, $hBjej.default),
    Accelerometer: (0, $kaw13.default),
    lorawan: (0, $i2GhY.default),
    'Additional Sensors/Capabilities': (0, $eBSuj.default),
    'Thermal Camera': (0, $cpkHS.default)
};
const $c0e187e54b5e79de$export$f7c72a4652ef2b0e = (capability)=>{
    const Icon = $c0e187e54b5e79de$export$f1e14b870fdde156[capability];
    if (!Icon) return null;
    // Handle function components (like Humidity)
    if (typeof Icon === 'function' && Icon.name && Icon.name !== 'SvgIcon') return /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {});
    // Handle MUI icon components
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
        fontSize: "small"
    });
};

});
parcelRegister("bKhW7", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d1e75ff02e690c$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $88d1e75ff02e690c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3h2c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1H2v-2h9.5c1.65 0 3 1.35 3 3M19 6.5C19 4.57 17.43 3 15.5 3S12 4.57 12 6.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S16.33 8 15.5 8H2v2h13.5c1.93 0 3.5-1.57 3.5-3.5m-.5 4.5H2v2h16.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5v2c1.93 0 3.5-1.57 3.5-3.5S20.43 11 18.5 11"
}), 'Air');

});

parcelRegister("7MzKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5aa8be3f47368a9e$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5aa8be3f47368a9e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.48 8 15.23 8 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69zm-6 2h4v2h-4zm0-4h4v2h-4z"
}), 'BugReportOutlined');

});

parcelRegister("9DQJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7050a812a60c4f0d$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $7050a812a60c4f0d$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8 19h3v3h2v-3h3l-4-4zm8-15h-3V1h-2v3H8l4 4zM4 9v2h16V9zm0 3h16v2H4z"
}), 'Compress');

});

parcelRegister("a8Oly", function(module, exports) {

$parcel$export(module.exports, "default", () => $7621b48448576332$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $7621b48448576332$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4m2 14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M9.5 15.54C9.5 16.9 10.62 18 12 18s2.5-1.1 2.5-2.46c0-1.09-.45-1.41-2.5-3.79-2.07 2.4-2.5 2.71-2.5 3.79M8 8h8v2H8z"
    }, "1")
], 'GasMeterOutlined');

});

parcelRegister("ghHtO", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdaff60a36efb092$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bdaff60a36efb092$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'Grain');

});

parcelRegister("4qq6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $338dd6b4a4479272$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $338dd6b4a4479272$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3m5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72z"
}), 'Mic');

});

parcelRegister("eBSuj", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa2ec9879b40d53e$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $aa2ec9879b40d53e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H7.07L2.4 12l4.66-7H22z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "9",
        cy: "12",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "14",
        cy: "12",
        r: "1.5"
    }, "2"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "19",
        cy: "12",
        r: "1.5"
    }, "3")
], 'MoreOutlined');

});

parcelRegister("gvNLa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c05623d3f531f023$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c05623d3f531f023$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.66 8 12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8M6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14z"
}), 'OpacityOutlined');

});

parcelRegister("i2GhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d22937943d9278f2$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d22937943d9278f2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16 4.2c1.5 0 3 .6 4.2 1.7l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2m-3.3 2.5.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1l.8-.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4M19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2m0 6H5v-4h14zM6 16h2v2H6zm3.5 0h2v2h-2zm3.5 0h2v2h-2z"
}), 'RouterOutlined');

});

parcelRegister("hBjej", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd04cf0393370600$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cd04cf0393370600$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 11.33 18 18H6l5-6.67V6h2m2.96-2H8.04c-.42 0-.65.48-.39.81L9 6.5v4.17L3.2 18.4c-.49.66-.02 1.6.8 1.6h16c.82 0 1.29-.94.8-1.6L15 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81"
}), 'ScienceOutlined');

});

parcelRegister("fhzQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b20440d82ba65b13$export$2e2bcd8739ae039);

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b20440d82ba65b13$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4m-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1h-1v1h1v2h-1v1h1v1z"
}), 'Thermostat');

});

parcelRegister("iZkyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f3357294e2d34cb$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $2f3357294e2d34cb$var$SvgWeathermix = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "#5f6368",
        viewBox: "0 -960 960 960",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M500-40q-25 0-42.5-17T440-99q0-12 4.5-23t13.5-19l42-39 42 39q9 8 13.5 19t4.5 23q0 25-17.5 42T500-40m-138-60-42-42 118-118 42 42zm258-60-60-60 60-60 60 60zm-360 0-60-60 60-60 60 60zm40-160q-91 0-155.5-64.5T80-540q0-83 55-145t136-73q32-57 87.5-89.5T480-880q90 0 156.5 57.5T717-679q69 6 116 57t47 122q0 75-52.5 127.5T700-320zm0-80h400q42 0 71-29t29-71-29-71-71-29h-60v-40q0-66-47-113t-113-47q-48 0-87.5 26T333-704l-10 24h-25q-57 2-97.5 42.5T160-540q0 58 41 99t99 41m180-200"
        })
    });
var $2f3357294e2d34cb$export$2e2bcd8739ae039 = $2f3357294e2d34cb$var$SvgWeathermix;

});

parcelRegister("4Fns4", function(module, exports) {

$parcel$export(module.exports, "default", () => $660c40362ef4a24c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $660c40362ef4a24c$var$SvgHumidity = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "#5f6368",
        viewBox: "0 -960 960 960",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M440-142q-118-15-199-104t-81-210q0-66 24.5-122.5T254-678l226-222 226 222q36 36 59.5 81t31.5 97h-81q-7-34-23.5-64.5T650-620L480-788 310-620q-35 33-52.5 74.5T240-456q0 87 57.5 153T440-223zm92-191-24-55q26-14 54.5-23t57.5-9q23 0 45.5 5.5T709-401q18 8 36.5 14t38.5 6q23 0 45-8t43-19l24 55q-26 14-54.5 23t-57.5 9q-23 0-45.5-5.5T695-340q-18-8-36.5-14t-38.5-6q-23 0-45 8t-43 19m0 120-24-55q26-14 54.5-23t57.5-9q23 0 45.5 5.5T709-281q18 8 36.5 14t38.5 6q23 0 45-8t43-19l24 55q-26 14-54.5 23t-57.5 9q-23 0-45.5-5.5T695-220q-18-8-36.5-14t-38.5-6q-23 0-45 8t-43 19m0 120-24-55q26-14 54.5-23t57.5-9q23 0 45.5 5.5T709-161q18 8 36.5 14t38.5 6q23 0 45-8t43-19l24 55q-26 14-54.5 23T784-81q-23 0-45.5-5.5T695-100q-18-8-36.5-14t-38.5-6q-23 0-45 8t-43 19"
        })
    });
var $660c40362ef4a24c$export$2e2bcd8739ae039 = $660c40362ef4a24c$var$SvgHumidity;

});

parcelRegister("kaw13", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b84b2f92ff556c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $b5b84b2f92ff556c$var$SvgLevel = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "#5f6368",
        viewBox: "0 -960 960 960",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M160-280q-33 0-56.5-23.5T80-360v-240q0-33 23.5-56.5T160-680h640q33 0 56.5 23.5T880-600v240q0 33-23.5 56.5T800-280zm0-80h640v-240h-94q7 14 10.5 29t3.5 31q0 57-41.5 98.5T580-400H380q-57 0-98.5-41.5T240-540q0-16 3.5-31t10.5-29h-94zm220-120h60v-120h-60q-24 0-42 18t-18 42 18 42 42 18m140 0h60q24 0 42-18t18-42-18-42-42-18h-60zm280 120H160z"
        })
    });
var $b5b84b2f92ff556c$export$2e2bcd8739ae039 = $b5b84b2f92ff556c$var$SvgLevel;

});





parcelRegister("8IuK2", function(module, exports) {

$parcel$export(module.exports, "queryData", () => $3cfd63de86e8f53f$export$3c598703d99462f5);
$parcel$export(module.exports, "createRules", () => $3cfd63de86e8f53f$export$826a84970f4c98e0);
$parcel$export(module.exports, "parseRules", () => $3cfd63de86e8f53f$export$9ece5110925c75b7);
$parcel$export(module.exports, "parsePlugins", () => $3cfd63de86e8f53f$export$4e493cf19d83a60a);
$parcel$export(module.exports, "appIDToName", () => $3cfd63de86e8f53f$export$2be36449012bae3a);

var $f1q41 = parcelRequire("f1q41");

var $alpjl = parcelRequire("alpjl");

var $gZwVy = parcelRequire("gZwVy");
const $3cfd63de86e8f53f$var$docker = (0, $gZwVy.default).dockerRegistry;
function $3cfd63de86e8f53f$export$3c598703d99462f5(data, query, cols) {
    return data.filter((row)=>Object.values((0, $f1q41.pick)(row, cols)).join('').toLowerCase().includes(query.toLowerCase()));
}
const $3cfd63de86e8f53f$export$13132fccaeb8646a = (rule)=>{
    return rule?.cron || '* * * * *';
};
const $3cfd63de86e8f53f$export$18efa497b083712f = (str)=>{
    const re = new RegExp(/((\*|\?|\d+((\/|-){0,1}(\d+))*)\s*){5}/);
    if (!re.test(str) || str.split(' ').length != 5) throw `Could not parse cron string: ${str}\n` + `Cron strings should be of form: '<min> <hour> <day_of_month> <month> <day_of_week>\n` + `Extended cron syntax is not currently supported.`;
    return {
        action: 'schedule',
        cron: str
    };
};
const $3cfd63de86e8f53f$export$73ed4aed77a0d86a = (args)=>{
    const { func: func, name: name, op: op, value: value } = args;
    if (func == 'any') return `${func}(v('${name}') ${op} ${value})`;
    else return `${func}(v('${name}')) ${op} ${value}`;
};
const $3cfd63de86e8f53f$export$c3f42fadb824b984 = (str)=>{
    const opList = Object.keys((0, $alpjl.ops));
    const re = new RegExp(`(${opList.join('|')})`);
    const parts = str.split(re).map((s)=>s.trim());
    const [exp, op] = parts;
    if (!opList.includes(op)) throw `Invalid comparison operator: ${op}\n` + `Must be one of: ${opList.join(', ')}`;
    // need to remove closing paren if entire if argument to callee is expresssion
    const value = parts[2].replace(/\)/g, '');
    if (parts.length != 3) throw `Invalid conditional expression: ${str}\n` + `Conditions must be of the form: <expression> <comparison_operator> <number|string>`;
    const funcEnd = exp.indexOf('(');
    const nameStart = exp.indexOf(`v('`) + 3;
    const func = exp.slice(0, funcEnd);
    const name = exp.slice(nameStart, exp.indexOf(`')`));
    if (!(0, $alpjl.aggFuncs).includes(func)) throw `Invalid aggregate function: ${func}\n` + `Must be one of: ${(0, $alpjl.aggFuncs).join(', ')}`;
    return {
        func: // @ts-ignore: revisit types if this component is used
        func,
        name: name,
        op: // @ts-ignore: revisit types if this component is used
        op,
        // @ts-ignore: revisit types if this component is used
        value: Number.isNaN(value) ? value : Number(value)
    };
};
const $3cfd63de86e8f53f$export$e35d10f18ff079ba = (str)=>{
    const strs = str.split(/(and|or)/g).map((s)=>s.trim());
    const [ruleStrs, logics] = [
        strs.filter((s)=>!(0, $alpjl.booleanLogics).includes(s)),
        strs.filter((s)=>(0, $alpjl.booleanLogics).includes(s))
    ];
    const conditions = ruleStrs.map((str)=>$3cfd63de86e8f53f$export$c3f42fadb824b984(str));
    return {
        conditions: conditions,
        logics: logics
    };
};
const $3cfd63de86e8f53f$export$1c5fdc105816b5c5 = (appName, rule)=>'name' in rule ? $3cfd63de86e8f53f$export$73ed4aed77a0d86a(rule) : `cronjob('${appName}', '${$3cfd63de86e8f53f$export$13132fccaeb8646a(rule)}')`;
const $3cfd63de86e8f53f$export$20b9491d30766b8e = (str)=>{
    const action = (0, $alpjl.actions).find((action)=>str.startsWith(action));
    if (action == 'schedule') {
        const [actionKeyString, ruleStr] = str.split(': ');
        const app = actionKeyString.match(/\((.+)\)/)[1].replace(/'/g, '');
        if (ruleStr.includes('cronjob')) {
            const cronStr = ruleStr.replace(/cronjob\(|\)/g, '');
            const [appName, cron] = cronStr.split(',').map((s)=>s.trim());
            const rule = $3cfd63de86e8f53f$export$18efa497b083712f(cron);
            return {
                app: appName.replace(/'|"/g, ''),
                rules: [
                    rule
                ],
                logics: []
            };
        // assume v( is conditional rules; todo(nc): should be mixable with cronjobs, maybe use AST parser
        } else if (ruleStr.includes('v(')) {
            const { conditions: conditions, logics: logics } = $3cfd63de86e8f53f$export$e35d10f18ff079ba(ruleStr);
            return {
                app: app,
                rules: conditions,
                logics: logics
            };
        } else throw `can not parse rule: ${str}`;
    } else throw `can not parse rule: ${str}`;
};
const $3cfd63de86e8f53f$export$826a84970f4c98e0 = (appName, action, rules, logics)=>{
    if (action == 'schedule') return `schedule('${appName}'): ` + rules.map((r, i)=>`${$3cfd63de86e8f53f$export$1c5fdc105816b5c5(appName, r)}${i < logics?.length ? ` ${logics[i]} ` : ''}`).join('');
    else if (action == 'publish') return rules.map((r)=>`publish(${r.publish}): ${$3cfd63de86e8f53f$export$1c5fdc105816b5c5(appName, r)}`);
    else if (action == 'set') return rules.map((r)=>{
        const value = Number.isNaN(Number(r.state)) ? `'${r.state}'` : Number(r.state);
        return `set(${r.stateKey}, value=${value}): ${$3cfd63de86e8f53f$export$1c5fdc105816b5c5(appName, r)}`;
    });
};
const $3cfd63de86e8f53f$export$9ece5110925c75b7 = (strs)=>{
    return strs.map((str)=>$3cfd63de86e8f53f$export$20b9491d30766b8e(str));
};
const $3cfd63de86e8f53f$export$4e493cf19d83a60a = (plugins)=>{
    const argStyles = {};
    const params = plugins.reduce((acc, obj)=>{
        const { image: image, args: args } = obj.pluginSpec;
        const mapObj = $3cfd63de86e8f53f$export$424584c2c88e48c0(args);
        const map = mapObj.mapping;
        const id = image.replace(`${$3cfd63de86e8f53f$var$docker}/`, '');
        argStyles[id] = mapObj.argStyle;
        return {
            ...acc,
            [id]: map
        };
    }, {});
    return {
        params: params,
        argStyles: argStyles
    };
};
const $3cfd63de86e8f53f$export$424584c2c88e48c0 = (args = [])=>{
    // infer param style convention
    let argStyle;
    if (args.some((arg)=>arg.startsWith('--'))) argStyle = '--';
    else if (args.some((arg)=>arg.startsWith('-'))) argStyle = '-';
    else throw `No CLI arg convention found.\n` + `App param CLI style is currently inferred from inputs provided to the scheduler, ` + `and perhaps no inputs were given to infer on.`;
    const mapping = args.reduce((acc, str, i)=>{
        const nextIdx = i + 1;
        // inspect next str, and set as false if none provided
        let next = null;
        if (nextIdx < args.length) next = args[nextIdx].startsWith(argStyle) ? false : args[nextIdx];
        // if is a param key, we'll add it to the mapping
        if (str.startsWith(argStyle)) // if no param value, we assume the param is a boolean true, so the value of null
        return {
            ...acc,
            [str.slice(argStyle.length)]: next ? next : null
        };
        return acc;
    }, {});
    return {
        mapping: mapping,
        argStyle: argStyle
    };
};
const $3cfd63de86e8f53f$export$2be36449012bae3a = (id)=>id.slice(id.indexOf('/') + 1, id.lastIndexOf(':'));

});
parcelRegister("alpjl", function(module, exports) {

$parcel$export(module.exports, "booleanLogics", () => $5a18bd1763db660a$export$3b04d71a160fadb2);
$parcel$export(module.exports, "ops", () => $5a18bd1763db660a$export$71689b23c8a2c9c6);
$parcel$export(module.exports, "actions", () => $5a18bd1763db660a$export$e324594224ef24da);
$parcel$export(module.exports, "aggFuncs", () => $5a18bd1763db660a$export$f37460bebc2e1eb2);
// todo(nc): remove this nonsense
const $5a18bd1763db660a$export$3212f69d66adf0f5 = [
    'min',
    'hour',
    'dayOfMonth',
    'month',
    'dayOfWeek',
    '*'
];
const $5a18bd1763db660a$export$3b04d71a160fadb2 = [
    'and',
    'or'
];
const $5a18bd1763db660a$export$71689b23c8a2c9c6 = {
    '<=': "\u2264",
    '>=': "\u2265",
    '!=': "\u2260",
    '=': '=',
    '<': '<',
    '>': '>'
};
const $5a18bd1763db660a$export$e324594224ef24da = [
    'schedule',
    'publish',
    'set'
];
const $5a18bd1763db660a$export$f37460bebc2e1eb2 = [
    'any',
    'avg',
    'sum',
    'count'
];

});


parcelRegister("2esSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a034abd43bd8eee$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $cJQfW = parcelRequire("cJQfW");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $3bYfT = parcelRequire("3bYfT");

var $jTnBY = parcelRequire("jTnBY");

var $7Z1x5 = parcelRequire("7Z1x5");

var $aaphR = parcelRequire("aaphR");

var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1a034abd43bd8eee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $jTnBY.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7Z1x5.getFormControlLabelUtilityClasses), classes);
};
const $1a034abd43bd8eee$export$1b479270917a5676 = (0, $d8seH.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $7Z1x5.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $jTnBY.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $7Z1x5.default).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $7Z1x5.default).label}`]: {
            [`&.${(0, $7Z1x5.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $1a034abd43bd8eee$var$AsteriskComponent = (0, $d8seH.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})((0, $aeD7H.default)(({ theme: theme })=>({
        [`&.${(0, $7Z1x5.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $1a034abd43bd8eee$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $1a034abd43bd8eee$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $6lpak.default)('typography', {
        elementType: (0, $3bYfT.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $3bYfT.default) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $5FMfE.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$export$1b479270917a5676, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1a034abd43bd8eee$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $1a034abd43bd8eee$export$2e2bcd8739ae039 = $1a034abd43bd8eee$var$FormControlLabel;

});
parcelRegister("7Z1x5", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $5cff6b4166fff27c$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $5cff6b4166fff27c$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5cff6b4166fff27c$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$export$2e2bcd8739ae039 = $5cff6b4166fff27c$var$formControlLabelClasses;

});



parcelRegister("hbZ6O", function(module, exports) {
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c842ddb70f8ccad0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842ddb70f8ccad0$var$_createSvgIcon = $c842ddb70f8ccad0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c842ddb70f8ccad0$var$_default = module.exports.default = (0, $c842ddb70f8ccad0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $2BuCw = parcelRequire("2BuCw");
var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

var $6WOpW = parcelRequire("6WOpW");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $4a7ae4f41d656e46$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $4jPsi.default) in themeInput ? themeInput[0, $4jPsi.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6WOpW.default), {
        ...props,
        themeId: scopedTheme ? (0, $4jPsi.default) : undefined,
        theme: scopedTheme || themeInput
    });
}



var $b0NgK = parcelRequire("b0NgK");

var $4jPsi = parcelRequire("4jPsi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $c4650f6dac4940cb$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $acw62.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $4jPsi.default) in theme ? theme[0, $4jPsi.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a7ae4f41d656e46$export$2e2bcd8739ae039), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0NgK.CssVarsProvider), {
        theme: theme,
        ...props
    });
}



var $acw62 = parcelRequire("acw62");


var $aAbgT = parcelRequire("aAbgT");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c3dfe91526ac04a1$var$isDynamicSupport = typeof (0, $aAbgT.globalCss)({}) === 'function';
const $c3dfe91526ac04a1$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $c3dfe91526ac04a1$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $c3dfe91526ac04a1$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $c3dfe91526ac04a1$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$c3dfe91526ac04a1$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $c3dfe91526ac04a1$var$SELECTOR = 'mui-ecs';
const $c3dfe91526ac04a1$var$staticStyles = (theme)=>{
    const result = $c3dfe91526ac04a1$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$c3dfe91526ac04a1$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $c3dfe91526ac04a1$var$GlobalStyles = (0, $aAbgT.globalCss)($c3dfe91526ac04a1$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$c3dfe91526ac04a1$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$c3dfe91526ac04a1$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            $c3dfe91526ac04a1$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($c3dfe91526ac04a1$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$c3dfe91526ac04a1$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $c3dfe91526ac04a1$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $c3dfe91526ac04a1$export$2e2bcd8739ae039 = $c3dfe91526ac04a1$var$CssBaseline;


var $71802778b2667a33$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $71802778b2667a33$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($71802778b2667a33$exports, "__esModule", {
    value: true
});
$71802778b2667a33$exports.default = void 0;

var $71802778b2667a33$var$_createSvgIcon = $71802778b2667a33$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $71802778b2667a33$var$_default = $71802778b2667a33$exports.default = (0, $71802778b2667a33$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39"
}), 'PublicRounded');


var $a61247555e1f801a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a61247555e1f801a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a61247555e1f801a$exports, "__esModule", {
    value: true
});
$a61247555e1f801a$exports.default = void 0;

var $a61247555e1f801a$var$_createSvgIcon = $a61247555e1f801a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a61247555e1f801a$var$_default = $a61247555e1f801a$exports.default = (0, $a61247555e1f801a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircleRounded');


var $dfa080570050ea5e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $dfa080570050ea5e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($dfa080570050ea5e$exports, "__esModule", {
    value: true
});
$dfa080570050ea5e$exports.default = void 0;

var $dfa080570050ea5e$var$_createSvgIcon = $dfa080570050ea5e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $dfa080570050ea5e$var$_default = $dfa080570050ea5e$exports.default = (0, $dfa080570050ea5e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1m0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1M7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1m-3 5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m0-8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1m4 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1m0 4h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1M7 8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1"
}), 'ListRounded');


var $c36a0b95bd5999f0$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c36a0b95bd5999f0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c36a0b95bd5999f0$exports, "__esModule", {
    value: true
});
$c36a0b95bd5999f0$exports.default = void 0;

var $c36a0b95bd5999f0$var$_createSvgIcon = $c36a0b95bd5999f0$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c36a0b95bd5999f0$var$_default = $c36a0b95bd5999f0$exports.default = (0, $c36a0b95bd5999f0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2m0 0c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2"
}), 'TimelineRounded');


var $45d7836043133042$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $45d7836043133042$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($45d7836043133042$exports, "__esModule", {
    value: true
});
$45d7836043133042$exports.default = void 0;

var $45d7836043133042$var$_createSvgIcon = $45d7836043133042$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $45d7836043133042$var$_default = $45d7836043133042$exports.default = (0, $45d7836043133042$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.88 18.47c.48-.77.75-1.67.69-2.66-.13-2.15-1.84-3.97-3.97-4.2-2.72-.3-5.02 1.81-5.02 4.47 0 2.49 2.01 4.5 4.49 4.5.88 0 1.7-.26 2.39-.7l2.41 2.41c.39.39 1.03.39 1.42 0s.39-1.03 0-1.42zm-3.8.11c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5m-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.08 5.01c-.36.58-1.17.64-1.61.13l-2.12-2.47-3.06 4.9c-.31.49-.97.62-1.44.28-.42-.31-.54-.89-.26-1.34l3.78-6.05c.36-.57 1.17-.63 1.61-.12L9 12.5l3.18-5.17c.38-.62 1.28-.64 1.68-.03zm2.59.5c-.64-.28-1.33-.45-2.05-.49L20.8 2.9c.31-.49.97-.61 1.43-.27.43.31.54.9.26 1.34z"
}), 'QueryStatsRounded');


var $c12e6d014cf6703a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c12e6d014cf6703a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c12e6d014cf6703a$exports, "__esModule", {
    value: true
});
$c12e6d014cf6703a$exports.default = void 0;

var $c12e6d014cf6703a$var$_createSvgIcon = $c12e6d014cf6703a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c12e6d014cf6703a$var$_default = $c12e6d014cf6703a$exports.default = (0, $c12e6d014cf6703a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4m13.1-8.16c.01-.11.02-.22.02-.34s-.01-.23-.03-.34l.74-.58c.07-.05.08-.15.04-.22l-.7-1.21c-.04-.08-.14-.1-.21-.08l-.86.35c-.18-.14-.38-.25-.59-.34l-.13-.93c-.02-.09-.09-.15-.18-.15h-1.4c-.09 0-.16.06-.17.15l-.13.93c-.21.09-.41.21-.59.34l-.87-.35c-.08-.03-.17 0-.21.08l-.7 1.21c-.04.08-.03.17.04.22l.74.58c-.02.11-.03.23-.03.34s.01.23.03.34l-.74.58c-.07.05-.08.15-.04.22l.7 1.21c.04.08.14.1.21.08l.87-.35c.18.14.38.25.59.34l.13.93c.01.09.08.15.17.15h1.4c.09 0 .16-.06.17-.15l.13-.93c.21-.09.41-.21.59-.34l.87.35c.08.03.17 0 .21-.08l.7-1.21c.04-.08.03-.17-.04-.22zm-2.6.91c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25m.42 3.93-.5-.87c-.03-.06-.1-.08-.15-.06l-.62.25q-.195-.15-.42-.24l-.09-.66c-.02-.06-.08-.1-.14-.1h-1c-.06 0-.11.04-.12.11l-.09.66c-.15.06-.29.15-.42.24l-.62-.25c-.06-.02-.12 0-.15.06l-.5.87c-.03.06-.02.12.03.16l.53.41c-.01.08-.02.16-.02.24s.01.17.02.24l-.53.41c-.05.04-.06.11-.03.16l.5.87c.03.06.1.08.15.06l.62-.25q.195.15.42.24l.09.66c.01.07.06.11.12.11h1c.06 0 .12-.04.12-.11l.09-.66c.15-.06.29-.15.42-.24l.62.25c.06.02.12 0 .15-.06l.5-.87c.03-.06.02-.12-.03-.16l-.52-.41c.01-.08.02-.16.02-.24s-.01-.17-.02-.24l.53-.41c.05-.04.06-.11.04-.17m-2.42 1.65c-.46 0-.83-.38-.83-.83 0-.46.38-.83.83-.83s.83.38.83.83c0 .46-.37.83-.83.83M4.74 9h8.53c.27 0 .49-.22.49-.49v-.02c0-.27-.22-.49-.49-.49H13c0-1.48-.81-2.75-2-3.45v.95c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.14C9.68 4.06 9.35 4 9 4s-.68.06-1 .14V5.5c0 .28-.22.5-.5.5S7 5.78 7 5.5v-.95C5.81 5.25 5 6.52 5 8h-.26c-.27 0-.49.22-.49.49v.03c0 .26.22.48.49.48M9 13c1.86 0 3.41-1.28 3.86-3H5.14c.45 1.72 2 3 3.86 3"
}), 'Engineering');



var $3a7ni = parcelRequire("3a7ni");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $lzNIT = parcelRequire("lzNIT");

var $f1q41 = parcelRequire("f1q41");

var $aQAPf = parcelRequire("aQAPf");
const $867b44e0261e6ba0$var$mainTitle = (0, $aQAPf.default).project || 'Sage';
function $867b44e0261e6ba0$export$2e2bcd8739ae039() {
    const location = (0, $aphAM.useLocation)();
    const params = (0, $aphAM.useParams)();
    const [searchParams] = (0, $lzNIT.useSearchParams)();
    const path = location.pathname;
    (0, $acw62.useEffect)(()=>{
        const hasParams = !!Object.keys(params).length, hasSearchParams = !![
            ...new Set(searchParams.keys())
        ].length;
        let subTitle;
        if (!(hasParams || hasSearchParams)) subTitle = `${(0, $f1q41.startCase)(path.slice(path.lastIndexOf('/')))}`;
        else if (hasParams && !hasSearchParams) subTitle = `${(0, $f1q41.startCase)(path.split('/')[1])} | ${Object.values(params).join(' | ')} `;
        else if (hasSearchParams) subTitle = `${(0, $f1q41.startCase)(path.split('/')[1])} | ` + `${[
            ...searchParams.entries()
        ].map(([k, v])=>`${k} ${v}`).join(' | ')}`;
        document.title = subTitle ? `${$867b44e0261e6ba0$var$mainTitle} - ${subTitle}` : $867b44e0261e6ba0$var$mainTitle;
    }, [
        path,
        params,
        searchParams
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
    });
}
function $867b44e0261e6ba0$export$b08a9033b36413fb(props) {
    (0, $acw62.useEffect)(()=>{
        document.title = `${$867b44e0261e6ba0$var$mainTitle} - ${props.title}`;
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: props.children
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");
var $6381b56c2e32bf3a$exports = {};
$6381b56c2e32bf3a$exports = import.meta.resolve("6S1hO");


var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse("{\"name\":\"sage-gui\",\"version\":\"3.4.0\",\"description\":\"\",\"scripts\":{\"start\":\"npm start -w sage\",\"build\":\"npm run build -w sage\",\"test\":\"npx playwright test\",\"clean\":\"npm run clean --workspaces --if-present && rm -rf .parcel-cache/\",\"release\":\"standard-version\",\"old-tests\":\"jest\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/sagecontinuum/sage-gui\"},\"license\":\"UNLICENSED\",\"devDependencies\":{\"@playwright/test\":\"^1.45.1\",\"@types/node\":\"^20.14.10\",\"@typescript-eslint/eslint-plugin\":\"^5.33.1\",\"@typescript-eslint/parser\":\"^5.33.1\",\"eslint\":\"^8.22.0\",\"eslint-plugin-react\":\"^7.30.1\",\"eslint-plugin-react-hooks\":\"^4.6.0\",\"standard-version\":\"^9.3.0\",\"svgo\":\"^3.3.2\",\"tsc-files\":\"^1.1.4\"},\"standard-version\":{\"header\":\"# Changelog\\n\\nThe following are some notable changes to the UI\\n\\n\"},\"workspaces\":[\"apps/admin\",\"apps/sage\",\"apps/project\",\"apps/registration-api\"],\"alias\":{\"d3\":\"d3/dist/d3.js\",\"@parcel/error-overlay\":\"./apps/ignore-react-overlay.js\"},\"dependencies\":{\"@mui/icons-material\":\"^6.5.0\",\"@mui/material\":\"^6.5.0\",\"@mui/styles\":\"^6.5.0\",\"chart.js\":\"^4.4.2\",\"chartjs-adapter-date-fns\":\"^3.0.0\",\"chartjs-plugin-zoom\":\"^2.0.1\"}}");


const $57f2839113b57759$var$SageLogo = ({ beta: beta = true })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex items-center logo",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($57f2839113b57759$var$LogoImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6381b56c2e32bf3a$exports))),
                height: "35"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($57f2839113b57759$var$Logo, {
                title: `Sage: v${(0, $8f13b60c0ee5b277$exports.version)}`,
                children: [
                    "Sage",
                    beta && /*#__PURE__*/ (0, $ayMG0.jsx)($57f2839113b57759$var$SageSup, {
                        children: "(beta)"
                    })
                ]
            })
        ]
    });
const $57f2839113b57759$var$LogoImg = (0, $lmFrL.default).img`
  margin-bottom: 2px;
`;
const $57f2839113b57759$var$Logo = (0, $lmFrL.default).span`
  font-size: 2.2em;
  font-family: 'Open sans', sans-serif;
  font-weight: 800;
  color: #87baa6;
  margin-bottom: 2px;
  padding-right: 20px;
  padding-left: 2px;
`;
const $57f2839113b57759$var$SageSup = (0, $lmFrL.default).sup`
  position: relative;
  top: -5px;
  font-size: .3em;
  color: #aaa;
`;
var $57f2839113b57759$export$2e2bcd8739ae039 = $57f2839113b57759$var$SageLogo;
const $57f2839113b57759$export$ebcd30672e67406 = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($57f2839113b57759$var$LogoImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6381b56c2e32bf3a$exports))),
                height: "35"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($57f2839113b57759$var$Logo, {
                title: "Sage Admin UI",
                children: [
                    "Sage",
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($57f2839113b57759$var$AdminSup, {
                        children: [
                            "[",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Admin"
                            }),
                            "]"
                        ]
                    })
                ]
            })
        ]
    });
const $57f2839113b57759$var$AdminSup = (0, $lmFrL.default).sup`
  position: relative;
  top: -5px;
  font-size: .3em;

  span {
    color: #8166a0;
    text-decoration: underline;
    text-decoration-color: #8166a0;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $d8seH = parcelRequire("d8seH");
var $9e577daae4aac7bc$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $9e577daae4aac7bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($9e577daae4aac7bc$exports, "__esModule", {
    value: true
});
$9e577daae4aac7bc$exports.default = void 0;

var $9e577daae4aac7bc$var$_createSvgIcon = $9e577daae4aac7bc$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $9e577daae4aac7bc$var$_default = $9e577daae4aac7bc$exports.default = (0, $9e577daae4aac7bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m8.71 11.71 2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71H9.41c-.89 0-1.33 1.08-.7 1.71"
}), 'ArrowDropDownRounded');



var $2iAqv = parcelRequire("2iAqv");

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $doXfV = parcelRequire("doXfV");

var $3W6ht = parcelRequire("3W6ht");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $83e175cb7e49d325$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $doXfV.getListItemIconUtilityClass), classes);
};
const $83e175cb7e49d325$var$ListItemIconRoot = (0, $d8seH.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $83e175cb7e49d325$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $3W6ht.default));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $83e175cb7e49d325$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($83e175cb7e49d325$var$ListItemIconRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $83e175cb7e49d325$export$2e2bcd8739ae039 = $83e175cb7e49d325$var$ListItemIcon;



function $1cc5f44952a47e0c$export$2e2bcd8739ae039(props) {
    const { label: label, menu: menu, to: to, root: root } = props;
    const ref = (0, $acw62.useRef)();
    const path = (0, $aphAM.useMatch)('*').pathname;
    const isActive = path.includes(root);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1cc5f44952a47e0c$var$Root, {
        ref: ref,
        className: "nav-item flex items-center",
        children: [
            to && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.NavLink), {
                to: to,
                className: `flex ${isActive ? 'active' : ''}`,
                children: [
                    label,
                    " ",
                    menu && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9e577daae4aac7bc$exports))), {})
                ]
            }),
            menu && !to && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: `flex ${isActive ? 'active' : ''}`,
                children: [
                    label,
                    " ",
                    menu && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9e577daae4aac7bc$exports))), {})
                ]
            }),
            props.href && /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: props.href,
                children: label
            }),
            menu && /*#__PURE__*/ (0, $ayMG0.jsx)($1cc5f44952a47e0c$var$MenuContainer, {
                style: props.style,
                children: menu
            })
        ]
    });
}
const $1cc5f44952a47e0c$var$Root = (0, $d8seH.default)('div')(({ theme: theme })=>`
  position: relative;
  margin: 0 15px;

  > a {
    padding: 20px 0;
    user-select: none;
    z-index: 9999;
    color: ${theme.palette.text.primary};
  }

  > a:hover {
    text-decoration: none;
  }

  > a:not(.active) {
    opacity: .6;
  }

  > a:not(.active):hover {
    opacity: 1.0;
  }

  > a.active {
    opacity: 1.0;
  }

  /* active item dot effect */
  > a:after {
    content: '';
    position: absolute;
    height: 0;
  }

  > a.active:after {
    transition: height .2s ease;

    width: 16px;
    height: 8px;
    bottom: 0;
    left: 35%;
    background: ${theme.palette.primary.main};
    border-radius: 15px 15px 0 0;
  }

  .MuiMenuItem-root,
  .MuiMenuItem-root svg {
    color: ${theme.palette.text.secondary};
  }

  .MuiMenuItem-root:after {
    content: '';
    position: absolute;
    height: 0;
  }

  .MuiMenuItem-root.active:after {
    width: 8px;
    height: 16px;
    left: 0;
    background: ${theme.palette.primary.main};
    border-radius: 0px 15px 15px 0;
  }
`);
const $1cc5f44952a47e0c$var$MenuContainer = (0, $d8seH.default)('div')`
  position: absolute;
  top: 59px;
  left: 50%;
  transform: translateX(-50%) translateY(-10px);
  min-width: 150px;
  background: ${(props)=>props.theme.palette.background.paper};
  box-shadow: 0px 5px 5px rgba(0, 0, 0, .05);
  border: solid ${(props)=>props.theme.palette.divider};
  border-width: 0 1px 1px 1px;
  z-index: 8999;

  /* Hidden by default */
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;

  /* Show on hover */
  .nav-item:hover & {
    opacity: 1;
    pointer-events: auto;
    transform: translateX(-50%) translateY(0);
  }
`;
function $1cc5f44952a47e0c$export$6d08773d2e66f8f2(props) {
    const { pathname: pathname, search: search } = (0, $aphAM.useLocation)();
    let isActive;
    if (props.to) isActive = search.length ? props.to.includes(pathname) && props.to.includes(decodeURIComponent(search)) : props.to == pathname;
    return(// @ts-ignore; custom component props mismatch; todo
    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2iAqv.default), {
        component: props.component || (0, $lzNIT.NavLink),
        className: `flex ${isActive ? 'active' : ''}`,
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e175cb7e49d325$export$2e2bcd8739ae039), {
                children: props.icon
            }),
            props.label
        ]
    }));
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");
var $4F5tJ = parcelRequire("4F5tJ");
var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $6n0Ko = parcelRequire("6n0Ko");

var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $254a3802f36599bb$export$21f89b560b65a301(slot) {
    return (0, $4Cod0.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $beCSm.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$export$2e2bcd8739ae039 = $254a3802f36599bb$var$toggleButtonClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $fe0e5fe90030f3ad$var$ToggleButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $fe0e5fe90030f3ad$export$2e2bcd8739ae039 = $fe0e5fe90030f3ad$var$ToggleButtonGroupContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $e49d517bbbfb7eee$export$2e2bcd8739ae039 = $e49d517bbbfb7eee$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $9775671ab3ebd2db$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab85d69438d76ec5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $jTnBY.default)(size)}`,
            color
        ]
    };
    return (0, $8Indx.default)(slots, (0, $254a3802f36599bb$export$21f89b560b65a301), classes);
};
const $ab85d69438d76ec5$var$ToggleButtonRoot = (0, $d8seH.default)((0, $6n0Ko.default), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette.text.primary, theme.palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $ab85d69438d76ec5$var$ToggleButton = /*#__PURE__*/ $acw62.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $acw62.useContext((0, $fe0e5fe90030f3ad$export$2e2bcd8739ae039));
    const toggleButtonGroupButtonContextPositionClassName = $acw62.useContext((0, $e49d517bbbfb7eee$export$2e2bcd8739ae039));
    const resolvedProps = (0, $4FZD0.default)({
        ...contextProps,
        selected: (0, $9775671ab3ebd2db$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $1iOpW.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $ab85d69438d76ec5$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab85d69438d76ec5$var$ToggleButtonRoot, {
        className: (0, $5FMfE.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var $ab85d69438d76ec5$export$2e2bcd8739ae039 = $ab85d69438d76ec5$var$ToggleButton;


var $acw62 = parcelRequire("acw62");



var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}



var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d382e18949ecbd32$export$44aa3ae5b353cef1(slot) {
    return (0, $4Cod0.default)('MuiToggleButtonGroup', slot);
}
const $d382e18949ecbd32$var$toggleButtonGroupClasses = (0, $beCSm.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
var $d382e18949ecbd32$export$2e2bcd8739ae039 = $d382e18949ecbd32$var$toggleButtonGroupClasses;






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7479184c3cda7f5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, fullWidth: fullWidth, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d382e18949ecbd32$export$44aa3ae5b353cef1), classes);
};
const $7479184c3cda7f5d$var$ToggleButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: {
                        [`&.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected} + .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected}`]: {
                            borderTop: 0,
                            marginTop: 0
                        }
                    },
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1,
                        borderTop: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                    },
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
                        borderTop: '1px solid transparent'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}`]: {
                        [`&.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected} + .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).grouped}.${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).selected}`]: {
                            borderLeft: 0,
                            marginLeft: 0
                        }
                    },
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).firstButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1,
                        borderLeft: '1px solid transparent',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    },
                    [`& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).lastButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled},& .${(0, $d382e18949ecbd32$export$2e2bcd8739ae039).middleButton}.${(0, $254a3802f36599bb$export$2e2bcd8739ae039).disabled}`]: {
                        borderLeft: '1px solid transparent'
                    }
                }
            }
        ]
    })));
const $7479184c3cda7f5d$var$ToggleButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, exclusive: exclusive = false, fullWidth: fullWidth = false, onChange: onChange, orientation: orientation = 'horizontal', size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size
    };
    const classes = $7479184c3cda7f5d$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = $acw62.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value: value,
            size: size,
            fullWidth: fullWidth,
            color: color,
            disabled: disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7479184c3cda7f5d$var$ToggleButtonGroupRoot, {
        role: "group",
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe0e5fe90030f3ad$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e49d517bbbfb7eee$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $7479184c3cda7f5d$export$2e2bcd8739ae039 = $7479184c3cda7f5d$var$ToggleButtonGroup;


var $cVXaD = parcelRequire("cVXaD");
var $b0NgK = parcelRequire("b0NgK");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $17a9bb39a7c6b75a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6"
}), 'Brightness4');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8eddbc861ed3e86a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9.37 5.51c-.18.64-.27 1.31-.27 1.99 0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27C17.45 17.19 14.93 19 12 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1"
}), 'DarkModeOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3bf41ea65b8b8d90$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5M2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1m18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1M11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1m0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1M5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0z"
}), 'LightModeOutlined');


function $b06ec7073f6709ec$export$2e2bcd8739ae039() {
    const { mode: mode, setMode: setMode } = (0, $b0NgK.useColorScheme)();
    const [themeAnchor, setThemeAnchor] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: themeAnchor ? '' : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center",
                    children: [
                        "Using ",
                        mode,
                        " color theme",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Click to change"
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9Lykx.default), {
                    onClick: (e)=>setThemeAnchor(e.currentTarget),
                    children: [
                        mode === 'light' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bf41ea65b8b8d90$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        }),
                        mode === 'dark' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8eddbc861ed3e86a$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        }),
                        mode === 'system' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17a9bb39a7c6b75a$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4F5tJ.default), {
                anchorEl: themeAnchor,
                open: Boolean(themeAnchor),
                onClose: ()=>setThemeAnchor(null),
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        padding: '8px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                        value: mode,
                        exclusive: true,
                        onChange: (e, newMode)=>{
                            if (newMode !== null) {
                                setMode(newMode);
                                setThemeAnchor(null);
                            }
                        },
                        size: "small",
                        orientation: "vertical",
                        fullWidth: true,
                        sx: {
                            minWidth: 150
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                value: "light",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bf41ea65b8b8d90$export$2e2bcd8739ae039), {
                                        fontSize: "small",
                                        sx: {
                                            mr: 1
                                        }
                                    }),
                                    "Light"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                value: "dark",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8eddbc861ed3e86a$export$2e2bcd8739ae039), {
                                        fontSize: "small",
                                        sx: {
                                            mr: 1
                                        }
                                    }),
                                    "Dark"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                value: "system",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17a9bb39a7c6b75a$export$2e2bcd8739ae039), {
                                        fontSize: "small",
                                        sx: {
                                            mr: 1
                                        }
                                    }),
                                    "System"
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}



var $lkxXU = parcelRequire("lkxXU");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $41651f8c3c72f67c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2 7v10c0 .55.45 1 1 1s1-.45 1-1V8h10v9c0 .55.45 1 1 1s1-.45 1-1v-1h4v1c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1m18 1v2h-4V8zm-4 6v-2h4v2z"
}), 'DeskRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $252e4639e13a0bf6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15 4v7H5.17L4 12.17V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1"
}), 'ForumOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5f72f4cec353c568$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-1 14H5c-.55 0-1-.45-1-1V8l6.94 4.34c.65.41 1.47.41 2.12 0L20 8v9c0 .55-.45 1-1 1m-7-7L4 6h16z"
}), 'MailOutlineRounded');



var $gZwVy = parcelRequire("gZwVy");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $6lXkL = parcelRequire("6lXkL");

var $lkxXU = parcelRequire("lkxXU");

var $1cc8fc7ba43458bc$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1cc8fc7ba43458bc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1cc8fc7ba43458bc$exports, "__esModule", {
    value: true
});
$1cc8fc7ba43458bc$exports.default = void 0;

var $1cc8fc7ba43458bc$var$_createSvgIcon = $1cc8fc7ba43458bc$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1cc8fc7ba43458bc$var$_default = $1cc8fc7ba43458bc$exports.default = (0, $1cc8fc7ba43458bc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 6.5c-1.66 0-3 1.34-3 3 0 .07 0 .14.01.21l-2.03.68c-.64-1.21-1.82-2.09-3.22-2.32V5.91C14.04 5.57 15 4.4 15 3c0-1.66-1.34-3-3-3S9 1.34 9 3c0 1.4.96 2.57 2.25 2.91v2.16c-1.4.23-2.58 1.11-3.22 2.32l-2.04-.68C6 9.64 6 9.57 6 9.5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3c1.06 0 1.98-.55 2.52-1.37l2.03.68c-.2 1.29.17 2.66 1.09 3.69l-1.41 1.77Q6.66 17 6 17c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3c0-.68-.22-1.3-.6-1.8l1.41-1.77c1.36.76 3.02.75 4.37 0l1.41 1.77c-.37.5-.59 1.12-.59 1.8 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3c-.44 0-.85.09-1.23.26l-1.41-1.77c.93-1.04 1.29-2.4 1.09-3.69l2.03-.68c.53.82 1.46 1.37 2.52 1.37 1.66 0 3-1.34 3-3S22.66 6.5 21 6.5m-18 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M6 21c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m5-18c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1m1 12c-1.38 0-2.5-1.12-2.5-2.5S10.62 10 12 10s2.5 1.12 2.5 2.5S13.38 15 12 15m6 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m3-8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), 'HubOutlined');


var $a24499e9cfcadef8$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a24499e9cfcadef8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a24499e9cfcadef8$exports, "__esModule", {
    value: true
});
$a24499e9cfcadef8$exports.default = void 0;

var $a24499e9cfcadef8$var$_createSvgIcon = $a24499e9cfcadef8$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a24499e9cfcadef8$var$_default = $a24499e9cfcadef8$exports.default = (0, $a24499e9cfcadef8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2"
}), 'LockOutlined');


var $c602c637cb757695$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c602c637cb757695$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c602c637cb757695$exports, "__esModule", {
    value: true
});
$c602c637cb757695$exports.default = void 0;

var $c602c637cb757695$var$_createSvgIcon = $c602c637cb757695$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c602c637cb757695$var$_default = $c602c637cb757695$exports.default = (0, $c602c637cb757695$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), 'ExitToApp');



var $2cPwN = parcelRequire("2cPwN");


var $c3pId = parcelRequire("c3pId");
const $c50b4b28307ae88b$var$username = (0, $c3pId.default).user;
const $c50b4b28307ae88b$var$webOrigin = window.location.origin;
const $c50b4b28307ae88b$var$isDev = ()=>false;
function $c50b4b28307ae88b$export$2e2bcd8739ae039(props) {
    const { pathname: pathname, search: search } = (0, $aphAM.useLocation)();
    const { isAdmin: isAdmin } = props;
    const [signingOut, setSigningOut] = (0, $acw62.useState)(false);
    const handleSignOut = (evt)=>{
        evt.stopPropagation();
        // display progress while signing out
        setSigningOut(true);
        (0, $c3pId.default).signOut();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            $c50b4b28307ae88b$var$username && !isAdmin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a61247555e1f801a$exports))), {}),
                        "\xa0",
                        $c50b4b28307ae88b$var$username
                    ]
                }),
                menu: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a61247555e1f801a$exports))), {}),
                            to: "/account/profile",
                            label: "Account"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1cc8fc7ba43458bc$exports))), {}),
                            to: "/account/nodes",
                            label: "My Nodes"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a24499e9cfcadef8$exports))), {}),
                            to: "/account/access",
                            label: "Access Creds"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            onClick: handleSignOut,
                            to: "/signout" // just for styling for now(?); stopPropagation is on handleSignOut
                            ,
                            icon: signingOut ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                size: 20
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c602c637cb757695$exports))), {}),
                            label: signingOut ? 'Signing out...' : 'Sign out'
                        })
                    ]
                })
            }),
            isAdmin && $c50b4b28307ae88b$var$username && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a61247555e1f801a$exports))), {}),
                        "\xa0",
                        $c50b4b28307ae88b$var$username
                    ]
                }),
                style: {
                    left: '-20px'
                },
                menu: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    style: {
                        padding: 10
                    },
                    children: [
                        "Please sign out via the ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "https://portal.sagecontinuum.org",
                                children: "portal"
                            })
                        }),
                        "."
                    ]
                })
            }),
            !$c50b4b28307ae88b$var$username && pathname != '/login' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                href: `${$c50b4b28307ae88b$var$isDev() ? '/login' : (0, $c3pId.default).url}?callback=${$c50b4b28307ae88b$var$webOrigin}${pathname}${search}`,
                variant: "outlined",
                color: "primary",
                sx: {
                    marginLeft: '20px'
                },
                children: "Sign In"
            })
        ]
    });
}


const $83644c50bf14ec8d$var$isDev = ()=>false;
function $83644c50bf14ec8d$export$2e2bcd8739ae039(props) {
    const { menu: menu, hasSignIn: hasSignIn, hasDocsLink: hasDocsLink, hasPortalLink: hasPortalLink, logo: logo } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($83644c50bf14ec8d$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center",
                children: [
                    logo ? logo : /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: $83644c50bf14ec8d$var$isDev() ? '/' : (0, $gZwVy.default).home,
                        className: "no-style flex items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57f2839113b57759$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "vertical",
                        flexItem: true,
                        style: {
                            margin: '5px 0'
                        }
                    })
                ]
            }),
            menu,
            /*#__PURE__*/ (0, $ayMG0.jsx)($83644c50bf14ec8d$var$Spacer, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center",
                children: [
                    hasDocsLink && /*#__PURE__*/ (0, $ayMG0.jsxs)($83644c50bf14ec8d$export$698668688a6e8f34, {
                        children: [
                            hasPortalLink && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                                label: "Portal",
                                href: (0, $gZwVy.default).portal
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                                label: "Labs",
                                href: (0, $gZwVy.default).labs
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                                label: "Docs",
                                href: `${(0, $gZwVy.default).docs}/about/overview`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                                label: "Help",
                                to: (0, $gZwVy.default).contactUs,
                                menu: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5f72f4cec353c568$export$2e2bcd8739ae039), {}),
                                            component: "a",
                                            href: (0, $gZwVy.default).contactUs,
                                            target: "_blank",
                                            label: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $252e4639e13a0bf6$export$2e2bcd8739ae039), {}),
                                            component: "a",
                                            href: `${(0, $gZwVy.default).contactUs}#-join-us-on-slack`,
                                            target: "_blank",
                                            label: "Join Slack"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41651f8c3c72f67c$export$2e2bcd8739ae039), {}),
                                            component: "a",
                                            href: (0, $gZwVy.default).officeHours,
                                            target: "_blank",
                                            label: "Office Hours"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06ec7073f6709ec$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    hasSignIn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c50b4b28307ae88b$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
const $83644c50bf14ec8d$var$Root = (0, $d8seH.default)('div')`
  display: flex;
  position: fixed;
  justify-content: space-between;
  align-items: center;
  top: 0;
  width: 100%;
  z-index: 9000;
  padding: 2px 20px 0 20px;
  height: 60px;
  border-bottom: 1px solid ${(props)=>props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.15)'};
  background-color: ${(props)=>props.theme.palette.background.paper};
  box-shadow:
    0px 2px 4px -1px rgb(0 0 0 / 0%),
    0px 4px 5px 0px rgb(0 0 0 / 0%),
    0px 1px 10px 0px rgb(0 0 0 / 12%);

  .docs-link {
    margin: 20px;
  }
`;
const $83644c50bf14ec8d$var$Spacer = (0, $d8seH.default)('div')`
  flex-grow: 1;
`;
const $83644c50bf14ec8d$export$698668688a6e8f34 = (0, $d8seH.default)('div')`
  display: flex;
  height: 100%;
  font-size: 1.1em;
  margin-left: 10px;
`;




var $ayMG0 = parcelRequire("ayMG0");

var $2cPwN = parcelRequire("2cPwN");
function $90dbddc73f95e2b7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex justify-center items-center h-full",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $d8seH = parcelRequire("d8seH");

var $6lXkL = parcelRequire("6lXkL");

var $lkxXU = parcelRequire("lkxXU");

var $3a7ni = parcelRequire("3a7ni");
var $292ac74a8e0bcaa5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $292ac74a8e0bcaa5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($292ac74a8e0bcaa5$exports, "__esModule", {
    value: true
});
$292ac74a8e0bcaa5$exports.default = void 0;

var $292ac74a8e0bcaa5$var$_createSvgIcon = $292ac74a8e0bcaa5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $292ac74a8e0bcaa5$var$_default = $292ac74a8e0bcaa5$exports.default = (0, $292ac74a8e0bcaa5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m3.23 15.39L12 15.45l-3.22 1.94c-.38.23-.85-.11-.75-.54l.85-3.66-2.83-2.45c-.33-.29-.15-.84.29-.88l3.74-.32 1.46-3.45c.17-.41.75-.41.92 0l1.46 3.44 3.74.32c.44.04.62.59.28.88l-2.83 2.45.85 3.67c.1.43-.36.77-.74.54"
}), 'StarsRounded');


var $fa7748a68cf6a1e4$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $fa7748a68cf6a1e4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($fa7748a68cf6a1e4$exports, "__esModule", {
    value: true
});
$fa7748a68cf6a1e4$exports.default = void 0;

var $fa7748a68cf6a1e4$var$_createSvgIcon = $fa7748a68cf6a1e4$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $fa7748a68cf6a1e4$var$_default = $fa7748a68cf6a1e4$exports.default = (0, $fa7748a68cf6a1e4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2m-10.6-3.47 1.63 2.18 2.58-3.22c.2-.25.58-.25.78 0l2.96 3.7c.26.33.03.81-.39.81H9c-.41 0-.65-.47-.4-.8l2-2.67c.2-.26.6-.26.8 0M2 7v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1s-1 .45-1 1"
}), 'CollectionsRounded');



var $87118691f42bf014$exports = {};
$87118691f42bf014$exports = import.meta.resolve("6WgQQ");



var $hw4Z0 = parcelRequire("hw4Z0");

var $gOa8m = parcelRequire("gOa8m");

var $2NJq1 = parcelRequire("2NJq1");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $58lXc = parcelRequire("58lXc");

var $8zogs = parcelRequire("8zogs");
var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $jTnBY = parcelRequire("jTnBY");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $4Cod0.default)('MuiLinearProgress', slot);
}
const $fd1aab3db3503e90$var$linearProgressClasses = (0, $beCSm.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $fd1aab3db3503e90$export$2e2bcd8739ae039 = $fd1aab3db3503e90$var$linearProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0fa40ac3f678fedb$var$TRANSITION_DURATION = 4; // seconds
const $0fa40ac3f678fedb$var$indeterminate1Keyframe = (0, $8zogs.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $0fa40ac3f678fedb$var$indeterminate1Animation = typeof $0fa40ac3f678fedb$var$indeterminate1Keyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $0fa40ac3f678fedb$var$indeterminate2Keyframe = (0, $8zogs.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $0fa40ac3f678fedb$var$indeterminate2Animation = typeof $0fa40ac3f678fedb$var$indeterminate2Keyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $0fa40ac3f678fedb$var$bufferKeyframe = (0, $8zogs.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $0fa40ac3f678fedb$var$bufferAnimation = typeof $0fa40ac3f678fedb$var$bufferKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $0fa40ac3f678fedb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $jTnBY.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $jTnBY.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $jTnBY.default)(color)}`,
            variant === 'buffer' && `color${(0, $jTnBY.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fd1aab3db3503e90$export$bc8a6ea1eb17d7c6), classes);
};
const $0fa40ac3f678fedb$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $aSEG4.lighten)(theme.palette[color].main, 0.62) : (0, $aSEG4.darken)(theme.palette[color].main, 0.5);
};
const $0fa40ac3f678fedb$var$LinearProgressRoot = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressDashed = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>{
                const backgroundColor = $0fa40ac3f678fedb$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $0fa40ac3f678fedb$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$0fa40ac3f678fedb$var$bufferKeyframe} 3s infinite linear`
});
const $0fa40ac3f678fedb$var$LinearProgressBar1 = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate1Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $0fa40ac3f678fedb$var$LinearProgressBar2 = (0, $d8seH.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $jTnBY.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $0fa40ac3f678fedb$var$getColorShade(theme, color),
                        transition: `transform .${$0fa40ac3f678fedb$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $0fa40ac3f678fedb$var$indeterminate2Animation || {
                    animation: `${$0fa40ac3f678fedb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $0fa40ac3f678fedb$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $0fa40ac3f678fedb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $58lXc.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0fa40ac3f678fedb$var$LinearProgressRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($0fa40ac3f678fedb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $0fa40ac3f678fedb$export$2e2bcd8739ae039 = $0fa40ac3f678fedb$var$LinearProgress;


const $c8fd8a7dca6d4c4c$var$ProgressContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
function $c8fd8a7dca6d4c4c$export$17a35283f282d18(props) {
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c8fd8a7dca6d4c4c$var$ProgressContext.Provider, {
        value: {
            loading: loading,
            setLoading: setLoading
        },
        children: [
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)($c8fd8a7dca6d4c4c$var$Progress, {}),
            props.children
        ]
    });
}
const $c8fd8a7dca6d4c4c$var$Progress = (0, $lmFrL.default)((0, $0fa40ac3f678fedb$export$2e2bcd8739ae039))`
  position: fixed;
  width: 100%;
  height: 3px;
  left: 0;
  top: 0;
  z-index: 9999;
`;
function $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($c8fd8a7dca6d4c4c$var$ProgressContext);
    if (context == undefined) throw new Error('useProgress must be used within a ProgressProvider');
    return context;
}



var $atFJM = parcelRequire("atFJM");

var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");

var $9Lykx = parcelRequire("9Lykx");
var $d8seH = parcelRequire("d8seH");

var $lzNIT = parcelRequire("lzNIT");

var $cVXaD = parcelRequire("cVXaD");

var $bFBmv = parcelRequire("bFBmv");

var $89a79221f2e2f7ee$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $89a79221f2e2f7ee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($89a79221f2e2f7ee$exports, "__esModule", {
    value: true
});
$89a79221f2e2f7ee$exports.default = void 0;

var $89a79221f2e2f7ee$var$_createSvgIcon = $89a79221f2e2f7ee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $89a79221f2e2f7ee$var$_default = $89a79221f2e2f7ee$exports.default = (0, $89a79221f2e2f7ee$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        fillRule: "evenodd",
        d: "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h3c.55 0 1-.45 1-1v-2c0-2.18-3.57-3.47-6.33-3.87"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "9",
        cy: "8",
        r: "4",
        fillRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        fillRule: "evenodd",
        d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24C14.5 5.27 15 6.58 15 8s-.5 2.73-1.33 3.76c.42.14.86.24 1.33.24m-6 1c-2.67 0-8 1.34-8 4v2c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-2c0-2.66-5.33-4-8-4"
    }, "2")
], 'PeopleAltRounded');


var $b373839037e81820$exports = {};
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $b373839037e81820$require$_interopRequireDefault = $1jnue.default;
var $27c3440315f0d929$exports = {};
var $2ef66ab8c52ac1c0$exports = {};
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
$2ef66ab8c52ac1c0$exports = $2ef66ab8c52ac1c0$var$_typeof, $2ef66ab8c52ac1c0$exports.__esModule = true, $2ef66ab8c52ac1c0$exports["default"] = $2ef66ab8c52ac1c0$exports;


var $27c3440315f0d929$var$_typeof = $2ef66ab8c52ac1c0$exports.default;
function $27c3440315f0d929$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($27c3440315f0d929$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $27c3440315f0d929$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $27c3440315f0d929$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $27c3440315f0d929$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
$27c3440315f0d929$exports = $27c3440315f0d929$var$_interopRequireWildcard, $27c3440315f0d929$exports.__esModule = true, $27c3440315f0d929$exports["default"] = $27c3440315f0d929$exports;


var $b373839037e81820$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($b373839037e81820$exports, "__esModule", {
    value: true
});
$b373839037e81820$exports.default = void 0;

var $b373839037e81820$var$React = $b373839037e81820$require$_interopRequireWildcard((parcelRequire("acw62")));

var $b373839037e81820$var$_createSvgIcon = $b373839037e81820$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b373839037e81820$var$_default = $b373839037e81820$exports.default = (0, $b373839037e81820$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 1.27a11 11 0 00-3.48 21.46c.55.09.73-.28.73-.55v-1.84c-3.03.64-3.67-1.46-3.67-1.46-.55-1.29-1.28-1.65-1.28-1.65-.92-.65.1-.65.1-.65 1.1 0 1.73 1.1 1.73 1.1.92 1.65 2.57 1.2 3.21.92a2 2 0 01.64-1.47c-2.47-.27-5.04-1.19-5.04-5.5 0-1.1.46-2.1 1.2-2.84a3.76 3.76 0 010-2.93s.91-.28 3.11 1.1c1.8-.49 3.7-.49 5.5 0 2.1-1.38 3.02-1.1 3.02-1.1a3.76 3.76 0 010 2.93c.83.74 1.2 1.74 1.2 2.94 0 4.21-2.57 5.13-5.04 5.4.45.37.82.92.82 2.02v3.03c0 .27.1.64.73.55A11 11 0 0012 1.27"
}), 'GitHub');



var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cVXaD = parcelRequire("cVXaD");

var $bFBmv = parcelRequire("bFBmv");
function $c07caf1618b8b680$export$2e2bcd8739ae039(props) {
    const { isBuilding: isBuilding, buildResult: buildResult, buildUrl: buildUrl } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: buildUrl && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                isBuilding ? /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    className: "success",
                    children: "Building"
                }) : buildResult == 'SUCCESS' ? /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    className: "success",
                    children: "Built"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    className: "failed",
                    children: "Failed"
                }),
                "\xa0 (",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "Jenkins ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                style: {
                                    fontSize: '1.1em'
                                }
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: buildUrl,
                        onClick: (evt)=>evt.stopPropagation(),
                        target: "_blank",
                        rel: "noreferrer",
                        children: "view"
                    })
                }),
                ")"
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
var $7e41c566302bd0e2$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $7e41c566302bd0e2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($7e41c566302bd0e2$exports, "__esModule", {
    value: true
});
$7e41c566302bd0e2$exports.default = void 0;

var $7e41c566302bd0e2$var$_createSvgIcon = $7e41c566302bd0e2$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7e41c566302bd0e2$var$_default = $7e41c566302bd0e2$exports.default = (0, $7e41c566302bd0e2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');



var $d18d1cbd35f5a198$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d18d1cbd35f5a198$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d18d1cbd35f5a198$exports, "__esModule", {
    value: true
});
$d18d1cbd35f5a198$exports.default = void 0;

var $d18d1cbd35f5a198$var$_createSvgIcon = $d18d1cbd35f5a198$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d18d1cbd35f5a198$var$_default = $d18d1cbd35f5a198$exports.default = (0, $d18d1cbd35f5a198$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m-9-2V7H4v3H1v2h3v3h2v-3h3v-2zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'PersonAdd');


var $4c735db17ea8a18b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4c735db17ea8a18b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($4c735db17ea8a18b$exports, "__esModule", {
    value: true
});
$4c735db17ea8a18b$exports.default = void 0;

var $4c735db17ea8a18b$var$_createSvgIcon = $4c735db17ea8a18b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4c735db17ea8a18b$var$_default = $4c735db17ea8a18b$exports.default = (0, $4c735db17ea8a18b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 8.17 6.49 3.66C8.07 2.61 9.96 2 12 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46C19.59 14.87 20 13.48 20 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2zm9.49 13.73c-.39.39-1.02.39-1.41 0l-1.56-1.56c-2.07 1.37-4.68 2-7.45 1.48-3.95-.75-7.13-3.92-7.88-7.88-.52-2.77.1-5.38 1.48-7.45L2.1 4.93a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0l16.97 16.97c.4.39.4 1.02.01 1.41M11 18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.08 3.05 7.44 7 7.93z"
}), 'PublicOffRounded');



var $cVXaD = parcelRequire("cVXaD");

var $9Lykx = parcelRequire("9Lykx");

var $6lXkL = parcelRequire("6lXkL");

var $ifEev = parcelRequire("ifEev");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");

var $6lXkL = parcelRequire("6lXkL");

var $6MV2p = parcelRequire("6MV2p");

var $2MUlQ = parcelRequire("2MUlQ");

var $6Q1H5 = parcelRequire("6Q1H5");

var $ejcfT = parcelRequire("ejcfT");

var $iwiZ3 = parcelRequire("iwiZ3");

var $bgK54 = parcelRequire("bgK54");

var $c3pId = parcelRequire("c3pId");

var $atFJM = parcelRequire("atFJM");
const $67ab6fe386a06ee6$var$userId = (0, $c3pId.default).user;
const $67ab6fe386a06ee6$var$permMap = {
    'FULL_CONTROL': 'owner',
    'READ': 'can read',
    'WRITE': 'can write'
};
const $67ab6fe386a06ee6$var$isMe = (grantee)=>grantee == $67ab6fe386a06ee6$var$userId;
function $67ab6fe386a06ee6$var$PermissionTable(props) {
    const { permissions: permissions, onDelete: onDelete } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
        className: "simple striped w-full",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                            children: "User"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                            children: "Permission"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("th", {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                children: permissions.map((perm)=>{
                    const { grantee: grantee, permission: permission } = perm;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                children: [
                                    grantee.slice(grantee.lastIndexOf('-') + 1),
                                    " ",
                                    $67ab6fe386a06ee6$var$isMe(grantee) ? '(me)' : ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                children: $67ab6fe386a06ee6$var$permMap[permission]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: (evt)=>onDelete(evt, perm),
                                    size: "large",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgK54))), {
                                        className: "delete"
                                    })
                                })
                            })
                        ]
                    }, grantee);
                })
            })
        ]
    });
}
function $67ab6fe386a06ee6$export$2e2bcd8739ae039(props) {
    const { repo: repo, onClose: onClose } = props;
    const [permissions, setPermissions] = (0, $acw62.useState)(null);
    const [user, setUser] = (0, $acw62.useState)(null);
    const [perm, setPerm] = (0, $acw62.useState)('READ');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        $atFJM.listPermissions(repo).then((perms)=>{
            setPermissions(perms);
        });
    }, [
        repo
    ]);
    const handleSubmit = (evt)=>{
        evt.preventDefault();
        setLoading(true);
    };
    const handleClose = (evt)=>{
        evt.preventDefault();
        if (onClose) onClose();
    };
    const handleAdd = (evt)=>{
        setLoading(true);
        $atFJM.share(repo, user, perm, 'add').then(()=>{
        // implement
        }).finally(()=>setLoading(false));
    };
    const handleDelete = (evt, perm)=>{
        const { grantee: grantee, permission: permission } = perm;
        $atFJM.share(repo, grantee, permission, 'delete').then(()=>{
        // implement
        }).finally(()=>setLoading(false));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
        open: true,
        onClose: handleClose,
        "aria-labelledby": "dialog-title",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            onSubmit: handleSubmit,
            autoComplete: "off",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ejcfT.default), {
                    id: "dialog-title",
                    children: "Edit Sharing"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        severity: "info",
                        children: "Sharing at the user level has been temporarily disabled."
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2MUlQ.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        onClick: handleClose,
                        color: "primary",
                        children: "Done"
                    })
                })
            ]
        })
    });
}



var $24m81 = parcelRequire("24m81");

var $atFJM = parcelRequire("atFJM");
function $cbfad8f157ab583f$var$ActionBtn({ title: title, onClick: onClick, icon: icon, className: className }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: title,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
            onClick: onClick,
            size: "small",
            className: className,
            children: icon
        })
    });
}
function $cbfad8f157ab583f$var$FullActionBtn({ text: text, onClick: onClick, icon: icon, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        onClick: onClick,
        style: {
            ...style
        },
        variant: "outlined",
        color: "primary",
        size: "small",
        startIcon: icon,
        children: text
    });
}
function $cbfad8f157ab583f$export$2e2bcd8739ae039(props) {
    const { enqueueSnackbar: enqueueSnackbar } = (0, $24m81.useSnackbar)();
    const { namespace: namespace, name: name, condensed: condensed = true, isPublic: isPublic, onComplete: onComplete } = props;
    const [confirm, setConfirm] = (0, $acw62.useState)(false);
    const [publish, setPublish] = (0, $acw62.useState)(false);
    const [share, setShare] = (0, $acw62.useState)(false);
    const handleDelete = (evt)=>{
        evt.preventDefault();
        evt.stopPropagation();
        setConfirm(true);
    };
    const handleMakePublic = (evt)=>{
        evt.preventDefault();
        setPublish(true);
    };
    const onDelete = ()=>{
        const repo = {
            namespace: namespace,
            name: name
        };
        return $atFJM.deleteRepo(repo).then(()=>enqueueSnackbar('App deleted!', {
                variant: 'success'
            })).catch(()=>enqueueSnackbar('Failed to delete app', {
                variant: 'error'
            })).finally(()=>onComplete && onComplete());
    };
    const onMakePublic = ()=>{
        const repo = {
            namespace: namespace,
            name: name
        };
        return $atFJM.makePublic(repo, isPublic ? 'delete' : 'add').then(()=>enqueueSnackbar(isPublic ? 'Your app is now private' : 'Your app is now public!', {
                variant: 'success'
            })).catch(()=>enqueueSnackbar('Failed to make app public', {
                variant: 'error'
            })).finally(()=>onComplete && onComplete());
    };
    const handleShare = (evt)=>{
        evt.preventDefault();
        setShare(true);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($cbfad8f157ab583f$var$Root, {
        className: "flex",
        children: [
            condensed ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cbfad8f157ab583f$var$ActionBtn, {
                        title: "Share repo",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d18d1cbd35f5a198$exports))), {}),
                        onClick: handleShare
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cbfad8f157ab583f$var$ActionBtn, {
                        title: isPublic ? 'Turn public access off' : 'Make repo public',
                        icon: isPublic ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c735db17ea8a18b$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71802778b2667a33$exports))), {}),
                        onClick: handleMakePublic
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cbfad8f157ab583f$var$ActionBtn, {
                        title: "Delete repo",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e41c566302bd0e2$exports))), {}),
                        onClick: handleDelete,
                        className: "delete"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex form-gap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cbfad8f157ab583f$var$FullActionBtn, {
                        text: "Share",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d18d1cbd35f5a198$exports))), {}),
                        onClick: handleShare
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cbfad8f157ab583f$var$FullActionBtn, {
                        text: isPublic ? 'Make private' : 'Make public',
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71802778b2667a33$exports))), {}),
                        onClick: handleMakePublic
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cbfad8f157ab583f$var$FullActionBtn, {
                        text: "Delete",
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e41c566302bd0e2$exports))), {}),
                        onClick: handleDelete,
                        style: {
                            color: '#912341',
                            border: '1px solid #912341'
                        }
                    })
                ]
            }),
            confirm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: `Are you sure you want to delete this?`,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                            children: [
                                namespace,
                                "/",
                                name
                            ]
                        }),
                        " and ",
                        props.versionCount,
                        " associated tag",
                        props.versionCount > 1 ? 's' : '',
                        " will be deleted!"
                    ]
                }),
                confirmBtnText: "Delete",
                confirmBtnStyle: {
                    background: '#c70000'
                },
                onConfirm: onDelete,
                onClose: ()=>setConfirm(false)
            }),
            publish && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: isPublic ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Make App Private"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Make App Publicly Readable"
                }),
                content: isPublic ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Your app ",
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                            children: [
                                namespace,
                                "/",
                                name
                            ]
                        }),
                        " will no longer be publicly viewable.  Are you sure?"
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Your app ",
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                            children: [
                                namespace,
                                "/",
                                name
                            ]
                        }),
                        " will be viewable to everyone without sign-in.",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Are you sure you want to do this?"
                    ]
                }),
                confirmBtnText: isPublic ? 'Make it private' : 'Make it public',
                confirmBtnStyle: isPublic ? {
                    background: '#c70000'
                } : {},
                onConfirm: onMakePublic,
                onClose: ()=>setPublish(false)
            }),
            share && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67ab6fe386a06ee6$export$2e2bcd8739ae039), {
                repo: {
                    namespace: namespace,
                    name: name
                },
                onClose: ()=>setShare(false)
            })
        ]
    });
}
const $cbfad8f157ab583f$var$Root = (0, $lmFrL.default).div`

`;


/* eslint-disable react/display-name */ 
var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");


var $cVXaD = parcelRequire("cVXaD");

var $lffEs = parcelRequire("lffEs");
function $f446074e335acab0$var$VersionTooltip(props) {
    const { row: row } = props;
    const versions = row.versions;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        arrow: true,
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "Tags:"
                }),
                versions.map((ver)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: ver
                    }, ver))
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
            to: `../app/${row.namespace}/${row.name}`,
            children: [
                versions.length,
                " tag",
                versions.length > 1 ? 's' : ''
            ]
        })
    });
}
const $f446074e335acab0$export$fe98a034cfb96d55 = {
    name: (name, o)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
            to: `../app/${o.namespace}/${name}`,
            children: name
        });
    },
    versions: (versions, row)=>{
        if (!versions?.length) return '-';
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                versions[versions?.length - 1].version,
                ' ',
                /*#__PURE__*/ (0, $ayMG0.jsx)($f446074e335acab0$var$VersionTooltip, {
                    row: row
                })
            ]
        });
    },
    repo: (_, { source: source })=>{
        const { url: url } = source;
        if (!url) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
            href: url,
            target: "_blank",
            rel: "noreferrer",
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b373839037e81820$exports))), {
                    fontSize: "small"
                }),
                "\xa0\xa0",
                url.slice(url.lastIndexOf('/') + 1).replace('.git', '')
            ]
        });
    },
    time: (val)=>{
        return $lffEs.msToTimeApprox(Date.now() - new Date(val).getTime());
    }
};
const $f446074e335acab0$export$6521433ed15a34db = (0, $d8seH.default)('div')`
  img, svg {
    width: 125px;
    height: 125px;
    object-fit: cover;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-right: 1em;
  }

  svg {
    padding: 1em;
    filter: ${(props)=>props.theme.palette.mode === 'light' ? 'drop-shadow(0px 0px 0.3rem #ccc)' : 'none'};
  }
`;
const $f446074e335acab0$export$d046b3c4a416f60d = (0, $d8seH.default)('div')`
  margin: 0 10px;
  :before {
    content: "·";
  }
`;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $a15b87fc16f8d46d$var$SvgBee = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 512 512",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M459.922 142.012c-19.517-7.683-41.197-8.649-62.701-2.795-16.371 4.458-32.004 12.617-46.698 24.346-7.894-19.211-21.479-35.503-38.649-46.765 2.251-9.798 7.696-25.348 16.735-37.428a36.8 36.8 0 0 0 13.342 2.497c20.41 0 37.016-16.604 37.016-37.014S362.361 7.84 341.951 7.84s-37.014 16.604-37.014 37.014c0 4.05.664 7.946 1.871 11.597-12.052 14.405-19.838 32.507-23.944 47.26-8.564-2.337-17.57-3.592-26.865-3.592s-18.301 1.255-26.865 3.592c-4.105-14.753-11.892-32.854-23.944-47.26a36.9 36.9 0 0 0 1.871-11.597c0-20.41-16.604-37.014-37.014-37.014s-37.016 16.604-37.016 37.014 16.605 37.014 37.016 37.014a36.8 36.8 0 0 0 13.341-2.497c9.039 12.081 14.484 27.63 16.735 37.428-17.17 11.263-30.755 27.554-38.649 46.765-14.693-11.729-30.326-19.89-46.698-24.346-21.505-5.856-43.185-4.888-62.701 2.795C20.262 154.541-.18 182.618.001 213.546c.104 17.88 7.185 35.349 20.476 50.515 10.824 12.352 25.56 23.057 43.94 31.943-8.251 20.6-3.948 44.52 12.738 63.265 12.005 13.485 30.473 23.431 50.868 23.431 6.096 0 12.365-.901 18.684-2.85 12.449 42.384 48.934 74.581 93.62 80.759v43.553h31.347v-43.553c44.686-6.178 81.171-38.375 93.62-80.759 6.319 1.949 12.587 2.849 18.684 2.849 20.392 0 38.864-9.947 50.868-23.431 16.687-18.744 20.99-42.665 12.738-63.265 18.38-8.886 33.115-19.591 43.94-31.943 13.291-15.166 20.371-32.633 20.476-50.515.18-30.927-20.26-59.004-52.078-71.533M341.952 39.186a5.676 5.676 0 0 1 5.669 5.667 5.676 5.676 0 0 1-5.669 5.668 5.676 5.676 0 0 1-5.668-5.668 5.676 5.676 0 0 1 5.668-5.667M170.048 50.521a5.676 5.676 0 0 1-5.669-5.668 5.675 5.675 0 0 1 5.669-5.667 5.675 5.675 0 0 1 5.668 5.667 5.676 5.676 0 0 1-5.668 5.668M256 131.465c39.037 0 70.798 31.761 70.798 70.798S295.038 273.06 256 273.06s-70.798-31.761-70.798-70.798 31.761-70.797 70.798-70.797m-56.294 155.986c16.152 10.709 35.506 16.958 56.294 16.958 20.789 0 40.143-6.248 56.295-16.958a82.9 82.9 0 0 1 20.389 29.876H179.317a82.86 82.86 0 0 1 20.389-29.876m-57.594 60.593c-16.187 7.297-32.062 1.033-41.542-9.618-8.48-9.526-14.018-25.515-1.717-39.222l15.258-17-21.35-8.12c-38.889-14.79-61.274-36.92-61.413-60.72-.104-17.879 12.541-34.437 32.214-42.183 28.493-11.22 61.928-.843 90.355 27.721a101 101 0 0 0-.062 3.36c0 24.224 8.481 46.5 22.623 64.029-21.767 21.273-34.37 50.643-34.37 81.509q.002.123.004.244M256 430.346c-23.374 0-44.494-9.781-59.526-25.447h119.052c-15.032 15.664-36.151 25.447-59.526 25.447m78.409-56.794H177.591a82.2 82.2 0 0 1-4.113-24.879h165.044a82.2 82.2 0 0 1-4.113 24.879m84.831-99.468-21.35 8.12 15.258 17c12.302 13.707 6.765 29.696-1.717 39.222-9.482 10.652-25.356 16.918-41.543 9.62q.002-.123.003-.245c0-30.865-12.603-60.235-34.37-81.509 14.142-17.529 22.623-39.805 22.623-64.029 0-1.125-.025-2.243-.062-3.36 28.427-28.563 61.863-38.941 90.355-27.721 19.673 7.746 32.319 24.303 32.214 42.182-.137 23.799-22.522 45.93-61.411 60.72",
                style: {
                    fill: "#aaa"
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M229.918 173.83c-5.671 0-10.285 4.661-10.285 10.418.001 5.756 4.615 10.422 10.285 10.422 5.678 0 10.291-4.665 10.291-10.422s-4.613-10.418-10.291-10.418M282.005 173.749c-5.725 0-10.37 4.701-10.37 10.499s4.645 10.499 10.37 10.499c5.718 0 10.362-4.7 10.362-10.499 0-5.798-4.644-10.499-10.362-10.499",
                style: {
                    fill: "#aaa"
                }
            })
        ]
    });
var $a15b87fc16f8d46d$export$2e2bcd8739ae039 = $a15b87fc16f8d46d$var$SvgBee;



var $c3pId = parcelRequire("c3pId");

var $gZwVy = parcelRequire("gZwVy");

var $gsYK2 = parcelRequire("gsYK2");
const { featuredApps: $e4256d352af69bee$var$featuredApps, samplers: $e4256d352af69bee$var$samplers } = (0, $gsYK2.default);
const $e4256d352af69bee$var$isSignedIn = (0, $c3pId.default).isSignedIn;
function $e4256d352af69bee$export$2e2bcd8739ae039(props) {
    let { rows: rows, view: view, ...rest } = props;
    if (view == 'explore') rows = rows.filter((row)=>![
            ...$e4256d352af69bee$var$featuredApps,
            ...$e4256d352af69bee$var$samplers
        ].includes(`${row.namespace}/${row.name}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e4256d352af69bee$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e4256d352af69bee$var$Rows, {
            children: rows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)($e4256d352af69bee$var$Row, {
                    data: row,
                    ...rest
                }, row.id))
        })
    });
}
const $e4256d352af69bee$var$Root = (0, $d8seH.default)('div')`
  margin-top: 1em;
`;
const $e4256d352af69bee$var$Rows = (0, $d8seH.default)('div')`
  margin-top: 1em;
`;
function $e4256d352af69bee$var$Row(props) {
    const { data: data, view: view, onComplete: onComplete, onNavigate: onNavigate } = props;
    const { namespace: namespace, name: name, version: version, versions: versions, isPublic: isPublic, isShared: isShared, description: description, time_last_updated: time_last_updated, isBuilding: isBuilding, buildResult: buildResult, buildUrl: buildUrl, thumbnail: thumbnail, hasRecentData: hasRecentData } = data;
    const verCount = versions.length;
    const handleClick = (evt)=>{
        if (evt.target.closest('.MuiDialog-root')) {
            // prevent navigation if using dialog
            evt.preventDefault();
            return;
        }
        // if not link or button, allow navigation
        if (!evt.target.hasAttribute('href') && !evt.target.closest('.MuiButtonBase-root')) onNavigate(`/apps/app/${namespace}/${name}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Item), {
        className: "flex justify-between large-click-target",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: thumbnail?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$6521433ed15a34db), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: `${(0, $gZwVy.default).ecr}/meta-files/${thumbnail}`
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$6521433ed15a34db), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15b87fc16f8d46d$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex column justify-around",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Title), {
                                children: [
                                    view != 'explore' && `${namespace} /`,
                                    " ",
                                    (0, $f446074e335acab0$export$fe98a034cfb96d55).name(name, data),
                                    ' '
                                ]
                            }),
                            description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: description
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex muted",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c07caf1618b8b680$export$2e2bcd8739ae039), {
                                        buildUrl: buildUrl,
                                        isBuilding: isBuilding,
                                        buildResult: buildResult
                                    }),
                                    buildUrl && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {}),
                                    view == 'explore' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            namespace,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {})
                                        ]
                                    }),
                                    view != 'explore' && isPublic && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71802778b2667a33$exports))), {
                                                        fontSize: "small"
                                                    }),
                                                    "\xa0",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "public"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            verCount,
                                            " tag",
                                            verCount > 1 ? 's' : ''
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            "Updated ",
                                            (0, $f446074e335acab0$export$fe98a034cfb96d55).time(time_last_updated)
                                        ]
                                    }),
                                    hasRecentData && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                                to: `/apps/app/${namespace}/${name}?tab=data`,
                                                children: "view data"
                                            })
                                        ]
                                    }),
                                    isShared && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "muted",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($89a79221f2e2f7ee$exports))), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "GitHub ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                style: {
                                    fontSize: '1.1em'
                                }
                            })
                        ]
                    }),
                    placement: "top",
                    className: "external-link hover",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        href: data.source.url,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b373839037e81820$exports))), {})
                    })
                })
            }),
            view != 'explore' && $e4256d352af69bee$var$isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbfad8f157ab583f$export$2e2bcd8739ae039), {
                    namespace: namespace,
                    name: name,
                    version: version,
                    isPublic: isPublic,
                    onComplete: onComplete,
                    versionCount: versions.length
                })
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $cVXaD = parcelRequire("cVXaD");

var $bFBmv = parcelRequire("bFBmv");

var $09fc43707f437bd6$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $09fc43707f437bd6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($09fc43707f437bd6$exports, "__esModule", {
    value: true
});
$09fc43707f437bd6$exports.default = void 0;

var $09fc43707f437bd6$var$_createSvgIcon = $09fc43707f437bd6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $09fc43707f437bd6$var$_default = $09fc43707f437bd6$exports.default = (0, $09fc43707f437bd6$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M6 15h6v2H6zm6-8h6v2h-6zm-3 4h6v2H9z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z"
    }, "1")
], 'ViewTimelineOutlined');



var $6lXkL = parcelRequire("6lXkL");


var $acw62 = parcelRequire("acw62");


var $umiYb = parcelRequire("umiYb");

var $4NpFa = parcelRequire("4NpFa");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $dxMBG = parcelRequire("dxMBG");

var $dFNG2 = parcelRequire("dFNG2");

var $eM1DJ = parcelRequire("eM1DJ");

var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");
const $6693217541d03f3f$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $6693217541d03f3f$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6693217541d03f3f$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $30b2f4f9de1f3c09$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $30b2f4f9de1f3c09$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $30b2f4f9de1f3c09$var$selfColumnsVar = '--Grid-columns';
const $30b2f4f9de1f3c09$var$parentColumnsVar = '--Grid-parent-columns';
const $30b2f4f9de1f3c09$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) - (var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) - ${value}) * (var(${$30b2f4f9de1f3c09$var$getParentSpacingVar('column')}) / var(${$30b2f4f9de1f3c09$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) + var(${$30b2f4f9de1f3c09$var$getParentSpacingVar('column')}) * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$30b2f4f9de1f3c09$var$selfColumnsVar]: 12
    };
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$selfColumnsVar]: columns,
            '> *': {
                [$30b2f4f9de1f3c09$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$30b2f4f9de1f3c09$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$30b2f4f9de1f3c09$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$30b2f4f9de1f3c09$var$getSelfSpacingVar('row')}) var(${$30b2f4f9de1f3c09$var$getSelfSpacingVar('column')})`
        }
    };
};
const $30b2f4f9de1f3c09$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $30b2f4f9de1f3c09$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $30b2f4f9de1f3c09$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};


const $36a42d20d006905e$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://v6.mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $36a42d20d006905e$var$warnedAboutProps = [];
function $36a42d20d006905e$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}



var $ayMG0 = parcelRequire("ayMG0");
const $71d3dec7f204ed17$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $71d3dec7f204ed17$var$defaultCreateStyledComponent = (0, $dxMBG.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $71d3dec7f204ed17$var$useThemePropsDefault(props) {
    return (0, $dFNG2.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $71d3dec7f204ed17$var$defaultTheme
    });
}
function $71d3dec7f204ed17$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $71d3dec7f204ed17$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $71d3dec7f204ed17$var$useThemePropsDefault, useTheme: useTheme = (0, $eM1DJ.default), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $30b2f4f9de1f3c09$export$a7c8efbe2b138a60)(direction),
                ...(0, $30b2f4f9de1f3c09$export$e2d1175061442d38)(size),
                ...container ? (0, $30b2f4f9de1f3c09$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $30b2f4f9de1f3c09$export$ccc4d4a4923f1b06), (0, $30b2f4f9de1f3c09$export$a89c28919b8e3bb5), (0, $30b2f4f9de1f3c09$export$68c4dad72dd49c74), (0, $30b2f4f9de1f3c09$export$84053369756c53db), (0, $30b2f4f9de1f3c09$export$2a0a3c01032b3f4), (0, $30b2f4f9de1f3c09$export$810b8c3ab5d46bf), (0, $30b2f4f9de1f3c09$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $36a42d20d006905e$export$2e2bcd8739ae039)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $umiYb.default)(classes.root, className),
            ...other,
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $4NpFa.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $acw62.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}




var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $14H9o = parcelRequire("14H9o");
'use client';
/**
 *
 * Demos:
 *
 * - [Grid version 2](https://v6.mui.com/material-ui/react-grid2/)
 *
 * API:
 *
 * - [Grid2 API](https://v6.mui.com/material-ui/api/grid-2/)
 */ const $e427cceb5e1ecc90$var$Grid2 = (0, $71d3dec7f204ed17$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiGrid2',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid2',
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid2'
        }),
    useTheme: $14H9o.default
});
var $e427cceb5e1ecc90$export$2e2bcd8739ae039 = $e427cceb5e1ecc90$var$Grid2;



var $gTmRg = parcelRequire("gTmRg");



var $f1q41 = parcelRequire("f1q41");

var $gZwVy = parcelRequire("gZwVy");

var $9Lykx = parcelRequire("9Lykx");
function $0bb1b8a7eec6af5a$var$AppBox(props) {
    const { data: data, view: view, onNavigate: onNavigate } = props;
    const { namespace: namespace, name: name, versions: versions, description: description, thumbnail: thumbnail, hasRecentData: hasRecentData } = data;
    const verCount = versions.length;
    const handleClick = (evt)=>{
        if (evt.target.closest('.MuiDialog-root')) {
            // prevent navigation if using dialog
            evt.preventDefault();
            return;
        }
        // if not link or button, allow navigation
        if (!evt.target.hasAttribute('href') && !evt.target.closest('.MuiButtonBase-root')) onNavigate(`/apps/app/${namespace}/${name}`);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
        size: {
            xs: 12,
            md: 6,
            lg: 4,
            xl: 3
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Item), {
            className: "large-click-target flex no-margin h-full",
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: thumbnail?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$6521433ed15a34db), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: `${(0, $gZwVy.default).ecr}/meta-files/${thumbnail}`
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$6521433ed15a34db), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15b87fc16f8d46d$export$2e2bcd8739ae039), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex column justify-between flex-grow",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Title), {
                                    children: (0, $f446074e335acab0$export$fe98a034cfb96d55).name(name, data)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "GitHub ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                                style: {
                                                    fontSize: '1.1em'
                                                }
                                            })
                                        ]
                                    }),
                                    placement: "top",
                                    className: "external-link hover",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        href: data.source.url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>e.stopPropagation(),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b373839037e81820$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $f1q41.truncate)(description, {
                                length: 70
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex muted items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        view == 'explore' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                namespace,
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$d046b3c4a416f60d), {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                verCount,
                                                " tag",
                                                verCount > 1 ? 's' : ''
                                            ]
                                        })
                                    ]
                                }),
                                hasRecentData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Recent data (from within the last year) is avaiable",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        component: (0, $lzNIT.Link),
                                        to: `/apps/app/${namespace}/${name}?tab=data`,
                                        className: "nowrap pull-right",
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($09fc43707f437bd6$exports))), {}),
                                        children: "data"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $0bb1b8a7eec6af5a$export$2e2bcd8739ae039(props) {
    const { rows: rows, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        children: rows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0bb1b8a7eec6af5a$var$AppBox, {
                data: row,
                ...rest
            }, row.id))
    });
}




var $ayMG0 = parcelRequire("ayMG0");

var $9Lykx = parcelRequire("9Lykx");
var $74aec63eeeb2c856$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $74aec63eeeb2c856$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($74aec63eeeb2c856$exports, "__esModule", {
    value: true
});
$74aec63eeeb2c856$exports.default = void 0;

var $74aec63eeeb2c856$var$_createSvgIcon = $74aec63eeeb2c856$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $74aec63eeeb2c856$var$_default = $74aec63eeeb2c856$exports.default = (0, $74aec63eeeb2c856$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17v-2c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2M3 7v2c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2"
}), 'ViewStream');


var $8a9c78675abbffce$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8a9c78675abbffce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($8a9c78675abbffce$exports, "__esModule", {
    value: true
});
$8a9c78675abbffce$exports.default = void 0;

var $8a9c78675abbffce$var$_createSvgIcon = $8a9c78675abbffce$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8a9c78675abbffce$var$_default = $8a9c78675abbffce$exports.default = (0, $8a9c78675abbffce$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M2 4v7h20V4zm8 16h12v-7H10zm-8 0h6v-7H2z"
}), 'ViewComfy');


function $92699f1d3dbb3eae$export$2e2bcd8739ae039(props) {
    const { layout: layout, onClick: onClick } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                onClick: ()=>onClick('compact'),
                sx: {
                    color: layout === 'compact' ? 'text.primary' : 'text.disabled'
                },
                size: "small",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8a9c78675abbffce$exports))), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                onClick: ()=>onClick('spacious'),
                sx: {
                    color: layout === 'spacious' ? 'text.primary' : 'text.disabled'
                },
                size: "small",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74aec63eeeb2c856$exports))), {})
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $atFJM = parcelRequire("atFJM");

var $c3pId = parcelRequire("c3pId");
function $4c336b56d6859994$export$2e2bcd8739ae039() {
    const path = (0, $aphAM.useMatch)('*').pathname;
    const view = path.split('/')[2];
    const [isDone, setIsDone] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)();
    // effect for updating build status
    (0, $acw62.useEffect)(()=>{
        // must be signed in to fetch build status
        if (!(0, $c3pId.default).isSignedIn) return;
        if (!data || isDone || view == 'explore') return;
        for (const app of data)$atFJM.getBuildStatus(app).then((status)=>{
            // if (!ref.current) return
            setData((prev)=>{
                if (!prev) return prev;
                // copy to change object ref
                const newRows = [
                    ...prev
                ];
                const idx = newRows.findIndex((d)=>d.id == app.id);
                newRows[idx] = {
                    ...newRows[idx],
                    isBuilding: status.building,
                    buildResult: status.result,
                    buildUrl: `${status.url}console`
                };
                return newRows;
            });
        }).catch((error)=>{
        // pass
        });
        setIsDone(true);
    }, [
        isDone,
        data,
        view
    ]);
    return [
        data,
        setData
    ];
}



var $gsYK2 = parcelRequire("gsYK2");

var $f1q41 = parcelRequire("f1q41");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $bcnr1 = parcelRequire("bcnr1");
function $1455de3949293917$export$13386e296638fa34(props) {
    const { start: start, end: end, vsn: vsn, plugin: plugin } = props;
    return $bcnr1.getPluginCounts({
        start: start,
        end: end,
        vsn: vsn,
        plugin: plugin
    }).then((d)=>{
        const data = $1455de3949293917$export$4c0e6fff2d4abe18({
            data: d,
            ...props
        });
        return {
            rawData: d,
            data: data
        };
    });
}
function $1455de3949293917$export$2dc7202091b59713(props) {
    const { start: start, end: end, vsn: vsn, plugin: plugin } = props;
    return $bcnr1.getMediaCounts({
        start: start,
        end: end,
        vsn: vsn,
        plugin: plugin
    }).then((d)=>{
        const data = $1455de3949293917$export$5997c3c2920baf30({
            data: d,
            ...props
        });
        return {
            rawData: d,
            data: data
        };
    });
}
function $1455de3949293917$export$4c0e6fff2d4abe18(props) {
    const { data: data, versions: versions = false, groupName: groupName = 'meta.vsn', time: time = 'hourly' } = props;
    let d = data;
    // remove versions if needed
    if (!versions) d = d.map((o)=>{
        const { plugin: p } = o.meta;
        const isIP = /\d+\.\d+\.\d+\.\d+:\d+/.test(p);
        const plugin = isIP ? p.slice(p.indexOf('/') + 1).split(':')[0] : p.split(':')[0];
        return {
            ...o,
            meta: {
                ...o.meta,
                plugin: plugin,
                origPluginName: p
            }
        };
    });
    const hourlyByVsn = (0, $f1q41.groupBy)(d, groupName);
    if (time == 'hourly') {
        const hourly = Object.keys(hourlyByVsn).reduce((acc, vsn)=>({
                ...acc,
                [vsn]: (0, $f1q41.groupBy)(hourlyByVsn[vsn], 'meta.plugin')
            }), {});
        return hourly;
    } else if (time == 'daily') return $1455de3949293917$export$14231cafbb44b1e2(hourlyByVsn);
    throw `parseData: grain='${time}' not valid`;
}
function $1455de3949293917$export$5997c3c2920baf30(props) {
    const { data: data, groupName: groupName = 'meta.vsn', time: time = 'hourly' } = props;
    const hourlyByVsn = (0, $f1q41.groupBy)(data, groupName);
    if (time == 'hourly') {
        const hourly = Object.keys(hourlyByVsn).reduce((acc, vsn)=>({
                ...acc,
                [vsn]: (0, $f1q41.groupBy)(hourlyByVsn[vsn].map((obj)=>{
                    const { meta: meta } = obj;
                    const { task: task, camera: camera } = meta;
                    return {
                        ...obj,
                        meta: {
                            ...meta,
                            'taskWithCamera': camera ? `${task} (${camera})` : task
                        }
                    };
                }), 'meta.taskWithCamera')
            }), {});
        return hourly;
    } else if (time == 'daily') return $1455de3949293917$export$14231cafbb44b1e2(hourlyByVsn, 'meta.task');
    throw `parseData: grain='${time}' not valid`;
}
function $1455de3949293917$export$14231cafbb44b1e2(hourlyByVSN, grouping = 'meta.plugin') {
    const daily = {};
    // for each vsn
    for (const vsn of Object.keys(hourlyByVSN)){
        const items = hourlyByVSN[vsn];
        const byPlugin = (0, $f1q41.groupBy)(items, grouping);
        // convert byPlugin (of hour records) to byDay for each
        const byPluginHourly = Object.keys(byPlugin).reduce((acc, plugin)=>{
            const items = byPlugin[plugin];
            return {
                ...acc,
                [plugin]: (0, $f1q41.groupBy)(items, (o)=>(0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(new Date(o.timestamp)).toISOString())
            };
        }, {});
        // convert byPluginHoursly to byDay (summing up each hour count)
        const byDay = {};
        for (const [plugin, hourlyObjs] of Object.entries(byPluginHourly)){
            const daily = Object.entries(hourlyObjs).map(([day, objs])=>{
                // here we just take the first object since all objects have the same meta
                // we only need to update the timestamp and value now
                const o = objs[0];
                return {
                    ...o,
                    timestamp: day,
                    value: (0, $f1q41.sumBy)(objs, 'value')
                };
            });
            byDay[plugin] = daily;
        }
        daily[vsn] = byDay;
    }
    return daily;
}
const $1455de3949293917$export$a0eaf844fa4a659a = ()=>$bcnr1.getPluginCounts({
        start: '-1y',
        tail: 1
    }).then((d)=>{
        const byPlugin = (0, $f1q41.groupBy)(d, 'meta.plugin');
        return byPlugin;
    });


const { featuredApps: $9455821df5564e7d$var$featuredApps, samplers: $9455821df5564e7d$var$samplers } = (0, $gsYK2.default);
const $9455821df5564e7d$var$columns = [
    {
        id: 'name',
        label: 'Name',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).name
    },
    {
        id: 'namespace',
        label: 'Namespace'
    },
    {
        id: 'versions',
        label: 'Tags',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).versions
    },
    {
        id: 'owner',
        label: 'Owner'
    },
    {
        id: 'repo',
        label: 'Repo',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).repo
    },
    {
        id: 'time_last_updated',
        label: 'Last Update',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).time
    }
];
const $9455821df5564e7d$var$queryData = (data, query)=>{
    return data.filter((row)=>Object.values(row).join('').toLowerCase().includes(query.toLowerCase()));
};
function $9455821df5564e7d$export$2e2bcd8739ae039() {
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const path = (0, $aphAM.useMatch)('*').pathname;
    const view = path.split('/')[2];
    const navigate = (0, $aphAM.useNavigate)();
    const query = params.get('query') || '';
    const ref = (0, $acw62.useRef)();
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $4c336b56d6859994$export$2e2bcd8739ae039)();
    const [rows, setRows] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    const [pluginData, setPluginData] = (0, $acw62.useState)();
    const [viewStyle, setViewStyle] = (0, $acw62.useState)('spacious');
    const listApps = (0, $acw62.useCallback)(()=>{
        const opts = view == 'explore' ? 'public' : 'mine';
        const p1 = $atFJM.listApps(opts).then((data)=>{
            if (!ref.current) return;
            setData(data);
            return data;
        }).catch((error)=>setError(error.message)).finally(()=>{
            if (!ref.current) return;
            setLoading(false);
        });
        const p2 = (0, $1455de3949293917$export$a0eaf844fa4a659a)();
        Promise.all([
            p1,
            p2
        ]).then(([ecr, pluginData])=>{
            const names = Object.keys(pluginData);
            ecr = ecr.map((obj)=>({
                    ...obj,
                    hasRecentData: !!names.find((name)=>name.includes(`${obj.namespace}/${obj.name}`))
                }));
            setData(ecr);
        });
    }, [
        setLoading,
        view
    ]);
    (0, $acw62.useEffect)(()=>{
        ref.current = true;
        setLoading(true);
        if ([
            'shared-with-me'
        ].includes(view)) {
            // todo(nc): implement
            setData([]);
            setLoading(false);
            return;
        }
        listApps();
        return ()=>{
            ref.current = false;
        };
    }, [
        view,
        setLoading,
        listApps
    ]);
    // effect for queries
    (0, $acw62.useEffect)(()=>{
        if (!data) return;
        setRows($9455821df5564e7d$var$queryData(data, query));
    }, [
        view,
        query,
        data
    ]);
    // todo: refactor into useContext or table componnent?
    const onSearch = ({ query: query })=>{
        if (query) params.set('query', query);
        else params.delete('query');
        setParams(params, {
            replace: true
        });
    };
    const onActionComplete = ()=>{
        setLoading(true);
        listApps();
    };
    const onNavigate = (path)=>{
        navigate(path);
    };
    if (!data && !error) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9455821df5564e7d$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Top), {
                top: "0",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9455821df5564e7d$var$Controls, {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2NJq1.default), {
                            onSearch: onSearch,
                            width: "300px"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex",
                            children: [
                                view !== 'explore' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            component: (0, $lzNIT.Link),
                                            to: "/apps/create-app",
                                            variant: "contained",
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a7ni))), {}),
                                            size: "small",
                                            fullWidth: true,
                                            children: "Create app"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                            orientation: "vertical",
                                            style: {
                                                margin: '0 8px 0 5px'
                                            },
                                            flexItem: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92699f1d3dbb3eae$export$2e2bcd8739ae039), {
                                    layout: viewStyle,
                                    onClick: (view)=>setViewStyle(view)
                                })
                            ]
                        })
                    ]
                })
            }),
            rows && viewStyle == 'compact' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                primaryKey: "id",
                enableSorting: true,
                columns: $9455821df5564e7d$var$columns,
                rows: rows
            }),
            rows && view == 'explore' && viewStyle == 'spacious' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($292ac74a8e0bcaa5$exports))), {}),
                            "\xa0Featured Apps"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bb1b8a7eec6af5a$export$2e2bcd8739ae039), {
                        rows: rows.filter((row)=>$9455821df5564e7d$var$featuredApps.includes(`${row.namespace}/${row.name}`)),
                        view: view,
                        onComplete: onActionComplete,
                        onNavigate: onNavigate
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fa7748a68cf6a1e4$exports))), {}),
                            "\xa0Sampling and Integration Apps"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0bb1b8a7eec6af5a$export$2e2bcd8739ae039), {
                        rows: rows.filter((row)=>$9455821df5564e7d$var$samplers.includes(`${row.namespace}/${row.name}`)),
                        view: view,
                        onComplete: onActionComplete,
                        onNavigate: onNavigate
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                ]
            }),
            rows && view == 'explore' && viewStyle == 'spacious' && /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71802778b2667a33$exports))), {}),
                    "\xa0Other Public Apps"
                ]
            }),
            rows && viewStyle == 'spacious' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4256d352af69bee$export$2e2bcd8739ae039), {
                rows: rows,
                view: view,
                onComplete: onActionComplete,
                onNavigate: onNavigate
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error
            }),
            !loading && view == 'my-apps' && data?.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($9455821df5564e7d$var$NoneFound, {
                className: "flex column items-center justify-center muted",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($87118691f42bf014$exports)))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "You don't have any apps yet.  Try ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                to: "/apps/create-app",
                                children: "creating one"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            !loading && view == 'shared-with-me' && data?.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($9455821df5564e7d$var$NoneFound, {
                className: "flex column items-center justify-center muted",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($87118691f42bf014$exports)))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "No apps are shared with you"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                        children: "(sharing is not fully implemented)"
                    })
                ]
            })
        ]
    });
}
const $9455821df5564e7d$var$Root = (0, $d8seH.default)('div')`
  position: relative;
`;
const $9455821df5564e7d$var$Controls = (0, $d8seH.default)('div')`
  background-color: ${(props)=>props.theme.palette.background.paper};

  padding: 20px 0 15px 0;
  border-bottom: 1px solid ${(props)=>props.theme.palette.divider};

  .MuiButton-root,
  .MuiFormControlLabel-root {
    margin: 0 10px;
  }
`;
const $9455821df5564e7d$var$NoneFound = (0, $d8seH.default)('div')`
  font-size: 2.0em;
  padding-top: 100px;

  img {
    width: 175px;
    margin-right: 20px;
    filter: ${(props)=>props.theme.palette.mode === 'light' ? 'drop-shadow(0px 0px 0.3rem #ccc)' : 'none'};
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $d8seH = parcelRequire("d8seH");
var $2b094bc5a886ac78$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2b094bc5a886ac78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2b094bc5a886ac78$exports, "__esModule", {
    value: true
});
$2b094bc5a886ac78$exports.default = void 0;

var $2b094bc5a886ac78$var$_createSvgIcon = $2b094bc5a886ac78$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2b094bc5a886ac78$var$_default = $2b094bc5a886ac78$exports.default = (0, $2b094bc5a886ac78$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20.54 17.73 15 11V5h1c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1h1v6l-5.54 6.73c-.32.39-.46.83-.46 1.27.01 1.03.82 2 2 2h14c1.19 0 2-.97 2-2 0-.44-.14-.88-.46-1.27"
}), 'ScienceRounded');


var $aebdc3f8d04c064a$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $aebdc3f8d04c064a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($aebdc3f8d04c064a$exports, "__esModule", {
    value: true
});
$aebdc3f8d04c064a$exports.default = void 0;

var $aebdc3f8d04c064a$var$_createSvgIcon = $aebdc3f8d04c064a$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $aebdc3f8d04c064a$var$_default = $aebdc3f8d04c064a$exports.default = (0, $aebdc3f8d04c064a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 3.01H3c-1.1 0-2 .9-2 2V8c0 .55.45 1 1 1s1-.45 1-1V5.99c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v12.03c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V16c0-.55-.45-1-1-1s-1 .45-1 1v3.01c0 1.09.89 1.98 1.98 1.98H21c1.1 0 2-.9 2-2V5.01c0-1.1-.9-2-2-2m-9.15 12.14 2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.32-.85-.1-.85.35V11H2c-.55 0-1 .45-1 1s.45 1 1 1h9v1.79c0 .45.54.67.85.36"
}), 'InputRounded');


var $d9d39c15fde07a1c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d9d39c15fde07a1c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d9d39c15fde07a1c$exports, "__esModule", {
    value: true
});
$d9d39c15fde07a1c$exports.default = void 0;

var $d9d39c15fde07a1c$var$_createSvgIcon = $d9d39c15fde07a1c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d9d39c15fde07a1c$var$_default = $d9d39c15fde07a1c$exports.default = (0, $d9d39c15fde07a1c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7"
}), 'LocalOfferRounded');




var $lkxXU = parcelRequire("lkxXU");


var $hw4Z0 = parcelRequire("hw4Z0");

parcelRequire("kalwe");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $2mdyF = parcelRequire("2mdyF");

var $2gURC = parcelRequire("2gURC");

var $9khrJ = parcelRequire("9khrJ");

var $cVXaD = parcelRequire("cVXaD");

var $6lXkL = parcelRequire("6lXkL");

var $9Lykx = parcelRequire("9Lykx");

var $14H9o = parcelRequire("14H9o");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1cc1a4c8ba8f7694$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12.09 2.91C10.08.9 7.07.49 4.65 1.67L8.28 5.3c.39.39.39 1.02 0 1.41L6.69 8.3c-.39.4-1.02.4-1.41 0L1.65 4.67C.48 7.1.89 10.09 2.9 12.1c1.86 1.86 4.58 2.35 6.89 1.48l7.96 7.96c1.03 1.03 2.69 1.03 3.71 0 1.03-1.03 1.03-2.69 0-3.71L13.54 9.9c.92-2.34.44-5.1-1.45-6.99"
}), 'BuildRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $65ebd81691801e03$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2zM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1m6.5-5-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"
}), 'DeleteOutlineRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0953557707017bc5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d35e0a850e4b4262$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 1.27a11 11 0 00-3.48 21.46c.55.09.73-.28.73-.55v-1.84c-3.03.64-3.67-1.46-3.67-1.46-.55-1.29-1.28-1.65-1.28-1.65-.92-.65.1-.65.1-.65 1.1 0 1.73 1.1 1.73 1.1.92 1.65 2.57 1.2 3.21.92a2 2 0 01.64-1.47c-2.47-.27-5.04-1.19-5.04-5.5 0-1.1.46-2.1 1.2-2.84a3.76 3.76 0 010-2.93s.91-.28 3.11 1.1c1.8-.49 3.7-.49 5.5 0 2.1-1.38 3.02-1.1 3.02-1.1a3.76 3.76 0 010 2.93c.83.74 1.2 1.74 1.2 2.94 0 4.21-2.57 5.13-5.04 5.4.45.37.82.92.82 2.02v3.03c0 .27.1.64.73.55A11 11 0 0012 1.27"
}), 'GitHub');


var $7wXDx = parcelRequire("7wXDx");
var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d239582b0e41976e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4v12H8V4zm0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4z"
}), 'LibraryAddCheckOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $4327e494506ebabb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.41 18.59 8.83 20 12 16.83 15.17 20l1.41-1.41L12 14zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10z"
}), 'UnfoldLessOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $af80bbb3733ed6a6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z"
}), 'UnfoldMoreOutlined');





var $lkxXU = parcelRequire("lkxXU");

var $24m81 = parcelRequire("24m81");

var $2sxTc = parcelRequire("2sxTc");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $1d0bc7ea6e9eb7e7$var$SvgYamlLogo = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        "data-name": "YAML Logo",
        viewBox: "0 0 512 470.647",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M512 422.735H395.638v-172.61h-48.196v219.522H512v-46.912M87.701 250.177v220.47h47.303V318.569l49.505 102.22h37.234l51.196-105.813v155.626h45.379V250.177h-61.96l-54.977 99.706-52.36-99.706z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M330.294 195.39H228.433l-20.717 50.024H162.61l95.38-224.949h46.137l91.51 224.949h-48.2zm-16.92-44.911-31.226-82.55-34.837 82.55z",
                style: {
                    fill: "#cb171e"
                },
                transform: "translate(0 -19.939)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "m235.793 0-91.815 137.674v87.275H87.702v-87.275L0 0h63.25l55.768 88.646L175.243 0z"
            })
        ]
    });
var $1d0bc7ea6e9eb7e7$export$2e2bcd8739ae039 = $1d0bc7ea6e9eb7e7$var$SvgYamlLogo;






var $ifEev = parcelRequire("ifEev");

var $lDN4l = parcelRequire("lDN4l");

var $acw62 = parcelRequire("acw62");
function $104a097c02e8f9d2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $104a097c02e8f9d2$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $104a097c02e8f9d2$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $104a097c02e8f9d2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $104a097c02e8f9d2$export$2e2bcd8739ae039 = $104a097c02e8f9d2$export$4f5d2d50c9deca37;


var $0fdca79f03e679c4$var$__create = Object.create;
var $0fdca79f03e679c4$var$__defProp = Object.defineProperty;
var $0fdca79f03e679c4$var$__defProps = Object.defineProperties;
var $0fdca79f03e679c4$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $0fdca79f03e679c4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0fdca79f03e679c4$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $0fdca79f03e679c4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0fdca79f03e679c4$var$__getProtoOf = Object.getPrototypeOf;
var $0fdca79f03e679c4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0fdca79f03e679c4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0fdca79f03e679c4$var$__defNormalProp = (obj, key, value)=>key in obj ? $0fdca79f03e679c4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0fdca79f03e679c4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0fdca79f03e679c4$var$__hasOwnProp.call(b, prop)) $0fdca79f03e679c4$var$__defNormalProp(a, prop, b[prop]);
    if ($0fdca79f03e679c4$var$__getOwnPropSymbols) {
        for (var prop of $0fdca79f03e679c4$var$__getOwnPropSymbols(b))if ($0fdca79f03e679c4$var$__propIsEnum.call(b, prop)) $0fdca79f03e679c4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0fdca79f03e679c4$var$__spreadProps = (a, b)=>$0fdca79f03e679c4$var$__defProps(a, $0fdca79f03e679c4$var$__getOwnPropDescs(b));
var $0fdca79f03e679c4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0fdca79f03e679c4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0fdca79f03e679c4$var$__getOwnPropSymbols) {
        for (var prop of $0fdca79f03e679c4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0fdca79f03e679c4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0fdca79f03e679c4$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$0fdca79f03e679c4$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $0fdca79f03e679c4$var$__export = (target, all)=>{
    for(var name in all)$0fdca79f03e679c4$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $0fdca79f03e679c4$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $0fdca79f03e679c4$var$__getOwnPropNames(from))if (!$0fdca79f03e679c4$var$__hasOwnProp.call(to, key) && key !== except) $0fdca79f03e679c4$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $0fdca79f03e679c4$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $0fdca79f03e679c4$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $0fdca79f03e679c4$var$__create($0fdca79f03e679c4$var$__getProtoOf(mod)) : {}, $0fdca79f03e679c4$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $0fdca79f03e679c4$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var $0fdca79f03e679c4$var$require_prism = $0fdca79f03e679c4$var$__commonJS({
    "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js" (exports, module) {
        var Prism2 = function() {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
                /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */ util: {
                    encode: function encode(tokens) {
                        if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                        else if (Array.isArray(tokens)) return tokens.map(encode);
                        else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */ type: function(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */ objId: function(obj) {
                        if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        });
                        return obj["__id"];
                    },
                    /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */ clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone;
                        var id;
                        switch(_.util.type(o)){
                            case "Object":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = /** @type {Record<string, any>} */ {};
                                visited[id] = clone;
                                for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                                return /** @type {any} */ clone;
                            case "Array":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = [];
                                visited[id] = clone;
                                /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                });
                                return /** @type {any} */ clone;
                            default:
                                return o;
                        }
                    },
                    /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */ getLanguage: function(element) {
                        while(element){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */ setLanguage: function(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), "");
                        element.classList.add("language-" + language);
                    },
                    /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */ isActive: function(element, className, defaultActivation) {
                        var no = "no-" + className;
                        while(element){
                            var classList = element.classList;
                            if (classList.contains(className)) return true;
                            if (classList.contains(no)) return false;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */ languages: {
                    /**
           * The grammar for plain, unformatted text.
           */ plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */ extend: function(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */ insertBefore: function(inside, before, insert, root) {
                        root = root || /** @type {any} */ _.languages;
                        var grammar = root[inside];
                        var ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) {
                                for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                            }
                            if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                        }
                        var old = root[inside];
                        root[inside] = ret;
                        _.languages.DFS(_.languages, function(key, value) {
                            if (value === old && key != inside) this[key] = ret;
                        });
                        return ret;
                    },
                    // Traverse a language definition with Depth First Search
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i];
                            var propertyType = _.util.type(property);
                            if (propertyType === "Object" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, null, visited);
                            } else if (propertyType === "Array" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, i, visited);
                            }
                        }
                    }
                },
                plugins: {},
                /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */ highlight: function(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar: grammar,
                        language: language
                    };
                    _.hooks.run("before-tokenize", env);
                    if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    env.tokens = _.tokenize(env.code, env.grammar);
                    _.hooks.run("after-tokenize", env);
                    return Token.stringify(_.util.encode(env.tokens), env.language);
                },
                /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */ tokenize: function(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList();
                    addAfter(tokenList, tokenList.head, text);
                    matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                    return toArray(tokenList);
                },
                /**
         * @namespace
         * @memberof Prism
         * @public
         */ hooks: {
                    all: {},
                    /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */ add: function(name, callback) {
                        var hooks2 = _.hooks.all;
                        hooks2[name] = hooks2[name] || [];
                        hooks2[name].push(callback);
                    },
                    /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */ run: function(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!callbacks || !callbacks.length) return;
                        for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token: Token
            };
            function Token(type, content, alias, matchedStr) {
                this.type = type;
                this.content = content;
                this.alias = alias;
                this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    o.forEach(function(e) {
                        s += stringify(e, language);
                    });
                    return s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language: language
                };
                var aliases = o.alias;
                if (aliases) {
                    if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                    else env.classes.push(aliases);
                }
                _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength;
                    match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar){
                    if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j];
                        var inside = patternObj.inside;
                        var lookbehind = !!patternObj.lookbehind;
                        var greedy = !!patternObj.greedy;
                        var alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        var pattern = patternObj.pattern || patternObj;
                        for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                            if (rematch && pos >= rematch.reach) break;
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (str instanceof Token) continue;
                            var removeCount = 1;
                            var match;
                            if (greedy) {
                                match = matchPattern(pattern, pos, text, lookbehind);
                                if (!match || match.index >= text.length) break;
                                var from = match.index;
                                var to = match.index + match[0].length;
                                var p = pos;
                                p += currentNode.value.length;
                                while(from >= p){
                                    currentNode = currentNode.next;
                                    p += currentNode.value.length;
                                }
                                p -= currentNode.value.length;
                                pos = p;
                                if (currentNode.value instanceof Token) continue;
                                for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                                    removeCount++;
                                    p += k.value.length;
                                }
                                removeCount--;
                                str = text.slice(pos, p);
                                match.index -= pos;
                            } else {
                                match = matchPattern(pattern, 0, str, lookbehind);
                                if (!match) continue;
                            }
                            var from = match.index;
                            var matchStr = match[0];
                            var before = str.slice(0, from);
                            var after = str.slice(from + matchStr.length);
                            var reach = pos + str.length;
                            if (rematch && reach > rematch.reach) rematch.reach = reach;
                            var removeFrom = currentNode.prev;
                            if (before) {
                                removeFrom = addAfter(tokenList, removeFrom, before);
                                pos += before.length;
                            }
                            removeRange(tokenList, removeFrom, removeCount);
                            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                            currentNode = addAfter(tokenList, removeFrom, wrapped);
                            if (after) addAfter(tokenList, currentNode, after);
                            if (removeCount > 1) {
                                var nestedRematch = {
                                    cause: token + "," + j,
                                    reach: reach
                                };
                                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                                if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                };
                var tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail;
                this.head = head;
                this.tail = tail;
                this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next;
                var newNode = {
                    value: value,
                    prev: node,
                    next: next
                };
                node.next = newNode;
                next.prev = newNode;
                list.length++;
                return newNode;
            }
            function removeRange(list, node, count) {
                var next = node.next;
                for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next;
                next.prev = node;
                list.length -= i;
            }
            function toArray(list) {
                var array = [];
                var node = list.head.next;
                while(node !== list.tail){
                    array.push(node.value);
                    node = node.next;
                }
                return array;
            }
            return _;
        }();
        module.exports = Prism2;
        Prism2.default = Prism2;
    }
});
// src/prism-langs.ts
var $0fdca79f03e679c4$export$dc7257ffb0972f87 = $0fdca79f03e679c4$var$__toESM($0fdca79f03e679c4$var$require_prism());
$0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.inside["attr-value"].inside.entity = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.entity, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.doctype.inside["internal-subset"].inside = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.hooks.add("wrap", function(e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty($0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag, "addInlined", {
    value: function(e, n) {
        var t = {}, t = (t["language-" + n] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages[n]
        }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: t
            }
        }), n = (t["language-" + n] = {
            pattern: /[\s\S]+/,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages[n]
        }, {});
        n[e] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return e;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: t
        }, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag, "addAttribute", {
    value: function(e, n) {
        $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                n,
                                "language-" + n
                            ],
                            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages[n]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.html = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.mathml = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.svg = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("markup", {}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.ssml = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.atom = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.rss = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.xml, function(e) {
    var n = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
    }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: true,
        alias: "variable"
    };
    e.languages.regex = {
        "char-class": {
            pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
            lookbehind: true,
            inside: {
                "char-class-negation": {
                    pattern: /(^\[)\^/,
                    lookbehind: true,
                    alias: "operator"
                },
                "char-class-punctuation": {
                    pattern: /^\[|\]$/,
                    alias: "punctuation"
                },
                range: {
                    pattern: a,
                    inside: {
                        escape: t,
                        "range-punctuation": {
                            pattern: /-/,
                            alias: "operator"
                        }
                    }
                },
                "special-escape": n,
                "char-set": {
                    pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
                    alias: "class-name"
                },
                escape: t
            }
        },
        "special-escape": n,
        "char-set": {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
        },
        backreference: [
            {
                pattern: /\\(?![123][0-7]{2})[1-9]/,
                alias: "keyword"
            },
            {
                pattern: /\\k<[^<>']+>/,
                alias: "keyword",
                inside: {
                    "group-name": r
                }
            }
        ],
        anchor: {
            pattern: /[$^]|\\[ABbGZz]/,
            alias: "function"
        },
        escape: t,
        group: [
            {
                pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                alias: "punctuation",
                inside: {
                    "group-name": r
                }
            },
            {
                pattern: /\)/,
                alias: "punctuation"
            }
        ],
        quantifier: {
            pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
            alias: "number"
        },
        alternation: {
            pattern: /\|/,
            alias: "keyword"
        }
    };
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    "class-name": [
        $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    keyword: [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    parameter: [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
        }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("javascript", "string", {
    hashbang: {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup && ($0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.addInlined("script", "javascript"), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.js = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.javascript, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript["class-name"].alias = "function", delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript.parameter, delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.actionscript["literal-property"], $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup && $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markup
    }
}), function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                script: {
                    pattern: /[\s\S]+/,
                    alias: "language-javascript",
                    inside: e.languages.javascript
                }
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(l) {
    var e = l.languages.javadoclike = {
        parameter: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
            lookbehind: true
        },
        keyword: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
            lookbehind: true
        },
        punctuation: /[{}]/
    };
    Object.defineProperty(e, "addSupport", {
        value: function(e2, o) {
            (e2 = "string" == typeof e2 ? [
                e2
            ] : e2).forEach(function(e3) {
                var n = function(e4) {
                    e4.inside || (e4.inside = {}), e4.inside.rest = o;
                }, t = "doc-comment";
                if (a = l.languages[e3]) {
                    var a, r = a[t];
                    if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", {
                        "doc-comment": {
                            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                            lookbehind: true,
                            alias: "comment"
                        }
                    }))[t]) instanceof RegExp && (r = a[t] = {
                        pattern: r
                    }), Array.isArray(r)) for(var s = 0, i = r.length; s < i; s++)r[s] instanceof RegExp && (r[s] = {
                        pattern: r[s]
                    }), n(r[s]);
                    else n(r);
                }
            });
        }
    }), e.addSupport([
        "java",
        "javascript",
        "php"
    ], e);
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                rule: /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                keyword: {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        url: {
            pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                function: /^url/i,
                punctuation: /^\(|\)$/,
                string: {
                    pattern: RegExp("^" + n.source + "$"),
                    alias: "url"
                }
            }
        },
        selector: {
            pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        string: {
            pattern: n,
            greedy: true
        },
        property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        important: /!important\b/i,
        function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = {
        pattern: e.languages.css.selector.pattern,
        lookbehind: true,
        inside: n = {
            "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            "pseudo-class": /:[-\w]+/,
            class: /\.[-\w]+/,
            id: /#[-\w]+/,
            attribute: {
                pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"),
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    "case-sensitivity": {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: "keyword"
                    },
                    namespace: {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\|$/
                        }
                    },
                    "attr-name": {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    "attr-value": [
                        n,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    operator: /[|~*^$]?=/
                }
            },
            "n-th": [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        number: /[\dn]+/,
                        operator: /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            combinator: />|\+|~|\|\|/,
            punctuation: /[(),]/
        }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", {
        variable: {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    }), {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }), t = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    e.languages.insertBefore("css", "function", {
        operator: {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        hexcode: {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: "color"
        },
        color: [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    unit: n,
                    number: t,
                    function: /[\w-]+(?=\()/,
                    punctuation: /[(),]/
                }
            }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: n,
        number: t
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function i(e2, n2) {
        n2 = (n2 || "").replace(/m/g, "") + "m";
        var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return a;
        }).replace(/<<value>>/g, function() {
            return e2;
        });
        return RegExp(t2, n2);
    }
    e.languages.yaml = {
        scalar: {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return a;
            })),
            lookbehind: true,
            alias: "string"
        },
        comment: /#.*/,
        key: {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return a;
            }).replace(/<<key>>/g, function() {
                return "(?:" + r + "|" + s + ")";
            })),
            lookbehind: true,
            greedy: true,
            alias: "atrule"
        },
        directive: {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: "important"
        },
        datetime: {
            pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: "number"
        },
        boolean: {
            pattern: i(/false|true/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        null: {
            pattern: i(/null|~/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        string: {
            pattern: i(s),
            lookbehind: true,
            greedy: true
        },
        number: {
            pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
            lookbehind: true
        },
        tag: t,
        important: n,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(o) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function e(e2) {
        return e2 = e2.replace(/<inner>/g, function() {
            return n;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
    }
    var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return t;
    }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                punctuation: /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: o.languages.yaml
                }
            }
        },
        blockquote: {
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        table: {
            pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(t),
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + a + ")" + r + "$"),
                    lookbehind: true,
                    inside: {
                        punctuation: /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + a + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(t),
                            alias: "important",
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                }
            }
        },
        code: [
            {
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    punctuation: /```/
                }
            }
        ],
        title: [
            {
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        hr: {
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        list: {
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                variable: {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                punctuation: /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        bold: {
            pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /\*\*|__/
            }
        },
        italic: {
            pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /[*_]/
            }
        },
        strike: {
            pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /~~?/
            }
        },
        "code-snippet": {
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        url: {
            pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                operator: /^!/,
                content: {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {}
                },
                variable: {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                url: {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                string: {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    }), [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(n2) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(e2) {
            n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
        });
    }), o.hooks.add("after-tokenize", function(e2) {
        "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
            if (n2 && "string" != typeof n2) for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r2, s = n2[t2];
                "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [
                    ""
                ])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [
                    s.alias,
                    r2
                ] : s.alias.push(r2) : s.alias = [
                    r2
                ]));
            }
        }(e2.tokens);
    }), o.hooks.add("wrap", function(e2) {
        if ("code-block" === e2.type) {
            for(var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++){
                var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
                if (r2) {
                    n2 = r2[1];
                    break;
                }
            }
            var s, i = o.languages[n2];
            i ? e2.content = o.highlight(function(e3) {
                e3 = e3.replace(l, "");
                return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
                    var t3;
                    return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
                });
            }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + /* @__PURE__ */ new Date().valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
                var e3 = document.getElementById(s);
                e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
            }));
        }
    }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    o.languages.md = o.languages.markdown;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.graphql = {
    comment: /#.*/,
    description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: "string",
        inside: {
            "language-markdown": {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.markdown
            }
        }
    },
    string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
    },
    "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.hooks.add("after-tokenize", function(e) {
    if ("graphql" === e.language) for(var i = e.tokens.filter(function(e2) {
        return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length;){
        var n = i[o++];
        if ("keyword" === n.type && "mutation" === n.content) {
            var t = [];
            if (p([
                "definition-mutation",
                "punctuation"
            ]) && "(" === c(1).content) {
                o += 2;
                var a = d(/^\($/, /^\)$/);
                if (-1 === a) continue;
                for(; o < a; o++){
                    var r = c(0);
                    "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
                }
                o = a + 1;
            }
            if (p([
                "punctuation",
                "property-query"
            ]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
                var s = d(/^\{$/, /^\}$/);
                if (-1 !== s) for(var l = o; l < s; l++){
                    var u = i[l];
                    "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
                }
            }
        }
    }
    function c(e2) {
        return i[o + e2];
    }
    function p(e2, n2) {
        n2 = n2 || 0;
        for(var t2 = 0; t2 < e2.length; t2++){
            var a2 = c(t2 + n2);
            if (!a2 || a2.type !== e2[t2]) return;
        }
        return 1;
    }
    function d(e2, n2) {
        for(var t2 = 1, a2 = o; a2 < i.length; a2++){
            var r2 = i[a2], s2 = r2.content;
            if ("punctuation" === r2.type && "string" == typeof s2) {
                if (e2.test(s2)) t2++;
                else if (n2.test(s2) && 0 === --t2) return a2;
            }
        }
        return -1;
    }
    function g(e2, n2) {
        var t2 = e2.alias;
        t2 ? Array.isArray(t2) || (e2.alias = t2 = [
            t2
        ]) : e2.alias = t2 = [], t2.push(n2);
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    variable: [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            punctuation: /^`|`$/
        }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
}, function(b) {
    var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
    function n(e2, n2) {
        if (b.languages[e2]) return {
            pattern: RegExp("((?:" + n2 + ")\\s*)" + t),
            lookbehind: true,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                "embedded-code": {
                    pattern: /[\s\S]+/,
                    alias: e2
                }
            }
        };
    }
    function h(e2, n2, t2) {
        e2 = {
            code: e2,
            grammar: n2,
            language: t2
        };
        return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
    }
    function l(a2, e2, r) {
        var n2 = b.tokenize(a2, {
            interpolation: {
                pattern: RegExp(s),
                lookbehind: true
            }
        }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
            if ("string" == typeof e3) return e3;
            for(var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")););
            return d[n3] = e3, n3;
        }).join(""), e2, r), g = Object.keys(d);
        return p = 0, function e3(n3) {
            for(var t2 = 0; t2 < n3.length; t2++){
                if (p >= g.length) return;
                var a3, r2, s2, i, o, l2, u2, c = n3[t2];
                "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [
                    1,
                    1
                ]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [
                    i
                ]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [
                    t2,
                    1
                ].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([
                    u2
                ]));
            }
        }(n2), new b.Token(r, n2, "language-" + r, a2);
    }
    b.languages.javascript["template-string"] = [
        n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        n("svg", /\bsvg/.source),
        n("markdown", /\b(?:markdown|md)/.source),
        n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        n("sql", /\bsql/.source),
        e
    ].filter(Boolean);
    var a = {
        javascript: true,
        js: true,
        typescript: true,
        ts: true,
        jsx: true,
        tsx: true
    };
    function u(e2) {
        return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
    }
    b.hooks.add("after-tokenize", function(e2) {
        e2.language in a && !function e3(n2) {
            for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r, s2, i, o = n2[t2];
                "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([
                    r
                ]));
            }
        }(e2.tokens);
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
        decorator: {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                at: {
                    pattern: /^@/,
                    alias: "operator"
                },
                function: /^[\s\S]+/
            }
        },
        "generic-function": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: n
                }
            }
        }
    }), e.languages.ts = e.languages.typescript;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
        parameter: {
            pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    }), e.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
            pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
            lookbehind: true,
            inside: {
                parameter: {
                    pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                code: {
                    pattern: /(=)[\s\S]*(?=\]$)/,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                },
                punctuation: /[=[\]]/
            }
        },
        "class-name": [
            {
                pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                    return t;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                pattern: RegExp("(@[a-z]+\\s+)" + t),
                lookbehind: true,
                inside: {
                    string: n.string,
                    number: n.number,
                    boolean: n.boolean,
                    keyword: e.languages.typescript.keyword,
                    operator: /=>|\.\.\.|[&|?:*]/,
                    punctuation: /[.,;=<>{}()[\]]/
                }
            }
        ],
        example: {
            pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
            lookbehind: true,
            inside: {
                code: {
                    pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                }
            }
        }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
        type: [
            {
                pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
            pattern: /\{\||\|\}/,
            alias: "punctuation"
        }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [
        e.languages.flow.keyword
    ]), e.languages.flow.keyword.unshift({
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: true
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.n4js = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("n4js", "constant", {
    annotation: {
        pattern: /@+\w+/,
        alias: "operator"
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.n4jsd = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.n4js, function(e) {
    function n(e2, n2) {
        return RegExp(e2.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), n2);
    }
    e.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
            lookbehind: true,
            alias: [
                "function-variable",
                "method",
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "function", {
        method: {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
            lookbehind: true,
            alias: [
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
            {
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: "class-name"
            },
            {
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.insertBefore("javascript", "keyword", {
        imports: {
            pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: e.languages.javascript
        },
        exports: {
            pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: e.languages.javascript
        }
    }), e.languages.javascript.keyword.unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
    }, {
        pattern: /\bnull\b/,
        alias: [
            "null",
            "nil"
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
        spread: {
            pattern: /\.{3}/,
            alias: "operator"
        },
        arrow: {
            pattern: /=>/,
            alias: "operator"
        }
    }), e.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
            pattern: n(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        "maybe-class-name": {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        dom: {
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: "variable"
        },
        console: {
            pattern: /\bconsole(?=\s*\.)/,
            alias: "class-name"
        }
    });
    for(var t = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
    ], a = 0; a < t.length; a++){
        var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = {
            pattern: s
        } : s).inside || {};
        (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(s) {
    var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function n(e2, n2) {
        return e2 = e2.replace(/<S>/g, function() {
            return t;
        }).replace(/<BRACES>/g, function() {
            return a;
        }).replace(/<SPREAD>/g, function() {
            return r;
        }), RegExp(e2, n2);
    }
    r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", {
        spread: {
            pattern: n(/<SPREAD>/.source),
            inside: s.languages.jsx
        }
    }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", {
        script: {
            pattern: n(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
                "script-punctuation": {
                    pattern: /^=(?=\{)/,
                    alias: "punctuation"
                },
                rest: s.languages.jsx
            }
        }
    }, s.languages.jsx.tag);
    function i(e2) {
        for(var n2 = [], t2 = 0; t2 < e2.length; t2++){
            var a2 = e2[t2], r2 = false;
            "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({
                tagName: o(a2.content[0].content[1]),
                openedBraces: 0
            }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
        }
    }
    var o = function(e2) {
        return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
    };
    s.hooks.add("after-tokenize", function(e2) {
        "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
    });
}($0fdca79f03e679c4$export$dc7257ffb0972f87), function(e) {
    var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
    n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.swift = {
    comment: {
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                punctuation: /\\(?=[\r\n])/,
                string: /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                string: /[\s\S]+/
            }
        }
    ],
    directive: {
        pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            boolean: /\b(?:false|true)\b/,
            number: /\b\d+(?:\.\d+)*\b/,
            operator: /!|&&|\|\||[<>]=?/,
            punctuation: /[(),]/
        }
    },
    literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    attribute: {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    label: {
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.swift;
}), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
        keyword: {
            pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
            lookbehind: true
        },
        function: [
            {
                pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                greedy: true
            },
            {
                pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                lookbehind: true,
                greedy: true
            }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
        "interpolation-punctuation": {
            pattern: /^\$\{?|\}$/,
            alias: "punctuation"
        },
        expression: {
            pattern: /[\s\S]+/,
            inside: e.languages.kotlin
        }
    };
    e.languages.insertBefore("kotlin", "string", {
        "string-literal": [
            {
                pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                alias: "multiline",
                inside: {
                    interpolation: {
                        pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            },
            {
                pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                alias: "singleline",
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        lookbehind: true,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        char: {
            pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
            greedy: true
        }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
        annotation: {
            pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
            alias: "builtin"
        }
    }), e.languages.insertBefore("kotlin", "function", {
        label: {
            pattern: /\b\w+@|@\w+\b/,
            alias: "symbol"
        }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    char: {
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            string: [
                {
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.string
            ],
            char: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.char,
            comment: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.comment,
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            directive: {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
                pattern: /\S[\s\S]*/,
                inside: $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c
            }
        }
    }
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.c.boolean, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objectivec = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("c", {
    string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objectivec["class-name"], $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objc = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.objectivec, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.reason = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("reason", "class-name", {
    char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
    }
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.reason.function, function(e) {
    for(var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)n = n.replace(/<self>/g, function() {
        return n;
    });
    n = n.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    }), e.languages.rust = {
        comment: [
            {
                pattern: RegExp(/(^|[^\\])/.source + n),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        char: {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        attribute: {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                string: null
            }
        },
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    punctuation: /::/
                }
            }
        ],
        keyword: [
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
            pattern: /\b\w+!/,
            alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                punctuation: /::/
            }
        },
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.go = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
}), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.insertBefore("go", "string", {
    char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
}), delete $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.go["class-name"], function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return n.source;
    });
    e.languages.cpp = e.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return n.source;
                })),
                lookbehind: true
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: n,
        number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
        module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return t;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                string: /^[<"][\s\S]+/,
                operator: /:/,
                punctuation: /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    }), e.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                function: /^\w+/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: e.languages.cpp
                }
            }
        }
    }), e.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    }), e.languages.insertBefore("cpp", "class-name", {
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: e.languages.extend("cpp", {})
        }
    }), e.languages.insertBefore("inside", "double-colon", {
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
}($0fdca79f03e679c4$export$dc7257ffb0972f87), $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python = {
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            string: /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            punctuation: /\./
        }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python["string-interpolation"].inside.interpolation.inside.rest = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.py = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.python, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.json = {
    property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
        pattern: /\bnull\b/,
        alias: "keyword"
    }
}, $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.webmanifest = $0fdca79f03e679c4$export$dc7257ffb0972f87.languages.json;
// src/themes/index.ts
var $0fdca79f03e679c4$export$d9a33280f07116d9 = {};
$0fdca79f03e679c4$var$__export($0fdca79f03e679c4$export$d9a33280f07116d9, {
    dracula: ()=>$0fdca79f03e679c4$var$dracula_default,
    duotoneDark: ()=>$0fdca79f03e679c4$var$duotoneDark_default,
    duotoneLight: ()=>$0fdca79f03e679c4$var$duotoneLight_default,
    github: ()=>$0fdca79f03e679c4$var$github_default,
    gruvboxMaterialDark: ()=>$0fdca79f03e679c4$var$gruvboxMaterialDark_default,
    gruvboxMaterialLight: ()=>$0fdca79f03e679c4$var$gruvboxMaterialLight_default,
    jettwaveDark: ()=>$0fdca79f03e679c4$var$jettwaveDark_default,
    jettwaveLight: ()=>$0fdca79f03e679c4$var$jettwaveLight_default,
    nightOwl: ()=>$0fdca79f03e679c4$var$nightOwl_default,
    nightOwlLight: ()=>$0fdca79f03e679c4$var$nightOwlLight_default,
    oceanicNext: ()=>$0fdca79f03e679c4$var$oceanicNext_default,
    okaidia: ()=>$0fdca79f03e679c4$var$okaidia_default,
    oneDark: ()=>$0fdca79f03e679c4$var$oneDark_default,
    oneLight: ()=>$0fdca79f03e679c4$var$oneLight_default,
    palenight: ()=>$0fdca79f03e679c4$var$palenight_default,
    shadesOfPurple: ()=>$0fdca79f03e679c4$var$shadesOfPurple_default,
    synthwave84: ()=>$0fdca79f03e679c4$var$synthwave84_default,
    ultramin: ()=>$0fdca79f03e679c4$var$ultramin_default,
    vsDark: ()=>$0fdca79f03e679c4$var$vsDark_default,
    vsLight: ()=>$0fdca79f03e679c4$var$vsLight_default
});
// src/themes/dracula.ts
var $0fdca79f03e679c4$var$theme = {
    plain: {
        color: "#F8F8F2",
        backgroundColor: "#282A36"
    },
    styles: [
        {
            types: [
                "prolog",
                "constant",
                "builtin"
            ],
            style: {
                color: "rgb(189, 147, 249)"
            }
        },
        {
            types: [
                "inserted",
                "function"
            ],
            style: {
                color: "rgb(80, 250, 123)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 85)"
            }
        },
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 184, 108)"
            }
        },
        {
            types: [
                "punctuation",
                "symbol"
            ],
            style: {
                color: "rgb(248, 248, 242)"
            }
        },
        {
            types: [
                "string",
                "char",
                "tag",
                "selector"
            ],
            style: {
                color: "rgb(255, 121, 198)"
            }
        },
        {
            types: [
                "keyword",
                "variable"
            ],
            style: {
                color: "rgb(189, 147, 249)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(98, 114, 164)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(241, 250, 140)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$dracula_default = $0fdca79f03e679c4$var$theme;
// src/themes/duotoneDark.ts
var $0fdca79f03e679c4$var$theme2 = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$duotoneDark_default = $0fdca79f03e679c4$var$theme2;
// src/themes/duotoneLight.ts
var $0fdca79f03e679c4$var$theme3 = {
    plain: {
        backgroundColor: "#faf8f5",
        color: "#728fcb"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#b6ad9a"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#063289"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#b29762"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#2d2006"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#896724"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule"
            ],
            style: {
                color: "#728fcb"
            }
        },
        {
            types: [
                "placeholder",
                "variable"
            ],
            style: {
                color: "#93abdc"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#896724"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$duotoneLight_default = $0fdca79f03e679c4$var$theme3;
// src/themes/github.ts
var $0fdca79f03e679c4$var$theme4 = {
    plain: {
        color: "#393A34",
        backgroundColor: "#f6f8fa"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#999988",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#e3116c"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#393A34"
            }
        },
        {
            types: [
                "entity",
                "url",
                "symbol",
                "number",
                "boolean",
                "variable",
                "constant",
                "property",
                "regex",
                "inserted"
            ],
            style: {
                color: "#36acaa"
            }
        },
        {
            types: [
                "atrule",
                "keyword",
                "attr-name",
                "selector"
            ],
            style: {
                color: "#00a4db"
            }
        },
        {
            types: [
                "function",
                "deleted",
                "tag"
            ],
            style: {
                color: "#d73a49"
            }
        },
        {
            types: [
                "function-variable"
            ],
            style: {
                color: "#6f42c1"
            }
        },
        {
            types: [
                "tag",
                "selector",
                "keyword"
            ],
            style: {
                color: "#00009f"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$github_default = $0fdca79f03e679c4$var$theme4;
// src/themes/nightOwl.ts
var $0fdca79f03e679c4$var$theme5 = {
    plain: {
        color: "#d6deeb",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(99, 119, 119)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(214, 222, 235)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(255, 203, 139)"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "rgb(127, 219, 202)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "property"
            ],
            style: {
                color: "rgb(128, 203, 196)"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$nightOwl_default = $0fdca79f03e679c4$var$theme5;
// src/themes/nightOwlLight.ts
var $0fdca79f03e679c4$var$theme6 = {
    plain: {
        color: "#403f53",
        backgroundColor: "#FBFBFB"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(72, 118, 214)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(152, 159, 177)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "builtin",
                "char",
                "constant",
                "url"
            ],
            style: {
                color: "rgb(72, 118, 214)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(201, 103, 101)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(170, 9, 130)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "function",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(153, 76, 195)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(17, 17, 17)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "operator",
                "property",
                "keyword",
                "namespace"
            ],
            style: {
                color: "rgb(12, 150, 155)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(188, 84, 84)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$nightOwlLight_default = $0fdca79f03e679c4$var$theme6;
// src/themes/oceanicNext.ts
var $0fdca79f03e679c4$var$colors = {
    char: "#D8DEE9",
    comment: "#999999",
    keyword: "#c5a5c5",
    primitive: "#5a9bcf",
    string: "#8dc891",
    variable: "#d7deea",
    boolean: "#ff8b50",
    punctuation: "#5FB3B3",
    tag: "#fc929e",
    function: "#79b6f2",
    className: "#FAC863",
    method: "#6699CC",
    operator: "#fc929e"
};
var $0fdca79f03e679c4$var$theme7 = {
    plain: {
        backgroundColor: "#282c34",
        color: "#ffffff"
    },
    styles: [
        {
            types: [
                "attr-name"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.keyword
            }
        },
        {
            types: [
                "attr-value"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.string
            }
        },
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata",
                "shebang"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.comment
            }
        },
        {
            types: [
                "property",
                "number",
                "function-name",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.primitive
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.boolean
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.tag
            }
        },
        {
            types: [
                "string"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.string
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.string
            }
        },
        {
            types: [
                "selector",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.char
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.function
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url",
                "variable"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.variable
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.keyword
            }
        },
        {
            types: [
                "atrule",
                "class-name"
            ],
            style: {
                color: $0fdca79f03e679c4$var$colors.className
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                fontWeight: "400"
            }
        },
        {
            types: [
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        }
    ]
};
var $0fdca79f03e679c4$var$oceanicNext_default = $0fdca79f03e679c4$var$theme7;
// src/themes/okaidia.ts
var $0fdca79f03e679c4$var$theme8 = {
    plain: {
        color: "#f8f8f2",
        backgroundColor: "#272822"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "#f92672",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#8292a2",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "#a6e22e"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "#e6db74"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "#a6e22e",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "#66d9ef"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)",
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "property"
            ],
            style: {
                color: "#f92672"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#a6e22e !important"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "#8292a2"
            }
        },
        {
            types: [
                "rule"
            ],
            style: {
                color: "#e6db74"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$okaidia_default = $0fdca79f03e679c4$var$theme8;
// src/themes/palenight.ts
var $0fdca79f03e679c4$var$theme9 = {
    plain: {
        color: "#bfc7d5",
        backgroundColor: "#292d3e"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(105, 112, 152)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "inserted"
            ],
            style: {
                color: "rgb(195, 232, 141)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            types: [
                "punctuation",
                "selector"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(191, 199, 213)"
            }
        },
        {
            types: [
                "class-name",
                "attr-name"
            ],
            style: {
                color: "rgb(255, 203, 107)"
            }
        },
        {
            types: [
                "tag",
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 114)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(137, 221, 255)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "rgb(221, 221, 221)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$palenight_default = $0fdca79f03e679c4$var$theme9;
// src/themes/shadesOfPurple.ts
var $0fdca79f03e679c4$var$theme10 = {
    plain: {
        color: "#9EFEFF",
        backgroundColor: "#2D2A55"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(179, 98, 255)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(255, 255, 255)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(165, 255, 144)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "number",
                "boolean"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 180, 84)"
            }
        },
        {
            types: [
                "keyword",
                "operator",
                "property",
                "namespace",
                "tag",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(255, 157, 0)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "rgb(250, 208, 0)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$shadesOfPurple_default = $0fdca79f03e679c4$var$theme10;
// src/themes/synthwave84.ts
var $0fdca79f03e679c4$var$theme11 = {
    plain: {
        backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
        backgroundImage: "#34294f",
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    styles: [
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#495495",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#ccc"
            }
        },
        {
            types: [
                "tag",
                "attr-name",
                "namespace",
                "number",
                "unit",
                "hexcode",
                "deleted"
            ],
            style: {
                color: "#e2777a"
            }
        },
        {
            types: [
                "property",
                "selector"
            ],
            style: {
                color: "#72f1b8",
                textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
            }
        },
        {
            types: [
                "function-name"
            ],
            style: {
                color: "#6196cc"
            }
        },
        {
            types: [
                "boolean",
                "selector-id",
                "function"
            ],
            style: {
                color: "#fdfdfd",
                textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
            }
        },
        {
            types: [
                "class-name",
                "maybe-class-name",
                "builtin"
            ],
            style: {
                color: "#fff5f6",
                textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
            }
        },
        {
            types: [
                "constant",
                "symbol"
            ],
            style: {
                color: "#f92aad",
                textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
            }
        },
        {
            types: [
                "important",
                "atrule",
                "keyword",
                "selector-class"
            ],
            style: {
                color: "#f4eee4",
                textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
            }
        },
        {
            types: [
                "string",
                "char",
                "attr-value",
                "regex",
                "variable"
            ],
            style: {
                color: "#f87c32"
            }
        },
        {
            types: [
                "parameter"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity",
                "url"
            ],
            style: {
                color: "#67cdcc"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "ffffffee"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "green"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$synthwave84_default = $0fdca79f03e679c4$var$theme11;
// src/themes/ultramin.ts
var $0fdca79f03e679c4$var$theme12 = {
    plain: {
        color: "#282a2e",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(197, 200, 198)"
            }
        },
        {
            types: [
                "string",
                "number",
                "builtin",
                "variable"
            ],
            style: {
                color: "rgb(150, 152, 150)"
            }
        },
        {
            types: [
                "class-name",
                "function",
                "tag",
                "attr-name"
            ],
            style: {
                color: "rgb(40, 42, 46)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$ultramin_default = $0fdca79f03e679c4$var$theme12;
// src/themes/vsDark.ts
var $0fdca79f03e679c4$var$theme13 = {
    plain: {
        color: "#9CDCFE",
        backgroundColor: "#1E1E1E"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "rgb(0, 0, 128)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(106, 153, 85)"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "rgb(181, 206, 168)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(100, 102, 149)"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "rgb(156, 220, 254)"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "rgb(206, 145, 120)"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "rgb(215, 186, 125)"
            }
        },
        {
            // Fix tag color
            types: [
                "tag"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            // Fix tag color for HTML
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "rgb(212, 212, 212)"
            }
        },
        {
            // Fix punctuation color for HTML
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "rgb(220, 220, 170)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "rgb(209, 105, 105)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$vsDark_default = $0fdca79f03e679c4$var$theme13;
// src/themes/vsLight.ts
var $0fdca79f03e679c4$var$theme14 = {
    plain: {
        color: "#000000",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(0, 128, 0)"
            }
        },
        {
            types: [
                "builtin"
            ],
            style: {
                color: "rgb(0, 112, 193)"
            }
        },
        {
            types: [
                "number",
                "variable",
                "inserted"
            ],
            style: {
                color: "rgb(9, 134, 88)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(0, 0, 0)"
            }
        },
        {
            types: [
                "constant",
                "char"
            ],
            style: {
                color: "rgb(129, 31, 63)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(128, 0, 0)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 0, 0)"
            }
        },
        {
            types: [
                "deleted",
                "string"
            ],
            style: {
                color: "rgb(163, 21, 21)"
            }
        },
        {
            types: [
                "changed",
                "punctuation"
            ],
            style: {
                color: "rgb(4, 81, 165)"
            }
        },
        {
            types: [
                "function",
                "keyword"
            ],
            style: {
                color: "rgb(0, 0, 255)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(38, 127, 153)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$vsLight_default = $0fdca79f03e679c4$var$theme14;
// src/themes/jettwaveDark.ts
var $0fdca79f03e679c4$var$theme15 = {
    plain: {
        color: "#f8fafc",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#569CD6"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#f8fafc"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#9CDCFE"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#cbd5e1"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#D4D4D4"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#7dd3fc"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$jettwaveDark_default = $0fdca79f03e679c4$var$theme15;
// src/themes/jettwaveLight.ts
var $0fdca79f03e679c4$var$theme16 = {
    plain: {
        color: "#0f172a",
        backgroundColor: "#f1f5f9"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#0f172a"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#64748b"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#475569"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#0e7490"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$jettwaveLight_default = $0fdca79f03e679c4$var$theme16;
// src/themes/oneDark.ts
var $0fdca79f03e679c4$var$theme17 = {
    plain: {
        backgroundColor: "hsl(220, 13%, 18%)",
        color: "hsl(220, 14%, 71%)",
        textShadow: "0 1px rgba(0, 0, 0, 0.3)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(220, 10%, 40%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "maybe-class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(29, 54%, 61%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(286, 60%, 67%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(355, 65%, 65%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value"
            ],
            style: {
                color: "hsl(95, 38%, 62%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(207, 82%, 66%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(187, 47%, 55%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$oneDark_default = $0fdca79f03e679c4$var$theme17;
// src/themes/oneLight.ts
var $0fdca79f03e679c4$var$theme18 = {
    plain: {
        backgroundColor: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(230, 4%, 64%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(35, 99%, 36%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(301, 63%, 40%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(5, 74%, 59%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value",
                "punctuation"
            ],
            style: {
                color: "hsl(119, 34%, 47%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(221, 87%, 60%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(198, 99%, 37%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$oneLight_default = $0fdca79f03e679c4$var$theme18;
// src/themes/gruvboxMaterialDark.ts
var $0fdca79f03e679c4$var$theme19 = {
    plain: {
        color: "#ebdbb2",
        backgroundColor: "#292828"
    },
    styles: [
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin",
                "function"
            ],
            style: {
                color: "#d8a657"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#7daea3"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#e78a4e"
            }
        },
        {
            types: [
                "attr-name",
                "char",
                "url",
                "regex"
            ],
            style: {
                color: "#a9b665"
            }
        },
        {
            types: [
                "attr-value",
                "string"
            ],
            style: {
                color: "#89b482"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#ea6962"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#d3869b"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$gruvboxMaterialDark_default = $0fdca79f03e679c4$var$theme19;
// src/themes/gruvboxMaterialLight.ts
var $0fdca79f03e679c4$var$theme20 = {
    plain: {
        color: "#654735",
        backgroundColor: "#f9f5d7"
    },
    styles: [
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#af2528"
            }
        },
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin"
            ],
            style: {
                color: "#b4730e"
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#477a5b"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#266b79"
            }
        },
        {
            types: [
                "function",
                "attr-name",
                "char",
                "url"
            ],
            style: {
                color: "#72761e"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#b94c07"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#924f79"
            }
        }
    ]
};
var $0fdca79f03e679c4$var$gruvboxMaterialLight_default = $0fdca79f03e679c4$var$theme20;
var $0fdca79f03e679c4$var$useGetLineProps = (themeDictionary)=>(0, $acw62.useCallback)((_a)=>{
        var _b = _a, { className: className, style: style, line: line } = _b, rest = $0fdca79f03e679c4$var$__objRest(_b, [
            "className",
            "style",
            "line"
        ]);
        const output = $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, rest), {
            className: (0, $104a097c02e8f9d2$export$2e2bcd8739ae039)("token-line", className)
        });
        if (typeof themeDictionary === "object" && "plain" in themeDictionary) output.style = themeDictionary.plain;
        if (typeof style === "object") output.style = $0fdca79f03e679c4$var$__spreadValues($0fdca79f03e679c4$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        themeDictionary
    ]);
var $0fdca79f03e679c4$var$useGetTokenProps = (themeDictionary)=>{
    const styleForToken = (0, $acw62.useCallback)(({ types: types, empty: empty })=>{
        if (themeDictionary == null) return void 0;
        else if (types.length === 1 && types[0] === "plain") return empty != null ? {
            display: "inline-block"
        } : void 0;
        else if (types.length === 1 && empty != null) return themeDictionary[types[0]];
        return Object.assign(empty != null ? {
            display: "inline-block"
        } : {}, ...types.map((type)=>themeDictionary[type]));
    }, [
        themeDictionary
    ]);
    return (0, $acw62.useCallback)((_a)=>{
        var _b = _a, { token: token, className: className, style: style } = _b, rest = $0fdca79f03e679c4$var$__objRest(_b, [
            "token",
            "className",
            "style"
        ]);
        const output = $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, rest), {
            className: (0, $104a097c02e8f9d2$export$2e2bcd8739ae039)("token", ...token.types, className),
            children: token.content,
            style: styleForToken(token)
        });
        if (style != null) output.style = $0fdca79f03e679c4$var$__spreadValues($0fdca79f03e679c4$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        styleForToken
    ]);
};
// src/utils/normalizeTokens.ts
var $0fdca79f03e679c4$var$newlineRe = /\r\n|\r|\n/;
var $0fdca79f03e679c4$var$normalizeEmptyLines = (line)=>{
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $0fdca79f03e679c4$var$appendTypes = (types, add)=>{
    const typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
};
var $0fdca79f03e679c4$var$normalizeTokens = (tokens)=>{
    const typeArrStack = [
        []
    ];
    const tokenArrStack = [
        tokens
    ];
    const tokenArrIndexStack = [
        0
    ];
    const tokenArrSizeStack = [
        tokens.length
    ];
    let i = 0;
    let stackIndex = 0;
    let currentLine = [];
    const acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            let content;
            let types = typeArrStack[stackIndex];
            const tokenArr = tokenArrStack[stackIndex];
            const token = tokenArr[i];
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $0fdca79f03e679c4$var$appendTypes(types, token.type);
                if (token.alias) types = $0fdca79f03e679c4$var$appendTypes(types, token.alias);
                content = token.content;
            }
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            }
            const splitByNewlines = content.split($0fdca79f03e679c4$var$newlineRe);
            const newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            });
            for(let i2 = 1; i2 < newlineCount; i2++){
                $0fdca79f03e679c4$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i2]
                });
            }
        }
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $0fdca79f03e679c4$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $0fdca79f03e679c4$export$2dc420fd853fdcc4 = $0fdca79f03e679c4$var$normalizeTokens;
var $0fdca79f03e679c4$export$7b94e077f7691ca1 = ({ prism: prism, code: code, grammar: grammar, language: language })=>{
    return (0, $acw62.useMemo)(()=>{
        if (grammar == null) return $0fdca79f03e679c4$export$2dc420fd853fdcc4([
            code
        ]);
        const prismConfig = {
            code: code,
            grammar: grammar,
            language: language,
            tokens: []
        };
        prism.hooks.run("before-tokenize", prismConfig);
        prismConfig.tokens = prism.tokenize(code, grammar);
        prism.hooks.run("after-tokenize", prismConfig);
        return $0fdca79f03e679c4$export$2dc420fd853fdcc4(prismConfig.tokens);
    }, [
        code,
        grammar,
        language,
        // prism is a stable import
        prism
    ]);
};
// src/utils/themeToDict.ts
var $0fdca79f03e679c4$var$themeToDict = (theme21, language)=>{
    const { plain: plain } = theme21;
    const themeDict = theme21.styles.reduce((acc, themeEntry)=>{
        const { languages: languages2, style: style } = themeEntry;
        if (languages2 && !languages2.includes(language)) return acc;
        themeEntry.types.forEach((type)=>{
            const accStyle = $0fdca79f03e679c4$var$__spreadValues($0fdca79f03e679c4$var$__spreadValues({}, acc[type]), style);
            acc[type] = accStyle;
        });
        return acc;
    }, {});
    themeDict.root = plain;
    themeDict.plain = $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, plain), {
        backgroundColor: void 0
    });
    return themeDict;
};
var $0fdca79f03e679c4$var$themeToDict_default = $0fdca79f03e679c4$var$themeToDict;
// src/components/highlight.ts
var $0fdca79f03e679c4$var$Highlight = ({ children: children, language: _language, code: code, theme: theme21, prism: prism })=>{
    const language = _language.toLowerCase();
    const themeDictionary = $0fdca79f03e679c4$var$themeToDict_default(theme21, language);
    const getLineProps = $0fdca79f03e679c4$var$useGetLineProps(themeDictionary);
    const getTokenProps = $0fdca79f03e679c4$var$useGetTokenProps(themeDictionary);
    const grammar = prism.languages[language];
    const tokens = $0fdca79f03e679c4$export$7b94e077f7691ca1({
        prism: prism,
        language: language,
        code: code,
        grammar: grammar
    });
    return children({
        tokens: tokens,
        className: `prism-code language-${language}`,
        style: themeDictionary != null ? themeDictionary.root : {},
        getLineProps: getLineProps,
        getTokenProps: getTokenProps
    });
};
// src/index.ts
var $0fdca79f03e679c4$export$39dbc3f558091353 = (props)=>(0, $acw62.createElement)($0fdca79f03e679c4$var$Highlight, $0fdca79f03e679c4$var$__spreadProps($0fdca79f03e679c4$var$__spreadValues({}, props), {
        prism: props.prism || $0fdca79f03e679c4$export$dc7257ffb0972f87,
        theme: props.theme || $0fdca79f03e679c4$var$vsDark_default,
        code: props.code,
        language: props.language
    }));
 /*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/ 


var $atFJM = parcelRequire("atFJM");

var $c3pId = parcelRequire("c3pId");

var $gZwVy = parcelRequire("gZwVy");
const $1465055af5cdf337$var$docker = (0, $gZwVy.default).dockerRegistry;
function $1465055af5cdf337$export$2e2bcd8739ae039(props) {
    const { enqueueSnackbar: enqueueSnackbar } = (0, $24m81.useSnackbar)();
    const theme = (0, $14H9o.default)();
    const classes = (0, $9khrJ.useAccordionStyles)();
    const [versions, setVersions] = (0, $4c336b56d6859994$export$2e2bcd8739ae039)();
    const [cfgMap, setCfgMap] = (0, $acw62.useState)({});
    const [format, setFormat] = (0, $acw62.useState)('yaml');
    const [showFullConfig, setShowFullConfig] = (0, $acw62.useState)(false);
    const [loadingConfigs, setLoadingConfigs] = (0, $acw62.useState)(false);
    const [buildSubmitted, setBuildSubmitted] = (0, $acw62.useState)(false);
    const [deleteTag, setDeleteTag] = (0, $acw62.useState)(null);
    const [expanded, setExpanded] = (0, $acw62.useState)('panel-0');
    // fetch all submitted app configs
    (0, $acw62.useEffect)(()=>{
        setLoadingConfigs(true);
        const proms = props.versions.map(({ namespace: namespace, name: name, version: version })=>$atFJM.getAppConfig({
                namespace: namespace,
                name: name,
                version: version
            }));
        Promise.all(proms).then((configs)=>{
            const cMap = configs.reduce((acc, cfg)=>cfg.version in acc ? acc : {
                    ...acc,
                    [cfg.version]: cfg
                }, {});
            setCfgMap(cMap);
        }).finally(()=>setLoadingConfigs(false));
        if (typeof setVersions === 'function') setVersions(props.versions);
    }, [
        props.versions,
        setVersions
    ]);
    const handleChange = (panel)=>(_, isExpanded)=>{
            setExpanded(isExpanded ? panel : false);
        };
    const onClickDeleteTag = (evt, app)=>{
        evt.stopPropagation();
        setDeleteTag(app);
    };
    const onClickBuild = (evt, app)=>{
        evt.stopPropagation();
        enqueueSnackbar('Build submitted');
        setBuildSubmitted(true);
        $atFJM.build(app).then(()=>{
            enqueueSnackbar('Build started');
            if (typeof setVersions === 'function') setVersions((prev)=>prev);
        }).catch((error)=>{
            enqueueSnackbar(`${error.message}  Please contact us for help.`, {
                variant: 'error'
            });
        }).finally(()=>setBuildSubmitted(false));
    };
    // after confirmation handle
    const handleDelete = ()=>{
        return $atFJM.deleteApp({
            namespace: deleteTag.namespace || '',
            name: deleteTag.name,
            version: deleteTag.version
        }).then(()=>enqueueSnackbar('Tag deleted!', {
                variant: 'success'
            })).catch(()=>enqueueSnackbar('Failed to delete tag', {
                variant: 'error'
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            versions && versions.map((ver, i)=>{
                const { namespace: namespace, name: name, version: version, description: description, time_last_updated: time_last_updated, buildUrl: buildUrl, isBuilding: isBuilding, buildResult: buildResult } = ver;
                const panel = `panel-${i}`;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9khrJ.default), {
                    className: classes.root,
                    expanded: expanded === panel,
                    onChange: handleChange(panel),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                            expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {
                                className: "caret"
                            }),
                            "aria-controls": `${panel}-content`,
                            id: `${panel}-content`,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex gap",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: version
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: classes.secondaryHeading,
                                                children: [
                                                    "updated ",
                                                    (0, $f446074e335acab0$export$fe98a034cfb96d55).time(time_last_updated)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c07caf1618b8b680$export$2e2bcd8739ae039), {
                                                buildUrl: buildUrl,
                                                isBuilding: isBuilding,
                                                buildResult: buildResult
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "tag-actions flex",
                                        children: [
                                            namespace == (0, $c3pId.default).user && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex gap",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: "Submit a new version of this app",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                            size: "small",
                                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d239582b0e41976e$export$2e2bcd8739ae039), {}),
                                                            variant: "contained",
                                                            color: "primary",
                                                            disabled: isBuilding || buildSubmitted,
                                                            component: (0, $lzNIT.Link),
                                                            to: `/apps/create-app?url=${ver.source.url}&branch=${ver.source.branch || ver.source.tag}`,
                                                            children: buildSubmitted ? 'Submitting...' : 'New'
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: "Rebuild this tagged version",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                            onClick: (evt)=>onClickBuild(evt, ver),
                                                            size: "small",
                                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc1a4c8ba8f7694$export$2e2bcd8739ae039), {}),
                                                            variant: "contained",
                                                            color: "primary",
                                                            disabled: isBuilding || buildSubmitted,
                                                            children: buildSubmitted ? 'Submitting...' : 'Rebuild'
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                        title: "Delete tag",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                            onClick: (evt)=>onClickDeleteTag(evt, ver),
                                                            size: "small",
                                                            className: "delete",
                                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65ebd81691801e03$export$2e2bcd8739ae039), {}),
                                                            variant: "outlined",
                                                            style: {
                                                                color: 'rgb(145, 35, 65)',
                                                                border: '1px solid rgb(145, 35, 65)'
                                                            },
                                                            children: "Delete"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                                        orientation: "vertical",
                                                        style: {
                                                            margin: '0 10px 0 0'
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        "GitHub ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7wXDx.default), {
                                                            style: {
                                                                fontSize: '1.1em'
                                                            }
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                    component: "a",
                                                    href: ver.source.url,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    onClick: (e)=>e.stopPropagation(),
                                                    size: "small",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d35e0a850e4b4262$export$2e2bcd8739ae039), {
                                                        fontSize: "small"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2mdyF.default), {
                            className: "flex column",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "no-margin",
                                    children: description
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-end justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                                            size: "small",
                                            value: format,
                                            exclusive: true,
                                            onChange: (evt, val)=>setFormat(val),
                                            "aria-label": "display config format",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                                    value: "yaml",
                                                    "aria-label": "yaml",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d0bc7ea6e9eb7e7$export$2e2bcd8739ae039), {
                                                        height: 18,
                                                        width: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                                    value: "json",
                                                    "aria-label": "json",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-color",
                                                            children: '{'
                                                        }),
                                                        "json",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "text-color",
                                                            children: '}'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: showFullConfig ? 'Show only app config' : 'Show all details',
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                    onClick: ()=>setShowFullConfig(!showFullConfig),
                                                    size: "small",
                                                    children: showFullConfig ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4327e494506ebabb$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af80bbb3733ed6a6$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        })
                                    ]
                                }),
                                loadingConfigs && /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                    className: "code",
                                    children: "loading..."
                                }),
                                version in cfgMap && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fdca79f03e679c4$export$39dbc3f558091353), {
                                        theme: theme.palette.mode === 'dark' ? (0, $0fdca79f03e679c4$export$d9a33280f07116d9).vsDark : (0, $0fdca79f03e679c4$export$d9a33280f07116d9).github,
                                        language: format === 'yaml' ? 'yaml' : 'json',
                                        code: !showFullConfig ? format == 'yaml' ? (0, $2sxTc.stringify)(cfgMap[version]) : JSON.stringify(cfgMap[version], null, 4) : format == 'yaml' ? (0, $2sxTc.stringify)((versions || []).filter((ver)=>ver.version == version)[0]) : JSON.stringify((versions || []).filter((ver)=>ver.version == version)[0], null, 4),
                                        children: ({ className: className, style: style, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                                className: className,
                                                style: {
                                                    ...style,
                                                    background: theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.palette.background.default,
                                                    margin: 0
                                                },
                                                children: tokens.map((line, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        ...getLineProps({
                                                            line: line,
                                                            key: i
                                                        }),
                                                        children: line.map((token, key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                ...getTokenProps({
                                                                    token: token,
                                                                    key: key
                                                                })
                                                            }, key))
                                                    }, i))
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                    className: "muted no-margin",
                                    children: "Pull this image"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                                    content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "docker pull ",
                                            $1465055af5cdf337$var$docker,
                                            "/",
                                            namespace,
                                            "/",
                                            name,
                                            ":",
                                            version
                                        ]
                                    }),
                                    tooltip: "Copy CMD"
                                })
                            ]
                        })
                    ]
                }, ver.id);
            }),
            deleteTag && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: `Are you sure you want to delete tag ${deleteTag.version}?`,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "This action cannot be undone!"
                }),
                confirmBtnText: "Delete",
                confirmBtnStyle: {
                    background: '#c70000'
                },
                onConfirm: handleDelete,
                onClose: ()=>setDeleteTag(null)
            })
        ]
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iAtns = parcelRequire("iAtns");

var $2iAqv = parcelRequire("2iAqv");

var $gOa8m = parcelRequire("gOa8m");
const $99958fa69128e58e$var$columns = [
    {
        id: 'id',
        label: 'Argument'
    },
    {
        id: 'type',
        label: 'Type'
    },
    {
        id: 'description',
        label: 'Description'
    },
    {
        id: 'default',
        label: 'Default'
    }
];
function $99958fa69128e58e$export$2e2bcd8739ae039(props) {
    const { versions: versions } = props;
    const initVer = versions[0];
    const [ver, setVer] = (0, $acw62.useState)(initVer.version);
    const [inputs, setInputs] = (0, $acw62.useState)(initVer.inputs);
    const handleChange = (evt)=>{
        const { value: value } = evt.target;
        setVer(value);
        setInputs(versions.find((o)=>o.version == value).inputs);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center gap",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    select: true,
                    value: ver,
                    label: "Version",
                    onChange: handleChange,
                    children: versions.map(({ version: v })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                            value: v,
                            children: v
                        }, v))
                })
            }),
            inputs && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                primaryKey: "id",
                enableSorting: true,
                columns: $99958fa69128e58e$var$columns,
                rows: inputs,
                emptyNotice: "No input arguments were provided"
            })
        ]
    });
}




var $atFJM = parcelRequire("atFJM");

var $c3pId = parcelRequire("c3pId");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $dd481356e993216d$var$SvgGit = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fill: "#0A0B09",
            d: "M15.698 7.287 8.713.302a1.03 1.03 0 0 0-1.458 0l-1.45 1.45 1.84 1.84a1.223 1.223 0 0 1 1.55 1.56l1.773 1.774a1.226 1.226 0 1 1-.734.691L8.579 5.965v4.352q.177.087.325.232a1.226 1.226 0 1 1-1.333-.268V5.887a1.226 1.226 0 0 1-.666-1.608L5.093 2.466l-4.79 4.79a1.03 1.03 0 0 0 0 1.458l6.986 6.985a1.03 1.03 0 0 0 1.457 0l6.953-6.953a1.03 1.03 0 0 0 0-1.458"
        })
    });
var $dd481356e993216d$export$2e2bcd8739ae039 = $dd481356e993216d$var$SvgGit;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $cfb79c02bd3b81be$var$SvgLink = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        "data-icon": "link",
        "data-prefix": "fas",
        viewBox: "0 0 512 512",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fill: "currentColor",
            d: "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.04 16.04 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.5 152.5 0 0 1 20.522 17.197M467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.5 152.5 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.04 16.04 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959"
        })
    });
var $cfb79c02bd3b81be$export$2e2bcd8739ae039 = $cfb79c02bd3b81be$var$SvgLink;



var $6ami2 = parcelRequire("6ami2");

var $atFJM = parcelRequire("atFJM");
const $a7730932b4f5accb$var$urlShortner = (url)=>`${url.slice(0, 40).replace('https://', '')}...`;
const $a7730932b4f5accb$var$metaItem = (data, label)=>{
    const key = label.toLowerCase();
    return data[key]?.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: data[key]
            })
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "muted not-found",
                children: "None submitted"
            })
        ]
    });
};
// todo(nc): support more badges
const $a7730932b4f5accb$var$getLicense = (license)=>{
    if (!license) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "muted not-found",
        children: "None submitted"
    });
    const text = license.toLowerCase();
    let img, a;
    if (text.includes('mit')) [img, a] = [
        `License-MIT-yellow.svg`,
        'licenses/MIT'
    ];
    else if (text.includes('bsd') && text.includes('3')) [img, a] = [
        `License-BSD%203--Clause-blue.svg`,
        'licenses/BSD-3-Clause'
    ];
    else if (text.includes('apache') && text.includes('2')) [img, a] = [
        `License-Apache%202.0-yellowgreen.svg`,
        'licenses/Apache-2.0'
    ];
    else if (text.includes('gnu') && text.includes('3')) [img, a] = [
        `License-GPLv3-blue.svg`,
        'licenses/gpl-3.0'
    ];
    if (a) return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: `https://opensource.org/${a}`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: `https://img.shields.io/badge/${img}`,
                alt: license
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        children: license
    });
};
function $a7730932b4f5accb$export$2e2bcd8739ae039(props) {
    const { data: data } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a7730932b4f5accb$var$Root, {
        children: [
            data.images && /*#__PURE__*/ (0, $ayMG0.jsx)($a7730932b4f5accb$var$SciImage, {
                src: `${$atFJM.url}/meta-files/${data.images[0]}`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: "Repository"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    href: data?.source.url,
                    target: "_blank",
                    rel: "noreferrer",
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dd481356e993216d$export$2e2bcd8739ae039), {}),
                        " ",
                        ' ',
                        $a7730932b4f5accb$var$urlShortner(data?.source.url.slice(0, 40))
                    ]
                })
            }),
            data.homepage && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: "Homepage"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                            href: data.homepage,
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfb79c02bd3b81be$export$2e2bcd8739ae039), {}),
                                " ",
                                ' ',
                                $a7730932b4f5accb$var$urlShortner(data.homepage)
                            ]
                        })
                    })
                ]
            }),
            data?.authors && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: "Authors"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        children: data?.authors.split(',').map((auth)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: auth.split('<')[0]
                            }, auth))
                    })
                ]
            }),
            data.keywords && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        children: "Keywords"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($a7730932b4f5accb$var$Keywords, {
                        children: data?.keywords.split(',').map((keyword)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                label: keyword,
                                variant: "outlined",
                                size: "small"
                            }, keyword))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: "License"
            }),
            $a7730932b4f5accb$var$getLicense(data.license),
            $a7730932b4f5accb$var$metaItem(data, 'Funding'),
            $a7730932b4f5accb$var$metaItem(data, 'Collaborators')
        ]
    });
}
const $a7730932b4f5accb$var$Root = (0, $lmFrL.default).div`
  margin: 0 0 0 4em;
  min-width: 300px;
  max-width: 300px;

  h4 {
    opacity: 0.6;
    margin-bottom: 0.5em;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  p, ul {
    margin: .5em 2px 1.5em 4px;
    font-weight: 600;

    svg {
      margin-right: .3em;
      width: 16px;
      height: 16px;
      color: rgb(10, 11, 9);
    }
  }

  .not-found {
    font-weight: 400;
  }

  .MuiChip-root { font-weight: 500; }
`;
const $a7730932b4f5accb$var$Keywords = (0, $lmFrL.default).div`
  margin: 10px 0;

  div {
    margin: 2px;
  }
`;
const $a7730932b4f5accb$var$SciImage = (0, $lmFrL.default).img`
  margin-top: 1em;
  width: 100%;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $gTmRg = parcelRequire("gTmRg");
// @ts-nocheck

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
var $dc1c498a1ad915c1$exports = {};
// https://d3js.org v7.8.5 Copyright 2010-2023 Mike Bostock
(function(global, factory) {
    factory($dc1c498a1ad915c1$exports);
})($dc1c498a1ad915c1$exports, function(exports1) {
    'use strict';
    var version = "7.8.5";
    function ascending$3(a, b) {
        return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function descending$2(a, b) {
        return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function bisector(f) {
        let compare1, compare2, delta;
        // If an accessor is specified, promote it to a comparator. In this case we
        // can test whether the search value is (self-) comparable. We can’t do this
        // for a comparator (except for specific, known comparators) because we can’t
        // tell if the comparator is symmetric, and an asymmetric comparator can’t be
        // used to test whether a single value is comparable.
        if (f.length !== 2) {
            compare1 = ascending$3;
            compare2 = (d, x)=>ascending$3(f(d), x);
            delta = (d, x)=>f(d) - x;
        } else {
            compare1 = f === ascending$3 || f === descending$2 ? f : zero$1;
            compare2 = f;
            delta = f;
        }
        function left(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi);
            }
            return lo;
        }
        function right(a, x, lo = 0, hi = a.length) {
            if (lo < hi) {
                if (compare1(x, x) !== 0) return hi;
                do {
                    const mid = lo + hi >>> 1;
                    if (compare2(a[mid], x) <= 0) lo = mid + 1;
                    else hi = mid;
                }while (lo < hi);
            }
            return lo;
        }
        function center(a, x, lo = 0, hi = a.length) {
            const i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return {
            left: left,
            center: center,
            right: right
        };
    }
    function zero$1() {
        return 0;
    }
    function number$3(x) {
        return x === null ? NaN : +x;
    }
    function* numbers(values, valueof) {
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) yield value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
        }
    }
    const ascendingBisect = bisector(ascending$3);
    const bisectRight = ascendingBisect.right;
    const bisectLeft = ascendingBisect.left;
    const bisectCenter = bisector(number$3).center;
    var bisect = bisectRight;
    function blur(values, r) {
        if (!((r = +r) >= 0)) throw new RangeError("invalid r");
        let length = values.length;
        if (!((length = Math.floor(length)) >= 0)) throw new RangeError("invalid length");
        if (!length || !r) return values;
        const blur = blurf(r);
        const temp = values.slice();
        blur(values, temp, 0, length, 1);
        blur(temp, values, 0, length, 1);
        blur(values, temp, 0, length, 1);
        return values;
    }
    const blur2 = Blur2(blurf);
    const blurImage = Blur2(blurfImage);
    function Blur2(blur) {
        return function(data, rx, ry = rx) {
            if (!((rx = +rx) >= 0)) throw new RangeError("invalid rx");
            if (!((ry = +ry) >= 0)) throw new RangeError("invalid ry");
            let { data: values, width: width, height: height } = data;
            if (!((width = Math.floor(width)) >= 0)) throw new RangeError("invalid width");
            if (!((height = Math.floor(height !== undefined ? height : values.length / width)) >= 0)) throw new RangeError("invalid height");
            if (!width || !height || !rx && !ry) return data;
            const blurx = rx && blur(rx);
            const blury = ry && blur(ry);
            const temp = values.slice();
            if (blurx && blury) {
                blurh(blurx, temp, values, width, height);
                blurh(blurx, values, temp, width, height);
                blurh(blurx, temp, values, width, height);
                blurv(blury, values, temp, width, height);
                blurv(blury, temp, values, width, height);
                blurv(blury, values, temp, width, height);
            } else if (blurx) {
                blurh(blurx, values, temp, width, height);
                blurh(blurx, temp, values, width, height);
                blurh(blurx, values, temp, width, height);
            } else if (blury) {
                blurv(blury, values, temp, width, height);
                blurv(blury, temp, values, width, height);
                blurv(blury, values, temp, width, height);
            }
            return data;
        };
    }
    function blurh(blur, T, S, w, h) {
        for(let y = 0, n = w * h; y < n;)blur(T, S, y, y += w, 1);
    }
    function blurv(blur, T, S, w, h) {
        for(let x = 0, n = w * h; x < w; ++x)blur(T, S, x, x + n, w);
    }
    function blurfImage(radius) {
        const blur = blurf(radius);
        return (T, S, start, stop, step)=>{
            start <<= 2, stop <<= 2, step <<= 2;
            blur(T, S, start + 0, stop + 0, step);
            blur(T, S, start + 1, stop + 1, step);
            blur(T, S, start + 2, stop + 2, step);
            blur(T, S, start + 3, stop + 3, step);
        };
    }
    // Given a target array T, a source array S, sets each value T[i] to the average
    // of {S[i - r], …, S[i], …, S[i + r]}, where r = ⌊radius⌋, start <= i < stop,
    // for each i, i + step, i + 2 * step, etc., and where S[j] is clamped between
    // S[start] (inclusive) and S[stop] (exclusive). If the given radius is not an
    // integer, S[i - r - 1] and S[i + r + 1] are added to the sum, each weighted
    // according to r - ⌊radius⌋.
    function blurf(radius) {
        const radius0 = Math.floor(radius);
        if (radius0 === radius) return bluri(radius);
        const t = radius - radius0;
        const w = 2 * radius + 1;
        return (T, S, start, stop, step)=>{
            if (!((stop -= step) >= start)) return; // inclusive stop
            let sum = radius0 * S[start];
            const s0 = step * radius0;
            const s1 = s0 + step;
            for(let i = start, j = start + s0; i < j; i += step)sum += S[Math.min(stop, i)];
            for(let i = start, j = stop; i <= j; i += step){
                sum += S[Math.min(stop, i + s0)];
                T[i] = (sum + t * (S[Math.max(start, i - s1)] + S[Math.min(stop, i + s1)])) / w;
                sum -= S[Math.max(start, i - s0)];
            }
        };
    }
    // Like blurf, but optimized for integer radius.
    function bluri(radius) {
        const w = 2 * radius + 1;
        return (T, S, start, stop, step)=>{
            if (!((stop -= step) >= start)) return; // inclusive stop
            let sum = radius * S[start];
            const s = step * radius;
            for(let i = start, j = start + s; i < j; i += step)sum += S[Math.min(stop, i)];
            for(let i = start, j = stop; i <= j; i += step){
                sum += S[Math.min(stop, i + s)];
                T[i] = sum / w;
                sum -= S[Math.max(start, i - s)];
            }
        };
    }
    function count$1(values, valueof) {
        let count = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) ++count;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
        }
        return count;
    }
    function length$3(array) {
        return array.length | 0;
    }
    function empty$2(length) {
        return !(length > 0);
    }
    function arrayify(values) {
        return typeof values !== "object" || "length" in values ? values : Array.from(values);
    }
    function reducer(reduce) {
        return (values)=>reduce(...values);
    }
    function cross$2(...values) {
        const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
        values = values.map(arrayify);
        const lengths = values.map(length$3);
        const j = values.length - 1;
        const index = new Array(j + 1).fill(0);
        const product = [];
        if (j < 0 || lengths.some(empty$2)) return product;
        while(true){
            product.push(index.map((j, i)=>values[i][j]));
            let i = j;
            while(++index[i] === lengths[i]){
                if (i === 0) return reduce ? product.map(reduce) : product;
                index[i--] = 0;
            }
        }
    }
    function cumsum(values, valueof) {
        var sum = 0, index = 0;
        return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
    }
    function variance(values, valueof) {
        let count = 0;
        let delta;
        let mean = 0;
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) {
                delta = value - mean;
                mean += delta / ++count;
                sum += delta * (value - mean);
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
                delta = value - mean;
                mean += delta / ++count;
                sum += delta * (value - mean);
            }
        }
        if (count > 1) return sum / (count - 1);
    }
    function deviation(values, valueof) {
        const v = variance(values, valueof);
        return v ? Math.sqrt(v) : v;
    }
    function extent$1(values, valueof) {
        let min;
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
                if (min === undefined) {
                    if (value >= value) min = max = value;
                } else {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    }
    // https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
    class Adder {
        constructor(){
            this._partials = new Float64Array(32);
            this._n = 0;
        }
        add(x) {
            const p = this._partials;
            let i = 0;
            for(let j = 0; j < this._n && j < 32; j++){
                const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                if (lo) p[i++] = lo;
                x = hi;
            }
            p[i] = x;
            this._n = i + 1;
            return this;
        }
        valueOf() {
            const p = this._partials;
            let n = this._n, x, y, lo, hi = 0;
            if (n > 0) {
                hi = p[--n];
                while(n > 0){
                    x = hi;
                    y = p[--n];
                    hi = x + y;
                    lo = y - (hi - x);
                    if (lo) break;
                }
                if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                    y = lo * 2;
                    x = hi + y;
                    if (y == x - hi) hi = x;
                }
            }
            return hi;
        }
    }
    function fsum(values, valueof) {
        const adder = new Adder();
        if (valueof === undefined) {
            for (let value of values)if (value = +value) adder.add(value);
        } else {
            let index = -1;
            for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
        }
        return +adder;
    }
    function fcumsum(values, valueof) {
        const adder = new Adder();
        let index = -1;
        return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
    }
    class InternMap extends Map {
        constructor(entries, key = keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (entries != null) for (const [key, value] of entries)this.set(key, value);
        }
        get(key) {
            return super.get(intern_get(this, key));
        }
        has(key) {
            return super.has(intern_get(this, key));
        }
        set(key, value) {
            return super.set(intern_set(this, key), value);
        }
        delete(key) {
            return super.delete(intern_delete(this, key));
        }
    }
    class InternSet extends Set {
        constructor(values, key = keyof){
            super();
            Object.defineProperties(this, {
                _intern: {
                    value: new Map()
                },
                _key: {
                    value: key
                }
            });
            if (values != null) for (const value of values)this.add(value);
        }
        has(value) {
            return super.has(intern_get(this, value));
        }
        add(value) {
            return super.add(intern_set(this, value));
        }
        delete(value) {
            return super.delete(intern_delete(this, value));
        }
    }
    function intern_get({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        return _intern.has(key) ? _intern.get(key) : value;
    }
    function intern_set({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) return _intern.get(key);
        _intern.set(key, value);
        return value;
    }
    function intern_delete({ _intern: _intern, _key: _key }, value) {
        const key = _key(value);
        if (_intern.has(key)) {
            value = _intern.get(key);
            _intern.delete(key);
        }
        return value;
    }
    function keyof(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function identity$9(x) {
        return x;
    }
    function group(values, ...keys) {
        return nest(values, identity$9, identity$9, keys);
    }
    function groups(values, ...keys) {
        return nest(values, Array.from, identity$9, keys);
    }
    function flatten$1(groups, keys) {
        for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                    ...g,
                    key,
                    value
                ]));
        return groups;
    }
    function flatGroup(values, ...keys) {
        return flatten$1(groups(values, ...keys), keys);
    }
    function flatRollup(values, reduce, ...keys) {
        return flatten$1(rollups(values, reduce, ...keys), keys);
    }
    function rollup(values, reduce, ...keys) {
        return nest(values, identity$9, reduce, keys);
    }
    function rollups(values, reduce, ...keys) {
        return nest(values, Array.from, reduce, keys);
    }
    function index$4(values, ...keys) {
        return nest(values, identity$9, unique, keys);
    }
    function indexes(values, ...keys) {
        return nest(values, Array.from, unique, keys);
    }
    function unique(values) {
        if (values.length !== 1) throw new Error("duplicate key");
        return values[0];
    }
    function nest(values, map, reduce, keys) {
        return function regroup(values, i) {
            if (i >= keys.length) return reduce(values);
            const groups = new InternMap();
            const keyof = keys[i++];
            let index = -1;
            for (const value of values){
                const key = keyof(value, ++index, values);
                const group = groups.get(key);
                if (group) group.push(value);
                else groups.set(key, [
                    value
                ]);
            }
            for (const [key, values] of groups)groups.set(key, regroup(values, i));
            return map(groups);
        }(values, 0);
    }
    function permute(source, keys) {
        return Array.from(keys, (key)=>source[key]);
    }
    function sort(values, ...F) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        values = Array.from(values);
        let [f] = F;
        if (f && f.length !== 2 || F.length > 1) {
            const index = Uint32Array.from(values, (d, i)=>i);
            if (F.length > 1) {
                F = F.map((f)=>values.map(f));
                index.sort((i, j)=>{
                    for (const f of F){
                        const c = ascendingDefined(f[i], f[j]);
                        if (c) return c;
                    }
                });
            } else {
                f = values.map(f);
                index.sort((i, j)=>ascendingDefined(f[i], f[j]));
            }
            return permute(values, index);
        }
        return values.sort(compareDefined(f));
    }
    function compareDefined(compare = ascending$3) {
        if (compare === ascending$3) return ascendingDefined;
        if (typeof compare !== "function") throw new TypeError("compare is not a function");
        return (a, b)=>{
            const x = compare(a, b);
            if (x || x === 0) return x;
            return (compare(b, b) === 0) - (compare(a, a) === 0);
        };
    }
    function ascendingDefined(a, b) {
        return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
    }
    function groupSort(values, reduce, key) {
        return (reduce.length !== 2 ? sort(rollup(values, reduce, key), ([ak, av], [bk, bv])=>ascending$3(av, bv) || ascending$3(ak, bk)) : sort(group(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || ascending$3(ak, bk))).map(([key])=>key);
    }
    var array$5 = Array.prototype;
    var slice$3 = array$5.slice;
    function constant$b(x) {
        return ()=>x;
    }
    const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
    function tickSpec(start, stop, count) {
        const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
        let i1, i2, inc;
        if (power < 0) {
            inc = Math.pow(10, -power) / factor;
            i1 = Math.round(start * inc);
            i2 = Math.round(stop * inc);
            if (i1 / inc < start) ++i1;
            if (i2 / inc > stop) --i2;
            inc = -inc;
        } else {
            inc = Math.pow(10, power) * factor;
            i1 = Math.round(start / inc);
            i2 = Math.round(stop / inc);
            if (i1 * inc < start) ++i1;
            if (i2 * inc > stop) --i2;
        }
        if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
        return [
            i1,
            i2,
            inc
        ];
    }
    function ticks(start, stop, count) {
        stop = +stop, start = +start, count = +count;
        if (!(count > 0)) return [];
        if (start === stop) return [
            start
        ];
        const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count);
        if (!(i2 >= i1)) return [];
        const n = i2 - i1 + 1, ticks = new Array(n);
        if (reverse) {
            if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
            else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
        } else {
            if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
            else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
        }
        return ticks;
    }
    function tickIncrement(start, stop, count) {
        stop = +stop, start = +start, count = +count;
        return tickSpec(start, stop, count)[2];
    }
    function tickStep(start, stop, count) {
        stop = +stop, start = +start, count = +count;
        const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
        return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
    }
    function nice$1(start, stop, count) {
        let prestep;
        while(true){
            const step = tickIncrement(start, stop, count);
            if (step === prestep || step === 0 || !isFinite(step)) return [
                start,
                stop
            ];
            else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            }
            prestep = step;
        }
    }
    function thresholdSturges(values) {
        return Math.max(1, Math.ceil(Math.log(count$1(values)) / Math.LN2) + 1);
    }
    function bin() {
        var value = identity$9, domain = extent$1, threshold = thresholdSturges;
        function histogram(data) {
            if (!Array.isArray(data)) data = Array.from(data);
            var i, n = data.length, x, step, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds, and nice the
            // default domain accordingly.
            if (!Array.isArray(tz)) {
                const max = x1, tn = +tz;
                if (domain === extent$1) [x0, x1] = nice$1(x0, x1, tn);
                tz = ticks(x0, x1, tn);
                // If the domain is aligned with the first tick (which it will by
                // default), then we can use quantization rather than bisection to bin
                // values, which is substantially faster.
                if (tz[0] <= x0) step = tickIncrement(x0, x1, tn);
                // If the last threshold is coincident with the domain’s upper bound, the
                // last bin will be zero-width. If the default domain is used, and this
                // last threshold is coincident with the maximum input value, we can
                // extend the niced upper bound by one tick to ensure uniform bin widths;
                // otherwise, we simply remove the last threshold. Note that we don’t
                // coerce values or the domain to numbers, and thus must be careful to
                // compare order (>=) rather than strict equality (===)!
                if (tz[tz.length - 1] >= x1) {
                    if (max >= x1 && domain === extent$1) {
                        const step = tickIncrement(x0, x1, tn);
                        if (isFinite(step)) {
                            if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                            else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                        }
                    } else tz.pop();
                }
            }
            // Remove any thresholds outside the domain.
            // Be careful not to mutate an array owned by the user!
            var m = tz.length, a = 0, b = m;
            while(tz[a] <= x0)++a;
            while(tz[b - 1] > x1)--b;
            if (a || b < m) tz = tz.slice(a, b), m = b - a;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            if (isFinite(step)) {
                if (step > 0) {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
                } else if (step < 0) {
                    for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                        const j = Math.floor((x0 - x) * step);
                        bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                    }
                }
            } else {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[bisect(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$b(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : constant$b([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : constant$b(Array.isArray(_) ? slice$3.call(_) : _), histogram) : threshold;
        };
        return histogram;
    }
    function max$3(values, valueof) {
        let max;
        if (valueof === undefined) {
            for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
        }
        return max;
    }
    function maxIndex(values, valueof) {
        let max;
        let maxIndex = -1;
        let index = -1;
        if (valueof === undefined) for (const value of values){
            ++index;
            if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
        }
        else {
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
        }
        return maxIndex;
    }
    function min$2(values, valueof) {
        let min;
        if (valueof === undefined) {
            for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
        }
        return min;
    }
    function minIndex(values, valueof) {
        let min;
        let minIndex = -1;
        let index = -1;
        if (valueof === undefined) for (const value of values){
            ++index;
            if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
        }
        else {
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
        }
        return minIndex;
    }
    // Based on https://github.com/mourner/quickselect
    // ISC license, Copyright 2018 Vladimir Agafonkin.
    function quickselect(array, k, left = 0, right = Infinity, compare) {
        k = Math.floor(k);
        left = Math.floor(Math.max(0, left));
        right = Math.floor(Math.min(array.length - 1, right));
        if (!(left <= k && k <= right)) return array;
        compare = compare === undefined ? ascendingDefined : compareDefined(compare);
        while(right > left){
            if (right - left > 600) {
                const n = right - left + 1;
                const m = k - left + 1;
                const z = Math.log(n);
                const s = 0.5 * Math.exp(2 * z / 3);
                const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                quickselect(array, k, newLeft, newRight, compare);
            }
            const t = array[k];
            let i = left;
            let j = right;
            swap$1(array, left, k);
            if (compare(array[right], t) > 0) swap$1(array, left, right);
            while(i < j){
                swap$1(array, i, j), ++i, --j;
                while(compare(array[i], t) < 0)++i;
                while(compare(array[j], t) > 0)--j;
            }
            if (compare(array[left], t) === 0) swap$1(array, left, j);
            else ++j, swap$1(array, j, right);
            if (j <= k) left = j + 1;
            if (k <= j) right = j - 1;
        }
        return array;
    }
    function swap$1(array, i, j) {
        const t = array[i];
        array[i] = array[j];
        array[j] = t;
    }
    function greatest(values, compare = ascending$3) {
        let max;
        let defined = false;
        if (compare.length === 1) {
            let maxValue;
            for (const element of values){
                const value = compare(element);
                if (defined ? ascending$3(value, maxValue) > 0 : ascending$3(value, value) === 0) {
                    max = element;
                    maxValue = value;
                    defined = true;
                }
            }
        } else {
            for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
                max = value;
                defined = true;
            }
        }
        return max;
    }
    function quantile$1(values, p, valueof) {
        values = Float64Array.from(numbers(values, valueof));
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return min$2(values);
        if (p >= 1) return max$3(values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max$3(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min$2(values.subarray(i0 + 1));
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileSorted(values, p, valueof = number$3) {
        if (!(n = values.length) || isNaN(p = +p)) return;
        if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (p >= 1) return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileIndex(values, p, valueof = number$3) {
        if (isNaN(p = +p)) return;
        numbers = Float64Array.from(values, (_, i)=>number$3(valueof(values[i], i, values)));
        if (p <= 0) return minIndex(numbers);
        if (p >= 1) return maxIndex(numbers);
        var numbers, index = Uint32Array.from(values, (_, i)=>i), j = numbers.length - 1, i = Math.floor(j * p);
        quickselect(index, i, 0, j, (i, j)=>ascendingDefined(numbers[i], numbers[j]));
        i = greatest(index.subarray(0, i + 1), (i)=>numbers[i]);
        return i >= 0 ? i : -1;
    }
    function thresholdFreedmanDiaconis(values, min, max) {
        const c = count$1(values), d = quantile$1(values, 0.75) - quantile$1(values, 0.25);
        return c && d ? Math.ceil((max - min) / (2 * d * Math.pow(c, -1 / 3))) : 1;
    }
    function thresholdScott(values, min, max) {
        const c = count$1(values), d = deviation(values);
        return c && d ? Math.ceil((max - min) * Math.cbrt(c) / (3.49 * d)) : 1;
    }
    function mean(values, valueof) {
        let count = 0;
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
        }
        if (count) return sum / count;
    }
    function median(values, valueof) {
        return quantile$1(values, 0.5, valueof);
    }
    function medianIndex(values, valueof) {
        return quantileIndex(values, 0.5, valueof);
    }
    function* flatten(arrays) {
        for (const array of arrays)yield* array;
    }
    function merge(arrays) {
        return Array.from(flatten(arrays));
    }
    function mode(values, valueof) {
        const counts = new InternMap();
        if (valueof === undefined) {
            for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
        } else {
            let index = -1;
            for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
        }
        let modeValue;
        let modeCount = 0;
        for (const [value, count] of counts)if (count > modeCount) {
            modeCount = count;
            modeValue = value;
        }
        return modeValue;
    }
    function pairs(values, pairof = pair) {
        const pairs1 = [];
        let previous;
        let first = false;
        for (const value of values){
            if (first) pairs1.push(pairof(previous, value));
            previous = value;
            first = true;
        }
        return pairs1;
    }
    function pair(a, b) {
        return [
            a,
            b
        ];
    }
    function range$2(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    }
    function rank(values, valueof = ascending$3) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        let V = Array.from(values);
        const R = new Float64Array(V.length);
        if (valueof.length !== 2) V = V.map(valueof), valueof = ascending$3;
        const compareIndex = (i, j)=>valueof(V[i], V[j]);
        let k, r;
        values = Uint32Array.from(V, (_, i)=>i);
        // Risky chaining due to Safari 14 https://github.com/d3/d3-array/issues/123
        values.sort(valueof === ascending$3 ? (i, j)=>ascendingDefined(V[i], V[j]) : compareDefined(compareIndex));
        values.forEach((j, i)=>{
            const c = compareIndex(j, k === undefined ? j : k);
            if (c >= 0) {
                if (k === undefined || c > 0) k = j, r = i;
                R[j] = r;
            } else R[j] = NaN;
        });
        return R;
    }
    function least(values, compare = ascending$3) {
        let min;
        let defined = false;
        if (compare.length === 1) {
            let minValue;
            for (const element of values){
                const value = compare(element);
                if (defined ? ascending$3(value, minValue) < 0 : ascending$3(value, value) === 0) {
                    min = element;
                    minValue = value;
                    defined = true;
                }
            }
        } else {
            for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
                min = value;
                defined = true;
            }
        }
        return min;
    }
    function leastIndex(values, compare = ascending$3) {
        if (compare.length === 1) return minIndex(values, compare);
        let minValue;
        let min = -1;
        let index = -1;
        for (const value of values){
            ++index;
            if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
                minValue = value;
                min = index;
            }
        }
        return min;
    }
    function greatestIndex(values, compare = ascending$3) {
        if (compare.length === 1) return maxIndex(values, compare);
        let maxValue;
        let max = -1;
        let index = -1;
        for (const value of values){
            ++index;
            if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
                maxValue = value;
                max = index;
            }
        }
        return max;
    }
    function scan(values, compare) {
        const index = leastIndex(values, compare);
        return index < 0 ? undefined : index;
    }
    var shuffle$1 = shuffler(Math.random);
    function shuffler(random) {
        return function shuffle(array, i0 = 0, i1 = array.length) {
            let m = i1 - (i0 = +i0);
            while(m){
                const i = random() * m-- | 0, t = array[m + i0];
                array[m + i0] = array[i + i0];
                array[i + i0] = t;
            }
            return array;
        };
    }
    function sum$2(values, valueof) {
        let sum = 0;
        if (valueof === undefined) {
            for (let value of values)if (value = +value) sum += value;
        } else {
            let index = -1;
            for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
        }
        return sum;
    }
    function transpose(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = min$2(matrix, length$2), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    }
    function length$2(d) {
        return d.length;
    }
    function zip() {
        return transpose(arguments);
    }
    function every(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        let index = -1;
        for (const value of values){
            if (!test(value, ++index, values)) return false;
        }
        return true;
    }
    function some(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        let index = -1;
        for (const value of values){
            if (test(value, ++index, values)) return true;
        }
        return false;
    }
    function filter$1(values, test) {
        if (typeof test !== "function") throw new TypeError("test is not a function");
        const array = [];
        let index = -1;
        for (const value of values)if (test(value, ++index, values)) array.push(value);
        return array;
    }
    function map$1(values, mapper) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
        return Array.from(values, (value, index)=>mapper(value, index, values));
    }
    function reduce(values, reducer, value) {
        if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
        const iterator = values[Symbol.iterator]();
        let done, next, index = -1;
        if (arguments.length < 3) {
            ({ done: done, value: value } = iterator.next());
            if (done) return;
            ++index;
        }
        while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
        return value;
    }
    function reverse$1(values) {
        if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
        return Array.from(values).reverse();
    }
    function difference(values, ...others) {
        values = new InternSet(values);
        for (const other of others)for (const value of other)values.delete(value);
        return values;
    }
    function disjoint(values, other) {
        const iterator = other[Symbol.iterator](), set = new InternSet();
        for (const v of values){
            if (set.has(v)) return false;
            let value, done;
            while({ value: value, done: done } = iterator.next()){
                if (done) break;
                if (Object.is(v, value)) return false;
                set.add(value);
            }
        }
        return true;
    }
    function intersection(values, ...others) {
        values = new InternSet(values);
        others = others.map(set$2);
        out: for (const value of values){
            for (const other of others)if (!other.has(value)) {
                values.delete(value);
                continue out;
            }
        }
        return values;
    }
    function set$2(values) {
        return values instanceof InternSet ? values : new InternSet(values);
    }
    function superset(values, other) {
        const iterator = values[Symbol.iterator](), set = new Set();
        for (const o of other){
            const io = intern(o);
            if (set.has(io)) continue;
            let value, done;
            while({ value: value, done: done } = iterator.next()){
                if (done) return false;
                const ivalue = intern(value);
                set.add(ivalue);
                if (Object.is(io, ivalue)) break;
            }
        }
        return true;
    }
    function intern(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function subset(values, other) {
        return superset(other, values);
    }
    function union(...others) {
        const set = new InternSet();
        for (const other of others)for (const o of other)set.add(o);
        return set;
    }
    function identity$8(x) {
        return x;
    }
    var top = 1, right = 2, bottom = 3, left = 4, epsilon$6 = 1e-6;
    function translateX(x) {
        return "translate(" + x + ",0)";
    }
    function translateY(y) {
        return "translate(0," + y + ")";
    }
    function number$2(scale) {
        return (d)=>+scale(d);
    }
    function center$1(scale, offset) {
        offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
        if (scale.round()) offset = Math.round(offset);
        return (d)=>+scale(d) + offset;
    }
    function entering() {
        return !this.__axis;
    }
    function axis(orient, scale) {
        var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
        function axis(context) {
            var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$8 : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? center$1 : number$2)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
                null
            ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
            path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
            tick = tick.merge(tickEnter);
            line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
            text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
            if (context !== selection) {
                path = path.transition(context);
                tick = tick.transition(context);
                line = line.transition(context);
                text = text.transition(context);
                tickExit = tickExit.transition(context).attr("opacity", epsilon$6).attr("transform", function(d) {
                    return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
                });
                tickEnter.attr("opacity", epsilon$6).attr("transform", function(d) {
                    var p = this.parentNode.__axis;
                    return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
                });
            }
            tickExit.remove();
            path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
            tick.attr("opacity", 1).attr("transform", function(d) {
                return transform(position(d) + offset);
            });
            line.attr(x + "2", k * tickSizeInner);
            text.attr(x, k * spacing).text(format);
            selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
            selection.each(function() {
                this.__axis = position;
            });
        }
        axis.scale = function(_) {
            return arguments.length ? (scale = _, axis) : scale;
        };
        axis.ticks = function() {
            return tickArguments = Array.from(arguments), axis;
        };
        axis.tickArguments = function(_) {
            return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
        };
        axis.tickValues = function(_) {
            return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
        };
        axis.tickFormat = function(_) {
            return arguments.length ? (tickFormat = _, axis) : tickFormat;
        };
        axis.tickSize = function(_) {
            return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
        };
        axis.tickSizeInner = function(_) {
            return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
        };
        axis.tickSizeOuter = function(_) {
            return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
        };
        axis.tickPadding = function(_) {
            return arguments.length ? (tickPadding = +_, axis) : tickPadding;
        };
        axis.offset = function(_) {
            return arguments.length ? (offset = +_, axis) : offset;
        };
        return axis;
    }
    function axisTop(scale) {
        return axis(top, scale);
    }
    function axisRight(scale) {
        return axis(right, scale);
    }
    function axisBottom(scale) {
        return axis(bottom, scale);
    }
    function axisLeft(scale) {
        return axis(left, scale);
    }
    var noop$3 = {
        value: ()=>{}
    };
    function dispatch() {
        for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
            if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
            _[t] = [];
        }
        return new Dispatch(_);
    }
    function Dispatch(_) {
        this._ = _;
    }
    function parseTypenames$1(typenames, types) {
        return typenames.trim().split(/^|\s+/).map(function(t) {
            var name = "", i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
            return {
                type: t,
                name: name
            };
        });
    }
    Dispatch.prototype = dispatch.prototype = {
        constructor: Dispatch,
        on: function(typename, callback) {
            var _ = this._, T = parseTypenames$1(typename + "", _), t, i = -1, n = T.length;
            // If no callback was specified, return the callback of the given type and name.
            if (arguments.length < 2) {
                while(++i < n)if ((t = (typename = T[i]).type) && (t = get$1(_[t], typename.name))) return t;
                return;
            }
            // If a type was specified, set the callback for the given type and name.
            // Otherwise, if a null callback was specified, remove callbacks of the given name.
            if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
            while(++i < n){
                if (t = (typename = T[i]).type) _[t] = set$1(_[t], typename.name, callback);
                else if (callback == null) for(t in _)_[t] = set$1(_[t], typename.name, null);
            }
            return this;
        },
        copy: function() {
            var copy = {}, _ = this._;
            for(var t in _)copy[t] = _[t].slice();
            return new Dispatch(copy);
        },
        call: function(type, that) {
            if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
            for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
        },
        apply: function(type, that, args) {
            if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
            for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
        }
    };
    function get$1(type, name) {
        for(var i = 0, n = type.length, c; i < n; ++i){
            if ((c = type[i]).name === name) return c.value;
        }
    }
    function set$1(type, name, callback) {
        for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
            type[i] = noop$3, type = type.slice(0, i).concat(type.slice(i + 1));
            break;
        }
        if (callback != null) type.push({
            name: name,
            value: callback
        });
        return type;
    }
    var xhtml = "http://www.w3.org/1999/xhtml";
    var namespaces = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: xhtml,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
    };
    function namespace(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return namespaces.hasOwnProperty(prefix) ? {
            space: namespaces[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    }
    function creatorInherit(name) {
        return function() {
            var document1 = this.ownerDocument, uri = this.namespaceURI;
            return uri === xhtml && document1.documentElement.namespaceURI === xhtml ? document1.createElement(name) : document1.createElementNS(uri, name);
        };
    }
    function creatorFixed(fullname) {
        return function() {
            return this.ownerDocument.createElementNS(fullname.space, fullname.local);
        };
    }
    function creator(name) {
        var fullname = namespace(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    }
    function none$2() {}
    function selector(selector) {
        return selector == null ? none$2 : function() {
            return this.querySelector(selector);
        };
    }
    function selection_select(select) {
        if (typeof select !== "function") select = selector(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new Selection$1(subgroups, this._parents);
    }
    // Given something array like (or null), returns something that is strictly an
    // array. This is used to ensure that array-like objects passed to d3.selectAll
    // or selection.selectAll are converted into proper arrays when creating a
    // selection; we don’t ever want to create a selection backed by a live
    // HTMLCollection or NodeList. However, note that selection.selectAll will use a
    // static NodeList as a group, since it safely derived from querySelectorAll.
    function array$4(x) {
        return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
    }
    function empty$1() {
        return [];
    }
    function selectorAll(selector) {
        return selector == null ? empty$1 : function() {
            return this.querySelectorAll(selector);
        };
    }
    function arrayAll(select) {
        return function() {
            return array$4(select.apply(this, arguments));
        };
    }
    function selection_selectAll(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = selectorAll(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new Selection$1(subgroups, parents);
    }
    function matcher(selector) {
        return function() {
            return this.matches(selector);
        };
    }
    function childMatcher(selector) {
        return function(node) {
            return node.matches(selector);
        };
    }
    var find$1 = Array.prototype.find;
    function childFind(match) {
        return function() {
            return find$1.call(this.children, match);
        };
    }
    function childFirst() {
        return this.firstElementChild;
    }
    function selection_selectChild(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : childMatcher(match)));
    }
    var filter = Array.prototype.filter;
    function children() {
        return Array.from(this.children);
    }
    function childrenFilter(match) {
        return function() {
            return filter.call(this.children, match);
        };
    }
    function selection_selectChildren(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : childMatcher(match)));
    }
    function selection_filter(match) {
        if (typeof match !== "function") match = matcher(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new Selection$1(subgroups, this._parents);
    }
    function sparse(update) {
        return new Array(update.length);
    }
    function selection_enter() {
        return new Selection$1(this._enter || this._groups.map(sparse), this._parents);
    }
    function EnterNode(parent, datum) {
        this.ownerDocument = parent.ownerDocument;
        this.namespaceURI = parent.namespaceURI;
        this._next = null;
        this._parent = parent;
        this.__data__ = datum;
    }
    EnterNode.prototype = {
        constructor: EnterNode,
        appendChild: function(child) {
            return this._parent.insertBefore(child, this._next);
        },
        insertBefore: function(child, next) {
            return this._parent.insertBefore(child, next);
        },
        querySelector: function(selector) {
            return this._parent.querySelector(selector);
        },
        querySelectorAll: function(selector) {
            return this._parent.querySelectorAll(selector);
        }
    };
    function constant$a(x) {
        return function() {
            return x;
        };
    }
    function bindIndex(parent, group, enter, update, exit, data) {
        var i = 0, node, groupLength = group.length, dataLength = data.length;
        // Put any non-null nodes that fit into update.
        // Put any null nodes into enter.
        // Put any remaining data into enter.
        for(; i < dataLength; ++i)if (node = group[i]) {
            node.__data__ = data[i];
            update[i] = node;
        } else enter[i] = new EnterNode(parent, data[i]);
        // Put any non-null nodes that don’t fit into exit.
        for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
    }
    function bindKey(parent, group, enter, update, exit, data, key) {
        var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
        // Compute the key for each node.
        // If multiple nodes have the same key, the duplicates are added to exit.
        for(i = 0; i < groupLength; ++i)if (node = group[i]) {
            keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
            if (nodeByKeyValue.has(keyValue)) exit[i] = node;
            else nodeByKeyValue.set(keyValue, node);
        }
        // Compute the key for each datum.
        // If there a node associated with this key, join and add it to update.
        // If there is not (or the key is a duplicate), add it to enter.
        for(i = 0; i < dataLength; ++i){
            keyValue = key.call(parent, data[i], i, data) + "";
            if (node = nodeByKeyValue.get(keyValue)) {
                update[i] = node;
                node.__data__ = data[i];
                nodeByKeyValue.delete(keyValue);
            } else enter[i] = new EnterNode(parent, data[i]);
        }
        // Add any remaining nodes that were not bound to data to exit.
        for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
    }
    function datum(node) {
        return node.__data__;
    }
    function selection_data(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = constant$a(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new Selection$1(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    }
    // Given some data, this returns an array-like view of it: an object that
    // exposes a length property and allows numeric indexing. Note that unlike
    // selectAll, this isn’t worried about “live” collections because the resulting
    // array will only be used briefly while data is being bound. (It is possible to
    // cause the data to change while iterating by using a key function, but please
    // don’t; we’d rather avoid a gratuitous copy.)
    function arraylike(data) {
        return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
         : Array.from(data); // Map, Set, iterable, string, or anything else
    }
    function selection_exit() {
        return new Selection$1(this._exit || this._groups.map(sparse), this._parents);
    }
    function selection_join(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    }
    function selection_merge(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new Selection$1(merges, this._parents);
    }
    function selection_order() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    }
    function selection_sort(compare) {
        if (!compare) compare = ascending$2;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new Selection$1(sortgroups, this._parents).order();
    }
    function ascending$2(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function selection_call() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    }
    function selection_nodes() {
        return Array.from(this);
    }
    function selection_node() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    }
    function selection_size() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    }
    function selection_empty() {
        return !this.node();
    }
    function selection_each(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    }
    function attrRemove$1(name) {
        return function() {
            this.removeAttribute(name);
        };
    }
    function attrRemoveNS$1(fullname) {
        return function() {
            this.removeAttributeNS(fullname.space, fullname.local);
        };
    }
    function attrConstant$1(name, value) {
        return function() {
            this.setAttribute(name, value);
        };
    }
    function attrConstantNS$1(fullname, value) {
        return function() {
            this.setAttributeNS(fullname.space, fullname.local, value);
        };
    }
    function attrFunction$1(name, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttribute(name);
            else this.setAttribute(name, v);
        };
    }
    function attrFunctionNS$1(fullname, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
            else this.setAttributeNS(fullname.space, fullname.local, v);
        };
    }
    function selection_attr(name, value) {
        var fullname = namespace(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS$1 : attrRemove$1 : typeof value === "function" ? fullname.local ? attrFunctionNS$1 : attrFunction$1 : fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, value));
    }
    function defaultView(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    }
    function styleRemove$1(name) {
        return function() {
            this.style.removeProperty(name);
        };
    }
    function styleConstant$1(name, value, priority) {
        return function() {
            this.style.setProperty(name, value, priority);
        };
    }
    function styleFunction$1(name, value, priority) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) this.style.removeProperty(name);
            else this.style.setProperty(name, v, priority);
        };
    }
    function selection_style(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove$1 : typeof value === "function" ? styleFunction$1 : styleConstant$1)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    }
    function styleValue(node, name) {
        return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
    }
    function propertyRemove(name) {
        return function() {
            delete this[name];
        };
    }
    function propertyConstant(name, value) {
        return function() {
            this[name] = value;
        };
    }
    function propertyFunction(name, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (v == null) delete this[name];
            else this[name] = v;
        };
    }
    function selection_property(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    }
    function classArray(string) {
        return string.trim().split(/^|\s+/);
    }
    function classList(node) {
        return node.classList || new ClassList(node);
    }
    function ClassList(node) {
        this._node = node;
        this._names = classArray(node.getAttribute("class") || "");
    }
    ClassList.prototype = {
        add: function(name) {
            var i = this._names.indexOf(name);
            if (i < 0) {
                this._names.push(name);
                this._node.setAttribute("class", this._names.join(" "));
            }
        },
        remove: function(name) {
            var i = this._names.indexOf(name);
            if (i >= 0) {
                this._names.splice(i, 1);
                this._node.setAttribute("class", this._names.join(" "));
            }
        },
        contains: function(name) {
            return this._names.indexOf(name) >= 0;
        }
    };
    function classedAdd(node, names) {
        var list = classList(node), i = -1, n = names.length;
        while(++i < n)list.add(names[i]);
    }
    function classedRemove(node, names) {
        var list = classList(node), i = -1, n = names.length;
        while(++i < n)list.remove(names[i]);
    }
    function classedTrue(names) {
        return function() {
            classedAdd(this, names);
        };
    }
    function classedFalse(names) {
        return function() {
            classedRemove(this, names);
        };
    }
    function classedFunction(names, value) {
        return function() {
            (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
        };
    }
    function selection_classed(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    }
    function textRemove() {
        this.textContent = "";
    }
    function textConstant$1(value) {
        return function() {
            this.textContent = value;
        };
    }
    function textFunction$1(value) {
        return function() {
            var v = value.apply(this, arguments);
            this.textContent = v == null ? "" : v;
        };
    }
    function selection_text(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction$1 : textConstant$1)(value)) : this.node().textContent;
    }
    function htmlRemove() {
        this.innerHTML = "";
    }
    function htmlConstant(value) {
        return function() {
            this.innerHTML = value;
        };
    }
    function htmlFunction(value) {
        return function() {
            var v = value.apply(this, arguments);
            this.innerHTML = v == null ? "" : v;
        };
    }
    function selection_html(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    }
    function raise() {
        if (this.nextSibling) this.parentNode.appendChild(this);
    }
    function selection_raise() {
        return this.each(raise);
    }
    function lower() {
        if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
    }
    function selection_lower() {
        return this.each(lower);
    }
    function selection_append(name) {
        var create = typeof name === "function" ? name : creator(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    }
    function constantNull() {
        return null;
    }
    function selection_insert(name, before) {
        var create = typeof name === "function" ? name : creator(name), select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    }
    function remove() {
        var parent = this.parentNode;
        if (parent) parent.removeChild(this);
    }
    function selection_remove() {
        return this.each(remove);
    }
    function selection_cloneShallow() {
        var clone = this.cloneNode(false), parent = this.parentNode;
        return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
    }
    function selection_cloneDeep() {
        var clone = this.cloneNode(true), parent = this.parentNode;
        return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
    }
    function selection_clone(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    }
    function selection_datum(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    }
    function contextListener(listener) {
        return function(event) {
            listener.call(this, event, this.__data__);
        };
    }
    function parseTypenames(typenames) {
        return typenames.trim().split(/^|\s+/).map(function(t) {
            var name = "", i = t.indexOf(".");
            if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
            return {
                type: t,
                name: name
            };
        });
    }
    function onRemove(typename) {
        return function() {
            var on = this.__on;
            if (!on) return;
            for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
            else on[++i] = o;
            if (++i) on.length = i;
            else delete this.__on;
        };
    }
    function onAdd(typename, value, options) {
        return function() {
            var on = this.__on, o, listener = contextListener(value);
            if (on) {
                for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                    this.removeEventListener(o.type, o.listener, o.options);
                    this.addEventListener(o.type, o.listener = listener, o.options = options);
                    o.value = value;
                    return;
                }
            }
            this.addEventListener(typename.type, listener, options);
            o = {
                type: typename.type,
                name: typename.name,
                value: value,
                listener: listener,
                options: options
            };
            if (!on) this.__on = [
                o
            ];
            else on.push(o);
        };
    }
    function selection_on(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    }
    function dispatchEvent(node, type, params) {
        var window1 = defaultView(node), event = window1.CustomEvent;
        if (typeof event === "function") event = new event(type, params);
        else {
            event = window1.document.createEvent("Event");
            if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
            else event.initEvent(type, false, false);
        }
        node.dispatchEvent(event);
    }
    function dispatchConstant(type, params) {
        return function() {
            return dispatchEvent(this, type, params);
        };
    }
    function dispatchFunction(type, params) {
        return function() {
            return dispatchEvent(this, type, params.apply(this, arguments));
        };
    }
    function selection_dispatch(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    }
    function* selection_iterator() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    }
    var root$1 = [
        null
    ];
    function Selection$1(groups, parents) {
        this._groups = groups;
        this._parents = parents;
    }
    function selection() {
        return new Selection$1([
            [
                document.documentElement
            ]
        ], root$1);
    }
    function selection_selection() {
        return this;
    }
    Selection$1.prototype = selection.prototype = {
        constructor: Selection$1,
        select: selection_select,
        selectAll: selection_selectAll,
        selectChild: selection_selectChild,
        selectChildren: selection_selectChildren,
        filter: selection_filter,
        data: selection_data,
        enter: selection_enter,
        exit: selection_exit,
        join: selection_join,
        merge: selection_merge,
        selection: selection_selection,
        order: selection_order,
        sort: selection_sort,
        call: selection_call,
        nodes: selection_nodes,
        node: selection_node,
        size: selection_size,
        empty: selection_empty,
        each: selection_each,
        attr: selection_attr,
        style: selection_style,
        property: selection_property,
        classed: selection_classed,
        text: selection_text,
        html: selection_html,
        raise: selection_raise,
        lower: selection_lower,
        append: selection_append,
        insert: selection_insert,
        remove: selection_remove,
        clone: selection_clone,
        datum: selection_datum,
        on: selection_on,
        dispatch: selection_dispatch,
        [Symbol.iterator]: selection_iterator
    };
    function select(selector) {
        return typeof selector === "string" ? new Selection$1([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new Selection$1([
            [
                selector
            ]
        ], root$1);
    }
    function create$1(name) {
        return select(creator(name).call(document.documentElement));
    }
    var nextId = 0;
    function local$1() {
        return new Local;
    }
    function Local() {
        this._ = "@" + (++nextId).toString(36);
    }
    Local.prototype = local$1.prototype = {
        constructor: Local,
        get: function(node) {
            var id = this._;
            while(!(id in node))if (!(node = node.parentNode)) return;
            return node[id];
        },
        set: function(node, value) {
            return node[this._] = value;
        },
        remove: function(node) {
            return this._ in node && delete node[this._];
        },
        toString: function() {
            return this._;
        }
    };
    function sourceEvent(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    }
    function pointer(event, node) {
        event = sourceEvent(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    }
    function pointers(events, node) {
        if (events.target) {
            events = sourceEvent(events);
            if (node === undefined) node = events.currentTarget;
            events = events.touches || [
                events
            ];
        }
        return Array.from(events, (event)=>pointer(event, node));
    }
    function selectAll(selector) {
        return typeof selector === "string" ? new Selection$1([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new Selection$1([
            array$4(selector)
        ], root$1);
    }
    // These are typically used in conjunction with noevent to ensure that we can
    // preventDefault on the event.
    const nonpassive = {
        passive: false
    };
    const nonpassivecapture = {
        capture: true,
        passive: false
    };
    function nopropagation$2(event) {
        event.stopImmediatePropagation();
    }
    function noevent$2(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    function dragDisable(view) {
        var root = view.document.documentElement, selection = select(view).on("dragstart.drag", noevent$2, nonpassivecapture);
        if ("onselectstart" in root) selection.on("selectstart.drag", noevent$2, nonpassivecapture);
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    }
    function yesdrag(view, noclick) {
        var root = view.document.documentElement, selection = select(view).on("dragstart.drag", null);
        if (noclick) {
            selection.on("click.drag", noevent$2, nonpassivecapture);
            setTimeout(function() {
                selection.on("click.drag", null);
            }, 0);
        }
        if ("onselectstart" in root) selection.on("selectstart.drag", null);
        else {
            root.style.MozUserSelect = root.__noselect;
            delete root.__noselect;
        }
    }
    var constant$9 = (x)=>()=>x;
    function DragEvent(type, { sourceEvent: sourceEvent, subject: subject, target: target, identifier: identifier, active: active, x: x, y: y, dx: dx, dy: dy, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            subject: {
                value: subject,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            identifier: {
                value: identifier,
                enumerable: true,
                configurable: true
            },
            active: {
                value: active,
                enumerable: true,
                configurable: true
            },
            x: {
                value: x,
                enumerable: true,
                configurable: true
            },
            y: {
                value: y,
                enumerable: true,
                configurable: true
            },
            dx: {
                value: dx,
                enumerable: true,
                configurable: true
            },
            dy: {
                value: dy,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    DragEvent.prototype.on = function() {
        var value = this._.on.apply(this._, arguments);
        return value === this._ ? this : value;
    };
    // Ignore right-click, since that should open the context menu.
    function defaultFilter$2(event) {
        return !event.ctrlKey && !event.button;
    }
    function defaultContainer() {
        return this.parentNode;
    }
    function defaultSubject(event, d) {
        return d == null ? {
            x: event.x,
            y: event.y
        } : d;
    }
    function defaultTouchable$2() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function drag() {
        var filter = defaultFilter$2, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable$2, gestures = {}, listeners = dispatch("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, nonpassive).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            select(event.view).on("mousemove.drag", mousemoved, nonpassivecapture).on("mouseup.drag", mouseupped, nonpassivecapture);
            dragDisable(event.view);
            nopropagation$2(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            noevent$2(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            select(event.view).on("mousemove.drag mouseup.drag", null);
            yesdrag(event.view, mousemoving);
            noevent$2(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                nopropagation$2(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                noevent$2(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                nopropagation$2(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = pointer(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new DragEvent("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier: identifier,
                active: active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch: dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = pointer(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new DragEvent(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier: identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch: dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant$9(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : constant$9(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : constant$9(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$9(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    }
    function define(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    }
    function extend(parent, definition) {
        var prototype = Object.create(parent.prototype);
        for(var key in definition)prototype[key] = definition[key];
        return prototype;
    }
    function Color() {}
    var darker = 0.7;
    var brighter = 1 / darker;
    var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
    var named = {
        aliceblue: 0xf0f8ff,
        antiquewhite: 0xfaebd7,
        aqua: 0x00ffff,
        aquamarine: 0x7fffd4,
        azure: 0xf0ffff,
        beige: 0xf5f5dc,
        bisque: 0xffe4c4,
        black: 0x000000,
        blanchedalmond: 0xffebcd,
        blue: 0x0000ff,
        blueviolet: 0x8a2be2,
        brown: 0xa52a2a,
        burlywood: 0xdeb887,
        cadetblue: 0x5f9ea0,
        chartreuse: 0x7fff00,
        chocolate: 0xd2691e,
        coral: 0xff7f50,
        cornflowerblue: 0x6495ed,
        cornsilk: 0xfff8dc,
        crimson: 0xdc143c,
        cyan: 0x00ffff,
        darkblue: 0x00008b,
        darkcyan: 0x008b8b,
        darkgoldenrod: 0xb8860b,
        darkgray: 0xa9a9a9,
        darkgreen: 0x006400,
        darkgrey: 0xa9a9a9,
        darkkhaki: 0xbdb76b,
        darkmagenta: 0x8b008b,
        darkolivegreen: 0x556b2f,
        darkorange: 0xff8c00,
        darkorchid: 0x9932cc,
        darkred: 0x8b0000,
        darksalmon: 0xe9967a,
        darkseagreen: 0x8fbc8f,
        darkslateblue: 0x483d8b,
        darkslategray: 0x2f4f4f,
        darkslategrey: 0x2f4f4f,
        darkturquoise: 0x00ced1,
        darkviolet: 0x9400d3,
        deeppink: 0xff1493,
        deepskyblue: 0x00bfff,
        dimgray: 0x696969,
        dimgrey: 0x696969,
        dodgerblue: 0x1e90ff,
        firebrick: 0xb22222,
        floralwhite: 0xfffaf0,
        forestgreen: 0x228b22,
        fuchsia: 0xff00ff,
        gainsboro: 0xdcdcdc,
        ghostwhite: 0xf8f8ff,
        gold: 0xffd700,
        goldenrod: 0xdaa520,
        gray: 0x808080,
        green: 0x008000,
        greenyellow: 0xadff2f,
        grey: 0x808080,
        honeydew: 0xf0fff0,
        hotpink: 0xff69b4,
        indianred: 0xcd5c5c,
        indigo: 0x4b0082,
        ivory: 0xfffff0,
        khaki: 0xf0e68c,
        lavender: 0xe6e6fa,
        lavenderblush: 0xfff0f5,
        lawngreen: 0x7cfc00,
        lemonchiffon: 0xfffacd,
        lightblue: 0xadd8e6,
        lightcoral: 0xf08080,
        lightcyan: 0xe0ffff,
        lightgoldenrodyellow: 0xfafad2,
        lightgray: 0xd3d3d3,
        lightgreen: 0x90ee90,
        lightgrey: 0xd3d3d3,
        lightpink: 0xffb6c1,
        lightsalmon: 0xffa07a,
        lightseagreen: 0x20b2aa,
        lightskyblue: 0x87cefa,
        lightslategray: 0x778899,
        lightslategrey: 0x778899,
        lightsteelblue: 0xb0c4de,
        lightyellow: 0xffffe0,
        lime: 0x00ff00,
        limegreen: 0x32cd32,
        linen: 0xfaf0e6,
        magenta: 0xff00ff,
        maroon: 0x800000,
        mediumaquamarine: 0x66cdaa,
        mediumblue: 0x0000cd,
        mediumorchid: 0xba55d3,
        mediumpurple: 0x9370db,
        mediumseagreen: 0x3cb371,
        mediumslateblue: 0x7b68ee,
        mediumspringgreen: 0x00fa9a,
        mediumturquoise: 0x48d1cc,
        mediumvioletred: 0xc71585,
        midnightblue: 0x191970,
        mintcream: 0xf5fffa,
        mistyrose: 0xffe4e1,
        moccasin: 0xffe4b5,
        navajowhite: 0xffdead,
        navy: 0x000080,
        oldlace: 0xfdf5e6,
        olive: 0x808000,
        olivedrab: 0x6b8e23,
        orange: 0xffa500,
        orangered: 0xff4500,
        orchid: 0xda70d6,
        palegoldenrod: 0xeee8aa,
        palegreen: 0x98fb98,
        paleturquoise: 0xafeeee,
        palevioletred: 0xdb7093,
        papayawhip: 0xffefd5,
        peachpuff: 0xffdab9,
        peru: 0xcd853f,
        pink: 0xffc0cb,
        plum: 0xdda0dd,
        powderblue: 0xb0e0e6,
        purple: 0x800080,
        rebeccapurple: 0x663399,
        red: 0xff0000,
        rosybrown: 0xbc8f8f,
        royalblue: 0x4169e1,
        saddlebrown: 0x8b4513,
        salmon: 0xfa8072,
        sandybrown: 0xf4a460,
        seagreen: 0x2e8b57,
        seashell: 0xfff5ee,
        sienna: 0xa0522d,
        silver: 0xc0c0c0,
        skyblue: 0x87ceeb,
        slateblue: 0x6a5acd,
        slategray: 0x708090,
        slategrey: 0x708090,
        snow: 0xfffafa,
        springgreen: 0x00ff7f,
        steelblue: 0x4682b4,
        tan: 0xd2b48c,
        teal: 0x008080,
        thistle: 0xd8bfd8,
        tomato: 0xff6347,
        turquoise: 0x40e0d0,
        violet: 0xee82ee,
        wheat: 0xf5deb3,
        white: 0xffffff,
        whitesmoke: 0xf5f5f5,
        yellow: 0xffff00,
        yellowgreen: 0x9acd32
    };
    define(Color, color, {
        copy (channels) {
            return Object.assign(new this.constructor, this, channels);
        },
        displayable () {
            return this.rgb().displayable();
        },
        hex: color_formatHex,
        formatHex: color_formatHex,
        formatHex8: color_formatHex8,
        formatHsl: color_formatHsl,
        formatRgb: color_formatRgb,
        toString: color_formatRgb
    });
    function color_formatHex() {
        return this.rgb().formatHex();
    }
    function color_formatHex8() {
        return this.rgb().formatHex8();
    }
    function color_formatHsl() {
        return hslConvert(this).formatHsl();
    }
    function color_formatRgb() {
        return this.rgb().formatRgb();
    }
    function color(format) {
        var m, l;
        format = (format + "").trim().toLowerCase();
        return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
         : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
         : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
         : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
         : null // invalid hex
        ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
         : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
         : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
         : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
         : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
         : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
         : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
         : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
    }
    function rgbn(n) {
        return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
    }
    function rgba(r, g, b, a) {
        if (a <= 0) r = g = b = NaN;
        return new Rgb(r, g, b, a);
    }
    function rgbConvert(o) {
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Rgb;
        o = o.rgb();
        return new Rgb(o.r, o.g, o.b, o.opacity);
    }
    function rgb(r, g, b, opacity) {
        return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
    }
    function Rgb(r, g, b, opacity) {
        this.r = +r;
        this.g = +g;
        this.b = +b;
        this.opacity = +opacity;
    }
    define(Rgb, rgb, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
        },
        rgb () {
            return this;
        },
        clamp () {
            return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
        },
        displayable () {
            return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
        },
        hex: rgb_formatHex,
        formatHex: rgb_formatHex,
        formatHex8: rgb_formatHex8,
        formatRgb: rgb_formatRgb,
        toString: rgb_formatRgb
    }));
    function rgb_formatHex() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
    }
    function rgb_formatHex8() {
        return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
    }
    function rgb_formatRgb() {
        const a = clampa(this.opacity);
        return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
    }
    function clampa(opacity) {
        return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
    }
    function clampi(value) {
        return Math.max(0, Math.min(255, Math.round(value) || 0));
    }
    function hex(value) {
        value = clampi(value);
        return (value < 16 ? "0" : "") + value.toString(16);
    }
    function hsla(h, s, l, a) {
        if (a <= 0) h = s = l = NaN;
        else if (l <= 0 || l >= 1) h = s = NaN;
        else if (s <= 0) h = NaN;
        return new Hsl(h, s, l, a);
    }
    function hslConvert(o) {
        if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Color)) o = color(o);
        if (!o) return new Hsl;
        if (o instanceof Hsl) return o;
        o = o.rgb();
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
        if (s) {
            if (r === max) h = (g - b) / s + (g < b) * 6;
            else if (g === max) h = (b - r) / s + 2;
            else h = (r - g) / s + 4;
            s /= l < 0.5 ? max + min : 2 - max - min;
            h *= 60;
        } else s = l > 0 && l < 1 ? 0 : h;
        return new Hsl(h, s, l, o.opacity);
    }
    function hsl$2(h, s, l, opacity) {
        return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
    }
    function Hsl(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    define(Hsl, hsl$2, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Hsl(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
            return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
        },
        clamp () {
            return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
        },
        displayable () {
            return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
        },
        formatHsl () {
            const a = clampa(this.opacity);
            return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
        }
    }));
    function clamph(value) {
        value = (value || 0) % 360;
        return value < 0 ? value + 360 : value;
    }
    function clampt(value) {
        return Math.max(0, Math.min(1, value || 0));
    }
    /* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
        return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
    }
    const radians$1 = Math.PI / 180;
    const degrees$2 = 180 / Math.PI;
    // https://observablehq.com/@mbostock/lab-and-rgb
    const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0$1 = 4 / 29, t1$1 = 6 / 29, t2 = 3 * t1$1 * t1$1, t3 = t1$1 * t1$1 * t1$1;
    function labConvert(o) {
        if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
        if (o instanceof Hcl) return hcl2lab(o);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
        if (r === g && g === b) x = z = y;
        else {
            x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
            z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
        }
        return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
    }
    function gray(l, opacity) {
        return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
    }
    function lab$1(l, a, b, opacity) {
        return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
    }
    function Lab(l, a, b, opacity) {
        this.l = +l;
        this.a = +a;
        this.b = +b;
        this.opacity = +opacity;
    }
    define(Lab, lab$1, extend(Color, {
        brighter (k) {
            return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        darker (k) {
            return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
        },
        rgb () {
            var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
            x = Xn * lab2xyz(x);
            y = Yn * lab2xyz(y);
            z = Zn * lab2xyz(z);
            return new Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
        }
    }));
    function xyz2lab(t) {
        return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
    }
    function lab2xyz(t) {
        return t > t1$1 ? t * t * t : t2 * (t - t0$1);
    }
    function lrgb2rgb(x) {
        return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
    }
    function rgb2lrgb(x) {
        return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    }
    function hclConvert(o) {
        if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
        if (!(o instanceof Lab)) o = labConvert(o);
        if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
        var h = Math.atan2(o.b, o.a) * degrees$2;
        return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
    }
    function lch(l, c, h, opacity) {
        return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
    }
    function hcl$2(h, c, l, opacity) {
        return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
    }
    function Hcl(h, c, l, opacity) {
        this.h = +h;
        this.c = +c;
        this.l = +l;
        this.opacity = +opacity;
    }
    function hcl2lab(o) {
        if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
        var h = o.h * radians$1;
        return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
    }
    define(Hcl, hcl$2, extend(Color, {
        brighter (k) {
            return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
        },
        darker (k) {
            return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
        },
        rgb () {
            return hcl2lab(this).rgb();
        }
    }));
    var A = -0.14861, B$1 = 1.78277, C = -0.29227, D$1 = -0.90649, E = 1.97294, ED = E * D$1, EB = E * B$1, BC_DA = B$1 * C - D$1 * A;
    function cubehelixConvert(o) {
        if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
        if (!(o instanceof Rgb)) o = rgbConvert(o);
        var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D$1, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * degrees$2 - 120 : NaN;
        return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
    }
    function cubehelix$3(h, s, l, opacity) {
        return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
    }
    function Cubehelix(h, s, l, opacity) {
        this.h = +h;
        this.s = +s;
        this.l = +l;
        this.opacity = +opacity;
    }
    define(Cubehelix, cubehelix$3, extend(Color, {
        brighter (k) {
            k = k == null ? brighter : Math.pow(brighter, k);
            return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        darker (k) {
            k = k == null ? darker : Math.pow(darker, k);
            return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
        },
        rgb () {
            var h = isNaN(this.h) ? 0 : (this.h + 120) * radians$1, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
            return new Rgb(255 * (l + a * (A * cosh + B$1 * sinh)), 255 * (l + a * (C * cosh + D$1 * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
        }
    }));
    function basis$1(t1, v0, v1, v2, v3) {
        var t2 = t1 * t1, t3 = t2 * t1;
        return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
    }
    function basis$2(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis$1((t - i / n) * n, v0, v1, v2, v3);
        };
    }
    function basisClosed$1(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return basis$1((t - i / n) * n, v0, v1, v2, v3);
        };
    }
    var constant$8 = (x)=>()=>x;
    function linear$2(a, d) {
        return function(t) {
            return a + t * d;
        };
    }
    function exponential$1(a, b, y) {
        return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
            return Math.pow(a + t * b, y);
        };
    }
    function hue$1(a, b) {
        var d = b - a;
        return d ? linear$2(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$8(isNaN(a) ? b : a);
    }
    function gamma$1(y) {
        return (y = +y) === 1 ? nogamma : function(a, b) {
            return b - a ? exponential$1(a, b, y) : constant$8(isNaN(a) ? b : a);
        };
    }
    function nogamma(a, b) {
        var d = b - a;
        return d ? linear$2(a, d) : constant$8(isNaN(a) ? b : a);
    }
    var interpolateRgb = function rgbGamma(y) {
        var color = gamma$1(y);
        function rgb$1(start, end) {
            var r = color((start = rgb(start)).r, (end = rgb(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.r = r(t);
                start.g = g(t);
                start.b = b(t);
                start.opacity = opacity(t);
                return start + "";
            };
        }
        rgb$1.gamma = rgbGamma;
        return rgb$1;
    }(1);
    function rgbSpline(spline) {
        return function(colors) {
            var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
            for(i = 0; i < n; ++i){
                color = rgb(colors[i]);
                r[i] = color.r || 0;
                g[i] = color.g || 0;
                b[i] = color.b || 0;
            }
            r = spline(r);
            g = spline(g);
            b = spline(b);
            color.opacity = 1;
            return function(t) {
                color.r = r(t);
                color.g = g(t);
                color.b = b(t);
                return color + "";
            };
        };
    }
    var rgbBasis = rgbSpline(basis$2);
    var rgbBasisClosed = rgbSpline(basisClosed$1);
    function numberArray(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    }
    function isNumberArray(x) {
        return ArrayBuffer.isView(x) && !(x instanceof DataView);
    }
    function array$3(a, b) {
        return (isNumberArray(b) ? numberArray : genericArray)(a, b);
    }
    function genericArray(a, b) {
        var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
        for(i = 0; i < na; ++i)x[i] = interpolate$2(a[i], b[i]);
        for(; i < nb; ++i)c[i] = b[i];
        return function(t) {
            for(i = 0; i < na; ++i)c[i] = x[i](t);
            return c;
        };
    }
    function date$1(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    }
    function interpolateNumber(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    }
    function object$1(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = interpolate$2(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    }
    var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
    function zero(b) {
        return function() {
            return b;
        };
    }
    function one(b) {
        return function(t) {
            return b(t) + "";
        };
    }
    function interpolateString(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: interpolateNumber(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    }
    function interpolate$2(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? constant$8(b) : (t === "number" ? interpolateNumber : t === "string" ? (c = color(b)) ? (b = c, interpolateRgb) : interpolateString : b instanceof color ? interpolateRgb : b instanceof Date ? date$1 : isNumberArray(b) ? numberArray : Array.isArray(b) ? genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object$1 : interpolateNumber)(a, b);
    }
    function discrete(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    }
    function hue(a, b) {
        var i = hue$1(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    }
    function interpolateRound(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    }
    var degrees$1 = 180 / Math.PI;
    var identity$7 = {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        skewX: 0,
        scaleX: 1,
        scaleY: 1
    };
    function decompose(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees$1,
            skewX: Math.atan(skewX) * degrees$1,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var svgNode;
    /* eslint-disable no-undef */ function parseCss(value) {
        const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
        return m.isIdentity ? identity$7 : decompose(m.a, m.b, m.c, m.d, m.e, m.f);
    }
    function parseSvg(value) {
        if (value == null) return identity$7;
        if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
        svgNode.setAttribute("transform", value);
        if (!(value = svgNode.transform.baseVal.consolidate())) return identity$7;
        value = value.matrix;
        return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
    }
    function interpolateTransform(parse, pxComma, pxParen, degParen) {
        function pop(s) {
            return s.length ? s.pop() + " " : "";
        }
        function translate(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
                var i = s.push("translate(", null, pxComma, null, pxParen);
                q.push({
                    i: i - 4,
                    x: interpolateNumber(xa, xb)
                }, {
                    i: i - 2,
                    x: interpolateNumber(ya, yb)
                });
            } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
        }
        function rotate(a, b, s, q) {
            if (a !== b) {
                if (a - b > 180) b += 360;
                else if (b - a > 180) a += 360; // shortest path
                q.push({
                    i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                    x: interpolateNumber(a, b)
                });
            } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
        }
        function skewX(a, b, s, q) {
            if (a !== b) q.push({
                i: s.push(pop(s) + "skewX(", null, degParen) - 2,
                x: interpolateNumber(a, b)
            });
            else if (b) s.push(pop(s) + "skewX(" + b + degParen);
        }
        function scale(xa, ya, xb, yb, s, q) {
            if (xa !== xb || ya !== yb) {
                var i = s.push(pop(s) + "scale(", null, ",", null, ")");
                q.push({
                    i: i - 4,
                    x: interpolateNumber(xa, xb)
                }, {
                    i: i - 2,
                    x: interpolateNumber(ya, yb)
                });
            } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
        }
        return function(a, b) {
            var s = [], q = []; // number interpolators
            a = parse(a), b = parse(b);
            translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
            rotate(a.rotate, b.rotate, s, q);
            skewX(a.skewX, b.skewX, s, q);
            scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
            a = b = null; // gc
            return function(t) {
                var i = -1, n = q.length, o;
                while(++i < n)s[(o = q[i]).i] = o.x(t);
                return s.join("");
            };
        };
    }
    var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
    var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
    var epsilon2$1 = 1e-12;
    function cosh(x) {
        return ((x = Math.exp(x)) + 1 / x) / 2;
    }
    function sinh(x) {
        return ((x = Math.exp(x)) - 1 / x) / 2;
    }
    function tanh(x) {
        return ((x = Math.exp(2 * x)) - 1) / (x + 1);
    }
    var interpolateZoom = function zoomRho(rho, rho2, rho4) {
        // p0 = [ux0, uy0, w0]
        // p1 = [ux1, uy1, w1]
        function zoom(p0, p1) {
            var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
            // Special case for u0 ≅ u1.
            if (d2 < epsilon2$1) {
                S = Math.log(w1 / w0) / rho;
                i = function(t) {
                    return [
                        ux0 + t * dx,
                        uy0 + t * dy,
                        w0 * Math.exp(rho * t * S)
                    ];
                };
            } else {
                var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
                S = (r1 - r0) / rho;
                i = function(t) {
                    var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                    return [
                        ux0 + u * dx,
                        uy0 + u * dy,
                        w0 * coshr0 / cosh(rho * s + r0)
                    ];
                };
            }
            i.duration = S * 1000 * rho / Math.SQRT2;
            return i;
        }
        zoom.rho = function(_) {
            var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
            return zoomRho(_1, _2, _4);
        };
        return zoom;
    }(Math.SQRT2, 2, 4);
    function hsl(hue) {
        return function(start, end) {
            var h = hue((start = hsl$2(start)).h, (end = hsl$2(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var hsl$1 = hsl(hue$1);
    var hslLong = hsl(nogamma);
    function lab(start, end) {
        var l = nogamma((start = lab$1(start)).l, (end = lab$1(end)).l), a = nogamma(start.a, end.a), b = nogamma(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
        return function(t) {
            start.l = l(t);
            start.a = a(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    function hcl(hue) {
        return function(start, end) {
            var h = hue((start = hcl$2(start)).h, (end = hcl$2(end)).h), c = nogamma(start.c, end.c), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.c = c(t);
                start.l = l(t);
                start.opacity = opacity(t);
                return start + "";
            };
        };
    }
    var hcl$1 = hcl(hue$1);
    var hclLong = hcl(nogamma);
    function cubehelix$1(hue) {
        return function cubehelixGamma(y) {
            y = +y;
            function cubehelix(start, end) {
                var h = hue((start = cubehelix$3(start)).h, (end = cubehelix$3(end)).h), s = nogamma(start.s, end.s), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
                return function(t) {
                    start.h = h(t);
                    start.s = s(t);
                    start.l = l(Math.pow(t, y));
                    start.opacity = opacity(t);
                    return start + "";
                };
            }
            cubehelix.gamma = cubehelixGamma;
            return cubehelix;
        }(1);
    }
    var cubehelix$2 = cubehelix$1(hue$1);
    var cubehelixLong = cubehelix$1(nogamma);
    function piecewise(interpolate, values) {
        if (values === undefined) values = interpolate, interpolate = interpolate$2;
        var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
        while(i < n)I[i] = interpolate(v, v = values[++i]);
        return function(t) {
            var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
            return I[i](t - i);
        };
    }
    function quantize$1(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    }
    var frame = 0, timeout$1 = 0, interval$1 = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
        setTimeout(f, 17);
    };
    function now() {
        return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
    }
    function clearNow() {
        clockNow = 0;
    }
    function Timer() {
        this._call = this._time = this._next = null;
    }
    Timer.prototype = timer.prototype = {
        constructor: Timer,
        restart: function(callback, delay, time) {
            if (typeof callback !== "function") throw new TypeError("callback is not a function");
            time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
            if (!this._next && taskTail !== this) {
                if (taskTail) taskTail._next = this;
                else taskHead = this;
                taskTail = this;
            }
            this._call = callback;
            this._time = time;
            sleep();
        },
        stop: function() {
            if (this._call) {
                this._call = null;
                this._time = Infinity;
                sleep();
            }
        }
    };
    function timer(callback, delay, time) {
        var t = new Timer;
        t.restart(callback, delay, time);
        return t;
    }
    function timerFlush() {
        now(); // Get the current time, if not already set.
        ++frame; // Pretend we’ve set an alarm, if we haven’t already.
        var t = taskHead, e;
        while(t){
            if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
            t = t._next;
        }
        --frame;
    }
    function wake() {
        clockNow = (clockLast = clock.now()) + clockSkew;
        frame = timeout$1 = 0;
        try {
            timerFlush();
        } finally{
            frame = 0;
            nap();
            clockNow = 0;
        }
    }
    function poke() {
        var now = clock.now(), delay = now - clockLast;
        if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
    }
    function nap() {
        var t0, t1 = taskHead, t2, time = Infinity;
        while(t1)if (t1._call) {
            if (time > t1._time) time = t1._time;
            t0 = t1, t1 = t1._next;
        } else {
            t2 = t1._next, t1._next = null;
            t1 = t0 ? t0._next = t2 : taskHead = t2;
        }
        taskTail = t0;
        sleep(time);
    }
    function sleep(time) {
        if (frame) return; // Soonest alarm already set, or will be.
        if (timeout$1) timeout$1 = clearTimeout(timeout$1);
        var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
        if (delay > 24) {
            if (time < Infinity) timeout$1 = setTimeout(wake, time - clock.now() - clockSkew);
            if (interval$1) interval$1 = clearInterval(interval$1);
        } else {
            if (!interval$1) clockLast = clock.now(), interval$1 = setInterval(poke, pokeDelay);
            frame = 1, setFrame(wake);
        }
    }
    function timeout(callback, delay, time) {
        var t = new Timer;
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    }
    function interval(callback, delay, time) {
        var t = new Timer, total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        t._restart = t.restart;
        t.restart = function(callback, delay, time) {
            delay = +delay, time = time == null ? now() : +time;
            t._restart(function tick(elapsed) {
                elapsed += total;
                t._restart(tick, total += delay, time);
                callback(elapsed);
            }, delay, time);
        };
        t.restart(callback, delay, time);
        return t;
    }
    var emptyOn = dispatch("start", "end", "cancel", "interrupt");
    var emptyTween = [];
    var CREATED = 0;
    var SCHEDULED = 1;
    var STARTING = 2;
    var STARTED = 3;
    var RUNNING = 4;
    var ENDING = 5;
    var ENDED = 6;
    function schedule(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    }
    function init(node, id) {
        var schedule = get(node, id);
        if (schedule.state > CREATED) throw new Error("too late; already scheduled");
        return schedule;
    }
    function set(node, id) {
        var schedule = get(node, id);
        if (schedule.state > STARTED) throw new Error("too late; already running");
        return schedule;
    }
    function get(node, id) {
        var schedule = node.__transition;
        if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
        return schedule;
    }
    function create(node, id, self) {
        var schedules = node.__transition, tween;
        // Initialize the self timer when the transition is created.
        // Note the actual delay is not known until the first callback!
        schedules[id] = self;
        self.timer = timer(schedule, 0, self.time);
        function schedule(elapsed) {
            self.state = SCHEDULED;
            self.timer.restart(start, self.delay, self.time);
            // If the elapsed delay is less than our first sleep, start immediately.
            if (self.delay <= elapsed) start(elapsed - self.delay);
        }
        function start(elapsed) {
            var i, j, n, o;
            // If the state is not SCHEDULED, then we previously errored on start.
            if (self.state !== SCHEDULED) return stop();
            for(i in schedules){
                o = schedules[i];
                if (o.name !== self.name) continue;
                // While this element already has a starting transition during this frame,
                // defer starting an interrupting transition until that transition has a
                // chance to tick (and possibly end); see d3/d3-transition#54!
                if (o.state === STARTED) return timeout(start);
                // Interrupt the active transition, if any.
                if (o.state === RUNNING) {
                    o.state = ENDED;
                    o.timer.stop();
                    o.on.call("interrupt", node, node.__data__, o.index, o.group);
                    delete schedules[i];
                } else if (+i < id) {
                    o.state = ENDED;
                    o.timer.stop();
                    o.on.call("cancel", node, node.__data__, o.index, o.group);
                    delete schedules[i];
                }
            }
            // Defer the first tick to end of the current frame; see d3/d3#1576.
            // Note the transition may be canceled after start and before the first tick!
            // Note this must be scheduled before the start event; see d3/d3-transition#16!
            // Assuming this is successful, subsequent callbacks go straight to tick.
            timeout(function() {
                if (self.state === STARTED) {
                    self.state = RUNNING;
                    self.timer.restart(tick, self.delay, self.time);
                    tick(elapsed);
                }
            });
            // Dispatch the start event.
            // Note this must be done before the tween are initialized.
            self.state = STARTING;
            self.on.call("start", node, node.__data__, self.index, self.group);
            if (self.state !== STARTING) return; // interrupted
            self.state = STARTED;
            // Initialize the tween, deleting null tween.
            tween = new Array(n = self.tween.length);
            for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
            tween.length = j + 1;
        }
        function tick(elapsed) {
            var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
            while(++i < n)tween[i].call(node, t);
            // Dispatch the end event.
            if (self.state === ENDING) {
                self.on.call("end", node, node.__data__, self.index, self.group);
                stop();
            }
        }
        function stop() {
            self.state = ENDED;
            self.timer.stop();
            delete schedules[id];
            for(var i in schedules)return; // eslint-disable-line no-unused-vars
            delete node.__transition;
        }
    }
    function interrupt(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > STARTING && schedule.state < ENDING;
            schedule.state = ENDED;
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    }
    function selection_interrupt(name) {
        return this.each(function() {
            interrupt(this, name);
        });
    }
    function tweenRemove(id, name) {
        var tween0, tween1;
        return function() {
            var schedule = set(this, id), tween = schedule.tween;
            // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.
            if (tween !== tween0) {
                tween1 = tween0 = tween;
                for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                    tween1 = tween1.slice();
                    tween1.splice(i, 1);
                    break;
                }
            }
            schedule.tween = tween1;
        };
    }
    function tweenFunction(id, name, value) {
        var tween0, tween1;
        if (typeof value !== "function") throw new Error;
        return function() {
            var schedule = set(this, id), tween = schedule.tween;
            // If this node shared tween with the previous node,
            // just assign the updated shared tween and we’re done!
            // Otherwise, copy-on-write.
            if (tween !== tween0) {
                tween1 = (tween0 = tween).slice();
                for(var t = {
                    name: name,
                    value: value
                }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                    tween1[i] = t;
                    break;
                }
                if (i === n) tween1.push(t);
            }
            schedule.tween = tween1;
        };
    }
    function transition_tween(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = get(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    }
    function tweenValue(transition, name, value) {
        var id = transition._id;
        transition.each(function() {
            var schedule = set(this, id);
            (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
        });
        return function(node) {
            return get(node, id).value[name];
        };
    }
    function interpolate$1(a, b) {
        var c;
        return (typeof b === "number" ? interpolateNumber : b instanceof color ? interpolateRgb : (c = color(b)) ? (b = c, interpolateRgb) : interpolateString)(a, b);
    }
    function attrRemove(name) {
        return function() {
            this.removeAttribute(name);
        };
    }
    function attrRemoveNS(fullname) {
        return function() {
            this.removeAttributeNS(fullname.space, fullname.local);
        };
    }
    function attrConstant(name, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = this.getAttribute(name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function attrConstantNS(fullname, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = this.getAttributeNS(fullname.space, fullname.local);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function attrFunction(name, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0, value1 = value(this), string1;
            if (value1 == null) return void this.removeAttribute(name);
            string0 = this.getAttribute(name);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function attrFunctionNS(fullname, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0, value1 = value(this), string1;
            if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
            string0 = this.getAttributeNS(fullname.space, fullname.local);
            string1 = value1 + "";
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function transition_attr(name, value) {
        var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    }
    function attrInterpolate(name, i) {
        return function(t) {
            this.setAttribute(name, i.call(this, t));
        };
    }
    function attrInterpolateNS(fullname, i) {
        return function(t) {
            this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
        };
    }
    function attrTweenNS(fullname, value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function attrTween(name, value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function transition_attrTween(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = namespace(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    }
    function delayFunction(id, value) {
        return function() {
            init(this, id).delay = +value.apply(this, arguments);
        };
    }
    function delayConstant(id, value) {
        return value = +value, function() {
            init(this, id).delay = value;
        };
    }
    function transition_delay(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : get(this.node(), id).delay;
    }
    function durationFunction(id, value) {
        return function() {
            set(this, id).duration = +value.apply(this, arguments);
        };
    }
    function durationConstant(id, value) {
        return value = +value, function() {
            set(this, id).duration = value;
        };
    }
    function transition_duration(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : get(this.node(), id).duration;
    }
    function easeConstant(id, value) {
        if (typeof value !== "function") throw new Error;
        return function() {
            set(this, id).ease = value;
        };
    }
    function transition_ease(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : get(this.node(), id).ease;
    }
    function easeVarying(id, value) {
        return function() {
            var v = value.apply(this, arguments);
            if (typeof v !== "function") throw new Error;
            set(this, id).ease = v;
        };
    }
    function transition_easeVarying(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    }
    function transition_filter(match) {
        if (typeof match !== "function") match = matcher(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new Transition(subgroups, this._parents, this._name, this._id);
    }
    function transition_merge(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new Transition(merges, this._parents, this._name, this._id);
    }
    function start(name) {
        return (name + "").trim().split(/^|\s+/).every(function(t) {
            var i = t.indexOf(".");
            if (i >= 0) t = t.slice(0, i);
            return !t || t === "start";
        });
    }
    function onFunction(id, name, listener) {
        var on0, on1, sit = start(name) ? init : set;
        return function() {
            var schedule = sit(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
            schedule.on = on1;
        };
    }
    function transition_on(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? get(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    }
    function removeFunction(id) {
        return function() {
            var parent = this.parentNode;
            for(var i in this.__transition)if (+i !== id) return;
            if (parent) parent.removeChild(this);
        };
    }
    function transition_remove() {
        return this.on("end.remove", removeFunction(this._id));
    }
    function transition_select(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = selector(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                schedule(subgroup[i], name, id, i, subgroup, get(node, id));
            }
        }
        return new Transition(subgroups, this._parents, name, id);
    }
    function transition_selectAll(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = selectorAll(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) schedule(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new Transition(subgroups, parents, name, id);
    }
    var Selection = selection.prototype.constructor;
    function transition_selection() {
        return new Selection(this._groups, this._parents);
    }
    function styleNull(name, interpolate) {
        var string00, string10, interpolate0;
        return function() {
            var string0 = styleValue(this, name), string1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
        };
    }
    function styleRemove(name) {
        return function() {
            this.style.removeProperty(name);
        };
    }
    function styleConstant(name, interpolate, value1) {
        var string00, string1 = value1 + "", interpolate0;
        return function() {
            var string0 = styleValue(this, name);
            return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
        };
    }
    function styleFunction(name, interpolate, value) {
        var string00, string10, interpolate0;
        return function() {
            var string0 = styleValue(this, name), value1 = value(this), string1 = value1 + "";
            if (value1 == null) string1 = value1 = (this.style.removeProperty(name), styleValue(this, name));
            return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
        };
    }
    function styleMaybeRemove(id, name) {
        var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
        return function() {
            var schedule = set(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
            schedule.on = on1;
        };
    }
    function transition_style(name, value, priority) {
        var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, tweenValue(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    }
    function styleInterpolate(name, i, priority) {
        return function(t) {
            this.style.setProperty(name, i.call(this, t), priority);
        };
    }
    function styleTween(name, value, priority) {
        var t, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
            return t;
        }
        tween._value = value;
        return tween;
    }
    function transition_styleTween(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    }
    function textConstant(value) {
        return function() {
            this.textContent = value;
        };
    }
    function textFunction(value) {
        return function() {
            var value1 = value(this);
            this.textContent = value1 == null ? "" : value1;
        };
    }
    function transition_text(value) {
        return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    }
    function textInterpolate(i) {
        return function(t) {
            this.textContent = i.call(this, t);
        };
    }
    function textTween(value) {
        var t0, i0;
        function tween() {
            var i = value.apply(this, arguments);
            if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
            return t0;
        }
        tween._value = value;
        return tween;
    }
    function transition_textTween(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    }
    function transition_transition() {
        var name = this._name, id0 = this._id, id1 = newId();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = get(node, id0);
                schedule(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new Transition(groups, this._parents, name, id1);
    }
    function transition_end() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = set(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    }
    var id = 0;
    function Transition(groups, parents, name, id) {
        this._groups = groups;
        this._parents = parents;
        this._name = name;
        this._id = id;
    }
    function transition(name) {
        return selection().transition(name);
    }
    function newId() {
        return ++id;
    }
    var selection_prototype = selection.prototype;
    Transition.prototype = transition.prototype = {
        constructor: Transition,
        select: transition_select,
        selectAll: transition_selectAll,
        selectChild: selection_prototype.selectChild,
        selectChildren: selection_prototype.selectChildren,
        filter: transition_filter,
        merge: transition_merge,
        selection: transition_selection,
        transition: transition_transition,
        call: selection_prototype.call,
        nodes: selection_prototype.nodes,
        node: selection_prototype.node,
        size: selection_prototype.size,
        empty: selection_prototype.empty,
        each: selection_prototype.each,
        on: transition_on,
        attr: transition_attr,
        attrTween: transition_attrTween,
        style: transition_style,
        styleTween: transition_styleTween,
        text: transition_text,
        textTween: transition_textTween,
        remove: transition_remove,
        tween: transition_tween,
        delay: transition_delay,
        duration: transition_duration,
        ease: transition_ease,
        easeVarying: transition_easeVarying,
        end: transition_end,
        [Symbol.iterator]: selection_prototype[Symbol.iterator]
    };
    const linear$1 = (t)=>+t;
    function quadIn(t) {
        return t * t;
    }
    function quadOut(t) {
        return t * (2 - t);
    }
    function quadInOut(t) {
        return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
    }
    function cubicIn(t) {
        return t * t * t;
    }
    function cubicOut(t) {
        return --t * t * t + 1;
    }
    function cubicInOut(t) {
        return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
    }
    var exponent$1 = 3;
    var polyIn = function custom(e) {
        e = +e;
        function polyIn(t) {
            return Math.pow(t, e);
        }
        polyIn.exponent = custom;
        return polyIn;
    }(exponent$1);
    var polyOut = function custom(e) {
        e = +e;
        function polyOut(t) {
            return 1 - Math.pow(1 - t, e);
        }
        polyOut.exponent = custom;
        return polyOut;
    }(exponent$1);
    var polyInOut = function custom(e) {
        e = +e;
        function polyInOut(t) {
            return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
        }
        polyInOut.exponent = custom;
        return polyInOut;
    }(exponent$1);
    var pi$4 = Math.PI, halfPi$3 = pi$4 / 2;
    function sinIn(t) {
        return +t === 1 ? 1 : 1 - Math.cos(t * halfPi$3);
    }
    function sinOut(t) {
        return Math.sin(t * halfPi$3);
    }
    function sinInOut(t) {
        return (1 - Math.cos(pi$4 * t)) / 2;
    }
    // tpmt is two power minus ten times t scaled to [0,1]
    function tpmt(x) {
        return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
    }
    function expIn(t) {
        return tpmt(1 - +t);
    }
    function expOut(t) {
        return 1 - tpmt(t);
    }
    function expInOut(t) {
        return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
    }
    function circleIn(t) {
        return 1 - Math.sqrt(1 - t * t);
    }
    function circleOut(t) {
        return Math.sqrt(1 - --t * t);
    }
    function circleInOut(t) {
        return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
    }
    var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
    function bounceIn(t) {
        return 1 - bounceOut(1 - t);
    }
    function bounceOut(t) {
        return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
    }
    function bounceInOut(t) {
        return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
    }
    var overshoot = 1.70158;
    var backIn = function custom(s) {
        s = +s;
        function backIn(t) {
            return (t = +t) * t * (s * (t - 1) + t);
        }
        backIn.overshoot = custom;
        return backIn;
    }(overshoot);
    var backOut = function custom(s) {
        s = +s;
        function backOut(t) {
            return --t * t * ((t + 1) * s + t) + 1;
        }
        backOut.overshoot = custom;
        return backOut;
    }(overshoot);
    var backInOut = function custom(s) {
        s = +s;
        function backInOut(t) {
            return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
        }
        backInOut.overshoot = custom;
        return backInOut;
    }(overshoot);
    var tau$5 = 2 * Math.PI, amplitude = 1, period = 0.3;
    var elasticIn = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticIn(t) {
            return a * tpmt(- --t) * Math.sin((s - t) / p);
        }
        elasticIn.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticIn.period = function(p) {
            return custom(a, p);
        };
        return elasticIn;
    }(amplitude, period);
    var elasticOut = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticOut(t) {
            return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
        }
        elasticOut.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticOut.period = function(p) {
            return custom(a, p);
        };
        return elasticOut;
    }(amplitude, period);
    var elasticInOut = function custom(a, p) {
        var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau$5);
        function elasticInOut(t) {
            return ((t = t * 2 - 1) < 0 ? a * tpmt(-t) * Math.sin((s - t) / p) : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
        }
        elasticInOut.amplitude = function(a) {
            return custom(a, p * tau$5);
        };
        elasticInOut.period = function(p) {
            return custom(a, p);
        };
        return elasticInOut;
    }(amplitude, period);
    var defaultTiming = {
        time: null,
        delay: 0,
        duration: 250,
        ease: cubicInOut
    };
    function inherit(node, id) {
        var timing;
        while(!(timing = node.__transition) || !(timing = timing[id])){
            if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
        }
        return timing;
    }
    function selection_transition(name) {
        var id, timing;
        if (name instanceof Transition) id = name._id, name = name._name;
        else id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) schedule(node, name, id, i, group, timing || inherit(node, id));
        }
        return new Transition(groups, this._parents, name, id);
    }
    selection.prototype.interrupt = selection_interrupt;
    selection.prototype.transition = selection_transition;
    var root = [
        null
    ];
    function active(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) return new Transition([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    }
    var constant$7 = (x)=>()=>x;
    function BrushEvent(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            selection: {
                value: selection,
                enumerable: true,
                configurable: true
            },
            mode: {
                value: mode,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    function nopropagation$1(event) {
        event.stopImmediatePropagation();
    }
    function noevent$1(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    var MODE_DRAG = {
        name: "drag"
    }, MODE_SPACE = {
        name: "space"
    }, MODE_HANDLE = {
        name: "handle"
    }, MODE_CENTER = {
        name: "center"
    };
    const { abs: abs$3, max: max$2, min: min$1 } = Math;
    function number1(e) {
        return [
            +e[0],
            +e[1]
        ];
    }
    function number2(e) {
        return [
            number1(e[0]),
            number1(e[1])
        ];
    }
    var X = {
        name: "x",
        handles: [
            "w",
            "e"
        ].map(type),
        input: function(x, e) {
            return x == null ? null : [
                [
                    +x[0],
                    e[0][1]
                ],
                [
                    +x[1],
                    e[1][1]
                ]
            ];
        },
        output: function(xy) {
            return xy && [
                xy[0][0],
                xy[1][0]
            ];
        }
    };
    var Y = {
        name: "y",
        handles: [
            "n",
            "s"
        ].map(type),
        input: function(y, e) {
            return y == null ? null : [
                [
                    e[0][0],
                    +y[0]
                ],
                [
                    e[1][0],
                    +y[1]
                ]
            ];
        },
        output: function(xy) {
            return xy && [
                xy[0][1],
                xy[1][1]
            ];
        }
    };
    var XY = {
        name: "xy",
        handles: [
            "n",
            "w",
            "e",
            "s",
            "nw",
            "ne",
            "sw",
            "se"
        ].map(type),
        input: function(xy) {
            return xy == null ? null : number2(xy);
        },
        output: function(xy) {
            return xy;
        }
    };
    var cursors = {
        overlay: "crosshair",
        selection: "move",
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
    };
    var flipX = {
        e: "w",
        w: "e",
        nw: "ne",
        ne: "nw",
        se: "sw",
        sw: "se"
    };
    var flipY = {
        n: "s",
        s: "n",
        nw: "sw",
        ne: "se",
        se: "ne",
        sw: "nw"
    };
    var signsX = {
        overlay: 1,
        selection: 1,
        n: null,
        e: 1,
        s: null,
        w: -1,
        nw: -1,
        ne: 1,
        se: 1,
        sw: -1
    };
    var signsY = {
        overlay: 1,
        selection: 1,
        n: -1,
        e: null,
        s: 1,
        w: null,
        nw: -1,
        ne: -1,
        se: 1,
        sw: 1
    };
    function type(t) {
        return {
            type: t
        };
    }
    // Ignore right-click, since that should open the context menu.
    function defaultFilter$1(event) {
        return !event.ctrlKey && !event.button;
    }
    function defaultExtent$1() {
        var svg = this.ownerSVGElement || this;
        if (svg.hasAttribute("viewBox")) {
            svg = svg.viewBox.baseVal;
            return [
                [
                    svg.x,
                    svg.y
                ],
                [
                    svg.x + svg.width,
                    svg.y + svg.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                svg.width.baseVal.value,
                svg.height.baseVal.value
            ]
        ];
    }
    function defaultTouchable$1() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    // Like d3.local, but with the name “__brush” rather than auto-generated.
    function local(node) {
        while(!node.__brush)if (!(node = node.parentNode)) return;
        return node.__brush;
    }
    function empty(extent) {
        return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
    }
    function brushSelection(node) {
        var state = node.__brush;
        return state ? state.dim.output(state.selection) : null;
    }
    function brushX() {
        return brush$1(X);
    }
    function brushY() {
        return brush$1(Y);
    }
    function brush() {
        return brush$1(XY);
    }
    function brush$1(dim) {
        var extent = defaultExtent$1, filter = defaultFilter$1, touchable = defaultTouchable$1, keys = true, listeners = dispatch("start", "brush", "end"), handleSize = 6, touchending;
        function brush(group) {
            var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
                type("overlay")
            ]);
            overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
                var extent = local(this).extent;
                select(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
            });
            group.selectAll(".selection").data([
                type("selection")
            ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
            var handle = group.selectAll(".handle").data(dim.handles, function(d) {
                return d.type;
            });
            handle.exit().remove();
            handle.enter().append("rect").attr("class", function(d) {
                return "handle handle--" + d.type;
            }).attr("cursor", function(d) {
                return cursors[d.type];
            });
            group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        brush.move = function(group, selection, event) {
            if (group.tween) group.on("start.brush", function(event) {
                emitter(this, arguments).beforestart().start(event);
            }).on("interrupt.brush end.brush", function(event) {
                emitter(this, arguments).end(event);
            }).tween("brush", function() {
                var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = interpolate$2(selection0, selection1);
                function tween(t) {
                    state.selection = t === 1 && selection1 === null ? null : i(t);
                    redraw.call(that);
                    emit.brush();
                }
                return selection0 !== null && selection1 !== null ? tween : tween(1);
            });
            else group.each(function() {
                var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
                interrupt(that);
                state.selection = selection1 === null ? null : selection1;
                redraw.call(that);
                emit.start(event).brush(event).end(event);
            });
        };
        brush.clear = function(group, event) {
            brush.move(group, null, event);
        };
        function redraw() {
            var group = select(this), selection = local(this).selection;
            if (selection) {
                group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
                group.selectAll(".handle").style("display", null).attr("x", function(d) {
                    return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
                }).attr("y", function(d) {
                    return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
                }).attr("width", function(d) {
                    return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
                }).attr("height", function(d) {
                    return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
                });
            } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
        }
        function emitter(that, args, clean) {
            var emit = that.__brush.emitter;
            return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
        }
        function Emitter(that, args, clean) {
            this.that = that;
            this.args = args;
            this.state = that.__brush;
            this.active = 0;
            this.clean = clean;
        }
        Emitter.prototype = {
            beforestart: function() {
                if (++this.active === 1) this.state.emitter = this, this.starting = true;
                return this;
            },
            start: function(event, mode) {
                if (this.starting) this.starting = false, this.emit("start", event, mode);
                else this.emit("brush", event);
                return this;
            },
            brush: function(event, mode) {
                this.emit("brush", event, mode);
                return this;
            },
            end: function(event, mode) {
                if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
                return this;
            },
            emit: function(type, event, mode) {
                var d = select(this.that).datum();
                listeners.call(type, this.that, new BrushEvent(type, {
                    sourceEvent: event,
                    target: brush,
                    selection: dim.output(this.state.selection),
                    mode: mode,
                    dispatch: listeners
                }), d);
            }
        };
        function started(event) {
            if (touchending && !event.touches) return;
            if (!filter.apply(this, arguments)) return;
            var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && event.altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
                event
            ], (t)=>{
                const i = t.identifier;
                t = pointer(t, that);
                t.point0 = t.slice();
                t.identifier = i;
                return t;
            });
            interrupt(that);
            var emit = emitter(that, arguments, true).beforestart();
            if (type === "overlay") {
                if (selection) moving = true;
                const pts = [
                    points[0],
                    points[1] || points[0]
                ];
                state.selection = selection = [
                    [
                        w0 = dim === Y ? W : min$1(pts[0][0], pts[1][0]),
                        n0 = dim === X ? N : min$1(pts[0][1], pts[1][1])
                    ],
                    [
                        e0 = dim === Y ? E : max$2(pts[0][0], pts[1][0]),
                        s0 = dim === X ? S : max$2(pts[0][1], pts[1][1])
                    ]
                ];
                if (points.length > 1) move(event);
            } else {
                w0 = selection[0][0];
                n0 = selection[0][1];
                e0 = selection[1][0];
                s0 = selection[1][1];
            }
            w1 = w0;
            n1 = n0;
            e1 = e0;
            s1 = s0;
            var group = select(that).attr("pointer-events", "none");
            var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
            if (event.touches) {
                emit.moved = moved;
                emit.ended = ended;
            } else {
                var view = select(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
                if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
                dragDisable(event.view);
            }
            redraw.call(that);
            emit.start(event, mode.name);
            function moved(event) {
                for (const p of event.changedTouches || [
                    event
                ]){
                    for (const d of points)if (d.identifier === p.identifier) d.cur = pointer(p, that);
                }
                if (shifting && !lockX && !lockY && points.length === 1) {
                    const point = points[0];
                    if (abs$3(point.cur[0] - point[0]) > abs$3(point.cur[1] - point[1])) lockY = true;
                    else lockX = true;
                }
                for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
                moving = true;
                noevent$1(event);
                move(event);
            }
            function move(event) {
                const point = points[0], point0 = point.point0;
                var t;
                dx = point[0] - point0[0];
                dy = point[1] - point0[1];
                switch(mode){
                    case MODE_SPACE:
                    case MODE_DRAG:
                        if (signX) dx = max$2(W - w0, min$1(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                        if (signY) dy = max$2(N - n0, min$1(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                        break;
                    case MODE_HANDLE:
                        if (points[1]) {
                            if (signX) w1 = max$2(W, min$1(E, points[0][0])), e1 = max$2(W, min$1(E, points[1][0])), signX = 1;
                            if (signY) n1 = max$2(N, min$1(S, points[0][1])), s1 = max$2(N, min$1(S, points[1][1])), signY = 1;
                        } else {
                            if (signX < 0) dx = max$2(W - w0, min$1(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                            else if (signX > 0) dx = max$2(W - e0, min$1(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                            if (signY < 0) dy = max$2(N - n0, min$1(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                            else if (signY > 0) dy = max$2(N - s0, min$1(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                        }
                        break;
                    case MODE_CENTER:
                        if (signX) w1 = max$2(W, min$1(E, w0 - dx * signX)), e1 = max$2(W, min$1(E, e0 + dx * signX));
                        if (signY) n1 = max$2(N, min$1(S, n0 - dy * signY)), s1 = max$2(N, min$1(S, s0 + dy * signY));
                        break;
                }
                if (e1 < w1) {
                    signX *= -1;
                    t = w0, w0 = e0, e0 = t;
                    t = w1, w1 = e1, e1 = t;
                    if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
                }
                if (s1 < n1) {
                    signY *= -1;
                    t = n0, n0 = s0, s0 = t;
                    t = n1, n1 = s1, s1 = t;
                    if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
                }
                if (state.selection) selection = state.selection; // May be set by brush.move!
                if (lockX) w1 = selection[0][0], e1 = selection[1][0];
                if (lockY) n1 = selection[0][1], s1 = selection[1][1];
                if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                    state.selection = [
                        [
                            w1,
                            n1
                        ],
                        [
                            e1,
                            s1
                        ]
                    ];
                    redraw.call(that);
                    emit.brush(event, mode.name);
                }
            }
            function ended(event) {
                nopropagation$1(event);
                if (event.touches) {
                    if (event.touches.length) return;
                    if (touchending) clearTimeout(touchending);
                    touchending = setTimeout(function() {
                        touchending = null;
                    }, 500); // Ghost clicks are delayed!
                } else {
                    yesdrag(event.view, moving);
                    view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
                }
                group.attr("pointer-events", "all");
                overlay.attr("cursor", cursors.overlay);
                if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
                if (empty(selection)) state.selection = null, redraw.call(that);
                emit.end(event, mode.name);
            }
            function keydowned(event) {
                switch(event.keyCode){
                    case 16:
                        shifting = signX && signY;
                        break;
                    case 18:
                        if (mode === MODE_HANDLE) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                            move(event);
                        }
                        break;
                    case 32:
                        if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                            if (signX < 0) e0 = e1 - dx;
                            else if (signX > 0) w0 = w1 - dx;
                            if (signY < 0) s0 = s1 - dy;
                            else if (signY > 0) n0 = n1 - dy;
                            mode = MODE_SPACE;
                            overlay.attr("cursor", cursors.selection);
                            move(event);
                        }
                        break;
                    default:
                        return;
                }
                noevent$1(event);
            }
            function keyupped(event) {
                switch(event.keyCode){
                    case 16:
                        if (shifting) {
                            lockX = lockY = shifting = false;
                            move(event);
                        }
                        break;
                    case 18:
                        if (mode === MODE_CENTER) {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                            move(event);
                        }
                        break;
                    case 32:
                        if (mode === MODE_SPACE) {
                            if (event.altKey) {
                                if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                                if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                                mode = MODE_CENTER;
                            } else {
                                if (signX < 0) e0 = e1;
                                else if (signX > 0) w0 = w1;
                                if (signY < 0) s0 = s1;
                                else if (signY > 0) n0 = n1;
                                mode = MODE_HANDLE;
                            }
                            overlay.attr("cursor", cursors[type]);
                            move(event);
                        }
                        break;
                    default:
                        return;
                }
                noevent$1(event);
            }
        }
        function touchmoved(event) {
            emitter(this, arguments).moved(event);
        }
        function touchended(event) {
            emitter(this, arguments).ended(event);
        }
        function initialize() {
            var state = this.__brush || {
                selection: null
            };
            state.extent = number2(extent.apply(this, arguments));
            state.dim = dim;
            return state;
        }
        brush.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant$7(number2(_)), brush) : extent;
        };
        brush.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant$7(!!_), brush) : filter;
        };
        brush.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant$7(!!_), brush) : touchable;
        };
        brush.handleSize = function(_) {
            return arguments.length ? (handleSize = +_, brush) : handleSize;
        };
        brush.keyModifiers = function(_) {
            return arguments.length ? (keys = !!_, brush) : keys;
        };
        brush.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? brush : value;
        };
        return brush;
    }
    var abs$2 = Math.abs;
    var cos$2 = Math.cos;
    var sin$2 = Math.sin;
    var pi$3 = Math.PI;
    var halfPi$2 = pi$3 / 2;
    var tau$4 = pi$3 * 2;
    var max$1 = Math.max;
    var epsilon$5 = 1e-12;
    function range$1(i, j) {
        return Array.from({
            length: j - i
        }, (_, k)=>i + k);
    }
    function compareValue(compare) {
        return function(a, b) {
            return compare(a.source.value + a.target.value, b.source.value + b.target.value);
        };
    }
    function chord() {
        return chord$1(false, false);
    }
    function chordTranspose() {
        return chord$1(false, true);
    }
    function chordDirected() {
        return chord$1(true, false);
    }
    function chord$1(directed, transpose) {
        var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
        function chord(matrix) {
            var n = matrix.length, groupSums = new Array(n), groupIndex = range$1(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
            matrix = Float64Array.from({
                length: n * n
            }, transpose ? (_, i)=>matrix[i % n][i / n | 0] : (_, i)=>matrix[i / n | 0][i % n]);
            // Compute the scaling factor from value to angle in [0, 2pi].
            for(let i = 0; i < n; ++i){
                let x = 0;
                for(let j = 0; j < n; ++j)x += matrix[i * n + j] + directed * matrix[j * n + i];
                k += groupSums[i] = x;
            }
            k = max$1(0, tau$4 - padAngle * n) / k;
            dx = k ? padAngle : tau$4 / n;
            // Compute the angles for each group and constituent chord.
            {
                let x = 0;
                if (sortGroups) groupIndex.sort((a, b)=>sortGroups(groupSums[a], groupSums[b]));
                for (const i of groupIndex){
                    const x0 = x;
                    if (directed) {
                        const subgroupIndex = range$1(~n + 1, n).filter((j)=>j < 0 ? matrix[~j * n + i] : matrix[i * n + j]);
                        if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]));
                        for (const j of subgroupIndex)if (j < 0) {
                            const chord = chords[~j * n + i] || (chords[~j * n + i] = {
                                source: null,
                                target: null
                            });
                            chord.target = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[~j * n + i] * k,
                                value: matrix[~j * n + i]
                            };
                        } else {
                            const chord = chords[i * n + j] || (chords[i * n + j] = {
                                source: null,
                                target: null
                            });
                            chord.source = {
                                index: i,
                                startAngle: x,
                                endAngle: x += matrix[i * n + j] * k,
                                value: matrix[i * n + j]
                            };
                        }
                        groups[i] = {
                            index: i,
                            startAngle: x0,
                            endAngle: x,
                            value: groupSums[i]
                        };
                    } else {
                        const subgroupIndex = range$1(0, n).filter((j)=>matrix[i * n + j] || matrix[j * n + i]);
                        if (sortSubgroups) subgroupIndex.sort((a, b)=>sortSubgroups(matrix[i * n + a], matrix[i * n + b]));
                        for (const j of subgroupIndex){
                            let chord;
                            if (i < j) {
                                chord = chords[i * n + j] || (chords[i * n + j] = {
                                    source: null,
                                    target: null
                                });
                                chord.source = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                            } else {
                                chord = chords[j * n + i] || (chords[j * n + i] = {
                                    source: null,
                                    target: null
                                });
                                chord.target = {
                                    index: i,
                                    startAngle: x,
                                    endAngle: x += matrix[i * n + j] * k,
                                    value: matrix[i * n + j]
                                };
                                if (i === j) chord.source = chord.target;
                            }
                            if (chord.source && chord.target && chord.source.value < chord.target.value) {
                                const source = chord.source;
                                chord.source = chord.target;
                                chord.target = source;
                            }
                        }
                        groups[i] = {
                            index: i,
                            startAngle: x0,
                            endAngle: x,
                            value: groupSums[i]
                        };
                    }
                    x += dx;
                }
            }
            // Remove empty chords.
            chords = Object.values(chords);
            chords.groups = groups;
            return sortChords ? chords.sort(sortChords) : chords;
        }
        chord.padAngle = function(_) {
            return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
        };
        chord.sortGroups = function(_) {
            return arguments.length ? (sortGroups = _, chord) : sortGroups;
        };
        chord.sortSubgroups = function(_) {
            return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
        };
        chord.sortChords = function(_) {
            return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
        };
        return chord;
    }
    const pi$2 = Math.PI, tau$3 = 2 * pi$2, epsilon$4 = 1e-6, tauEpsilon = tau$3 - epsilon$4;
    function append$1(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
    }
    function appendRound$1(digits) {
        let d = Math.floor(digits);
        if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
        if (d > 15) return append$1;
        const k = 10 ** d;
        return function(strings) {
            this._ += strings[0];
            for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
        };
    }
    let Path$1 = class Path {
        constructor(digits){
            this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
            this._ = "";
            this._append = digits == null ? append$1 : appendRound$1(digits);
        }
        moveTo(x, y) {
            this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
        }
        closePath() {
            if (this._x1 !== null) {
                this._x1 = this._x0, this._y1 = this._y0;
                this._append`Z`;
            }
        }
        lineTo(x, y) {
            this._append`L${this._x1 = +x},${this._y1 = +y}`;
        }
        quadraticCurveTo(x1, y1, x, y) {
            this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
        }
        bezierCurveTo(x1, y1, x2, y2, x, y) {
            this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
        }
        arcTo(x1, y1, x2, y2, r) {
            x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
            // Is the radius negative? Error.
            if (r < 0) throw new Error(`negative radius: ${r}`);
            let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
            // Is this path empty? Move to (x1,y1).
            if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
            else if (!(l01_2 > epsilon$4)) ;
            else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$4) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
            else {
                let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi$2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
                // If the start tangent is not coincident with (x0,y0), line to.
                if (Math.abs(t01 - 1) > epsilon$4) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
                this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
            }
        }
        arc(x, y, r, a0, a1, ccw) {
            x = +x, y = +y, r = +r, ccw = !!ccw;
            // Is the radius negative? Error.
            if (r < 0) throw new Error(`negative radius: ${r}`);
            let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
            // Is this path empty? Move to (x0,y0).
            if (this._x1 === null) this._append`M${x0},${y0}`;
            else if (Math.abs(this._x1 - x0) > epsilon$4 || Math.abs(this._y1 - y0) > epsilon$4) this._append`L${x0},${y0}`;
            // Is this arc empty? We’re done.
            if (!r) return;
            // Does the angle go the wrong way? Flip the direction.
            if (da < 0) da = da % tau$3 + tau$3;
            // Is this a complete circle? Draw two arcs to complete the circle.
            if (da > tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
            else if (da > epsilon$4) this._append`A${r},${r},0,${+(da >= pi$2)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
        }
        rect(x, y, w, h) {
            this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
        }
        toString() {
            return this._;
        }
    };
    function path() {
        return new Path$1;
    }
    // Allow instanceof d3.path
    path.prototype = Path$1.prototype;
    function pathRound(digits = 3) {
        return new Path$1(+digits);
    }
    var slice$2 = Array.prototype.slice;
    function constant$6(x) {
        return function() {
            return x;
        };
    }
    function defaultSource$1(d) {
        return d.source;
    }
    function defaultTarget(d) {
        return d.target;
    }
    function defaultRadius$1(d) {
        return d.radius;
    }
    function defaultStartAngle(d) {
        return d.startAngle;
    }
    function defaultEndAngle(d) {
        return d.endAngle;
    }
    function defaultPadAngle() {
        return 0;
    }
    function defaultArrowheadRadius() {
        return 10;
    }
    function ribbon(headRadius) {
        var source = defaultSource$1, target = defaultTarget, sourceRadius = defaultRadius$1, targetRadius = defaultRadius$1, startAngle = defaultStartAngle, endAngle = defaultEndAngle, padAngle = defaultPadAngle, context = null;
        function ribbon() {
            var buffer, s = source.apply(this, arguments), t = target.apply(this, arguments), ap = padAngle.apply(this, arguments) / 2, argv = slice$2.call(arguments), sr = +sourceRadius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - halfPi$2, sa1 = endAngle.apply(this, argv) - halfPi$2, tr = +targetRadius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - halfPi$2, ta1 = endAngle.apply(this, argv) - halfPi$2;
            if (!context) context = buffer = path();
            if (ap > epsilon$5) {
                if (abs$2(sa1 - sa0) > ap * 2 + epsilon$5) sa1 > sa0 ? (sa0 += ap, sa1 -= ap) : (sa0 -= ap, sa1 += ap);
                else sa0 = sa1 = (sa0 + sa1) / 2;
                if (abs$2(ta1 - ta0) > ap * 2 + epsilon$5) ta1 > ta0 ? (ta0 += ap, ta1 -= ap) : (ta0 -= ap, ta1 += ap);
                else ta0 = ta1 = (ta0 + ta1) / 2;
            }
            context.moveTo(sr * cos$2(sa0), sr * sin$2(sa0));
            context.arc(0, 0, sr, sa0, sa1);
            if (sa0 !== ta0 || sa1 !== ta1) {
                if (headRadius) {
                    var hr = +headRadius.apply(this, arguments), tr2 = tr - hr, ta2 = (ta0 + ta1) / 2;
                    context.quadraticCurveTo(0, 0, tr2 * cos$2(ta0), tr2 * sin$2(ta0));
                    context.lineTo(tr * cos$2(ta2), tr * sin$2(ta2));
                    context.lineTo(tr2 * cos$2(ta1), tr2 * sin$2(ta1));
                } else {
                    context.quadraticCurveTo(0, 0, tr * cos$2(ta0), tr * sin$2(ta0));
                    context.arc(0, 0, tr, ta0, ta1);
                }
            }
            context.quadraticCurveTo(0, 0, sr * cos$2(sa0), sr * sin$2(sa0));
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        if (headRadius) ribbon.headRadius = function(_) {
            return arguments.length ? (headRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : headRadius;
        };
        ribbon.radius = function(_) {
            return arguments.length ? (sourceRadius = targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
        };
        ribbon.sourceRadius = function(_) {
            return arguments.length ? (sourceRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : sourceRadius;
        };
        ribbon.targetRadius = function(_) {
            return arguments.length ? (targetRadius = typeof _ === "function" ? _ : constant$6(+_), ribbon) : targetRadius;
        };
        ribbon.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : startAngle;
        };
        ribbon.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : endAngle;
        };
        ribbon.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$6(+_), ribbon) : padAngle;
        };
        ribbon.source = function(_) {
            return arguments.length ? (source = _, ribbon) : source;
        };
        ribbon.target = function(_) {
            return arguments.length ? (target = _, ribbon) : target;
        };
        ribbon.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
        };
        return ribbon;
    }
    function ribbon$1() {
        return ribbon();
    }
    function ribbonArrow() {
        return ribbon(defaultArrowheadRadius);
    }
    var array$2 = Array.prototype;
    var slice$1 = array$2.slice;
    function ascending$1(a, b) {
        return a - b;
    }
    function area$3(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    }
    var constant$5 = (x)=>()=>x;
    function contains$2(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    }
    function ringContains(ring, point) {
        var x = point[0], y = point[1], contains = -1;
        for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
            var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
            if (segmentContains(pi, pj, point)) return 0;
            if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
        }
        return contains;
    }
    function segmentContains(a, b, c) {
        var i;
        return collinear$1(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
    }
    function collinear$1(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
    }
    function within(p, q, r) {
        return p <= q && q <= r || r <= q && q <= p;
    }
    function noop$2() {}
    var cases = [
        [],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    0.5,
                    1.0
                ]
            ],
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    0.5
                ],
                [
                    0.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ],
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        [
            [
                [
                    1.5,
                    1.0
                ],
                [
                    1.0,
                    0.5
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    1.0,
                    1.5
                ],
                [
                    1.5,
                    1.0
                ]
            ]
        ],
        [
            [
                [
                    0.5,
                    1.0
                ],
                [
                    1.0,
                    1.5
                ]
            ]
        ],
        []
    ];
    function Contours() {
        var dx = 1, dy = 1, threshold = thresholdSturges, smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                const e = extent$1(values, finite);
                tz = ticks(...nice$1(e[0], e[1], tz), tz);
                while(tz[tz.length - 1] >= e[1])tz.pop();
                while(tz[1] < e[0])tz.shift();
            } else tz = tz.slice().sort(ascending$1);
            return tz.map((value)=>contour(values, value));
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            const v = value == null ? NaN : +value;
            if (isNaN(v)) throw new Error(`invalid value: ${value}`);
            var polygons = [], holes = [];
            isorings(values, v, function(ring) {
                smooth(ring, values, v);
                if (area$3(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if (contains$2((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = above(values[0], value);
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = above(values[x + 1], value);
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = above(values[y * dx + dx], value);
                t2 = above(values[y * dx], value);
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = above(values[y * dx + dx + x + 1], value);
                    t3 = t2, t2 = above(values[y * dx + x + 1], value);
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = above(values[y * dx + x + 1], value);
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v1 = valid(values[yt * dx + xt]);
                if (x > 0 && x < dx && xt === x) point[0] = smooth1(x, valid(values[yt * dx + xt - 1]), v1, value);
                if (y > 0 && y < dy && yt === y) point[1] = smooth1(y, valid(values[(yt - 1) * dx + xt]), v1, value);
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.floor(_[0]), _1 = Math.floor(_[1]);
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : noop$2, contours) : smooth === smoothLinear;
        };
        return contours;
    }
    // When computing the extent, ignore infinite values (as well as invalid ones).
    function finite(x) {
        return isFinite(x) ? x : NaN;
    }
    // Is the (possibly invalid) x greater than or equal to the (known valid) value?
    // Treat any invalid value as below negative infinity.
    function above(x, value) {
        return x == null ? false : +x >= value;
    }
    // During smoothing, treat any invalid value as negative infinity.
    function valid(v) {
        return v == null || isNaN(v = +v) ? -Infinity : v;
    }
    function smooth1(x, v0, v1, value) {
        const a = value - v0;
        const b = v1 - v0;
        const d = isFinite(a) || isFinite(b) ? a / b : Math.sign(a) / Math.sign(b);
        return isNaN(d) ? x : x + d - 0.5;
    }
    function defaultX$1(d) {
        return d[0];
    }
    function defaultY$1(d) {
        return d[1];
    }
    function defaultWeight() {
        return 1;
    }
    function density() {
        var x = defaultX$1, y = defaultY$1, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = constant$5(20);
        function grid(data) {
            var values = new Float32Array(n * m), pow2k = Math.pow(2, -k), i = -1;
            for (const d of data){
                var xi = (x(d, ++i, data) + o) * pow2k, yi = (y(d, i, data) + o) * pow2k, wi = +weight(d, i, data);
                if (wi && xi >= 0 && xi < n && yi >= 0 && yi < m) {
                    var x0 = Math.floor(xi), y0 = Math.floor(yi), xt = xi - x0 - 0.5, yt = yi - y0 - 0.5;
                    values[x0 + y0 * n] += (1 - xt) * (1 - yt) * wi;
                    values[x0 + 1 + y0 * n] += xt * (1 - yt) * wi;
                    values[x0 + 1 + (y0 + 1) * n] += xt * yt * wi;
                    values[x0 + (y0 + 1) * n] += (1 - xt) * yt * wi;
                }
            }
            blur2({
                data: values,
                width: n,
                height: m
            }, r * pow2k);
            return values;
        }
        function density(data) {
            var values = grid(data), tz = threshold(values), pow4k = Math.pow(2, 2 * k);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) tz = ticks(Number.MIN_VALUE, max$3(values) / pow4k, tz);
            return Contours().size([
                n,
                m
            ]).thresholds(tz.map((d)=>d * pow4k))(values).map((c, i)=>(c.value = +tz[i], transform(c)));
        }
        density.contours = function(data) {
            var values = grid(data), contours = Contours().size([
                n,
                m
            ]), pow4k = Math.pow(2, 2 * k), contour = (value)=>{
                value = +value;
                var c = transform(contours.contour(values, value * pow4k));
                c.value = value; // preserve exact threshold value
                return c;
            };
            Object.defineProperty(contour, "max", {
                get: ()=>max$3(values) / pow4k
            });
            return contour;
        };
        function transform(geometry) {
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$5(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : constant$5(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : constant$5(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = +_[0], _1 = +_[1];
            if (!(_0 >= 0 && _1 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$5(slice$1.call(_)) : constant$5(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = (Math.sqrt(4 * _ * _ + 1) - 1) / 2, resize();
        };
        return density;
    }
    const epsilon$3 = 1.1102230246251565e-16;
    const splitter = 134217729;
    const resulterrbound = (3 + 8 * epsilon$3) * epsilon$3;
    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum$1(elen, e, flen, f, h) {
        let Q, Qnew, hh, bvirt;
        let enow = e[0];
        let fnow = f[0];
        let eindex = 0;
        let findex = 0;
        if (fnow > enow === fnow > -enow) {
            Q = enow;
            enow = e[++eindex];
        } else {
            Q = fnow;
            fnow = f[++findex];
        }
        let hindex = 0;
        if (eindex < elen && findex < flen) {
            if (fnow > enow === fnow > -enow) {
                Qnew = enow + Q;
                hh = Q - (Qnew - enow);
                enow = e[++eindex];
            } else {
                Qnew = fnow + Q;
                hh = Q - (Qnew - fnow);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
            while(eindex < elen && findex < flen){
                if (fnow > enow === fnow > -enow) {
                    Qnew = Q + enow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (enow - bvirt);
                    enow = e[++eindex];
                } else {
                    Qnew = Q + fnow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
        }
        while(eindex < elen){
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        while(findex < flen){
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        if (Q !== 0 || hindex === 0) h[hindex++] = Q;
        return hindex;
    }
    function estimate(elen, e) {
        let Q = e[0];
        for(let i = 1; i < elen; i++)Q += e[i];
        return Q;
    }
    function vec(n) {
        return new Float64Array(n);
    }
    const ccwerrboundA = (3 + 16 * epsilon$3) * epsilon$3;
    const ccwerrboundB = (2 + 12 * epsilon$3) * epsilon$3;
    const ccwerrboundC = (9 + 64 * epsilon$3) * epsilon$3 * epsilon$3;
    const B = vec(4);
    const C1 = vec(8);
    const C2 = vec(12);
    const D = vec(16);
    const u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
        let acxtail, acytail, bcxtail, bcytail;
        let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
        const acx = ax - cx;
        const bcx = bx - cx;
        const acy = ay - cy;
        const bcy = by - cy;
        s1 = acx * bcy;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcx;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        B[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        B[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        B[2] = _j - (u3 - bvirt) + (_i - bvirt);
        B[3] = u3;
        let det = estimate(4, B);
        let errbound = ccwerrboundB * detsum;
        if (det >= errbound || -det >= errbound) return det;
        bvirt = ax - acx;
        acxtail = ax - (acx + bvirt) + (bvirt - cx);
        bvirt = bx - bcx;
        bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
        bvirt = ay - acy;
        acytail = ay - (acy + bvirt) + (bvirt - cy);
        bvirt = by - bcy;
        bcytail = by - (bcy + bvirt) + (bvirt - cy);
        if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
        errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
        det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
        if (det >= errbound || -det >= errbound) return det;
        s1 = acxtail * bcy;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcx;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C1len = sum$1(4, B, 4, u, C1);
        s1 = acx * bcytail;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcxtail;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const C2len = sum$1(C1len, C1, 4, u, C2);
        s1 = acxtail * bcytail;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcxtail;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        const Dlen = sum$1(C2len, C2, 4, u, D);
        return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
        const detleft = (ay - cy) * (bx - cx);
        const detright = (ax - cx) * (by - cy);
        const det = detleft - detright;
        const detsum = Math.abs(detleft + detright);
        if (Math.abs(det) >= ccwerrboundA * detsum) return det;
        return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }
    const EPSILON = Math.pow(2, -52);
    const EDGE_STACK = new Uint32Array(512);
    class Delaunator {
        static from(points, getX = defaultGetX, getY = defaultGetY) {
            const n = points.length;
            const coords = new Float64Array(n * 2);
            for(let i = 0; i < n; i++){
                const p = points[i];
                coords[2 * i] = getX(p);
                coords[2 * i + 1] = getY(p);
            }
            return new Delaunator(coords);
        }
        constructor(coords){
            const n = coords.length >> 1;
            if (n > 0 && typeof coords[0] !== 'number') throw new Error('Expected coords to contain numbers.');
            this.coords = coords;
            // arrays that will store the triangulation graph
            const maxTriangles = Math.max(2 * n - 5, 0);
            this._triangles = new Uint32Array(maxTriangles * 3);
            this._halfedges = new Int32Array(maxTriangles * 3);
            // temporary arrays for tracking the edges of the advancing convex hull
            this._hashSize = Math.ceil(Math.sqrt(n));
            this._hullPrev = new Uint32Array(n); // edge to prev edge
            this._hullNext = new Uint32Array(n); // edge to next edge
            this._hullTri = new Uint32Array(n); // edge to adjacent triangle
            this._hullHash = new Int32Array(this._hashSize).fill(-1); // angular edge hash
            // temporary arrays for sorting points
            this._ids = new Uint32Array(n);
            this._dists = new Float64Array(n);
            this.update();
        }
        update() {
            const { coords: coords, _hullPrev: hullPrev, _hullNext: hullNext, _hullTri: hullTri, _hullHash: hullHash } = this;
            const n = coords.length >> 1;
            // populate an array of point indices; calculate input data bbox
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            for(let i = 0; i < n; i++){
                const x = coords[2 * i];
                const y = coords[2 * i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
                this._ids[i] = i;
            }
            const cx = (minX + maxX) / 2;
            const cy = (minY + maxY) / 2;
            let minDist = Infinity;
            let i0, i1, i2;
            // pick a seed point close to the center
            for(let i = 0; i < n; i++){
                const d = dist(cx, cy, coords[2 * i], coords[2 * i + 1]);
                if (d < minDist) {
                    i0 = i;
                    minDist = d;
                }
            }
            const i0x = coords[2 * i0];
            const i0y = coords[2 * i0 + 1];
            minDist = Infinity;
            // find the point closest to the seed
            for(let i = 0; i < n; i++){
                if (i === i0) continue;
                const d = dist(i0x, i0y, coords[2 * i], coords[2 * i + 1]);
                if (d < minDist && d > 0) {
                    i1 = i;
                    minDist = d;
                }
            }
            let i1x = coords[2 * i1];
            let i1y = coords[2 * i1 + 1];
            let minRadius = Infinity;
            // find the third point which forms the smallest circumcircle with the first two
            for(let i = 0; i < n; i++){
                if (i === i0 || i === i1) continue;
                const r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i], coords[2 * i + 1]);
                if (r < minRadius) {
                    i2 = i;
                    minRadius = r;
                }
            }
            let i2x = coords[2 * i2];
            let i2y = coords[2 * i2 + 1];
            if (minRadius === Infinity) {
                // order collinear points by dx (or dy if all x are identical)
                // and return the list as a hull
                for(let i = 0; i < n; i++)this._dists[i] = coords[2 * i] - coords[0] || coords[2 * i + 1] - coords[1];
                quicksort(this._ids, this._dists, 0, n - 1);
                const hull = new Uint32Array(n);
                let j = 0;
                for(let i = 0, d0 = -Infinity; i < n; i++){
                    const id = this._ids[i];
                    if (this._dists[id] > d0) {
                        hull[j++] = id;
                        d0 = this._dists[id];
                    }
                }
                this.hull = hull.subarray(0, j);
                this.triangles = new Uint32Array(0);
                this.halfedges = new Uint32Array(0);
                return;
            }
            // swap the order of the seed points for counter-clockwise orientation
            if (orient2d(i0x, i0y, i1x, i1y, i2x, i2y) < 0) {
                const i = i1;
                const x = i1x;
                const y = i1y;
                i1 = i2;
                i1x = i2x;
                i1y = i2y;
                i2 = i;
                i2x = x;
                i2y = y;
            }
            const center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
            this._cx = center.x;
            this._cy = center.y;
            for(let i = 0; i < n; i++)this._dists[i] = dist(coords[2 * i], coords[2 * i + 1], center.x, center.y);
            // sort the points by distance from the seed triangle circumcenter
            quicksort(this._ids, this._dists, 0, n - 1);
            // set up the seed triangle as the starting hull
            this._hullStart = i0;
            let hullSize = 3;
            hullNext[i0] = hullPrev[i2] = i1;
            hullNext[i1] = hullPrev[i0] = i2;
            hullNext[i2] = hullPrev[i1] = i0;
            hullTri[i0] = 0;
            hullTri[i1] = 1;
            hullTri[i2] = 2;
            hullHash.fill(-1);
            hullHash[this._hashKey(i0x, i0y)] = i0;
            hullHash[this._hashKey(i1x, i1y)] = i1;
            hullHash[this._hashKey(i2x, i2y)] = i2;
            this.trianglesLen = 0;
            this._addTriangle(i0, i1, i2, -1, -1, -1);
            for(let k = 0, xp, yp; k < this._ids.length; k++){
                const i = this._ids[k];
                const x = coords[2 * i];
                const y = coords[2 * i + 1];
                // skip near-duplicate points
                if (k > 0 && Math.abs(x - xp) <= EPSILON && Math.abs(y - yp) <= EPSILON) continue;
                xp = x;
                yp = y;
                // skip seed triangle points
                if (i === i0 || i === i1 || i === i2) continue;
                // find a visible edge on the convex hull using edge hash
                let start = 0;
                for(let j = 0, key = this._hashKey(x, y); j < this._hashSize; j++){
                    start = hullHash[(key + j) % this._hashSize];
                    if (start !== -1 && start !== hullNext[start]) break;
                }
                start = hullPrev[start];
                let e = start, q;
                while(q = hullNext[e], orient2d(x, y, coords[2 * e], coords[2 * e + 1], coords[2 * q], coords[2 * q + 1]) >= 0){
                    e = q;
                    if (e === start) {
                        e = -1;
                        break;
                    }
                }
                if (e === -1) continue; // likely a near-duplicate point; skip it
                // add the first triangle from the point
                let t = this._addTriangle(e, i, hullNext[e], -1, -1, hullTri[e]);
                // recursively flip triangles from the point until they satisfy the Delaunay condition
                hullTri[i] = this._legalize(t + 2);
                hullTri[e] = t; // keep track of boundary triangles on the hull
                hullSize++;
                // walk forward through the hull, adding more triangles and flipping recursively
                let n = hullNext[e];
                while(q = hullNext[n], orient2d(x, y, coords[2 * n], coords[2 * n + 1], coords[2 * q], coords[2 * q + 1]) < 0){
                    t = this._addTriangle(n, i, q, hullTri[i], -1, hullTri[n]);
                    hullTri[i] = this._legalize(t + 2);
                    hullNext[n] = n; // mark as removed
                    hullSize--;
                    n = q;
                }
                // walk backward from the other side, adding more triangles and flipping
                if (e === start) while(q = hullPrev[e], orient2d(x, y, coords[2 * q], coords[2 * q + 1], coords[2 * e], coords[2 * e + 1]) < 0){
                    t = this._addTriangle(q, i, e, -1, hullTri[e], hullTri[q]);
                    this._legalize(t + 2);
                    hullTri[q] = t;
                    hullNext[e] = e; // mark as removed
                    hullSize--;
                    e = q;
                }
                // update the hull indices
                this._hullStart = hullPrev[i] = e;
                hullNext[e] = hullPrev[n] = i;
                hullNext[i] = n;
                // save the two new edges in the hash table
                hullHash[this._hashKey(x, y)] = i;
                hullHash[this._hashKey(coords[2 * e], coords[2 * e + 1])] = e;
            }
            this.hull = new Uint32Array(hullSize);
            for(let i = 0, e = this._hullStart; i < hullSize; i++){
                this.hull[i] = e;
                e = hullNext[e];
            }
            // trim typed triangle mesh arrays
            this.triangles = this._triangles.subarray(0, this.trianglesLen);
            this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
        }
        _hashKey(x, y) {
            return Math.floor(pseudoAngle(x - this._cx, y - this._cy) * this._hashSize) % this._hashSize;
        }
        _legalize(a) {
            const { _triangles: triangles, _halfedges: halfedges, coords: coords } = this;
            let i = 0;
            let ar = 0;
            // recursion eliminated with a fixed-size stack
            while(true){
                const b = halfedges[a];
                /* if the pair of triangles doesn't satisfy the Delaunay condition
             * (p1 is inside the circumcircle of [p0, pl, pr]), flip them,
             * then do the same check/flip recursively for the new pair of triangles
             *
             *           pl                    pl
             *          /||\                  /  \
             *       al/ || \bl            al/    \a
             *        /  ||  \              /      \
             *       /  a||b  \    flip    /___ar___\
             *     p0\   ||   /p1   =>   p0\---bl---/p1
             *        \  ||  /              \      /
             *       ar\ || /br             b\    /br
             *          \||/                  \  /
             *           pr                    pr
             */ const a0 = a - a % 3;
                ar = a0 + (a + 2) % 3;
                if (b === -1) {
                    if (i === 0) break;
                    a = EDGE_STACK[--i];
                    continue;
                }
                const b0 = b - b % 3;
                const al = a0 + (a + 1) % 3;
                const bl = b0 + (b + 2) % 3;
                const p0 = triangles[ar];
                const pr = triangles[a];
                const pl = triangles[al];
                const p1 = triangles[bl];
                const illegal = inCircle(coords[2 * p0], coords[2 * p0 + 1], coords[2 * pr], coords[2 * pr + 1], coords[2 * pl], coords[2 * pl + 1], coords[2 * p1], coords[2 * p1 + 1]);
                if (illegal) {
                    triangles[a] = p1;
                    triangles[b] = p0;
                    const hbl = halfedges[bl];
                    // edge swapped on the other side of the hull (rare); fix the halfedge reference
                    if (hbl === -1) {
                        let e = this._hullStart;
                        do {
                            if (this._hullTri[e] === bl) {
                                this._hullTri[e] = a;
                                break;
                            }
                            e = this._hullPrev[e];
                        }while (e !== this._hullStart);
                    }
                    this._link(a, hbl);
                    this._link(b, halfedges[ar]);
                    this._link(ar, bl);
                    const br = b0 + (b + 1) % 3;
                    // don't worry about hitting the cap: it can only happen on extremely degenerate input
                    if (i < EDGE_STACK.length) EDGE_STACK[i++] = br;
                } else {
                    if (i === 0) break;
                    a = EDGE_STACK[--i];
                }
            }
            return ar;
        }
        _link(a, b) {
            this._halfedges[a] = b;
            if (b !== -1) this._halfedges[b] = a;
        }
        // add a new triangle given vertex indices and adjacent half-edge ids
        _addTriangle(i0, i1, i2, a, b, c) {
            const t = this.trianglesLen;
            this._triangles[t] = i0;
            this._triangles[t + 1] = i1;
            this._triangles[t + 2] = i2;
            this._link(t, a);
            this._link(t + 1, b);
            this._link(t + 2, c);
            this.trianglesLen += 3;
            return t;
        }
    }
    // monotonically increases with real angle, but doesn't need expensive trigonometry
    function pseudoAngle(dx, dy) {
        const p = dx / (Math.abs(dx) + Math.abs(dy));
        return (dy > 0 ? 3 - p : 1 + p) / 4; // [0..1]
    }
    function dist(ax, ay, bx, by) {
        const dx = ax - bx;
        const dy = ay - by;
        return dx * dx + dy * dy;
    }
    function inCircle(ax, ay, bx, by, cx, cy, px, py) {
        const dx = ax - px;
        const dy = ay - py;
        const ex = bx - px;
        const ey = by - py;
        const fx = cx - px;
        const fy = cy - py;
        const ap = dx * dx + dy * dy;
        const bp = ex * ex + ey * ey;
        const cp = fx * fx + fy * fy;
        return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
    }
    function circumradius(ax, ay, bx, by, cx, cy) {
        const dx = bx - ax;
        const dy = by - ay;
        const ex = cx - ax;
        const ey = cy - ay;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const d = 0.5 / (dx * ey - dy * ex);
        const x = (ey * bl - dy * cl) * d;
        const y = (dx * cl - ex * bl) * d;
        return x * x + y * y;
    }
    function circumcenter(ax, ay, bx, by, cx, cy) {
        const dx = bx - ax;
        const dy = by - ay;
        const ex = cx - ax;
        const ey = cy - ay;
        const bl = dx * dx + dy * dy;
        const cl = ex * ex + ey * ey;
        const d = 0.5 / (dx * ey - dy * ex);
        const x = ax + (ey * bl - dy * cl) * d;
        const y = ay + (dx * cl - ex * bl) * d;
        return {
            x: x,
            y: y
        };
    }
    function quicksort(ids, dists, left, right) {
        if (right - left <= 20) for(let i = left + 1; i <= right; i++){
            const temp = ids[i];
            const tempDist = dists[temp];
            let j = i - 1;
            while(j >= left && dists[ids[j]] > tempDist)ids[j + 1] = ids[j--];
            ids[j + 1] = temp;
        }
        else {
            const median = left + right >> 1;
            let i = left + 1;
            let j = right;
            swap(ids, median, i);
            if (dists[ids[left]] > dists[ids[right]]) swap(ids, left, right);
            if (dists[ids[i]] > dists[ids[right]]) swap(ids, i, right);
            if (dists[ids[left]] > dists[ids[i]]) swap(ids, left, i);
            const temp = ids[i];
            const tempDist = dists[temp];
            while(true){
                do i++;
                while (dists[ids[i]] < tempDist);
                do j--;
                while (dists[ids[j]] > tempDist);
                if (j < i) break;
                swap(ids, i, j);
            }
            ids[left + 1] = ids[j];
            ids[j] = temp;
            if (right - i + 1 >= j - left) {
                quicksort(ids, dists, i, right);
                quicksort(ids, dists, left, j - 1);
            } else {
                quicksort(ids, dists, left, j - 1);
                quicksort(ids, dists, i, right);
            }
        }
    }
    function swap(arr, i, j) {
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    function defaultGetX(p) {
        return p[0];
    }
    function defaultGetY(p) {
        return p[1];
    }
    const epsilon$2 = 1e-6;
    class Path {
        constructor(){
            this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
            this._ = "";
        }
        moveTo(x, y) {
            this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
        }
        closePath() {
            if (this._x1 !== null) {
                this._x1 = this._x0, this._y1 = this._y0;
                this._ += "Z";
            }
        }
        lineTo(x, y) {
            this._ += `L${this._x1 = +x},${this._y1 = +y}`;
        }
        arc(x, y, r) {
            x = +x, y = +y, r = +r;
            const x0 = x + r;
            const y0 = y;
            if (r < 0) throw new Error("negative radius");
            if (this._x1 === null) this._ += `M${x0},${y0}`;
            else if (Math.abs(this._x1 - x0) > epsilon$2 || Math.abs(this._y1 - y0) > epsilon$2) this._ += "L" + x0 + "," + y0;
            if (!r) return;
            this._ += `A${r},${r},0,1,1,${x - r},${y}A${r},${r},0,1,1,${this._x1 = x0},${this._y1 = y0}`;
        }
        rect(x, y, w, h) {
            this._ += `M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${+w}v${+h}h${-w}Z`;
        }
        value() {
            return this._ || null;
        }
    }
    class Polygon {
        constructor(){
            this._ = [];
        }
        moveTo(x, y) {
            this._.push([
                x,
                y
            ]);
        }
        closePath() {
            this._.push(this._[0].slice());
        }
        lineTo(x, y) {
            this._.push([
                x,
                y
            ]);
        }
        value() {
            return this._.length ? this._ : null;
        }
    }
    class Voronoi {
        constructor(delaunay, [xmin, ymin, xmax, ymax] = [
            0,
            0,
            960,
            500
        ]){
            if (!((xmax = +xmax) >= (xmin = +xmin)) || !((ymax = +ymax) >= (ymin = +ymin))) throw new Error("invalid bounds");
            this.delaunay = delaunay;
            this._circumcenters = new Float64Array(delaunay.points.length * 2);
            this.vectors = new Float64Array(delaunay.points.length * 2);
            this.xmax = xmax, this.xmin = xmin;
            this.ymax = ymax, this.ymin = ymin;
            this._init();
        }
        update() {
            this.delaunay.update();
            this._init();
            return this;
        }
        _init() {
            const { delaunay: { points: points, hull: hull, triangles: triangles }, vectors: vectors } = this;
            let bx, by; // lazily computed barycenter of the hull
            // Compute circumcenters.
            const circumcenters = this.circumcenters = this._circumcenters.subarray(0, triangles.length / 3 * 2);
            for(let i = 0, j = 0, n = triangles.length, x, y; i < n; i += 3, j += 2){
                const t1 = triangles[i] * 2;
                const t2 = triangles[i + 1] * 2;
                const t3 = triangles[i + 2] * 2;
                const x1 = points[t1];
                const y1 = points[t1 + 1];
                const x2 = points[t2];
                const y2 = points[t2 + 1];
                const x3 = points[t3];
                const y3 = points[t3 + 1];
                const dx = x2 - x1;
                const dy = y2 - y1;
                const ex = x3 - x1;
                const ey = y3 - y1;
                const ab = (dx * ey - dy * ex) * 2;
                if (Math.abs(ab) < 1e-9) {
                    // For a degenerate triangle, the circumcenter is at the infinity, in a
                    // direction orthogonal to the halfedge and away from the “center” of
                    // the diagram <bx, by>, defined as the hull’s barycenter.
                    if (bx === undefined) {
                        bx = by = 0;
                        for (const i of hull)bx += points[i * 2], by += points[i * 2 + 1];
                        bx /= hull.length, by /= hull.length;
                    }
                    const a = 1e9 * Math.sign((bx - x1) * ey - (by - y1) * ex);
                    x = (x1 + x3) / 2 - a * ey;
                    y = (y1 + y3) / 2 + a * ex;
                } else {
                    const d = 1 / ab;
                    const bl = dx * dx + dy * dy;
                    const cl = ex * ex + ey * ey;
                    x = x1 + (ey * bl - dy * cl) * d;
                    y = y1 + (dx * cl - ex * bl) * d;
                }
                circumcenters[j] = x;
                circumcenters[j + 1] = y;
            }
            // Compute exterior cell rays.
            let h = hull[hull.length - 1];
            let p0, p1 = h * 4;
            let x0, x1 = points[2 * h];
            let y0, y1 = points[2 * h + 1];
            vectors.fill(0);
            for(let i = 0; i < hull.length; ++i){
                h = hull[i];
                p0 = p1, x0 = x1, y0 = y1;
                p1 = h * 4, x1 = points[2 * h], y1 = points[2 * h + 1];
                vectors[p0 + 2] = vectors[p1] = y0 - y1;
                vectors[p0 + 3] = vectors[p1 + 1] = x1 - x0;
            }
        }
        render(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { delaunay: { halfedges: halfedges, inedges: inedges, hull: hull }, circumcenters: circumcenters, vectors: vectors } = this;
            if (hull.length <= 1) return null;
            for(let i = 0, n = halfedges.length; i < n; ++i){
                const j = halfedges[i];
                if (j < i) continue;
                const ti = Math.floor(i / 3) * 2;
                const tj = Math.floor(j / 3) * 2;
                const xi = circumcenters[ti];
                const yi = circumcenters[ti + 1];
                const xj = circumcenters[tj];
                const yj = circumcenters[tj + 1];
                this._renderSegment(xi, yi, xj, yj, context);
            }
            let h0, h1 = hull[hull.length - 1];
            for(let i = 0; i < hull.length; ++i){
                h0 = h1, h1 = hull[i];
                const t = Math.floor(inedges[h1] / 3) * 2;
                const x = circumcenters[t];
                const y = circumcenters[t + 1];
                const v = h0 * 4;
                const p = this._project(x, y, vectors[v + 2], vectors[v + 3]);
                if (p) this._renderSegment(x, y, p[0], p[1], context);
            }
            return buffer && buffer.value();
        }
        renderBounds(context) {
            const buffer = context == null ? context = new Path : undefined;
            context.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin);
            return buffer && buffer.value();
        }
        renderCell(i, context) {
            const buffer = context == null ? context = new Path : undefined;
            const points = this._clip(i);
            if (points === null || !points.length) return;
            context.moveTo(points[0], points[1]);
            let n = points.length;
            while(points[0] === points[n - 2] && points[1] === points[n - 1] && n > 1)n -= 2;
            for(let i = 2; i < n; i += 2)if (points[i] !== points[i - 2] || points[i + 1] !== points[i - 1]) context.lineTo(points[i], points[i + 1]);
            context.closePath();
            return buffer && buffer.value();
        }
        *cellPolygons() {
            const { delaunay: { points: points } } = this;
            for(let i = 0, n = points.length / 2; i < n; ++i){
                const cell = this.cellPolygon(i);
                if (cell) cell.index = i, yield cell;
            }
        }
        cellPolygon(i) {
            const polygon = new Polygon;
            this.renderCell(i, polygon);
            return polygon.value();
        }
        _renderSegment(x0, y0, x1, y1, context) {
            let S;
            const c0 = this._regioncode(x0, y0);
            const c1 = this._regioncode(x1, y1);
            if (c0 === 0 && c1 === 0) {
                context.moveTo(x0, y0);
                context.lineTo(x1, y1);
            } else if (S = this._clipSegment(x0, y0, x1, y1, c0, c1)) {
                context.moveTo(S[0], S[1]);
                context.lineTo(S[2], S[3]);
            }
        }
        contains(i, x, y) {
            if ((x = +x, x !== x) || (y = +y, y !== y)) return false;
            return this.delaunay._step(i, x, y) === i;
        }
        *neighbors(i) {
            const ci = this._clip(i);
            if (ci) for (const j of this.delaunay.neighbors(i)){
                const cj = this._clip(j);
                // find the common edge
                if (cj) loop: for(let ai = 0, li = ci.length; ai < li; ai += 2){
                    for(let aj = 0, lj = cj.length; aj < lj; aj += 2)if (ci[ai] === cj[aj] && ci[ai + 1] === cj[aj + 1] && ci[(ai + 2) % li] === cj[(aj + lj - 2) % lj] && ci[(ai + 3) % li] === cj[(aj + lj - 1) % lj]) {
                        yield j;
                        break loop;
                    }
                }
            }
        }
        _cell(i) {
            const { circumcenters: circumcenters, delaunay: { inedges: inedges, halfedges: halfedges, triangles: triangles } } = this;
            const e0 = inedges[i];
            if (e0 === -1) return null; // coincident point
            const points = [];
            let e = e0;
            do {
                const t = Math.floor(e / 3);
                points.push(circumcenters[t * 2], circumcenters[t * 2 + 1]);
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) break; // bad triangulation
                e = halfedges[e];
            }while (e !== e0 && e !== -1);
            return points;
        }
        _clip(i) {
            // degenerate case (1 valid point: return the box)
            if (i === 0 && this.delaunay.hull.length === 1) return [
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax,
                this.xmin,
                this.ymin
            ];
            const points = this._cell(i);
            if (points === null) return null;
            const { vectors: V } = this;
            const v = i * 4;
            return this._simplify(V[v] || V[v + 1] ? this._clipInfinite(i, points, V[v], V[v + 1], V[v + 2], V[v + 3]) : this._clipFinite(i, points));
        }
        _clipFinite(i, points) {
            const n = points.length;
            let P = null;
            let x0, y0, x1 = points[n - 2], y1 = points[n - 1];
            let c0, c1 = this._regioncode(x1, y1);
            let e0, e1 = 0;
            for(let j = 0; j < n; j += 2){
                x0 = x1, y0 = y1, x1 = points[j], y1 = points[j + 1];
                c0 = c1, c1 = this._regioncode(x1, y1);
                if (c0 === 0 && c1 === 0) {
                    e0 = e1, e1 = 0;
                    if (P) P.push(x1, y1);
                    else P = [
                        x1,
                        y1
                    ];
                } else {
                    let S, sx0, sy0, sx1, sy1;
                    if (c0 === 0) {
                        if ((S = this._clipSegment(x0, y0, x1, y1, c0, c1)) === null) continue;
                        [sx0, sy0, sx1, sy1] = S;
                    } else {
                        if ((S = this._clipSegment(x1, y1, x0, y0, c1, c0)) === null) continue;
                        [sx1, sy1, sx0, sy0] = S;
                        e0 = e1, e1 = this._edgecode(sx0, sy0);
                        if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                        if (P) P.push(sx0, sy0);
                        else P = [
                            sx0,
                            sy0
                        ];
                    }
                    e0 = e1, e1 = this._edgecode(sx1, sy1);
                    if (e0 && e1) this._edge(i, e0, e1, P, P.length);
                    if (P) P.push(sx1, sy1);
                    else P = [
                        sx1,
                        sy1
                    ];
                }
            }
            if (P) {
                e0 = e1, e1 = this._edgecode(P[0], P[1]);
                if (e0 && e1) this._edge(i, e0, e1, P, P.length);
            } else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax,
                this.xmin,
                this.ymin
            ];
            return P;
        }
        _clipSegment(x0, y0, x1, y1, c0, c1) {
            // for more robustness, always consider the segment in the same order
            const flip = c0 < c1;
            if (flip) [x0, y0, x1, y1, c0, c1] = [
                x1,
                y1,
                x0,
                y0,
                c1,
                c0
            ];
            while(true){
                if (c0 === 0 && c1 === 0) return flip ? [
                    x1,
                    y1,
                    x0,
                    y0
                ] : [
                    x0,
                    y0,
                    x1,
                    y1
                ];
                if (c0 & c1) return null;
                let x, y, c = c0 || c1;
                if (c & 8) x = x0 + (x1 - x0) * (this.ymax - y0) / (y1 - y0), y = this.ymax;
                else if (c & 4) x = x0 + (x1 - x0) * (this.ymin - y0) / (y1 - y0), y = this.ymin;
                else if (c & 2) y = y0 + (y1 - y0) * (this.xmax - x0) / (x1 - x0), x = this.xmax;
                else y = y0 + (y1 - y0) * (this.xmin - x0) / (x1 - x0), x = this.xmin;
                if (c0) x0 = x, y0 = y, c0 = this._regioncode(x0, y0);
                else x1 = x, y1 = y, c1 = this._regioncode(x1, y1);
            }
        }
        _clipInfinite(i, points, vx0, vy0, vxn, vyn) {
            let P = Array.from(points), p;
            if (p = this._project(P[0], P[1], vx0, vy0)) P.unshift(p[0], p[1]);
            if (p = this._project(P[P.length - 2], P[P.length - 1], vxn, vyn)) P.push(p[0], p[1]);
            if (P = this._clipFinite(i, P)) for(let j = 0, n = P.length, c0, c1 = this._edgecode(P[n - 2], P[n - 1]); j < n; j += 2){
                c0 = c1, c1 = this._edgecode(P[j], P[j + 1]);
                if (c0 && c1) j = this._edge(i, c0, c1, P, j), n = P.length;
            }
            else if (this.contains(i, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) P = [
                this.xmin,
                this.ymin,
                this.xmax,
                this.ymin,
                this.xmax,
                this.ymax,
                this.xmin,
                this.ymax
            ];
            return P;
        }
        _edge(i, e0, e1, P, j) {
            while(e0 !== e1){
                let x, y;
                switch(e0){
                    case 5:
                        e0 = 4;
                        continue; // top-left
                    case 4:
                        e0 = 6, x = this.xmax, y = this.ymin;
                        break; // top
                    case 6:
                        e0 = 2;
                        continue; // top-right
                    case 2:
                        e0 = 10, x = this.xmax, y = this.ymax;
                        break; // right
                    case 10:
                        e0 = 8;
                        continue; // bottom-right
                    case 8:
                        e0 = 9, x = this.xmin, y = this.ymax;
                        break; // bottom
                    case 9:
                        e0 = 1;
                        continue; // bottom-left
                    case 1:
                        e0 = 5, x = this.xmin, y = this.ymin;
                        break; // left
                }
                // Note: this implicitly checks for out of bounds: if P[j] or P[j+1] are
                // undefined, the conditional statement will be executed.
                if ((P[j] !== x || P[j + 1] !== y) && this.contains(i, x, y)) P.splice(j, 0, x, y), j += 2;
            }
            return j;
        }
        _project(x0, y0, vx, vy) {
            let t = Infinity, c, x, y;
            if (vy < 0) {
                if (y0 <= this.ymin) return null;
                if ((c = (this.ymin - y0) / vy) < t) y = this.ymin, x = x0 + (t = c) * vx;
            } else if (vy > 0) {
                if (y0 >= this.ymax) return null;
                if ((c = (this.ymax - y0) / vy) < t) y = this.ymax, x = x0 + (t = c) * vx;
            }
            if (vx > 0) {
                if (x0 >= this.xmax) return null;
                if ((c = (this.xmax - x0) / vx) < t) x = this.xmax, y = y0 + (t = c) * vy;
            } else if (vx < 0) {
                if (x0 <= this.xmin) return null;
                if ((c = (this.xmin - x0) / vx) < t) x = this.xmin, y = y0 + (t = c) * vy;
            }
            return [
                x,
                y
            ];
        }
        _edgecode(x, y) {
            return (x === this.xmin ? 1 : x === this.xmax ? 2 : 0) | (y === this.ymin ? 4 : y === this.ymax ? 8 : 0);
        }
        _regioncode(x, y) {
            return (x < this.xmin ? 1 : x > this.xmax ? 2 : 0) | (y < this.ymin ? 4 : y > this.ymax ? 8 : 0);
        }
        _simplify(P) {
            if (P && P.length > 4) {
                for(let i = 0; i < P.length; i += 2){
                    const j = (i + 2) % P.length, k = (i + 4) % P.length;
                    if (P[i] === P[j] && P[j] === P[k] || P[i + 1] === P[j + 1] && P[j + 1] === P[k + 1]) P.splice(j, 2), i -= 2;
                }
                if (!P.length) P = null;
            }
            return P;
        }
    }
    const tau$2 = 2 * Math.PI, pow$2 = Math.pow;
    function pointX(p) {
        return p[0];
    }
    function pointY(p) {
        return p[1];
    }
    // A triangulation is collinear if all its triangles have a non-null area
    function collinear(d) {
        const { triangles: triangles, coords: coords } = d;
        for(let i = 0; i < triangles.length; i += 3){
            const a = 2 * triangles[i], b = 2 * triangles[i + 1], c = 2 * triangles[i + 2], cross = (coords[c] - coords[a]) * (coords[b + 1] - coords[a + 1]) - (coords[b] - coords[a]) * (coords[c + 1] - coords[a + 1]);
            if (cross > 1e-10) return false;
        }
        return true;
    }
    function jitter(x, y, r) {
        return [
            x + Math.sin(x + y) * r,
            y + Math.cos(x - y) * r
        ];
    }
    class Delaunay {
        static from(points, fx = pointX, fy = pointY, that) {
            return new Delaunay("length" in points ? flatArray(points, fx, fy, that) : Float64Array.from(flatIterable(points, fx, fy, that)));
        }
        constructor(points){
            this._delaunator = new Delaunator(points);
            this.inedges = new Int32Array(points.length / 2);
            this._hullIndex = new Int32Array(points.length / 2);
            this.points = this._delaunator.coords;
            this._init();
        }
        update() {
            this._delaunator.update();
            this._init();
            return this;
        }
        _init() {
            const d = this._delaunator, points = this.points;
            // check for collinear
            if (d.hull && d.hull.length > 2 && collinear(d)) {
                this.collinear = Int32Array.from({
                    length: points.length / 2
                }, (_, i)=>i).sort((i, j)=>points[2 * i] - points[2 * j] || points[2 * i + 1] - points[2 * j + 1]); // for exact neighbors
                const e = this.collinear[0], f = this.collinear[this.collinear.length - 1], bounds = [
                    points[2 * e],
                    points[2 * e + 1],
                    points[2 * f],
                    points[2 * f + 1]
                ], r = 1e-8 * Math.hypot(bounds[3] - bounds[1], bounds[2] - bounds[0]);
                for(let i = 0, n = points.length / 2; i < n; ++i){
                    const p = jitter(points[2 * i], points[2 * i + 1], r);
                    points[2 * i] = p[0];
                    points[2 * i + 1] = p[1];
                }
                this._delaunator = new Delaunator(points);
            } else delete this.collinear;
            const halfedges = this.halfedges = this._delaunator.halfedges;
            const hull = this.hull = this._delaunator.hull;
            const triangles = this.triangles = this._delaunator.triangles;
            const inedges = this.inedges.fill(-1);
            const hullIndex = this._hullIndex.fill(-1);
            // Compute an index from each point to an (arbitrary) incoming halfedge
            // Used to give the first neighbor of each point; for this reason,
            // on the hull we give priority to exterior halfedges
            for(let e = 0, n = halfedges.length; e < n; ++e){
                const p = triangles[e % 3 === 2 ? e - 2 : e + 1];
                if (halfedges[e] === -1 || inedges[p] === -1) inedges[p] = e;
            }
            for(let i = 0, n = hull.length; i < n; ++i)hullIndex[hull[i]] = i;
            // degenerate case: 1 or 2 (distinct) points
            if (hull.length <= 2 && hull.length > 0) {
                this.triangles = new Int32Array(3).fill(-1);
                this.halfedges = new Int32Array(3).fill(-1);
                this.triangles[0] = hull[0];
                inedges[hull[0]] = 1;
                if (hull.length === 2) {
                    inedges[hull[1]] = 0;
                    this.triangles[1] = hull[1];
                    this.triangles[2] = hull[1];
                }
            }
        }
        voronoi(bounds) {
            return new Voronoi(this, bounds);
        }
        *neighbors(i) {
            const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, collinear: collinear } = this;
            // degenerate case with several collinear points
            if (collinear) {
                const l = collinear.indexOf(i);
                if (l > 0) yield collinear[l - 1];
                if (l < collinear.length - 1) yield collinear[l + 1];
                return;
            }
            const e0 = inedges[i];
            if (e0 === -1) return; // coincident point
            let e = e0, p0 = -1;
            do {
                yield p0 = triangles[e];
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) return; // bad triangulation
                e = halfedges[e];
                if (e === -1) {
                    const p = hull[(_hullIndex[i] + 1) % hull.length];
                    if (p !== p0) yield p;
                    return;
                }
            }while (e !== e0);
        }
        find(x, y, i = 0) {
            if ((x = +x, x !== x) || (y = +y, y !== y)) return -1;
            const i0 = i;
            let c;
            while((c = this._step(i, x, y)) >= 0 && c !== i && c !== i0)i = c;
            return c;
        }
        _step(i, x, y) {
            const { inedges: inedges, hull: hull, _hullIndex: _hullIndex, halfedges: halfedges, triangles: triangles, points: points } = this;
            if (inedges[i] === -1 || !points.length) return (i + 1) % (points.length >> 1);
            let c = i;
            let dc = pow$2(x - points[i * 2], 2) + pow$2(y - points[i * 2 + 1], 2);
            const e0 = inedges[i];
            let e = e0;
            do {
                let t = triangles[e];
                const dt = pow$2(x - points[t * 2], 2) + pow$2(y - points[t * 2 + 1], 2);
                if (dt < dc) dc = dt, c = t;
                e = e % 3 === 2 ? e - 2 : e + 1;
                if (triangles[e] !== i) break; // bad triangulation
                e = halfedges[e];
                if (e === -1) {
                    e = hull[(_hullIndex[i] + 1) % hull.length];
                    if (e !== t) {
                        if (pow$2(x - points[e * 2], 2) + pow$2(y - points[e * 2 + 1], 2) < dc) return e;
                    }
                    break;
                }
            }while (e !== e0);
            return c;
        }
        render(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { points: points, halfedges: halfedges, triangles: triangles } = this;
            for(let i = 0, n = halfedges.length; i < n; ++i){
                const j = halfedges[i];
                if (j < i) continue;
                const ti = triangles[i] * 2;
                const tj = triangles[j] * 2;
                context.moveTo(points[ti], points[ti + 1]);
                context.lineTo(points[tj], points[tj + 1]);
            }
            this.renderHull(context);
            return buffer && buffer.value();
        }
        renderPoints(context, r) {
            if (r === undefined && (!context || typeof context.moveTo !== "function")) r = context, context = null;
            r = r == undefined ? 2 : +r;
            const buffer = context == null ? context = new Path : undefined;
            const { points: points } = this;
            for(let i = 0, n = points.length; i < n; i += 2){
                const x = points[i], y = points[i + 1];
                context.moveTo(x + r, y);
                context.arc(x, y, r, 0, tau$2);
            }
            return buffer && buffer.value();
        }
        renderHull(context) {
            const buffer = context == null ? context = new Path : undefined;
            const { hull: hull, points: points } = this;
            const h = hull[0] * 2, n = hull.length;
            context.moveTo(points[h], points[h + 1]);
            for(let i = 1; i < n; ++i){
                const h = 2 * hull[i];
                context.lineTo(points[h], points[h + 1]);
            }
            context.closePath();
            return buffer && buffer.value();
        }
        hullPolygon() {
            const polygon = new Polygon;
            this.renderHull(polygon);
            return polygon.value();
        }
        renderTriangle(i, context) {
            const buffer = context == null ? context = new Path : undefined;
            const { points: points, triangles: triangles } = this;
            const t0 = triangles[i *= 3] * 2;
            const t1 = triangles[i + 1] * 2;
            const t2 = triangles[i + 2] * 2;
            context.moveTo(points[t0], points[t0 + 1]);
            context.lineTo(points[t1], points[t1 + 1]);
            context.lineTo(points[t2], points[t2 + 1]);
            context.closePath();
            return buffer && buffer.value();
        }
        *trianglePolygons() {
            const { triangles: triangles } = this;
            for(let i = 0, n = triangles.length / 3; i < n; ++i)yield this.trianglePolygon(i);
        }
        trianglePolygon(i) {
            const polygon = new Polygon;
            this.renderTriangle(i, polygon);
            return polygon.value();
        }
    }
    function flatArray(points, fx, fy, that) {
        const n = points.length;
        const array = new Float64Array(n * 2);
        for(let i = 0; i < n; ++i){
            const p = points[i];
            array[i * 2] = fx.call(that, p, i, points);
            array[i * 2 + 1] = fy.call(that, p, i, points);
        }
        return array;
    }
    function* flatIterable(points, fx, fy, that) {
        let i = 0;
        for (const p of points){
            yield fx.call(that, p, i, points);
            yield fy.call(that, p, i, points);
            ++i;
        }
    }
    var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
    function objectConverter(columns) {
        return new Function("d", "return {" + columns.map(function(name, i) {
            return JSON.stringify(name) + ": d[" + i + "] || \"\"";
        }).join(",") + "}");
    }
    function customConverter(columns, f) {
        var object = objectConverter(columns);
        return function(row, i) {
            return f(object(row), i, columns);
        };
    }
    // Compute unique columns in order of discovery.
    function inferColumns(rows) {
        var columnSet = Object.create(null), columns = [];
        rows.forEach(function(row) {
            for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
        });
        return columns;
    }
    function pad$1(value, width) {
        var s = value + "", length = s.length;
        return length < width ? new Array(width - length + 1).join(0) + s : s;
    }
    function formatYear$1(year) {
        return year < 0 ? "-" + pad$1(-year, 6) : year > 9999 ? "+" + pad$1(year, 6) : pad$1(year, 4);
    }
    function formatDate(date) {
        var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
        return isNaN(date) ? "Invalid Date" : formatYear$1(date.getUTCFullYear()) + "-" + pad$1(date.getUTCMonth() + 1, 2) + "-" + pad$1(date.getUTCDate(), 2) + (milliseconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "." + pad$1(milliseconds, 3) + "Z" : seconds ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + ":" + pad$1(seconds, 2) + "Z" : minutes || hours ? "T" + pad$1(hours, 2) + ":" + pad$1(minutes, 2) + "Z" : "");
    }
    function dsvFormat(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    }
    var csv$1 = dsvFormat(",");
    var csvParse = csv$1.parse;
    var csvParseRows = csv$1.parseRows;
    var csvFormat = csv$1.format;
    var csvFormatBody = csv$1.formatBody;
    var csvFormatRows = csv$1.formatRows;
    var csvFormatRow = csv$1.formatRow;
    var csvFormatValue = csv$1.formatValue;
    var tsv$1 = dsvFormat("\t");
    var tsvParse = tsv$1.parse;
    var tsvParseRows = tsv$1.parseRows;
    var tsvFormat = tsv$1.format;
    var tsvFormatBody = tsv$1.formatBody;
    var tsvFormatRows = tsv$1.formatRows;
    var tsvFormatRow = tsv$1.formatRow;
    var tsvFormatValue = tsv$1.formatValue;
    function autoType(object) {
        for(var key in object){
            var value = object[key].trim(), number, m;
            if (!value) value = null;
            else if (value === "true") value = true;
            else if (value === "false") value = false;
            else if (value === "NaN") value = NaN;
            else if (!isNaN(number = +value)) value = number;
            else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
                if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
                value = new Date(value);
            } else continue;
            object[key] = value;
        }
        return object;
    }
    // https://github.com/d3/d3-dsv/issues/45
    const fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
    function responseBlob(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.blob();
    }
    function blob(input, init) {
        return fetch(input, init).then(responseBlob);
    }
    function responseArrayBuffer(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.arrayBuffer();
    }
    function buffer(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    }
    function responseText(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        return response.text();
    }
    function text(input, init) {
        return fetch(input, init).then(responseText);
    }
    function dsvParse(parse) {
        return function(input, init, row) {
            if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
            return text(input, init).then(function(response) {
                return parse(response, row);
            });
        };
    }
    function dsv(delimiter, input, init, row) {
        if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
        var format = dsvFormat(delimiter);
        return text(input, init).then(function(response) {
            return format.parse(response, row);
        });
    }
    var csv = dsvParse(csvParse);
    var tsv = dsvParse(tsvParse);
    function image(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    }
    function responseJson(response) {
        if (!response.ok) throw new Error(response.status + " " + response.statusText);
        if (response.status === 204 || response.status === 205) return;
        return response.json();
    }
    function json(input, init) {
        return fetch(input, init).then(responseJson);
    }
    function parser(type) {
        return (input, init)=>text(input, init).then((text)=>(new DOMParser).parseFromString(text, type));
    }
    var xml = parser("application/xml");
    var html = parser("text/html");
    var svg = parser("image/svg+xml");
    function center(x, y) {
        var nodes, strength = 1;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        return force;
    }
    function tree_add(d) {
        const x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    }
    function add(tree, x, y, d) {
        if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
        var parent, node = tree._root, leaf = {
            data: d
        }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return tree._root = leaf, tree;
        // Find the existing leaf for the new point, or add it.
        while(node.length){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
        }
        // Is the new point is exactly coincident with the existing point?
        xp = +tree._x.call(null, node.data);
        yp = +tree._y.call(null, node.data);
        if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
        // Otherwise, split the leaf node until the old and new point are separated.
        do {
            parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
        }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
        return parent[j] = node, parent[i] = leaf, tree;
    }
    function addAll(data) {
        var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
        // Compute the points and their extent.
        for(i = 0; i < n; ++i){
            if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
            xz[i] = x;
            yz[i] = y;
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
        }
        // If there were no (valid) points, abort.
        if (x0 > x1 || y0 > y1) return this;
        // Expand the tree to cover the new points.
        this.cover(x0, y0).cover(x1, y1);
        // Add the new points.
        for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
        return this;
    }
    function tree_cover(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0 || 1, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    }
    function tree_data() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    }
    function tree_extent(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    }
    function Quad(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    }
    function tree_find(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new Quad(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new Quad(node[3], xm, ym, x2, y2), new Quad(node[2], x1, ym, xm, y2), new Quad(node[1], xm, y1, x2, ym), new Quad(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    }
    function tree_remove(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    }
    function removeAll(data) {
        for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
        return this;
    }
    function tree_root() {
        return this._root;
    }
    function tree_size() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    }
    function tree_visit(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
        }
        return this;
    }
    function tree_visitAfter(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    }
    function defaultX(d) {
        return d[0];
    }
    function tree_x(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    }
    function defaultY(d) {
        return d[1];
    }
    function tree_y(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    }
    function quadtree(nodes, x, y) {
        var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
        return nodes == null ? tree : tree.addAll(nodes);
    }
    function Quadtree(x, y, x0, y0, x1, y1) {
        this._x = x;
        this._y = y;
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        this._root = undefined;
    }
    function leaf_copy(leaf) {
        var copy = {
            data: leaf.data
        }, next = copy;
        while(leaf = leaf.next)next = next.next = {
            data: leaf.data
        };
        return copy;
    }
    var treeProto = quadtree.prototype = Quadtree.prototype;
    treeProto.copy = function() {
        var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
        if (!node) return copy;
        if (!node.length) return copy._root = leaf_copy(node), copy;
        nodes = [
            {
                source: node,
                target: copy._root = new Array(4)
            }
        ];
        while(node = nodes.pop()){
            for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
                if (child.length) nodes.push({
                    source: child,
                    target: node.target[i] = new Array(4)
                });
                else node.target[i] = leaf_copy(child);
            }
        }
        return copy;
    };
    treeProto.add = tree_add;
    treeProto.addAll = addAll;
    treeProto.cover = tree_cover;
    treeProto.data = tree_data;
    treeProto.extent = tree_extent;
    treeProto.find = tree_find;
    treeProto.remove = tree_remove;
    treeProto.removeAll = removeAll;
    treeProto.root = tree_root;
    treeProto.size = tree_size;
    treeProto.visit = tree_visit;
    treeProto.visitAfter = tree_visitAfter;
    treeProto.x = tree_x;
    treeProto.y = tree_y;
    function constant$4(x) {
        return function() {
            return x;
        };
    }
    function jiggle(random) {
        return (random() - 0.5) * 1e-6;
    }
    function x$3(d) {
        return d.x + d.vx;
    }
    function y$3(d) {
        return d.y + d.vy;
    }
    function collide(radius) {
        var nodes, radii, random, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = constant$4(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = quadtree(nodes, x$3, y$3).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = jiggle(random), l += x * x;
                            if (y === 0) y = jiggle(random), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
        };
        return force;
    }
    function index$3(d) {
        return d.index;
    }
    function find(nodeById, nodeId) {
        var node = nodeById.get(nodeId);
        if (!node) throw new Error("node not found: " + nodeId);
        return node;
    }
    function link$2(links) {
        var id = index$3, strength = defaultStrength, strengths, distance = constant$4(30), distances, nodes, count, bias, random, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || jiggle(random);
                y = target.y + target.vy - source.y - source.vy || jiggle(random);
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                    id(d, i, nodes),
                    d
                ])), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : constant$4(+_), initializeDistance(), force) : distance;
        };
        return force;
    }
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const a$2 = 1664525;
    const c$4 = 1013904223;
    const m$1 = 4294967296; // 2^32
    function lcg$2() {
        let s = 1;
        return ()=>(s = (a$2 * s + c$4) % m$1) / m$1;
    }
    function x$2(d) {
        return d.x;
    }
    function y$2(d) {
        return d.y;
    }
    var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));
    function simulation(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = timer(step), event = dispatch("tick", "end"), random = lcg$2();
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.forEach(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(0.5 + i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes, random);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            randomSource: function(_) {
                return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    }
    function manyBody() {
        var nodes, node, random, alpha, strength = constant$4(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = quadtree(nodes, x$2, y$2).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = jiggle(random), l += x * x;
                    if (y === 0) y = jiggle(random), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = jiggle(random), l += x * x;
                if (y === 0) y = jiggle(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_nodes, _random) {
            nodes = _nodes;
            random = _random;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    }
    function radial$1(radius, x, y) {
        var nodes, strength = constant$4(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = constant$4(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    }
    function x$1(x) {
        var strength = constant$4(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = constant$4(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : x;
        };
        return force;
    }
    function y$1(y) {
        var strength = constant$4(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = constant$4(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : constant$4(+_), initialize(), force) : y;
        };
        return force;
    }
    function formatDecimal(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    }
    // Computes the decimal coefficient and exponent of the specified number x with
    // significant digits p, where x is positive and p is in [1, 21] or undefined.
    // For example, formatDecimalParts(1.23) returns ["123", 0].
    function formatDecimalParts(x, p) {
        if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
        var i, coefficient = x.slice(0, i);
        // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
        // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
        return [
            coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
            +x.slice(i + 1)
        ];
    }
    function exponent(x) {
        return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
    }
    function formatGroup(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    }
    function formatNumerals(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    }
    // [[fill]align][sign][symbol][0][width][,][.precision][~][type]
    var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
    function formatSpecifier(specifier) {
        if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
        var match;
        return new FormatSpecifier({
            fill: match[1],
            align: match[2],
            sign: match[3],
            symbol: match[4],
            zero: match[5],
            width: match[6],
            comma: match[7],
            precision: match[8] && match[8].slice(1),
            trim: match[9],
            type: match[10]
        });
    }
    formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
    function FormatSpecifier(specifier) {
        this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
        this.align = specifier.align === undefined ? ">" : specifier.align + "";
        this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
        this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
        this.zero = !!specifier.zero;
        this.width = specifier.width === undefined ? undefined : +specifier.width;
        this.comma = !!specifier.comma;
        this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
        this.trim = !!specifier.trim;
        this.type = specifier.type === undefined ? "" : specifier.type + "";
    }
    FormatSpecifier.prototype.toString = function() {
        return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
    };
    // Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
    function formatTrim(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    }
    var prefixExponent;
    function formatPrefixAuto(x, p) {
        var d = formatDecimalParts(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    }
    function formatRounded(x, p) {
        var d = formatDecimalParts(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    }
    var formatTypes = {
        "%": (x, p)=>(x * 100).toFixed(p),
        "b": (x)=>Math.round(x).toString(2),
        "c": (x)=>x + "",
        "d": formatDecimal,
        "e": (x, p)=>x.toExponential(p),
        "f": (x, p)=>x.toFixed(p),
        "g": (x, p)=>x.toPrecision(p),
        "o": (x)=>Math.round(x).toString(8),
        "p": (x, p)=>formatRounded(x * 100, p),
        "r": formatRounded,
        "s": formatPrefixAuto,
        "X": (x)=>Math.round(x).toString(16).toUpperCase(),
        "x": (x)=>Math.round(x).toString(16)
    };
    function identity$6(x) {
        return x;
    }
    var map = Array.prototype.map, prefixes = [
        "y",
        "z",
        "a",
        "f",
        "p",
        "n",
        "\xb5",
        "m",
        "",
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ];
    function formatLocale$1(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? identity$6 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? identity$6 : formatNumerals(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = formatSpecifier(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = formatTypes[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = formatTrim(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    }
    var locale$1;
    exports1.format = void 0;
    exports1.formatPrefix = void 0;
    defaultLocale$1({
        thousands: ",",
        grouping: [
            3
        ],
        currency: [
            "$",
            ""
        ]
    });
    function defaultLocale$1(definition) {
        locale$1 = formatLocale$1(definition);
        exports1.format = locale$1.format;
        exports1.formatPrefix = locale$1.formatPrefix;
        return locale$1;
    }
    function precisionFixed(step) {
        return Math.max(0, -exponent(Math.abs(step)));
    }
    function precisionPrefix(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
    }
    function precisionRound(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, exponent(max) - exponent(step)) + 1;
    }
    var epsilon$1 = 1e-6;
    var epsilon2 = 1e-12;
    var pi$1 = Math.PI;
    var halfPi$1 = pi$1 / 2;
    var quarterPi = pi$1 / 4;
    var tau$1 = pi$1 * 2;
    var degrees = 180 / pi$1;
    var radians = pi$1 / 180;
    var abs$1 = Math.abs;
    var atan = Math.atan;
    var atan2$1 = Math.atan2;
    var cos$1 = Math.cos;
    var ceil = Math.ceil;
    var exp = Math.exp;
    var hypot = Math.hypot;
    var log$1 = Math.log;
    var pow$1 = Math.pow;
    var sin$1 = Math.sin;
    var sign$1 = Math.sign || function(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
    };
    var sqrt$2 = Math.sqrt;
    var tan = Math.tan;
    function acos$1(x) {
        return x > 1 ? 0 : x < -1 ? pi$1 : Math.acos(x);
    }
    function asin$1(x) {
        return x > 1 ? halfPi$1 : x < -1 ? -halfPi$1 : Math.asin(x);
    }
    function haversin(x) {
        return (x = sin$1(x / 2)) * x;
    }
    function noop$1() {}
    function streamGeometry(geometry, stream) {
        if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
    }
    var streamObjectType = {
        Feature: function(object, stream) {
            streamGeometry(object.geometry, stream);
        },
        FeatureCollection: function(object, stream) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)streamGeometry(features[i].geometry, stream);
        }
    };
    var streamGeometryType = {
        Sphere: function(object, stream) {
            stream.sphere();
        },
        Point: function(object, stream) {
            object = object.coordinates;
            stream.point(object[0], object[1], object[2]);
        },
        MultiPoint: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
        },
        LineString: function(object, stream) {
            streamLine(object.coordinates, stream, 0);
        },
        MultiLineString: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)streamLine(coordinates[i], stream, 0);
        },
        Polygon: function(object, stream) {
            streamPolygon(object.coordinates, stream);
        },
        MultiPolygon: function(object, stream) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)streamPolygon(coordinates[i], stream);
        },
        GeometryCollection: function(object, stream) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)streamGeometry(geometries[i], stream);
        }
    };
    function streamLine(coordinates, stream, closed) {
        var i = -1, n = coordinates.length - closed, coordinate;
        stream.lineStart();
        while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
        stream.lineEnd();
    }
    function streamPolygon(coordinates, stream) {
        var i = -1, n = coordinates.length;
        stream.polygonStart();
        while(++i < n)streamLine(coordinates[i], stream, 1);
        stream.polygonEnd();
    }
    function geoStream(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    }
    var areaRingSum$1 = new Adder();
    // hello?
    var areaSum$1 = new Adder(), lambda00$2, phi00$2, lambda0$2, cosPhi0$1, sinPhi0$1;
    var areaStream$1 = {
        point: noop$1,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: function() {
            areaRingSum$1 = new Adder();
            areaStream$1.lineStart = areaRingStart$1;
            areaStream$1.lineEnd = areaRingEnd$1;
        },
        polygonEnd: function() {
            var areaRing = +areaRingSum$1;
            areaSum$1.add(areaRing < 0 ? tau$1 + areaRing : areaRing);
            this.lineStart = this.lineEnd = this.point = noop$1;
        },
        sphere: function() {
            areaSum$1.add(tau$1);
        }
    };
    function areaRingStart$1() {
        areaStream$1.point = areaPointFirst$1;
    }
    function areaRingEnd$1() {
        areaPoint$1(lambda00$2, phi00$2);
    }
    function areaPointFirst$1(lambda, phi) {
        areaStream$1.point = areaPoint$1;
        lambda00$2 = lambda, phi00$2 = phi;
        lambda *= radians, phi *= radians;
        lambda0$2 = lambda, cosPhi0$1 = cos$1(phi = phi / 2 + quarterPi), sinPhi0$1 = sin$1(phi);
    }
    function areaPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        phi = phi / 2 + quarterPi; // half the angular distance from south pole
        // Spherical excess E for a spherical triangle with vertices: south pole,
        // previous point, current point.  Uses a formula derived from Cagnoli’s
        // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
        var dLambda = lambda - lambda0$2, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = cos$1(phi), sinPhi = sin$1(phi), k = sinPhi0$1 * sinPhi, u = cosPhi0$1 * cosPhi + k * cos$1(adLambda), v = k * sdLambda * sin$1(adLambda);
        areaRingSum$1.add(atan2$1(v, u));
        // Advance the previous points.
        lambda0$2 = lambda, cosPhi0$1 = cosPhi, sinPhi0$1 = sinPhi;
    }
    function area$2(object) {
        areaSum$1 = new Adder();
        geoStream(object, areaStream$1);
        return areaSum$1 * 2;
    }
    function spherical(cartesian) {
        return [
            atan2$1(cartesian[1], cartesian[0]),
            asin$1(cartesian[2])
        ];
    }
    function cartesian(spherical) {
        var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
        return [
            cosPhi * cos$1(lambda),
            cosPhi * sin$1(lambda),
            sin$1(phi)
        ];
    }
    function cartesianDot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }
    function cartesianCross(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    // TODO return a
    function cartesianAddInPlace(a, b) {
        a[0] += b[0], a[1] += b[1], a[2] += b[2];
    }
    function cartesianScale(vector, k) {
        return [
            vector[0] * k,
            vector[1] * k,
            vector[2] * k
        ];
    }
    // TODO return d
    function cartesianNormalizeInPlace(d) {
        var l = sqrt$2(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l, d[1] /= l, d[2] /= l;
    }
    var lambda0$1, phi0, lambda1, phi1, lambda2, lambda00$1, phi00$1, p0, deltaSum, ranges, range;
    var boundsStream$2 = {
        point: boundsPoint$1,
        lineStart: boundsLineStart,
        lineEnd: boundsLineEnd,
        polygonStart: function() {
            boundsStream$2.point = boundsRingPoint;
            boundsStream$2.lineStart = boundsRingStart;
            boundsStream$2.lineEnd = boundsRingEnd;
            deltaSum = new Adder();
            areaStream$1.polygonStart();
        },
        polygonEnd: function() {
            areaStream$1.polygonEnd();
            boundsStream$2.point = boundsPoint$1;
            boundsStream$2.lineStart = boundsLineStart;
            boundsStream$2.lineEnd = boundsLineEnd;
            if (areaRingSum$1 < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
            else if (deltaSum > epsilon$1) phi1 = 90;
            else if (deltaSum < -epsilon$1) phi0 = -90;
            range[0] = lambda0$1, range[1] = lambda1;
        },
        sphere: function() {
            lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        }
    };
    function boundsPoint$1(lambda, phi) {
        ranges.push(range = [
            lambda0$1 = lambda,
            lambda1 = lambda
        ]);
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
    }
    function linePoint(lambda, phi) {
        var p = cartesian([
            lambda * radians,
            phi * radians
        ]);
        if (p0) {
            var normal = cartesianCross(p0, p), equatorial = [
                normal[1],
                -normal[0],
                0
            ], inflection = cartesianCross(equatorial, normal);
            cartesianNormalizeInPlace(inflection);
            inflection = spherical(inflection);
            var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * degrees * sign, phii, antimeridian = abs$1(delta) > 180;
            if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                phii = inflection[1] * degrees;
                if (phii > phi1) phi1 = phii;
            } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
                phii = -inflection[1] * degrees;
                if (phii < phi0) phi0 = phii;
            } else {
                if (phi < phi0) phi0 = phi;
                if (phi > phi1) phi1 = phi;
            }
            if (antimeridian) {
                if (lambda < lambda2) {
                    if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
            } else if (lambda1 >= lambda0$1) {
                if (lambda < lambda0$1) lambda0$1 = lambda;
                if (lambda > lambda1) lambda1 = lambda;
            } else {
                if (lambda > lambda2) {
                    if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
                } else if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
            }
        } else ranges.push(range = [
            lambda0$1 = lambda,
            lambda1 = lambda
        ]);
        if (phi < phi0) phi0 = phi;
        if (phi > phi1) phi1 = phi;
        p0 = p, lambda2 = lambda;
    }
    function boundsLineStart() {
        boundsStream$2.point = linePoint;
    }
    function boundsLineEnd() {
        range[0] = lambda0$1, range[1] = lambda1;
        boundsStream$2.point = boundsPoint$1;
        p0 = null;
    }
    function boundsRingPoint(lambda, phi) {
        if (p0) {
            var delta = lambda - lambda2;
            deltaSum.add(abs$1(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
        } else lambda00$1 = lambda, phi00$1 = phi;
        areaStream$1.point(lambda, phi);
        linePoint(lambda, phi);
    }
    function boundsRingStart() {
        areaStream$1.lineStart();
    }
    function boundsRingEnd() {
        boundsRingPoint(lambda00$1, phi00$1);
        areaStream$1.lineEnd();
        if (abs$1(deltaSum) > epsilon$1) lambda0$1 = -(lambda1 = 180);
        range[0] = lambda0$1, range[1] = lambda1;
        p0 = null;
    }
    // Finds the left-right distance between two longitudes.
    // This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
    // the distance between ±180° to be 360°.
    function angle(lambda0, lambda1) {
        return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
    }
    function rangeCompare(a, b) {
        return a[0] - b[0];
    }
    function rangeContains(range, x) {
        return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    function bounds(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
        ranges = [];
        geoStream(feature, boundsStream$2);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0$1 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0$1,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    }
    var W0, W1, X0$1, Y0$1, Z0$1, X1$1, Y1$1, Z1$1, X2$1, Y2$1, Z2$1, lambda00, phi00, x0$4, y0$4, z0; // previous point
    var centroidStream$1 = {
        sphere: noop$1,
        point: centroidPoint$1,
        lineStart: centroidLineStart$1,
        lineEnd: centroidLineEnd$1,
        polygonStart: function() {
            centroidStream$1.lineStart = centroidRingStart$1;
            centroidStream$1.lineEnd = centroidRingEnd$1;
        },
        polygonEnd: function() {
            centroidStream$1.lineStart = centroidLineStart$1;
            centroidStream$1.lineEnd = centroidLineEnd$1;
        }
    };
    // Arithmetic mean of Cartesian vectors.
    function centroidPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi);
        centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
    }
    function centroidPointCartesian(x, y, z) {
        ++W0;
        X0$1 += (x - X0$1) / W0;
        Y0$1 += (y - Y0$1) / W0;
        Z0$1 += (z - Z0$1) / W0;
    }
    function centroidLineStart$1() {
        centroidStream$1.point = centroidLinePointFirst;
    }
    function centroidLinePointFirst(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi);
        x0$4 = cosPhi * cos$1(lambda);
        y0$4 = cosPhi * sin$1(lambda);
        z0 = sin$1(phi);
        centroidStream$1.point = centroidLinePoint;
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidLinePoint(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), w = atan2$1(sqrt$2((w = y0$4 * z - z0 * y) * w + (w = z0 * x - x0$4 * z) * w + (w = x0$4 * y - y0$4 * x) * w), x0$4 * x + y0$4 * y + z0 * z);
        W1 += w;
        X1$1 += w * (x0$4 + (x0$4 = x));
        Y1$1 += w * (y0$4 + (y0$4 = y));
        Z1$1 += w * (z0 + (z0 = z));
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidLineEnd$1() {
        centroidStream$1.point = centroidPoint$1;
    }
    // See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
    // J. Applied Mechanics 42, 239 (1975).
    function centroidRingStart$1() {
        centroidStream$1.point = centroidRingPointFirst;
    }
    function centroidRingEnd$1() {
        centroidRingPoint(lambda00, phi00);
        centroidStream$1.point = centroidPoint$1;
    }
    function centroidRingPointFirst(lambda, phi) {
        lambda00 = lambda, phi00 = phi;
        lambda *= radians, phi *= radians;
        centroidStream$1.point = centroidRingPoint;
        var cosPhi = cos$1(phi);
        x0$4 = cosPhi * cos$1(lambda);
        y0$4 = cosPhi * sin$1(lambda);
        z0 = sin$1(phi);
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroidRingPoint(lambda, phi) {
        lambda *= radians, phi *= radians;
        var cosPhi = cos$1(phi), x = cosPhi * cos$1(lambda), y = cosPhi * sin$1(lambda), z = sin$1(phi), cx = y0$4 * z - z0 * y, cy = z0 * x - x0$4 * z, cz = x0$4 * y - y0$4 * x, m = hypot(cx, cy, cz), w = asin$1(m), v = m && -w / m; // area weight multiplier
        X2$1.add(v * cx);
        Y2$1.add(v * cy);
        Z2$1.add(v * cz);
        W1 += w;
        X1$1 += w * (x0$4 + (x0$4 = x));
        Y1$1 += w * (y0$4 + (y0$4 = y));
        Z1$1 += w * (z0 + (z0 = z));
        centroidPointCartesian(x0$4, y0$4, z0);
    }
    function centroid$1(object) {
        W0 = W1 = X0$1 = Y0$1 = Z0$1 = X1$1 = Y1$1 = Z1$1 = 0;
        X2$1 = new Adder();
        Y2$1 = new Adder();
        Z2$1 = new Adder();
        geoStream(object, centroidStream$1);
        var x = +X2$1, y = +Y2$1, z = +Z2$1, m = hypot(x, y, z);
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < epsilon2) {
            x = X1$1, y = Y1$1, z = Z1$1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < epsilon$1) x = X0$1, y = Y0$1, z = Z0$1;
            m = hypot(x, y, z);
            // If the feature still has an undefined ccentroid, then return.
            if (m < epsilon2) return [
                NaN,
                NaN
            ];
        }
        return [
            atan2$1(y, x) * degrees,
            asin$1(z / m) * degrees
        ];
    }
    function constant$3(x) {
        return function() {
            return x;
        };
    }
    function compose(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    }
    function rotationIdentity(lambda, phi) {
        if (abs$1(lambda) > pi$1) lambda -= Math.round(lambda / tau$1) * tau$1;
        return [
            lambda,
            phi
        ];
    }
    rotationIdentity.invert = rotationIdentity;
    function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
        return (deltaLambda %= tau$1) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
    }
    function forwardRotationLambda(deltaLambda) {
        return function(lambda, phi) {
            lambda += deltaLambda;
            if (abs$1(lambda) > pi$1) lambda -= Math.round(lambda / tau$1) * tau$1;
            return [
                lambda,
                phi
            ];
        };
    }
    function rotationLambda(deltaLambda) {
        var rotation = forwardRotationLambda(deltaLambda);
        rotation.invert = forwardRotationLambda(-deltaLambda);
        return rotation;
    }
    function rotationPhiGamma(deltaPhi, deltaGamma) {
        var cosDeltaPhi = cos$1(deltaPhi), sinDeltaPhi = sin$1(deltaPhi), cosDeltaGamma = cos$1(deltaGamma), sinDeltaGamma = sin$1(deltaGamma);
        function rotation(lambda, phi) {
            var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
            return [
                atan2$1(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
                asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
            ];
        }
        rotation.invert = function(lambda, phi) {
            var cosPhi = cos$1(phi), x = cos$1(lambda) * cosPhi, y = sin$1(lambda) * cosPhi, z = sin$1(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
            return [
                atan2$1(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
                asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
            ];
        };
        return rotation;
    }
    function rotation(rotate) {
        rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
            return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
            return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
        };
        return forward;
    }
    // Generates a circle centered at [0°, 0°], with a given radius and precision.
    function circleStream(stream, radius, delta, direction, t0, t1) {
        if (!delta) return;
        var cosRadius = cos$1(radius), sinRadius = sin$1(radius), step = direction * delta;
        if (t0 == null) {
            t0 = radius + direction * tau$1;
            t1 = radius - step / 2;
        } else {
            t0 = circleRadius(cosRadius, t0);
            t1 = circleRadius(cosRadius, t1);
            if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$1;
        }
        for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
            point = spherical([
                cosRadius,
                -sinRadius * cos$1(t),
                -sinRadius * sin$1(t)
            ]);
            stream.point(point[0], point[1]);
        }
    }
    // Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
    function circleRadius(cosRadius, point) {
        point = cartesian(point), point[0] -= cosRadius;
        cartesianNormalizeInPlace(point);
        var radius = acos$1(-point[1]);
        return ((-point[2] < 0 ? -radius : radius) + tau$1 - epsilon$1) % tau$1;
    }
    function circle$1() {
        var center = constant$3([
            0,
            0
        ]), radius = constant$3(90), precision = constant$3(6), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= degrees, x[1] *= degrees;
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * radians, p = precision.apply(this, arguments) * radians;
            ring = [];
            rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : constant$3([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : constant$3(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : constant$3(+_), circle) : precision;
        };
        return circle;
    }
    function clipBuffer() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: noop$1,
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    }
    function pointEqual(a, b) {
        return abs$1(a[0] - b[0]) < epsilon$1 && abs$1(a[1] - b[1]) < epsilon$1;
    }
    function Intersection(point, points, other, entry) {
        this.x = point;
        this.z = points;
        this.o = other; // another intersection
        this.e = entry; // is an entry?
        this.v = false; // visited
        this.n = this.p = null; // next & previous
    }
    // A generalized polygon clipping algorithm: given a polygon that has been cut
    // into its visible line segments, and rejoins the segments by interpolating
    // along the clip edge.
    function clipRejoin(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if (pointEqual(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * epsilon$1;
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link$1(subject);
        link$1(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    }
    function link$1(array) {
        if (!(n = array.length)) return;
        var n, i = 0, a = array[0], b;
        while(++i < n){
            a.n = b = array[i];
            b.p = a;
            a = b;
        }
        a.n = b = array[0];
        b.p = a;
    }
    function longitude(point) {
        return abs$1(point[0]) <= pi$1 ? point[0] : sign$1(point[0]) * ((abs$1(point[0]) + pi$1) % tau$1 - pi$1);
    }
    function polygonContains(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = sin$1(phi), normal = [
            sin$1(lambda),
            -cos$1(lambda),
            0
        ], angle = 0, winding = 0;
        var sum = new Adder();
        if (sinPhi === 1) phi = halfPi$1 + epsilon$1;
        else if (sinPhi === -1) phi = -halfPi$1 - epsilon$1;
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + quarterPi, sinPhi0 = sin$1(phi0), cosPhi0 = cos$1(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + quarterPi, sinPhi1 = sin$1(phi1), cosPhi1 = cos$1(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > pi$1, k = sinPhi0 * sinPhi1;
                sum.add(atan2$1(k * sign * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
                angle += antimeridian ? delta + sign * tau$1 : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = cartesianCross(cartesian(point0), cartesian(point1));
                    cartesianNormalizeInPlace(arc);
                    var intersection = cartesianCross(normal, arc);
                    cartesianNormalizeInPlace(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -epsilon$1 || angle < epsilon$1 && sum < -epsilon2) ^ winding & 1;
    }
    function clip(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = clipBuffer(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = merge(segments);
                    var startInside = polygonContains(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    }
    function validSegment(segment) {
        return segment.length > 1;
    }
    // Intersections are sorted along the clip edge. For both antimeridian cutting
    // and circle clipping, the same comparison is used.
    function compareIntersection(a, b) {
        return ((a = a.x)[0] < 0 ? a[1] - halfPi$1 - epsilon$1 : halfPi$1 - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfPi$1 - epsilon$1 : halfPi$1 - b[1]);
    }
    var clipAntimeridian = clip(function() {
        return true;
    }, clipAntimeridianLine, clipAntimeridianInterpolate, [
        -pi$1,
        -halfPi$1
    ]);
    // Takes a line and cuts into visible segments. Return values: 0 - there were
    // intersections or the line was empty; 1 - no intersections; 2 - there were
    // intersections, and the first and last segments should be rejoined.
    function clipAntimeridianLine(stream) {
        var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
        return {
            lineStart: function() {
                stream.lineStart();
                clean = 1;
            },
            point: function(lambda1, phi1) {
                var sign1 = lambda1 > 0 ? pi$1 : -pi$1, delta = abs$1(lambda1 - lambda0);
                if (abs$1(delta - pi$1) < epsilon$1) {
                    stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$1 : -halfPi$1);
                    stream.point(sign0, phi0);
                    stream.lineEnd();
                    stream.lineStart();
                    stream.point(sign1, phi0);
                    stream.point(lambda1, phi0);
                    clean = 0;
                } else if (sign0 !== sign1 && delta >= pi$1) {
                    if (abs$1(lambda0 - sign0) < epsilon$1) lambda0 -= sign0 * epsilon$1; // handle degeneracies
                    if (abs$1(lambda1 - sign1) < epsilon$1) lambda1 -= sign1 * epsilon$1;
                    phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                    stream.point(sign0, phi0);
                    stream.lineEnd();
                    stream.lineStart();
                    stream.point(sign1, phi0);
                    clean = 0;
                }
                stream.point(lambda0 = lambda1, phi0 = phi1);
                sign0 = sign1;
            },
            lineEnd: function() {
                stream.lineEnd();
                lambda0 = phi0 = NaN;
            },
            clean: function() {
                return 2 - clean; // if intersections, rejoin first and last segments
            }
        };
    }
    function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
        var cosPhi0, cosPhi1, sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
        return abs$1(sinLambda0Lambda1) > epsilon$1 ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1) - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
    }
    function clipAntimeridianInterpolate(from, to, direction, stream) {
        var phi;
        if (from == null) {
            phi = direction * halfPi$1;
            stream.point(-pi$1, phi);
            stream.point(0, phi);
            stream.point(pi$1, phi);
            stream.point(pi$1, 0);
            stream.point(pi$1, -phi);
            stream.point(0, -phi);
            stream.point(-pi$1, -phi);
            stream.point(-pi$1, 0);
            stream.point(-pi$1, phi);
        } else if (abs$1(from[0] - to[0]) > epsilon$1) {
            var lambda = from[0] < to[0] ? pi$1 : -pi$1;
            phi = direction * lambda / 2;
            stream.point(-lambda, phi);
            stream.point(0, phi);
            stream.point(lambda, phi);
        } else stream.point(to[0], to[1]);
    }
    function clipCircle(radius) {
        var cr = cos$1(radius), delta = 6 * radians, smallRadius = cr > 0, notHemisphere = abs$1(cr) > epsilon$1; // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            circleStream(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return cos$1(lambda) * cos$1(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? pi$1 : -pi$1), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !pointEqual(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = cartesian(a), pb = cartesian(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = cartesianCross(n1, n2), A = cartesianScale(n1, c1), B = cartesianScale(n2, c2);
            cartesianAddInPlace(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = cartesianDot(A, u), uu = cartesianDot(u, u), t2 = w * w - uu * (cartesianDot(A, A) - 1);
            if (t2 < 0) return;
            var t = sqrt$2(t2), q = cartesianScale(u, (-w - t) / uu);
            cartesianAddInPlace(q, A);
            q = spherical(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = abs$1(delta - pi$1) < epsilon$1, meridian = polar || delta < epsilon$1;
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < (abs$1(q[0] - lambda0) < epsilon$1 ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > pi$1 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = cartesianScale(u, (-w + t) / uu);
                cartesianAddInPlace(q1, A);
                return [
                    q,
                    spherical(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : pi$1 - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return clip(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -pi$1,
            radius - pi$1
        ]);
    }
    function clipLine(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    }
    var clipMax = 1e9, clipMin = -clipMax;
    // TODO Use d3-polygon’s polygonContains here for the ring check?
    // TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
    function clipRectangle(x0, y0, x1, y1) {
        function visible(x, y) {
            return x0 <= x && x <= x1 && y0 <= y && y <= y1;
        }
        function interpolate(from, to, direction, stream) {
            var a = 0, a1 = 0;
            if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
            while ((a = (a + direction + 4) % 4) !== a1);
            else stream.point(to[0], to[1]);
        }
        function corner(p, direction) {
            return abs$1(p[0] - x0) < epsilon$1 ? direction > 0 ? 0 : 3 : abs$1(p[0] - x1) < epsilon$1 ? direction > 0 ? 2 : 1 : abs$1(p[1] - y0) < epsilon$1 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
        }
        function compareIntersection(a, b) {
            return comparePoint(a.x, b.x);
        }
        function comparePoint(a, b) {
            var ca = corner(a, 1), cb = corner(b, 1);
            return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
        }
        return function(stream) {
            var activeStream = stream, bufferStream = clipBuffer(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
            var clipStream = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: polygonStart,
                polygonEnd: polygonEnd
            };
            function point(x, y) {
                if (visible(x, y)) activeStream.point(x, y);
            }
            function polygonInside() {
                var winding = 0;
                for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                    a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                    if (a1 <= y1) {
                        if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                    } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
                }
                return winding;
            }
            // Buffer geometry within a polygon and then clip it en masse.
            function polygonStart() {
                activeStream = bufferStream, segments = [], polygon = [], clean = true;
            }
            function polygonEnd() {
                var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = merge(segments)).length;
                if (cleanInside || visible) {
                    stream.polygonStart();
                    if (cleanInside) {
                        stream.lineStart();
                        interpolate(null, null, 1, stream);
                        stream.lineEnd();
                    }
                    if (visible) clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
                    stream.polygonEnd();
                }
                activeStream = stream, segments = polygon = ring = null;
            }
            function lineStart() {
                clipStream.point = linePoint;
                if (polygon) polygon.push(ring = []);
                first = true;
                v_ = false;
                x_ = y_ = NaN;
            }
            // TODO rather than special-case polygons, simply handle them separately.
            // Ideally, coincident intersection points should be jittered to avoid
            // clipping issues.
            function lineEnd() {
                if (segments) {
                    linePoint(x__, y__);
                    if (v__ && v_) bufferStream.rejoin();
                    segments.push(bufferStream.result());
                }
                clipStream.point = point;
                if (v_) activeStream.lineEnd();
            }
            function linePoint(x, y) {
                var v = visible(x, y);
                if (polygon) ring.push([
                    x,
                    y
                ]);
                if (first) {
                    x__ = x, y__ = y, v__ = v;
                    first = false;
                    if (v) {
                        activeStream.lineStart();
                        activeStream.point(x, y);
                    }
                } else if (v && v_) activeStream.point(x, y);
                else {
                    var a = [
                        x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                        y_ = Math.max(clipMin, Math.min(clipMax, y_))
                    ], b = [
                        x = Math.max(clipMin, Math.min(clipMax, x)),
                        y = Math.max(clipMin, Math.min(clipMax, y))
                    ];
                    if (clipLine(a, b, x0, y0, x1, y1)) {
                        if (!v_) {
                            activeStream.lineStart();
                            activeStream.point(a[0], a[1]);
                        }
                        activeStream.point(b[0], b[1]);
                        if (!v) activeStream.lineEnd();
                        clean = false;
                    } else if (v) {
                        activeStream.lineStart();
                        activeStream.point(x, y);
                        clean = false;
                    }
                }
                x_ = x, y_ = y, v_ = v;
            }
            return clipStream;
        };
    }
    function extent() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    }
    var lengthSum$1, lambda0, sinPhi0, cosPhi0;
    var lengthStream$1 = {
        sphere: noop$1,
        point: noop$1,
        lineStart: lengthLineStart,
        lineEnd: noop$1,
        polygonStart: noop$1,
        polygonEnd: noop$1
    };
    function lengthLineStart() {
        lengthStream$1.point = lengthPointFirst$1;
        lengthStream$1.lineEnd = lengthLineEnd;
    }
    function lengthLineEnd() {
        lengthStream$1.point = lengthStream$1.lineEnd = noop$1;
    }
    function lengthPointFirst$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        lambda0 = lambda, sinPhi0 = sin$1(phi), cosPhi0 = cos$1(phi);
        lengthStream$1.point = lengthPoint$1;
    }
    function lengthPoint$1(lambda, phi) {
        lambda *= radians, phi *= radians;
        var sinPhi = sin$1(phi), cosPhi = cos$1(phi), delta = abs$1(lambda - lambda0), cosDelta = cos$1(delta), sinDelta = sin$1(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
        lengthSum$1.add(atan2$1(sqrt$2(x * x + y * y), z));
        lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
    }
    function length$1(object) {
        lengthSum$1 = new Adder();
        geoStream(object, lengthStream$1);
        return +lengthSum$1;
    }
    var coordinates = [
        null,
        null
    ], object = {
        type: "LineString",
        coordinates: coordinates
    };
    function distance(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return length$1(object);
    }
    var containsObjectType = {
        Feature: function(object, point) {
            return containsGeometry(object.geometry, point);
        },
        FeatureCollection: function(object, point) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
            return false;
        }
    };
    var containsGeometryType = {
        Sphere: function() {
            return true;
        },
        Point: function(object, point) {
            return containsPoint(object.coordinates, point);
        },
        MultiPoint: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsPoint(coordinates[i], point)) return true;
            return false;
        },
        LineString: function(object, point) {
            return containsLine(object.coordinates, point);
        },
        MultiLineString: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsLine(coordinates[i], point)) return true;
            return false;
        },
        Polygon: function(object, point) {
            return containsPolygon(object.coordinates, point);
        },
        MultiPolygon: function(object, point) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
            return false;
        },
        GeometryCollection: function(object, point) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)if (containsGeometry(geometries[i], point)) return true;
            return false;
        }
    };
    function containsGeometry(geometry, point) {
        return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
    }
    function containsPoint(coordinates, point) {
        return distance(coordinates, point) === 0;
    }
    function containsLine(coordinates, point) {
        var ao, bo, ab;
        for(var i = 0, n = coordinates.length; i < n; i++){
            bo = distance(coordinates[i], point);
            if (bo === 0) return true;
            if (i > 0) {
                ab = distance(coordinates[i], coordinates[i - 1]);
                if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < epsilon2 * ab) return true;
            }
            ao = bo;
        }
        return false;
    }
    function containsPolygon(coordinates, point) {
        return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
    }
    function ringRadians(ring) {
        return ring = ring.map(pointRadians), ring.pop(), ring;
    }
    function pointRadians(point) {
        return [
            point[0] * radians,
            point[1] * radians
        ];
    }
    function contains$1(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    }
    function graticuleX(y0, y1, dy) {
        var y = range$2(y0, y1 - epsilon$1, dy).concat(y1);
        return function(x) {
            return y.map(function(y) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function graticuleY(x0, x1, dx) {
        var x = range$2(x0, x1 - epsilon$1, dx).concat(x1);
        return function(y) {
            return x.map(function(x) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function graticule() {
        var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
        function graticule() {
            return {
                type: "MultiLineString",
                coordinates: lines()
            };
        }
        function lines() {
            return range$2(ceil(X0 / DX) * DX, X1, DX).map(X).concat(range$2(ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(range$2(ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
                return abs$1(x % DX) > epsilon$1;
            }).map(x)).concat(range$2(ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
                return abs$1(y % DY) > epsilon$1;
            }).map(y));
        }
        graticule.lines = function() {
            return lines().map(function(coordinates) {
                return {
                    type: "LineString",
                    coordinates: coordinates
                };
            });
        };
        graticule.outline = function() {
            return {
                type: "Polygon",
                coordinates: [
                    X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
                ]
            };
        };
        graticule.extent = function(_) {
            if (!arguments.length) return graticule.extentMinor();
            return graticule.extentMajor(_).extentMinor(_);
        };
        graticule.extentMajor = function(_) {
            if (!arguments.length) return [
                [
                    X0,
                    Y0
                ],
                [
                    X1,
                    Y1
                ]
            ];
            X0 = +_[0][0], X1 = +_[1][0];
            Y0 = +_[0][1], Y1 = +_[1][1];
            if (X0 > X1) _ = X0, X0 = X1, X1 = _;
            if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
            return graticule.precision(precision);
        };
        graticule.extentMinor = function(_) {
            if (!arguments.length) return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
            x0 = +_[0][0], x1 = +_[1][0];
            y0 = +_[0][1], y1 = +_[1][1];
            if (x0 > x1) _ = x0, x0 = x1, x1 = _;
            if (y0 > y1) _ = y0, y0 = y1, y1 = _;
            return graticule.precision(precision);
        };
        graticule.step = function(_) {
            if (!arguments.length) return graticule.stepMinor();
            return graticule.stepMajor(_).stepMinor(_);
        };
        graticule.stepMajor = function(_) {
            if (!arguments.length) return [
                DX,
                DY
            ];
            DX = +_[0], DY = +_[1];
            return graticule;
        };
        graticule.stepMinor = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            dx = +_[0], dy = +_[1];
            return graticule;
        };
        graticule.precision = function(_) {
            if (!arguments.length) return precision;
            precision = +_;
            x = graticuleX(y0, y1, 90);
            y = graticuleY(x0, x1, precision);
            X = graticuleX(Y0, Y1, 90);
            Y = graticuleY(X0, X1, precision);
            return graticule;
        };
        return graticule.extentMajor([
            [
                -180,
                -90 + epsilon$1
            ],
            [
                180,
                90 - epsilon$1
            ]
        ]).extentMinor([
            [
                -180,
                -80 - epsilon$1
            ],
            [
                180,
                80 + epsilon$1
            ]
        ]);
    }
    function graticule10() {
        return graticule()();
    }
    function interpolate(a, b) {
        var x0 = a[0] * radians, y0 = a[1] * radians, x1 = b[0] * radians, y1 = b[1] * radians, cy0 = cos$1(y0), sy0 = sin$1(y0), cy1 = cos$1(y1), sy1 = sin$1(y1), kx0 = cy0 * cos$1(x0), ky0 = cy0 * sin$1(x0), kx1 = cy1 * cos$1(x1), ky1 = cy1 * sin$1(x1), d = 2 * asin$1(sqrt$2(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))), k = sin$1(d);
        var interpolate = d ? function(t) {
            var B = sin$1(t *= d) / k, A = sin$1(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                atan2$1(y, x) * degrees,
                atan2$1(z, sqrt$2(x * x + y * y)) * degrees
            ];
        } : function() {
            return [
                x0 * degrees,
                y0 * degrees
            ];
        };
        interpolate.distance = d;
        return interpolate;
    }
    var identity$5 = (x)=>x;
    var areaSum = new Adder(), areaRingSum = new Adder(), x00$2, y00$2, x0$3, y0$3;
    var areaStream = {
        point: noop$1,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: function() {
            areaStream.lineStart = areaRingStart;
            areaStream.lineEnd = areaRingEnd;
        },
        polygonEnd: function() {
            areaStream.lineStart = areaStream.lineEnd = areaStream.point = noop$1;
            areaSum.add(abs$1(areaRingSum));
            areaRingSum = new Adder();
        },
        result: function() {
            var area = areaSum / 2;
            areaSum = new Adder();
            return area;
        }
    };
    function areaRingStart() {
        areaStream.point = areaPointFirst;
    }
    function areaPointFirst(x, y) {
        areaStream.point = areaPoint;
        x00$2 = x0$3 = x, y00$2 = y0$3 = y;
    }
    function areaPoint(x, y) {
        areaRingSum.add(y0$3 * x - x0$3 * y);
        x0$3 = x, y0$3 = y;
    }
    function areaRingEnd() {
        areaPoint(x00$2, y00$2);
    }
    var pathArea = areaStream;
    var x0$2 = Infinity, y0$2 = x0$2, x1 = -x0$2, y1 = x1;
    var boundsStream = {
        point: boundsPoint,
        lineStart: noop$1,
        lineEnd: noop$1,
        polygonStart: noop$1,
        polygonEnd: noop$1,
        result: function() {
            var bounds = [
                [
                    x0$2,
                    y0$2
                ],
                [
                    x1,
                    y1
                ]
            ];
            x1 = y1 = -(y0$2 = x0$2 = Infinity);
            return bounds;
        }
    };
    function boundsPoint(x, y) {
        if (x < x0$2) x0$2 = x;
        if (x > x1) x1 = x;
        if (y < y0$2) y0$2 = y;
        if (y > y1) y1 = y;
    }
    var boundsStream$1 = boundsStream;
    // TODO Enforce positive area for exterior, negative area for interior?
    var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00$1, y00$1, x0$1, y0$1;
    var centroidStream = {
        point: centroidPoint,
        lineStart: centroidLineStart,
        lineEnd: centroidLineEnd,
        polygonStart: function() {
            centroidStream.lineStart = centroidRingStart;
            centroidStream.lineEnd = centroidRingEnd;
        },
        polygonEnd: function() {
            centroidStream.point = centroidPoint;
            centroidStream.lineStart = centroidLineStart;
            centroidStream.lineEnd = centroidLineEnd;
        },
        result: function() {
            var centroid = Z2 ? [
                X2 / Z2,
                Y2 / Z2
            ] : Z1 ? [
                X1 / Z1,
                Y1 / Z1
            ] : Z0 ? [
                X0 / Z0,
                Y0 / Z0
            ] : [
                NaN,
                NaN
            ];
            X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
            return centroid;
        }
    };
    function centroidPoint(x, y) {
        X0 += x;
        Y0 += y;
        ++Z0;
    }
    function centroidLineStart() {
        centroidStream.point = centroidPointFirstLine;
    }
    function centroidPointFirstLine(x, y) {
        centroidStream.point = centroidPointLine;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    function centroidPointLine(x, y) {
        var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
        X1 += z * (x0$1 + x) / 2;
        Y1 += z * (y0$1 + y) / 2;
        Z1 += z;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    function centroidLineEnd() {
        centroidStream.point = centroidPoint;
    }
    function centroidRingStart() {
        centroidStream.point = centroidPointFirstRing;
    }
    function centroidRingEnd() {
        centroidPointRing(x00$1, y00$1);
    }
    function centroidPointFirstRing(x, y) {
        centroidStream.point = centroidPointRing;
        centroidPoint(x00$1 = x0$1 = x, y00$1 = y0$1 = y);
    }
    function centroidPointRing(x, y) {
        var dx = x - x0$1, dy = y - y0$1, z = sqrt$2(dx * dx + dy * dy);
        X1 += z * (x0$1 + x) / 2;
        Y1 += z * (y0$1 + y) / 2;
        Z1 += z;
        z = y0$1 * x - x0$1 * y;
        X2 += z * (x0$1 + x);
        Y2 += z * (y0$1 + y);
        Z2 += z * 3;
        centroidPoint(x0$1 = x, y0$1 = y);
    }
    var pathCentroid = centroidStream;
    function PathContext(context) {
        this._context = context;
    }
    PathContext.prototype = {
        _radius: 4.5,
        pointRadius: function(_) {
            return this._radius = _, this;
        },
        polygonStart: function() {
            this._line = 0;
        },
        polygonEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line === 0) this._context.closePath();
            this._point = NaN;
        },
        point: function(x, y) {
            switch(this._point){
                case 0:
                    this._context.moveTo(x, y);
                    this._point = 1;
                    break;
                case 1:
                    this._context.lineTo(x, y);
                    break;
                default:
                    this._context.moveTo(x + this._radius, y);
                    this._context.arc(x, y, this._radius, 0, tau$1);
                    break;
            }
        },
        result: noop$1
    };
    var lengthSum = new Adder(), lengthRing, x00, y00, x0, y0;
    var lengthStream = {
        point: noop$1,
        lineStart: function() {
            lengthStream.point = lengthPointFirst;
        },
        lineEnd: function() {
            if (lengthRing) lengthPoint(x00, y00);
            lengthStream.point = noop$1;
        },
        polygonStart: function() {
            lengthRing = true;
        },
        polygonEnd: function() {
            lengthRing = null;
        },
        result: function() {
            var length = +lengthSum;
            lengthSum = new Adder();
            return length;
        }
    };
    function lengthPointFirst(x, y) {
        lengthStream.point = lengthPoint;
        x00 = x0 = x, y00 = y0 = y;
    }
    function lengthPoint(x, y) {
        x0 -= x, y0 -= y;
        lengthSum.add(sqrt$2(x0 * x0 + y0 * y0));
        x0 = x, y0 = y;
    }
    var pathMeasure = lengthStream;
    // Simple caching for constant-radius points.
    let cacheDigits, cacheAppend, cacheRadius, cacheCircle;
    class PathString {
        constructor(digits){
            this._append = digits == null ? append : appendRound(digits);
            this._radius = 4.5;
            this._ = "";
        }
        pointRadius(_) {
            this._radius = +_;
            return this;
        }
        polygonStart() {
            this._line = 0;
        }
        polygonEnd() {
            this._line = NaN;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {
            if (this._line === 0) this._ += "Z";
            this._point = NaN;
        }
        point(x, y) {
            switch(this._point){
                case 0:
                    this._append`M${x},${y}`;
                    this._point = 1;
                    break;
                case 1:
                    this._append`L${x},${y}`;
                    break;
                default:
                    this._append`M${x},${y}`;
                    if (this._radius !== cacheRadius || this._append !== cacheAppend) {
                        const r = this._radius;
                        const s = this._;
                        this._ = ""; // stash the old string so we can cache the circle path fragment
                        this._append`m0,${r}a${r},${r} 0 1,1 0,${-2 * r}a${r},${r} 0 1,1 0,${2 * r}z`;
                        cacheRadius = r;
                        cacheAppend = this._append;
                        cacheCircle = this._;
                        this._ = s;
                    }
                    this._ += cacheCircle;
                    break;
            }
        }
        result() {
            const result = this._;
            this._ = "";
            return result.length ? result : null;
        }
    }
    function append(strings) {
        let i = 1;
        this._ += strings[0];
        for(const j = strings.length; i < j; ++i)this._ += arguments[i] + strings[i];
    }
    function appendRound(digits) {
        const d = Math.floor(digits);
        if (!(d >= 0)) throw new RangeError(`invalid digits: ${digits}`);
        if (d > 15) return append;
        if (d !== cacheDigits) {
            const k = 10 ** d;
            cacheDigits = d;
            cacheAppend = function append(strings) {
                let i = 1;
                this._ += strings[0];
                for(const j = strings.length; i < j; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
            };
        }
        return cacheAppend;
    }
    function index$2(projection, context) {
        let digits = 3, pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                geoStream(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            geoStream(object, projectionStream(pathArea));
            return pathArea.result();
        };
        path.measure = function(object) {
            geoStream(object, projectionStream(pathMeasure));
            return pathMeasure.result();
        };
        path.bounds = function(object) {
            geoStream(object, projectionStream(boundsStream$1));
            return boundsStream$1.result();
        };
        path.centroid = function(object) {
            geoStream(object, projectionStream(pathCentroid));
            return pathCentroid.result();
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectionStream = _ == null ? (projection = null, identity$5) : (projection = _).stream;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new PathString(digits)) : new PathContext(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        path.digits = function(_) {
            if (!arguments.length) return digits;
            if (_ == null) digits = null;
            else {
                const d = Math.floor(_);
                if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
                digits = d;
            }
            if (context === null) contextStream = new PathString(digits);
            return path;
        };
        return path.projection(projection).digits(digits).context(context);
    }
    function transform$1(methods) {
        return {
            stream: transformer$3(methods)
        };
    }
    function transformer$3(methods) {
        return function(stream) {
            var s = new TransformStream;
            for(var key in methods)s[key] = methods[key];
            s.stream = stream;
            return s;
        };
    }
    function TransformStream() {}
    TransformStream.prototype = {
        constructor: TransformStream,
        point: function(x, y) {
            this.stream.point(x, y);
        },
        sphere: function() {
            this.stream.sphere();
        },
        lineStart: function() {
            this.stream.lineStart();
        },
        lineEnd: function() {
            this.stream.lineEnd();
        },
        polygonStart: function() {
            this.stream.polygonStart();
        },
        polygonEnd: function() {
            this.stream.polygonEnd();
        }
    };
    function fit(projection, fitBounds, object) {
        var clip = projection.clipExtent && projection.clipExtent();
        projection.scale(150).translate([
            0,
            0
        ]);
        if (clip != null) projection.clipExtent(null);
        geoStream(object, projection.stream(boundsStream$1));
        fitBounds(boundsStream$1.result());
        if (clip != null) projection.clipExtent(clip);
        return projection;
    }
    function fitExtent(projection, extent, object) {
        return fit(projection, function(b) {
            var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    function fitSize(projection, size, object) {
        return fitExtent(projection, [
            [
                0,
                0
            ],
            size
        ], object);
    }
    function fitWidth(projection, width, object) {
        return fit(projection, function(b) {
            var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    function fitHeight(projection, height, object) {
        return fit(projection, function(b) {
            var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
            projection.scale(150 * k).translate([
                x,
                y
            ]);
        }, object);
    }
    var maxDepth = 16, cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
    function resample(project, delta2) {
        return +delta2 ? resample$1(project, delta2) : resampleNone(project);
    }
    function resampleNone(project) {
        return transformer$3({
            point: function(x, y) {
                x = project(x, y);
                this.stream.point(x[0], x[1]);
            }
        });
    }
    function resample$1(project, delta2) {
        function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
            var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
            if (d2 > 4 * delta2 && depth--) {
                var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = sqrt$2(a * a + b * b + c * c), phi2 = asin$1(c /= m), lambda2 = abs$1(abs$1(c) - 1) < epsilon$1 || abs$1(lambda0 - lambda1) < epsilon$1 ? (lambda0 + lambda1) / 2 : atan2$1(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
                if (dz * dz / d2 > delta2 // perpendicular projected distance
                 || abs$1((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
                 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                    resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                    stream.point(x2, y2);
                    resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
                }
            }
        }
        return function(stream) {
            var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
            var resampleStream = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    stream.polygonStart();
                    resampleStream.lineStart = ringStart;
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                    resampleStream.lineStart = lineStart;
                }
            };
            function point(x, y) {
                x = project(x, y);
                stream.point(x[0], x[1]);
            }
            function lineStart() {
                x0 = NaN;
                resampleStream.point = linePoint;
                stream.lineStart();
            }
            function linePoint(lambda, phi) {
                var c = cartesian([
                    lambda,
                    phi
                ]), p = project(lambda, phi);
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
                stream.point(x0, y0);
            }
            function lineEnd() {
                resampleStream.point = point;
                stream.lineEnd();
            }
            function ringStart() {
                lineStart();
                resampleStream.point = ringPoint;
                resampleStream.lineEnd = ringEnd;
            }
            function ringPoint(lambda, phi) {
                linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
                resampleStream.point = linePoint;
            }
            function ringEnd() {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
                resampleStream.lineEnd = lineEnd;
                lineEnd();
            }
            return resampleStream;
        };
    }
    var transformRadians = transformer$3({
        point: function(x, y) {
            this.stream.point(x * radians, y * radians);
        }
    });
    function transformRotate(rotate) {
        return transformer$3({
            point: function(x, y) {
                var r = rotate(x, y);
                return this.stream.point(r[0], r[1]);
            }
        });
    }
    function scaleTranslate(k, dx, dy, sx, sy) {
        function transform(x, y) {
            x *= sx;
            y *= sy;
            return [
                dx + k * x,
                dy - k * y
            ];
        }
        transform.invert = function(x, y) {
            return [
                (x - dx) / k * sx,
                (dy - y) / k * sy
            ];
        };
        return transform;
    }
    function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
        if (!alpha) return scaleTranslate(k, dx, dy, sx, sy);
        var cosAlpha = cos$1(alpha), sinAlpha = sin$1(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
        function transform(x, y) {
            x *= sx;
            y *= sy;
            return [
                a * x - b * y + dx,
                dy - b * x - a * y
            ];
        }
        transform.invert = function(x, y) {
            return [
                sx * (ai * x - bi * y + ci),
                sy * (fi - bi * x - ai * y)
            ];
        };
        return transform;
    }
    function projection(project) {
        return projectionMutator(function() {
            return project;
        })();
    }
    function projectionMutator(projectAt) {
        var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = clipAntimeridian, x0 = null, y0, x1, y1, postclip = identity$5, delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
        function projection(point) {
            return projectRotateTransform(point[0] * radians, point[1] * radians);
        }
        function invert(point) {
            point = projectRotateTransform.invert(point[0], point[1]);
            return point && [
                point[0] * degrees,
                point[1] * degrees
            ];
        }
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
        };
        projection.preclip = function(_) {
            return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipAngle = function(_) {
            return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, recenter()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
                x,
                y
            ];
        };
        projection.center = function(_) {
            return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [
                lambda * degrees,
                phi * degrees
            ];
        };
        projection.rotate = function(_) {
            return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [
                deltaLambda * degrees,
                deltaPhi * degrees,
                deltaGamma * degrees
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * radians, recenter()) : alpha * degrees;
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
        };
        projection.precision = function(_) {
            return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$2(delta2);
        };
        projection.fitExtent = function(extent, object) {
            return fitExtent(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return fitSize(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return fitWidth(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return fitHeight(projection, height, object);
        };
        function recenter() {
            var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = scaleTranslateRotate(k, x - center[0], y - center[1], sx, sy, alpha);
            rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma);
            projectTransform = compose(project, transform);
            projectRotateTransform = compose(rotate, projectTransform);
            projectResample = resample(projectTransform, delta2);
            return reset();
        }
        function reset() {
            cache = cacheStream = null;
            return projection;
        }
        return function() {
            project = projectAt.apply(this, arguments);
            projection.invert = project.invert && invert;
            return recenter();
        };
    }
    function conicProjection(projectAt) {
        var phi0 = 0, phi1 = pi$1 / 3, m = projectionMutator(projectAt), p = m(phi0, phi1);
        p.parallels = function(_) {
            return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [
                phi0 * degrees,
                phi1 * degrees
            ];
        };
        return p;
    }
    function cylindricalEqualAreaRaw(phi0) {
        var cosPhi0 = cos$1(phi0);
        function forward(lambda, phi) {
            return [
                lambda * cosPhi0,
                sin$1(phi) / cosPhi0
            ];
        }
        forward.invert = function(x, y) {
            return [
                x / cosPhi0,
                asin$1(y * cosPhi0)
            ];
        };
        return forward;
    }
    function conicEqualAreaRaw(y0, y1) {
        var sy0 = sin$1(y0), n = (sy0 + sin$1(y1)) / 2;
        // Are the parallels symmetrical around the Equator?
        if (abs$1(n) < epsilon$1) return cylindricalEqualAreaRaw(y0);
        var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt$2(c) / n;
        function project(x, y) {
            var r = sqrt$2(c - 2 * n * sin$1(y)) / n;
            return [
                r * sin$1(x *= n),
                r0 - r * cos$1(x)
            ];
        }
        project.invert = function(x, y) {
            var r0y = r0 - y, l = atan2$1(x, abs$1(r0y)) * sign$1(r0y);
            if (r0y * n < 0) l -= pi$1 * sign$1(x) * sign$1(r0y);
            return [
                l / n,
                asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))
            ];
        };
        return project;
    }
    function conicEqualArea() {
        return conicProjection(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    }
    function albers() {
        return conicEqualArea().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    }
    // The projections must have mutually exclusive clip regions on the sphere,
    // as this will avoid emitting interleaving lines and polygons.
    function multiplex(streams) {
        var n = streams.length;
        return {
            point: function(x, y) {
                var i = -1;
                while(++i < n)streams[i].point(x, y);
            },
            sphere: function() {
                var i = -1;
                while(++i < n)streams[i].sphere();
            },
            lineStart: function() {
                var i = -1;
                while(++i < n)streams[i].lineStart();
            },
            lineEnd: function() {
                var i = -1;
                while(++i < n)streams[i].lineEnd();
            },
            polygonStart: function() {
                var i = -1;
                while(++i < n)streams[i].polygonStart();
            },
            polygonEnd: function() {
                var i = -1;
                while(++i < n)streams[i].polygonEnd();
            }
        };
    }
    // A composite projection for the United States, configured by default for
    // 960×500. The projection also works quite well at 960×600 if you change the
    // scale to 1285 and adjust the translate accordingly. The set of standard
    // parallels for each region comes from USGS, which is published here:
    // http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
    function albersUsa() {
        var cache, cacheStream, lower48 = albers(), lower48Point, alaska = conicEqualArea().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = conicEqualArea().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + epsilon$1,
                    y + 0.120 * k + epsilon$1
                ],
                [
                    x - 0.214 * k - epsilon$1,
                    y + 0.234 * k - epsilon$1
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + epsilon$1,
                    y + 0.166 * k + epsilon$1
                ],
                [
                    x - 0.115 * k - epsilon$1,
                    y + 0.234 * k - epsilon$1
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return fitExtent(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return fitSize(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return fitWidth(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return fitHeight(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    }
    function azimuthalRaw(scale) {
        return function(x, y) {
            var cx = cos$1(x), cy = cos$1(y), k = scale(cx * cy);
            if (k === Infinity) return [
                2,
                0
            ];
            return [
                k * cy * sin$1(x),
                k * sin$1(y)
            ];
        };
    }
    function azimuthalInvert(angle) {
        return function(x, y) {
            var z = sqrt$2(x * x + y * y), c = angle(z), sc = sin$1(c), cc = cos$1(c);
            return [
                atan2$1(x * sc, z * cc),
                asin$1(z && y * sc / z)
            ];
        };
    }
    var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
        return sqrt$2(2 / (1 + cxcy));
    });
    azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
        return 2 * asin$1(z / 2);
    });
    function azimuthalEqualArea() {
        return projection(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    }
    var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
        return (c = acos$1(c)) && c / sin$1(c);
    });
    azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
        return z;
    });
    function azimuthalEquidistant() {
        return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    }
    function mercatorRaw(lambda, phi) {
        return [
            lambda,
            log$1(tan((halfPi$1 + phi) / 2))
        ];
    }
    mercatorRaw.invert = function(x, y) {
        return [
            x,
            2 * atan(exp(y)) - halfPi$1
        ];
    };
    function mercator() {
        return mercatorProjection(mercatorRaw).scale(961 / tau$1);
    }
    function mercatorProjection(project) {
        var m = projection(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
        m.scale = function(_) {
            return arguments.length ? (scale(_), reclip()) : scale();
        };
        m.translate = function(_) {
            return arguments.length ? (translate(_), reclip()) : translate();
        };
        m.center = function(_) {
            return arguments.length ? (center(_), reclip()) : center();
        };
        m.clipExtent = function(_) {
            return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        function reclip() {
            var k = pi$1 * scale(), t = m(rotation(m.rotate()).invert([
                0,
                0
            ]));
            return clipExtent(x0 == null ? [
                [
                    t[0] - k,
                    t[1] - k
                ],
                [
                    t[0] + k,
                    t[1] + k
                ]
            ] : project === mercatorRaw ? [
                [
                    Math.max(t[0] - k, x0),
                    y0
                ],
                [
                    Math.min(t[0] + k, x1),
                    y1
                ]
            ] : [
                [
                    x0,
                    Math.max(t[1] - k, y0)
                ],
                [
                    x1,
                    Math.min(t[1] + k, y1)
                ]
            ]);
        }
        return reclip();
    }
    function tany(y) {
        return tan((halfPi$1 + y) / 2);
    }
    function conicConformalRaw(y0, y1) {
        var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)), f = cy0 * pow$1(tany(y0), n) / n;
        if (!n) return mercatorRaw;
        function project(x, y) {
            if (f > 0) {
                if (y < -halfPi$1 + epsilon$1) y = -halfPi$1 + epsilon$1;
            } else if (y > halfPi$1 - epsilon$1) y = halfPi$1 - epsilon$1;
            var r = f / pow$1(tany(y), n);
            return [
                r * sin$1(n * x),
                f - r * cos$1(n * x)
            ];
        }
        project.invert = function(x, y) {
            var fy = f - y, r = sign$1(n) * sqrt$2(x * x + fy * fy), l = atan2$1(x, abs$1(fy)) * sign$1(fy);
            if (fy * n < 0) l -= pi$1 * sign$1(x) * sign$1(fy);
            return [
                l / n,
                2 * atan(pow$1(f / r, 1 / n)) - halfPi$1
            ];
        };
        return project;
    }
    function conicConformal() {
        return conicProjection(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    }
    function equirectangularRaw(lambda, phi) {
        return [
            lambda,
            phi
        ];
    }
    equirectangularRaw.invert = equirectangularRaw;
    function equirectangular() {
        return projection(equirectangularRaw).scale(152.63);
    }
    function conicEquidistantRaw(y0, y1) {
        var cy0 = cos$1(y0), n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0), g = cy0 / n + y0;
        if (abs$1(n) < epsilon$1) return equirectangularRaw;
        function project(x, y) {
            var gy = g - y, nx = n * x;
            return [
                gy * sin$1(nx),
                g - gy * cos$1(nx)
            ];
        }
        project.invert = function(x, y) {
            var gy = g - y, l = atan2$1(x, abs$1(gy)) * sign$1(gy);
            if (gy * n < 0) l -= pi$1 * sign$1(x) * sign$1(gy);
            return [
                l / n,
                g - sign$1(n) * sqrt$2(x * x + gy * gy)
            ];
        };
        return project;
    }
    function conicEquidistant() {
        return conicProjection(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    }
    var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = sqrt$2(3) / 2, iterations = 12;
    function equalEarthRaw(lambda, phi) {
        var l = asin$1(M * sin$1(phi)), l2 = l * l, l6 = l2 * l2 * l2;
        return [
            lambda * cos$1(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
            l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
        ];
    }
    equalEarthRaw.invert = function(x, y) {
        var l = y, l2 = l * l, l6 = l2 * l2 * l2;
        for(var i = 0, delta, fy, fpy; i < iterations; ++i){
            fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
            fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
            l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
            if (abs$1(delta) < epsilon2) break;
        }
        return [
            M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / cos$1(l),
            asin$1(sin$1(l) / M)
        ];
    };
    function equalEarth() {
        return projection(equalEarthRaw).scale(177.158);
    }
    function gnomonicRaw(x, y) {
        var cy = cos$1(y), k = cos$1(x) * cy;
        return [
            cy * sin$1(x) / k,
            sin$1(y) / k
        ];
    }
    gnomonicRaw.invert = azimuthalInvert(atan);
    function gnomonic() {
        return projection(gnomonicRaw).scale(144.049).clipAngle(60);
    }
    function identity$4() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = transformer$3({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = identity$5, cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$5) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * radians, sa = sin$1(alpha), ca = cos$1(alpha), reset()) : alpha * degrees;
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return fitExtent(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return fitSize(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return fitWidth(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return fitHeight(projection, height, object);
        };
        return projection;
    }
    function naturalEarth1Raw(lambda, phi) {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        return [
            lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
            phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
        ];
    }
    naturalEarth1Raw.invert = function(x, y) {
        var phi = y, i = 25, delta;
        do {
            var phi2 = phi * phi, phi4 = phi2 * phi2;
            phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
        }while (abs$1(delta) > epsilon$1 && --i > 0);
        return [
            x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
            phi
        ];
    };
    function naturalEarth1() {
        return projection(naturalEarth1Raw).scale(175.295);
    }
    function orthographicRaw(x, y) {
        return [
            cos$1(y) * sin$1(x),
            sin$1(y)
        ];
    }
    orthographicRaw.invert = azimuthalInvert(asin$1);
    function orthographic() {
        return projection(orthographicRaw).scale(249.5).clipAngle(90 + epsilon$1);
    }
    function stereographicRaw(x, y) {
        var cy = cos$1(y), k = 1 + cos$1(x) * cy;
        return [
            cy * sin$1(x) / k,
            sin$1(y) / k
        ];
    }
    stereographicRaw.invert = azimuthalInvert(function(z) {
        return 2 * atan(z);
    });
    function stereographic() {
        return projection(stereographicRaw).scale(250).clipAngle(142);
    }
    function transverseMercatorRaw(lambda, phi) {
        return [
            log$1(tan((halfPi$1 + phi) / 2)),
            -lambda
        ];
    }
    transverseMercatorRaw.invert = function(x, y) {
        return [
            -y,
            2 * atan(exp(x)) - halfPi$1
        ];
    };
    function transverseMercator() {
        var m = mercatorProjection(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    }
    function defaultSeparation$1(a, b) {
        return a.parent === b.parent ? 1 : 2;
    }
    function meanX(children) {
        return children.reduce(meanXReduce, 0) / children.length;
    }
    function meanXReduce(x, c) {
        return x + c.x;
    }
    function maxY(children) {
        return 1 + children.reduce(maxYReduce, 0);
    }
    function maxYReduce(y, c) {
        return Math.max(y, c.y);
    }
    function leafLeft(node) {
        var children;
        while(children = node.children)node = children[0];
        return node;
    }
    function leafRight(node) {
        var children;
        while(children = node.children)node = children[children.length - 1];
        return node;
    }
    function cluster() {
        var separation = defaultSeparation$1, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    }
    function count(node) {
        var sum = 0, children = node.children, i = children && children.length;
        if (!i) sum = 1;
        else while(--i >= 0)sum += children[i].value;
        node.value = sum;
    }
    function node_count() {
        return this.eachAfter(count);
    }
    function node_each(callback, that) {
        let index = -1;
        for (const node of this)callback.call(that, node, ++index, this);
        return this;
    }
    function node_eachBefore(callback, that) {
        var node = this, nodes = [
            node
        ], children, i, index = -1;
        while(node = nodes.pop()){
            callback.call(that, node, ++index, this);
            if (children = node.children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    }
    function node_eachAfter(callback, that) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n, index = -1;
        while(node = nodes.pop()){
            next.push(node);
            if (children = node.children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback.call(that, node, ++index, this);
        return this;
    }
    function node_find(callback, that) {
        let index = -1;
        for (const node of this){
            if (callback.call(that, node, ++index, this)) return node;
        }
    }
    function node_sum(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    }
    function node_sort(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    }
    function node_path(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    }
    function leastCommonAncestor(a, b) {
        if (a === b) return a;
        var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
        a = aNodes.pop();
        b = bNodes.pop();
        while(a === b){
            c = a;
            a = aNodes.pop();
            b = bNodes.pop();
        }
        return c;
    }
    function node_ancestors() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    }
    function node_descendants() {
        return Array.from(this);
    }
    function node_leaves() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    }
    function node_links() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    }
    function* node_iterator() {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                yield node;
                if (children = node.children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
    }
    function hierarchy(data, children) {
        if (data instanceof Map) {
            data = [
                undefined,
                data
            ];
            if (children === undefined) children = mapChildren;
        } else if (children === undefined) children = objectChildren;
        var root = new Node$1(data), node, nodes = [
            root
        ], child, childs, i, n;
        while(node = nodes.pop())if ((childs = children(node.data)) && (n = (childs = Array.from(childs)).length)) {
            node.children = childs;
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = childs[i] = new Node$1(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
        return root.eachBefore(computeHeight);
    }
    function node_copy() {
        return hierarchy(this).eachBefore(copyData);
    }
    function objectChildren(d) {
        return d.children;
    }
    function mapChildren(d) {
        return Array.isArray(d) ? d[1] : null;
    }
    function copyData(node) {
        if (node.data.value !== undefined) node.value = node.data.value;
        node.data = node.data.data;
    }
    function computeHeight(node) {
        var height = 0;
        do node.height = height;
        while ((node = node.parent) && node.height < ++height);
    }
    function Node$1(data) {
        this.data = data;
        this.depth = this.height = 0;
        this.parent = null;
    }
    Node$1.prototype = hierarchy.prototype = {
        constructor: Node$1,
        count: node_count,
        each: node_each,
        eachAfter: node_eachAfter,
        eachBefore: node_eachBefore,
        find: node_find,
        sum: node_sum,
        sort: node_sort,
        path: node_path,
        ancestors: node_ancestors,
        descendants: node_descendants,
        leaves: node_leaves,
        links: node_links,
        copy: node_copy,
        [Symbol.iterator]: node_iterator
    };
    function optional(f) {
        return f == null ? null : required(f);
    }
    function required(f) {
        if (typeof f !== "function") throw new Error;
        return f;
    }
    function constantZero() {
        return 0;
    }
    function constant$2(x) {
        return function() {
            return x;
        };
    }
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const a$1 = 1664525;
    const c$3 = 1013904223;
    const m = 4294967296; // 2^32
    function lcg$1() {
        let s = 1;
        return ()=>(s = (a$1 * s + c$3) % m) / m;
    }
    function array$1(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    }
    function shuffle(array, random) {
        let m = array.length, t, i;
        while(m){
            i = random() * m-- | 0;
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
    }
    function enclose(circles) {
        return packEncloseRandom(circles, lcg$1());
    }
    function packEncloseRandom(circles, random) {
        var i = 0, n = (circles = shuffle(Array.from(circles), random)).length, B = [], p, e;
        while(i < n){
            p = circles[i];
            if (e && enclosesWeak(e, p)) ++i;
            else e = encloseBasis(B = extendBasis(B, p)), i = 0;
        }
        return e;
    }
    function extendBasis(B, p) {
        var i, j;
        if (enclosesWeakAll(p, B)) return [
            p
        ];
        // If we get here then B must have at least one element.
        for(i = 0; i < B.length; ++i){
            if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
                B[i],
                p
            ];
        }
        // If we get here then B must have at least two elements.
        for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
            if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
                B[i],
                B[j],
                p
            ];
        }
        // If we get here then something is very wrong.
        throw new Error;
    }
    function enclosesNot(a, b) {
        var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
        return dr < 0 || dr * dr < dx * dx + dy * dy;
    }
    function enclosesWeak(a, b) {
        var dr = a.r - b.r + Math.max(a.r, b.r, 1) * 1e-9, dx = b.x - a.x, dy = b.y - a.y;
        return dr > 0 && dr * dr > dx * dx + dy * dy;
    }
    function enclosesWeakAll(a, B) {
        for(var i = 0; i < B.length; ++i){
            if (!enclosesWeak(a, B[i])) return false;
        }
        return true;
    }
    function encloseBasis(B) {
        switch(B.length){
            case 1:
                return encloseBasis1(B[0]);
            case 2:
                return encloseBasis2(B[0], B[1]);
            case 3:
                return encloseBasis3(B[0], B[1], B[2]);
        }
    }
    function encloseBasis1(a) {
        return {
            x: a.x,
            y: a.y,
            r: a.r
        };
    }
    function encloseBasis2(a, b) {
        var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
        return {
            x: (x1 + x2 + x21 / l * r21) / 2,
            y: (y1 + y2 + y21 / l * r21) / 2,
            r: (l + r1 + r2) / 2
        };
    }
    function encloseBasis3(a, b, c) {
        var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(Math.abs(A) > 1e-6 ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
        return {
            x: x1 + xa + xb * r,
            y: y1 + ya + yb * r,
            r: r
        };
    }
    function place(b, a, c) {
        var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
        if (d2) {
            a2 = a.r + c.r, a2 *= a2;
            b2 = b.r + c.r, b2 *= b2;
            if (a2 > b2) {
                x = (d2 + b2 - a2) / (2 * d2);
                y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
                c.x = b.x - x * dx - y * dy;
                c.y = b.y - x * dy + y * dx;
            } else {
                x = (d2 + a2 - b2) / (2 * d2);
                y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
                c.x = a.x + x * dx - y * dy;
                c.y = a.y + x * dy + y * dx;
            }
        } else {
            c.x = a.x + c.r;
            c.y = a.y;
        }
    }
    function intersects(a, b) {
        var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
        return dr > 0 && dr * dr > dx * dx + dy * dy;
    }
    function score(node) {
        var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
        return dx * dx + dy * dy;
    }
    function Node(circle) {
        this._ = circle;
        this.next = null;
        this.previous = null;
    }
    function packSiblingsRandom(circles, random) {
        if (!(n = (circles = array$1(circles)).length)) return 0;
        var a, b, c, n, aa, ca, i, j, k, sj, sk;
        // Place the first circle.
        a = circles[0], a.x = 0, a.y = 0;
        if (!(n > 1)) return a.r;
        // Place the second circle.
        b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
        if (!(n > 2)) return a.r + b.r;
        // Place the third circle.
        place(b, a, c = circles[2]);
        // Initialize the front-chain using the first three circles a, b and c.
        a = new Node(a), b = new Node(b), c = new Node(c);
        a.next = c.previous = b;
        b.next = a.previous = c;
        c.next = b.previous = a;
        // Attempt to place each remaining circle…
        pack: for(i = 3; i < n; ++i){
            place(a._, b._, c = circles[i]), c = new Node(c);
            // Find the closest intersecting circle on the front-chain, if any.
            // “Closeness” is determined by linear distance along the front-chain.
            // “Ahead” or “behind” is likewise determined by linear distance.
            j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
            do if (sj <= sk) {
                if (intersects(j._, c._)) {
                    b = j, a.next = b, b.previous = a, --i;
                    continue pack;
                }
                sj += j._.r, j = j.next;
            } else {
                if (intersects(k._, c._)) {
                    a = k, a.next = b, b.previous = a, --i;
                    continue pack;
                }
                sk += k._.r, k = k.previous;
            }
            while (j !== k.next);
            // Success! Insert the new circle c between a and b.
            c.previous = a, c.next = b, a.next = b.previous = b = c;
            // Compute the new closest circle pair to the centroid.
            aa = score(a);
            while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
            b = a.next;
        }
        // Compute the enclosing circle of the front chain.
        a = [
            b._
        ], c = b;
        while((c = c.next) !== b)a.push(c._);
        c = packEncloseRandom(a, random);
        // Translate the circles to put the enclosing circle around the origin.
        for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
        return c.r;
    }
    function siblings(circles) {
        packSiblingsRandom(circles, lcg$1());
        return circles;
    }
    function defaultRadius(d) {
        return Math.sqrt(d.value);
    }
    function index$1() {
        var radius = null, dx = 1, dy = 1, padding = constantZero;
        function pack(root) {
            const random = lcg$1();
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildrenRandom(padding, 0.5, random)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildrenRandom(constantZero, 1, random)).eachAfter(packChildrenRandom(padding, root.r / Math.min(dx, dy), random)).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = optional(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : constant$2(+x), pack) : padding;
        };
        return pack;
    }
    function radiusLeaf(radius) {
        return function(node) {
            if (!node.children) node.r = Math.max(0, +radius(node) || 0);
        };
    }
    function packChildrenRandom(padding, k, random) {
        return function(node) {
            if (children = node.children) {
                var children, i, n = children.length, r = padding(node) * k || 0, e;
                if (r) for(i = 0; i < n; ++i)children[i].r += r;
                e = packSiblingsRandom(children, random);
                if (r) for(i = 0; i < n; ++i)children[i].r -= r;
                node.r = e + r;
            }
        };
    }
    function translateChild(k) {
        return function(node) {
            var parent = node.parent;
            node.r *= k;
            if (parent) {
                node.x = parent.x + k * node.x;
                node.y = parent.y + k * node.y;
            }
        };
    }
    function roundNode(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    }
    function treemapDice(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    }
    function partition() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore(roundNode);
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    }
    var preroot = {
        depth: -1
    }, ambiguous = {}, imputed = {};
    function defaultId(d) {
        return d.id;
    }
    function defaultParentId(d) {
        return d.parentId;
    }
    function stratify() {
        var id = defaultId, parentId = defaultParentId, path;
        function stratify(data) {
            var nodes = Array.from(data), currentId = id, currentParentId = parentId, n, d, i, root, parent, node, nodeId, nodeKey, nodeByKey = new Map;
            if (path != null) {
                const I = nodes.map((d, i)=>normalize$1(path(d, i, data)));
                const P = I.map(parentof);
                const S = new Set(I).add("");
                for (const i of P)if (!S.has(i)) {
                    S.add(i);
                    I.push(i);
                    P.push(parentof(i));
                    nodes.push(imputed);
                }
                currentId = (_, i)=>I[i];
                currentParentId = (_, i)=>P[i];
            }
            for(i = 0, n = nodes.length; i < n; ++i){
                d = nodes[i], node = nodes[i] = new Node$1(d);
                if ((nodeId = currentId(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = node.id = nodeId;
                    nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
                }
                if ((nodeId = currentParentId(d, i, data)) != null && (nodeId += "")) node.parent = nodeId;
            }
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (nodeId = node.parent) {
                    parent = nodeByKey.get(nodeId);
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                } else {
                    if (root) throw new Error("multiple roots");
                    root = node;
                }
            }
            if (!root) throw new Error("no root");
            // When imputing internal nodes, only introduce roots if needed.
            // Then replace the imputed marker data with null.
            if (path != null) {
                while(root.data === imputed && root.children.length === 1)root = root.children[0], --n;
                for(let i = nodes.length - 1; i >= 0; --i){
                    node = nodes[i];
                    if (node.data !== imputed) break;
                    node.data = null;
                }
            }
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore(computeHeight);
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = optional(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = optional(x), stratify) : parentId;
        };
        stratify.path = function(x) {
            return arguments.length ? (path = optional(x), stratify) : path;
        };
        return stratify;
    }
    // To normalize a path, we coerce to a string, strip the trailing slash if any
    // (as long as the trailing slash is not immediately preceded by another slash),
    // and add leading slash if missing.
    function normalize$1(path) {
        path = `${path}`;
        let i = path.length;
        if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
        return path[0] === "/" ? path : `/${path}`;
    }
    // Walk backwards to find the first slash that is not the leading slash, e.g.:
    // "/foo/bar" ⇥ "/foo", "/foo" ⇥ "/", "/" ↦ "". (The root is special-cased
    // because the id of the root must be a truthy value.)
    function parentof(path) {
        let i = path.length;
        if (i < 2) return "";
        while(--i > 1)if (slash(path, i)) break;
        return path.slice(0, i);
    }
    // Slashes can be escaped; to determine whether a slash is a path delimiter, we
    // count the number of preceding backslashes escaping the forward slash: an odd
    // number indicates an escaped forward slash.
    function slash(path, i) {
        if (path[i] === "/") {
            let k = 0;
            while(i > 0 && path[--i] === "\\")++k;
            if ((k & 1) === 0) return true;
        }
        return false;
    }
    function defaultSeparation(a, b) {
        return a.parent === b.parent ? 1 : 2;
    }
    // function radialSeparation(a, b) {
    //   return (a.parent === b.parent ? 1 : 2) / a.depth;
    // }
    // This function is used to traverse the left contour of a subtree (or
    // subforest). It returns the successor of v on this contour. This successor is
    // either given by the leftmost child of v or by the thread of v. The function
    // returns null if and only if v is on the highest level of its subtree.
    function nextLeft(v) {
        var children = v.children;
        return children ? children[0] : v.t;
    }
    // This function works analogously to nextLeft.
    function nextRight(v) {
        var children = v.children;
        return children ? children[children.length - 1] : v.t;
    }
    // Shifts the current subtree rooted at w+. This is done by increasing
    // prelim(w+) and mod(w+) by shift.
    function moveSubtree(wm, wp, shift) {
        var change = shift / (wp.i - wm.i);
        wp.c -= change;
        wp.s += shift;
        wm.c += change;
        wp.z += shift;
        wp.m += shift;
    }
    // All other shifts, applied to the smaller subtrees between w- and w+, are
    // performed by this function. To prepare the shifts, we have to adjust
    // change(w+), shift(w+), and change(w-).
    function executeShifts(v) {
        var shift = 0, change = 0, children = v.children, i = children.length, w;
        while(--i >= 0){
            w = children[i];
            w.z += shift;
            w.m += shift;
            shift += w.s + (change += w.c);
        }
    }
    // If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
    // returns the specified (default) ancestor.
    function nextAncestor(vim, v, ancestor) {
        return vim.a.parent === v.parent ? vim.a : ancestor;
    }
    function TreeNode(node, i) {
        this._ = node;
        this.parent = null;
        this.children = null;
        this.A = null; // default ancestor
        this.a = this; // ancestor
        this.z = 0; // prelim
        this.m = 0; // mod
        this.c = 0; // change
        this.s = 0; // shift
        this.t = null; // thread
        this.i = i; // number
    }
    TreeNode.prototype = Object.create(Node$1.prototype);
    function treeRoot(root) {
        var tree = new TreeNode(root, 0), node, nodes = [
            tree
        ], child, children, i, n;
        while(node = nodes.pop())if (children = node._.children) {
            node.children = new Array(n = children.length);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new TreeNode(children[i], i));
                child.parent = node;
            }
        }
        (tree.parent = new TreeNode(null, 0)).children = [
            tree
        ];
        return tree;
    }
    // Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
    function tree() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    }
    function treemapSlice(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    }
    var phi = (1 + Math.sqrt(5)) / 2;
    function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
        var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
        while(i0 < n){
            dx = x1 - x0, dy = y1 - y0;
            // Find the next non-empty node.
            do sumValue = nodes[i1++].value;
            while (!sumValue && i1 < n);
            minValue = maxValue = sumValue;
            alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
            beta = sumValue * sumValue * alpha;
            minRatio = Math.max(maxValue / beta, beta / minValue);
            // Keep adding nodes while the aspect ratio maintains or improves.
            for(; i1 < n; ++i1){
                sumValue += nodeValue = nodes[i1].value;
                if (nodeValue < minValue) minValue = nodeValue;
                if (nodeValue > maxValue) maxValue = nodeValue;
                beta = sumValue * sumValue * alpha;
                newRatio = Math.max(maxValue / beta, beta / minValue);
                if (newRatio > minRatio) {
                    sumValue -= nodeValue;
                    break;
                }
                minRatio = newRatio;
            }
            // Position and record the row orientation.
            rows.push(row = {
                value: sumValue,
                dice: dx < dy,
                children: nodes.slice(i0, i1)
            });
            if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
            else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
            value -= sumValue, i0 = i1;
        }
        return rows;
    }
    var squarify = function custom(ratio) {
        function squarify(parent, x0, y0, x1, y1) {
            squarifyRatio(ratio, parent, x0, y0, x1, y1);
        }
        squarify.ratio = function(x) {
            return custom((x = +x) > 1 ? x : 1);
        };
        return squarify;
    }(phi);
    function index() {
        var tile = squarify, round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore(roundNode);
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = required(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$2(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$2(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$2(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$2(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$2(+x), treemap) : paddingLeft;
        };
        return treemap;
    }
    function binary(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = value ? (x0 * valueRight + x1 * valueLeft) / value : x1;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = value ? (y0 * valueRight + y1 * valueLeft) / value : y1;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    }
    function sliceDice(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
    }
    var resquarify = function custom(ratio) {
        function resquarify(parent, x0, y0, x1, y1) {
            if ((rows = parent._squarify) && rows.ratio === ratio) {
                var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
                while(++j < m){
                    row = rows[j], nodes = row.children;
                    for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += (y1 - y0) * row.value / value : y1);
                    else treemapSlice(row, x0, y0, value ? x0 += (x1 - x0) * row.value / value : x1, y1);
                    value -= row.value;
                }
            } else {
                parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
                rows.ratio = ratio;
            }
        }
        resquarify.ratio = function(x) {
            return custom((x = +x) > 1 ? x : 1);
        };
        return resquarify;
    }(phi);
    function area$1(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    }
    function centroid(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    }
    // Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
    // the 3D cross product in a quadrant I Cartesian coordinate system (+x is
    // right, +y is up). Returns a positive value if ABC is counter-clockwise,
    // negative if clockwise, and zero if the points are collinear.
    function cross$1(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    }
    function lexicographicOrder(a, b) {
        return a[0] - b[0] || a[1] - b[1];
    }
    // Computes the upper convex hull per the monotone chain algorithm.
    // Assumes points.length >= 3, is sorted by x, unique in y.
    // Returns an array of indices into points in left-to-right order.
    function computeUpperHullIndexes(points) {
        const n = points.length, indexes = [
            0,
            1
        ];
        let size = 2, i;
        for(i = 2; i < n; ++i){
            while(size > 1 && cross$1(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
            indexes[size++] = i;
        }
        return indexes.slice(0, size); // remove popped points
    }
    function hull(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    }
    function contains(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    }
    function length(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.hypot(xa, ya);
        }
        return perimeter;
    }
    var defaultSource = Math.random;
    var uniform = function sourceRandomUniform(source) {
        function randomUniform(min, max) {
            min = min == null ? 0 : +min;
            max = max == null ? 1 : +max;
            if (arguments.length === 1) max = min, min = 0;
            else max -= min;
            return function() {
                return source() * max + min;
            };
        }
        randomUniform.source = sourceRandomUniform;
        return randomUniform;
    }(defaultSource);
    var int = function sourceRandomInt(source) {
        function randomInt(min, max) {
            if (arguments.length < 2) max = min, min = 0;
            min = Math.floor(min);
            max = Math.floor(max) - min;
            return function() {
                return Math.floor(source() * max + min);
            };
        }
        randomInt.source = sourceRandomInt;
        return randomInt;
    }(defaultSource);
    var normal = function sourceRandomNormal(source) {
        function randomNormal(mu, sigma) {
            var x, r;
            mu = mu == null ? 0 : +mu;
            sigma = sigma == null ? 1 : +sigma;
            return function() {
                var y;
                // If available, use the second previously-generated uniform random.
                if (x != null) y = x, x = null;
                else do {
                    x = source() * 2 - 1;
                    y = source() * 2 - 1;
                    r = x * x + y * y;
                }while (!r || r > 1);
                return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
            };
        }
        randomNormal.source = sourceRandomNormal;
        return randomNormal;
    }(defaultSource);
    var logNormal = function sourceRandomLogNormal(source) {
        var N = normal.source(source);
        function randomLogNormal() {
            var randomNormal = N.apply(this, arguments);
            return function() {
                return Math.exp(randomNormal());
            };
        }
        randomLogNormal.source = sourceRandomLogNormal;
        return randomLogNormal;
    }(defaultSource);
    var irwinHall = function sourceRandomIrwinHall(source) {
        function randomIrwinHall(n) {
            if ((n = +n) <= 0) return ()=>0;
            return function() {
                for(var sum = 0, i = n; i > 1; --i)sum += source();
                return sum + i * source();
            };
        }
        randomIrwinHall.source = sourceRandomIrwinHall;
        return randomIrwinHall;
    }(defaultSource);
    var bates = function sourceRandomBates(source) {
        var I = irwinHall.source(source);
        function randomBates(n) {
            // use limiting distribution at n === 0
            if ((n = +n) === 0) return source;
            var randomIrwinHall = I(n);
            return function() {
                return randomIrwinHall() / n;
            };
        }
        randomBates.source = sourceRandomBates;
        return randomBates;
    }(defaultSource);
    var exponential = function sourceRandomExponential(source) {
        function randomExponential(lambda) {
            return function() {
                return -Math.log1p(-source()) / lambda;
            };
        }
        randomExponential.source = sourceRandomExponential;
        return randomExponential;
    }(defaultSource);
    var pareto = function sourceRandomPareto(source) {
        function randomPareto(alpha) {
            if ((alpha = +alpha) < 0) throw new RangeError("invalid alpha");
            alpha = 1 / -alpha;
            return function() {
                return Math.pow(1 - source(), alpha);
            };
        }
        randomPareto.source = sourceRandomPareto;
        return randomPareto;
    }(defaultSource);
    var bernoulli = function sourceRandomBernoulli(source) {
        function randomBernoulli(p) {
            if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
            return function() {
                return Math.floor(source() + p);
            };
        }
        randomBernoulli.source = sourceRandomBernoulli;
        return randomBernoulli;
    }(defaultSource);
    var geometric = function sourceRandomGeometric(source) {
        function randomGeometric(p) {
            if ((p = +p) < 0 || p > 1) throw new RangeError("invalid p");
            if (p === 0) return ()=>Infinity;
            if (p === 1) return ()=>1;
            p = Math.log1p(-p);
            return function() {
                return 1 + Math.floor(Math.log1p(-source()) / p);
            };
        }
        randomGeometric.source = sourceRandomGeometric;
        return randomGeometric;
    }(defaultSource);
    var gamma = function sourceRandomGamma(source) {
        var randomNormal = normal.source(source)();
        function randomGamma(k, theta) {
            if ((k = +k) < 0) throw new RangeError("invalid k");
            // degenerate distribution if k === 0
            if (k === 0) return ()=>0;
            theta = theta == null ? 1 : +theta;
            // exponential distribution if k === 1
            if (k === 1) return ()=>-Math.log1p(-source()) * theta;
            var d = (k < 1 ? k + 1 : k) - 1 / 3, c = 1 / (3 * Math.sqrt(d)), multiplier = k < 1 ? ()=>Math.pow(source(), 1 / k) : ()=>1;
            return function() {
                do {
                    do var x = randomNormal(), v = 1 + c * x;
                    while (v <= 0);
                    v *= v * v;
                    var u = 1 - source();
                }while (u >= 1 - 0.0331 * x * x * x * x && Math.log(u) >= 0.5 * x * x + d * (1 - v + Math.log(v)));
                return d * v * multiplier() * theta;
            };
        }
        randomGamma.source = sourceRandomGamma;
        return randomGamma;
    }(defaultSource);
    var beta = function sourceRandomBeta(source) {
        var G = gamma.source(source);
        function randomBeta(alpha, beta) {
            var X = G(alpha), Y = G(beta);
            return function() {
                var x = X();
                return x === 0 ? 0 : x / (x + Y());
            };
        }
        randomBeta.source = sourceRandomBeta;
        return randomBeta;
    }(defaultSource);
    var binomial = function sourceRandomBinomial(source) {
        var G = geometric.source(source), B = beta.source(source);
        function randomBinomial(n, p) {
            n = +n;
            if ((p = +p) >= 1) return ()=>n;
            if (p <= 0) return ()=>0;
            return function() {
                var acc = 0, nn = n, pp = p;
                while(nn * pp > 16 && nn * (1 - pp) > 16){
                    var i = Math.floor((nn + 1) * pp), y = B(i, nn - i + 1)();
                    if (y <= pp) {
                        acc += i;
                        nn -= i;
                        pp = (pp - y) / (1 - y);
                    } else {
                        nn = i - 1;
                        pp /= y;
                    }
                }
                var sign = pp < 0.5, pFinal = sign ? pp : 1 - pp, g = G(pFinal);
                for(var s = g(), k = 0; s <= nn; ++k)s += g();
                return acc + (sign ? k : nn - k);
            };
        }
        randomBinomial.source = sourceRandomBinomial;
        return randomBinomial;
    }(defaultSource);
    var weibull = function sourceRandomWeibull(source) {
        function randomWeibull(k, a, b) {
            var outerFunc;
            if ((k = +k) === 0) outerFunc = (x)=>-Math.log(x);
            else {
                k = 1 / k;
                outerFunc = (x)=>Math.pow(x, k);
            }
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                return a + b * outerFunc(-Math.log1p(-source()));
            };
        }
        randomWeibull.source = sourceRandomWeibull;
        return randomWeibull;
    }(defaultSource);
    var cauchy = function sourceRandomCauchy(source) {
        function randomCauchy(a, b) {
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                return a + b * Math.tan(Math.PI * source());
            };
        }
        randomCauchy.source = sourceRandomCauchy;
        return randomCauchy;
    }(defaultSource);
    var logistic = function sourceRandomLogistic(source) {
        function randomLogistic(a, b) {
            a = a == null ? 0 : +a;
            b = b == null ? 1 : +b;
            return function() {
                var u = source();
                return a + b * Math.log(u / (1 - u));
            };
        }
        randomLogistic.source = sourceRandomLogistic;
        return randomLogistic;
    }(defaultSource);
    var poisson = function sourceRandomPoisson(source) {
        var G = gamma.source(source), B = binomial.source(source);
        function randomPoisson(lambda) {
            return function() {
                var acc = 0, l = lambda;
                while(l > 16){
                    var n = Math.floor(0.875 * l), t = G(n)();
                    if (t > l) return acc + B(n - 1, l / t)();
                    acc += n;
                    l -= t;
                }
                for(var s = -Math.log1p(-source()), k = 0; s <= l; ++k)s -= Math.log1p(-source());
                return acc + k;
            };
        }
        randomPoisson.source = sourceRandomPoisson;
        return randomPoisson;
    }(defaultSource);
    // https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
    const mul = 0x19660D;
    const inc = 0x3C6EF35F;
    const eps = 1 / 0x100000000;
    function lcg(seed = Math.random()) {
        let state = (0 <= seed && seed < 1 ? seed / eps : Math.abs(seed)) | 0;
        return ()=>(state = mul * state + inc | 0, eps * (state >>> 0));
    }
    function initRange(domain, range) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                this.range(domain);
                break;
            default:
                this.range(range).domain(domain);
                break;
        }
        return this;
    }
    function initInterpolator(domain, interpolator) {
        switch(arguments.length){
            case 0:
                break;
            case 1:
                if (typeof domain === "function") this.interpolator(domain);
                else this.range(domain);
                break;
            default:
                this.domain(domain);
                if (typeof interpolator === "function") this.interpolator(interpolator);
                else this.range(interpolator);
                break;
        }
        return this;
    }
    const implicit = Symbol("implicit");
    function ordinal() {
        var index = new InternMap(), domain = [], range = [], unknown = implicit;
        function scale(d) {
            let i = index.get(d);
            if (i === undefined) {
                if (unknown !== implicit) return unknown;
                index.set(d, i = domain.push(d) - 1);
            }
            return range[i % range.length];
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [], index = new InternMap();
            for (const value of _){
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
            return scale;
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), scale) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return ordinal(domain, range).unknown(unknown);
        };
        initRange.apply(scale, arguments);
        return scale;
    }
    function band() {
        var scale = ordinal().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
        delete scale.unknown;
        function rescale() {
            var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
            step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
            if (round) step = Math.floor(step);
            start += (stop - start - step * (n - paddingInner)) * align;
            bandwidth = step * (1 - paddingInner);
            if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
            var values = range$2(n).map(function(i) {
                return start + step * i;
            });
            return ordinalRange(reverse ? values.reverse() : values);
        }
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.range = function(_) {
            return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
                r0,
                r1
            ];
        };
        scale.rangeRound = function(_) {
            return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
        };
        scale.bandwidth = function() {
            return bandwidth;
        };
        scale.step = function() {
            return step;
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, rescale()) : round;
        };
        scale.padding = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
        };
        scale.paddingInner = function(_) {
            return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
        };
        scale.paddingOuter = function(_) {
            return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
        };
        scale.align = function(_) {
            return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
        };
        scale.copy = function() {
            return band(domain(), [
                r0,
                r1
            ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
        };
        return initRange.apply(rescale(), arguments);
    }
    function pointish(scale) {
        var copy = scale.copy;
        scale.padding = scale.paddingOuter;
        delete scale.paddingInner;
        delete scale.paddingOuter;
        scale.copy = function() {
            return pointish(copy());
        };
        return scale;
    }
    function point$4() {
        return pointish(band.apply(null, arguments).paddingInner(1));
    }
    function constants(x) {
        return function() {
            return x;
        };
    }
    function number$1(x) {
        return +x;
    }
    var unit = [
        0,
        1
    ];
    function identity$3(x) {
        return x;
    }
    function normalize(a, b) {
        return (b -= a = +a) ? function(x) {
            return (x - a) / b;
        } : constants(isNaN(b) ? NaN : 0.5);
    }
    function clamper(a, b) {
        var t;
        if (a > b) t = a, a = b, b = t;
        return function(x) {
            return Math.max(a, Math.min(b, x));
        };
    }
    // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
    // interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
    function bimap(domain, range, interpolate) {
        var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
        if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
        else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
        return function(x) {
            return r0(d0(x));
        };
    }
    function polymap(domain, range, interpolate) {
        var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
        // Reverse descending domains.
        if (domain[j] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
        }
        while(++i < j){
            d[i] = normalize(domain[i], domain[i + 1]);
            r[i] = interpolate(range[i], range[i + 1]);
        }
        return function(x) {
            var i = bisect(domain, x, 1, j) - 1;
            return r[i](d[i](x));
        };
    }
    function copy$1(source, target) {
        return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
    }
    function transformer$2() {
        var domain = unit, range = unit, interpolate = interpolate$2, transform, untransform, unknown, clamp = identity$3, piecewise, output, input;
        function rescale() {
            var n = Math.min(domain.length, range.length);
            if (clamp !== identity$3) clamp = clamper(domain[0], domain[n - 1]);
            piecewise = n > 2 ? polymap : bimap;
            output = input = null;
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
        }
        scale.invert = function(y) {
            return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
        };
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.rangeRound = function(_) {
            return range = Array.from(_), interpolate = interpolateRound, rescale();
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = _ ? true : identity$3, rescale()) : clamp !== identity$3;
        };
        scale.interpolate = function(_) {
            return arguments.length ? (interpolate = _, rescale()) : interpolate;
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t, u) {
            transform = t, untransform = u;
            return rescale();
        };
    }
    function continuous() {
        return transformer$2()(identity$3, identity$3);
    }
    function tickFormat(start, stop, count, specifier) {
        var step = tickStep(start, stop, count), precision;
        specifier = formatSpecifier(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
                return exports1.formatPrefix(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return exports1.format(specifier);
    }
    function linearish(scale) {
        var domain = scale.domain;
        scale.ticks = function(count) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
        };
        scale.tickFormat = function(count, specifier) {
            var d = domain();
            return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
        };
        scale.nice = function(count) {
            if (count == null) count = 10;
            var d = domain();
            var i0 = 0;
            var i1 = d.length - 1;
            var start = d[i0];
            var stop = d[i1];
            var prestep;
            var step;
            var maxIter = 10;
            if (stop < start) {
                step = start, start = stop, stop = step;
                step = i0, i0 = i1, i1 = step;
            }
            while(maxIter-- > 0){
                step = tickIncrement(start, stop, count);
                if (step === prestep) {
                    d[i0] = start;
                    d[i1] = stop;
                    return domain(d);
                } else if (step > 0) {
                    start = Math.floor(start / step) * step;
                    stop = Math.ceil(stop / step) * step;
                } else if (step < 0) {
                    start = Math.ceil(start * step) / step;
                    stop = Math.floor(stop * step) / step;
                } else break;
                prestep = step;
            }
            return scale;
        };
        return scale;
    }
    function linear() {
        var scale = continuous();
        scale.copy = function() {
            return copy$1(scale, linear());
        };
        initRange.apply(scale, arguments);
        return linearish(scale);
    }
    function identity$2(domain) {
        var unknown;
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : x;
        }
        scale.invert = scale;
        scale.domain = scale.range = function(_) {
            return arguments.length ? (domain = Array.from(_, number$1), scale) : domain.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return identity$2(domain).unknown(unknown);
        };
        domain = arguments.length ? Array.from(domain, number$1) : [
            0,
            1
        ];
        return linearish(scale);
    }
    function nice(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    }
    function transformLog(x) {
        return Math.log(x);
    }
    function transformExp(x) {
        return Math.exp(x);
    }
    function transformLogn(x) {
        return -Math.log(-x);
    }
    function transformExpn(x) {
        return -Math.exp(-x);
    }
    function pow10(x) {
        return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
    }
    function powp(base) {
        return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
    }
    function logp(base) {
        return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
    }
    function reflect(f) {
        return (x, k)=>-f(-x, k);
    }
    function loggish(transform) {
        const scale = transform(transformLog, transformExp);
        const domain = scale.domain;
        let base = 10;
        let logs;
        let pows;
        function rescale() {
            logs = logp(base), pows = powp(base);
            if (domain()[0] < 0) {
                logs = reflect(logs), pows = reflect(pows);
                transform(transformLogn, transformExpn);
            } else transform(transformLog, transformExp);
            return scale;
        }
        scale.base = function(_) {
            return arguments.length ? (base = +_, rescale()) : base;
        };
        scale.domain = function(_) {
            return arguments.length ? (domain(_), rescale()) : domain();
        };
        scale.ticks = (count)=>{
            const d = domain();
            let u = d[0];
            let v = d[d.length - 1];
            const r = v < u;
            if (r) [u, v] = [
                v,
                u
            ];
            let i = logs(u);
            let j = logs(v);
            let k;
            let t;
            const n = count == null ? 10 : +count;
            let z = [];
            if (!(base % 1) && j - i < n) {
                i = Math.floor(i), j = Math.ceil(j);
                if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                    t = i < 0 ? k / pows(-i) : k * pows(i);
                    if (t < u) continue;
                    if (t > v) break;
                    z.push(t);
                }
                else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                    t = i > 0 ? k / pows(-i) : k * pows(i);
                    if (t < u) continue;
                    if (t > v) break;
                    z.push(t);
                }
                if (z.length * 2 < n) z = ticks(u, v, n);
            } else z = ticks(i, j, Math.min(j - i, n)).map(pows);
            return r ? z.reverse() : z;
        };
        scale.tickFormat = (count, specifier)=>{
            if (count == null) count = 10;
            if (specifier == null) specifier = base === 10 ? "s" : ",";
            if (typeof specifier !== "function") {
                if (!(base % 1) && (specifier = formatSpecifier(specifier)).precision == null) specifier.trim = true;
                specifier = exports1.format(specifier);
            }
            if (count === Infinity) return specifier;
            const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
            return (d)=>{
                let i = d / pows(Math.round(logs(d)));
                if (i * base < base - 0.5) i *= base;
                return i <= k ? specifier(d) : "";
            };
        };
        scale.nice = ()=>{
            return domain(nice(domain(), {
                floor: (x)=>pows(Math.floor(logs(x))),
                ceil: (x)=>pows(Math.ceil(logs(x)))
            }));
        };
        return scale;
    }
    function log() {
        const scale = loggish(transformer$2()).domain([
            1,
            10
        ]);
        scale.copy = ()=>copy$1(scale, log()).base(scale.base());
        initRange.apply(scale, arguments);
        return scale;
    }
    function transformSymlog(c) {
        return function(x) {
            return Math.sign(x) * Math.log1p(Math.abs(x / c));
        };
    }
    function transformSymexp(c) {
        return function(x) {
            return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
        };
    }
    function symlogish(transform) {
        var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
        scale.constant = function(_) {
            return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
        };
        return linearish(scale);
    }
    function symlog() {
        var scale = symlogish(transformer$2());
        scale.copy = function() {
            return copy$1(scale, symlog()).constant(scale.constant());
        };
        return initRange.apply(scale, arguments);
    }
    function transformPow(exponent) {
        return function(x) {
            return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
        };
    }
    function transformSqrt(x) {
        return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
    }
    function transformSquare(x) {
        return x < 0 ? -x * x : x * x;
    }
    function powish(transform) {
        var scale = transform(identity$3, identity$3), exponent = 1;
        function rescale() {
            return exponent === 1 ? transform(identity$3, identity$3) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
        }
        scale.exponent = function(_) {
            return arguments.length ? (exponent = +_, rescale()) : exponent;
        };
        return linearish(scale);
    }
    function pow() {
        var scale = powish(transformer$2());
        scale.copy = function() {
            return copy$1(scale, pow()).exponent(scale.exponent());
        };
        initRange.apply(scale, arguments);
        return scale;
    }
    function sqrt$1() {
        return pow.apply(null, arguments).exponent(0.5);
    }
    function square$1(x) {
        return Math.sign(x) * x * x;
    }
    function unsquare(x) {
        return Math.sign(x) * Math.sqrt(Math.abs(x));
    }
    function radial() {
        var squared = continuous(), range = [
            0,
            1
        ], round = false, unknown;
        function scale(x) {
            var y = unsquare(squared(x));
            return isNaN(y) ? unknown : round ? Math.round(y) : y;
        }
        scale.invert = function(y) {
            return squared.invert(square$1(y));
        };
        scale.domain = function(_) {
            return arguments.length ? (squared.domain(_), scale) : squared.domain();
        };
        scale.range = function(_) {
            return arguments.length ? (squared.range((range = Array.from(_, number$1)).map(square$1)), scale) : range.slice();
        };
        scale.rangeRound = function(_) {
            return scale.range(_).round(true);
        };
        scale.round = function(_) {
            return arguments.length ? (round = !!_, scale) : round;
        };
        scale.clamp = function(_) {
            return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
        };
        initRange.apply(scale, arguments);
        return linearish(scale);
    }
    function quantile() {
        var domain = [], range = [], thresholds = [], unknown;
        function rescale() {
            var i = 0, n = Math.max(1, range.length);
            thresholds = new Array(n - 1);
            while(++i < n)thresholds[i - 1] = quantileSorted(domain, i / n);
            return scale;
        }
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
        }
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return i < 0 ? [
                NaN,
                NaN
            ] : [
                i > 0 ? thresholds[i - 1] : domain[0],
                i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
            ];
        };
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [];
            for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
            domain.sort(ascending$3);
            return rescale();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.quantiles = function() {
            return thresholds.slice();
        };
        scale.copy = function() {
            return quantile().domain(domain).range(range).unknown(unknown);
        };
        return initRange.apply(scale, arguments);
    }
    function quantize() {
        var x0 = 0, x1 = 1, n = 1, domain = [
            0.5
        ], range = [
            0,
            1
        ], unknown;
        function scale(x) {
            return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
        }
        function rescale() {
            var i = -1;
            domain = new Array(n);
            while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
            return scale;
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
                x0,
                x1
            ];
        };
        scale.range = function(_) {
            return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
        };
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return i < 0 ? [
                NaN,
                NaN
            ] : i < 1 ? [
                x0,
                domain[0]
            ] : i >= n ? [
                domain[n - 1],
                x1
            ] : [
                domain[i - 1],
                domain[i]
            ];
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : scale;
        };
        scale.thresholds = function() {
            return domain.slice();
        };
        scale.copy = function() {
            return quantize().domain([
                x0,
                x1
            ]).range(range).unknown(unknown);
        };
        return initRange.apply(linearish(scale), arguments);
    }
    function threshold() {
        var domain = [
            0.5
        ], range = [
            0,
            1
        ], unknown, n = 1;
        function scale(x) {
            return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
        }
        scale.domain = function(_) {
            return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
        };
        scale.range = function(_) {
            return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
        };
        scale.invertExtent = function(y) {
            var i = range.indexOf(y);
            return [
                domain[i - 1],
                domain[i]
            ];
        };
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        scale.copy = function() {
            return threshold().domain(domain).range(range).unknown(unknown);
        };
        return initRange.apply(scale, arguments);
    }
    const t0 = new Date, t1 = new Date;
    function timeInterval(floori, offseti, count, field) {
        function interval(date) {
            return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
        }
        interval.floor = (date)=>{
            return floori(date = new Date(+date)), date;
        };
        interval.ceil = (date)=>{
            return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
        };
        interval.round = (date)=>{
            const d0 = interval(date), d1 = interval.ceil(date);
            return date - d0 < d1 - date ? d0 : d1;
        };
        interval.offset = (date, step)=>{
            return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
        };
        interval.range = (start, stop, step)=>{
            const range = [];
            start = interval.ceil(start);
            step = step == null ? 1 : Math.floor(step);
            if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
            let previous;
            do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
            while (previous < start && start < stop);
            return range;
        };
        interval.filter = (test)=>{
            return timeInterval((date)=>{
                if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
            }, (date, step)=>{
                if (date >= date) {
                    if (step < 0) while(++step <= 0){
                        while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                    }
                    else while(--step >= 0){
                        while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                    }
                }
            });
        };
        if (count) {
            interval.count = (start, end)=>{
                t0.setTime(+start), t1.setTime(+end);
                floori(t0), floori(t1);
                return Math.floor(count(t0, t1));
            };
            interval.every = (step)=>{
                step = Math.floor(step);
                return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
            };
        }
        return interval;
    }
    const millisecond = timeInterval(()=>{
    // noop
    }, (date, step)=>{
        date.setTime(+date + step);
    }, (start, end)=>{
        return end - start;
    });
    // An optimized implementation for this simple case.
    millisecond.every = (k)=>{
        k = Math.floor(k);
        if (!isFinite(k) || !(k > 0)) return null;
        if (!(k > 1)) return millisecond;
        return timeInterval((date)=>{
            date.setTime(Math.floor(date / k) * k);
        }, (date, step)=>{
            date.setTime(+date + step * k);
        }, (start, end)=>{
            return (end - start) / k;
        });
    };
    const milliseconds = millisecond.range;
    const durationSecond = 1000;
    const durationMinute = durationSecond * 60;
    const durationHour = durationMinute * 60;
    const durationDay = durationHour * 24;
    const durationWeek = durationDay * 7;
    const durationMonth = durationDay * 30;
    const durationYear = durationDay * 365;
    const second = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds());
    }, (date, step)=>{
        date.setTime(+date + step * durationSecond);
    }, (start, end)=>{
        return (end - start) / durationSecond;
    }, (date)=>{
        return date.getUTCSeconds();
    });
    const seconds = second.range;
    const timeMinute = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
    }, (date, step)=>{
        date.setTime(+date + step * durationMinute);
    }, (start, end)=>{
        return (end - start) / durationMinute;
    }, (date)=>{
        return date.getMinutes();
    });
    const timeMinutes = timeMinute.range;
    const utcMinute = timeInterval((date)=>{
        date.setUTCSeconds(0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * durationMinute);
    }, (start, end)=>{
        return (end - start) / durationMinute;
    }, (date)=>{
        return date.getUTCMinutes();
    });
    const utcMinutes = utcMinute.range;
    const timeHour = timeInterval((date)=>{
        date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
    }, (date, step)=>{
        date.setTime(+date + step * durationHour);
    }, (start, end)=>{
        return (end - start) / durationHour;
    }, (date)=>{
        return date.getHours();
    });
    const timeHours = timeHour.range;
    const utcHour = timeInterval((date)=>{
        date.setUTCMinutes(0, 0, 0);
    }, (date, step)=>{
        date.setTime(+date + step * durationHour);
    }, (start, end)=>{
        return (end - start) / durationHour;
    }, (date)=>{
        return date.getUTCHours();
    });
    const utcHours = utcHour.range;
    const timeDay = timeInterval((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay, (date)=>date.getDate() - 1);
    const timeDays = timeDay.range;
    const utcDay = timeInterval((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / durationDay;
    }, (date)=>{
        return date.getUTCDate() - 1;
    });
    const utcDays = utcDay.range;
    const unixDay = timeInterval((date)=>{
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step);
    }, (start, end)=>{
        return (end - start) / durationDay;
    }, (date)=>{
        return Math.floor(date / durationDay);
    });
    const unixDays = unixDay.range;
    function timeWeekday(i) {
        return timeInterval((date)=>{
            date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setDate(date.getDate() + step * 7);
        }, (start, end)=>{
            return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
        });
    }
    const timeSunday = timeWeekday(0);
    const timeMonday = timeWeekday(1);
    const timeTuesday = timeWeekday(2);
    const timeWednesday = timeWeekday(3);
    const timeThursday = timeWeekday(4);
    const timeFriday = timeWeekday(5);
    const timeSaturday = timeWeekday(6);
    const timeSundays = timeSunday.range;
    const timeMondays = timeMonday.range;
    const timeTuesdays = timeTuesday.range;
    const timeWednesdays = timeWednesday.range;
    const timeThursdays = timeThursday.range;
    const timeFridays = timeFriday.range;
    const timeSaturdays = timeSaturday.range;
    function utcWeekday(i) {
        return timeInterval((date)=>{
            date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCDate(date.getUTCDate() + step * 7);
        }, (start, end)=>{
            return (end - start) / durationWeek;
        });
    }
    const utcSunday = utcWeekday(0);
    const utcMonday = utcWeekday(1);
    const utcTuesday = utcWeekday(2);
    const utcWednesday = utcWeekday(3);
    const utcThursday = utcWeekday(4);
    const utcFriday = utcWeekday(5);
    const utcSaturday = utcWeekday(6);
    const utcSundays = utcSunday.range;
    const utcMondays = utcMonday.range;
    const utcTuesdays = utcTuesday.range;
    const utcWednesdays = utcWednesday.range;
    const utcThursdays = utcThursday.range;
    const utcFridays = utcFriday.range;
    const utcSaturdays = utcSaturday.range;
    const timeMonth = timeInterval((date)=>{
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setMonth(date.getMonth() + step);
    }, (start, end)=>{
        return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
    }, (date)=>{
        return date.getMonth();
    });
    const timeMonths = timeMonth.range;
    const utcMonth = timeInterval((date)=>{
        date.setUTCDate(1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCMonth(date.getUTCMonth() + step);
    }, (start, end)=>{
        return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
    }, (date)=>{
        return date.getUTCMonth();
    });
    const utcMonths = utcMonth.range;
    const timeYear = timeInterval((date)=>{
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step);
    }, (start, end)=>{
        return end.getFullYear() - start.getFullYear();
    }, (date)=>{
        return date.getFullYear();
    });
    // An optimized implementation for this simple case.
    timeYear.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
            date.setFullYear(Math.floor(date.getFullYear() / k) * k);
            date.setMonth(0, 1);
            date.setHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setFullYear(date.getFullYear() + step * k);
        });
    };
    const timeYears = timeYear.range;
    const utcYear = timeInterval((date)=>{
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step);
    }, (start, end)=>{
        return end.getUTCFullYear() - start.getUTCFullYear();
    }, (date)=>{
        return date.getUTCFullYear();
    });
    // An optimized implementation for this simple case.
    utcYear.every = (k)=>{
        return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : timeInterval((date)=>{
            date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
            date.setUTCMonth(0, 1);
            date.setUTCHours(0, 0, 0, 0);
        }, (date, step)=>{
            date.setUTCFullYear(date.getUTCFullYear() + step * k);
        });
    };
    const utcYears = utcYear.range;
    function ticker(year, month, week, day, hour, minute) {
        const tickIntervals = [
            [
                second,
                1,
                durationSecond
            ],
            [
                second,
                5,
                5 * durationSecond
            ],
            [
                second,
                15,
                15 * durationSecond
            ],
            [
                second,
                30,
                30 * durationSecond
            ],
            [
                minute,
                1,
                durationMinute
            ],
            [
                minute,
                5,
                5 * durationMinute
            ],
            [
                minute,
                15,
                15 * durationMinute
            ],
            [
                minute,
                30,
                30 * durationMinute
            ],
            [
                hour,
                1,
                durationHour
            ],
            [
                hour,
                3,
                3 * durationHour
            ],
            [
                hour,
                6,
                6 * durationHour
            ],
            [
                hour,
                12,
                12 * durationHour
            ],
            [
                day,
                1,
                durationDay
            ],
            [
                day,
                2,
                2 * durationDay
            ],
            [
                week,
                1,
                durationWeek
            ],
            [
                month,
                1,
                durationMonth
            ],
            [
                month,
                3,
                3 * durationMonth
            ],
            [
                year,
                1,
                durationYear
            ]
        ];
        function ticks(start, stop, count) {
            const reverse = stop < start;
            if (reverse) [start, stop] = [
                stop,
                start
            ];
            const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
            const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
            return reverse ? ticks.reverse() : ticks;
        }
        function tickInterval(start, stop, count) {
            const target = Math.abs(stop - start) / count;
            const i = bisector(([, , step])=>step).right(tickIntervals, target);
            if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
            if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
            const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
            return t.every(step);
        }
        return [
            ticks,
            tickInterval
        ];
    }
    const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
    const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
    function localDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
            date.setFullYear(d.y);
            return date;
        }
        return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
    }
    function utcDate(d) {
        if (0 <= d.y && d.y < 100) {
            var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
            date.setUTCFullYear(d.y);
            return date;
        }
        return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
    }
    function newDate(y, m, d) {
        return {
            y: y,
            m: m,
            d: d,
            H: 0,
            M: 0,
            S: 0,
            L: 0
        };
    }
    function formatLocale(locale) {
        var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
        var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
        var formats = {
            "a": formatShortWeekday,
            "A": formatWeekday,
            "b": formatShortMonth,
            "B": formatMonth,
            "c": null,
            "d": formatDayOfMonth,
            "e": formatDayOfMonth,
            "f": formatMicroseconds,
            "g": formatYearISO,
            "G": formatFullYearISO,
            "H": formatHour24,
            "I": formatHour12,
            "j": formatDayOfYear,
            "L": formatMilliseconds,
            "m": formatMonthNumber,
            "M": formatMinutes,
            "p": formatPeriod,
            "q": formatQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatSeconds,
            "u": formatWeekdayNumberMonday,
            "U": formatWeekNumberSunday,
            "V": formatWeekNumberISO,
            "w": formatWeekdayNumberSunday,
            "W": formatWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatYear,
            "Y": formatFullYear,
            "Z": formatZone,
            "%": formatLiteralPercent
        };
        var utcFormats = {
            "a": formatUTCShortWeekday,
            "A": formatUTCWeekday,
            "b": formatUTCShortMonth,
            "B": formatUTCMonth,
            "c": null,
            "d": formatUTCDayOfMonth,
            "e": formatUTCDayOfMonth,
            "f": formatUTCMicroseconds,
            "g": formatUTCYearISO,
            "G": formatUTCFullYearISO,
            "H": formatUTCHour24,
            "I": formatUTCHour12,
            "j": formatUTCDayOfYear,
            "L": formatUTCMilliseconds,
            "m": formatUTCMonthNumber,
            "M": formatUTCMinutes,
            "p": formatUTCPeriod,
            "q": formatUTCQuarter,
            "Q": formatUnixTimestamp,
            "s": formatUnixTimestampSeconds,
            "S": formatUTCSeconds,
            "u": formatUTCWeekdayNumberMonday,
            "U": formatUTCWeekNumberSunday,
            "V": formatUTCWeekNumberISO,
            "w": formatUTCWeekdayNumberSunday,
            "W": formatUTCWeekNumberMonday,
            "x": null,
            "X": null,
            "y": formatUTCYear,
            "Y": formatUTCFullYear,
            "Z": formatUTCZone,
            "%": formatLiteralPercent
        };
        var parses = {
            "a": parseShortWeekday,
            "A": parseWeekday,
            "b": parseShortMonth,
            "B": parseMonth,
            "c": parseLocaleDateTime,
            "d": parseDayOfMonth,
            "e": parseDayOfMonth,
            "f": parseMicroseconds,
            "g": parseYear,
            "G": parseFullYear,
            "H": parseHour24,
            "I": parseHour24,
            "j": parseDayOfYear,
            "L": parseMilliseconds,
            "m": parseMonthNumber,
            "M": parseMinutes,
            "p": parsePeriod,
            "q": parseQuarter,
            "Q": parseUnixTimestamp,
            "s": parseUnixTimestampSeconds,
            "S": parseSeconds,
            "u": parseWeekdayNumberMonday,
            "U": parseWeekNumberSunday,
            "V": parseWeekNumberISO,
            "w": parseWeekdayNumberSunday,
            "W": parseWeekNumberMonday,
            "x": parseLocaleDate,
            "X": parseLocaleTime,
            "y": parseYear,
            "Y": parseFullYear,
            "Z": parseZone,
            "%": parseLiteralPercent
        };
        // These recursive directive definitions must be deferred.
        formats.x = newFormat(locale_date, formats);
        formats.X = newFormat(locale_time, formats);
        formats.c = newFormat(locale_dateTime, formats);
        utcFormats.x = newFormat(locale_date, utcFormats);
        utcFormats.X = newFormat(locale_time, utcFormats);
        utcFormats.c = newFormat(locale_dateTime, utcFormats);
        function newFormat(specifier, formats) {
            return function(date) {
                var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
                if (!(date instanceof Date)) date = new Date(+date);
                while(++i < n)if (specifier.charCodeAt(i) === 37) {
                    string.push(specifier.slice(j, i));
                    if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                    else pad = c === "e" ? " " : "0";
                    if (format = formats[c]) c = format(date, pad);
                    string.push(c);
                    j = i + 1;
                }
                string.push(specifier.slice(j, i));
                return string.join("");
            };
        }
        function newParse(specifier, Z) {
            return function(string) {
                var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
                if (i != string.length) return null;
                // If a UNIX timestamp is specified, return it.
                if ("Q" in d) return new Date(d.Q);
                if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
                // If this is utcParse, never use the local timezone.
                if (Z && !("Z" in d)) d.Z = 0;
                // The am-pm flag is 0 for AM, and 1 for PM.
                if ("p" in d) d.H = d.H % 12 + d.p * 12;
                // If the month was not specified, inherit from the quarter.
                if (d.m === undefined) d.m = "q" in d ? d.q : 0;
                // Convert day-of-week and week-of-year to day-of-year.
                if ("V" in d) {
                    if (d.V < 1 || d.V > 53) return null;
                    if (!("w" in d)) d.w = 1;
                    if ("Z" in d) {
                        week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                        week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
                        week = utcDay.offset(week, (d.V - 1) * 7);
                        d.y = week.getUTCFullYear();
                        d.m = week.getUTCMonth();
                        d.d = week.getUTCDate() + (d.w + 6) % 7;
                    } else {
                        week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                        week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
                        week = timeDay.offset(week, (d.V - 1) * 7);
                        d.y = week.getFullYear();
                        d.m = week.getMonth();
                        d.d = week.getDate() + (d.w + 6) % 7;
                    }
                } else if ("W" in d || "U" in d) {
                    if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                    day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                    d.m = 0;
                    d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
                }
                // If a time zone is specified, all fields are interpreted as UTC and then
                // offset according to the specified time zone.
                if ("Z" in d) {
                    d.H += d.Z / 100 | 0;
                    d.M += d.Z % 100;
                    return utcDate(d);
                }
                // Otherwise, all fields are in local time.
                return localDate(d);
            };
        }
        function parseSpecifier(d, specifier, string, j) {
            var i = 0, n = specifier.length, m = string.length, c, parse;
            while(i < n){
                if (j >= m) return -1;
                c = specifier.charCodeAt(i++);
                if (c === 37) {
                    c = specifier.charAt(i++);
                    parse = parses[c in pads ? specifier.charAt(i++) : c];
                    if (!parse || (j = parse(d, string, j)) < 0) return -1;
                } else if (c != string.charCodeAt(j++)) return -1;
            }
            return j;
        }
        function parsePeriod(d, string, i) {
            var n = periodRe.exec(string.slice(i));
            return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortWeekday(d, string, i) {
            var n = shortWeekdayRe.exec(string.slice(i));
            return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseWeekday(d, string, i) {
            var n = weekdayRe.exec(string.slice(i));
            return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseShortMonth(d, string, i) {
            var n = shortMonthRe.exec(string.slice(i));
            return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseMonth(d, string, i) {
            var n = monthRe.exec(string.slice(i));
            return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function parseLocaleDateTime(d, string, i) {
            return parseSpecifier(d, locale_dateTime, string, i);
        }
        function parseLocaleDate(d, string, i) {
            return parseSpecifier(d, locale_date, string, i);
        }
        function parseLocaleTime(d, string, i) {
            return parseSpecifier(d, locale_time, string, i);
        }
        function formatShortWeekday(d) {
            return locale_shortWeekdays[d.getDay()];
        }
        function formatWeekday(d) {
            return locale_weekdays[d.getDay()];
        }
        function formatShortMonth(d) {
            return locale_shortMonths[d.getMonth()];
        }
        function formatMonth(d) {
            return locale_months[d.getMonth()];
        }
        function formatPeriod(d) {
            return locale_periods[+(d.getHours() >= 12)];
        }
        function formatQuarter(d) {
            return 1 + ~~(d.getMonth() / 3);
        }
        function formatUTCShortWeekday(d) {
            return locale_shortWeekdays[d.getUTCDay()];
        }
        function formatUTCWeekday(d) {
            return locale_weekdays[d.getUTCDay()];
        }
        function formatUTCShortMonth(d) {
            return locale_shortMonths[d.getUTCMonth()];
        }
        function formatUTCMonth(d) {
            return locale_months[d.getUTCMonth()];
        }
        function formatUTCPeriod(d) {
            return locale_periods[+(d.getUTCHours() >= 12)];
        }
        function formatUTCQuarter(d) {
            return 1 + ~~(d.getUTCMonth() / 3);
        }
        return {
            format: function(specifier) {
                var f = newFormat(specifier += "", formats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            parse: function(specifier) {
                var p = newParse(specifier += "", false);
                p.toString = function() {
                    return specifier;
                };
                return p;
            },
            utcFormat: function(specifier) {
                var f = newFormat(specifier += "", utcFormats);
                f.toString = function() {
                    return specifier;
                };
                return f;
            },
            utcParse: function(specifier) {
                var p = newParse(specifier += "", true);
                p.toString = function() {
                    return specifier;
                };
                return p;
            }
        };
    }
    var pads = {
        "-": "",
        "_": " ",
        "0": "0"
    }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
    function pad(value, fill, width) {
        var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
        return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
    }
    function requote(s) {
        return s.replace(requoteRe, "\\$&");
    }
    function formatRe(names) {
        return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
    }
    function formatLookup(names) {
        return new Map(names.map((name, i)=>[
                name.toLowerCase(),
                i
            ]));
    }
    function parseWeekdayNumberSunday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.w = +n[0], i + n[0].length) : -1;
    }
    function parseWeekdayNumberMonday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.u = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberSunday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.U = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberISO(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.V = +n[0], i + n[0].length) : -1;
    }
    function parseWeekNumberMonday(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.W = +n[0], i + n[0].length) : -1;
    }
    function parseFullYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 4));
        return n ? (d.y = +n[0], i + n[0].length) : -1;
    }
    function parseYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
    }
    function parseZone(d, string, i) {
        var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
        return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
    }
    function parseQuarter(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 1));
        return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
    }
    function parseMonthNumber(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
    }
    function parseDayOfMonth(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.d = +n[0], i + n[0].length) : -1;
    }
    function parseDayOfYear(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 3));
        return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
    }
    function parseHour24(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.H = +n[0], i + n[0].length) : -1;
    }
    function parseMinutes(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.M = +n[0], i + n[0].length) : -1;
    }
    function parseSeconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 2));
        return n ? (d.S = +n[0], i + n[0].length) : -1;
    }
    function parseMilliseconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 3));
        return n ? (d.L = +n[0], i + n[0].length) : -1;
    }
    function parseMicroseconds(d, string, i) {
        var n = numberRe.exec(string.slice(i, i + 6));
        return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
    }
    function parseLiteralPercent(d, string, i) {
        var n = percentRe.exec(string.slice(i, i + 1));
        return n ? i + n[0].length : -1;
    }
    function parseUnixTimestamp(d, string, i) {
        var n = numberRe.exec(string.slice(i));
        return n ? (d.Q = +n[0], i + n[0].length) : -1;
    }
    function parseUnixTimestampSeconds(d, string, i) {
        var n = numberRe.exec(string.slice(i));
        return n ? (d.s = +n[0], i + n[0].length) : -1;
    }
    function formatDayOfMonth(d, p) {
        return pad(d.getDate(), p, 2);
    }
    function formatHour24(d, p) {
        return pad(d.getHours(), p, 2);
    }
    function formatHour12(d, p) {
        return pad(d.getHours() % 12 || 12, p, 2);
    }
    function formatDayOfYear(d, p) {
        return pad(1 + timeDay.count(timeYear(d), d), p, 3);
    }
    function formatMilliseconds(d, p) {
        return pad(d.getMilliseconds(), p, 3);
    }
    function formatMicroseconds(d, p) {
        return formatMilliseconds(d, p) + "000";
    }
    function formatMonthNumber(d, p) {
        return pad(d.getMonth() + 1, p, 2);
    }
    function formatMinutes(d, p) {
        return pad(d.getMinutes(), p, 2);
    }
    function formatSeconds(d, p) {
        return pad(d.getSeconds(), p, 2);
    }
    function formatWeekdayNumberMonday(d) {
        var day = d.getDay();
        return day === 0 ? 7 : day;
    }
    function formatWeekNumberSunday(d, p) {
        return pad(timeSunday.count(timeYear(d) - 1, d), p, 2);
    }
    function dISO(d) {
        var day = d.getDay();
        return day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
    }
    function formatWeekNumberISO(d, p) {
        d = dISO(d);
        return pad(timeThursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
    }
    function formatWeekdayNumberSunday(d) {
        return d.getDay();
    }
    function formatWeekNumberMonday(d, p) {
        return pad(timeMonday.count(timeYear(d) - 1, d), p, 2);
    }
    function formatYear(d, p) {
        return pad(d.getFullYear() % 100, p, 2);
    }
    function formatYearISO(d, p) {
        d = dISO(d);
        return pad(d.getFullYear() % 100, p, 2);
    }
    function formatFullYear(d, p) {
        return pad(d.getFullYear() % 10000, p, 4);
    }
    function formatFullYearISO(d, p) {
        var day = d.getDay();
        d = day >= 4 || day === 0 ? timeThursday(d) : timeThursday.ceil(d);
        return pad(d.getFullYear() % 10000, p, 4);
    }
    function formatZone(d) {
        var z = d.getTimezoneOffset();
        return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
    }
    function formatUTCDayOfMonth(d, p) {
        return pad(d.getUTCDate(), p, 2);
    }
    function formatUTCHour24(d, p) {
        return pad(d.getUTCHours(), p, 2);
    }
    function formatUTCHour12(d, p) {
        return pad(d.getUTCHours() % 12 || 12, p, 2);
    }
    function formatUTCDayOfYear(d, p) {
        return pad(1 + utcDay.count(utcYear(d), d), p, 3);
    }
    function formatUTCMilliseconds(d, p) {
        return pad(d.getUTCMilliseconds(), p, 3);
    }
    function formatUTCMicroseconds(d, p) {
        return formatUTCMilliseconds(d, p) + "000";
    }
    function formatUTCMonthNumber(d, p) {
        return pad(d.getUTCMonth() + 1, p, 2);
    }
    function formatUTCMinutes(d, p) {
        return pad(d.getUTCMinutes(), p, 2);
    }
    function formatUTCSeconds(d, p) {
        return pad(d.getUTCSeconds(), p, 2);
    }
    function formatUTCWeekdayNumberMonday(d) {
        var dow = d.getUTCDay();
        return dow === 0 ? 7 : dow;
    }
    function formatUTCWeekNumberSunday(d, p) {
        return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
    }
    function UTCdISO(d) {
        var day = d.getUTCDay();
        return day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
    }
    function formatUTCWeekNumberISO(d, p) {
        d = UTCdISO(d);
        return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
    }
    function formatUTCWeekdayNumberSunday(d) {
        return d.getUTCDay();
    }
    function formatUTCWeekNumberMonday(d, p) {
        return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
    }
    function formatUTCYear(d, p) {
        return pad(d.getUTCFullYear() % 100, p, 2);
    }
    function formatUTCYearISO(d, p) {
        d = UTCdISO(d);
        return pad(d.getUTCFullYear() % 100, p, 2);
    }
    function formatUTCFullYear(d, p) {
        return pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function formatUTCFullYearISO(d, p) {
        var day = d.getUTCDay();
        d = day >= 4 || day === 0 ? utcThursday(d) : utcThursday.ceil(d);
        return pad(d.getUTCFullYear() % 10000, p, 4);
    }
    function formatUTCZone() {
        return "+0000";
    }
    function formatLiteralPercent() {
        return "%";
    }
    function formatUnixTimestamp(d) {
        return +d;
    }
    function formatUnixTimestampSeconds(d) {
        return Math.floor(+d / 1000);
    }
    var locale;
    exports1.timeFormat = void 0;
    exports1.timeParse = void 0;
    exports1.utcFormat = void 0;
    exports1.utcParse = void 0;
    defaultLocale({
        dateTime: "%x, %X",
        date: "%-m/%-d/%Y",
        time: "%-I:%M:%S %p",
        periods: [
            "AM",
            "PM"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]
    });
    function defaultLocale(definition) {
        locale = formatLocale(definition);
        exports1.timeFormat = locale.format;
        exports1.timeParse = locale.parse;
        exports1.utcFormat = locale.utcFormat;
        exports1.utcParse = locale.utcParse;
        return locale;
    }
    var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
    function formatIsoNative(date) {
        return date.toISOString();
    }
    var formatIso = Date.prototype.toISOString ? formatIsoNative : exports1.utcFormat(isoSpecifier);
    var formatIso$1 = formatIso;
    function parseIsoNative(string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
    }
    var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : exports1.utcParse(isoSpecifier);
    var parseIso$1 = parseIso;
    function date(t) {
        return new Date(t);
    }
    function number(t) {
        return t instanceof Date ? +t : +new Date(+t);
    }
    function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
        var scale = continuous(), invert = scale.invert, domain = scale.domain;
        var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
        function tickFormat(date) {
            return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
        }
        scale.invert = function(y) {
            return new Date(invert(y));
        };
        scale.domain = function(_) {
            return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
        };
        scale.ticks = function(interval) {
            var d = domain();
            return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
        };
        scale.tickFormat = function(count, specifier) {
            return specifier == null ? tickFormat : format(specifier);
        };
        scale.nice = function(interval) {
            var d = domain();
            if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
            return interval ? domain(nice(d, interval)) : scale;
        };
        scale.copy = function() {
            return copy$1(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
        };
        return scale;
    }
    function time() {
        return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, exports1.timeFormat).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]), arguments);
    }
    function utcTime() {
        return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, exports1.utcFormat).domain([
            Date.UTC(2000, 0, 1),
            Date.UTC(2000, 0, 2)
        ]), arguments);
    }
    function transformer$1() {
        var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = identity$3, clamp = false, unknown;
        function scale(x) {
            return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
                x0,
                x1
            ];
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = !!_, scale) : clamp;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        function range(interpolate) {
            return function(_) {
                var r0, r1;
                return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                    interpolator(0),
                    interpolator(1)
                ];
            };
        }
        scale.range = range(interpolate$2);
        scale.rangeRound = range(interpolateRound);
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t) {
            transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
            return scale;
        };
    }
    function copy(source, target) {
        return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
    }
    function sequential() {
        var scale = linearish(transformer$1()(identity$3));
        scale.copy = function() {
            return copy(scale, sequential());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialLog() {
        var scale = loggish(transformer$1()).domain([
            1,
            10
        ]);
        scale.copy = function() {
            return copy(scale, sequentialLog()).base(scale.base());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialSymlog() {
        var scale = symlogish(transformer$1());
        scale.copy = function() {
            return copy(scale, sequentialSymlog()).constant(scale.constant());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialPow() {
        var scale = powish(transformer$1());
        scale.copy = function() {
            return copy(scale, sequentialPow()).exponent(scale.exponent());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function sequentialSqrt() {
        return sequentialPow.apply(null, arguments).exponent(0.5);
    }
    function sequentialQuantile() {
        var domain = [], interpolator = identity$3;
        function scale(x) {
            if (x != null && !isNaN(x = +x)) return interpolator((bisect(domain, x, 1) - 1) / (domain.length - 1));
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain.slice();
            domain = [];
            for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
            domain.sort(ascending$3);
            return scale;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        scale.range = function() {
            return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
        };
        scale.quantiles = function(n) {
            return Array.from({
                length: n + 1
            }, (_, i)=>quantile$1(domain, i / n));
        };
        scale.copy = function() {
            return sequentialQuantile(interpolator).domain(domain);
        };
        return initInterpolator.apply(scale, arguments);
    }
    function transformer() {
        var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = identity$3, transform, clamp = false, unknown;
        function scale(x) {
            return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
        }
        scale.domain = function(_) {
            return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
                x0,
                x1,
                x2
            ];
        };
        scale.clamp = function(_) {
            return arguments.length ? (clamp = !!_, scale) : clamp;
        };
        scale.interpolator = function(_) {
            return arguments.length ? (interpolator = _, scale) : interpolator;
        };
        function range(interpolate) {
            return function(_) {
                var r0, r1, r2;
                return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [
                    r0,
                    r1,
                    r2
                ]), scale) : [
                    interpolator(0),
                    interpolator(0.5),
                    interpolator(1)
                ];
            };
        }
        scale.range = range(interpolate$2);
        scale.rangeRound = range(interpolateRound);
        scale.unknown = function(_) {
            return arguments.length ? (unknown = _, scale) : unknown;
        };
        return function(t) {
            transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
            return scale;
        };
    }
    function diverging$1() {
        var scale = linearish(transformer()(identity$3));
        scale.copy = function() {
            return copy(scale, diverging$1());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingLog() {
        var scale = loggish(transformer()).domain([
            0.1,
            1,
            10
        ]);
        scale.copy = function() {
            return copy(scale, divergingLog()).base(scale.base());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingSymlog() {
        var scale = symlogish(transformer());
        scale.copy = function() {
            return copy(scale, divergingSymlog()).constant(scale.constant());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingPow() {
        var scale = powish(transformer());
        scale.copy = function() {
            return copy(scale, divergingPow()).exponent(scale.exponent());
        };
        return initInterpolator.apply(scale, arguments);
    }
    function divergingSqrt() {
        return divergingPow.apply(null, arguments).exponent(0.5);
    }
    function colors(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    }
    var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
    var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
    var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
    var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
    var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
    var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
    var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
    var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
    var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
    var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
    var ramp$1 = (scheme)=>rgbBasis(scheme[scheme.length - 1]);
    var scheme$q = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map(colors);
    var BrBG = ramp$1(scheme$q);
    var scheme$p = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map(colors);
    var PRGn = ramp$1(scheme$p);
    var scheme$o = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map(colors);
    var PiYG = ramp$1(scheme$o);
    var scheme$n = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map(colors);
    var PuOr = ramp$1(scheme$n);
    var scheme$m = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map(colors);
    var RdBu = ramp$1(scheme$m);
    var scheme$l = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map(colors);
    var RdGy = ramp$1(scheme$l);
    var scheme$k = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map(colors);
    var RdYlBu = ramp$1(scheme$k);
    var scheme$j = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map(colors);
    var RdYlGn = ramp$1(scheme$j);
    var scheme$i = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map(colors);
    var Spectral = ramp$1(scheme$i);
    var scheme$h = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map(colors);
    var BuGn = ramp$1(scheme$h);
    var scheme$g = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map(colors);
    var BuPu = ramp$1(scheme$g);
    var scheme$f = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map(colors);
    var GnBu = ramp$1(scheme$f);
    var scheme$e = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map(colors);
    var OrRd = ramp$1(scheme$e);
    var scheme$d = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map(colors);
    var PuBuGn = ramp$1(scheme$d);
    var scheme$c = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map(colors);
    var PuBu = ramp$1(scheme$c);
    var scheme$b = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map(colors);
    var PuRd = ramp$1(scheme$b);
    var scheme$a = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map(colors);
    var RdPu = ramp$1(scheme$a);
    var scheme$9 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map(colors);
    var YlGnBu = ramp$1(scheme$9);
    var scheme$8 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map(colors);
    var YlGn = ramp$1(scheme$8);
    var scheme$7 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map(colors);
    var YlOrBr = ramp$1(scheme$7);
    var scheme$6 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map(colors);
    var YlOrRd = ramp$1(scheme$6);
    var scheme$5 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map(colors);
    var Blues = ramp$1(scheme$5);
    var scheme$4 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map(colors);
    var Greens = ramp$1(scheme$4);
    var scheme$3 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map(colors);
    var Greys = ramp$1(scheme$3);
    var scheme$2 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map(colors);
    var Purples = ramp$1(scheme$2);
    var scheme$1 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map(colors);
    var Reds = ramp$1(scheme$1);
    var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map(colors);
    var Oranges = ramp$1(scheme);
    function cividis(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    }
    var cubehelix = cubehelixLong(cubehelix$3(300, 0.5, 0.0), cubehelix$3(-240, 0.5, 1.0));
    var warm = cubehelixLong(cubehelix$3(-100, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
    var cool = cubehelixLong(cubehelix$3(260, 0.75, 0.35), cubehelix$3(80, 1.50, 0.8));
    var c$2 = cubehelix$3();
    function rainbow(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c$2.h = 360 * t - 100;
        c$2.s = 1.5 - 1.5 * ts;
        c$2.l = 0.8 - 0.9 * ts;
        return c$2 + "";
    }
    var c$1 = rgb(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;
    function sinebow(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c$1.r = 255 * (x = Math.sin(t)) * x;
        c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c$1 + "";
    }
    function turbo(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    }
    function ramp(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    }
    var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
    var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
    var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
    var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
    function constant$1(x) {
        return function constant() {
            return x;
        };
    }
    const abs = Math.abs;
    const atan2 = Math.atan2;
    const cos = Math.cos;
    const max = Math.max;
    const min = Math.min;
    const sin = Math.sin;
    const sqrt = Math.sqrt;
    const epsilon = 1e-12;
    const pi = Math.PI;
    const halfPi = pi / 2;
    const tau = 2 * pi;
    function acos(x) {
        return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
    }
    function asin(x) {
        return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
    }
    function withPath(shape) {
        let digits = 3;
        shape.digits = function(_) {
            if (!arguments.length) return digits;
            if (_ == null) digits = null;
            else {
                const d = Math.floor(_);
                if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
                digits = d;
            }
            return shape;
        };
        return ()=>new Path$1(digits);
    }
    function arcInnerRadius(d) {
        return d.innerRadius;
    }
    function arcOuterRadius(d) {
        return d.outerRadius;
    }
    function arcStartAngle(d) {
        return d.startAngle;
    }
    function arcEndAngle(d) {
        return d.endAngle;
    }
    function arcPadAngle(d) {
        return d && d.padAngle; // Note: optional!
    }
    function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
        var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
        if (t * t < epsilon) return;
        t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
        return [
            x0 + t * x10,
            y0 + t * y10
        ];
    }
    // Compute perpendicular offset line of length rc.
    // http://mathworld.wolfram.com/Circle-LineIntersection.html
    function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
        var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
        // Pick the closer of the two intersection points.
        // TODO Is there a faster way to determine which intersection to use?
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
        return {
            cx: cx0,
            cy: cy0,
            x01: -ox,
            y01: -oy,
            x11: cx0 * (r1 / r - 1),
            y11: cy0 * (r1 / r - 1)
        };
    }
    function arc() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$1(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = withPath(arc);
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = path();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > epsilon)) context.moveTo(0, 0);
            else if (da > tau - epsilon) {
                context.moveTo(r1 * cos(a0), r1 * sin(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > epsilon) {
                    context.moveTo(r0 * cos(a1), r0 * sin(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > epsilon) {
                    var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
                    if ((da0 -= p0 * 2) > epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
                // Apply rounded corners?
                if (rc > epsilon) {
                    var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
                    // Restrict the corner radius according to the sector angle. If this
                    // intersection fails, it’s probably because the arc is too small, so
                    // disable the corner radius entirely.
                    if (da < pi) {
                        if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
                            rc0 = min(rc, (r0 - lc) / (kc - 1));
                            rc1 = min(rc, (r1 - lc) / (kc + 1));
                        } else rc0 = rc1 = 0;
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > epsilon)) context.moveTo(x01, y01);
                else if (rc1 > epsilon) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
                else if (rc0 > epsilon) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
            return [
                cos(a) * r,
                sin(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    }
    var slice = Array.prototype.slice;
    function array(x) {
        return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
         : Array.from(x); // Map, Set, iterable, string, or anything else
    }
    function Linear(context) {
        this._context = context;
    }
    Linear.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    this._context.lineTo(x, y);
                    break;
            }
        }
    };
    function curveLinear(context) {
        return new Linear(context);
    }
    function x(p) {
        return p[0];
    }
    function y(p) {
        return p[1];
    }
    function line(x$1, y$1) {
        var defined = constant$1(true), context = null, curve = curveLinear, output = null, path = withPath(line);
        x$1 = typeof x$1 === "function" ? x$1 : x$1 === undefined ? x : constant$1(x$1);
        y$1 = typeof y$1 === "function" ? y$1 : y$1 === undefined ? y : constant$1(y$1);
        function line(data) {
            var i, n = (data = array(data)).length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$1;
        };
        line.y = function(_) {
            return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$1;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    }
    function area(x0, y0, y1) {
        var x1 = null, defined = constant$1(true), context = null, curve = curveLinear, output = null, path = withPath(area);
        x0 = typeof x0 === "function" ? x0 : x0 === undefined ? x : constant$1(+x0);
        y0 = typeof y0 === "function" ? y0 : y0 === undefined ? constant$1(0) : constant$1(+y0);
        y1 = typeof y1 === "function" ? y1 : y1 === undefined ? y : constant$1(+y1);
        function area(data) {
            var i, j, k, n = (data = array(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = path());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return line().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    }
    function descending$1(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function identity$1(d) {
        return d;
    }
    function pie() {
        var value = identity$1, sortValues = descending$1, sort = null, startAngle = constant$1(0), endAngle = constant$1(tau), padAngle = constant$1(0);
        function pie(data) {
            var i, n = (data = array(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
        };
        return pie;
    }
    var curveRadialLinear = curveRadial(curveLinear);
    function Radial(curve) {
        this._curve = curve;
    }
    Radial.prototype = {
        areaStart: function() {
            this._curve.areaStart();
        },
        areaEnd: function() {
            this._curve.areaEnd();
        },
        lineStart: function() {
            this._curve.lineStart();
        },
        lineEnd: function() {
            this._curve.lineEnd();
        },
        point: function(a, r) {
            this._curve.point(r * Math.sin(a), r * -Math.cos(a));
        }
    };
    function curveRadial(curve) {
        function radial(context) {
            return new Radial(curve(context));
        }
        radial._curve = curve;
        return radial;
    }
    function lineRadial(l) {
        var c = l.curve;
        l.angle = l.x, delete l.x;
        l.radius = l.y, delete l.y;
        l.curve = function(_) {
            return arguments.length ? c(curveRadial(_)) : c()._curve;
        };
        return l;
    }
    function lineRadial$1() {
        return lineRadial(line().curve(curveRadialLinear));
    }
    function areaRadial() {
        var a = area().curve(curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return lineRadial(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return lineRadial(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return lineRadial(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return lineRadial(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c(curveRadial(_)) : c()._curve;
        };
        return a;
    }
    function pointRadial(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    }
    class Bump {
        constructor(context, x){
            this._context = context;
            this._x = x;
        }
        areaStart() {
            this._line = 0;
        }
        areaEnd() {
            this._line = NaN;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        }
        point(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    if (this._line) this._context.lineTo(x, y);
                    else this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                    else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                    break;
            }
            this._x0 = x, this._y0 = y;
        }
    }
    class BumpRadial {
        constructor(context){
            this._context = context;
        }
        lineStart() {
            this._point = 0;
        }
        lineEnd() {}
        point(x, y) {
            x = +x, y = +y;
            if (this._point === 0) this._point = 1;
            else {
                const p0 = pointRadial(this._x0, this._y0);
                const p1 = pointRadial(this._x0, this._y0 = (this._y0 + y) / 2);
                const p2 = pointRadial(x, this._y0);
                const p3 = pointRadial(x, y);
                this._context.moveTo(...p0);
                this._context.bezierCurveTo(...p1, ...p2, ...p3);
            }
            this._x0 = x, this._y0 = y;
        }
    }
    function bumpX(context) {
        return new Bump(context, true);
    }
    function bumpY(context) {
        return new Bump(context, false);
    }
    function bumpRadial(context) {
        return new BumpRadial(context);
    }
    function linkSource(d) {
        return d.source;
    }
    function linkTarget(d) {
        return d.target;
    }
    function link(curve) {
        let source = linkSource, target = linkTarget, x$1 = x, y$1 = y, context = null, output = null, path = withPath(link);
        function link() {
            let buffer;
            const argv = slice.call(arguments);
            const s = source.apply(this, argv);
            const t = target.apply(this, argv);
            if (context == null) output = curve(buffer = path());
            output.lineStart();
            argv[0] = s, output.point(+x$1.apply(this, argv), +y$1.apply(this, argv));
            argv[0] = t, output.point(+x$1.apply(this, argv), +y$1.apply(this, argv));
            output.lineEnd();
            if (buffer) return output = null, buffer + "" || null;
        }
        link.source = function(_) {
            return arguments.length ? (source = _, link) : source;
        };
        link.target = function(_) {
            return arguments.length ? (target = _, link) : target;
        };
        link.x = function(_) {
            return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant$1(+_), link) : x$1;
        };
        link.y = function(_) {
            return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant$1(+_), link) : y$1;
        };
        link.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
        };
        return link;
    }
    function linkHorizontal() {
        return link(bumpX);
    }
    function linkVertical() {
        return link(bumpY);
    }
    function linkRadial() {
        const l = link(bumpRadial);
        l.angle = l.x, delete l.x;
        l.radius = l.y, delete l.y;
        return l;
    }
    const sqrt3$2 = sqrt(3);
    var asterisk = {
        draw (context, size) {
            const r = sqrt(size + min(size / 28, 0.75)) * 0.59436;
            const t = r / 2;
            const u = t * sqrt3$2;
            context.moveTo(0, r);
            context.lineTo(0, -r);
            context.moveTo(-u, -t);
            context.lineTo(u, t);
            context.moveTo(-u, t);
            context.lineTo(u, -t);
        }
    };
    var circle = {
        draw (context, size) {
            const r = sqrt(size / pi);
            context.moveTo(r, 0);
            context.arc(0, 0, r, 0, tau);
        }
    };
    var cross = {
        draw (context, size) {
            const r = sqrt(size / 5) / 2;
            context.moveTo(-3 * r, -r);
            context.lineTo(-r, -r);
            context.lineTo(-r, -3 * r);
            context.lineTo(r, -3 * r);
            context.lineTo(r, -r);
            context.lineTo(3 * r, -r);
            context.lineTo(3 * r, r);
            context.lineTo(r, r);
            context.lineTo(r, 3 * r);
            context.lineTo(-r, 3 * r);
            context.lineTo(-r, r);
            context.lineTo(-3 * r, r);
            context.closePath();
        }
    };
    const tan30 = sqrt(1 / 3);
    const tan30_2 = tan30 * 2;
    var diamond = {
        draw (context, size) {
            const y = sqrt(size / tan30_2);
            const x = y * tan30;
            context.moveTo(0, -y);
            context.lineTo(x, 0);
            context.lineTo(0, y);
            context.lineTo(-x, 0);
            context.closePath();
        }
    };
    var diamond2 = {
        draw (context, size) {
            const r = sqrt(size) * 0.62625;
            context.moveTo(0, -r);
            context.lineTo(r, 0);
            context.lineTo(0, r);
            context.lineTo(-r, 0);
            context.closePath();
        }
    };
    var plus = {
        draw (context, size) {
            const r = sqrt(size - min(size / 7, 2)) * 0.87559;
            context.moveTo(-r, 0);
            context.lineTo(r, 0);
            context.moveTo(0, r);
            context.lineTo(0, -r);
        }
    };
    var square = {
        draw (context, size) {
            const w = sqrt(size);
            const x = -w / 2;
            context.rect(x, x, w, w);
        }
    };
    var square2 = {
        draw (context, size) {
            const r = sqrt(size) * 0.4431;
            context.moveTo(r, r);
            context.lineTo(r, -r);
            context.lineTo(-r, -r);
            context.lineTo(-r, r);
            context.closePath();
        }
    };
    const ka = 0.89081309152928522810;
    const kr = sin(pi / 10) / sin(7 * pi / 10);
    const kx = sin(tau / 10) * kr;
    const ky = -cos(tau / 10) * kr;
    var star = {
        draw (context, size) {
            const r = sqrt(size * ka);
            const x = kx * r;
            const y = ky * r;
            context.moveTo(0, -r);
            context.lineTo(x, y);
            for(let i = 1; i < 5; ++i){
                const a = tau * i / 5;
                const c = cos(a);
                const s = sin(a);
                context.lineTo(s * r, -c * r);
                context.lineTo(c * x - s * y, s * x + c * y);
            }
            context.closePath();
        }
    };
    const sqrt3$1 = sqrt(3);
    var triangle = {
        draw (context, size) {
            const y = -sqrt(size / (sqrt3$1 * 3));
            context.moveTo(0, y * 2);
            context.lineTo(-sqrt3$1 * y, -y);
            context.lineTo(sqrt3$1 * y, -y);
            context.closePath();
        }
    };
    const sqrt3 = sqrt(3);
    var triangle2 = {
        draw (context, size) {
            const s = sqrt(size) * 0.6824;
            const t = s / 2;
            const u = s * sqrt3 / 2; // cos(Math.PI / 6)
            context.moveTo(0, -s);
            context.lineTo(u, t);
            context.lineTo(-u, t);
            context.closePath();
        }
    };
    const c = -0.5;
    const s = sqrt(3) / 2;
    const k = 1 / sqrt(12);
    const a = (k / 2 + 1) * 3;
    var wye = {
        draw (context, size) {
            const r = sqrt(size / a);
            const x0 = r / 2, y0 = r * k;
            const x1 = x0, y1 = r * k + r;
            const x2 = -x1, y2 = y1;
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.lineTo(x2, y2);
            context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
            context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
            context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
            context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
            context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
            context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
            context.closePath();
        }
    };
    var times = {
        draw (context, size) {
            const r = sqrt(size - min(size / 6, 1.7)) * 0.6189;
            context.moveTo(-r, -r);
            context.lineTo(r, r);
            context.moveTo(-r, r);
            context.lineTo(r, -r);
        }
    };
    // These symbols are designed to be filled.
    const symbolsFill = [
        circle,
        cross,
        diamond,
        square,
        star,
        triangle,
        wye
    ];
    // These symbols are designed to be stroked (with a width of 1.5px and round caps).
    const symbolsStroke = [
        circle,
        plus,
        times,
        triangle2,
        asterisk,
        square2,
        diamond2
    ];
    function Symbol$1(type, size) {
        let context = null, path = withPath(symbol);
        type = typeof type === "function" ? type : constant$1(type || circle);
        size = typeof size === "function" ? size : constant$1(size === undefined ? 64 : +size);
        function symbol() {
            let buffer;
            if (!context) context = buffer = path();
            type.apply(this, arguments).draw(context, +size.apply(this, arguments));
            if (buffer) return context = null, buffer + "" || null;
        }
        symbol.type = function(_) {
            return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
        };
        symbol.size = function(_) {
            return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
        };
        symbol.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, symbol) : context;
        };
        return symbol;
    }
    function noop() {}
    function point$3(that, x, y) {
        that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
    }
    function Basis(context) {
        this._context = context;
    }
    Basis.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 3:
                    point$3(this, this._x1, this._y1); // falls through
                case 2:
                    this._context.lineTo(this._x1, this._y1);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basis(context) {
        return new Basis(context);
    }
    function BasisClosed(context) {
        this._context = context;
    }
    BasisClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x2, this._y2);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                    this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x2, this._y2);
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x2 = x, this._y2 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._x3 = x, this._y3 = y;
                    break;
                case 2:
                    this._point = 3;
                    this._x4 = x, this._y4 = y;
                    this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                    break;
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basisClosed(context) {
        return new BasisClosed(context);
    }
    function BasisOpen(context) {
        this._context = context;
    }
    BasisOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                    this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$3(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
        }
    };
    function basisOpen(context) {
        return new BasisOpen(context);
    }
    function Bundle(context, beta) {
        this._basis = new Basis(context);
        this._beta = beta;
    }
    Bundle.prototype = {
        lineStart: function() {
            this._x = [];
            this._y = [];
            this._basis.lineStart();
        },
        lineEnd: function() {
            var x = this._x, y = this._y, j = x.length - 1;
            if (j > 0) {
                var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
                while(++i <= j){
                    t = i / j;
                    this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
                }
            }
            this._x = this._y = null;
            this._basis.lineEnd();
        },
        point: function(x, y) {
            this._x.push(+x);
            this._y.push(+y);
        }
    };
    var bundle = function custom(beta) {
        function bundle(context) {
            return beta === 1 ? new Basis(context) : new Bundle(context, beta);
        }
        bundle.beta = function(beta) {
            return custom(+beta);
        };
        return bundle;
    }(0.85);
    function point$2(that, x, y) {
        that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
    }
    function Cardinal(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    Cardinal.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x2, this._y2);
                    break;
                case 3:
                    point$2(this, this._x1, this._y1);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    this._x1 = x, this._y1 = y;
                    break;
                case 2:
                    this._point = 3; // falls through
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinal = function custom(tension) {
        function cardinal(context) {
            return new Cardinal(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function CardinalClosed(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    CardinalClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.lineTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    this.point(this._x5, this._y5);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x3 = x, this._y3 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._context.moveTo(this._x4 = x, this._y4 = y);
                    break;
                case 2:
                    this._point = 3;
                    this._x5 = x, this._y5 = y;
                    break;
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinalClosed = function custom(tension) {
        function cardinal(context) {
            return new CardinalClosed(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function CardinalOpen(context, tension) {
        this._context = context;
        this._k = (1 - tension) / 6;
    }
    CardinalOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$2(this, x, y);
                    break;
            }
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var cardinalOpen = function custom(tension) {
        function cardinal(context) {
            return new CardinalOpen(context, tension);
        }
        cardinal.tension = function(tension) {
            return custom(+tension);
        };
        return cardinal;
    }(0);
    function point$1(that, x, y) {
        var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
        if (that._l01_a > epsilon) {
            var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
            x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
            y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
        }
        if (that._l23_a > epsilon) {
            var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
            x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
            y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
        }
        that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
    }
    function CatmullRom(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRom.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x2, this._y2);
                    break;
                case 3:
                    this.point(this._x2, this._y2);
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3; // falls through
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRom = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function CatmullRomClosed(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRomClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 1:
                    this._context.moveTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 2:
                    this._context.lineTo(this._x3, this._y3);
                    this._context.closePath();
                    break;
                case 3:
                    this.point(this._x3, this._y3);
                    this.point(this._x4, this._y4);
                    this.point(this._x5, this._y5);
                    break;
            }
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._x3 = x, this._y3 = y;
                    break;
                case 1:
                    this._point = 2;
                    this._context.moveTo(this._x4 = x, this._y4 = y);
                    break;
                case 2:
                    this._point = 3;
                    this._x5 = x, this._y5 = y;
                    break;
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRomClosed = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function CatmullRomOpen(context, alpha) {
        this._context = context;
        this._alpha = alpha;
    }
    CatmullRomOpen.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
            this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
        },
        lineEnd: function() {
            if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) {
                var x23 = this._x2 - x, y23 = this._y2 - y;
                this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
            }
            switch(this._point){
                case 0:
                    this._point = 1;
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                    break;
                case 3:
                    this._point = 4; // falls through
                default:
                    point$1(this, x, y);
                    break;
            }
            this._l01_a = this._l12_a, this._l12_a = this._l23_a;
            this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
            this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
            this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
        }
    };
    var catmullRomOpen = function custom(alpha) {
        function catmullRom(context) {
            return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
        }
        catmullRom.alpha = function(alpha) {
            return custom(+alpha);
        };
        return catmullRom;
    }(0.5);
    function LinearClosed(context) {
        this._context = context;
    }
    LinearClosed.prototype = {
        areaStart: noop,
        areaEnd: noop,
        lineStart: function() {
            this._point = 0;
        },
        lineEnd: function() {
            if (this._point) this._context.closePath();
        },
        point: function(x, y) {
            x = +x, y = +y;
            if (this._point) this._context.lineTo(x, y);
            else this._point = 1, this._context.moveTo(x, y);
        }
    };
    function linearClosed(context) {
        return new LinearClosed(context);
    }
    function sign(x) {
        return x < 0 ? -1 : 1;
    }
    // Calculate the slopes of the tangents (Hermite-type interpolation) based on
    // the following paper: Steffen, M. 1990. A Simple Method for Monotonic
    // Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
    // NOV(II), P. 443, 1990.
    function slope3(that, x2, y2) {
        var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
        return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
    }
    // Calculate a one-sided slope.
    function slope2(that, t) {
        var h = that._x1 - that._x0;
        return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
    }
    // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
    // "you can express cubic Hermite interpolation in terms of cubic Bézier curves
    // with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
    function point(that, t0, t1) {
        var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
        that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
    }
    function MonotoneX(context) {
        this._context = context;
    }
    MonotoneX.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            switch(this._point){
                case 2:
                    this._context.lineTo(this._x1, this._y1);
                    break;
                case 3:
                    point(this, this._t0, slope2(this, this._t0));
                    break;
            }
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            this._line = 1 - this._line;
        },
        point: function(x, y) {
            var t1 = NaN;
            x = +x, y = +y;
            if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2;
                    break;
                case 2:
                    this._point = 3;
                    point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                    break;
                default:
                    point(this, this._t0, t1 = slope3(this, x, y));
                    break;
            }
            this._x0 = this._x1, this._x1 = x;
            this._y0 = this._y1, this._y1 = y;
            this._t0 = t1;
        }
    };
    function MonotoneY(context) {
        this._context = new ReflectContext(context);
    }
    (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
        MonotoneX.prototype.point.call(this, y, x);
    };
    function ReflectContext(context) {
        this._context = context;
    }
    ReflectContext.prototype = {
        moveTo: function(x, y) {
            this._context.moveTo(y, x);
        },
        closePath: function() {
            this._context.closePath();
        },
        lineTo: function(x, y) {
            this._context.lineTo(y, x);
        },
        bezierCurveTo: function(x1, y1, x2, y2, x, y) {
            this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
        }
    };
    function monotoneX(context) {
        return new MonotoneX(context);
    }
    function monotoneY(context) {
        return new MonotoneY(context);
    }
    function Natural(context) {
        this._context = context;
    }
    Natural.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x = [];
            this._y = [];
        },
        lineEnd: function() {
            var x = this._x, y = this._y, n = x.length;
            if (n) {
                this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
                if (n === 2) this._context.lineTo(x[1], y[1]);
                else {
                    var px = controlPoints(x), py = controlPoints(y);
                    for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
                }
            }
            if (this._line || this._line !== 0 && n === 1) this._context.closePath();
            this._line = 1 - this._line;
            this._x = this._y = null;
        },
        point: function(x, y) {
            this._x.push(+x);
            this._y.push(+y);
        }
    };
    // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
    function controlPoints(x) {
        var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
        a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
        for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
        a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
        for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
        a[n - 1] = r[n - 1] / b[n - 1];
        for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
        b[n - 1] = (x[n] + a[n - 1]) / 2;
        for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
        return [
            a,
            b
        ];
    }
    function natural(context) {
        return new Natural(context);
    }
    function Step(context, t) {
        this._context = context;
        this._t = t;
    }
    Step.prototype = {
        areaStart: function() {
            this._line = 0;
        },
        areaEnd: function() {
            this._line = NaN;
        },
        lineStart: function() {
            this._x = this._y = NaN;
            this._point = 0;
        },
        lineEnd: function() {
            if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
            if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
            if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
        },
        point: function(x, y) {
            x = +x, y = +y;
            switch(this._point){
                case 0:
                    this._point = 1;
                    this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                    break;
                case 1:
                    this._point = 2; // falls through
                default:
                    if (this._t <= 0) {
                        this._context.lineTo(this._x, y);
                        this._context.lineTo(x, y);
                    } else {
                        var x1 = this._x * (1 - this._t) + x * this._t;
                        this._context.lineTo(x1, this._y);
                        this._context.lineTo(x1, y);
                    }
                    break;
            }
            this._x = x, this._y = y;
        }
    };
    function step(context) {
        return new Step(context, 0.5);
    }
    function stepBefore(context) {
        return new Step(context, 0);
    }
    function stepAfter(context) {
        return new Step(context, 1);
    }
    function none$1(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    }
    function none(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    }
    function stackValue(d, key) {
        return d[key];
    }
    function stackSeries(key) {
        const series = [];
        series.key = key;
        return series;
    }
    function stack() {
        var keys = constant$1([]), order = none, offset = none$1, value = stackValue;
        function stack(data) {
            var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
            for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
                0,
                +value(d, sz[i].key, j, data)
            ]).data = d;
            for(i = 0, oz = array(order(sz)); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? none : typeof _ === "function" ? _ : constant$1(Array.from(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? none$1 : _, stack) : offset;
        };
        return stack;
    }
    function expand(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        none$1(series, order);
    }
    function diverging(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    }
    function silhouette(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        none$1(series, order);
    }
    function wiggle(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        none$1(series, order);
    }
    function appearance(series) {
        var peaks = series.map(peak);
        return none(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    }
    function peak(series) {
        var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
        while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
        return j;
    }
    function ascending(series) {
        var sums = series.map(sum);
        return none(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    }
    function sum(series) {
        var s = 0, i = -1, n = series.length, v;
        while(++i < n)if (v = +series[i][1]) s += v;
        return s;
    }
    function descending(series) {
        return ascending(series).reverse();
    }
    function insideOut(series) {
        var n = series.length, i, j, sums = series.map(sum), order = appearance(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    }
    function reverse(series) {
        return none(series).reverse();
    }
    var constant = (x)=>()=>x;
    function ZoomEvent(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
        Object.defineProperties(this, {
            type: {
                value: type,
                enumerable: true,
                configurable: true
            },
            sourceEvent: {
                value: sourceEvent,
                enumerable: true,
                configurable: true
            },
            target: {
                value: target,
                enumerable: true,
                configurable: true
            },
            transform: {
                value: transform,
                enumerable: true,
                configurable: true
            },
            _: {
                value: dispatch
            }
        });
    }
    function Transform(k, x, y) {
        this.k = k;
        this.x = x;
        this.y = y;
    }
    Transform.prototype = {
        constructor: Transform,
        scale: function(k) {
            return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
        },
        translate: function(x, y) {
            return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
        },
        apply: function(point) {
            return [
                point[0] * this.k + this.x,
                point[1] * this.k + this.y
            ];
        },
        applyX: function(x) {
            return x * this.k + this.x;
        },
        applyY: function(y) {
            return y * this.k + this.y;
        },
        invert: function(location) {
            return [
                (location[0] - this.x) / this.k,
                (location[1] - this.y) / this.k
            ];
        },
        invertX: function(x) {
            return (x - this.x) / this.k;
        },
        invertY: function(y) {
            return (y - this.y) / this.k;
        },
        rescaleX: function(x) {
            return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
        },
        rescaleY: function(y) {
            return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
        },
        toString: function() {
            return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
        }
    };
    var identity = new Transform(1, 0, 0);
    transform.prototype = Transform.prototype;
    function transform(node) {
        while(!node.__zoom)if (!(node = node.parentNode)) return identity;
        return node.__zoom;
    }
    function nopropagation(event) {
        event.stopImmediatePropagation();
    }
    function noevent(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    // Ignore right-click, since that should open the context menu.
    // except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
    function defaultFilter(event) {
        return (!event.ctrlKey || event.type === 'wheel') && !event.button;
    }
    function defaultExtent() {
        var e = this;
        if (e instanceof SVGElement) {
            e = e.ownerSVGElement || e;
            if (e.hasAttribute("viewBox")) {
                e = e.viewBox.baseVal;
                return [
                    [
                        e.x,
                        e.y
                    ],
                    [
                        e.x + e.width,
                        e.y + e.height
                    ]
                ];
            }
            return [
                [
                    0,
                    0
                ],
                [
                    e.width.baseVal.value,
                    e.height.baseVal.value
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.clientWidth,
                e.clientHeight
            ]
        ];
    }
    function defaultTransform() {
        return this.__zoom || identity;
    }
    function defaultWheelDelta(event) {
        return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
    }
    function defaultTouchable() {
        return navigator.maxTouchPoints || "ontouchstart" in this;
    }
    function defaultConstrain(transform, extent, translateExtent) {
        var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
        return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
    }
    function zoom() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = interpolateZoom, listeners = dispatch("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain(identity.translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = select(this.that).datum();
                listeners.call(type, this.that, new ZoomEvent(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type: type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = pointer(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                interrupt(this);
                g.start();
            }
            noevent(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = select(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = pointer(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            dragDisable(event.view);
            nopropagation(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            interrupt(this);
            g.start();
            function mousemoved(event) {
                noevent(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = pointer(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                yesdrag(event.view, g.moved);
                noevent(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = pointer(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            noevent(event);
            if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0, event);
            else select(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            nopropagation(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = pointer(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                interrupt(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            noevent(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = pointer(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            nopropagation(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = pointer(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = select(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : constant(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : constant(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : constant(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : constant([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    }
    exports1.Adder = Adder;
    exports1.Delaunay = Delaunay;
    exports1.FormatSpecifier = FormatSpecifier;
    exports1.InternMap = InternMap;
    exports1.InternSet = InternSet;
    exports1.Node = Node$1;
    exports1.Path = Path$1;
    exports1.Voronoi = Voronoi;
    exports1.ZoomTransform = Transform;
    exports1.active = active;
    exports1.arc = arc;
    exports1.area = area;
    exports1.areaRadial = areaRadial;
    exports1.ascending = ascending$3;
    exports1.autoType = autoType;
    exports1.axisBottom = axisBottom;
    exports1.axisLeft = axisLeft;
    exports1.axisRight = axisRight;
    exports1.axisTop = axisTop;
    exports1.bin = bin;
    exports1.bisect = bisect;
    exports1.bisectCenter = bisectCenter;
    exports1.bisectLeft = bisectLeft;
    exports1.bisectRight = bisectRight;
    exports1.bisector = bisector;
    exports1.blob = blob;
    exports1.blur = blur;
    exports1.blur2 = blur2;
    exports1.blurImage = blurImage;
    exports1.brush = brush;
    exports1.brushSelection = brushSelection;
    exports1.brushX = brushX;
    exports1.brushY = brushY;
    exports1.buffer = buffer;
    exports1.chord = chord;
    exports1.chordDirected = chordDirected;
    exports1.chordTranspose = chordTranspose;
    exports1.cluster = cluster;
    exports1.color = color;
    exports1.contourDensity = density;
    exports1.contours = Contours;
    exports1.count = count$1;
    exports1.create = create$1;
    exports1.creator = creator;
    exports1.cross = cross$2;
    exports1.csv = csv;
    exports1.csvFormat = csvFormat;
    exports1.csvFormatBody = csvFormatBody;
    exports1.csvFormatRow = csvFormatRow;
    exports1.csvFormatRows = csvFormatRows;
    exports1.csvFormatValue = csvFormatValue;
    exports1.csvParse = csvParse;
    exports1.csvParseRows = csvParseRows;
    exports1.cubehelix = cubehelix$3;
    exports1.cumsum = cumsum;
    exports1.curveBasis = basis;
    exports1.curveBasisClosed = basisClosed;
    exports1.curveBasisOpen = basisOpen;
    exports1.curveBumpX = bumpX;
    exports1.curveBumpY = bumpY;
    exports1.curveBundle = bundle;
    exports1.curveCardinal = cardinal;
    exports1.curveCardinalClosed = cardinalClosed;
    exports1.curveCardinalOpen = cardinalOpen;
    exports1.curveCatmullRom = catmullRom;
    exports1.curveCatmullRomClosed = catmullRomClosed;
    exports1.curveCatmullRomOpen = catmullRomOpen;
    exports1.curveLinear = curveLinear;
    exports1.curveLinearClosed = linearClosed;
    exports1.curveMonotoneX = monotoneX;
    exports1.curveMonotoneY = monotoneY;
    exports1.curveNatural = natural;
    exports1.curveStep = step;
    exports1.curveStepAfter = stepAfter;
    exports1.curveStepBefore = stepBefore;
    exports1.descending = descending$2;
    exports1.deviation = deviation;
    exports1.difference = difference;
    exports1.disjoint = disjoint;
    exports1.dispatch = dispatch;
    exports1.drag = drag;
    exports1.dragDisable = dragDisable;
    exports1.dragEnable = yesdrag;
    exports1.dsv = dsv;
    exports1.dsvFormat = dsvFormat;
    exports1.easeBack = backInOut;
    exports1.easeBackIn = backIn;
    exports1.easeBackInOut = backInOut;
    exports1.easeBackOut = backOut;
    exports1.easeBounce = bounceOut;
    exports1.easeBounceIn = bounceIn;
    exports1.easeBounceInOut = bounceInOut;
    exports1.easeBounceOut = bounceOut;
    exports1.easeCircle = circleInOut;
    exports1.easeCircleIn = circleIn;
    exports1.easeCircleInOut = circleInOut;
    exports1.easeCircleOut = circleOut;
    exports1.easeCubic = cubicInOut;
    exports1.easeCubicIn = cubicIn;
    exports1.easeCubicInOut = cubicInOut;
    exports1.easeCubicOut = cubicOut;
    exports1.easeElastic = elasticOut;
    exports1.easeElasticIn = elasticIn;
    exports1.easeElasticInOut = elasticInOut;
    exports1.easeElasticOut = elasticOut;
    exports1.easeExp = expInOut;
    exports1.easeExpIn = expIn;
    exports1.easeExpInOut = expInOut;
    exports1.easeExpOut = expOut;
    exports1.easeLinear = linear$1;
    exports1.easePoly = polyInOut;
    exports1.easePolyIn = polyIn;
    exports1.easePolyInOut = polyInOut;
    exports1.easePolyOut = polyOut;
    exports1.easeQuad = quadInOut;
    exports1.easeQuadIn = quadIn;
    exports1.easeQuadInOut = quadInOut;
    exports1.easeQuadOut = quadOut;
    exports1.easeSin = sinInOut;
    exports1.easeSinIn = sinIn;
    exports1.easeSinInOut = sinInOut;
    exports1.easeSinOut = sinOut;
    exports1.every = every;
    exports1.extent = extent$1;
    exports1.fcumsum = fcumsum;
    exports1.filter = filter$1;
    exports1.flatGroup = flatGroup;
    exports1.flatRollup = flatRollup;
    exports1.forceCenter = center;
    exports1.forceCollide = collide;
    exports1.forceLink = link$2;
    exports1.forceManyBody = manyBody;
    exports1.forceRadial = radial$1;
    exports1.forceSimulation = simulation;
    exports1.forceX = x$1;
    exports1.forceY = y$1;
    exports1.formatDefaultLocale = defaultLocale$1;
    exports1.formatLocale = formatLocale$1;
    exports1.formatSpecifier = formatSpecifier;
    exports1.fsum = fsum;
    exports1.geoAlbers = albers;
    exports1.geoAlbersUsa = albersUsa;
    exports1.geoArea = area$2;
    exports1.geoAzimuthalEqualArea = azimuthalEqualArea;
    exports1.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
    exports1.geoAzimuthalEquidistant = azimuthalEquidistant;
    exports1.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
    exports1.geoBounds = bounds;
    exports1.geoCentroid = centroid$1;
    exports1.geoCircle = circle$1;
    exports1.geoClipAntimeridian = clipAntimeridian;
    exports1.geoClipCircle = clipCircle;
    exports1.geoClipExtent = extent;
    exports1.geoClipRectangle = clipRectangle;
    exports1.geoConicConformal = conicConformal;
    exports1.geoConicConformalRaw = conicConformalRaw;
    exports1.geoConicEqualArea = conicEqualArea;
    exports1.geoConicEqualAreaRaw = conicEqualAreaRaw;
    exports1.geoConicEquidistant = conicEquidistant;
    exports1.geoConicEquidistantRaw = conicEquidistantRaw;
    exports1.geoContains = contains$1;
    exports1.geoDistance = distance;
    exports1.geoEqualEarth = equalEarth;
    exports1.geoEqualEarthRaw = equalEarthRaw;
    exports1.geoEquirectangular = equirectangular;
    exports1.geoEquirectangularRaw = equirectangularRaw;
    exports1.geoGnomonic = gnomonic;
    exports1.geoGnomonicRaw = gnomonicRaw;
    exports1.geoGraticule = graticule;
    exports1.geoGraticule10 = graticule10;
    exports1.geoIdentity = identity$4;
    exports1.geoInterpolate = interpolate;
    exports1.geoLength = length$1;
    exports1.geoMercator = mercator;
    exports1.geoMercatorRaw = mercatorRaw;
    exports1.geoNaturalEarth1 = naturalEarth1;
    exports1.geoNaturalEarth1Raw = naturalEarth1Raw;
    exports1.geoOrthographic = orthographic;
    exports1.geoOrthographicRaw = orthographicRaw;
    exports1.geoPath = index$2;
    exports1.geoProjection = projection;
    exports1.geoProjectionMutator = projectionMutator;
    exports1.geoRotation = rotation;
    exports1.geoStereographic = stereographic;
    exports1.geoStereographicRaw = stereographicRaw;
    exports1.geoStream = geoStream;
    exports1.geoTransform = transform$1;
    exports1.geoTransverseMercator = transverseMercator;
    exports1.geoTransverseMercatorRaw = transverseMercatorRaw;
    exports1.gray = gray;
    exports1.greatest = greatest;
    exports1.greatestIndex = greatestIndex;
    exports1.group = group;
    exports1.groupSort = groupSort;
    exports1.groups = groups;
    exports1.hcl = hcl$2;
    exports1.hierarchy = hierarchy;
    exports1.histogram = bin;
    exports1.hsl = hsl$2;
    exports1.html = html;
    exports1.image = image;
    exports1.index = index$4;
    exports1.indexes = indexes;
    exports1.interpolate = interpolate$2;
    exports1.interpolateArray = array$3;
    exports1.interpolateBasis = basis$2;
    exports1.interpolateBasisClosed = basisClosed$1;
    exports1.interpolateBlues = Blues;
    exports1.interpolateBrBG = BrBG;
    exports1.interpolateBuGn = BuGn;
    exports1.interpolateBuPu = BuPu;
    exports1.interpolateCividis = cividis;
    exports1.interpolateCool = cool;
    exports1.interpolateCubehelix = cubehelix$2;
    exports1.interpolateCubehelixDefault = cubehelix;
    exports1.interpolateCubehelixLong = cubehelixLong;
    exports1.interpolateDate = date$1;
    exports1.interpolateDiscrete = discrete;
    exports1.interpolateGnBu = GnBu;
    exports1.interpolateGreens = Greens;
    exports1.interpolateGreys = Greys;
    exports1.interpolateHcl = hcl$1;
    exports1.interpolateHclLong = hclLong;
    exports1.interpolateHsl = hsl$1;
    exports1.interpolateHslLong = hslLong;
    exports1.interpolateHue = hue;
    exports1.interpolateInferno = inferno;
    exports1.interpolateLab = lab;
    exports1.interpolateMagma = magma;
    exports1.interpolateNumber = interpolateNumber;
    exports1.interpolateNumberArray = numberArray;
    exports1.interpolateObject = object$1;
    exports1.interpolateOrRd = OrRd;
    exports1.interpolateOranges = Oranges;
    exports1.interpolatePRGn = PRGn;
    exports1.interpolatePiYG = PiYG;
    exports1.interpolatePlasma = plasma;
    exports1.interpolatePuBu = PuBu;
    exports1.interpolatePuBuGn = PuBuGn;
    exports1.interpolatePuOr = PuOr;
    exports1.interpolatePuRd = PuRd;
    exports1.interpolatePurples = Purples;
    exports1.interpolateRainbow = rainbow;
    exports1.interpolateRdBu = RdBu;
    exports1.interpolateRdGy = RdGy;
    exports1.interpolateRdPu = RdPu;
    exports1.interpolateRdYlBu = RdYlBu;
    exports1.interpolateRdYlGn = RdYlGn;
    exports1.interpolateReds = Reds;
    exports1.interpolateRgb = interpolateRgb;
    exports1.interpolateRgbBasis = rgbBasis;
    exports1.interpolateRgbBasisClosed = rgbBasisClosed;
    exports1.interpolateRound = interpolateRound;
    exports1.interpolateSinebow = sinebow;
    exports1.interpolateSpectral = Spectral;
    exports1.interpolateString = interpolateString;
    exports1.interpolateTransformCss = interpolateTransformCss;
    exports1.interpolateTransformSvg = interpolateTransformSvg;
    exports1.interpolateTurbo = turbo;
    exports1.interpolateViridis = viridis;
    exports1.interpolateWarm = warm;
    exports1.interpolateYlGn = YlGn;
    exports1.interpolateYlGnBu = YlGnBu;
    exports1.interpolateYlOrBr = YlOrBr;
    exports1.interpolateYlOrRd = YlOrRd;
    exports1.interpolateZoom = interpolateZoom;
    exports1.interrupt = interrupt;
    exports1.intersection = intersection;
    exports1.interval = interval;
    exports1.isoFormat = formatIso$1;
    exports1.isoParse = parseIso$1;
    exports1.json = json;
    exports1.lab = lab$1;
    exports1.lch = lch;
    exports1.least = least;
    exports1.leastIndex = leastIndex;
    exports1.line = line;
    exports1.lineRadial = lineRadial$1;
    exports1.link = link;
    exports1.linkHorizontal = linkHorizontal;
    exports1.linkRadial = linkRadial;
    exports1.linkVertical = linkVertical;
    exports1.local = local$1;
    exports1.map = map$1;
    exports1.matcher = matcher;
    exports1.max = max$3;
    exports1.maxIndex = maxIndex;
    exports1.mean = mean;
    exports1.median = median;
    exports1.medianIndex = medianIndex;
    exports1.merge = merge;
    exports1.min = min$2;
    exports1.minIndex = minIndex;
    exports1.mode = mode;
    exports1.namespace = namespace;
    exports1.namespaces = namespaces;
    exports1.nice = nice$1;
    exports1.now = now;
    exports1.pack = index$1;
    exports1.packEnclose = enclose;
    exports1.packSiblings = siblings;
    exports1.pairs = pairs;
    exports1.partition = partition;
    exports1.path = path;
    exports1.pathRound = pathRound;
    exports1.permute = permute;
    exports1.pie = pie;
    exports1.piecewise = piecewise;
    exports1.pointRadial = pointRadial;
    exports1.pointer = pointer;
    exports1.pointers = pointers;
    exports1.polygonArea = area$1;
    exports1.polygonCentroid = centroid;
    exports1.polygonContains = contains;
    exports1.polygonHull = hull;
    exports1.polygonLength = length;
    exports1.precisionFixed = precisionFixed;
    exports1.precisionPrefix = precisionPrefix;
    exports1.precisionRound = precisionRound;
    exports1.quadtree = quadtree;
    exports1.quantile = quantile$1;
    exports1.quantileIndex = quantileIndex;
    exports1.quantileSorted = quantileSorted;
    exports1.quantize = quantize$1;
    exports1.quickselect = quickselect;
    exports1.radialArea = areaRadial;
    exports1.radialLine = lineRadial$1;
    exports1.randomBates = bates;
    exports1.randomBernoulli = bernoulli;
    exports1.randomBeta = beta;
    exports1.randomBinomial = binomial;
    exports1.randomCauchy = cauchy;
    exports1.randomExponential = exponential;
    exports1.randomGamma = gamma;
    exports1.randomGeometric = geometric;
    exports1.randomInt = int;
    exports1.randomIrwinHall = irwinHall;
    exports1.randomLcg = lcg;
    exports1.randomLogNormal = logNormal;
    exports1.randomLogistic = logistic;
    exports1.randomNormal = normal;
    exports1.randomPareto = pareto;
    exports1.randomPoisson = poisson;
    exports1.randomUniform = uniform;
    exports1.randomWeibull = weibull;
    exports1.range = range$2;
    exports1.rank = rank;
    exports1.reduce = reduce;
    exports1.reverse = reverse$1;
    exports1.rgb = rgb;
    exports1.ribbon = ribbon$1;
    exports1.ribbonArrow = ribbonArrow;
    exports1.rollup = rollup;
    exports1.rollups = rollups;
    exports1.scaleBand = band;
    exports1.scaleDiverging = diverging$1;
    exports1.scaleDivergingLog = divergingLog;
    exports1.scaleDivergingPow = divergingPow;
    exports1.scaleDivergingSqrt = divergingSqrt;
    exports1.scaleDivergingSymlog = divergingSymlog;
    exports1.scaleIdentity = identity$2;
    exports1.scaleImplicit = implicit;
    exports1.scaleLinear = linear;
    exports1.scaleLog = log;
    exports1.scaleOrdinal = ordinal;
    exports1.scalePoint = point$4;
    exports1.scalePow = pow;
    exports1.scaleQuantile = quantile;
    exports1.scaleQuantize = quantize;
    exports1.scaleRadial = radial;
    exports1.scaleSequential = sequential;
    exports1.scaleSequentialLog = sequentialLog;
    exports1.scaleSequentialPow = sequentialPow;
    exports1.scaleSequentialQuantile = sequentialQuantile;
    exports1.scaleSequentialSqrt = sequentialSqrt;
    exports1.scaleSequentialSymlog = sequentialSymlog;
    exports1.scaleSqrt = sqrt$1;
    exports1.scaleSymlog = symlog;
    exports1.scaleThreshold = threshold;
    exports1.scaleTime = time;
    exports1.scaleUtc = utcTime;
    exports1.scan = scan;
    exports1.schemeAccent = Accent;
    exports1.schemeBlues = scheme$5;
    exports1.schemeBrBG = scheme$q;
    exports1.schemeBuGn = scheme$h;
    exports1.schemeBuPu = scheme$g;
    exports1.schemeCategory10 = category10;
    exports1.schemeDark2 = Dark2;
    exports1.schemeGnBu = scheme$f;
    exports1.schemeGreens = scheme$4;
    exports1.schemeGreys = scheme$3;
    exports1.schemeOrRd = scheme$e;
    exports1.schemeOranges = scheme;
    exports1.schemePRGn = scheme$p;
    exports1.schemePaired = Paired;
    exports1.schemePastel1 = Pastel1;
    exports1.schemePastel2 = Pastel2;
    exports1.schemePiYG = scheme$o;
    exports1.schemePuBu = scheme$c;
    exports1.schemePuBuGn = scheme$d;
    exports1.schemePuOr = scheme$n;
    exports1.schemePuRd = scheme$b;
    exports1.schemePurples = scheme$2;
    exports1.schemeRdBu = scheme$m;
    exports1.schemeRdGy = scheme$l;
    exports1.schemeRdPu = scheme$a;
    exports1.schemeRdYlBu = scheme$k;
    exports1.schemeRdYlGn = scheme$j;
    exports1.schemeReds = scheme$1;
    exports1.schemeSet1 = Set1;
    exports1.schemeSet2 = Set2;
    exports1.schemeSet3 = Set3;
    exports1.schemeSpectral = scheme$i;
    exports1.schemeTableau10 = Tableau10;
    exports1.schemeYlGn = scheme$8;
    exports1.schemeYlGnBu = scheme$9;
    exports1.schemeYlOrBr = scheme$7;
    exports1.schemeYlOrRd = scheme$6;
    exports1.select = select;
    exports1.selectAll = selectAll;
    exports1.selection = selection;
    exports1.selector = selector;
    exports1.selectorAll = selectorAll;
    exports1.shuffle = shuffle$1;
    exports1.shuffler = shuffler;
    exports1.some = some;
    exports1.sort = sort;
    exports1.stack = stack;
    exports1.stackOffsetDiverging = diverging;
    exports1.stackOffsetExpand = expand;
    exports1.stackOffsetNone = none$1;
    exports1.stackOffsetSilhouette = silhouette;
    exports1.stackOffsetWiggle = wiggle;
    exports1.stackOrderAppearance = appearance;
    exports1.stackOrderAscending = ascending;
    exports1.stackOrderDescending = descending;
    exports1.stackOrderInsideOut = insideOut;
    exports1.stackOrderNone = none;
    exports1.stackOrderReverse = reverse;
    exports1.stratify = stratify;
    exports1.style = styleValue;
    exports1.subset = subset;
    exports1.sum = sum$2;
    exports1.superset = superset;
    exports1.svg = svg;
    exports1.symbol = Symbol$1;
    exports1.symbolAsterisk = asterisk;
    exports1.symbolCircle = circle;
    exports1.symbolCross = cross;
    exports1.symbolDiamond = diamond;
    exports1.symbolDiamond2 = diamond2;
    exports1.symbolPlus = plus;
    exports1.symbolSquare = square;
    exports1.symbolSquare2 = square2;
    exports1.symbolStar = star;
    exports1.symbolTimes = times;
    exports1.symbolTriangle = triangle;
    exports1.symbolTriangle2 = triangle2;
    exports1.symbolWye = wye;
    exports1.symbolX = times;
    exports1.symbols = symbolsFill;
    exports1.symbolsFill = symbolsFill;
    exports1.symbolsStroke = symbolsStroke;
    exports1.text = text;
    exports1.thresholdFreedmanDiaconis = thresholdFreedmanDiaconis;
    exports1.thresholdScott = thresholdScott;
    exports1.thresholdSturges = thresholdSturges;
    exports1.tickFormat = tickFormat;
    exports1.tickIncrement = tickIncrement;
    exports1.tickStep = tickStep;
    exports1.ticks = ticks;
    exports1.timeDay = timeDay;
    exports1.timeDays = timeDays;
    exports1.timeFormatDefaultLocale = defaultLocale;
    exports1.timeFormatLocale = formatLocale;
    exports1.timeFriday = timeFriday;
    exports1.timeFridays = timeFridays;
    exports1.timeHour = timeHour;
    exports1.timeHours = timeHours;
    exports1.timeInterval = timeInterval;
    exports1.timeMillisecond = millisecond;
    exports1.timeMilliseconds = milliseconds;
    exports1.timeMinute = timeMinute;
    exports1.timeMinutes = timeMinutes;
    exports1.timeMonday = timeMonday;
    exports1.timeMondays = timeMondays;
    exports1.timeMonth = timeMonth;
    exports1.timeMonths = timeMonths;
    exports1.timeSaturday = timeSaturday;
    exports1.timeSaturdays = timeSaturdays;
    exports1.timeSecond = second;
    exports1.timeSeconds = seconds;
    exports1.timeSunday = timeSunday;
    exports1.timeSundays = timeSundays;
    exports1.timeThursday = timeThursday;
    exports1.timeThursdays = timeThursdays;
    exports1.timeTickInterval = timeTickInterval;
    exports1.timeTicks = timeTicks;
    exports1.timeTuesday = timeTuesday;
    exports1.timeTuesdays = timeTuesdays;
    exports1.timeWednesday = timeWednesday;
    exports1.timeWednesdays = timeWednesdays;
    exports1.timeWeek = timeSunday;
    exports1.timeWeeks = timeSundays;
    exports1.timeYear = timeYear;
    exports1.timeYears = timeYears;
    exports1.timeout = timeout;
    exports1.timer = timer;
    exports1.timerFlush = timerFlush;
    exports1.transition = transition;
    exports1.transpose = transpose;
    exports1.tree = tree;
    exports1.treemap = index;
    exports1.treemapBinary = binary;
    exports1.treemapDice = treemapDice;
    exports1.treemapResquarify = resquarify;
    exports1.treemapSlice = treemapSlice;
    exports1.treemapSliceDice = sliceDice;
    exports1.treemapSquarify = squarify;
    exports1.tsv = tsv;
    exports1.tsvFormat = tsvFormat;
    exports1.tsvFormatBody = tsvFormatBody;
    exports1.tsvFormatRow = tsvFormatRow;
    exports1.tsvFormatRows = tsvFormatRows;
    exports1.tsvFormatValue = tsvFormatValue;
    exports1.tsvParse = tsvParse;
    exports1.tsvParseRows = tsvParseRows;
    exports1.union = union;
    exports1.unixDay = unixDay;
    exports1.unixDays = unixDays;
    exports1.utcDay = utcDay;
    exports1.utcDays = utcDays;
    exports1.utcFriday = utcFriday;
    exports1.utcFridays = utcFridays;
    exports1.utcHour = utcHour;
    exports1.utcHours = utcHours;
    exports1.utcMillisecond = millisecond;
    exports1.utcMilliseconds = milliseconds;
    exports1.utcMinute = utcMinute;
    exports1.utcMinutes = utcMinutes;
    exports1.utcMonday = utcMonday;
    exports1.utcMondays = utcMondays;
    exports1.utcMonth = utcMonth;
    exports1.utcMonths = utcMonths;
    exports1.utcSaturday = utcSaturday;
    exports1.utcSaturdays = utcSaturdays;
    exports1.utcSecond = second;
    exports1.utcSeconds = seconds;
    exports1.utcSunday = utcSunday;
    exports1.utcSundays = utcSundays;
    exports1.utcThursday = utcThursday;
    exports1.utcThursdays = utcThursdays;
    exports1.utcTickInterval = utcTickInterval;
    exports1.utcTicks = utcTicks;
    exports1.utcTuesday = utcTuesday;
    exports1.utcTuesdays = utcTuesdays;
    exports1.utcWednesday = utcWednesday;
    exports1.utcWednesdays = utcWednesdays;
    exports1.utcWeek = utcSunday;
    exports1.utcWeeks = utcSundays;
    exports1.utcYear = utcYear;
    exports1.utcYears = utcYears;
    exports1.variance = variance;
    exports1.version = version;
    exports1.window = defaultView;
    exports1.xml = xml;
    exports1.zip = zip;
    exports1.zoom = zoom;
    exports1.zoomIdentity = identity;
    exports1.zoomTransform = transform;
});



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
function $c2855e4006b2a4dd$export$2e2bcd8739ae039(props) {
    const { formatter: formatter } = props;
    const [labels, setLabels] = (0, $acw62.useState)(props.labels);
    (0, $acw62.useEffect)(()=>{
        setLabels(props.labels);
    }, [
        props.labels
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c2855e4006b2a4dd$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "labels",
            children: labels.map((label)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "label",
                    children: formatter ? formatter(label) : label
                }, label))
        })
    });
}
const $c2855e4006b2a4dd$var$Root = (0, $lmFrL.default).div`
  margin: -1px 2px 0 0;
  white-space: nowrap;
  text-align: end;
  font-weight: bold;

  .label {
    height: 15px;
    font-size: .8rem;
  }
`;


var $b1d18033c089f3dc$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b1d18033c089f3dc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($b1d18033c089f3dc$exports, "__esModule", {
    value: true
});
$b1d18033c089f3dc$exports.default = void 0;

var $b1d18033c089f3dc$var$_createSvgIcon = $b1d18033c089f3dc$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b1d18033c089f3dc$var$_default = $b1d18033c089f3dc$exports.default = (0, $b1d18033c089f3dc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z"
}), 'ArrowBackIosNew');


var $724059c25d8988ef$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $724059c25d8988ef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($724059c25d8988ef$exports, "__esModule", {
    value: true
});
$724059c25d8988ef$exports.default = void 0;

var $724059c25d8988ef$var$_createSvgIcon = $724059c25d8988ef$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $724059c25d8988ef$var$_default = $724059c25d8988ef$exports.default = (0, $724059c25d8988ef$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');


var $ba8129acb7bb4493$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ba8129acb7bb4493$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ba8129acb7bb4493$exports, "__esModule", {
    value: true
});
$ba8129acb7bb4493$exports.default = void 0;

var $ba8129acb7bb4493$var$_createSvgIcon = $ba8129acb7bb4493$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ba8129acb7bb4493$var$_default = $ba8129acb7bb4493$exports.default = (0, $ba8129acb7bb4493$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2z"
    }, "1")
], 'ZoomIn');


var $4934695977454536$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $4934695977454536$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($4934695977454536$exports, "__esModule", {
    value: true
});
$4934695977454536$exports.default = void 0;

var $4934695977454536$var$_createSvgIcon = $4934695977454536$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $4934695977454536$var$_default = $4934695977454536$exports.default = (0, $4934695977454536$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14M7 9h5v1H7z"
}), 'ZoomOut');


var $26a1017a5fed6599$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $26a1017a5fed6599$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($26a1017a5fed6599$exports, "__esModule", {
    value: true
});
$26a1017a5fed6599$exports.default = void 0;

var $26a1017a5fed6599$var$_createSvgIcon = $26a1017a5fed6599$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $26a1017a5fed6599$var$_default = $26a1017a5fed6599$exports.default = (0, $26a1017a5fed6599$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 5.69 5 4.5V18h-2v-6H9v6H7v-7.81zM12 3 2 12h3v8h6v-6h2v6h6v-8h3z"
}), 'HomeOutlined');



var $7upBl = parcelRequire("7upBl");
var $1d0470f54d972767$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1d0470f54d972767$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1d0470f54d972767$exports, "__esModule", {
    value: true
});
$1d0470f54d972767$exports.default = void 0;

var $1d0470f54d972767$var$_createSvgIcon = $1d0470f54d972767$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1d0470f54d972767$var$_default = $1d0470f54d972767$exports.default = (0, $1d0470f54d972767$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11.29 8.71 6.7 13.3c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L12 10.83l3.88 3.88c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L12.7 8.71c-.38-.39-1.02-.39-1.41 0"
}), 'ExpandLessRounded');



var $lmFrL = parcelRequire("lmFrL");

var $gTmRg = parcelRequire("gTmRg");
const $0b85f1216005eff9$var$TimelineContainer = (0, $lmFrL.default)((0, $gTmRg.Card))`
  margin: 25px 0;

  .title-row {
    float: left;
    width: 100%; /* required to expand container for timeline viz */

    h2 {
      margin: 0;
    }
  }
`;
var $0b85f1216005eff9$export$2e2bcd8739ae039 = $0b85f1216005eff9$var$TimelineContainer;


const $66ac2ba2d2031913$var$HOUR = 3600000;
const $66ac2ba2d2031913$var$DAY = 24 * $66ac2ba2d2031913$var$HOUR;
const $66ac2ba2d2031913$var$CELL_UNITS = {
    'hour': $66ac2ba2d2031913$var$HOUR,
    'day': $66ac2ba2d2031913$var$DAY
};
const $66ac2ba2d2031913$var$margin = {
    top: 20,
    left: 2,
    right: 10,
    bottom: 50
};
const $66ac2ba2d2031913$var$defaultWidth = 800;
const $66ac2ba2d2031913$var$cellHeight = 15;
const $66ac2ba2d2031913$var$cellPad = 2;
const $66ac2ba2d2031913$var$borderRadius = 0;
const $66ac2ba2d2031913$var$guideStroke = 3;
const $66ac2ba2d2031913$var$panAmount = 100;
const $66ac2ba2d2031913$var$redSpectrum = [
    '#ff8686',
    '#890000',
    '#520000'
];
const $66ac2ba2d2031913$export$35e9368ef982300f = {
    noValue: '#efefef',
    green: '#4cc948',
    green1: '#b2dfb0',
    green2: '#8ed88b',
    green3: '#4cc948',
    green4: '#06af00',
    red1: '#ffc5c5',
    red2: '#ff8686',
    red3: '#d34848',
    red4: '#890000',
    orange: '#d49318'
};
const $66ac2ba2d2031913$export$8f45430ccf837300 = {
    blues: [
        '#eff3ff',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#3182bd',
        '#08519c',
        '#053e78'
    ],
    noValue: '#dcdcdc'
};
function $66ac2ba2d2031913$var$parseData(data) {
    let array = [];
    Object.keys(data).map((key)=>{
        const rows = data[key].map((obj)=>({
                row: key,
                ...obj
            }));
        array = [
            ...array,
            ...rows
        ];
    });
    return array;
}
function $66ac2ba2d2031913$var$getDomain(data, cellUnit) {
    const sorted = [
        ...data
    ].sort((a, b)=>+new Date(a.timestamp) - +new Date(b.timestamp));
    const start = new Date(sorted[0].timestamp);
    const end = new Date(new Date(sorted[sorted.length - 1].timestamp).getTime() + cellUnit);
    return [
        start,
        end
    ];
}
function $66ac2ba2d2031913$var$getMinMax(data) {
    const sorted = [
        ...data
    ].sort((a, b)=>a.value - b.value);
    return [
        sorted[0].value,
        sorted.pop().value
    ];
}
function $66ac2ba2d2031913$var$computeCanvasHeight(m, cellHeight) {
    return m * cellHeight;
}
function $66ac2ba2d2031913$var$computeSize(data) {
    const lengths = Object.values(data).map((arr)=>arr.length);
    return {
        m: Object.keys(data).length,
        n: Math.max(...lengths)
    };
}
function $66ac2ba2d2031913$export$75f9af112506f7de(data) {
    const [min, max] = $66ac2ba2d2031913$var$getMinMax(data);
    const colorScale = $dc1c498a1ad915c1$exports.scaleLinear().domain([
        min,
        10,
        max
    ])// @ts-ignore: ???
    .range($66ac2ba2d2031913$var$redSpectrum);
    return colorScale;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $66ac2ba2d2031913$var$showGuide(ref, svg, y) {
    const foo = $dc1c498a1ad915c1$exports.select(ref).node().getBBox();
    svg.append('rect').attr('class', 'guide').attr('x', 0 + $66ac2ba2d2031913$var$guideStroke).attr('y', foo.y + $66ac2ba2d2031913$var$margin.top).attr('width', $66ac2ba2d2031913$var$margin.left).attr('height', y.bandwidth() - 2).attr('stroke', '#0088ff').attr('stroke-width', $66ac2ba2d2031913$var$guideStroke).attr('fill', 'none');
}
function $66ac2ba2d2031913$var$drawRect(ctx, x, y, w, h, color) {
    ctx.beginPath();
    ctx.rect(x, y, w, h);
    ctx.fillStyle = color;
    ctx.fill();
    ctx.closePath();
}
const $66ac2ba2d2031913$var$getFill = (d, colorCell, colorScale)=>{
    if (colorCell) return colorCell(d.value, d);
    else if (d.value > 0 && d.meta.severity == 'warning') return $66ac2ba2d2031913$export$35e9368ef982300f.orange;
    else return d.value == 0 ? $66ac2ba2d2031913$export$35e9368ef982300f.green : colorScale(d.value);
};
function $66ac2ba2d2031913$var$renderCanvasCells(args) {
    const { domEle: domEle, data: data, width: width, height: height, x: x, y: y, computeWidth: computeWidth, colorCell: colorCell, colorScale: colorScale } = args;
    const pixelRatio = window.devicePixelRatio;
    // Add the canvas
    const canvasHeight = height + $66ac2ba2d2031913$var$margin.top;
    const context = $dc1c498a1ad915c1$exports.select(domEle).append('div').style('position', 'absolute').style('top', 0).style('left', 0).append('canvas').attr('width', width * pixelRatio).attr('height', canvasHeight * pixelRatio).style('width', `${width}px`).style('height', `${canvasHeight}px`).style('border', '1px solid black').node().getContext('2d');
    context.scale(pixelRatio, pixelRatio);
    data.forEach(function(d) {
        $66ac2ba2d2031913$var$drawRect(context, x(new Date(d.timestamp)), y(d.row) + $66ac2ba2d2031913$var$cellPad, computeWidth(d, x), 10, $66ac2ba2d2031913$var$getFill(d, colorCell, colorScale));
    });
    return context;
}
function $66ac2ba2d2031913$var$renderSVGCells(args) {
    const { svg: svg, domEle: domEle, data: data, width: width, x: x, y: y, computeWidth: computeWidth, onCellClick: onCellClick, colorCell: colorCell, tooltip: tooltip, tooltipPos: tooltipPos, colorScale: colorScale } = args;
    // add cell container
    const cells = svg.append('g').attr('width', width).style('cursor', onCellClick ? 'pointer' : 'auto').attr('transform', `translate(${$66ac2ba2d2031913$var$margin.left}, ${$66ac2ba2d2031913$var$margin.top})`);
    // add cells
    cells.selectAll().data(data).enter().append('rect').attr('class', 'cell').attr('x', (d)=>x(new Date(d.timestamp))).attr('y', (d)=>y(d.row) + $66ac2ba2d2031913$var$cellPad).attr('width', (d)=>computeWidth(d, x)).attr('height', y.bandwidth() - 2).attr('rx', $66ac2ba2d2031913$var$borderRadius).attr('stroke-width', 2)// .attr('opacity', .5)
    .attr('fill', (d)=>$66ac2ba2d2031913$var$getFill(d, colorCell, colorScale)).on('mouseenter', function(evt, data) {
        // showGuide(this, svg, y)
        $dc1c498a1ad915c1$exports.select(this).attr('opacity', 0.85).attr('stroke-width', 2).attr('stroke', '#444');
        showTooltip(evt, data);
    }).on('mouseleave', function() {
        $dc1c498a1ad915c1$exports.select('.guide').remove();
        $dc1c498a1ad915c1$exports.select(this).attr('opacity', 1.0).attr('stroke', null);
        tt.style('display', 'none');
    }).on('click', (evt, data)=>{
        if (!onCellClick) return;
        onCellClick(data);
    });
    /**
   * tooltip
   */ const tt = $dc1c498a1ad915c1$exports.select(domEle).selectAll('#tooltip').data([
        null
    ]).join('div').attr('id', 'tooltip').style('position', 'absolute').style('display', 'none').style('background', '#000').style('color', '#fff').style('padding', '1em');
    const showTooltip = (evt, data)=>{
        tt.html(tooltip ? tooltip(data) : `${new Date(data.timestamp).toDateString()} ` + `${new Date(data.timestamp).toLocaleTimeString()}<br>
       ${data.value == 0 ? 'passed' : data.meta.severity == 'warning' ? 'warning' : 'failed'}<br>
       value: ${data.value}`).style('top', tooltipPos == 'bottom' ? `${evt.pageY + 15}px` : `${evt.pageY - 265}px`).style('left', `${evt.pageX - 80}px`).style('z-index', 999);
        tt.style('display', null);
    };
    return cells;
}
function $66ac2ba2d2031913$var$drawChart(domEle, params) {
    const { data: data, startTime: startTime, endTime: endTime, scaleExtent: scaleExtent, width: width = $66ac2ba2d2031913$var$defaultWidth, yLabels: yLabels, yFormat: yFormat, tooltip: tooltip, tooltipPos: tooltipPos = 'bottom', useD3YAxis: useD3YAxis, colorCell: colorCell, onCellClick: onCellClick, onRowClick: onRowClick } = params;
    const cellUnit = params.cellUnit ? $66ac2ba2d2031913$var$CELL_UNITS[params.cellUnit] : $66ac2ba2d2031913$var$CELL_UNITS.hour;
    const [start, end] = $66ac2ba2d2031913$var$getDomain(data, cellUnit);
    const height = $66ac2ba2d2031913$var$computeCanvasHeight(yLabels.length, $66ac2ba2d2031913$var$cellHeight);
    const zoom = $dc1c498a1ad915c1$exports.zoom().filter((evt)=>evt.type === 'wheel' ? evt.ctrlKey : true).scaleExtent(scaleExtent || [
        .2,
        30
    ]).on('zoom', zoomed);
    // create scaling functions
    const x = $dc1c498a1ad915c1$exports.scaleTime().domain([
        startTime || start,
        endTime || end
    ]).range([
        0,
        width
    ]);
    const y = $dc1c498a1ad915c1$exports.scaleBand().domain(yLabels).range([
        0,
        height
    ]);
    const colorScale = $66ac2ba2d2031913$export$75f9af112506f7de(data);
    // create axises
    const xAxis = $dc1c498a1ad915c1$exports.axisTop(x);
    const yAxis = $dc1c498a1ad915c1$exports.axisLeft(y);
    // format y axis labels if needed
    if (yFormat && useD3YAxis) yAxis.tickFormat(yFormat);
    const svgHeight = height + $66ac2ba2d2031913$var$margin.top;
    const svg = $dc1c498a1ad915c1$exports.select(domEle).append('svg').attr('width', '100%').attr('height', svgHeight).attr('cursor', 'grab');
    const gX = svg.append('g').attr('cursor', 'grab').attr('transform', `translate(${$66ac2ba2d2031913$var$margin.left}, ${$66ac2ba2d2031913$var$margin.top})`).call(xAxis);
    const useCanvas = false;
    let cells, context;
    if (useCanvas) context = $66ac2ba2d2031913$var$renderCanvasCells({
        svg: svg,
        domEle: domEle,
        data: data,
        x: x,
        y: y,
        width: width,
        height: height,
        tooltip: tooltip,
        tooltipPos: tooltipPos,
        computeWidth: computeWidth,
        onCellClick: onCellClick,
        colorCell: colorCell,
        colorScale: colorScale
    });
    else cells = $66ac2ba2d2031913$var$renderSVGCells({
        svg: svg,
        domEle: domEle,
        data: data,
        x: x,
        y: y,
        width: width,
        tooltip: tooltip,
        tooltipPos: tooltipPos,
        computeWidth: computeWidth,
        onCellClick: onCellClick,
        colorCell: colorCell,
        colorScale: colorScale
    });
    // add y axis overlay
    svg.append('g').append('rect').attr('fill', '#fff').attr('x', 0).attr('y', $66ac2ba2d2031913$var$margin.top).attr('width', $66ac2ba2d2031913$var$margin.left).attr('height', height);
    // optionally render y axis with d3
    if (useD3YAxis) svg.append('g').attr('class', `y-axis`).attr('transform', `translate(${$66ac2ba2d2031913$var$margin.left}, ${$66ac2ba2d2031913$var$margin.top})`).call(yAxis).on('click', (evt)=>{
        if (!onRowClick) return;
        const label = $dc1c498a1ad915c1$exports.select(evt.target).data()[0];
        const row = data.filter((o)=>o.row == label);
        onRowClick(label, row);
    });
    /**
   * panning/zooming
   **/ svg.call(zoom);
    function zoomed(e) {
        const newScale = e.transform.rescaleX(x);
        if (useCanvas) {
            context.clearRect(0, 0, width, height);
            data.forEach(function(d) {
                $66ac2ba2d2031913$var$drawRect(context, newScale(new Date(d.timestamp)), y(d.row) + $66ac2ba2d2031913$var$cellPad, computeWidth(d, newScale), 10);
            });
        } else cells.selectAll('.cell').attr('x', (d)=>newScale(new Date(d.timestamp))).attr('width', (d)=>computeWidth(d, newScale));
        gX.call(xAxis.scale(newScale));
    }
    function computeWidth(d, scale) {
        const x = scale;
        // use end time if provided, cellUnit is an hour unless user provided
        const w = d.end ? x(new Date(d.end).getTime()) - x(new Date(d.timestamp)) : x(new Date(d.timestamp).getTime() + cellUnit) - x(new Date(d.timestamp));
        return w > $66ac2ba2d2031913$var$cellPad ? w - $66ac2ba2d2031913$var$cellPad : $66ac2ba2d2031913$var$cellPad;
    }
    // add events for button controls
    const ctrls = $dc1c498a1ad915c1$exports.select(domEle).select(function() {
        return this.parentNode.parentNode;
    });
    ctrls.select('.pan-left').on('click', (evt)=>{
        evt.preventDefault();
        pan('left');
    });
    ctrls.select('.pan-right').on('click', (evt)=>{
        evt.preventDefault();
        pan('right');
    });
    ctrls.select('.zoom-in').on('click', (evt)=>{
        evt.preventDefault();
        zoomTo('in');
    });
    ctrls.select('.zoom-out').on('click', (evt)=>{
        evt.preventDefault();
        zoomTo('out');
    });
    ctrls.select('.reset').on('click', (evt)=>{
        evt.preventDefault();
        reset();
    });
    function pan(dir) {
        const amount = dir == 'right' ? $66ac2ba2d2031913$var$panAmount : -$66ac2ba2d2031913$var$panAmount;
        const t = $dc1c498a1ad915c1$exports.zoomTransform(svg.node());
        const transform = $dc1c498a1ad915c1$exports.zoomIdentity.translate(t.x - amount, t.y).scale(t.k);
        zoom.transform(svg.transition().duration(200).ease($dc1c498a1ad915c1$exports.easeLinear), transform);
    }
    function zoomTo(dir) {
        const center = width / 2;
        const zoomTransform = $dc1c498a1ad915c1$exports.zoomTransform(svg.node());
        const scale = zoomTransform.k, extent = zoom.scaleExtent();
        let x = zoomTransform.x, factor = dir == 'in' ? 1.5 : 1 / 1.5, targetScale = scale * factor;
        // Don't pass scaling extent in either direction
        if (targetScale < extent[0] || targetScale > extent[1]) return false;
        // If the factor is too much, scale it down to reach the extent exactly
        const clampedTargetScale = Math.max(extent[0], Math.min(extent[1], targetScale));
        if (clampedTargetScale != targetScale) {
            targetScale = clampedTargetScale;
            factor = targetScale / scale;
        }
        // Center each vector, stretch, then put back
        x = (x - center) * factor + center;
        const transform = $dc1c498a1ad915c1$exports.zoomIdentity.translate(x, zoomTransform.y).scale(targetScale);
        zoom.transform(svg.transition().duration(200).ease($dc1c498a1ad915c1$exports.easeLinear), transform);
    }
    function reset() {
        svg.transition().duration(500).ease($dc1c498a1ad915c1$exports.easeLinear).call(zoom.transform, $dc1c498a1ad915c1$exports.zoomIdentity);
    }
}
function $66ac2ba2d2031913$var$Chart(props) {
    const { data: data, labelWidth: labelWidth, showLegend: showLegend, showButtons: showButtons = true, limitRowCount: limitRowCount, useD3YAxis: useD3YAxis = false, ...rest } = props;
    const [showAllRows, setShowAllRows] = (0, $acw62.useState)(false);
    const [totalRows, setTotalRows] = (0, $acw62.useState)(0);
    const [labels, setLabels] = (0, $acw62.useState)(null);
    const ref = (0, $acw62.useRef)(null);
    // const legendRef = useRef(null)
    (0, $acw62.useEffect)(()=>{
        const node = ref.current;
        let yLabels, chartData, size;
        if (typeof data == 'object') {
            // todo(nc): optimize by removing grouped api requirement.  allow flat array of objs?
            yLabels = Object.keys(data);
            chartData = $66ac2ba2d2031913$var$parseData(data);
            size = $66ac2ba2d2031913$var$computeSize(data);
            // ignore data with no rows for now
            if (size.m == 0) return;
        } else throw `data format should be an object in form { [key: string]: {}[] }, was: ${data}`;
        const ro = new ResizeObserver((entries)=>{
            const entry = entries[0];
            const cr = entry.contentRect;
            const width = cr.width - $66ac2ba2d2031913$var$margin.left - $66ac2ba2d2031913$var$margin.right;
            const svg = node.querySelector('svg');
            if (svg) svg.remove();
            // todo(nc): redraw, instead entirely replacing the canvas
            const canvas = node.querySelector('canvas');
            if (canvas) canvas.remove();
            if (limitRowCount) {
                setTotalRows(yLabels.length);
                yLabels = limitRowCount && !showAllRows ? yLabels.slice(0, limitRowCount) : yLabels;
                chartData = chartData.filter((o)=>yLabels.includes(o.row));
            }
            if (JSON.stringify(labels) !== JSON.stringify(yLabels)) setLabels(yLabels);
            $66ac2ba2d2031913$var$drawChart(node, {
                data: chartData,
                yLabels: yLabels,
                width: width,
                size: size,
                labelWidth: labelWidth,
                useD3YAxis: useD3YAxis,
                ...rest
            });
        });
        ro.observe(node);
        /* todo: legend
    const legendNode = legendRef.current
    const legendSvg = legendNode.querySelector('svg')
    if (showLegend && !legendSvg) {
      appendLegend(legendNode, chartData)
    }
    */ return ()=>{
            ro.unobserve(node);
        };
    }, [
        data,
        rest,
        $66ac2ba2d2031913$var$margin,
        showLegend,
        limitRowCount
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            showButtons && /*#__PURE__*/ (0, $ayMG0.jsxs)($66ac2ba2d2031913$var$Ctrls, {
                style: {
                    marginRight: $66ac2ba2d2031913$var$margin.right
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn reset",
                        title: "reset zoom/panning",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26a1017a5fed6599$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn pan-left",
                        title: "pan left",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b1d18033c089f3dc$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn zoom-in",
                        title: "zoom in",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba8129acb7bb4493$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn zoom-out",
                        title: "zoom out",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4934695977454536$exports))), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "btn pan-right",
                        title: "pan right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($724059c25d8988ef$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex w-full",
                children: [
                    labels && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            marginTop: $66ac2ba2d2031913$var$margin.top,
                            width: labelWidth
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2855e4006b2a4dd$export$2e2bcd8739ae039), {
                            labels: labels,
                            data: data,
                            formatter: props.yFormat,
                            margin: $66ac2ba2d2031913$var$margin
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: ref,
                        className: "w-full"
                    })
                ]
            }),
            limitRowCount && totalRows > limitRowCount && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                onClick: ()=>setShowAllRows((prev)=>!prev),
                className: "more-btn",
                style: {
                    marginLeft: $66ac2ba2d2031913$var$margin.left
                },
                children: showAllRows ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "hide rows ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1d0470f54d972767$exports))), {})
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "show ",
                        totalRows - limitRowCount,
                        " more rows ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7upBl))), {})
                    ]
                })
            })
        ]
    });
}
var $66ac2ba2d2031913$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)(function TimelineContainer(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($66ac2ba2d2031913$var$Root, {
        colorLinks: !!props.onRowClick,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($66ac2ba2d2031913$var$Chart, {
            ...props
        })
    });
}, (prev, next)=>prev.data === next.data && prev.colorCell === next.colorCell && prev.onRowClick === next.onRowClick && prev.onCellClick === next.onCellClick);
const $66ac2ba2d2031913$var$Root = (0, $lmFrL.default).div`
  width: 100%;
  .timeline {
    display: flex;
  }

  button {
    margin: 0 2px;
    background: none;
    border-radius: 3px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, .2);

    :hover {
      border: 1px solid #1d7198;
      .MuiSvgIcon-root {
        color: #1d7198;
      }
    }

    .MuiSvgIcon-root {
      font-size: 1.25rem;
      padding-top: 2px;
    }
  }

  button.more-btn {
    display: flex;
    align-items: center;
  }

  ${(props)=>props.colorLinks && `
    .y-axis text {
        color: #444;
        font-size: 1.2em;
        font-weight: 600;
      }
      .y-axis text:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }`}
`;
const $66ac2ba2d2031913$var$Ctrls = (0, $lmFrL.default).div`
  float: right;
  margin: 0 20px 15px 15px;

  .reset {
    margin-right: 15px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $5RIww = parcelRequire("5RIww");

var $30UGG = parcelRequire("30UGG");
function $1a4a018ec5a6eb95$export$2e2bcd8739ae039(props) {
    const { includeHeader: includeHeader } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1a4a018ec5a6eb95$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $30UGG.default), {
            spacing: 1,
            children: [
                includeHeader && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 40
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 200
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 100
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: "100%",
                            animation: "wave"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 100
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: "100%",
                            animation: "wave"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 100
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: "100%",
                            animation: "wave"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: 100
                        }),
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                            width: "100%",
                            animation: "wave"
                        })
                    ]
                })
            ]
        })
    });
}
const $1a4a018ec5a6eb95$var$Root = (0, $lmFrL.default).div`
  margin: 20px 10px 0 10px;
`;



var $9bsRS = parcelRequire("9bsRS");
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}



var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var timestamp = (0, $gdr0J.default)(dirtyDate).getTime();
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



var $4LmDH = parcelRequire("4LmDH");
var $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR = 3600000;
function $eba2848fce1475e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, amount * $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR);
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $1ed606b7addd3a91$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setMinutes(59, 59, 999);
    return date;
}




var $4LmDH = parcelRequire("4LmDH");
function $320e4d083cefb0bc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $4f754377033842c6$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}



var $4LmDH = parcelRequire("4LmDH");
function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}



var $4LmDH = parcelRequire("4LmDH");
function $393cfda53f7a350f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $eb237db400049a40$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



var $gZwVy = parcelRequire("gZwVy");

var $hw4Z0 = parcelRequire("hw4Z0");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a180a55535de9e53$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.65 6.35c-1.63-1.63-3.94-2.57-6.48-2.31-3.67.37-6.69 3.35-7.1 7.02C3.52 15.91 7.27 20 12 20c3.19 0 5.93-1.87 7.21-4.56.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53-1.13 2.43-3.84 3.97-6.8 3.31-2.22-.49-4.01-2.3-4.48-4.52C5.31 9.44 8.26 6 12 6c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71H19c.55 0 1-.45 1-1V6.41c0-.89-1.08-1.34-1.71-.71z"
}), 'RefreshRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $04c3fb0d25ae3dfa$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4 14H8V8h8z"
}), 'StopCircle');



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");
var $789b80ef9a3da2f3$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $789b80ef9a3da2f3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($789b80ef9a3da2f3$exports, "__esModule", {
    value: true
});
$789b80ef9a3da2f3$exports.default = void 0;

var $789b80ef9a3da2f3$var$_createSvgIcon = $789b80ef9a3da2f3$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $789b80ef9a3da2f3$var$_default = $789b80ef9a3da2f3$exports.default = (0, $789b80ef9a3da2f3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
}), 'CalendarMonth');



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $c9Z8w = parcelRequire("c9Z8w");
var $92515163af4739b4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $92515163af4739b4$export$84fe03429ed1b6d6 = [
    'onCopy',
    'onCut',
    'onPaste'
];
var $92515163af4739b4$export$dbc46161504615f7 = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
var $92515163af4739b4$export$fb6351c2666f0875 = [
    'onFocus',
    'onBlur'
];
var $92515163af4739b4$export$4e58c1a9761ed81a = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
var $92515163af4739b4$export$3bf7402f2a4eb3af = [
    'onLoad',
    'onError'
];
var $92515163af4739b4$export$409c4891d97f97cf = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
var $92515163af4739b4$export$6be5aa2386088264 = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
var $92515163af4739b4$export$3a6e2b8954613992 = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
var $92515163af4739b4$export$6c96379d5b8a2df7 = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
var $92515163af4739b4$export$d93346aa7735a637 = [
    'onSelect'
];
var $92515163af4739b4$export$fa367689c659e65c = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var $92515163af4739b4$export$c731eab7619e00a0 = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
var $92515163af4739b4$export$bac3087b5cb826f6 = [
    'onScroll'
];
var $92515163af4739b4$export$28298837799e00e8 = [
    'onWheel'
];
var $92515163af4739b4$export$6ff45424014e7407 = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
var $92515163af4739b4$export$78878fc7bd50dc3e = [
    'onTransitionEnd'
];
var $92515163af4739b4$export$477a88c5b93a108d = [
    'onToggle'
];
var $92515163af4739b4$export$7212b61f9f58bd1 = [
    'onChange'
];
var $92515163af4739b4$export$59ef7197c4d7b9dc = $92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray($92515163af4739b4$var$__spreadArray([], $92515163af4739b4$export$84fe03429ed1b6d6, true), $92515163af4739b4$export$dbc46161504615f7, true), $92515163af4739b4$export$fb6351c2666f0875, true), $92515163af4739b4$export$4e58c1a9761ed81a, true), $92515163af4739b4$export$3bf7402f2a4eb3af, true), $92515163af4739b4$export$409c4891d97f97cf, true), $92515163af4739b4$export$6be5aa2386088264, true), $92515163af4739b4$export$3a6e2b8954613992, true), $92515163af4739b4$export$6c96379d5b8a2df7, true), $92515163af4739b4$export$d93346aa7735a637, true), $92515163af4739b4$export$fa367689c659e65c, true), $92515163af4739b4$export$c731eab7619e00a0, true), $92515163af4739b4$export$bac3087b5cb826f6, true), $92515163af4739b4$export$28298837799e00e8, true), $92515163af4739b4$export$6ff45424014e7407, true), $92515163af4739b4$export$78878fc7bd50dc3e, true), $92515163af4739b4$export$7212b61f9f58bd1, true), $92515163af4739b4$export$477a88c5b93a108d, true);
function $92515163af4739b4$export$2e2bcd8739ae039(props, getArgs) {
    var eventProps = {};
    $92515163af4739b4$export$59ef7197c4d7b9dc.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}


function $bfccead57fba6d8c$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $bfccead57fba6d8c$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $bfccead57fba6d8c$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $bfccead57fba6d8c$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $bfccead57fba6d8c$export$2e2bcd8739ae039 = $bfccead57fba6d8c$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $a45fe03b551d5ffa$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $a45fe03b551d5ffa$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $a45fe03b551d5ffa$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $a45fe03b551d5ffa$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $a45fe03b551d5ffa$export$2e2bcd8739ae039 = $a45fe03b551d5ffa$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
var $b2c937a9c7fcec3b$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b2c937a9c7fcec3b$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $b2c937a9c7fcec3b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var $b2c937a9c7fcec3b$var$funcTag = '[object Function]', $b2c937a9c7fcec3b$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $b2c937a9c7fcec3b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $b2c937a9c7fcec3b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $b2c937a9c7fcec3b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b2c937a9c7fcec3b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b2c937a9c7fcec3b$var$root = $b2c937a9c7fcec3b$var$freeGlobal || $b2c937a9c7fcec3b$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b2c937a9c7fcec3b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $b2c937a9c7fcec3b$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $b2c937a9c7fcec3b$var$arrayProto = Array.prototype, $b2c937a9c7fcec3b$var$funcProto = Function.prototype, $b2c937a9c7fcec3b$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $b2c937a9c7fcec3b$var$coreJsData = $b2c937a9c7fcec3b$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $b2c937a9c7fcec3b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($b2c937a9c7fcec3b$var$coreJsData && $b2c937a9c7fcec3b$var$coreJsData.keys && $b2c937a9c7fcec3b$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $b2c937a9c7fcec3b$var$funcToString = $b2c937a9c7fcec3b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b2c937a9c7fcec3b$var$hasOwnProperty = $b2c937a9c7fcec3b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b2c937a9c7fcec3b$var$objectToString = $b2c937a9c7fcec3b$var$objectProto.toString;
/** Used to detect if a method is native. */ var $b2c937a9c7fcec3b$var$reIsNative = RegExp('^' + $b2c937a9c7fcec3b$var$funcToString.call($b2c937a9c7fcec3b$var$hasOwnProperty).replace($b2c937a9c7fcec3b$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $b2c937a9c7fcec3b$var$splice = $b2c937a9c7fcec3b$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $b2c937a9c7fcec3b$var$Map = $b2c937a9c7fcec3b$var$getNative($b2c937a9c7fcec3b$var$root, 'Map'), $b2c937a9c7fcec3b$var$nativeCreate = $b2c937a9c7fcec3b$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2c937a9c7fcec3b$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b2c937a9c7fcec3b$var$hashClear() {
    this.__data__ = $b2c937a9c7fcec3b$var$nativeCreate ? $b2c937a9c7fcec3b$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2c937a9c7fcec3b$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2c937a9c7fcec3b$var$hashGet(key) {
    var data = this.__data__;
    if ($b2c937a9c7fcec3b$var$nativeCreate) {
        var result = data[key];
        return result === $b2c937a9c7fcec3b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $b2c937a9c7fcec3b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b2c937a9c7fcec3b$var$hashHas(key) {
    var data = this.__data__;
    return $b2c937a9c7fcec3b$var$nativeCreate ? data[key] !== undefined : $b2c937a9c7fcec3b$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $b2c937a9c7fcec3b$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $b2c937a9c7fcec3b$var$nativeCreate && value === undefined ? $b2c937a9c7fcec3b$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$b2c937a9c7fcec3b$var$Hash.prototype.clear = $b2c937a9c7fcec3b$var$hashClear;
$b2c937a9c7fcec3b$var$Hash.prototype['delete'] = $b2c937a9c7fcec3b$var$hashDelete;
$b2c937a9c7fcec3b$var$Hash.prototype.get = $b2c937a9c7fcec3b$var$hashGet;
$b2c937a9c7fcec3b$var$Hash.prototype.has = $b2c937a9c7fcec3b$var$hashHas;
$b2c937a9c7fcec3b$var$Hash.prototype.set = $b2c937a9c7fcec3b$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2c937a9c7fcec3b$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b2c937a9c7fcec3b$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2c937a9c7fcec3b$var$listCacheDelete(key) {
    var data = this.__data__, index = $b2c937a9c7fcec3b$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $b2c937a9c7fcec3b$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2c937a9c7fcec3b$var$listCacheGet(key) {
    var data = this.__data__, index = $b2c937a9c7fcec3b$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b2c937a9c7fcec3b$var$listCacheHas(key) {
    return $b2c937a9c7fcec3b$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b2c937a9c7fcec3b$var$listCacheSet(key, value) {
    var data = this.__data__, index = $b2c937a9c7fcec3b$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$b2c937a9c7fcec3b$var$ListCache.prototype.clear = $b2c937a9c7fcec3b$var$listCacheClear;
$b2c937a9c7fcec3b$var$ListCache.prototype['delete'] = $b2c937a9c7fcec3b$var$listCacheDelete;
$b2c937a9c7fcec3b$var$ListCache.prototype.get = $b2c937a9c7fcec3b$var$listCacheGet;
$b2c937a9c7fcec3b$var$ListCache.prototype.has = $b2c937a9c7fcec3b$var$listCacheHas;
$b2c937a9c7fcec3b$var$ListCache.prototype.set = $b2c937a9c7fcec3b$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2c937a9c7fcec3b$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b2c937a9c7fcec3b$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $b2c937a9c7fcec3b$var$Hash,
        'map': new ($b2c937a9c7fcec3b$var$Map || $b2c937a9c7fcec3b$var$ListCache),
        'string': new $b2c937a9c7fcec3b$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2c937a9c7fcec3b$var$mapCacheDelete(key) {
    return $b2c937a9c7fcec3b$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2c937a9c7fcec3b$var$mapCacheGet(key) {
    return $b2c937a9c7fcec3b$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b2c937a9c7fcec3b$var$mapCacheHas(key) {
    return $b2c937a9c7fcec3b$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $b2c937a9c7fcec3b$var$mapCacheSet(key, value) {
    $b2c937a9c7fcec3b$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$b2c937a9c7fcec3b$var$MapCache.prototype.clear = $b2c937a9c7fcec3b$var$mapCacheClear;
$b2c937a9c7fcec3b$var$MapCache.prototype['delete'] = $b2c937a9c7fcec3b$var$mapCacheDelete;
$b2c937a9c7fcec3b$var$MapCache.prototype.get = $b2c937a9c7fcec3b$var$mapCacheGet;
$b2c937a9c7fcec3b$var$MapCache.prototype.has = $b2c937a9c7fcec3b$var$mapCacheHas;
$b2c937a9c7fcec3b$var$MapCache.prototype.set = $b2c937a9c7fcec3b$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b2c937a9c7fcec3b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($b2c937a9c7fcec3b$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $b2c937a9c7fcec3b$var$baseIsNative(value) {
    if (!$b2c937a9c7fcec3b$var$isObject(value) || $b2c937a9c7fcec3b$var$isMasked(value)) return false;
    var pattern = $b2c937a9c7fcec3b$var$isFunction(value) || $b2c937a9c7fcec3b$var$isHostObject(value) ? $b2c937a9c7fcec3b$var$reIsNative : $b2c937a9c7fcec3b$var$reIsHostCtor;
    return pattern.test($b2c937a9c7fcec3b$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b2c937a9c7fcec3b$var$getMapData(map, key) {
    var data = map.__data__;
    return $b2c937a9c7fcec3b$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $b2c937a9c7fcec3b$var$getNative(object, key) {
    var value = $b2c937a9c7fcec3b$var$getValue(object, key);
    return $b2c937a9c7fcec3b$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b2c937a9c7fcec3b$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b2c937a9c7fcec3b$var$isMasked(func) {
    return !!$b2c937a9c7fcec3b$var$maskSrcKey && $b2c937a9c7fcec3b$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $b2c937a9c7fcec3b$var$toSource(func) {
    if (func != null) {
        try {
            return $b2c937a9c7fcec3b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $b2c937a9c7fcec3b$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($b2c937a9c7fcec3b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($b2c937a9c7fcec3b$var$memoize.Cache || $b2c937a9c7fcec3b$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$b2c937a9c7fcec3b$var$memoize.Cache = $b2c937a9c7fcec3b$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $b2c937a9c7fcec3b$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b2c937a9c7fcec3b$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $b2c937a9c7fcec3b$var$isObject(value) ? $b2c937a9c7fcec3b$var$objectToString.call(value) : '';
    return tag == $b2c937a9c7fcec3b$var$funcTag || tag == $b2c937a9c7fcec3b$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b2c937a9c7fcec3b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$b2c937a9c7fcec3b$exports = $b2c937a9c7fcec3b$var$memoize;


function $3cee2524baeacc16$var$resolver(options) {
    return JSON.stringify(options);
}
function $3cee2524baeacc16$var$isString(el) {
    return typeof el === 'string';
}
function $3cee2524baeacc16$var$isUnique(el, index, arr) {
    return arr.indexOf(el) === index;
}
function $3cee2524baeacc16$var$isAllLowerCase(el) {
    return el.toLowerCase() === el;
}
function $3cee2524baeacc16$var$fixCommas(el) {
    return el.indexOf(',') === -1 ? el : el.split(',');
}
function $3cee2524baeacc16$var$normalizeLocale(locale) {
    if (!locale) return locale;
    if (locale === 'C' || locale === 'posix' || locale === 'POSIX') return 'en-US';
    // If there's a dot (.) in the locale, it's likely in the format of "en-US.UTF-8", so we only take the first part
    if (locale.indexOf('.') !== -1) {
        var _a = locale.split('.')[0], actualLocale = _a === void 0 ? '' : _a;
        return $3cee2524baeacc16$var$normalizeLocale(actualLocale);
    }
    // If there's an at sign (@) in the locale, it's likely in the format of "en-US@posix", so we only take the first part
    if (locale.indexOf('@') !== -1) {
        var _b = locale.split('@')[0], actualLocale = _b === void 0 ? '' : _b;
        return $3cee2524baeacc16$var$normalizeLocale(actualLocale);
    }
    // If there's a dash (-) in the locale and it's not all lower case, it's already in the format of "en-US", so we return it
    if (locale.indexOf('-') === -1 || !$3cee2524baeacc16$var$isAllLowerCase(locale)) return locale;
    var _c = locale.split('-'), splitEl1 = _c[0], _d = _c[1], splitEl2 = _d === void 0 ? '' : _d;
    return "".concat(splitEl1, "-").concat(splitEl2.toUpperCase());
}
function $3cee2524baeacc16$var$getUserLocalesInternal(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.useFallbackLocale, useFallbackLocale = _c === void 0 ? true : _c, _d = _b.fallbackLocale, fallbackLocale = _d === void 0 ? 'en-US' : _d;
    var languageList = [];
    if (typeof navigator !== 'undefined') {
        var rawLanguages = navigator.languages || [];
        var languages = [];
        for(var _i = 0, rawLanguages_1 = rawLanguages; _i < rawLanguages_1.length; _i++){
            var rawLanguagesItem = rawLanguages_1[_i];
            languages = languages.concat($3cee2524baeacc16$var$fixCommas(rawLanguagesItem));
        }
        var rawLanguage = navigator.language;
        var language = rawLanguage ? $3cee2524baeacc16$var$fixCommas(rawLanguage) : rawLanguage;
        languageList = languageList.concat(languages, language);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return languageList.filter($3cee2524baeacc16$var$isString).map($3cee2524baeacc16$var$normalizeLocale).filter($3cee2524baeacc16$var$isUnique);
}
var $3cee2524baeacc16$export$2709d88c05bbce73 = (0, (/*@__PURE__*/$parcel$interopDefault($b2c937a9c7fcec3b$exports)))($3cee2524baeacc16$var$getUserLocalesInternal, $3cee2524baeacc16$var$resolver);
function $3cee2524baeacc16$var$getUserLocaleInternal(options) {
    return $3cee2524baeacc16$export$2709d88c05bbce73(options)[0] || null;
}
var $3cee2524baeacc16$export$a6ea185b366483aa = (0, (/*@__PURE__*/$parcel$interopDefault($b2c937a9c7fcec3b$exports)))($3cee2524baeacc16$var$getUserLocaleInternal, $3cee2524baeacc16$var$resolver);
var $3cee2524baeacc16$export$2e2bcd8739ae039 = $3cee2524baeacc16$export$a6ea185b366483aa;


/**
 * Utils
 */ function $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $78fdc7949801ab2a$var$makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function $78fdc7949801ab2a$var$makeGetRange(getStart, getEnd) {
    return function makeGetRangeInternal(date) {
        return [
            getStart(date),
            getEnd(date)
        ];
    };
}
function $78fdc7949801ab2a$export$5846dc2d57a5c860(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === 'number') return date;
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date) {
    if (date instanceof Date) return date.getMonth();
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$a8575fd59bc333e3(date) {
    if (date instanceof Date) return date.getMonth() + 1;
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$aa350b96d91cd94(date) {
    if (date instanceof Date) return date.getDate();
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$257b40f71c07d58f(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            if (hoursString) {
                var hours = parseInt(hoursString, 10);
                if (!isNaN(hours)) return hours;
            }
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$b7f1bc3ea3ac4145(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || '0';
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) return minutes;
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$5e9417507ff28427(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var seconds = parseInt(secondsWithMillisecondsString, 10);
            if (!isNaN(seconds)) return seconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$b8e4380f312797af(date) {
    if (date instanceof Date) return date.getMilliseconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var millisecondsString = secondsWithMillisecondsString.split('.')[1] || '0';
            var milliseconds = parseInt(millisecondsString, 10);
            if (!isNaN(milliseconds)) return milliseconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function $78fdc7949801ab2a$export$34dd42d02ca37c6b(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var centuryStartYear = year + (-year + 1) % 100;
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
var $78fdc7949801ab2a$export$e65b64b0f80e225a = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$34dd42d02ca37c6b, -100);
var $78fdc7949801ab2a$export$3e300bd96d747c8a = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$34dd42d02ca37c6b, 100);
var $78fdc7949801ab2a$export$43c2109e18ca667b = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$3e300bd96d747c8a);
var $78fdc7949801ab2a$export$4d124431cf7f00b5 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$43c2109e18ca667b, -100);
var $78fdc7949801ab2a$export$2663e0ade48d35a9 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$43c2109e18ca667b, 100);
var $78fdc7949801ab2a$export$a4332dc3f9de051f = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$34dd42d02ca37c6b, $78fdc7949801ab2a$export$43c2109e18ca667b);
function $78fdc7949801ab2a$export$8bb35b885d308e78(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var decadeStartYear = year + (-year + 1) % 10;
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
var $78fdc7949801ab2a$export$e43f83f55f1766fa = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$8bb35b885d308e78, -10);
var $78fdc7949801ab2a$export$8266d1a140c33d17 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$8bb35b885d308e78, 10);
var $78fdc7949801ab2a$export$aa0bfba5bfc33956 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$8266d1a140c33d17);
var $78fdc7949801ab2a$export$93edec1b41903921 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$aa0bfba5bfc33956, -10);
var $78fdc7949801ab2a$export$112141384c9d3d6b = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$aa0bfba5bfc33956, 10);
var $78fdc7949801ab2a$export$35cef0a1278b17e1 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$8bb35b885d308e78, $78fdc7949801ab2a$export$aa0bfba5bfc33956);
function $78fdc7949801ab2a$export$bbcf6a6951bb3c3a(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
var $78fdc7949801ab2a$export$97fe927b771a6825 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a, -1);
var $78fdc7949801ab2a$export$fed82860795beff7 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a, 1);
var $78fdc7949801ab2a$export$248ddd7fb95e4a56 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$fed82860795beff7);
var $78fdc7949801ab2a$export$639fe5fbfbb704d0 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$248ddd7fb95e4a56, -1);
var $78fdc7949801ab2a$export$952396487caf69e5 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighbor($78fdc7949801ab2a$export$5846dc2d57a5c860, $78fdc7949801ab2a$export$248ddd7fb95e4a56, 1);
var $78fdc7949801ab2a$export$17e213d8c10b7032 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$bbcf6a6951bb3c3a, $78fdc7949801ab2a$export$248ddd7fb95e4a56);
/**
 * Month
 */ function $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
        var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $78fdc7949801ab2a$export$c7002b157c9b9e95(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
var $78fdc7949801ab2a$export$e1815383d4029267 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$c7002b157c9b9e95, -1);
var $78fdc7949801ab2a$export$21b7c773284d5b43 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$c7002b157c9b9e95, 1);
var $78fdc7949801ab2a$export$6f306f93ccbcd612 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$21b7c773284d5b43);
var $78fdc7949801ab2a$export$b4b5df1ab9a8303b = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$6f306f93ccbcd612, -1);
var $78fdc7949801ab2a$export$98f1c9e60dc0189 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborMonth($78fdc7949801ab2a$export$6f306f93ccbcd612, 1);
var $78fdc7949801ab2a$export$c59fdbf3ad20e694 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$c7002b157c9b9e95, $78fdc7949801ab2a$export$6f306f93ccbcd612);
/**
 * Day
 */ function $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
        var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date);
        var day = $78fdc7949801ab2a$export$aa350b96d91cd94(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function $78fdc7949801ab2a$export$ef6b506418c2b397(date) {
    var year = $78fdc7949801ab2a$export$5846dc2d57a5c860(date);
    var month = $78fdc7949801ab2a$export$6ce1b5acc29cb53b(date);
    var day = $78fdc7949801ab2a$export$aa350b96d91cd94(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
var $78fdc7949801ab2a$export$4f27323eaab2ccfd = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$ef6b506418c2b397, -1);
var $78fdc7949801ab2a$export$78c5682078b46db4 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$ef6b506418c2b397, 1);
var $78fdc7949801ab2a$export$7b798396f3e38cd7 = $78fdc7949801ab2a$var$makeGetEnd($78fdc7949801ab2a$export$78c5682078b46db4);
var $78fdc7949801ab2a$export$fde0c09caefdfd4a = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$7b798396f3e38cd7, -1);
var $78fdc7949801ab2a$export$f991202e82da93a1 = $78fdc7949801ab2a$var$makeGetEdgeOfNeighborDay($78fdc7949801ab2a$export$7b798396f3e38cd7, 1);
var $78fdc7949801ab2a$export$adb5aef569605e64 = $78fdc7949801ab2a$var$makeGetRange($78fdc7949801ab2a$export$ef6b506418c2b397, $78fdc7949801ab2a$export$7b798396f3e38cd7);
function $78fdc7949801ab2a$export$f645ddd439eb259d(date) {
    return $78fdc7949801ab2a$export$aa350b96d91cd94($78fdc7949801ab2a$export$6f306f93ccbcd612(date));
}
function $78fdc7949801ab2a$var$padStart(num, val) {
    if (val === void 0) val = 2;
    var numStr = "".concat(num);
    if (numStr.length >= val) return num;
    return "0000".concat(numStr).slice(-val);
}
function $78fdc7949801ab2a$export$aefe158a7bd76d23(date) {
    var hours = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$257b40f71c07d58f(date));
    var minutes = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$b7f1bc3ea3ac4145(date));
    return "".concat(hours, ":").concat(minutes);
}
function $78fdc7949801ab2a$export$52113457154e5fc(date) {
    var hours = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$257b40f71c07d58f(date));
    var minutes = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$b7f1bc3ea3ac4145(date));
    var seconds = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$5e9417507ff28427(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function $78fdc7949801ab2a$export$6f885d58ae224c35(date) {
    var year = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$5846dc2d57a5c860(date), 4);
    var month = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$a8575fd59bc333e3(date));
    return "".concat(year, "-").concat(month);
}
function $78fdc7949801ab2a$export$ce780a31b7197841(date) {
    var year = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$5846dc2d57a5c860(date), 4);
    var month = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$a8575fd59bc333e3(date));
    var day = $78fdc7949801ab2a$var$padStart($78fdc7949801ab2a$export$aa350b96d91cd94(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function $78fdc7949801ab2a$export$98f36b76519fd86(date) {
    return "".concat($78fdc7949801ab2a$export$ce780a31b7197841(date), "T").concat($78fdc7949801ab2a$export$52113457154e5fc(date));
}


var $6ede4d444f78ee44$var$_a;
var $6ede4d444f78ee44$export$26fa441040070c35 = {
    GREGORY: 'gregory',
    HEBREW: 'hebrew',
    ISLAMIC: 'islamic',
    ISO_8601: 'iso8601'
};
var $6ede4d444f78ee44$export$c75dd2712cca6e92 = {
    ARABIC: 'Arabic',
    HEBREW: 'Hebrew',
    ISO_8601: 'ISO 8601',
    US: 'US'
};
var $6ede4d444f78ee44$export$e4e5576db5b8e30f = ($6ede4d444f78ee44$var$_a = {}, $6ede4d444f78ee44$var$_a[$6ede4d444f78ee44$export$26fa441040070c35.GREGORY] = [
    'en-CA',
    'en-US',
    'es-AR',
    'es-BO',
    'es-CL',
    'es-CO',
    'es-CR',
    'es-DO',
    'es-EC',
    'es-GT',
    'es-HN',
    'es-MX',
    'es-NI',
    'es-PA',
    'es-PE',
    'es-PR',
    'es-SV',
    'es-VE',
    'pt-BR'
], $6ede4d444f78ee44$var$_a[$6ede4d444f78ee44$export$26fa441040070c35.HEBREW] = [
    'he',
    'he-IL'
], $6ede4d444f78ee44$var$_a[$6ede4d444f78ee44$export$26fa441040070c35.ISLAMIC] = [
    // ar-LB, ar-MA intentionally missing
    'ar',
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LY',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SD',
    'ar-SY',
    'ar-YE',
    'dv',
    'dv-MV',
    'ps',
    'ps-AR'
], $6ede4d444f78ee44$var$_a);
var $6ede4d444f78ee44$export$ecc24ef5795d74f8 = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];



var $5398151a7800b344$var$formatterCache = new Map();
function $5398151a7800b344$var$getFormatter(options) {
    return function formatter(locale, date) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$5398151a7800b344$var$formatterCache.has(localeWithDefault)) $5398151a7800b344$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $5398151a7800b344$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault || undefined, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 * @returns {Date} Date with hour set to 12.
 */ function $5398151a7800b344$var$toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function $5398151a7800b344$var$getSafeFormatter(options) {
    return function(locale, date) {
        return $5398151a7800b344$var$getFormatter(options)(locale, $5398151a7800b344$var$toSafeHour(date));
    };
}
var $5398151a7800b344$var$formatDateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};
var $5398151a7800b344$var$formatDayOptions = {
    day: 'numeric'
};
var $5398151a7800b344$var$formatLongDateOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
var $5398151a7800b344$var$formatMonthOptions = {
    month: 'long'
};
var $5398151a7800b344$var$formatMonthYearOptions = {
    month: 'long',
    year: 'numeric'
};
var $5398151a7800b344$var$formatShortWeekdayOptions = {
    weekday: 'short'
};
var $5398151a7800b344$var$formatWeekdayOptions = {
    weekday: 'long'
};
var $5398151a7800b344$var$formatYearOptions = {
    year: 'numeric'
};
var $5398151a7800b344$export$3ae94a2503e890a1 = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatDateOptions);
var $5398151a7800b344$export$a7f242eff11c1345 = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatDayOptions);
var $5398151a7800b344$export$322b36d80aef60ca = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatLongDateOptions);
var $5398151a7800b344$export$d0536c8e7f45796e = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatMonthOptions);
var $5398151a7800b344$export$18f8ccbe37e54acd = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatMonthYearOptions);
var $5398151a7800b344$export$7ebe25e42481bc02 = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatShortWeekdayOptions);
var $5398151a7800b344$export$407180b957f39d7e = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatWeekdayOptions);
var $5398151a7800b344$export$2979e79cc7cbf15b = $5398151a7800b344$var$getSafeFormatter($5398151a7800b344$var$formatYearOptions);


var $f0256d0d4f3b1098$var$SUNDAY = (0, $6ede4d444f78ee44$export$ecc24ef5795d74f8)[0];
var $f0256d0d4f3b1098$var$FRIDAY = (0, $6ede4d444f78ee44$export$ecc24ef5795d74f8)[5];
var $f0256d0d4f3b1098$var$SATURDAY = (0, $6ede4d444f78ee44$export$ecc24ef5795d74f8)[6];
function $f0256d0d4f3b1098$export$2061056d06d7cdf7(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601:
            // Shifts days of the week so that Monday is 0, Sunday is 6
            return (weekday + 6) % 7;
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ISLAMIC:
            return (weekday + 1) % 7;
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).HEBREW:
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).GREGORY:
            return weekday;
        default:
            throw new Error('Unsupported calendar type.');
    }
}
function $f0256d0d4f3b1098$export$5fc0cc931278f768(date) {
    var beginOfCentury = (0, $78fdc7949801ab2a$export$34dd42d02ca37c6b)(date);
    return (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(beginOfCentury);
}
function $f0256d0d4f3b1098$export$59fb6e4ffa904295(date) {
    var beginOfDecade = (0, $78fdc7949801ab2a$export$8bb35b885d308e78)(date);
    return (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(beginOfDecade);
}
function $f0256d0d4f3b1098$export$84e707e5f485f282(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date);
    var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(date);
    var day = date.getDate() - $f0256d0d4f3b1098$export$2061056d06d7cdf7(date, calendarType);
    return new Date(year, monthIndex, day);
}
function $f0256d0d4f3b1098$export$b59889984706b7a7(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var calendarTypeForWeekNumber = calendarType === (0, $6ede4d444f78ee44$export$26fa441040070c35).GREGORY ? (0, $6ede4d444f78ee44$export$26fa441040070c35).GREGORY : (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var beginOfWeek = $f0256d0d4f3b1098$export$84e707e5f485f282(date, calendarType);
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek;
    // Look for the first week one that does not come after a given date
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601 ? 4 : 1);
        beginOfFirstWeek = $f0256d0d4f3b1098$export$84e707e5f485f282(dayInWeekOne, calendarType);
        year -= 1;
    }while (date < beginOfFirstWeek);
    return Math.round((beginOfWeek.getTime() - beginOfFirstWeek.getTime()) / (8.64e7 * 7)) + 1;
}
function $f0256d0d4f3b1098$export$700a64ae37cbc741(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $78fdc7949801ab2a$export$34dd42d02ca37c6b)(date);
        case 'decade':
            return (0, $78fdc7949801ab2a$export$8bb35b885d308e78)(date);
        case 'year':
            return (0, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a)(date);
        case 'month':
            return (0, $78fdc7949801ab2a$export$c7002b157c9b9e95)(date);
        case 'day':
            return (0, $78fdc7949801ab2a$export$ef6b506418c2b397)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$fac7f4c8b12617ff(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $78fdc7949801ab2a$export$e65b64b0f80e225a)(date);
        case 'decade':
            return (0, $78fdc7949801ab2a$export$e43f83f55f1766fa)(date);
        case 'year':
            return (0, $78fdc7949801ab2a$export$97fe927b771a6825)(date);
        case 'month':
            return (0, $78fdc7949801ab2a$export$e1815383d4029267)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$19193c1f2d841d47(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $78fdc7949801ab2a$export$3e300bd96d747c8a)(date);
        case 'decade':
            return (0, $78fdc7949801ab2a$export$8266d1a140c33d17)(date);
        case 'year':
            return (0, $78fdc7949801ab2a$export$fed82860795beff7)(date);
        case 'month':
            return (0, $78fdc7949801ab2a$export$21b7c773284d5b43)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$b514bf5935bed2bf(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $78fdc7949801ab2a$export$e43f83f55f1766fa)(date, -100);
        case 'year':
            return (0, $78fdc7949801ab2a$export$97fe927b771a6825)(date, -10);
        case 'month':
            return (0, $78fdc7949801ab2a$export$e1815383d4029267)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$2805b7ce8402b644(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $78fdc7949801ab2a$export$8266d1a140c33d17)(date, 100);
        case 'year':
            return (0, $78fdc7949801ab2a$export$fed82860795beff7)(date, 10);
        case 'month':
            return (0, $78fdc7949801ab2a$export$21b7c773284d5b43)(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$946298ccd438a697(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $78fdc7949801ab2a$export$43c2109e18ca667b)(date);
        case 'decade':
            return (0, $78fdc7949801ab2a$export$aa0bfba5bfc33956)(date);
        case 'year':
            return (0, $78fdc7949801ab2a$export$248ddd7fb95e4a56)(date);
        case 'month':
            return (0, $78fdc7949801ab2a$export$6f306f93ccbcd612)(date);
        case 'day':
            return (0, $78fdc7949801ab2a$export$7b798396f3e38cd7)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$3030eb755e02a078(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $78fdc7949801ab2a$export$4d124431cf7f00b5)(date);
        case 'decade':
            return (0, $78fdc7949801ab2a$export$93edec1b41903921)(date);
        case 'year':
            return (0, $78fdc7949801ab2a$export$639fe5fbfbb704d0)(date);
        case 'month':
            return (0, $78fdc7949801ab2a$export$b4b5df1ab9a8303b)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$d34b1dc45bd5f1d3(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return (0, $78fdc7949801ab2a$export$93edec1b41903921)(date, -100);
        case 'year':
            return (0, $78fdc7949801ab2a$export$639fe5fbfbb704d0)(date, -10);
        case 'month':
            return (0, $78fdc7949801ab2a$export$b4b5df1ab9a8303b)(date, -12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$fef151b94550e9f5(rangeType, date) {
    switch(rangeType){
        case 'century':
            return (0, $78fdc7949801ab2a$export$a4332dc3f9de051f)(date);
        case 'decade':
            return (0, $78fdc7949801ab2a$export$35cef0a1278b17e1)(date);
        case 'year':
            return (0, $78fdc7949801ab2a$export$17e213d8c10b7032)(date);
        case 'month':
            return (0, $78fdc7949801ab2a$export$c59fdbf3ad20e694)(date);
        case 'day':
            return (0, $78fdc7949801ab2a$export$adb5aef569605e64)(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function $f0256d0d4f3b1098$export$3a3e6dbcaf74641d(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a, b) {
        return a.getTime() - b.getTime();
    });
    return [
        $f0256d0d4f3b1098$export$700a64ae37cbc741(rangeType, rawNextValue[0]),
        $f0256d0d4f3b1098$export$946298ccd438a697(rangeType, rawNextValue[1])
    ];
}
function $f0256d0d4f3b1098$var$toYearLabel(locale, formatYear, dates) {
    if (formatYear === void 0) formatYear = (0, $5398151a7800b344$export$2979e79cc7cbf15b);
    return dates.map(function(date) {
        return formatYear(locale, date);
    }).join(" \u2013 ");
}
function $f0256d0d4f3b1098$export$a05bb87f2c518835(locale, formatYear, date) {
    return $f0256d0d4f3b1098$var$toYearLabel(locale, formatYear, (0, $78fdc7949801ab2a$export$a4332dc3f9de051f)(date));
}
function $f0256d0d4f3b1098$export$2e69ef6076209750(locale, formatYear, date) {
    return $f0256d0d4f3b1098$var$toYearLabel(locale, formatYear, (0, $78fdc7949801ab2a$export$35cef0a1278b17e1)(date));
}
function $f0256d0d4f3b1098$export$12e2595dc60a5d5(date) {
    return date.getDay() === new Date().getDay();
}
function $f0256d0d4f3b1098$export$618d60ea299da42(date, calendarType) {
    if (calendarType === void 0) calendarType = (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
    var weekday = date.getDay();
    switch(calendarType){
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ISLAMIC:
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).HEBREW:
            return weekday === $f0256d0d4f3b1098$var$FRIDAY || weekday === $f0256d0d4f3b1098$var$SATURDAY;
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601:
        case (0, $6ede4d444f78ee44$export$26fa441040070c35).GREGORY:
            return weekday === $f0256d0d4f3b1098$var$SATURDAY || weekday === $f0256d0d4f3b1098$var$SUNDAY;
        default:
            throw new Error('Unsupported calendar type.');
    }
}



'use client';
var $cfbfa00fe9577c18$var$className = 'react-calendar__navigation';
function $cfbfa00fe9577c18$export$2e2bcd8739ae039(_a) {
    var activeStartDate = _a.activeStartDate, drillUp = _a.drillUp, _b = _a.formatMonthYear, formatMonthYear = _b === void 0 ? (0, $5398151a7800b344$export$18f8ccbe37e54acd) : _b, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $5398151a7800b344$export$2979e79cc7cbf15b) : _c, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, _d = _a.navigationAriaLabel, navigationAriaLabel = _d === void 0 ? '' : _d, navigationAriaLive = _a.navigationAriaLive, navigationLabel = _a.navigationLabel, _e = _a.next2AriaLabel, next2AriaLabel = _e === void 0 ? '' : _e, _f = _a.next2Label, next2Label = _f === void 0 ? "\xbb" : _f, _g = _a.nextAriaLabel, nextAriaLabel = _g === void 0 ? '' : _g, _h = _a.nextLabel, nextLabel = _h === void 0 ? "\u203A" : _h, _j = _a.prev2AriaLabel, prev2AriaLabel = _j === void 0 ? '' : _j, _k = _a.prev2Label, prev2Label = _k === void 0 ? "\xab" : _k, _l = _a.prevAriaLabel, prevAriaLabel = _l === void 0 ? '' : _l, _m = _a.prevLabel, prevLabel = _m === void 0 ? "\u2039" : _m, setActiveStartDate = _a.setActiveStartDate, showDoubleView = _a.showDoubleView, view = _a.view, views = _a.views;
    var drillUpAvailable = views.indexOf(view) > 0;
    var shouldShowPrevNext2Buttons = view !== 'century';
    var previousActiveStartDate = (0, $f0256d0d4f3b1098$export$fac7f4c8b12617ff)(view, activeStartDate);
    var previousActiveStartDate2 = shouldShowPrevNext2Buttons ? (0, $f0256d0d4f3b1098$export$b514bf5935bed2bf)(view, activeStartDate) : undefined;
    var nextActiveStartDate = (0, $f0256d0d4f3b1098$export$19193c1f2d841d47)(view, activeStartDate);
    var nextActiveStartDate2 = shouldShowPrevNext2Buttons ? (0, $f0256d0d4f3b1098$export$2805b7ce8402b644)(view, activeStartDate) : undefined;
    var prevButtonDisabled = function() {
        if (previousActiveStartDate.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $f0256d0d4f3b1098$export$3030eb755e02a078)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
        if (previousActiveStartDate2.getFullYear() < 0) return true;
        var previousActiveEndDate = (0, $f0256d0d4f3b1098$export$d34b1dc45bd5f1d3)(view, activeStartDate);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
    var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
    function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate, 'prev');
    }
    function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2, 'prev2');
    }
    function onClickNext() {
        setActiveStartDate(nextActiveStartDate, 'next');
    }
    function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2, 'next2');
    }
    function renderLabel(date) {
        var label = function() {
            switch(view){
                case 'century':
                    return (0, $f0256d0d4f3b1098$export$a05bb87f2c518835)(locale, formatYear, date);
                case 'decade':
                    return (0, $f0256d0d4f3b1098$export$2e69ef6076209750)(locale, formatYear, date);
                case 'year':
                    return formatYear(locale, date);
                case 'month':
                    return formatMonthYear(locale, date);
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        return navigationLabel ? navigationLabel({
            date: date,
            label: label,
            locale: locale || (0, $3cee2524baeacc16$export$a6ea185b366483aa)() || undefined,
            view: view
        }) : label;
    }
    function renderButton() {
        var labelClassName = "".concat($cfbfa00fe9577c18$var$className, "__label");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "aria-label": navigationAriaLabel,
            "aria-live": navigationAriaLive,
            className: labelClassName,
            disabled: !drillUpAvailable,
            onClick: drillUp,
            style: {
                flexGrow: 1
            },
            type: "button"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
        }, renderLabel(activeStartDate)), showDoubleView ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(labelClassName, "__divider")
        }, " \u2013 "), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
        }, renderLabel(nextActiveStartDate))) : null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $cfbfa00fe9577c18$var$className
    }, prev2Label !== null && shouldShowPrevNext2Buttons ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": prev2AriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__prev2-button"),
        disabled: prev2ButtonDisabled,
        onClick: onClickPrevious2,
        type: "button"
    }, prev2Label) : null, prevLabel !== null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": prevAriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__prev-button"),
        disabled: prevButtonDisabled,
        onClick: onClickPrevious,
        type: "button"
    }, prevLabel), renderButton(), nextLabel !== null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": nextAriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__next-button"),
        disabled: nextButtonDisabled,
        onClick: onClickNext,
        type: "button"
    }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": next2AriaLabel,
        className: "".concat($cfbfa00fe9577c18$var$className, "__arrow ").concat($cfbfa00fe9577c18$var$className, "__next2-button"),
        disabled: next2ButtonDisabled,
        onClick: onClickNext2,
        type: "button"
    }, next2Label) : null);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $19228e875a5c8531$var$__assign = undefined && undefined.__assign || function() {
    $19228e875a5c8531$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $19228e875a5c8531$var$__assign.apply(this, arguments);
};
var $19228e875a5c8531$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $19228e875a5c8531$var$toPercent(num) {
    return "".concat(num, "%");
}
function $19228e875a5c8531$export$2e2bcd8739ae039(_a) {
    var children = _a.children, className = _a.className, count = _a.count, direction = _a.direction, offset = _a.offset, style = _a.style, wrap = _a.wrap, otherProps = $19228e875a5c8531$var$__rest(_a, [
        "children",
        "className",
        "count",
        "direction",
        "offset",
        "style",
        "wrap"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $19228e875a5c8531$var$__assign({
        className: className,
        style: $19228e875a5c8531$var$__assign({
            display: 'flex',
            flexDirection: direction,
            flexWrap: wrap ? 'wrap' : 'nowrap'
        }, style)
    }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, function(child, index) {
        var marginInlineStart = offset && index === 0 ? $19228e875a5c8531$var$toPercent(100 * offset / count) : null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, $19228e875a5c8531$var$__assign($19228e875a5c8531$var$__assign({}, child.props), {
            style: {
                flexBasis: $19228e875a5c8531$var$toPercent(100 / count),
                flexShrink: 0,
                flexGrow: 0,
                overflow: 'hidden',
                marginLeft: marginInlineStart,
                marginInlineStart: marginInlineStart,
                marginInlineEnd: 0
            }
        }));
    }));
}



var $9RYKL = parcelRequire("9RYKL");


var $31b103f03d6f0116$var$_a;
function $31b103f03d6f0116$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
function $31b103f03d6f0116$export$7c4e06fee2f75722(value, range) {
    return range[0] <= value && range[1] >= value;
}
function $31b103f03d6f0116$export$eecb2aa703319c46(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function $31b103f03d6f0116$export$2e215bb7f5401ba1(range1, range2) {
    return $31b103f03d6f0116$export$7c4e06fee2f75722(range1[0], range2) || $31b103f03d6f0116$export$7c4e06fee2f75722(range1[1], range2);
}
function $31b103f03d6f0116$var$getRangeClassNames(valueRange, dateRange, baseClassName) {
    var isRange = $31b103f03d6f0116$export$2e215bb7f5401ba1(dateRange, valueRange);
    var classes = [];
    if (isRange) {
        classes.push(baseClassName);
        var isRangeStart = $31b103f03d6f0116$export$7c4e06fee2f75722(valueRange[0], dateRange);
        var isRangeEnd = $31b103f03d6f0116$export$7c4e06fee2f75722(valueRange[1], dateRange);
        if (isRangeStart) classes.push("".concat(baseClassName, "Start"));
        if (isRangeEnd) classes.push("".concat(baseClassName, "End"));
        if (isRangeStart && isRangeEnd) classes.push("".concat(baseClassName, "BothEnds"));
    }
    return classes;
}
function $31b103f03d6f0116$var$isCompleteValue(value) {
    if (Array.isArray(value)) return value[0] !== null && value[1] !== null;
    return value !== null;
}
function $31b103f03d6f0116$export$8b25b190354ee282(args) {
    if (!args) throw new Error('args is required');
    var value = args.value, date = args.date, hover = args.hover;
    var className = 'react-calendar__tile';
    var classes = [
        className
    ];
    if (!date) return classes;
    var now = new Date();
    var dateRange = function() {
        if (Array.isArray(date)) return date;
        var dateType = args.dateType;
        if (!dateType) throw new Error('dateType is required when date is not an array of two dates');
        return (0, $f0256d0d4f3b1098$export$fef151b94550e9f5)(dateType, date);
    }();
    if ($31b103f03d6f0116$export$7c4e06fee2f75722(now, dateRange)) classes.push("".concat(className, "--now"));
    if (!value || !$31b103f03d6f0116$var$isCompleteValue(value)) return classes;
    var valueRange = function() {
        if (Array.isArray(value)) return value;
        var valueType = args.valueType;
        if (!valueType) throw new Error('valueType is required when value is not an array of two dates');
        return (0, $f0256d0d4f3b1098$export$fef151b94550e9f5)(valueType, value);
    }();
    if ($31b103f03d6f0116$export$eecb2aa703319c46(valueRange, dateRange)) classes.push("".concat(className, "--active"));
    else if ($31b103f03d6f0116$export$2e215bb7f5401ba1(valueRange, dateRange)) classes.push("".concat(className, "--hasActive"));
    var valueRangeClassNames = $31b103f03d6f0116$var$getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
    classes.push.apply(classes, valueRangeClassNames);
    var valueArray = Array.isArray(value) ? value : [
        value
    ];
    if (hover && valueArray.length === 1) {
        var hoverRange = hover > valueRange[0] ? [
            valueRange[0],
            hover
        ] : [
            hover,
            valueRange[0]
        ];
        var hoverRangeClassNames = $31b103f03d6f0116$var$getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
        classes.push.apply(classes, hoverRangeClassNames);
    }
    return classes;
}
var $31b103f03d6f0116$var$calendarTypeMap = ($31b103f03d6f0116$var$_a = {}, $31b103f03d6f0116$var$_a[(0, $6ede4d444f78ee44$export$c75dd2712cca6e92).ARABIC] = (0, $6ede4d444f78ee44$export$26fa441040070c35).ISLAMIC, $31b103f03d6f0116$var$_a[(0, $6ede4d444f78ee44$export$c75dd2712cca6e92).HEBREW] = (0, $6ede4d444f78ee44$export$26fa441040070c35).HEBREW, $31b103f03d6f0116$var$_a[(0, $6ede4d444f78ee44$export$c75dd2712cca6e92).ISO_8601] = (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601, $31b103f03d6f0116$var$_a[(0, $6ede4d444f78ee44$export$c75dd2712cca6e92).US] = (0, $6ede4d444f78ee44$export$26fa441040070c35).GREGORY, $31b103f03d6f0116$var$_a);
function $31b103f03d6f0116$var$isDeprecatedCalendarType(calendarType) {
    return calendarType !== undefined && calendarType in (0, $6ede4d444f78ee44$export$c75dd2712cca6e92);
}
var $31b103f03d6f0116$var$warned = false;
function $31b103f03d6f0116$export$52aa1e9fb4a280ce(calendarTypeOrDeprecatedCalendarType) {
    if ($31b103f03d6f0116$var$isDeprecatedCalendarType(calendarTypeOrDeprecatedCalendarType)) {
        var calendarType = $31b103f03d6f0116$var$calendarTypeMap[calendarTypeOrDeprecatedCalendarType];
        (0, $9RYKL.default)($31b103f03d6f0116$var$warned, "Specifying calendarType=\"".concat(calendarTypeOrDeprecatedCalendarType, "\" is deprecated. Use calendarType=\"").concat(calendarType, "\" instead."));
        $31b103f03d6f0116$var$warned = true;
        return calendarType;
    }
    return calendarTypeOrDeprecatedCalendarType;
}


function $89388808b0fcfc7d$export$2e2bcd8739ae039(_a) {
    var className = _a.className, _b = _a.count, count = _b === void 0 ? 3 : _b, dateTransform = _a.dateTransform, dateType = _a.dateType, end = _a.end, hover = _a.hover, offset = _a.offset, renderTile = _a.renderTile, start = _a.start, _c = _a.step, step = _c === void 0 ? 1 : _c, value = _a.value, valueType = _a.valueType;
    var tiles = [];
    for(var point = start; point <= end; point += step){
        var date = dateTransform(point);
        tiles.push(renderTile({
            classes: (0, $31b103f03d6f0116$export$8b25b190354ee282)({
                date: date,
                dateType: dateType,
                hover: hover,
                value: value,
                valueType: valueType
            }),
            date: date
        }));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19228e875a5c8531$export$2e2bcd8739ae039), {
        className: className,
        count: count,
        offset: offset,
        wrap: true
    }, tiles);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $96d05e9cc89df7f5$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, children = props.children, classes = props.classes, date = props.date, formatAbbr = props.formatAbbr, locale = props.locale, maxDate = props.maxDate, maxDateTransform = props.maxDateTransform, minDate = props.minDate, minDateTransform = props.minDateTransform, onClick = props.onClick, onMouseOver = props.onMouseOver, style = props.style, tileClassNameProps = props.tileClassName, tileContentProps = props.tileContent, tileDisabled = props.tileDisabled, view = props.view;
    var tileClassName = (0, $acw62.useMemo)(function() {
        var args = {
            activeStartDate: activeStartDate,
            date: date,
            view: view
        };
        return typeof tileClassNameProps === 'function' ? tileClassNameProps(args) : tileClassNameProps;
    }, [
        activeStartDate,
        date,
        tileClassNameProps,
        view
    ]);
    var tileContent = (0, $acw62.useMemo)(function() {
        var args = {
            activeStartDate: activeStartDate,
            date: date,
            view: view
        };
        return typeof tileContentProps === 'function' ? tileContentProps(args) : tileContentProps;
    }, [
        activeStartDate,
        date,
        tileContentProps,
        view
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: (0, $a45fe03b551d5ffa$export$2e2bcd8739ae039)(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
            activeStartDate: activeStartDate,
            date: date,
            view: view
        }),
        onClick: onClick ? function(event) {
            return onClick(date, event);
        } : undefined,
        onFocus: onMouseOver ? function() {
            return onMouseOver(date);
        } : undefined,
        onMouseOver: onMouseOver ? function() {
            return onMouseOver(date);
        } : undefined,
        style: style,
        type: "button"
    }, formatAbbr ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
    }, children) : children, tileContent);
}




var $a4987d626034a3cd$var$__assign = undefined && undefined.__assign || function() {
    $a4987d626034a3cd$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a4987d626034a3cd$var$__assign.apply(this, arguments);
};
var $a4987d626034a3cd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a4987d626034a3cd$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a4987d626034a3cd$var$className = 'react-calendar__century-view__decades__decade';
function $a4987d626034a3cd$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $5398151a7800b344$export$2979e79cc7cbf15b) : _c, otherProps = $a4987d626034a3cd$var$__rest(_a, [
        "classes",
        "formatYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $a4987d626034a3cd$var$__assign({}, otherProps, {
        classes: $a4987d626034a3cd$var$__spreadArray($a4987d626034a3cd$var$__spreadArray([], classes, true), [
            $a4987d626034a3cd$var$className
        ], false),
        maxDateTransform: (0, $78fdc7949801ab2a$export$aa0bfba5bfc33956),
        minDateTransform: (0, $78fdc7949801ab2a$export$8bb35b885d308e78),
        view: "century"
    }), (0, $f0256d0d4f3b1098$export$2e69ef6076209750)(locale, formatYear, date));
}



var $ddd6edd34bb52616$var$__assign = undefined && undefined.__assign || function() {
    $ddd6edd34bb52616$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ddd6edd34bb52616$var$__assign.apply(this, arguments);
};
var $ddd6edd34bb52616$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ddd6edd34bb52616$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, value = props.value, valueType = props.valueType, otherProps = $ddd6edd34bb52616$var$__rest(props, [
        "activeStartDate",
        "hover",
        "value",
        "valueType"
    ]);
    var start = (0, $f0256d0d4f3b1098$export$5fc0cc931278f768)(activeStartDate);
    var end = start + 99;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), {
        className: "react-calendar__century-view__decades",
        dateTransform: (0, $78fdc7949801ab2a$export$8bb35b885d308e78),
        dateType: "decade",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $ddd6edd34bb52616$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a4987d626034a3cd$export$2e2bcd8739ae039), $ddd6edd34bb52616$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                date: date
            }));
        },
        start: start,
        step: 10,
        value: value,
        valueType: valueType
    });
}



var $c9Z8w = parcelRequire("c9Z8w");

var $42f0853312470faa$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $42f0853312470faa$var$calendarTypes = Object.values((0, $6ede4d444f78ee44$export$26fa441040070c35));
var $42f0853312470faa$var$deprecatedCalendarTypes = Object.values((0, $6ede4d444f78ee44$export$c75dd2712cca6e92));
var $42f0853312470faa$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $42f0853312470faa$export$9780328ce60eac34 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($42f0853312470faa$var$__spreadArray($42f0853312470faa$var$__spreadArray([], $42f0853312470faa$var$calendarTypes, true), $42f0853312470faa$var$deprecatedCalendarTypes, true));
var $42f0853312470faa$export$d53f3db2f43345df = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
]);
var $42f0853312470faa$export$283839a53860a2f5 = function isMinDate(props, propName, componentName) {
    var _a = props, _b = propName, minDate = _a[_b];
    if (!minDate) return null;
    if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate, "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var maxDate = props.maxDate;
    if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate, "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    return null;
};
var $42f0853312470faa$export$20075fd45e42d41c = function isMaxDate(props, propName, componentName) {
    var _a = props, _b = propName, maxDate = _a[_b];
    if (!maxDate) return null;
    if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof maxDate, "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var minDate = props.minDate;
    if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof maxDate, "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    return null;
};
var $42f0853312470faa$export$4f9f5282de18fc69 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).exact({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    })
]);
var $42f0853312470faa$var$isRange = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        null
    ])
]).isRequired);
var $42f0853312470faa$export$2fb7a00a48619649 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        null
    ]),
    $42f0853312470faa$var$isRange
]);
var $42f0853312470faa$export$bf6a8a97c2633c68 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($42f0853312470faa$var$allViews));
var $42f0853312470faa$export$7c1393839656cd16 = function isView(props, propName, componentName) {
    var _a = props, _b = propName, view = _a[_b];
    if (view !== undefined && (typeof view !== 'string' || $42f0853312470faa$var$allViews.indexOf(view) === -1)) return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat($42f0853312470faa$var$allViews.map(function(a) {
        return "\"".concat(a, "\"");
    }).join(', '), "]."));
    // Everything is fine
    return null;
};
$42f0853312470faa$export$7c1393839656cd16.isRequired = function isViewIsRequired(props, propName, componentName, location, propFullName) {
    var _a = props, _b = propName, view = _a[_b];
    if (!view) return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
    return $42f0853312470faa$export$7c1393839656cd16(props, propName, componentName, location, propFullName);
};
var $42f0853312470faa$export$382f6fb00c4220 = function(type) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf(type);
};
var $42f0853312470faa$export$61cce6a131f71246 = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    hover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: $42f0853312470faa$export$20075fd45e42d41c,
    minDate: $42f0853312470faa$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        $42f0853312470faa$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    value: $42f0853312470faa$export$2fb7a00a48619649,
    valueType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'century',
        'decade',
        'year',
        'month',
        'day'
    ]).isRequired
};
var $42f0853312470faa$export$8571f7299c7936ad = {
    activeStartDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired).isRequired,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date).isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: $42f0853312470faa$export$20075fd45e42d41c,
    minDate: $42f0853312470faa$export$283839a53860a2f5,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ])),
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        $42f0853312470faa$export$d53f3db2f43345df
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};


var $69d85f028a6b153b$var$__assign = undefined && undefined.__assign || function() {
    $69d85f028a6b153b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $69d85f028a6b153b$var$__assign.apply(this, arguments);
};
var $69d85f028a6b153b$var$CenturyView = function CenturyView(props) {
    function renderDecades() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ddd6edd34bb52616$export$2e2bcd8739ae039), $69d85f028a6b153b$var$__assign({}, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-calendar__century-view"
    }, renderDecades());
};
$69d85f028a6b153b$var$CenturyView.propTypes = $69d85f028a6b153b$var$__assign({}, (0, $42f0853312470faa$export$61cce6a131f71246));
var $69d85f028a6b153b$export$2e2bcd8739ae039 = $69d85f028a6b153b$var$CenturyView;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $c225ef028b1ac835$var$__assign = undefined && undefined.__assign || function() {
    $c225ef028b1ac835$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c225ef028b1ac835$var$__assign.apply(this, arguments);
};
var $c225ef028b1ac835$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c225ef028b1ac835$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $c225ef028b1ac835$var$className = 'react-calendar__decade-view__years__year';
function $c225ef028b1ac835$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.formatYear, formatYear = _c === void 0 ? (0, $5398151a7800b344$export$2979e79cc7cbf15b) : _c, otherProps = $c225ef028b1ac835$var$__rest(_a, [
        "classes",
        "formatYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $c225ef028b1ac835$var$__assign({}, otherProps, {
        classes: $c225ef028b1ac835$var$__spreadArray($c225ef028b1ac835$var$__spreadArray([], classes, true), [
            $c225ef028b1ac835$var$className
        ], false),
        maxDateTransform: (0, $78fdc7949801ab2a$export$248ddd7fb95e4a56),
        minDateTransform: (0, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a),
        view: "decade"
    }), formatYear(locale, date));
}



var $40801898d3cba4b0$var$__assign = undefined && undefined.__assign || function() {
    $40801898d3cba4b0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $40801898d3cba4b0$var$__assign.apply(this, arguments);
};
var $40801898d3cba4b0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $40801898d3cba4b0$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, value = props.value, valueType = props.valueType, otherProps = $40801898d3cba4b0$var$__rest(props, [
        "activeStartDate",
        "hover",
        "value",
        "valueType"
    ]);
    var start = (0, $f0256d0d4f3b1098$export$59fb6e4ffa904295)(activeStartDate);
    var end = start + 9;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), {
        className: "react-calendar__decade-view__years",
        dateTransform: (0, $78fdc7949801ab2a$export$bbcf6a6951bb3c3a),
        dateType: "year",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $40801898d3cba4b0$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c225ef028b1ac835$export$2e2bcd8739ae039), $40801898d3cba4b0$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                date: date
            }));
        },
        start: start,
        value: value,
        valueType: valueType
    });
}



var $389ea55df3c2dae8$var$__assign = undefined && undefined.__assign || function() {
    $389ea55df3c2dae8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $389ea55df3c2dae8$var$__assign.apply(this, arguments);
};
var $389ea55df3c2dae8$var$DecadeView = function DecadeView(props) {
    function renderYears() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $40801898d3cba4b0$export$2e2bcd8739ae039), $389ea55df3c2dae8$var$__assign({}, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-calendar__decade-view"
    }, renderYears());
};
$389ea55df3c2dae8$var$DecadeView.propTypes = $389ea55df3c2dae8$var$__assign({}, (0, $42f0853312470faa$export$61cce6a131f71246));
var $389ea55df3c2dae8$export$2e2bcd8739ae039 = $389ea55df3c2dae8$var$DecadeView;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $3770b516c35c9a94$var$__assign = undefined && undefined.__assign || function() {
    $3770b516c35c9a94$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3770b516c35c9a94$var$__assign.apply(this, arguments);
};
var $3770b516c35c9a94$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3770b516c35c9a94$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3770b516c35c9a94$var$className = 'react-calendar__year-view__months__month';
function $3770b516c35c9a94$export$2e2bcd8739ae039(_a) {
    var _b = _a.classes, classes = _b === void 0 ? [] : _b, _c = _a.formatMonth, formatMonth = _c === void 0 ? (0, $5398151a7800b344$export$d0536c8e7f45796e) : _c, _d = _a.formatMonthYear, formatMonthYear = _d === void 0 ? (0, $5398151a7800b344$export$18f8ccbe37e54acd) : _d, otherProps = $3770b516c35c9a94$var$__rest(_a, [
        "classes",
        "formatMonth",
        "formatMonthYear"
    ]);
    var date = otherProps.date, locale = otherProps.locale;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $3770b516c35c9a94$var$__assign({}, otherProps, {
        classes: $3770b516c35c9a94$var$__spreadArray($3770b516c35c9a94$var$__spreadArray([], classes, true), [
            $3770b516c35c9a94$var$className
        ], false),
        formatAbbr: formatMonthYear,
        maxDateTransform: (0, $78fdc7949801ab2a$export$6f306f93ccbcd612),
        minDateTransform: (0, $78fdc7949801ab2a$export$c7002b157c9b9e95),
        view: "year"
    }), formatMonth(locale, date));
}


var $fe4d2a338d069e69$var$__assign = undefined && undefined.__assign || function() {
    $fe4d2a338d069e69$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fe4d2a338d069e69$var$__assign.apply(this, arguments);
};
var $fe4d2a338d069e69$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $fe4d2a338d069e69$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, hover = props.hover, value = props.value, valueType = props.valueType, otherProps = $fe4d2a338d069e69$var$__rest(props, [
        "activeStartDate",
        "hover",
        "value",
        "valueType"
    ]);
    var start = 0;
    var end = 11;
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(activeStartDate);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), {
        className: "react-calendar__year-view__months",
        dateTransform: function(monthIndex) {
            var date = new Date();
            date.setFullYear(year, monthIndex, 1);
            return (0, $78fdc7949801ab2a$export$c7002b157c9b9e95)(date);
        },
        dateType: "month",
        end: end,
        hover: hover,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $fe4d2a338d069e69$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3770b516c35c9a94$export$2e2bcd8739ae039), $fe4d2a338d069e69$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                date: date
            }));
        },
        start: start,
        value: value,
        valueType: valueType
    });
}



var $f9aea9fc51f771c2$var$__assign = undefined && undefined.__assign || function() {
    $f9aea9fc51f771c2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f9aea9fc51f771c2$var$__assign.apply(this, arguments);
};
var $f9aea9fc51f771c2$var$YearView = function YearView(props) {
    function renderMonths() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fe4d2a338d069e69$export$2e2bcd8739ae039), $f9aea9fc51f771c2$var$__assign({}, props));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-calendar__year-view"
    }, renderMonths());
};
$f9aea9fc51f771c2$var$YearView.propTypes = $f9aea9fc51f771c2$var$__assign({}, (0, $42f0853312470faa$export$61cce6a131f71246));
var $f9aea9fc51f771c2$export$2e2bcd8739ae039 = $f9aea9fc51f771c2$var$YearView;



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $539df20092d410b7$var$__assign = undefined && undefined.__assign || function() {
    $539df20092d410b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $539df20092d410b7$var$__assign.apply(this, arguments);
};
var $539df20092d410b7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $539df20092d410b7$var$className = 'react-calendar__month-view__days__day';
function $539df20092d410b7$export$2e2bcd8739ae039(_a) {
    var calendarTypeOrDeprecatedCalendarType = _a.calendarType, _b = _a.classes, classes = _b === void 0 ? [] : _b, currentMonthIndex = _a.currentMonthIndex, _c = _a.formatDay, formatDay = _c === void 0 ? (0, $5398151a7800b344$export$a7f242eff11c1345) : _c, _d = _a.formatLongDate, formatLongDate = _d === void 0 ? (0, $5398151a7800b344$export$322b36d80aef60ca) : _d, otherProps = $539df20092d410b7$var$__rest(_a, [
        "calendarType",
        "classes",
        "currentMonthIndex",
        "formatDay",
        "formatLongDate"
    ]);
    var calendarType = (0, $31b103f03d6f0116$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var date = otherProps.date, locale = otherProps.locale;
    var classesProps = [];
    if (classes) classesProps.push.apply(classesProps, classes);
    if ($539df20092d410b7$var$className) classesProps.push($539df20092d410b7$var$className);
    if ((0, $f0256d0d4f3b1098$export$618d60ea299da42)(date, calendarType)) classesProps.push("".concat($539df20092d410b7$var$className, "--weekend"));
    if (date.getMonth() !== currentMonthIndex) classesProps.push("".concat($539df20092d410b7$var$className, "--neighboringMonth"));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96d05e9cc89df7f5$export$2e2bcd8739ae039), $539df20092d410b7$var$__assign({}, otherProps, {
        classes: classesProps,
        formatAbbr: formatLongDate,
        maxDateTransform: (0, $78fdc7949801ab2a$export$7b798396f3e38cd7),
        minDateTransform: (0, $78fdc7949801ab2a$export$ef6b506418c2b397),
        view: "month"
    }), formatDay(locale, date));
}




var $201b2cf16ef2651c$var$__assign = undefined && undefined.__assign || function() {
    $201b2cf16ef2651c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $201b2cf16ef2651c$var$__assign.apply(this, arguments);
};
var $201b2cf16ef2651c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $201b2cf16ef2651c$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarTypeOrDeprecatedCalendarType = props.calendarType, hover = props.hover, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, value = props.value, valueType = props.valueType, otherProps = $201b2cf16ef2651c$var$__rest(props, [
        "activeStartDate",
        "calendarType",
        "hover",
        "showFixedNumberOfWeeks",
        "showNeighboringMonth",
        "value",
        "valueType"
    ]);
    var calendarType = (0, $31b103f03d6f0116$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(activeStartDate);
    var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(activeStartDate);
    var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
    var dayOfWeek = (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(activeStartDate, calendarType);
    var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
    /**
     * Defines on which day of the month the grid shall start. If we simply show current
     * month, we obviously start on day one, but if showNeighboringMonth is set to
     * true, we need to find the beginning of the week the first day of the month is in.
     */ var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
    /**
     * Defines on which day of the month the grid shall end. If we simply show current
     * month, we need to stop on the last day of the month, but if showNeighboringMonth
     * is set to true, we need to find the end of the week the last day of the month is in.
     */ var end = function() {
        if (showFixedNumberOfWeeks) // Always show 6 weeks
        return start + 42 - 1;
        var daysInMonth = (0, $78fdc7949801ab2a$export$f645ddd439eb259d)(activeStartDate);
        if (showNeighboringMonth) {
            var activeEndDate = new Date();
            activeEndDate.setFullYear(year, monthIndex, daysInMonth);
            activeEndDate.setHours(0, 0, 0, 0);
            var daysUntilEndOfTheWeek = 7 - (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(activeEndDate, calendarType) - 1;
            return daysInMonth + daysUntilEndOfTheWeek;
        }
        return daysInMonth;
    }();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $89388808b0fcfc7d$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__days",
        count: 7,
        dateTransform: function(day) {
            var date = new Date();
            date.setFullYear(year, monthIndex, day);
            return (0, $78fdc7949801ab2a$export$ef6b506418c2b397)(date);
        },
        dateType: "day",
        hover: hover,
        end: end,
        renderTile: function(_a) {
            var date = _a.date, otherTileProps = $201b2cf16ef2651c$var$__rest(_a, [
                "date"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $539df20092d410b7$export$2e2bcd8739ae039), $201b2cf16ef2651c$var$__assign({
                key: date.getTime()
            }, otherProps, otherTileProps, {
                activeStartDate: activeStartDate,
                currentMonthIndex: monthIndex,
                date: date
            }));
        },
        offset: offset,
        start: start,
        value: value,
        valueType: valueType
    });
}



var $acw62 = parcelRequire("acw62");






var $39e2786eb9f92c54$var$className = 'react-calendar__month-view__weekdays';
var $39e2786eb9f92c54$var$weekdayClassName = "".concat($39e2786eb9f92c54$var$className, "__weekday");
function $39e2786eb9f92c54$export$2e2bcd8739ae039(props) {
    var calendarTypeOrDeprecatedCalendarType = props.calendarType, _a = props.formatShortWeekday, formatShortWeekday = _a === void 0 ? (0, $5398151a7800b344$export$7ebe25e42481bc02) : _a, _b = props.formatWeekday, formatWeekday = _b === void 0 ? (0, $5398151a7800b344$export$407180b957f39d7e) : _b, locale = props.locale, onMouseLeave = props.onMouseLeave;
    var calendarType = (0, $31b103f03d6f0116$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var anyDate = new Date();
    var beginOfMonth = (0, $78fdc7949801ab2a$export$c7002b157c9b9e95)(anyDate);
    var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(beginOfMonth);
    var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(beginOfMonth);
    var weekdays = [];
    for(var weekday = 1; weekday <= 7; weekday += 1){
        var weekdayDate = new Date(year, monthIndex, weekday - (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(beginOfMonth, calendarType));
        var abbr = formatWeekday(locale, weekdayDate);
        weekdays.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: weekday,
            className: (0, $a45fe03b551d5ffa$export$2e2bcd8739ae039)($39e2786eb9f92c54$var$weekdayClassName, (0, $f0256d0d4f3b1098$export$12e2595dc60a5d5)(weekdayDate) && "".concat($39e2786eb9f92c54$var$weekdayClassName, "--current"), (0, $f0256d0d4f3b1098$export$618d60ea299da42)(weekdayDate, calendarType) && "".concat($39e2786eb9f92c54$var$weekdayClassName, "--weekend"))
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("abbr", {
            "aria-label": abbr,
            title: abbr
        }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19228e875a5c8531$export$2e2bcd8739ae039), {
        className: $39e2786eb9f92c54$var$className,
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave
    }, weekdays);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $ae17ba4d0b6e707b$var$__assign = undefined && undefined.__assign || function() {
    $ae17ba4d0b6e707b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ae17ba4d0b6e707b$var$__assign.apply(this, arguments);
};
var $ae17ba4d0b6e707b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ae17ba4d0b6e707b$var$className = 'react-calendar__tile';
function $ae17ba4d0b6e707b$export$2e2bcd8739ae039(props) {
    var onClickWeekNumber = props.onClickWeekNumber, weekNumber = props.weekNumber;
    var children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, weekNumber);
    if (onClickWeekNumber) {
        var date_1 = props.date, onClickWeekNumber_1 = props.onClickWeekNumber, weekNumber_1 = props.weekNumber, otherProps = $ae17ba4d0b6e707b$var$__rest(props, [
            "date",
            "onClickWeekNumber",
            "weekNumber"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", $ae17ba4d0b6e707b$var$__assign({}, otherProps, {
            className: $ae17ba4d0b6e707b$var$className,
            onClick: function(event) {
                return onClickWeekNumber_1(weekNumber_1, date_1, event);
            },
            type: "button"
        }), children);
    } else {
        var date = props.date, onClickWeekNumber_2 = props.onClickWeekNumber, weekNumber_2 = props.weekNumber, otherProps = $ae17ba4d0b6e707b$var$__rest(props, [
            "date",
            "onClickWeekNumber",
            "weekNumber"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $ae17ba4d0b6e707b$var$__assign({}, otherProps, {
            className: $ae17ba4d0b6e707b$var$className
        }), children);
    }
}





function $5256b69244056cde$export$2e2bcd8739ae039(props) {
    var activeStartDate = props.activeStartDate, calendarTypeOrDeprecatedCalendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var calendarType = (0, $31b103f03d6f0116$export$52aa1e9fb4a280ce)(calendarTypeOrDeprecatedCalendarType);
    var numberOfWeeks = function() {
        if (showFixedNumberOfWeeks) return 6;
        var numberOfDays = (0, $78fdc7949801ab2a$export$f645ddd439eb259d)(activeStartDate);
        var startWeekday = (0, $f0256d0d4f3b1098$export$2061056d06d7cdf7)(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
    }();
    var dates = function() {
        var year = (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(activeStartDate);
        var monthIndex = (0, $78fdc7949801ab2a$export$6ce1b5acc29cb53b)(activeStartDate);
        var day = (0, $78fdc7949801ab2a$export$aa350b96d91cd94)(activeStartDate);
        var result = [];
        for(var index = 0; index < numberOfWeeks; index += 1)result.push((0, $f0256d0d4f3b1098$export$84e707e5f485f282)(new Date(year, monthIndex, day + index * 7), calendarType));
        return result;
    }();
    var weekNumbers = dates.map(function(date) {
        return (0, $f0256d0d4f3b1098$export$b59889984706b7a7)(date, calendarType);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19228e875a5c8531$export$2e2bcd8739ae039), {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
            flexBasis: 'calc(100% * (1 / 8)',
            flexShrink: 0
        }
    }, weekNumbers.map(function(weekNumber, weekIndex) {
        var date = dates[weekIndex];
        if (!date) throw new Error('date is not defined');
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ae17ba4d0b6e707b$export$2e2bcd8739ae039), {
            key: weekNumber,
            date: date,
            onClickWeekNumber: onClickWeekNumber,
            weekNumber: weekNumber
        });
    }));
}




var $f0b3612df8f4d50d$var$__assign = undefined && undefined.__assign || function() {
    $f0b3612df8f4d50d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f0b3612df8f4d50d$var$__assign.apply(this, arguments);
};
var $f0b3612df8f4d50d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f0b3612df8f4d50d$var$getCalendarTypeFromLocale(locale) {
    if (locale) for(var _i = 0, _a = Object.entries((0, $6ede4d444f78ee44$export$e4e5576db5b8e30f)); _i < _a.length; _i++){
        var _b = _a[_i], calendarType = _b[0], locales = _b[1];
        if (locales.includes(locale)) return calendarType;
    }
    return (0, $6ede4d444f78ee44$export$26fa441040070c35).ISO_8601;
}
var $f0b3612df8f4d50d$var$MonthView = function MonthView(props) {
    var activeStartDate = props.activeStartDate, locale = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var _a = props.calendarType, calendarType = _a === void 0 ? $f0b3612df8f4d50d$var$getCalendarTypeFromLocale(locale) : _a, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = $f0b3612df8f4d50d$var$__rest(props, [
        "calendarType",
        "formatShortWeekday",
        "formatWeekday",
        "onClickWeekNumber",
        "showWeekNumbers"
    ]);
    function renderWeekdays() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39e2786eb9f92c54$export$2e2bcd8739ae039), {
            calendarType: calendarType,
            formatShortWeekday: formatShortWeekday,
            formatWeekday: formatWeekday,
            locale: locale,
            onMouseLeave: onMouseLeave
        });
    }
    function renderWeekNumbers() {
        if (!showWeekNumbers) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5256b69244056cde$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            calendarType: calendarType,
            onClickWeekNumber: onClickWeekNumber,
            onMouseLeave: onMouseLeave,
            showFixedNumberOfWeeks: showFixedNumberOfWeeks
        });
    }
    function renderDays() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $201b2cf16ef2651c$export$2e2bcd8739ae039), $f0b3612df8f4d50d$var$__assign({
            calendarType: calendarType
        }, childProps));
    }
    var className = 'react-calendar__month-view';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a45fe03b551d5ffa$export$2e2bcd8739ae039)(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end'
        }
    }, renderWeekNumbers(), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexGrow: 1,
            width: '100%'
        }
    }, renderWeekdays(), renderDays())));
};
$f0b3612df8f4d50d$var$MonthView.propTypes = $f0b3612df8f4d50d$var$__assign($f0b3612df8f4d50d$var$__assign({}, (0, $42f0853312470faa$export$61cce6a131f71246)), {
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34),
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
});
var $f0b3612df8f4d50d$export$2e2bcd8739ae039 = $f0b3612df8f4d50d$var$MonthView;





'use client';
var $1c0e8dbf87fa9d2a$var$__assign = undefined && undefined.__assign || function() {
    $1c0e8dbf87fa9d2a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1c0e8dbf87fa9d2a$var$__assign.apply(this, arguments);
};
var $1c0e8dbf87fa9d2a$var$baseClassName = 'react-calendar';
var $1c0e8dbf87fa9d2a$var$allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var $1c0e8dbf87fa9d2a$var$allValueTypes = [
    'decade',
    'year',
    'month',
    'day'
];
var $1c0e8dbf87fa9d2a$var$defaultMinDate = new Date();
$1c0e8dbf87fa9d2a$var$defaultMinDate.setFullYear(1, 0, 1);
$1c0e8dbf87fa9d2a$var$defaultMinDate.setHours(0, 0, 0, 0);
var $1c0e8dbf87fa9d2a$var$defaultMaxDate = new Date(8.64e15);
function $1c0e8dbf87fa9d2a$var$toDate(value) {
    if (value instanceof Date) return value;
    return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */ function $1c0e8dbf87fa9d2a$var$getLimitedViews(minDetail, maxDetail) {
    return $1c0e8dbf87fa9d2a$var$allViews.slice($1c0e8dbf87fa9d2a$var$allViews.indexOf(minDetail), $1c0e8dbf87fa9d2a$var$allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */ function $1c0e8dbf87fa9d2a$var$isViewAllowed(view, minDetail, maxDetail) {
    var views = $1c0e8dbf87fa9d2a$var$getLimitedViews(minDetail, maxDetail);
    return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */ function $1c0e8dbf87fa9d2a$var$getView(view, minDetail, maxDetail) {
    if (!view) return maxDetail;
    if ($1c0e8dbf87fa9d2a$var$isViewAllowed(view, minDetail, maxDetail)) return view;
    return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */ function $1c0e8dbf87fa9d2a$var$getValueType(view) {
    var index = $1c0e8dbf87fa9d2a$var$allViews.indexOf(view);
    return $1c0e8dbf87fa9d2a$var$allValueTypes[index];
}
function $1c0e8dbf87fa9d2a$var$getValue(value, index) {
    var rawValue = Array.isArray(value) ? value[index] : value;
    if (!rawValue) return null;
    var valueDate = $1c0e8dbf87fa9d2a$var$toDate(rawValue);
    if (isNaN(valueDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueDate;
}
function $1c0e8dbf87fa9d2a$var$getDetailValue(_a, index) {
    var value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, maxDetail = _a.maxDetail;
    var valuePiece = $1c0e8dbf87fa9d2a$var$getValue(value, index);
    if (!valuePiece) return null;
    var valueType = $1c0e8dbf87fa9d2a$var$getValueType(maxDetail);
    var detailValueFrom = function() {
        switch(index){
            case 0:
                return (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(valueType, valuePiece);
            case 1:
                return (0, $f0256d0d4f3b1098$export$946298ccd438a697)(valueType, valuePiece);
            default:
                throw new Error("Invalid index value: ".concat(index));
        }
    }();
    return (0, $31b103f03d6f0116$export$cf95c51b03f10bae)(detailValueFrom, minDate, maxDate);
}
var $1c0e8dbf87fa9d2a$var$getDetailValueFrom = function(args) {
    return $1c0e8dbf87fa9d2a$var$getDetailValue(args, 0);
};
var $1c0e8dbf87fa9d2a$var$getDetailValueTo = function(args) {
    return $1c0e8dbf87fa9d2a$var$getDetailValue(args, 1);
};
var $1c0e8dbf87fa9d2a$var$getDetailValueArray = function(args) {
    return [
        $1c0e8dbf87fa9d2a$var$getDetailValueFrom,
        $1c0e8dbf87fa9d2a$var$getDetailValueTo
    ].map(function(fn) {
        return fn(args);
    });
};
function $1c0e8dbf87fa9d2a$var$getActiveStartDate(_a) {
    var maxDate = _a.maxDate, maxDetail = _a.maxDetail, minDate = _a.minDate, minDetail = _a.minDetail, value = _a.value, view = _a.view;
    var rangeType = $1c0e8dbf87fa9d2a$var$getView(view, minDetail, maxDetail);
    var valueFrom = $1c0e8dbf87fa9d2a$var$getDetailValueFrom({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
    }) || new Date();
    return (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(rangeType, valueFrom);
}
function $1c0e8dbf87fa9d2a$var$getInitialActiveStartDate(_a) {
    var activeStartDate = _a.activeStartDate, defaultActiveStartDate = _a.defaultActiveStartDate, defaultValue = _a.defaultValue, defaultView = _a.defaultView, maxDate = _a.maxDate, maxDetail = _a.maxDetail, minDate = _a.minDate, minDetail = _a.minDetail, value = _a.value, view = _a.view;
    var rangeType = $1c0e8dbf87fa9d2a$var$getView(view, minDetail, maxDetail);
    var valueFrom = activeStartDate || defaultActiveStartDate;
    if (valueFrom) return (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(rangeType, valueFrom);
    return $1c0e8dbf87fa9d2a$var$getActiveStartDate({
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        minDetail: minDetail,
        value: value || defaultValue,
        view: view || defaultView
    });
}
function $1c0e8dbf87fa9d2a$var$getIsSingleValue(value) {
    return value && (!Array.isArray(value) || value.length === 1);
}
function $1c0e8dbf87fa9d2a$var$areDatesEqual(date1, date2) {
    return date1 instanceof Date && date2 instanceof Date && date1.getTime() === date2.getTime();
}
var $1c0e8dbf87fa9d2a$var$Calendar = (0, $acw62.forwardRef)(function Calendar(props, ref) {
    var activeStartDateProps = props.activeStartDate, allowPartialRange = props.allowPartialRange, calendarType = props.calendarType, className = props.className, defaultActiveStartDate = props.defaultActiveStartDate, defaultValue = props.defaultValue, defaultView = props.defaultView, formatDay = props.formatDay, formatLongDate = props.formatLongDate, formatMonth = props.formatMonth, formatMonthYear = props.formatMonthYear, formatShortWeekday = props.formatShortWeekday, formatWeekday = props.formatWeekday, formatYear = props.formatYear, _a = props.goToRangeStartOnSelect, goToRangeStartOnSelect = _a === void 0 ? true : _a, inputRef = props.inputRef, locale = props.locale, _b = props.maxDate, maxDate = _b === void 0 ? $1c0e8dbf87fa9d2a$var$defaultMaxDate : _b, _c = props.maxDetail, maxDetail = _c === void 0 ? 'month' : _c, _d = props.minDate, minDate = _d === void 0 ? $1c0e8dbf87fa9d2a$var$defaultMinDate : _d, _e = props.minDetail, minDetail = _e === void 0 ? 'century' : _e, navigationAriaLabel = props.navigationAriaLabel, navigationAriaLive = props.navigationAriaLive, navigationLabel = props.navigationLabel, next2AriaLabel = props.next2AriaLabel, next2Label = props.next2Label, nextAriaLabel = props.nextAriaLabel, nextLabel = props.nextLabel, onActiveStartDateChange = props.onActiveStartDateChange, onChangeProps = props.onChange, onClickDay = props.onClickDay, onClickDecade = props.onClickDecade, onClickMonth = props.onClickMonth, onClickWeekNumber = props.onClickWeekNumber, onClickYear = props.onClickYear, onDrillDown = props.onDrillDown, onDrillUp = props.onDrillUp, onViewChange = props.onViewChange, prev2AriaLabel = props.prev2AriaLabel, prev2Label = props.prev2Label, prevAriaLabel = props.prevAriaLabel, prevLabel = props.prevLabel, _f = props.returnValue, returnValue = _f === void 0 ? 'start' : _f, selectRange = props.selectRange, showDoubleView = props.showDoubleView, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, _g = props.showNavigation, showNavigation = _g === void 0 ? true : _g, _h = props.showNeighboringMonth, showNeighboringMonth = _h === void 0 ? true : _h, showWeekNumbers = props.showWeekNumbers, tileClassName = props.tileClassName, tileContent = props.tileContent, tileDisabled = props.tileDisabled, valueProps = props.value, viewProps = props.view;
    var _j = (0, $acw62.useState)(defaultActiveStartDate), activeStartDateState = _j[0], setActiveStartDateState = _j[1];
    var _k = (0, $acw62.useState)(null), hoverState = _k[0], setHoverState = _k[1];
    var _l = (0, $acw62.useState)(Array.isArray(defaultValue) ? defaultValue.map(function(el) {
        return el !== null ? $1c0e8dbf87fa9d2a$var$toDate(el) : null;
    }) : defaultValue !== null && defaultValue !== undefined ? $1c0e8dbf87fa9d2a$var$toDate(defaultValue) : null), valueState = _l[0], setValueState = _l[1];
    var _m = (0, $acw62.useState)(defaultView), viewState = _m[0], setViewState = _m[1];
    var activeStartDate = activeStartDateProps || activeStartDateState || $1c0e8dbf87fa9d2a$var$getInitialActiveStartDate({
        activeStartDate: activeStartDateProps,
        defaultActiveStartDate: defaultActiveStartDate,
        defaultValue: defaultValue,
        defaultView: defaultView,
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        minDetail: minDetail,
        value: valueProps,
        view: viewProps
    });
    var value = function() {
        var rawValue = function() {
            // In the middle of range selection, use value from state
            if (selectRange && $1c0e8dbf87fa9d2a$var$getIsSingleValue(valueState)) return valueState;
            return valueProps !== undefined ? valueProps : valueState;
        }();
        if (!rawValue) return null;
        return Array.isArray(rawValue) ? rawValue.map(function(el) {
            return el !== null ? $1c0e8dbf87fa9d2a$var$toDate(el) : null;
        }) : rawValue !== null ? $1c0e8dbf87fa9d2a$var$toDate(rawValue) : null;
    }();
    var valueType = $1c0e8dbf87fa9d2a$var$getValueType(maxDetail);
    var view = $1c0e8dbf87fa9d2a$var$getView(viewProps || viewState, minDetail, maxDetail);
    var views = $1c0e8dbf87fa9d2a$var$getLimitedViews(minDetail, maxDetail);
    var hover = selectRange ? hoverState : null;
    var drillDownAvailable = views.indexOf(view) < views.length - 1;
    var drillUpAvailable = views.indexOf(view) > 0;
    var getProcessedValue = (0, $acw62.useCallback)(function(value) {
        var processFunction = function() {
            switch(returnValue){
                case 'start':
                    return $1c0e8dbf87fa9d2a$var$getDetailValueFrom;
                case 'end':
                    return $1c0e8dbf87fa9d2a$var$getDetailValueTo;
                case 'range':
                    return $1c0e8dbf87fa9d2a$var$getDetailValueArray;
                default:
                    throw new Error('Invalid returnValue.');
            }
        }();
        return processFunction({
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            value: value
        });
    }, [
        maxDate,
        maxDetail,
        minDate,
        returnValue
    ]);
    var setActiveStartDate = (0, $acw62.useCallback)(function(nextActiveStartDate, action) {
        setActiveStartDateState(nextActiveStartDate);
        var args = {
            action: action,
            activeStartDate: nextActiveStartDate,
            value: value,
            view: view
        };
        if (onActiveStartDateChange && !$1c0e8dbf87fa9d2a$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
    }, [
        activeStartDate,
        onActiveStartDateChange,
        value,
        view
    ]);
    var onClickTile = (0, $acw62.useCallback)(function(value, event) {
        var callback = function() {
            switch(view){
                case 'century':
                    return onClickDecade;
                case 'decade':
                    return onClickYear;
                case 'year':
                    return onClickMonth;
                case 'month':
                    return onClickDay;
                default:
                    throw new Error("Invalid view: ".concat(view, "."));
            }
        }();
        if (callback) callback(value, event);
    }, [
        onClickDay,
        onClickDecade,
        onClickMonth,
        onClickYear,
        view
    ]);
    var drillDown = (0, $acw62.useCallback)(function(nextActiveStartDate, event) {
        if (!drillDownAvailable) return;
        onClickTile(nextActiveStartDate, event);
        var nextView = views[views.indexOf(view) + 1];
        if (!nextView) throw new Error('Attempted to drill down from the lowest view.');
        setActiveStartDateState(nextActiveStartDate);
        setViewState(nextView);
        var args = {
            action: 'drillDown',
            activeStartDate: nextActiveStartDate,
            value: value,
            view: nextView
        };
        if (onActiveStartDateChange && !$1c0e8dbf87fa9d2a$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onViewChange && view !== nextView) onViewChange(args);
        if (onDrillDown) onDrillDown(args);
    }, [
        activeStartDate,
        drillDownAvailable,
        onActiveStartDateChange,
        onClickTile,
        onDrillDown,
        onViewChange,
        value,
        view,
        views
    ]);
    var drillUp = (0, $acw62.useCallback)(function() {
        if (!drillUpAvailable) return;
        var nextView = views[views.indexOf(view) - 1];
        if (!nextView) throw new Error('Attempted to drill up from the highest view.');
        var nextActiveStartDate = (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(nextView, activeStartDate);
        setActiveStartDateState(nextActiveStartDate);
        setViewState(nextView);
        var args = {
            action: 'drillUp',
            activeStartDate: nextActiveStartDate,
            value: value,
            view: nextView
        };
        if (onActiveStartDateChange && !$1c0e8dbf87fa9d2a$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onViewChange && view !== nextView) onViewChange(args);
        if (onDrillUp) onDrillUp(args);
    }, [
        activeStartDate,
        drillUpAvailable,
        onActiveStartDateChange,
        onDrillUp,
        onViewChange,
        value,
        view,
        views
    ]);
    var onChange = (0, $acw62.useCallback)(function(rawNextValue, event) {
        var previousValue = value;
        onClickTile(rawNextValue, event);
        var isFirstValueInRange = selectRange && !$1c0e8dbf87fa9d2a$var$getIsSingleValue(previousValue);
        var nextValue;
        if (selectRange) {
            // Range selection turned on
            if (isFirstValueInRange) // Value has 0 or 2 elements - either way we're starting a new array
            // First value
            nextValue = (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(valueType, rawNextValue);
            else {
                if (!previousValue) throw new Error('previousValue is required');
                if (Array.isArray(previousValue)) throw new Error('previousValue must not be an array');
                // Second value
                nextValue = (0, $f0256d0d4f3b1098$export$3a3e6dbcaf74641d)(valueType, previousValue, rawNextValue);
            }
        } else // Range selection turned off
        nextValue = getProcessedValue(rawNextValue);
        var nextActiveStartDate = // Range selection turned off
        !selectRange || // Range selection turned on, first value
        isFirstValueInRange || // Range selection turned on, second value, goToRangeStartOnSelect toggled on
        goToRangeStartOnSelect ? $1c0e8dbf87fa9d2a$var$getActiveStartDate({
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            minDetail: minDetail,
            value: nextValue,
            view: view
        }) : null;
        event.persist();
        setActiveStartDateState(nextActiveStartDate);
        setValueState(nextValue);
        var args = {
            action: 'onChange',
            activeStartDate: nextActiveStartDate,
            value: nextValue,
            view: view
        };
        if (onActiveStartDateChange && !$1c0e8dbf87fa9d2a$var$areDatesEqual(activeStartDate, nextActiveStartDate)) onActiveStartDateChange(args);
        if (onChangeProps) {
            if (selectRange) {
                var isSingleValue = $1c0e8dbf87fa9d2a$var$getIsSingleValue(nextValue);
                if (!isSingleValue) onChangeProps(nextValue || null, event);
                else if (allowPartialRange) {
                    if (Array.isArray(nextValue)) throw new Error('value must not be an array');
                    onChangeProps([
                        nextValue || null,
                        null
                    ], event);
                }
            } else onChangeProps(nextValue || null, event);
        }
    }, [
        activeStartDate,
        allowPartialRange,
        getProcessedValue,
        goToRangeStartOnSelect,
        maxDate,
        maxDetail,
        minDate,
        minDetail,
        onActiveStartDateChange,
        onChangeProps,
        onClickTile,
        selectRange,
        value,
        valueType,
        view
    ]);
    function onMouseOver(nextHover) {
        setHoverState(nextHover);
    }
    function onMouseLeave() {
        setHoverState(null);
    }
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            activeStartDate: activeStartDate,
            drillDown: drillDown,
            drillUp: drillUp,
            onChange: onChange,
            setActiveStartDate: setActiveStartDate,
            value: value,
            view: view
        };
    }, [
        activeStartDate,
        drillDown,
        drillUp,
        onChange,
        setActiveStartDate,
        value,
        view
    ]);
    function renderContent(next) {
        var currentActiveStartDate = next ? (0, $f0256d0d4f3b1098$export$19193c1f2d841d47)(view, activeStartDate) : (0, $f0256d0d4f3b1098$export$700a64ae37cbc741)(view, activeStartDate);
        var onClick = drillDownAvailable ? drillDown : onChange;
        var commonProps = {
            activeStartDate: currentActiveStartDate,
            hover: hover,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            onClick: onClick,
            onMouseOver: selectRange ? onMouseOver : undefined,
            tileClassName: tileClassName,
            tileContent: tileContent,
            tileDisabled: tileDisabled,
            value: value,
            valueType: valueType
        };
        switch(view){
            case 'century':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $69d85f028a6b153b$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$__assign({
                    formatYear: formatYear
                }, commonProps));
            case 'decade':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $389ea55df3c2dae8$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$__assign({
                    formatYear: formatYear
                }, commonProps));
            case 'year':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f9aea9fc51f771c2$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$__assign({
                    formatMonth: formatMonth,
                    formatMonthYear: formatMonthYear
                }, commonProps));
            case 'month':
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f0b3612df8f4d50d$export$2e2bcd8739ae039), $1c0e8dbf87fa9d2a$var$__assign({
                    calendarType: calendarType,
                    formatDay: formatDay,
                    formatLongDate: formatLongDate,
                    formatShortWeekday: formatShortWeekday,
                    formatWeekday: formatWeekday,
                    onClickWeekNumber: onClickWeekNumber,
                    onMouseLeave: selectRange ? onMouseLeave : undefined,
                    showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
                    showNeighboringMonth: showNeighboringMonth,
                    showWeekNumbers: showWeekNumbers
                }, commonProps));
            default:
                throw new Error("Invalid view: ".concat(view, "."));
        }
    }
    function renderNavigation() {
        if (!showNavigation) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfbfa00fe9577c18$export$2e2bcd8739ae039), {
            activeStartDate: activeStartDate,
            drillUp: drillUp,
            formatMonthYear: formatMonthYear,
            formatYear: formatYear,
            locale: locale,
            maxDate: maxDate,
            minDate: minDate,
            navigationAriaLabel: navigationAriaLabel,
            navigationAriaLive: navigationAriaLive,
            navigationLabel: navigationLabel,
            next2AriaLabel: next2AriaLabel,
            next2Label: next2Label,
            nextAriaLabel: nextAriaLabel,
            nextLabel: nextLabel,
            prev2AriaLabel: prev2AriaLabel,
            prev2Label: prev2Label,
            prevAriaLabel: prevAriaLabel,
            prevLabel: prevLabel,
            setActiveStartDate: setActiveStartDate,
            showDoubleView: showDoubleView,
            view: view,
            views: views
        });
    }
    var valueArray = Array.isArray(value) ? value : [
        value
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $a45fe03b551d5ffa$export$2e2bcd8739ae039)($1c0e8dbf87fa9d2a$var$baseClassName, selectRange && valueArray.length === 1 && "".concat($1c0e8dbf87fa9d2a$var$baseClassName, "--selectRange"), showDoubleView && "".concat($1c0e8dbf87fa9d2a$var$baseClassName, "--doubleView"), className),
        ref: inputRef
    }, renderNavigation(), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat($1c0e8dbf87fa9d2a$var$baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : undefined,
        onMouseLeave: selectRange ? onMouseLeave : undefined
    }, renderContent(), showDoubleView ? renderContent(true) : null));
});
var $1c0e8dbf87fa9d2a$var$isActiveStartDate = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date);
var $1c0e8dbf87fa9d2a$var$isValue = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date)
]);
var $1c0e8dbf87fa9d2a$var$isValueOrValueArray = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    $1c0e8dbf87fa9d2a$var$isValue,
    (0, $42f0853312470faa$export$382f6fb00c4220)($1c0e8dbf87fa9d2a$var$isValue)
]);
$1c0e8dbf87fa9d2a$var$Calendar.propTypes = {
    activeStartDate: $1c0e8dbf87fa9d2a$var$isActiveStartDate,
    allowPartialRange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    calendarType: (0, $42f0853312470faa$export$9780328ce60eac34),
    className: (0, $42f0853312470faa$export$d53f3db2f43345df),
    defaultActiveStartDate: $1c0e8dbf87fa9d2a$var$isActiveStartDate,
    defaultValue: $1c0e8dbf87fa9d2a$var$isValueOrValueArray,
    defaultView: (0, $42f0853312470faa$export$7c1393839656cd16),
    formatDay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatLongDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatMonthYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatShortWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    formatYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    goToRangeStartOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inputRef: (0, $42f0853312470faa$export$4f9f5282de18fc69),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: (0, $42f0853312470faa$export$20075fd45e42d41c),
    maxDetail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($1c0e8dbf87fa9d2a$var$allViews),
    minDate: (0, $42f0853312470faa$export$283839a53860a2f5),
    minDetail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($1c0e8dbf87fa9d2a$var$allViews),
    navigationAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    navigationAriaLive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'off',
        'polite',
        'assertive'
    ]),
    navigationLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    next2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    next2Label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    nextAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    nextLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    onActiveStartDateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickDay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickDecade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClickYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onDrillDown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onDrillUp: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    prev2AriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    prev2Label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    prevAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    prevLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    returnValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'start',
        'end',
        'range'
    ]),
    selectRange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showDoubleView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showFixedNumberOfWeeks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showNeighboringMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    showWeekNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tileClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, $42f0853312470faa$export$d53f3db2f43345df)
    ]),
    tileContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    tileDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    value: $1c0e8dbf87fa9d2a$var$isValueOrValueArray,
    view: (0, $42f0853312470faa$export$7c1393839656cd16)
};
var $1c0e8dbf87fa9d2a$export$2e2bcd8739ae039 = $1c0e8dbf87fa9d2a$var$Calendar;







var $5304fe6d5e1a96df$export$2e2bcd8739ae039 = (0, $1c0e8dbf87fa9d2a$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $39c78b96331d7131$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $39c78b96331d7131$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $39c78b96331d7131$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $39c78b96331d7131$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $39c78b96331d7131$export$2e2bcd8739ae039 = $39c78b96331d7131$export$4f5d2d50c9deca37;




var $acw62 = parcelRequire("acw62");
function $cd35284a247f5300$export$2e2bcd8739ae039(_a) {
    var _b = _a.angle, angle = _b === void 0 ? 0 : _b, name = _a.name, _c = _a.length, length = _c === void 0 ? 100 : _c, _d = _a.oppositeLength, oppositeLength = _d === void 0 ? 10 : _d, _e = _a.width, width = _e === void 0 ? 1 : _e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-clock__hand react-clock__".concat(name, "-hand"),
        style: {
            transform: "rotate(".concat(angle, "deg)")
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-clock__hand__body react-clock__".concat(name, "-hand__body"),
        style: {
            width: "".concat(width, "px"),
            top: "".concat(50 - length / 2, "%"),
            bottom: "".concat(50 - oppositeLength / 2, "%")
        }
    }));
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $02d00b26fe1703aa$export$2e2bcd8739ae039(_a) {
    var _b = _a.angle, angle = _b === void 0 ? 0 : _b, _c = _a.length, length = _c === void 0 ? 10 : _c, name = _a.name, _d = _a.width, width = _d === void 0 ? 1 : _d, number = _a.number;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-clock__mark react-clock__".concat(name, "-mark"),
        style: {
            transform: "rotate(".concat(angle, "deg)")
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-clock__mark__body react-clock__".concat(name, "-mark__body"),
        style: {
            width: "".concat(width, "px"),
            top: 0,
            bottom: "".concat(100 - length / 2, "%")
        }
    }), number ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-clock__mark__number",
        style: {
            transform: "rotate(-".concat(angle, "deg)"),
            top: "".concat(length / 2, "%")
        }
    }, number) : null);
}


var $12fb62d716b6ea64$var$__assign = undefined && undefined.__assign || function() {
    $12fb62d716b6ea64$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $12fb62d716b6ea64$var$__assign.apply(this, arguments);
};
var $12fb62d716b6ea64$var$MinuteMark = (0, $acw62.memo)(function MinuteMark(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02d00b26fe1703aa$export$2e2bcd8739ae039), $12fb62d716b6ea64$var$__assign({}, props));
});
var $12fb62d716b6ea64$export$2e2bcd8739ae039 = $12fb62d716b6ea64$var$MinuteMark;



var $acw62 = parcelRequire("acw62");


function $689a2341276ab1bf$export$86a5557e1d677e29(locale, hour) {
    return hour.toLocaleString(locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)() || undefined);
}


var $35a3b12f7c2ec5e0$var$__assign = undefined && undefined.__assign || function() {
    $35a3b12f7c2ec5e0$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35a3b12f7c2ec5e0$var$__assign.apply(this, arguments);
};
var $35a3b12f7c2ec5e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $35a3b12f7c2ec5e0$var$HourMark = (0, $acw62.memo)(function HourMark(_a) {
    var _b = _a.formatHour, formatHour = _b === void 0 ? (0, $689a2341276ab1bf$export$86a5557e1d677e29) : _b, locale = _a.locale, number = _a.number, otherProps = $35a3b12f7c2ec5e0$var$__rest(_a, [
        "formatHour",
        "locale",
        "number"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02d00b26fe1703aa$export$2e2bcd8739ae039), $35a3b12f7c2ec5e0$var$__assign({
        number: number ? formatHour(locale, number) : null
    }, otherProps));
});
var $35a3b12f7c2ec5e0$export$2e2bcd8739ae039 = $35a3b12f7c2ec5e0$var$HourMark;


function $99983cfbebac9aeb$var$isNumberBetween(min, max) {
    return function(props, propName, componentName) {
        var _a = props, _b = propName, value = _a[_b];
        if (typeof value !== 'undefined') {
            if (typeof value !== 'number') return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof value, "` supplied to `").concat(componentName, "`, expected `number`."));
            if (value < min || value > max) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof value, "` supplied to `").concat(componentName, "`, length must be between ").concat(min, " and ").concat(max, "."));
        }
        // Everything is fine
        return null;
    };
}
var $99983cfbebac9aeb$export$fe15a346fc0257ba = $99983cfbebac9aeb$var$isNumberBetween(0, 100);
var $99983cfbebac9aeb$export$d04210019f05468f = $99983cfbebac9aeb$var$isNumberBetween(-100, 100);
var $99983cfbebac9aeb$export$c1ec1099741930b0 = function isHandWidth(props, propName, componentName) {
    var _a = props, _b = propName, width = _a[_b];
    if (typeof width !== 'undefined') {
        if (typeof width !== 'number') return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof width, "` supplied to `").concat(componentName, "`, expected `number`."));
        if (width < 0) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof width, "` supplied to `").concat(componentName, "`, width must be greater or equal to 0."));
    }
    // Everything is fine
    return null;
};
var $99983cfbebac9aeb$export$98a7e4f87467dbf4 = $99983cfbebac9aeb$export$fe15a346fc0257ba;
var $99983cfbebac9aeb$export$bd2b11d032489a2b = $99983cfbebac9aeb$export$c1ec1099741930b0;


var $c223954c2570877e$var$Clock = function Clock(_a) {
    var className = _a.className, formatHour = _a.formatHour, _b = _a.hourHandLength, hourHandLength = _b === void 0 ? 50 : _b, hourHandOppositeLength = _a.hourHandOppositeLength, _c = _a.hourHandWidth, hourHandWidth = _c === void 0 ? 4 : _c, _d = _a.hourMarksLength, hourMarksLength = _d === void 0 ? 10 : _d, _e = _a.hourMarksWidth, hourMarksWidth = _e === void 0 ? 3 : _e, locale = _a.locale, _f = _a.minuteHandLength, minuteHandLength = _f === void 0 ? 70 : _f, minuteHandOppositeLength = _a.minuteHandOppositeLength, _g = _a.minuteHandWidth, minuteHandWidth = _g === void 0 ? 2 : _g, _h = _a.minuteMarksLength, minuteMarksLength = _h === void 0 ? 6 : _h, _j = _a.minuteMarksWidth, minuteMarksWidth = _j === void 0 ? 1 : _j, _k = _a.renderHourMarks, renderHourMarks = _k === void 0 ? true : _k, _l = _a.renderMinuteHand, renderMinuteHand = _l === void 0 ? true : _l, _m = _a.renderMinuteMarks, renderMinuteMarks = _m === void 0 ? true : _m, renderNumbers = _a.renderNumbers, _o = _a.renderSecondHand, renderSecondHand = _o === void 0 ? true : _o, _p = _a.secondHandLength, secondHandLength = _p === void 0 ? 90 : _p, secondHandOppositeLength = _a.secondHandOppositeLength, _q = _a.secondHandWidth, secondHandWidth = _q === void 0 ? 1 : _q, _r = _a.size, size = _r === void 0 ? 150 : _r, useMillisecondPrecision = _a.useMillisecondPrecision, value = _a.value;
    function renderMinuteMarksFn() {
        if (!renderMinuteMarks) return null;
        var minuteMarks = [];
        for(var i = 1; i <= 60; i += 1){
            var isHourMark = renderHourMarks && !(i % 5);
            if (!isHourMark) minuteMarks.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $12fb62d716b6ea64$export$2e2bcd8739ae039), {
                key: "minute_".concat(i),
                angle: i * 6,
                length: minuteMarksLength,
                name: "minute",
                width: minuteMarksWidth
            }));
        }
        return minuteMarks;
    }
    function renderHourMarksFn() {
        if (!renderHourMarks) return null;
        var hourMarks = [];
        for(var i = 1; i <= 12; i += 1)hourMarks.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35a3b12f7c2ec5e0$export$2e2bcd8739ae039), {
            key: "hour_".concat(i),
            angle: i * 30,
            formatHour: formatHour,
            length: hourMarksLength,
            locale: locale,
            name: "hour",
            number: renderNumbers ? i : undefined,
            width: hourMarksWidth
        }));
        return hourMarks;
    }
    function renderFace() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-clock__face"
        }, renderMinuteMarksFn(), renderHourMarksFn());
    }
    function renderHourHandFn() {
        var angle = value ? (0, $78fdc7949801ab2a$export$257b40f71c07d58f)(value) * 30 + (0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(value) / 2 + (0, $78fdc7949801ab2a$export$5e9417507ff28427)(value) / 120 + (useMillisecondPrecision ? (0, $78fdc7949801ab2a$export$b8e4380f312797af)(value) / 120000 : 0) : 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cd35284a247f5300$export$2e2bcd8739ae039), {
            angle: angle,
            length: hourHandLength,
            name: "hour",
            oppositeLength: hourHandOppositeLength,
            width: hourHandWidth
        });
    }
    function renderMinuteHandFn() {
        if (!renderMinuteHand) return null;
        var angle = value ? (0, $78fdc7949801ab2a$export$257b40f71c07d58f)(value) * 360 + (0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(value) * 6 + (0, $78fdc7949801ab2a$export$5e9417507ff28427)(value) / 10 + (useMillisecondPrecision ? (0, $78fdc7949801ab2a$export$b8e4380f312797af)(value) / 10000 : 0) : 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cd35284a247f5300$export$2e2bcd8739ae039), {
            angle: angle,
            length: minuteHandLength,
            name: "minute",
            oppositeLength: minuteHandOppositeLength,
            width: minuteHandWidth
        });
    }
    function renderSecondHandFn() {
        if (!renderSecondHand) return null;
        var angle = value ? (0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(value) * 360 + (0, $78fdc7949801ab2a$export$5e9417507ff28427)(value) * 6 + (useMillisecondPrecision ? (0, $78fdc7949801ab2a$export$b8e4380f312797af)(value) * 0.006 : 0) : 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cd35284a247f5300$export$2e2bcd8739ae039), {
            angle: angle,
            length: secondHandLength,
            name: "second",
            oppositeLength: secondHandOppositeLength,
            width: secondHandWidth
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("time", {
        className: (0, $39c78b96331d7131$export$2e2bcd8739ae039)('react-clock', className),
        dateTime: value instanceof Date ? value.toISOString() : value || undefined,
        style: {
            width: size,
            height: size
        }
    }, renderFace(), renderHourHandFn(), renderMinuteHandFn(), renderSecondHandFn());
};
$c223954c2570877e$var$Clock.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    formatHour: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hourHandLength: (0, $99983cfbebac9aeb$export$fe15a346fc0257ba),
    hourHandOppositeLength: (0, $99983cfbebac9aeb$export$d04210019f05468f),
    hourHandWidth: (0, $99983cfbebac9aeb$export$c1ec1099741930b0),
    hourMarksLength: (0, $99983cfbebac9aeb$export$98a7e4f87467dbf4),
    hourMarksWidth: (0, $99983cfbebac9aeb$export$bd2b11d032489a2b),
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    minuteHandLength: (0, $99983cfbebac9aeb$export$fe15a346fc0257ba),
    minuteHandOppositeLength: (0, $99983cfbebac9aeb$export$d04210019f05468f),
    minuteHandWidth: (0, $99983cfbebac9aeb$export$c1ec1099741930b0),
    minuteMarksLength: (0, $99983cfbebac9aeb$export$98a7e4f87467dbf4),
    minuteMarksWidth: (0, $99983cfbebac9aeb$export$bd2b11d032489a2b),
    renderHourMarks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    renderMinuteHand: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    renderMinuteMarks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    renderNumbers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    renderSecondHand: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    secondHandLength: (0, $99983cfbebac9aeb$export$fe15a346fc0257ba),
    secondHandOppositeLength: (0, $99983cfbebac9aeb$export$d04210019f05468f),
    secondHandWidth: (0, $99983cfbebac9aeb$export$c1ec1099741930b0),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date)
    ])
};
var $c223954c2570877e$export$2e2bcd8739ae039 = $c223954c2570877e$var$Clock;


var $1ea2f3c788d1690a$export$2e2bcd8739ae039 = (0, $c223954c2570877e$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $c9Z8w = parcelRequire("c9Z8w");
function $edb75f201efcdf24$var$getRect(element) {
    return element.getBoundingClientRect();
}
function $edb75f201efcdf24$export$2e2bcd8739ae039(element, container) {
    return {
        get collidedTop () {
            return $edb75f201efcdf24$var$getRect(element).top < $edb75f201efcdf24$var$getRect(container).top;
        },
        get collidedBottom () {
            return $edb75f201efcdf24$var$getRect(element).bottom > $edb75f201efcdf24$var$getRect(container).bottom;
        },
        get collidedLeft () {
            return $edb75f201efcdf24$var$getRect(element).left < $edb75f201efcdf24$var$getRect(container).left;
        },
        get collidedRight () {
            return $edb75f201efcdf24$var$getRect(element).right > $edb75f201efcdf24$var$getRect(container).right;
        },
        get overflowTop () {
            return $edb75f201efcdf24$var$getRect(container).top - $edb75f201efcdf24$var$getRect(element).top;
        },
        get overflowBottom () {
            return $edb75f201efcdf24$var$getRect(element).bottom - $edb75f201efcdf24$var$getRect(container).bottom;
        },
        get overflowLeft () {
            return $edb75f201efcdf24$var$getRect(container).left - $edb75f201efcdf24$var$getRect(element).left;
        },
        get overflowRight () {
            return $edb75f201efcdf24$var$getRect(element).right - $edb75f201efcdf24$var$getRect(container).right;
        }
    };
}



var $9RYKL = parcelRequire("9RYKL");
'use client';
var $7548ac4faa48d4bb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7548ac4faa48d4bb$var$__assign = undefined && undefined.__assign || function() {
    $7548ac4faa48d4bb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7548ac4faa48d4bb$var$__assign.apply(this, arguments);
};
var $7548ac4faa48d4bb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7548ac4faa48d4bb$var$isBrowser = typeof document !== 'undefined';
var $7548ac4faa48d4bb$var$isDisplayContentsSupported = $7548ac4faa48d4bb$var$isBrowser && 'CSS' in window && 'supports' in window.CSS && CSS.supports('display', 'contents');
var $7548ac4faa48d4bb$var$isMutationObserverSupported = $7548ac4faa48d4bb$var$isBrowser && 'MutationObserver' in window;
function $7548ac4faa48d4bb$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $7548ac4faa48d4bb$var$findScrollContainer(element) {
    var parent = element.parentElement;
    while(parent){
        var overflow = window.getComputedStyle(parent).overflow;
        if (overflow.split(' ').every(function(o) {
            return o === 'auto' || o === 'scroll';
        })) return parent;
        parent = parent.parentElement;
    }
    return document.documentElement;
}
function $7548ac4faa48d4bb$var$alignAxis(_a) {
    var axis = _a.axis, container = _a.container, element = _a.element, invertAxis = _a.invertAxis, secondary = _a.secondary, scrollContainer = _a.scrollContainer, spacing = _a.spacing;
    var style = window.getComputedStyle(element);
    var parent = container.parentElement;
    if (!parent) return;
    var scrollContainerCollisions = (0, $edb75f201efcdf24$export$2e2bcd8739ae039)(parent, scrollContainer);
    var documentCollisions = (0, $edb75f201efcdf24$export$2e2bcd8739ae039)(parent, document.documentElement);
    var isX = axis === 'x';
    var startProperty = isX ? 'left' : 'top';
    var endProperty = isX ? 'right' : 'bottom';
    var sizeProperty = isX ? 'width' : 'height';
    var overflowStartProperty = "overflow".concat($7548ac4faa48d4bb$var$capitalize(startProperty));
    var overflowEndProperty = "overflow".concat($7548ac4faa48d4bb$var$capitalize(endProperty));
    var scrollProperty = "scroll".concat($7548ac4faa48d4bb$var$capitalize(startProperty));
    var uppercasedSizeProperty = $7548ac4faa48d4bb$var$capitalize(sizeProperty);
    var offsetSizeProperty = "offset".concat(uppercasedSizeProperty);
    var clientSizeProperty = "client".concat(uppercasedSizeProperty);
    var minSizeProperty = "min-".concat(sizeProperty);
    var scrollbarWidth = scrollContainer[offsetSizeProperty] - scrollContainer[clientSizeProperty];
    var startSpacing = typeof spacing === 'object' ? spacing[startProperty] : spacing;
    var availableStartSpace = -Math.max(scrollContainerCollisions[overflowStartProperty], documentCollisions[overflowStartProperty] + document.documentElement[scrollProperty]) - startSpacing;
    var endSpacing = typeof spacing === 'object' ? spacing[endProperty] : spacing;
    var availableEndSpace = -Math.max(scrollContainerCollisions[overflowEndProperty], documentCollisions[overflowEndProperty] - document.documentElement[scrollProperty]) - endSpacing - scrollbarWidth;
    if (secondary) {
        availableStartSpace += parent[clientSizeProperty];
        availableEndSpace += parent[clientSizeProperty];
    }
    var offsetSize = element[offsetSizeProperty];
    function displayStart() {
        element.style[startProperty] = 'auto';
        element.style[endProperty] = secondary ? '0' : '100%';
    }
    function displayEnd() {
        element.style[startProperty] = secondary ? '0' : '100%';
        element.style[endProperty] = 'auto';
    }
    function displayIfFits(availableSpace, display) {
        var fits = offsetSize <= availableSpace;
        if (fits) display();
        return fits;
    }
    function displayStartIfFits() {
        return displayIfFits(availableStartSpace, displayStart);
    }
    function displayEndIfFits() {
        return displayIfFits(availableEndSpace, displayEnd);
    }
    function displayWhereverShrinkedFits() {
        var moreSpaceStart = availableStartSpace > availableEndSpace;
        var rawMinSize = style.getPropertyValue(minSizeProperty);
        var minSize = rawMinSize ? parseInt(rawMinSize, 10) : null;
        function shrinkToSize(size) {
            (0, $9RYKL.default)(!minSize || size >= minSize, "<Fit />'s child will not fit anywhere with its current ".concat(minSizeProperty, " of ").concat(minSize, "px."));
            var newSize = Math.max(size, minSize || 0);
            (0, $9RYKL.default)(false, "<Fit />'s child needed to have its ".concat(sizeProperty, " decreased to ").concat(newSize, "px."));
            element.style[sizeProperty] = "".concat(newSize, "px");
        }
        if (moreSpaceStart) {
            shrinkToSize(availableStartSpace);
            displayStart();
        } else {
            shrinkToSize(availableEndSpace);
            displayEnd();
        }
    }
    var fits;
    if (invertAxis) fits = displayStartIfFits() || displayEndIfFits();
    else fits = displayEndIfFits() || displayStartIfFits();
    if (!fits) displayWhereverShrinkedFits();
}
function $7548ac4faa48d4bb$var$alignMainAxis(args) {
    $7548ac4faa48d4bb$var$alignAxis(args);
}
function $7548ac4faa48d4bb$var$alignSecondaryAxis(args) {
    $7548ac4faa48d4bb$var$alignAxis($7548ac4faa48d4bb$var$__assign($7548ac4faa48d4bb$var$__assign({}, args), {
        axis: args.axis === 'x' ? 'y' : 'x',
        secondary: true
    }));
}
function $7548ac4faa48d4bb$var$alignBothAxis(args) {
    var invertAxis = args.invertAxis, invertSecondaryAxis = args.invertSecondaryAxis, commonArgs = $7548ac4faa48d4bb$var$__rest(args, [
        "invertAxis",
        "invertSecondaryAxis"
    ]);
    $7548ac4faa48d4bb$var$alignMainAxis($7548ac4faa48d4bb$var$__assign($7548ac4faa48d4bb$var$__assign({}, commonArgs), {
        invertAxis: invertAxis
    }));
    $7548ac4faa48d4bb$var$alignSecondaryAxis($7548ac4faa48d4bb$var$__assign($7548ac4faa48d4bb$var$__assign({}, commonArgs), {
        invertAxis: invertSecondaryAxis
    }));
}
var $7548ac4faa48d4bb$var$Fit = /** @class */ function(_super) {
    $7548ac4faa48d4bb$var$__extends(Fit, _super);
    function Fit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fit = function() {
            var _a = _this, scrollContainer = _a.scrollContainer, container = _a.container, element = _a.element;
            if (!scrollContainer || !container || !element) return;
            var elementWidth = element.clientWidth;
            var elementHeight = element.clientHeight;
            // No need to recalculate - already did that for current dimensions
            if (_this.elementWidth === elementWidth && _this.elementHeight === elementHeight) return;
            // Save the dimensions so that we know we don't need to repeat the function if unchanged
            _this.elementWidth = elementWidth;
            _this.elementHeight = elementHeight;
            var parent = container.parentElement;
            // Container was unmounted
            if (!parent) return;
            /**
             * We need to ensure that <Fit />'s child has a absolute position. Otherwise,
             * we wouldn't be able to place the child in the correct position.
             */ var style = window.getComputedStyle(element);
            var position = style.position;
            if (position !== 'absolute') element.style.position = 'absolute';
            /**
             * We need to ensure that <Fit />'s parent has a relative or absolute position. Otherwise,
             * we wouldn't be able to place the child in the correct position.
             */ var parentStyle = window.getComputedStyle(parent);
            var parentPosition = parentStyle.position;
            if (parentPosition !== 'relative' && parentPosition !== 'absolute') parent.style.position = 'relative';
            var _b = _this.props, invertAxis = _b.invertAxis, invertSecondaryAxis = _b.invertSecondaryAxis, _c = _b.mainAxis, mainAxis = _c === void 0 ? 'y' : _c, _d = _b.spacing, spacing = _d === void 0 ? 8 : _d;
            $7548ac4faa48d4bb$var$alignBothAxis({
                container: container,
                element: element,
                invertAxis: invertAxis,
                invertSecondaryAxis: invertSecondaryAxis,
                axis: mainAxis,
                scrollContainer: scrollContainer,
                spacing: spacing
            });
        };
        return _this;
    }
    Fit.prototype.componentDidMount = function() {
        var _this = this;
        if (!$7548ac4faa48d4bb$var$isDisplayContentsSupported) {
            // eslint-disable-next-line react/no-find-dom-node
            var element = (0, $1u0KT.findDOMNode)(this);
            if (!element || !(element instanceof HTMLElement)) return;
            this.container = element;
            this.element = element;
            this.scrollContainer = $7548ac4faa48d4bb$var$findScrollContainer(element);
        }
        this.fit();
        var onMutation = function() {
            _this.fit();
        };
        if ($7548ac4faa48d4bb$var$isMutationObserverSupported && this.element) {
            var mutationObserver = new MutationObserver(onMutation);
            mutationObserver.observe(this.element, {
                attributes: true,
                attributeFilter: [
                    'class',
                    'style'
                ]
            });
        }
    };
    Fit.prototype.render = function() {
        var _this = this;
        var children = this.props.children;
        var child = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children);
        if ($7548ac4faa48d4bb$var$isDisplayContentsSupported) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            ref: function(container) {
                _this.container = container;
                var element = container && container.firstElementChild;
                if (!element || !(element instanceof HTMLElement)) return;
                _this.element = element;
                _this.scrollContainer = $7548ac4faa48d4bb$var$findScrollContainer(element);
            },
            style: {
                display: 'contents'
            }
        }, child);
        return child;
    };
    Fit.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
        invertAxis: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        invertSecondaryAxis: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        mainAxis: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'x',
            'y'
        ]),
        spacing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
                bottom: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                left: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                right: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
                top: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired
            })
        ])
    };
    return Fit;
}((0, $acw62.Component));
var $7548ac4faa48d4bb$export$2e2bcd8739ae039 = $7548ac4faa48d4bb$var$Fit;


var $4d44b999b4c4c57d$export$2e2bcd8739ae039 = (0, $7548ac4faa48d4bb$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $d588bbd5794641a1$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "react-datetime-picker__inputGroup__divider"
    }, children);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $c517d2e5f4f3ebfd$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c517d2e5f4f3ebfd$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c517d2e5f4f3ebfd$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c517d2e5f4f3ebfd$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c517d2e5f4f3ebfd$export$2e2bcd8739ae039 = $c517d2e5f4f3ebfd$export$4f5d2d50c9deca37;


var $30bc6fa40b0f5291$var$allowedVariants = [
    'normal',
    'small-caps'
];
function $30bc6fa40b0f5291$export$c92c612bac8147ea(element) {
    if (!element) return '';
    var style = window.getComputedStyle(element);
    if (style.font) return style.font;
    var isFontDefined = style.fontFamily !== '';
    if (!isFontDefined) return '';
    var fontVariant = $30bc6fa40b0f5291$var$allowedVariants.includes(style.fontVariant) ? style.fontVariant : 'normal';
    return "".concat(style.fontStyle, " ").concat(fontVariant, " ").concat(style.fontWeight, " ").concat(style.fontSize, " / ").concat(style.lineHeight, " ").concat(style.fontFamily);
}
var $30bc6fa40b0f5291$var$cachedCanvas;
function $30bc6fa40b0f5291$export$866cc30a33805630(text, font) {
    var canvas = $30bc6fa40b0f5291$var$cachedCanvas || ($30bc6fa40b0f5291$var$cachedCanvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    // Context type not supported
    if (!context) return null;
    context.font = font;
    var width = context.measureText(text).width;
    return Math.ceil(width);
}
function $30bc6fa40b0f5291$export$6278e7bf110509e(element) {
    if (typeof document === 'undefined' || !element) return null;
    var font = $30bc6fa40b0f5291$export$c92c612bac8147ea(element);
    var text = element.value || element.placeholder;
    var width = $30bc6fa40b0f5291$export$866cc30a33805630(text, font);
    if (width === null) return null;
    element.style.width = "".concat(width, "px");
    return width;
}
var $30bc6fa40b0f5291$export$2e2bcd8739ae039 = $30bc6fa40b0f5291$export$6278e7bf110509e;


var $940c27ea511edf40$var$isBrowser = typeof document !== 'undefined';
var $940c27ea511edf40$var$useIsomorphicLayoutEffect = $940c27ea511edf40$var$isBrowser ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $940c27ea511edf40$var$isIEOrEdgeLegacy = $940c27ea511edf40$var$isBrowser && /(MSIE|Trident\/|Edge\/)/.test(navigator.userAgent);
var $940c27ea511edf40$var$isFirefox = $940c27ea511edf40$var$isBrowser && /Firefox/.test(navigator.userAgent);
function $940c27ea511edf40$var$onFocus(event) {
    var target = event.target;
    if ($940c27ea511edf40$var$isIEOrEdgeLegacy) requestAnimationFrame(function() {
        return target.select();
    });
    else target.select();
}
function $940c27ea511edf40$var$updateInputWidthOnLoad(element) {
    if (document.readyState === 'complete') return;
    function onLoad() {
        (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(element);
    }
    window.addEventListener('load', onLoad);
}
function $940c27ea511edf40$var$updateInputWidthOnFontLoad(element) {
    if (!document.fonts) return;
    var font = (0, $30bc6fa40b0f5291$export$c92c612bac8147ea)(element);
    if (!font) return;
    var isFontLoaded = document.fonts.check(font);
    if (isFontLoaded) return;
    function onLoadingDone() {
        (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(element);
    }
    document.fonts.addEventListener('loadingdone', onLoadingDone);
}
function $940c27ea511edf40$var$getSelectionString(input) {
    /**
     * window.getSelection().toString() returns empty string in IE11 and Firefox,
     * so alternatives come first.
     */ if (input && 'selectionStart' in input && input.selectionStart !== null && 'selectionEnd' in input && input.selectionEnd !== null) return input.value.slice(input.selectionStart, input.selectionEnd);
    if ('getSelection' in window) {
        var selection = window.getSelection();
        return selection && selection.toString();
    }
    return null;
}
function $940c27ea511edf40$var$makeOnKeyPress(maxLength) {
    if (maxLength === null) return undefined;
    /**
     * Prevents keystrokes that would not produce a number or when value after keystroke would
     * exceed maxLength.
     */ return function onKeyPress(event) {
        if ($940c27ea511edf40$var$isFirefox) // See https://github.com/wojtekmaj/react-time-picker/issues/92
        return;
        var key = event.key, input = event.target;
        var value = input.value;
        var isNumberKey = key.length === 1 && /\d/.test(key);
        var selection = $940c27ea511edf40$var$getSelectionString(input);
        if (!isNumberKey || !(selection || value.length < maxLength)) event.preventDefault();
    };
}
function $940c27ea511edf40$export$2e2bcd8739ae039(_a) {
    var ariaLabel = _a.ariaLabel, autoFocus = _a.autoFocus, className = _a.className, disabled = _a.disabled, inputRef = _a.inputRef, max = _a.max, min = _a.min, name = _a.name, nameForClass = _a.nameForClass, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, _b = _a.placeholder, placeholder = _b === void 0 ? '--' : _b, required = _a.required, showLeadingZeros = _a.showLeadingZeros, step = _a.step, value = _a.value;
    $940c27ea511edf40$var$useIsomorphicLayoutEffect(function() {
        if (!inputRef || !inputRef.current) return;
        (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(inputRef.current);
        $940c27ea511edf40$var$updateInputWidthOnLoad(inputRef.current);
        $940c27ea511edf40$var$updateInputWidthOnFontLoad(inputRef.current);
    }, [
        inputRef,
        value
    ]);
    var hasLeadingZero = showLeadingZeros && value && Number(value) < 10 && (value === '0' || !value.toString().startsWith('0'));
    var maxLength = max ? max.toString().length : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, hasLeadingZero ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(className, "__leadingZero")
    }, "0") : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        "aria-label": ariaLabel,
        autoComplete: "off",
        autoFocus: autoFocus,
        className: (0, $c517d2e5f4f3ebfd$export$2e2bcd8739ae039)("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
        "data-input": "true",
        disabled: disabled,
        inputMode: "numeric",
        max: max,
        min: min,
        name: name,
        onChange: onChange,
        onFocus: $940c27ea511edf40$var$onFocus,
        onKeyDown: onKeyDown,
        onKeyPress: $940c27ea511edf40$var$makeOnKeyPress(maxLength),
        onKeyUp: function(event) {
            (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(event.target);
            if (onKeyUp) onKeyUp(event);
        },
        placeholder: placeholder,
        ref: inputRef,
        required: required,
        step: step,
        type: "number",
        value: value !== null ? value : ''
    }));
}


/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {Date} value Value to return.
 * @param {Date} min Minimum return value.
 * @param {Date} max Maximum return value.
 * @returns {Date} Value between min and max.
 */ function $e27c1faed708ea57$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
function $e27c1faed708ea57$var$isValidNumber(num) {
    return num !== null && num !== false && !Number.isNaN(Number(num));
}
function $e27c1faed708ea57$export$e4271ef32f1fa92() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return Math.min.apply(Math, args.filter($e27c1faed708ea57$var$isValidNumber));
}
function $e27c1faed708ea57$export$2341d2512ecea49e() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return Math.max.apply(Math, args.filter($e27c1faed708ea57$var$isValidNumber));
}


var $841141269e7dd588$var$__assign = undefined && undefined.__assign || function() {
    $841141269e7dd588$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $841141269e7dd588$var$__assign.apply(this, arguments);
};
var $841141269e7dd588$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $841141269e7dd588$export$2e2bcd8739ae039(_a) {
    var maxDate = _a.maxDate, minDate = _a.minDate, month = _a.month, year = _a.year, otherProps = $841141269e7dd588$var$__rest(_a, [
        "maxDate",
        "minDate",
        "month",
        "year"
    ]);
    var currentMonthMaxDays = function() {
        if (!month) return 31;
        return (0, $78fdc7949801ab2a$export$f645ddd439eb259d)(new Date(Number(year), Number(month) - 1, 1));
    }();
    function isSameMonth(date) {
        return year === (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date).toString() && month === (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(date).toString();
    }
    var maxDay = (0, $e27c1faed708ea57$export$e4271ef32f1fa92)(currentMonthMaxDays, maxDate && isSameMonth(maxDate) && (0, $78fdc7949801ab2a$export$aa350b96d91cd94)(maxDate));
    var minDay = (0, $e27c1faed708ea57$export$2341d2512ecea49e)(1, minDate && isSameMonth(minDate) && (0, $78fdc7949801ab2a$export$aa350b96d91cd94)(minDate));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $940c27ea511edf40$export$2e2bcd8739ae039), $841141269e7dd588$var$__assign({
        max: maxDay,
        min: minDay,
        name: "day"
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");



var $4ce62ddaee3b3c27$var$__assign = undefined && undefined.__assign || function() {
    $4ce62ddaee3b3c27$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ce62ddaee3b3c27$var$__assign.apply(this, arguments);
};
var $4ce62ddaee3b3c27$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $4ce62ddaee3b3c27$export$2e2bcd8739ae039(_a) {
    var maxDate = _a.maxDate, minDate = _a.minDate, year = _a.year, otherProps = $4ce62ddaee3b3c27$var$__rest(_a, [
        "maxDate",
        "minDate",
        "year"
    ]);
    function isSameYear(date) {
        return date && year === (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date).toString();
    }
    var maxMonth = (0, $e27c1faed708ea57$export$e4271ef32f1fa92)(12, maxDate && isSameYear(maxDate) && (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(maxDate));
    var minMonth = (0, $e27c1faed708ea57$export$2341d2512ecea49e)(1, minDate && isSameYear(minDate) && (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(minDate));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $940c27ea511edf40$export$2e2bcd8739ae039), $4ce62ddaee3b3c27$var$__assign({
        max: maxMonth,
        min: minMonth,
        name: "month"
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");



var $1fbb680a258a0fc1$var$formatterCache = new Map();
function $1fbb680a258a0fc1$export$a7f9565e3c81cd54(options) {
    return function formatter(locale, date) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$1fbb680a258a0fc1$var$formatterCache.has(localeWithDefault)) $1fbb680a258a0fc1$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $1fbb680a258a0fc1$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault || undefined, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 * @returns {Date} Date with hour set to 12.
 */ function $1fbb680a258a0fc1$var$toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function $1fbb680a258a0fc1$var$getSafeFormatter(options) {
    return function(locale, date) {
        return $1fbb680a258a0fc1$export$a7f9565e3c81cd54(options)(locale, $1fbb680a258a0fc1$var$toSafeHour(date));
    };
}
var $1fbb680a258a0fc1$var$formatMonthOptions = {
    month: 'long'
};
var $1fbb680a258a0fc1$var$formatShortMonthOptions = {
    month: 'short'
};
var $1fbb680a258a0fc1$export$d0536c8e7f45796e = $1fbb680a258a0fc1$var$getSafeFormatter($1fbb680a258a0fc1$var$formatMonthOptions);
var $1fbb680a258a0fc1$export$8162c834bf09ab30 = $1fbb680a258a0fc1$var$getSafeFormatter($1fbb680a258a0fc1$var$formatShortMonthOptions);



var $ca842f2c59ca8ec0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $ca842f2c59ca8ec0$export$2e2bcd8739ae039(_a) {
    var ariaLabel = _a.ariaLabel, autoFocus = _a.autoFocus, className = _a.className, disabled = _a.disabled, inputRef = _a.inputRef, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, onKeyDown = _a.onKeyDown, _b = _a.placeholder, placeholder = _b === void 0 ? '--' : _b, required = _a.required, short = _a.short, value = _a.value, year = _a.year;
    function isSameYear(date) {
        return date && year === (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date).toString();
    }
    var maxMonth = (0, $e27c1faed708ea57$export$e4271ef32f1fa92)(12, maxDate && isSameYear(maxDate) && (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(maxDate));
    var minMonth = (0, $e27c1faed708ea57$export$2341d2512ecea49e)(1, minDate && isSameYear(minDate) && (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(minDate));
    var dates = $ca842f2c59ca8ec0$var$__spreadArray([], Array(12), true).map(function(el, index) {
        return new Date(2019, index, 1);
    });
    var name = 'month';
    var formatter = short ? (0, $1fbb680a258a0fc1$export$8162c834bf09ab30) : (0, $1fbb680a258a0fc1$export$d0536c8e7f45796e);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        "aria-label": ariaLabel,
        autoFocus: autoFocus,
        className: (0, $c517d2e5f4f3ebfd$export$2e2bcd8739ae039)("".concat(className, "__input"), "".concat(className, "__").concat(name)),
        "data-input": "true",
        "data-select": "true",
        disabled: disabled,
        name: name,
        onChange: onChange,
        onKeyDown: onKeyDown,
        ref: inputRef,
        required: required,
        value: value !== null ? value : ''
    }, !value && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), dates.map(function(date) {
        var month = (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(date);
        var disabled = month < minMonth || month > maxMonth;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: month,
            disabled: disabled,
            value: month
        }, formatter(locale, date));
    }));
}



var $acw62 = parcelRequire("acw62");



var $6073540acba1d78e$var$__assign = undefined && undefined.__assign || function() {
    $6073540acba1d78e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6073540acba1d78e$var$__assign.apply(this, arguments);
};
var $6073540acba1d78e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6073540acba1d78e$export$2e2bcd8739ae039(_a) {
    var maxDate = _a.maxDate, minDate = _a.minDate, _b = _a.placeholder, placeholder = _b === void 0 ? '----' : _b, valueType = _a.valueType, otherProps = $6073540acba1d78e$var$__rest(_a, [
        "maxDate",
        "minDate",
        "placeholder",
        "valueType"
    ]);
    var maxYear = (0, $e27c1faed708ea57$export$e4271ef32f1fa92)(275760, maxDate && (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(maxDate));
    var minYear = (0, $e27c1faed708ea57$export$2341d2512ecea49e)(1, minDate && (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(minDate));
    var yearStep = function() {
        if (valueType === 'century') return 10;
        return 1;
    }();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $940c27ea511edf40$export$2e2bcd8739ae039), $6073540acba1d78e$var$__assign({
        max: maxYear,
        min: minYear,
        name: "year",
        placeholder: placeholder,
        step: yearStep
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $20fbcde3916e30b0$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $20fbcde3916e30b0$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $20fbcde3916e30b0$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $20fbcde3916e30b0$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $20fbcde3916e30b0$export$2e2bcd8739ae039 = $20fbcde3916e30b0$export$4f5d2d50c9deca37;



var $bcacd0b0f02e993c$var$isBrowser = typeof document !== 'undefined';
var $bcacd0b0f02e993c$var$useIsomorphicLayoutEffect = $bcacd0b0f02e993c$var$isBrowser ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $bcacd0b0f02e993c$var$isIEOrEdgeLegacy = $bcacd0b0f02e993c$var$isBrowser && /(MSIE|Trident\/|Edge\/)/.test(navigator.userAgent);
var $bcacd0b0f02e993c$var$isFirefox = $bcacd0b0f02e993c$var$isBrowser && /Firefox/.test(navigator.userAgent);
function $bcacd0b0f02e993c$var$onFocus(event) {
    var target = event.target;
    if ($bcacd0b0f02e993c$var$isIEOrEdgeLegacy) requestAnimationFrame(function() {
        return target.select();
    });
    else target.select();
}
function $bcacd0b0f02e993c$var$updateInputWidthOnLoad(element) {
    if (document.readyState === 'complete') return;
    function onLoad() {
        (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(element);
    }
    window.addEventListener('load', onLoad);
}
function $bcacd0b0f02e993c$var$updateInputWidthOnFontLoad(element) {
    if (!document.fonts) return;
    var font = (0, $30bc6fa40b0f5291$export$c92c612bac8147ea)(element);
    if (!font) return;
    var isFontLoaded = document.fonts.check(font);
    if (isFontLoaded) return;
    function onLoadingDone() {
        (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(element);
    }
    document.fonts.addEventListener('loadingdone', onLoadingDone);
}
function $bcacd0b0f02e993c$var$getSelectionString(input) {
    /**
     * window.getSelection().toString() returns empty string in IE11 and Firefox,
     * so alternatives come first.
     */ if (input && 'selectionStart' in input && input.selectionStart !== null && 'selectionEnd' in input && input.selectionEnd !== null) return input.value.slice(input.selectionStart, input.selectionEnd);
    if ('getSelection' in window) {
        var selection = window.getSelection();
        return selection && selection.toString();
    }
    return null;
}
function $bcacd0b0f02e993c$var$makeOnKeyPress(maxLength) {
    if (maxLength === null) return undefined;
    /**
     * Prevents keystrokes that would not produce a number or when value after keystroke would
     * exceed maxLength.
     */ return function onKeyPress(event) {
        if ($bcacd0b0f02e993c$var$isFirefox) // See https://github.com/wojtekmaj/react-time-picker/issues/92
        return;
        var key = event.key, input = event.target;
        var value = input.value;
        var isNumberKey = key.length === 1 && /\d/.test(key);
        var selection = $bcacd0b0f02e993c$var$getSelectionString(input);
        if (!isNumberKey || !(selection || value.length < maxLength)) event.preventDefault();
    };
}
function $bcacd0b0f02e993c$export$2e2bcd8739ae039(_a) {
    var ariaLabel = _a.ariaLabel, autoFocus = _a.autoFocus, className = _a.className, disabled = _a.disabled, inputRef = _a.inputRef, max = _a.max, min = _a.min, name = _a.name, nameForClass = _a.nameForClass, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, _b = _a.placeholder, placeholder = _b === void 0 ? '--' : _b, required = _a.required, showLeadingZeros = _a.showLeadingZeros, step = _a.step, value = _a.value;
    $bcacd0b0f02e993c$var$useIsomorphicLayoutEffect(function() {
        if (!inputRef || !inputRef.current) return;
        (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(inputRef.current);
        $bcacd0b0f02e993c$var$updateInputWidthOnLoad(inputRef.current);
        $bcacd0b0f02e993c$var$updateInputWidthOnFontLoad(inputRef.current);
    }, [
        inputRef,
        value
    ]);
    var hasLeadingZero = showLeadingZeros && value && Number(value) < 10 && (value === '0' || !value.toString().startsWith('0'));
    var maxLength = max ? max.toString().length : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, hasLeadingZero ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "".concat(className, "__leadingZero")
    }, "0") : null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        "aria-label": ariaLabel,
        autoComplete: "off",
        autoFocus: autoFocus,
        className: (0, $20fbcde3916e30b0$export$2e2bcd8739ae039)("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
        "data-input": "true",
        disabled: disabled,
        inputMode: "numeric",
        max: max,
        min: min,
        name: name,
        onChange: onChange,
        onFocus: $bcacd0b0f02e993c$var$onFocus,
        onKeyDown: onKeyDown,
        onKeyPress: $bcacd0b0f02e993c$var$makeOnKeyPress(maxLength),
        onKeyUp: function(event) {
            (0, $30bc6fa40b0f5291$export$2e2bcd8739ae039)(event.target);
            if (onKeyUp) onKeyUp(event);
        },
        placeholder: placeholder,
        ref: inputRef,
        required: required,
        step: step,
        type: "number",
        value: value !== null ? value : ''
    }));
}


function $18002e934667f9ed$export$e40e59a57ec762e4(hour12, amPm) {
    var hour24 = Number(hour12);
    if (amPm === 'am' && hour24 === 12) hour24 = 0;
    else if (amPm === 'pm' && hour24 < 12) hour24 += 12;
    return hour24;
}
function $18002e934667f9ed$export$8041c02ebe2956d0(hour24) {
    var hour12 = Number(hour24) % 12 || 12;
    return [
        hour12,
        Number(hour24) < 12 ? 'am' : 'pm'
    ];
}



var $b5f8c5529b5c20a8$var$formatterCache = new Map();
function $b5f8c5529b5c20a8$export$a7f9565e3c81cd54(options) {
    return function formatter(locale, date) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$b5f8c5529b5c20a8$var$formatterCache.has(localeWithDefault)) $b5f8c5529b5c20a8$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $b5f8c5529b5c20a8$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault || undefined, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
var $b5f8c5529b5c20a8$var$numberFormatterCache = new Map();
function $b5f8c5529b5c20a8$export$c2604861dc73a731(options) {
    return function(locale, number) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$b5f8c5529b5c20a8$var$numberFormatterCache.has(localeWithDefault)) $b5f8c5529b5c20a8$var$numberFormatterCache.set(localeWithDefault, new Map());
        var numberFormatterCacheLocale = $b5f8c5529b5c20a8$var$numberFormatterCache.get(localeWithDefault);
        if (!numberFormatterCacheLocale.has(options)) numberFormatterCacheLocale.set(options, new Intl.NumberFormat(localeWithDefault || undefined, options).format);
        return numberFormatterCacheLocale.get(options)(number);
    };
}


var $2b5c3768a6527bdc$var$nines = [
    '9',
    "\u0669"
];
var $2b5c3768a6527bdc$var$ninesRegExp = new RegExp("[".concat($2b5c3768a6527bdc$var$nines.join(''), "]"));
var $2b5c3768a6527bdc$var$amPmFormatter = (0, $b5f8c5529b5c20a8$export$a7f9565e3c81cd54)({
    hour: 'numeric'
});
function $2b5c3768a6527bdc$export$3185e3c14090a339(locale) {
    var amString = $2b5c3768a6527bdc$var$amPmFormatter(locale, new Date(2017, 0, 1, 9));
    var pmString = $2b5c3768a6527bdc$var$amPmFormatter(locale, new Date(2017, 0, 1, 21));
    var _a = amString.split($2b5c3768a6527bdc$var$ninesRegExp), am1 = _a[0], am2 = _a[1];
    var _b = pmString.split($2b5c3768a6527bdc$var$ninesRegExp), pm1 = _b[0], pm2 = _b[1];
    if (pm2 !== undefined) {
        // If pm2 is undefined, nine was not found in pmString - this locale is not using 12-hour time
        if (am1 !== pm1) return [
            am1,
            pm1
        ].map(function(el) {
            return el.trim();
        });
        if (am2 !== pm2) return [
            am2,
            pm2
        ].map(function(el) {
            return el.trim();
        });
    }
    // Fallback
    return [
        'AM',
        'PM'
    ];
}
function $2b5c3768a6527bdc$var$isValidNumber(num) {
    return num !== null && num !== false && !Number.isNaN(Number(num));
}
function $2b5c3768a6527bdc$export$e4271ef32f1fa92() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return Math.min.apply(Math, args.filter($2b5c3768a6527bdc$var$isValidNumber));
}
function $2b5c3768a6527bdc$export$2341d2512ecea49e() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return Math.max.apply(Math, args.filter($2b5c3768a6527bdc$var$isValidNumber));
}


var $4ba9182fb2008c90$var$__assign = undefined && undefined.__assign || function() {
    $4ba9182fb2008c90$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4ba9182fb2008c90$var$__assign.apply(this, arguments);
};
var $4ba9182fb2008c90$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $4ba9182fb2008c90$export$2e2bcd8739ae039(_a) {
    var amPm = _a.amPm, maxTime = _a.maxTime, minTime = _a.minTime, value = _a.value, otherProps = $4ba9182fb2008c90$var$__rest(_a, [
        "amPm",
        "maxTime",
        "minTime",
        "value"
    ]);
    var maxHour = (0, $2b5c3768a6527bdc$export$e4271ef32f1fa92)(12, maxTime && function() {
        var _a = (0, $18002e934667f9ed$export$8041c02ebe2956d0)((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(maxTime)), maxHourResult = _a[0], maxAmPm = _a[1];
        if (maxAmPm !== amPm) // pm is always after am, so we should ignore validation
        return null;
        return maxHourResult;
    }());
    var minHour = (0, $2b5c3768a6527bdc$export$2341d2512ecea49e)(1, minTime && function() {
        var _a = (0, $18002e934667f9ed$export$8041c02ebe2956d0)((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(minTime)), minHourResult = _a[0], minAmPm = _a[1];
        if (// pm is always after am, so we should ignore validation
        minAmPm !== amPm || // If minHour is 12 am/pm, user should be able to enter 12, 1, ..., 11.
        minHourResult === 12) return null;
        return minHourResult;
    }());
    var value12 = value ? (0, $18002e934667f9ed$export$8041c02ebe2956d0)(value)[0].toString() : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bcacd0b0f02e993c$export$2e2bcd8739ae039), $4ba9182fb2008c90$var$__assign({
        max: maxHour,
        min: minHour,
        name: "hour12",
        nameForClass: "hour",
        value: value12
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");



var $1ccc9e54c87f9c3f$var$__assign = undefined && undefined.__assign || function() {
    $1ccc9e54c87f9c3f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1ccc9e54c87f9c3f$var$__assign.apply(this, arguments);
};
var $1ccc9e54c87f9c3f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $1ccc9e54c87f9c3f$export$2e2bcd8739ae039(_a) {
    var maxTime = _a.maxTime, minTime = _a.minTime, otherProps = $1ccc9e54c87f9c3f$var$__rest(_a, [
        "maxTime",
        "minTime"
    ]);
    var maxHour = (0, $2b5c3768a6527bdc$export$e4271ef32f1fa92)(23, maxTime && (0, $78fdc7949801ab2a$export$257b40f71c07d58f)(maxTime));
    var minHour = (0, $2b5c3768a6527bdc$export$2341d2512ecea49e)(0, minTime && (0, $78fdc7949801ab2a$export$257b40f71c07d58f)(minTime));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bcacd0b0f02e993c$export$2e2bcd8739ae039), $1ccc9e54c87f9c3f$var$__assign({
        max: maxHour,
        min: minHour,
        name: "hour24",
        nameForClass: "hour"
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");



var $200246a6b0e25505$var$__assign = undefined && undefined.__assign || function() {
    $200246a6b0e25505$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $200246a6b0e25505$var$__assign.apply(this, arguments);
};
var $200246a6b0e25505$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $200246a6b0e25505$export$2e2bcd8739ae039(_a) {
    var hour = _a.hour, maxTime = _a.maxTime, minTime = _a.minTime, _b = _a.showLeadingZeros, showLeadingZeros = _b === void 0 ? true : _b, otherProps = $200246a6b0e25505$var$__rest(_a, [
        "hour",
        "maxTime",
        "minTime",
        "showLeadingZeros"
    ]);
    function isSameHour(date) {
        return hour === (0, $78fdc7949801ab2a$export$257b40f71c07d58f)(date).toString();
    }
    var maxMinute = (0, $2b5c3768a6527bdc$export$e4271ef32f1fa92)(59, maxTime && isSameHour(maxTime) && (0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(maxTime));
    var minMinute = (0, $2b5c3768a6527bdc$export$2341d2512ecea49e)(0, minTime && isSameHour(minTime) && (0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(minTime));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bcacd0b0f02e993c$export$2e2bcd8739ae039), $200246a6b0e25505$var$__assign({
        max: maxMinute,
        min: minMinute,
        name: "minute",
        showLeadingZeros: showLeadingZeros
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");



var $043a7e7bf24b83d6$var$__assign = undefined && undefined.__assign || function() {
    $043a7e7bf24b83d6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $043a7e7bf24b83d6$var$__assign.apply(this, arguments);
};
var $043a7e7bf24b83d6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $043a7e7bf24b83d6$export$2e2bcd8739ae039(_a) {
    var hour = _a.hour, maxTime = _a.maxTime, minTime = _a.minTime, minute = _a.minute, _b = _a.showLeadingZeros, showLeadingZeros = _b === void 0 ? true : _b, otherProps = $043a7e7bf24b83d6$var$__rest(_a, [
        "hour",
        "maxTime",
        "minTime",
        "minute",
        "showLeadingZeros"
    ]);
    function isSameMinute(date) {
        return hour === (0, $78fdc7949801ab2a$export$257b40f71c07d58f)(date).toString() && minute === (0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(date).toString();
    }
    var maxSecond = (0, $2b5c3768a6527bdc$export$e4271ef32f1fa92)(59, maxTime && isSameMinute(maxTime) && (0, $78fdc7949801ab2a$export$5e9417507ff28427)(maxTime));
    var minSecond = (0, $2b5c3768a6527bdc$export$2341d2512ecea49e)(0, minTime && isSameMinute(minTime) && (0, $78fdc7949801ab2a$export$5e9417507ff28427)(minTime));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bcacd0b0f02e993c$export$2e2bcd8739ae039), $043a7e7bf24b83d6$var$__assign({
        max: maxSecond,
        min: minSecond,
        name: "second",
        showLeadingZeros: showLeadingZeros
    }, otherProps));
}



var $acw62 = parcelRequire("acw62");




function $cb136e7037b8eb70$export$2e2bcd8739ae039(_a) {
    var ariaLabel = _a.ariaLabel, autoFocus = _a.autoFocus, className = _a.className, disabled = _a.disabled, inputRef = _a.inputRef, locale = _a.locale, maxTime = _a.maxTime, minTime = _a.minTime, onChange = _a.onChange, onKeyDown = _a.onKeyDown, required = _a.required, value = _a.value;
    var amDisabled = minTime ? (0, $18002e934667f9ed$export$8041c02ebe2956d0)((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(minTime))[1] === 'pm' : false;
    var pmDisabled = maxTime ? (0, $18002e934667f9ed$export$8041c02ebe2956d0)((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(maxTime))[1] === 'am' : false;
    var name = 'amPm';
    var _b = (0, $2b5c3768a6527bdc$export$3185e3c14090a339)(locale), amLabel = _b[0], pmLabel = _b[1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        "aria-label": ariaLabel,
        autoFocus: autoFocus,
        className: (0, $20fbcde3916e30b0$export$2e2bcd8739ae039)("".concat(className, "__input"), "".concat(className, "__").concat(name)),
        "data-input": "true",
        "data-select": "true",
        disabled: disabled,
        name: name,
        onChange: onChange,
        onKeyDown: onKeyDown,
        ref: inputRef,
        required: required,
        value: value !== null ? value : ''
    }, !value && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, "--"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        disabled: amDisabled,
        value: "am"
    }, amLabel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        disabled: pmDisabled,
        value: "pm"
    }, pmLabel));
}



var $acw62 = parcelRequire("acw62");

function $8e67f6db7f1cc193$export$2e2bcd8739ae039(_a) {
    var ariaLabel = _a.ariaLabel, disabled = _a.disabled, maxDate = _a.maxDate, minDate = _a.minDate, name = _a.name, onChange = _a.onChange, required = _a.required, value = _a.value, valueType = _a.valueType;
    var nativeValueParser = function() {
        switch(valueType){
            case 'hour':
                return function(receivedValue) {
                    return "".concat((0, $78fdc7949801ab2a$export$ce780a31b7197841)(receivedValue), "T").concat((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(receivedValue), ":00");
                };
            case 'minute':
                return function(receivedValue) {
                    return "".concat((0, $78fdc7949801ab2a$export$ce780a31b7197841)(receivedValue), "T").concat((0, $78fdc7949801ab2a$export$aefe158a7bd76d23)(receivedValue));
                };
            case 'second':
                return 0, $78fdc7949801ab2a$export$98f36b76519fd86;
            default:
                throw new Error('Invalid valueType');
        }
    }();
    var step = function() {
        switch(valueType){
            case 'hour':
                return 3600;
            case 'minute':
                return 60;
            case 'second':
                return 1;
            default:
                throw new Error('Invalid valueType');
        }
    }();
    function stopPropagation(event) {
        event.stopPropagation();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        "aria-label": ariaLabel,
        disabled: disabled,
        hidden: true,
        max: maxDate ? nativeValueParser(maxDate) : undefined,
        min: minDate ? nativeValueParser(minDate) : undefined,
        name: name,
        onChange: onChange,
        onFocus: stopPropagation,
        required: required,
        step: step,
        style: {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: '-999'
        },
        type: "datetime-local",
        value: value ? nativeValueParser(value) : ''
    });
}



var $9a1d45b85ab6436c$var$formatterCache = new Map();
function $9a1d45b85ab6436c$export$a7f9565e3c81cd54(options) {
    return function formatter(locale, date) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$9a1d45b85ab6436c$var$formatterCache.has(localeWithDefault)) $9a1d45b85ab6436c$var$formatterCache.set(localeWithDefault, new Map());
        var formatterCacheLocale = $9a1d45b85ab6436c$var$formatterCache.get(localeWithDefault);
        if (!formatterCacheLocale.has(options)) formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault || undefined, options).format);
        return formatterCacheLocale.get(options)(date);
    };
}
var $9a1d45b85ab6436c$var$numberFormatterCache = new Map();
function $9a1d45b85ab6436c$export$c2604861dc73a731(options) {
    return function(locale, number) {
        var localeWithDefault = locale || (0, $3cee2524baeacc16$export$2e2bcd8739ae039)();
        if (!$9a1d45b85ab6436c$var$numberFormatterCache.has(localeWithDefault)) $9a1d45b85ab6436c$var$numberFormatterCache.set(localeWithDefault, new Map());
        var numberFormatterCacheLocale = $9a1d45b85ab6436c$var$numberFormatterCache.get(localeWithDefault);
        if (!numberFormatterCacheLocale.has(options)) numberFormatterCacheLocale.set(options, new Intl.NumberFormat(localeWithDefault || undefined, options).format);
        return numberFormatterCacheLocale.get(options)(number);
    };
}
var $9a1d45b85ab6436c$var$formatDateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};
var $9a1d45b85ab6436c$export$3ae94a2503e890a1 = $9a1d45b85ab6436c$export$a7f9565e3c81cd54($9a1d45b85ab6436c$var$formatDateOptions);


function $6e3cf8db165558f8$export$e40e59a57ec762e4(hour12, amPm) {
    var hour24 = Number(hour12);
    if (amPm === 'am' && hour24 === 12) hour24 = 0;
    else if (amPm === 'pm' && hour24 < 12) hour24 += 12;
    return hour24;
}
function $6e3cf8db165558f8$export$8041c02ebe2956d0(hour24) {
    var hour12 = Number(hour24) % 12 || 12;
    return [
        hour12,
        Number(hour24) < 12 ? 'am' : 'pm'
    ];
}



function $c2d5332b6c3ec38d$export$cf95c51b03f10bae(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
}
var $c2d5332b6c3ec38d$var$nines = [
    '9',
    "\u0669"
];
var $c2d5332b6c3ec38d$var$ninesRegExp = new RegExp("[".concat($c2d5332b6c3ec38d$var$nines.join(''), "]"));
var $c2d5332b6c3ec38d$var$amPmFormatter = (0, $9a1d45b85ab6436c$export$a7f9565e3c81cd54)({
    hour: 'numeric'
});
function $c2d5332b6c3ec38d$export$3185e3c14090a339(locale) {
    var amString = $c2d5332b6c3ec38d$var$amPmFormatter(locale, new Date(2017, 0, 1, 9));
    var pmString = $c2d5332b6c3ec38d$var$amPmFormatter(locale, new Date(2017, 0, 1, 21));
    var _a = amString.split($c2d5332b6c3ec38d$var$ninesRegExp), am1 = _a[0], am2 = _a[1];
    var _b = pmString.split($c2d5332b6c3ec38d$var$ninesRegExp), pm1 = _b[0], pm2 = _b[1];
    if (pm2 !== undefined) {
        // If pm2 is undefined, nine was not found in pmString - this locale is not using 12-hour time
        if (am1 !== pm1) return [
            am1,
            pm1
        ].map(function(el) {
            return el.trim();
        });
        if (am2 !== pm2) return [
            am2,
            pm2
        ].map(function(el) {
            return el.trim();
        });
    }
    // Fallback
    return [
        'AM',
        'PM'
    ];
}


'use client';
var $a947434757992386$var$__assign = undefined && undefined.__assign || function() {
    $a947434757992386$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a947434757992386$var$__assign.apply(this, arguments);
};
var $a947434757992386$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $a947434757992386$var$getFormatterOptionsCache = {};
var $a947434757992386$var$defaultMinDate = new Date();
$a947434757992386$var$defaultMinDate.setFullYear(1, 0, 1);
$a947434757992386$var$defaultMinDate.setHours(0, 0, 0, 0);
var $a947434757992386$var$defaultMaxDate = new Date(8.64e15);
var $a947434757992386$var$allViews = [
    'hour',
    'minute',
    'second'
];
function $a947434757992386$var$toDate(value) {
    if (value instanceof Date) return value;
    return new Date(value);
}
function $a947434757992386$var$isSameDate(date, year, month, day) {
    return year === (0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(date).toString() && month === (0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(date).toString() && day === (0, $78fdc7949801ab2a$export$aa350b96d91cd94)(date).toString();
}
function $a947434757992386$var$getValue(value, index) {
    var rawValue = Array.isArray(value) ? value[index] : value;
    if (!rawValue) return null;
    var valueDate = $a947434757992386$var$toDate(rawValue);
    if (isNaN(valueDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueDate;
}
function $a947434757992386$var$getDetailValue(_a, index) {
    var value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate;
    var valuePiece = $a947434757992386$var$getValue(value, index);
    if (!valuePiece) return null;
    return (0, $c2d5332b6c3ec38d$export$cf95c51b03f10bae)(valuePiece, minDate, maxDate);
}
var $a947434757992386$var$getDetailValueFrom = function(args) {
    return $a947434757992386$var$getDetailValue(args, 0);
};
function $a947434757992386$var$isInternalInput(element) {
    return element.dataset.input === 'true';
}
function $a947434757992386$var$findInput(element, property) {
    var nextElement = element;
    do nextElement = nextElement[property];
    while (nextElement && !$a947434757992386$var$isInternalInput(nextElement));
    return nextElement;
}
function $a947434757992386$var$focus(element) {
    if (element) element.focus();
}
function $a947434757992386$var$renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances) {
    var usedFunctions = [];
    var pattern = new RegExp(Object.keys(elementFunctions).map(function(el) {
        return "".concat(el, "+");
    }).join('|'), 'g');
    var matches = placeholder.match(pattern);
    return placeholder.split(pattern).reduce(function(arr, element, index) {
        var divider = element && // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d588bbd5794641a1$export$2e2bcd8739ae039), {
            key: "separator_".concat(index)
        }, element);
        var res = $a947434757992386$var$__spreadArray($a947434757992386$var$__spreadArray([], arr, true), [
            divider
        ], false);
        var currentMatch = matches && matches[index];
        if (currentMatch) {
            var renderFunction = elementFunctions[currentMatch] || elementFunctions[Object.keys(elementFunctions).find(function(elementFunction) {
                return currentMatch.match(elementFunction);
            })];
            if (!renderFunction) return res;
            if (!allowMultipleInstances && usedFunctions.includes(renderFunction)) res.push(currentMatch);
            else {
                res.push(renderFunction(currentMatch, index));
                usedFunctions.push(renderFunction);
            }
        }
        return res;
    }, []);
}
var $a947434757992386$var$formatNumber = (0, $9a1d45b85ab6436c$export$c2604861dc73a731)({
    useGrouping: false
});
function $a947434757992386$export$2e2bcd8739ae039(_a) {
    var amPmAriaLabel = _a.amPmAriaLabel, autoFocus = _a.autoFocus, className = _a.className, dayAriaLabel = _a.dayAriaLabel, dayPlaceholder = _a.dayPlaceholder, disabled = _a.disabled, format = _a.format, hourAriaLabel = _a.hourAriaLabel, hourPlaceholder = _a.hourPlaceholder, isWidgetOpenProps = _a.isWidgetOpen, locale = _a.locale, maxDate = _a.maxDate, _b = _a.maxDetail, maxDetail = _b === void 0 ? 'minute' : _b, minDate = _a.minDate, minuteAriaLabel = _a.minuteAriaLabel, minutePlaceholder = _a.minutePlaceholder, monthAriaLabel = _a.monthAriaLabel, monthPlaceholder = _a.monthPlaceholder, _c = _a.name, name = _c === void 0 ? 'datetime' : _c, nativeInputAriaLabel = _a.nativeInputAriaLabel, onChangeProps = _a.onChange, onInvalidChange = _a.onInvalidChange, required = _a.required, secondAriaLabel = _a.secondAriaLabel, secondPlaceholder = _a.secondPlaceholder, showLeadingZeros = _a.showLeadingZeros, valueProps = _a.value, yearAriaLabel = _a.yearAriaLabel, yearPlaceholder = _a.yearPlaceholder;
    var _d = (0, $acw62.useState)(null), amPm = _d[0], setAmPm = _d[1];
    var _e = (0, $acw62.useState)(null), year = _e[0], setYear = _e[1];
    var _f = (0, $acw62.useState)(null), month = _f[0], setMonth = _f[1];
    var _g = (0, $acw62.useState)(null), day = _g[0], setDay = _g[1];
    var _h = (0, $acw62.useState)(null), hour = _h[0], setHour = _h[1];
    var _j = (0, $acw62.useState)(null), minute = _j[0], setMinute = _j[1];
    var _k = (0, $acw62.useState)(null), second = _k[0], setSecond = _k[1];
    var _l = (0, $acw62.useState)(null), value = _l[0], setValue = _l[1];
    var amPmInput = (0, $acw62.useRef)(null);
    var yearInput = (0, $acw62.useRef)(null);
    var monthInput = (0, $acw62.useRef)(null);
    var monthSelect = (0, $acw62.useRef)(null);
    var dayInput = (0, $acw62.useRef)(null);
    var hour12Input = (0, $acw62.useRef)(null);
    var hour24Input = (0, $acw62.useRef)(null);
    var minuteInput = (0, $acw62.useRef)(null);
    var secondInput = (0, $acw62.useRef)(null);
    var _m = (0, $acw62.useState)(isWidgetOpenProps), isWidgetOpen = _m[0], setIsWidgetOpenOpen = _m[1];
    var lastPressedKey = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(function() {
        setIsWidgetOpenOpen(isWidgetOpenProps);
    }, [
        isWidgetOpenProps
    ]);
    (0, $acw62.useEffect)(function() {
        var nextValue = $a947434757992386$var$getDetailValueFrom({
            value: valueProps,
            minDate: minDate,
            maxDate: maxDate
        });
        if (nextValue) {
            setAmPm((0, $6e3cf8db165558f8$export$8041c02ebe2956d0)((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(nextValue))[1]);
            setYear((0, $78fdc7949801ab2a$export$5846dc2d57a5c860)(nextValue).toString());
            setMonth((0, $78fdc7949801ab2a$export$a8575fd59bc333e3)(nextValue).toString());
            setDay((0, $78fdc7949801ab2a$export$aa350b96d91cd94)(nextValue).toString());
            setHour((0, $78fdc7949801ab2a$export$257b40f71c07d58f)(nextValue).toString());
            setMinute((0, $78fdc7949801ab2a$export$b7f1bc3ea3ac4145)(nextValue).toString());
            setSecond((0, $78fdc7949801ab2a$export$5e9417507ff28427)(nextValue).toString());
            setValue($a947434757992386$var$toDate(nextValue));
        } else {
            setAmPm(null);
            setYear(null);
            setMonth(null);
            setDay(null);
            setHour(null);
            setMinute(null);
            setSecond(null);
            setValue(null);
        }
    }, [
        valueProps,
        minDate,
        maxDate,
        // Toggling widget visibility resets values
        isWidgetOpen
    ]);
    var valueType = maxDetail;
    var formatTime = function() {
        var level = $a947434757992386$var$allViews.indexOf(maxDetail);
        var formatterOptions = $a947434757992386$var$getFormatterOptionsCache[level] || function() {
            var options = {
                hour: 'numeric'
            };
            if (level >= 1) options.minute = 'numeric';
            if (level >= 2) options.second = 'numeric';
            $a947434757992386$var$getFormatterOptionsCache[level] = options;
            return options;
        }();
        return (0, $9a1d45b85ab6436c$export$a7f9565e3c81cd54)(formatterOptions);
    }();
    var datePlaceholder = function() {
        var year = 2017;
        var monthIndex = 11;
        var day = 11;
        var date = new Date(year, monthIndex, day);
        var formattedDate = (0, $9a1d45b85ab6436c$export$3ae94a2503e890a1)(locale, date);
        var datePieces = [
            'year',
            'month',
            'day'
        ];
        var datePieceReplacements = [
            'y',
            'M',
            'd'
        ];
        function formatDatePiece(name, dateToFormat) {
            var formatterOptions = $a947434757992386$var$getFormatterOptionsCache[name] || function() {
                var _a;
                var options = (_a = {}, _a[name] = 'numeric', _a);
                $a947434757992386$var$getFormatterOptionsCache[name] = options;
                return options;
            }();
            return (0, $9a1d45b85ab6436c$export$a7f9565e3c81cd54)(formatterOptions)(locale, dateToFormat).match(/\d{1,}/);
        }
        var placeholder = formattedDate;
        datePieces.forEach(function(datePiece, index) {
            var match = formatDatePiece(datePiece, date);
            if (match) {
                var formattedDatePiece = match[0];
                var datePieceReplacement = datePieceReplacements[index];
                placeholder = placeholder.replace(formattedDatePiece, datePieceReplacement);
            }
        });
        // See: https://github.com/wojtekmaj/react-date-picker/issues/396
        placeholder = placeholder.replace('17', 'y');
        return placeholder;
    }();
    var timePlaceholder = function() {
        var hour24 = 21;
        var hour12 = 9;
        var minute = 13;
        var second = 14;
        var date = new Date(2017, 0, 1, hour24, minute, second);
        return formatTime(locale, date).replace($a947434757992386$var$formatNumber(locale, hour12), 'h').replace($a947434757992386$var$formatNumber(locale, hour24), 'H').replace($a947434757992386$var$formatNumber(locale, minute), 'mm').replace($a947434757992386$var$formatNumber(locale, second), 'ss').replace(new RegExp((0, $c2d5332b6c3ec38d$export$3185e3c14090a339)(locale).join('|')), 'a');
    }();
    var placeholder = format || "".concat(datePlaceholder, "\u00A0").concat(timePlaceholder);
    var dateDivider = function() {
        var dividers = datePlaceholder.match(/[^0-9a-z]/i);
        return dividers ? dividers[0] : null;
    }();
    var timeDivider = function() {
        var dividers = timePlaceholder.match(/[^0-9a-z]/i);
        return dividers ? dividers[0] : null;
    }();
    var maxTime = function() {
        if (!maxDate) return undefined;
        if (!$a947434757992386$var$isSameDate(maxDate, year, month, day)) return undefined;
        return (0, $78fdc7949801ab2a$export$52113457154e5fc)(maxDate || $a947434757992386$var$defaultMaxDate);
    }();
    var minTime = function() {
        if (!minDate) return undefined;
        if (!$a947434757992386$var$isSameDate(minDate, year, month, day)) return undefined;
        return (0, $78fdc7949801ab2a$export$52113457154e5fc)(minDate || $a947434757992386$var$defaultMinDate);
    }();
    function onClick(event) {
        if (event.target === event.currentTarget) {
            // Wrapper was directly clicked
            var firstInput = event.target.children[1];
            $a947434757992386$var$focus(firstInput);
        }
    }
    function onKeyDown(event) {
        lastPressedKey.current = event.key;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowRight':
            case dateDivider:
            case timeDivider:
                event.preventDefault();
                var input = event.target;
                var property = event.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling';
                var nextInput = $a947434757992386$var$findInput(input, property);
                $a947434757992386$var$focus(nextInput);
                break;
            default:
        }
    }
    function onKeyUp(event) {
        var key = event.key, input = event.target;
        var isLastPressedKey = lastPressedKey.current === key;
        if (!isLastPressedKey) return;
        var isNumberKey = !isNaN(Number(key));
        if (!isNumberKey) return;
        var max = input.getAttribute('max');
        if (!max) return;
        var value = input.value;
        /**
         * Given 1, the smallest possible number the user could type by adding another digit is 10.
         * 10 would be a valid value given max = 12, so we won't jump to the next input.
         * However, given 2, smallers possible number would be 20, and thus keeping the focus in
         * this field doesn't make sense.
         */ if (Number(value) * 10 > Number(max) || value.length >= max.length) {
            var property = 'nextElementSibling';
            var nextInput = $a947434757992386$var$findInput(input, property);
            $a947434757992386$var$focus(nextInput);
        }
    }
    /**
     * Called after internal onChange. Checks input validity. If all fields are valid,
     * calls props.onChange.
     */ function onChangeExternal() {
        if (!onChangeProps) return;
        function filterBoolean(value) {
            return Boolean(value);
        }
        var formElements = [
            amPmInput.current,
            dayInput.current,
            monthInput.current,
            monthSelect.current,
            yearInput.current,
            hour12Input.current,
            hour24Input.current,
            minuteInput.current,
            secondInput.current
        ].filter(filterBoolean);
        var formElementsWithoutSelect = formElements.slice(1);
        var values = {};
        formElements.forEach(function(formElement) {
            values[formElement.name] = formElement.type === 'number' ? 'valueAsNumber' in formElement ? formElement.valueAsNumber : Number(formElement.value) : formElement.value;
        });
        var isEveryValueEmpty = formElementsWithoutSelect.every(function(formElement) {
            return !formElement.value;
        });
        if (isEveryValueEmpty) {
            onChangeProps(null, false);
            return;
        }
        var isEveryValueFilled = formElements.every(function(formElement) {
            return formElement.value;
        });
        var isEveryValueValid = formElements.every(function(formElement) {
            return formElement.validity.valid;
        });
        if (isEveryValueFilled && isEveryValueValid) {
            var year_1 = Number(values.year || new Date().getFullYear());
            var monthIndex = Number(values.month || 1) - 1;
            var day_1 = Number(values.day || 1);
            var hour_1 = Number(values.hour24 || values.hour12 && values.amPm && (0, $6e3cf8db165558f8$export$e40e59a57ec762e4)(values.hour12, values.amPm) || 0);
            var minute_1 = Number(values.minute || 0);
            var second_1 = Number(values.second || 0);
            var proposedValue = new Date();
            proposedValue.setFullYear(year_1, monthIndex, day_1);
            proposedValue.setHours(hour_1, minute_1, second_1, 0);
            onChangeProps(proposedValue, false);
            return;
        }
        if (!onInvalidChange) return;
        onInvalidChange();
    }
    /**
     * Called when non-native date input is changed.
     */ function onChange(event) {
        var _a = event.target, name = _a.name, value = _a.value;
        switch(name){
            case 'amPm':
                setAmPm(value);
                break;
            case 'year':
                setYear(value);
                break;
            case 'month':
                setMonth(value);
                break;
            case 'day':
                setDay(value);
                break;
            case 'hour12':
                setHour(value ? (0, $6e3cf8db165558f8$export$e40e59a57ec762e4)(value, amPm || 'am').toString() : '');
                break;
            case 'hour24':
                setHour(value);
                break;
            case 'minute':
                setMinute(value);
                break;
            case 'second':
                setSecond(value);
                break;
        }
        onChangeExternal();
    }
    /**
     * Called when native date input is changed.
     */ function onChangeNative(event) {
        var value = event.target.value;
        if (!onChangeProps) return;
        var processedValue = function() {
            if (!value) return null;
            var _a = value.split('T'), valueDate = _a[0], valueTime = _a[1];
            var _b = valueDate.split('-'), yearString = _b[0], monthString = _b[1], dayString = _b[2];
            var year = Number(yearString);
            var monthIndex = Number(monthString) - 1 || 0;
            var day = Number(dayString) || 1;
            var _c = valueTime.split(':'), hourString = _c[0], minuteString = _c[1], secondString = _c[2];
            var hour = Number(hourString) || 0;
            var minute = Number(minuteString) || 0;
            var second = Number(secondString) || 0;
            var proposedValue = new Date();
            proposedValue.setFullYear(year, monthIndex, day);
            proposedValue.setHours(hour, minute, second, 0);
            return proposedValue;
        }();
        onChangeProps(processedValue, false);
    }
    var commonInputProps = {
        className: className,
        disabled: disabled,
        maxDate: maxDate || $a947434757992386$var$defaultMaxDate,
        minDate: minDate || $a947434757992386$var$defaultMinDate,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        // This is only for showing validity when editing
        required: Boolean(required || isWidgetOpen)
    };
    var commonTimeInputProps = {
        maxTime: maxTime,
        minTime: minTime
    };
    function renderDay(currentMatch, index) {
        if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
        var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $841141269e7dd588$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "day"
        }, commonInputProps, {
            ariaLabel: dayAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: dayInput,
            month: month,
            placeholder: dayPlaceholder,
            showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
            value: day,
            year: year
        }));
    }
    function renderMonth(currentMatch, index) {
        if (currentMatch && currentMatch.length > 4) throw new Error("Unsupported token: ".concat(currentMatch));
        if (currentMatch.length > 2) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ca842f2c59ca8ec0$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "month"
        }, commonInputProps, {
            ariaLabel: monthAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: monthSelect,
            locale: locale,
            placeholder: monthPlaceholder,
            short: currentMatch.length === 3,
            value: month,
            year: year
        }));
        var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ce62ddaee3b3c27$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "month"
        }, commonInputProps, {
            ariaLabel: monthAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: monthInput,
            placeholder: monthPlaceholder,
            showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
            value: month,
            year: year
        }));
    }
    function renderYear(currentMatch, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6073540acba1d78e$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "year"
        }, commonInputProps, {
            ariaLabel: yearAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: yearInput,
            placeholder: yearPlaceholder,
            value: year,
            valueType: "day"
        }));
    }
    function renderHour12(currentMatch, index) {
        if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
        var showLeadingZeros = currentMatch ? currentMatch.length === 2 : false;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4ba9182fb2008c90$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "hour12"
        }, commonInputProps, commonTimeInputProps, {
            amPm: amPm,
            ariaLabel: hourAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: hour12Input,
            placeholder: hourPlaceholder,
            showLeadingZeros: showLeadingZeros,
            value: hour
        }));
    }
    function renderHour24(currentMatch, index) {
        if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
        var showLeadingZeros = currentMatch ? currentMatch.length === 2 : false;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ccc9e54c87f9c3f$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "hour24"
        }, commonInputProps, commonTimeInputProps, {
            ariaLabel: hourAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: hour24Input,
            placeholder: hourPlaceholder,
            showLeadingZeros: showLeadingZeros,
            value: hour
        }));
    }
    function renderHour(currentMatch, index) {
        if (/h/.test(currentMatch)) return renderHour12(currentMatch, index);
        return renderHour24(currentMatch, index);
    }
    function renderMinute(currentMatch, index) {
        if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
        var showLeadingZeros = currentMatch ? currentMatch.length === 2 : false;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $200246a6b0e25505$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "minute"
        }, commonInputProps, commonTimeInputProps, {
            ariaLabel: minuteAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            hour: hour,
            inputRef: minuteInput,
            placeholder: minutePlaceholder,
            showLeadingZeros: showLeadingZeros,
            value: minute
        }));
    }
    function renderSecond(currentMatch, index) {
        if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
        var showLeadingZeros = currentMatch ? currentMatch.length === 2 : true;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $043a7e7bf24b83d6$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "second"
        }, commonInputProps, commonTimeInputProps, {
            ariaLabel: secondAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            hour: hour,
            inputRef: secondInput,
            minute: minute,
            placeholder: secondPlaceholder,
            showLeadingZeros: showLeadingZeros,
            value: second
        }));
    }
    function renderAmPm(currentMatch, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cb136e7037b8eb70$export$2e2bcd8739ae039), $a947434757992386$var$__assign({
            key: "ampm"
        }, commonInputProps, commonTimeInputProps, {
            ariaLabel: amPmAriaLabel,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: index === 0 && autoFocus,
            inputRef: amPmInput,
            locale: locale,
            onChange: onChange,
            value: amPm
        }));
    }
    function renderCustomInputsInternal() {
        var elementFunctions = {
            d: renderDay,
            M: renderMonth,
            y: renderYear,
            h: renderHour,
            H: renderHour,
            m: renderMinute,
            s: renderSecond,
            a: renderAmPm
        };
        var allowMultipleInstances = typeof format !== 'undefined';
        return $a947434757992386$var$renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances);
    }
    function renderNativeInput() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8e67f6db7f1cc193$export$2e2bcd8739ae039), {
            key: "datetime",
            ariaLabel: nativeInputAriaLabel,
            disabled: disabled,
            maxDate: maxDate || $a947434757992386$var$defaultMaxDate,
            minDate: minDate || $a947434757992386$var$defaultMinDate,
            name: name,
            onChange: onChangeNative,
            required: required,
            value: value,
            valueType: valueType
        });
    }
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        onClick: onClick
    }, renderNativeInput(), renderCustomInputsInternal()));
}



var $c9Z8w = parcelRequire("c9Z8w");
var $491feb45fc3fdf5f$export$283839a53860a2f5 = function isMinDate(props, propName, componentName) {
    var _a = props, _b = propName, minDate = _a[_b];
    if (!minDate) return null;
    if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate, "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var maxDate = props.maxDate;
    if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate, "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    return null;
};
var $491feb45fc3fdf5f$export$20075fd45e42d41c = function isMaxDate(props, propName, componentName) {
    var _a = props, _b = propName, maxDate = _a[_b];
    if (!maxDate) return null;
    if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof maxDate, "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    var minDate = props.minDate;
    if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof maxDate, "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    return null;
};
var $491feb45fc3fdf5f$export$382f6fb00c4220 = function(type) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf(type);
};


'use client';
var $eb3eff6b997222a6$var$__assign = undefined && undefined.__assign || function() {
    $eb3eff6b997222a6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eb3eff6b997222a6$var$__assign.apply(this, arguments);
};
var $eb3eff6b997222a6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $eb3eff6b997222a6$var$isBrowser = typeof document !== 'undefined';
var $eb3eff6b997222a6$var$baseClassName = 'react-datetimerange-picker';
var $eb3eff6b997222a6$var$outsideActionEvents = [
    'mousedown',
    'focusin',
    'touchstart'
];
var $eb3eff6b997222a6$var$allViews = [
    'hour',
    'minute',
    'second'
];
var $eb3eff6b997222a6$var$iconProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 19,
    height: 19,
    viewBox: '0 0 19 19',
    stroke: 'black',
    strokeWidth: 2
};
var $eb3eff6b997222a6$var$CalendarIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $eb3eff6b997222a6$var$__assign({}, $eb3eff6b997222a6$var$iconProps, {
    className: "".concat($eb3eff6b997222a6$var$baseClassName, "__calendar-button__icon ").concat($eb3eff6b997222a6$var$baseClassName, "__button__icon")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
    fill: "none",
    height: "15",
    width: "15",
    x: "2",
    y: "2"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    x1: "6",
    x2: "6",
    y1: "0",
    y2: "4"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    x1: "13",
    x2: "13",
    y1: "0",
    y2: "4"
}));
var $eb3eff6b997222a6$var$ClearIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $eb3eff6b997222a6$var$__assign({}, $eb3eff6b997222a6$var$iconProps, {
    className: "".concat($eb3eff6b997222a6$var$baseClassName, "__clear-button__icon ").concat($eb3eff6b997222a6$var$baseClassName, "__button__icon")
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    x1: "4",
    x2: "15",
    y1: "4",
    y2: "15"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
    x1: "15",
    x2: "4",
    y1: "4",
    y2: "15"
}));
var $eb3eff6b997222a6$var$DateTimeRangePicker = function DateTimeRangePicker(props) {
    var amPmAriaLabel = props.amPmAriaLabel, autoFocus = props.autoFocus, calendarAriaLabel = props.calendarAriaLabel, _a = props.calendarIcon, calendarIcon = _a === void 0 ? $eb3eff6b997222a6$var$CalendarIcon : _a, className = props.className, clearAriaLabel = props.clearAriaLabel, _b = props.clearIcon, clearIcon = _b === void 0 ? $eb3eff6b997222a6$var$ClearIcon : _b, _c = props.closeWidgets, shouldCloseWidgetsOnSelect = _c === void 0 ? true : _c, dataTestid = props["data-testid"], dayAriaLabel = props.dayAriaLabel, dayPlaceholder = props.dayPlaceholder, disableCalendar = props.disableCalendar, disableClock = props.disableClock, disabled = props.disabled, format = props.format, hourAriaLabel = props.hourAriaLabel, hourPlaceholder = props.hourPlaceholder, id = props.id, _d = props.isCalendarOpen, isCalendarOpenProps = _d === void 0 ? null : _d, _e = props.isClockOpen, isClockOpenProps = _e === void 0 ? null : _e, locale = props.locale, maxDate = props.maxDate, _f = props.maxDetail, maxDetail = _f === void 0 ? 'minute' : _f, minDate = props.minDate, minuteAriaLabel = props.minuteAriaLabel, minutePlaceholder = props.minutePlaceholder, monthAriaLabel = props.monthAriaLabel, monthPlaceholder = props.monthPlaceholder, _g = props.name, name = _g === void 0 ? 'datetimerange' : _g, nativeInputAriaLabel = props.nativeInputAriaLabel, onCalendarClose = props.onCalendarClose, onCalendarOpen = props.onCalendarOpen, onChangeProps = props.onChange, onClockClose = props.onClockClose, onClockOpen = props.onClockOpen, onFocusProps = props.onFocus, onInvalidChange = props.onInvalidChange, _h = props.openWidgetsOnFocus, openWidgetsOnFocus = _h === void 0 ? true : _h, _j = props.rangeDivider, rangeDivider = _j === void 0 ? "\u2013" : _j, required = props.required, secondAriaLabel = props.secondAriaLabel, secondPlaceholder = props.secondPlaceholder, shouldCloseWidgets = props.shouldCloseWidgets, shouldOpenWidgets = props.shouldOpenWidgets, showLeadingZeros = props.showLeadingZeros, value = props.value, yearAriaLabel = props.yearAriaLabel, yearPlaceholder = props.yearPlaceholder, otherProps = $eb3eff6b997222a6$var$__rest(props, [
        "amPmAriaLabel",
        "autoFocus",
        "calendarAriaLabel",
        "calendarIcon",
        "className",
        "clearAriaLabel",
        "clearIcon",
        "closeWidgets",
        'data-testid',
        "dayAriaLabel",
        "dayPlaceholder",
        "disableCalendar",
        "disableClock",
        "disabled",
        "format",
        "hourAriaLabel",
        "hourPlaceholder",
        "id",
        "isCalendarOpen",
        "isClockOpen",
        "locale",
        "maxDate",
        "maxDetail",
        "minDate",
        "minuteAriaLabel",
        "minutePlaceholder",
        "monthAriaLabel",
        "monthPlaceholder",
        "name",
        "nativeInputAriaLabel",
        "onCalendarClose",
        "onCalendarOpen",
        "onChange",
        "onClockClose",
        "onClockOpen",
        "onFocus",
        "onInvalidChange",
        "openWidgetsOnFocus",
        "rangeDivider",
        "required",
        "secondAriaLabel",
        "secondPlaceholder",
        "shouldCloseWidgets",
        "shouldOpenWidgets",
        "showLeadingZeros",
        "value",
        "yearAriaLabel",
        "yearPlaceholder"
    ]);
    var _k = (0, $acw62.useState)(isCalendarOpenProps), isCalendarOpen = _k[0], setIsCalendarOpen = _k[1];
    var _l = (0, $acw62.useState)(isClockOpenProps), isClockOpen = _l[0], setIsClockOpen = _l[1];
    var wrapper = (0, $acw62.useRef)(null);
    var calendarWrapper = (0, $acw62.useRef)(null);
    var clockWrapper = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        setIsCalendarOpen(isCalendarOpenProps);
    }, [
        isCalendarOpenProps
    ]);
    (0, $acw62.useEffect)(function() {
        setIsClockOpen(isClockOpenProps);
    }, [
        isClockOpenProps
    ]);
    function openCalendar(_a) {
        var reason = _a.reason;
        if (shouldOpenWidgets) {
            if (!shouldOpenWidgets({
                reason: reason,
                widget: 'calendar'
            })) return;
        }
        setIsClockOpen(isClockOpen ? false : isCalendarOpen);
        setIsCalendarOpen(true);
        if (onCalendarOpen) onCalendarOpen();
    }
    var closeCalendar = (0, $acw62.useCallback)(function(_a) {
        var reason = _a.reason;
        if (shouldCloseWidgets) {
            if (!shouldCloseWidgets({
                reason: reason,
                widget: 'calendar'
            })) return;
        }
        setIsCalendarOpen(false);
        if (onCalendarClose) onCalendarClose();
    }, [
        onCalendarClose,
        shouldCloseWidgets
    ]);
    function toggleCalendar() {
        if (isCalendarOpen) closeCalendar({
            reason: 'buttonClick'
        });
        else openCalendar({
            reason: 'buttonClick'
        });
    }
    function openClock(_a) {
        var reason = _a.reason;
        if (shouldOpenWidgets) {
            if (!shouldOpenWidgets({
                reason: reason,
                widget: 'clock'
            })) return;
        }
        setIsCalendarOpen(isCalendarOpen ? false : isCalendarOpen);
        setIsClockOpen(true);
        if (onClockOpen) onClockOpen();
    }
    var closeClock = (0, $acw62.useCallback)(function(_a) {
        var reason = _a.reason;
        if (shouldCloseWidgets) {
            if (!shouldCloseWidgets({
                reason: reason,
                widget: 'clock'
            })) return;
        }
        setIsClockOpen(false);
        if (onClockClose) onClockClose();
    }, [
        onClockClose,
        shouldCloseWidgets
    ]);
    var closeWidgets = (0, $acw62.useCallback)(function(_a) {
        var reason = _a.reason;
        closeCalendar({
            reason: reason
        });
        closeClock({
            reason: reason
        });
    }, [
        closeCalendar,
        closeClock
    ]);
    function onChange(value, shouldCloseWidgets) {
        if (shouldCloseWidgets === void 0) shouldCloseWidgets = shouldCloseWidgetsOnSelect;
        if (shouldCloseWidgets) closeWidgets({
            reason: 'select'
        });
        if (onChangeProps) onChangeProps(value);
    }
    function onChangeFrom(valueFrom, closeCalendar) {
        var _a = Array.isArray(value) ? value : [
            value
        ], valueTo = _a[1];
        var valueToDate = valueTo ? new Date(valueTo) : null;
        onChange([
            valueFrom,
            valueToDate
        ], closeCalendar);
    }
    function onChangeTo(valueTo, closeCalendar) {
        var valueFrom = (Array.isArray(value) ? value : [
            value
        ])[0];
        var valueFromDate = valueFrom ? new Date(valueFrom) : null;
        onChange([
            valueFromDate,
            valueTo
        ], closeCalendar);
    }
    function onDateChange(nextValue, shouldCloseWidgets) {
        // React-Calendar passes an array of values when selectRange is enabled
        var _a = Array.isArray(nextValue) ? nextValue : [
            nextValue
        ], rawNextValueFrom = _a[0], rawNextValueTo = _a[1];
        var _b = Array.isArray(value) ? value : [
            value
        ], valueFrom = _b[0], valueTo = _b[1];
        var nextValueFrom = function() {
            if (!valueFrom || !rawNextValueFrom) return rawNextValueFrom;
            var valueFromDate = new Date(valueFrom);
            var nextValueFromWithHour = new Date(rawNextValueFrom);
            nextValueFromWithHour.setHours(valueFromDate.getHours(), valueFromDate.getMinutes(), valueFromDate.getSeconds(), valueFromDate.getMilliseconds());
            return nextValueFromWithHour;
        }();
        var nextValueTo = function() {
            if (!valueTo || !rawNextValueTo) return rawNextValueTo;
            var valueToDate = new Date(valueTo);
            var nextValueToWithHour = new Date(rawNextValueTo);
            nextValueToWithHour.setHours(valueToDate.getHours(), valueToDate.getMinutes(), valueToDate.getSeconds(), valueToDate.getMilliseconds());
            return nextValueToWithHour;
        }();
        onChange([
            nextValueFrom || null,
            nextValueTo || null
        ], shouldCloseWidgets);
    }
    function onFocus(event) {
        if (onFocusProps) onFocusProps(event);
        if (// Internet Explorer still fires onFocus on disabled elements
        disabled || !openWidgetsOnFocus || event.target.dataset.select === 'true') return;
        switch(event.target.name){
            case 'day':
            case 'month':
            case 'year':
                if (isCalendarOpen) return;
                openCalendar({
                    reason: 'focus'
                });
                break;
            case 'hour12':
            case 'hour24':
            case 'minute':
            case 'second':
                if (isClockOpen) return;
                openClock({
                    reason: 'focus'
                });
                break;
            default:
        }
    }
    var onKeyDown = (0, $acw62.useCallback)(function(event) {
        if (event.key === 'Escape') closeWidgets({
            reason: 'escape'
        });
    }, [
        closeWidgets
    ]);
    function clear() {
        onChange(null);
    }
    function stopPropagation(event) {
        event.stopPropagation();
    }
    var onOutsideAction = (0, $acw62.useCallback)(function(event) {
        var wrapperEl = wrapper.current;
        var calendarWrapperEl = calendarWrapper.current;
        var clockWrapperEl = clockWrapper.current;
        // Try event.composedPath first to handle clicks inside a Shadow DOM.
        var target = 'composedPath' in event ? event.composedPath()[0] : event.target;
        if (target && wrapperEl && !wrapperEl.contains(target) && (!calendarWrapperEl || !calendarWrapperEl.contains(target)) && (!clockWrapperEl || !clockWrapperEl.contains(target))) closeWidgets({
            reason: 'outsideAction'
        });
    }, [
        calendarWrapper,
        clockWrapper,
        closeWidgets,
        wrapper
    ]);
    var handleOutsideActionListeners = (0, $acw62.useCallback)(function(shouldListen) {
        if (shouldListen === void 0) shouldListen = isCalendarOpen || isClockOpen;
        $eb3eff6b997222a6$var$outsideActionEvents.forEach(function(event) {
            if (shouldListen) document.addEventListener(event, onOutsideAction);
            else document.removeEventListener(event, onOutsideAction);
        });
        if (shouldListen) document.addEventListener('keydown', onKeyDown);
        else document.removeEventListener('keydown', onKeyDown);
    }, [
        isCalendarOpen,
        isClockOpen,
        onOutsideAction,
        onKeyDown
    ]);
    (0, $acw62.useEffect)(function() {
        handleOutsideActionListeners();
        return function() {
            handleOutsideActionListeners(false);
        };
    }, [
        handleOutsideActionListeners
    ]);
    function renderInputs() {
        var _a = Array.isArray(value) ? value : [
            value
        ], valueFrom = _a[0], valueTo = _a[1];
        var ariaLabelProps = {
            amPmAriaLabel: amPmAriaLabel,
            dayAriaLabel: dayAriaLabel,
            hourAriaLabel: hourAriaLabel,
            minuteAriaLabel: minuteAriaLabel,
            monthAriaLabel: monthAriaLabel,
            nativeInputAriaLabel: nativeInputAriaLabel,
            secondAriaLabel: secondAriaLabel,
            yearAriaLabel: yearAriaLabel
        };
        var placeholderProps = {
            dayPlaceholder: dayPlaceholder,
            hourPlaceholder: hourPlaceholder,
            minutePlaceholder: minutePlaceholder,
            monthPlaceholder: monthPlaceholder,
            secondPlaceholder: secondPlaceholder,
            yearPlaceholder: yearPlaceholder
        };
        var commonProps = $eb3eff6b997222a6$var$__assign($eb3eff6b997222a6$var$__assign($eb3eff6b997222a6$var$__assign({}, ariaLabelProps), placeholderProps), {
            className: "".concat($eb3eff6b997222a6$var$baseClassName, "__inputGroup"),
            disabled: disabled,
            format: format,
            isWidgetOpen: isCalendarOpen || isClockOpen,
            locale: locale,
            maxDate: maxDate,
            maxDetail: maxDetail,
            minDate: minDate,
            onInvalidChange: onInvalidChange,
            required: required,
            showLeadingZeros: showLeadingZeros
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "".concat($eb3eff6b997222a6$var$baseClassName, "__wrapper")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a947434757992386$export$2e2bcd8739ae039), $eb3eff6b997222a6$var$__assign({}, commonProps, {
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: autoFocus,
            name: "".concat(name, "_from"),
            onChange: onChangeFrom,
            value: valueFrom
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat($eb3eff6b997222a6$var$baseClassName, "__range-divider")
        }, rangeDivider), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a947434757992386$export$2e2bcd8739ae039), $eb3eff6b997222a6$var$__assign({}, commonProps, {
            name: "".concat(name, "_to"),
            onChange: onChangeTo,
            value: valueTo
        })), clearIcon !== null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "aria-label": clearAriaLabel,
            className: "".concat($eb3eff6b997222a6$var$baseClassName, "__clear-button ").concat($eb3eff6b997222a6$var$baseClassName, "__button"),
            disabled: disabled,
            onClick: clear,
            onFocus: stopPropagation,
            type: "button"
        }, typeof clearIcon === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(clearIcon) : clearIcon), calendarIcon !== null && !disableCalendar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            "aria-label": calendarAriaLabel,
            className: "".concat($eb3eff6b997222a6$var$baseClassName, "__calendar-button ").concat($eb3eff6b997222a6$var$baseClassName, "__button"),
            disabled: disabled,
            onClick: toggleCalendar,
            onFocus: stopPropagation,
            type: "button"
        }, typeof calendarIcon === 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(calendarIcon) : calendarIcon));
    }
    function renderCalendar() {
        if (isCalendarOpen === null || disableCalendar) return null;
        var calendarClassName = props.calendarClassName, dateTimeRangePickerClassName = props.className, dateTimeRangePickerMaxDetail = props.maxDetail, onChangeProps = props.onChange, portalContainer = props.portalContainer, value = props.value, calendarProps = $eb3eff6b997222a6$var$__rest(props, [
            "calendarClassName",
            "className",
            "maxDetail",
            "onChange",
            "portalContainer",
            "value"
        ]);
        var className = "".concat($eb3eff6b997222a6$var$baseClassName, "__calendar");
        var classNames = (0, $bfccead57fba6d8c$export$2e2bcd8739ae039)(className, "".concat(className, "--").concat(isCalendarOpen ? 'open' : 'closed'));
        var calendar = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5304fe6d5e1a96df$export$2e2bcd8739ae039), $eb3eff6b997222a6$var$__assign({
            className: calendarClassName,
            onChange: function(value) {
                return onDateChange(value);
            },
            selectRange: true,
            value: value
        }, calendarProps));
        return portalContainer ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: calendarWrapper,
            className: classNames
        }, calendar), portalContainer) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d44b999b4c4c57d$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: function(ref) {
                if (ref && !isCalendarOpen) ref.removeAttribute('style');
            },
            className: classNames
        }, calendar));
    }
    function renderClock() {
        if (isClockOpen === null || disableClock) return null;
        var clockClassName = props.clockClassName, dateTimePickerClassName = props.className, _a = props.maxDetail, maxDetail = _a === void 0 ? 'minute' : _a, onChange = props.onChange, portalContainer = props.portalContainer, value = props.value, clockProps = $eb3eff6b997222a6$var$__rest(props, [
            "clockClassName",
            "className",
            "maxDetail",
            "onChange",
            "portalContainer",
            "value"
        ]);
        var className = "".concat($eb3eff6b997222a6$var$baseClassName, "__clock");
        var classNames = (0, $bfccead57fba6d8c$export$2e2bcd8739ae039)(className, "".concat(className, "--").concat(isClockOpen ? 'open' : 'closed'));
        var valueFrom = (Array.isArray(value) ? value : [
            value
        ])[0];
        var maxDetailIndex = $eb3eff6b997222a6$var$allViews.indexOf(maxDetail);
        var clock = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1ea2f3c788d1690a$export$2e2bcd8739ae039), $eb3eff6b997222a6$var$__assign({
            className: clockClassName,
            renderMinuteHand: maxDetailIndex > 0,
            renderSecondHand: maxDetailIndex > 1,
            value: valueFrom
        }, clockProps));
        return portalContainer ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: clockWrapper,
            className: classNames
        }, clock), portalContainer) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4d44b999b4c4c57d$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: function(ref) {
                if (ref && !isClockOpen) ref.removeAttribute('style');
            },
            className: classNames
        }, clock));
    }
    var eventProps = (0, $acw62.useMemo)(function() {
        return (0, $92515163af4739b4$export$2e2bcd8739ae039)(otherProps);
    }, [
        otherProps
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $eb3eff6b997222a6$var$__assign({
        className: (0, $bfccead57fba6d8c$export$2e2bcd8739ae039)($eb3eff6b997222a6$var$baseClassName, "".concat($eb3eff6b997222a6$var$baseClassName, "--").concat(isCalendarOpen || isClockOpen ? 'open' : 'closed'), "".concat($eb3eff6b997222a6$var$baseClassName, "--").concat(disabled ? 'disabled' : 'enabled'), className),
        "data-testid": dataTestid,
        id: id
    }, eventProps, {
        onFocus: onFocus,
        ref: wrapper
    }), renderInputs(), renderCalendar(), renderClock());
};
var $eb3eff6b997222a6$var$isValue = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(Date)
]);
var $eb3eff6b997222a6$var$isValueOrValueArray = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    $eb3eff6b997222a6$var$isValue,
    (0, $491feb45fc3fdf5f$export$382f6fb00c4220)($eb3eff6b997222a6$var$isValue)
]);
$eb3eff6b997222a6$var$DateTimeRangePicker.propTypes = {
    amPmAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    calendarAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    calendarClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    calendarIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    clearAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    clearIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    clockClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    closeWidgets: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    'data-testid': (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dayAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dayPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    disableCalendar: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disableClock: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hourAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hourPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isCalendarOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isClockOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxDate: (0, $491feb45fc3fdf5f$export$20075fd45e42d41c),
    maxDetail: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf($eb3eff6b997222a6$var$allViews),
    minDate: (0, $491feb45fc3fdf5f$export$283839a53860a2f5),
    minuteAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    minutePlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    monthAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    monthPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    nativeInputAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onCalendarClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onCalendarOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClockClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClockOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    openWidgetsOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    rangeDivider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    secondAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    secondPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    showLeadingZeros: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    value: $eb3eff6b997222a6$var$isValueOrValueArray,
    yearAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yearPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
if ($eb3eff6b997222a6$var$isBrowser) $eb3eff6b997222a6$var$DateTimeRangePicker.propTypes.portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(HTMLElement);
var $eb3eff6b997222a6$export$2e2bcd8739ae039 = $eb3eff6b997222a6$var$DateTimeRangePicker;


var $470aadd605532c5a$export$2e2bcd8739ae039 = (0, $eb3eff6b997222a6$export$2e2bcd8739ae039);




function $55e1f74d050ef4ae$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($55e1f74d050ef4ae$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $470aadd605532c5a$export$2e2bcd8739ae039), {
            clearIcon: false,
            maxDate: new Date(),
            maxDetail: "second",
            rangeDivider: "to",
            disableClock: true,
            calendarIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($789b80ef9a3da2f3$exports))), {
                color: "action"
            }),
            ...props
        })
    });
}
const $55e1f74d050ef4ae$var$Root = (0, $lmFrL.default).div`
  white-space: nowrap;

  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  select {
    -webkit-appearance: none;
  }

  .react-calendar__tile--now {
    background: #f2f2f2;
  }

  [class*=-picker__calendar--open] {
    left: 50px !important;
    z-index: 5000;
    box-shadow: 0px -1px 10px 1px rgba(0,0,0,.2);
    border: none;
  }

  [class*=-picker__wrapper] {
    border: 1px solid #c4c4c4;
    border-radius: 5px;
    margin: 0 10px 0 10px;
  }

  [class*=-picker__wrapper]:hover {
    border-color: #212121;
  }

  [class*=-picker__range-divider] {
    margin: 0 10px;
  }
  [class*=-picker__calendar-button] {
    padding: 1px 2px 2px 2px;
  }

  .react-calendar__tile--range {
    background: #006edc;
    color: #f2f2f2;
    font-weight: bold;
  }

  .react-calendar__tile--rangeStart {
    border-radius: 50px 0 0 50px;
  }

  .react-calendar__tile--rangeEnd {
    border-radius: 0 50px 50px 0;
  }

  .react-calendar__tile--rangeBothEnds {
    border-radius: 50px;
  }

  .react-calendar__tile--active {
    color: #fff;
    background: #3789dc;
  }

  [class*=react-calendar__navigation],
  .react-calendar abbr {
    font-weight: 600;
  }
`;



var $lffEs = parcelRequire("lffEs");


var $d8seH = parcelRequire("d8seH");
const $bbfb475904626785$var$TimeOpts = (0, $d8seH.default)('div')`
  display: flex;

  .MuiInputBase-root,
  .MuiButtonBase-root {
    height: 29px;
    border-radius: 5px;
  }

  .MuiButtonBase-root,
  .react-datetimerange-picker__wrapper {
    min-width: 30px;
    border-color: ${({ theme: theme })=>theme.palette.mode == 'dark' ? theme.palette.grey[700] : theme.palette.grey[400]} !important;
  }

  .MuiButtonBase-root:hover,
  .react-datetimerange-picker__wrapper:hover {
    border-color: ${({ theme: theme })=>theme.palette.mode == 'dark' ? theme.palette.grey[100] : theme.palette.text.primary} !important;
  }

  .MuiCircularProgress-root {
    position: absolute
  }
`;
var $bbfb475904626785$export$2e2bcd8739ae039 = $bbfb475904626785$var$TimeOpts;


function $39d20adadcde0807$export$2e2bcd8739ae039(props) {
    const { opts: opts, groupByToggle: groupByToggle = false, condensed: condensed = false, aggregation: aggregation = false, hideQuickRanges: hideQuickRanges = false, quickRanges: quickRanges = [
        '-1y',
        '-90d',
        '-30d',
        '-7d',
        '-2d'
    ], showAll: showAll, onChange: // showViewType, // curently unused
    onChange, onDateChange: onDateChange } = props;
    const { loading: loading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [calClosed, setCalClosed] = (0, $acw62.useState)(true);
    const [pendingRange, setPendingRange] = (0, $acw62.useState)();
    const update = (0, $acw62.useCallback)(()=>{
        onDateChange(pendingRange);
        setPendingRange(null);
        onChange('window', null);
    }, [
        pendingRange,
        onDateChange,
        onChange
    ]);
    // regular submit
    const handleSubmit = (0, $acw62.useCallback)(()=>{
        if (pendingRange) update();
        else {
            // reset
            onChange('time', 'hourly');
            onChange('window', '-7d');
        }
    }, [
        pendingRange,
        update,
        onChange
    ]);
    // a workaround for updating ranges whenever there
    // was a change AND when the cal is closed (or when 'enter' is pressed)
    (0, $acw62.useEffect)(()=>{
        if (pendingRange && calClosed) update();
    }, [
        pendingRange,
        calClosed,
        update
    ]);
    (0, $acw62.useEffect)(()=>{
        const onKeyDown = (e)=>e.key === 'Enter' && handleSubmit();
        document.addEventListener('keydown', onKeyDown);
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [
        handleSubmit
    ]);
    const handleDatePickerChange = ([start, end])=>{
        setPendingRange([
            start,
            end
        ]);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($39d20adadcde0807$var$Root, {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-grow gap",
                children: [
                    groupByToggle && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            !condensed && /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "subtitle no-margin muted",
                                children: "Group by"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                                value: opts.display,
                                onChange: (evt, val)=>onChange(val),
                                "aria-label": "group by",
                                exclusive: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "nodes",
                                        "aria-label": "nodes",
                                        children: "Nodes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "apps",
                                        "aria-label": "apps",
                                        children: "Apps"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            opts.colorType && !condensed && /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "subtitle no-margin muted",
                                children: "Color type"
                            }),
                            opts.colorType && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                                value: opts.colorType,
                                onChange: (_evt, val)=>onChange('colorType', val),
                                "aria-label": "type of coloring: number of records (density) or availability",
                                exclusive: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "density",
                                        "aria-label": "density",
                                        children: "Density"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "availability",
                                        "aria-label": "availability",
                                        children: "Availability"
                                    })
                                ]
                            })
                        ]
                    }),
                    aggregation && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            !condensed && /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                className: "subtitle no-margin muted",
                                children: "Aggregation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                                value: opts.time,
                                onChange: (_evt, val)=>onChange('time', val),
                                "aria-label": "change time (windows)",
                                exclusive: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "hourly",
                                        "aria-label": "hourly",
                                        children: "Hourly"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "daily",
                                        "aria-label": "daily",
                                        children: "Daily"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    !hideQuickRanges && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                            value: opts.window,
                            onChange: (_evt, val)=>onChange('window', val),
                            "aria-label": "change last x days",
                            exclusive: true,
                            children: [
                                showAll && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                    value: "showAll",
                                    "aria-label": "show all, daily by default",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($39d20adadcde0807$var$InfIcon, {
                                            children: "-\u221E"
                                        }),
                                        " ",
                                        opts.time == 'hourly' && opts.window != 'showAll' ? ` (daily)` : ''
                                    ]
                                }),
                                quickRanges.map((v)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: v,
                                        "aria-label": (0, $lffEs.quickRanges)[v],
                                        children: v
                                    }, v);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex"
                    }),
                    onDateChange && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bbfb475904626785$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55e1f74d050ef4ae$export$2e2bcd8739ae039), {
                                value: pendingRange || [
                                    opts.start,
                                    opts.end
                                ],
                                onChange: handleDatePickerChange,
                                onCalendarClose: ()=>setCalClosed(true),
                                onCalendarOpen: ()=>setCalClosed(false),
                                maxDetail: "hour"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: loading ? 'Cancel' : pendingRange ? 'Submit' : 'Refresh',
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    variant: pendingRange ? 'contained' : 'outlined',
                                    color: pendingRange ? 'success' : 'info',
                                    type: "submit",
                                    onClick: handleSubmit,
                                    children: loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                size: 25
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04c3fb0d25ae3dfa$export$2e2bcd8739ae039), {
                                                color: "action"
                                            })
                                        ]
                                    }) : pendingRange ? 'Go' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a180a55535de9e53$export$2e2bcd8739ae039), {
                                        color: "action",
                                        sx: pendingRange && {
                                            color: '#f2f2f2'
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $39d20adadcde0807$var$Root = (0, $d8seH.default)('div')`
  [role=group] {
    margin-right: 10px;
  }

  .MuiToggleButtonGroup-root {
    height: 27px;
  }
`;
const $39d20adadcde0807$var$InfIcon = (0, $d8seH.default)('div')`
  font-size: 1.1em;
  padding-bottom: 1px;
`;




var $f1q41 = parcelRequire("f1q41");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");

var $6lXkL = parcelRequire("6lXkL");
var $39562499e45c6466$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $39562499e45c6466$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($39562499e45c6466$exports, "__esModule", {
    value: true
});
$39562499e45c6466$exports.default = void 0;

var $39562499e45c6466$var$_createSvgIcon = $39562499e45c6466$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $39562499e45c6466$var$_default = $39562499e45c6466$exports.default = (0, $39562499e45c6466$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 9H15V4c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H7.41c-.89 0-1.34 1.08-.71 1.71l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.63-.63.19-1.71-.7-1.71M5 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1"
}), 'FileDownloadRounded');




var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $9Lykx = parcelRequire("9Lykx");

var $2esSG = parcelRequire("2esSG");

var $iAtns = parcelRequire("iAtns");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ee94d57d97760d6e$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'SearchOutlined');



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $e11645b86426ecc0$export$2e2bcd8739ae039(text, query) {
    if (!text) return '';
    // Escape special regex characters in the query
    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const parts = String(text).split(new RegExp(`(${escapedQuery})`, 'gi'));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: parts.map((part, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                style: part.toLowerCase() === query.toLowerCase() ? {
                    fontWeight: '800',
                    color: '#2684ff'
                } : {},
                children: part
            }, i))
    });
}



var $5xexf = parcelRequire("5xexf");
// number of rows shown by default for each facet
const $b478a515f6547033$var$DEFAULT_SHOWN = 10;
const $b478a515f6547033$var$sortOptions = (options, checked)=>[
        ...options.filter((obj)=>checked.includes(obj.name)),
        ...options.filter((obj)=>!checked.includes(obj.name)).sort((a, b)=>b.count - a.count)
    ];
function $b478a515f6547033$export$2e2bcd8739ae039(props) {
    const { title: title, hideSearchIcon: hideSearchIcon, hideSelectAll: hideSelectAll, defaultShown: defaultShown, showSearchBox: showSearchBox = false, onCheck: onCheck, onSelectAll: onSelectAll } = props;
    const [allData, setAllData] = (0, $acw62.useState)(props.data);
    const [data, setData] = (0, $acw62.useState)([]) // filtered data
    ;
    const [checked, setChecked] = (0, $acw62.useState)(props.checked);
    const [showAll, setShowAll] = (0, $acw62.useState)(false);
    const [showSearch, setShowSearch] = (0, $acw62.useState)(showSearchBox);
    const [selectAll, setSelectAll] = (0, $acw62.useState)(false);
    const [showUndo, setShowUndo] = (0, $acw62.useState)(false);
    // query in search field
    const [query, setQuery] = (0, $acw62.useState)('');
    const shownCount = defaultShown || $b478a515f6547033$var$DEFAULT_SHOWN;
    // update facets
    (0, $acw62.useEffect)(()=>{
        setAllData(props.data);
    }, [
        props.data
    ]);
    // update checked facets
    (0, $acw62.useEffect)(()=>{
        setChecked(props.checked);
    }, [
        props.checked
    ]);
    // effect for filtering data (currently client-side)
    (0, $acw62.useEffect)(()=>{
        if (!allData) return;
        const filteredData = allData.filter((obj)=>(obj.displayName || obj.name)?.toLowerCase().includes(query.toLowerCase()));
        // sort checked to the top, and sort rest
        setData($b478a515f6547033$var$sortOptions(filteredData, checked));
        // watch checked for indeterminate state
        const l = checked.length;
        if (l > 0 && l < allData.length) {
            setShowUndo(true);
            setSelectAll(false);
        } else if (l == 0) {
            setShowUndo(false);
            setSelectAll(false);
        } else if (l == allData.length) setSelectAll(true);
    }, [
        query,
        allData,
        checked
    ]);
    const handleCheck = (evt, value)=>{
        onCheck(evt, value);
    };
    const handleShowAll = ()=>{
        setShowAll(!showAll);
    };
    const handleSelectAll = (evt)=>{
        onSelectAll(evt, props.data.map((o)=>o.name));
    };
    // const onSubmitRange = (evt) => {
    //   evt.preventDefault()
    //
    // only render if there's actually facet data
    if (!props.data) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b478a515f6547033$var$FilterRoot, {
        children: allData && allData.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($b478a515f6547033$var$Header, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($b478a515f6547033$var$Title, {
                            children: [
                                !hideSelectAll && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                    checked: selectAll,
                                    onChange: (evt)=>handleSelectAll(evt),
                                    indeterminate: showUndo && !selectAll
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    style: hideSelectAll ? {
                                        marginLeft: 34
                                    } : {},
                                    children: title
                                })
                            ]
                        }),
                        !hideSearchIcon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>setShowSearch(!showSearch),
                            size: "small",
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee94d57d97760d6e$export$2e2bcd8739ae039), {})
                        })
                    ]
                }),
                showSearch && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        margin: '5px 0 5px 10px'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                        autoFocus: true,
                        placeholder: `Filter ${title}`,
                        onChange: (evt)=>setQuery(evt.target.value),
                        fullWidth: true,
                        variant: "outlined",
                        slotProps: {
                            input: {
                                style: {
                                    height: 26
                                }
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($b478a515f6547033$var$Filters, {
                    children: [
                        data.slice(0, showAll ? data.length : shownCount).map(({ name: name, displayName: displayName, count: count, icon: icon })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($b478a515f6547033$var$CBContainer, {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                        name: name,
                                        checked: checked.includes(name),
                                        onChange: (evt)=>handleCheck(evt, name)
                                    }),
                                    label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($b478a515f6547033$var$FacetLabel, {
                                                children: [
                                                    (0, $e11645b86426ecc0$export$2e2bcd8739ae039)(displayName || name, query),
                                                    icon
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($b478a515f6547033$var$Count, {
                                                children: count && count.toLocaleString()
                                            })
                                        ]
                                    })
                                })
                            }, name)),
                        data.length == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($b478a515f6547033$var$NoneFound, {
                            className: "muted",
                            children: "none found"
                        })
                    ]
                }),
                allData && data.length > shownCount && /*#__PURE__*/ (0, $ayMG0.jsxs)($b478a515f6547033$var$MoreBtn, {
                    onClick: handleShowAll,
                    children: [
                        !showAll && `${data.length - shownCount} more\u{2026}`,
                        showAll && "less\u2026"
                    ]
                })
            ]
        })
    });
}
const $b478a515f6547033$var$FilterRoot = (0, $d8seH.default)('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  padding: 0 5px;
`;
const $b478a515f6547033$var$Header = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props)=>props.theme.palette.divider};
  margin: 5px 0;
  padding-bottom: 5px;
`;
const $b478a515f6547033$var$Title = (0, $d8seH.default)('div')`

`;
const $b478a515f6547033$var$Filters = (0, $d8seH.default)('div')`

`;
const $b478a515f6547033$var$CBContainer = (0, $d8seH.default)((0, $2esSG.default))`
  &.MuiFormControlLabel-root {
    width: 225px;
    margin-left: 0;
  }
  &.MuiFormControlLabel-root:hover * {
    font-weight: bold;
  }

  & .MuiTypography-root {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
const $b478a515f6547033$var$FacetLabel = (0, $d8seH.default)('div')`
  font-size: .9rem;
`;
const $b478a515f6547033$var$Count = (0, $d8seH.default)('div')`
  color: #888;
  font-size: .8rem;
`;
const $b478a515f6547033$var$MoreBtn = (0, $d8seH.default)('a')`
  display: flex;
  margin-left: auto;
  margin-right: 10px;
  font-size: .9em;
`;
const $b478a515f6547033$var$NoneFound = (0, $d8seH.default)('div')`
  margin: 0 20px;
` /* ranges are not currently supported
const RangeForm = styled('form')`
  margin-bottom: 5px;
`

const RangeSubmitBtn = styled(Button)`
  &.MuiButton-root {
    margin-left: 5px;
    min-width: 10px;
    height: 26px;
  }
`
*/ ;



var $hw4Z0 = parcelRequire("hw4Z0");




var $ayMG0 = parcelRequire("ayMG0");

var $cVXaD = parcelRequire("cVXaD");

var $atFJM = parcelRequire("atFJM");

var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $gZwVy = parcelRequire("gZwVy");
function $16b114de8dc6e3f4$export$2e2bcd8739ae039(props) {
    const { children: children, target: target, rel: rel } = props;
    const to = props.to || props.href;
    const isPortal = window.location.origin == (0, $gZwVy.default).portal;
    if (isPortal) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
        to: to,
        children: children
    });
    else return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: `${(0, $gZwVy.default).portal}${to}`,
        ...target ? {
            target: target
        } : {},
        ...rel ? {
            rel: rel
        } : {},
        children: children
    });
}


function $eb4b7a6d51daf17c$export$2e2bcd8739ae039(props) {
    const { label: label, ecr: ecrAppList } = props;
    const path = label.replace('registry.sagecontinuum.org/', '');
    const shortened = label.slice(label.lastIndexOf('/') + 1);
    const name = path.split(':')[0];
    if (!$atFJM.repoIsPublic(ecrAppList, name)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: label,
        placement: "right",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: shortened
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                path,
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                "(click for details)"
            ]
        }),
        placement: "right",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16b114de8dc6e3f4$export$2e2bcd8739ae039), {
                to: `/apps/app/${name}`,
                children: shortened
            })
        })
    });
}



var $eOilY = parcelRequire("eOilY");

var $9bsRS = parcelRequire("9bsRS");

var $atFJM = parcelRequire("atFJM");

var $f1q41 = parcelRequire("f1q41");




var $aQAPf = parcelRequire("aQAPf");
// optional project config
const $4cab315b36f812e1$var$DATA_START = (0, $aQAPf.default).dataStart;
const $4cab315b36f812e1$var$DATA_END = (0, $aQAPf.default).dataEnd;
const $4cab315b36f812e1$var$DATA_PRODUCT_PATH = (0, $aQAPf.default).dataProductPath;
const $4cab315b36f812e1$export$e51a0c2bf117db0a = 'Unassigned';
const $4cab315b36f812e1$var$TIME_WINDOW = 'hour';
const $4cab315b36f812e1$var$TIMELINE_LABEL_WIDTH = 175;
const $4cab315b36f812e1$var$ITEMS_INITIALLY = 10;
const $4cab315b36f812e1$var$ITEMS_PER_PAGE = 5;
const $4cab315b36f812e1$var$DAYS = 7;
const $4cab315b36f812e1$var$getStartTime = (str)=>str.includes('y') ? (0, $393cfda53f7a350f$export$2e2bcd8739ae039)(new Date(), str.replace(/-|y/g, '')) : (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), str.replace(/-|d/g, ''));
const $4cab315b36f812e1$var$getFacets = (data, name)=>{
    if (name === 'vsn' && data && typeof data === 'object' && !Array.isArray(data)) // Handle node dictionary case for VSN facet with site_id
    return (0, $f1q41.chain)(data).map((node, vsn)=>({
            name: String(vsn),
            displayName: node.site_id ? `${node.site_id} (${vsn})` : vsn
        })).value();
    else // Default behavior for other facets
    return (0, $f1q41.chain)(data).countBy(name) // returns string 'undefined' if undefined
    .map((count, name)=>({
            name: name == 'undefined' || !name || !name.length ? $4cab315b36f812e1$export$e51a0c2bf117db0a : name,
            count: count
        })).value();
};
const $4cab315b36f812e1$export$1eaa38d4ebccfa84 = (val)=>val == null ? (0, $66ac2ba2d2031913$export$8f45430ccf837300).noValue : (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[4];
const $4cab315b36f812e1$export$80ee56865356b7c3 = (val)=>{
    if (val == null) return (0, $66ac2ba2d2031913$export$8f45430ccf837300).noValue;
    if (val == 1) return (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[1];
    if (val <= 10) return (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[2];
    else if (val <= 100) return (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[3];
    else if (val <= 1000) return (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[4];
    else if (val <= 5000) return (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[5];
    else return (0, $66ac2ba2d2031913$export$8f45430ccf837300).blues[6];
};
const $4cab315b36f812e1$var$getInfiniteEnd = (page)=>page == 1 ? $4cab315b36f812e1$var$ITEMS_INITIALLY : page * $4cab315b36f812e1$var$ITEMS_PER_PAGE;
const $4cab315b36f812e1$var$getDownloadLink = (path)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($39562499e45c6466$exports))), {}),
        to: path,
        variant: "outlined",
        component: (0, $lzNIT.Link),
        children: "Download"
    });
function $4cab315b36f812e1$export$2e2bcd8739ae039(props) {
    // alter init data state if project/focus is provided
    const { project: project, focus: focus, vsns: vsns } = props;
    if (project) (0, $5cd62f408c38b395$export$e60cc94444444c1f).filters.project = [
        project
    ];
    if (focus) (0, $5cd62f408c38b395$export$e60cc94444444c1f).filters.focus = [
        focus
    ];
    const [nodeDict, setNodeDict] = (0, $acw62.useState)();
    const [nodes, setNodes] = (0, $acw62.useState)();
    const [ecr, setECR] = (0, $acw62.useState)();
    // infinite scroll
    const [page, setPage] = (0, $acw62.useState)(1);
    const loader = (0, $acw62.useRef)(null);
    const [loadingMore, setLoadingMore] = (0, $acw62.useState)(false);
    // main data views
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [{ data: data, filtered: filtered, filters: filters, rawData: rawData, byApp: byApp, error: error }, dispatch] = (0, $acw62.useReducer)((0, $5cd62f408c38b395$export$ad7bdf946026e48), (0, $5cd62f408c38b395$export$e60cc94444444c1f));
    const facetList = Object.keys((0, $5cd62f408c38b395$export$48c206defab35690));
    const [facets, setFacets] = (0, $acw62.useState)(null);
    // options
    const [opts, setOpts] = (0, $acw62.useState)({
        display: 'nodes',
        time: 'hourly',
        colorType: 'density',
        versions: false,
        window: `-${$4cab315b36f812e1$var$DAYS}d`,
        start: $4cab315b36f812e1$var$DATA_START || (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), $4cab315b36f812e1$var$DAYS),
        end: $4cab315b36f812e1$var$DATA_END || (0, $1ed606b7addd3a91$export$2e2bcd8739ae039)(new Date())
    });
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        const mProm = $9bsRS.getNodeDict({
            project: project,
            vsns: vsns
        }).then((data)=>{
            setNodeDict(data);
            const nodes = Object.values(data);
            setNodes(nodes);
            const projects = $4cab315b36f812e1$var$getFacets(data, 'project');
            const focuses = $4cab315b36f812e1$var$getFacets(data, 'focus');
            const cities = $4cab315b36f812e1$var$getFacets(data, 'city');
            const states = $4cab315b36f812e1$var$getFacets(data, 'state');
            const vsns = $4cab315b36f812e1$var$getFacets(data, 'vsn');
            setFacets({
                project: {
                    title: 'Project',
                    items: projects,
                    hide: !!project
                },
                focus: {
                    title: 'Focus',
                    items: focuses,
                    hide: !!focus
                },
                city: {
                    title: 'City',
                    items: cities
                },
                state: {
                    title: 'State',
                    items: states
                },
                vsn: {
                    title: 'Node',
                    items: vsns
                }
            });
            return nodes;
        }).catch((error)=>dispatch({
                type: 'ERROR',
                error: error
            }));
        const dProm = (0, $1455de3949293917$export$13386e296638fa34)(opts);
        Promise.all([
            mProm,
            dProm
        ]).then(([nodes, data])=>dispatch({
                type: 'INIT_DATA',
                data: data,
                nodes: nodes
            })).catch((error)=>dispatch({
                type: 'ERROR',
                error: error
            })).finally(()=>setLoading(false));
    }, [
        opts.start,
        opts.end
    ]);
    // fetch public ECR apps to determine if apps are indeed public
    (0, $acw62.useEffect)(()=>{
        $atFJM.listApps('public').then((ecr)=>setECR(ecr));
    }, []);
    const handleObserver = (0, $acw62.useCallback)((entries)=>{
        const target = entries[0];
        if (!target.isIntersecting) return;
        setLoadingMore(true);
        setTimeout(()=>{
            setPage((prev)=>prev + 1);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const option = {
            root: null,
            rootMargin: '100px',
            threshold: 0
        };
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current);
    }, [
        handleObserver
    ]);
    const handleFilter = (evt, facet, val)=>{
        const checked = evt.target.checked;
        if (checked) dispatch({
            type: 'ADD_FILTER',
            nodes: nodes,
            facet: facet,
            val: val
        });
        else dispatch({
            type: 'RM_FILTER',
            nodes: nodes,
            facet: facet,
            val: val
        });
    };
    const handleSelectAll = (evt, facet, vals)=>{
        const checked = evt.target.checked;
        if (checked) dispatch({
            type: 'SELECT_ALL',
            nodes: nodes,
            facet: facet,
            vals: vals
        });
        else dispatch({
            type: 'CLEAR_CATEGORY',
            nodes: nodes,
            facet: facet
        });
    };
    // todo(nc): refactor into provider
    const handleOptionChange = (name, val)=>{
        if ([
            'nodes',
            'apps'
        ].includes(name)) {
            setPage(1) // reset page
            ;
            setOpts((prev)=>({
                    ...prev,
                    display: name
                }));
            return;
        } else if (name == 'time') {
            const time = val;
            const data = (0, $1455de3949293917$export$4c0e6fff2d4abe18)({
                data: rawData,
                time: time
            });
            dispatch({
                type: 'SET_DATA',
                data: data
            });
            setOpts((prev)=>({
                    ...prev,
                    [name]: time
                }));
            return;
        } else if (name == 'versions') {
            const versions = val;
            const data = (0, $1455de3949293917$export$4c0e6fff2d4abe18)({
                data: rawData,
                time: opts.time,
                versions: versions
            });
            dispatch({
                type: 'SET_DATA',
                data: data
            });
            setOpts((prev)=>({
                    ...prev,
                    [name]: versions
                }));
            return;
        } else if (name == 'colorType') setOpts((prev)=>({
                ...prev,
                [name]: val
            }));
        else if (name == 'window') setOpts((prev)=>({
                ...prev,
                ...val && {
                    window: val,
                    start: $4cab315b36f812e1$var$getStartTime(val)
                }
            }));
        else throw `unhandled option state change name=${name}`;
    };
    const handleDateChange = ([start, end])=>{
        setOpts((prev)=>({
                ...prev,
                start: start,
                end: end
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4cab315b36f812e1$var$Root, {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Sidebar), {
                width: "250px",
                style: {
                    padding: '10px 0 100px 0'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.FilterTitle), {
                        children: "Filters"
                    }),
                    facets && facetList.map((facet)=>{
                        const { title: title, items: items, hide: hide } = facets[facet] || {};
                        if (hide) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}, title);
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b478a515f6547033$export$2e2bcd8739ae039), {
                            title: (0, $f1q41.startCase)(title.replace('res_', '')),
                            checked: filters[facet],
                            onCheck: (evt, val)=>handleFilter(evt, facet, val),
                            onSelectAll: (evt, vals)=>handleSelectAll(evt, facet, vals),
                            data: items
                        }, title);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($4cab315b36f812e1$var$Main, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Top), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Controls), {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex column",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "title no-margin",
                                            children: "Explore Data"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                                            className: "subtitle no-margin muted",
                                            children: [
                                                opts.display == 'nodes' && `${filtered.length} nodes with recent data`,
                                                opts.display == 'apps' && byApp && `${Object.keys(byApp).length} apps with data`
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Divider), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex-grow",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39d20adadcde0807$export$2e2bcd8739ae039), {
                                        onChange: handleOptionChange,
                                        onDateChange: handleDateChange,
                                        opts: opts,
                                        quickRanges: [
                                            '-30d',
                                            '-7d',
                                            '-2d',
                                            '-1d'
                                        ],
                                        groupByToggle: true,
                                        aggregation: true,
                                        density: true
                                    })
                                })
                            ]
                        })
                    }),
                    opts.display == 'nodes' && filtered && ecr && filtered.slice(0, $4cab315b36f812e1$var$getInfiniteEnd(page)).map((vsn)=>{
                        const timelineData = data[vsn];
                        const { location: location } = nodeDict[vsn];
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0b85f1216005eff9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex title-row gap",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex column",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                        children: (0, $eOilY.vsnLink)(vsn, nodeDict[vsn])
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: location
                                                })
                                            ]
                                        }),
                                        $4cab315b36f812e1$var$DATA_PRODUCT_PATH && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: $4cab315b36f812e1$var$getDownloadLink($4cab315b36f812e1$var$DATA_PRODUCT_PATH)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                                    data: timelineData,
                                    cellUnit: opts.time == 'daily' ? 'day' : 'hour',
                                    colorCell: opts.colorType == 'density' ? $4cab315b36f812e1$export$80ee56865356b7c3 : $4cab315b36f812e1$export$1eaa38d4ebccfa84,
                                    startTime: opts.start,
                                    endTime: opts.end,
                                    tooltip: (item)=>`
                      <div style="margin-bottom: 5px;">
                        ${new Date(item.timestamp).toDateString()}${' '}
                        ${new Date(item.timestamp).toLocaleTimeString([], {
                                            timeStyle: 'short'
                                        })}${' '}
                        (${$4cab315b36f812e1$var$TIME_WINDOW})
                      </div>
                      ${item.meta.plugin}<br>
                      ${item.value.toLocaleString()} records`,
                                    onCellClick: (data)=>{
                                        const { timestamp: timestamp, meta: meta } = data;
                                        const { vsn: vsn, origPluginName: origPluginName } = meta;
                                        const date = new Date(timestamp);
                                        const end = (opts.time == 'daily' ? (0, $4f754377033842c6$export$2e2bcd8739ae039)(date, 1) : (0, $eba2848fce1475e9$export$2e2bcd8739ae039)(date, 1)).toISOString();
                                        window.open(`${window.location.origin}/query-browser` + `?nodes=${vsn}&apps=${origPluginName}.*&start=${timestamp}&end=${end}`, '_blank');
                                    },
                                    yFormat: (label)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb4b7a6d51daf17c$export$2e2bcd8739ae039), {
                                            label: label,
                                            ecr: ecr
                                        }),
                                    labelWidth: $4cab315b36f812e1$var$TIMELINE_LABEL_WIDTH
                                })
                            ]
                        }, vsn);
                    }),
                    opts.display == 'apps' && byApp && Object.keys(byApp).slice(0, $4cab315b36f812e1$var$getInfiniteEnd(page)).map((name)=>{
                        const timelineData = byApp[name];
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0b85f1216005eff9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb4b7a6d51daf17c$export$2e2bcd8739ae039), {
                                        label: name,
                                        ecr: ecr
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                                    data: timelineData,
                                    limitRowCount: 10,
                                    cellUnit: opts.time == 'daily' ? 'day' : 'hour',
                                    colorCell: opts.colorType == 'density' ? $4cab315b36f812e1$export$80ee56865356b7c3 : $4cab315b36f812e1$export$1eaa38d4ebccfa84,
                                    startTime: opts.start,
                                    endTime: opts.end,
                                    tooltip: (item)=>`
                      <div style="margin-bottom: 5px;">
                        ${new Date(item.timestamp).toDateString()}${' '}
                        ${new Date(item.timestamp).toLocaleTimeString([], {
                                            timeStyle: 'short'
                                        })}${' '}
                        (${$4cab315b36f812e1$var$TIME_WINDOW})
                      </div>
                      ${item.meta.plugin}<br>
                      ${item.value.toLocaleString()} records`,
                                    yFormat: (vsn)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                            to: `/nodes/${vsn}`,
                                            target: "_blank",
                                            children: vsn
                                        }),
                                    onCellClick: (data)=>{
                                        const { timestamp: timestamp, meta: meta } = data;
                                        const { vsn: vsn, plugin: plugin } = meta;
                                        const date = new Date(timestamp);
                                        const end = (opts.time == 'daily' ? (0, $4f754377033842c6$export$2e2bcd8739ae039)(date, 1) : (0, $eba2848fce1475e9$export$2e2bcd8739ae039)(date, 1)).toISOString();
                                        window.open(window.location.origin + `/query-browser?nodes=${vsn}&apps=${plugin}.*&start=${timestamp}&end=${end}`, '_blank');
                                    },
                                    labelWidth: $4cab315b36f812e1$var$TIMELINE_LABEL_WIDTH
                                })
                            ]
                        }, name);
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: loader
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                        children: error.message
                    }),
                    (loading || loadingMore) && (data ? $4cab315b36f812e1$var$getInfiniteEnd(page) < data?.length : true) && [
                        ...Array($4cab315b36f812e1$var$ITEMS_INITIALLY)
                    ].map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b85f1216005eff9$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a4a018ec5a6eb95$export$2e2bcd8739ae039), {})
                        }, i)),
                    loadingMore && (data ? $4cab315b36f812e1$var$getInfiniteEnd(page) < data?.length : true) && /*#__PURE__*/ (0, $ayMG0.jsx)($4cab315b36f812e1$var$LoadingMore, {
                        className: "flex items-center muted",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: "loading..."
                        })
                    })
                ]
            })
        ]
    });
}
const $4cab315b36f812e1$var$Root = (0, $d8seH.default)('div')`
`;
const $4cab315b36f812e1$var$Main = (0, $d8seH.default)('div')`
  margin: 0px 20px 30px 0;
  padding: 0 0 0 20px;
  width: 100%;
`;
const $4cab315b36f812e1$var$LoadingMore = (0, $d8seH.default)('div')`
  font-size: 2em;
`;


const $5cd62f408c38b395$export$48c206defab35690 = {
    project: [],
    focus: [],
    city: [],
    state: [],
    vsn: []
};
const $5cd62f408c38b395$export$e60cc94444444c1f = {
    rawData: null,
    data: null,
    filtered: [],
    filters: $5cd62f408c38b395$export$48c206defab35690
};
function $5cd62f408c38b395$export$ad7bdf946026e48(state, action) {
    // todo(nc): note: we likely won't need both ADD_FILTER and RM_FILTER?
    switch(action.type){
        case 'INIT_DATA':
            {
                const { filters: filters } = state;
                const { nodes: nodes } = action;
                const { rawData: rawData, data: data } = action.data;
                let filtered = $5cd62f408c38b395$var$sortVSNs(Object.keys(data));
                filtered = $5cd62f408c38b395$var$getFilteredVSNs(nodes, data, filters);
                return {
                    ...state,
                    rawData: rawData,
                    data: data,
                    filtered: filtered,
                    byApp: $5cd62f408c38b395$export$b06c394ef43d8f98(rawData, filtered)
                };
            }
        case 'SET_DATA':
            return {
                ...state,
                data: action.data
            };
        case 'ADD_FILTER':
            {
                const { data: data, filters: filters } = state;
                const { nodes: nodes, facet: facet, val: val } = action;
                // new filter state
                const newFilters = {
                    ...filters,
                    [facet]: [
                        ...filters[facet],
                        val
                    ]
                };
                // new filtered data, using "nodeMeta" data
                const filtered = $5cd62f408c38b395$var$getFilteredVSNs(nodes, data, newFilters);
                return {
                    ...state,
                    filtered: filtered,
                    filters: newFilters,
                    byApp: $5cd62f408c38b395$export$b06c394ef43d8f98(state.rawData, filtered)
                };
            }
        case 'RM_FILTER':
            {
                const { data: data, filters: filters } = state;
                const { nodes: nodes, facet: facet, val: val } = action;
                // new filter state
                const newFilters = {
                    ...filters,
                    [facet]: filters[facet].filter((v)=>v != val)
                };
                // new filtered data, using "nodeMeta" data
                const filtered = $5cd62f408c38b395$var$getFilteredVSNs(nodes, data, newFilters);
                return {
                    ...state,
                    filtered: filtered,
                    filters: newFilters,
                    byApp: $5cd62f408c38b395$export$b06c394ef43d8f98(state.rawData, filtered)
                };
            }
        case 'SELECT_ALL':
            {
                const { data: data, filters: filters } = state;
                const { nodes: nodes, facet: facet, vals: vals } = action;
                const newFilters = {
                    ...filters,
                    [facet]: vals
                };
                const filtered = $5cd62f408c38b395$var$getFilteredVSNs(nodes, data, newFilters);
                return {
                    ...state,
                    filtered: filtered,
                    filters: newFilters,
                    byApp: $5cd62f408c38b395$export$b06c394ef43d8f98(state.rawData, filtered)
                };
            }
        case 'CLEAR_CATEGORY':
            {
                const { data: data, filters: filters } = state;
                const { nodes: nodes, facet: facet } = action;
                const newFilters = {
                    ...filters,
                    [facet]: []
                };
                const filtered = $5cd62f408c38b395$var$getFilteredVSNs(nodes, data, newFilters);
                return {
                    ...state,
                    filtered: filtered,
                    filters: newFilters,
                    byApp: $5cd62f408c38b395$export$b06c394ef43d8f98(state.rawData, filtered)
                };
            }
        case 'ERROR':
            return {
                ...state,
                error: action.error
            };
        default:
            return state;
    }
}
// core logic for intersection of unions; could be optimized or simplified if needed
const $5cd62f408c38b395$var$getFilteredVSNs = (nodes, data, filters)=>{
    const vsnsByField = {};
    for (const [field, vals] of Object.entries(filters))for (const node of nodes){
        let isEmpty;
        if (vals.includes((0, $4cab315b36f812e1$export$e51a0c2bf117db0a)) && node[field] == '') isEmpty = true // eslint-disable-line @typescript-eslint/no-unused-vars
        ;
        else if (!vals.includes(node[field])) continue;
        const vsn = node.vsn;
        vsnsByField[field] = field in vsnsByField ? [
            ...vsnsByField[field],
            vsn
        ] : [
            vsn
        ];
    }
    const count = (0, $f1q41.sum)(Object.values(vsnsByField).map((vals)=>vals.length));
    const vsns = count ? (0, $f1q41.intersection)(...Object.values(vsnsByField)) : nodes.map((m)=>m.vsn);
    // find intersection of vsns and data vsns
    let vsnSubset = Object.keys(data).filter((vsn)=>vsns.includes(vsn));
    vsnSubset = $5cd62f408c38b395$var$sortVSNs(vsnSubset);
    return vsnSubset;
};
// sort by node, then blade
const $5cd62f408c38b395$var$sortVSNs = (vsns)=>[
        ...vsns.filter((vsn)=>vsn.charAt(0) == 'W').sort(),
        ...vsns.filter((vsn)=>vsn.charAt(0) == 'V').sort()
    ];
function $5cd62f408c38b395$export$b06c394ef43d8f98(data, vsns) {
    const byApp = (0, $f1q41.groupBy)(data, 'meta.plugin');
    const byAppByNode = Object.keys(byApp).reduce((acc, app)=>{
        let grouped = (0, $f1q41.groupBy)(byApp[app], 'meta.vsn');
        grouped = (0, $f1q41.pick)(grouped, vsns);
        const hasData = !!Object.keys(grouped).length;
        return hasData ? {
            ...acc,
            [app]: grouped
        } : acc;
    }, {});
    return byAppByNode;
}




var $lffEs = parcelRequire("lffEs");

var $eOilY = parcelRequire("eOilY");

var $f1q41 = parcelRequire("f1q41");
const $de04a124219a92c5$var$registry = (0, $gZwVy.default).dockerRegistry;
const $de04a124219a92c5$var$TIMELINE_LABEL_WIDTH = 40;
const $de04a124219a92c5$var$TAIL_DAYS = '-7d';
// todo(nc): generalize a la data/query browser handling of times
const $de04a124219a92c5$var$getStartTime = (str)=>{
    if (str.includes('d')) return (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), str.replace(/-|d/g, ''));
    else if (str.includes('y')) return (0, $393cfda53f7a350f$export$2e2bcd8739ae039)(new Date(), str.replace(/-|y/g, ''));
    else throw new Error(`getStartTime: relative start time '%{string}' not supported.`);
};
function $de04a124219a92c5$export$2e2bcd8739ae039(props) {
    const { plugin: plugin } = props;
    const [nodes, setNodes] = (0, $acw62.useState)();
    const [nodeDict, setNodeDict] = (0, $acw62.useState)();
    const [{ data: data, rawData: rawData, byApp: byApp, error: error }, dispatch] = (0, $acw62.useReducer)((0, $5cd62f408c38b395$export$ad7bdf946026e48), (0, $5cd62f408c38b395$export$e60cc94444444c1f));
    const [loadingTL, setLoadingTL] = (0, $acw62.useState)(false);
    const [opts, setOpts] = (0, $acw62.useState)({
        display: 'nodes',
        colorType: 'density',
        versions: false,
        time: 'hourly',
        start: $de04a124219a92c5$var$getStartTime($de04a124219a92c5$var$TAIL_DAYS),
        window: $de04a124219a92c5$var$TAIL_DAYS
    });
    // note: endtime is not currently an option
    const [end] = (0, $acw62.useState)((0, $1ed606b7addd3a91$export$2e2bcd8739ae039)(new Date()));
    (0, $acw62.useEffect)(()=>{
        $9bsRS.getNodes().then((nodes)=>{
            setNodes(nodes);
            setNodeDict((0, $f1q41.keyBy)(nodes, 'vsn'));
        }).catch((error)=>dispatch({
                type: 'ERROR',
                error: error
            }));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!nodes) return;
        setLoadingTL(true);
        (0, $1455de3949293917$export$13386e296638fa34)({
            ...opts,
            plugin: `${$de04a124219a92c5$var$registry}/${plugin}.*`
        }).then((data)=>dispatch({
                type: 'INIT_DATA',
                data: data,
                nodes: nodes
            })).catch((error)=>dispatch({
                type: 'ERROR',
                error: error
            })).finally(()=>setLoadingTL(false));
    }, [
        plugin,
        nodes,
        opts
    ]);
    const handleOptionChange = (name, val)=>{
        if (name == 'time') {
            const data = (0, $1455de3949293917$export$4c0e6fff2d4abe18)({
                data: rawData,
                time: val
            });
            dispatch({
                type: 'SET_DATA',
                data: data
            });
            setOpts((prev)=>({
                    ...prev,
                    [name]: val
                }));
        } else if ([
            'colorType'
        ].includes(name)) setOpts((prev)=>({
                ...prev,
                [name]: val
            }));
        else if (name == 'window') setOpts((prev)=>({
                ...prev,
                ...val && {
                    window: val,
                    start: $de04a124219a92c5$var$getStartTime(val)
                }
            }));
        else throw `unhandled option state change name=${name}`;
    };
    const hasData = (data)=>Object.keys(data || {}).length > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($de04a124219a92c5$var$Root, {
        className: "flex column gap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex gap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "no-margin",
                            children: (0, $lffEs.getRangeTitle)(opts.window)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39d20adadcde0807$export$2e2bcd8739ae039), {
                            onChange: handleOptionChange,
                            opts: opts,
                            condensed: true,
                            aggregation: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                children: [
                    loadingTL && !error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a4a018ec5a6eb95$export$2e2bcd8739ae039), {}),
                    data != null && !hasData(data) && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "No recent data available for this period"
                    }),
                    !loadingTL && byApp && Object.keys(byApp).map((name)=>{
                        const timelineData = byApp[name];
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)($de04a124219a92c5$var$TimelineContainer, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "timeline-title",
                                    children: name.slice(name.lastIndexOf('/') + 1)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                                    data: timelineData,
                                    cellUnit: opts.time == 'daily' ? 'day' : 'hour',
                                    colorCell: opts.colorType == 'density' ? (0, $4cab315b36f812e1$export$80ee56865356b7c3) : (0, $4cab315b36f812e1$export$1eaa38d4ebccfa84),
                                    startTime: opts.start,
                                    endTime: end,
                                    tooltip: (item)=>`
                      <div style="margin-bottom: 5px;">
                        ${new Date(item.timestamp).toDateString()} ` + `${new Date(item.timestamp).toLocaleTimeString([], {
                                            timeStyle: 'short'
                                        })} (${opts.time})
                      </div>
                      ${item.meta.plugin}<br>
                      ${item.value.toLocaleString()} records`,
                                    yFormat: (vsn)=>(0, $eOilY.vsnLinkNameOnly)(vsn, nodeDict[vsn]),
                                    onCellClick: (data)=>{
                                        const { timestamp: timestamp, meta: meta } = data;
                                        const { vsn: vsn, plugin: plugin } = meta;
                                        const date = new Date(timestamp);
                                        const end = (opts.time == 'daily' ? (0, $4f754377033842c6$export$2e2bcd8739ae039)(date, 1) : (0, $eba2848fce1475e9$export$2e2bcd8739ae039)(date, 1)).toISOString();
                                        window.open(`${window.location.origin}/query-browser` + `?nodes=${vsn}&apps=${plugin}&start=${timestamp}&end=${end}`, '_blank');
                                    },
                                    labelWidth: $de04a124219a92c5$var$TIMELINE_LABEL_WIDTH
                                })
                            ]
                        }, name);
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                        children: error.message
                    })
                ]
            })
        ]
    });
}
const $de04a124219a92c5$var$Root = (0, $lmFrL.default).div`
  .timeline-title {
    float: left;
    margin: 0;
  }

  /* todo(nc): hide 'daily' until parser is fixed */
  [value=daily] { display: none; }
  [value=hourly] { border-radius: 4px !important; }
`;
const $de04a124219a92c5$var$TimelineContainer = (0, $lmFrL.default).div`
  margin-bottom: 50px
`;


var $d55025bea272cdc1$exports = {};
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2022, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($d55025bea272cdc1$exports);
})($d55025bea272cdc1$exports, function(exports1) {
    'use strict';
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaults() {
        return {
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: '',
            highlight: null,
            langPrefix: 'language-',
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartLists: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    exports1.defaults = getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = /[&<>"']/g;
    var escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
    var escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;
    var escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    /**
   * @param {string} html
   */ function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === 'colon') return ':';
            if (n.charAt(0) === '#') return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return '';
        });
    }
    var caret = /(^|[^\[])\^/g;
    /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */ function edit(regex, opt) {
        regex = typeof regex === 'string' ? regex : regex.source;
        opt = opt || '';
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, '$1');
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */ function cleanUrl(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, '%');
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    /**
   * @param {string} base
   * @param {string} href
   */ function resolveUrl(base, href) {
        if (!baseUrls[' ' + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[' ' + base] = base + '/';
            else baseUrls[' ' + base] = rtrim(base, '/', true);
        }
        base = baseUrls[' ' + base];
        var relativeBase = base.indexOf(':') === -1;
        if (href.substring(0, 2) === '//') {
            if (relativeBase) return href;
            return base.replace(protocol, '$1') + href;
        } else if (href.charAt(0) === '/') {
            if (relativeBase) return href;
            return base.replace(domain, '$1') + href;
        } else return base + href;
    }
    var noopTest = {
        exec: function noopTest() {}
    };
    function merge(obj) {
        var i = 1, target, key;
        for(; i < arguments.length; i++){
            target = arguments[i];
            for(key in target)if (Object.prototype.hasOwnProperty.call(target, key)) obj[key] = target[key];
        }
        return obj;
    }
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
            else // add space before unescaped |
            return ' |';
        }), cells = row.split(/ \|/);
        var i = 0; // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push('');
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        return cells;
    }
    /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */ function rtrim(str, c, invert) {
        var l = str.length;
        if (l === 0) return '';
         // Length of suffix matching the invert condition.
        var suffLen = 0; // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === '\\') i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    } // copied from https://stackoverflow.com/a/5450113/806777
    /**
   * @param {string} pattern
   * @param {number} count
   */ function repeatString(pattern, count) {
        if (count < 1) return '';
        var result = '';
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    function outputLink(cap, link, raw, lexer) {
        var href = link.href;
        var title = link.title ? escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            var token = {
                type: 'link',
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text, [])
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split('\n').map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join('\n');
    }
    /**
   * Tokenizer
   */ var Tokenizer = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: 'space',
                raw: cap[0]
            };
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic ? rtrim(text, '\n') : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || '');
                return {
                    type: 'code',
                    raw: raw,
                    lang: cap[2] ? cap[2].trim() : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim(); // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, '#');
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                var token = {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: []
                };
                this.lexer.inline(token.text, token.tokens);
                return token;
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: 'hr',
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *>[ \t]?/gm, '');
                return {
                    type: 'blockquote',
                    raw: cap[0],
                    tokens: this.lexer.blockTokens(text, []),
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
                var bull = cap[1].trim();
                var isordered = bull.length > 1;
                var list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: []
                };
                bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
                if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
                 // Get next list item
                var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))"); // Check if current bullet point can start a new List Item
                while(src){
                    endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    line = cap[2].split('\n', 1)[0];
                    nextLine = src.split('\n', 1)[0];
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimLeft();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        // Items begin with at most one blank line
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))");
                        var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"); // Check if following lines should be included in List Item
                        while(src){
                            rawLine = src.split('\n', 1)[0];
                            line = rawLine; // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) line = line.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                             // End list item if found start of new bullet
                            if (nextBulletRegex.test(line)) break;
                             // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (line.search(/[^ ]/) >= indent || !line.trim()) // Dedent if possible
                            itemContents += '\n' + line.slice(indent);
                            else if (!blankLine) // Until blank line, item doesn't need indentation
                            itemContents += '\n' + line;
                            else break;
                            if (!blankLine && !line.trim()) // Check if current line is blank
                            blankLine = true;
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    } // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents
                    });
                    list.raw += raw;
                } // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimRight();
                list.items[list.items.length - 1].text = itemContents.trimRight();
                list.raw = list.raw.trimRight();
                var l = list.items.length; // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(i = 0; i < l; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    var spacers = list.items[i].tokens.filter(function(t) {
                        return t.type === 'space';
                    });
                    var hasMultipleLineBreaks = spacers.every(function(t) {
                        var chars = t.raw.split('');
                        var lineBreaks = 0;
                        for(var _iterator = _createForOfIteratorHelperLoose(chars), _step; !(_step = _iterator()).done;){
                            var _char = _step.value;
                            if (_char === '\n') lineBreaks += 1;
                            if (lineBreaks > 1) return true;
                        }
                        return false;
                    });
                    if (!list.loose && spacers.length && hasMultipleLineBreaks) {
                        // Having a single line break doesn't mean a list is loose. A single line break is terminating the last list item
                        list.loose = true;
                        list.items[i].loose = true;
                    }
                }
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) {
                var token = {
                    type: 'html',
                    raw: cap[0],
                    pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
                    text: cap[0]
                };
                if (this.options.sanitize) {
                    token.type = 'paragraph';
                    token.text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
                    token.tokens = [];
                    this.lexer.inline(token.text, token.tokens);
                }
                return token;
            }
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
                var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
                return {
                    type: 'def',
                    tag: tag,
                    raw: cap[0],
                    href: cap[2],
                    title: cap[3]
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: 'table',
                    header: splitCells(cap[1]).map(function(c) {
                        return {
                            text: c
                        };
                    }),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i, j, k, row;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = 'right';
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = 'center';
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = 'left';
                        else item.align[i] = null;
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map(function(c) {
                        return {
                            text: c
                        };
                    });
                     // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++){
                        item.header[j].tokens = [];
                        this.lexer.inline(item.header[j].text, item.header[j].tokens);
                    } // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++){
                            row[k].tokens = [];
                            this.lexer.inline(row[k].text, row[k].tokens);
                        }
                    }
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) {
                var token = {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[2].charAt(0) === '=' ? 1 : 2,
                    text: cap[1],
                    tokens: []
                };
                this.lexer.inline(token.text, token.tokens);
                return token;
            }
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                var token = {
                    type: 'paragraph',
                    raw: cap[0],
                    text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1],
                    tokens: []
                };
                this.lexer.inline(token.text, token.tokens);
                return token;
            }
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) {
                var token = {
                    type: 'text',
                    raw: cap[0],
                    text: cap[0],
                    tokens: []
                };
                this.lexer.inline(token.text, token.tokens);
                return token;
            }
        };
        _proto.escape = function escape$1(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: 'escape',
                raw: cap[0],
                text: escape(cap[1])
            };
        };
        _proto.tag = function tag(src) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: this.options.sanitize ? 'text' : 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                     // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                var href = cap[2];
                var title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : '';
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
                    title: title ? title.replace(this.rules.inline._escapes, '$1') : title
                }, cap[0], this.lexer);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                link = links[link.toLowerCase()];
                if (!link || !link.href) {
                    var text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = '';
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return; // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || '';
            if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0; // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal); // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        var _text = src.slice(1, lLength + match.index + rLength);
                        return {
                            type: 'em',
                            raw: src.slice(0, lLength + match.index + rLength + 1),
                            text: _text,
                            tokens: this.lexer.inlineTokens(_text, [])
                        };
                    } // Create 'strong' if smallest delimiter has even char count. **a***
                    var text = src.slice(2, lLength + match.index + rLength - 1);
                    return {
                        type: 'strong',
                        raw: src.slice(0, lLength + match.index + rLength + 1),
                        text: text,
                        tokens: this.lexer.inlineTokens(text, [])
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, ' ');
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: 'br',
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: 'del',
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2], [])
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === '@') {
                    text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = 'mailto:' + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === '@') {
                    text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = 'mailto:' + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === 'www.') href = 'http://' + text;
                    else href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (this.lexer.state.inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
                else text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: 'text',
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    /**
   * Block-Level Grammar
   */ var block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block.normal = merge({}, block);
    /**
   * GFM Block Grammar
   */ block.gfm = merge({}, block.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('table', block.gfm.table) // interrupt paragraphs with table
    .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block.pedantic = merge({}, block.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: 'reflink|nolink(?!\\()',
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //          () Skip orphan inside strong  () Consume to delim (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
            rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    }; // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex(); // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    inline.escapedEmSt = /\\\*|\\_/g;
    inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline.normal = merge({}, inline);
    /**
   * Pedantic Inline Grammar
   */ inline.pedantic = merge({}, inline.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline.gfm = merge({}, inline.normal, {
        escape: edit(inline.escape).replace('])', '~|])').getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline.breaks = merge({}, inline.gfm, {
        br: edit(inline.br).replace('{2,}', '*').getRegex(),
        text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
    });
    /**
   * smartypants text replacement
   * @param {string} text
   */ function smartypants(text) {
        return text // em-dashes
        .replace(/---/g, "\u2014") // en-dashes
        .replace(/--/g, "\u2013") // opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018") // closing singles & apostrophes
        .replace(/'/g, "\u2019") // opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C") // closing doubles
        .replace(/"/g, "\u201D") // ellipses
        .replace(/\.{3}/g, "\u2026");
    }
    /**
   * mangle email addresses
   * @param {string} text
   */ function mangle(text) {
        var out = '', i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = 'x' + ch.toString(16);
            out += '&#' + ch + ';';
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        } /**
     * Static Lex Inline Method
     */ ;
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        } /**
     * Preprocessing
     */ ;
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, '\n');
            this.blockTokens(src, this.tokens);
            var next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        } /**
     * Lexing
     */ ;
        _proto.blockTokens = function blockTokens(src, tokens) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (this.options.pedantic) src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
            else src = src.replace(/^( *)(\t+)/gm, function(_, leading, tabs) {
                return leading + '    '.repeat(tabs.length);
            });
            var token, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                 // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += '\n';
                    else tokens.push(token);
                    continue;
                } // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1]; // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                } // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                } // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                } // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        };
        _proto.inline = function inline(src, tokens) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
        } /**
     * Lexing/Compiling
     */ ;
        _proto.inlineTokens = function inlineTokens(src, tokens) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            var token, lastToken, cutSrc; // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar; // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            } // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
             // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = '';
                keepPrevChar = false; // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this2
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                 // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                } // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                } // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                } // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    /**
   * Renderer
   */ var Renderer = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || '').match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, '') + '\n';
            if (!lang) return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
            return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
        } /**
     * @param {string} quote
     */ ;
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        } /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */ ;
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) {
                var id = this.options.headerPrefix + slugger.slug(raw);
                return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
            } // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? 'ol' : 'ul', startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
            return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
        } /**
     * @param {string} text
     */ ;
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
        } /**
     * @param {string} text
     */ ;
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        } /**
     * @param {string} header
     * @param {string} body
     */ ;
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
        } /**
     * @param {string} content
     */ ;
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? 'th' : 'td';
            var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
            return tag + content + ("</" + type + ">\n");
        } /**
     * span level renderer
     * @param {string} text
     */ ;
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        } /**
     * @param {string} text
     */ ;
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        } /**
     * @param {string} text
     */ ;
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? '<br/>' : '<br>';
        } /**
     * @param {string} text
     */ ;
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + escape(href) + '"';
            if (title) out += ' title="' + title + '"';
            out += '>' + text + '</a>';
            return out;
        } /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */ ;
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
            if (title) out += " title=\"" + title + "\"";
            out += this.options.xhtml ? '/>' : '>';
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return '' + text;
        };
        _proto.image = function image(href, title, text) {
            return '' + text;
        };
        _proto.br = function br() {
            return '';
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        /**
     * @param {string} value
     */ var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim() // remove html tags
            .replace(/<[!\/a-z].*?>/ig, '') // remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
        } /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */ ;
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + '-' + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        } /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */ ;
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    /**
   * Parsing & Compiling
   */ var Parser = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer();
            this.slugger = new Slugger();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        } /**
     * Static Parse Inline Method
     */ ;
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        } /**
     * Parse Loop
     */ ;
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = '', i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i]; // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        'space',
                        'hr',
                        'heading',
                        'code',
                        'table',
                        'blockquote',
                        'list',
                        'html',
                        'paragraph',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'space':
                        continue;
                    case 'hr':
                        out += this.renderer.hr();
                        continue;
                    case 'heading':
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case 'code':
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case 'table':
                        header = ''; // header
                        cell = '';
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = '';
                        l2 = token.rows.length;
                        for(j = 0; j < l2; j++){
                            row = token.rows[j];
                            cell = '';
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case 'blockquote':
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case 'list':
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = '';
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = '';
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: 'text',
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case 'html':
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case 'paragraph':
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case 'text':
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === 'text'){
                            token = tokens[++i];
                            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        } /**
     * Parse Inline Tokens
     */ ;
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = '', i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i]; // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        'escape',
                        'html',
                        'link',
                        'image',
                        'strong',
                        'em',
                        'codespan',
                        'br',
                        'del',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'escape':
                        out += renderer.text(token.text);
                        break;
                    case 'html':
                        out += renderer.html(token.text);
                        break;
                    case 'link':
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case 'image':
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case 'strong':
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case 'em':
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case 'codespan':
                        out += renderer.codespan(token.text);
                        break;
                    case 'br':
                        out += renderer.br();
                        break;
                    case 'del':
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case 'text':
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    /**
   * Marked
   */ function marked(src, opt, callback) {
        // throw error in case of non string input
        if (typeof src === 'undefined' || src === null) throw new Error('marked(): input parameter is undefined or null');
        if (typeof src !== 'string') throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
        if (typeof opt === 'function') {
            callback = opt;
            opt = null;
        }
        opt = merge({}, marked.defaults, opt || {});
        checkSanitizeDeprecation(opt);
        if (callback) {
            var highlight = opt.highlight;
            var tokens;
            try {
                tokens = Lexer.lex(src, opt);
            } catch (e) {
                return callback(e);
            }
            var done = function done(err) {
                var out;
                if (!err) try {
                    if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                    out = Parser.parse(tokens, opt);
                } catch (e) {
                    err = e;
                }
                opt.highlight = highlight;
                return err ? callback(err) : callback(null, out);
            };
            if (!highlight || highlight.length < 3) return done();
            delete opt.highlight;
            if (!tokens.length) return done();
            var pending = 0;
            marked.walkTokens(tokens, function(token) {
                if (token.type === 'code') {
                    pending++;
                    setTimeout(function() {
                        highlight(token.text, token.lang, function(err, code) {
                            if (err) return done(err);
                            if (code != null && code !== token.text) {
                                token.text = code;
                                token.escaped = true;
                            }
                            pending--;
                            if (pending === 0) done();
                        });
                    }, 0);
                }
            });
            if (pending === 0) done();
            return;
        }
        try {
            var _tokens = Lexer.lex(src, opt);
            if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
            return Parser.parse(_tokens, opt);
        } catch (e) {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (opt.silent) return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
            throw e;
        }
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        merge(marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = exports1.defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var opts = merge.apply(void 0, [
            {}
        ].concat(args));
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        var hasExtensions;
        args.forEach(function(pack) {
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                hasExtensions = true;
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error('extension name required');
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers ? extensions.renderers[ext.name] : null;
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === 'block') {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === 'inline') {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
            } // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop]; // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop]; // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
             // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var _walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    pack.walkTokens.call(this, token);
                    if (_walkTokens) _walkTokens.call(this, token);
                };
            }
            if (hasExtensions) opts.extensions = extensions;
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var _loop3 = function _loop3() {
            var token = _step.value;
            callback.call(marked, token);
            switch(token.type){
                case 'table':
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        marked.walkTokens(cell.tokens, callback);
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            marked.walkTokens(_cell.tokens, callback);
                        }
                    }
                    break;
                case 'list':
                    marked.walkTokens(token.items, callback);
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        marked.walkTokens(token[childTokens], callback);
                    });
                    else if (token.tokens) marked.walkTokens(token.tokens, callback);
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop3();
    };
    /**
   * Parse Inline
   * @param {string} src
   */ marked.parseInline = function(src, opt) {
        // throw error in case of non string input
        if (typeof src === 'undefined' || src === null) throw new Error('marked.parseInline(): input parameter is undefined or null');
        if (typeof src !== 'string') throw new Error('marked.parseInline(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
        opt = merge({}, marked.defaults, opt || {});
        checkSanitizeDeprecation(opt);
        try {
            var tokens = Lexer.lexInline(src, opt);
            if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
            return Parser.parseInline(tokens, opt);
        } catch (e) {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (opt.silent) return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
            throw e;
        }
    };
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = Parser.parse;
    var lexer = Lexer.lex;
    exports1.Lexer = Lexer;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.Slugger = Slugger;
    exports1.TextRenderer = TextRenderer;
    exports1.Tokenizer = Tokenizer;
    exports1.getDefaults = getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


function $e4688a1d9d0979e6$export$2e2bcd8739ae039() {
    const path = (0, $aphAM.useParams)()['*'];
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const tab = params.get('tab') || 'science';
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [repo, setRepo] = (0, $acw62.useState)(null);
    const [isPublic] = (0, $acw62.useState)(null);
    const [sciHtml, setSciHtml] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        const [namespace, name] = path.split('/');
        setLoading(true);
        $atFJM.getRepo({
            namespace: namespace,
            name: name
        }).then((repo)=>{
            setRepo(repo);
            const latestTag = repo.versions[0];
            const hasSciMarkDown = !!latestTag?.science_description;
            const mdPath = hasSciMarkDown ? latestTag?.science_description : null;
            if (mdPath) return $atFJM.getSciMarkdown(mdPath).then((text)=>setSciHtml((0, $d55025bea272cdc1$exports.marked)(text)));
            else {
                // if no description, just go to tags
                params.set('tab', 'tags');
                setParams(params);
            }
        }).catch((err)=>setError(err.message)).finally(()=>setLoading(false));
    }, [
        path,
        setLoading
    ]);
    const handleActionComplete = ()=>{
    // todo: implement
    };
    const versions = repo ? repo.versions : [];
    const latestTag = versions.length ? versions[0] : null;
    const [namespace, name] = path.split('/');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e4688a1d9d0979e6$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex",
                        children: [
                            repo && latestTag.thumbnail ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$6521433ed15a34db), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: `${$atFJM.url}/meta-files/${latestTag.thumbnail}`
                                })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f446074e335acab0$export$6521433ed15a34db), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15b87fc16f8d46d$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                        className: "no-margin",
                                        children: [
                                            namespace,
                                            " / ",
                                            name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        children: latestTag?.description
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $c3pId.default).isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "actions",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbfad8f157ab583f$export$2e2bcd8739ae039), {
                            namespace: namespace,
                            name: name,
                            condensed: false,
                            onComplete: handleActionComplete,
                            versionCount: versions.length,
                            isPublic: isPublic
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($e4688a1d9d0979e6$var$HR, {}),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($e4688a1d9d0979e6$var$Details, {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($e4688a1d9d0979e6$var$Main, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                                value: tab,
                                "aria-label": "App details tabs",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2b094bc5a886ac78$exports))), {
                                                    fontSize: "small"
                                                }),
                                                "\xa0Science Overview"
                                            ]
                                        }),
                                        value: "science",
                                        component: (0, $lzNIT.Link),
                                        to: "?tab=science",
                                        replace: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aebdc3f8d04c064a$exports))), {
                                                    fontSize: "small"
                                                }),
                                                "\xa0Input Arguments"
                                            ]
                                        }),
                                        value: "inputs",
                                        component: (0, $lzNIT.Link),
                                        to: "?tab=inputs",
                                        replace: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d9d39c15fde07a1c$exports))), {
                                                    fontSize: "small"
                                                }),
                                                "\xa0Tagged Versions (",
                                                versions.length,
                                                ")"
                                            ]
                                        }),
                                        value: "tags",
                                        component: (0, $lzNIT.Link),
                                        to: "?tab=tags",
                                        replace: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                                        label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c36a0b95bd5999f0$exports))), {
                                                    fontSize: "small"
                                                }),
                                                "\xa0Data"
                                            ]
                                        }),
                                        value: "data",
                                        component: (0, $lzNIT.Link),
                                        to: "?tab=data",
                                        replace: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            tab == 'science' && /*#__PURE__*/ (0, $ayMG0.jsx)($e4688a1d9d0979e6$var$Science, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: sciHtml
                                    }
                                })
                            }),
                            tab == 'science' && sciHtml == null && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "muted",
                                children: "No science description available for this app."
                            }),
                            tab == 'inputs' && versions.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99958fa69128e58e$export$2e2bcd8739ae039), {
                                versions: versions
                            }),
                            tab == 'tags' && versions.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1465055af5cdf337$export$2e2bcd8739ae039), {
                                versions: versions
                            }),
                            tab == 'data' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de04a124219a92c5$export$2e2bcd8739ae039), {
                                plugin: path
                            })
                        ]
                    }),
                    latestTag && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7730932b4f5accb$export$2e2bcd8739ae039), {
                        data: latestTag
                    })
                ]
            })
        ]
    });
}
const $e4688a1d9d0979e6$var$Root = (0, $d8seH.default)('div')`
  padding: 20px 0px;
`;
const $e4688a1d9d0979e6$var$HR = (0, $d8seH.default)((0, $lkxXU.default))`
  margin: 2em 0 0 0;
`;
const $e4688a1d9d0979e6$var$Details = (0, $d8seH.default)('div')`
`;
const $e4688a1d9d0979e6$var$Main = (0, $d8seH.default)('div')`
  width: 100%;
`;
const $e4688a1d9d0979e6$var$Science = (0, $d8seH.default)('div')`
  position: relative;
  width: 100%;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $lzNIT = parcelRequire("lzNIT");

var $lmFrL = parcelRequire("lmFrL");

var $iAtns = parcelRequire("iAtns");

var $6lXkL = parcelRequire("6lXkL");

var $cVXaD = parcelRequire("cVXaD");

var $i32L9 = parcelRequire("i32L9");

var $2esSG = parcelRequire("2esSG");
var $ba571672f7b8a33c$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ba571672f7b8a33c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ba571672f7b8a33c$exports, "__esModule", {
    value: true
});
$ba571672f7b8a33c$exports.default = void 0;

var $ba571672f7b8a33c$var$_createSvgIcon = $ba571672f7b8a33c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ba571672f7b8a33c$var$_default = $ba571672f7b8a33c$exports.default = (0, $ba571672f7b8a33c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');



var $bFBmv = parcelRequire("bFBmv");

var $eAebc = parcelRequire("eAebc");
var $e6d2a2f5f6be5770$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e6d2a2f5f6be5770$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e6d2a2f5f6be5770$exports, "__esModule", {
    value: true
});
$e6d2a2f5f6be5770$exports.default = void 0;

var $e6d2a2f5f6be5770$var$_createSvgIcon = $e6d2a2f5f6be5770$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e6d2a2f5f6be5770$var$_default = $e6d2a2f5f6be5770$exports.default = (0, $e6d2a2f5f6be5770$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m21.41 11.58-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42M13 20.01 4 11V4h7v-.01l9 9z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "6.5",
        cy: "6.5",
        r: "1.5"
    }, "1")
], 'LocalOfferOutlined');



var $7upBl = parcelRequire("7upBl");

var $2sxTc = parcelRequire("2sxTc");

var $24m81 = parcelRequire("24m81");

var $3X9tg = parcelRequire("3X9tg");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $gd5y7 = parcelRequire("gd5y7");

var $iAtns = parcelRequire("iAtns");

var $OEVqP = parcelRequire("OEVqP");

var $cX7V2 = parcelRequire("cX7V2");

var $2iAqv = parcelRequire("2iAqv");

var $c3pId = parcelRequire("c3pId");

const $4f79c756e347622c$var$user = (0, $c3pId.default).user;
function $4f79c756e347622c$export$2e2bcd8739ae039(props) {
    const { form: form, onChange: onChange } = props;
    const [isValid, setIsValid] = (0, $acw62.useState)(true);
    const handleNameChange = (evt)=>{
        const name = evt.target.value;
        const isValid = /^[a-z0-9_-]*$/.test(name);
        setIsValid(isValid);
        onChange(evt);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4f79c756e347622c$var$Form, {
        className: "flex column",
        autoComplete: "off",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex row",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                            id: "namespace-label",
                            required: true,
                            children: "Namespace"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                            labelId: "namespace-label",
                            name: "namespace",
                            value: form.namespace,
                            onChange: (evt)=>onChange(evt),
                            style: {
                                width: 125
                            },
                            label: "Namespace *",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: $4f79c756e347622c$var$user,
                                    children: $4f79c756e347622c$var$user
                                }),
                                (0, $4f79c756e347622c$export$2e2bcd8739ae039) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                    value: "waggle",
                                    children: "waggle"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($4f79c756e347622c$var$Slash, {
                    children: "\xa0/\xa0"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    label: "Name",
                    name: "name",
                    value: form.name,
                    onChange: handleNameChange,
                    placeholder: "my-app",
                    error: !isValid,
                    helperText: !isValid && 'Only lowercase letters, numbers, "-", or "_" allowed',
                    required: true,
                    slotProps: {
                        inputLabel: {
                            shrink: true
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    label: "Version",
                    name: "version",
                    value: form.version,
                    onChange: onChange,
                    style: {
                        width: 125,
                        marginLeft: 10
                    },
                    placeholder: "1.x (optional)",
                    slotProps: {
                        inputLabel: {
                            shrink: true
                        }
                    }
                })
            ]
        })
    });
}
const $4f79c756e347622c$var$Form = (0, $lmFrL.default).form`
  .MuiTextField-root, .MuiFormControl-root {
    margin: 10px 0;
  }
`;
const $4f79c756e347622c$var$Slash = (0, $lmFrL.default).div`
  height: 40px;
  font-size: 40px;
  color: #888;
`;



var $eo4xm = parcelRequire("eo4xm");

var $5xexf = parcelRequire("5xexf");

var $c3pId = parcelRequire("c3pId");

var $atFJM = parcelRequire("atFJM");

var $acw62 = parcelRequire("acw62");

var $ecxdi = parcelRequire("ecxdi");
function $0467c85c2f7adf78$export$2e2bcd8739ae039() {
    const [isApproved, setIsApproved] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        $ecxdi.getUserDetails().then((user)=>setIsApproved(user.is_approved)).catch(()=>setIsApproved(false));
    }, []);
    return {
        isApproved: isApproved
    };
}



var $gZwVy = parcelRequire("gZwVy");
const { contactUs: $524e274d44800e0c$var$contactUs, docs: $524e274d44800e0c$var$docs } = (0, $gZwVy.default);
const $524e274d44800e0c$var$user = (0, $c3pId.default).user;
const $524e274d44800e0c$var$devList = [
    'nconrad',
    'gemblerz',
    'seanshahkarami',
    'jswantek'
];
const $524e274d44800e0c$export$325ca01a5dd409db = $524e274d44800e0c$var$devList.includes($524e274d44800e0c$var$user);
const $524e274d44800e0c$var$GITHUB_API = 'https://api.github.com';
const $524e274d44800e0c$var$GITHUB_STATIC_URL = 'https://raw.githubusercontent.com';
const $524e274d44800e0c$var$SAGE_YAML_DOCS_URL = `https://github.com/waggle-sensor/pywaggle/blob/main/docs/writing-a-plugin.md` + `#adding-hello-world-plugin-packaging-info`;
const $524e274d44800e0c$var$EXAMPLES = {
    'hello': 'https://github.com/waggle-sensor/plugin-helloworld-ml',
    'motion': 'https://github.com/waggle-sensor/plugin-motion-analysis',
    'birdnet': 'https://github.com/dariodematties/BirdNET_Plugin'
};
const $524e274d44800e0c$var$getRepoPath = (url)=>url.replace('https://github.com/', '').replace('.git', '');
const $524e274d44800e0c$var$invalidCommit = (gitCommit)=>gitCommit && gitCommit.length != 40;
// const invalidCommitMsg = 'Invalid Git commit hash.  String must be 40 chars long.'
const $524e274d44800e0c$var$initialState = {
    namespace: $524e274d44800e0c$var$user,
    // name: '',     // populated automatically
    // version: '',  // populated automatically
    description: '',
    source: {
        architectures: [],
        directory: '',
        dockerfile: '',
        url: '',
        branch: ''
    },
    url: '',
    directory: '',
    resources: [],
    inputs: [],
    metadata: {}
};
function $524e274d44800e0c$export$2e2bcd8739ae039() {
    const navigate = (0, $aphAM.useNavigate)();
    const [params] = (0, $lzNIT.useSearchParams)() // {url: string, branch: string}
    ;
    const { enqueueSnackbar: enqueueSnackbar } = (0, $24m81.useSnackbar)();
    // app repo
    const [repoURL, setRepoURL] = (0, $acw62.useState)(params.get('url') || '');
    const [branch, setBranch] = (0, $acw62.useState)('main');
    const [gitCommit, setGitCommit] = (0, $acw62.useState)(null);
    const [branchList, setBranchList] = (0, $acw62.useState)([]);
    // app config state
    const [form, setForm] = (0, $acw62.useState)($524e274d44800e0c$var$initialState);
    const [config, setConfig] = (0, $acw62.useState)($2sxTc.stringify($524e274d44800e0c$var$initialState));
    const [configType, setConfigType] = (0, $acw62.useState)(null);
    const [validating, setValidating] = (0, $acw62.useState)(false);
    const [isValid, setIsValid] = (0, $acw62.useState)(null);
    const { isApproved: isApproved } = (0, $0467c85c2f7adf78$export$2e2bcd8739ae039)();
    const [isRegistering, setIsRegistering] = (0, $acw62.useState)(false);
    const [isBuilding, setIsBuilding] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    // debug settings
    const [devMode, setDevMode] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        handleRepoVerify().then(()=>{
            if (params.get('branch')) setBranch(params.get('branch'));
        });
    }, [
        params
    ]);
    const fetchSageConfig = (0, $acw62.useCallback)((branchOrCommit)=>{
        if (!repoURL || !branchOrCommit) return;
        const path = $524e274d44800e0c$var$getRepoPath(repoURL);
        fetch(`${$524e274d44800e0c$var$GITHUB_STATIC_URL}/${path}/${branchOrCommit}/sage.yaml`).then((res)=>{
            // set config type
            const type = res.status == 404 ? 'none' : res.url.slice(res.url.lastIndexOf('.') + 1);
            setConfigType(type);
            // set form/config
            res.text().then((text)=>{
                if (text == '404: Not Found') {
                    setError(true);
                    return;
                }
                let obj = $2sxTc.parse(text);
                obj = sanitizeForm(obj);
                // update config with repo url and branch (or commit)
                obj.source.url = repoURL;
                if (gitCommit) {
                    obj.source.git_commit = gitCommit;
                    delete obj.source.branch;
                } else obj.source.branch = obj.source.branch || branchOrCommit;
                setForm(obj);
                setConfig($2sxTc.stringify(obj));
            });
        }).catch(()=>setConfigType('none'));
    }, [
        repoURL,
        gitCommit
    ]);
    // remove all verification/error state on changes
    (0, $acw62.useEffect)(()=>{
        setError(null);
        setGitCommit(null);
    }, [
        repoURL,
        config
    ]);
    // if repo url changes, force user to reverify
    (0, $acw62.useEffect)(()=>{
        setIsValid(null);
    }, [
        repoURL
    ]);
    (0, $acw62.useEffect)(()=>{
        if ($524e274d44800e0c$var$invalidCommit(gitCommit)) return;
        fetchSageConfig(gitCommit);
    }, [
        gitCommit,
        fetchSageConfig
    ]);
    const handleRepoVerify = (evt = null)=>{
        if (evt) evt.preventDefault();
        const path = $524e274d44800e0c$var$getRepoPath(repoURL);
        // todo: add rate limit notice, add branch?
        setValidating(true);
        const prom = fetch(`${$524e274d44800e0c$var$GITHUB_API}/repos/${path}`).then((res)=>{
            setIsValid(res.ok);
            return res.json();
        }).then((data)=>{
            // set branch dropdown to github default branch
            const branch = data.default_branch;
            setBranch(branch);
            // fetch branches for dropdown (this will be tags in future?)
            fetch(data.branches_url.replace('{/branch}', '')).then((res)=>res.json()).then((branches)=>{
                const opts = branches.map((b)=>b.name).map((name)=>({
                        id: name,
                        label: name
                    }));
                setBranchList(opts);
            });
            fetchSageConfig(branch);
        }).catch(()=>setIsValid(false)).then(()=>setValidating(false));
        return prom;
    };
    const onRepoBranchChange = (tagObj)=>{
        if (!tagObj) return;
        setBranch(tagObj.id);
        setIsValid(true);
        fetchSageConfig(tagObj.id);
    };
    /*
  const onGitCommitChange = (evt) => {
    if (invalidCommit(gitCommit)) {
      setError(invalidCommitMsg)
    }

    const hash = evt.target.value
    setGitCommit(hash)
  }
  */ const sanitizeForm = (obj)=>{
        return {
            ...obj,
            namespace: $524e274d44800e0c$var$user
        };
    };
    const onRegister = ()=>{
        setIsRegistering(true);
        $atFJM.register(config).then(()=>{
            enqueueSnackbar('App registered', {
                variant: 'success'
            });
            navigate('/apps/my-apps');
        }).catch((error)=>{
            error.message.includes('force=true');
            setError(error.message);
        }).finally(()=>setIsRegistering(false));
    };
    const onBuild = ()=>{
        setIsBuilding(true);
        $atFJM.registerAndBuild(config).then(()=>{
            enqueueSnackbar('Build started');
            navigate('/apps/my-apps');
        }).catch((error)=>{
            setError(error.message);
        }).finally(()=>setIsBuilding(false));
    };
    const onUpdateForm = (event)=>{
        const { name: name, value: value } = event.target;
        const f = {
            ...form,
            [name]: value
        };
        setForm(f);
        setConfig($2sxTc.stringify(f));
    };
    const disableRegister = ()=>!form.namespace || !form.name || !isValid || configType == 'none' || isRegistering || isBuilding || error || $524e274d44800e0c$var$invalidCommit(gitCommit);
    const disableBuild = ()=>!isApproved || disableRegister();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($524e274d44800e0c$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($524e274d44800e0c$var$Main, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: "Create App"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                        icon: "1",
                        label: "Repo URL"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepForm), {
                        className: "repo-step flex column gap",
                        onSubmit: handleRepoVerify,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "GitHub Repo URL",
                                    placeholder: "https://github.com/me/my-edge-app",
                                    value: repoURL,
                                    onChange: (evt)=>setRepoURL(evt.target.value),
                                    error: isValid == false,
                                    helperText: isValid == false ? 'Sorry, we could not verify github repo url' : '',
                                    style: {
                                        width: 500
                                    },
                                    required: true,
                                    slotProps: {
                                        inputLabel: {
                                            shrink: true
                                        }
                                    }
                                }),
                                repoURL && !isValid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    onClick: handleRepoVerify,
                                    variant: "contained",
                                    color: "primary",
                                    children: validating ? 'Validating...' : 'Verify'
                                }),
                                isValid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                                        options: branchList,
                                        multiple: false,
                                        onChange: onRepoBranchChange,
                                        value: {
                                            id: branch,
                                            label: branch
                                        },
                                        headerText: "Select a different branch",
                                        ButtonComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                                            style: {
                                                marginLeft: 10
                                            },
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e6d2a2f5f6be5770$exports))), {}),
                                            children: [
                                                branch,
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7upBl))), {})
                                            ]
                                        }),
                                        disabled: gitCommit
                                    })
                                }),
                                isValid && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ba571672f7b8a33c$exports))), {
                                    className: "success"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                        icon: "2",
                        label: "App Name and Version"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.Step), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4f79c756e347622c$export$2e2bcd8739ae039), {
                            form: form,
                            onChange: onUpdateForm
                        })
                    }),
                    isValid && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3X9tg.Step), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: "App Config"
                            }),
                            configType == 'none' && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    "No ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mono-term",
                                        children: "sage.yaml"
                                    }),
                                    " configuration file found. Before registering or building your app, please create a sage.yaml following the directions ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: $524e274d44800e0c$var$SAGE_YAML_DOCS_URL,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "here"
                                        })
                                    }),
                                    "."
                                ]
                            }),
                            configType != 'none' && /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                className: "code",
                                children: config
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                                style: {
                                    fontSize: '1.1em'
                                },
                                error: true,
                                children: error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3X9tg.Step), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: onRegister,
                                variant: "outlined",
                                color: "primary",
                                disabled: disableRegister(),
                                className: "register-app",
                                children: isRegistering ? 'Registering...' : 'Register App'
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: onBuild,
                                variant: "contained",
                                color: "primary",
                                disabled: disableBuild(),
                                children: isBuilding ? 'Submitting...' : 'Register & Build App'
                            }),
                            isApproved === false && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                        children: "Note:"
                                    }),
                                    " You may register an application, but to enable builds of apps on our infrastructure, please ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                        href: $524e274d44800e0c$var$contactUs,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            "contact us",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                                className: "external-link"
                                            })
                                        ]
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($524e274d44800e0c$var$Help, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: "Help"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                        className: "no-padding list-none",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    href: `${$524e274d44800e0c$var$docs}/tutorials/edge-apps/intro-to-edge-apps`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        "Intro to edge apps",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                            className: "external-link"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    href: `${$524e274d44800e0c$var$docs}/tutorials/edge-apps/creating-an-edge-app`,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        "Creating an edge app",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                            className: "external-link"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    $524e274d44800e0c$export$325ca01a5dd409db && /*#__PURE__*/ (0, $ayMG0.jsxs)($524e274d44800e0c$var$DebugOptions, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                                className: "no-margin",
                                children: [
                                    "Debugging",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("sup", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: `These special debug mode options are only available to: ${$524e274d44800e0c$var$devList.join(', ')}`,
                                            placement: "top",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eAebc))), {
                                                fontSize: "small"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                    checked: devMode,
                                    onChange: (evt)=>setDevMode(evt.target.checked)
                                }),
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: "Show form state"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                children: "Example Apps:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                className: "no-padding list-none",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                onClick: ()=>setRepoURL($524e274d44800e0c$var$EXAMPLES.hello),
                                                children: "Helloworld ML"
                                            }),
                                            " [master branch]"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                onClick: ()=>setRepoURL($524e274d44800e0c$var$EXAMPLES.motion),
                                                children: "Motion Analysis"
                                            }),
                                            " [multiple branches]"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                onClick: ()=>setRepoURL($524e274d44800e0c$var$EXAMPLES.birdnet),
                                                children: "BirdNet"
                                            }),
                                            " [main branch]"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    devMode && /*#__PURE__*/ (0, $ayMG0.jsx)($524e274d44800e0c$var$Debug, {
                        form: form
                    })
                ]
            })
        ]
    });
}
const $524e274d44800e0c$var$Root = (0, $lmFrL.default).div`
  display: flex;
  margin: 0 25px;
`;
const $524e274d44800e0c$var$Main = (0, $lmFrL.default).div`
  margin: 10px 0;
  flex-grow: 3;

  .repo-step {
    margin-top: 6px;
    button, svg {
      margin-left: 10px;
    }
  }

  .register-app {
    margin-right: 10px;
  }
`;
const $524e274d44800e0c$var$Help = (0, $lmFrL.default).div`
  margin: 20px 0;
  flex-grow: 1;
  max-width: 300px;
`;
const $524e274d44800e0c$var$DebugOptions = (0, $lmFrL.default).div`
  margin-top: 75px;
`;
function $524e274d44800e0c$var$Debug(props) {
    const { form: form } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($524e274d44800e0c$var$DebugRoot, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: "Form State (Debug Mode)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                className: "code",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(form, null, 2).replace(/\\n/g, '<br/>')
                }
            })
        ]
    });
}
const $524e274d44800e0c$var$DebugRoot = (0, $lmFrL.default).div`
  pre {
    overflow: scroll;
    font-size: .7em;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $fagfG = parcelRequire("fagfG");
var $d8seH = parcelRequire("d8seH");

var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $72cb569b8b57c40c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5m10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11"
    }, "1")
], 'AccountCircleOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f844ce4c5a1a92c5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'CheckCircleOutline');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $36ccf536c539c8a0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v2h-4V5zM9 5v6H5V5zm10 8v6h-4v-6zM9 17v2H5v-2zM21 3h-8v6h8zM11 3H3v10h8zm10 8h-8v10h8zm-10 4H3v6h8z"
}), 'DashboardOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a326420a66b9276c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.25 12.5 4.75 9H3.5v6h1.25v-3.5L7.3 15h1.2V9H7.25zM9.5 15h4v-1.25H11v-1.11h2.5v-1.26H11v-1.12h2.5V9h-4zm9.75-6v4.5h-1.12V9.99h-1.25v3.52h-1.13V9H14.5v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9z"
}), 'FiberNewOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $efc7aacb001bb1b7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5M4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12m0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7m7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44M15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35"
}), 'GroupOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $19477c5c1a8aa609$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5zm1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"
}), 'ListAlt');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $41decd48a00f1aa4$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 5h2V3c-1.1 0-2 .9-2 2m0 8h2v-2H3zm4 8h2v-2H7zM3 9h2V7H3zm10-6h-2v2h2zm6 0v2h2c0-1.1-.9-2-2-2M5 21v-2H3c0 1.1.9 2 2 2m-2-4h2v-2H3zM9 3H7v2h2zm2 18h2v-2h-2zm8-8h2v-2h-2zm0 8c1.1 0 2-.9 2-2h-2zm0-12h2V7h-2zm0 8h2v-2h-2zm-4 4h2v-2h-2zm0-16h2V3h-2zM7 17h10V7H7zm2-8h6v6H9z"
}), 'SelectAll');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3c320837f6ba03a0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.54 8.54c.35.35.37.88.1 1.29C8.24 10.45 8 11.2 8 12s.24 1.55.64 2.17c.27.41.24.95-.11 1.29-.43.43-1.17.4-1.51-.11C6.38 14.4 6 13.24 6 12c0-1.21.36-2.33.97-3.28.36-.54 1.11-.64 1.57-.18m6.92 6.92c.43.43 1.17.4 1.51-.11C17.62 14.4 18 13.24 18 12s-.38-2.4-1.03-3.36c-.34-.5-1.08-.54-1.51-.11-.35.35-.37.88-.11 1.29.41.63.65 1.38.65 2.18s-.24 1.55-.64 2.17c-.27.41-.24.95.1 1.29M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6.32 8.32c.42.42 1.12.39 1.5-.08C21.18 16.53 22 14.36 22 12s-.82-4.53-2.18-6.24c-.37-.47-1.07-.5-1.5-.08-.36.36-.4.92-.08 1.32 1.1 1.37 1.76 3.11 1.76 5s-.66 3.63-1.76 5c-.32.39-.28.96.08 1.32M5.68 5.68c-.42-.42-1.12-.39-1.5.08C2.82 7.47 2 9.64 2 12s.82 4.53 2.18 6.24c.37.47 1.07.5 1.5.08.36-.36.4-.92.08-1.32C4.66 15.63 4 13.89 4 12s.66-3.63 1.76-5c.32-.39.28-.96-.08-1.32"
}), 'SensorsRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cdbaae095ceb82e8$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    fillRule: "evenodd",
    d: "M14 6V4h-4v2zM4 8v11h16V8zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2z"
}), 'WorkOutline');



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $dce3f69302df64fe$var$SvgHardDrive = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "#5f6368",
        viewBox: "0 -960 960 960",
        ...props,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M160-280h640v-240H160zm520-60q25 0 42.5-17.5T740-400t-17.5-42.5T680-460t-42.5 17.5T620-400t17.5 42.5T680-340m200-260H767l-80-80H273l-80 80H80l137-137q11-11 25.5-17t30.5-6h414q16 0 30.5 6t25.5 17zM160-200q-33 0-56.5-23.5T80-280v-320h800v320q0 33-23.5 56.5T800-200z"
        })
    });
var $dce3f69302df64fe$export$2e2bcd8739ae039 = $dce3f69302df64fe$var$SvgHardDrive;



var $c3pId = parcelRequire("c3pId");

var $ayMG0 = parcelRequire("ayMG0");

var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $lzNIT = parcelRequire("lzNIT");

var $acw62 = parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $48660cdefc9954f1$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $20ead04f3e1b7da9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $934716524eb29958$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');



var $gTmRg = parcelRequire("gTmRg");

var $gA7Iw = parcelRequire("gA7Iw");
const $a111e4fc257fd7f3$var$AnimatedSidebar = (0, $d8seH.default)((0, $gTmRg.Sidebar))`
  transition: width .5s ease;
  position: fixed;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  /* Hide content that overflows during animation */
  .nav-label {
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  /* Delay showing labels when expanding */
  &[data-minimized="false"] .nav-label {
    transition-delay: 0.3s;
  }

  /* Hide labels immediately when minimizing */
  &[data-minimized="true"] .nav-label {
    opacity: 0;
    transition-delay: 0s;
  }
`;
const $a111e4fc257fd7f3$var$Item = (0, $d8seH.default)((0, $lzNIT.NavLink))`
  width: 100%;
  font-size: 1.1em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#bbb' : '#444'};
  border-right: 3px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'};
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  padding: 8px 4px 8px 0px;
  position: relative;

  span {
    opacity: 1;
    transition: opacity 0.3s ease 0.1s;
    white-space: nowrap;
  }

  /* Default expanded icon sizes */
  > div > .MuiSvgIcon-root,
  > div > svg {
    font-size: 2em;
  }

  &.indent {
    padding-left: 1rem;
    font-size: 0.9em;
  }

  &.indent > div > .MuiSvgIcon-root,
  &.indent > div > svg {
    font-size: 1.5em;
  }

  /* Minimized state with larger icons like apps/jobs sidebar */
  &.minimized {
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    gap: 2px;
    font-size: 0.9em; /* Override any font-size for consistent sizing */

    &.indent {
      padding: 10px;
      font-size: 0.9em; /* Ensure indent items have same base font-size */
    }

    .minimized-label {
      font-size: 1em;
      margin-top: 0;
      text-align: center;
    }

    > div > .MuiSvgIcon-root,
    > div > svg {
      font-size: 2.5em;
    }

    &.indent > div > .MuiSvgIcon-root,
    &.indent > div > svg {
      font-size: 2.5em;
    }
  }

  :hover{
    text-decoration: none;
    background-color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : '#f0f0f0'};
  }

  :hover:not(.active) {
    color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#000'};
  }

  &.active {
    border-right: 3px solid ${({ theme: theme })=>theme.palette.primary.main};
    border-top: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#333' : '#eee'};
    border-bottom: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#333' : '#eee'};

    background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : 'rgb(255, 255, 255)'};
    font-weight: 800;
  }

  &.active .MuiSvgIcon-root {
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $a111e4fc257fd7f3$var$MinimizeButtonWrapper = (0, $d8seH.default)('div')`
  display: flex;
  padding: 8px 8px 4px;
  border-bottom: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#333' : '#e0e0e0'};
  margin-bottom: 4px;

  &.minimized {
    justify-content: center;
    border-bottom: none;
    margin-bottom: 0;
  }
`;
const $a111e4fc257fd7f3$var$MinimizeButton = (0, $d8seH.default)((0, $9Lykx.default))`
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#888' : '#666'};
  background-color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)'};
  border-radius: 4px;
  padding: 4px;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    background-color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.06)'};
    transform: scale(1.05);
  }

  .MuiSvgIcon-root {
    font-size: 1.2rem;
  }

  .minimized & {
    background-color: transparent;
    border-radius: 0;
    padding: 0;
  }

  .minimized &:hover {
    background-color: transparent;
    transform: none;
  }
`;
const $a111e4fc257fd7f3$var$Nav = (0, $d8seH.default)('div')`
  margin-top: 0;
`;
const $a111e4fc257fd7f3$var$ExpandButton = ({ expanded: expanded, onToggle: onToggle })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
        size: "small",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onToggle();
        },
        sx: {
            padding: 0,
            minWidth: 'auto',
            position: 'absolute'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48660cdefc9954f1$export$2e2bcd8739ae039), {
            style: {
                transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                transition: 'transform 0.2s'
            }
        })
    });
function $a111e4fc257fd7f3$export$2e2bcd8739ae039({ navItems: navItems, storageKey: storageKey = 'sidebar.state', minimizedWidth: minimizedWidth = '75px', expandedWidth: expandedWidth = '160px', defaultExpanded: defaultExpanded = {}, itemIdGenerator: itemIdGenerator = (item)=>item !== 'divider' ? item.to || '' : '', onMinimizedChange: onMinimizedChange }) {
    const [minimized, setMinimized] = (0, $acw62.useState)(()=>{
        const stored = $gA7Iw.get(storageKey);
        if (stored) {
            const parsed = JSON.parse(stored);
            return typeof parsed === 'object' ? parsed.minimized ?? false : parsed;
        }
        return false;
    });
    const [expandedItems, setExpandedItems] = (0, $acw62.useState)(()=>{
        const stored = $gA7Iw.get(storageKey);
        if (stored) {
            const parsed = JSON.parse(stored);
            return typeof parsed === 'object' ? parsed.expanded ?? defaultExpanded : defaultExpanded;
        }
        return defaultExpanded;
    });
    (0, $acw62.useEffect)(()=>{
        $gA7Iw.set(storageKey, {
            minimized: minimized,
            expanded: expandedItems
        });
        onMinimizedChange?.(minimized);
    }, [
        minimized,
        expandedItems,
        storageKey,
        onMinimizedChange
    ]);
    const toggleMinimized = ()=>{
        setMinimized(!minimized);
    };
    const toggleExpanded = (itemId)=>{
        setExpandedItems((prev)=>({
                ...prev,
                [itemId]: !prev[itemId]
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a111e4fc257fd7f3$var$AnimatedSidebar, {
        width: minimized ? minimizedWidth : expandedWidth,
        "data-minimized": minimized,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a111e4fc257fd7f3$var$MinimizeButtonWrapper, {
                className: minimized ? 'minimized' : 'flex justify-end',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a111e4fc257fd7f3$var$MinimizeButton, {
                    onClick: toggleMinimized,
                    size: "small",
                    children: minimized ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $934716524eb29958$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20ead04f3e1b7da9$export$2e2bcd8739ae039), {})
                })
            }),
            minimized && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                sx: {
                    margin: '10px 0'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a111e4fc257fd7f3$var$Nav, {
                children: navItems.map((item, index)=>{
                    if (item == 'divider') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        sx: {
                            margin: '10px 0'
                        }
                    }, `divider-${index}`);
                    // Skip child items if parent is collapsed
                    if (item.parentId && !expandedItems[item.parentId]) return null;
                    const itemId = itemIdGenerator(item);
                    const isExpanded = expandedItems[itemId] ?? item.expanded;
                    const itemContent = /*#__PURE__*/ (0, $ayMG0.jsxs)($a111e4fc257fd7f3$var$Item, {
                        to: item.to,
                        className: `flex items-center ${minimized ? 'gap minimized' : ''}${item.indent ? ' indent' : ''}`,
                        end: true,
                        children: [
                            item.expandable && !minimized && /*#__PURE__*/ (0, $ayMG0.jsx)($a111e4fc257fd7f3$var$ExpandButton, {
                                expanded: isExpanded,
                                onToggle: ()=>toggleExpanded(itemId)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    marginLeft: item.expandable && !minimized ? '1.5rem' : minimized ? '0' : '1.5rem'
                                },
                                className: "flex items-center",
                                children: item.icon
                            }),
                            !minimized ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "nav-label",
                                style: {
                                    marginLeft: '.5rem'
                                },
                                children: item.label
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "minimized-label",
                                children: item.minimizedLabel || item.label
                            })
                        ]
                    }, item.to);
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: item.tooltip || item.label,
                        placement: "right",
                        enterDelay: 0,
                        children: itemContent
                    }, item.to);
                })
            })
        ]
    });
}



var $acw62 = parcelRequire("acw62");
const $750b876e77c164e1$var$userBadgeSx = {
    '& .MuiBadge-badge': {
        backgroundColor: (theme)=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5',
        color: 'inherit',
        right: 6,
        top: 4,
        borderRadius: '50%',
        minWidth: 'auto',
        width: '0.9em',
        height: '0.9em',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};
const $750b876e77c164e1$var$getNavItems = (includeSensors, search)=>{
    let items = [
        {
            to: `nodes/all`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41decd48a00f1aa4$export$2e2bcd8739ae039), {}),
            label: 'All Nodes',
            tooltip: 'All Nodes',
            expandable: true,
            expanded: false
        },
        {
            to: `nodes/all/sgt`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a326420a66b9276c$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '1.5em'
                    }
                }),
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                overlap: "circular",
                sx: $750b876e77c164e1$var$userBadgeSx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce3f69302df64fe$export$2e2bcd8739ae039), {})
            }),
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "SGT"
            }),
            tooltip: 'Sage Grande Testbed Nodes',
            minimizedLabel: 'SGT',
            indent: true,
            parentId: 'nodes/all'
        },
        {
            to: `nodes/all/sage`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce3f69302df64fe$export$2e2bcd8739ae039), {}),
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Sage"
            }),
            tooltip: 'Sage Nodes',
            indent: true,
            parentId: 'nodes/all'
        },
        // ------------------------------
        {
            to: `nodes`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f844ce4c5a1a92c5$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '1.2em'
                    }
                }),
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                overlap: "circular",
                sx: $750b876e77c164e1$var$userBadgeSx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $19477c5c1a8aa609$export$2e2bcd8739ae039), {})
            }),
            label: 'Status',
            tooltip: 'Node Status',
            expandable: true,
            expanded: true
        },
        {
            to: `nodes/project/sgt`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f844ce4c5a1a92c5$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '1.2em'
                    }
                }),
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                overlap: "circular",
                sx: $750b876e77c164e1$var$userBadgeSx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce3f69302df64fe$export$2e2bcd8739ae039), {})
            }),
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "SGT"
            }),
            tooltip: 'Sage Grande Testbed Nodes',
            minimizedLabel: 'SGT',
            indent: true,
            parentId: 'nodes'
        },
        {
            to: `nodes/project/sage`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f844ce4c5a1a92c5$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '1.2em'
                    }
                }),
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                overlap: "circular",
                sx: $750b876e77c164e1$var$userBadgeSx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce3f69302df64fe$export$2e2bcd8739ae039), {})
            }),
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Sage"
            }),
            tooltip: 'Sage Nodes',
            indent: true,
            parentId: 'nodes'
        }
    ];
    if (includeSensors) items = [
        ...items,
        {
            to: `sensors${search}`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c320837f6ba03a0$export$2e2bcd8739ae039), {}),
            label: 'Sensors'
        }
    ];
    items = [
        ...items,
        'divider',
        {
            to: `user/${(0, $c3pId.default).user}/dash`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $36ccf536c539c8a0$export$2e2bcd8739ae039), {}),
            label: 'Dash',
            tooltip: 'My Dashboard'
        },
        {
            to: `user/${(0, $c3pId.default).user}/nodes?show_all=true`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72cb569b8b57c40c$export$2e2bcd8739ae039), {}),
            label: 'My Nodes',
            expandable: true,
            expanded: false
        },
        {
            to: `user/${(0, $c3pId.default).user}/nodes/project/sgt?show_all=true`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72cb569b8b57c40c$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '1.4em'
                    }
                }),
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                overlap: "circular",
                sx: $750b876e77c164e1$var$userBadgeSx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce3f69302df64fe$export$2e2bcd8739ae039), {})
            }),
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "SGT"
            }),
            tooltip: 'My SGT Nodes',
            minimizedLabel: 'My SGT Nodes',
            indent: true,
            parentId: 'user/nodes'
        },
        {
            to: `user/${(0, $c3pId.default).user}/nodes/project/sage?show_all=true`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fagfG.default), {
                badgeContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72cb569b8b57c40c$export$2e2bcd8739ae039), {
                    style: {
                        fontSize: '1.4em'
                    }
                }),
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                overlap: "circular",
                sx: $750b876e77c164e1$var$userBadgeSx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dce3f69302df64fe$export$2e2bcd8739ae039), {})
            }),
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Sage"
            }),
            tooltip: 'My Sage Nodes',
            minimizedLabel: 'My Sage Nodes',
            indent: true,
            parentId: 'user/nodes'
        }
    ];
    if ((0, $c3pId.default).isSignedIn) items = [
        ...items,
        {
            to: `user/${(0, $c3pId.default).user}/projects`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdbaae095ceb82e8$export$2e2bcd8739ae039), {}),
            label: 'Projects',
            tooltip: 'My Projects'
        },
        {
            to: `user/${(0, $c3pId.default).user}/teams`,
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efc7aacb001bb1b7$export$2e2bcd8739ae039), {}),
            label: 'Members',
            tooltip: 'My Teams'
        }
    ];
    return items;
};
function $750b876e77c164e1$export$2e2bcd8739ae039(props) {
    const { includeSensors: includeSensors = true } = props;
    const { search: search } = (0, $aphAM.useLocation)();
    const [minimized, setMinimized] = (0, $acw62.useState)(false);
    const navItems = $750b876e77c164e1$var$getNavItems(includeSensors, search);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($750b876e77c164e1$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a111e4fc257fd7f3$export$2e2bcd8739ae039), {
                navItems: navItems,
                storageKey: "nodeTabs.state",
                defaultExpanded: {
                    'nodes': true,
                    'user/nodes': false
                },
                itemIdGenerator: (item)=>{
                    if (item === 'divider') return '';
                    // ignore query params and user-specific paths for active state
                    return item.to?.split('?')[0]?.replace(`user/${(0, $c3pId.default).user}/nodes`, 'user/nodes') || '';
                },
                onMinimizedChange: setMinimized
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($750b876e77c164e1$var$Main, {
                $minimized: minimized,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
            })
        ]
    });
}
const $750b876e77c164e1$var$Root = (0, $d8seH.default)('div')`
  display: flex;
  height: 100%;
`;
const $750b876e77c164e1$var$Main = (0, $d8seH.default)('div')`
  padding: 0 20px;
  flex-grow: 1;
  overflow-y: auto;
  margin-left: ${({ $minimized: $minimized })=>$minimized ? '75px' : '160px'};
  transition: margin-left .5s ease;
`;


/* eslint-disable react/display-name */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $6lXkL = parcelRequire("6lXkL");

var $lkxXU = parcelRequire("lkxXU");

var $iwiZ3 = parcelRequire("iwiZ3");

var $2esSG = parcelRequire("2esSG");

var $cVXaD = parcelRequire("cVXaD");
var $5861ec10399b0856$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $5861ec10399b0856$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($5861ec10399b0856$exports, "__esModule", {
    value: true
});
$5861ec10399b0856$exports.default = void 0;

var $5861ec10399b0856$var$_createSvgIcon = $5861ec10399b0856$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $5861ec10399b0856$var$_default = $5861ec10399b0856$exports.default = (0, $5861ec10399b0856$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L3.71 8.71C3.08 8.08 2 8.52 2 9.41V15c0 .55.45 1 1 1h5.59c.89 0 1.34-1.08.71-1.71l-1.91-1.91c1.39-1.16 3.16-1.88 5.12-1.88 3.16 0 5.89 1.84 7.19 4.5.27.56.91.84 1.5.64.71-.23 1.07-1.04.75-1.72C20.23 10.42 16.65 8 12.5 8"
}), 'UndoRounded');



var $f1q41 = parcelRequire("f1q41");
/* eslint-disable react/display-name */ 
var $ayMG0 = parcelRequire("ayMG0");

var $aQAPf = parcelRequire("aQAPf");

var $eOilY = parcelRequire("eOilY");
const $c494113f591db146$var$PROJECT = (0, $aQAPf.default).project?.toLowerCase();
const $c494113f591db146$var$columns = [
    {
        id: 'status',
        label: 'Status',
        format: $eOilY.statusWithPhase,
        width: '1px'
    },
    {
        id: 'vsn',
        label: 'Node',
        format: $eOilY.vsnLinkWithEdit,
        width: '138px'
    },
    {
        id: 'type',
        label: 'Type',
        hide: $c494113f591db146$var$PROJECT != 'sage'
    },
    {
        id: 'focus',
        label: 'Focus',
        format: $eOilY.focus
    },
    {
        id: 'elapsedTimes',
        label: 'Last Reported Metrics',
        format: $eOilY.lastUpdated,
        hide: true
    },
    {
        id: 'uptimes',
        label: 'Uptime',
        format: $eOilY.uptimes,
        hide: true
    },
    {
        id: 'city',
        label: 'City',
        hide: true
    },
    {
        id: 'state',
        label: 'State',
        format: (val, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($eOilY.GPSIcon, {
                        obj: obj
                    }),
                    "\xa0",
                    val || '-'
                ]
            })
    },
    {
        id: 'gps',
        label: 'GPS',
        format: $eOilY.gps,
        dlFormat: (_, obj)=>obj.lat && obj.lng ? `${obj.lat}, ${obj.lng}` : '',
        hide: true
    },
    {
        id: 'alt',
        label: 'Elevation (m)',
        format: (val)=>{
            return val || '-';
        },
        hide: true
    },
    {
        id: 'sensors',
        label: 'Sensors',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eOilY.HardwareList, {
                data: val,
                path: "/sensors/"
            }),
        dlFormat: (val)=>val.map((v)=>v.hw_model).join(', '),
        hide: true
    },
    {
        id: 'sensorIcons',
        label: 'Sensor Capabilities',
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eOilY.SensorIcons, {
                data: obj.sensors
            }),
        dlFormat: (_, obj)=>{
            const caps = new Set();
            obj.sensors?.forEach((s)=>s.capabilities?.forEach((c)=>caps.add(c)));
            return Array.from(caps).sort().join(', ');
        }
    },
    {
        id: 'sensorModels',
        label: 'Sensor Models',
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eOilY.HardwareListSimple, {
                data: obj.sensors,
                path: "/sensors/"
            }),
        dlFormat: (_, obj)=>obj.sensors.map((v)=>v.hw_model).join(', '),
        hide: true
    },
    {
        id: 'sensorCapabilities',
        label: 'Sensor Capabilities',
        format: (val)=>val.join(', '),
        dlFormat: (val)=>val.join(', '),
        hide: true
    },
    {
        id: 'computes',
        label: 'Computes',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eOilY.HardwareList, {
                data: val
            }),
        dlFormat: (val)=>val.map((v)=>v.hw_model).join(', '),
        width: '200px',
        hide: true
    },
    {
        id: 'commissioned_at',
        label: 'Commission Time',
        hide: true,
        format: (val)=>val ? new Date(val).toLocaleString() : '-'
    },
    {
        id: 'modem_model',
        label: 'Modem',
        format: $eOilY.modem,
        hide: true
    },
    {
        id: 'modem_sim',
        label: 'Modem Sim',
        format: $eOilY.modemSim,
        hide: true
    }
];
if ($c494113f591db146$var$PROJECT != 'sage') $c494113f591db146$var$columns.splice(4, 0, {
    id: 'phase',
    label: 'Phase',
    hide: true
});
var $c494113f591db146$export$2e2bcd8739ae039 = $c494113f591db146$var$columns;



var $9bsRS = parcelRequire("9bsRS");
function $e7d96055c3aa1815$export$7351ae98fd71d438(params, opts) {
    const { initialState: initialState, exclude: exclude, multiple: multiple = true } = opts || {};
    const obj = {
        ...initialState
    };
    params.forEach((v, k)=>{
        if (initialState && !Object.keys(initialState).includes(k)) return;
        if (exclude?.includes(k)) return;
        if (multiple) try {
            // if val is a valid list of quoted strings, parse using json parser
            obj[k] = JSON.parse(`[${v}]`);
        } catch  {
            // otherwise store as is
            obj[k] = [
                v
            ];
        }
        else obj[k] = v;
    });
    return obj;
}


var $dd9814843bcd5416$export$2e2bcd8739ae039 = {
    elapsedThresholds: {
        fail: 360000,
        warning: 180000
    }
};



var $bcnr1 = parcelRequire("bcnr1");
const $626807995b044d88$var$ELAPSED_FAIL_THRES = (0, $dd9814843bcd5416$export$2e2bcd8739ae039).elapsedThresholds.fail;
function $626807995b044d88$export$d6ad891437e8c72c(data, state) {
    const filteredRows = data.filter((row)=>{
        let keep = true;
        for (const [field, filters] of Object.entries(state)){
            if (!filters.length) continue;
            if (Array.isArray(row[field])) {
                keep = new Set([
                    ...filters
                ].filter((x)=>new Set(row[field]).has(x))).size > 0;
                if (keep) break;
            }
            if (!filters.includes(row[field])) {
                keep = false;
                break;
            }
        }
        return keep;
    });
    return filteredRows;
}
function $626807995b044d88$var$getElapsedTimes(metrics) {
    const elapsedByHost = {};
    const mostRecent = {};
    Object.keys(metrics).forEach((host)=>{
        const uptimes = metrics[host]['sys.uptime'];
        // there may not be metrics in last x days
        if (!uptimes) return;
        const timestamp = uptimes[0].timestamp;
        // ensure the latest time per host is used; mostly for the factory
        if (mostRecent[host]?.localeCompare(timestamp)) return;
        const elapsedTime = new Date().getTime() - new Date(timestamp).getTime();
        elapsedByHost[host] = elapsedTime;
        mostRecent[host] = timestamp;
    });
    return elapsedByHost;
}
function $626807995b044d88$var$getNxMetric(metrics, serial, metricName) {
    if (!serial) return;
    // first find the nx host (16 chars + suffix)
    const host = $9bsRS.findHostWithSerial(Object.keys(metrics), serial);
    const m = (metrics[host] || {})[metricName];
    if (!m) return;
    const val = m.at(-1).value;
    return val;
}
function $626807995b044d88$var$getMetricsByHost(metrics, computes, metricName, latestOnly = true) {
    const valueObj = {};
    Object.keys(metrics).forEach((host)=>{
        const suffixEnding = host.split('-')[1] // example: '0123456789abcdef.ws-rpi' -> rpi
        ;
        const serial = computes.find((o)=>o.name == suffixEnding)?.serial_no;
        if (!serial) return;
        host = $9bsRS.findHostWithSerial(Object.keys(metrics), serial);
        const m = (metrics[host] || {})[metricName];
        if (!m) return;
        const val = latestOnly ? m.at(-1).value : m;
        valueObj[host] = val;
    });
    return valueObj;
}
function $626807995b044d88$export$5bf220bb94eb5a86(data) {
    if (!data) return {};
    let passed = 0, failed = 0;
    data.forEach((obj)=>{
        const { value: value } = obj;
        passed = value == 1 ? passed + 1 : passed;
        failed = value <= 0 ? failed + 1 : failed;
    });
    return {
        details: data.sort((a, b)=>a.timestamp.localeCompare(b.timestamp)),
        passed: passed,
        failed: failed
    };
}
function $626807995b044d88$export$49201f1a0694fe29(data) {
    if (!data) return {};
    let passed = 0, failed = 0;
    data.forEach((obj)=>{
        const { value: value } = obj;
        passed = value == 0 ? passed + 1 : passed;
        failed = value > 0 ? failed + 1 : failed;
    });
    return {
        details: data.sort((a, b)=>a.timestamp.localeCompare(b.timestamp)),
        passed: passed,
        failed: failed
    };
}
const $626807995b044d88$var$determineStatus = (nodeObj, elapsedTimes)=>{
    const { computes: computes, phase: phase } = nodeObj;
    if (phase == 'Maintenance') return 'degraded';
    const notReporting = computes.some(({ serial_no: serial_no, is_active: is_active })=>{
        // skip any inactive computes
        if (!is_active) return false;
        const host = $9bsRS.findHostWithSerial(Object.keys(elapsedTimes), serial_no);
        return !(host in elapsedTimes) || elapsedTimes[host] > $626807995b044d88$var$ELAPSED_FAIL_THRES;
    });
    if (phase == 'Deployed' && notReporting) return 'not reporting';
    else if (phase == 'Deployed' && !notReporting) return 'reporting';
    else return 'pending';
};
function $626807995b044d88$export$29859d30d52b47f6(data, records, health, sanity) {
    // If a VSN is changed, the data api will return latest records for each VSN.
    // So, we only consider metrics with VSNs which are known by "beekeeper"
    const vsns = data.map((o)=>o.vsn);
    const metrics = records.filter((m)=>vsns.includes(m.meta.vsn));
    const byNode = (0, $bcnr1.aggregateMetrics)(metrics);
    const joinedData = data.map((nodeObj)=>{
        const { vsn: vsn, computes: computes } = nodeObj;
        if (!byNode || !(vsn in byNode)) return {
            ...nodeObj,
            status: 'not reporting'
        };
        const metrics = byNode[vsn];
        const elapsedTimes = $626807995b044d88$var$getElapsedTimes(metrics);
        const nxSerial = computes.find((o)=>o.name == 'nxcore')?.serial_no;
        const temp = $626807995b044d88$var$getNxMetric(metrics, nxSerial, 'iio.in_temp_input');
        const liveLat = $626807995b044d88$var$getNxMetric(metrics, nxSerial, 'sys.gps.lat');
        const liveLon = $626807995b044d88$var$getNxMetric(metrics, nxSerial, 'sys.gps.lon');
        const alt = $626807995b044d88$var$getNxMetric(metrics, nxSerial, 'sys.gps.alt');
        const ip = Object.values($626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.net.ip'))[0];
        const { gps_lat: gps_lat, gps_lon: gps_lon } = nodeObj;
        return {
            ...nodeObj,
            temp: temp ? temp / 1000 : null,
            status: $626807995b044d88$var$determineStatus(nodeObj, elapsedTimes),
            elapsedTimes: elapsedTimes,
            hasStaticGPS: !!gps_lat && !!gps_lon,
            hasLiveGPS: !!liveLat && !!liveLon,
            lat: gps_lat || liveLat,
            lng: gps_lon || liveLon,
            gps_lat: gps_lat,
            gps_lon: gps_lon,
            liveLat: liveLat,
            liveLon: liveLon,
            alt: alt,
            ip: ip,
            uptimes: $626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.uptime'),
            memTotal: $626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.mem.total'),
            memFree: $626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.mem.free'),
            memAvail: $626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.mem.avail'),
            fsAvail: $626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.fs.avail', false),
            fsSize: $626807995b044d88$var$getMetricsByHost(metrics, computes, 'sys.fs.size', false),
            // cpu: getMetricsByHost(metrics, 'sys.cpu_seconds', false),
            // sysTimes: getMetricsByHost(metrics, 'sys.time'),
            // txBytes: getMetricsByHost(metrics, 'sys.net.tx_bytes', false),
            // txPackets: getMetricsByHost(metrics, 'sys.net.tx_packets', false),
            // rxBytes: getMetricsByHost(metrics, 'sys.net.rx_bytes', false),
            // rxPackets: getMetricsByHost(metrics, 'sys.net.rx_packets', false),
            health: {
                sanity: sanity ? $626807995b044d88$export$49201f1a0694fe29(sanity[vsn]) : {},
                health: health ? $626807995b044d88$export$5bf220bb94eb5a86(health[vsn]) : {}
            }
        };
    });
    return joinedData;
}
const $626807995b044d88$export$d4c72bab9d6cc13a = {
    status: [],
    project: [],
    city: [],
    state: [],
    focus: [],
    sensor: [],
    vsn: []
};
function $626807995b044d88$export$26893885d9a03bc4(params) {
    return (0, $e7d96055c3aa1815$export$7351ae98fd71d438)(params, {
        initialState: $626807995b044d88$export$d4c72bab9d6cc13a,
        exclude: [
            'query',
            'phase'
        ]
    });
}



var $gOa8m = parcelRequire("gOa8m");

var $eo4xm = parcelRequire("eo4xm");

var $7L4OA = parcelRequire("7L4OA");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $6ami2 = parcelRequire("6ami2");
function $177e9ab8fdb34313$export$2e2bcd8739ae039(props) {
    const { filterState: filterState, scroll: scroll, disableDelete: disableDelete, onDelete: onDelete } = props;
    const handleDelete = (field, filters, toRemove)=>{
        filters.splice(filters.indexOf(toRemove), 1);
        onDelete(field, filters);
    };
    const shouldDisableDelete = (field, filter)=>onDelete && disableDelete?.field == field && disableDelete?.filter == filter;
    const fields = Object.keys(filterState).filter((field)=>filterState[field].length);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($177e9ab8fdb34313$var$Root, {
        scroll: scroll,
        children: fields.map((field, i)=>{
            const filters = filterState[field];
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "part",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($177e9ab8fdb34313$var$FilterSet, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: field
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: " is "
                            }),
                            filters.map((filter, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            color: "primary",
                                            variant: "filled",
                                            size: "small",
                                            onDelete: shouldDisableDelete(field, filter) ? null : ()=>handleDelete(field, filters, filter),
                                            label: filter
                                        }),
                                        i !== filters.length - 1 && ' '
                                    ]
                                }, filter))
                        ]
                    }),
                    i !== fields.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: " and "
                    })
                ]
            }, field);
        })
    });
}
const $177e9ab8fdb34313$var$Root = (0, $lmFrL.default).div`
  margin: 2px 10px;

  ${(props)=>props.scroll ? `white-space: nowrap;
    overflow-x: scroll;
    height: 40px;` : ''}`;
const $177e9ab8fdb34313$var$FilterSet = (0, $lmFrL.default).span`
`;




var $f1q41 = parcelRequire("f1q41");
function $52fc2129eac6b28c$export$3c598703d99462f5(data, query) {
    return data.filter((row)=>Object.values(row).join('').toLowerCase().includes(query.toLowerCase()));
}
const $52fc2129eac6b28c$var$operation = {
    '<=': (a, b)=>a <= b,
    '>=': (a, b)=>a >= b,
    '!=': (a, b)=>a != b,
    '=': (a, b)=>a == b,
    '>': (a, b)=>a > b,
    '<': (a, b)=>a < b
};
function $52fc2129eac6b28c$export$d6ad891437e8c72c(data, rules) {
    let d = data;
    for (const rule of rules){
        const { name: name, value: value } = rule;
        if ('op' in rule) d = data.filter((row)=>$52fc2129eac6b28c$var$operation[rule['op']]((0, $f1q41.get)(row, name), value));
        else // assume range (value = [start, end])
        d = data.filter((row)=>$52fc2129eac6b28c$var$operation['>=']((0, $f1q41.get)(row, name), value[0])).filter((row)=>$52fc2129eac6b28c$var$operation['<=']((0, $f1q41.get)(row, name), value[1]));
    }
    return d;
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ecxdi = parcelRequire("ecxdi");
const $0ad5317c8f9b9985$var$PermissionContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $0ad5317c8f9b9985$export$86d2c930e35495d7(props) {
    const [isSuper, setIsSuper] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        // todo(nc): extend to other permissions
        $ecxdi.getUserDetails().then((user)=>setIsSuper(user.is_superuser)).catch(()=>setIsSuper(false));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0ad5317c8f9b9985$var$PermissionContext.Provider, {
        value: {
            isSuper: isSuper
        },
        children: props.children
    });
}
function $0ad5317c8f9b9985$export$fa63741f3dc98587() {
    const context = (0, $acw62.useContext)($0ad5317c8f9b9985$var$PermissionContext);
    if (context == undefined) throw new Error('useIsSuper must be used within a PermissionProvider');
    return context;
}



var $9bsRS = parcelRequire("9bsRS");

var $bcnr1 = parcelRequire("bcnr1");

var $ecxdi = parcelRequire("ecxdi");

var $c3pId = parcelRequire("c3pId");

var $aQAPf = parcelRequire("aQAPf");

var $5xexf = parcelRequire("5xexf");

var $eOilY = parcelRequire("eOilY");
const $c4f0e9a82b16d72b$var$TIME_OUT = 5000;
const $c4f0e9a82b16d72b$var$getOptions = (data, field)=>[
        ...new Set(data.map((obj)=>obj[field]))
    ].map((name)=>({
            id: name,
            label: name
        })).filter((o)=>o.id?.length);
// helper to filter against project/focuses in setting file
const $c4f0e9a82b16d72b$var$filterOn = (data, key)=>data.filter((o)=>o[key]?.toLowerCase() == (0, $aQAPf.default)[key]?.toLowerCase());
function $c4f0e9a82b16d72b$var$getProjectNodes(projectParam) {
    const { project: settingsProject, focus: focus, vsns: vsns } = (0, $aQAPf.default);
    const project = projectParam || settingsProject;
    return $9bsRS.getNodes({
        project: project
    }).then((data)=>{
        if (focus) data = $c4f0e9a82b16d72b$var$filterOn(data, 'focus');
        if (vsns) data = data.filter((o)=>(0, $aQAPf.default).vsns.includes(o.vsn));
        if (project.includes('SAGE')) data = data.filter((obj)=>[
                'Deployed',
                'Awaiting Deployment',
                'Maintenance'
            ].includes(obj.phase));
        return data;
    });
}
function $c4f0e9a82b16d72b$export$2e2bcd8739ae039() {
    const { sageProject: sageProject } = (0, $aphAM.useParams)();
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const { pathname: pathname } = (0, $aphAM.useLocation)();
    const { isSuper: isSuper } = (0, $0ad5317c8f9b9985$export$fa63741f3dc98587)();
    // Derived state from URL/pathname
    const isMyNodes = (0, $acw62.useMemo)(()=>{
        return (0, $c3pId.default).isSignedIn && !!pathname.match(/\/user\/[^/]+\/nodes/);
    }, [
        pathname
    ]);
    const all_nodes = pathname.startsWith('/nodes/all');
    const phase = params.get('phase');
    const query = params.get('query') || '';
    const show_all = params.get('show_all') === 'true';
    // Data state
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [filtered, setFiltered] = (0, $acw62.useState)(null);
    const [lastUpdate, setLastUpdate] = (0, $acw62.useState)(null);
    const [selected, setSelected] = (0, $acw62.useState)([]);
    // MyNodes-specific state
    const [userVsns, setUserVsns] = (0, $acw62.useState)(null);
    const [vsnToProjectsMap, setVsnToProjectsMap] = (0, $acw62.useState)(null);
    const [userProjectsList, setUserProjectsList] = (0, $acw62.useState)(null);
    const [myNodesReady, setMyNodesReady] = (0, $acw62.useState)(false);
    // Filter state
    const [filterState, setFilterState] = (0, $acw62.useState)({});
    const [updateID, setUpdateID] = (0, $acw62.useState)(0);
    // Memoized filter options
    const filterOptions = (0, $acw62.useMemo)(()=>{
        if (!data) return {};
        const sensorOptions = (0, $f1q41.uniqBy)(data.flatMap((o)=>o.sensors), 'hw_model').map((o)=>({
                id: o.hw_model,
                label: o.hw_model,
                subText: o.capabilities.join(', ')
            }));
        return {
            projects: isMyNodes && userProjectsList ? userProjectsList.map((p)=>({
                    id: p.name,
                    label: p.name
                })) : $c4f0e9a82b16d72b$var$getOptions(data, 'project'),
            focuses: $c4f0e9a82b16d72b$var$getOptions(data, 'focus'),
            cities: $c4f0e9a82b16d72b$var$getOptions(data, 'city'),
            states: $c4f0e9a82b16d72b$var$getOptions(data, 'state'),
            sensors: sensorOptions
        };
    }, [
        data,
        isMyNodes,
        userProjectsList
    ]);
    // Refs
    const dataRef = (0, $acw62.useRef)(null);
    dataRef.current = data;
    // Load user projects data for MyNodes view
    (0, $acw62.useEffect)(()=>{
        if (!isMyNodes) {
            setMyNodesReady(false);
            setUserVsns(null);
            setVsnToProjectsMap(null);
            setUserProjectsList(null);
            return;
        }
        setMyNodesReady(false);
        if (!params.has('show_all')) {
            // Default to showing all nodes in MyNodes view since users expect to
            // see their nodes even if they're not reporting
            const newParams = new URLSearchParams(params);
            newParams.set('show_all', 'true');
            setParams(newParams, {
                replace: true
            });
        }
        $ecxdi.listMyProjects().then(({ vsns: vsns, projects: projects })=>{
            setUserProjectsList(projects);
            setUserVsns(vsns);
            // Create VSN to projects mapping
            const vsnProjectMap = new Map();
            projects.forEach((project)=>{
                project.nodes.forEach((node)=>{
                    const existing = vsnProjectMap.get(node.vsn);
                    vsnProjectMap.set(node.vsn, existing ? `${existing}, ${project.name}` : project.name);
                });
            });
            setVsnToProjectsMap(vsnProjectMap);
            setMyNodesReady(true);
        });
    }, [
        isMyNodes
    ]);
    // Add projects field to nodes data when in MyNodes view
    const enrichWithProjects = (0, $acw62.useCallback)((nodes)=>{
        if (!isMyNodes || !vsnToProjectsMap) return nodes;
        return nodes.map((node)=>({
                ...node,
                projects: vsnToProjectsMap.get(node.vsn) || ''
            }));
    }, [
        isMyNodes,
        vsnToProjectsMap
    ]);
    // Load and poll node data
    (0, $acw62.useEffect)(()=>{
        if (isMyNodes && !myNodesReady) return; // Wait for MyNodes data to be ready
        let done = false;
        let handle;
        const ping = async ()=>{
            handle = setTimeout(async ()=>{
                if (done) return;
                const metrics = await $bcnr1.getNodeData();
                const updatedData = enrichWithProjects((0, $626807995b044d88$export$29859d30d52b47f6)(dataRef.current, metrics, null, null));
                setData(updatedData);
                setLastUpdate(new Date());
                ping();
            }, $c4f0e9a82b16d72b$var$TIME_OUT);
        };
        setLoading(true);
        const dataPromise = isMyNodes && userVsns ? $c4f0e9a82b16d72b$var$getProjectNodes(sageProject).then((nodes)=>nodes.filter((node)=>userVsns.includes(node.vsn))) : $c4f0e9a82b16d72b$var$getProjectNodes(sageProject);
        Promise.all([
            dataPromise,
            $bcnr1.getNodeData()
        ]).then(([state, metrics])=>{
            if (done) return;
            const allData = enrichWithProjects((0, $626807995b044d88$export$29859d30d52b47f6)(state, metrics, null, null));
            setData(allData);
            setLastUpdate(new Date());
            ping();
        }).catch((err)=>{
            console.log('err', err);
            setError(err);
        }).finally(()=>setLoading(false));
        return ()=>{
            done = true;
            clearTimeout(handle);
        };
    }, [
        sageProject,
        isMyNodes,
        myNodesReady,
        userVsns,
        enrichWithProjects
    ]);
    // Filter and update data whenever dependencies change
    (0, $acw62.useEffect)(()=>{
        if (!data) return;
        // Don't update filtered data until MyNodes is ready (prevents flicker)
        if (isMyNodes && !myNodesReady) return;
        const newFilterState = (0, $626807995b044d88$export$26893885d9a03bc4)(params);
        setFilterState(newFilterState);
        let result = [
            ...data
        ];
        // Apply phase filter
        if (phase) result = result.filter((obj)=>obj.phase == $9bsRS.phaseMap[phase]);
        // Apply status filter
        if (!show_all && !all_nodes) result = result.filter((obj)=>obj.status == 'reporting');
        // Apply query search
        result = (0, $52fc2129eac6b28c$export$3c598703d99462f5)(result, query);
        // Handle projects filter for MyNodes (comma-separated values)
        if (isMyNodes && newFilterState.projects?.length) {
            result = result.filter((node)=>{
                const nodeProjects = node.projects || '';
                return newFilterState.projects.some((projectName)=>nodeProjects.split(', ').includes(projectName));
            });
            // Remove projects from filter state so filterData doesn't process it
            const { projects: projects, ...remainingFilters } = newFilterState;
            result = (0, $626807995b044d88$export$d6ad891437e8c72c)(result, remainingFilters);
        } else result = (0, $626807995b044d88$export$d6ad891437e8c72c)(result, newFilterState);
        setFiltered(result);
        setUpdateID((prev)=>prev + 1);
    }, [
        data,
        phase,
        show_all,
        all_nodes,
        query,
        params,
        isMyNodes,
        myNodesReady
    ]);
    // Compute columns based on current state
    const cols = (0, $acw62.useMemo)(()=>{
        const computedColumns = [
            ...(0, $c494113f591db146$export$2e2bcd8739ae039)
        ];
        // Modify VSN column for super users
        if (isSuper) {
            const vsnIdx = computedColumns.findIndex((o)=>o.id === 'vsn');
            if (vsnIdx !== -1) computedColumns[vsnIdx] = {
                ...computedColumns[vsnIdx],
                format: (0, $eOilY.vsnLinkWithEdit)
            };
        }
        // Add projects column for MyNodes view (only when data is ready)
        if (isMyNodes && myNodesReady && vsnToProjectsMap) {
            const vsnIdx = computedColumns.findIndex((o)=>o.id === 'vsn');
            const projectsCol = {
                id: 'projects',
                label: 'My Project(s)',
                format: (_, obj)=>{
                    const projectsStr = vsnToProjectsMap.get(obj.vsn);
                    if (!projectsStr) return '-';
                    const projectNames = projectsStr.split(', ');
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: projectNames.map((name, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                        to: `/user/${(0, $c3pId.default).user}/teams/${encodeURIComponent(name)}`,
                                        children: name
                                    }),
                                    idx < projectNames.length - 1 && ', '
                                ]
                            }, name))
                    });
                },
                dlFormat: (_, obj)=>vsnToProjectsMap.get(obj.vsn) || ''
            };
            computedColumns.splice(vsnIdx + 1, 0, projectsCol);
        }
        // Hide status column for all_nodes view
        const statusIdx = computedColumns.findIndex((o)=>o.id === 'status');
        if (statusIdx !== -1) computedColumns[statusIdx] = {
            ...computedColumns[statusIdx],
            hide: all_nodes
        };
        return computedColumns;
    }, [
        isSuper,
        isMyNodes,
        myNodesReady,
        vsnToProjectsMap,
        all_nodes
    ]);
    // Update map when selection changes
    (0, $acw62.useEffect)(()=>{
        setUpdateID((prev)=>prev + 1);
    }, [
        selected
    ]);
    (0, $acw62.useEffect)(()=>{
        setUpdateID((prev)=>prev + 1);
    }, [
        show_all
    ]);
    // Event handlers
    const handleQuery = ({ query: query })=>{
        const newParams = new URLSearchParams(params);
        if (query) newParams.set('query', query);
        else newParams.delete('query');
        setParams(newParams, {
            replace: true
        });
    };
    const handleFilterChange = (field, vals)=>{
        const newStr = vals.map((item)=>`"${typeof item == 'string' ? item : item.id}"`).join(',');
        const newParams = new URLSearchParams(params);
        if (!newStr.length) newParams.delete(field);
        else newParams.set(field, newStr);
        setParams(newParams, {
            replace: true
        });
    };
    const handleShowAll = (evt)=>{
        const checked = evt.target.checked;
        const newParams = new URLSearchParams(params);
        if (checked) newParams.set('show_all', 'true');
        else newParams.delete('show_all');
        setParams(newParams, {
            replace: true
        });
    };
    const handleRemoveFilters = ()=>{
        setParams(phase ? {
            phase: phase
        } : {}, {
            replace: true
        });
    };
    const handleSelect = (sel)=>{
        setSelected(sel.objs.length ? sel.objs : []);
    };
    const handleQueryViewerChange = (field, next)=>{
        const newParams = new URLSearchParams(params);
        if (!next.length) newParams.delete(field);
        else newParams.set(field, next.map((str)=>`"${str}"`).join(','));
        setParams(newParams, {
            replace: true
        });
    };
    const getSelectedSubset = (selected, nodes)=>{
        const vsns = selected.map((o)=>o.vsn);
        return nodes.filter((obj)=>vsns.includes(obj.vsn));
    };
    const hasActiveFilters = Object.values(filterState).some((fList)=>fList.length > 0);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c4f0e9a82b16d72b$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($c4f0e9a82b16d72b$var$Overview, {
                className: "flex",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($c4f0e9a82b16d72b$var$MapContainer, {
                    children: [
                        filtered && !selected?.length && /*#__PURE__*/ (0, $ayMG0.jsxs)($c4f0e9a82b16d72b$var$Title, {
                            children: [
                                isMyNodes ? `My ${filtered.length} Node` : `${filtered.length} Node`,
                                filtered.length == 1 ? '' : 's',
                                ' ',
                                "|",
                                ' ',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: lastUpdate?.toLocaleTimeString('en-US')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                            data: selected.length ? getSelectedSubset(selected, filtered) : filtered,
                            markerClass: all_nodes ? 'blue-dot' : null,
                            updateID: updateID
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c4f0e9a82b16d72b$var$TableContainer, {
                children: filtered && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                    primaryKey: "id",
                    rows: filtered,
                    columns: cols,
                    enableSorting: true,
                    enableDownload: true,
                    sort: "-vsn",
                    search: query,
                    storageKey: pathname,
                    onSearch: handleQuery,
                    onColumnMenuChange: ()=>{},
                    onSelect: handleSelect,
                    emptyNotice: show_all || all_nodes || query || hasActiveFilters ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "No nodes found for this query"
                            }),
                            !isMyNodes && /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
                                children: [
                                    "Please try using the tab ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                        to: "/nodes/all",
                                        children: "View All Nodes"
                                    }),
                                    ", or the checkbox ( ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                            checked: show_all,
                                            onChange: (evt)=>handleShowAll(evt)
                                        }),
                                        label: "Show all",
                                        sx: {
                                            marginRight: 0
                                        }
                                    }),
                                    " ) to show nodes ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " which are in maintenance, pending deployment, or not reporting."
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("i", {
                                children: [
                                    "A recent issue has delayed node measurement publications and reporting status, ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    ' resulting in data transfer delays and a "Not Reporting" status across all nodes.',
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    "Please check back later for updates. We thank you for your patience."
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
                                children: [
                                    "Consider using the tab ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                        to: "/nodes/all",
                                        children: "View All Nodes"
                                    }),
                                    ", or the checkbox ( ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                            checked: show_all,
                                            onChange: (evt)=>handleShowAll(evt)
                                        }),
                                        label: "Show all",
                                        sx: {
                                            marginRight: 0
                                        }
                                    }),
                                    " ) to show nodes ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    " which are in maintenance, pending deployment, or not reporting."
                                ]
                            })
                        ]
                    }),
                    middleComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)($c4f0e9a82b16d72b$var$FilterControls, {
                        className: "flex items-center",
                        children: [
                            filterOptions.projects && isMyNodes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                                label: "Project",
                                options: filterOptions.projects,
                                value: filterState.projects,
                                onChange: (vals)=>handleFilterChange('project', vals),
                                noSelectedSort: true
                            }),
                            filterOptions.focuses && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                                label: "Focus",
                                options: filterOptions.focuses,
                                value: filterState.focus,
                                onChange: (vals)=>handleFilterChange('focus', vals),
                                noSelectedSort: true
                            }),
                            filterOptions.cities && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                                label: "City",
                                options: filterOptions.cities,
                                value: filterState.city,
                                onChange: (vals)=>handleFilterChange('city', vals)
                            }),
                            filterOptions.states && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                                label: "State",
                                options: filterOptions.states,
                                value: filterState.state,
                                onChange: (vals)=>handleFilterChange('state', vals)
                            }),
                            filterOptions.sensors && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                                label: "Sensors",
                                options: filterOptions.sensors,
                                value: filterState.sensor,
                                onChange: (vals)=>handleFilterChange('sensor', vals)
                            }),
                            !all_nodes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                sx: {
                                    mx: 1
                                },
                                placement: "top",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: "Show nodes which are in maintenance, pending deployment, or not reporting."
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                        checked: show_all,
                                        onChange: (evt)=>handleShowAll(evt)
                                    }),
                                    label: "Show all"
                                })
                            }),
                            hasActiveFilters && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c4f0e9a82b16d72b$var$VertDivider, {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        color: "primary",
                                        size: "small",
                                        onClick: handleRemoveFilters,
                                        style: {
                                            backgroundColor: '#1c8cc9'
                                        },
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5861ec10399b0856$exports))), {}),
                                        children: "Clear"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $177e9ab8fdb34313$export$2e2bcd8739ae039), {
                                filterState: filterState,
                                onDelete: handleQueryViewerChange
                            })
                        ]
                    })
                })
            })
        ]
    });
}
const $c4f0e9a82b16d72b$var$VertDivider = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
        orientation: "vertical",
        flexItem: true,
        style: {
            margin: '5px 15px 5px 15px'
        }
    });
const $c4f0e9a82b16d72b$var$Root = (0, $d8seH.default)('div')``;
const $c4f0e9a82b16d72b$var$Overview = (0, $d8seH.default)('div')`
  z-index: 100;
  padding: 10px 0;
  border-bottom: 1px solid ${(props)=>props.theme.palette.divider};
`;
const $c4f0e9a82b16d72b$var$MapContainer = (0, $d8seH.default)('div')`
  position: relative;
  width: 100%;
`;
const $c4f0e9a82b16d72b$var$Title = (0, $d8seH.default)('h2')`
  margin: .5em;
  position: absolute;
  z-index: 1000;
`;
const $c4f0e9a82b16d72b$var$TableContainer = (0, $d8seH.default)('div')`
  margin-top: .5em;

  .status-icon {
    margin: 0 10px;
  }

  .gps-icon {
    margin-right: 10px;
  }

  .edit-btn {
    margin-left: .5em;
    visibility: hidden;
  }

  tr:hover .edit-btn {
    visibility: visible;
  }
`;
const $c4f0e9a82b16d72b$var$FilterControls = (0, $d8seH.default)('div')`
  margin-left: 1.5em;
`;


/* eslint-disable max-len */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iwiZ3 = parcelRequire("iwiZ3");
var $d8seH = parcelRequire("d8seH");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $1En50 = parcelRequire("1En50");

var $8nd05 = parcelRequire("8nd05");

var $8Indx = parcelRequire("8Indx");

var $1u0KT = parcelRequire("1u0KT");

var $d8seH = parcelRequire("d8seH");
var $dFNG2 = parcelRequire("dFNG2");

var $jR9F1 = parcelRequire("jR9F1");

var $4jPsi = parcelRequire("4jPsi");
'use client';
function $48eb684ebe9272b4$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $dFNG2.default)({
        props: props,
        name: name,
        defaultTheme: $jR9F1.default,
        themeId: (0, $4jPsi.default)
    });
}



var $7kpn1 = parcelRequire("7kpn1");
var $82aMg = parcelRequire("82aMg");

var $3z1Ay = parcelRequire("3z1Ay");
var $eEJPp = parcelRequire("eEJPp");
var $3qSdM = parcelRequire("3qSdM");
function $86ac7da80443b97e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $86ac7da80443b97e$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $86ac7da80443b97e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $86ac7da80443b97e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $86ac7da80443b97e$export$2e2bcd8739ae039 = $86ac7da80443b97e$export$4f5d2d50c9deca37;




var $acw62 = parcelRequire("acw62");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $d83cd5c489d68e9f$export$13091bac7ca2fdc3(slot) {
    return (0, $4Cod0.default)('MuiMasonry', slot);
}
const $d83cd5c489d68e9f$var$masonryClasses = (0, $beCSm.default)('MuiMasonry', [
    'root'
]);
var $d83cd5c489d68e9f$export$2e2bcd8739ae039 = $d83cd5c489d68e9f$var$masonryClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c44972b00cb09b56$var$_excluded = [
    "children",
    "className",
    "component",
    "columns",
    "spacing",
    "sequential",
    "defaultColumns",
    "defaultHeight",
    "defaultSpacing"
];
const $c44972b00cb09b56$export$efe1b1f313878622 = (val)=>{
    return Number(val.replace('px', ''));
};
const $c44972b00cb09b56$var$lineBreakStyle = {
    flexBasis: '100%',
    width: 0,
    margin: 0,
    padding: 0
};
const $c44972b00cb09b56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d83cd5c489d68e9f$export$13091bac7ca2fdc3), classes);
};
const $c44972b00cb09b56$export$3d2f074408bd1b82 = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        width: '100%',
        display: 'flex',
        flexFlow: 'column wrap',
        alignContent: 'flex-start',
        boxSizing: 'border-box',
        '& > *': {
            boxSizing: 'border-box'
        }
    };
    const stylesSSR = {};
    // Only applicable for Server-Side Rendering
    if (ownerState.isSSR) {
        const orderStyleSSR = {};
        const defaultSpacing = $c44972b00cb09b56$export$efe1b1f313878622(theme.spacing(ownerState.defaultSpacing));
        for(let i = 1; i <= ownerState.defaultColumns; i += 1)orderStyleSSR[`&:nth-of-type(${ownerState.defaultColumns}n+${i % ownerState.defaultColumns})`] = {
            order: i
        };
        stylesSSR.height = ownerState.defaultHeight;
        stylesSSR.margin = -(defaultSpacing / 2);
        stylesSSR['& > *'] = (0, $8nd05.default)({}, styles['& > *'], orderStyleSSR, {
            margin: defaultSpacing / 2,
            width: `calc(${(100 / ownerState.defaultColumns).toFixed(2)}% - ${defaultSpacing}px)`
        });
        return (0, $8nd05.default)({}, styles, stylesSSR);
    }
    const spacingValues = (0, $82aMg.resolveBreakpointValues)({
        values: ownerState.spacing,
        breakpoints: theme.breakpoints.values
    });
    const transformer = (0, $7kpn1.createUnarySpacing)(theme);
    const spacingStyleFromPropValue = (propValue)=>{
        let spacing;
        // in case of string/number value
        if (typeof propValue === 'string' && !Number.isNaN(Number(propValue)) || typeof propValue === 'number') {
            const themeSpacingValue = Number(propValue);
            spacing = (0, $7kpn1.getValue)(transformer, themeSpacingValue);
        } else spacing = propValue;
        return (0, $8nd05.default)({
            margin: `calc(0px - (${spacing} / 2))`,
            '& > *': {
                margin: `calc(${spacing} / 2)`
            }
        }, ownerState.maxColumnHeight && {
            height: typeof spacing === 'number' ? Math.ceil(ownerState.maxColumnHeight + $c44972b00cb09b56$export$efe1b1f313878622(spacing)) : `calc(${ownerState.maxColumnHeight}px + ${spacing})`
        });
    };
    styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
        theme: theme
    }, spacingValues, spacingStyleFromPropValue));
    const columnValues = (0, $82aMg.resolveBreakpointValues)({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
    });
    const columnStyleFromPropValue = (propValue)=>{
        const columnValue = Number(propValue);
        const width = `${(100 / columnValue).toFixed(2)}%`;
        const spacing = typeof spacingValues === 'string' && !Number.isNaN(Number(spacingValues)) || typeof spacingValues === 'number' ? (0, $7kpn1.getValue)(transformer, Number(spacingValues)) : '0px';
        return {
            '& > *': {
                width: `calc(${width} - ${spacing})`
            }
        };
    };
    styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
        theme: theme
    }, columnValues, columnStyleFromPropValue));
    // configure width for responsive spacing values
    if (typeof spacingValues === 'object') styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
        theme: theme
    }, spacingValues, (propValue, breakpoint)=>{
        if (breakpoint) {
            const themeSpacingValue = Number(propValue);
            const lastBreakpoint = Object.keys(columnValues).pop();
            const spacing = (0, $7kpn1.getValue)(transformer, themeSpacingValue);
            const column = typeof columnValues === 'object' ? columnValues[breakpoint] || columnValues[lastBreakpoint] : columnValues;
            const width = `${(100 / column).toFixed(2)}%`;
            return {
                '& > *': {
                    width: `calc(${width} - ${spacing})`
                }
            };
        }
        return null;
    }));
    return styles;
};
const $c44972b00cb09b56$var$MasonryRoot = (0, $d8seH.default)('div', {
    name: 'MuiMasonry',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            styles.root
        ];
    }
})($c44972b00cb09b56$export$3d2f074408bd1b82);
const $c44972b00cb09b56$var$Masonry = /*#__PURE__*/ $acw62.forwardRef(function Masonry(inProps, ref) {
    const props = (0, $48eb684ebe9272b4$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMasonry'
    });
    const { children: children, className: className, component: component = 'div', columns: columns = 4, spacing: spacing = 1, sequential: sequential = false, defaultColumns: defaultColumns, defaultHeight: defaultHeight, defaultSpacing: defaultSpacing } = props, other = (0, $1En50.default)(props, $c44972b00cb09b56$var$_excluded);
    const masonryRef = $acw62.useRef();
    const [maxColumnHeight, setMaxColumnHeight] = $acw62.useState();
    const isSSR = !maxColumnHeight && defaultHeight && defaultColumns !== undefined && defaultSpacing !== undefined;
    const [numberOfLineBreaks, setNumberOfLineBreaks] = $acw62.useState(isSSR ? defaultColumns - 1 : 0);
    const ownerState = (0, $8nd05.default)({}, props, {
        spacing: spacing,
        columns: columns,
        maxColumnHeight: maxColumnHeight,
        defaultColumns: defaultColumns,
        defaultHeight: defaultHeight,
        defaultSpacing: defaultSpacing,
        isSSR: isSSR
    });
    const classes = $c44972b00cb09b56$var$useUtilityClasses(ownerState);
    const handleResize = $acw62.useCallback((masonryChildren)=>{
        if (!masonryRef.current || !masonryChildren || masonryChildren.length === 0) return;
        const masonry = masonryRef.current;
        const masonryFirstChild = masonryRef.current.firstChild;
        const parentWidth = masonry.clientWidth;
        const firstChildWidth = masonryFirstChild.clientWidth;
        if (parentWidth === 0 || firstChildWidth === 0) return;
        const firstChildComputedStyle = window.getComputedStyle(masonryFirstChild);
        const firstChildMarginLeft = $c44972b00cb09b56$export$efe1b1f313878622(firstChildComputedStyle.marginLeft);
        const firstChildMarginRight = $c44972b00cb09b56$export$efe1b1f313878622(firstChildComputedStyle.marginRight);
        const currentNumberOfColumns = Math.round(parentWidth / (firstChildWidth + firstChildMarginLeft + firstChildMarginRight));
        const columnHeights = new Array(currentNumberOfColumns).fill(0);
        let skip = false;
        let nextOrder = 1;
        masonry.childNodes.forEach((child)=>{
            if (child.nodeType !== Node.ELEMENT_NODE || child.dataset.class === 'line-break' || skip) return;
            const childComputedStyle = window.getComputedStyle(child);
            const childMarginTop = $c44972b00cb09b56$export$efe1b1f313878622(childComputedStyle.marginTop);
            const childMarginBottom = $c44972b00cb09b56$export$efe1b1f313878622(childComputedStyle.marginBottom);
            // if any one of children isn't rendered yet, masonry's height shouldn't be computed yet
            const childHeight = $c44972b00cb09b56$export$efe1b1f313878622(childComputedStyle.height) ? Math.ceil($c44972b00cb09b56$export$efe1b1f313878622(childComputedStyle.height)) + childMarginTop + childMarginBottom : 0;
            if (childHeight === 0) {
                skip = true;
                return;
            }
            // if there is a nested image that isn't rendered yet, masonry's height shouldn't be computed yet
            for(let i = 0; i < child.childNodes.length; i += 1){
                const nestedChild = child.childNodes[i];
                if (nestedChild.tagName === 'IMG' && nestedChild.clientHeight === 0) {
                    skip = true;
                    break;
                }
            }
            if (!skip) {
                if (sequential) {
                    columnHeights[nextOrder - 1] += childHeight;
                    child.style.order = nextOrder;
                    nextOrder += 1;
                    if (nextOrder > currentNumberOfColumns) nextOrder = 1;
                } else {
                    // find the current shortest column (where the current item will be placed)
                    const currentMinColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
                    columnHeights[currentMinColumnIndex] += childHeight;
                    const order = currentMinColumnIndex + 1;
                    child.style.order = order;
                }
            }
        });
        if (!skip) // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $1u0KT.flushSync(()=>{
            setMaxColumnHeight(Math.max(...columnHeights));
            setNumberOfLineBreaks(currentNumberOfColumns > 0 ? currentNumberOfColumns - 1 : 0);
        });
    }, [
        sequential
    ]);
    (0, $eEJPp.default)(()=>{
        // IE and old browsers are not supported
        if (typeof ResizeObserver === 'undefined') return undefined;
        let animationFrame;
        const resizeObserver = new ResizeObserver(()=>{
            // see https://github.com/mui/material-ui/issues/36909
            animationFrame = requestAnimationFrame(handleResize);
        });
        if (masonryRef.current) masonryRef.current.childNodes.forEach((childNode)=>{
            resizeObserver.observe(childNode);
        });
        return ()=>{
            if (animationFrame) window.cancelAnimationFrame(animationFrame);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        columns,
        spacing,
        children,
        handleResize
    ]);
    const handleRef = (0, $3qSdM.default)(ref, masonryRef);
    //  columns are likely to have different heights and hence can start to merge;
    //  a line break at the end of each column prevents columns from merging
    const lineBreaks = new Array(numberOfLineBreaks).fill('').map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            "data-class": "line-break",
            style: (0, $8nd05.default)({}, $c44972b00cb09b56$var$lineBreakStyle, {
                order: index + 1
            })
        }, index));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c44972b00cb09b56$var$MasonryRoot, (0, $8nd05.default)({
        as: component,
        className: (0, $86ac7da80443b97e$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            lineBreaks
        ]
    }));
});
var $c44972b00cb09b56$export$2e2bcd8739ae039 = $c44972b00cb09b56$var$Masonry;



var $bcnr1 = parcelRequire("bcnr1");

var $9bsRS = parcelRequire("9bsRS");


var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");


var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");

var $9bsRS = parcelRequire("9bsRS");
function $34d1c5c943619e11$export$2e2bcd8739ae039() {
    const vsn = (0, $aphAM.useParams)().vsn;
    const [recommended, setRecommended] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        $9bsRS.getSimpleManifests().then((data)=>{
            const urlParam = vsn.toUpperCase();
            const node = data.find(({ vsn: vsn, name: name })=>vsn.toUpperCase() == urlParam || name.toUpperCase() == urlParam);
            setRecommended(node.vsn);
        }).catch((err)=>setError(err));
    }, [
        vsn
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($34d1c5c943619e11$var$Root, {
        className: "flex align-center column",
        children: [
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bee",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15b87fc16f8d46d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "The VSN ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: vsn
                    }),
                    " can not be found."
                ]
            }),
            recommended && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    "Were you looking for ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: `/nodes/${recommended}`,
                        children: recommended
                    }),
                    "?"
                ]
            })
        ]
    });
}
const $34d1c5c943619e11$var$Root = (0, $lmFrL.default).div`
  margin-top: 2em;
  font-size: 2rem;
  text-align: center;
  color: #666;

  .bee svg {
    max-width: 300px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");
var $182ce0f141db4820$exports = {};
/*!
 * wavesurfer.js 5.2.0 (2021-08-16)
 * https://wavesurfer-js.org
 * @license BSD-3-Clause
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $182ce0f141db4820$exports = factory();
})(self, function() {
    return /******/ (()=>{
        /******/ var __webpack_modules__ = {
            /***/ "./src/drawer.canvasentry.js": /*!***********************************!*\
  !*** ./src/drawer.canvasentry.js ***!
  \***********************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _style = _interopRequireDefault(__webpack_require__(/*! ./util/style */ "./src/util/style.js"));
                var _getId = _interopRequireDefault(__webpack_require__(/*! ./util/get-id */ "./src/util/get-id.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * The `CanvasEntry` class represents an element consisting of a wave `canvas`
 * and an (optional) progress wave `canvas`.
 *
 * The `MultiCanvas` renderer uses one or more `CanvasEntry` instances to
 * render a waveform, depending on the zoom level.
 */ var CanvasEntry = /*#__PURE__*/ function() {
                    function CanvasEntry() {
                        _classCallCheck(this, CanvasEntry);
                        /**
     * The wave node
     *
     * @type {HTMLCanvasElement}
     */ this.wave = null;
                        /**
     * The wave canvas rendering context
     *
     * @type {CanvasRenderingContext2D}
     */ this.waveCtx = null;
                        /**
     * The (optional) progress wave node
     *
     * @type {HTMLCanvasElement}
     */ this.progress = null;
                        /**
     * The (optional) progress wave canvas rendering context
     *
     * @type {CanvasRenderingContext2D}
     */ this.progressCtx = null;
                        /**
     * Start of the area the canvas should render, between 0 and 1
     *
     * @type {number}
     */ this.start = 0;
                        /**
     * End of the area the canvas should render, between 0 and 1
     *
     * @type {number}
     */ this.end = 1;
                        /**
     * Unique identifier for this entry
     *
     * @type {string}
     */ this.id = (0, _getId.default)(typeof this.constructor.name !== 'undefined' ? this.constructor.name.toLowerCase() + '_' : 'canvasentry_');
                        /**
     * Canvas 2d context attributes
     *
     * @type {object}
     */ this.canvasContextAttributes = {};
                    }
                    /**
   * Store the wave canvas element and create the 2D rendering context
   *
   * @param {HTMLCanvasElement} element The wave `canvas` element.
   */ _createClass(CanvasEntry, [
                        {
                            key: "initWave",
                            value: function initWave(element) {
                                this.wave = element;
                                this.waveCtx = this.wave.getContext('2d', this.canvasContextAttributes);
                            }
                        },
                        {
                            key: "initProgress",
                            value: function initProgress(element) {
                                this.progress = element;
                                this.progressCtx = this.progress.getContext('2d', this.canvasContextAttributes);
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions(elementWidth, totalWidth, width, height) {
                                // where the canvas starts and ends in the waveform, represented as a
                                // decimal between 0 and 1
                                this.start = this.wave.offsetLeft / totalWidth || 0;
                                this.end = this.start + elementWidth / totalWidth; // set wave canvas dimensions
                                this.wave.width = width;
                                this.wave.height = height;
                                var elementSize = {
                                    width: elementWidth + 'px'
                                };
                                (0, _style.default)(this.wave, elementSize);
                                if (this.hasProgressCanvas) {
                                    // set progress canvas dimensions
                                    this.progress.width = width;
                                    this.progress.height = height;
                                    (0, _style.default)(this.progress, elementSize);
                                }
                            }
                        },
                        {
                            key: "clearWave",
                            value: function clearWave() {
                                // wave
                                this.waveCtx.clearRect(0, 0, this.waveCtx.canvas.width, this.waveCtx.canvas.height); // progress
                                if (this.hasProgressCanvas) this.progressCtx.clearRect(0, 0, this.progressCtx.canvas.width, this.progressCtx.canvas.height);
                            }
                        },
                        {
                            key: "setFillStyles",
                            value: function setFillStyles(waveColor, progressColor) {
                                this.waveCtx.fillStyle = waveColor;
                                if (this.hasProgressCanvas) this.progressCtx.fillStyle = progressColor;
                            }
                        },
                        {
                            key: "applyCanvasTransforms",
                            value: function applyCanvasTransforms(vertical) {
                                if (vertical) {
                                    // Reflect the waveform across the line y = -x
                                    this.waveCtx.setTransform(0, 1, 1, 0, 0, 0);
                                    if (this.hasProgressCanvas) this.progressCtx.setTransform(0, 1, 1, 0, 0, 0);
                                }
                            }
                        },
                        {
                            key: "fillRects",
                            value: function fillRects(x, y, width, height, radius) {
                                this.fillRectToContext(this.waveCtx, x, y, width, height, radius);
                                if (this.hasProgressCanvas) this.fillRectToContext(this.progressCtx, x, y, width, height, radius);
                            }
                        },
                        {
                            key: "fillRectToContext",
                            value: function fillRectToContext(ctx, x, y, width, height, radius) {
                                if (!ctx) return;
                                if (radius) this.drawRoundedRect(ctx, x, y, width, height, radius);
                                else ctx.fillRect(x, y, width, height);
                            }
                        },
                        {
                            key: "drawRoundedRect",
                            value: function drawRoundedRect(ctx, x, y, width, height, radius) {
                                if (height === 0) return;
                                 // peaks are float values from -1 to 1. Use absolute height values in
                                // order to correctly calculate rounded rectangle coordinates
                                if (height < 0) {
                                    height *= -1;
                                    y -= height;
                                }
                                ctx.beginPath();
                                ctx.moveTo(x + radius, y);
                                ctx.lineTo(x + width - radius, y);
                                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                                ctx.lineTo(x + width, y + height - radius);
                                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                                ctx.lineTo(x + radius, y + height);
                                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                                ctx.lineTo(x, y + radius);
                                ctx.quadraticCurveTo(x, y, x + radius, y);
                                ctx.closePath();
                                ctx.fill();
                            }
                        },
                        {
                            key: "drawLines",
                            value: function drawLines(peaks, absmax, halfH, offsetY, start, end) {
                                this.drawLineToContext(this.waveCtx, peaks, absmax, halfH, offsetY, start, end);
                                if (this.hasProgressCanvas) this.drawLineToContext(this.progressCtx, peaks, absmax, halfH, offsetY, start, end);
                            }
                        },
                        {
                            key: "drawLineToContext",
                            value: function drawLineToContext(ctx, peaks, absmax, halfH, offsetY, start, end) {
                                if (!ctx) return;
                                var length = peaks.length / 2;
                                var first = Math.round(length * this.start); // use one more peak value to make sure we join peaks at ends -- unless,
                                // of course, this is the last canvas
                                var last = Math.round(length * this.end) + 1;
                                var canvasStart = first;
                                var canvasEnd = last;
                                var scale = this.wave.width / (canvasEnd - canvasStart - 1); // optimization
                                var halfOffset = halfH + offsetY;
                                var absmaxHalf = absmax / halfH;
                                ctx.beginPath();
                                ctx.moveTo((canvasStart - first) * scale, halfOffset);
                                ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart] || 0) / absmaxHalf));
                                var i, peak, h;
                                for(i = canvasStart; i < canvasEnd; i++){
                                    peak = peaks[2 * i] || 0;
                                    h = Math.round(peak / absmaxHalf);
                                    ctx.lineTo((i - first) * scale + this.halfPixel, halfOffset - h);
                                } // draw the bottom edge going backwards, to make a single
                                // closed hull to fill
                                var j = canvasEnd - 1;
                                for(j; j >= canvasStart; j--){
                                    peak = peaks[2 * j + 1] || 0;
                                    h = Math.round(peak / absmaxHalf);
                                    ctx.lineTo((j - first) * scale + this.halfPixel, halfOffset - h);
                                }
                                ctx.lineTo((canvasStart - first) * scale, halfOffset - Math.round((peaks[2 * canvasStart + 1] || 0) / absmaxHalf));
                                ctx.closePath();
                                ctx.fill();
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.waveCtx = null;
                                this.wave = null;
                                this.progressCtx = null;
                                this.progress = null;
                            }
                        },
                        {
                            key: "getImage",
                            value: function getImage(format, quality, type) {
                                var _this = this;
                                if (type === 'blob') return new Promise(function(resolve) {
                                    _this.wave.toBlob(resolve, format, quality);
                                });
                                else if (type === 'dataURL') return this.wave.toDataURL(format, quality);
                            }
                        }
                    ]);
                    return CanvasEntry;
                }();
                exports.default = CanvasEntry;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/drawer.js": /*!***********************!*\
  !*** ./src/drawer.js ***!
  \***********************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Parent class for renderers
 *
 * @extends {Observer}
 */ var Drawer = /*#__PURE__*/ function(_util$Observer) {
                    _inherits(Drawer, _util$Observer);
                    var _super = _createSuper(Drawer);
                    /**
   * @param {HTMLElement} container The container node of the wavesurfer instance
   * @param {WavesurferParams} params The wavesurfer initialisation options
   */ function Drawer(container, params) {
                        var _this;
                        _classCallCheck(this, Drawer);
                        _this = _super.call(this);
                        _this.container = util.withOrientation(container, params.vertical);
                        /**
     * @type {WavesurferParams}
     */ _this.params = params;
                        /**
     * The width of the renderer
     * @type {number}
     */ _this.width = 0;
                        /**
     * The height of the renderer
     * @type {number}
     */ _this.height = params.height * _this.params.pixelRatio;
                        _this.lastPos = 0;
                        /**
     * The `<wave>` element which is added to the container
     * @type {HTMLElement}
     */ _this.wrapper = null;
                        return _this;
                    }
                    /**
   * Alias of `util.style`
   *
   * @param {HTMLElement} el The element that the styles will be applied to
   * @param {Object} styles The map of propName: attribute, both are used as-is
   * @return {HTMLElement} el
   */ _createClass(Drawer, [
                        {
                            key: "style",
                            value: function style(el, styles) {
                                return util.style(el, styles);
                            }
                        },
                        {
                            key: "createWrapper",
                            value: function createWrapper() {
                                this.wrapper = util.withOrientation(this.container.appendChild(document.createElement('wave')), this.params.vertical);
                                this.style(this.wrapper, {
                                    display: 'block',
                                    position: 'relative',
                                    userSelect: 'none',
                                    webkitUserSelect: 'none',
                                    height: this.params.height + 'px'
                                });
                                if (this.params.fillParent || this.params.scrollParent) this.style(this.wrapper, {
                                    width: '100%',
                                    overflowX: this.params.hideScrollbar ? 'hidden' : 'auto',
                                    overflowY: 'hidden'
                                });
                                this.setupWrapperEvents();
                            }
                        },
                        {
                            key: "handleEvent",
                            value: function handleEvent(e, noPrevent) {
                                !noPrevent && e.preventDefault();
                                var clientX = util.withOrientation(e.targetTouches ? e.targetTouches[0] : e, this.params.vertical).clientX;
                                var bbox = this.wrapper.getBoundingClientRect();
                                var nominalWidth = this.width;
                                var parentWidth = this.getWidth();
                                var progressPixels = this.getProgressPixels(bbox, clientX);
                                var progress;
                                if (!this.params.fillParent && nominalWidth < parentWidth) progress = progressPixels * (this.params.pixelRatio / nominalWidth) || 0;
                                else progress = (progressPixels + this.wrapper.scrollLeft) / this.wrapper.scrollWidth || 0;
                                return util.clamp(progress, 0, 1);
                            }
                        },
                        {
                            key: "getProgressPixels",
                            value: function getProgressPixels(wrapperBbox, clientX) {
                                if (this.params.rtl) return wrapperBbox.right - clientX;
                                else return clientX - wrapperBbox.left;
                            }
                        },
                        {
                            key: "setupWrapperEvents",
                            value: function setupWrapperEvents() {
                                var _this2 = this;
                                this.wrapper.addEventListener('click', function(e) {
                                    var orientedEvent = util.withOrientation(e, _this2.params.vertical);
                                    var scrollbarHeight = _this2.wrapper.offsetHeight - _this2.wrapper.clientHeight;
                                    if (scrollbarHeight !== 0) {
                                        // scrollbar is visible.  Check if click was on it
                                        var bbox = _this2.wrapper.getBoundingClientRect();
                                        if (orientedEvent.clientY >= bbox.bottom - scrollbarHeight) // ignore mousedown as it was on the scrollbar
                                        return;
                                    }
                                    if (_this2.params.interact) _this2.fireEvent('click', e, _this2.handleEvent(e));
                                });
                                this.wrapper.addEventListener('dblclick', function(e) {
                                    if (_this2.params.interact) _this2.fireEvent('dblclick', e, _this2.handleEvent(e));
                                });
                                this.wrapper.addEventListener('scroll', function(e) {
                                    return _this2.fireEvent('scroll', e);
                                });
                            }
                        },
                        {
                            key: "drawPeaks",
                            value: function drawPeaks(peaks, length, start, end) {
                                if (!this.setWidth(length)) this.clearWave();
                                this.params.barWidth ? this.drawBars(peaks, 0, start, end) : this.drawWave(peaks, 0, start, end);
                            }
                        },
                        {
                            key: "resetScroll",
                            value: function resetScroll() {
                                if (this.wrapper !== null) this.wrapper.scrollLeft = 0;
                            }
                        },
                        {
                            key: "recenter",
                            value: function recenter(percent) {
                                var position = this.wrapper.scrollWidth * percent;
                                this.recenterOnPosition(position, true);
                            }
                        },
                        {
                            key: "recenterOnPosition",
                            value: function recenterOnPosition(position, immediate) {
                                var scrollLeft = this.wrapper.scrollLeft;
                                var half = ~~(this.wrapper.clientWidth / 2);
                                var maxScroll = this.wrapper.scrollWidth - this.wrapper.clientWidth;
                                var target = position - half;
                                var offset = target - scrollLeft;
                                if (maxScroll == 0) // no need to continue if scrollbar is not there
                                return;
                                 // if the cursor is currently visible...
                                if (!immediate && -half <= offset && offset < half) {
                                    // set rate at which waveform is centered
                                    var rate = this.params.autoCenterRate; // make rate depend on width of view and length of waveform
                                    rate /= half;
                                    rate *= maxScroll;
                                    offset = Math.max(-rate, Math.min(rate, offset));
                                    target = scrollLeft + offset;
                                } // limit target to valid range (0 to maxScroll)
                                target = Math.max(0, Math.min(maxScroll, target)); // no use attempting to scroll if we're not moving
                                if (target != scrollLeft) this.wrapper.scrollLeft = target;
                            }
                        },
                        {
                            key: "getScrollX",
                            value: function getScrollX() {
                                var x = 0;
                                if (this.wrapper) {
                                    var pixelRatio = this.params.pixelRatio;
                                    x = Math.round(this.wrapper.scrollLeft * pixelRatio); // In cases of elastic scroll (safari with mouse wheel) you can
                                    // scroll beyond the limits of the container
                                    // Calculate and floor the scrollable extent to make sure an out
                                    // of bounds value is not returned
                                    // Ticket #1312
                                    if (this.params.scrollParent) {
                                        var maxScroll = ~~(this.wrapper.scrollWidth * pixelRatio - this.getWidth());
                                        x = Math.min(maxScroll, Math.max(0, x));
                                    }
                                }
                                return x;
                            }
                        },
                        {
                            key: "getWidth",
                            value: function getWidth() {
                                return Math.round(this.container.clientWidth * this.params.pixelRatio);
                            }
                        },
                        {
                            key: "setWidth",
                            value: function setWidth(width) {
                                if (this.width == width) return false;
                                this.width = width;
                                if (this.params.fillParent || this.params.scrollParent) this.style(this.wrapper, {
                                    width: ''
                                });
                                else {
                                    var newWidth = ~~(this.width / this.params.pixelRatio) + 'px';
                                    this.style(this.wrapper, {
                                        width: newWidth
                                    });
                                }
                                this.updateSize();
                                return true;
                            }
                        },
                        {
                            key: "setHeight",
                            value: function setHeight(height) {
                                if (height == this.height) return false;
                                this.height = height;
                                this.style(this.wrapper, {
                                    height: ~~(this.height / this.params.pixelRatio) + 'px'
                                });
                                this.updateSize();
                                return true;
                            }
                        },
                        {
                            key: "progress",
                            value: function progress(_progress) {
                                var minPxDelta = 1 / this.params.pixelRatio;
                                var pos = Math.round(_progress * this.width) * minPxDelta;
                                if (pos < this.lastPos || pos - this.lastPos >= minPxDelta) {
                                    this.lastPos = pos;
                                    if (this.params.scrollParent && this.params.autoCenter) {
                                        var newPos = ~~(this.wrapper.scrollWidth * _progress);
                                        this.recenterOnPosition(newPos, this.params.autoCenterImmediately);
                                    }
                                    this.updateProgress(pos);
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.unAll();
                                if (this.wrapper) {
                                    if (this.wrapper.parentNode == this.container.domElement) this.container.removeChild(this.wrapper.domElement);
                                    this.wrapper = null;
                                }
                            }
                        },
                        {
                            key: "updateCursor",
                            value: function updateCursor() {}
                        },
                        {
                            key: "updateSize",
                            value: function updateSize() {}
                        },
                        {
                            key: "drawBars",
                            value: function drawBars(peaks, channelIndex, start, end) {}
                        },
                        {
                            key: "drawWave",
                            value: function drawWave(peaks, channelIndex, start, end) {}
                        },
                        {
                            key: "clearWave",
                            value: function clearWave() {}
                        },
                        {
                            key: "updateProgress",
                            value: function updateProgress(position) {}
                        }
                    ]);
                    return Drawer;
                }(util.Observer);
                exports.default = Drawer;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/drawer.multicanvas.js": /*!***********************************!*\
  !*** ./src/drawer.multicanvas.js ***!
  \***********************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _drawer = _interopRequireDefault(__webpack_require__(/*! ./drawer */ "./src/drawer.js"));
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                var _drawer2 = _interopRequireDefault(__webpack_require__(/*! ./drawer.canvasentry */ "./src/drawer.canvasentry.js"));
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * MultiCanvas renderer for wavesurfer. Is currently the default and sole
 * builtin renderer.
 *
 * A `MultiCanvas` consists of one or more `CanvasEntry` instances, depending
 * on the zoom level.
 */ var MultiCanvas = /*#__PURE__*/ function(_Drawer) {
                    _inherits(MultiCanvas, _Drawer);
                    var _super = _createSuper(MultiCanvas);
                    /**
   * @param {HTMLElement} container The container node of the wavesurfer instance
   * @param {WavesurferParams} params The wavesurfer initialisation options
   */ function MultiCanvas(container, params) {
                        var _this;
                        _classCallCheck(this, MultiCanvas);
                        _this = _super.call(this, container, params);
                        /**
     * @type {number}
     */ _this.maxCanvasWidth = params.maxCanvasWidth;
                        /**
     * @type {number}
     */ _this.maxCanvasElementWidth = Math.round(params.maxCanvasWidth / params.pixelRatio);
                        /**
     * Whether or not the progress wave is rendered. If the `waveColor`
     * and `progressColor` are the same color it is not.
     *
     * @type {boolean}
     */ _this.hasProgressCanvas = params.waveColor != params.progressColor;
                        /**
     * @type {number}
     */ _this.halfPixel = 0.5 / params.pixelRatio;
                        /**
     * List of `CanvasEntry` instances.
     *
     * @type {Array}
     */ _this.canvases = [];
                        /**
     * @type {HTMLElement}
     */ _this.progressWave = null;
                        /**
     * Class used to generate entries.
     *
     * @type {function}
     */ _this.EntryClass = _drawer2.default;
                        /**
     * Canvas 2d context attributes.
     *
     * @type {object}
     */ _this.canvasContextAttributes = params.drawingContextAttributes;
                        /**
     * Overlap added between entries to prevent vertical white stripes
     * between `canvas` elements.
     *
     * @type {number}
     */ _this.overlap = 2 * Math.ceil(params.pixelRatio / 2);
                        /**
     * The radius of the wave bars. Makes bars rounded
     *
     * @type {number}
     */ _this.barRadius = params.barRadius || 0;
                        /**
     * Whether to render the waveform vertically. Defaults to false.
     *
     * @type {boolean}
     */ _this.vertical = params.vertical;
                        return _this;
                    }
                    /**
   * Initialize the drawer
   */ _createClass(MultiCanvas, [
                        {
                            key: "init",
                            value: function init() {
                                this.createWrapper();
                                this.createElements();
                            }
                        },
                        {
                            key: "createElements",
                            value: function createElements() {
                                this.progressWave = util.withOrientation(this.wrapper.appendChild(document.createElement('wave')), this.params.vertical);
                                this.style(this.progressWave, {
                                    position: 'absolute',
                                    zIndex: 3,
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    overflow: 'hidden',
                                    width: '0',
                                    display: 'none',
                                    boxSizing: 'border-box',
                                    borderRightStyle: 'solid',
                                    pointerEvents: 'none'
                                });
                                this.addCanvas();
                                this.updateCursor();
                            }
                        },
                        {
                            key: "updateCursor",
                            value: function updateCursor() {
                                this.style(this.progressWave, {
                                    borderRightWidth: this.params.cursorWidth + 'px',
                                    borderRightColor: this.params.cursorColor
                                });
                            }
                        },
                        {
                            key: "updateSize",
                            value: function updateSize() {
                                var _this2 = this;
                                var totalWidth = Math.round(this.width / this.params.pixelRatio);
                                var requiredCanvases = Math.ceil(totalWidth / (this.maxCanvasElementWidth + this.overlap)); // add required canvases
                                while(this.canvases.length < requiredCanvases)this.addCanvas();
                                 // remove older existing canvases, if any
                                while(this.canvases.length > requiredCanvases)this.removeCanvas();
                                var canvasWidth = this.maxCanvasWidth + this.overlap;
                                var lastCanvas = this.canvases.length - 1;
                                this.canvases.forEach(function(entry, i) {
                                    if (i == lastCanvas) canvasWidth = _this2.width - _this2.maxCanvasWidth * lastCanvas;
                                    _this2.updateDimensions(entry, canvasWidth, _this2.height);
                                    entry.clearWave();
                                });
                            }
                        },
                        {
                            key: "addCanvas",
                            value: function addCanvas() {
                                var entry = new this.EntryClass();
                                entry.canvasContextAttributes = this.canvasContextAttributes;
                                entry.hasProgressCanvas = this.hasProgressCanvas;
                                entry.halfPixel = this.halfPixel;
                                var leftOffset = this.maxCanvasElementWidth * this.canvases.length; // wave
                                var wave = util.withOrientation(this.wrapper.appendChild(document.createElement('canvas')), this.params.vertical);
                                this.style(wave, {
                                    position: 'absolute',
                                    zIndex: 2,
                                    left: leftOffset + 'px',
                                    top: 0,
                                    bottom: 0,
                                    height: '100%',
                                    pointerEvents: 'none'
                                });
                                entry.initWave(wave); // progress
                                if (this.hasProgressCanvas) {
                                    var progress = util.withOrientation(this.progressWave.appendChild(document.createElement('canvas')), this.params.vertical);
                                    this.style(progress, {
                                        position: 'absolute',
                                        left: leftOffset + 'px',
                                        top: 0,
                                        bottom: 0,
                                        height: '100%'
                                    });
                                    entry.initProgress(progress);
                                }
                                this.canvases.push(entry);
                            }
                        },
                        {
                            key: "removeCanvas",
                            value: function removeCanvas() {
                                var lastEntry = this.canvases[this.canvases.length - 1]; // wave
                                lastEntry.wave.parentElement.removeChild(lastEntry.wave.domElement); // progress
                                if (this.hasProgressCanvas) lastEntry.progress.parentElement.removeChild(lastEntry.progress.domElement);
                                 // cleanup
                                if (lastEntry) {
                                    lastEntry.destroy();
                                    lastEntry = null;
                                }
                                this.canvases.pop();
                            }
                        },
                        {
                            key: "updateDimensions",
                            value: function updateDimensions(entry, width, height) {
                                var elementWidth = Math.round(width / this.params.pixelRatio);
                                var totalWidth = Math.round(this.width / this.params.pixelRatio); // update canvas dimensions
                                entry.updateDimensions(elementWidth, totalWidth, width, height); // style element
                                this.style(this.progressWave, {
                                    display: 'block'
                                });
                            }
                        },
                        {
                            key: "clearWave",
                            value: function clearWave() {
                                var _this3 = this;
                                util.frame(function() {
                                    _this3.canvases.forEach(function(entry) {
                                        return entry.clearWave();
                                    });
                                })();
                            }
                        },
                        {
                            key: "drawBars",
                            value: function drawBars(peaks, channelIndex, start, end) {
                                var _this4 = this;
                                return this.prepareDraw(peaks, channelIndex, start, end, function(_ref) {
                                    var absmax = _ref.absmax, hasMinVals = _ref.hasMinVals, height = _ref.height, offsetY = _ref.offsetY, halfH = _ref.halfH, peaks = _ref.peaks, ch = _ref.channelIndex;
                                    // if drawBars was called within ws.empty we don't pass a start and
                                    // don't want anything to happen
                                    if (start === undefined) return;
                                     // Skip every other value if there are negatives.
                                    var peakIndexScale = hasMinVals ? 2 : 1;
                                    var length = peaks.length / peakIndexScale;
                                    var bar = _this4.params.barWidth * _this4.params.pixelRatio;
                                    var gap = _this4.params.barGap === null ? Math.max(_this4.params.pixelRatio, ~~(bar / 2)) : Math.max(_this4.params.pixelRatio, _this4.params.barGap * _this4.params.pixelRatio);
                                    var step = bar + gap;
                                    var scale = length / _this4.width;
                                    var first = start;
                                    var last = end;
                                    var i = first;
                                    for(i; i < last; i += step){
                                        var peak = peaks[Math.floor(i * scale * peakIndexScale)] || 0;
                                        var h = Math.round(peak / absmax * halfH);
                                        /* in case of silences, allow the user to specify that we
           * always draw *something* (normally a 1px high bar) */ if (h == 0 && _this4.params.barMinHeight) h = _this4.params.barMinHeight;
                                        _this4.fillRect(i + _this4.halfPixel, halfH - h + offsetY, bar + _this4.halfPixel, h * 2, _this4.barRadius, ch);
                                    }
                                });
                            }
                        },
                        {
                            key: "drawWave",
                            value: function drawWave(peaks, channelIndex, start, end) {
                                var _this5 = this;
                                return this.prepareDraw(peaks, channelIndex, start, end, function(_ref2) {
                                    var absmax = _ref2.absmax, hasMinVals = _ref2.hasMinVals, height = _ref2.height, offsetY = _ref2.offsetY, halfH = _ref2.halfH, peaks = _ref2.peaks, channelIndex = _ref2.channelIndex;
                                    if (!hasMinVals) {
                                        var reflectedPeaks = [];
                                        var len = peaks.length;
                                        var i = 0;
                                        for(i; i < len; i++){
                                            reflectedPeaks[2 * i] = peaks[i];
                                            reflectedPeaks[2 * i + 1] = -peaks[i];
                                        }
                                        peaks = reflectedPeaks;
                                    } // if drawWave was called within ws.empty we don't pass a start and
                                    // end and simply want a flat line
                                    if (start !== undefined) _this5.drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex);
                                     // always draw a median line
                                    _this5.fillRect(0, halfH + offsetY - _this5.halfPixel, _this5.width, _this5.halfPixel, _this5.barRadius, channelIndex);
                                });
                            }
                        },
                        {
                            key: "drawLine",
                            value: function drawLine(peaks, absmax, halfH, offsetY, start, end, channelIndex) {
                                var _this6 = this;
                                var _ref3 = this.params.splitChannelsOptions.channelColors[channelIndex] || {}, waveColor = _ref3.waveColor, progressColor = _ref3.progressColor;
                                this.canvases.forEach(function(entry, i) {
                                    _this6.setFillStyles(entry, waveColor, progressColor);
                                    _this6.applyCanvasTransforms(entry, _this6.params.vertical);
                                    entry.drawLines(peaks, absmax, halfH, offsetY, start, end);
                                });
                            }
                        },
                        {
                            key: "fillRect",
                            value: function fillRect(x, y, width, height, radius, channelIndex) {
                                var startCanvas = Math.floor(x / this.maxCanvasWidth);
                                var endCanvas = Math.min(Math.ceil((x + width) / this.maxCanvasWidth) + 1, this.canvases.length);
                                var i = startCanvas;
                                for(i; i < endCanvas; i++){
                                    var entry = this.canvases[i];
                                    var leftOffset = i * this.maxCanvasWidth;
                                    var intersection = {
                                        x1: Math.max(x, i * this.maxCanvasWidth),
                                        y1: y,
                                        x2: Math.min(x + width, i * this.maxCanvasWidth + entry.wave.width),
                                        y2: y + height
                                    };
                                    if (intersection.x1 < intersection.x2) {
                                        var _ref4 = this.params.splitChannelsOptions.channelColors[channelIndex] || {}, waveColor = _ref4.waveColor, progressColor = _ref4.progressColor;
                                        this.setFillStyles(entry, waveColor, progressColor);
                                        this.applyCanvasTransforms(entry, this.params.vertical);
                                        entry.fillRects(intersection.x1 - leftOffset, intersection.y1, intersection.x2 - intersection.x1, intersection.y2 - intersection.y1, radius);
                                    }
                                }
                            }
                        },
                        {
                            key: "hideChannel",
                            value: function hideChannel(channelIndex) {
                                return this.params.splitChannels && this.params.splitChannelsOptions.filterChannels.includes(channelIndex);
                            }
                        },
                        {
                            key: "prepareDraw",
                            value: function prepareDraw(peaks, channelIndex, start, end, fn, drawIndex, normalizedMax) {
                                var _this7 = this;
                                return util.frame(function() {
                                    // Split channels and call this function with the channelIndex set
                                    if (peaks[0] instanceof Array) {
                                        var channels = peaks;
                                        if (_this7.params.splitChannels) {
                                            var filteredChannels = channels.filter(function(c, i) {
                                                return !_this7.hideChannel(i);
                                            });
                                            if (!_this7.params.splitChannelsOptions.overlay) _this7.setHeight(Math.max(filteredChannels.length, 1) * _this7.params.height * _this7.params.pixelRatio);
                                            var overallAbsMax;
                                            if (_this7.params.splitChannelsOptions && _this7.params.splitChannelsOptions.relativeNormalization) // calculate maximum peak across channels to use for normalization
                                            overallAbsMax = util.max(channels.map(function(channelPeaks) {
                                                return util.absMax(channelPeaks);
                                            }));
                                            return channels.forEach(function(channelPeaks, i) {
                                                return _this7.prepareDraw(channelPeaks, i, start, end, fn, filteredChannels.indexOf(channelPeaks), overallAbsMax);
                                            });
                                        }
                                        peaks = channels[0];
                                    } // Return and do not draw channel peaks if hidden.
                                    if (_this7.hideChannel(channelIndex)) return;
                                     // calculate maximum modulation value, either from the barHeight
                                    // parameter or if normalize=true from the largest value in the peak
                                    // set
                                    var absmax = 1 / _this7.params.barHeight;
                                    if (_this7.params.normalize) absmax = normalizedMax === undefined ? util.absMax(peaks) : normalizedMax;
                                     // Bar wave draws the bottom only as a reflection of the top,
                                    // so we don't need negative values
                                    var hasMinVals = [].some.call(peaks, function(val) {
                                        return val < 0;
                                    });
                                    var height = _this7.params.height * _this7.params.pixelRatio;
                                    var halfH = height / 2;
                                    var offsetY = height * drawIndex || 0; // Override offsetY if overlay is true
                                    if (_this7.params.splitChannelsOptions && _this7.params.splitChannelsOptions.overlay) offsetY = 0;
                                    return fn({
                                        absmax: absmax,
                                        hasMinVals: hasMinVals,
                                        height: height,
                                        offsetY: offsetY,
                                        halfH: halfH,
                                        peaks: peaks,
                                        channelIndex: channelIndex
                                    });
                                })();
                            }
                        },
                        {
                            key: "setFillStyles",
                            value: function setFillStyles(entry) {
                                var waveColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.waveColor;
                                var progressColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.params.progressColor;
                                entry.setFillStyles(waveColor, progressColor);
                            }
                        },
                        {
                            key: "applyCanvasTransforms",
                            value: function applyCanvasTransforms(entry) {
                                var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                                entry.applyCanvasTransforms(vertical);
                            }
                        },
                        {
                            key: "getImage",
                            value: function getImage(format, quality, type) {
                                if (type === 'blob') return Promise.all(this.canvases.map(function(entry) {
                                    return entry.getImage(format, quality, type);
                                }));
                                else if (type === 'dataURL') {
                                    var images = this.canvases.map(function(entry) {
                                        return entry.getImage(format, quality, type);
                                    });
                                    return images.length > 1 ? images : images[0];
                                }
                            }
                        },
                        {
                            key: "updateProgress",
                            value: function updateProgress(position) {
                                this.style(this.progressWave, {
                                    width: position + 'px'
                                });
                            }
                        }
                    ]);
                    return MultiCanvas;
                }(_drawer.default);
                exports.default = MultiCanvas;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/mediaelement-webaudio.js": /*!**************************************!*\
  !*** ./src/mediaelement-webaudio.js ***!
  \**************************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _mediaelement = _interopRequireDefault(__webpack_require__(/*! ./mediaelement */ "./src/mediaelement.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _get(target, property, receiver) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
                    else _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) return desc.get.call(receiver);
                        return desc.value;
                    };
                    return _get(target, property, receiver || target);
                }
                function _superPropBase(object, property) {
                    while(!Object.prototype.hasOwnProperty.call(object, property)){
                        object = _getPrototypeOf(object);
                        if (object === null) break;
                    }
                    return object;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * MediaElementWebAudio backend: load audio via an HTML5 audio tag, but playback with the WebAudio API.
 * The advantage here is that the html5 <audio> tag can perform range requests on the server and not
 * buffer the entire file in one request, and you still get the filtering and scripting functionality
 * of the webaudio API.
 * Note that in order to use range requests and prevent buffering, you must provide peak data.
 *
 * @since 3.2.0
 */ var MediaElementWebAudio = /*#__PURE__*/ function(_MediaElement) {
                    _inherits(MediaElementWebAudio, _MediaElement);
                    var _super = _createSuper(MediaElementWebAudio);
                    /**
   * Construct the backend
   *
   * @param {WavesurferParams} params Wavesurfer parameters
   */ function MediaElementWebAudio(params) {
                        var _this;
                        _classCallCheck(this, MediaElementWebAudio);
                        _this = _super.call(this, params);
                        /** @private */ _this.params = params;
                        /** @private */ _this.sourceMediaElement = null;
                        return _this;
                    }
                    /**
   * Initialise the backend, called in `wavesurfer.createBackend()`
   */ _createClass(MediaElementWebAudio, [
                        {
                            key: "init",
                            value: function init() {
                                this.setPlaybackRate(this.params.audioRate);
                                this.createTimer();
                                this.createVolumeNode();
                                this.createScriptNode();
                                this.createAnalyserNode();
                            }
                        },
                        {
                            key: "_load",
                            value: function _load(media, peaks, preload) {
                                _get(_getPrototypeOf(MediaElementWebAudio.prototype), "_load", this).call(this, media, peaks, preload);
                                this.createMediaElementSource(media);
                            }
                        },
                        {
                            key: "createMediaElementSource",
                            value: function createMediaElementSource(mediaElement) {
                                this.sourceMediaElement = this.ac.createMediaElementSource(mediaElement);
                                this.sourceMediaElement.connect(this.analyser);
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                this.resumeAudioContext();
                                return _get(_getPrototypeOf(MediaElementWebAudio.prototype), "play", this).call(this, start, end);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                _get(_getPrototypeOf(MediaElementWebAudio.prototype), "destroy", this).call(this);
                                this.destroyWebAudio();
                            }
                        }
                    ]);
                    return MediaElementWebAudio;
                }(_mediaelement.default);
                exports.default = MediaElementWebAudio;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/mediaelement.js": /*!*****************************!*\
  !*** ./src/mediaelement.js ***!
  \*****************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _webaudio = _interopRequireDefault(__webpack_require__(/*! ./webaudio */ "./src/webaudio.js"));
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _get(target, property, receiver) {
                    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
                    else _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) return desc.get.call(receiver);
                        return desc.value;
                    };
                    return _get(target, property, receiver || target);
                }
                function _superPropBase(object, property) {
                    while(!Object.prototype.hasOwnProperty.call(object, property)){
                        object = _getPrototypeOf(object);
                        if (object === null) break;
                    }
                    return object;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * MediaElement backend
 */ var MediaElement = /*#__PURE__*/ function(_WebAudio) {
                    _inherits(MediaElement, _WebAudio);
                    var _super = _createSuper(MediaElement);
                    /**
   * Construct the backend
   *
   * @param {WavesurferParams} params Wavesurfer parameters
   */ function MediaElement(params) {
                        var _this;
                        _classCallCheck(this, MediaElement);
                        _this = _super.call(this, params);
                        /** @private */ _this.params = params;
                        /**
     * Initially a dummy media element to catch errors. Once `_load` is
     * called, this will contain the actual `HTMLMediaElement`.
     * @private
     */ _this.media = {
                            currentTime: 0,
                            duration: 0,
                            paused: true,
                            playbackRate: 1,
                            play: function play() {},
                            pause: function pause() {},
                            volume: 0
                        };
                        /** @private */ _this.mediaType = params.mediaType.toLowerCase();
                        /** @private */ _this.elementPosition = params.elementPosition;
                        /** @private */ _this.peaks = null;
                        /** @private */ _this.playbackRate = 1;
                        /** @private */ _this.volume = 1;
                        /** @private */ _this.isMuted = false;
                        /** @private */ _this.buffer = null;
                        /** @private */ _this.onPlayEnd = null;
                        /** @private */ _this.mediaListeners = {};
                        return _this;
                    }
                    /**
   * Initialise the backend, called in `wavesurfer.createBackend()`
   */ _createClass(MediaElement, [
                        {
                            key: "init",
                            value: function init() {
                                this.setPlaybackRate(this.params.audioRate);
                                this.createTimer();
                            }
                        },
                        {
                            key: "_setupMediaListeners",
                            value: function _setupMediaListeners() {
                                var _this2 = this;
                                this.mediaListeners.error = function() {
                                    _this2.fireEvent('error', 'Error loading media element');
                                };
                                this.mediaListeners.canplay = function() {
                                    _this2.fireEvent('canplay');
                                };
                                this.mediaListeners.ended = function() {
                                    _this2.fireEvent('finish');
                                }; // listen to and relay play, pause and seeked events to enable
                                // playback control from the external media element
                                this.mediaListeners.play = function() {
                                    _this2.fireEvent('play');
                                };
                                this.mediaListeners.pause = function() {
                                    _this2.fireEvent('pause');
                                };
                                this.mediaListeners.seeked = function(event) {
                                    _this2.fireEvent('seek');
                                };
                                this.mediaListeners.volumechange = function(event) {
                                    _this2.isMuted = _this2.media.muted;
                                    if (_this2.isMuted) _this2.volume = 0;
                                    else _this2.volume = _this2.media.volume;
                                    _this2.fireEvent('volume');
                                }; // reset event listeners
                                Object.keys(this.mediaListeners).forEach(function(id) {
                                    _this2.media.removeEventListener(id, _this2.mediaListeners[id]);
                                    _this2.media.addEventListener(id, _this2.mediaListeners[id]);
                                });
                            }
                        },
                        {
                            key: "createTimer",
                            value: function createTimer() {
                                var _this3 = this;
                                var onAudioProcess = function onAudioProcess() {
                                    if (_this3.isPaused()) return;
                                    _this3.fireEvent('audioprocess', _this3.getCurrentTime()); // Call again in the next frame
                                    util.frame(onAudioProcess)();
                                };
                                this.on('play', onAudioProcess); // Update the progress one more time to prevent it from being stuck in
                                // case of lower framerates
                                this.on('pause', function() {
                                    _this3.fireEvent('audioprocess', _this3.getCurrentTime());
                                });
                            }
                        },
                        {
                            key: "load",
                            value: function load(url, container, peaks, preload) {
                                var media = document.createElement(this.mediaType);
                                media.controls = this.params.mediaControls;
                                media.autoplay = this.params.autoplay || false;
                                media.preload = preload == null ? 'auto' : preload;
                                media.src = url;
                                media.style.width = '100%';
                                var prevMedia = container.querySelector(this.mediaType);
                                if (prevMedia) container.removeChild(prevMedia);
                                container.appendChild(media);
                                this._load(media, peaks, preload);
                            }
                        },
                        {
                            key: "loadElt",
                            value: function loadElt(elt, peaks) {
                                elt.controls = this.params.mediaControls;
                                elt.autoplay = this.params.autoplay || false;
                                this._load(elt, peaks, elt.preload);
                            }
                        },
                        {
                            key: "_load",
                            value: function _load(media, peaks, preload) {
                                // verify media element is valid
                                if (!(media instanceof HTMLMediaElement) || typeof media.addEventListener === 'undefined') throw new Error('media parameter is not a valid media element');
                                 // load must be called manually on iOS, otherwise peaks won't draw
                                // until a user interaction triggers load --> 'ready' event
                                //
                                // note that we avoid calling media.load here when given peaks and preload == 'none'
                                // as this almost always triggers some browser fetch of the media.
                                if (typeof media.load == 'function' && !(peaks && preload == 'none')) // Resets the media element and restarts the media resource. Any
                                // pending events are discarded. How much media data is fetched is
                                // still affected by the preload attribute.
                                media.load();
                                this.media = media;
                                this._setupMediaListeners();
                                this.peaks = peaks;
                                this.onPlayEnd = null;
                                this.buffer = null;
                                this.isMuted = media.muted;
                                this.setPlaybackRate(this.playbackRate);
                                this.setVolume(this.volume);
                            }
                        },
                        {
                            key: "isPaused",
                            value: function isPaused() {
                                return !this.media || this.media.paused;
                            }
                        },
                        {
                            key: "getDuration",
                            value: function getDuration() {
                                if (this.explicitDuration) return this.explicitDuration;
                                var duration = (this.buffer || this.media).duration;
                                if (duration >= Infinity) // streaming audio
                                duration = this.media.seekable.end(0);
                                return duration;
                            }
                        },
                        {
                            key: "getCurrentTime",
                            value: function getCurrentTime() {
                                return this.media && this.media.currentTime;
                            }
                        },
                        {
                            key: "getPlayedPercents",
                            value: function getPlayedPercents() {
                                return this.getCurrentTime() / this.getDuration() || 0;
                            }
                        },
                        {
                            key: "getPlaybackRate",
                            value: function getPlaybackRate() {
                                return this.playbackRate || this.media.playbackRate;
                            }
                        },
                        {
                            key: "setPlaybackRate",
                            value: function setPlaybackRate(value) {
                                this.playbackRate = value || 1;
                                this.media.playbackRate = this.playbackRate;
                            }
                        },
                        {
                            key: "seekTo",
                            value: function seekTo(start) {
                                if (start != null) this.media.currentTime = start;
                                this.clearPlayEnd();
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                this.seekTo(start);
                                var promise = this.media.play();
                                end && this.setPlayEnd(end);
                                return promise;
                            }
                        },
                        {
                            key: "pause",
                            value: function pause() {
                                var promise;
                                if (this.media) promise = this.media.pause();
                                this.clearPlayEnd();
                                return promise;
                            }
                        },
                        {
                            key: "setPlayEnd",
                            value: function setPlayEnd(end) {
                                var _this4 = this;
                                this.clearPlayEnd();
                                this._onPlayEnd = function(time) {
                                    if (time >= end) {
                                        _this4.pause();
                                        _this4.seekTo(end);
                                    }
                                };
                                this.on('audioprocess', this._onPlayEnd);
                            }
                        },
                        {
                            key: "clearPlayEnd",
                            value: function clearPlayEnd() {
                                if (this._onPlayEnd) {
                                    this.un('audioprocess', this._onPlayEnd);
                                    this._onPlayEnd = null;
                                }
                            }
                        },
                        {
                            key: "getPeaks",
                            value: function getPeaks(length, first, last) {
                                if (this.buffer) return _get(_getPrototypeOf(MediaElement.prototype), "getPeaks", this).call(this, length, first, last);
                                return this.peaks || [];
                            }
                        },
                        {
                            key: "setSinkId",
                            value: function setSinkId(deviceId) {
                                if (deviceId) {
                                    if (!this.media.setSinkId) return Promise.reject(new Error('setSinkId is not supported in your browser'));
                                    return this.media.setSinkId(deviceId);
                                }
                                return Promise.reject(new Error('Invalid deviceId: ' + deviceId));
                            }
                        },
                        {
                            key: "getVolume",
                            value: function getVolume() {
                                return this.volume;
                            }
                        },
                        {
                            key: "setVolume",
                            value: function setVolume(value) {
                                this.volume = value; // no need to change when it's already at that volume
                                if (this.media.volume !== this.volume) this.media.volume = this.volume;
                            }
                        },
                        {
                            key: "setMute",
                            value: function setMute(muted) {
                                // This causes a volume change to be emitted too through the
                                // volumechange event listener.
                                this.isMuted = this.media.muted = muted;
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                var _this5 = this;
                                this.pause();
                                this.unAll();
                                this.destroyed = true; // cleanup media event listeners
                                Object.keys(this.mediaListeners).forEach(function(id) {
                                    if (_this5.media) _this5.media.removeEventListener(id, _this5.mediaListeners[id]);
                                });
                                if (this.params.removeMediaElementOnDestroy && this.media && this.media.parentNode) this.media.parentNode.removeChild(this.media);
                                this.media = null;
                            }
                        }
                    ]);
                    return MediaElement;
                }(_webaudio.default);
                exports.default = MediaElement;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/peakcache.js": /*!**************************!*\
  !*** ./src/peakcache.js ***!
  \**************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * Caches the decoded peaks data to improve rendering speed for large audio
 *
 * Is used if the option parameter `partialRender` is set to `true`
 */ var PeakCache = /*#__PURE__*/ function() {
                    /**
   * Instantiate cache
   */ function PeakCache() {
                        _classCallCheck(this, PeakCache);
                        this.clearPeakCache();
                    }
                    /**
   * Empty the cache
   */ _createClass(PeakCache, [
                        {
                            key: "clearPeakCache",
                            value: function clearPeakCache() {
                                /**
       * Flat array with entries that are always in pairs to mark the
       * beginning and end of each subrange.  This is a convenience so we can
       * iterate over the pairs for easy set difference operations.
       * @private
       */ this.peakCacheRanges = [];
                                /**
       * Length of the entire cachable region, used for resetting the cache
       * when this changes (zoom events, for instance).
       * @private
       */ this.peakCacheLength = -1;
                            }
                        },
                        {
                            key: "addRangeToPeakCache",
                            value: function addRangeToPeakCache(length, start, end) {
                                if (length != this.peakCacheLength) {
                                    this.clearPeakCache();
                                    this.peakCacheLength = length;
                                } // Return ranges that weren't in the cache before the call.
                                var uncachedRanges = [];
                                var i = 0; // Skip ranges before the current start.
                                while(i < this.peakCacheRanges.length && this.peakCacheRanges[i] < start)i++;
                                 // If |i| is even, |start| falls after an existing range.  Otherwise,
                                // |start| falls between an existing range, and the uncached region
                                // starts when we encounter the next node in |peakCacheRanges| or
                                // |end|, whichever comes first.
                                if (i % 2 == 0) uncachedRanges.push(start);
                                while(i < this.peakCacheRanges.length && this.peakCacheRanges[i] <= end){
                                    uncachedRanges.push(this.peakCacheRanges[i]);
                                    i++;
                                } // If |i| is even, |end| is after all existing ranges.
                                if (i % 2 == 0) uncachedRanges.push(end);
                                 // Filter out the 0-length ranges.
                                uncachedRanges = uncachedRanges.filter(function(item, pos, arr) {
                                    if (pos == 0) return item != arr[pos + 1];
                                    else if (pos == arr.length - 1) return item != arr[pos - 1];
                                    return item != arr[pos - 1] && item != arr[pos + 1];
                                }); // Merge the two ranges together, uncachedRanges will either contain
                                // wholly new points, or duplicates of points in peakCacheRanges.  If
                                // duplicates are detected, remove both and extend the range.
                                this.peakCacheRanges = this.peakCacheRanges.concat(uncachedRanges);
                                this.peakCacheRanges = this.peakCacheRanges.sort(function(a, b) {
                                    return a - b;
                                }).filter(function(item, pos, arr) {
                                    if (pos == 0) return item != arr[pos + 1];
                                    else if (pos == arr.length - 1) return item != arr[pos - 1];
                                    return item != arr[pos - 1] && item != arr[pos + 1];
                                }); // Push the uncached ranges into an array of arrays for ease of
                                // iteration in the functions that call this.
                                var uncachedRangePairs = [];
                                for(i = 0; i < uncachedRanges.length; i += 2)uncachedRangePairs.push([
                                    uncachedRanges[i],
                                    uncachedRanges[i + 1]
                                ]);
                                return uncachedRangePairs;
                            }
                        },
                        {
                            key: "getCacheRanges",
                            value: function getCacheRanges() {
                                var peakCacheRangePairs = [];
                                var i;
                                for(i = 0; i < this.peakCacheRanges.length; i += 2)peakCacheRangePairs.push([
                                    this.peakCacheRanges[i],
                                    this.peakCacheRanges[i + 1]
                                ]);
                                return peakCacheRangePairs;
                            }
                        }
                    ]);
                    return PeakCache;
                }();
                exports.default = PeakCache;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/absMax.js": /*!****************************!*\
  !*** ./src/util/absMax.js ***!
  \****************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = absMax;
                var _max = _interopRequireDefault(__webpack_require__(/*! ./max */ "./src/util/max.js"));
                var _min = _interopRequireDefault(__webpack_require__(/*! ./min */ "./src/util/min.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Get the largest absolute value in an array
 *
 * @param   {Array} values Array of numbers
 * @returns {Number} Largest number found
 * @example console.log(max([-3, 2, 1]), max([-3, 2, 4])); // logs 3 4
 * @since 4.3.0
 */ function absMax(values) {
                    var max = (0, _max.default)(values);
                    var min = (0, _min.default)(values);
                    return -min > max ? -min : max;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/clamp.js": /*!***************************!*\
  !*** ./src/util/clamp.js ***!
  \***************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = clamp;
                /**
 * Returns a number limited to the given range.
 *
 * @param {number} val The number to be limited to a range
 * @param {number} min The lower boundary of the limit range
 * @param {number} max The upper boundary of the limit range
 * @returns {number} A number in the range [min, max]
 */ function clamp(val, min, max) {
                    return Math.min(Math.max(min, val), max);
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/fetch.js": /*!***************************!*\
  !*** ./src/util/fetch.js ***!
  \***************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = fetchFile;
                var _observer = _interopRequireDefault(__webpack_require__(/*! ./observer */ "./src/util/observer.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                var ProgressHandler = /*#__PURE__*/ function() {
                    /**
   * Instantiate ProgressHandler
   *
   * @param {Observer} instance The `fetchFile` observer instance.
   * @param {Number} contentLength Content length.
   * @param {Response} response Response object.
   */ function ProgressHandler(instance, contentLength, response) {
                        _classCallCheck(this, ProgressHandler);
                        this.instance = instance;
                        this.instance._reader = response.body.getReader();
                        this.total = parseInt(contentLength, 10);
                        this.loaded = 0;
                    }
                    /**
   * A method that is called once, immediately after the `ReadableStream``
   * is constructed.
   *
   * @param {ReadableStreamDefaultController} controller Controller instance
   *     used to control the stream.
   */ _createClass(ProgressHandler, [
                        {
                            key: "start",
                            value: function start(controller) {
                                var _this = this;
                                var read = function read() {
                                    // instance._reader.read() returns a promise that resolves
                                    // when a value has been received
                                    _this.instance._reader.read().then(function(_ref) {
                                        var done = _ref.done, value = _ref.value;
                                        // result objects contain two properties:
                                        // done  - true if the stream has already given you all its data.
                                        // value - some data. Always undefined when done is true.
                                        if (done) {
                                            // ensure onProgress called when content-length=0
                                            if (_this.total === 0) _this.instance.onProgress.call(_this.instance, {
                                                loaded: _this.loaded,
                                                total: _this.total,
                                                lengthComputable: false
                                            });
                                             // no more data needs to be consumed, close the stream
                                            controller.close();
                                            return;
                                        }
                                        _this.loaded += value.byteLength;
                                        _this.instance.onProgress.call(_this.instance, {
                                            loaded: _this.loaded,
                                            total: _this.total,
                                            lengthComputable: !(_this.total === 0)
                                        }); // enqueue the next data chunk into our target stream
                                        controller.enqueue(value);
                                        read();
                                    }).catch(function(error) {
                                        controller.error(error);
                                    });
                                };
                                read();
                            }
                        }
                    ]);
                    return ProgressHandler;
                }();
                /**
 * Load a file using `fetch`.
 *
 * @param {object} options Request options to use. See example below.
 * @returns {Observer} Observer instance
 * @example
 * // default options
 * let options = {
 *     url: undefined,
 *     method: 'GET',
 *     mode: 'cors',
 *     credentials: 'same-origin',
 *     cache: 'default',
 *     responseType: 'json',
 *     requestHeaders: [],
 *     redirect: 'follow',
 *     referrer: 'client'
 * };
 *
 * // override some options
 * options.url = '../media/demo.wav';

 * // available types: 'arraybuffer', 'blob', 'json' or 'text'
 * options.responseType = 'arraybuffer';
 *
 * // make fetch call
 * let request = util.fetchFile(options);
 *
 * // listen for events
 * request.on('progress', e => {
 *     console.log('progress', e);
 * });
 *
 * request.on('success', data => {
 *     console.log('success!', data);
 * });
 *
 * request.on('error', e => {
 *     console.warn('fetchFile error: ', e);
 * });
 */ function fetchFile(options) {
                    if (!options) throw new Error('fetch options missing');
                    else if (!options.url) throw new Error('fetch url missing');
                    var instance = new _observer.default();
                    var fetchHeaders = new Headers();
                    var fetchRequest = new Request(options.url); // add ability to abort
                    instance.controller = new AbortController(); // check if headers have to be added
                    if (options && options.requestHeaders) // add custom request headers
                    options.requestHeaders.forEach(function(header) {
                        fetchHeaders.append(header.key, header.value);
                    });
                     // parse fetch options
                    var responseType = options.responseType || 'json';
                    var fetchOptions = {
                        method: options.method || 'GET',
                        headers: fetchHeaders,
                        mode: options.mode || 'cors',
                        credentials: options.credentials || 'same-origin',
                        cache: options.cache || 'default',
                        redirect: options.redirect || 'follow',
                        referrer: options.referrer || 'client',
                        signal: instance.controller.signal
                    };
                    fetch(fetchRequest, fetchOptions).then(function(response) {
                        // store response reference
                        instance.response = response;
                        var progressAvailable = true;
                        if (!response.body) // ReadableStream is not yet supported in this browser
                        // see https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
                        progressAvailable = false;
                         // Server must send CORS header "Access-Control-Expose-Headers: content-length"
                        var contentLength = response.headers.get('content-length');
                        if (contentLength === null) // Content-Length server response header missing.
                        // Don't evaluate download progress if we can't compare against a total size
                        // see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Access-Control-Expose-Headers
                        progressAvailable = false;
                        if (!progressAvailable) // not able to check download progress so skip it
                        return response;
                         // fire progress event when during load
                        instance.onProgress = function(e) {
                            instance.fireEvent('progress', e);
                        };
                        return new Response(new ReadableStream(new ProgressHandler(instance, contentLength, response)), fetchOptions);
                    }).then(function(response) {
                        var errMsg;
                        if (response.ok) switch(responseType){
                            case 'arraybuffer':
                                return response.arrayBuffer();
                            case 'json':
                                return response.json();
                            case 'blob':
                                return response.blob();
                            case 'text':
                                return response.text();
                            default:
                                errMsg = 'Unknown responseType: ' + responseType;
                                break;
                        }
                        if (!errMsg) errMsg = 'HTTP error status: ' + response.status;
                        throw new Error(errMsg);
                    }).then(function(response) {
                        instance.fireEvent('success', response);
                    }).catch(function(error) {
                        instance.fireEvent('error', error);
                    }); // return the fetch request
                    instance.fetchRequest = fetchRequest;
                    return instance;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/frame.js": /*!***************************!*\
  !*** ./src/util/frame.js ***!
  \***************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = frame;
                var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(/*! ./request-animation-frame */ "./src/util/request-animation-frame.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                /**
 * Create a function which will be called at the next requestAnimationFrame
 * cycle
 *
 * @param {function} func The function to call
 *
 * @return {func} The function wrapped within a requestAnimationFrame
 */ function frame(func) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return (0, _requestAnimationFrame.default)(function() {
                            return func.apply(void 0, args);
                        });
                    };
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/get-id.js": /*!****************************!*\
  !*** ./src/util/get-id.js ***!
  \****************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = getId;
                /**
 * Get a random prefixed ID
 *
 * @param {String} prefix Prefix to use. Default is `'wavesurfer_'`.
 * @returns {String} Random prefixed ID
 * @example
 * console.log(getId()); // logs 'wavesurfer_b5pors4ru6g'
 *
 * let prefix = 'foo-';
 * console.log(getId(prefix)); // logs 'foo-b5pors4ru6g'
 */ function getId(prefix) {
                    if (prefix === undefined) prefix = 'wavesurfer_';
                    return prefix + Math.random().toString(32).substring(2);
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/index.js": /*!***************************!*\
  !*** ./src/util/index.js ***!
  \***************************/ /***/ (__unused_webpack_module, exports, __webpack_require__)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "getId", {
                    enumerable: true,
                    get: function get() {
                        return _getId.default;
                    }
                });
                Object.defineProperty(exports, "max", {
                    enumerable: true,
                    get: function get() {
                        return _max.default;
                    }
                });
                Object.defineProperty(exports, "min", {
                    enumerable: true,
                    get: function get() {
                        return _min.default;
                    }
                });
                Object.defineProperty(exports, "absMax", {
                    enumerable: true,
                    get: function get() {
                        return _absMax.default;
                    }
                });
                Object.defineProperty(exports, "Observer", {
                    enumerable: true,
                    get: function get() {
                        return _observer.default;
                    }
                });
                Object.defineProperty(exports, "style", {
                    enumerable: true,
                    get: function get() {
                        return _style.default;
                    }
                });
                Object.defineProperty(exports, "requestAnimationFrame", {
                    enumerable: true,
                    get: function get() {
                        return _requestAnimationFrame.default;
                    }
                });
                Object.defineProperty(exports, "frame", {
                    enumerable: true,
                    get: function get() {
                        return _frame.default;
                    }
                });
                Object.defineProperty(exports, "debounce", {
                    enumerable: true,
                    get: function get() {
                        return _debounce.default;
                    }
                });
                Object.defineProperty(exports, "preventClick", {
                    enumerable: true,
                    get: function get() {
                        return _preventClick.default;
                    }
                });
                Object.defineProperty(exports, "fetchFile", {
                    enumerable: true,
                    get: function get() {
                        return _fetch.default;
                    }
                });
                Object.defineProperty(exports, "clamp", {
                    enumerable: true,
                    get: function get() {
                        return _clamp.default;
                    }
                });
                Object.defineProperty(exports, "withOrientation", {
                    enumerable: true,
                    get: function get() {
                        return _orientation.default;
                    }
                });
                Object.defineProperty(exports, "ignoreSilenceMode", {
                    enumerable: true,
                    get: function get() {
                        return _silenceMode.default;
                    }
                });
                var _getId = _interopRequireDefault(__webpack_require__(/*! ./get-id */ "./src/util/get-id.js"));
                var _max = _interopRequireDefault(__webpack_require__(/*! ./max */ "./src/util/max.js"));
                var _min = _interopRequireDefault(__webpack_require__(/*! ./min */ "./src/util/min.js"));
                var _absMax = _interopRequireDefault(__webpack_require__(/*! ./absMax */ "./src/util/absMax.js"));
                var _observer = _interopRequireDefault(__webpack_require__(/*! ./observer */ "./src/util/observer.js"));
                var _style = _interopRequireDefault(__webpack_require__(/*! ./style */ "./src/util/style.js"));
                var _requestAnimationFrame = _interopRequireDefault(__webpack_require__(/*! ./request-animation-frame */ "./src/util/request-animation-frame.js"));
                var _frame = _interopRequireDefault(__webpack_require__(/*! ./frame */ "./src/util/frame.js"));
                var _debounce = _interopRequireDefault(__webpack_require__(/*! debounce */ "./node_modules/debounce/index.js"));
                var _preventClick = _interopRequireDefault(__webpack_require__(/*! ./prevent-click */ "./src/util/prevent-click.js"));
                var _fetch = _interopRequireDefault(__webpack_require__(/*! ./fetch */ "./src/util/fetch.js"));
                var _clamp = _interopRequireDefault(__webpack_require__(/*! ./clamp */ "./src/util/clamp.js"));
                var _orientation = _interopRequireDefault(__webpack_require__(/*! ./orientation */ "./src/util/orientation.js"));
                var _silenceMode = _interopRequireDefault(__webpack_require__(/*! ./silence-mode */ "./src/util/silence-mode.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
            /***/ },
            /***/ "./src/util/max.js": /*!*************************!*\
  !*** ./src/util/max.js ***!
  \*************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = max;
                /**
 * Get the largest value
 *
 * @param   {Array} values Array of numbers
 * @returns {Number} Largest number found
 * @example console.log(max([1, 2, 3])); // logs 3
 */ function max(values) {
                    var largest = -Infinity;
                    Object.keys(values).forEach(function(i) {
                        if (values[i] > largest) largest = values[i];
                    });
                    return largest;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/min.js": /*!*************************!*\
  !*** ./src/util/min.js ***!
  \*************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = min;
                /**
 * Get the smallest value
 *
 * @param   {Array} values Array of numbers
 * @returns {Number} Smallest number found
 * @example console.log(min([1, 2, 3])); // logs 1
 */ function min(values) {
                    var smallest = Number(Infinity);
                    Object.keys(values).forEach(function(i) {
                        if (values[i] < smallest) smallest = values[i];
                    });
                    return smallest;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/observer.js": /*!******************************!*\
  !*** ./src/util/observer.js ***!
  \******************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * @typedef {Object} ListenerDescriptor
 * @property {string} name The name of the event
 * @property {function} callback The callback
 * @property {function} un The function to call to remove the listener
 */ /**
 * Observer class
 */ var Observer = /*#__PURE__*/ function() {
                    /**
   * Instantiate Observer
   */ function Observer() {
                        _classCallCheck(this, Observer);
                        /**
     * @private
     * @todo Initialise the handlers here already and remove the conditional
     * assignment in `on()`
     */ this._disabledEventEmissions = [];
                        this.handlers = null;
                    }
                    /**
   * Attach a handler function for an event.
   *
   * @param {string} event Name of the event to listen to
   * @param {function} fn The callback to trigger when the event is fired
   * @return {ListenerDescriptor} The event descriptor
   */ _createClass(Observer, [
                        {
                            key: "on",
                            value: function on(event, fn) {
                                var _this = this;
                                if (!this.handlers) this.handlers = {};
                                var handlers = this.handlers[event];
                                if (!handlers) handlers = this.handlers[event] = [];
                                handlers.push(fn); // Return an event descriptor
                                return {
                                    name: event,
                                    callback: fn,
                                    un: function un(e, fn) {
                                        return _this.un(e, fn);
                                    }
                                };
                            }
                        },
                        {
                            key: "un",
                            value: function un(event, fn) {
                                if (!this.handlers) return;
                                var handlers = this.handlers[event];
                                var i;
                                if (handlers) {
                                    if (fn) {
                                        for(i = handlers.length - 1; i >= 0; i--)if (handlers[i] == fn) handlers.splice(i, 1);
                                    } else handlers.length = 0;
                                }
                            }
                        },
                        {
                            key: "unAll",
                            value: function unAll() {
                                this.handlers = null;
                            }
                        },
                        {
                            key: "once",
                            value: function once(event, handler) {
                                var _this2 = this;
                                var fn = function fn() {
                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                    /*  eslint-disable no-invalid-this */ handler.apply(_this2, args);
                                    /*  eslint-enable no-invalid-this */ setTimeout(function() {
                                        _this2.un(event, fn);
                                    }, 0);
                                };
                                return this.on(event, fn);
                            }
                        },
                        {
                            key: "setDisabledEventEmissions",
                            value: function setDisabledEventEmissions(eventNames) {
                                this._disabledEventEmissions = eventNames;
                            }
                        },
                        {
                            key: "_isDisabledEventEmission",
                            value: function _isDisabledEventEmission(event) {
                                return this._disabledEventEmissions && this._disabledEventEmissions.includes(event);
                            }
                        },
                        {
                            key: "fireEvent",
                            value: function fireEvent(event) {
                                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                                if (!this.handlers || this._isDisabledEventEmission(event)) return;
                                var handlers = this.handlers[event];
                                handlers && handlers.forEach(function(fn) {
                                    fn.apply(void 0, args);
                                });
                            }
                        }
                    ]);
                    return Observer;
                }();
                exports.default = Observer;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/orientation.js": /*!*********************************!*\
  !*** ./src/util/orientation.js ***!
  \*********************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = withOrientation;
                var verticalPropMap = {
                    width: 'height',
                    height: 'width',
                    overflowX: 'overflowY',
                    overflowY: 'overflowX',
                    clientWidth: 'clientHeight',
                    clientHeight: 'clientWidth',
                    clientX: 'clientY',
                    clientY: 'clientX',
                    scrollWidth: 'scrollHeight',
                    scrollLeft: 'scrollTop',
                    offsetLeft: 'offsetTop',
                    offsetTop: 'offsetLeft',
                    offsetHeight: 'offsetWidth',
                    offsetWidth: 'offsetHeight',
                    left: 'top',
                    right: 'bottom',
                    top: 'left',
                    bottom: 'right',
                    borderRightStyle: 'borderBottomStyle',
                    borderRightWidth: 'borderBottomWidth',
                    borderRightColor: 'borderBottomColor'
                };
                /**
 * Convert a horizontally-oriented property name to a vertical one.
 *
 * @param {string} prop A property name
 * @param {bool} vertical Whether the element is oriented vertically
 * @returns {string} prop, converted appropriately
 */ function mapProp(prop, vertical) {
                    if (Object.prototype.hasOwnProperty.call(verticalPropMap, prop)) return vertical ? verticalPropMap[prop] : prop;
                    else return prop;
                }
                var isProxy = Symbol("isProxy");
                /**
 * Returns an appropriately oriented object based on vertical.
 * If vertical is true, attribute getting and setting will be mapped through
 * verticalPropMap, so that e.g. getting the object's .width will give its
 * .height instead.
 * Certain methods of an oriented object will return oriented objects as well.
 * Oriented objects can't be added to the DOM directly since they are Proxy objects
 * and thus fail typechecks. Use domElement to get the actual element for this.
 *
 * @param {object} target The object to be wrapped and oriented
 * @param {bool} vertical Whether the element is oriented vertically
 * @returns {Proxy} An oriented object with attr translation via verticalAttrMap
 * @since 5.0.0
 */ function withOrientation(target, vertical) {
                    if (target[isProxy]) return target;
                    else return new Proxy(target, {
                        get: function get(obj, prop, receiver) {
                            if (prop === isProxy) return true;
                            else if (prop === 'domElement') return obj;
                            else if (prop === 'style') return withOrientation(obj.style, vertical);
                            else if (prop === 'canvas') return withOrientation(obj.canvas, vertical);
                            else if (prop === 'getBoundingClientRect') return function() {
                                return withOrientation(obj.getBoundingClientRect.apply(obj, arguments), vertical);
                            };
                            else if (prop === 'getContext') return function() {
                                return withOrientation(obj.getContext.apply(obj, arguments), vertical);
                            };
                            else {
                                var value = obj[mapProp(prop, vertical)];
                                return typeof value == 'function' ? value.bind(obj) : value;
                            }
                        },
                        set: function set(obj, prop, value) {
                            obj[mapProp(prop, vertical)] = value;
                            return true;
                        }
                    });
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/prevent-click.js": /*!***********************************!*\
  !*** ./src/util/prevent-click.js ***!
  \***********************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = preventClick;
                /**
 * Stops propagation of click event and removes event listener
 *
 * @private
 * @param {object} event The click event
 */ function preventClickHandler(event) {
                    event.stopPropagation();
                    document.body.removeEventListener('click', preventClickHandler, true);
                }
                /**
 * Starts listening for click event and prevent propagation
 *
 * @param {object} values Values
 */ function preventClick(values) {
                    document.body.addEventListener('click', preventClickHandler, true);
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/request-animation-frame.js": /*!*********************************************!*\
  !*** ./src/util/request-animation-frame.js ***!
  \*********************************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                /* eslint-disable valid-jsdoc */ /**
 * Returns the `requestAnimationFrame` function for the browser, or a shim with
 * `setTimeout` if the function is not found
 *
 * @return {function} Available `requestAnimationFrame` function for the browser
 */ var _default = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback, element) {
                    return setTimeout(callback, 1000 / 60);
                }).bind(window);
                exports.default = _default;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/silence-mode.js": /*!**********************************!*\
  !*** ./src/util/silence-mode.js ***!
  \**********************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = ignoreSilenceMode;
                /**
 * Ignores device silence mode when using the `WebAudio` backend.
 *
 * Many mobile devices contain a hardware button to mute the ringtone for incoming
 * calls and messages. Unfortunately, on some platforms like iOS, this also mutes
 * wavesurfer's audio when using the `WebAudio` backend. This function creates a
 * temporary `<audio>` element that makes sure the WebAudio backend keeps playing
 * when muting the device ringer.
 *
 * @since 5.2.0
 */ function ignoreSilenceMode() {
                    // Set the src to a short bit of url encoded as a silent mp3
                    // NOTE The silence MP3 must be high quality, when web audio sounds are played
                    // in parallel the web audio sound is mixed to match the bitrate of the html sound
                    // 0.01 seconds of silence VBR220-260 Joint Stereo 859B
                    var audioData = "data:audio/mpeg;base64,//uQxAAAAAAAAAAAAAAAAAAAAAAAWGluZwAAAA8AAAACAAACcQCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA//////////////////////////////////////////////////////////////////8AAABhTEFNRTMuMTAwA8MAAAAAAAAAABQgJAUHQQAB9AAAAnGMHkkIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//sQxAADgnABGiAAQBCqgCRMAAgEAH///////////////7+n/9FTuQsQH//////2NG0jWUGlio5gLQTOtIoeR2WX////X4s9Atb/JRVCbBUpeRUq//////////////////9RUi0f2jn/+xDECgPCjAEQAABN4AAANIAAAAQVTEFNRTMuMTAwVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVQ=="; // disable iOS Airplay (setting the attribute in js doesn't work)
                    var tmp = document.createElement("div");
                    tmp.innerHTML = '<audio x-webkit-airplay="deny"></audio>';
                    var audioSilentMode = tmp.children.item(0);
                    audioSilentMode.src = audioData;
                    audioSilentMode.preload = "auto";
                    audioSilentMode.type = "audio/mpeg";
                    audioSilentMode.disableRemotePlayback = true; // play
                    audioSilentMode.play(); // cleanup
                    audioSilentMode.remove();
                    tmp.remove();
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/util/style.js": /*!***************************!*\
  !*** ./src/util/style.js ***!
  \***************************/ /***/ (module1, exports)=>{
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = style;
                /**
 * Apply a map of styles to an element
 *
 * @param {HTMLElement} el The element that the styles will be applied to
 * @param {Object} styles The map of propName: attribute, both are used as-is
 *
 * @return {HTMLElement} el
 */ function style(el, styles) {
                    Object.keys(styles).forEach(function(prop) {
                        if (el.style[prop] !== styles[prop]) el.style[prop] = styles[prop];
                    });
                    return el;
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/wavesurfer.js": /*!***************************!*\
  !*** ./src/wavesurfer.js ***!
  \***************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                var _drawer = _interopRequireDefault(__webpack_require__(/*! ./drawer.multicanvas */ "./src/drawer.multicanvas.js"));
                var _webaudio = _interopRequireDefault(__webpack_require__(/*! ./webaudio */ "./src/webaudio.js"));
                var _mediaelement = _interopRequireDefault(__webpack_require__(/*! ./mediaelement */ "./src/mediaelement.js"));
                var _peakcache = _interopRequireDefault(__webpack_require__(/*! ./peakcache */ "./src/peakcache.js"));
                var _mediaelementWebaudio = _interopRequireDefault(__webpack_require__(/*! ./mediaelement-webaudio */ "./src/mediaelement-webaudio.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /*
 * This work is licensed under a BSD-3-Clause License.
 */ /** @external {HTMLElement} https://developer.mozilla.org/en/docs/Web/API/HTMLElement */ /** @external {OfflineAudioContext} https://developer.mozilla.org/en-US/docs/Web/API/OfflineAudioContext */ /** @external {File} https://developer.mozilla.org/en-US/docs/Web/API/File */ /** @external {Blob} https://developer.mozilla.org/en-US/docs/Web/API/Blob */ /** @external {CanvasRenderingContext2D} https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D */ /** @external {MediaStreamConstraints} https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints */ /** @external {AudioNode} https://developer.mozilla.org/de/docs/Web/API/AudioNode */ /**
 * @typedef {Object} WavesurferParams
 * @property {AudioContext} audioContext=null Use your own previously
 * initialized AudioContext or leave blank.
 * @property {number} audioRate=1 Speed at which to play audio. Lower number is
 * slower.
 * @property {ScriptProcessorNode} audioScriptProcessor=null Use your own previously
 * initialized ScriptProcessorNode or leave blank.
 * @property {boolean} autoCenter=true If a scrollbar is present, center the
 * waveform on current progress
 * @property {number} autoCenterRate=5 If autoCenter is active, rate at which the
 * waveform is centered
 * @property {boolean} autoCenterImmediately=false If autoCenter is active, immediately
 * center waveform on current progress
 * @property {string} backend='WebAudio' `'WebAudio'|'MediaElement'|'MediaElementWebAudio'` In most cases
 * you don't have to set this manually. MediaElement is a fallback for unsupported browsers.
 * MediaElementWebAudio allows to use WebAudio API also with big audio files, loading audio like with
 * MediaElement backend (HTML5 audio tag). You have to use the same methods of MediaElement backend for loading and
 * playback, giving also peaks, so the audio data are not decoded. In this way you can use WebAudio features, like filters,
 * also with audio with big duration. For example:
 * ` wavesurfer.load(url | HTMLMediaElement, peaks, preload, duration);
 *   wavesurfer.play();
 *   wavesurfer.setFilter(customFilter);
 * `
 * @property {string} backgroundColor=null Change background color of the
 * waveform container.
 * @property {number} barHeight=1 The height of the wave bars.
 * @property {number} barRadius=0 The radius of the wave bars. Makes bars rounded
 * @property {number} barGap=null The optional spacing between bars of the wave,
 * if not provided will be calculated in legacy format.
 * @property {number} barWidth=null Draw the waveform using bars.
 * @property {number} barMinHeight=null If specified, draw at least a bar of this height,
 * eliminating waveform gaps
 * @property {boolean} closeAudioContext=false Close and nullify all audio
 * contexts when the destroy method is called.
 * @property {!string|HTMLElement} container CSS selector or HTML element where
 * the waveform should be drawn. This is the only required parameter.
 * @property {string} cursorColor='#333' The fill color of the cursor indicating
 * the playhead position.
 * @property {number} cursorWidth=1 Measured in pixels.
 * @property {object} drawingContextAttributes={desynchronized: false} Drawing context
 * attributes.
 * @property {number} duration=null Optional audio length so pre-rendered peaks
 * can be display immediately for example.
 * @property {boolean} fillParent=true Whether to fill the entire container or
 * draw only according to `minPxPerSec`.
 * @property {boolean} forceDecode=false Force decoding of audio using web audio
 * when zooming to get a more detailed waveform.
 * @property {number} height=128 The height of the waveform. Measured in
 * pixels.
 * @property {boolean} hideScrollbar=false Whether to hide the horizontal
 * scrollbar when one would normally be shown.
 * @property {boolean} ignoreSilenceMode=false If true, ignores device silence mode
 * when using the `WebAudio` backend.
 * @property {boolean} interact=true Whether the mouse interaction will be
 * enabled at initialization. You can switch this parameter at any time later
 * on.
 * @property {boolean} loopSelection=true (Use with regions plugin) Enable
 * looping of selected regions
 * @property {number} maxCanvasWidth=4000 Maximum width of a single canvas in
 * pixels, excluding a small overlap (2 * `pixelRatio`, rounded up to the next
 * even integer). If the waveform is longer than this value, additional canvases
 * will be used to render the waveform, which is useful for very large waveforms
 * that may be too wide for browsers to draw on a single canvas.
 * @property {boolean} mediaControls=false (Use with backend `MediaElement` or `MediaElementWebAudio`)
 * this enables the native controls for the media element
 * @property {string} mediaType='audio' (Use with backend `MediaElement` or `MediaElementWebAudio`)
 * `'audio'|'video'` ('video' only for `MediaElement`)
 * @property {number} minPxPerSec=20 Minimum number of pixels per second of
 * audio.
 * @property {boolean} normalize=false If true, normalize by the maximum peak
 * instead of 1.0.
 * @property {boolean} partialRender=false Use the PeakCache to improve
 * rendering speed of large waveforms
 * @property {number} pixelRatio=window.devicePixelRatio The pixel ratio used to
 * calculate display
 * @property {PluginDefinition[]} plugins=[] An array of plugin definitions to
 * register during instantiation, they will be directly initialised unless they
 * are added with the `deferInit` property set to true.
 * @property {string} progressColor='#555' The fill color of the part of the
 * waveform behind the cursor. When `progressColor` and `waveColor` are the same
 * the progress wave is not rendered at all.
 * @property {boolean} removeMediaElementOnDestroy=true Set to false to keep the
 * media element in the DOM when the player is destroyed. This is useful when
 * reusing an existing media element via the `loadMediaElement` method.
 * @property {Object} renderer=MultiCanvas Can be used to inject a custom
 * renderer.
 * @property {boolean|number} responsive=false If set to `true` resize the
 * waveform, when the window is resized. This is debounced with a `100ms`
 * timeout by default. If this parameter is a number it represents that timeout.
 * @property {boolean} rtl=false If set to `true`, renders waveform from
 * right-to-left.
 * @property {boolean} scrollParent=false Whether to scroll the container with a
 * lengthy waveform. Otherwise the waveform is shrunk to the container width
 * (see fillParent).
 * @property {number} skipLength=2 Number of seconds to skip with the
 * skipForward() and skipBackward() methods.
 * @property {boolean} splitChannels=false Render with separate waveforms for
 * the channels of the audio
 * @property {SplitChannelOptions} splitChannelsOptions={} Options for splitChannel rendering
 * @property {boolean} vertical=false Render the waveform vertically instead of horizontally.
 * @property {string} waveColor='#999' The fill color of the waveform after the
 * cursor.
 * @property {object} xhr={} XHR options. For example:
 * `let xhr = {
 *     cache: 'default',
 *     mode: 'cors',
 *     method: 'GET',
 *     credentials: 'same-origin',
 *     redirect: 'follow',
 *     referrer: 'client',
 *     requestHeaders: [
 *         {
 *             key: 'Authorization',
 *             value: 'my-token'
 *         }
 *     ]
 * };`
 */ /**
 * @typedef {Object} PluginDefinition
 * @desc The Object used to describe a plugin
 * @example wavesurfer.addPlugin(pluginDefinition);
 * @property {string} name The name of the plugin, the plugin instance will be
 * added as a property to the wavesurfer instance under this name
 * @property {?Object} staticProps The properties that should be added to the
 * wavesurfer instance as static properties
 * @property {?boolean} deferInit Don't initialise plugin
 * automatically
 * @property {Object} params={} The plugin parameters, they are the first parameter
 * passed to the plugin class constructor function
 * @property {PluginClass} instance The plugin instance factory, is called with
 * the dependency specified in extends. Returns the plugin class.
 */ /**
 * @typedef {Object} SplitChannelOptions
 * @desc parameters applied when splitChannels option is true
 * @property {boolean} overlay=false determines whether channels are rendered on top of each other or on separate tracks
 * @property {object} channelColors={} object describing color for each channel. Example:
 * {
 *     0: {
 *         progressColor: 'green',
 *         waveColor: 'pink'
 *     },
 *     1: {
 *         progressColor: 'orange',
 *         waveColor: 'purple'
 *     }
 * }
 * @property {number[]} filterChannels=[] indexes of channels to be hidden from rendering
 * @property {boolean} relativeNormalization=false determines whether
 * normalization is done per channel or maintains proportionality between
 * channels. Only applied when normalize and splitChannels are both true.
 * @since 4.3.0
 */ /**
 * @interface PluginClass
 *
 * @desc This is the interface which is implemented by all plugin classes. Note
 * that this only turns into an observer after being passed through
 * `wavesurfer.addPlugin`.
 *
 * @extends {Observer}
 */ var PluginClass = /*#__PURE__*/ function() {
                    /**
   * Construct the plugin
   *
   * @param {Object} params={} The plugin params (specific to the plugin)
   * @param {Object} ws The wavesurfer instance
   */ function PluginClass(params, ws) {
                        _classCallCheck(this, PluginClass);
                    }
                    /**
   * Initialise the plugin
   *
   * Start doing something. This is called by
   * `wavesurfer.initPlugin(pluginName)`
   */ _createClass(PluginClass, [
                        {
                            key: "create",
                            value: /**
     * Plugin definition factory
     *
     * This function must be used to create a plugin definition which can be
     * used by wavesurfer to correctly instantiate the plugin.
     *
     * It returns a `PluginDefinition` object representing the plugin.
     *
     * @param {Object} params={} The plugin params (specific to the plugin)
     */ function create(params) {}
                        },
                        {
                            key: "init",
                            value: function init() {}
                        },
                        {
                            key: "destroy",
                            value: function destroy() {}
                        }
                    ]);
                    return PluginClass;
                }();
                /**
 * WaveSurfer core library class
 *
 * @extends {Observer}
 * @example
 * const params = {
 *   container: '#waveform',
 *   waveColor: 'violet',
 *   progressColor: 'purple'
 * };
 *
 * // initialise like this
 * const wavesurfer = WaveSurfer.create(params);
 *
 * // or like this ...
 * const wavesurfer = new WaveSurfer(params);
 * wavesurfer.init();
 *
 * // load audio file
 * wavesurfer.load('example/media/demo.wav');
 */ var WaveSurfer = /*#__PURE__*/ function(_util$Observer) {
                    _inherits(WaveSurfer, _util$Observer);
                    var _super = _createSuper(WaveSurfer);
                    /**
   * Initialise wavesurfer instance
   *
   * @param {WavesurferParams} params Instantiation options for wavesurfer
   * @example
   * const wavesurfer = new WaveSurfer(params);
   * @returns {this} Wavesurfer instance
   */ function WaveSurfer(params) {
                        var _this;
                        _classCallCheck(this, WaveSurfer);
                        _this = _super.call(this);
                        /**
     * Extract relevant parameters (or defaults)
     * @private
     */ _this.defaultParams = {
                            audioContext: null,
                            audioScriptProcessor: null,
                            audioRate: 1,
                            autoCenter: true,
                            autoCenterRate: 5,
                            autoCenterImmediately: false,
                            backend: 'WebAudio',
                            backgroundColor: null,
                            barHeight: 1,
                            barRadius: 0,
                            barGap: null,
                            barMinHeight: null,
                            container: null,
                            cursorColor: '#333',
                            cursorWidth: 1,
                            dragSelection: true,
                            drawingContextAttributes: {
                                // Boolean that hints the user agent to reduce the latency
                                // by desynchronizing the canvas paint cycle from the event
                                // loop
                                desynchronized: false
                            },
                            duration: null,
                            fillParent: true,
                            forceDecode: false,
                            height: 128,
                            hideScrollbar: false,
                            ignoreSilenceMode: false,
                            interact: true,
                            loopSelection: true,
                            maxCanvasWidth: 4000,
                            mediaContainer: null,
                            mediaControls: false,
                            mediaType: 'audio',
                            minPxPerSec: 20,
                            normalize: false,
                            partialRender: false,
                            pixelRatio: window.devicePixelRatio || screen.deviceXDPI / screen.logicalXDPI,
                            plugins: [],
                            progressColor: '#555',
                            removeMediaElementOnDestroy: true,
                            renderer: _drawer.default,
                            responsive: false,
                            rtl: false,
                            scrollParent: false,
                            skipLength: 2,
                            splitChannels: false,
                            splitChannelsOptions: {
                                overlay: false,
                                channelColors: {},
                                filterChannels: [],
                                relativeNormalization: false
                            },
                            vertical: false,
                            waveColor: '#999',
                            xhr: {}
                        };
                        _this.backends = {
                            MediaElement: _mediaelement.default,
                            WebAudio: _webaudio.default,
                            MediaElementWebAudio: _mediaelementWebaudio.default
                        };
                        _this.util = util;
                        _this.params = Object.assign({}, _this.defaultParams, params);
                        _this.params.splitChannelsOptions = Object.assign({}, _this.defaultParams.splitChannelsOptions, params.splitChannelsOptions);
                        /** @private */ _this.container = 'string' == typeof params.container ? document.querySelector(_this.params.container) : _this.params.container;
                        if (!_this.container) throw new Error('Container element not found');
                        if (_this.params.mediaContainer == null) /** @private */ _this.mediaContainer = _this.container;
                        else if (typeof _this.params.mediaContainer == 'string') /** @private */ _this.mediaContainer = document.querySelector(_this.params.mediaContainer);
                        else /** @private */ _this.mediaContainer = _this.params.mediaContainer;
                        if (!_this.mediaContainer) throw new Error('Media Container element not found');
                        if (_this.params.maxCanvasWidth <= 1) throw new Error('maxCanvasWidth must be greater than 1');
                        else if (_this.params.maxCanvasWidth % 2 == 1) throw new Error('maxCanvasWidth must be an even number');
                        if (_this.params.rtl === true) {
                            if (_this.params.vertical === true) util.style(_this.container, {
                                transform: 'rotateX(180deg)'
                            });
                            else util.style(_this.container, {
                                transform: 'rotateY(180deg)'
                            });
                        }
                        if (_this.params.backgroundColor) _this.setBackgroundColor(_this.params.backgroundColor);
                        /**
     * @private Used to save the current volume when muting so we can
     * restore once unmuted
     * @type {number}
     */ _this.savedVolume = 0;
                        /**
     * @private The current muted state
     * @type {boolean}
     */ _this.isMuted = false;
                        /**
     * @private Will hold a list of event descriptors that need to be
     * canceled on subsequent loads of audio
     * @type {Object[]}
     */ _this.tmpEvents = [];
                        /**
     * @private Holds any running audio downloads
     * @type {Observer}
     */ _this.currentRequest = null;
                        /** @private */ _this.arraybuffer = null;
                        /** @private */ _this.drawer = null;
                        /** @private */ _this.backend = null;
                        /** @private */ _this.peakCache = null; // cache constructor objects
                        if (typeof _this.params.renderer !== 'function') throw new Error('Renderer parameter is invalid');
                        /**
     * @private The uninitialised Drawer class
     */ _this.Drawer = _this.params.renderer;
                        /**
     * @private The uninitialised Backend class
     */ // Back compat
                        if (_this.params.backend == 'AudioElement') _this.params.backend = 'MediaElement';
                        if ((_this.params.backend == 'WebAudio' || _this.params.backend === 'MediaElementWebAudio') && !_webaudio.default.prototype.supportsWebAudio.call(null)) _this.params.backend = 'MediaElement';
                        _this.Backend = _this.backends[_this.params.backend];
                        /**
     * @private map of plugin names that are currently initialised
     */ _this.initialisedPluginList = {};
                        /** @private */ _this.isDestroyed = false;
                        /**
     * Get the current ready status.
     *
     * @example const isReady = wavesurfer.isReady;
     * @return {boolean}
     */ _this.isReady = false; // responsive debounced event listener. If this.params.responsive is not
                        // set, this is never called. Use 100ms or this.params.responsive as
                        // timeout for the debounce function.
                        var prevWidth = 0;
                        _this._onResize = util.debounce(function() {
                            if (prevWidth != _this.drawer.wrapper.clientWidth && !_this.params.scrollParent) {
                                prevWidth = _this.drawer.wrapper.clientWidth;
                                _this.drawer.fireEvent('redraw');
                            }
                        }, typeof _this.params.responsive === 'number' ? _this.params.responsive : 100);
                        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
                    }
                    /**
   * Initialise the wave
   *
   * @example
   * var wavesurfer = new WaveSurfer(params);
   * wavesurfer.init();
   * @return {this} The wavesurfer instance
   */ _createClass(WaveSurfer, [
                        {
                            key: "init",
                            value: function init() {
                                this.registerPlugins(this.params.plugins);
                                this.createDrawer();
                                this.createBackend();
                                this.createPeakCache();
                                return this;
                            }
                        },
                        {
                            key: "registerPlugins",
                            value: function registerPlugins(plugins) {
                                var _this2 = this;
                                // first instantiate all the plugins
                                plugins.forEach(function(plugin) {
                                    return _this2.addPlugin(plugin);
                                }); // now run the init functions
                                plugins.forEach(function(plugin) {
                                    // call init function of the plugin if deferInit is falsey
                                    // in that case you would manually use initPlugins()
                                    if (!plugin.deferInit) _this2.initPlugin(plugin.name);
                                });
                                this.fireEvent('plugins-registered', plugins);
                                return this;
                            }
                        },
                        {
                            key: "getActivePlugins",
                            value: function getActivePlugins() {
                                return this.initialisedPluginList;
                            }
                        },
                        {
                            key: "addPlugin",
                            value: function addPlugin(plugin) {
                                var _this3 = this;
                                if (!plugin.name) throw new Error('Plugin does not have a name!');
                                if (!plugin.instance) throw new Error("Plugin ".concat(plugin.name, " does not have an instance property!"));
                                 // staticProps properties are applied to wavesurfer instance
                                if (plugin.staticProps) Object.keys(plugin.staticProps).forEach(function(pluginStaticProp) {
                                    /**
           * Properties defined in a plugin definition's `staticProps` property are added as
           * staticProps properties of the WaveSurfer instance
           */ _this3[pluginStaticProp] = plugin.staticProps[pluginStaticProp];
                                });
                                var Instance = plugin.instance; // turn the plugin instance into an observer
                                var observerPrototypeKeys = Object.getOwnPropertyNames(util.Observer.prototype);
                                observerPrototypeKeys.forEach(function(key) {
                                    Instance.prototype[key] = util.Observer.prototype[key];
                                });
                                /**
       * Instantiated plugin classes are added as a property of the wavesurfer
       * instance
       * @type {Object}
       */ this[plugin.name] = new Instance(plugin.params || {}, this);
                                this.fireEvent('plugin-added', plugin.name);
                                return this;
                            }
                        },
                        {
                            key: "initPlugin",
                            value: function initPlugin(name) {
                                if (!this[name]) throw new Error("Plugin ".concat(name, " has not been added yet!"));
                                if (this.initialisedPluginList[name]) // destroy any already initialised plugins
                                this.destroyPlugin(name);
                                this[name].init();
                                this.initialisedPluginList[name] = true;
                                this.fireEvent('plugin-initialised', name);
                                return this;
                            }
                        },
                        {
                            key: "destroyPlugin",
                            value: function destroyPlugin(name) {
                                if (!this[name]) throw new Error("Plugin ".concat(name, " has not been added yet and cannot be destroyed!"));
                                if (!this.initialisedPluginList[name]) throw new Error("Plugin ".concat(name, " is not active and cannot be destroyed!"));
                                if (typeof this[name].destroy !== 'function') throw new Error("Plugin ".concat(name, " does not have a destroy function!"));
                                this[name].destroy();
                                delete this.initialisedPluginList[name];
                                this.fireEvent('plugin-destroyed', name);
                                return this;
                            }
                        },
                        {
                            key: "destroyAllPlugins",
                            value: function destroyAllPlugins() {
                                var _this4 = this;
                                Object.keys(this.initialisedPluginList).forEach(function(name) {
                                    return _this4.destroyPlugin(name);
                                });
                            }
                        },
                        {
                            key: "createDrawer",
                            value: function createDrawer() {
                                var _this5 = this;
                                this.drawer = new this.Drawer(this.container, this.params);
                                this.drawer.init();
                                this.fireEvent('drawer-created', this.drawer);
                                if (this.params.responsive !== false) {
                                    window.addEventListener('resize', this._onResize, true);
                                    window.addEventListener('orientationchange', this._onResize, true);
                                }
                                this.drawer.on('redraw', function() {
                                    _this5.drawBuffer();
                                    _this5.drawer.progress(_this5.backend.getPlayedPercents());
                                }); // Click-to-seek
                                this.drawer.on('click', function(e, progress) {
                                    setTimeout(function() {
                                        return _this5.seekTo(progress);
                                    }, 0);
                                }); // Relay the scroll event from the drawer
                                this.drawer.on('scroll', function(e) {
                                    if (_this5.params.partialRender) _this5.drawBuffer();
                                    _this5.fireEvent('scroll', e);
                                });
                            }
                        },
                        {
                            key: "createBackend",
                            value: function createBackend() {
                                var _this6 = this;
                                if (this.backend) this.backend.destroy();
                                this.backend = new this.Backend(this.params);
                                this.backend.init();
                                this.fireEvent('backend-created', this.backend);
                                this.backend.on('finish', function() {
                                    _this6.drawer.progress(_this6.backend.getPlayedPercents());
                                    _this6.fireEvent('finish');
                                });
                                this.backend.on('play', function() {
                                    return _this6.fireEvent('play');
                                });
                                this.backend.on('pause', function() {
                                    return _this6.fireEvent('pause');
                                });
                                this.backend.on('audioprocess', function(time) {
                                    _this6.drawer.progress(_this6.backend.getPlayedPercents());
                                    _this6.fireEvent('audioprocess', time);
                                }); // only needed for MediaElement and MediaElementWebAudio backend
                                if (this.params.backend === 'MediaElement' || this.params.backend === 'MediaElementWebAudio') {
                                    this.backend.on('seek', function() {
                                        _this6.drawer.progress(_this6.backend.getPlayedPercents());
                                    });
                                    this.backend.on('volume', function() {
                                        var newVolume = _this6.getVolume();
                                        _this6.fireEvent('volume', newVolume);
                                        if (_this6.backend.isMuted !== _this6.isMuted) {
                                            _this6.isMuted = _this6.backend.isMuted;
                                            _this6.fireEvent('mute', _this6.isMuted);
                                        }
                                    });
                                }
                            }
                        },
                        {
                            key: "createPeakCache",
                            value: function createPeakCache() {
                                if (this.params.partialRender) this.peakCache = new _peakcache.default();
                            }
                        },
                        {
                            key: "getDuration",
                            value: function getDuration() {
                                return this.backend.getDuration();
                            }
                        },
                        {
                            key: "getCurrentTime",
                            value: function getCurrentTime() {
                                return this.backend.getCurrentTime();
                            }
                        },
                        {
                            key: "setCurrentTime",
                            value: function setCurrentTime(seconds) {
                                if (seconds >= this.getDuration()) this.seekTo(1);
                                else this.seekTo(seconds / this.getDuration());
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                var _this7 = this;
                                if (this.params.ignoreSilenceMode) // ignores device hardware silence mode
                                util.ignoreSilenceMode();
                                this.fireEvent('interaction', function() {
                                    return _this7.play(start, end);
                                });
                                return this.backend.play(start, end);
                            }
                        },
                        {
                            key: "setPlayEnd",
                            value: function setPlayEnd(position) {
                                this.backend.setPlayEnd(position);
                            }
                        },
                        {
                            key: "pause",
                            value: function pause() {
                                if (!this.backend.isPaused()) return this.backend.pause();
                            }
                        },
                        {
                            key: "playPause",
                            value: function playPause() {
                                return this.backend.isPaused() ? this.play() : this.pause();
                            }
                        },
                        {
                            key: "isPlaying",
                            value: function isPlaying() {
                                return !this.backend.isPaused();
                            }
                        },
                        {
                            key: "skipBackward",
                            value: function skipBackward(seconds) {
                                this.skip(-seconds || -this.params.skipLength);
                            }
                        },
                        {
                            key: "skipForward",
                            value: function skipForward(seconds) {
                                this.skip(seconds || this.params.skipLength);
                            }
                        },
                        {
                            key: "skip",
                            value: function skip(offset) {
                                var duration = this.getDuration() || 1;
                                var position = this.getCurrentTime() || 0;
                                position = Math.max(0, Math.min(duration, position + (offset || 0)));
                                this.seekAndCenter(position / duration);
                            }
                        },
                        {
                            key: "seekAndCenter",
                            value: function seekAndCenter(progress) {
                                this.seekTo(progress);
                                this.drawer.recenter(progress);
                            }
                        },
                        {
                            key: "seekTo",
                            value: function seekTo(progress) {
                                var _this8 = this;
                                // return an error if progress is not a number between 0 and 1
                                if (typeof progress !== 'number' || !isFinite(progress) || progress < 0 || progress > 1) throw new Error('Error calling wavesurfer.seekTo, parameter must be a number between 0 and 1!');
                                this.fireEvent('interaction', function() {
                                    return _this8.seekTo(progress);
                                });
                                var isWebAudioBackend = this.params.backend === 'WebAudio';
                                var paused = this.backend.isPaused();
                                if (isWebAudioBackend && !paused) this.backend.pause();
                                 // avoid small scrolls while paused seeking
                                var oldScrollParent = this.params.scrollParent;
                                this.params.scrollParent = false;
                                this.backend.seekTo(progress * this.getDuration());
                                this.drawer.progress(progress);
                                if (isWebAudioBackend && !paused) this.backend.play();
                                this.params.scrollParent = oldScrollParent;
                                this.fireEvent('seek', progress);
                            }
                        },
                        {
                            key: "stop",
                            value: function stop() {
                                this.pause();
                                this.seekTo(0);
                                this.drawer.progress(0);
                            }
                        },
                        {
                            key: "setSinkId",
                            value: function setSinkId(deviceId) {
                                return this.backend.setSinkId(deviceId);
                            }
                        },
                        {
                            key: "setVolume",
                            value: function setVolume(newVolume) {
                                this.backend.setVolume(newVolume);
                                this.fireEvent('volume', newVolume);
                            }
                        },
                        {
                            key: "getVolume",
                            value: function getVolume() {
                                return this.backend.getVolume();
                            }
                        },
                        {
                            key: "setPlaybackRate",
                            value: function setPlaybackRate(rate) {
                                this.backend.setPlaybackRate(rate);
                            }
                        },
                        {
                            key: "getPlaybackRate",
                            value: function getPlaybackRate() {
                                return this.backend.getPlaybackRate();
                            }
                        },
                        {
                            key: "toggleMute",
                            value: function toggleMute() {
                                this.setMute(!this.isMuted);
                            }
                        },
                        {
                            key: "setMute",
                            value: function setMute(mute) {
                                // ignore all muting requests if the audio is already in that state
                                if (mute === this.isMuted) {
                                    this.fireEvent('mute', this.isMuted);
                                    return;
                                }
                                if (this.backend.setMute) {
                                    // Backends such as the MediaElement backend have their own handling
                                    // of mute, let them handle it.
                                    this.backend.setMute(mute);
                                    this.isMuted = mute;
                                } else if (mute) {
                                    // If currently not muted then save current volume,
                                    // turn off the volume and update the mute properties
                                    this.savedVolume = this.backend.getVolume();
                                    this.backend.setVolume(0);
                                    this.isMuted = true;
                                    this.fireEvent('volume', 0);
                                } else {
                                    // If currently muted then restore to the saved volume
                                    // and update the mute properties
                                    this.backend.setVolume(this.savedVolume);
                                    this.isMuted = false;
                                    this.fireEvent('volume', this.savedVolume);
                                }
                                this.fireEvent('mute', this.isMuted);
                            }
                        },
                        {
                            key: "getMute",
                            value: function getMute() {
                                return this.isMuted;
                            }
                        },
                        {
                            key: "getFilters",
                            value: function getFilters() {
                                return this.backend.filters || [];
                            }
                        },
                        {
                            key: "toggleScroll",
                            value: function toggleScroll() {
                                this.params.scrollParent = !this.params.scrollParent;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "toggleInteraction",
                            value: function toggleInteraction() {
                                this.params.interact = !this.params.interact;
                            }
                        },
                        {
                            key: "getWaveColor",
                            value: function getWaveColor() {
                                return this.params.waveColor;
                            }
                        },
                        {
                            key: "setWaveColor",
                            value: function setWaveColor(color) {
                                this.params.waveColor = color;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "getProgressColor",
                            value: function getProgressColor() {
                                return this.params.progressColor;
                            }
                        },
                        {
                            key: "setProgressColor",
                            value: function setProgressColor(color) {
                                this.params.progressColor = color;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "getBackgroundColor",
                            value: function getBackgroundColor() {
                                return this.params.backgroundColor;
                            }
                        },
                        {
                            key: "setBackgroundColor",
                            value: function setBackgroundColor(color) {
                                this.params.backgroundColor = color;
                                util.style(this.container, {
                                    background: this.params.backgroundColor
                                });
                            }
                        },
                        {
                            key: "getCursorColor",
                            value: function getCursorColor() {
                                return this.params.cursorColor;
                            }
                        },
                        {
                            key: "setCursorColor",
                            value: function setCursorColor(color) {
                                this.params.cursorColor = color;
                                this.drawer.updateCursor();
                            }
                        },
                        {
                            key: "getHeight",
                            value: function getHeight() {
                                return this.params.height;
                            }
                        },
                        {
                            key: "setHeight",
                            value: function setHeight(height) {
                                this.params.height = height;
                                this.drawer.setHeight(height * this.params.pixelRatio);
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "setFilteredChannels",
                            value: function setFilteredChannels(channelIndices) {
                                this.params.splitChannelsOptions.filterChannels = channelIndices;
                                this.drawBuffer();
                            }
                        },
                        {
                            key: "drawBuffer",
                            value: function drawBuffer() {
                                var nominalWidth = Math.round(this.getDuration() * this.params.minPxPerSec * this.params.pixelRatio);
                                var parentWidth = this.drawer.getWidth();
                                var width = nominalWidth; // always start at 0 after zooming for scrolling : issue redraw left part
                                var start = 0;
                                var end = Math.max(start + parentWidth, width); // Fill container
                                if (this.params.fillParent && (!this.params.scrollParent || nominalWidth < parentWidth)) {
                                    width = parentWidth;
                                    start = 0;
                                    end = width;
                                }
                                var peaks;
                                if (this.params.partialRender) {
                                    var newRanges = this.peakCache.addRangeToPeakCache(width, start, end);
                                    var i;
                                    for(i = 0; i < newRanges.length; i++){
                                        peaks = this.backend.getPeaks(width, newRanges[i][0], newRanges[i][1]);
                                        this.drawer.drawPeaks(peaks, width, newRanges[i][0], newRanges[i][1]);
                                    }
                                } else {
                                    peaks = this.backend.getPeaks(width, start, end);
                                    this.drawer.drawPeaks(peaks, width, start, end);
                                }
                                this.fireEvent('redraw', peaks, width);
                            }
                        },
                        {
                            key: "zoom",
                            value: function zoom(pxPerSec) {
                                if (!pxPerSec) {
                                    this.params.minPxPerSec = this.defaultParams.minPxPerSec;
                                    this.params.scrollParent = false;
                                } else {
                                    this.params.minPxPerSec = pxPerSec;
                                    this.params.scrollParent = true;
                                }
                                this.drawBuffer();
                                this.drawer.progress(this.backend.getPlayedPercents());
                                this.drawer.recenter(this.getCurrentTime() / this.getDuration());
                                this.fireEvent('zoom', pxPerSec);
                            }
                        },
                        {
                            key: "loadArrayBuffer",
                            value: function loadArrayBuffer(arraybuffer) {
                                var _this9 = this;
                                this.decodeArrayBuffer(arraybuffer, function(data) {
                                    if (!_this9.isDestroyed) _this9.loadDecodedBuffer(data);
                                });
                            }
                        },
                        {
                            key: "loadDecodedBuffer",
                            value: function loadDecodedBuffer(buffer) {
                                this.backend.load(buffer);
                                this.drawBuffer();
                                this.isReady = true;
                                this.fireEvent('ready');
                            }
                        },
                        {
                            key: "loadBlob",
                            value: function loadBlob(blob) {
                                var _this10 = this;
                                // Create file reader
                                var reader = new FileReader();
                                reader.addEventListener('progress', function(e) {
                                    return _this10.onProgress(e);
                                });
                                reader.addEventListener('load', function(e) {
                                    return _this10.loadArrayBuffer(e.target.result);
                                });
                                reader.addEventListener('error', function() {
                                    return _this10.fireEvent('error', 'Error reading file');
                                });
                                reader.readAsArrayBuffer(blob);
                                this.empty();
                            }
                        },
                        {
                            key: "load",
                            value: function load(url, peaks, preload, duration) {
                                if (!url) throw new Error('url parameter cannot be empty');
                                this.empty();
                                if (preload) {
                                    // check whether the preload attribute will be usable and if not log
                                    // a warning listing the reasons why not and nullify the variable
                                    var preloadIgnoreReasons = {
                                        "Preload is not 'auto', 'none' or 'metadata'": [
                                            'auto',
                                            'metadata',
                                            'none'
                                        ].indexOf(preload) === -1,
                                        'Peaks are not provided': !peaks,
                                        "Backend is not of type 'MediaElement' or 'MediaElementWebAudio'": [
                                            'MediaElement',
                                            'MediaElementWebAudio'
                                        ].indexOf(this.params.backend) === -1,
                                        'Url is not of type string': typeof url !== 'string'
                                    };
                                    var activeReasons = Object.keys(preloadIgnoreReasons).filter(function(reason) {
                                        return preloadIgnoreReasons[reason];
                                    });
                                    if (activeReasons.length) {
                                        // eslint-disable-next-line no-console
                                        console.warn('Preload parameter of wavesurfer.load will be ignored because:\n\t- ' + activeReasons.join('\n\t- ')); // stop invalid values from being used
                                        preload = null;
                                    }
                                } // loadBuffer(url, peaks, duration) requires that url is a string
                                // but users can pass in a HTMLMediaElement to WaveSurfer
                                if (this.params.backend === 'WebAudio' && url instanceof HTMLMediaElement) url = url.src;
                                switch(this.params.backend){
                                    case 'WebAudio':
                                        return this.loadBuffer(url, peaks, duration);
                                    case 'MediaElement':
                                    case 'MediaElementWebAudio':
                                        return this.loadMediaElement(url, peaks, preload, duration);
                                }
                            }
                        },
                        {
                            key: "loadBuffer",
                            value: function loadBuffer(url, peaks, duration) {
                                var _this11 = this;
                                var load = function load(action) {
                                    if (action) _this11.tmpEvents.push(_this11.once('ready', action));
                                    return _this11.getArrayBuffer(url, function(data) {
                                        return _this11.loadArrayBuffer(data);
                                    });
                                };
                                if (peaks) {
                                    this.backend.setPeaks(peaks, duration);
                                    this.drawBuffer();
                                    this.fireEvent('waveform-ready');
                                    this.tmpEvents.push(this.once('interaction', load));
                                } else return load();
                            }
                        },
                        {
                            key: "loadMediaElement",
                            value: function loadMediaElement(urlOrElt, peaks, preload, duration) {
                                var _this12 = this;
                                var url = urlOrElt;
                                if (typeof urlOrElt === 'string') this.backend.load(url, this.mediaContainer, peaks, preload);
                                else {
                                    var elt = urlOrElt;
                                    this.backend.loadElt(elt, peaks); // If peaks are not provided,
                                    // url = element.src so we can get peaks with web audio
                                    url = elt.src;
                                }
                                this.tmpEvents.push(this.backend.once('canplay', function() {
                                    // ignore when backend was already destroyed
                                    if (!_this12.backend.destroyed) {
                                        _this12.drawBuffer();
                                        _this12.isReady = true;
                                        _this12.fireEvent('ready');
                                    }
                                }), this.backend.once('error', function(err) {
                                    return _this12.fireEvent('error', err);
                                })); // If peaks are provided, render them and fire the `waveform-ready` event.
                                if (peaks) {
                                    this.backend.setPeaks(peaks, duration);
                                    this.drawBuffer();
                                    this.fireEvent('waveform-ready');
                                } // If no pre-decoded peaks are provided, or are provided with
                                // forceDecode flag, attempt to download the audio file and decode it
                                // with Web Audio.
                                if ((!peaks || this.params.forceDecode) && this.backend.supportsWebAudio()) this.getArrayBuffer(url, function(arraybuffer) {
                                    _this12.decodeArrayBuffer(arraybuffer, function(buffer) {
                                        _this12.backend.buffer = buffer;
                                        _this12.backend.setPeaks(null);
                                        _this12.drawBuffer();
                                        _this12.fireEvent('waveform-ready');
                                    });
                                });
                            }
                        },
                        {
                            key: "decodeArrayBuffer",
                            value: function decodeArrayBuffer(arraybuffer, callback) {
                                var _this13 = this;
                                if (!this.isDestroyed) {
                                    this.arraybuffer = arraybuffer;
                                    this.backend.decodeArrayBuffer(arraybuffer, function(data) {
                                        // Only use the decoded data if we haven't been destroyed or
                                        // another decode started in the meantime
                                        if (!_this13.isDestroyed && _this13.arraybuffer == arraybuffer) {
                                            callback(data);
                                            _this13.arraybuffer = null;
                                        }
                                    }, function() {
                                        return _this13.fireEvent('error', 'Error decoding audiobuffer');
                                    });
                                }
                            }
                        },
                        {
                            key: "getArrayBuffer",
                            value: function getArrayBuffer(url, callback) {
                                var _this14 = this;
                                var options = Object.assign({
                                    url: url,
                                    responseType: 'arraybuffer'
                                }, this.params.xhr);
                                var request = util.fetchFile(options);
                                this.currentRequest = request;
                                this.tmpEvents.push(request.on('progress', function(e) {
                                    _this14.onProgress(e);
                                }), request.on('success', function(data) {
                                    callback(data);
                                    _this14.currentRequest = null;
                                }), request.on('error', function(e) {
                                    _this14.fireEvent('error', e);
                                    _this14.currentRequest = null;
                                }));
                                return request;
                            }
                        },
                        {
                            key: "onProgress",
                            value: function onProgress(e) {
                                var percentComplete;
                                if (e.lengthComputable) percentComplete = e.loaded / e.total;
                                else // Approximate progress with an asymptotic
                                // function, and assume downloads in the 1-3 MB range.
                                percentComplete = e.loaded / (e.loaded + 1000000);
                                this.fireEvent('loading', Math.round(percentComplete * 100), e.target);
                            }
                        },
                        {
                            key: "exportPCM",
                            value: function exportPCM(length, accuracy, noWindow, start, end) {
                                length = length || 1024;
                                start = start || 0;
                                accuracy = accuracy || 10000;
                                noWindow = noWindow || false;
                                var peaks = this.backend.getPeaks(length, start, end);
                                var arr = [].map.call(peaks, function(val) {
                                    return Math.round(val * accuracy) / accuracy;
                                });
                                return new Promise(function(resolve, reject) {
                                    if (!noWindow) {
                                        var blobJSON = new Blob([
                                            JSON.stringify(arr)
                                        ], {
                                            type: 'application/json;charset=utf-8'
                                        });
                                        var objURL = URL.createObjectURL(blobJSON);
                                        window.open(objURL);
                                        URL.revokeObjectURL(objURL);
                                    }
                                    resolve(arr);
                                });
                            }
                        },
                        {
                            key: "exportImage",
                            value: function exportImage(format, quality, type) {
                                if (!format) format = 'image/png';
                                if (!quality) quality = 1;
                                if (!type) type = 'dataURL';
                                return this.drawer.getImage(format, quality, type);
                            }
                        },
                        {
                            key: "cancelAjax",
                            value: function cancelAjax() {
                                if (this.currentRequest && this.currentRequest.controller) {
                                    // If the current request has a ProgressHandler, then its ReadableStream might need to be cancelled too
                                    // See: Wavesurfer issue #2042
                                    // See Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1583815
                                    if (this.currentRequest._reader) // Ignoring exceptions thrown by call to cancel()
                                    this.currentRequest._reader.cancel().catch(function(err) {});
                                    this.currentRequest.controller.abort();
                                    this.currentRequest = null;
                                }
                            }
                        },
                        {
                            key: "clearTmpEvents",
                            value: function clearTmpEvents() {
                                this.tmpEvents.forEach(function(e) {
                                    return e.un();
                                });
                            }
                        },
                        {
                            key: "empty",
                            value: function empty() {
                                if (!this.backend.isPaused()) {
                                    this.stop();
                                    this.backend.disconnectSource();
                                }
                                this.isReady = false;
                                this.cancelAjax();
                                this.clearTmpEvents(); // empty drawer
                                this.drawer.progress(0);
                                this.drawer.setWidth(0);
                                this.drawer.drawPeaks({
                                    length: this.drawer.getWidth()
                                }, 0);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.destroyAllPlugins();
                                this.fireEvent('destroy');
                                this.cancelAjax();
                                this.clearTmpEvents();
                                this.unAll();
                                if (this.params.responsive !== false) {
                                    window.removeEventListener('resize', this._onResize, true);
                                    window.removeEventListener('orientationchange', this._onResize, true);
                                }
                                if (this.backend) {
                                    this.backend.destroy(); // clears memory usage
                                    this.backend = null;
                                }
                                if (this.drawer) this.drawer.destroy();
                                this.isDestroyed = true;
                                this.isReady = false;
                                this.arraybuffer = null;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: /** @private */ /** @private */ /**
     * Instantiate this class, call its `init` function and returns it
     *
     * @param {WavesurferParams} params The wavesurfer parameters
     * @return {Object} WaveSurfer instance
     * @example const wavesurfer = WaveSurfer.create(params);
     */ function create(params) {
                                var wavesurfer = new WaveSurfer(params);
                                return wavesurfer.init();
                            }
                        }
                    ]);
                    return WaveSurfer;
                }(util.Observer);
                exports.default = WaveSurfer;
                WaveSurfer.VERSION = "5.2.0";
                WaveSurfer.util = util;
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/webaudio.js": /*!*************************!*\
  !*** ./src/webaudio.js ***!
  \*************************/ /***/ (module1, exports, __webpack_require__)=>{
                "use strict";
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var util = _interopRequireWildcard(__webpack_require__(/*! ./util */ "./src/util/index.js"));
                function _getRequireWildcardCache(nodeInterop) {
                    if (typeof WeakMap !== "function") return null;
                    var cacheBabelInterop = new WeakMap();
                    var cacheNodeInterop = new WeakMap();
                    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
                        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
                    })(nodeInterop);
                }
                function _interopRequireWildcard(obj, nodeInterop) {
                    if (!nodeInterop && obj && obj.__esModule) return obj;
                    if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") return {
                        default: obj
                    };
                    var cache = _getRequireWildcardCache(nodeInterop);
                    if (cache && cache.has(obj)) return cache.get(obj);
                    var newObj = {};
                    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
                    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
                        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
                        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
                        else newObj[key] = obj[key];
                    }
                    newObj.default = obj;
                    if (cache) cache.set(obj, newObj);
                    return newObj;
                }
                function _defineProperty(obj, key, value) {
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self1, call) {
                    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(self1);
                }
                function _assertThisInitialized(self1) {
                    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self1;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                // using constants to prevent someone writing the string wrong
                var PLAYING = 'playing';
                var PAUSED = 'paused';
                var FINISHED = 'finished';
                /**
 * WebAudio backend
 *
 * @extends {Observer}
 */ var WebAudio = /*#__PURE__*/ function(_util$Observer) {
                    _inherits(WebAudio, _util$Observer);
                    var _super = _createSuper(WebAudio);
                    /**
   * Construct the backend
   *
   * @param {WavesurferParams} params Wavesurfer parameters
   */ function WebAudio(params) {
                        var _this$stateBehaviors, _this$states;
                        var _this;
                        _classCallCheck(this, WebAudio);
                        _this = _super.call(this);
                        /** @private */ _this.audioContext = null;
                        _this.offlineAudioContext = null;
                        _this.stateBehaviors = (_this$stateBehaviors = {}, _defineProperty(_this$stateBehaviors, PLAYING, {
                            init: function init() {
                                this.addOnAudioProcess();
                            },
                            getPlayedPercents: function getPlayedPercents() {
                                var duration = this.getDuration();
                                return this.getCurrentTime() / duration || 0;
                            },
                            getCurrentTime: function getCurrentTime() {
                                return this.startPosition + this.getPlayedTime();
                            }
                        }), _defineProperty(_this$stateBehaviors, PAUSED, {
                            init: function init() {
                                this.removeOnAudioProcess();
                            },
                            getPlayedPercents: function getPlayedPercents() {
                                var duration = this.getDuration();
                                return this.getCurrentTime() / duration || 0;
                            },
                            getCurrentTime: function getCurrentTime() {
                                return this.startPosition;
                            }
                        }), _defineProperty(_this$stateBehaviors, FINISHED, {
                            init: function init() {
                                this.removeOnAudioProcess();
                                this.fireEvent('finish');
                            },
                            getPlayedPercents: function getPlayedPercents() {
                                return 1;
                            },
                            getCurrentTime: function getCurrentTime() {
                                return this.getDuration();
                            }
                        }), _this$stateBehaviors);
                        _this.params = params;
                        /** ac: Audio Context instance */ _this.ac = params.audioContext || (_this.supportsWebAudio() ? _this.getAudioContext() : {});
                        /**@private */ _this.lastPlay = _this.ac.currentTime;
                        /** @private */ _this.startPosition = 0;
                        /** @private */ _this.scheduledPause = null;
                        /** @private */ _this.states = (_this$states = {}, _defineProperty(_this$states, PLAYING, Object.create(_this.stateBehaviors[PLAYING])), _defineProperty(_this$states, PAUSED, Object.create(_this.stateBehaviors[PAUSED])), _defineProperty(_this$states, FINISHED, Object.create(_this.stateBehaviors[FINISHED])), _this$states);
                        /** @private */ _this.buffer = null;
                        /** @private */ _this.filters = [];
                        /** gainNode: allows to control audio volume */ _this.gainNode = null;
                        /** @private */ _this.mergedPeaks = null;
                        /** @private */ _this.offlineAc = null;
                        /** @private */ _this.peaks = null;
                        /** @private */ _this.playbackRate = 1;
                        /** analyser: provides audio analysis information */ _this.analyser = null;
                        /** scriptNode: allows processing audio */ _this.scriptNode = null;
                        /** @private */ _this.source = null;
                        /** @private */ _this.splitPeaks = [];
                        /** @private */ _this.state = null;
                        /** @private */ _this.explicitDuration = params.duration;
                        /**
     * Boolean indicating if the backend was destroyed.
     */ _this.destroyed = false;
                        return _this;
                    }
                    /**
   * Initialise the backend, called in `wavesurfer.createBackend()`
   */ _createClass(WebAudio, [
                        {
                            key: "supportsWebAudio",
                            value: /** scriptBufferSize: size of the processing buffer */ /** audioContext: allows to process audio with WebAudio API */ /** @private */ /** @private */ /**
     * Does the browser support this backend
     *
     * @return {boolean} Whether or not this browser supports this backend
     */ function supportsWebAudio() {
                                return !!(window.AudioContext || window.webkitAudioContext);
                            }
                        },
                        {
                            key: "getAudioContext",
                            value: function getAudioContext() {
                                if (!window.WaveSurferAudioContext) window.WaveSurferAudioContext = new (window.AudioContext || window.webkitAudioContext)();
                                return window.WaveSurferAudioContext;
                            }
                        },
                        {
                            key: "getOfflineAudioContext",
                            value: function getOfflineAudioContext(sampleRate) {
                                if (!window.WaveSurferOfflineAudioContext) window.WaveSurferOfflineAudioContext = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 2, sampleRate);
                                return window.WaveSurferOfflineAudioContext;
                            }
                        },
                        {
                            key: "init",
                            value: function init() {
                                this.createVolumeNode();
                                this.createScriptNode();
                                this.createAnalyserNode();
                                this.setState(PAUSED);
                                this.setPlaybackRate(this.params.audioRate);
                                this.setLength(0);
                            }
                        },
                        {
                            key: "disconnectFilters",
                            value: function disconnectFilters() {
                                if (this.filters) {
                                    this.filters.forEach(function(filter) {
                                        filter && filter.disconnect();
                                    });
                                    this.filters = null; // Reconnect direct path
                                    this.analyser.connect(this.gainNode);
                                }
                            }
                        },
                        {
                            key: "setState",
                            value: function setState(state) {
                                if (this.state !== this.states[state]) {
                                    this.state = this.states[state];
                                    this.state.init.call(this);
                                }
                            }
                        },
                        {
                            key: "setFilter",
                            value: function setFilter() {
                                for(var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++)filters[_key] = arguments[_key];
                                this.setFilters(filters);
                            }
                        },
                        {
                            key: "setFilters",
                            value: function setFilters(filters) {
                                // Remove existing filters
                                this.disconnectFilters(); // Insert filters if filter array not empty
                                if (filters && filters.length) {
                                    this.filters = filters; // Disconnect direct path before inserting filters
                                    this.analyser.disconnect(); // Connect each filter in turn
                                    filters.reduce(function(prev, curr) {
                                        prev.connect(curr);
                                        return curr;
                                    }, this.analyser).connect(this.gainNode);
                                }
                            }
                        },
                        {
                            key: "createScriptNode",
                            value: function createScriptNode() {
                                if (this.params.audioScriptProcessor) this.scriptNode = this.params.audioScriptProcessor;
                                else if (this.ac.createScriptProcessor) this.scriptNode = this.ac.createScriptProcessor(WebAudio.scriptBufferSize);
                                else this.scriptNode = this.ac.createJavaScriptNode(WebAudio.scriptBufferSize);
                                this.scriptNode.connect(this.ac.destination);
                            }
                        },
                        {
                            key: "addOnAudioProcess",
                            value: function addOnAudioProcess() {
                                var _this2 = this;
                                this.scriptNode.onaudioprocess = function() {
                                    var time = _this2.getCurrentTime();
                                    if (time >= _this2.getDuration()) {
                                        _this2.setState(FINISHED);
                                        _this2.fireEvent('pause');
                                    } else if (time >= _this2.scheduledPause) _this2.pause();
                                    else if (_this2.state === _this2.states[PLAYING]) _this2.fireEvent('audioprocess', time);
                                };
                            }
                        },
                        {
                            key: "removeOnAudioProcess",
                            value: function removeOnAudioProcess() {
                                this.scriptNode.onaudioprocess = null;
                            }
                        },
                        {
                            key: "createAnalyserNode",
                            value: function createAnalyserNode() {
                                this.analyser = this.ac.createAnalyser();
                                this.analyser.connect(this.gainNode);
                            }
                        },
                        {
                            key: "createVolumeNode",
                            value: function createVolumeNode() {
                                // Create gain node using the AudioContext
                                if (this.ac.createGain) this.gainNode = this.ac.createGain();
                                else this.gainNode = this.ac.createGainNode();
                                 // Add the gain node to the graph
                                this.gainNode.connect(this.ac.destination);
                            }
                        },
                        {
                            key: "setSinkId",
                            value: function setSinkId(deviceId) {
                                if (deviceId) {
                                    /**
         * The webaudio API doesn't currently support setting the device
         * output. Here we create an HTMLAudioElement, connect the
         * webaudio stream to that element and setSinkId there.
         */ var audio = new window.Audio();
                                    if (!audio.setSinkId) return Promise.reject(new Error('setSinkId is not supported in your browser'));
                                    audio.autoplay = true;
                                    var dest = this.ac.createMediaStreamDestination();
                                    this.gainNode.disconnect();
                                    this.gainNode.connect(dest);
                                    audio.srcObject = dest.stream;
                                    return audio.setSinkId(deviceId);
                                } else return Promise.reject(new Error('Invalid deviceId: ' + deviceId));
                            }
                        },
                        {
                            key: "setVolume",
                            value: function setVolume(value) {
                                this.gainNode.gain.setValueAtTime(value, this.ac.currentTime);
                            }
                        },
                        {
                            key: "getVolume",
                            value: function getVolume() {
                                return this.gainNode.gain.value;
                            }
                        },
                        {
                            key: "decodeArrayBuffer",
                            value: function decodeArrayBuffer(arraybuffer, callback, errback) {
                                if (!this.offlineAc) this.offlineAc = this.getOfflineAudioContext(this.ac && this.ac.sampleRate ? this.ac.sampleRate : 44100);
                                if ('webkitAudioContext' in window) // Safari: no support for Promise-based decodeAudioData enabled
                                // Enable it in Safari using the Experimental Features > Modern WebAudio API option
                                this.offlineAc.decodeAudioData(arraybuffer, function(data) {
                                    return callback(data);
                                }, errback);
                                else this.offlineAc.decodeAudioData(arraybuffer).then(function(data) {
                                    return callback(data);
                                }).catch(function(err) {
                                    return errback(err);
                                });
                            }
                        },
                        {
                            key: "setPeaks",
                            value: function setPeaks(peaks, duration) {
                                if (duration != null) this.explicitDuration = duration;
                                this.peaks = peaks;
                            }
                        },
                        {
                            key: "setLength",
                            value: function setLength(length) {
                                // No resize, we can preserve the cached peaks.
                                if (this.mergedPeaks && length == 2 * this.mergedPeaks.length - 1 + 2) return;
                                this.splitPeaks = [];
                                this.mergedPeaks = []; // Set the last element of the sparse array so the peak arrays are
                                // appropriately sized for other calculations.
                                var channels = this.buffer ? this.buffer.numberOfChannels : 1;
                                var c;
                                for(c = 0; c < channels; c++){
                                    this.splitPeaks[c] = [];
                                    this.splitPeaks[c][2 * (length - 1)] = 0;
                                    this.splitPeaks[c][2 * (length - 1) + 1] = 0;
                                }
                                this.mergedPeaks[2 * (length - 1)] = 0;
                                this.mergedPeaks[2 * (length - 1) + 1] = 0;
                            }
                        },
                        {
                            key: "getPeaks",
                            value: function getPeaks(length, first, last) {
                                if (this.peaks) return this.peaks;
                                if (!this.buffer) return [];
                                first = first || 0;
                                last = last || length - 1;
                                this.setLength(length);
                                if (!this.buffer) return this.params.splitChannels ? this.splitPeaks : this.mergedPeaks;
                                /**
       * The following snippet fixes a buffering data issue on the Safari
       * browser which returned undefined It creates the missing buffer based
       * on 1 channel, 4096 samples and the sampleRate from the current
       * webaudio context 4096 samples seemed to be the best fit for rendering
       * will review this code once a stable version of Safari TP is out
       */ if (!this.buffer.length) {
                                    var newBuffer = this.createBuffer(1, 4096, this.sampleRate);
                                    this.buffer = newBuffer.buffer;
                                }
                                var sampleSize = this.buffer.length / length;
                                var sampleStep = ~~(sampleSize / 10) || 1;
                                var channels = this.buffer.numberOfChannels;
                                var c;
                                for(c = 0; c < channels; c++){
                                    var peaks = this.splitPeaks[c];
                                    var chan = this.buffer.getChannelData(c);
                                    var i = void 0;
                                    for(i = first; i <= last; i++){
                                        var start = ~~(i * sampleSize);
                                        var end = ~~(start + sampleSize);
                                        /**
           * Initialize the max and min to the first sample of this
           * subrange, so that even if the samples are entirely
           * on one side of zero, we still return the true max and
           * min values in the subrange.
           */ var min = chan[start];
                                        var max = min;
                                        var j = void 0;
                                        for(j = start; j < end; j += sampleStep){
                                            var value = chan[j];
                                            if (value > max) max = value;
                                            if (value < min) min = value;
                                        }
                                        peaks[2 * i] = max;
                                        peaks[2 * i + 1] = min;
                                        if (c == 0 || max > this.mergedPeaks[2 * i]) this.mergedPeaks[2 * i] = max;
                                        if (c == 0 || min < this.mergedPeaks[2 * i + 1]) this.mergedPeaks[2 * i + 1] = min;
                                    }
                                }
                                return this.params.splitChannels ? this.splitPeaks : this.mergedPeaks;
                            }
                        },
                        {
                            key: "getPlayedPercents",
                            value: function getPlayedPercents() {
                                return this.state.getPlayedPercents.call(this);
                            }
                        },
                        {
                            key: "disconnectSource",
                            value: function disconnectSource() {
                                if (this.source) this.source.disconnect();
                            }
                        },
                        {
                            key: "destroyWebAudio",
                            value: function destroyWebAudio() {
                                this.disconnectFilters();
                                this.disconnectSource();
                                this.gainNode.disconnect();
                                this.scriptNode.disconnect();
                                this.analyser.disconnect(); // close the audioContext if closeAudioContext option is set to true
                                if (this.params.closeAudioContext) {
                                    // check if browser supports AudioContext.close()
                                    if (typeof this.ac.close === 'function' && this.ac.state != 'closed') this.ac.close();
                                     // clear the reference to the audiocontext
                                    this.ac = null; // clear the actual audiocontext, either passed as param or the
                                    // global singleton
                                    if (!this.params.audioContext) window.WaveSurferAudioContext = null;
                                    else this.params.audioContext = null;
                                     // clear the offlineAudioContext
                                    window.WaveSurferOfflineAudioContext = null;
                                }
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                if (!this.isPaused()) this.pause();
                                this.unAll();
                                this.buffer = null;
                                this.destroyed = true;
                                this.destroyWebAudio();
                            }
                        },
                        {
                            key: "load",
                            value: function load(buffer) {
                                this.startPosition = 0;
                                this.lastPlay = this.ac.currentTime;
                                this.buffer = buffer;
                                this.createSource();
                            }
                        },
                        {
                            key: "createSource",
                            value: function createSource() {
                                this.disconnectSource();
                                this.source = this.ac.createBufferSource(); // adjust for old browsers
                                this.source.start = this.source.start || this.source.noteGrainOn;
                                this.source.stop = this.source.stop || this.source.noteOff;
                                this.setPlaybackRate(this.playbackRate);
                                this.source.buffer = this.buffer;
                                this.source.connect(this.analyser);
                            }
                        },
                        {
                            key: "resumeAudioContext",
                            value: function resumeAudioContext() {
                                if (this.ac.state == 'suspended') this.ac.resume && this.ac.resume();
                            }
                        },
                        {
                            key: "isPaused",
                            value: function isPaused() {
                                return this.state !== this.states[PLAYING];
                            }
                        },
                        {
                            key: "getDuration",
                            value: function getDuration() {
                                if (this.explicitDuration) return this.explicitDuration;
                                if (!this.buffer) return 0;
                                return this.buffer.duration;
                            }
                        },
                        {
                            key: "seekTo",
                            value: function seekTo(start, end) {
                                if (!this.buffer) return;
                                this.scheduledPause = null;
                                if (start == null) {
                                    start = this.getCurrentTime();
                                    if (start >= this.getDuration()) start = 0;
                                }
                                if (end == null) end = this.getDuration();
                                this.startPosition = start;
                                this.lastPlay = this.ac.currentTime;
                                if (this.state === this.states[FINISHED]) this.setState(PAUSED);
                                return {
                                    start: start,
                                    end: end
                                };
                            }
                        },
                        {
                            key: "getPlayedTime",
                            value: function getPlayedTime() {
                                return (this.ac.currentTime - this.lastPlay) * this.playbackRate;
                            }
                        },
                        {
                            key: "play",
                            value: function play(start, end) {
                                if (!this.buffer) return;
                                 // need to re-create source on each playback
                                this.createSource();
                                var adjustedTime = this.seekTo(start, end);
                                start = adjustedTime.start;
                                end = adjustedTime.end;
                                this.scheduledPause = end;
                                this.source.start(0, start);
                                this.resumeAudioContext();
                                this.setState(PLAYING);
                                this.fireEvent('play');
                            }
                        },
                        {
                            key: "pause",
                            value: function pause() {
                                this.scheduledPause = null;
                                this.startPosition += this.getPlayedTime();
                                try {
                                    this.source && this.source.stop(0);
                                } catch (err) {
                                // - RangeError (The value specified for when is negative.)
                                // - InvalidStateNode (The node has not been started by calling start().)
                                // We can safely ignore both errors, because:
                                // - The range is surely correct
                                // - The node might not have been started yet, in which case we just want to carry on without causing any trouble.
                                }
                                this.setState(PAUSED);
                                this.fireEvent('pause');
                            }
                        },
                        {
                            key: "getCurrentTime",
                            value: function getCurrentTime() {
                                return this.state.getCurrentTime.call(this);
                            }
                        },
                        {
                            key: "getPlaybackRate",
                            value: function getPlaybackRate() {
                                return this.playbackRate;
                            }
                        },
                        {
                            key: "setPlaybackRate",
                            value: function setPlaybackRate(value) {
                                this.playbackRate = value || 1;
                                this.source && this.source.playbackRate.setValueAtTime(this.playbackRate, this.ac.currentTime);
                            }
                        },
                        {
                            key: "setPlayEnd",
                            value: function setPlayEnd(end) {
                                this.scheduledPause = end;
                            }
                        }
                    ]);
                    return WebAudio;
                }(util.Observer);
                exports.default = WebAudio;
                WebAudio.scriptBufferSize = 256;
                module1.exports = exports.default;
            /***/ },
            /***/ "./node_modules/debounce/index.js": /*!****************************************!*\
  !*** ./node_modules/debounce/index.js ***!
  \****************************************/ /***/ (module1)=>{
                /**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function debounce(func, wait, immediate) {
                    var timeout, args, context, timestamp, result;
                    if (null == wait) wait = 100;
                    function later() {
                        var last = Date.now() - timestamp;
                        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
                        else {
                            timeout = null;
                            if (!immediate) {
                                result = func.apply(context, args);
                                context = args = null;
                            }
                        }
                    }
                    var debounced = function() {
                        context = this;
                        args = arguments;
                        timestamp = Date.now();
                        var callNow = immediate && !timeout;
                        if (!timeout) timeout = setTimeout(later, wait);
                        if (callNow) {
                            result = func.apply(context, args);
                            context = args = null;
                        }
                        return result;
                    };
                    debounced.clear = function() {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                    };
                    debounced.flush = function() {
                        if (timeout) {
                            result = func.apply(context, args);
                            context = args = null;
                            clearTimeout(timeout);
                            timeout = null;
                        }
                    };
                    return debounced;
                }
                // Adds compatibility for ES modules
                debounce.debounce = debounce;
                module1.exports = debounce;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/wavesurfer.js");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});


var $f3bc61d5769e56ec$exports = {};
/*!
 * wavesurfer.js spectrogram plugin 5.2.0 (2021-08-16)
 * https://wavesurfer-js.org
 * @license BSD-3-Clause
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $f3bc61d5769e56ec$exports = factory();
})(self, function() {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ "./src/plugin/spectrogram/fft.js": /*!***************************************!*\
  !*** ./src/plugin/spectrogram/fft.js ***!
  \***************************************/ /***/ (module1, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = FFT;
                /* eslint-disable complexity, no-redeclare, no-var, one-var */ /**
 * Calculate FFT - Based on https://github.com/corbanbrook/dsp.js
 *
 * @param {Number} bufferSize Buffer size
 * @param {Number} sampleRate Sample rate
 * @param {Function} windowFunc Window function
 * @param {Number} alpha Alpha channel
 */ function FFT(bufferSize, sampleRate, windowFunc, alpha) {
                    this.bufferSize = bufferSize;
                    this.sampleRate = sampleRate;
                    this.bandwidth = 2 / bufferSize * (sampleRate / 2);
                    this.sinTable = new Float32Array(bufferSize);
                    this.cosTable = new Float32Array(bufferSize);
                    this.windowValues = new Float32Array(bufferSize);
                    this.reverseTable = new Uint32Array(bufferSize);
                    this.peakBand = 0;
                    this.peak = 0;
                    var i;
                    switch(windowFunc){
                        case 'bartlett':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = 2 / (bufferSize - 1) * ((bufferSize - 1) / 2 - Math.abs(i - (bufferSize - 1) / 2));
                            break;
                        case 'bartlettHann':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = 0.62 - 0.48 * Math.abs(i / (bufferSize - 1) - 0.5) - 0.38 * Math.cos(Math.PI * 2 * i / (bufferSize - 1));
                            break;
                        case 'blackman':
                            alpha = alpha || 0.16;
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = (1 - alpha) / 2 - 0.5 * Math.cos(Math.PI * 2 * i / (bufferSize - 1)) + alpha / 2 * Math.cos(4 * Math.PI * i / (bufferSize - 1));
                            break;
                        case 'cosine':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = Math.cos(Math.PI * i / (bufferSize - 1) - Math.PI / 2);
                            break;
                        case 'gauss':
                            alpha = alpha || 0.25;
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = Math.pow(Math.E, -0.5 * Math.pow((i - (bufferSize - 1) / 2) / (alpha * (bufferSize - 1) / 2), 2));
                            break;
                        case 'hamming':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = 0.54 - 0.46 * Math.cos(Math.PI * 2 * i / (bufferSize - 1));
                            break;
                        case 'hann':
                        case undefined:
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = 0.5 * (1 - Math.cos(Math.PI * 2 * i / (bufferSize - 1)));
                            break;
                        case 'lanczoz':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = Math.sin(Math.PI * (2 * i / (bufferSize - 1) - 1)) / (Math.PI * (2 * i / (bufferSize - 1) - 1));
                            break;
                        case 'rectangular':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = 1;
                            break;
                        case 'triangular':
                            for(i = 0; i < bufferSize; i++)this.windowValues[i] = 2 / bufferSize * (bufferSize / 2 - Math.abs(i - (bufferSize - 1) / 2));
                            break;
                        default:
                            throw Error("No such window function '" + windowFunc + "'");
                    }
                    var limit = 1;
                    var bit = bufferSize >> 1;
                    var i;
                    while(limit < bufferSize){
                        for(i = 0; i < limit; i++)this.reverseTable[i + limit] = this.reverseTable[i] + bit;
                        limit = limit << 1;
                        bit = bit >> 1;
                    }
                    for(i = 0; i < bufferSize; i++){
                        this.sinTable[i] = Math.sin(-Math.PI / i);
                        this.cosTable[i] = Math.cos(-Math.PI / i);
                    }
                    this.calculateSpectrum = function(buffer) {
                        // Locally scope variables for speed up
                        var bufferSize = this.bufferSize, cosTable = this.cosTable, sinTable = this.sinTable, reverseTable = this.reverseTable, real = new Float32Array(bufferSize), imag = new Float32Array(bufferSize), bSi = 2 / this.bufferSize, sqrt = Math.sqrt, rval, ival, mag, spectrum = new Float32Array(bufferSize / 2);
                        var k = Math.floor(Math.log(bufferSize) / Math.LN2);
                        if (Math.pow(2, k) !== bufferSize) throw 'Invalid buffer size, must be a power of 2.';
                        if (bufferSize !== buffer.length) throw 'Supplied buffer is not the same size as defined FFT. FFT Size: ' + bufferSize + ' Buffer Size: ' + buffer.length;
                        var halfSize = 1, phaseShiftStepReal, phaseShiftStepImag, currentPhaseShiftReal, currentPhaseShiftImag, off, tr, ti, tmpReal;
                        for(var i = 0; i < bufferSize; i++){
                            real[i] = buffer[reverseTable[i]] * this.windowValues[reverseTable[i]];
                            imag[i] = 0;
                        }
                        while(halfSize < bufferSize){
                            phaseShiftStepReal = cosTable[halfSize];
                            phaseShiftStepImag = sinTable[halfSize];
                            currentPhaseShiftReal = 1;
                            currentPhaseShiftImag = 0;
                            for(var fftStep = 0; fftStep < halfSize; fftStep++){
                                var i = fftStep;
                                while(i < bufferSize){
                                    off = i + halfSize;
                                    tr = currentPhaseShiftReal * real[off] - currentPhaseShiftImag * imag[off];
                                    ti = currentPhaseShiftReal * imag[off] + currentPhaseShiftImag * real[off];
                                    real[off] = real[i] - tr;
                                    imag[off] = imag[i] - ti;
                                    real[i] += tr;
                                    imag[i] += ti;
                                    i += halfSize << 1;
                                }
                                tmpReal = currentPhaseShiftReal;
                                currentPhaseShiftReal = tmpReal * phaseShiftStepReal - currentPhaseShiftImag * phaseShiftStepImag;
                                currentPhaseShiftImag = tmpReal * phaseShiftStepImag + currentPhaseShiftImag * phaseShiftStepReal;
                            }
                            halfSize = halfSize << 1;
                        }
                        for(var i = 0, N = bufferSize / 2; i < N; i++){
                            rval = real[i];
                            ival = imag[i];
                            mag = bSi * sqrt(rval * rval + ival * ival);
                            if (mag > this.peak) {
                                this.peakBand = i;
                                this.peak = mag;
                            }
                            spectrum[i] = mag;
                        }
                        return spectrum;
                    };
                }
                module1.exports = exports.default;
            /***/ },
            /***/ "./src/plugin/spectrogram/index.js": /*!*****************************************!*\
  !*** ./src/plugin/spectrogram/index.js ***!
  \*****************************************/ /***/ (module1, exports, __webpack_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = void 0;
                var _fft = _interopRequireDefault(__webpack_require__(/*! ./fft */ "./src/plugin/spectrogram/fft.js"));
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                /**
 * @typedef {Object} SpectrogramPluginParams
 * @property {string|HTMLElement} container Selector of element or element in
 * which to render
 * @property {number} fftSamples=512 Number of samples to fetch to FFT. Must be
 * a power of 2.
 * @property {boolean} labels Set to true to display frequency labels.
 * @property {number} noverlap Size of the overlapping window. Must be <
 * fftSamples. Auto deduced from canvas size by default.
 * @property {string} windowFunc='hann' The window function to be used. One of
 * these: `'bartlett'`, `'bartlettHann'`, `'blackman'`, `'cosine'`, `'gauss'`,
 * `'hamming'`, `'hann'`, `'lanczoz'`, `'rectangular'`, `'triangular'`
 * @property {?number} alpha Some window functions have this extra value.
 * (Between 0 and 1)
 * @property {number} pixelRatio=wavesurfer.params.pixelRatio to control the
 * size of the spectrogram in relation with its canvas. 1 = Draw on the whole
 * canvas. 2 = Draw on a quarter (1/2 the length and 1/2 the width)
 * @property {?boolean} deferInit Set to true to manually call
 * `initPlugin('spectrogram')`
 * @property {?number[][]} colorMap A 256 long array of 4-element arrays.
 * Each entry should contain a float between 0 and 1 and specify
 * r, g, b, and alpha.
 */ /**
 * Render a spectrogram visualisation of the audio.
 *
 * @implements {PluginClass}
 * @extends {Observer}
 * @example
 * // es6
 * import SpectrogramPlugin from 'wavesurfer.spectrogram.js';
 *
 * // commonjs
 * var SpectrogramPlugin = require('wavesurfer.spectrogram.js');
 *
 * // if you are using <script> tags
 * var SpectrogramPlugin = window.WaveSurfer.spectrogram;
 *
 * // ... initialising wavesurfer with the plugin
 * var wavesurfer = WaveSurfer.create({
 *   // wavesurfer options ...
 *   plugins: [
 *     SpectrogramPlugin.create({
 *       // plugin options ...
 *     })
 *   ]
 * });
 */ var SpectrogramPlugin = /*#__PURE__*/ function() {
                    function SpectrogramPlugin(params, ws) {
                        var _this = this;
                        _classCallCheck(this, SpectrogramPlugin);
                        this.params = params;
                        this.wavesurfer = ws;
                        this.util = ws.util;
                        this.frequenciesDataUrl = params.frequenciesDataUrl;
                        this._onScroll = function(e) {
                            _this.updateScroll(e);
                        };
                        this._onRender = function() {
                            _this.render();
                        };
                        this._onWrapperClick = function(e) {
                            _this._wrapperClickHandler(e);
                        };
                        this._onReady = function() {
                            var drawer = _this.drawer = ws.drawer;
                            _this.container = 'string' == typeof params.container ? document.querySelector(params.container) : params.container;
                            if (!_this.container) throw Error('No container for WaveSurfer spectrogram');
                            if (params.colorMap) {
                                if (params.colorMap.length < 256) throw new Error('Colormap must contain 256 elements');
                                for(var i = 0; i < params.colorMap.length; i++){
                                    var cmEntry = params.colorMap[i];
                                    if (cmEntry.length !== 4) throw new Error('ColorMap entries must contain 4 values');
                                }
                                _this.colorMap = params.colorMap;
                            } else {
                                _this.colorMap = [];
                                for(var _i = 0; _i < 256; _i++){
                                    var val = (255 - _i) / 256;
                                    _this.colorMap.push([
                                        val,
                                        val,
                                        val,
                                        1
                                    ]);
                                }
                            }
                            _this.width = drawer.width;
                            _this.pixelRatio = _this.params.pixelRatio || ws.params.pixelRatio;
                            _this.fftSamples = _this.params.fftSamples || ws.params.fftSamples || 512;
                            _this.height = _this.fftSamples / 2;
                            _this.noverlap = params.noverlap;
                            _this.windowFunc = params.windowFunc;
                            _this.alpha = params.alpha;
                            _this.createWrapper();
                            _this.createCanvas();
                            _this.render();
                            drawer.wrapper.addEventListener('scroll', _this._onScroll);
                            ws.on('redraw', _this._onRender);
                        };
                    }
                    _createClass(SpectrogramPlugin, [
                        {
                            key: "init",
                            value: function init() {
                                // Check if wavesurfer is ready
                                if (this.wavesurfer.isReady) this._onReady();
                                else this.wavesurfer.once('ready', this._onReady);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.unAll();
                                this.wavesurfer.un('ready', this._onReady);
                                this.wavesurfer.un('redraw', this._onRender);
                                this.drawer && this.drawer.wrapper.removeEventListener('scroll', this._onScroll);
                                this.wavesurfer = null;
                                this.util = null;
                                this.params = null;
                                if (this.wrapper) {
                                    this.wrapper.removeEventListener('click', this._onWrapperClick);
                                    this.wrapper.parentNode.removeChild(this.wrapper);
                                    this.wrapper = null;
                                }
                            }
                        },
                        {
                            key: "createWrapper",
                            value: function createWrapper() {
                                var prevSpectrogram = this.container.querySelector('spectrogram');
                                if (prevSpectrogram) this.container.removeChild(prevSpectrogram);
                                var wsParams = this.wavesurfer.params;
                                this.wrapper = document.createElement('spectrogram'); // if labels are active
                                if (this.params.labels) {
                                    var labelsEl = this.labelsEl = document.createElement('canvas');
                                    labelsEl.classList.add('spec-labels');
                                    this.drawer.style(labelsEl, {
                                        left: 0,
                                        position: 'absolute',
                                        zIndex: 9,
                                        height: "".concat(this.height / this.pixelRatio, "px"),
                                        width: "".concat(55 / this.pixelRatio, "px")
                                    });
                                    this.wrapper.appendChild(labelsEl);
                                    this.loadLabels('rgba(68,68,68,0.5)', '12px', '10px', '', '#fff', '#f7f7f7', 'center', '#specLabels');
                                }
                                this.drawer.style(this.wrapper, {
                                    display: 'block',
                                    position: 'relative',
                                    userSelect: 'none',
                                    webkitUserSelect: 'none',
                                    height: "".concat(this.height / this.pixelRatio, "px")
                                });
                                if (wsParams.fillParent || wsParams.scrollParent) this.drawer.style(this.wrapper, {
                                    width: '100%',
                                    overflowX: 'hidden',
                                    overflowY: 'hidden'
                                });
                                this.container.appendChild(this.wrapper);
                                this.wrapper.addEventListener('click', this._onWrapperClick);
                            }
                        },
                        {
                            key: "_wrapperClickHandler",
                            value: function _wrapperClickHandler(event) {
                                event.preventDefault();
                                var relX = 'offsetX' in event ? event.offsetX : event.layerX;
                                this.fireEvent('click', relX / this.width || 0);
                            }
                        },
                        {
                            key: "createCanvas",
                            value: function createCanvas() {
                                var canvas = this.canvas = this.wrapper.appendChild(document.createElement('canvas'));
                                this.spectrCc = canvas.getContext('2d');
                                this.util.style(canvas, {
                                    position: 'absolute',
                                    zIndex: 4
                                });
                            }
                        },
                        {
                            key: "render",
                            value: function render() {
                                this.updateCanvasStyle();
                                if (this.frequenciesDataUrl) this.loadFrequenciesData(this.frequenciesDataUrl);
                                else this.getFrequencies(this.drawSpectrogram);
                            }
                        },
                        {
                            key: "updateCanvasStyle",
                            value: function updateCanvasStyle() {
                                var width = Math.round(this.width / this.pixelRatio) + 'px';
                                this.canvas.width = this.width;
                                this.canvas.height = this.height;
                                this.canvas.style.width = width;
                            }
                        },
                        {
                            key: "drawSpectrogram",
                            value: function drawSpectrogram(frequenciesData, my) {
                                var spectrCc = my.spectrCc;
                                var height = my.height;
                                var width = my.width;
                                var pixels = my.resample(frequenciesData);
                                var heightFactor = my.buffer ? 2 / my.buffer.numberOfChannels : 1;
                                if (spectrCc) {
                                    var imageData = spectrCc.createImageData(width, height);
                                    var i;
                                    var j;
                                    var k;
                                    for(i = 0; i < pixels.length; i++)for(j = 0; j < pixels[i].length; j++){
                                        var colorMap = my.colorMap[pixels[i][j]];
                                        /* eslint-disable max-depth */ for(k = 0; k < heightFactor; k++){
                                            var y = height - j * heightFactor;
                                            if (heightFactor === 2 && k === 1) y--;
                                            var redIndex = y * (width * 4) + i * 4;
                                            imageData.data[redIndex] = colorMap[0] * 255;
                                            imageData.data[redIndex + 1] = colorMap[1] * 255;
                                            imageData.data[redIndex + 2] = colorMap[2] * 255;
                                            imageData.data[redIndex + 3] = colorMap[3] * 255;
                                        }
                                    /* eslint-enable max-depth */ }
                                    spectrCc.putImageData(imageData, 0, 0);
                                }
                            }
                        },
                        {
                            key: "getFrequencies",
                            value: function getFrequencies(callback) {
                                var fftSamples = this.fftSamples;
                                var buffer = this.buffer = this.wavesurfer.backend.buffer;
                                var channelOne = buffer.getChannelData(0);
                                var bufferLength = buffer.length;
                                var sampleRate = buffer.sampleRate;
                                var frequencies = [];
                                if (!buffer) {
                                    this.fireEvent('error', 'Web Audio buffer is not available');
                                    return;
                                }
                                var noverlap = this.noverlap;
                                if (!noverlap) {
                                    var uniqueSamplesPerPx = buffer.length / this.canvas.width;
                                    noverlap = Math.max(0, Math.round(fftSamples - uniqueSamplesPerPx));
                                }
                                var fft = new _fft.default(fftSamples, sampleRate, this.windowFunc, this.alpha);
                                var maxSlicesCount = Math.floor(bufferLength / (fftSamples - noverlap));
                                var currentOffset = 0;
                                while(currentOffset + fftSamples < channelOne.length){
                                    var segment = channelOne.slice(currentOffset, currentOffset + fftSamples);
                                    var spectrum = fft.calculateSpectrum(segment);
                                    var array = new Uint8Array(fftSamples / 2);
                                    var j = void 0;
                                    for(j = 0; j < fftSamples / 2; j++)array[j] = Math.max(-255, Math.log10(spectrum[j]) * 45);
                                    frequencies.push(array);
                                    currentOffset += fftSamples - noverlap;
                                }
                                callback(frequencies, this);
                            }
                        },
                        {
                            key: "loadFrequenciesData",
                            value: function loadFrequenciesData(url) {
                                var _this2 = this;
                                var request = this.util.fetchFile({
                                    url: url
                                });
                                request.on('success', function(data) {
                                    return _this2.drawSpectrogram(JSON.parse(data), _this2);
                                });
                                request.on('error', function(e) {
                                    return _this2.fireEvent('error', e);
                                });
                                return request;
                            }
                        },
                        {
                            key: "freqType",
                            value: function freqType(freq) {
                                return freq >= 1000 ? (freq / 1000).toFixed(1) : Math.round(freq);
                            }
                        },
                        {
                            key: "unitType",
                            value: function unitType(freq) {
                                return freq >= 1000 ? 'KHz' : 'Hz';
                            }
                        },
                        {
                            key: "loadLabels",
                            value: function loadLabels(bgFill, fontSizeFreq, fontSizeUnit, fontType, textColorFreq, textColorUnit, textAlign, container) {
                                var frequenciesHeight = this.height;
                                bgFill = bgFill || 'rgba(68,68,68,0)';
                                fontSizeFreq = fontSizeFreq || '12px';
                                fontSizeUnit = fontSizeUnit || '10px';
                                fontType = fontType || 'Helvetica';
                                textColorFreq = textColorFreq || '#fff';
                                textColorUnit = textColorUnit || '#fff';
                                textAlign = textAlign || 'center';
                                container = container || '#specLabels';
                                var bgWidth = 55;
                                var getMaxY = frequenciesHeight || 512;
                                var labelIndex = 5 * (getMaxY / 256);
                                var freqStart = 0;
                                var step = (this.wavesurfer.backend.ac.sampleRate / 2 - freqStart) / labelIndex; // prepare canvas element for labels
                                var ctx = this.labelsEl.getContext('2d');
                                this.labelsEl.height = this.height;
                                this.labelsEl.width = bgWidth;
                                if (ctx) {
                                    // fill background
                                    ctx.fillStyle = bgFill;
                                    ctx.fillRect(0, 0, bgWidth, getMaxY);
                                    ctx.fill();
                                    var i; // render labels
                                    for(i = 0; i <= labelIndex; i++){
                                        ctx.textAlign = textAlign;
                                        ctx.textBaseline = 'middle';
                                        var freq = freqStart + step * i;
                                        var index = Math.round(freq / (this.sampleRate / 2) * this.fftSamples);
                                        var label = this.freqType(freq);
                                        var units = this.unitType(freq);
                                        var yLabelOffset = 2;
                                        var x = 16;
                                        var y = void 0;
                                        if (i == 0) {
                                            y = getMaxY + i - 10; // unit label
                                            ctx.fillStyle = textColorUnit;
                                            ctx.font = fontSizeUnit + ' ' + fontType;
                                            ctx.fillText(units, x + 24, y); // freq label
                                            ctx.fillStyle = textColorFreq;
                                            ctx.font = fontSizeFreq + ' ' + fontType;
                                            ctx.fillText(label, x, y);
                                        } else {
                                            y = getMaxY - i * 50 + yLabelOffset; // unit label
                                            ctx.fillStyle = textColorUnit;
                                            ctx.font = fontSizeUnit + ' ' + fontType;
                                            ctx.fillText(units, x + 24, y); // freq label
                                            ctx.fillStyle = textColorFreq;
                                            ctx.font = fontSizeFreq + ' ' + fontType;
                                            ctx.fillText(label, x, y);
                                        }
                                    }
                                }
                            }
                        },
                        {
                            key: "updateScroll",
                            value: function updateScroll(e) {
                                if (this.wrapper) this.wrapper.scrollLeft = e.target.scrollLeft;
                            }
                        },
                        {
                            key: "resample",
                            value: function resample(oldMatrix) {
                                var columnsNumber = this.width;
                                var newMatrix = [];
                                var oldPiece = 1 / oldMatrix.length;
                                var newPiece = 1 / columnsNumber;
                                var i;
                                for(i = 0; i < columnsNumber; i++){
                                    var column = new Array(oldMatrix[0].length);
                                    var j = void 0;
                                    for(j = 0; j < oldMatrix.length; j++){
                                        var oldStart = j * oldPiece;
                                        var oldEnd = oldStart + oldPiece;
                                        var newStart = i * newPiece;
                                        var newEnd = newStart + newPiece;
                                        var overlap = oldEnd <= newStart || newEnd <= oldStart ? 0 : Math.min(Math.max(oldEnd, newStart), Math.max(newEnd, oldStart)) - Math.max(Math.min(oldEnd, newStart), Math.min(newEnd, oldStart));
                                        var k = void 0;
                                        /* eslint-disable max-depth */ if (overlap > 0) for(k = 0; k < oldMatrix[0].length; k++){
                                            if (column[k] == null) column[k] = 0;
                                            column[k] += overlap / newPiece * oldMatrix[j][k];
                                        }
                                    /* eslint-enable max-depth */ }
                                    var intColumn = new Uint8Array(oldMatrix[0].length);
                                    var m = void 0;
                                    for(m = 0; m < oldMatrix[0].length; m++)intColumn[m] = column[m];
                                    newMatrix.push(intColumn);
                                }
                                return newMatrix;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: /**
     * Spectrogram plugin definition factory
     *
     * This function must be used to create a plugin definition which can be
     * used by wavesurfer to correctly instantiate the plugin.
     *
     * @param  {SpectrogramPluginParams} params Parameters used to initialise the plugin
     * @return {PluginDefinition} An object representing the plugin.
     */ function create(params) {
                                return {
                                    name: 'spectrogram',
                                    deferInit: params && params.deferInit ? params.deferInit : false,
                                    params: params,
                                    staticProps: {
                                        FFT: _fft.default
                                    },
                                    instance: SpectrogramPlugin
                                };
                            }
                        }
                    ]);
                    return SpectrogramPlugin;
                }();
                exports.default = SpectrogramPlugin;
                module1.exports = exports.default;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /******/ // startup
        /******/ // Load entry module and return exports
        /******/ // This entry module is referenced by other modules so it can't be inlined
        /******/ var __webpack_exports__ = __webpack_require__("./src/plugin/spectrogram/index.js");
        /******/ /******/ return __webpack_exports__;
    /******/ })();
});


var $0f0d0cb2aeb32558$exports = {};
/*
 * Ben Postlethwaite
 * January 2013
 * License MIT
 */ 'use strict';
var $2dac8b613c9499d3$exports = {};
$2dac8b613c9499d3$exports = {
    "jet": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                131
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                0,
                60,
                170
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                5,
                255,
                255
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                255,
                255,
                0
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                250,
                0,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                128,
                0,
                0
            ]
        }
    ],
    "hsv": [
        {
            "index": 0,
            "rgb": [
                255,
                0,
                0
            ]
        },
        {
            "index": 0.169,
            "rgb": [
                253,
                255,
                2
            ]
        },
        {
            "index": 0.173,
            "rgb": [
                247,
                255,
                2
            ]
        },
        {
            "index": 0.337,
            "rgb": [
                0,
                252,
                4
            ]
        },
        {
            "index": 0.341,
            "rgb": [
                0,
                252,
                10
            ]
        },
        {
            "index": 0.506,
            "rgb": [
                1,
                249,
                255
            ]
        },
        {
            "index": 0.671,
            "rgb": [
                2,
                0,
                253
            ]
        },
        {
            "index": 0.675,
            "rgb": [
                8,
                0,
                253
            ]
        },
        {
            "index": 0.839,
            "rgb": [
                255,
                0,
                251
            ]
        },
        {
            "index": 0.843,
            "rgb": [
                255,
                0,
                245
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                6
            ]
        }
    ],
    "hot": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.3,
            "rgb": [
                230,
                0,
                0
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                255,
                210,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "spring": [
        {
            "index": 0,
            "rgb": [
                255,
                0,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                0
            ]
        }
    ],
    "summer": [
        {
            "index": 0,
            "rgb": [
                0,
                128,
                102
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                102
            ]
        }
    ],
    "autumn": [
        {
            "index": 0,
            "rgb": [
                255,
                0,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                0
            ]
        }
    ],
    "winter": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                0,
                255,
                128
            ]
        }
    ],
    "bone": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.376,
            "rgb": [
                84,
                84,
                116
            ]
        },
        {
            "index": 0.753,
            "rgb": [
                169,
                200,
                200
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "copper": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.804,
            "rgb": [
                255,
                160,
                102
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                199,
                127
            ]
        }
    ],
    "greys": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "yignbu": [
        {
            "index": 0,
            "rgb": [
                8,
                29,
                88
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                37,
                52,
                148
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                34,
                94,
                168
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                29,
                145,
                192
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                65,
                182,
                196
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                127,
                205,
                187
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                199,
                233,
                180
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                237,
                248,
                217
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                217
            ]
        }
    ],
    "greens": [
        {
            "index": 0,
            "rgb": [
                0,
                68,
                27
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                0,
                109,
                44
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                35,
                139,
                69
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                65,
                171,
                93
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                116,
                196,
                118
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                161,
                217,
                155
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                199,
                233,
                192
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                229,
                245,
                224
            ]
        },
        {
            "index": 1,
            "rgb": [
                247,
                252,
                245
            ]
        }
    ],
    "yiorrd": [
        {
            "index": 0,
            "rgb": [
                128,
                0,
                38
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                189,
                0,
                38
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                227,
                26,
                28
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                252,
                78,
                42
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                253,
                141,
                60
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                254,
                178,
                76
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                254,
                217,
                118
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                255,
                237,
                160
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                204
            ]
        }
    ],
    "bluered": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                0
            ]
        }
    ],
    "rdbu": [
        {
            "index": 0,
            "rgb": [
                5,
                10,
                172
            ]
        },
        {
            "index": 0.35,
            "rgb": [
                106,
                137,
                247
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                190,
                190,
                190
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                220,
                170,
                132
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                230,
                145,
                90
            ]
        },
        {
            "index": 1,
            "rgb": [
                178,
                10,
                28
            ]
        }
    ],
    "picnic": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                255
            ]
        },
        {
            "index": 0.1,
            "rgb": [
                51,
                153,
                255
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                102,
                204,
                255
            ]
        },
        {
            "index": 0.3,
            "rgb": [
                153,
                204,
                255
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                204,
                204,
                255
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                255,
                255,
                255
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                255,
                204,
                255
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                255,
                153,
                255
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                255,
                102,
                204
            ]
        },
        {
            "index": 0.9,
            "rgb": [
                255,
                102,
                102
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                0
            ]
        }
    ],
    "rainbow": [
        {
            "index": 0,
            "rgb": [
                150,
                0,
                90
            ]
        },
        {
            "index": 0.125,
            "rgb": [
                0,
                0,
                200
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                0,
                25,
                255
            ]
        },
        {
            "index": 0.375,
            "rgb": [
                0,
                152,
                255
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                44,
                255,
                150
            ]
        },
        {
            "index": 0.625,
            "rgb": [
                151,
                255,
                0
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                255,
                234,
                0
            ]
        },
        {
            "index": 0.875,
            "rgb": [
                255,
                111,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                0,
                0
            ]
        }
    ],
    "portland": [
        {
            "index": 0,
            "rgb": [
                12,
                51,
                131
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                10,
                136,
                186
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                242,
                211,
                56
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                242,
                143,
                56
            ]
        },
        {
            "index": 1,
            "rgb": [
                217,
                30,
                30
            ]
        }
    ],
    "blackbody": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                230,
                0,
                0
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                230,
                210,
                0
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                255,
                255,
                255
            ]
        },
        {
            "index": 1,
            "rgb": [
                160,
                200,
                255
            ]
        }
    ],
    "earth": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                130
            ]
        },
        {
            "index": 0.1,
            "rgb": [
                0,
                180,
                180
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                40,
                210,
                40
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                230,
                230,
                50
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                120,
                70,
                20
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255
            ]
        }
    ],
    "electric": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.15,
            "rgb": [
                30,
                0,
                100
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                120,
                0,
                100
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                160,
                90,
                0
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                230,
                200,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                250,
                220
            ]
        }
    ],
    "alpha": [
        {
            "index": 0,
            "rgb": [
                255,
                255,
                255,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                255,
                255,
                1
            ]
        }
    ],
    "viridis": [
        {
            "index": 0,
            "rgb": [
                68,
                1,
                84
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                71,
                44,
                122
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                59,
                81,
                139
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                44,
                113,
                142
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                33,
                144,
                141
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                39,
                173,
                129
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                92,
                200,
                99
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                170,
                220,
                50
            ]
        },
        {
            "index": 1,
            "rgb": [
                253,
                231,
                37
            ]
        }
    ],
    "inferno": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                4
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                31,
                12,
                72
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                85,
                15,
                109
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                136,
                34,
                106
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                186,
                54,
                85
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                227,
                89,
                51
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                249,
                140,
                10
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                249,
                201,
                50
            ]
        },
        {
            "index": 1,
            "rgb": [
                252,
                255,
                164
            ]
        }
    ],
    "magma": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                4
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                28,
                16,
                68
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                79,
                18,
                123
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                129,
                37,
                129
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                181,
                54,
                122
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                229,
                80,
                100
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                251,
                135,
                97
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                254,
                194,
                135
            ]
        },
        {
            "index": 1,
            "rgb": [
                252,
                253,
                191
            ]
        }
    ],
    "plasma": [
        {
            "index": 0,
            "rgb": [
                13,
                8,
                135
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                75,
                3,
                161
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                125,
                3,
                168
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                168,
                34,
                150
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                203,
                70,
                121
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                229,
                107,
                93
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                248,
                148,
                65
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                253,
                195,
                40
            ]
        },
        {
            "index": 1,
            "rgb": [
                240,
                249,
                33
            ]
        }
    ],
    "warm": [
        {
            "index": 0,
            "rgb": [
                125,
                0,
                179
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                172,
                0,
                187
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                219,
                0,
                170
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                255,
                0,
                130
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                255,
                63,
                74
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                255,
                123,
                0
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                234,
                176,
                0
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                190,
                228,
                0
            ]
        },
        {
            "index": 1,
            "rgb": [
                147,
                255,
                0
            ]
        }
    ],
    "cool": [
        {
            "index": 0,
            "rgb": [
                125,
                0,
                179
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                116,
                0,
                218
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                98,
                74,
                237
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                68,
                146,
                231
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                0,
                204,
                197
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                0,
                247,
                146
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                0,
                255,
                88
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                40,
                255,
                8
            ]
        },
        {
            "index": 1,
            "rgb": [
                147,
                255,
                0
            ]
        }
    ],
    "rainbow-soft": [
        {
            "index": 0,
            "rgb": [
                125,
                0,
                179
            ]
        },
        {
            "index": 0.1,
            "rgb": [
                199,
                0,
                180
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                255,
                0,
                121
            ]
        },
        {
            "index": 0.3,
            "rgb": [
                255,
                108,
                0
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                222,
                194,
                0
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                150,
                255,
                0
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                0,
                255,
                55
            ]
        },
        {
            "index": 0.7,
            "rgb": [
                0,
                246,
                150
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                50,
                167,
                222
            ]
        },
        {
            "index": 0.9,
            "rgb": [
                103,
                51,
                235
            ]
        },
        {
            "index": 1,
            "rgb": [
                124,
                0,
                186
            ]
        }
    ],
    "bathymetry": [
        {
            "index": 0,
            "rgb": [
                40,
                26,
                44
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                59,
                49,
                90
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                64,
                76,
                139
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                63,
                110,
                151
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                72,
                142,
                158
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                85,
                174,
                163
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                120,
                206,
                163
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                187,
                230,
                172
            ]
        },
        {
            "index": 1,
            "rgb": [
                253,
                254,
                204
            ]
        }
    ],
    "cdom": [
        {
            "index": 0,
            "rgb": [
                47,
                15,
                62
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                87,
                23,
                86
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                130,
                28,
                99
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                171,
                41,
                96
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                206,
                67,
                86
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                230,
                106,
                84
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                242,
                149,
                103
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                249,
                193,
                135
            ]
        },
        {
            "index": 1,
            "rgb": [
                254,
                237,
                176
            ]
        }
    ],
    "chlorophyll": [
        {
            "index": 0,
            "rgb": [
                18,
                36,
                20
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                25,
                63,
                41
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                24,
                91,
                59
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                13,
                119,
                72
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                18,
                148,
                80
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                80,
                173,
                89
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                132,
                196,
                122
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                175,
                221,
                162
            ]
        },
        {
            "index": 1,
            "rgb": [
                215,
                249,
                208
            ]
        }
    ],
    "density": [
        {
            "index": 0,
            "rgb": [
                54,
                14,
                36
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                89,
                23,
                80
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                110,
                45,
                132
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                120,
                77,
                178
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                120,
                113,
                213
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                115,
                151,
                228
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                134,
                185,
                227
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                177,
                214,
                227
            ]
        },
        {
            "index": 1,
            "rgb": [
                230,
                241,
                241
            ]
        }
    ],
    "freesurface-blue": [
        {
            "index": 0,
            "rgb": [
                30,
                4,
                110
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                47,
                14,
                176
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                41,
                45,
                236
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                25,
                99,
                212
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                68,
                131,
                200
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                114,
                156,
                197
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                157,
                181,
                203
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                200,
                208,
                216
            ]
        },
        {
            "index": 1,
            "rgb": [
                241,
                237,
                236
            ]
        }
    ],
    "freesurface-red": [
        {
            "index": 0,
            "rgb": [
                60,
                9,
                18
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                100,
                17,
                27
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                142,
                20,
                29
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                177,
                43,
                27
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                192,
                87,
                63
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                205,
                125,
                105
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                216,
                162,
                148
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                227,
                199,
                193
            ]
        },
        {
            "index": 1,
            "rgb": [
                241,
                237,
                236
            ]
        }
    ],
    "oxygen": [
        {
            "index": 0,
            "rgb": [
                64,
                5,
                5
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                106,
                6,
                15
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                144,
                26,
                7
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                168,
                64,
                3
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                188,
                100,
                4
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                206,
                136,
                11
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                220,
                174,
                25
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                231,
                215,
                44
            ]
        },
        {
            "index": 1,
            "rgb": [
                248,
                254,
                105
            ]
        }
    ],
    "par": [
        {
            "index": 0,
            "rgb": [
                51,
                20,
                24
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                90,
                32,
                35
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                129,
                44,
                34
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                159,
                68,
                25
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                182,
                99,
                19
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                199,
                134,
                22
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                212,
                171,
                35
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                221,
                210,
                54
            ]
        },
        {
            "index": 1,
            "rgb": [
                225,
                253,
                75
            ]
        }
    ],
    "phase": [
        {
            "index": 0,
            "rgb": [
                145,
                105,
                18
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                184,
                71,
                38
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                186,
                58,
                115
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                160,
                71,
                185
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                110,
                97,
                218
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                50,
                123,
                164
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                31,
                131,
                110
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                77,
                129,
                34
            ]
        },
        {
            "index": 1,
            "rgb": [
                145,
                105,
                18
            ]
        }
    ],
    "salinity": [
        {
            "index": 0,
            "rgb": [
                42,
                24,
                108
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                33,
                50,
                162
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                15,
                90,
                145
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                40,
                118,
                137
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                59,
                146,
                135
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                79,
                175,
                126
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                120,
                203,
                104
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                193,
                221,
                100
            ]
        },
        {
            "index": 1,
            "rgb": [
                253,
                239,
                154
            ]
        }
    ],
    "temperature": [
        {
            "index": 0,
            "rgb": [
                4,
                35,
                51
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                23,
                51,
                122
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                85,
                59,
                157
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                129,
                79,
                143
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                175,
                95,
                130
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                222,
                112,
                101
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                249,
                146,
                66
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                249,
                196,
                65
            ]
        },
        {
            "index": 1,
            "rgb": [
                232,
                250,
                91
            ]
        }
    ],
    "turbidity": [
        {
            "index": 0,
            "rgb": [
                34,
                31,
                27
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                65,
                50,
                41
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                98,
                69,
                52
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                131,
                89,
                57
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                161,
                112,
                59
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                185,
                140,
                66
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                202,
                174,
                88
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                216,
                209,
                126
            ]
        },
        {
            "index": 1,
            "rgb": [
                233,
                246,
                171
            ]
        }
    ],
    "velocity-blue": [
        {
            "index": 0,
            "rgb": [
                17,
                32,
                64
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                35,
                52,
                116
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                29,
                81,
                156
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                31,
                113,
                162
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                50,
                144,
                169
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                87,
                173,
                176
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                149,
                196,
                189
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                203,
                221,
                211
            ]
        },
        {
            "index": 1,
            "rgb": [
                254,
                251,
                230
            ]
        }
    ],
    "velocity-green": [
        {
            "index": 0,
            "rgb": [
                23,
                35,
                19
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                24,
                64,
                38
            ]
        },
        {
            "index": 0.25,
            "rgb": [
                11,
                95,
                45
            ]
        },
        {
            "index": 0.38,
            "rgb": [
                39,
                123,
                35
            ]
        },
        {
            "index": 0.5,
            "rgb": [
                95,
                146,
                12
            ]
        },
        {
            "index": 0.63,
            "rgb": [
                152,
                165,
                18
            ]
        },
        {
            "index": 0.75,
            "rgb": [
                201,
                186,
                69
            ]
        },
        {
            "index": 0.88,
            "rgb": [
                233,
                216,
                137
            ]
        },
        {
            "index": 1,
            "rgb": [
                255,
                253,
                205
            ]
        }
    ],
    "cubehelix": [
        {
            "index": 0,
            "rgb": [
                0,
                0,
                0
            ]
        },
        {
            "index": 0.07,
            "rgb": [
                22,
                5,
                59
            ]
        },
        {
            "index": 0.13,
            "rgb": [
                60,
                4,
                105
            ]
        },
        {
            "index": 0.2,
            "rgb": [
                109,
                1,
                135
            ]
        },
        {
            "index": 0.27,
            "rgb": [
                161,
                0,
                147
            ]
        },
        {
            "index": 0.33,
            "rgb": [
                210,
                2,
                142
            ]
        },
        {
            "index": 0.4,
            "rgb": [
                251,
                11,
                123
            ]
        },
        {
            "index": 0.47,
            "rgb": [
                255,
                29,
                97
            ]
        },
        {
            "index": 0.53,
            "rgb": [
                255,
                54,
                69
            ]
        },
        {
            "index": 0.6,
            "rgb": [
                255,
                85,
                46
            ]
        },
        {
            "index": 0.67,
            "rgb": [
                255,
                120,
                34
            ]
        },
        {
            "index": 0.73,
            "rgb": [
                255,
                157,
                37
            ]
        },
        {
            "index": 0.8,
            "rgb": [
                241,
                191,
                57
            ]
        },
        {
            "index": 0.87,
            "rgb": [
                224,
                220,
                93
            ]
        },
        {
            "index": 0.93,
            "rgb": [
                218,
                241,
                142
            ]
        },
        {
            "index": 1,
            "rgb": [
                227,
                253,
                198
            ]
        }
    ]
};


var $47adcb215a7fbfed$exports = {};
function $47adcb215a7fbfed$var$lerp(v0, v1, t) {
    return v0 * (1 - t) + v1 * t;
}
$47adcb215a7fbfed$exports = $47adcb215a7fbfed$var$lerp;


$0f0d0cb2aeb32558$exports = $0f0d0cb2aeb32558$var$createColormap;
function $0f0d0cb2aeb32558$var$createColormap(spec) {
    /*
     * Default Options
     */ var indicies, fromrgba, torgba, nsteps, cmap, colormap, format, nshades, colors, alpha, i;
    if (!spec) spec = {};
    nshades = (spec.nshades || 72) - 1;
    format = spec.format || 'hex';
    colormap = spec.colormap;
    if (!colormap) colormap = 'jet';
    if (typeof colormap === 'string') {
        colormap = colormap.toLowerCase();
        if (!$2dac8b613c9499d3$exports[colormap]) throw Error(colormap + ' not a supported colorscale');
        cmap = $2dac8b613c9499d3$exports[colormap];
    } else if (Array.isArray(colormap)) cmap = colormap.slice();
    else throw Error('unsupported colormap option', colormap);
    if (cmap.length > nshades + 1) throw new Error(colormap + ' map requires nshades to be at least size ' + cmap.length);
    if (!Array.isArray(spec.alpha)) {
        if (typeof spec.alpha === 'number') alpha = [
            spec.alpha,
            spec.alpha
        ];
        else alpha = [
            1,
            1
        ];
    } else if (spec.alpha.length !== 2) alpha = [
        1,
        1
    ];
    else alpha = spec.alpha.slice();
    // map index points from 0..1 to 0..n-1
    indicies = cmap.map(function(c) {
        return Math.round(c.index * nshades);
    });
    // Add alpha channel to the map
    alpha[0] = Math.min(Math.max(alpha[0], 0), 1);
    alpha[1] = Math.min(Math.max(alpha[1], 0), 1);
    var steps = cmap.map(function(c, i) {
        var index = cmap[i].index;
        var rgba = cmap[i].rgb.slice();
        // if user supplies their own map use it
        if (rgba.length === 4 && rgba[3] >= 0 && rgba[3] <= 1) return rgba;
        rgba[3] = alpha[0] + (alpha[1] - alpha[0]) * index;
        return rgba;
    });
    /*
     * map increasing linear values between indicies to
     * linear steps in colorvalues
     */ var colors = [];
    for(i = 0; i < indicies.length - 1; ++i){
        nsteps = indicies[i + 1] - indicies[i];
        fromrgba = steps[i];
        torgba = steps[i + 1];
        for(var j = 0; j < nsteps; j++){
            var amt = j / nsteps;
            colors.push([
                Math.round($47adcb215a7fbfed$exports(fromrgba[0], torgba[0], amt)),
                Math.round($47adcb215a7fbfed$exports(fromrgba[1], torgba[1], amt)),
                Math.round($47adcb215a7fbfed$exports(fromrgba[2], torgba[2], amt)),
                $47adcb215a7fbfed$exports(fromrgba[3], torgba[3], amt)
            ]);
        }
    }
    //add 1 step as last value
    colors.push(cmap[cmap.length - 1].rgb.concat(alpha[1]));
    if (format === 'hex') colors = colors.map($0f0d0cb2aeb32558$var$rgb2hex);
    else if (format === 'rgbaString') colors = colors.map($0f0d0cb2aeb32558$var$rgbaStr);
    else if (format === 'float') colors = colors.map($0f0d0cb2aeb32558$var$rgb2float);
    return colors;
}
function $0f0d0cb2aeb32558$var$rgb2float(rgba) {
    return [
        rgba[0] / 255,
        rgba[1] / 255,
        rgba[2] / 255,
        rgba[3]
    ];
}
function $0f0d0cb2aeb32558$var$rgb2hex(rgba) {
    var dig, hex = '#';
    for(var i = 0; i < 3; ++i){
        dig = rgba[i];
        dig = dig.toString(16);
        hex += ('00' + dig).substr(dig.length);
    }
    return hex;
}
function $0f0d0cb2aeb32558$var$rgbaStr(rgba) {
    return 'rgba(' + rgba.join(',') + ')';
}



var $6lXkL = parcelRequire("6lXkL");

var $cVXaD = parcelRequire("cVXaD");
var $e49855c5f216deae$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e49855c5f216deae$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e49855c5f216deae$exports, "__esModule", {
    value: true
});
$e49855c5f216deae$exports.default = void 0;

var $e49855c5f216deae$var$_createSvgIcon = $e49855c5f216deae$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e49855c5f216deae$var$_default = $e49855c5f216deae$exports.default = (0, $e49855c5f216deae$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82"
}), 'PlayArrowRounded');


var $aa4a098869236e7b$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $aa4a098869236e7b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($aa4a098869236e7b$exports, "__esModule", {
    value: true
});
$aa4a098869236e7b$exports.default = void 0;

var $aa4a098869236e7b$var$_createSvgIcon = $aa4a098869236e7b$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $aa4a098869236e7b$var$_default = $aa4a098869236e7b$exports.default = (0, $aa4a098869236e7b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 14c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1m4 0c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1"
}), 'PauseCircleFilledRounded');



var $hBKHw = parcelRequire("hBKHw");
var $e1b28a5539150830$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e1b28a5539150830$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e1b28a5539150830$exports, "__esModule", {
    value: true
});
$e1b28a5539150830$exports.default = void 0;

var $e1b28a5539150830$var$_createSvgIcon = $e1b28a5539150830$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e1b28a5539150830$var$_default = $e1b28a5539150830$exports.default = (0, $e1b28a5539150830$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3M12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1m1 4h-2v-2h2z"
}), 'WarningRounded');



var $lffEs = parcelRequire("lffEs");


var $bcnr1 = parcelRequire("bcnr1");
const $d58c41d80e376ef6$var$colors = (0, (/*@__PURE__*/$parcel$interopDefault($0f0d0cb2aeb32558$exports)))({
    colormap: 'hot',
    nshades: 256,
    format: 'float'
});
function $d58c41d80e376ef6$export$2e2bcd8739ae039(props) {
    const { vsn: vsn, dataURL: dataURL, className: className = '' } = props;
    if (!vsn && !dataURL) throw 'Audio: no node vsn or url provided';
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const audioRef = (0, $acw62.useRef)();
    const spectroGramRef = (0, $acw62.useRef)();
    const [waveSurf, setWaveSurf] = (0, $acw62.useState)(null);
    const [isPlaying, setIsPlaying] = (0, $acw62.useState)(false);
    const [meta, setMeta] = (0, $acw62.useState)();
    // error for meta requests
    const [error, setError] = (0, $acw62.useState)(null);
    // wavesurfer error
    const [vizError, setVizError] = (0, $acw62.useState)();
    // if node id is provided, find latest audio first
    (0, $acw62.useEffect)(()=>{
        if (!vsn) return;
        setLoading(true);
        $bcnr1.getLatestAudio(vsn).then((meta)=>{
            setMeta(meta);
            // if we can't find meta, don't load wavesurfer
            if (!meta) return;
            const url = meta.value;
            const ws = loadPlayer(url);
            setWaveSurf(ws);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, [
        vsn,
        setLoading
    ]);
    // if OSN url is provided just load the player
    (0, $acw62.useEffect)(()=>{
        if (!dataURL || waveSurf) return;
        const ws = loadPlayer(dataURL);
        setWaveSurf(ws);
    }, [
        dataURL
    ]);
    function loadPlayer(url) {
        const wavesurfer = (0, (/*@__PURE__*/$parcel$interopDefault($182ce0f141db4820$exports))).create({
            container: audioRef.current,
            waveColor: 'violet',
            progressColor: 'purple',
            xhr: {
                credentials: 'include'
            },
            plugins: [
                (0, (/*@__PURE__*/$parcel$interopDefault($f3bc61d5769e56ec$exports))).create({
                    container: spectroGramRef.current,
                    labels: true,
                    colorMap: $d58c41d80e376ef6$var$colors
                })
            ]
        });
        wavesurfer.on('play', ()=>setIsPlaying(true));
        wavesurfer.on('pause', ()=>setIsPlaying(false));
        wavesurfer.on('error', (err)=>setVizError(err));
        wavesurfer.load(url);
        return wavesurfer;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d58c41d80e376ef6$var$Root, {
        className: `flex column ${className}`,
        children: [
            vizError && (meta?.value || dataURL) && /*#__PURE__*/ (0, $ayMG0.jsx)($d58c41d80e376ef6$var$HtmlAudio, {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("audio", {
                    controls: true,
                    src: meta?.value || dataURL,
                    children: [
                        "Your browser does not support the ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                            children: "audio"
                        }),
                        " element."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: meta && (0, $lffEs.isOldData)(meta.timestamp) ? {} : {},
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                            !vizError && (meta || dataURL) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center justify-end gap",
                                children: [
                                    !isPlaying && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e49855c5f216deae$exports))), {}),
                                        onClick: ()=>{
                                            waveSurf.play();
                                        },
                                        variant: "outlined",
                                        children: "play"
                                    }),
                                    isPlaying && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aa4a098869236e7b$exports))), {}),
                                        onClick: ()=>{
                                            waveSurf.pause();
                                        },
                                        variant: "outlined",
                                        children: "pause"
                                    })
                                ]
                            })
                        ]
                    }),
                    !vizError && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                ref: audioRef
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                ref: spectroGramRef
                            })
                        ]
                    }),
                    !dataURL && meta && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: (0, $lffEs.isOldData)(meta.timestamp) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e1b28a5539150830$exports))), {
                                            className: "failed"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: new Date(meta.timestamp).toLocaleString(),
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("b", {
                                            className: (0, $lffEs.isOldData)(meta.timestamp) ? 'failed' : 'muted',
                                            children: [
                                                "~",
                                                (0, $lffEs.msToTime)(new Date().getTime() - new Date(meta.timestamp).getTime())
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {}),
                                href: meta.value,
                                children: (0, $lffEs.bytesToSizeSI)(meta.size)
                            })
                        ]
                    })
                ]
            }),
            meta === null && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "muted",
                children: "No recent audio available"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error.message
            })
        ]
    });
}
const $d58c41d80e376ef6$var$Root = (0, $lmFrL.default).div`
`;
const $d58c41d80e376ef6$var$HtmlAudio = (0, $lmFrL.default).div`
  audio {
    width: 100%;
  }
`;



var $7L4OA = parcelRequire("7L4OA");

var $gOa8m = parcelRequire("gOa8m");
var $eqsnC = parcelRequire("eqsnC");

var $lffEs = parcelRequire("lffEs");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");

var $cVXaD = parcelRequire("cVXaD");

var $ipR47 = parcelRequire("ipR47");
var $371cde9cd7137df5$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $371cde9cd7137df5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($371cde9cd7137df5$exports, "__esModule", {
    value: true
});
$371cde9cd7137df5$exports.default = void 0;

var $371cde9cd7137df5$var$_createSvgIcon = $371cde9cd7137df5$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $371cde9cd7137df5$var$_default = $371cde9cd7137df5$exports.default = (0, $371cde9cd7137df5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27c1.2-1.4 1.82-3.31 1.48-5.34-.47-2.78-2.79-5-5.59-5.34-4.23-.52-7.78 3.04-7.27 7.27.34 2.8 2.56 5.12 5.34 5.59 2.03.34 3.94-.28 5.34-1.48l.27.28v.79l4.26 4.25c.41.41 1.07.41 1.48 0l.01-.01c.41-.41.41-1.07 0-1.48zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14m0-7c-.28 0-.5.22-.5.5V9H7.5c-.28 0-.5.22-.5.5s.22.5.5.5H9v1.5c0 .28.22.5.5.5s.5-.22.5-.5V10h1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5H10V7.5c0-.28-.22-.5-.5-.5"
}), 'ZoomInRounded');



var $hw4Z0 = parcelRequire("hw4Z0");

var $lffEs = parcelRequire("lffEs");


var $bcnr1 = parcelRequire("bcnr1");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $87e6acd7396d97dc$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $87e6acd7396d97dc$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $87e6acd7396d97dc$export$869b26d4e1bbdb63(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $87e6acd7396d97dc$export$dbf961a8d278dbef(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $87e6acd7396d97dc$export$aa35ef1f24408ab9(v) {
    return $87e6acd7396d97dc$export$837ba5c449269406($87e6acd7396d97dc$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $87e6acd7396d97dc$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $87e6acd7396d97dc$var$hex = [
    ...'0123456789ABCDEF'
];
const $87e6acd7396d97dc$var$h1 = (b)=>$87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$h2 = (b)=>$87e6acd7396d97dc$var$hex[(b & 0xF0) >> 4] + $87e6acd7396d97dc$var$hex[b & 0xF];
const $87e6acd7396d97dc$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $87e6acd7396d97dc$var$isShort = (v)=>$87e6acd7396d97dc$var$eq(v.r) && $87e6acd7396d97dc$var$eq(v.g) && $87e6acd7396d97dc$var$eq(v.b) && $87e6acd7396d97dc$var$eq(v.a);
function $87e6acd7396d97dc$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $87e6acd7396d97dc$var$map$1[str[1]] * 17,
            g: 255 & $87e6acd7396d97dc$var$map$1[str[2]] * 17,
            b: 255 & $87e6acd7396d97dc$var$map$1[str[3]] * 17,
            a: len === 5 ? $87e6acd7396d97dc$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $87e6acd7396d97dc$var$map$1[str[1]] << 4 | $87e6acd7396d97dc$var$map$1[str[2]],
            g: $87e6acd7396d97dc$var$map$1[str[3]] << 4 | $87e6acd7396d97dc$var$map$1[str[4]],
            b: $87e6acd7396d97dc$var$map$1[str[5]] << 4 | $87e6acd7396d97dc$var$map$1[str[6]],
            a: len === 9 ? $87e6acd7396d97dc$var$map$1[str[7]] << 4 | $87e6acd7396d97dc$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $87e6acd7396d97dc$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $87e6acd7396d97dc$export$1b06654353ef9f67(v) {
    var f = $87e6acd7396d97dc$var$isShort(v) ? $87e6acd7396d97dc$var$h1 : $87e6acd7396d97dc$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $87e6acd7396d97dc$var$alpha(v.a, f) : undefined;
}
const $87e6acd7396d97dc$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $87e6acd7396d97dc$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $87e6acd7396d97dc$var$hwb2rgbn(h, w, b) {
    const rgb = $87e6acd7396d97dc$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $87e6acd7396d97dc$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $87e6acd7396d97dc$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $87e6acd7396d97dc$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $87e6acd7396d97dc$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($87e6acd7396d97dc$export$ed9bd8dcaeba14f6);
}
function $87e6acd7396d97dc$export$4c15bd42559b811d(h, s, l) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsl2rgbn, h, s, l);
}
function $87e6acd7396d97dc$export$e2710022c70fc9ee(h, w, b) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hwb2rgbn, h, w, b);
}
function $87e6acd7396d97dc$export$b785a357c84e4a04(h, s, v) {
    return $87e6acd7396d97dc$var$calln($87e6acd7396d97dc$var$hsv2rgbn, h, s, v);
}
function $87e6acd7396d97dc$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $87e6acd7396d97dc$export$5e91288c399be4f9(str) {
    const m = $87e6acd7396d97dc$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(+m[5]) : $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $87e6acd7396d97dc$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $87e6acd7396d97dc$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $87e6acd7396d97dc$export$b785a357c84e4a04(h, p1, p2);
    else v = $87e6acd7396d97dc$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $87e6acd7396d97dc$export$bb628a54ab399bc9(v, deg) {
    var h = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    h[0] = $87e6acd7396d97dc$var$hue(h[0] + deg);
    h = $87e6acd7396d97dc$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $87e6acd7396d97dc$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[1]);
    const l = $87e6acd7396d97dc$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $87e6acd7396d97dc$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $87e6acd7396d97dc$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $87e6acd7396d97dc$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($87e6acd7396d97dc$var$names$1);
    const tkeys = Object.keys($87e6acd7396d97dc$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $87e6acd7396d97dc$var$map[k]);
        }
        k = parseInt($87e6acd7396d97dc$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $87e6acd7396d97dc$var$names;
function $87e6acd7396d97dc$export$b2f06b640faad956(str) {
    if (!$87e6acd7396d97dc$var$names) {
        $87e6acd7396d97dc$var$names = $87e6acd7396d97dc$var$unpack();
        $87e6acd7396d97dc$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $87e6acd7396d97dc$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $87e6acd7396d97dc$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $87e6acd7396d97dc$export$91aedb20f296e541(str) {
    const m = $87e6acd7396d97dc$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(v) : $87e6acd7396d97dc$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(r) : $87e6acd7396d97dc$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(g) : $87e6acd7396d97dc$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $87e6acd7396d97dc$export$bcc6e673dfa14d36(b) : $87e6acd7396d97dc$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $87e6acd7396d97dc$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$87e6acd7396d97dc$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $87e6acd7396d97dc$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $87e6acd7396d97dc$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $87e6acd7396d97dc$var$interpolate(rgb1, rgb2, t) {
    const r = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.r));
    const g = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.g));
    const b = $87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(r + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(g + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $87e6acd7396d97dc$export$ed9bd8dcaeba14f6($87e6acd7396d97dc$var$to(b + t * ($87e6acd7396d97dc$var$from($87e6acd7396d97dc$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $87e6acd7396d97dc$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $87e6acd7396d97dc$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $87e6acd7396d97dc$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $87e6acd7396d97dc$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $87e6acd7396d97dc$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $87e6acd7396d97dc$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $87e6acd7396d97dc$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $87e6acd7396d97dc$export$91aedb20f296e541(str);
    return $87e6acd7396d97dc$export$5e91288c399be4f9(str);
}
class $87e6acd7396d97dc$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $87e6acd7396d97dc$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $87e6acd7396d97dc$var$fromObject(input);
        else if (type === 'string') v = $87e6acd7396d97dc$export$625a38b961e8b5e9(input) || $87e6acd7396d97dc$export$b2f06b640faad956(input) || $87e6acd7396d97dc$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $87e6acd7396d97dc$var$clone(this._rgb);
        if (v) v.a = $87e6acd7396d97dc$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $87e6acd7396d97dc$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $87e6acd7396d97dc$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $87e6acd7396d97dc$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $87e6acd7396d97dc$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $87e6acd7396d97dc$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $87e6acd7396d97dc$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $87e6acd7396d97dc$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $87e6acd7396d97dc$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $87e6acd7396d97dc$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $87e6acd7396d97dc$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $87e6acd7396d97dc$export$2e2bcd8739ae039(input) {
    return new $87e6acd7396d97dc$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $8d27ca75da600b9c$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $8d27ca75da600b9c$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $8d27ca75da600b9c$export$342063e11d6c3cad(value) {
    return value === null || typeof value === 'undefined';
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $8d27ca75da600b9c$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $8d27ca75da600b9c$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $8d27ca75da600b9c$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $8d27ca75da600b9c$export$c4ce752e73470fba(value, defaultValue) {
    return $8d27ca75da600b9c$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $8d27ca75da600b9c$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $8d27ca75da600b9c$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $8d27ca75da600b9c$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $8d27ca75da600b9c$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $8d27ca75da600b9c$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($8d27ca75da600b9c$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($8d27ca75da600b9c$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $8d27ca75da600b9c$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $8d27ca75da600b9c$export$d377dcb2b61d6c4e(source) {
    if ($8d27ca75da600b9c$export$8b22cf2602fb60ce(source)) return source.map($8d27ca75da600b9c$export$d377dcb2b61d6c4e);
    if ($8d27ca75da600b9c$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $8d27ca75da600b9c$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $8d27ca75da600b9c$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $8d27ca75da600b9c$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$8d27ca75da600b9c$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($8d27ca75da600b9c$export$23f2a1d2818174ef(tval) && $8d27ca75da600b9c$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $8d27ca75da600b9c$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $8d27ca75da600b9c$export$d377dcb2b61d6c4e(sval);
}
function $8d27ca75da600b9c$export$efca4cbe5dd06740(target, source, options) {
    const sources = $8d27ca75da600b9c$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$8d27ca75da600b9c$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $8d27ca75da600b9c$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$8d27ca75da600b9c$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $8d27ca75da600b9c$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $8d27ca75da600b9c$export$efca4cbe5dd06740(target, source, {
        merger: $8d27ca75da600b9c$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $8d27ca75da600b9c$export$317a3d46287192d8(key, target, source) {
    if (!$8d27ca75da600b9c$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($8d27ca75da600b9c$export$23f2a1d2818174ef(tval) && $8d27ca75da600b9c$export$23f2a1d2818174ef(sval)) $8d27ca75da600b9c$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $8d27ca75da600b9c$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $8d27ca75da600b9c$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $8d27ca75da600b9c$export$9d0e2d13d04f7070(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $8d27ca75da600b9c$var$_getKeyResolver(key) {
    const keys = $8d27ca75da600b9c$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $8d27ca75da600b9c$export$2d1720544b23b823(obj, key) {
    const resolver = $8d27ca75da600b9c$var$keyResolvers[key] || ($8d27ca75da600b9c$var$keyResolvers[key] = $8d27ca75da600b9c$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $8d27ca75da600b9c$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $8d27ca75da600b9c$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $8d27ca75da600b9c$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $8d27ca75da600b9c$export$f38c853ae54ed474(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $8d27ca75da600b9c$export$56c0d5a1e737357d = Math.PI;
const $8d27ca75da600b9c$export$971d5caa766a69d7 = 2 * $8d27ca75da600b9c$export$56c0d5a1e737357d;
const $8d27ca75da600b9c$export$d29e374196577086 = $8d27ca75da600b9c$export$971d5caa766a69d7 + $8d27ca75da600b9c$export$56c0d5a1e737357d;
const $8d27ca75da600b9c$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $8d27ca75da600b9c$export$53c86fa97d611818 = $8d27ca75da600b9c$export$56c0d5a1e737357d / 180;
const $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd = $8d27ca75da600b9c$export$56c0d5a1e737357d / 2;
const $8d27ca75da600b9c$export$39c1cc7c062529d4 = $8d27ca75da600b9c$export$56c0d5a1e737357d / 4;
const $8d27ca75da600b9c$export$7a0bdf7d4a91ea88 = $8d27ca75da600b9c$export$56c0d5a1e737357d * 2 / 3;
const $8d27ca75da600b9c$export$9f4f30ee63539e24 = Math.log10;
const $8d27ca75da600b9c$export$2408f22a0fab9ae5 = Math.sign;
function $8d27ca75da600b9c$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $8d27ca75da600b9c$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $8d27ca75da600b9c$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($8d27ca75da600b9c$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $8d27ca75da600b9c$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $8d27ca75da600b9c$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $8d27ca75da600b9c$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $8d27ca75da600b9c$export$625550452a3fa3ec(degrees) {
    return degrees * ($8d27ca75da600b9c$export$56c0d5a1e737357d / 180);
}
function $8d27ca75da600b9c$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $8d27ca75da600b9c$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $8d27ca75da600b9c$export$23ebac1979863676(x) {
    if (!$8d27ca75da600b9c$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $8d27ca75da600b9c$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $8d27ca75da600b9c$export$56c0d5a1e737357d) angle += $8d27ca75da600b9c$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $8d27ca75da600b9c$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $8d27ca75da600b9c$export$c18d01048907ea92(a, b) {
    return (a - b + $8d27ca75da600b9c$export$d29e374196577086) % $8d27ca75da600b9c$export$971d5caa766a69d7 - $8d27ca75da600b9c$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $8d27ca75da600b9c$export$28f7fcd39efa255(a) {
    return (a % $8d27ca75da600b9c$export$971d5caa766a69d7 + $8d27ca75da600b9c$export$971d5caa766a69d7) % $8d27ca75da600b9c$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $8d27ca75da600b9c$export$28f7fcd39efa255(angle);
    const s = $8d27ca75da600b9c$export$28f7fcd39efa255(start);
    const e = $8d27ca75da600b9c$export$28f7fcd39efa255(end);
    const angleToStart = $8d27ca75da600b9c$export$28f7fcd39efa255(s - a);
    const angleToEnd = $8d27ca75da600b9c$export$28f7fcd39efa255(e - a);
    const startToAngle = $8d27ca75da600b9c$export$28f7fcd39efa255(a - s);
    const endToAngle = $8d27ca75da600b9c$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $8d27ca75da600b9c$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $8d27ca75da600b9c$export$71cec2538cb2c617(value) {
    return $8d27ca75da600b9c$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $8d27ca75da600b9c$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $8d27ca75da600b9c$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $8d27ca75da600b9c$export$ef35774e6d314e91 = (table, key, value, last)=>$8d27ca75da600b9c$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $8d27ca75da600b9c$export$ebd11618f299a286 = (table, key, value)=>$8d27ca75da600b9c$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $8d27ca75da600b9c$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $8d27ca75da600b9c$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $8d27ca75da600b9c$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $8d27ca75da600b9c$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $8d27ca75da600b9c$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $8d27ca75da600b9c$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $8d27ca75da600b9c$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $8d27ca75da600b9c$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $8d27ca75da600b9c$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $8d27ca75da600b9c$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $8d27ca75da600b9c$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $8d27ca75da600b9c$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $8d27ca75da600b9c$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $8d27ca75da600b9c$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $8d27ca75da600b9c$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $8d27ca75da600b9c$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $8d27ca75da600b9c$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, _parsed: _parsed } = meta;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) start = $8d27ca75da600b9c$export$25ce5a424b770e84(Math.min($8d27ca75da600b9c$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $8d27ca75da600b9c$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $8d27ca75da600b9c$export$25ce5a424b770e84(Math.max($8d27ca75da600b9c$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $8d27ca75da600b9c$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $8d27ca75da600b9c$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $8d27ca75da600b9c$var$atEdge = (t)=>t === 0 || t === 1;
const $8d27ca75da600b9c$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $8d27ca75da600b9c$export$971d5caa766a69d7 / p));
const $8d27ca75da600b9c$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $8d27ca75da600b9c$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $8d27ca75da600b9c$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($8d27ca75da600b9c$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$8d27ca75da600b9c$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$8d27ca75da600b9c$var$atEdge(t) ? t : $8d27ca75da600b9c$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$8d27ca75da600b9c$var$atEdge(t) ? t : $8d27ca75da600b9c$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $8d27ca75da600b9c$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $8d27ca75da600b9c$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $8d27ca75da600b9c$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $8d27ca75da600b9c$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $8d27ca75da600b9c$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $8d27ca75da600b9c$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $8d27ca75da600b9c$export$f96d196f7728bb5(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $8d27ca75da600b9c$export$db3b6bfb95261072(value) {
    return $8d27ca75da600b9c$export$f96d196f7728bb5(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value);
}
function $8d27ca75da600b9c$export$738ab4df8bf92ae9(value) {
    return $8d27ca75da600b9c$export$f96d196f7728bb5(value) ? value : new (0, $87e6acd7396d97dc$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $8d27ca75da600b9c$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $8d27ca75da600b9c$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $8d27ca75da600b9c$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $8d27ca75da600b9c$var$colors
        },
        numbers: {
            type: 'number',
            properties: $8d27ca75da600b9c$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $8d27ca75da600b9c$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $8d27ca75da600b9c$var$intlCache = new Map();
function $8d27ca75da600b9c$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $8d27ca75da600b9c$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $8d27ca75da600b9c$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $8d27ca75da600b9c$export$ae1af26003f05816(num, locale, options) {
    return $8d27ca75da600b9c$var$getNumberFormat(locale, options).format(num);
}
const $8d27ca75da600b9c$var$formatters = {
    values (value) {
        return $8d27ca75da600b9c$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $8d27ca75da600b9c$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $8d27ca75da600b9c$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $8d27ca75da600b9c$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($8d27ca75da600b9c$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $8d27ca75da600b9c$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $8d27ca75da600b9c$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $8d27ca75da600b9c$export$91477dc880baac21 = {
    formatters: $8d27ca75da600b9c$var$formatters
};
function $8d27ca75da600b9c$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $8d27ca75da600b9c$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $8d27ca75da600b9c$export$6559d589eb85fbb6 = Object.create(null);
const $8d27ca75da600b9c$export$2e2af4578d910ddf = Object.create(null);
function $8d27ca75da600b9c$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $8d27ca75da600b9c$var$set(root, scope, values) {
    if (typeof scope === 'string') return $8d27ca75da600b9c$export$efca4cbe5dd06740($8d27ca75da600b9c$var$getScope$1(root, scope), values);
    return $8d27ca75da600b9c$export$efca4cbe5dd06740($8d27ca75da600b9c$var$getScope$1(root, ''), scope);
}
class $8d27ca75da600b9c$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$8d27ca75da600b9c$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$8d27ca75da600b9c$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$8d27ca75da600b9c$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $8d27ca75da600b9c$var$set(this, scope, values);
    }
    get(scope) {
        return $8d27ca75da600b9c$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $8d27ca75da600b9c$var$set($8d27ca75da600b9c$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $8d27ca75da600b9c$var$set($8d27ca75da600b9c$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $8d27ca75da600b9c$var$getScope$1(this, scope);
        const targetScopeObject = $8d27ca75da600b9c$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($8d27ca75da600b9c$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $8d27ca75da600b9c$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $8d27ca75da600b9c$export$4368d992c4eafac0 = /* #__PURE__ */ new $8d27ca75da600b9c$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $8d27ca75da600b9c$var$applyAnimationsDefaults,
    $8d27ca75da600b9c$var$applyLayoutsDefaults,
    $8d27ca75da600b9c$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $8d27ca75da600b9c$export$1a8f5705751d8277(font) {
    if (!font || $8d27ca75da600b9c$export$342063e11d6c3cad(font.size) || $8d27ca75da600b9c$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $8d27ca75da600b9c$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$8d27ca75da600b9c$export$8b22cf2602fb60ce(thing)) longest = $8d27ca75da600b9c$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($8d27ca75da600b9c$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$8d27ca75da600b9c$export$8b22cf2602fb60ce(nestedThing)) longest = $8d27ca75da600b9c$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $8d27ca75da600b9c$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $8d27ca75da600b9c$export$c9170ad7d4cd7e57(canvas, ctx) {
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $8d27ca75da600b9c$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $8d27ca75da600b9c$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $8d27ca75da600b9c$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $8d27ca75da600b9c$export$53c86fa97d611818;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $8d27ca75da600b9c$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $8d27ca75da600b9c$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $8d27ca75da600b9c$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $8d27ca75da600b9c$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $8d27ca75da600b9c$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $8d27ca75da600b9c$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $8d27ca75da600b9c$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $8d27ca75da600b9c$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $8d27ca75da600b9c$export$56c0d5a1e737357d, rad - $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd, rad + $8d27ca75da600b9c$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $8d27ca75da600b9c$export$39c1cc7c062529d4;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $8d27ca75da600b9c$export$39c1cc7c062529d4;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $8d27ca75da600b9c$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $8d27ca75da600b9c$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $8d27ca75da600b9c$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $8d27ca75da600b9c$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $8d27ca75da600b9c$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$8d27ca75da600b9c$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $8d27ca75da600b9c$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $8d27ca75da600b9c$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $8d27ca75da600b9c$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $8d27ca75da600b9c$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $8d27ca75da600b9c$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $8d27ca75da600b9c$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$8d27ca75da600b9c$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $8d27ca75da600b9c$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $8d27ca75da600b9c$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $8d27ca75da600b9c$export$56c0d5a1e737357d, $8d27ca75da600b9c$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $8d27ca75da600b9c$export$56c0d5a1e737357d, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$8d27ca75da600b9c$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $8d27ca75da600b9c$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $8d27ca75da600b9c$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $8d27ca75da600b9c$export$8c78c7c36408ea29(value, size) {
    const matches = ('' + value).match($8d27ca75da600b9c$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $8d27ca75da600b9c$var$numberOrZero = (v)=>+v || 0;
function $8d27ca75da600b9c$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $8d27ca75da600b9c$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $8d27ca75da600b9c$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$8d27ca75da600b9c$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $8d27ca75da600b9c$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $8d27ca75da600b9c$export$d66dc83d8cfc8dd(value) {
    return $8d27ca75da600b9c$export$21579262ef46735b(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $8d27ca75da600b9c$export$92108d983e8ee699(value) {
    return $8d27ca75da600b9c$export$21579262ef46735b(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $8d27ca75da600b9c$export$a9c23c6ac3fc3eca(value) {
    const obj = $8d27ca75da600b9c$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $8d27ca75da600b9c$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $8d27ca75da600b9c$export$4368d992c4eafac0.font;
    let size = $8d27ca75da600b9c$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $8d27ca75da600b9c$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($8d27ca75da600b9c$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $8d27ca75da600b9c$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $8d27ca75da600b9c$export$8c78c7c36408ea29($8d27ca75da600b9c$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $8d27ca75da600b9c$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $8d27ca75da600b9c$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $8d27ca75da600b9c$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $8d27ca75da600b9c$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $8d27ca75da600b9c$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $8d27ca75da600b9c$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $8d27ca75da600b9c$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $8d27ca75da600b9c$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $8d27ca75da600b9c$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$8d27ca75da600b9c$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $8d27ca75da600b9c$var$_cached(target, prop, ()=>$8d27ca75da600b9c$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $8d27ca75da600b9c$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $8d27ca75da600b9c$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $8d27ca75da600b9c$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $8d27ca75da600b9c$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$8d27ca75da600b9c$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$8d27ca75da600b9c$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $8d27ca75da600b9c$var$_cached(target, prop, ()=>$8d27ca75da600b9c$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $8d27ca75da600b9c$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $8d27ca75da600b9c$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $8d27ca75da600b9c$var$readKey = (prefix, name)=>prefix ? prefix + $8d27ca75da600b9c$export$a8550f7dbe79f93a(name) : name;
const $8d27ca75da600b9c$var$needsSubResolver = (prop, value)=>$8d27ca75da600b9c$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $8d27ca75da600b9c$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $8d27ca75da600b9c$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($8d27ca75da600b9c$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $8d27ca75da600b9c$var$_resolveScriptable(prop, value, target, receiver);
    if ($8d27ca75da600b9c$export$8b22cf2602fb60ce(value) && value.length) value = $8d27ca75da600b9c$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($8d27ca75da600b9c$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $8d27ca75da600b9c$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $8d27ca75da600b9c$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($8d27ca75da600b9c$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $8d27ca75da600b9c$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $8d27ca75da600b9c$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($8d27ca75da600b9c$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $8d27ca75da600b9c$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($8d27ca75da600b9c$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $8d27ca75da600b9c$var$resolveFallback(fallback, prop, value) {
    return $8d27ca75da600b9c$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $8d27ca75da600b9c$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $8d27ca75da600b9c$export$2d1720544b23b823(parent, key) : undefined;
function $8d27ca75da600b9c$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $8d27ca75da600b9c$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $8d27ca75da600b9c$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $8d27ca75da600b9c$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $8d27ca75da600b9c$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $8d27ca75da600b9c$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $8d27ca75da600b9c$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $8d27ca75da600b9c$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$8d27ca75da600b9c$var$subGetTarget(resolver, prop, value));
}
function $8d27ca75da600b9c$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $8d27ca75da600b9c$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $8d27ca75da600b9c$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($8d27ca75da600b9c$export$8b22cf2602fb60ce(target) && $8d27ca75da600b9c$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $8d27ca75da600b9c$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $8d27ca75da600b9c$var$_resolve($8d27ca75da600b9c$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $8d27ca75da600b9c$var$needsSubResolver(prop, value) ? $8d27ca75da600b9c$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $8d27ca75da600b9c$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $8d27ca75da600b9c$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $8d27ca75da600b9c$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $8d27ca75da600b9c$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $8d27ca75da600b9c$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($8d27ca75da600b9c$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $8d27ca75da600b9c$var$EPSILON = Number.EPSILON || 1e-14;
const $8d27ca75da600b9c$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $8d27ca75da600b9c$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $8d27ca75da600b9c$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $8d27ca75da600b9c$export$158acd800e1ef08b(current, previous);
    const d12 = $8d27ca75da600b9c$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $8d27ca75da600b9c$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $8d27ca75da600b9c$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $8d27ca75da600b9c$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($8d27ca75da600b9c$export$a05254e7c3aeba6e(deltaK[i], 0, $8d27ca75da600b9c$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $8d27ca75da600b9c$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $8d27ca75da600b9c$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $8d27ca75da600b9c$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $8d27ca75da600b9c$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $8d27ca75da600b9c$export$527e9aa3390079e9(points, indexAxis = 'x') {
    const valueAxis = $8d27ca75da600b9c$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $8d27ca75da600b9c$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $8d27ca75da600b9c$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $8d27ca75da600b9c$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $8d27ca75da600b9c$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $8d27ca75da600b9c$var$monotoneAdjust(points, deltaK, mK);
    $8d27ca75da600b9c$var$monotoneCompute(points, mK, indexAxis);
}
function $8d27ca75da600b9c$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $8d27ca75da600b9c$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $8d27ca75da600b9c$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $8d27ca75da600b9c$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $8d27ca75da600b9c$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $8d27ca75da600b9c$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $8d27ca75da600b9c$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $8d27ca75da600b9c$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $8d27ca75da600b9c$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $8d27ca75da600b9c$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $8d27ca75da600b9c$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $8d27ca75da600b9c$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $8d27ca75da600b9c$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $8d27ca75da600b9c$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $8d27ca75da600b9c$export$a17c37559e1db147(el, property) {
    return $8d27ca75da600b9c$var$getComputedStyle(el).getPropertyValue(property);
}
const $8d27ca75da600b9c$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $8d27ca75da600b9c$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $8d27ca75da600b9c$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $8d27ca75da600b9c$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $8d27ca75da600b9c$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($8d27ca75da600b9c$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $8d27ca75da600b9c$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $8d27ca75da600b9c$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $8d27ca75da600b9c$var$getPositionedStyle(style, 'padding');
    const borders = $8d27ca75da600b9c$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $8d27ca75da600b9c$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $8d27ca75da600b9c$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $8d27ca75da600b9c$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $8d27ca75da600b9c$var$getComputedStyle(container);
            const containerBorder = $8d27ca75da600b9c$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $8d27ca75da600b9c$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $8d27ca75da600b9c$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $8d27ca75da600b9c$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $8d27ca75da600b9c$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $8d27ca75da600b9c$export$2ec5befb9e6c97d4
    };
}
const $8d27ca75da600b9c$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $8d27ca75da600b9c$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $8d27ca75da600b9c$var$getComputedStyle(canvas);
    const margins = $8d27ca75da600b9c$var$getPositionedStyle(style, 'margin');
    const maxWidth = $8d27ca75da600b9c$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $8d27ca75da600b9c$export$2ec5befb9e6c97d4;
    const maxHeight = $8d27ca75da600b9c$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $8d27ca75da600b9c$export$2ec5befb9e6c97d4;
    const containerSize = $8d27ca75da600b9c$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $8d27ca75da600b9c$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $8d27ca75da600b9c$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $8d27ca75da600b9c$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $8d27ca75da600b9c$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $8d27ca75da600b9c$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $8d27ca75da600b9c$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $8d27ca75da600b9c$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $8d27ca75da600b9c$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($8d27ca75da600b9c$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $8d27ca75da600b9c$export$b4171a6734a65d42(element, property) {
    const value = $8d27ca75da600b9c$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $8d27ca75da600b9c$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $8d27ca75da600b9c$export$8a5498727ef6be21(p1, cp1, t);
    const b = $8d27ca75da600b9c$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $8d27ca75da600b9c$export$8a5498727ef6be21(cp2, p2, t);
    const d = $8d27ca75da600b9c$export$8a5498727ef6be21(a, b, t);
    const e = $8d27ca75da600b9c$export$8a5498727ef6be21(b, c, t);
    return $8d27ca75da600b9c$export$8a5498727ef6be21(d, e, t);
}
const $8d27ca75da600b9c$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $8d27ca75da600b9c$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $8d27ca75da600b9c$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $8d27ca75da600b9c$var$getRightToLeftAdapter(rectX, width) : $8d27ca75da600b9c$var$getLeftToRightAdapter();
}
function $8d27ca75da600b9c$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $8d27ca75da600b9c$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $8d27ca75da600b9c$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $8d27ca75da600b9c$export$ffb5f4729a158638,
        compare: $8d27ca75da600b9c$export$c18d01048907ea92,
        normalize: $8d27ca75da600b9c$export$28f7fcd39efa255
    };
    return {
        between: $8d27ca75da600b9c$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $8d27ca75da600b9c$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $8d27ca75da600b9c$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $8d27ca75da600b9c$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $8d27ca75da600b9c$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $8d27ca75da600b9c$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $8d27ca75da600b9c$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($8d27ca75da600b9c$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($8d27ca75da600b9c$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $8d27ca75da600b9c$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $8d27ca75da600b9c$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $8d27ca75da600b9c$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $8d27ca75da600b9c$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $8d27ca75da600b9c$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $8d27ca75da600b9c$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $8d27ca75da600b9c$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $8d27ca75da600b9c$var$splitByStyles(line, $8d27ca75da600b9c$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $8d27ca75da600b9c$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $8d27ca75da600b9c$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $8d27ca75da600b9c$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $8d27ca75da600b9c$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $8d27ca75da600b9c$var$readStyle(segmentOptions.setContext($8d27ca75da600b9c$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($8d27ca75da600b9c$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $8d27ca75da600b9c$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $8d27ca75da600b9c$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$8d27ca75da600b9c$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $216d2bdc6f281bf6$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $8d27ca75da600b9c$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $216d2bdc6f281bf6$export$a424a0aa8f687495 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Animator();
const $216d2bdc6f281bf6$var$transparent = 'transparent';
const $216d2bdc6f281bf6$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $8d27ca75da600b9c$export$db3b6bfb95261072)(from || $216d2bdc6f281bf6$var$transparent);
        const c1 = c0.valid && (0, $8d27ca75da600b9c$export$db3b6bfb95261072)(to || $216d2bdc6f281bf6$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $216d2bdc6f281bf6$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $8d27ca75da600b9c$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $8d27ca75da600b9c$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $216d2bdc6f281bf6$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $8d27ca75da600b9c$export$f1e1789686576879)[cfg.easing] || (0, $8d27ca75da600b9c$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $8d27ca75da600b9c$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $8d27ca75da600b9c$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $216d2bdc6f281bf6$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $8d27ca75da600b9c$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $216d2bdc6f281bf6$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $216d2bdc6f281bf6$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $216d2bdc6f281bf6$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $216d2bdc6f281bf6$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $216d2bdc6f281bf6$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $216d2bdc6f281bf6$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $216d2bdc6f281bf6$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $216d2bdc6f281bf6$var$scaleClip(xScale, allowedOverflow);
    const y = $216d2bdc6f281bf6$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $216d2bdc6f281bf6$var$toClip(value) {
    let t, r, b, l;
    if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $216d2bdc6f281bf6$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $8d27ca75da600b9c$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(value) === (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $216d2bdc6f281bf6$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $216d2bdc6f281bf6$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $216d2bdc6f281bf6$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $216d2bdc6f281bf6$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $216d2bdc6f281bf6$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $216d2bdc6f281bf6$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $216d2bdc6f281bf6$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $216d2bdc6f281bf6$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $216d2bdc6f281bf6$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $216d2bdc6f281bf6$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $216d2bdc6f281bf6$var$createDatasetContext(parent, index) {
    return (0, $8d27ca75da600b9c$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $216d2bdc6f281bf6$var$createDataContext(parent, index, element) {
    return (0, $8d27ca75da600b9c$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $216d2bdc6f281bf6$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $216d2bdc6f281bf6$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $216d2bdc6f281bf6$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $216d2bdc6f281bf6$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $216d2bdc6f281bf6$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(dataset.xAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(dataset.yAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(dataset.rAxisID, $216d2bdc6f281bf6$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $8d27ca75da600b9c$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(data)) this._data = $216d2bdc6f281bf6$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $8d27ca75da600b9c$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $216d2bdc6f281bf6$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $8d27ca75da600b9c$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $216d2bdc6f281bf6$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $216d2bdc6f281bf6$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $216d2bdc6f281bf6$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $216d2bdc6f281bf6$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $8d27ca75da600b9c$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $8d27ca75da600b9c$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $216d2bdc6f281bf6$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $216d2bdc6f281bf6$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $216d2bdc6f281bf6$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $216d2bdc6f281bf6$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $216d2bdc6f281bf6$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $8d27ca75da600b9c$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $8d27ca75da600b9c$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $216d2bdc6f281bf6$var$toClip((0, $8d27ca75da600b9c$export$90a7f3efeed30595)(this.options.clip, $216d2bdc6f281bf6$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $216d2bdc6f281bf6$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $216d2bdc6f281bf6$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $8d27ca75da600b9c$export$dda1d9f60106f0e9)(index);
        if (cached) return $216d2bdc6f281bf6$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $8d27ca75da600b9c$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($216d2bdc6f281bf6$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $216d2bdc6f281bf6$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$216d2bdc6f281bf6$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $216d2bdc6f281bf6$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $216d2bdc6f281bf6$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $8d27ca75da600b9c$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $216d2bdc6f281bf6$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $216d2bdc6f281bf6$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $8d27ca75da600b9c$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i) {
    if ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(entry)) $216d2bdc6f281bf6$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($216d2bdc6f281bf6$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $216d2bdc6f281bf6$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $216d2bdc6f281bf6$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $216d2bdc6f281bf6$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$216d2bdc6f281bf6$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$216d2bdc6f281bf6$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $216d2bdc6f281bf6$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $216d2bdc6f281bf6$var$swap(edge, a, b);
        edge = $216d2bdc6f281bf6$var$startEnd(edge, b, a);
    } else edge = $216d2bdc6f281bf6$var$startEnd(edge, a, b);
    return edge;
}
function $216d2bdc6f281bf6$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $216d2bdc6f281bf6$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $216d2bdc6f281bf6$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $216d2bdc6f281bf6$export$e97d5dc64e999004 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $216d2bdc6f281bf6$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $8d27ca75da600b9c$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($216d2bdc6f281bf6$var$parseValue((0, $8d27ca75da600b9c$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $216d2bdc6f281bf6$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $8d27ca75da600b9c$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $216d2bdc6f281bf6$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $216d2bdc6f281bf6$var$setBorderSkipped(properties, options, stack, index);
            $216d2bdc6f281bf6$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $216d2bdc6f281bf6$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $216d2bdc6f281bf6$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(value) !== (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $216d2bdc6f281bf6$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $216d2bdc6f281bf6$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $216d2bdc6f281bf6$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class $216d2bdc6f281bf6$export$19b5c4773f17abe extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $8d27ca75da600b9c$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $8d27ca75da600b9c$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $8d27ca75da600b9c$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $8d27ca75da600b9c$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $8d27ca75da600b9c$export$56c0d5a1e737357d) + (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $216d2bdc6f281bf6$export$e04603e7d8b77172 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $8d27ca75da600b9c$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $8d27ca75da600b9c$export$971d5caa766a69d7);
        let max = -(0, $8d27ca75da600b9c$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $8d27ca75da600b9c$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $216d2bdc6f281bf6$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $8d27ca75da600b9c$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $8d27ca75da600b9c$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $8d27ca75da600b9c$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $8d27ca75da600b9c$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $8d27ca75da600b9c$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $8d27ca75da600b9c$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $8d27ca75da600b9c$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $8d27ca75da600b9c$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $8d27ca75da600b9c$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $216d2bdc6f281bf6$export$2a270b3a0d973c85 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $8d27ca75da600b9c$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $8d27ca75da600b9c$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $8d27ca75da600b9c$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $216d2bdc6f281bf6$export$b21a3f1286706191 extends $216d2bdc6f281bf6$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $216d2bdc6f281bf6$export$48dbc6ac651bf8be extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $8d27ca75da600b9c$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $216d2bdc6f281bf6$export$b2f2bae6713db87 extends $216d2bdc6f281bf6$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $8d27ca75da600b9c$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $8d27ca75da600b9c$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $8d27ca75da600b9c$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $8d27ca75da600b9c$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $216d2bdc6f281bf6$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $216d2bdc6f281bf6$export$e97d5dc64e999004,
    BubbleController: $216d2bdc6f281bf6$export$19b5c4773f17abe,
    DoughnutController: $216d2bdc6f281bf6$export$e04603e7d8b77172,
    LineController: $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0,
    PieController: $216d2bdc6f281bf6$export$b21a3f1286706191,
    PolarAreaController: $216d2bdc6f281bf6$export$2a270b3a0d973c85,
    RadarController: $216d2bdc6f281bf6$export$48dbc6ac651bf8be,
    ScatterController: $216d2bdc6f281bf6$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $216d2bdc6f281bf6$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $216d2bdc6f281bf6$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($216d2bdc6f281bf6$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    parse() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    format() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    add() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    diff() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    startOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
    endOf() {
        return $216d2bdc6f281bf6$var$abstract();
    }
}
var $216d2bdc6f281bf6$export$f32766ea09ec8bc4 = {
    _date: $216d2bdc6f281bf6$var$DateAdapterBase
};
function $216d2bdc6f281bf6$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $8d27ca75da600b9c$export$ebd11618f299a286) : (0, $8d27ca75da600b9c$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $216d2bdc6f281bf6$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $8d27ca75da600b9c$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $8d27ca75da600b9c$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $8d27ca75da600b9c$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $216d2bdc6f281bf6$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $216d2bdc6f281bf6$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $216d2bdc6f281bf6$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $216d2bdc6f281bf6$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $216d2bdc6f281bf6$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $216d2bdc6f281bf6$export$a13296960cae0384 = {
    evaluateInteractionItems: $216d2bdc6f281bf6$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $216d2bdc6f281bf6$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(e, chart);
            return $216d2bdc6f281bf6$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $216d2bdc6f281bf6$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $216d2bdc6f281bf6$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$216d2bdc6f281bf6$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $216d2bdc6f281bf6$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $216d2bdc6f281bf6$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $216d2bdc6f281bf6$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$216d2bdc6f281bf6$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$setLayoutDims(layouts, params) {
    const stacks = $216d2bdc6f281bf6$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $216d2bdc6f281bf6$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $216d2bdc6f281bf6$var$wrapBoxes(boxes);
    const fullSize = $216d2bdc6f281bf6$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'right'));
    const top = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $216d2bdc6f281bf6$var$sortByWeight($216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $216d2bdc6f281bf6$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $216d2bdc6f281bf6$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $216d2bdc6f281bf6$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $216d2bdc6f281bf6$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $216d2bdc6f281bf6$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $216d2bdc6f281bf6$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $216d2bdc6f281bf6$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $216d2bdc6f281bf6$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $216d2bdc6f281bf6$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $216d2bdc6f281bf6$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $216d2bdc6f281bf6$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $8d27ca75da600b9c$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $216d2bdc6f281bf6$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $8d27ca75da600b9c$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $216d2bdc6f281bf6$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $216d2bdc6f281bf6$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $216d2bdc6f281bf6$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $216d2bdc6f281bf6$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $8d27ca75da600b9c$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $216d2bdc6f281bf6$var$updateMaxPadding(maxPadding, (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $216d2bdc6f281bf6$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $216d2bdc6f281bf6$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($216d2bdc6f281bf6$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $216d2bdc6f281bf6$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $216d2bdc6f281bf6$var$handleMaxPadding(chartArea);
        $216d2bdc6f281bf6$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $216d2bdc6f281bf6$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $8d27ca75da600b9c$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $216d2bdc6f281bf6$export$a40a96b24b46cf35 extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $216d2bdc6f281bf6$var$EXPANDO_KEY = '$chartjs';
const $216d2bdc6f281bf6$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $216d2bdc6f281bf6$var$isNullOrEmpty = (value)=>value === null || value === '';
function $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $8d27ca75da600b9c$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($216d2bdc6f281bf6$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $8d27ca75da600b9c$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $216d2bdc6f281bf6$var$eventListenerOptions = (0, $8d27ca75da600b9c$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $216d2bdc6f281bf6$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $216d2bdc6f281bf6$var$eventListenerOptions);
}
function $216d2bdc6f281bf6$var$fromNativeEvent(event, chart) {
    const type = $216d2bdc6f281bf6$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $216d2bdc6f281bf6$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $216d2bdc6f281bf6$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $216d2bdc6f281bf6$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $216d2bdc6f281bf6$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$216d2bdc6f281bf6$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $216d2bdc6f281bf6$var$drpListeningCharts = new Map();
let $216d2bdc6f281bf6$var$oldDevicePixelRatio = 0;
function $216d2bdc6f281bf6$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $216d2bdc6f281bf6$var$oldDevicePixelRatio) return;
    $216d2bdc6f281bf6$var$oldDevicePixelRatio = dpr;
    $216d2bdc6f281bf6$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.addEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
    $216d2bdc6f281bf6$var$drpListeningCharts.set(chart, resize);
}
function $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart) {
    $216d2bdc6f281bf6$var$drpListeningCharts.delete(chart);
    if (!$216d2bdc6f281bf6$var$drpListeningCharts.size) window.removeEventListener('resize', $216d2bdc6f281bf6$var$onWindowResize);
}
function $216d2bdc6f281bf6$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $8d27ca75da600b9c$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $8d27ca75da600b9c$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $216d2bdc6f281bf6$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $216d2bdc6f281bf6$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $216d2bdc6f281bf6$var$unlistenDevicePixelRatioChanges(chart);
}
function $216d2bdc6f281bf6$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $8d27ca75da600b9c$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($216d2bdc6f281bf6$var$fromNativeEvent(event, chart));
    }, chart);
    $216d2bdc6f281bf6$var$addListener(canvas, type, proxy);
    return proxy;
}
class $216d2bdc6f281bf6$export$f02da7f882cf6b2e extends $216d2bdc6f281bf6$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $216d2bdc6f281bf6$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY]) return false;
        const initial = canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$216d2bdc6f281bf6$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $216d2bdc6f281bf6$var$createAttachObserver,
            detach: $216d2bdc6f281bf6$var$createDetachObserver,
            resize: $216d2bdc6f281bf6$var$createResizeObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $216d2bdc6f281bf6$var$releaseObserver,
            detach: $216d2bdc6f281bf6$var$releaseObserver,
            resize: $216d2bdc6f281bf6$var$releaseObserver
        };
        const handler = handlers[type] || $216d2bdc6f281bf6$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $8d27ca75da600b9c$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $8d27ca75da600b9c$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $216d2bdc6f281bf6$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $8d27ca75da600b9c$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $216d2bdc6f281bf6$export$a40a96b24b46cf35;
    return $216d2bdc6f281bf6$export$f02da7f882cf6b2e;
}
class $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $8d27ca75da600b9c$export$d141bba7fdc215a3)(this.x) && (0, $8d27ca75da600b9c$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $216d2bdc6f281bf6$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $216d2bdc6f281bf6$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $216d2bdc6f281bf6$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, (0, $8d27ca75da600b9c$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, last, (0, $8d27ca75da600b9c$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $216d2bdc6f281bf6$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $216d2bdc6f281bf6$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $216d2bdc6f281bf6$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $8d27ca75da600b9c$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $216d2bdc6f281bf6$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $216d2bdc6f281bf6$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $216d2bdc6f281bf6$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $8d27ca75da600b9c$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $216d2bdc6f281bf6$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $216d2bdc6f281bf6$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $216d2bdc6f281bf6$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $216d2bdc6f281bf6$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $216d2bdc6f281bf6$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $216d2bdc6f281bf6$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $216d2bdc6f281bf6$var$garbageCollect(caches, length) {
    (0, $8d27ca75da600b9c$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $216d2bdc6f281bf6$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $216d2bdc6f281bf6$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $216d2bdc6f281bf6$var$createScaleContext(parent, scale) {
    return (0, $8d27ca75da600b9c$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $216d2bdc6f281bf6$var$createTickContext(parent, index, tick) {
    return (0, $8d27ca75da600b9c$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $216d2bdc6f281bf6$var$titleAlign(align, position, reverse) {
    let ret = (0, $8d27ca75da600b9c$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $216d2bdc6f281bf6$var$reverseAlign(ret);
    return ret;
}
function $216d2bdc6f281bf6$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $216d2bdc6f281bf6$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd) : (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $216d2bdc6f281bf6$export$d60cfc58d3c358b6 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(min, (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(max, min)),
            max: (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(max, (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $8d27ca75da600b9c$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $216d2bdc6f281bf6$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $216d2bdc6f281bf6$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $216d2bdc6f281bf6$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $216d2bdc6f281bf6$var$getTickMarkLength(options.grid) - tickOpts.padding - $216d2bdc6f281bf6$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $8d27ca75da600b9c$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $8d27ca75da600b9c$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $8d27ca75da600b9c$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $8d27ca75da600b9c$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $216d2bdc6f281bf6$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $216d2bdc6f281bf6$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $216d2bdc6f281bf6$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $216d2bdc6f281bf6$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(label) && !(0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(label)) {
                width = (0, $8d27ca75da600b9c$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(nestedLabel) && !(0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $8d27ca75da600b9c$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $216d2bdc6f281bf6$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $8d27ca75da600b9c$export$71cec2538cb2c617)(this._alignToPixels ? (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $216d2bdc6f281bf6$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $216d2bdc6f281bf6$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $216d2bdc6f281bf6$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $8d27ca75da600b9c$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $8d27ca75da600b9c$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $8d27ca75da600b9c$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $8d27ca75da600b9c$export$34aec0b863436764)(title.font);
        const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $216d2bdc6f281bf6$var$titleArgs(this, offset, position, align);
        (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $216d2bdc6f281bf6$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $216d2bdc6f281bf6$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $8d27ca75da600b9c$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $216d2bdc6f281bf6$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($216d2bdc6f281bf6$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $8d27ca75da600b9c$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $8d27ca75da600b9c$export$4368d992c4eafac0)[scope]) {
            delete (0, $8d27ca75da600b9c$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $8d27ca75da600b9c$export$6559d589eb85fbb6)[id];
        }
    }
}
function $216d2bdc6f281bf6$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $8d27ca75da600b9c$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $8d27ca75da600b9c$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $8d27ca75da600b9c$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $8d27ca75da600b9c$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $216d2bdc6f281bf6$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $8d27ca75da600b9c$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $216d2bdc6f281bf6$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $8d27ca75da600b9c$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $216d2bdc6f281bf6$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $216d2bdc6f281bf6$var$Registry {
    constructor(){
        this.controllers = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $216d2bdc6f281bf6$var$TypedRegistry(Object, 'plugins');
        this.scales = new $216d2bdc6f281bf6$var$TypedRegistry($216d2bdc6f281bf6$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $8d27ca75da600b9c$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $8d27ca75da600b9c$export$a8550f7dbe79f93a)(method);
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $216d2bdc6f281bf6$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $216d2bdc6f281bf6$var$Registry();
class $216d2bdc6f281bf6$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $216d2bdc6f281bf6$var$allPlugins(config);
        return options === false && !all ? [] : $216d2bdc6f281bf6$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $216d2bdc6f281bf6$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($216d2bdc6f281bf6$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($216d2bdc6f281bf6$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $216d2bdc6f281bf6$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $216d2bdc6f281bf6$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $216d2bdc6f281bf6$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $216d2bdc6f281bf6$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $216d2bdc6f281bf6$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $216d2bdc6f281bf6$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $8d27ca75da600b9c$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $216d2bdc6f281bf6$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $216d2bdc6f281bf6$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $216d2bdc6f281bf6$var$determineAxis(id, ...scaleOptions) {
    if ($216d2bdc6f281bf6$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $216d2bdc6f281bf6$var$axisFromPosition(opts.position) || id.length > 1 && $216d2bdc6f281bf6$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $216d2bdc6f281bf6$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'x', boundDs[0]) || $216d2bdc6f281bf6$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $216d2bdc6f281bf6$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $8d27ca75da600b9c$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $216d2bdc6f281bf6$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleConf, $216d2bdc6f281bf6$var$retrieveAxisFromDatasets(id, config), (0, $8d27ca75da600b9c$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $216d2bdc6f281bf6$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $8d27ca75da600b9c$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $8d27ca75da600b9c$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $216d2bdc6f281bf6$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $8d27ca75da600b9c$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $8d27ca75da600b9c$export$555508cbc6add439)(scale, [
            (0, $8d27ca75da600b9c$export$4368d992c4eafac0).scales[scale.type],
            (0, $8d27ca75da600b9c$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $216d2bdc6f281bf6$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $216d2bdc6f281bf6$var$mergeScaleConfig(config, options);
}
function $216d2bdc6f281bf6$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $216d2bdc6f281bf6$var$initConfig(config) {
    config = config || {};
    config.data = $216d2bdc6f281bf6$var$initData(config.data);
    $216d2bdc6f281bf6$var$initOptions(config);
    return config;
}
const $216d2bdc6f281bf6$var$keyCache = new Map();
const $216d2bdc6f281bf6$var$keysCached = new Set();
function $216d2bdc6f281bf6$var$cachedKeys(cacheKey, generate) {
    let keys = $216d2bdc6f281bf6$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $216d2bdc6f281bf6$var$keyCache.set(cacheKey, keys);
        $216d2bdc6f281bf6$var$keysCached.add(keys);
    }
    return keys;
}
const $216d2bdc6f281bf6$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $8d27ca75da600b9c$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $216d2bdc6f281bf6$var$Config {
    constructor(config){
        this._config = $216d2bdc6f281bf6$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $216d2bdc6f281bf6$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $216d2bdc6f281bf6$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $216d2bdc6f281bf6$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $216d2bdc6f281bf6$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $216d2bdc6f281bf6$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $8d27ca75da600b9c$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $8d27ca75da600b9c$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$216d2bdc6f281bf6$var$addIfFound(scopes, (0, $8d27ca75da600b9c$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($216d2bdc6f281bf6$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $8d27ca75da600b9c$export$6559d589eb85fbb6)[type] || {},
            (0, $8d27ca75da600b9c$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $8d27ca75da600b9c$export$4368d992c4eafac0),
            (0, $8d27ca75da600b9c$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($216d2bdc6f281bf6$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $8d27ca75da600b9c$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $8d27ca75da600b9c$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $216d2bdc6f281bf6$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(context) ? (0, $8d27ca75da600b9c$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $216d2bdc6f281bf6$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $8d27ca75da600b9c$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $216d2bdc6f281bf6$var$hasFunction = (value)=>(0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $8d27ca75da600b9c$export$a93c5207d687da10)(value[key]));
function $216d2bdc6f281bf6$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $8d27ca75da600b9c$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $8d27ca75da600b9c$export$a93c5207d687da10)(value) || $216d2bdc6f281bf6$var$hasFunction(value)) || indexable && (0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $216d2bdc6f281bf6$var$version = "4.4.2";
const $216d2bdc6f281bf6$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $216d2bdc6f281bf6$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $216d2bdc6f281bf6$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $216d2bdc6f281bf6$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $216d2bdc6f281bf6$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $216d2bdc6f281bf6$var$getCanvas(item) {
    if ((0, $8d27ca75da600b9c$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $216d2bdc6f281bf6$var$instances = {};
const $216d2bdc6f281bf6$var$getChart = (key)=>{
    const canvas = $216d2bdc6f281bf6$var$getCanvas(key);
    return Object.values($216d2bdc6f281bf6$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $216d2bdc6f281bf6$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $216d2bdc6f281bf6$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
function $216d2bdc6f281bf6$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $216d2bdc6f281bf6$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $216d2bdc6f281bf6$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $216d2bdc6f281bf6$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $216d2bdc6f281bf6$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $216d2bdc6f281bf6$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
class $216d2bdc6f281bf6$export$acaa6426d77a227e {
    static defaults = (0, $8d27ca75da600b9c$export$4368d992c4eafac0);
    static instances = $216d2bdc6f281bf6$var$instances;
    static overrides = (0, $8d27ca75da600b9c$export$6559d589eb85fbb6);
    static registry = $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    static version = $216d2bdc6f281bf6$var$version;
    static getChart = $216d2bdc6f281bf6$var$getChart;
    static register(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.add(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    static unregister(...items) {
        $216d2bdc6f281bf6$export$4bb7493d241fd8a5.remove(...items);
        $216d2bdc6f281bf6$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $216d2bdc6f281bf6$var$Config(userConfig);
        const initialCanvas = $216d2bdc6f281bf6$var$getCanvas(item);
        const existingChart = $216d2bdc6f281bf6$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $216d2bdc6f281bf6$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $8d27ca75da600b9c$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $216d2bdc6f281bf6$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $8d27ca75da600b9c$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $216d2bdc6f281bf6$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'complete', $216d2bdc6f281bf6$var$onAnimationsComplete);
        $216d2bdc6f281bf6$export$a424a0aa8f687495.listen(this, 'progress', $216d2bdc6f281bf6$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $216d2bdc6f281bf6$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $8d27ca75da600b9c$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $8d27ca75da600b9c$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $216d2bdc6f281bf6$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $8d27ca75da600b9c$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $8d27ca75da600b9c$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $8d27ca75da600b9c$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $216d2bdc6f281bf6$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $216d2bdc6f281bf6$var$positionIsHorizontal(scaleOptions.position, axis) !== $216d2bdc6f281bf6$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $8d27ca75da600b9c$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $8d27ca75da600b9c$export$d66501df72047452)(scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($216d2bdc6f281bf6$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $216d2bdc6f281bf6$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $8d27ca75da600b9c$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $216d2bdc6f281bf6$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $8d27ca75da600b9c$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($216d2bdc6f281bf6$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this.scales, (scale)=>{
            $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $8d27ca75da600b9c$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $216d2bdc6f281bf6$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $8d27ca75da600b9c$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $8d27ca75da600b9c$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($216d2bdc6f281bf6$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$216d2bdc6f281bf6$export$a424a0aa8f687495.running(this)) $216d2bdc6f281bf6$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $216d2bdc6f281bf6$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $216d2bdc6f281bf6$var$getDatasetArea(meta, this.chartArea);
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (useClip) (0, $8d27ca75da600b9c$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $8d27ca75da600b9c$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $8d27ca75da600b9c$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $216d2bdc6f281bf6$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $8d27ca75da600b9c$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $8d27ca75da600b9c$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $216d2bdc6f281bf6$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $8d27ca75da600b9c$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $216d2bdc6f281bf6$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $8d27ca75da600b9c$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $8d27ca75da600b9c$export$f38c853ae54ed474)(e);
        const lastEvent = $216d2bdc6f281bf6$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $8d27ca75da600b9c$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $216d2bdc6f281bf6$var$invalidatePlugins() {
    return (0, $8d27ca75da600b9c$export$d66501df72047452)($216d2bdc6f281bf6$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd), startAngle - (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$toRadiusCorners(value) {
    return (0, $8d27ca75da600b9c$export$21579262ef46735b)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $216d2bdc6f281bf6$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $216d2bdc6f281bf6$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $216d2bdc6f281bf6$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $8d27ca75da600b9c$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $216d2bdc6f281bf6$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $216d2bdc6f281bf6$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $216d2bdc6f281bf6$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $8d27ca75da600b9c$export$971d5caa766a69d7) || (0, $8d27ca75da600b9c$export$971d5caa766a69d7));
    }
    $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $216d2bdc6f281bf6$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $8d27ca75da600b9c$export$971d5caa766a69d7) || (0, $8d27ca75da600b9c$export$971d5caa766a69d7));
    }
    if (inner) $216d2bdc6f281bf6$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $216d2bdc6f281bf6$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $216d2bdc6f281bf6$export$d48203c759d6a1fc extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $8d27ca75da600b9c$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $8d27ca75da600b9c$export$971d5caa766a69d7) || (0, $8d27ca75da600b9c$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $8d27ca75da600b9c$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $8d27ca75da600b9c$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $8d27ca75da600b9c$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $8d27ca75da600b9c$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $216d2bdc6f281bf6$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $216d2bdc6f281bf6$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $8d27ca75da600b9c$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $216d2bdc6f281bf6$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $216d2bdc6f281bf6$var$getLineMethod(options) {
    if (options.stepped) return 0, $8d27ca75da600b9c$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $8d27ca75da600b9c$export$6554612db691658e;
    return $216d2bdc6f281bf6$var$lineTo;
}
function $216d2bdc6f281bf6$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $216d2bdc6f281bf6$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const lineMethod = $216d2bdc6f281bf6$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $216d2bdc6f281bf6$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $216d2bdc6f281bf6$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $216d2bdc6f281bf6$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $216d2bdc6f281bf6$var$fastPathSegment : $216d2bdc6f281bf6$var$pathSegment;
}
function $216d2bdc6f281bf6$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $8d27ca75da600b9c$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $8d27ca75da600b9c$export$2f6ca3d3b1f80bf5;
    return 0, $8d27ca75da600b9c$export$8a5498727ef6be21;
}
function $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $216d2bdc6f281bf6$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(line);
    for (const segment of segments){
        $216d2bdc6f281bf6$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $216d2bdc6f281bf6$var$usePath2D = typeof Path2D === 'function';
function $216d2bdc6f281bf6$var$draw(ctx, line, start, count) {
    if ($216d2bdc6f281bf6$var$usePath2D && !line.options.segment) $216d2bdc6f281bf6$var$strokePathWithCache(ctx, line, start, count);
    else $216d2bdc6f281bf6$var$strokePathDirect(ctx, line, start, count);
}
class $216d2bdc6f281bf6$export$55e463fa7bcd3469 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $8d27ca75da600b9c$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $8d27ca75da600b9c$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $8d27ca75da600b9c$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $216d2bdc6f281bf6$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $216d2bdc6f281bf6$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $216d2bdc6f281bf6$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $216d2bdc6f281bf6$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $216d2bdc6f281bf6$export$bd159b522b230b7a extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $8d27ca75da600b9c$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $8d27ca75da600b9c$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $216d2bdc6f281bf6$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(value, min, max);
}
function $216d2bdc6f281bf6$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $8d27ca75da600b9c$export$d66dc83d8cfc8dd)(value);
    return {
        t: $216d2bdc6f281bf6$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $216d2bdc6f281bf6$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $216d2bdc6f281bf6$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $216d2bdc6f281bf6$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $216d2bdc6f281bf6$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $216d2bdc6f281bf6$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $216d2bdc6f281bf6$var$boundingRects(bar) {
    const bounds = $216d2bdc6f281bf6$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $216d2bdc6f281bf6$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $216d2bdc6f281bf6$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $216d2bdc6f281bf6$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $216d2bdc6f281bf6$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $8d27ca75da600b9c$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $8d27ca75da600b9c$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $216d2bdc6f281bf6$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $216d2bdc6f281bf6$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $216d2bdc6f281bf6$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $216d2bdc6f281bf6$export$a16ed71bf4b07672 extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $216d2bdc6f281bf6$var$boundingRects(this);
        const addRectPath = $216d2bdc6f281bf6$var$hasRadius(outer.radius) ? (0, $8d27ca75da600b9c$export$1fbe638ecf81657e) : $216d2bdc6f281bf6$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $216d2bdc6f281bf6$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $216d2bdc6f281bf6$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $216d2bdc6f281bf6$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $216d2bdc6f281bf6$export$d48203c759d6a1fc,
    BarElement: $216d2bdc6f281bf6$export$a16ed71bf4b07672,
    LineElement: $216d2bdc6f281bf6$export$55e463fa7bcd3469,
    PointElement: $216d2bdc6f281bf6$export$bd159b522b230b7a
});
const $216d2bdc6f281bf6$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $216d2bdc6f281bf6$var$BACKGROUND_COLORS = /* #__PURE__ */ $216d2bdc6f281bf6$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $216d2bdc6f281bf6$var$getBorderColor(i) {
    return $216d2bdc6f281bf6$var$BORDER_COLORS[i % $216d2bdc6f281bf6$var$BORDER_COLORS.length];
}
function $216d2bdc6f281bf6$var$getBackgroundColor(i) {
    return $216d2bdc6f281bf6$var$BACKGROUND_COLORS[i % $216d2bdc6f281bf6$var$BACKGROUND_COLORS.length];
}
function $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $216d2bdc6f281bf6$var$getBorderColor(i);
    dataset.backgroundColor = $216d2bdc6f281bf6$var$getBackgroundColor(i);
    return ++i;
}
function $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBorderColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$216d2bdc6f281bf6$var$getBackgroundColor(i++));
    return i;
}
function $216d2bdc6f281bf6$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $216d2bdc6f281bf6$export$e04603e7d8b77172) i = $216d2bdc6f281bf6$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $216d2bdc6f281bf6$export$2a270b3a0d973c85) i = $216d2bdc6f281bf6$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $216d2bdc6f281bf6$var$colorizeDefaultDataset(dataset, i);
    };
}
function $216d2bdc6f281bf6$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $216d2bdc6f281bf6$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $216d2bdc6f281bf6$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        if (!options.forceOverride && ($216d2bdc6f281bf6$var$containsColorsDefinitions(datasets) || $216d2bdc6f281bf6$var$containsColorsDefinition(chartOptions) || elements && $216d2bdc6f281bf6$var$containsColorsDefinitions(elements))) return;
        const colorizer = $216d2bdc6f281bf6$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(minIndex) && !(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $216d2bdc6f281bf6$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
    });
}
function $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $8d27ca75da600b9c$export$25ce5a424b770e84)((0, $8d27ca75da600b9c$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $8d27ca75da600b9c$export$25ce5a424b770e84)((0, $8d27ca75da600b9c$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $216d2bdc6f281bf6$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $8d27ca75da600b9c$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $216d2bdc6f281bf6$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $216d2bdc6f281bf6$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $216d2bdc6f281bf6$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $216d2bdc6f281bf6$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $216d2bdc6f281bf6$var$cleanDecimatedData(chart);
    }
};
function $216d2bdc6f281bf6$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points);
        const bounds = $216d2bdc6f281bf6$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $8d27ca75da600b9c$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $216d2bdc6f281bf6$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $8d27ca75da600b9c$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $216d2bdc6f281bf6$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $216d2bdc6f281bf6$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $8d27ca75da600b9c$export$28f7fcd39efa255)(start);
        end = (0, $8d27ca75da600b9c$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $216d2bdc6f281bf6$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $216d2bdc6f281bf6$var$_pointsFromSegments(boundary, line);
    return points.length ? new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $216d2bdc6f281bf6$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $216d2bdc6f281bf6$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $8d27ca75da600b9c$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $216d2bdc6f281bf6$var$_decodeFill(line, index, count) {
    const fill = $216d2bdc6f281bf6$var$parseFillOption(line);
    if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $8d27ca75da600b9c$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $216d2bdc6f281bf6$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $216d2bdc6f281bf6$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $216d2bdc6f281bf6$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $216d2bdc6f281bf6$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $216d2bdc6f281bf6$var$getLinesBelow(scale, index);
    linesBelow.push($216d2bdc6f281bf6$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $216d2bdc6f281bf6$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $216d2bdc6f281bf6$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $216d2bdc6f281bf6$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $216d2bdc6f281bf6$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $8d27ca75da600b9c$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $216d2bdc6f281bf6$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $8d27ca75da600b9c$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $216d2bdc6f281bf6$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $8d27ca75da600b9c$export$39b482c5e57630a8)(fill)) return $216d2bdc6f281bf6$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $216d2bdc6f281bf6$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $216d2bdc6f281bf6$var$computeBoundary(source);
    if (boundary instanceof $216d2bdc6f281bf6$var$simpleArc) return boundary;
    return $216d2bdc6f281bf6$var$_createBoundaryLine(boundary, line);
}
function $216d2bdc6f281bf6$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $216d2bdc6f281bf6$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $216d2bdc6f281bf6$var$computeCircularBoundary(source);
    return $216d2bdc6f281bf6$var$computeLinearBoundary(source);
}
function $216d2bdc6f281bf6$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $216d2bdc6f281bf6$var$_getTargetPixel(fill, scale);
    if ((0, $8d27ca75da600b9c$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $216d2bdc6f281bf6$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $216d2bdc6f281bf6$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $216d2bdc6f281bf6$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $216d2bdc6f281bf6$var$_drawfill(ctx, source, area) {
    const target = $216d2bdc6f281bf6$var$_getTarget(source);
    const { line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    if (target && line.points.length) {
        (0, $8d27ca75da600b9c$export$8743009a87fcb00f)(ctx, area);
        $216d2bdc6f281bf6$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $8d27ca75da600b9c$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $216d2bdc6f281bf6$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    if (property === 'x' && below !== above) {
        $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.top);
        $216d2bdc6f281bf6$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $216d2bdc6f281bf6$var$clipVertical(ctx, target, area.bottom);
    }
    $216d2bdc6f281bf6$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $216d2bdc6f281bf6$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$216d2bdc6f281bf6$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $216d2bdc6f281bf6$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale } = cfg;
    const segments = $216d2bdc6f281bf6$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $216d2bdc6f281bf6$var$clipBounds(ctx, scale, notShape && $216d2bdc6f281bf6$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $216d2bdc6f281bf6$var$clipBounds(ctx, scale, bounds) {
    const { top: top, bottom: bottom } = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x') {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $216d2bdc6f281bf6$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $216d2bdc6f281bf6$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $216d2bdc6f281bf6$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $216d2bdc6f281bf6$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $216d2bdc6f281bf6$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($216d2bdc6f281bf6$var$_shouldApplyFill(source)) $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$216d2bdc6f281bf6$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $216d2bdc6f281bf6$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $216d2bdc6f281bf6$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $216d2bdc6f281bf6$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $216d2bdc6f281bf6$var$Legend extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $8d27ca75da600b9c$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $8d27ca75da600b9c$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $8d27ca75da600b9c$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $8d27ca75da600b9c$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $8d27ca75da600b9c$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $216d2bdc6f281bf6$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $8d27ca75da600b9c$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $8d27ca75da600b9c$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $8d27ca75da600b9c$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $8d27ca75da600b9c$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $8d27ca75da600b9c$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $8d27ca75da600b9c$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $8d27ca75da600b9c$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $8d27ca75da600b9c$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $8d27ca75da600b9c$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $8d27ca75da600b9c$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $8d27ca75da600b9c$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $8d27ca75da600b9c$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$216d2bdc6f281bf6$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $216d2bdc6f281bf6$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $216d2bdc6f281bf6$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $216d2bdc6f281bf6$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $216d2bdc6f281bf6$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $216d2bdc6f281bf6$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $216d2bdc6f281bf6$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $216d2bdc6f281bf6$export$ed247974535929c7 = {
    id: 'legend',
    _element: $216d2bdc6f281bf6$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $216d2bdc6f281bf6$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $216d2bdc6f281bf6$var$Title extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $8d27ca75da600b9c$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $8d27ca75da600b9c$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $8d27ca75da600b9c$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $8d27ca75da600b9c$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $8d27ca75da600b9c$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $8d27ca75da600b9c$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $216d2bdc6f281bf6$var$createTitle(chart, titleOpts) {
    const title = new $216d2bdc6f281bf6$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $216d2bdc6f281bf6$export$f99233281efd08a0 = {
    id: 'title',
    _element: $216d2bdc6f281bf6$var$Title,
    start (chart, _args, options) {
        $216d2bdc6f281bf6$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$map = new WeakMap();
var $216d2bdc6f281bf6$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $216d2bdc6f281bf6$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.addBox(chart, title);
        $216d2bdc6f281bf6$var$map.set(chart, title);
    },
    stop (chart) {
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.removeBox(chart, $216d2bdc6f281bf6$var$map.get(chart));
        $216d2bdc6f281bf6$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $216d2bdc6f281bf6$var$map.get(chart);
        $216d2bdc6f281bf6$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $216d2bdc6f281bf6$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $8d27ca75da600b9c$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $216d2bdc6f281bf6$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $216d2bdc6f281bf6$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $216d2bdc6f281bf6$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $216d2bdc6f281bf6$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $8d27ca75da600b9c$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $8d27ca75da600b9c$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $8d27ca75da600b9c$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $216d2bdc6f281bf6$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($216d2bdc6f281bf6$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $216d2bdc6f281bf6$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $216d2bdc6f281bf6$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $216d2bdc6f281bf6$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $216d2bdc6f281bf6$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $216d2bdc6f281bf6$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(cornerRadius);
    let x = $216d2bdc6f281bf6$var$alignX(size, xAlign);
    const y = $216d2bdc6f281bf6$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $216d2bdc6f281bf6$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $216d2bdc6f281bf6$var$getBeforeAfterBodyLines(callback) {
    return $216d2bdc6f281bf6$var$pushOrConcat([], $216d2bdc6f281bf6$var$splitNewlines(callback));
}
function $216d2bdc6f281bf6$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $8d27ca75da600b9c$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $216d2bdc6f281bf6$var$defaultCallbacks = {
    beforeTitle: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    beforeBody: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    beforeLabel: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    afterBody: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    beforeFooter: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    footer: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46),
    afterFooter: (0, $8d27ca75da600b9c$export$cf2f7c5792f80b46)
};
function $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $216d2bdc6f281bf6$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $216d2bdc6f281bf6$var$Tooltip extends $216d2bdc6f281bf6$export$db77ccec0bb4ccac {
    static positioners = $216d2bdc6f281bf6$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $216d2bdc6f281bf6$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $216d2bdc6f281bf6$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeTitle));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(title));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $8d27ca75da600b9c$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(callbacks, context);
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.before, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.lines, $216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $216d2bdc6f281bf6$var$pushOrConcat(bodyItem.after, $216d2bdc6f281bf6$var$splitNewlines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $216d2bdc6f281bf6$var$getBeforeAfterBodyLines($216d2bdc6f281bf6$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $216d2bdc6f281bf6$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(beforeFooter));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(footer));
        lines = $216d2bdc6f281bf6$var$pushOrConcat(lines, $216d2bdc6f281bf6$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($216d2bdc6f281bf6$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $8d27ca75da600b9c$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $216d2bdc6f281bf6$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($216d2bdc6f281bf6$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $8d27ca75da600b9c$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.bodyFont);
        const colorX = $216d2bdc6f281bf6$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $8d27ca75da600b9c$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $8d27ca75da600b9c$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $8d27ca75da600b9c$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $8d27ca75da600b9c$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $8d27ca75da600b9c$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $8d27ca75da600b9c$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $8d27ca75da600b9c$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $8d27ca75da600b9c$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $8d27ca75da600b9c$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $8d27ca75da600b9c$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $216d2bdc6f281bf6$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $216d2bdc6f281bf6$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $216d2bdc6f281bf6$var$determineAlignment(chart, options, positionAndSize);
            const point = $216d2bdc6f281bf6$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $8d27ca75da600b9c$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $8d27ca75da600b9c$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $8d27ca75da600b9c$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $8d27ca75da600b9c$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $216d2bdc6f281bf6$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $216d2bdc6f281bf6$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $216d2bdc6f281bf6$var$Tooltip,
    positioners: $216d2bdc6f281bf6$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $216d2bdc6f281bf6$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $216d2bdc6f281bf6$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $216d2bdc6f281bf6$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $216d2bdc6f281bf6$export$c537fa0d021d010b,
    Decimation: $216d2bdc6f281bf6$export$be17f937e9aa7533,
    Filler: $216d2bdc6f281bf6$export$d19ba4d812bed757,
    Legend: $216d2bdc6f281bf6$export$ed247974535929c7,
    SubTitle: $216d2bdc6f281bf6$export$d5c56664638992a4,
    Title: $216d2bdc6f281bf6$export$f99233281efd08a0,
    Tooltip: $216d2bdc6f281bf6$export$28c660c63b792dea
});
const $216d2bdc6f281bf6$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $216d2bdc6f281bf6$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $216d2bdc6f281bf6$var$validIndex = (index, max)=>index === null ? null : (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $216d2bdc6f281bf6$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $216d2bdc6f281bf6$export$29e663ba4d09fe7 extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $216d2bdc6f281bf6$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $216d2bdc6f281bf6$var$findOrAddLabel(labels, raw, (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $216d2bdc6f281bf6$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $216d2bdc6f281bf6$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $216d2bdc6f281bf6$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $8d27ca75da600b9c$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $8d27ca75da600b9c$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $8d27ca75da600b9c$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $8d27ca75da600b9c$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $8d27ca75da600b9c$export$23ebac1979863676)(spacing), (0, $8d27ca75da600b9c$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $8d27ca75da600b9c$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $8d27ca75da600b9c$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $216d2bdc6f281bf6$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $8d27ca75da600b9c$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $216d2bdc6f281bf6$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $216d2bdc6f281bf6$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $216d2bdc6f281bf6$var$LinearScaleBase extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $216d2bdc6f281bf6$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $8d27ca75da600b9c$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $8d27ca75da600b9c$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $216d2bdc6f281bf6$export$e7f4e5e8656f0b93 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $8d27ca75da600b9c$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $216d2bdc6f281bf6$var$log10Floor = (v)=>Math.floor((0, $8d27ca75da600b9c$export$9f4f30ee63539e24)(v));
const $216d2bdc6f281bf6$var$changeExponent = (v, m)=>Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(v) + m);
function $216d2bdc6f281bf6$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $216d2bdc6f281bf6$var$log10Floor(tickVal));
    return remain === 1;
}
function $216d2bdc6f281bf6$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $216d2bdc6f281bf6$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $216d2bdc6f281bf6$var$log10Floor(range);
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($216d2bdc6f281bf6$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $216d2bdc6f281bf6$var$log10Floor(min));
}
function $216d2bdc6f281bf6$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $216d2bdc6f281bf6$var$log10Floor(min);
    let exp = $216d2bdc6f281bf6$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $216d2bdc6f281bf6$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $8d27ca75da600b9c$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $216d2bdc6f281bf6$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $216d2bdc6f281bf6$export$85295eaf7cb3ac3e extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $8d27ca75da600b9c$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $216d2bdc6f281bf6$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $8d27ca75da600b9c$export$39b482c5e57630a8)(this._userMin)) this.min = min === $216d2bdc6f281bf6$var$changeExponent(this.min, 0) ? $216d2bdc6f281bf6$var$changeExponent(this.min, -1) : $216d2bdc6f281bf6$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($216d2bdc6f281bf6$var$changeExponent(min, -1));
                setMax($216d2bdc6f281bf6$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($216d2bdc6f281bf6$var$changeExponent(max, -1));
        if (max <= 0) setMax($216d2bdc6f281bf6$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $216d2bdc6f281bf6$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $8d27ca75da600b9c$export$53a70dd1ebbae346)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $8d27ca75da600b9c$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $8d27ca75da600b9c$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $8d27ca75da600b9c$export$9f4f30ee63539e24)(this.max) - (0, $8d27ca75da600b9c$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $8d27ca75da600b9c$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $8d27ca75da600b9c$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $216d2bdc6f281bf6$var$measureLabelSize(ctx, font, label) {
    label = (0, $8d27ca75da600b9c$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $8d27ca75da600b9c$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $216d2bdc6f281bf6$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $216d2bdc6f281bf6$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $8d27ca75da600b9c$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(opts.font);
        const textSize = $216d2bdc6f281bf6$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $8d27ca75da600b9c$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $8d27ca75da600b9c$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $216d2bdc6f281bf6$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $216d2bdc6f281bf6$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $216d2bdc6f281bf6$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $216d2bdc6f281bf6$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $8d27ca75da600b9c$export$3a6d5c9ae78a2c08)((0, $8d27ca75da600b9c$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd))));
    const y = $216d2bdc6f281bf6$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $216d2bdc6f281bf6$var$getTextAlignForAngle(angle);
    const left = $216d2bdc6f281bf6$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $216d2bdc6f281bf6$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $8d27ca75da600b9c$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $8d27ca75da600b9c$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $8d27ca75da600b9c$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $8d27ca75da600b9c$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $216d2bdc6f281bf6$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $216d2bdc6f281bf6$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $8d27ca75da600b9c$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $216d2bdc6f281bf6$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $216d2bdc6f281bf6$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $216d2bdc6f281bf6$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $216d2bdc6f281bf6$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $216d2bdc6f281bf6$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $8d27ca75da600b9c$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $8d27ca75da600b9c$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $8d27ca75da600b9c$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $216d2bdc6f281bf6$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $216d2bdc6f281bf6$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $8d27ca75da600b9c$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $216d2bdc6f281bf6$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $216d2bdc6f281bf6$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $216d2bdc6f281bf6$var$createPointLabelContext(parent, index, label) {
    return (0, $8d27ca75da600b9c$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $216d2bdc6f281bf6$export$cfafc36d95386d38 extends $216d2bdc6f281bf6$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $8d27ca75da600b9c$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)($216d2bdc6f281bf6$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $216d2bdc6f281bf6$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $216d2bdc6f281bf6$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $216d2bdc6f281bf6$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $8d27ca75da600b9c$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $8d27ca75da600b9c$export$28f7fcd39efa255)(index * angleMultiplier + (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $216d2bdc6f281bf6$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $8d27ca75da600b9c$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $216d2bdc6f281bf6$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $216d2bdc6f281bf6$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $216d2bdc6f281bf6$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $8d27ca75da600b9c$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $8d27ca75da600b9c$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $8d27ca75da600b9c$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $216d2bdc6f281bf6$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $216d2bdc6f281bf6$var$UNITS = /* #__PURE__ */ Object.keys($216d2bdc6f281bf6$var$INTERVALS);
function $216d2bdc6f281bf6$var$sorter(a, b) {
    return a - b;
}
function $216d2bdc6f281bf6$var$parse(scale, input) {
    if ((0, $8d27ca75da600b9c$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $8d27ca75da600b9c$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $8d27ca75da600b9c$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $216d2bdc6f281bf6$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $216d2bdc6f281bf6$var$UNITS.length;
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $216d2bdc6f281bf6$var$UNITS[i];
    }
    return $216d2bdc6f281bf6$var$UNITS[ilen - 1];
}
function $216d2bdc6f281bf6$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.length - 1; i >= $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit); i--){
        const unit = $216d2bdc6f281bf6$var$UNITS[i];
        if ($216d2bdc6f281bf6$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $216d2bdc6f281bf6$var$UNITS[minUnit ? $216d2bdc6f281bf6$var$UNITS.indexOf(minUnit) : 0];
}
function $216d2bdc6f281bf6$var$determineMajorUnit(unit) {
    for(let i = $216d2bdc6f281bf6$var$UNITS.indexOf(unit) + 1, ilen = $216d2bdc6f281bf6$var$UNITS.length; i < ilen; ++i){
        if ($216d2bdc6f281bf6$var$INTERVALS[$216d2bdc6f281bf6$var$UNITS[i]].common) return $216d2bdc6f281bf6$var$UNITS[i];
    }
}
function $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $8d27ca75da600b9c$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $216d2bdc6f281bf6$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $216d2bdc6f281bf6$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $216d2bdc6f281bf6$export$a894c72689ff3ec extends $216d2bdc6f281bf6$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $216d2bdc6f281bf6$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $8d27ca75da600b9c$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $216d2bdc6f281bf6$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $8d27ca75da600b9c$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $8d27ca75da600b9c$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $216d2bdc6f281bf6$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $216d2bdc6f281bf6$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $216d2bdc6f281bf6$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $8d27ca75da600b9c$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $216d2bdc6f281bf6$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $8d27ca75da600b9c$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $216d2bdc6f281bf6$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($216d2bdc6f281bf6$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $8d27ca75da600b9c$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $216d2bdc6f281bf6$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($216d2bdc6f281bf6$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $8d27ca75da600b9c$export$71511d61b312f219)(values.sort($216d2bdc6f281bf6$var$sorter));
    }
}
function $216d2bdc6f281bf6$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $8d27ca75da600b9c$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $8d27ca75da600b9c$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $216d2bdc6f281bf6$export$85df64a8eb6dc986 extends $216d2bdc6f281bf6$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $216d2bdc6f281bf6$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $216d2bdc6f281bf6$var$interpolate(table, this.min);
        this._tableRange = $216d2bdc6f281bf6$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($216d2bdc6f281bf6$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $216d2bdc6f281bf6$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $216d2bdc6f281bf6$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $216d2bdc6f281bf6$export$29e663ba4d09fe7,
    LinearScale: $216d2bdc6f281bf6$export$e7f4e5e8656f0b93,
    LogarithmicScale: $216d2bdc6f281bf6$export$85295eaf7cb3ac3e,
    RadialLinearScale: $216d2bdc6f281bf6$export$cfafc36d95386d38,
    TimeScale: $216d2bdc6f281bf6$export$a894c72689ff3ec,
    TimeSeriesScale: $216d2bdc6f281bf6$export$85df64a8eb6dc986
});
const $216d2bdc6f281bf6$export$e8959e79e3af550f = [
    $216d2bdc6f281bf6$export$a6506504f799c5d5,
    $216d2bdc6f281bf6$export$7a5d735b2ab6389d,
    $216d2bdc6f281bf6$export$8b3ca321c77fdea6,
    $216d2bdc6f281bf6$export$bcac1c16f1530ec2
];



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
function $fe769d98421e6dac$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}


var $b0a93f4c47fccf6f$export$2e2bcd8739ae039 = (0, $fe769d98421e6dac$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");



var $f1q41 = parcelRequire("f1q41");

var $eOilY = parcelRequire("eOilY");

var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $OEVqP = parcelRequire("OEVqP");
var $2iAqv = parcelRequire("2iAqv");
var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $kVqvD = parcelRequire("kVqvD");
parcelRequire("acw62");

parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $03c2199a765ab5af$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("acw62");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $e413843d0810bb75$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6d9735fee3c00fe1$var$RadioButtonIconRoot = (0, $d8seH.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $8Uq77.default)
})({
    position: 'relative',
    display: 'flex'
});
const $6d9735fee3c00fe1$var$RadioButtonIconBackground = (0, $d8seH.default)((0, $03c2199a765ab5af$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $6d9735fee3c00fe1$var$RadioButtonIconDot = (0, $d8seH.default)((0, $e413843d0810bb75$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})((0, $aeD7H.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $6d9735fee3c00fe1$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6d9735fee3c00fe1$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6d9735fee3c00fe1$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $6d9735fee3c00fe1$export$2e2bcd8739ae039 = $6d9735fee3c00fe1$var$RadioButtonIcon;



var $jTnBY = parcelRequire("jTnBY");

var $hPGQj = parcelRequire("hPGQj");
var $3d47321b9fcbcb38$export$2e2bcd8739ae039 = (0, $hPGQj.default);



var $cJQfW = parcelRequire("cJQfW");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $f9f6bb9b992d33b5$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $f9f6bb9b992d33b5$export$2e2bcd8739ae039 = $f9f6bb9b992d33b5$var$RadioGroupContext;


'use client';
function $e9140607eee18105$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039));
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d9d692e9561f6352$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $beCSm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$export$2e2bcd8739ae039 = $d9d692e9561f6352$var$radioClasses;



var $8Uq77 = parcelRequire("8Uq77");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $6lpak = parcelRequire("6lpak");

var $1iOpW = parcelRequire("1iOpW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $cb3af4fea2cad44e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $jTnBY.default)(color)}`,
            size !== 'medium' && `size${(0, $jTnBY.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $8Indx.default)(slots, (0, $d9d692e9561f6352$export$192f7b2363c77155), classes)
    };
};
const $cb3af4fea2cad44e$var$RadioRoot = (0, $d8seH.default)((0, $kVqvD.default), {
    shouldForwardProp: (prop)=>(0, $8Uq77.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $d9d692e9561f6352$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $cb3af4fea2cad44e$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $cb3af4fea2cad44e$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {
    checked: true
});
const $cb3af4fea2cad44e$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d9735fee3c00fe1$export$2e2bcd8739ae039), {});
const $cb3af4fea2cad44e$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $cb3af4fea2cad44e$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $cb3af4fea2cad44e$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $cb3af4fea2cad44e$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $e9140607eee18105$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $3d47321b9fcbcb38$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $cb3af4fea2cad44e$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        ref: ref,
        elementType: $cb3af4fea2cad44e$var$RadioRoot,
        className: (0, $5FMfE.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $cb3af4fea2cad44e$export$2e2bcd8739ae039 = $cb3af4fea2cad44e$var$Radio;


var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $de580948e3d734b1$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $de580948e3d734b1$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $de580948e3d734b1$export$2e2bcd8739ae039 = $de580948e3d734b1$var$formGroupClasses;



var $cJQfW = parcelRequire("cJQfW");

var $aaphR = parcelRequire("aaphR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5042f159189dda87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $de580948e3d734b1$export$d72d4cbdc30b331f), classes);
};
const $5042f159189dda87$var$FormGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $5042f159189dda87$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $cJQfW.default)();
    const fcs = (0, $aaphR.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $5042f159189dda87$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5042f159189dda87$var$FormGroupRoot, {
        className: (0, $5FMfE.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $5042f159189dda87$export$2e2bcd8739ae039 = $5042f159189dda87$var$FormGroup;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $c550ce5d3f5617f8$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)('MuiRadioGroup', slot);
}
const $c550ce5d3f5617f8$var$radioGroupClasses = (0, $beCSm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $c550ce5d3f5617f8$export$2e2bcd8739ae039 = $c550ce5d3f5617f8$var$radioGroupClasses;



var $9Rgf1 = parcelRequire("9Rgf1");

var $3yddg = parcelRequire("3yddg");


var $5A6d3 = parcelRequire("5A6d3");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $659f9ff12b4e3755$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c550ce5d3f5617f8$export$c4cff3a43f7cabb6), classes);
};
const $659f9ff12b4e3755$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $acw62.useRef(null);
    const classes = $659f9ff12b4e3755$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $3yddg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $9Rgf1.default)(ref, rootRef);
    const name = (0, $5A6d3.default)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f9f6bb9b992d33b5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5042f159189dda87$export$2e2bcd8739ae039), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $5FMfE.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $659f9ff12b4e3755$export$2e2bcd8739ae039 = $659f9ff12b4e3755$var$RadioGroup;


var $cX7V2 = parcelRequire("cX7V2");
var $iAtns = parcelRequire("iAtns");

var $5xexf = parcelRequire("5xexf");

var $6lXkL = parcelRequire("6lXkL");


/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */ 



var $4LmDH = parcelRequire("4LmDH");
var $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE = 60000;
function $8a9f3e7be35784f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, amount * $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE);
}




var $4LmDH = parcelRequire("4LmDH");
function $e8f3df7678d5e716$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    var months = amount * 3;
    return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(dirtyDate, months);
}




var $4LmDH = parcelRequire("4LmDH");
function $30a94a667184fb38$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, amount * 1000);
}




var $4LmDH = parcelRequire("4LmDH");
function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $4f754377033842c6$export$2e2bcd8739ae039)(dirtyDate, days);
}


var $gdr0J = parcelRequire("gdr0J");

var $9vfYB = parcelRequire("9vfYB");


var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9vfYB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9vfYB.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}



var $4LmDH = parcelRequire("4LmDH");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}
function $5e650688c0910592$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var sign = $5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $f8bd67cac91ee19b$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($5e650688c0910592$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
    return result === 0 ? 0 : result;
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4faa9cd956e257dc$export$dfd9b671c89acc8e = 7;
var $4faa9cd956e257dc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4faa9cd956e257dc$export$91246f0b9bd9beff = 60000;
var $4faa9cd956e257dc$export$7f72910d6dfd237a = 3600000;
var $4faa9cd956e257dc$export$397c2d5776aa9055 = 1000;
var $4faa9cd956e257dc$export$4dec998e48f9c246 = -$4faa9cd956e257dc$export$81caae6e1cc7a622;
var $4faa9cd956e257dc$export$f2f5ae5a8e2d8f9f = 60;
var $4faa9cd956e257dc$export$3c58128db900d44e = 3;
var $4faa9cd956e257dc$export$80d7e435f744f319 = 12;
var $4faa9cd956e257dc$export$4db7641526e3241f = 4;
var $4faa9cd956e257dc$export$698aec755e92c695 = 3600;
var $4faa9cd956e257dc$export$a77c1a7ebebe2a5a = 60;



var $bFuWZ = parcelRequire("bFuWZ");

var $4LmDH = parcelRequire("4LmDH");

var $hbRD3 = parcelRequire("hbRD3");
function $bc23742ab6e4a898$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $bFuWZ.default)(dateLeft, dateRight) / (0, $4faa9cd956e257dc$export$7f72910d6dfd237a);
    return (0, $hbRD3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $bFuWZ = parcelRequire("bFuWZ");

var $bFuWZ = parcelRequire("bFuWZ");

var $4LmDH = parcelRequire("4LmDH");

var $hbRD3 = parcelRequire("hbRD3");
function $c13bbb54037e7269$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $bFuWZ.default)(dateLeft, dateRight) / (0, $4faa9cd956e257dc$export$91246f0b9bd9beff);
    return (0, $hbRD3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $3Umsa = parcelRequire("3Umsa");
var $3Umsa = parcelRequire("3Umsa");

var $4LmDH = parcelRequire("4LmDH");

var $hbRD3 = parcelRequire("hbRD3");
function $1672b99dd1850a2d$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $3Umsa.default)(dateLeft, dateRight) / 3;
    return (0, $hbRD3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $8xDhD = parcelRequire("8xDhD");

var $4LmDH = parcelRequire("4LmDH");

var $hbRD3 = parcelRequire("hbRD3");
function $dfaafc43dccafd3d$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var diff = (0, $5e650688c0910592$export$2e2bcd8739ae039)(dateLeft, dateRight) / 7;
    return (0, $hbRD3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $gdr0J = parcelRequire("gdr0J");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $e66021df2494c23e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}



var $bQPWp = parcelRequire("bQPWp");

var $4LmDH = parcelRequire("4LmDH");
function $3ff7ac235dc3be01$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var sign = (0, $bQPWp.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $e66021df2494c23e$export$2e2bcd8739ae039)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $bQPWp.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero
    return result === 0 ? 0 : result;
}


var $6uyHy = parcelRequire("6uyHy");
var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $17aca8a6c8bc25fd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setSeconds(59, 999);
    return date;
}


var $l2vHo = parcelRequire("l2vHo");
var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9195d3fb013f21bf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8d858ac4063064f9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setMilliseconds(999);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");


var $4LmDH = parcelRequire("4LmDH");
function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5a7a122bf592ddcb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}


var $4LmDH = parcelRequire("4LmDH");
function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $4LmDH.default)(1, arguments);
    return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}



var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    if (!(0, $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $gdr0J.default)(dirtyDate);
    return !isNaN(Number(date));
}



var $15nwl = parcelRequire("15nwl");



var $4LmDH = parcelRequire("4LmDH");
function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



var $gdr0J = parcelRequire("gdr0J");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}



var $gdr0J = parcelRequire("gdr0J");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}



var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




var $4LmDH = parcelRequire("4LmDH");
function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $4LmDH = parcelRequire("4LmDH");
var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(date).getTime() - (0, $4e98b4d5a2488885$export$2e2bcd8739ae039)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}




var $gdr0J = parcelRequire("gdr0J");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}



var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");


function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}



var $4LmDH = parcelRequire("4LmDH");


function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.firstWeekContainsDate);
    var year = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(firstWeek, dirtyOptions);
    return date;
}



var $4LmDH = parcelRequire("4LmDH");
var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options).getTime() - (0, $5b38b39a484f4993$export$2e2bcd8739ae039)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}



function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;


var $d91e238bf521c720$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = (0, $56d5b29bd1df6af4$export$2e2bcd8739ae039)(date); // Padding
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = (0, $dbfee7256f9ba04c$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $8dea7dd01f0b97c2$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $88335940ad51fc8f$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;


function $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
}
function $4f085685fa15e740$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
}
function $4f085685fa15e740$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
}
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;



var $9vfYB = parcelRequire("9vfYB");
var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}




var $4LmDH = parcelRequire("4LmDH");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    (0, $4LmDH.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $15nwl.default);
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $gdr0J.default)(dirtyDate);
    if (!(0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9vfYB.default)(originalDate);
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
        }
        return substring;
    }).join('').match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $d91e238bf521c720$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && (0, $a5375092e28b891e$export$c6cc36aa33304772)(substring)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    return input.match($4e349bc0dbb08c36$var$escapedStringRegExp)[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}


var $15nwl = parcelRequire("15nwl");


var $gdr0J = parcelRequire("gdr0J");

var $6yoAC = parcelRequire("6yoAC");


var $9vfYB = parcelRequire("9vfYB");




var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

function $cd47f247bdfd58ed$export$2e2bcd8739ae039(dirtyDate, dirtyDay, dirtyOptions) {
    (0, $4LmDH.default)(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}



var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

function $7ae224ed93d5e7cb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $4LmDH.default)(2, arguments);
    var day = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}




var $gdr0J = parcelRequire("gdr0J");


var $4LmDH = parcelRequire("4LmDH");
function $e5bdf6fda1ca18fd$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var isoWeek = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $e2b4503c694c959a$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}




var $gdr0J = parcelRequire("gdr0J");


var $4LmDH = parcelRequire("4LmDH");
function $78111b508c05f859$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var week = (0, $a874c42e2166676d$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $c4c2445bc457b574$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}




var $c1027c3b7f83f29d$var$MILLISECONDS_IN_HOUR = 3600000;
var $c1027c3b7f83f29d$var$MILLISECONDS_IN_MINUTE = 60000;
var $c1027c3b7f83f29d$var$MILLISECONDS_IN_SECOND = 1000;
var $c1027c3b7f83f29d$var$numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $c1027c3b7f83f29d$var$timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $c1027c3b7f83f29d$var$parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
    var value = parseInt(matchResult[0], 10);
    return {
        value: valueCallback ? valueCallback(value) : value,
        rest: string.slice(matchResult[0].length)
    };
}
function $c1027c3b7f83f29d$var$parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: string.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $c1027c3b7f83f29d$var$MILLISECONDS_IN_HOUR + minutes * $c1027c3b7f83f29d$var$MILLISECONDS_IN_MINUTE + seconds * $c1027c3b7f83f29d$var$MILLISECONDS_IN_SECOND),
        rest: string.slice(matchResult[0].length)
    };
}
function $c1027c3b7f83f29d$var$parseAnyDigitsSigned(string, valueCallback) {
    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.anyDigitsSigned, string, valueCallback);
}
function $c1027c3b7f83f29d$var$parseNDigits(n, string, valueCallback) {
    switch(n){
        case 1:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.singleDigit, string, valueCallback);
        case 2:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.twoDigits, string, valueCallback);
        case 3:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.threeDigits, string, valueCallback);
        case 4:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.fourDigits, string, valueCallback);
        default:
            return $c1027c3b7f83f29d$var$parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $c1027c3b7f83f29d$var$parseNDigitsSigned(n, string, valueCallback) {
    switch(n){
        case 1:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.singleDigitSigned, string, valueCallback);
        case 2:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.twoDigitsSigned, string, valueCallback);
        case 3:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.threeDigitsSigned, string, valueCallback);
        case 4:
            return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.fourDigitsSigned, string, valueCallback);
        default:
            return $c1027c3b7f83f29d$var$parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
    }
}
function $c1027c3b7f83f29d$var$dayPeriodEnumToHours(enumValue) {
    switch(enumValue){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $c1027c3b7f83f29d$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
var $c1027c3b7f83f29d$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $c1027c3b7f83f29d$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // User for validation
function $c1027c3b7f83f29d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ var $c1027c3b7f83f29d$var$parsers = {
    // Era
    G: {
        priority: 140,
        parse: function(string, token, match, _options) {
            switch(token){
                // AD, BC
                case 'G':
                case 'GG':
                case 'GGG':
                    return match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
                // A, B
                case 'GGGGG':
                    return match.era(string, {
                        width: 'narrow'
                    });
                // Anno Domini, Before Christ
                case 'GGGG':
                default:
                    return match.era(string, {
                        width: 'wide'
                    }) || match.era(string, {
                        width: 'abbreviated'
                    }) || match.era(string, {
                        width: 'narrow'
                    });
            }
        },
        set: function(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'R',
            'u',
            't',
            'T'
        ]
    },
    // Year
    y: {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'yy'
                };
            };
            switch(token){
                case 'y':
                    return $c1027c3b7f83f29d$var$parseNDigits(4, string, valueCallback);
                case 'yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $c1027c3b7f83f29d$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week-numbering year
    Y: {
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === 'YY'
                };
            };
            switch(token){
                case 'Y':
                    return $c1027c3b7f83f29d$var$parseNDigits(4, string, valueCallback);
                case 'Yo':
                    return match.ordinalNumber(string, {
                        unit: 'year',
                        valueCallback: valueCallback
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, options) {
            var currentYear = (0, $efe8c2ce4ac4bd36$export$2e2bcd8739ae039)(date, options);
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $c1027c3b7f83f29d$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options);
            }
            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)(date, options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week-numbering year
    R: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'R') return $c1027c3b7f83f29d$var$parseNDigitsSigned(4, string);
            return $c1027c3b7f83f29d$var$parseNDigitsSigned(token.length, string);
        },
        set: function(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)(firstWeekOfYear);
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Extended year
    u: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === 'u') return $c1027c3b7f83f29d$var$parseNDigitsSigned(4, string);
            return $c1027c3b7f83f29d$var$parseNDigitsSigned(token.length, string);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Quarter
    Q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'Q':
                case 'QQ':
                    // 01, 02, 03, 04
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'Qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'QQQ':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'QQQQQ':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'QQQQ':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone quarter
    q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case 'q':
                case 'qq':
                    // 01, 02, 03, 04
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case 'qo':
                    return match.ordinalNumber(string, {
                        unit: 'quarter'
                    });
                // Q1, Q2, Q3, Q4
                case 'qqq':
                    return match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case 'qqqqq':
                    return match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // 1st quarter, 2nd quarter, ...
                case 'qqqq':
                default:
                    return match.quarter(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.quarter(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Month
    M: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'M':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'MM':
                    return $c1027c3b7f83f29d$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Mo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'MMM':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // J, F, ..., D
                case 'MMMMM':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // January, February, ..., December
                case 'MMMM':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone month
    L: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case 'L':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case 'LL':
                    return $c1027c3b7f83f29d$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case 'Lo':
                    return match.ordinalNumber(string, {
                        unit: 'month',
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case 'LLL':
                    return match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // J, F, ..., D
                case 'LLLLL':
                    return match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // January, February, ..., December
                case 'LLLL':
                default:
                    return match.month(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.month(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local week of year
    w: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'w':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.week, string);
                case 'wo':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $0dfbcd4e04a34858$export$2e2bcd8739ae039)((0, $78111b508c05f859$export$2e2bcd8739ae039)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    // ISO week of year
    I: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'I':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.week, string);
                case 'Io':
                    return match.ordinalNumber(string, {
                        unit: 'week'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return (0, $8b6bcc549b1c1b29$export$2e2bcd8739ae039)((0, $e5bdf6fda1ca18fd$export$2e2bcd8739ae039)(date, value, options), options);
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of the month
    d: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'd':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.date, string);
                case 'do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $c1027c3b7f83f29d$var$isLeapYearIndex(year);
            var month = date.getUTCMonth();
            if (isLeapYear) return value >= 1 && value <= $c1027c3b7f83f29d$var$DAYS_IN_MONTH_LEAP_YEAR[month];
            else return value >= 1 && value <= $c1027c3b7f83f29d$var$DAYS_IN_MONTH[month];
        },
        set: function(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of year
    D: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'D':
                case 'DD':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.dayOfYear, string);
                case 'Do':
                    return match.ordinalNumber(string, {
                        unit: 'date'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $c1027c3b7f83f29d$var$isLeapYearIndex(year);
            if (isLeapYear) return value >= 1 && value <= 366;
            else return value >= 1 && value <= 365;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Day of week
    E: {
        priority: 90,
        parse: function(string, token, match, _options) {
            switch(token){
                // Tue
                case 'E':
                case 'EE':
                case 'EEE':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'EEEEE':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'EEEEEE':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'EEEE':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $cd47f247bdfd58ed$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // Local day of week
    e: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'e':
                case 'ee':
                    // 03
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'eo':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'eee':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // T
                case 'eeeee':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tu
                case 'eeeeee':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                // Tuesday
                case 'eeee':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $cd47f247bdfd58ed$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]
    },
    // Stand-alone local day of week
    c: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case 'c':
                case 'cc':
                    // 03
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case 'co':
                    return match.ordinalNumber(string, {
                        unit: 'day',
                        valueCallback: valueCallback
                    });
                // Tue
                case 'ccc':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // T
                case 'ccccc':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tu
                case 'cccccc':
                    return match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                // Tuesday
                case 'cccc':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'short',
                        context: 'standalone'
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = (0, $cd47f247bdfd58ed$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]
    },
    // ISO day of week
    i: {
        priority: 90,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                if (value === 0) return 7;
                return value;
            };
            switch(token){
                // 2
                case 'i':
                case 'ii':
                    // 02
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
                // 2nd
                case 'io':
                    return match.ordinalNumber(string, {
                        unit: 'day'
                    });
                // Tue
                case 'iii':
                    return match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // T
                case 'iiiii':
                    return match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tu
                case 'iiiiii':
                    return match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
                // Tuesday
                case 'iiii':
                default:
                    return match.day(string, {
                        width: 'wide',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: valueCallback
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 7;
        },
        set: function(date, _flags, value, options) {
            date = (0, $7ae224ed93d5e7cb$export$2e2bcd8739ae039)(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]
    },
    // AM or PM
    a: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'a':
                case 'aa':
                case 'aaa':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaaa':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($c1027c3b7f83f29d$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // AM, PM, midnight
    b: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'b':
                case 'bb':
                case 'bbb':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbbb':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($c1027c3b7f83f29d$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return match.dayPeriod(string, {
                        width: 'wide',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || match.dayPeriod(string, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($c1027c3b7f83f29d$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            't',
            'T'
        ]
    },
    // Hour [1-12]
    h: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'h':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour12h, string);
                case 'ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 12;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-23]
    H: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'H':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour23h, string);
                case 'Ho':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 23;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]
    },
    // Hour [0-11]
    K: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'K':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour11h, string);
                case 'Ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'h',
            'H',
            'k',
            't',
            'T'
        ]
    },
    // Hour [1-24]
    k: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'k':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.hour24h, string);
                case 'ko':
                    return match.ordinalNumber(string, {
                        unit: 'hour'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 24;
        },
        set: function(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]
    },
    // Minute
    m: {
        priority: 60,
        parse: function(string, token, match, _options) {
            switch(token){
                case 'm':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.minute, string);
                case 'mo':
                    return match.ordinalNumber(string, {
                        unit: 'minute'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Second
    s: {
        priority: 50,
        parse: function(string, token, match, _options) {
            switch(token){
                case 's':
                    return $c1027c3b7f83f29d$var$parseNumericPattern($c1027c3b7f83f29d$var$numericPatterns.second, string);
                case 'so':
                    return match.ordinalNumber(string, {
                        unit: 'second'
                    });
                default:
                    return $c1027c3b7f83f29d$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Fraction of second
    S: {
        priority: 30,
        parse: function(string, token, _match, _options) {
            var valueCallback = function(value) {
                return Math.floor(value * Math.pow(10, -token.length + 3));
            };
            return $c1027c3b7f83f29d$var$parseNDigits(token.length, string, valueCallback);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'X':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalMinutes, string);
                case 'XX':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basic, string);
                case 'XXXX':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalSeconds, string);
                case 'XXXXX':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'XXX':
                default:
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'x'
        ]
    },
    // Timezone (ISO-8601)
    x: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case 'x':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalMinutes, string);
                case 'xx':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basic, string);
                case 'xxxx':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.basicOptionalSeconds, string);
                case 'xxxxx':
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extendedOptionalSeconds, string);
                case 'xxx':
                default:
                    return $c1027c3b7f83f29d$var$parseTimezonePattern($c1027c3b7f83f29d$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            't',
            'T',
            'X'
        ]
    },
    // Seconds timestamp
    t: {
        priority: 40,
        parse: function(string, _token, _match, _options) {
            return $c1027c3b7f83f29d$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value * 1000),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    },
    // Milliseconds timestamp
    T: {
        priority: 20,
        parse: function(string, _token, _match, _options) {
            return $c1027c3b7f83f29d$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: '*'
    }
};
var $c1027c3b7f83f29d$export$2e2bcd8739ae039 = $c1027c3b7f83f29d$var$parsers;



var $4LmDH = parcelRequire("4LmDH");
var $7a460707bf147158$var$TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7a460707bf147158$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7a460707bf147158$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7a460707bf147158$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7a460707bf147158$var$doubleQuoteRegExp = /''/g;
var $7a460707bf147158$var$notWhitespaceRegExp = /\S/;
var $7a460707bf147158$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7a460707bf147158$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    (0, $4LmDH.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale = options.locale || (0, $15nwl.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $gdr0J.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        {
            priority: $7a460707bf147158$var$TIMEZONE_UNIT_PRIORITY,
            subPriority: -1,
            set: $7a460707bf147158$var$dateToSystemTimezone,
            index: 0
        }
    ];
    var i;
    var tokens = formatString.match($7a460707bf147158$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $4f085685fa15e740$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
        }
        return substring;
    }).join('').match($7a460707bf147158$var$formattingTokensRegExp);
    var usedTokens = [];
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (!options.useAdditionalWeekYearTokens && (0, $a5375092e28b891e$export$c6b49d6dceb604a1)(token)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
        if (!options.useAdditionalDayOfYearTokens && (0, $a5375092e28b891e$export$c6cc36aa33304772)(token)) (0, $a5375092e28b891e$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
        var firstCharacter = token[0];
        var parser = (0, $c1027c3b7f83f29d$export$2e2bcd8739ae039)[firstCharacter];
        if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;
            if (Array.isArray(incompatibleTokens)) {
                var incompatibleToken = void 0;
                for(var _i = 0; _i < usedTokens.length; _i++){
                    var usedToken = usedTokens[_i].token;
                    if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                        incompatibleToken = usedTokens[_i];
                        break;
                    }
                }
                if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            } else if (parser.incompatibleTokens === '*' && usedTokens.length) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
            if (!parseResult) return new Date(NaN);
            setters.push({
                priority: parser.priority,
                subPriority: parser.subPriority || 0,
                set: parser.set,
                validate: parser.validate,
                value: parseResult.value,
                index: setters.length
            });
            dateString = parseResult.rest;
        } else {
            if (firstCharacter.match($7a460707bf147158$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
             // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $7a460707bf147158$var$cleanEscapedString(token);
             // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
            else return new Date(NaN);
        }
    } // Check if the remaining input contains something other than whitespace
    if (dateString.length > 0 && $7a460707bf147158$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $gdr0J.default)(dirtyReferenceDate);
    if (isNaN(date)) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
    var utcDate = (0, $6673cc5b62dfa592$export$2e2bcd8739ae039)(date, (0, $9vfYB.default)(date));
    var flags = {};
    for(i = 0; i < uniquePrioritySetters.length; i++){
        var setter = uniquePrioritySetters[i];
        if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) return new Date(NaN);
        var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
        if (result[0]) {
            utcDate = result[0];
            (0, $6yoAC.default)(flags, result[1]); // Result is date
        } else utcDate = result;
    }
    return utcDate;
}
function $7a460707bf147158$var$dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) return date;
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
}
function $7a460707bf147158$var$cleanEscapedString(input) {
    return input.match($7a460707bf147158$var$escapedStringRegExp)[1].replace($7a460707bf147158$var$doubleQuoteRegExp, "'");
}



var $4LmDH = parcelRequire("4LmDH");

function $9c2d1611e11d9224$export$2e2bcd8739ae039(argument, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? 2 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9c2d1611e11d9224$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c2d1611e11d9224$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c2d1611e11d9224$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c2d1611e11d9224$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c2d1611e11d9224$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9c2d1611e11d9224$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c2d1611e11d9224$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c2d1611e11d9224$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c2d1611e11d9224$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c2d1611e11d9224$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c2d1611e11d9224$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c2d1611e11d9224$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c2d1611e11d9224$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c2d1611e11d9224$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c2d1611e11d9224$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c2d1611e11d9224$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9c2d1611e11d9224$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c2d1611e11d9224$var$parseDateUnit(captures[1]);
    var month = $9c2d1611e11d9224$var$parseDateUnit(captures[2]) - 1;
    var day = $9c2d1611e11d9224$var$parseDateUnit(captures[3]);
    var week = $9c2d1611e11d9224$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c2d1611e11d9224$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c2d1611e11d9224$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c2d1611e11d9224$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c2d1611e11d9224$var$validateDate(year, month, day) || !$9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c2d1611e11d9224$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c2d1611e11d9224$var$parseTime(timeString) {
    var captures = timeString.match($9c2d1611e11d9224$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9c2d1611e11d9224$var$parseTimeUnit(captures[1]);
    var minutes = $9c2d1611e11d9224$var$parseTimeUnit(captures[2]);
    var seconds = $9c2d1611e11d9224$var$parseTimeUnit(captures[3]);
    if (!$9c2d1611e11d9224$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $4faa9cd956e257dc$export$7f72910d6dfd237a) + minutes * (0, $4faa9cd956e257dc$export$91246f0b9bd9beff) + seconds * 1000;
}
function $9c2d1611e11d9224$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9c2d1611e11d9224$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9c2d1611e11d9224$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c2d1611e11d9224$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $4faa9cd956e257dc$export$7f72910d6dfd237a) + minutes * (0, $4faa9cd956e257dc$export$91246f0b9bd9beff));
}
function $9c2d1611e11d9224$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $9c2d1611e11d9224$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c2d1611e11d9224$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9c2d1611e11d9224$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c2d1611e11d9224$var$daysInMonths[month] || ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c2d1611e11d9224$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c2d1611e11d9224$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c2d1611e11d9224$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $af6ff563afc12374$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5e301086deafe9c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setSeconds(0, 0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c53a4d8dd17910c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $b384d2906418fecc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setMilliseconds(0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");


var $4LmDH = parcelRequire("4LmDH");
function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, dirtyOptions) {
    (0, $4LmDH.default)(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $a874c42e2166676d$export$2e2bcd8739ae039)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var cleanDate = (0, $gdr0J.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $gdr0J = parcelRequire("gdr0J");
const $4c7ca2525ef80a8f$var$FORMATS = {
    datetime: 'MMM d, yyyy, h:mm:ss aaaa',
    millisecond: 'h:mm:ss.SSS aaaa',
    second: 'h:mm:ss aaaa',
    minute: 'h:mm aaaa',
    hour: 'ha',
    day: 'MMM d',
    week: 'PP',
    month: 'MMM yyyy',
    quarter: 'qqq - yyyy',
    year: 'yyyy'
};
(0, $216d2bdc6f281bf6$export$f32766ea09ec8bc4)._date.override({
    _id: 'date-fns',
    formats: function() {
        return $4c7ca2525ef80a8f$var$FORMATS;
    },
    parse: function(value, fmt) {
        if (value === null || typeof value === 'undefined') return null;
        const type = typeof value;
        if (type === 'number' || value instanceof Date) value = (0, $gdr0J.default)(value);
        else if (type === 'string') {
            if (typeof fmt === 'string') value = (0, $7a460707bf147158$export$2e2bcd8739ae039)(value, fmt, new Date(), this.options);
            else value = (0, $9c2d1611e11d9224$export$2e2bcd8739ae039)(value, this.options);
        }
        return (0, $93a8d45f3f5c7cb9$export$2e2bcd8739ae039)(value) ? value.getTime() : null;
    },
    format: function(time, fmt) {
        return (0, $4e349bc0dbb08c36$export$2e2bcd8739ae039)(time, fmt, this.options);
    },
    add: function(time, amount, unit) {
        switch(unit){
            case 'millisecond':
                return (0, $5fd7da45fede2458$export$2e2bcd8739ae039)(time, amount);
            case 'second':
                return (0, $30a94a667184fb38$export$2e2bcd8739ae039)(time, amount);
            case 'minute':
                return (0, $8a9f3e7be35784f5$export$2e2bcd8739ae039)(time, amount);
            case 'hour':
                return (0, $eba2848fce1475e9$export$2e2bcd8739ae039)(time, amount);
            case 'day':
                return (0, $4f754377033842c6$export$2e2bcd8739ae039)(time, amount);
            case 'week':
                return (0, $207b05f27970aaba$export$2e2bcd8739ae039)(time, amount);
            case 'month':
                return (0, $a8211859f65764ad$export$2e2bcd8739ae039)(time, amount);
            case 'quarter':
                return (0, $e8f3df7678d5e716$export$2e2bcd8739ae039)(time, amount);
            case 'year':
                return (0, $eb237db400049a40$export$2e2bcd8739ae039)(time, amount);
            default:
                return time;
        }
    },
    diff: function(max, min, unit) {
        switch(unit){
            case 'millisecond':
                return (0, $bFuWZ.default)(max, min);
            case 'second':
                return (0, $8xDhD.default)(max, min);
            case 'minute':
                return (0, $c13bbb54037e7269$export$2e2bcd8739ae039)(max, min);
            case 'hour':
                return (0, $bc23742ab6e4a898$export$2e2bcd8739ae039)(max, min);
            case 'day':
                return (0, $5e650688c0910592$export$2e2bcd8739ae039)(max, min);
            case 'week':
                return (0, $dfaafc43dccafd3d$export$2e2bcd8739ae039)(max, min);
            case 'month':
                return (0, $3Umsa.default)(max, min);
            case 'quarter':
                return (0, $1672b99dd1850a2d$export$2e2bcd8739ae039)(max, min);
            case 'year':
                return (0, $3ff7ac235dc3be01$export$2e2bcd8739ae039)(max, min);
            default:
                return 0;
        }
    },
    startOf: function(time, unit, weekday) {
        switch(unit){
            case 'second':
                return (0, $b384d2906418fecc$export$2e2bcd8739ae039)(time);
            case 'minute':
                return (0, $5e301086deafe9c2$export$2e2bcd8739ae039)(time);
            case 'hour':
                return (0, $af6ff563afc12374$export$2e2bcd8739ae039)(time);
            case 'day':
                return (0, $9445ecc5e7cfb647$export$2e2bcd8739ae039)(time);
            case 'week':
                return (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(time);
            case 'isoWeek':
                return (0, $5808e7e2a5fbbc4c$export$2e2bcd8739ae039)(time, {
                    weekStartsOn: +weekday
                });
            case 'month':
                return (0, $41c3cc0836893904$export$2e2bcd8739ae039)(time);
            case 'quarter':
                return (0, $c53a4d8dd17910c2$export$2e2bcd8739ae039)(time);
            case 'year':
                return (0, $48a662f07bb27222$export$2e2bcd8739ae039)(time);
            default:
                return time;
        }
    },
    endOf: function(time, unit) {
        switch(unit){
            case 'second':
                return (0, $8d858ac4063064f9$export$2e2bcd8739ae039)(time);
            case 'minute':
                return (0, $17aca8a6c8bc25fd$export$2e2bcd8739ae039)(time);
            case 'hour':
                return (0, $1ed606b7addd3a91$export$2e2bcd8739ae039)(time);
            case 'day':
                return (0, $6uyHy.default)(time);
            case 'week':
                return (0, $52a761315a8e3e9c$export$2e2bcd8739ae039)(time);
            case 'month':
                return (0, $l2vHo.default)(time);
            case 'quarter':
                return (0, $9195d3fb013f21bf$export$2e2bcd8739ae039)(time);
            case 'year':
                return (0, $5a7a122bf592ddcb$export$2e2bcd8739ae039)(time);
            default:
                return time;
        }
    }
});


/*!
* chartjs-plugin-zoom v2.0.1
* undefined
 * (c) 2016-2023 chartjs-plugin-zoom Contributors
 * Released under the MIT License
 */ var $cebfe6726e901212$exports = {};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    'use strict';
    var VENDOR_PREFIXES = [
        '',
        'webkit',
        'Moz',
        'MS',
        'ms',
        'o'
    ];
    var TEST_ELEMENT = document1.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
        return function() {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== 'function') assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = 'ontouchstart' in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        'x',
        'y'
    ];
    var PROPS_CLIENT_XY = [
        'clientX',
        'clientY'
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId');
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), 'identifier', true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(' '));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            'auto',
            'manipulation',
            'pan-y',
            'pan-x',
            'pan-x pan-y',
            'none'
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return 'cancel';
        else if (state & STATE_ENDED) return 'end';
        else if (state & STATE_CHANGED) return 'move';
        else if (state & STATE_BEGAN) return 'start';
        return '';
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return 'down';
        else if (direction == DIRECTION_UP) return 'up';
        else if (direction == DIRECTION_LEFT) return 'left';
        else if (direction == DIRECTION_RIGHT) return 'right';
        return '';
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'pinch',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + 'up', input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: 'rotate',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = '2.0.7';
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    'rotate'
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    'swipe'
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: 'doubletap',
                    taps: 2
                },
                [
                    'tap'
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: 'none',
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: 'none',
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: 'none',
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: 'none',
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: 'none',
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: 'rgba(0,0,0,0)'
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, 'add', this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, 'remove', this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || '';
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent('Event');
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== 'undefined' ? window1 : typeof self !== 'undefined' ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === 'function' && define.amd) define(function() {
        return Hammer;
    });
    else if (0, $cebfe6726e901212$exports) $cebfe6726e901212$exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, 'Hammer');





const $009710f418dccc36$var$getModifierKey = (opts)=>opts && opts.enabled && opts.modifierKey;
const $009710f418dccc36$var$keyPressed = (key, event)=>key && event[key + 'Key'];
const $009710f418dccc36$var$keyNotPressed = (key, event)=>key && !event[key + 'Key'];
/**
 * @param {string|function} mode can be 'x', 'y' or 'xy'
 * @param {string} dir can be 'x' or 'y'
 * @param {import('chart.js').Chart} chart instance of the chart in question
 * @returns {boolean}
 */ function $009710f418dccc36$var$directionEnabled(mode, dir, chart) {
    if (mode === undefined) return true;
    else if (typeof mode === 'string') return mode.indexOf(dir) !== -1;
    else if (typeof mode === 'function') return mode({
        chart: chart
    }).indexOf(dir) !== -1;
    return false;
}
function $009710f418dccc36$var$directionsEnabled(mode, chart) {
    if (typeof mode === 'function') mode = mode({
        chart: chart
    });
    if (typeof mode === 'string') return {
        x: mode.indexOf('x') !== -1,
        y: mode.indexOf('y') !== -1
    };
    return {
        x: false,
        y: false
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 * @param {function} fn - Function to call. No arguments are passed.
 * @param {number} delay - Delay in ms. 0 = immediate invocation.
 * @returns {function}
 */ function $009710f418dccc36$var$debounce(fn, delay) {
    let timeout;
    return function() {
        clearTimeout(timeout);
        timeout = setTimeout(fn, delay);
        return delay;
    };
}
/**
 * Checks which axis is under the mouse cursor.
 * @param {{x: number, y: number}} point - the mouse location
 * @param {import('chart.js').Chart} [chart] instance of the chart in question
 * @return {import('chart.js').Scale}
 */ function $009710f418dccc36$var$getScaleUnderPoint({ x: x, y: y }, chart) {
    const scales = chart.scales;
    const scaleIds = Object.keys(scales);
    for(let i = 0; i < scaleIds.length; i++){
        const scale = scales[scaleIds[i]];
        if (y >= scale.top && y <= scale.bottom && x >= scale.left && x <= scale.right) return scale;
    }
    return null;
}
/**
 * Evaluate the chart's mode, scaleMode, and overScaleMode properties to
 * determine which axes are eligible for scaling.
 * options.overScaleMode can be a function if user want zoom only one scale of many for example.
 * @param options - Zoom or pan options
 * @param {{x: number, y: number}} point - the mouse location
 * @param {import('chart.js').Chart} [chart] instance of the chart in question
 * @return {import('chart.js').Scale[]}
 */ function $009710f418dccc36$var$getEnabledScalesByPoint(options, point, chart) {
    const { mode: mode = 'xy', scaleMode: scaleMode, overScaleMode: overScaleMode } = options || {};
    const scale = $009710f418dccc36$var$getScaleUnderPoint(point, chart);
    const enabled = $009710f418dccc36$var$directionsEnabled(mode, chart);
    const scaleEnabled = $009710f418dccc36$var$directionsEnabled(scaleMode, chart);
    // Convert deprecated overScaleEnabled to new scaleEnabled.
    if (overScaleMode) {
        const overScaleEnabled = $009710f418dccc36$var$directionsEnabled(overScaleMode, chart);
        for (const axis of [
            'x',
            'y'
        ])if (overScaleEnabled[axis]) {
            scaleEnabled[axis] = enabled[axis];
            enabled[axis] = false;
        }
    }
    if (scale && scaleEnabled[scale.axis]) return [
        scale
    ];
    const enabledScales = [];
    (0, $8d27ca75da600b9c$export$d66501df72047452)(chart.scales, function(scaleItem) {
        if (enabled[scaleItem.axis]) enabledScales.push(scaleItem);
    });
    return enabledScales;
}
const $009710f418dccc36$var$chartStates = new WeakMap();
function $009710f418dccc36$var$getState(chart) {
    let state = $009710f418dccc36$var$chartStates.get(chart);
    if (!state) {
        state = {
            originalScaleLimits: {},
            updatedScaleLimits: {},
            handlers: {},
            panDelta: {}
        };
        $009710f418dccc36$var$chartStates.set(chart, state);
    }
    return state;
}
function $009710f418dccc36$var$removeState(chart) {
    $009710f418dccc36$var$chartStates.delete(chart);
}
function $009710f418dccc36$var$zoomDelta(scale, zoom, center) {
    const range = scale.max - scale.min;
    const newRange = range * (zoom - 1);
    const centerPoint = scale.isHorizontal() ? center.x : center.y;
    // `scale.getValueForPixel()` can return a value less than the `scale.min` or
    // greater than `scale.max` when `centerPoint` is outside chartArea.
    const minPercent = Math.max(0, Math.min(1, (scale.getValueForPixel(centerPoint) - scale.min) / range || 0));
    const maxPercent = 1 - minPercent;
    return {
        min: newRange * minPercent,
        max: newRange * maxPercent
    };
}
function $009710f418dccc36$var$getLimit(state, scale, scaleLimits, prop, fallback) {
    let limit = scaleLimits[prop];
    if (limit === 'original') {
        const original = state.originalScaleLimits[scale.id][prop];
        limit = (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(original.options, original.scale);
    }
    return (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(limit, fallback);
}
function $009710f418dccc36$var$getRange(scale, pixel0, pixel1) {
    const v0 = scale.getValueForPixel(pixel0);
    const v1 = scale.getValueForPixel(pixel1);
    return {
        min: Math.min(v0, v1),
        max: Math.max(v0, v1)
    };
}
function $009710f418dccc36$var$updateRange(scale, { min: min, max: max }, limits, zoom = false) {
    const state = $009710f418dccc36$var$getState(scale.chart);
    const { id: id, axis: axis, options: scaleOpts } = scale;
    const scaleLimits = limits && (limits[id] || limits[axis]) || {};
    const { minRange: minRange = 0 } = scaleLimits;
    const minLimit = $009710f418dccc36$var$getLimit(state, scale, scaleLimits, 'min', -Infinity);
    const maxLimit = $009710f418dccc36$var$getLimit(state, scale, scaleLimits, 'max', Infinity);
    const range = zoom ? Math.max(max - min, minRange) : scale.max - scale.min;
    const offset = (range - max + min) / 2;
    min -= offset;
    max += offset;
    if (min < minLimit) {
        min = minLimit;
        max = Math.min(minLimit + range, maxLimit);
    } else if (max > maxLimit) {
        max = maxLimit;
        min = Math.max(maxLimit - range, minLimit);
    }
    scaleOpts.min = min;
    scaleOpts.max = max;
    state.updatedScaleLimits[scale.id] = {
        min: min,
        max: max
    };
    // return true if the scale range is changed
    return scale.parse(min) !== scale.min || scale.parse(max) !== scale.max;
}
function $009710f418dccc36$var$zoomNumericalScale(scale, zoom, center, limits) {
    const delta = $009710f418dccc36$var$zoomDelta(scale, zoom, center);
    const newRange = {
        min: scale.min + delta.min,
        max: scale.max - delta.max
    };
    return $009710f418dccc36$var$updateRange(scale, newRange, limits, true);
}
function $009710f418dccc36$var$zoomRectNumericalScale(scale, from, to, limits) {
    $009710f418dccc36$var$updateRange(scale, $009710f418dccc36$var$getRange(scale, from, to), limits, true);
}
const $009710f418dccc36$var$integerChange = (v)=>v === 0 || isNaN(v) ? 0 : v < 0 ? Math.min(Math.round(v), -1) : Math.max(Math.round(v), 1);
function $009710f418dccc36$var$existCategoryFromMaxZoom(scale) {
    const labels = scale.getLabels();
    const maxIndex = labels.length - 1;
    if (scale.min > 0) scale.min -= 1;
    if (scale.max < maxIndex) scale.max += 1;
}
function $009710f418dccc36$var$zoomCategoryScale(scale, zoom, center, limits) {
    const delta = $009710f418dccc36$var$zoomDelta(scale, zoom, center);
    if (scale.min === scale.max && zoom < 1) $009710f418dccc36$var$existCategoryFromMaxZoom(scale);
    const newRange = {
        min: scale.min + $009710f418dccc36$var$integerChange(delta.min),
        max: scale.max - $009710f418dccc36$var$integerChange(delta.max)
    };
    return $009710f418dccc36$var$updateRange(scale, newRange, limits, true);
}
function $009710f418dccc36$var$scaleLength(scale) {
    return scale.isHorizontal() ? scale.width : scale.height;
}
function $009710f418dccc36$var$panCategoryScale(scale, delta, limits) {
    const labels = scale.getLabels();
    const lastLabelIndex = labels.length - 1;
    let { min: min, max: max } = scale;
    // The visible range. Ticks can be skipped, and thus not reliable.
    const range = Math.max(max - min, 1);
    // How many pixels of delta is required before making a step. stepSize, but limited to max 1/10 of the scale length.
    const stepDelta = Math.round($009710f418dccc36$var$scaleLength(scale) / Math.max(range, 10));
    const stepSize = Math.round(Math.abs(delta / stepDelta));
    let applied;
    if (delta < -stepDelta) {
        max = Math.min(max + stepSize, lastLabelIndex);
        min = range === 1 ? max : max - range;
        applied = max === lastLabelIndex;
    } else if (delta > stepDelta) {
        min = Math.max(0, min - stepSize);
        max = range === 1 ? min : min + range;
        applied = min === 0;
    }
    return $009710f418dccc36$var$updateRange(scale, {
        min: min,
        max: max
    }, limits) || applied;
}
const $009710f418dccc36$var$OFFSETS = {
    second: 500,
    minute: 30000,
    hour: 1800000,
    day: 43200000,
    week: 302400000,
    month: 1296000000,
    quarter: 5184000000,
    year: 15724800000 // 182 d
};
function $009710f418dccc36$var$panNumericalScale(scale, delta, limits, canZoom = false) {
    const { min: prevStart, max: prevEnd, options: options } = scale;
    const round = options.time && options.time.round;
    const offset = $009710f418dccc36$var$OFFSETS[round] || 0;
    const newMin = scale.getValueForPixel(scale.getPixelForValue(prevStart + offset) - delta);
    const newMax = scale.getValueForPixel(scale.getPixelForValue(prevEnd + offset) - delta);
    const { min: minLimit = -Infinity, max: maxLimit = Infinity } = canZoom && limits && limits[scale.axis] || {};
    if (isNaN(newMin) || isNaN(newMax) || newMin < minLimit || newMax > maxLimit) // At limit: No change but return true to indicate no need to store the delta.
    // NaN can happen for 0-dimension scales (either because they were configured
    // with min === max or because the chart has 0 plottable area).
    return true;
    return $009710f418dccc36$var$updateRange(scale, {
        min: newMin,
        max: newMax
    }, limits, canZoom);
}
function $009710f418dccc36$var$panNonLinearScale(scale, delta, limits) {
    return $009710f418dccc36$var$panNumericalScale(scale, delta, limits, true);
}
const $009710f418dccc36$var$zoomFunctions = {
    category: $009710f418dccc36$var$zoomCategoryScale,
    default: $009710f418dccc36$var$zoomNumericalScale
};
const $009710f418dccc36$var$zoomRectFunctions = {
    default: $009710f418dccc36$var$zoomRectNumericalScale
};
const $009710f418dccc36$var$panFunctions = {
    category: $009710f418dccc36$var$panCategoryScale,
    default: $009710f418dccc36$var$panNumericalScale,
    logarithmic: $009710f418dccc36$var$panNonLinearScale,
    timeseries: $009710f418dccc36$var$panNonLinearScale
};
function $009710f418dccc36$var$shouldUpdateScaleLimits(scale, originalScaleLimits, updatedScaleLimits) {
    const { id: id, options: { min: min, max: max } } = scale;
    if (!originalScaleLimits[id] || !updatedScaleLimits[id]) return true;
    const previous = updatedScaleLimits[id];
    return previous.min !== min || previous.max !== max;
}
function $009710f418dccc36$var$removeMissingScales(limits, scales) {
    (0, $8d27ca75da600b9c$export$d66501df72047452)(limits, (opt, key)=>{
        if (!scales[key]) delete limits[key];
    });
}
function $009710f418dccc36$var$storeOriginalScaleLimits(chart, state) {
    const { scales: scales } = chart;
    const { originalScaleLimits: originalScaleLimits, updatedScaleLimits: updatedScaleLimits } = state;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(scales, function(scale) {
        if ($009710f418dccc36$var$shouldUpdateScaleLimits(scale, originalScaleLimits, updatedScaleLimits)) originalScaleLimits[scale.id] = {
            min: {
                scale: scale.min,
                options: scale.options.min
            },
            max: {
                scale: scale.max,
                options: scale.options.max
            }
        };
    });
    $009710f418dccc36$var$removeMissingScales(originalScaleLimits, scales);
    $009710f418dccc36$var$removeMissingScales(updatedScaleLimits, scales);
    return originalScaleLimits;
}
function $009710f418dccc36$var$doZoom(scale, amount, center, limits) {
    const fn = $009710f418dccc36$var$zoomFunctions[scale.type] || $009710f418dccc36$var$zoomFunctions.default;
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(fn, [
        scale,
        amount,
        center,
        limits
    ]);
}
function $009710f418dccc36$var$doZoomRect(scale, amount, from, to, limits) {
    const fn = $009710f418dccc36$var$zoomRectFunctions[scale.type] || $009710f418dccc36$var$zoomRectFunctions.default;
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(fn, [
        scale,
        amount,
        from,
        to,
        limits
    ]);
}
function $009710f418dccc36$var$getCenter(chart) {
    const ca = chart.chartArea;
    return {
        x: (ca.left + ca.right) / 2,
        y: (ca.top + ca.bottom) / 2
    };
}
/**
 * @param chart The chart instance
 * @param {number | {x?: number, y?: number, focalPoint?: {x: number, y: number}}} amount The zoom percentage or percentages and focal point
 * @param {string} [transition] Which transition mode to use. Defaults to 'none'
 */ function $009710f418dccc36$export$e83f174dbf56adcc(chart, amount, transition = 'none') {
    const { x: x = 1, y: y = 1, focalPoint: focalPoint = $009710f418dccc36$var$getCenter(chart) } = typeof amount === 'number' ? {
        x: amount,
        y: amount
    } : amount;
    const state = $009710f418dccc36$var$getState(chart);
    const { options: { limits: limits, zoom: zoomOptions } } = state;
    $009710f418dccc36$var$storeOriginalScaleLimits(chart, state);
    const xEnabled = x !== 1;
    const yEnabled = y !== 1;
    const enabledScales = $009710f418dccc36$var$getEnabledScalesByPoint(zoomOptions, focalPoint, chart);
    (0, $8d27ca75da600b9c$export$d66501df72047452)(enabledScales || chart.scales, function(scale) {
        if (scale.isHorizontal() && xEnabled) $009710f418dccc36$var$doZoom(scale, x, focalPoint, limits);
        else if (!scale.isHorizontal() && yEnabled) $009710f418dccc36$var$doZoom(scale, y, focalPoint, limits);
    });
    chart.update(transition);
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(zoomOptions.onZoom, [
        {
            chart: chart
        }
    ]);
}
function $009710f418dccc36$export$5e8e70b5f122ac9(chart, p0, p1, transition = 'none') {
    const state = $009710f418dccc36$var$getState(chart);
    const { options: { limits: limits, zoom: zoomOptions } } = state;
    const { mode: mode = 'xy' } = zoomOptions;
    $009710f418dccc36$var$storeOriginalScaleLimits(chart, state);
    const xEnabled = $009710f418dccc36$var$directionEnabled(mode, 'x', chart);
    const yEnabled = $009710f418dccc36$var$directionEnabled(mode, 'y', chart);
    (0, $8d27ca75da600b9c$export$d66501df72047452)(chart.scales, function(scale) {
        if (scale.isHorizontal() && xEnabled) $009710f418dccc36$var$doZoomRect(scale, p0.x, p1.x, limits);
        else if (!scale.isHorizontal() && yEnabled) $009710f418dccc36$var$doZoomRect(scale, p0.y, p1.y, limits);
    });
    chart.update(transition);
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(zoomOptions.onZoom, [
        {
            chart: chart
        }
    ]);
}
function $009710f418dccc36$export$bd064d51d863101c(chart, scaleId, range, transition = 'none') {
    $009710f418dccc36$var$storeOriginalScaleLimits(chart, $009710f418dccc36$var$getState(chart));
    const scale = chart.scales[scaleId];
    $009710f418dccc36$var$updateRange(scale, range, undefined, true);
    chart.update(transition);
}
function $009710f418dccc36$export$ac12f90bdc1d9b7(chart, transition = 'default') {
    const state = $009710f418dccc36$var$getState(chart);
    const originalScaleLimits = $009710f418dccc36$var$storeOriginalScaleLimits(chart, state);
    (0, $8d27ca75da600b9c$export$d66501df72047452)(chart.scales, function(scale) {
        const scaleOptions = scale.options;
        if (originalScaleLimits[scale.id]) {
            scaleOptions.min = originalScaleLimits[scale.id].min.options;
            scaleOptions.max = originalScaleLimits[scale.id].max.options;
        } else {
            delete scaleOptions.min;
            delete scaleOptions.max;
        }
    });
    chart.update(transition);
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(state.options.zoom.onZoomComplete, [
        {
            chart: chart
        }
    ]);
}
function $009710f418dccc36$var$getOriginalRange(state, scaleId) {
    const original = state.originalScaleLimits[scaleId];
    if (!original) return;
    const { min: min, max: max } = original;
    return (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(max.options, max.scale) - (0, $8d27ca75da600b9c$export$90a7f3efeed30595)(min.options, min.scale);
}
function $009710f418dccc36$var$getZoomLevel(chart) {
    const state = $009710f418dccc36$var$getState(chart);
    let min = 1;
    let max = 1;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(chart.scales, function(scale) {
        const origRange = $009710f418dccc36$var$getOriginalRange(state, scale.id);
        if (origRange) {
            const level = Math.round(origRange / (scale.max - scale.min) * 100) / 100;
            min = Math.min(min, level);
            max = Math.max(max, level);
        }
    });
    return min < 1 ? min : max;
}
function $009710f418dccc36$var$panScale(scale, delta, limits, state) {
    const { panDelta: panDelta } = state;
    // Add possible cumulative delta from previous pan attempts where scale did not change
    const storedDelta = panDelta[scale.id] || 0;
    if ((0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(storedDelta) === (0, $8d27ca75da600b9c$export$2408f22a0fab9ae5)(delta)) delta += storedDelta;
    const fn = $009710f418dccc36$var$panFunctions[scale.type] || $009710f418dccc36$var$panFunctions.default;
    if ((0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(fn, [
        scale,
        delta,
        limits
    ])) // The scale changed, reset cumulative delta
    panDelta[scale.id] = 0;
    else // The scale did not change, store cumulative delta
    panDelta[scale.id] = delta;
}
function $009710f418dccc36$export$4c486572e961a974(chart, delta, enabledScales, transition = 'none') {
    const { x: x = 0, y: y = 0 } = typeof delta === 'number' ? {
        x: delta,
        y: delta
    } : delta;
    const state = $009710f418dccc36$var$getState(chart);
    const { options: { pan: panOptions, limits: limits } } = state;
    const { onPan: onPan } = panOptions || {};
    $009710f418dccc36$var$storeOriginalScaleLimits(chart, state);
    const xEnabled = x !== 0;
    const yEnabled = y !== 0;
    (0, $8d27ca75da600b9c$export$d66501df72047452)(enabledScales || chart.scales, function(scale) {
        if (scale.isHorizontal() && xEnabled) $009710f418dccc36$var$panScale(scale, x, limits, state);
        else if (!scale.isHorizontal() && yEnabled) $009710f418dccc36$var$panScale(scale, y, limits, state);
    });
    chart.update(transition);
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(onPan, [
        {
            chart: chart
        }
    ]);
}
function $009710f418dccc36$var$getInitialScaleBounds(chart) {
    const state = $009710f418dccc36$var$getState(chart);
    $009710f418dccc36$var$storeOriginalScaleLimits(chart, state);
    const scaleBounds = {};
    for (const scaleId of Object.keys(chart.scales)){
        const { min: min, max: max } = state.originalScaleLimits[scaleId] || {
            min: {},
            max: {}
        };
        scaleBounds[scaleId] = {
            min: min.scale,
            max: max.scale
        };
    }
    return scaleBounds;
}
function $009710f418dccc36$var$isZoomedOrPanned(chart) {
    const scaleBounds = $009710f418dccc36$var$getInitialScaleBounds(chart);
    for (const scaleId of Object.keys(chart.scales)){
        const { min: originalMin, max: originalMax } = scaleBounds[scaleId];
        if (originalMin !== undefined && chart.scales[scaleId].min !== originalMin) return true;
        if (originalMax !== undefined && chart.scales[scaleId].max !== originalMax) return true;
    }
    return false;
}
function $009710f418dccc36$var$removeHandler(chart, type) {
    const { handlers: handlers } = $009710f418dccc36$var$getState(chart);
    const handler = handlers[type];
    if (handler && handler.target) {
        handler.target.removeEventListener(type, handler);
        delete handlers[type];
    }
}
function $009710f418dccc36$var$addHandler(chart, target, type, handler) {
    const { handlers: handlers, options: options } = $009710f418dccc36$var$getState(chart);
    const oldHandler = handlers[type];
    if (oldHandler && oldHandler.target === target) // already attached
    return;
    $009710f418dccc36$var$removeHandler(chart, type);
    handlers[type] = (event)=>handler(chart, event, options);
    handlers[type].target = target;
    target.addEventListener(type, handlers[type]);
}
function $009710f418dccc36$var$mouseMove(chart, event) {
    const state = $009710f418dccc36$var$getState(chart);
    if (state.dragStart) {
        state.dragging = true;
        state.dragEnd = event;
        chart.update('none');
    }
}
function $009710f418dccc36$var$keyDown(chart, event) {
    const state = $009710f418dccc36$var$getState(chart);
    if (!state.dragStart || event.key !== 'Escape') return;
    $009710f418dccc36$var$removeHandler(chart, 'keydown');
    state.dragging = false;
    state.dragStart = state.dragEnd = null;
    chart.update('none');
}
function $009710f418dccc36$var$zoomStart(chart, event, zoomOptions) {
    const { onZoomStart: onZoomStart, onZoomRejected: onZoomRejected } = zoomOptions;
    if (onZoomStart) {
        const point = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(event, chart);
        if ((0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(onZoomStart, [
            {
                chart: chart,
                event: event,
                point: point
            }
        ]) === false) {
            (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(onZoomRejected, [
                {
                    chart: chart,
                    event: event
                }
            ]);
            return false;
        }
    }
}
function $009710f418dccc36$var$mouseDown(chart, event) {
    const state = $009710f418dccc36$var$getState(chart);
    const { pan: panOptions, zoom: zoomOptions = {} } = state.options;
    if (event.button !== 0 || $009710f418dccc36$var$keyPressed($009710f418dccc36$var$getModifierKey(panOptions), event) || $009710f418dccc36$var$keyNotPressed($009710f418dccc36$var$getModifierKey(zoomOptions.drag), event)) return (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(zoomOptions.onZoomRejected, [
        {
            chart: chart,
            event: event
        }
    ]);
    if ($009710f418dccc36$var$zoomStart(chart, event, zoomOptions) === false) return;
    state.dragStart = event;
    $009710f418dccc36$var$addHandler(chart, chart.canvas, 'mousemove', $009710f418dccc36$var$mouseMove);
    $009710f418dccc36$var$addHandler(chart, window.document, 'keydown', $009710f418dccc36$var$keyDown);
}
function $009710f418dccc36$var$computeDragRect(chart, mode, beginPointEvent, endPointEvent) {
    const xEnabled = $009710f418dccc36$var$directionEnabled(mode, 'x', chart);
    const yEnabled = $009710f418dccc36$var$directionEnabled(mode, 'y', chart);
    let { top: top, left: left, right: right, bottom: bottom, width: chartWidth, height: chartHeight } = chart.chartArea;
    const beginPoint = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(beginPointEvent, chart);
    const endPoint = (0, $8d27ca75da600b9c$export$df995fae86a55f06)(endPointEvent, chart);
    if (xEnabled) {
        left = Math.min(beginPoint.x, endPoint.x);
        right = Math.max(beginPoint.x, endPoint.x);
    }
    if (yEnabled) {
        top = Math.min(beginPoint.y, endPoint.y);
        bottom = Math.max(beginPoint.y, endPoint.y);
    }
    const width = right - left;
    const height = bottom - top;
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom,
        width: width,
        height: height,
        zoomX: xEnabled && width ? 1 + (chartWidth - width) / chartWidth : 1,
        zoomY: yEnabled && height ? 1 + (chartHeight - height) / chartHeight : 1
    };
}
function $009710f418dccc36$var$mouseUp(chart, event) {
    const state = $009710f418dccc36$var$getState(chart);
    if (!state.dragStart) return;
    $009710f418dccc36$var$removeHandler(chart, 'mousemove');
    const { mode: mode, onZoomComplete: onZoomComplete, drag: { threshold: threshold = 0 } } = state.options.zoom;
    const rect = $009710f418dccc36$var$computeDragRect(chart, mode, state.dragStart, event);
    const distanceX = $009710f418dccc36$var$directionEnabled(mode, 'x', chart) ? rect.width : 0;
    const distanceY = $009710f418dccc36$var$directionEnabled(mode, 'y', chart) ? rect.height : 0;
    const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
    // Remove drag start and end before chart update to stop drawing selected area
    state.dragStart = state.dragEnd = null;
    if (distance <= threshold) {
        state.dragging = false;
        chart.update('none');
        return;
    }
    $009710f418dccc36$export$5e8e70b5f122ac9(chart, {
        x: rect.left,
        y: rect.top
    }, {
        x: rect.right,
        y: rect.bottom
    }, 'zoom');
    setTimeout(()=>state.dragging = false, 500);
    (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(onZoomComplete, [
        {
            chart: chart
        }
    ]);
}
function $009710f418dccc36$var$wheelPreconditions(chart, event, zoomOptions) {
    // Before preventDefault, check if the modifier key required and pressed
    if ($009710f418dccc36$var$keyNotPressed($009710f418dccc36$var$getModifierKey(zoomOptions.wheel), event)) {
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(zoomOptions.onZoomRejected, [
            {
                chart: chart,
                event: event
            }
        ]);
        return;
    }
    if ($009710f418dccc36$var$zoomStart(chart, event, zoomOptions) === false) return;
    // Prevent the event from triggering the default behavior (e.g. content scrolling).
    if (event.cancelable) event.preventDefault();
    // Firefox always fires the wheel event twice:
    // First without the delta and right after that once with the delta properties.
    if (event.deltaY === undefined) return;
    return true;
}
function $009710f418dccc36$var$wheel(chart, event) {
    const { handlers: { onZoomComplete: onZoomComplete }, options: { zoom: zoomOptions } } = $009710f418dccc36$var$getState(chart);
    if (!$009710f418dccc36$var$wheelPreconditions(chart, event, zoomOptions)) return;
    const rect = event.target.getBoundingClientRect();
    const speed = 1 + (event.deltaY >= 0 ? -zoomOptions.wheel.speed : zoomOptions.wheel.speed);
    const amount = {
        x: speed,
        y: speed,
        focalPoint: {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top
        }
    };
    $009710f418dccc36$export$e83f174dbf56adcc(chart, amount);
    if (onZoomComplete) onZoomComplete();
}
function $009710f418dccc36$var$addDebouncedHandler(chart, name, handler, delay) {
    if (handler) $009710f418dccc36$var$getState(chart).handlers[name] = $009710f418dccc36$var$debounce(()=>(0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(handler, [
            {
                chart: chart
            }
        ]), delay);
}
function $009710f418dccc36$var$addListeners(chart, options) {
    const canvas = chart.canvas;
    const { wheel: wheelOptions, drag: dragOptions, onZoomComplete: onZoomComplete } = options.zoom;
    // Install listeners. Do this dynamically based on options so that we can turn zoom on and off
    // We also want to make sure listeners aren't always on. E.g. if you're scrolling down a page
    // and the mouse goes over a chart you don't want it intercepted unless the plugin is enabled
    if (wheelOptions.enabled) {
        $009710f418dccc36$var$addHandler(chart, canvas, 'wheel', $009710f418dccc36$var$wheel);
        $009710f418dccc36$var$addDebouncedHandler(chart, 'onZoomComplete', onZoomComplete, 250);
    } else $009710f418dccc36$var$removeHandler(chart, 'wheel');
    if (dragOptions.enabled) {
        $009710f418dccc36$var$addHandler(chart, canvas, 'mousedown', $009710f418dccc36$var$mouseDown);
        $009710f418dccc36$var$addHandler(chart, canvas.ownerDocument, 'mouseup', $009710f418dccc36$var$mouseUp);
    } else {
        $009710f418dccc36$var$removeHandler(chart, 'mousedown');
        $009710f418dccc36$var$removeHandler(chart, 'mousemove');
        $009710f418dccc36$var$removeHandler(chart, 'mouseup');
        $009710f418dccc36$var$removeHandler(chart, 'keydown');
    }
}
function $009710f418dccc36$var$removeListeners(chart) {
    $009710f418dccc36$var$removeHandler(chart, 'mousedown');
    $009710f418dccc36$var$removeHandler(chart, 'mousemove');
    $009710f418dccc36$var$removeHandler(chart, 'mouseup');
    $009710f418dccc36$var$removeHandler(chart, 'wheel');
    $009710f418dccc36$var$removeHandler(chart, 'click');
    $009710f418dccc36$var$removeHandler(chart, 'keydown');
}
function $009710f418dccc36$var$createEnabler(chart, state) {
    return function(recognizer, event) {
        const { pan: panOptions, zoom: zoomOptions = {} } = state.options;
        if (!panOptions || !panOptions.enabled) return false;
        const srcEvent = event && event.srcEvent;
        if (!srcEvent) return true;
        if (!state.panning && event.pointerType === 'mouse' && ($009710f418dccc36$var$keyNotPressed($009710f418dccc36$var$getModifierKey(panOptions), srcEvent) || $009710f418dccc36$var$keyPressed($009710f418dccc36$var$getModifierKey(zoomOptions.drag), srcEvent))) {
            (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(panOptions.onPanRejected, [
                {
                    chart: chart,
                    event: event
                }
            ]);
            return false;
        }
        return true;
    };
}
function $009710f418dccc36$var$pinchAxes(p0, p1) {
    // fingers position difference
    const pinchX = Math.abs(p0.clientX - p1.clientX);
    const pinchY = Math.abs(p0.clientY - p1.clientY);
    // diagonal fingers will change both (xy) axes
    const p = pinchX / pinchY;
    let x, y;
    if (p > 0.3 && p < 1.7) x = y = true;
    else if (pinchX > pinchY) x = true;
    else y = true;
    return {
        x: x,
        y: y
    };
}
function $009710f418dccc36$var$handlePinch(chart, state, e) {
    if (state.scale) {
        const { center: center, pointers: pointers } = e;
        // Hammer reports the total scaling. We need the incremental amount
        const zoomPercent = 1 / state.scale * e.scale;
        const rect = e.target.getBoundingClientRect();
        const pinch = $009710f418dccc36$var$pinchAxes(pointers[0], pointers[1]);
        const mode = state.options.zoom.mode;
        const amount = {
            x: pinch.x && $009710f418dccc36$var$directionEnabled(mode, 'x', chart) ? zoomPercent : 1,
            y: pinch.y && $009710f418dccc36$var$directionEnabled(mode, 'y', chart) ? zoomPercent : 1,
            focalPoint: {
                x: center.x - rect.left,
                y: center.y - rect.top
            }
        };
        $009710f418dccc36$export$e83f174dbf56adcc(chart, amount);
        // Keep track of overall scale
        state.scale = e.scale;
    }
}
function $009710f418dccc36$var$startPinch(chart, state) {
    if (state.options.zoom.pinch.enabled) state.scale = 1;
}
function $009710f418dccc36$var$endPinch(chart, state, e) {
    if (state.scale) {
        $009710f418dccc36$var$handlePinch(chart, state, e);
        state.scale = null; // reset
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(state.options.zoom.onZoomComplete, [
            {
                chart: chart
            }
        ]);
    }
}
function $009710f418dccc36$var$handlePan(chart, state, e) {
    const delta = state.delta;
    if (delta) {
        state.panning = true;
        $009710f418dccc36$export$4c486572e961a974(chart, {
            x: e.deltaX - delta.x,
            y: e.deltaY - delta.y
        }, state.panScales);
        state.delta = {
            x: e.deltaX,
            y: e.deltaY
        };
    }
}
function $009710f418dccc36$var$startPan(chart, state, event) {
    const { enabled: enabled, onPanStart: onPanStart, onPanRejected: onPanRejected } = state.options.pan;
    if (!enabled) return;
    const rect = event.target.getBoundingClientRect();
    const point = {
        x: event.center.x - rect.left,
        y: event.center.y - rect.top
    };
    if ((0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(onPanStart, [
        {
            chart: chart,
            event: event,
            point: point
        }
    ]) === false) return (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(onPanRejected, [
        {
            chart: chart,
            event: event
        }
    ]);
    state.panScales = $009710f418dccc36$var$getEnabledScalesByPoint(state.options.pan, point, chart);
    state.delta = {
        x: 0,
        y: 0
    };
    clearTimeout(state.panEndTimeout);
    $009710f418dccc36$var$handlePan(chart, state, event);
}
function $009710f418dccc36$var$endPan(chart, state) {
    state.delta = null;
    if (state.panning) {
        state.panEndTimeout = setTimeout(()=>state.panning = false, 500);
        (0, $8d27ca75da600b9c$export$3722cfe417b6ed86)(state.options.pan.onPanComplete, [
            {
                chart: chart
            }
        ]);
    }
}
const $009710f418dccc36$var$hammers = new WeakMap();
function $009710f418dccc36$var$startHammer(chart, options) {
    const state = $009710f418dccc36$var$getState(chart);
    const canvas = chart.canvas;
    const { pan: panOptions, zoom: zoomOptions } = options;
    const mc = new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).Manager(canvas);
    if (zoomOptions && zoomOptions.pinch.enabled) {
        mc.add(new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).Pinch());
        mc.on('pinchstart', ()=>$009710f418dccc36$var$startPinch(chart, state));
        mc.on('pinch', (e)=>$009710f418dccc36$var$handlePinch(chart, state, e));
        mc.on('pinchend', (e)=>$009710f418dccc36$var$endPinch(chart, state, e));
    }
    if (panOptions && panOptions.enabled) {
        mc.add(new (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))).Pan({
            threshold: panOptions.threshold,
            enable: $009710f418dccc36$var$createEnabler(chart, state)
        }));
        mc.on('panstart', (e)=>$009710f418dccc36$var$startPan(chart, state, e));
        mc.on('panmove', (e)=>$009710f418dccc36$var$handlePan(chart, state, e));
        mc.on('panend', ()=>$009710f418dccc36$var$endPan(chart, state));
    }
    $009710f418dccc36$var$hammers.set(chart, mc);
}
function $009710f418dccc36$var$stopHammer(chart) {
    const mc = $009710f418dccc36$var$hammers.get(chart);
    if (mc) {
        mc.remove('pinchstart');
        mc.remove('pinch');
        mc.remove('pinchend');
        mc.remove('panstart');
        mc.remove('pan');
        mc.remove('panend');
        mc.destroy();
        $009710f418dccc36$var$hammers.delete(chart);
    }
}
var $009710f418dccc36$var$version = "2.0.1";
function $009710f418dccc36$var$draw(chart, caller, options) {
    const dragOptions = options.zoom.drag;
    const { dragStart: dragStart, dragEnd: dragEnd } = $009710f418dccc36$var$getState(chart);
    if (dragOptions.drawTime !== caller || !dragEnd) return;
    const { left: left, top: top, width: width, height: height } = $009710f418dccc36$var$computeDragRect(chart, options.zoom.mode, dragStart, dragEnd);
    const ctx = chart.ctx;
    ctx.save();
    ctx.beginPath();
    ctx.fillStyle = dragOptions.backgroundColor || 'rgba(225,225,225,0.3)';
    ctx.fillRect(left, top, width, height);
    if (dragOptions.borderWidth > 0) {
        ctx.lineWidth = dragOptions.borderWidth;
        ctx.strokeStyle = dragOptions.borderColor || 'rgba(225,225,225)';
        ctx.strokeRect(left, top, width, height);
    }
    ctx.restore();
}
var $009710f418dccc36$export$2e2bcd8739ae039 = {
    id: 'zoom',
    version: $009710f418dccc36$var$version,
    defaults: {
        pan: {
            enabled: false,
            mode: 'xy',
            threshold: 10,
            modifierKey: null
        },
        zoom: {
            wheel: {
                enabled: false,
                speed: 0.1,
                modifierKey: null
            },
            drag: {
                enabled: false,
                drawTime: 'beforeDatasetsDraw',
                modifierKey: null
            },
            pinch: {
                enabled: false
            },
            mode: 'xy'
        }
    },
    start: function(chart, _args, options) {
        const state = $009710f418dccc36$var$getState(chart);
        state.options = options;
        if (Object.prototype.hasOwnProperty.call(options.zoom, 'enabled')) console.warn('The option `zoom.enabled` is no longer supported. Please use `zoom.wheel.enabled`, `zoom.drag.enabled`, or `zoom.pinch.enabled`.');
        if (Object.prototype.hasOwnProperty.call(options.zoom, 'overScaleMode') || Object.prototype.hasOwnProperty.call(options.pan, 'overScaleMode')) console.warn('The option `overScaleMode` is deprecated. Please use `scaleMode` instead (and update `mode` as desired).');
        if (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))) $009710f418dccc36$var$startHammer(chart, options);
        chart.pan = (delta, panScales, transition)=>$009710f418dccc36$export$4c486572e961a974(chart, delta, panScales, transition);
        chart.zoom = (args, transition)=>$009710f418dccc36$export$e83f174dbf56adcc(chart, args, transition);
        chart.zoomRect = (p0, p1, transition)=>$009710f418dccc36$export$5e8e70b5f122ac9(chart, p0, p1, transition);
        chart.zoomScale = (id, range, transition)=>$009710f418dccc36$export$bd064d51d863101c(chart, id, range, transition);
        chart.resetZoom = (transition)=>$009710f418dccc36$export$ac12f90bdc1d9b7(chart, transition);
        chart.getZoomLevel = ()=>$009710f418dccc36$var$getZoomLevel(chart);
        chart.getInitialScaleBounds = ()=>$009710f418dccc36$var$getInitialScaleBounds(chart);
        chart.isZoomedOrPanned = ()=>$009710f418dccc36$var$isZoomedOrPanned(chart);
    },
    beforeEvent (chart) {
        const state = $009710f418dccc36$var$getState(chart);
        if (state.panning || state.dragging) // cancel any event handling while panning or dragging
        return false;
    },
    beforeUpdate: function(chart, args, options) {
        const state = $009710f418dccc36$var$getState(chart);
        state.options = options;
        $009710f418dccc36$var$addListeners(chart, options);
    },
    beforeDatasetsDraw (chart, _args, options) {
        $009710f418dccc36$var$draw(chart, 'beforeDatasetsDraw', options);
    },
    afterDatasetsDraw (chart, _args, options) {
        $009710f418dccc36$var$draw(chart, 'afterDatasetsDraw', options);
    },
    beforeDraw (chart, _args, options) {
        $009710f418dccc36$var$draw(chart, 'beforeDraw', options);
    },
    afterDraw (chart, _args, options) {
        $009710f418dccc36$var$draw(chart, 'afterDraw', options);
    },
    stop: function(chart) {
        $009710f418dccc36$var$removeListeners(chart);
        if (0, (/*@__PURE__*/$parcel$interopDefault($cebfe6726e901212$exports))) $009710f418dccc36$var$stopHammer(chart);
        $009710f418dccc36$var$removeState(chart);
    },
    panFunctions: $009710f418dccc36$var$panFunctions,
    zoomFunctions: $009710f418dccc36$var$zoomFunctions,
    zoomRectFunctions: $009710f418dccc36$var$zoomRectFunctions
};


const $854549d671bc593b$export$ca9606c5da0d1e68 = {
    AQT530: {
        names: [
            {
                name: 'aqt.env.temp',
                label: 'Temperature'
            },
            {
                name: 'aqt.env.humidity',
                label: 'Humidity'
            },
            {
                name: 'aqt.env.pressure',
                label: 'Pressure'
            },
            {
                name: 'aqt.gas.co',
                label: 'co'
            },
            {
                name: 'aqt.gas.no',
                label: 'no'
            },
            {
                name: 'aqt.gas.no2',
                label: 'no2'
            },
            {
                name: 'aqt.gas.ozone',
                label: 'ozone'
            },
            // {name: 'aqt.house.datetime'}
            // {name: 'aqt.house.uptime'}
            {
                name: 'aqt.particle.pm1',
                label: 'pm1'
            },
            {
                name: 'aqt.particle.pm2.5',
                label: 'pm2.5'
            },
            {
                name: 'aqt.particle.pm10',
                label: 'pm10'
            }
        ]
    },
    WXT536: {
        start: '-1h',
        names: [
            {
                name: 'wxt.env.temp',
                label: 'Temperature'
            },
            {
                name: 'wxt.env.humidity',
                label: 'Humidity'
            },
            {
                name: 'wxt.env.pressure',
                label: 'Pressure'
            },
            {
                name: 'wxt.rain.accumulation',
                label: 'Rain Accum.'
            },
            {
                name: 'wxt.hail.accumulation',
                label: 'Hail Accum.'
            },
            {
                name: 'wxt.wind.direction',
                label: 'Wind Direction'
            },
            {
                name: 'wxt.wind.speed',
                label: 'Wind Speed'
            }
        ]
    },
    BME680: {
        names: [
            {
                name: 'env.temperature',
                label: 'Temperature',
                units: "\xb0C"
            },
            {
                name: 'env.relative_humidity',
                label: 'Humidity',
                units: '%'
            },
            {
                name: 'env.pressure',
                label: 'Pressure',
                units: 'Pa'
            }
        ],
        sensor: 'bme680'
    },
    'RG-15': {
        names: [
            {
                name: 'env.raingauge.event_acc',
                label: 'Rainfall',
                units: 'mm'
            }
        ]
    },
    'ES-642': {
        names: [
            {
                name: 'env.temperature',
                label: 'Temperature',
                units: "\xb0C"
            },
            {
                name: 'env.relative_humidity',
                label: 'Humidity',
                units: '%'
            },
            {
                name: 'env.pressure',
                label: 'Pressure',
                units: 'Pa'
            },
            {
                name: 'env.air_quality.conc',
                label: 'Air Quality',
                units: "mg/m\xb3"
            },
            {
                name: 'env.air_quality.flow',
                label: 'Air Flow'
            }
        ],
        sensor: 'es642'
    },
    'LI-7500DS': {
        start: '-1h',
        names: [
            {
                name: 'co2.absolute_water'
            },
            {
                name: 'co2.absolute_water_offset'
            },
            {
                name: 'co2.density'
            },
            {
                name: 'co2.mg_per_m3'
            },
            {
                name: 'co2.mole_fraction'
            },
            {
                name: 'co2.raw'
            },
            {
                name: 'co2.signal_strength'
            },
            {
                name: 'dew_point'
            },
            {
                name: 'h2o.absolute_water'
            },
            {
                name: 'h2o.absolute_water_offset'
            },
            {
                name: 'h2o.density'
            },
            {
                name: 'h2o.g_per_m3'
            },
            {
                name: 'h2o.mole_fraction'
            },
            {
                name: 'h2o.raw'
            },
            {
                name: 'pressure'
            },
            {
                name: 'sonic.speed_of_sound'
            },
            {
                name: 'sonic.temperature'
            },
            {
                name: 'sonic.u'
            },
            {
                name: 'sonic.v'
            },
            {
                name: 'sonic.w'
            },
            {
                name: 'temperature'
            }
        ],
        sensor: 'LI7500DS/uSonic-3'
    },
    SFM1x: {
        // lora device
        names: [
            {
                name: 'uncorrected_inner|uncorrected_outer',
                label: 'Uncorrected Inner/Outer'
            }
        ]
    },
    MPU6050: {
        names: [
            {
                name: 'env.pitch.hut',
                label: 'Hut Pitch'
            },
            {
                name: 'env.roll.hut',
                label: 'Hut Roll'
            },
            {
                name: 'env.yaw.hut',
                label: 'Hut Yaw'
            }
        ]
    },
    AHT21: {
        names: [
            {
                name: 'env.humidity.hut',
                label: 'Hut Humidity'
            },
            {
                name: 'env.temperature.hut',
                label: 'Hut Temperature'
            }
        ]
    },
    'GS-MPPT-60': {
        names: [
            {
                name: 'env.solar.current.array',
                label: 'array'
            },
            {
                name: 'env.solar.current.load',
                label: 'load'
            },
            {
                name: 'env.solar.current.system.battery',
                label: 'system.battery'
            },
            {
                name: 'env.solar.current.system.charging',
                label: 'system.charging'
            },
            {
                name: 'env.solar.current.system.load',
                label: 'system.load'
            },
            {
                name: 'env.solar.state.charging',
                label: 'state.charging'
            },
            {
                name: 'env.solar.state.load',
                label: 'state.load'
            },
            {
                name: 'env.solar.temperature.battery',
                label: 'temperature.battery'
            },
            {
                name: 'env.solar.temperature.heatsink',
                label: 'temperature.heatsink'
            },
            {
                name: 'env.solar.voltage.array',
                label: 'voltage.array'
            },
            {
                name: 'env.solar.voltage.battery',
                label: 'voltage.battery'
            },
            {
                name: 'env.solar.voltage.battery.sense',
                label: 'voltage.battery.sense'
            },
            {
                name: 'env.solar.voltage.load',
                label: 'voltage.load'
            }
        ]
    },
    'EXO_sonde': {
        names: [
            // { name: 'battery', label: 'Battery' },
            // { name: 'conductivity', label: 'Conductivity' },
            {
                name: 'device_id'
            },
            // { name: 'env_battery_v', label: 'Env_battery_v' },
            // { name: 'env_conductivity_ms_cm', label: 'Env_conductivity_ms_cm' },
            {
                name: 'env_conductivity_us_cm'
            },
            {
                name: 'env_external_power_v'
            },
            // { name: 'env_fdom_qsu', label: 'Env_fdom_qsu' },
            {
                name: 'env_fdom_rfu'
            },
            // { name: 'env_nlf_conductivity_ms_cm', label: 'Env_nlf_conductivity_ms_cm' },
            // { name: 'env_nlf_conductivity_us_cm', label: 'Env_nlf_conductivity_us_cm' },
            // { name: 'env_odo__sat', label: 'Env_odo__sat' },
            // { name: 'env_odo__satlocal', label: 'Env_odo__satlocal' },
            {
                name: 'env_odo_mg_l'
            },
            // { name: 'env_salinity_ppt', label: 'Env_salinity_ppt' },
            {
                name: 'env_sampling_period'
            },
            // { name: 'env_specific_conductance_ms_cm', label: 'Env_specific_conductance_ms_cm' },
            // { name: 'env_specific_conductance_us_cm', label: 'Env_specific_conductance_us_cm' },
            {
                name: 'env_temperature_c'
            },
            // { name: 'env_temperature_f', label: 'Env_temperature_f' },
            // { name: 'env_temperature_k', label: 'Env_temperature_k' },
            // { name: 'env_wiper_peak_current_ma', label: 'Env_wiper_peak_current_ma' },
            // { name: 'env_wiper_position_v', label: 'Env_wiper_position_v' },
            // { name: 'external_power', label: 'External_power' },
            // { name: 'fdom', label: 'Fdom' },
            // { name: 'nlf_conductivity', label: 'Nlf_conductivity' },
            // { name: 'odo', label: 'Odo' },
            // { name: 'raw_payload', label: 'Raw_payload' },  <!----- reporting recently, but hidden
            // { name: 'salinity', label: 'Salinity' },
            // { name: 'sampling_period', label: 'Sampling_period' },
            // { name: 'signal.pl', label: 'Pl' },
            // { name: 'signal.rssi', label: 'Rssi' },
            // { name: 'signal.snr', label: 'Snr' },
            // { name: 'signal.spreadingfactor', label: 'Spreadingfactor' },
            // { name: 'specific_conductance', label: 'Specific_conductance' },
            // { name: 'temperature', label: 'Temperature' },
            {
                name: 'version'
            }
        ]
    },
    'MFR_node': {
        names: [
            {
                name: 'air_temperature',
                label: 'Air Temp'
            },
            {
                name: 'barometric_pressure',
                label: 'Barometric Pressure'
            },
            {
                name: 'water_conductivity',
                label: 'Water Conductivity'
            },
            {
                name: 'water_depth',
                label: 'Water Depth'
            },
            {
                name: 'water_temperature',
                label: 'Water Temp'
            },
            {
                name: 'heat_flux',
                label: 'Heat Flux'
            },
            {
                name: 'relative_humidity',
                label: 'Relative Humidity'
            },
            {
                name: 'signal.spreadingfactor',
                label: 'Spreadingfactor'
            },
            {
                name: 'solar_voltage',
                label: 'Solar Voltage'
            },
            {
                name: 'total_net_radiation',
                label: 'Total Net Radiation'
            },
            {
                name: 'vapour_pressure_deficit',
                label: 'Vapour Pressure Deficit'
            },
            {
                'name': 'frequency',
                'label': 'Frequency'
            },
            {
                'name': 'header',
                'label': 'Header'
            },
            {
                'name': 'signal.snr',
                'label': 'Snr'
            },
            {
                'name': 'signal.rssi',
                'label': 'Rssi'
            },
            {
                'name': 'uptime',
                'label': 'Uptime'
            },
            {
                'name': 'voltage_adc',
                'label': 'Voltage_adc'
            },
            {
                'name': 'net_longwave',
                'label': 'Net_longwave'
            },
            {
                'name': 'net_shortwave',
                'label': 'Net_shortwave'
            },
            {
                'name': 'packet_type',
                'label': 'Packet_type'
            },
            {
                'name': 'payload_version',
                'label': 'Payload_version'
            },
            {
                'name': 'battery_voltage',
                'label': 'Battery_voltage'
            },
            {
                'name': 'charging_state',
                'label': 'Charging_state'
            },
            {
                'name': 'command',
                'label': 'Command'
            },
            {
                'name': 'digital_count',
                'label': 'Digital_count'
            },
            {
                'name': 'fault',
                'label': 'Fault'
            },
            {
                'name': 'vwc_d1',
                'label': 'Vwc_d1'
            },
            {
                'name': 'vwc_d2',
                'label': 'Vwc_d2'
            },
            {
                'name': 'vwc_d3',
                'label': 'Vwc_d3'
            },
            {
                'name': 'vwc_d4',
                'label': 'Vwc_d4'
            },
            {
                'name': 'temp_d1',
                'label': 'Temp_d1'
            },
            {
                'name': 'temp_d2',
                'label': 'Temp_d2'
            },
            {
                'name': 'temp_d3',
                'label': 'Temp_d3'
            },
            {
                'name': 'temp_d4',
                'label': 'Temp_d4'
            }
        ]
    },
    'RAK10701': {
        'names': [
            {
                'name': 'signal.pl',
                'label': 'PL'
            },
            {
                'name': 'signal.plr',
                'label': 'PLR'
            },
            {
                'name': 'signal.rssi',
                'label': 'RSSI'
            },
            {
                'name': 'signal.snr',
                'label': 'SNR'
            },
            {
                'name': 'signal.spreadingfactor',
                'label': 'Spreading Factor'
            }
        ]
    }
};
const $854549d671bc593b$export$5aa079670cd594b5 = {
    'microgram per cubic meter': "\u03BCg/m\xb3",
    'percent relative humidity': 'RH',
    'percent': '%',
    'ppm': 'PPM',
    'degrees Celsius': "\xb0C",
    'degree Celsius': "\xb0C",
    'degrees': "\xb0",
    'degree': "\xb0",
    'milimeters': 'mm',
    'meters per second': 'm/s',
    'hits per square centimeter': "hits / cm\xb2",
    'hectoPascal': 'hPa',
    'mg/m^2': "mg/m\xb2",
    'mg/m^3': "mg/m\xb3",
    'unit': ' '
};
/* other recent units
  'hPa'
  'UTC time'
  'seconds'
  'YYYY-MM-DD'
  '°C'
  'g/m^3'
  'kPa'
  'm/s'
  'HH:MM:SS'
  'ns'
  's'
  'volts'
*/ const $854549d671bc593b$export$534de2520f191712 = [
    'microphone',
    'gps',
    'bme280',
    'Lorawan Antenna',
    'lorawan',
    'Device_2',
    'MFR_node_MNLA4O102'
];


(0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register((0, $216d2bdc6f281bf6$export$28c660c63b792dea), (0, $216d2bdc6f281bf6$export$ed247974535929c7), (0, $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0), (0, $216d2bdc6f281bf6$export$e97d5dc64e999004), (0, $216d2bdc6f281bf6$export$55e463fa7bcd3469), (0, $216d2bdc6f281bf6$export$bd159b522b230b7a), (0, $216d2bdc6f281bf6$export$e7f4e5e8656f0b93), (0, $216d2bdc6f281bf6$export$a894c72689ff3ec), (0, $216d2bdc6f281bf6$export$29e663ba4d09fe7), (0, $216d2bdc6f281bf6$export$a16ed71bf4b07672), (0, $216d2bdc6f281bf6$export$f99233281efd08a0), (0, $216d2bdc6f281bf6$export$be17f937e9aa7533), (0, $009710f418dccc36$export$2e2bcd8739ae039));
const $8c2d9704d1d32119$export$b235c79ac8d2dc4 = 10000;
const $8c2d9704d1d32119$var$lineConfig = {
    type: 'line',
    options: {
        animation: false,
        parsing: false,
        interaction: {
            mode: 'nearest',
            intersect: false
        },
        scales: {
            x: {
                type: 'time'
            }
        },
        plugins: {
            decimation: {
                enabled: true,
                threshold: $8c2d9704d1d32119$export$b235c79ac8d2dc4,
                algorithm: 'lttb'
            },
            zoom: {
                pan: {
                    enabled: true,
                    modifierKey: 'ctrl'
                },
                zoom: {
                    drag: {
                        enabled: true
                    },
                    mode: 'x',
                    onZoomComplete: ()=>{}
                }
            },
            tooltip: {
                callbacks: {
                    label: (context)=>{
                        let label = context.dataset.label || '';
                        if (label) label += ': ';
                        if (context.parsed.y !== null) {
                            const { y: y, meta: meta } = context.parsed;
                            label += `${y} ${(0, $854549d671bc593b$export$5aa079670cd594b5)[meta.units] || meta.units || ''}`;
                        }
                        return label;
                    }
                }
            }
        }
    }
};
const $8c2d9704d1d32119$var$barConfig = {
    type: 'bar',
    scales: {
        y: {
            display: true,
            min: 0
        }
    }
};
const $8c2d9704d1d32119$var$histogramConfig = {
    type: 'bar',
    options: {
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Bins'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Frequency'
                }
            }
        }
    }
};
function $8c2d9704d1d32119$export$6df1c00318459dc5(records, opts, siteIDs) {
    const datasets = [];
    const byName = (0, $f1q41.groupBy)(records, 'name');
    let idx = 0;
    Object.keys(byName).forEach((name)=>{
        const namedData = byName[name];
        const grouped = (0, $f1q41.groupBy)(namedData, (o)=>{
            const { sensor: sensor, zone: zone, deviceName: deviceName, vsn: vsn } = o.meta;
            const node = siteIDs ? (0, $eOilY.vsnToDisplayStr)(vsn, siteIDs[vsn]) : vsn;
            if (sensor && zone) return `${node}; ${sensor}; ${zone}`;
            else if (sensor) return `${node}; ${sensor}`;
            else if (deviceName) return `${node}; ${deviceName};`;
            else return node;
        });
        const hasGroup = Object.keys(grouped)[0] != 'undefined';
        Object.keys(grouped).forEach((key)=>{
            const d = grouped[key].map((o)=>({
                    x: new Date(o.timestamp).getTime(),
                    y: o.value,
                    meta: o.meta
                })).sort((a, b)=>a.x - b.x);
            datasets.push({
                label: name + (hasGroup ? `; ${key}` : ''),
                data: d,
                pointRadius: opts.showPoints ? 3 : 0,
                showLine: opts.showLines,
                borderColor: (0, $b0a93f4c47fccf6f$export$2e2bcd8739ae039)[idx % 10],
                borderWidth: 1
            });
            idx += 1;
        });
    });
    return datasets;
}
function $8c2d9704d1d32119$var$getCountData(records) {
    const items = (0, $f1q41.chain)(records).countBy('name').map((val, key)=>({
            name: key,
            value: val
        })).sortBy('value').reverse().value();
    const labels = items.map((o)=>o.name);
    const data = items.map((o)=>o.value);
    return {
        labels: labels,
        datasets: [
            {
                label: 'frequency',
                data: data,
                backgroundColor: labels.map((_, i)=>(0, $b0a93f4c47fccf6f$export$2e2bcd8739ae039)[i % 10])
            }
        ]
    };
}
function $8c2d9704d1d32119$var$getSumData(records) {
    const items = (0, $f1q41.chain)(records).groupBy('name').map((objs, key)=>({
            name: key,
            value: (0, $f1q41.sumBy)(objs, 'value')
        })).sortBy('value').reverse().value();
    const labels = items.map((o)=>o.name);
    const data = items.map((o)=>o.value);
    return {
        labels: labels,
        datasets: [
            {
                label: 'sums',
                data: data,
                backgroundColor: labels.map((_, i)=>(0, $b0a93f4c47fccf6f$export$2e2bcd8739ae039)[i % 10])
            }
        ]
    };
}
// todo: internationalize
const $8c2d9704d1d32119$var$days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const $8c2d9704d1d32119$var$months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $8c2d9704d1d32119$var$getBinLabels = (bins, binBy)=>{
    if (binBy == 'value') return bins.map(({ x0: x0, x1: x1 })=>`${x0} - ${x1}`);
    else if (binBy == 'hour') return bins.map(({ x0: x0, x1: x1 })=>`${x0 < 10 ? '0' : ''}${x0}:00 - ${x1}:00`);
    else if (binBy == 'day') return bins.map((bin)=>$8c2d9704d1d32119$var$days[bin.x0]);
    else if (binBy == 'month') return bins.map((bin)=>$8c2d9704d1d32119$var$months[bin.x0]);
    else if (binBy == 'dayOfYear') return bins.map(({ x1: x1 })=>`${x1 + 1}`) // starting index of 1
    ;
    else if (binBy == 'time') return bins.map(({ x0: x0 })=>`${x0.toLocaleDateString()} ${x0.toLocaleTimeString()}`);
    else {
        alert(`Note: binBy option "${binBy}" is not recognized.`);
        return bins.map(({ x0: x0, x1: x1 })=>`${x0} - ${x1}`);
    }
};
function $8c2d9704d1d32119$var$thresholdTime(n) {
    return (data, min, max)=>{
        return $dc1c498a1ad915c1$exports.scaleUtc().domain([
            min,
            max
        ]).ticks(n);
    };
}
function $8c2d9704d1d32119$var$daysIntoYear(date) {
    return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
}
const $8c2d9704d1d32119$var$timeAgg = {
    hour: (date)=>date.getHours(),
    day: (date)=>date.getDay(),
    dayOfYear: (date)=>$8c2d9704d1d32119$var$daysIntoYear(date),
    month: (date)=>date.getMonth()
};
const $8c2d9704d1d32119$var$timeUpper = {
    hour: 24,
    day: 7,
    dayOfYear: 366,
    month: 12
};
function $8c2d9704d1d32119$var$getHistogramData(args) {
    const { data: data, binBy: binBy = 'value' } = args;
    const thresholds = args.thresholds || 20;
    let bins;
    if (binBy == 'value') {
        const key = 'value';
        const min = Number((0, $f1q41.minBy)(data, key)[key]);
        const max = Number((0, $f1q41.maxBy)(data, key)[key]);
        bins = $dc1c498a1ad915c1$exports.bin().value((d)=>d[key]).domain([
            min,
            max
        ]).thresholds(thresholds)(data);
    } else if (binBy == 'time') bins = $dc1c498a1ad915c1$exports.bin().value((d)=>new Date(d['timestamp'])).thresholds($8c2d9704d1d32119$var$thresholdTime(thresholds))(data);
    else bins = $dc1c498a1ad915c1$exports.bin().value((d)=>$8c2d9704d1d32119$var$timeAgg[binBy](new Date(d['timestamp']))).domain([
        0,
        $8c2d9704d1d32119$var$timeUpper[binBy]
    ]).thresholds($8c2d9704d1d32119$var$timeUpper[binBy])(data);
    const counts = bins.map((bin)=>bin.length);
    return {
        labels: $8c2d9704d1d32119$var$getBinLabels(bins, binBy),
        datasets: [
            {
                label: 'Count',
                data: counts,
                backgroundColor: (0, $b0a93f4c47fccf6f$export$2e2bcd8739ae039)[0]
            }
        ]
    };
}
var $8c2d9704d1d32119$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)(function TimeSeries(props) {
    const { data: data, chartOpts: opts, siteIDs: siteIDs, onChange: onChange } = props;
    const chartRef = (0, $acw62.useRef)();
    const [chart, setChart] = (0, $acw62.useState)(null);
    const [disableDownsampling, setDisableDownsampling] = (0, $acw62.useState)(false);
    const [isZoomed, setIsZoomed] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const { type: type } = opts;
        let datasets;
        if (type == 'frequency') datasets = $8c2d9704d1d32119$var$getCountData(data);
        else if (type == 'sum') datasets = $8c2d9704d1d32119$var$getSumData(data);
        else if (type == 'histogram') {
            const { binBy: binBy, thresholds: thresholds } = opts;
            datasets = $8c2d9704d1d32119$var$getHistogramData({
                data: data,
                binBy: binBy,
                thresholds: thresholds
            });
        } else datasets = $8c2d9704d1d32119$export$6df1c00318459dc5(data, opts, siteIDs);
        let config;
        if (type == 'frequency') config = {
            ...$8c2d9704d1d32119$var$barConfig,
            data: {
                ...datasets
            }
        };
        else if (type == 'sum') config = {
            ...$8c2d9704d1d32119$var$barConfig,
            data: {
                ...datasets
            }
        };
        else if (type == 'histogram') config = {
            ...$8c2d9704d1d32119$var$histogramConfig,
            data: {
                ...datasets
            }
        };
        else {
            $8c2d9704d1d32119$var$lineConfig.options.plugins.decimation.enabled = !disableDownsampling;
            $8c2d9704d1d32119$var$lineConfig.options.plugins.zoom.zoom.onZoomComplete = ()=>setIsZoomed(true);
            config = {
                ...$8c2d9704d1d32119$var$lineConfig,
                data: {
                    datasets: datasets
                }
            };
        }
        if (chart) chart.destroy();
        const c = new (0, $216d2bdc6f281bf6$export$acaa6426d77a227e)(chartRef.current, config);
        setChart(c);
    }, [
        data,
        opts,
        disableDownsampling
    ]);
    const handleOpts = (evt, option)=>{
        const target = evt.target;
        const val = evt.target.type == 'checkbox' ? target.checked : target.value;
        onChange({
            ...opts,
            [option]: val
        });
    };
    const handleZoomReset = ()=>{
        chart.resetZoom();
        setIsZoomed(false);
    };
    const { type: type, binBy: binBy = 'value', thresholds: thresholds = 20 } = opts;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8c2d9704d1d32119$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
                ref: chartRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($8c2d9704d1d32119$var$Ctrls, {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-centern gap",
                        children: [
                            type == 'timeseries' && isZoomed && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleZoomReset,
                                color: "primary",
                                variant: "contained",
                                children: "Reset zoom"
                            }),
                            type == 'timeseries' && data.length >= $8c2d9704d1d32119$export$b235c79ac8d2dc4 && chart && /*#__PURE__*/ (0, $ayMG0.jsxs)($8c2d9704d1d32119$var$DownsampleOpts, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                                        onClick: ()=>setDisableDownsampling((prev)=>!prev),
                                        children: [
                                            !disableDownsampling ? 'Disable' : 'Enable',
                                            " downsampling"
                                        ]
                                    }),
                                    !disableDownsampling && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            "Note: data in this chart has been downsampled using ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: "http://hdl.handle.net/1946/15343",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "LTTB"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center gap",
                        children: [
                            type == 'timeseries' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8c2d9704d1d32119$var$CB, {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                            checked: opts.showLines,
                                            onChange: (evt)=>handleOpts(evt, 'showLines')
                                        }),
                                        label: "lines"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($8c2d9704d1d32119$var$CB, {
                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                            checked: opts.showPoints,
                                            onChange: (evt)=>handleOpts(evt, 'showPoints')
                                        }),
                                        label: "points"
                                    })
                                ]
                            }),
                            type == 'histogram' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
                                        row: true,
                                        "aria-labelledby": "demo-radio-buttons-group-label",
                                        name: "radio-buttons-group",
                                        value: binBy || 'value',
                                        onChange: (evt)=>handleOpts(evt, 'binBy'),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                value: "value",
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                                label: "By Value"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                value: "hour",
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                                label: "By Hour"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                value: "day",
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                                label: "By Day of Week"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                value: "month",
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                                label: "By Month"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                value: "time",
                                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                                label: "By Time w/Thresholds"
                                            })
                                        ]
                                    }),
                                    [
                                        'value',
                                        'time'
                                    ].includes(binBy) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        type: "number",
                                        placeholder: "20",
                                        value: thresholds,
                                        onChange: (evt)=>handleOpts(evt, 'thresholds'),
                                        label: "Thresholds",
                                        slotProps: {
                                            inputLabel: {
                                                shrink: true
                                            }
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                        id: "chart-type",
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                                        labelId: "chart-type",
                                        value: type,
                                        onChange: (evt)=>handleOpts(evt, 'type'),
                                        label: "Type",
                                        margin: "dense",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "timeseries",
                                                children: "Timeseries"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "frequency",
                                                children: "Frequency"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "sum",
                                                children: "Sum"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                value: "histogram",
                                                children: "Histogram (distribution)"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}, (prev, next)=>prev.data === next.data && JSON.stringify(prev.chartOpts) === JSON.stringify(next.chartOpts));
const $8c2d9704d1d32119$var$Root = (0, $lmFrL.default).div`
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 1em;
`;
const $8c2d9704d1d32119$var$DownsampleOpts = (0, $lmFrL.default).div`
  button {
    margin: 0 5px 2px 0;
  }
`;
const $8c2d9704d1d32119$var$Ctrls = (0, $lmFrL.default).div`
  margin-top: 1em;
`;
const $8c2d9704d1d32119$var$CB = (0, $lmFrL.default)((0, $2esSG.default))`
  .MuiFormControlLabel-label {
    font-size: 1em;
  }
`;


(0, $216d2bdc6f281bf6$export$acaa6426d77a227e).register((0, $216d2bdc6f281bf6$export$28c660c63b792dea), (0, $216d2bdc6f281bf6$export$ed247974535929c7), (0, $216d2bdc6f281bf6$export$3c9b5d28c11cbfd0), (0, $216d2bdc6f281bf6$export$e97d5dc64e999004), (0, $216d2bdc6f281bf6$export$55e463fa7bcd3469), (0, $216d2bdc6f281bf6$export$bd159b522b230b7a), (0, $216d2bdc6f281bf6$export$e7f4e5e8656f0b93), (0, $216d2bdc6f281bf6$export$a894c72689ff3ec), (0, $216d2bdc6f281bf6$export$29e663ba4d09fe7), (0, $216d2bdc6f281bf6$export$a16ed71bf4b07672), (0, $216d2bdc6f281bf6$export$f99233281efd08a0), (0, $216d2bdc6f281bf6$export$be17f937e9aa7533));
const $69dfb5e45b536e0a$var$lineConfig = {
    type: 'line',
    options: {
        events: [],
        animation: false,
        responsive: false,
        interaction: {
            mode: 'nearest',
            intersect: false
        },
        scales: {
            x: {
                type: 'time',
                display: false
            },
            y: {
                display: false
            }
        },
        plugins: {
            legend: {
                display: false,
                labels: {
                    // @ts-ignore
                    display: false
                }
            },
            tooltip: {
                enabled: false
            }
        }
    }
};
function $69dfb5e45b536e0a$export$2e2bcd8739ae039(props) {
    const { data: data } = props;
    const ref = (0, $acw62.useRef)(null);
    const [chart, setChart] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!data) return;
        if (chart) chart.destroy();
        const datasets = (0, $8c2d9704d1d32119$export$6df1c00318459dc5)(data, {
            showLines: true,
            showPoints: false
        });
        const config = {
            ...$69dfb5e45b536e0a$var$lineConfig,
            data: {
                datasets: datasets
            }
        };
        const c = new (0, $216d2bdc6f281bf6$export$acaa6426d77a227e)(ref.current, config);
        setChart(c);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($69dfb5e45b536e0a$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
            ref: ref
        })
    });
}
const $69dfb5e45b536e0a$var$Root = (0, $lmFrL.default).span`
  canvas {
    max-height: 50px;
    min-width: 100%;
    max-width: 50px;
  }
`;



const $06526ad812440b77$var$getClassName = (timestamp, inactive)=>inactive ? 'inactive font-bold nowrap' : (0, $lffEs.isOldData)(timestamp) ? 'failed font-bold nowrap' : 'muted nowrap';
const $06526ad812440b77$var$renderValue = (value, format, meta, item)=>{
    if (value == 'loading') return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "muted",
        children: "loading..."
    });
    else if (value != 'loading' && format) return format(value);
    else if (value == null) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "muted",
        children: "n/a"
    });
    return `${value}${(0, $854549d671bc593b$export$5aa079670cd594b5)[meta.units] || meta.units || item.units || ''}`;
};
var $06526ad812440b77$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)(function RecentDataTable(props) {
    const { title: title, previewLabel: previewLabel, items: items, showSparkline: showSparkline = true, className: className, inactive: inactive = false } = props;
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [recentData, setRecentData] = (0, $acw62.useState)(items.reduce((acc, o)=>({
            ...acc,
            [o.query.name]: {
                value: 'loading'
            }
        }), {}));
    const [sparkLines, setSparkLines] = (0, $acw62.useState)({});
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        const proms = [];
        for (const item of items){
            const { query: query } = item;
            const { name: name } = query;
            const p = $bcnr1.getRecentRecord(query).then((data)=>{
                // take latest record for latest value
                const d = data.pop();
                if (!d) {
                    // find for latest record
                    const q = {
                        ...query,
                        tail: 1,
                        start: '-999y'
                    };
                    $bcnr1.getRecentRecord(q).then((data)=>{
                        const d = data.pop();
                        if (!d) {
                            setRecentData((prev)=>({
                                    ...prev,
                                    [name]: null
                                }));
                            return;
                        }
                        setRecentData((prev)=>({
                                ...prev,
                                [name]: d
                            }));
                    }).catch((err)=>{
                        setRecentData((prev)=>({
                                ...prev,
                                [name]: null
                            }));
                        setError(err);
                    });
                    return;
                }
                setRecentData((prev)=>({
                        ...prev,
                        [name]: d
                    }));
                setSparkLines((prev)=>({
                        ...prev,
                        [name]: data
                    }));
            }).catch((err)=>{
                setRecentData((prev)=>({
                        ...prev,
                        [name]: null
                    }));
                setError(err);
            });
            proms.push(p);
        }
        Promise.allSettled(proms).finally(()=>setLoading(false));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($06526ad812440b77$var$Root, {
        children: [
            recentData && /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                className: `simple key-value ${className}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: title || ''
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: "latest time"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: previewLabel || 'Last 24 Hours'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: "value",
                                    children: "value"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: items.map((item)=>{
                            const { query: query, label: label, format: format, linkParams: linkParams } = item;
                            const { name: name, sensor: sensor } = query;
                            const data = recentData[name];
                            const { value: value, timestamp: timestamp, meta: meta } = data || {};
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        children: [
                                            label || name,
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                                                    children: "name"
                                                                }),
                                                                ": ",
                                                                name
                                                            ]
                                                        }),
                                                        sensor && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                                                    children: "sensor"
                                                                }),
                                                                ": ",
                                                                sensor
                                                            ]
                                                        }),
                                                        meta?.units && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                                                    children: "meta.units"
                                                                }),
                                                                ": ",
                                                                meta.units
                                                            ]
                                                        }),
                                                        item.units && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                            children: [
                                                                "configured units: ",
                                                                item.units
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                placement: "left",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                                    to: `/data/ontology/${name}`,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($06526ad812440b77$var$HelpIcon, {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                        className: $06526ad812440b77$var$getClassName(timestamp, inactive),
                                        children: [
                                            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                title: new Date(timestamp).toLocaleString(),
                                                placement: "right",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    children: (0, $lffEs.relativeTime)(timestamp)
                                                })
                                            }),
                                            !timestamp && '-'
                                        ]
                                    }),
                                    !showSparkline && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: data && linkParams && data.value != 'loading' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                            to: `/query-browser?${linkParams(data)}`,
                                            children: "more..."
                                        })
                                    }),
                                    showSparkline && /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: data && linkParams && data.value != 'loading' && /*#__PURE__*/ (0, $ayMG0.jsx)($06526ad812440b77$var$SparkLineLink, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                                                to: `/query-browser?${linkParams(data)}`,
                                                target: "_blank",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69dfb5e45b536e0a$export$2e2bcd8739ae039), {
                                                        data: sparkLines[name]
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($371cde9cd7137df5$exports))), {})
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        className: "value",
                                        children: $06526ad812440b77$var$renderValue(value, format, meta, item)
                                    })
                                ]
                            }, name);
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error.message
            })
        ]
    });
}, (prev, next)=>prev.items != next.items);
const $06526ad812440b77$var$Root = (0, $d8seH.default)('div')`
  thead th {
    color: #fff;
    background: #4e2a84;
    :first-child { border-radius: 4px 0 0 0; }
    :last-child { border-radius: 0px 4px 0 0; }
  }

  table thead th:not(:first-child) {
    color: #e9dbff;
  }

  tr:not(:first-child) {
    border-top: 1px solid ${(props)=>props.theme.palette.divider};
  }
  thead tr {
    border-top: 1px solid ${(props)=>props.theme.palette.divider};
  }

  .value {
    text-align: right;
  }
`;
const $06526ad812440b77$var$HelpIcon = (0, $d8seH.default)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))))`
  position: absolute;
  width: 12px;
  top: 0;
  color: #1c8cc9;
`;
const $06526ad812440b77$var$SparkLineLink = (0, $d8seH.default)('div')`
  &:hover canvas {
    background-color: rgba(0, 0, 0, .3);
  }

  .MuiSvgIcon-root {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    color: #f2f2f2;
    display: none;
  }

  &:hover .MuiSvgIcon-root {
    display: block;
  }
`;
function $06526ad812440b77$export$7d76682e61dc46e7(props) {
    const { title: title, content: content } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($06526ad812440b77$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
            className: `simple key-value`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "muted text-center",
                                children: content || 'Not available'
                            })
                        })
                    })
                })
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $lmFrL = parcelRequire("lmFrL");

var $6lXkL = parcelRequire("6lXkL");

var $cVXaD = parcelRequire("cVXaD");

var $hBKHw = parcelRequire("hBKHw");


var $iwiZ3 = parcelRequire("iwiZ3");

var $lffEs = parcelRequire("lffEs");

var $bcnr1 = parcelRequire("bcnr1");
function $73e08e4740801120$export$2e2bcd8739ae039(props) {
    const { vsn: vsn, cameras: cameras, horizontal: horizontal } = props;
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [images, setImages] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)();
    const [total, setTotal] = (0, $acw62.useState)();
    const [progress, setProgress] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $bcnr1.getRecentImagesV2(vsn, cameras, onStart, onProgress).then((images)=>{
            const hasData = !!Object.keys(images).filter((k)=>images[k]).length;
            setImages(hasData ? images : null);
        }).catch((err)=>{
            setError(err);
        }).finally(()=>setLoading(false));
    }, [
        vsn,
        cameras
    ]);
    const onStart = (name, total)=>{
        setTotal((prev)=>({
                ...prev,
                [name]: total
            }));
    };
    const onProgress = (name, count)=>{
        setProgress((prev)=>({
                ...prev,
                [name]: count
            }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($73e08e4740801120$var$Root, {
        className: horizontal ? 'flex horizontal flex-wrap' : '',
        children: [
            images && cameras.map((name)=>{
                // const title = `${name.charAt(0).toUpperCase()}${name.slice(1)}`
                if (!images[name]) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: name
                    })
                }, name);
                const { timestamp: timestamp, size: size, value: value, meta: meta } = images[name];
                const { task: task } = meta;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            children: name
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: `hover-${name}-camera`,
                            src: value
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                (0, $lffEs.isOldData)(timestamp) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e1b28a5539150830$exports))), {
                                                        className: "failed"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                    title: new Date(timestamp).toLocaleString(),
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                        className: (0, $lffEs.isOldData)(timestamp) ? 'failed' : 'muted',
                                                        children: (0, $lffEs.relativeTime)(timestamp)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            component: (0, $lzNIT.Link),
                                            to: `/query-browser?type=images&tasks=${task}&start=-12h&mimeType=image&page=0&nodes=${vsn}`,
                                            children: "View more..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {}),
                                    href: value,
                                    children: (0, $lffEs.bytesToSizeSI)(size)
                                })
                            ]
                        })
                    ]
                }, name);
            }),
            loading && total && progress && cameras.map((name)=>{
                return total[name] > 0 && total[name] != progress[name] && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: name
                        }),
                        ": Searching ",
                        progress[name],
                        " of ",
                        total[name]
                    ]
                }, name);
            }),
            !loading && !images && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "muted",
                children: "No recent images available"
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error.message
            })
        ]
    });
}
const $73e08e4740801120$var$Root = (0, $lmFrL.default).div`
  &.horizontal > div {
    margin-right: 2em;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");
var $f5de08bd86b7f3d6$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $f5de08bd86b7f3d6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($f5de08bd86b7f3d6$exports, "__esModule", {
    value: true
});
$f5de08bd86b7f3d6$exports.default = void 0;

var $f5de08bd86b7f3d6$var$_createSvgIcon = $f5de08bd86b7f3d6$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $f5de08bd86b7f3d6$var$_default = $f5de08bd86b7f3d6$exports.default = (0, $f5de08bd86b7f3d6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.29 16.29 5.7 12.7a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0"
}), 'CheckCircleRounded');


var $e07848420df079ca$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e07848420df079ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e07848420df079ca$exports, "__esModule", {
    value: true
});
$e07848420df079ca$exports.default = void 0;

var $e07848420df079ca$var$_createSvgIcon = $e07848420df079ca$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e07848420df079ca$var$_default = $e07848420df079ca$exports.default = (0, $e07848420df079ca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1m-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m1-3h-2v-2h2z"
}), 'ErrorOutlineRounded');


var $e970a307f52c04cf$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e970a307f52c04cf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e970a307f52c04cf$exports, "__esModule", {
    value: true
});
$e970a307f52c04cf$exports.default = void 0;

var $e970a307f52c04cf$var$_createSvgIcon = $e970a307f52c04cf$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e970a307f52c04cf$var$_default = $e970a307f52c04cf$exports.default = (0, $e970a307f52c04cf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'RemoveCircleOutlineOutlined');


var $b342ef7cdf5e20bb$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $b342ef7cdf5e20bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($b342ef7cdf5e20bb$exports, "__esModule", {
    value: true
});
$b342ef7cdf5e20bb$exports.default = void 0;

var $b342ef7cdf5e20bb$var$_createSvgIcon = $b342ef7cdf5e20bb$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $b342ef7cdf5e20bb$var$_default = $b342ef7cdf5e20bb$exports.default = (0, $b342ef7cdf5e20bb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');



var $ayMG0 = parcelRequire("ayMG0");
var $ab52c41c421a83ac$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $ab52c41c421a83ac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($ab52c41c421a83ac$exports, "__esModule", {
    value: true
});
$ab52c41c421a83ac$exports.default = void 0;

var $ab52c41c421a83ac$var$_createSvgIcon = $ab52c41c421a83ac$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $ab52c41c421a83ac$var$_default = $ab52c41c421a83ac$exports.default = (0, $ab52c41c421a83ac$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 14h3v6H5z"
}), 'SignalCellularAlt1Bar');


var $02f2d7a9a883e59e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $02f2d7a9a883e59e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($02f2d7a9a883e59e$exports, "__esModule", {
    value: true
});
$02f2d7a9a883e59e$exports.default = void 0;

var $02f2d7a9a883e59e$var$_createSvgIcon = $02f2d7a9a883e59e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $02f2d7a9a883e59e$var$_default = $02f2d7a9a883e59e$exports.default = (0, $02f2d7a9a883e59e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 14h3v6H5zm6-5h3v11h-3z"
}), 'SignalCellularAlt2Bar');


var $1709f843566662ab$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1709f843566662ab$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1709f843566662ab$exports, "__esModule", {
    value: true
});
$1709f843566662ab$exports.default = void 0;

var $1709f843566662ab$var$_createSvgIcon = $1709f843566662ab$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1709f843566662ab$var$_default = $1709f843566662ab$exports.default = (0, $1709f843566662ab$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z"
}), 'SignalCellularAlt');



var $cVXaD = parcelRequire("cVXaD");

var $dxMBG = parcelRequire("dxMBG");
const $1224d5d5c3fec551$var$IconWrapper = (0, $dxMBG.default)('div')({
    position: 'relative',
    display: 'inline-block'
});
const $1224d5d5c3fec551$var$BaseIcon = (0, $dxMBG.default)((0, (/*@__PURE__*/$parcel$interopDefault($1709f843566662ab$exports))))({
    fill: 'none',
    stroke: 'black',
    strokeWidth: 0.5
});
const $1224d5d5c3fec551$var$OverlayIcon = (0, $dxMBG.default)('div')({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1
});
const $1224d5d5c3fec551$var$SignalIcon = ({ bars: bars })=>{
    const title = bars === 3 ? 'Strong Signal' : bars === 2 ? 'Moderate Signal' : bars === 1 ? 'Weak Signal' : 'No Signal';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: title,
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($1224d5d5c3fec551$var$IconWrapper, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($1224d5d5c3fec551$var$BaseIcon, {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($1224d5d5c3fec551$var$OverlayIcon, {
                    children: [
                        bars === 3 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1709f843566662ab$exports))), {}),
                        bars === 2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($02f2d7a9a883e59e$exports))), {}),
                        bars === 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab52c41c421a83ac$exports))), {})
                    ]
                })
            ]
        })
    });
};
var $1224d5d5c3fec551$export$2e2bcd8739ae039 = $1224d5d5c3fec551$var$SignalIcon;


var $7e60b91ef098e912$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $7e60b91ef098e912$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($7e60b91ef098e912$exports, "__esModule", {
    value: true
});
$7e60b91ef098e912$exports.default = void 0;

var $7e60b91ef098e912$var$_createSvgIcon = $7e60b91ef098e912$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $7e60b91ef098e912$var$_default = $7e60b91ef098e912$exports.default = (0, $7e60b91ef098e912$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.01 7 16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99"
}), 'Power');



var $ayMG0 = parcelRequire("ayMG0");
var $aee7698c8b25ef20$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $aee7698c8b25ef20$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($aee7698c8b25ef20$exports, "__esModule", {
    value: true
});
$aee7698c8b25ef20$exports.default = void 0;

var $aee7698c8b25ef20$var$_createSvgIcon = $aee7698c8b25ef20$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $aee7698c8b25ef20$var$_default = $aee7698c8b25ef20$exports.default = (0, $aee7698c8b25ef20$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4"
}), 'BatteryFull');


var $5c3b9f395e507c5e$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5c3b9f395e507c5e$require$_interopRequireDefault = $1jnue.default;

var $5c3b9f395e507c5e$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($5c3b9f395e507c5e$exports, "__esModule", {
    value: true
});
$5c3b9f395e507c5e$exports.default = void 0;

var $5c3b9f395e507c5e$var$React = $5c3b9f395e507c5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5c3b9f395e507c5e$var$_createSvgIcon = $5c3b9f395e507c5e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $5c3b9f395e507c5e$var$_default = $5c3b9f395e507c5e$exports.default = (0, $5c3b9f395e507c5e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($5c3b9f395e507c5e$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillOpacity: ".3",
            d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
        })
    ]
}), 'Battery90');


var $c123aa35df928913$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c123aa35df928913$require$_interopRequireDefault = $1jnue.default;

var $c123aa35df928913$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($c123aa35df928913$exports, "__esModule", {
    value: true
});
$c123aa35df928913$exports.default = void 0;

var $c123aa35df928913$var$React = $c123aa35df928913$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c123aa35df928913$var$_createSvgIcon = $c123aa35df928913$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c123aa35df928913$var$_default = $c123aa35df928913$exports.default = (0, $c123aa35df928913$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($c123aa35df928913$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillOpacity: ".3",
            d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
        })
    ]
}), 'Battery80');


var $c9cb0ea7c7c64b4c$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c9cb0ea7c7c64b4c$require$_interopRequireDefault = $1jnue.default;

var $c9cb0ea7c7c64b4c$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($c9cb0ea7c7c64b4c$exports, "__esModule", {
    value: true
});
$c9cb0ea7c7c64b4c$exports.default = void 0;

var $c9cb0ea7c7c64b4c$var$React = $c9cb0ea7c7c64b4c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c9cb0ea7c7c64b4c$var$_createSvgIcon = $c9cb0ea7c7c64b4c$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c9cb0ea7c7c64b4c$var$_default = $c9cb0ea7c7c64b4c$exports.default = (0, $c9cb0ea7c7c64b4c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($c9cb0ea7c7c64b4c$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillOpacity: ".3",
            d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
        })
    ]
}), 'Battery60');


var $6758660ca4bf7768$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6758660ca4bf7768$require$_interopRequireDefault = $1jnue.default;

var $6758660ca4bf7768$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($6758660ca4bf7768$exports, "__esModule", {
    value: true
});
$6758660ca4bf7768$exports.default = void 0;

var $6758660ca4bf7768$var$React = $6758660ca4bf7768$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6758660ca4bf7768$var$_createSvgIcon = $6758660ca4bf7768$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $6758660ca4bf7768$var$_default = $6758660ca4bf7768$exports.default = (0, $6758660ca4bf7768$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($6758660ca4bf7768$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillOpacity: ".3",
            d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
        })
    ]
}), 'Battery50');


var $40d9a8540af250c8$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40d9a8540af250c8$require$_interopRequireDefault = $1jnue.default;

var $40d9a8540af250c8$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($40d9a8540af250c8$exports, "__esModule", {
    value: true
});
$40d9a8540af250c8$exports.default = void 0;

var $40d9a8540af250c8$var$React = $40d9a8540af250c8$require$_interopRequireWildcard((parcelRequire("acw62")));

var $40d9a8540af250c8$var$_createSvgIcon = $40d9a8540af250c8$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $40d9a8540af250c8$var$_default = $40d9a8540af250c8$exports.default = (0, $40d9a8540af250c8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($40d9a8540af250c8$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillOpacity: ".3",
            d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
        })
    ]
}), 'Battery30');


var $46900e8cd41fc05d$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $46900e8cd41fc05d$require$_interopRequireDefault = $1jnue.default;

var $46900e8cd41fc05d$require$_interopRequireWildcard = $27c3440315f0d929$exports.default;
Object.defineProperty($46900e8cd41fc05d$exports, "__esModule", {
    value: true
});
$46900e8cd41fc05d$exports.default = void 0;

var $46900e8cd41fc05d$var$React = $46900e8cd41fc05d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $46900e8cd41fc05d$var$_createSvgIcon = $46900e8cd41fc05d$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $46900e8cd41fc05d$var$_default = $46900e8cd41fc05d$exports.default = (0, $46900e8cd41fc05d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($46900e8cd41fc05d$var$React.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillOpacity: ".3",
            d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
        })
    ]
}), 'Battery20');



var $cVXaD = parcelRequire("cVXaD");

var $dxMBG = parcelRequire("dxMBG");
const $01188c09d8e3a70e$var$IconWrapper = (0, $dxMBG.default)('div')({
    position: 'relative',
    display: 'inline-block'
});
const $01188c09d8e3a70e$var$BatteryEmptyIcon = (0, $dxMBG.default)((0, (/*@__PURE__*/$parcel$interopDefault($aee7698c8b25ef20$exports))))({
    fill: '#c2c2c2'
});
const $01188c09d8e3a70e$var$BatteryIcon = ({ batteryPerc: batteryPerc })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: batteryPerc + '%',
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($01188c09d8e3a70e$var$IconWrapper, {
            children: [
                batteryPerc == 100 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aee7698c8b25ef20$exports))), {}),
                batteryPerc < 100 && batteryPerc >= 90 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5c3b9f395e507c5e$exports))), {}),
                batteryPerc < 90 && batteryPerc >= 80 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c123aa35df928913$exports))), {}),
                batteryPerc < 80 && batteryPerc >= 60 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c9cb0ea7c7c64b4c$exports))), {}),
                batteryPerc < 60 && batteryPerc >= 50 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6758660ca4bf7768$exports))), {}),
                batteryPerc < 50 && batteryPerc >= 30 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($40d9a8540af250c8$exports))), {}),
                batteryPerc < 30 && batteryPerc > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46900e8cd41fc05d$exports))), {}),
                batteryPerc == 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($01188c09d8e3a70e$var$BatteryEmptyIcon, {})
            ]
        })
    });
};
var $01188c09d8e3a70e$export$2e2bcd8739ae039 = $01188c09d8e3a70e$var$BatteryIcon;



var $ipR47 = parcelRequire("ipR47");
var $43c2449ff5c5b42e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $43c2449ff5c5b42e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($43c2449ff5c5b42e$exports, "__esModule", {
    value: true
});
$43c2449ff5c5b42e$exports.default = void 0;

var $43c2449ff5c5b42e$var$_createSvgIcon = $43c2449ff5c5b42e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $43c2449ff5c5b42e$var$_default = $43c2449ff5c5b42e$exports.default = (0, $43c2449ff5c5b42e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5z"
}), 'DescriptionOutlined');



var $cVXaD = parcelRequire("cVXaD");
function $bdde76de382eb768$export$471f7ae5c4103ae1(val, obj) {
    if (!val || val == '1970-01-01T00:00:00Z') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: `No activity`,
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e970a307f52c04cf$exports))), {
            className: "inactive status-icon"
        })
    });
    const lastSeenDate = new Date(val);
    const currentTime = new Date().getTime();
    const formattedLastSeenDate = lastSeenDate.toLocaleString(undefined, {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    let icon;
    let interval_tooltip;
    if (obj.expected_uplink_interval_sec === null || obj.expected_uplink_interval_sec === undefined) {
        interval_tooltip = 'Expected Interval: Not set';
        icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b342ef7cdf5e20bb$exports))), {
            className: "QuestionIcon status-icon"
        });
    } else {
        const expectedLastSeenTime = new Date(currentTime - obj.expected_uplink_interval_sec * 1000);
        if (lastSeenDate >= expectedLastSeenTime) icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f5de08bd86b7f3d6$exports))), {
            className: "success status-icon"
        });
        else icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e07848420df079ca$exports))), {
            className: "failed status-icon"
        });
        interval_tooltip = `Expected Interval: ${obj.expected_uplink_interval_sec} sec`;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                "Last Seen: ",
                formattedLastSeenDate,
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                interval_tooltip
            ]
        }),
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: icon
    });
}
function $bdde76de382eb768$export$e2ef10f86a8d60e8(val) {
    if (!val) return '-';
    const bars = val >= -30 ? 3 : val < -30 && val >= -75 ? 2 : val < -75 && val >= -120 ? 1 : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1224d5d5c3fec551$export$2e2bcd8739ae039), {
        bars: bars
    });
}
function $bdde76de382eb768$export$836601bcef5ff40(val) {
    if (!val && val != 0) return '-';
    if (val === -1) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: "External Power-Source",
        componentsProps: {
            tooltip: {
                sx: {
                    background: '#000'
                }
            }
        },
        placement: "top",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7e60b91ef098e912$exports))), {})
    });
    else if (val >= 0 && val <= 100) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $01188c09d8e3a70e$export$2e2bcd8739ae039), {
        batteryPerc: val
    });
    else return '-';
}
function $bdde76de382eb768$export$ece231723a612020(label, tooltip) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)($bdde76de382eb768$var$TooltipTitle, {
            children: tooltip
        }),
        placement: "bottom",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                label,
                /*#__PURE__*/ (0, $ayMG0.jsx)($bdde76de382eb768$var$InfoIcon, {})
            ]
        })
    });
}
const $bdde76de382eb768$var$TooltipTitle = (0, $lmFrL.default).div`
  a {
    color: #4ed6ff;
    font-weight: bold;
  }
  a:hover {
    color: #f2f2f2;
    text-decoration: underline
  }
`;
const $bdde76de382eb768$var$InfoIcon = (0, $lmFrL.default)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))))`
  width: 15px;
`;
function $bdde76de382eb768$export$6c82ad6fb278fb6(val) {
    return val ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: val,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($43c2449ff5c5b42e$exports))), {})
    }) : '-';
}



var $lzNIT = parcelRequire("lzNIT");
const $6c3d116a34d884c6$export$cdeea3e16c093706 = [
    {
        id: 'name',
        label: 'Name'
    },
    {
        id: 'hw_model',
        label: 'Model',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/sensors/${val}`,
                children: val
            })
    },
    {
        id: 'deveui',
        label: $bdde76de382eb768$export$ece231723a612020('DevEUI', 'A unique 64 bit device identifier assigned by the manufacturer.')
    },
    {
        id: 'manufacturer',
        label: 'Manufacturer'
    },
    {
        id: 'datasheet',
        label: 'Datasheet',
        format: $bdde76de382eb768$export$6c82ad6fb278fb6
    }
];
const $6c3d116a34d884c6$export$59e48b3563bb8be9 = [
    {
        id: 'last_seen_at',
        label: 'Status',
        format: $bdde76de382eb768$export$471f7ae5c4103ae1,
        width: '70px'
    },
    {
        id: 'name',
        label: 'Name'
    },
    {
        id: 'deveui',
        label: $bdde76de382eb768$export$ece231723a612020('DevEUI', 'A unique 64 bit device identifier assigned by the manufacturer.')
    },
    {
        id: 'battery_level',
        label: 'Battery Level',
        format: $bdde76de382eb768$export$836601bcef5ff40
    },
    {
        id: 'margin',
        label: $bdde76de382eb768$export$ece231723a612020('Margin', /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                "Indicates the quality of the received signal compared to background noise using the difference between Max measured ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "https://www.thethingsnetwork.org/docs/lorawan/rssi-and-snr/#snr",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "SNR"
                }),
                " at the gateway and Min SNR needed to demodulate a message at a specific data rate."
            ]
        }))
    },
    {
        id: 'rssi',
        label: $bdde76de382eb768$export$ece231723a612020('Signal Strength', /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            children: [
                "Determined by ",
                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: "https://www.thethingsnetwork.org/docs/lorawan/rssi-and-snr/#rssi",
                    target: "_blank",
                    rel: "noreferrer",
                    children: "RSSI"
                }),
                ". Column disabled if signal.rssi values are not being collected."
            ]
        })),
        format: $bdde76de382eb768$export$e2ef10f86a8d60e8,
        width: '200px'
    }
];



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cc200de1acd27a89$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m-1-4h2v2h-2zm1.61-9.96c-2.06-.3-3.88.97-4.43 2.79-.18.58.26 1.17.87 1.17h.2c.41 0 .74-.29.88-.67.32-.89 1.27-1.5 2.3-1.28.95.2 1.65 1.13 1.57 2.1-.1 1.34-1.62 1.63-2.45 2.88 0 .01-.01.01-.01.02-.01.02-.02.03-.03.05-.09.15-.18.32-.25.5-.01.03-.03.05-.04.08-.01.02-.01.04-.02.07-.12.34-.2.75-.2 1.25h2c0-.42.11-.77.28-1.07.02-.03.03-.06.05-.09.08-.14.18-.27.28-.39.01-.01.02-.03.03-.04.1-.12.21-.23.33-.34.96-.91 2.26-1.65 1.99-3.56-.24-1.74-1.61-3.21-3.35-3.47"
}), 'HelpOutlineRounded');



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $lzNIT = parcelRequire("lzNIT");

var $bFBmv = parcelRequire("bFBmv");


var $ipR47 = parcelRequire("ipR47");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ea58ebca9ef3ab98$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10.3 7.7c-.39.39-.39 1.01 0 1.4l1.9 1.9H3c-.55 0-1 .45-1 1s.45 1 1 1h9.2l-1.9 1.9c-.39.39-.39 1.01 0 1.4s1.01.39 1.4 0l3.59-3.59c.39-.39.39-1.02 0-1.41L11.7 7.7a.984.984 0 0 0-1.4 0M20 19h-7c-.55 0-1 .45-1 1s.45 1 1 1h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-7c-.55 0-1 .45-1 1s.45 1 1 1h7z"
}), 'LoginRounded');




var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $f1q41 = parcelRequire("f1q41");
function $2f33fb571dcb5924$export$2e2bcd8739ae039(props) {
    const { title: title, rows: rows, data: data } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2f33fb571dcb5924$var$Table, {
        className: "simple key-value",
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                        colSpan: 2,
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                children: rows.map((item)=>{
                    const { id: id, label: label, format: format } = item;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                children: label || (0, $f1q41.startCase)(id.replace(/_/g, ' '))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                children: format ? format(data[id], data) : (data[id] || '-').toString() || '-'
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
}
const $2f33fb571dcb5924$var$Table = (0, $d8seH.default)('table')`
  thead th {
    color: ${(props)=>props.theme.palette.primary.contrastText};
    background: #4e2a84;
  }

  tbody td:first-child {
    width: 100px;
    text-align: right;
  }

  tr:not(:first-child) {
    border-top: 1px solid ${(props)=>props.theme.palette.divider};
  }
  thead tr {
    border-top: 1px solid ${(props)=>props.theme.palette.divider};
  }
` /* see global style.scss for rest of class styling */ ;



var $gOa8m = parcelRequire("gOa8m");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $lzNIT = parcelRequire("lzNIT");
parcelRequire("kalwe");
var $jNGAr = parcelRequire("jNGAr");
var $kalwe = parcelRequire("kalwe");
var $aDtBU = parcelRequire("aDtBU");
var $2e13a979320b0aad$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2e13a979320b0aad$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2e13a979320b0aad$exports, "__esModule", {
    value: true
});
$2e13a979320b0aad$exports.default = void 0;

var $2e13a979320b0aad$var$_createSvgIcon = $2e13a979320b0aad$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2e13a979320b0aad$var$_default = $2e13a979320b0aad$exports.default = (0, $2e13a979320b0aad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 9h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1m0 4h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1m0 4h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1M7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20 3H4c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1m-1 16H5V5h14z"
}), 'ListAltRounded');


var $e277e0fda847e332$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e277e0fda847e332$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e277e0fda847e332$exports, "__esModule", {
    value: true
});
$e277e0fda847e332$exports.default = void 0;

var $e277e0fda847e332$var$_createSvgIcon = $e277e0fda847e332$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e277e0fda847e332$var$_default = $e277e0fda847e332$exports.default = (0, $e277e0fda847e332$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.54 8.54c.35.35.37.88.1 1.29C8.24 10.45 8 11.2 8 12s.24 1.55.64 2.17c.27.41.24.95-.11 1.29-.43.43-1.17.4-1.51-.11C6.38 14.4 6 13.24 6 12c0-1.21.36-2.33.97-3.28.36-.54 1.11-.64 1.57-.18m6.92 6.92c.43.43 1.17.4 1.51-.11C17.62 14.4 18 13.24 18 12s-.38-2.4-1.03-3.36c-.34-.5-1.08-.54-1.51-.11-.35.35-.37.88-.11 1.29.41.63.65 1.38.65 2.18s-.24 1.55-.64 2.17c-.27.41-.24.95.1 1.29M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6.32 8.32c.42.42 1.12.39 1.5-.08C21.18 16.53 22 14.36 22 12s-.82-4.53-2.18-6.24c-.37-.47-1.07-.5-1.5-.08-.36.36-.4.92-.08 1.32 1.1 1.37 1.76 3.11 1.76 5s-.66 3.63-1.76 5c-.32.39-.28.96.08 1.32M5.68 5.68c-.42-.42-1.12-.39-1.5.08C2.82 7.47 2 9.64 2 12s.82 4.53 2.18 6.24c.37.47 1.07.5 1.5.08.36-.36.4-.92.08-1.32C4.66 15.63 4 13.89 4 12s.66-3.63 1.76-5c.32-.39.28-.96-.08-1.32"
}), 'SensorsRounded');


var $caff09a9ae2bbb47$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $caff09a9ae2bbb47$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($caff09a9ae2bbb47$exports, "__esModule", {
    value: true
});
$caff09a9ae2bbb47$exports.default = void 0;

var $caff09a9ae2bbb47$var$_createSvgIcon = $caff09a9ae2bbb47$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $caff09a9ae2bbb47$var$_default = $caff09a9ae2bbb47$exports.default = (0, $caff09a9ae2bbb47$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22 8c0-.55-.45-1-1-1h-1V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1v-2h1c.55 0 1-.45 1-1s-.45-1-1-1h-1V9h1c.55 0 1-.45 1-1m-5 11H5c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1M6.5 13h4c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5m6-6h3c.28 0 .5.22.5.5v2c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-2c0-.28.22-.5.5-.5m-6 0h4c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5m6 4h3c.28 0 .5.22.5.5v5c0 .28-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5"
}), 'DeveloperBoardRounded');


var $140dabcf4b227294$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $140dabcf4b227294$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($140dabcf4b227294$exports, "__esModule", {
    value: true
});
$140dabcf4b227294$exports.default = void 0;

var $140dabcf4b227294$var$_createSvgIcon = $140dabcf4b227294$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $140dabcf4b227294$var$_default = $140dabcf4b227294$exports.default = (0, $140dabcf4b227294$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 5V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-2.21-1.79-4-4-4S5 4.79 5 7v7H4c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H7V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4v-7h1c.55 0 1-.45 1-1V5z"
}), 'Cable');


var $2e7eff9bb64d010f$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $2e7eff9bb64d010f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($2e7eff9bb64d010f$exports, "__esModule", {
    value: true
});
$2e7eff9bb64d010f$exports.default = void 0;

var $2e7eff9bb64d010f$var$_createSvgIcon = $2e7eff9bb64d010f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $2e7eff9bb64d010f$var$_default = $2e7eff9bb64d010f$exports.default = (0, $2e7eff9bb64d010f$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M20 4H4c-1.1 0-2 .9-2 2v3h2V6h16v3h2V6c0-1.1-.9-2-2-2m0 14H4v-3H2v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3h-2z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M14.89 7.55c-.34-.68-1.45-.68-1.79 0L10 13.76l-1.11-2.21A.988.988 0 0 0 8 11H2v2h5.38l1.72 3.45c.18.34.52.55.9.55s.72-.21.89-.55L14 10.24l1.11 2.21c.17.34.51.55.89.55h6v-2h-5.38z"
    }, "1")
], 'MonitorHeartOutlined');


var $82f8d207fac0b8bd$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $82f8d207fac0b8bd$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($82f8d207fac0b8bd$exports, "__esModule", {
    value: true
});
$82f8d207fac0b8bd$exports.default = void 0;

var $82f8d207fac0b8bd$var$_createSvgIcon = $82f8d207fac0b8bd$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $82f8d207fac0b8bd$var$_default = $82f8d207fac0b8bd$exports.default = (0, $82f8d207fac0b8bd$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m7.3 14.7 1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7M19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9s-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1s-1-5.1-2.9-7.1"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M6.1 4.1 4.9 2.9C3 4.9 2 7.4 2 10s1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9s.8-4.3 2.4-5.9m10.6 10.6c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5zM14.5 10c0-1.38-1.12-2.5-2.5-2.5S9.5 8.62 9.5 10c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88m-4.17 8L12 13l1.67 5z"
    }, "1")
], 'CellTower');


// a tab is rendered with react.clone, so we must explicity pass TabProps
const $acfb82061fdef91e$var$ConditionalTab = (props)=>props.show ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
        ...props
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
function $acfb82061fdef91e$export$2e2bcd8739ae039(props) {
    const { admin: admin, counts: counts, lorawan: lorawan } = props;
    const [params] = (0, $lzNIT.useSearchParams)();
    const tab = params.get('tab') || 'overview';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acfb82061fdef91e$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
            value: tab,
            "aria-label": "node details tabs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                    label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2e13a979320b0aad$exports))), {
                        fontSize: "small"
                    }), 'Overview'),
                    component: (0, $lzNIT.Link),
                    value: "overview",
                    to: "?tab=overview",
                    replace: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                    label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e277e0fda847e332$exports))), {}), 'Sensors', counts),
                    component: (0, $lzNIT.Link),
                    value: "sensors",
                    to: "?tab=sensors",
                    replace: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                    label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caff09a9ae2bbb47$exports))), {
                        fontSize: "small"
                    }), 'Computes', counts),
                    component: (0, $lzNIT.Link),
                    value: "computes",
                    to: "?tab=computes",
                    replace: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                    label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($140dabcf4b227294$exports))), {
                        fontSize: "small"
                    }), 'Peripherals', counts),
                    component: (0, $lzNIT.Link),
                    value: "peripherals",
                    to: "?tab=peripherals",
                    replace: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($acfb82061fdef91e$var$ConditionalTab, {
                    show: lorawan,
                    label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82f8d207fac0b8bd$exports))), {}), 'LoRaWAN Devices', counts),
                    component: (0, $lzNIT.Link),
                    value: "lorawandevices",
                    to: "?tab=lorawandevices",
                    replace: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($acfb82061fdef91e$var$ConditionalTab, {
                    show: admin,
                    label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2e7eff9bb64d010f$exports))), {
                        fontSize: "small"
                    }), 'Health'),
                    component: (0, $lzNIT.Link),
                    value: "health",
                    to: "?tab=health",
                    replace: true
                })
            ]
        })
    });
}
const $acfb82061fdef91e$var$Root = (0, $lmFrL.default).div`

`;



var $hgW6l = parcelRequire("hgW6l");

var $eOilY = parcelRequire("eOilY");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $iwiZ3 = parcelRequire("iwiZ3");

var $bcnr1 = parcelRequire("bcnr1");



var $gTmRg = parcelRequire("gTmRg");

const $2fa763baf39f698d$export$fc6b1e9923bb7632 = 200;
const $2fa763baf39f698d$var$DEFAULT_VIEW = 7 // days
;
const $2fa763baf39f698d$var$start = '-14d' // query start
;
function $2fa763baf39f698d$var$sanityColor(val, obj) {
    if (val == null) return (0, $66ac2ba2d2031913$export$35e9368ef982300f).noValue;
    if (val <= 0) return (0, $66ac2ba2d2031913$export$35e9368ef982300f).green;
    else if (obj.meta.severity == 'warning') return (0, $66ac2ba2d2031913$export$35e9368ef982300f).orange;
    else return (0, $66ac2ba2d2031913$export$35e9368ef982300f).red4;
}
const $2fa763baf39f698d$var$yFormat = (test, testType, label)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
        to: `/tests/?phase=deployed&test=${test}&test_type=${testType}`,
        target: "_blank",
        className: "text-inherit",
        children: label || test
    });
function $2fa763baf39f698d$export$2e2bcd8739ae039() {
    const vsn = (0, $aphAM.useParams)().vsn;
    const params = new URLSearchParams((0, $aphAM.useLocation)().search);
    const hours = params.get('hours');
    const days = params.get('days');
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [health, setHealth] = (0, $acw62.useState)(null);
    const [sanityData, setSanityData] = (0, $acw62.useState)(null);
    const [loadingHealth, setLoadingHealth] = (0, $acw62.useState)(null);
    const [loadingSanity, setLoadingSanity] = (0, $acw62.useState)(null);
    const [sanityError, setSanityError] = (0, $acw62.useState)(null);
    const [healthError, setHealthError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        setLoadingHealth(true);
        const p1 = $bcnr1.getDeviceHealthSummary({
            vsn: vsn,
            start: $2fa763baf39f698d$var$start
        }).then((data)=>setHealth(data)).catch((err)=>setHealthError(err)).finally(()=>setLoadingHealth(false));
        setLoadingSanity(true);
        const p2 = $bcnr1.getSanityData({
            vsn: vsn,
            start: $2fa763baf39f698d$var$start
        }).then((sanity)=>{
            if (!sanity) return;
            const data = Object.values(Object.values(sanity)[0])[0];
            // ignore failing telegraf cadvisor metric
            delete data['sys.sanity_status.wes_telegraf_cadvisor'];
            setSanityData(data);
        }).catch((err)=>setSanityError(err)).finally(()=>setLoadingSanity(false));
        Promise.all([
            p1,
            p2
        ]).then(()=>setLoading(false));
    }, [
        vsn,
        setLoading,
        days,
        hours
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2fa763baf39f698d$var$Root, {
        className: "gap",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Health"
                }),
                health && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                    data: health,
                    // same range as the request, but can be modified if needed
                    startTime: (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), $2fa763baf39f698d$var$DEFAULT_VIEW),
                    endTime: (0, $1ed606b7addd3a91$export$2e2bcd8739ae039)(new Date()),
                    colorCell: (val, obj)=>{
                        if (val == null) return (0, $66ac2ba2d2031913$export$35e9368ef982300f).noValue;
                        return val == 0 ? (0, $66ac2ba2d2031913$export$35e9368ef982300f).red4 : (0, $66ac2ba2d2031913$export$35e9368ef982300f).green;
                    },
                    tooltip: (item)=>`${new Date(item.timestamp).toDateString()} ${new Date(item.timestamp).toLocaleTimeString()}<br>
              ${item.meta.device}<br>
              <b style="color: ${item.value == 0 ? (0, $66ac2ba2d2031913$export$35e9368ef982300f).red3 : (0, $66ac2ba2d2031913$export$35e9368ef982300f).green}">
                ${item.value == 0 ? 'failed' : `success`}
              </b>
              `,
                    labelWidth: $2fa763baf39f698d$export$fc6b1e9923bb7632,
                    yFormat: (label)=>$2fa763baf39f698d$var$yFormat(label, 'health')
                }),
                healthError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    severity: "error",
                    children: healthError.message
                }),
                !loadingHealth && !health && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "clearfix"
                        }),
                        "No health data available"
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Sanity Tests"
                }),
                sanityData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                    data: sanityData,
                    startTime: (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), $2fa763baf39f698d$var$DEFAULT_VIEW),
                    endTime: (0, $1ed606b7addd3a91$export$2e2bcd8739ae039)(new Date()),
                    colorCell: $2fa763baf39f698d$var$sanityColor,
                    tooltip: (item)=>`${new Date(item.timestamp).toDateString()} ${new Date(item.timestamp).toLocaleTimeString()}<br>
              ${item.row.split('.').pop()}<br>
              <b style="color: ${$2fa763baf39f698d$var$sanityColor(item.value, item)}">
                ${item.value == 0 ? 'passed' : item.meta.severity == 'warning' ? 'warning' : 'failed'}
              </b>
              `,
                    labelWidth: $2fa763baf39f698d$export$fc6b1e9923bb7632,
                    yFormat: (label)=>$2fa763baf39f698d$var$yFormat(label, 'sanity', label.split('.').pop())
                }),
                sanityError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    severity: "error",
                    children: sanityError.message
                }),
                !loadingSanity && !sanityData && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "muted",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "clearfix"
                        }),
                        "No sanity data available"
                    ]
                })
            ]
        })
    });
}
const $2fa763baf39f698d$var$Root = (0, $lmFrL.default).div`
  h2 {
    float: left;
    margin:0;
  }
`;



var $gZwVy = parcelRequire("gZwVy");


var $f1q41 = parcelRequire("f1q41");

var $ifEev = parcelRequire("ifEev");


var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $cVXaD = parcelRequire("cVXaD");
var $8c6ad197f63b3f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8c6ad197f63b3f3e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($8c6ad197f63b3f3e$exports, "__esModule", {
    value: true
});
$8c6ad197f63b3f3e$exports.default = void 0;

var $8c6ad197f63b3f3e$var$_createSvgIcon = $8c6ad197f63b3f3e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8c6ad197f63b3f3e$var$_default = $8c6ad197f63b3f3e$exports.default = (0, $8c6ad197f63b3f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');




var $gZwVy = parcelRequire("gZwVy");
function $4073a7ed36c832a6$export$2e2bcd8739ae039(props) {
    const { isSuper: isSuper } = (0, $0ad5317c8f9b9985$export$fa63741f3dc98587)();
    const { id: id } = props;
    if (!isSuper) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
            placement: "top",
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "Edit manifest"
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                href: `${(0, $gZwVy.default).auth}/admin/manifests/nodedata/${id}`,
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8c6ad197f63b3f3e$exports))), {}),
                children: "Edit"
            })
        })
    });
}


const $06e1e255202fae97$var$labelDict = {
    gps: 'GPS',
    bme280: "T\xb7P\xb7H",
    bme680: "T\xb7P\xb7H\xb7G",
    aqt: 'AQT',
    wxt: 'WXT',
    nxcore: 'NX',
    nxagent: 'NXagent',
    rpi: 'RPi',
    sbcore: 'Sage Blade'
};
const $06e1e255202fae97$var$getConfigTable = (o)=>{
    const { description: description, datasheet: datasheet, ...rest } = o;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: '300px'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f33fb571dcb5924$export$2e2bcd8739ae039), {
            title: "Configuration Details",
            rows: Object.keys(rest).map((k)=>({
                    id: k,
                    label: k
                })),
            data: rest
        })
    });
};
const $06e1e255202fae97$var$sanitizeLabel = (obj)=>{
    const { name: name } = obj;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: name in $06e1e255202fae97$var$labelDict ? $06e1e255202fae97$var$labelDict[name] : (0, $f1q41.startCase)(name.replace(/-|_/, ' '))
    });
};
const $06e1e255202fae97$var$metaRows1 = [
    {
        id: 'project',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: `/nodes?project="${encodeURIComponent(val)}"`,
                target: "_blank",
                rel: "noreferrer",
                children: val
            })
    },
    {
        id: 'focus',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: `/nodes?focus="${encodeURIComponent(val)}"`,
                target: "_blank",
                rel: "noreferrer",
                children: val
            })
    },
    {
        id: 'cityAndState',
        label: 'City & State',
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: `/nodes?city="${encodeURIComponent(obj.city)}"`,
                        target: "_blank",
                        rel: "noreferrer",
                        children: obj.cityStr
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: `/nodes?state="${encodeURIComponent(obj.state)}"`,
                        target: "_blank",
                        rel: "noreferrer",
                        children: obj.state
                    })
                ]
            })
    },
    /* todo: add, if needed
{
  id: 'build_date',
  label: 'Built'
},
*/ {
        id: 'registration_event',
        label: 'Registration',
        format: (val)=>{
            if (val === null) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "muted",
                children: "Not found"
            });
            else if (!val) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "muted",
                children: "loading..."
            });
            else return new Date(val).toLocaleString();
        }
    },
    {
        id: 'commissioned_at',
        label: 'Commissioned',
        format: (val)=>val ? new Date(val).toLocaleString() : '-'
    }
];
const $06e1e255202fae97$var$computeOverview = [
    {
        id: 'computes',
        format: (val, obj)=>{
            const { computes: computes } = obj;
            return /*#__PURE__*/ (0, $ayMG0.jsx)($06e1e255202fae97$var$NodeDetails, {
                data: computes
            });
        }
    }
];
const $06e1e255202fae97$var$hardwareMeta = [
    {
        id: 'all',
        format: (val, obj)=>{
            const { modem: modem, computes: computes } = obj;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                container: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                        size: {
                            xs: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                className: "muted font-bold",
                                children: "Stevenson Shield"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: (0, $c17cd402450ea43c$export$2be08591ea73e876)(computes) ? 'yes' : 'no'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                        size: {
                            xs: 3
                        },
                        children: $eOilY.modem(modem, obj)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                        size: {
                            xs: 3
                        },
                        children: $eOilY.modemSim(modem, obj)
                    })
                ]
            });
        }
    }
];
const $06e1e255202fae97$var$sensorOverview = [
    {
        id: 'cameras',
        format: (val, obj)=>{
            const cameras = obj.sensors.filter((o)=>o.name.match(/camera/gi));
            if (!obj.sensors.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "muted",
                children: "No sensors configured"
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)($06e1e255202fae97$var$NodeDetails, {
                data: cameras,
                linkPath: "/sensors"
            });
        }
    },
    {
        id: 'sensors',
        label: 'Sensors',
        format: (val, obj)=>{
            const sensors = obj.sensors.filter((o)=>!o.name.match(/camera/gi));
            return /*#__PURE__*/ (0, $ayMG0.jsx)($06e1e255202fae97$var$NodeDetails, {
                data: sensors,
                linkPath: "/sensors"
            });
        }
    }
];
/**
 * column config for sensor/compute/peripherals table details
 */ const $06e1e255202fae97$var$sensorCols = [
    {
        id: 'name',
        label: 'Name'
    },
    {
        id: 'hw_model',
        label: 'Model',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/sensors/${val}`,
                children: val
            })
    },
    {
        id: 'manufacturer',
        label: 'Manufacturer'
    },
    {
        id: 'datasheet',
        label: 'Datasheet',
        format: (val)=>val ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: val,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($43c2449ff5c5b42e$exports))), {})
            }) : '-'
    }
];
const $06e1e255202fae97$var$computeCols = [
    {
        id: 'name',
        label: 'Name'
    },
    {
        id: 'hw_model',
        label: 'Model'
    },
    {
        id: 'manufacturer',
        label: 'Manufacturer'
    },
    /* {
  id: 'serial_no',
  label: 'Serial No.'
}*/ {
        id: 'datasheet',
        label: 'Datasheet',
        format: (val)=>val ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: val,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($43c2449ff5c5b42e$exports))), {})
            }) : '-'
    }
];
const $06e1e255202fae97$var$resourceCols = [
    {
        id: 'name',
        label: 'Name'
    },
    {
        id: 'hw_model',
        label: 'Model'
    },
    {
        id: 'manufacturer',
        label: 'Manufacturer'
    },
    {
        id: 'datasheet',
        label: 'Datasheet',
        format: (val)=>val ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: val,
                target: "_blank",
                rel: "noreferrer",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($43c2449ff5c5b42e$exports))), {})
            }) : '-'
    }
];
function $06e1e255202fae97$var$NodeDetails(props) {
    const { data: data, linkPath: linkPath } = props;
    const [details, setDetails] = (0, $acw62.useState)(null);
    const handleCloseDetails = ()=>setDetails(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
        container: true,
        children: [
            data.map((o, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e427cceb5e1ecc90$export$2e2bcd8739ae039), {
                    size: {
                        xs: 3
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($06e1e255202fae97$var$NodeInfo, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
                                className: "muted font-bold",
                                children: [
                                    $06e1e255202fae97$var$sanitizeLabel(o),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                        title: "Show config",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            onClick: ()=>setDetails(o),
                                            size: "small",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ipR47))), {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: linkPath ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                    to: `${linkPath}/${o.hw_model}`,
                                    children: o.hw_model
                                }) : o.hw_model
                            })
                        ]
                    })
                }, i)),
            details && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: details.hw_model,
                content: $06e1e255202fae97$var$getConfigTable(details),
                onClose: handleCloseDetails,
                onConfirm: handleCloseDetails,
                maxWidth: "xl"
            })
        ]
    });
}
function $06e1e255202fae97$export$2e2bcd8739ae039(props) {
    const { node: node, manifest: manifest, bkMeta: bkMeta, loraDataWithRssi: loraDataWithRssi, tab: tab, liveGPS: liveGPS, loading: loading, status: status, admin: admin } = props;
    const { type: type, vsn: vsn, id: id } = node || {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-center gap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                                    className: "no-margin",
                                    children: [
                                        type == 'WSN' ? 'Wild Sage Node' : type,
                                        " ",
                                        node && $eOilY.vsnToDisplayName(vsn, node)
                                    ]
                                }),
                                admin && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    href: `${(0, $gZwVy.default).portal}/nodes/${vsn}`,
                                    endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea58ebca9ef3ab98$export$2e2bcd8739ae039), {}),
                                    children: "view portal"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex gap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4073a7ed36c832a6$export$2e2bcd8739ae039), {
                                    id: id
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    placement: "top",
                                    title: admin ? 'Node health' : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "Admin page ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFBmv))), {
                                                style: {
                                                    fontSize: '1.1em'
                                                }
                                            })
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        href: node ? `${(0, $gZwVy.default).adminURL}/nodes/${vsn}?tab=health` : '',
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: `${status == 'reporting' ? 'success font-bold' : 'failed font-bold'}`,
                                            children: status
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                noPad: true,
                style: {
                    marginBotton: 0
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acfb82061fdef91e$export$2e2bcd8739ae039), {
                        counts: {
                            'Sensors': manifest?.sensors.length,
                            'Computes': manifest?.computes.length,
                            'Peripherals': manifest?.resources.length,
                            'LoRaWAN Devices': manifest?.lorawanconnections.length
                        },
                        admin: admin,
                        lorawan: manifest?.sensors.some((item)=>item.capabilities.includes('lorawan'))
                    }),
                    tab == 'sensors' && manifest && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c17cd402450ea43c$export$f2c3aea42b2a048f), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "name",
                            columns: $06e1e255202fae97$var$sensorCols,
                            rows: manifest.sensors,
                            enableSorting: true
                        })
                    }),
                    tab == 'computes' && manifest && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c17cd402450ea43c$export$f2c3aea42b2a048f), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "name",
                            columns: $06e1e255202fae97$var$computeCols,
                            rows: manifest.computes,
                            enableSorting: true
                        })
                    }),
                    tab == 'lorawandevices' && loraDataWithRssi && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c17cd402450ea43c$export$f2c3aea42b2a048f), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "deveui",
                            columns: (0, $6c3d116a34d884c6$export$cdeea3e16c093706),
                            rows: loraDataWithRssi,
                            enableSorting: true
                        })
                    }),
                    tab == 'peripherals' && manifest && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c17cd402450ea43c$export$f2c3aea42b2a048f), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "name",
                            columns: $06e1e255202fae97$var$resourceCols,
                            rows: manifest.resources,
                            enableSorting: true
                        })
                    })
                ]
            }),
            tab == 'overview' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex gap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                        noPad: true,
                        className: "meta-left",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f33fb571dcb5924$export$2e2bcd8739ae039), {
                            title: "Overview",
                            rows: [
                                ...$06e1e255202fae97$var$metaRows1,
                                {
                                    id: 'gps',
                                    label: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            "GPS (",
                                            node?.hasStaticGPS ? 'static' : 'from stream',
                                            ")"
                                        ]
                                    }),
                                    format: ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                node?.hasStaticGPS && !liveGPS && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hgW6l.default), {
                                                    data: {
                                                        lat: node.gps_lat,
                                                        lng: node.gps_lon,
                                                        hasStaticGPS: true
                                                    }
                                                }),
                                                node?.hasStaticGPS && liveGPS && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hgW6l.default), {
                                                    data: {
                                                        lat: node.gps_lat,
                                                        lng: node.gps_lon,
                                                        hasStaticGPS: true,
                                                        hasLiveGPS: true
                                                    }
                                                }),
                                                !node?.hasStaticGPS && liveGPS && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hgW6l.default), {
                                                            data: {
                                                                lat: liveGPS.lat,
                                                                lng: liveGPS.lon,
                                                                hasStaticGPS: false,
                                                                hasLiveGPS: true
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                            title: "Last available GPS timestamp",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                                                className: "muted",
                                                                children: new Date(liveGPS.timestamp).toLocaleString()
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !node?.hasStaticGPS && !liveGPS && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "muted",
                                                    children: "not available"
                                                }),
                                                !node?.hasStaticGPS && !liveGPS && loading && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                    className: "muted",
                                                    children: "loading..."
                                                })
                                            ]
                                        })
                                }
                            ],
                            data: {
                                ...node,
                                ...bkMeta
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                        noPad: true,
                        className: "meta-right",
                        children: manifest && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "summary-table",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f33fb571dcb5924$export$2e2bcd8739ae039), {
                                        title: "Sensors",
                                        rows: $06e1e255202fae97$var$sensorOverview,
                                        data: manifest
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "summary-table",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f33fb571dcb5924$export$2e2bcd8739ae039), {
                                        title: "Computes",
                                        rows: $06e1e255202fae97$var$computeOverview,
                                        data: manifest
                                    })
                                }),
                                type == 'WSN' && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "summary-table",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f33fb571dcb5924$export$2e2bcd8739ae039), {
                                        title: "Hardware",
                                        rows: $06e1e255202fae97$var$hardwareMeta,
                                        data: {
                                            ...node,
                                            ...manifest
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            admin && tab == 'health' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fa763baf39f698d$export$2e2bcd8739ae039), {})
        ]
    });
}
const $06e1e255202fae97$var$NodeInfo = (0, $d8seH.default)('div')`
  position: relative;

  & .MuiIconButton-root  {
    visibility: hidden;
    position: absolute;
    top: -2px;
    margin-left: 5px;
    .MuiSvgIcon-root { font-size: 1rem;}
  }

  &:hover .MuiIconButton-root  {
    visibility: visible;
  }

  &:hover .MuiIconButton-root:hover {
    color: #222;
  }
`;


/* eslint-disable max-len */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
var $42e73a07e3f5c75e$exports = {};
$42e73a07e3f5c75e$exports = import.meta.resolve("hrJ7c");



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $cVXaD = parcelRequire("cVXaD");
const $adc61c8e71a84992$var$HOT_SPOT_SIZE = 20;
function $adc61c8e71a84992$export$2e2bcd8739ae039(props) {
    const { label: label, title: title, onMouseOver: onMouseOver, onMouseOut: onMouseOut, hoverid: hoverid } = props;
    const handleOver = ()=>{
        if (onMouseOver) onMouseOver(hoverid, label, title);
    };
    const handleOut = ()=>{
        if (onMouseOut) onMouseOut(hoverid, label, title);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($adc61c8e71a84992$var$HotspotRoot, {
        ...props,
        onMouseOver: handleOver,
        onMouseOut: handleOut,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
            title: title,
            placement: "top",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "label",
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($adc61c8e71a84992$var$HotspotDot, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "dot"
                        })
                    })
                ]
            })
        })
    });
}
const $adc61c8e71a84992$var$getLabelTop = (pos)=>{
    if (pos == 'left' || pos == 'right') return '0px';
    else if (pos == 'bottom') return '20px';
    return '-20px';
};
const $adc61c8e71a84992$var$getLabelLeft = (pos)=>{
    if (pos == 'left') return `-${$adc61c8e71a84992$var$HOT_SPOT_SIZE + 5}px`;
    else if (pos == 'right') return `${$adc61c8e71a84992$var$HOT_SPOT_SIZE + 5}px`;
    return '0';
};
const $adc61c8e71a84992$var$getLabelJustifyContent = (pos)=>{
    if (pos == 'left') return 'right';
    else if (pos == 'right') return 'left';
    return 'center';
};
const $adc61c8e71a84992$var$HotspotRoot = (0, $lmFrL.default).div`
  position: absolute;
  top: ${(props)=>props.top};
  left: ${(props)=>props.left};
  cursor: default;

  .label {
    position: absolute;
    white-space: nowrap;
    font-weight: 800;
    font-size: 1.0em;
    color: #1283c8;
    background: none;
    text-shadow: 0 0 1px #1283c8;
    width: 100%;
    height: 100%;
    display: flex;
    top: ${({ pos: pos })=>$adc61c8e71a84992$var$getLabelTop(pos)};
    left: ${({ pos: pos })=>$adc61c8e71a84992$var$getLabelLeft(pos)};
    justify-content: ${({ pos: pos })=>$adc61c8e71a84992$var$getLabelJustifyContent(pos)};
    align-items: center;
  }

  :hover .dot {
    border-color: #1283c8 !important;
    animation-play-state: paused;
    color: #fff;
  }

  :hover .dot::after {
    background-color: #9ec7e0;
  }

  /*
  @keyframes pulse {
    50% { border-color: rgb(255, 255, 255, 0.2); }
    100% { border-color: rgb(255, 255, 255, 0.8); }
  }*/
`;
const $adc61c8e71a84992$var$HotspotDot = (0, $lmFrL.default).div`
  .dot {
    width: ${$adc61c8e71a84992$var$HOT_SPOT_SIZE}px;
    height: ${$adc61c8e71a84992$var$HOT_SPOT_SIZE}px;
    border: 3px solid rgb(255, 255, 255, 0.8);
    border-radius: 50%;
    animation: pulse 2s ease infinite;
    transition: all 0.2s;
    text-decoration: none;
    font-weight: bold;
    font-family: sans-serif;
    color: #555;
    box-shadow: 0 0 4px #000;
  }

  .dot:after {
    content: "";
    width: ${$adc61c8e71a84992$var$HOT_SPOT_SIZE - 6}px;
    height: ${$adc61c8e71a84992$var$HOT_SPOT_SIZE - 6}px;
    background-color: #1283c8;
    border-radius: 50%;
    display: block;
    transition: all 0.2s;
  }

`;


function $df72e33dd0bd0807$export$2e2bcd8739ae039(props) {
    const { node: node, shield: shield } = props;
    const { vsn: vsn, type: type, top_camera: top_camera, bottom_camera: bottom_camera, left_camera: left_camera, right_camera: right_camera } = node || {};
    const [hover, setHover] = (0, $acw62.useState)('');
    const onOver = (id)=>{
        const cls = `.hover-${id}`;
        const ele = document.querySelector(cls);
        if (!ele) return;
        ele.style.outline = '3px solid #1a779c';
        setHover(cls);
    };
    const onOut = ()=>{
        if (!hover) return;
        const ele = document.querySelector(hover);
        ele.style.outline = 'none';
    };
    const mouse = {
        onMouseOver: onOver,
        onMouseOut: onOut
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: type == 'WSN' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($df72e33dd0bd0807$var$WSNView, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($42e73a07e3f5c75e$exports))),
                    width: $df72e33dd0bd0807$var$WSN_VIEW_WIDTH
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($df72e33dd0bd0807$var$VSN, {
                    children: vsn
                }),
                node && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        shield && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "62%",
                            left: "10%",
                            label: "ML1-WS",
                            title: "Microphone",
                            pos: "left",
                            ...mouse,
                            hoverid: "audio"
                        }),
                        shield && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "40%",
                            left: "10%",
                            label: "BME680",
                            title: "Temp, humidity, pressure, and gas sesnor",
                            pos: "left",
                            ...mouse,
                            hoverid: "BME680"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "15%",
                            left: "68%",
                            label: "RG-15",
                            title: "Raingauge",
                            pos: "right",
                            ...mouse,
                            hoverid: "RG-15"
                        }),
                        top_camera && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "7%",
                            left: "61%",
                            label: top_camera,
                            title: "Top camera",
                            pos: "left",
                            ...mouse,
                            hoverid: "top-camera"
                        }),
                        bottom_camera && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "87%",
                            left: "61%",
                            label: bottom_camera,
                            title: "Bottom camera",
                            pos: "bottom",
                            ...mouse,
                            hoverid: "bottom-camera"
                        }),
                        left_camera && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "49%",
                            left: "90%",
                            label: left_camera,
                            title: "Left camera",
                            ...mouse,
                            hoverid: "left-camera"
                        }),
                        right_camera && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adc61c8e71a84992$export$2e2bcd8739ae039), {
                            top: "49%",
                            left: "8%",
                            label: right_camera,
                            title: "Right camera",
                            ...mouse,
                            hoverid: "right-camera"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: {
                width: $df72e33dd0bd0807$var$WSN_VIEW_WIDTH
            }
        })
    });
}
const $df72e33dd0bd0807$var$VSN = (0, $lmFrL.default).div`
  position: absolute;
  width: 33%;
  height: 12%;
  top: 51%;
  left: 48%;
  font-size: 3.5em;
  padding: 0;
  background: #b3b3b3;
`;
const $df72e33dd0bd0807$var$WSN_VIEW_WIDTH = 400;
const $df72e33dd0bd0807$var$WSNView = (0, $lmFrL.default).div`
  position: sticky;
  top: 60px;

  img {
    padding: 50px;
    -webkit-filter: drop-shadow(2px 2px 2px #ccc);
    filter: drop-shadow(2px 2px 2px #ccc);
  }
`;




var $gZwVy = parcelRequire("gZwVy");


/* eslint-disable max-len */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $424f77c771d04e79$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 9H3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1m0 3H3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1m13.88 6.29-3.12-3.12c-.86.56-1.89.88-3 .82-2.37-.11-4.4-1.96-4.72-4.31-.44-3.35 2.45-6.18 5.83-5.61 1.95.33 3.57 1.85 4 3.78.33 1.46.01 2.82-.7 3.9l3.13 3.13c.39.39.39 1.02 0 1.41s-1.03.39-1.42 0M17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3M3 19h8c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1"
}), 'ManageSearchRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d437b3ea27dc377d$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.88 18.47c.48-.77.75-1.67.69-2.66-.13-2.15-1.84-3.97-3.97-4.2-2.72-.3-5.02 1.81-5.02 4.47 0 2.49 2.01 4.5 4.49 4.5.88 0 1.7-.26 2.39-.7l2.41 2.41c.39.39 1.03.39 1.42 0s.39-1.03 0-1.42zm-3.8.11c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5m-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.08 5.01c-.36.58-1.17.64-1.61.13l-2.12-2.47-3.06 4.9c-.31.49-.97.62-1.44.28-.42-.31-.54-.89-.26-1.34l3.78-6.05c.36-.57 1.17-.63 1.61-.12L9 12.5l3.18-5.17c.38-.62 1.28-.64 1.68-.03zm2.59.5c-.64-.28-1.33-.45-2.05-.49L20.8 2.9c.31-.49.97-.61 1.43-.27.43.31.54.9.26 1.34z"
}), 'QueryStatsRounded');






var $lffEs = parcelRequire("lffEs");






var $bcnr1 = parcelRequire("bcnr1");

var $atFJM = parcelRequire("atFJM");
parcelRequire("kalwe");
var $jNGAr = parcelRequire("jNGAr");
var $kalwe = parcelRequire("kalwe");
var $aDtBU = parcelRequire("aDtBU");

var $gOa8m = parcelRequire("gOa8m");

const $55ff8fe0cab419ec$var$TL_LABEL_WIDTH = 175 // default timeline label width
;
const $55ff8fe0cab419ec$var$TAIL_DAYS = '-7d';
const $55ff8fe0cab419ec$var$getStartTime = (str)=>str.includes('y') ? (0, $393cfda53f7a350f$export$2e2bcd8739ae039)(new Date(), str.replace(/-|y/g, '')) : (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), str.replace(/-|d/g, ''));
/* Todo: WIP -- if needed for tables
function getTableData(data, vsn) {
  const byItem = data[vsn]

  let table = []
  for (let [name, list] of Object.entries(byItem)) {
    const records = list.map( obj => ({...obj, 'taskWithCamera': `${obj.meta.task} (${obj.meta.camera})` }) )
    table = [...table, ...records]
  }

  table = groupBy(table, 'timestamp')

  return table
}
*/ const $55ff8fe0cab419ec$var$latestRecColumns = [
    {
        id: 'name',
        label: 'Name'
    },
    {
        id: 'timestamp',
        label: 'Timestamp',
        format: (0, $lffEs.relativeTime)
    },
    {
        id: 'value',
        label: 'Value'
    },
    {
        id: 'sensor',
        label: 'Sensor'
    },
    {
        id: 'deviceName',
        label: 'LoRa Device Name'
    }
];
function $55ff8fe0cab419ec$export$2e2bcd8739ae039(props) {
    const { node: node } = props;
    const vsn = (0, $aphAM.useParams)().vsn;
    const [params] = (0, $lzNIT.useSearchParams)();
    const tab = params.get('timeline') || 'apps';
    // todo(nc): refactor into provider?
    const [{ data: data, rawData: rawData }, dispatch] = (0, $acw62.useReducer)((0, $5cd62f408c38b395$export$ad7bdf946026e48), (0, $5cd62f408c38b395$export$e60cc94444444c1f));
    const [loadingTL, setLoadingTL] = (0, $acw62.useState)(false);
    const [opts, setOpts] = (0, $acw62.useState)({
        display: 'nodes',
        colorType: 'density',
        viewType: 'timeline',
        versions: false,
        time: 'hourly',
        start: $55ff8fe0cab419ec$var$getStartTime($55ff8fe0cab419ec$var$TAIL_DAYS),
        window: $55ff8fe0cab419ec$var$TAIL_DAYS
    });
    const [showAll, setShowAll] = (0, $acw62.useState)(false);
    // note: endtime is not currently an option
    const [end] = (0, $acw62.useState)((0, $1ed606b7addd3a91$export$2e2bcd8739ae039)(new Date()));
    const [ecr, setECR] = (0, $acw62.useState)();
    // recent measurements/records
    const [recent, setRecent] = (0, $acw62.useState)(null);
    const [filteredRecent, setFilteredRecent] = (0, $acw62.useState)(null);
    const [query] = (0, $acw62.useState)('');
    const [latestRange, setLatestRange] = (0, $acw62.useState)('-5m');
    const [cols, setCols] = (0, $acw62.useState)(null);
    const [checked] = (0, $acw62.useState)({
        relativeTime: true,
        showMeta: false
    });
    // relative time and show meta checkbox events
    (0, $acw62.useEffect)(()=>{
    /*
    setCols(prev => {
      let idx
      if (checked.relativeTime) {
        idx = findColumn(prev, 'timestamp')
        prev[idx] = {...prev[idx], format: (val) => relativeTime(val)}
      } else {
        idx = findColumn(prev, 'timestamp')
        prev[idx] = {...prev[idx], format: (val) => val}
      }

      idx = findColumn(prev, 'meta')
      prev[idx] = {...prev[idx], hide: !checked.showMeta}

      return prev.slice(0)
    })
    */ }, [
        checked
    ]);
    // data timelines
    (0, $acw62.useEffect)(()=>{
        if (!node || tab != 'apps') return;
        setLoadingTL(true);
        (0, $1455de3949293917$export$13386e296638fa34)({
            ...opts,
            vsn: vsn
        }).then((data)=>dispatch({
                type: 'INIT_DATA',
                data: data,
                nodes: [
                    node
                ]
            })).catch((error)=>dispatch({
                type: 'ERROR',
                error: error
            })).finally(()=>setLoadingTL(false));
    }, [
        vsn,
        node,
        opts,
        tab
    ]);
    // data timelines
    (0, $acw62.useEffect)(()=>{
        if (!node || tab != 'uploads') return;
        setLoadingTL(true);
        (0, $1455de3949293917$export$2dc7202091b59713)({
            ...opts,
            vsn: vsn
        }).then((data)=>{
            dispatch({
                type: 'INIT_DATA',
                data: data,
                nodes: [
                    node
                ]
            });
        }).catch((error)=>dispatch({
                type: 'ERROR',
                error: error
            })).finally(()=>setLoadingTL(false));
    }, [
        vsn,
        node,
        opts,
        tab
    ]);
    // fetch public ECR apps to determine if apps are indeed public
    (0, $acw62.useEffect)(()=>{
        $atFJM.listApps('public').then((ecr)=>setECR(ecr));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (tab != 'recent-records') return;
        $bcnr1.getData({
            start: latestRange,
            filter: {
                vsn: vsn
            },
            tail: 1
        }).then((data)=>{
            let allCols = [];
            const d = data.map((obj)=>{
                const { meta: meta, ...rest } = obj;
                allCols = [
                    ...allCols,
                    ...Object.keys(meta)
                ];
                return {
                    ...rest,
                    ...meta
                };
            });
            setRecent(d);
            setFilteredRecent(d);
            const uniqCols = [
                ...new Set(allCols)
            ];
            setCols(()=>[
                    ...$55ff8fe0cab419ec$var$latestRecColumns,
                    ...uniqCols.map((name)=>({
                            id: name,
                            label: name,
                            hide: true
                        })).filter((o)=>!$55ff8fe0cab419ec$var$latestRecColumns.find((obj)=>o.id == obj.id))
                ]);
        });
    }, [
        tab,
        latestRange,
        vsn
    ]);
    const handleOptionChange = (name, val)=>{
        if ([
            'nodes',
            'apps'
        ].includes(name)) {
            setOpts((prev)=>({
                    ...prev,
                    display: name
                }));
            return;
        } else if (name == 'time') {
            const time = val;
            const data = (0, $1455de3949293917$export$4c0e6fff2d4abe18)({
                data: rawData,
                time: time
            });
            dispatch({
                type: 'SET_DATA',
                data: data
            });
            setOpts((prev)=>({
                    ...prev,
                    [name]: time
                }));
            return;
        } else if (name == 'versions') {
            const versions = val;
            const data = (0, $1455de3949293917$export$4c0e6fff2d4abe18)({
                data: rawData,
                time: opts.time,
                versions: versions
            });
            dispatch({
                type: 'SET_DATA',
                data: data
            });
            setOpts((prev)=>({
                    ...prev,
                    [name]: versions
                }));
            return;
        } else if ([
            'colorType',
            'viewType'
        ].includes(name)) setOpts((prev)=>({
                ...prev,
                [name]: val
            }));
        else if (name == 'window') {
            if (!val) return;
            const showAll = val == 'showAll';
            setShowAll(showAll);
            const start = $55ff8fe0cab419ec$var$getStartTime(showAll ? '-20y' : val);
            setOpts((prev)=>({
                    ...prev,
                    ...val && {
                        window: val,
                        start: start
                    },
                    ...showAll && {
                        time: 'daily'
                    }
                }));
        } else throw `unhandled option state change name=${name}`;
    };
    const handleQuery = ({ query: query })=>{
        const d = (0, $52fc2129eac6b28c$export$3c598703d99462f5)(recent, query);
        setFilteredRecent(d);
    };
    const handleLatestOpts = (name, val)=>{
        setLatestRange(val);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                value: tab,
                "aria-label": "timeline view tabs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d437b3ea27dc377d$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        }), 'App History'),
                        value: "apps",
                        component: (0, $lzNIT.Link),
                        to: "?timeline=apps",
                        replace: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                        label: (0, $kalwe.tabLabel)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $424f77c771d04e79$export$2e2bcd8739ae039), {
                            fontSize: "small"
                        }), 'Latest Records'),
                        value: "recent-records",
                        component: (0, $lzNIT.Link),
                        to: "?timeline=recent-records",
                        replace: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($55ff8fe0cab419ec$var$TimelineContainer, {
                children: [
                    tab == 'apps' && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "timeline-title flex items-start gap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                children: (0, $lffEs.getRangeTitle)(opts.window)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39d20adadcde0807$export$2e2bcd8739ae039), {
                                onChange: handleOptionChange,
                                opts: opts,
                                quickRanges: [
                                    '-1y',
                                    '-90d',
                                    '-30d',
                                    '-7d',
                                    '-2d'
                                ],
                                density: true,
                                showAll: true,
                                condensed: true,
                                showViewType: true,
                                aggregation: true
                            })
                        ]
                    }),
                    loadingTL && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "clearfix w-full",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a4a018ec5a6eb95$export$2e2bcd8739ae039), {
                            includeHeader: false
                        })
                    }),
                    tab == 'apps' && data && opts.viewType == 'timeline' && !!Object.keys(data).length && ecr && !loadingTL && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                        data: data[vsn],
                        cellUnit: opts.time == 'daily' ? 'day' : 'hour',
                        colorCell: opts.colorType == 'density' ? (0, $4cab315b36f812e1$export$80ee56865356b7c3) : (0, $4cab315b36f812e1$export$1eaa38d4ebccfa84),
                        startTime: !showAll ? opts.start : null,
                        endTime: end,
                        tooltip: (item)=>`
              <div style="margin-bottom: 5px;">
                ${new Date(item.timestamp).toDateString()} ${new Date(item.timestamp).toLocaleTimeString([], {
                                timeStyle: 'short'
                            })} (${opts.time})
              </div>
              ${item.meta.plugin}<br>
              ${item.value.toLocaleString()} ${tab == 'uploads' ? 'uploads' : 'records'}`,
                        onCellClick: (data)=>{
                            const { timestamp: timestamp, meta: meta } = data;
                            const { vsn: vsn, origPluginName: origPluginName } = meta;
                            const date = new Date(timestamp);
                            const end = (opts.time == 'daily' ? (0, $4f754377033842c6$export$2e2bcd8739ae039)(date, 1) : (0, $eba2848fce1475e9$export$2e2bcd8739ae039)(date, 1)).toISOString();
                            let url;
                            if (tab == 'apps') url = `/query-browser?nodes=${vsn}&apps=${origPluginName}.*&start=${timestamp}&end=${end}`;
                            else if (tab == 'uploads') url = `/query-browser?type=images&tasks=${meta.task}&nodes=${vsn}&names=upload&start=${timestamp}&end=${end}`;
                            window.open(url, '_blank');
                        },
                        yFormat: (label)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $eb4b7a6d51daf17c$export$2e2bcd8739ae039), {
                                label: label,
                                ecr: ecr
                            }),
                        labelWidth: tab == 'uploads' ? $55ff8fe0cab419ec$var$TL_LABEL_WIDTH + 100 : $55ff8fe0cab419ec$var$TL_LABEL_WIDTH
                    }),
                    tab == 'recent-records' && filteredRecent && cols && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "rowID",
                            columns: cols,
                            rows: filteredRecent,
                            enableSorting: true,
                            sort: "-timestamp",
                            pagination: true,
                            page: 0,
                            rowsPerPage: 25,
                            limit: filteredRecent.length,
                            search: query,
                            onSearch: handleQuery,
                            onColumnMenuChange: ()=>{},
                            middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)($55ff8fe0cab419ec$var$Controls, {
                                className: "flex items-start gap",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39d20adadcde0807$export$2e2bcd8739ae039), {
                                    onChange: handleLatestOpts,
                                    opts: {
                                        colorType: null,
                                        window: latestRange
                                    },
                                    quickRanges: [
                                        '-10m',
                                        '-5m',
                                        '-1m'
                                    ],
                                    condensed: true
                                })
                            })
                        })
                    }),
                    data && !Object.keys(data).length && !loadingTL && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "clearfix"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "muted",
                                children: "No data available"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $55ff8fe0cab419ec$var$TimelineContainer = (0, $lmFrL.default).div`
  margin: 0 16px 16px 16px;
`;
const $55ff8fe0cab419ec$var$Controls = (0, $lmFrL.default).div`
  margin-left: 2rem;
`;


const $c17cd402450ea43c$var$ELAPSED_FAIL_THRES = (0, $dd9814843bcd5416$export$2e2bcd8739ae039).elapsedThresholds.fail;
// todo(nc): refactor more into a general config
const $c17cd402450ea43c$var$COMMON_SENSORS = [
    'BME680',
    'RG-15',
    'ES-642'
];
const $c17cd402450ea43c$var$hasSensor = (meta, sensors)=>meta?.sensors.some(({ hw_model: hw_model })=>{
        sensors = Array.isArray(sensors) ? sensors : [
            sensors
        ];
        const re = new RegExp(sensors.join('|'), 'gi');
        return hw_model.match(re);
    });
const $c17cd402450ea43c$export$2be08591ea73e876 = (computes)=>!!computes.some((o)=>o.zone == 'shield');
// todo(nc): solution assumes compute/sensor names are uniqu
const $c17cd402450ea43c$var$getInActive = (data)=>[
        ...data.computes.reduce((acc, o)=>!o.is_active ? [
                ...acc,
                o.name
            ] : acc, []),
        ...data.sensors.reduce((acc, o)=>!o.is_active ? [
                ...acc,
                o.hw_model
            ] : acc, [])
    ];
const $c17cd402450ea43c$var$getSensorList = (data)=>{
    const sensors = data?.sensors.filter((o)=>!o.capabilities.includes('camera') && !(0, $854549d671bc593b$export$534de2520f191712).includes(o.name));
    return sensors;
};
const $c17cd402450ea43c$var$getVisibleCameras = (node, isAdmin)=>{
    const { sensors: sensors } = node;
    const visibleSensors = isAdmin ? sensors : sensors.filter((o)=>o.is_active);
    const cameras = visibleSensors.filter((o)=>o.capabilities.includes('Camera'));
    return cameras.map((o)=>o.name);
};
function $c17cd402450ea43c$export$2e2bcd8739ae039(props) {
    const { admin: admin } = props;
    const vsn = (0, $aphAM.useParams)().vsn;
    const [params] = (0, $lzNIT.useSearchParams)();
    const tab = params.get('tab') || 'overview';
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [node, setNode] = (0, $acw62.useState)();
    const [manifest, setManifest] = (0, $acw62.useState)();
    const [inactive, setInactive] = (0, $acw62.useState)();
    const [bkMeta, setBKMeta] = (0, $acw62.useState)();
    const [status, setStatus] = (0, $acw62.useState)();
    const [liveGPS, setLiveGPS] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    const [vsnNotFound, setVsnNotFound] = (0, $acw62.useState)(null);
    const [loraDataWithRssi, setDataWithRssi] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        const p1 = $9bsRS.getNode(vsn).then((data)=>{
            setNode(data);
            setInactive($c17cd402450ea43c$var$getInActive(data));
            const id = data.name;
            // fetch the registration time from beekeeper
            $9bsRS.getBKState(id).then((data)=>setBKMeta(data)).catch((err)=>{
                setError({
                    message: `Beekeeper ${err.message}. Hence, the node registration time for ${vsn} was not found.`
                });
                setBKMeta({
                    registration_event: null
                });
            });
        }).catch((err)=>{
            if (err.message == 'Not found.') setVsnNotFound(true);
        });
        const p2 = $9bsRS.getManifest(vsn).then((data)=>setManifest(data)).catch(()=>{});
        const p3 = $bcnr1.getSimpleNodeStatus(vsn).then((records)=>{
            const elapsed = records.map((o)=>new Date().getTime() - new Date(o.timestamp).getTime());
            const isReporting = elapsed.some((val)=>val < $c17cd402450ea43c$var$ELAPSED_FAIL_THRES);
            setStatus(isReporting ? 'reporting' : 'not reporting');
        }).catch(()=>setStatus('unknown'));
        const p4 = $bcnr1.getGPS(vsn).then((d)=>setLiveGPS(d)).catch(()=>setLiveGPS(null));
        Promise.all([
            p1,
            p2,
            p3,
            p4
        ]).finally(()=>setLoading(false));
    }, [
        vsn,
        setLoading
    ]);
    // fetch rssi
    (0, $acw62.useEffect)(()=>{
        if (!manifest) return;
        $bcnr1.getLoraWithRssi(manifest).then((data)=>setDataWithRssi(data));
    }, [
        manifest
    ]);
    const shield = manifest?.computes ? $c17cd402450ea43c$export$2be08591ea73e876(manifest.computes) : false;
    const sensors = (0, $acw62.useMemo)(()=>{
        if (!manifest || !node || !vsn || !inactive) return;
        return $c17cd402450ea43c$var$getSensorList(node).map((obj, i)=>{
            const { hw_model: hw_model, name: name, capabilities: capabilities, is_active: is_active } = obj;
            const config = (0, $854549d671bc593b$export$ca9606c5da0d1e68)[hw_model];
            const start = config?.start || '-1d';
            const { sensor: sensor } = config || {};
            const isLora = capabilities.includes('lorawan');
            const deviceName = isLora ? name.replace(/_/g, ' ') : null;
            let scope;
            if (!isLora) // todo(nc): scope is only available in manifests, add to nodes endpoint
            scope = manifest.sensors.find((obj)=>obj.name == name).scope;
            const items = config?.names.map((obj)=>{
                const { name: name, label: label, units: units } = obj;
                return {
                    label: label || name,
                    query: {
                        vsn: vsn,
                        name: name,
                        start: start,
                        sensor: sensor,
                        deviceName: deviceName // for lorawan sensor
                    },
                    units: units,
                    linkParams: ({ meta: meta })=>[
                            `type=names`,
                            `nodes=${meta.vsn}`,
                            `names=${name}`,
                            `start=${start}`,
                            ...sensor ? [
                                `&sensors=${sensor}`
                            ] : [],
                            ...deviceName ? [
                                `&deviceNames=${deviceName}`
                            ] : []
                        ].join('&')
                };
            });
            if (!items) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06526ad812440b77$export$7d76682e61dc46e7), {
                title: hw_model,
                content: "Preview not configured"
            }, i);
            if (!admin && !is_active) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06526ad812440b77$export$7d76682e61dc46e7), {
                title: hw_model,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        "The ",
                        hw_model,
                        " sensor is marked as inactive ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4073a7ed36c832a6$export$2e2bcd8739ae039), {
                            id: node.id
                        })
                    ]
                })
            }, i);
            if (!admin && inactive.includes(scope)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06526ad812440b77$export$7d76682e61dc46e7), {
                title: hw_model,
                content: `The ${scope} is marked as inactive`
            }, i);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06526ad812440b77$export$2e2bcd8739ae039), {
                title: deviceName ? deviceName : hw_model,
                items: items,
                previewLabel: (0, $lffEs.quickRanges)[start],
                className: `hover-${hw_model}`
            }, i);
        });
    }, [
        manifest,
        node,
        inactive,
        vsn
    ]);
    if (vsnNotFound) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34d1c5c943619e11$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c17cd402450ea43c$var$Root, {
        children: [
            (0, $gTmRg.CardViewStyle),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "info",
                children: error.message
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($c17cd402450ea43c$var$LeftSide, {
                        className: "flex column gap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06e1e255202fae97$export$2e2bcd8739ae039), {
                                node: node,
                                manifest: manifest,
                                bkMeta: bkMeta,
                                loraDataWithRssi: loraDataWithRssi,
                                tab: tab,
                                admin: admin,
                                liveGPS: liveGPS,
                                loading: loading,
                                status: status
                            }),
                            manifest?.sensors.some((item)=>item.capabilities.includes('lorawan')) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                        children: [
                                            "LoRaWAN",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                                to: `${(0, $gZwVy.default).docs}/about/architecture#lorawan`,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($c17cd402450ea43c$var$HelpIcon, {})
                                            })
                                        ]
                                    }),
                                    loraDataWithRssi && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                                        primaryKey: "deveui",
                                        columns: (0, $6c3d116a34d884c6$export$59e48b3563bb8be9),
                                        rows: loraDataWithRssi,
                                        enableSorting: true,
                                        emptyNotice: "No devices found"
                                    }),
                                    !loraDataWithRssi && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eqsnC.default), {
                                        noSearch: true,
                                        rows: 5
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                                noPad: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55ff8fe0cab419ec$export$2e2bcd8739ae039), {
                                    node: node
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                        className: "flex justify-between",
                                        children: [
                                            "Sensors ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4073a7ed36c832a6$export$2e2bcd8739ae039), {
                                                id: node?.id
                                            })
                                        ]
                                    }),
                                    inactive && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            admin && !!inactive.length && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                                severity: "info",
                                                sx: {
                                                    marginBottom: '1em'
                                                },
                                                action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4073a7ed36c832a6$export$2e2bcd8739ae039), {
                                                    id: node?.id
                                                }),
                                                children: [
                                                    (0, $lffEs.prettyList)(inactive),
                                                    " ",
                                                    inactive.length > 1 ? 'are' : 'is',
                                                    " marked as inactive"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c44972b00cb09b56$export$2e2bcd8739ae039), {
                                                columns: 2,
                                                spacing: 2,
                                                children: sensors
                                            })
                                        ]
                                    }),
                                    !$c17cd402450ea43c$var$hasSensor(node, $c17cd402450ea43c$var$COMMON_SENSORS) && vsn != 'X001' && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "muted",
                                        children: [
                                            "No configuration was found for common sensors (",
                                            $c17cd402450ea43c$var$COMMON_SENSORS.slice(0, -1).join(', '),
                                            ", or ",
                                            $c17cd402450ea43c$var$COMMON_SENSORS.slice(-1),
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: "Images"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($c17cd402450ea43c$var$Imgs, {
                                        children: node && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73e08e4740801120$export$2e2bcd8739ae039), {
                                            vsn: vsn,
                                            cameras: $c17cd402450ea43c$var$getVisibleCameras(node, admin),
                                            horizontal: true
                                        })
                                    })
                                ]
                            }),
                            shield && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        children: "Audio"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d58c41d80e376ef6$export$2e2bcd8739ae039), {
                                        vsn: vsn,
                                        className: "hover-audio"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($c17cd402450ea43c$var$RightSide, {
                        className: "justify-end",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                noPad: true,
                                children: [
                                    node?.hasStaticGPS && status && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                                        showUptime: false,
                                        // @ts-ignore; todo: map does not actually need manifest info since showUptime == false
                                        data: [
                                            {
                                                ...node,
                                                hasLiveGPS: !!liveGPS,
                                                status: status
                                            }
                                        ]
                                    }),
                                    !node?.hasStaticGPS && !!liveGPS && status && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                                        showUptime: false,
                                        // @ts-ignore; todo: map does not actually need manifest info since showUptime == false
                                        data: [
                                            {
                                                ...node,
                                                lat: liveGPS.lat,
                                                lng: liveGPS.lon,
                                                hasLiveGPS: true,
                                                status: status
                                            }
                                        ]
                                    }),
                                    !node?.hasStaticGPS && !liveGPS && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "muted",
                                        style: {
                                            margin: 18
                                        },
                                        children: "(Map not available)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df72e33dd0bd0807$export$2e2bcd8739ae039), {
                                node: node,
                                shield: shield
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $c17cd402450ea43c$var$Root = (0, $d8seH.default)('div')`
  h2 {
    margin-top: 0;
  }

  .meta-left {
    flex: 3;
    height: 100%;

    tbody td:first-child {
      white-space: nowrap;
    }
  }

  .meta-right {
    flex: 4;

    .summary-table table td:first-child {
      display: none;
    }
  }

  .timeline-title {
    float: left;
    h2 { margin-right: 1em; }
  }
`;
const $c17cd402450ea43c$var$Imgs = (0, $d8seH.default)('div')`
  img {
    max-width: 380px;
    object-fit: contain;
  }
`;
const $c17cd402450ea43c$var$LeftSide = (0, $d8seH.default)('div')`
  margin: 20px;
  flex: 2 1 auto;
`;
const $c17cd402450ea43c$var$RightSide = (0, $d8seH.default)('div')`
  margin: 20px 20px 20px 15px;
`;
const $c17cd402450ea43c$export$f2c3aea42b2a048f = (0, $d8seH.default)('div')`
  padding: 0 1rem 1rem 1rem;
`;
const $c17cd402450ea43c$var$HelpIcon = (0, $d8seH.default)((0, $cc200de1acd27a89$export$2e2bcd8739ae039))`
  width: 15px;
  color: #1c8cc9;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $6lXkL = parcelRequire("6lXkL");
var $6ami2 = parcelRequire("6ami2");

var $3c4d0782a0aeb057$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $3c4d0782a0aeb057$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($3c4d0782a0aeb057$exports, "__esModule", {
    value: true
});
$3c4d0782a0aeb057$exports.default = void 0;

var $3c4d0782a0aeb057$var$_createSvgIcon = $3c4d0782a0aeb057$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $3c4d0782a0aeb057$var$_default = $3c4d0782a0aeb057$exports.default = (0, $3c4d0782a0aeb057$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1q-.15.15-.15.36M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'EditRounded');




var $hw4Z0 = parcelRequire("hw4Z0");


var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $cFBau = parcelRequire("cFBau");
var $gd5y7 = parcelRequire("gd5y7");
var $i32L9 = parcelRequire("i32L9");
var $iAtns = parcelRequire("iAtns");
var $cJQfW = parcelRequire("cJQfW");
function $86ba48c15c409e47$export$2e2bcd8739ae039(props) {
    const { fields: fields, data: data, state: state, isEditing: isEditing, onChange: onChange } = props;
    const handleInputChange = (evt)=>{
        const { name: name, value: value } = evt.target;
        onChange(name, value);
    };
    const handleAutocompleteChange = (id, value)=>{
        onChange(id, value);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($86ba48c15c409e47$var$Root, {
        children: fields.map((obj)=>{
            const { id: id, label: label, edit: edit, type: type, helpText: helpText, maxLength: maxLength, multiple: multiple, options: options, width: width, placeholder: placeholder } = obj;
            const value = data[id];
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    (edit == false || !isEditing) && /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: label
                    }),
                    isEditing && edit != false ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                        margin: "normal",
                        children: [
                            multiple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                multiple: true,
                                freeSolo: true,
                                options: options || [],
                                onChange: (_, value)=>handleAutocompleteChange(id, value),
                                // getOptionLabel={(option) => option.label}
                                defaultValue: value,
                                filterSelectedOptions: true,
                                sx: {
                                    width: width || 500
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        ...params,
                                        label: label,
                                        placeholder: placeholder,
                                        slotProps: {
                                            inputLabel: {
                                                shrink: true
                                            }
                                        }
                                    })
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                label: label,
                                placeholder: placeholder,
                                "aria-label": label,
                                name: id,
                                onChange: handleInputChange,
                                value: state[id],
                                multiline: type == 'textarea',
                                minRows: type == 'textarea' ? 4 : 0,
                                sx: {
                                    width: width || (type == 'textarea' ? 500 : 300)
                                },
                                slotProps: {
                                    htmlInput: {
                                        maxLength: maxLength
                                    },
                                    inputLabel: {
                                        shrink: true
                                    }
                                }
                            }),
                            helpText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
                                children: helpText
                            }),
                            maxLength && /*#__PURE__*/ (0, $ayMG0.jsx)($86ba48c15c409e47$var$FocusedHelperText, {
                                text: state[id]?.length > 20 && `${maxLength - state[id]?.length} characters left`
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: value ? value : /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                            className: "muted",
                            children: "Not available"
                        })
                    })
                ]
            }, id);
        })
    });
}
const $86ba48c15c409e47$var$Root = (0, $lmFrL.default).div`
`;
function $86ba48c15c409e47$var$FocusedHelperText({ text: text }) {
    const { focused: focused } = (0, $cJQfW.default)();
    const helperText = (0, $acw62.useMemo)(()=>{
        return focused ? text : '';
    }, [
        focused,
        text
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i32L9.default), {
        children: helperText
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $lmFrL = parcelRequire("lmFrL");
function $9dc74b806698c54b$export$2e2bcd8739ae039(props) {
    const { path: path, onNavigate: onNavigate } = props;
    const parts = path.split('/');
    parts.shift();
    const topLevel = decodeURIComponent(parts[0]);
    const currentLevel = parts.length - 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9dc74b806698c54b$var$Root, {
        children: [
            ' / ',
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/${topLevel}`,
                onClick: (evt)=>onNavigate(evt, `/${topLevel}`),
                children: topLevel.split('@')[0]
            }),
            ' / ',
            parts.slice(1).map((name, i)=>{
                const userPath = parts.slice(1, 2 + i).join('/');
                const fullPath = `/${topLevel}/${userPath}`;
                const path = `/${fullPath}`;
                return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: i == currentLevel - 1 ? name : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                to: path,
                                onClick: (evt)=>onNavigate(evt, fullPath),
                                children: name
                            }),
                            ' / '
                        ]
                    })
                }, i);
            })
        ]
    });
}
const $9dc74b806698c54b$var$Root = (0, $lmFrL.default).div`
  background-color: #fff;
  font-size: 1.1em;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $gOa8m = parcelRequire("gOa8m");

var $9bsRS = parcelRequire("9bsRS");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $aphAM = parcelRequire("aphAM");

var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $6ff6af0e7b54a176$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1"
}), 'AddRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $645d3c26402e93bc$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M6 15h6v2H6zm6-8h6v2h-6zm-3 4h6v2H9z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z"
    }, "1")
], 'ViewTimelineOutlined');



var $f1q41 = parcelRequire("f1q41");

var $hw4Z0 = parcelRequire("hw4Z0");

var $7L4OA = parcelRequire("7L4OA");

var $gOa8m = parcelRequire("gOa8m");
var $eqsnC = parcelRequire("eqsnC");


var $lffEs = parcelRequire("lffEs");


var $gTmRg = parcelRequire("gTmRg");
// @ts-nocheck -- type checking for timeline is still a todo

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $cVXaD = parcelRequire("cVXaD");

var $ifEev = parcelRequire("ifEev");

const $3bc0c95c48ca4029$var$colorMap = {
    completed: (0, $66ac2ba2d2031913$export$35e9368ef982300f).green4,
    complete: (0, $66ac2ba2d2031913$export$35e9368ef982300f).green4,
    failed: (0, $66ac2ba2d2031913$export$35e9368ef982300f).red4,
    running: 'rgb(235, 172, 101, .6)',
    undefined: (0, $66ac2ba2d2031913$export$35e9368ef982300f).noValue
};
function $3bc0c95c48ca4029$export$2e2bcd8739ae039(props) {
    const { data: data, errors: errors, start: start } = props;
    const navigate = (0, $aphAM.useNavigate)();
    const [selectedEvent, setSelectedEvent] = (0, $acw62.useState)(false);
    const getErrors = (pluginEvent)=>{
        const { goal_id: goal_id, k3s_pod_instance: k3s_pod_instance } = pluginEvent.value;
        const text = (errors[goal_id] || []).filter((obj)=>obj.value.k3s_pod_instance == k3s_pod_instance).map((obj)=>obj.value.error_log);
        return text.length == 0 ? 'no errors found' : text;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($3bc0c95c48ca4029$var$Root, {
        children: [
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                data: data,
                startTime: new Date(start),
                scaleExtent: [
                    .2,
                    1000
                ],
                colorCell: (val, obj)=>{
                    if (obj.status === undefined) return (0, $66ac2ba2d2031913$export$35e9368ef982300f).noValue;
                    return $3bc0c95c48ca4029$var$colorMap[obj.status];
                },
                tooltip: (obj)=>`
            ${new Date(obj.timestamp).toLocaleString()}
            - ${new Date(obj.end).toLocaleTimeString()}<br>
            <br/>
            <b>goal id:</b> ${obj.value.goal_id}<br>
            <b>image:</b> ${obj.value.plugin_image}<br>
            <b>task:</b> ${obj.value.plugin_task}<br>
            <b>args:</b> ${obj.value.plugin_args}<br>
            <b>selector:</b> ${obj.value.plugin_selector}<br>
            <b>status:</b>
              <b class="${obj.status}">${obj.status}</b><br>
          `,
                yFormat: (label)=>{
                    // todo: this is workaround to ensure chart can be updated when y axis changes(?)
                    if (!data[label]) return;
                    // just form label from first entry
                    const l = data[label][0].value.plugin_image;
                    const path = l.replace('registry.sagecontinuum.org/', '').split(':')[0];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                path,
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "(click for details)"
                            ]
                        }),
                        placement: "right",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                            to: `/apps/app/${path}`,
                            children: label
                        }, label)
                    });
                },
                onCellClick: (data)=>{
                    // show errors for red boxes
                    if (data.status == 'failed') {
                        setSelectedEvent(data);
                        return;
                    }
                    const { value: value, meta: meta, timestamp: timestamp, end: end } = data;
                    const image = value.plugin_image;
                    const { vsn: vsn } = meta;
                    const app = image.slice(image.lastIndexOf('/') + 1);
                    navigate(`/query-browser/?apps=.*${app}&nodes=${vsn}&start=${timestamp}&end=${end}`);
                },
                labelWidth: 175,
                tooltipPos: "top"
            }),
            selectedEvent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: "Errors",
                onClose: ()=>setSelectedEvent(false),
                onConfirm: ()=>setSelectedEvent(false),
                content: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                    children: getErrors(selectedEvent)
                }),
                maxWidth: "65%"
            })
        ]
    });
}
const $3bc0c95c48ca4029$var$Root = (0, $lmFrL.default).div`

`;



// @ts-nocheck -- type checking for timeline is still a todo

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $2esSG = parcelRequire("2esSG");
var $9Lykx = parcelRequire("9Lykx");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $c270bfce12616bee$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $c270bfce12616bee$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($c270bfce12616bee$exports, "__esModule", {
    value: true
});
$c270bfce12616bee$exports.default = void 0;

var $c270bfce12616bee$var$_createSvgIcon = $c270bfce12616bee$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $c270bfce12616bee$var$_default = $c270bfce12616bee$exports.default = (0, $c270bfce12616bee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4H4c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2m0 14H4V8h16zm-8-2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1M6.79 9.71c.39-.39 1.02-.39 1.41 0l2.59 2.59c.39.39.39 1.02 0 1.41L8.2 16.3c-.39.39-1.02.39-1.41 0a.996.996 0 0 1 0-1.41L8.67 13l-1.88-1.88a.996.996 0 0 1 0-1.41"
}), 'TerminalRounded');


var $0bfcfc6d9f51e2a8$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $0bfcfc6d9f51e2a8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0bfcfc6d9f51e2a8$exports, "__esModule", {
    value: true
});
$0bfcfc6d9f51e2a8$exports.default = void 0;

var $0bfcfc6d9f51e2a8$var$_createSvgIcon = $0bfcfc6d9f51e2a8$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $0bfcfc6d9f51e2a8$var$_default = $0bfcfc6d9f51e2a8$exports.default = (0, $0bfcfc6d9f51e2a8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2m0 3c0 .55-.45 1-1 1h-8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1m-6 5v-2h2v2zm2 2v2h-2v-2zm-4-2H9v-2h2zm6-2h2v2h-2zm-8 4h2v2H9zm8 2v-2h2v2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1z"
}), 'TableViewRounded');



var $hBKHw = parcelRequire("hBKHw");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9khrJ = parcelRequire("9khrJ");

var $2mdyF = parcelRequire("2mdyF");
var $2gURC = parcelRequire("2gURC");

var $7upBl = parcelRequire("7upBl");

var $2sxTc = parcelRequire("2sxTc");
function $6e85fc454e9dbe5c$export$2e2bcd8739ae039(props) {
    const { data: data } = props;
    const classes = (0, $9khrJ.useAccordionStyles)();
    const [expanded, setExpanded] = (0, $acw62.useState)(null);
    const handleChange = (panel)=>(_, isExpanded)=>{
            setExpanded(isExpanded ? panel : null);
        };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: data.map((app, i)=>{
            const { name: name, goal_id: goal_id, plugin_spec: plugin_spec } = app;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9khrJ.default), {
                className: classes.root,
                expanded: expanded == i,
                onChange: handleChange(i),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                        expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7upBl))), {}),
                        "aria-controls": `${goal_id}-content`,
                        id: `${goal_id}-content`,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2mdyF.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Goal ID:"
                            }),
                            " ",
                            goal_id,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                children: (0, $2sxTc.stringify)(plugin_spec)
                            })
                        ]
                    })
                ]
            }, i);
        })
    });
}



var $ifEev = parcelRequire("ifEev");


var $lDN4l = parcelRequire("lDN4l");

var $5xexf = parcelRequire("5xexf");




parcelRequire("kalwe");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");
var $cVXaD = parcelRequire("cVXaD");
var $a0a5450dd7e50a49$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $a0a5450dd7e50a49$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($a0a5450dd7e50a49$exports, "__esModule", {
    value: true
});
$a0a5450dd7e50a49$exports.default = void 0;

var $a0a5450dd7e50a49$var$_createSvgIcon = $a0a5450dd7e50a49$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $a0a5450dd7e50a49$var$_default = $a0a5450dd7e50a49$exports.default = (0, $a0a5450dd7e50a49$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'ErrorOutline');



var $bcnr1 = parcelRequire("bcnr1");

var $f1q41 = parcelRequire("f1q41");
const $40e87a8fc7815d98$var$pluginEventTypes = [
    'sys.scheduler.status.plugin.queued',
    'sys.scheduler.status.plugin.selected',
    'sys.scheduler.status.plugin.scheduled',
    'sys.scheduler.status.plugin.initializing',
    'sys.scheduler.status.plugin.running',
    'sys.scheduler.status.plugin.failed',
    'sys.scheduler.status.plugin.complete',
    'sys.scheduler.status.plugin.launched'
];
const $40e87a8fc7815d98$var$parseESRecord = (data)=>data.map((o)=>({
            ...o,
            value: JSON.parse(o.value)
        }));
const $40e87a8fc7815d98$var$emptyTask = {
    pluginruntime_pod_instance: null,
    node: null,
    vsn: null,
    events: [],
    queued_start: null,
    selected_start: null,
    scheduled_start: null,
    initializing_start: null,
    running_start: null,
    end_time: null,
    metric_queued: null,
    metric_selected: null,
    metric_scheduled: null,
    metric_initializing: null,
    metric_running: null
};
function $40e87a8fc7815d98$export$1bb22295c2bc6770(args) {
    const { start: start, vsns: vsns, job: job, includeAllTasks: includeAllTasks } = args || {};
    return $bcnr1.getData({
        start: start || '-24h',
        filter: {
            name: 'sys.scheduler.status.plugin.*',
            ...vsns && {
                vsn: vsns.join('|')
            }
        }
    }).then((data)=>$40e87a8fc7815d98$var$parseESRecord(data)).then((pluginEvents)=>{
        return $40e87a8fc7815d98$var$reduceData(pluginEvents, job, includeAllTasks);
    });
}
// O(p*t*s) where p:= number of plugins, t:= number of tasks, s:= number of status messages
function $40e87a8fc7815d98$var$reduceData(pluginEvents, job, includeAllTasks) {
    // filter to related plugins if needed
    if (!includeAllTasks) {
        const taskNames = job.plugins.map((o)=>o.name);
        pluginEvents = pluginEvents.filter((obj)=>taskNames.includes(obj.value.plugin_name));
    }
    const oldRecords = pluginEvents.filter((obj)=>!obj.value.pluginruntime_pod_instance);
    const oldCount = oldRecords.length;
    if (oldCount) throw `${oldCount.toLocaleString()} records out
    of ${pluginEvents.length.toLocaleString()} are incompatible
    with the task viewer for this selected range, and so this task list is not currently available.`;
    const data = (0, $f1q41.groupBy)(pluginEvents, 'value.plugin_name');
    const taskByPluginName = {};
    Object.entries(data).forEach(([name, messages])=>{
        const byPodInstance = (0, $f1q41.groupBy)(messages, 'value.pluginruntime_pod_instance');
        const tasks = [];
        // create single task
        Object.entries(byPodInstance).forEach(([pod, statuses])=>{
            let task = $40e87a8fc7815d98$var$emptyTask;
            task.pluginruntime_pod_instance = pod;
            statuses.forEach((event)=>{
                const { timestamp: timestamp, name: name, value: value, meta: meta } = event;
                const n = name.split('.').pop();
                if (n == 'complete' || n == 'failed') task[`end_time`] = timestamp;
                if (n == 'event') task.events = [
                    ...task.events,
                    event
                ];
                else task[`${n}_start`] = timestamp;
                if (!task.node || !task.vsn) task = {
                    ...task,
                    ...meta
                };
                task = {
                    ...task,
                    ...value
                };
            });
            // add metrics
            task.metric_queued = $40e87a8fc7815d98$var$timeDiff(task.queued_start, task.selected_start);
            task.metric_selected = $40e87a8fc7815d98$var$timeDiff(task.selected_start, task.scheduled_start);
            task.metric_scheduled = $40e87a8fc7815d98$var$timeDiff(task.scheduled_start, task.initializing_start);
            task.metric_initializing = $40e87a8fc7815d98$var$timeDiff(task.initializing_start, task.running_start);
            task.metric_running = $40e87a8fc7815d98$var$timeDiff(task.running_start, task.end_time);
            tasks.push(task);
        });
        taskByPluginName[name] = tasks;
    });
    return taskByPluginName;
}
const $40e87a8fc7815d98$var$timeDiff = (start, end)=>{
    const e = new Date(end).getTime();
    const s = new Date(start).getTime();
    if (s > e) return;
    return (e - s) / 1000;
};



var $gOa8m = parcelRequire("gOa8m");
var $eqsnC = parcelRequire("eqsnC");


var $lffEs = parcelRequire("lffEs");

var $gZwVy = parcelRequire("gZwVy");

const { contactUs: $6a4558d2db5a85f3$var$contactUs } = (0, $gZwVy.default);
const $6a4558d2db5a85f3$var$prettyTime = (d)=>{
    if (!d) return '-';
    return new Date(d).toLocaleString() // + new Date(d).getMilliseconds()
    ;
};
const $6a4558d2db5a85f3$var$prettyDiff = (ms)=>{
    if (ms == 0) return '~0';
    if (!ms) return '-';
    return $lffEs.prettyTimeMS(ms);
};
const $6a4558d2db5a85f3$var$cols = [
    {
        id: 'pluginruntime_pod_instance',
        label: 'Pod'
    },
    {
        id: 'queued_start',
        label: 'Queued',
        format: $6a4558d2db5a85f3$var$prettyTime
    },
    {
        id: 'selected_start',
        label: 'Selected',
        format: $6a4558d2db5a85f3$var$prettyTime,
        hide: true
    },
    {
        id: 'scheduled_start',
        label: 'Scheduled',
        format: $6a4558d2db5a85f3$var$prettyTime,
        hide: true
    },
    {
        id: 'initializing_start',
        label: 'Initialized',
        format: $6a4558d2db5a85f3$var$prettyTime,
        hide: true
    },
    {
        id: 'running_start',
        label: 'Started',
        format: $6a4558d2db5a85f3$var$prettyTime
    },
    {
        id: 'end_time',
        label: 'Ended',
        format: (v, obj)=>obj.failed_start ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: obj.error_log,
                placement: "right",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex items-center gap failed",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: $6a4558d2db5a85f3$var$prettyTime(v)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a0a5450dd7e50a49$exports))), {
                            fontSize: "small"
                        })
                    ]
                })
            }) : $6a4558d2db5a85f3$var$prettyTime(v)
    },
    // metrics
    {
        id: 'metric_queued',
        label: 'Queue Time',
        format: $6a4558d2db5a85f3$var$prettyDiff
    },
    {
        id: 'metric_selected',
        label: 'Selected Time',
        format: $6a4558d2db5a85f3$var$prettyDiff
    },
    {
        id: 'metric_scheduled',
        label: 'Scheduled Time',
        format: $6a4558d2db5a85f3$var$prettyDiff
    },
    {
        id: 'metric_initializing',
        label: 'Initializing Time',
        format: $6a4558d2db5a85f3$var$prettyDiff
    },
    {
        id: 'metric_running',
        label: 'Runtime',
        format: $6a4558d2db5a85f3$var$prettyDiff
    }
];
function $6a4558d2db5a85f3$export$2e2bcd8739ae039(props) {
    const { job: job, start: start, showAllTasks: showAllTasks } = props;
    const { nodes: nodes } = job;
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [qData, setQData] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)();
    const [page] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        (0, $40e87a8fc7815d98$export$1bb22295c2bc6770)({
            vsns: nodes,
            start: start,
            job: job,
            includeAllTasks: showAllTasks
        }).then((byApp)=>{
            const tasks = [].concat(...Object.values(byApp));
            setData(tasks);
            setQData(tasks);
        }).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        start,
        showAllTasks
    ]);
    const handleQuery = ({ query: query })=>{
        setQData((0, $52fc2129eac6b28c$export$3c598703d99462f5)(data, query));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($6a4558d2db5a85f3$var$TableContainer, {
            children: [
                qData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                    primaryKey: "pluginruntime_pod_instance",
                    rows: qData,
                    columns: $6a4558d2db5a85f3$var$cols,
                    storageKey: "task-listing",
                    enableSorting: true,
                    pagination: true,
                    page: page,
                    limit: qData.length,
                    rowsPerPage: 25,
                    onSearch: handleQuery,
                    sort: "-running_start",
                    onColumnMenuChange: ()=>{},
                    emptyNotice: "No tasks found",
                    // onSelect={handleSelect}
                    middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {})
                }),
                !data && !error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eqsnC.default), {}),
                error && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                    severity: "info",
                    children: [
                        error,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Please ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: $6a4558d2db5a85f3$var$contactUs,
                                children: "contact us"
                            })
                        }),
                        " if you think this could be a mistake."
                    ]
                })
            ]
        })
    });
}
const $6a4558d2db5a85f3$var$TableContainer = (0, $lmFrL.default).div`
  margin-top: 1rem;
`;



var $b8Rua = parcelRequire("b8Rua");




var $lffEs = parcelRequire("lffEs");

var $f1q41 = parcelRequire("f1q41");


var $hw4Z0 = parcelRequire("hw4Z0");
const $fdc2e6d7b93e9128$var$TAIL_DAYS = '-1d';
const $fdc2e6d7b93e9128$var$getStartTime = (str)=>(0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), str.replace(/-|d/g, ''));
function $fdc2e6d7b93e9128$export$2e2bcd8739ae039(props) {
    const { job: job, nodeMetaByVSN: nodeMetaByVSN, handleCloseDialog: handleCloseDialog } = props;
    const { pathname: pathname } = (0, $aphAM.useLocation)();
    const [params] = (0, $lzNIT.useSearchParams)();
    const tab = params.get('tab') || 'timeline';
    const [yaml, setYaml] = (0, $acw62.useState)();
    const [eventsByNode, setEventsByNode] = (0, $acw62.useState)();
    const [errorsByGoalID, setErrorsByGoalID] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)();
    // all events related to the job being looked at (by node)
    const [events, setEvents] = (0, $acw62.useState)();
    const [showAllTasks, setShowAllTasks] = (0, $acw62.useState)(false);
    const [opts, setOpts] = (0, $acw62.useState)({
        start: $fdc2e6d7b93e9128$var$getStartTime($fdc2e6d7b93e9128$var$TAIL_DAYS),
        window: $fdc2e6d7b93e9128$var$TAIL_DAYS
    });
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    (0, $acw62.useEffect)(()=>{
        if (!job) return;
        const { start: start } = opts;
        setLoading(true);
        $b8Rua.getEvents({
            vsns: job.nodes,
            start: start
        }).then(({ events: events, errors: errors })=>{
            setEventsByNode(events);
            setErrorsByGoalID(errors);
        }).catch((error)=>setError(error.message)).finally(()=>setLoading(false));
    }, [
        job,
        setLoading,
        opts
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!eventsByNode || !job) return;
        if (showAllTasks) setEvents(eventsByNode);
        else {
            const taskNames = job.plugins.map((o)=>o.name);
            // filter to relevant tasks (by node)
            const byNode = {};
            Object.keys(eventsByNode).forEach((vsn)=>{
                byNode[vsn] = (0, $f1q41.pickBy)(eventsByNode[vsn], (_, key)=>taskNames.includes(key));
            });
            setEvents(byNode);
        }
    }, [
        job,
        eventsByNode,
        showAllTasks
    ]);
    const handleViewYaml = ()=>{
        if (yaml) {
            setYaml(null);
            return;
        }
        $b8Rua.getTemplate(job.job_id, 'yaml').then((yaml)=>setYaml(yaml)).catch((error)=>setYaml(error.message));
    };
    const handleOptionChange = (name, val)=>{
        if (name == 'window') setOpts((prev)=>({
                ...prev,
                ...val && {
                    window: val,
                    start: $fdc2e6d7b93e9128$var$getStartTime(val)
                }
            }));
        else throw `unhandled option state change name=${name}`;
    };
    const handleDownload = ()=>{
        $b8Rua.downloadTemplate(job.job_id);
    };
    const dayCount = opts.window.replace(/-|d/g, '');
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "Job Overview"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    orientation: "vertical",
                    flexItem: true,
                    sx: {
                        margin: '5px 10px'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                    component: (0, $lzNIT.Link),
                    variant: "contained",
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c4d0782a0aeb057$exports))), {}),
                    size: "small",
                    to: `/jobs/create-job?tab=editor&start_with_job=${job.job_id}`,
                    children: "Recreate or edit job"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    orientation: "vertical",
                    flexItem: true,
                    sx: {
                        margin: '5px 10px'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: yaml ? 'Show table' : 'Show YAML',
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: handleViewYaml,
                        children: yaml ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0bfcfc6d9f51e2a8$exports))), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c270bfce12616bee$exports))), {})
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                    title: "Download spec",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                        onClick: handleDownload,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {})
                    })
                })
            ]
        }),
        fullScreen: true,
        onConfirm: handleCloseDialog,
        onClose: handleCloseDialog,
        confirmBtnText: "Close",
        content: /*#__PURE__*/ (0, $ayMG0.jsxs)($fdc2e6d7b93e9128$var$Content, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($fdc2e6d7b93e9128$var$JobMetaContainer, {
                    children: [
                        yaml && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                            content: yaml
                        }),
                        !yaml && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f33fb571dcb5924$export$2e2bcd8739ae039), {
                            rows: [
                                {
                                    id: 'job_id',
                                    label: 'Job ID'
                                },
                                {
                                    id: 'user',
                                    label: 'User'
                                },
                                {
                                    id: 'apps',
                                    label: `Apps (${job.plugins.length})`,
                                    format: (0, $3d03a7c5535c78ec$export$fe98a034cfb96d55).apps
                                },
                                {
                                    id: 'nodes',
                                    label: `Nodes (${job.nodes.length})`,
                                    format: (0, $3d03a7c5535c78ec$export$fe98a034cfb96d55).nodes
                                },
                                {
                                    id: 'node_tags',
                                    label: `Node Tags`,
                                    format: (v)=>(v || []).join(', ')
                                },
                                {
                                    id: 'params',
                                    label: `Params`,
                                    format: (v, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e85fc454e9dbe5c$export$2e2bcd8739ae039), {
                                            data: obj.plugins
                                        })
                                },
                                {
                                    id: 'science_rules',
                                    label: `Science Rules`,
                                    format: (v)=>/*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                            children: (v || []).join('\n')
                                        })
                                },
                                {
                                    id: 'success_criteria',
                                    label: `Success Criteria`,
                                    format: (v)=>/*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                            children: (v || []).join('\n')
                                        })
                                }
                            ],
                            data: job
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aDtBU.default), {
                    value: tab,
                    "aria-label": "timeline or table",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($09fc43707f437bd6$exports))), {}),
                                    "\xa0Timeline"
                                ]
                            }),
                            value: "timeline",
                            component: (0, $lzNIT.Link),
                            to: `${pathname}?job=${job.job_id}&tab=timeline`,
                            replace: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2e13a979320b0aad$exports))), {}),
                                    "\xa0Task List"
                                ]
                            }),
                            value: "tasks",
                            component: (0, $lzNIT.Link),
                            to: `${pathname}?job=${job.job_id}&tab=tasks`,
                            replace: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "timeline-title flex items-center gap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "no-margin",
                            children: [
                                "Last ",
                                dayCount == '1' ? 'day' : `${dayCount} days`,
                                " of events"
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39d20adadcde0807$export$2e2bcd8739ae039), {
                            quickRanges: [
                                '-90d',
                                '-30d',
                                '-7d',
                                '-2d',
                                '-1d'
                            ],
                            onChange: handleOptionChange,
                            opts: opts
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                checked: showAllTasks,
                                onChange: (evt)=>setShowAllTasks(evt.target.checked)
                            }),
                            label: "Show all tasks"
                        })
                    ]
                }),
                tab == 'tasks' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a4558d2db5a85f3$export$2e2bcd8739ae039), {
                    job: job,
                    start: opts.start,
                    showAllTasks: showAllTasks
                }),
                tab == 'timeline' && !events && loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a4a018ec5a6eb95$export$2e2bcd8739ae039), {}),
                error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                    children: error
                }),
                tab == 'timeline' && events && Object.keys(events).map((vsn)=>{
                    const { address: address } = nodeMetaByVSN[vsn];
                    const data = events[vsn];
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b85f1216005eff9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "title-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex column",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                                    to: `/nodes/${vsn}`,
                                                    children: vsn
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            children: address
                                        })
                                    ]
                                }),
                                loading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a4a018ec5a6eb95$export$2e2bcd8739ae039), {
                                        includeHeader: false
                                    })
                                }),
                                !loading && !Object.keys(data).length && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "muted",
                                    children: [
                                        !showAllTasks && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "No events found for this job (for the ",
                                                (0, $lffEs.quickRanges)[opts.window],
                                                ")."
                                            ]
                                        }),
                                        showAllTasks && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                "No events found for the ",
                                                (0, $lffEs.quickRanges)[opts.window],
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                !loading && Object.keys(data).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bc0c95c48ca4029$export$2e2bcd8739ae039), {
                                    data: data,
                                    errors: errorsByGoalID,
                                    start: opts.start
                                })
                            ]
                        })
                    }, vsn);
                })
            ]
        })
    });
}
const $fdc2e6d7b93e9128$var$JobMetaContainer = (0, $d8seH.default)('div')`
  tbody td:first-child {
    width: 120px;
    text-align: right;
    vertical-align: top;
  }

  td > pre {
    margin: 0;
  }
`;
const $fdc2e6d7b93e9128$var$Content = (0, $d8seH.default)('div')`
  .timeline-title {
    margin-top: 2rem;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $lzNIT = parcelRequire("lzNIT");

var $6lXkL = parcelRequire("6lXkL");
var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $cVXaD = parcelRequire("cVXaD");


var $hBKHw = parcelRequire("hBKHw");
var $e47119fc3016a409$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $e47119fc3016a409$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($e47119fc3016a409$exports, "__esModule", {
    value: true
});
$e47119fc3016a409$exports.default = void 0;

var $e47119fc3016a409$var$_createSvgIcon = $e47119fc3016a409$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $e47119fc3016a409$var$_default = $e47119fc3016a409$exports.default = (0, $e47119fc3016a409$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m10.8 15.9 4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1c-.33-.25-.8-.01-.8.4v7c0 .41.47.65.8.4M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'PlayCircleOutlineRounded');


var $8cfc9805c04f53ce$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $8cfc9805c04f53ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($8cfc9805c04f53ce$exports, "__esModule", {
    value: true
});
$8cfc9805c04f53ce$exports.default = void 0;

var $8cfc9805c04f53ce$var$_createSvgIcon = $8cfc9805c04f53ce$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $8cfc9805c04f53ce$var$_default = $8cfc9805c04f53ce$exports.default = (0, $8cfc9805c04f53ce$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 16c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1m2-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m2-4c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1"
}), 'PauseCircleOutlineRounded');



var $bgK54 = parcelRequire("bgK54");

var $ifEev = parcelRequire("ifEev");

var $b8Rua = parcelRequire("b8Rua");


var $24m81 = parcelRequire("24m81");
function $01ff23d02e76f25f$export$2e2bcd8739ae039(props) {
    const { view: view, jobs: jobs = [], onDone: onDone } = props;
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const { enqueueSnackbar: enqueueSnackbar } = (0, $24m81.useSnackbar)();
    const [confirmSuspend, setConfirmSuspend] = (0, $acw62.useState)(false);
    const [confirmRm, setConfirmRm] = (0, $acw62.useState)(false);
    const handleDownload = ()=>{
        $b8Rua.downloadTemplate(jobs[0].job_id);
    };
    const handleRunJob = ()=>{
        setLoading(true);
        const ids = jobs.map((o)=>o.job_id);
        return $b8Rua.resubmitJobs(ids).then(()=>{
            const count = ids.length;
            enqueueSnackbar(`${count} job${count > 1 ? 's' : ''} resubmitted`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to resubmit at least one job",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 7000
            });
        }).finally(()=>{
            setLoading(false);
            onDone();
        });
    };
    const handleSuspendJob = ()=>{
        setLoading(true);
        return $b8Rua.suspendJobs(jobs.map((o)=>o.job_id)).then((resList)=>{
            const count = resList.filter((o)=>o.state == 'Suspended').length;
            enqueueSnackbar(`${count} job${count > 1 ? 's' : ''} suspended`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to suspend at least one job",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 7000
            });
        }).finally(()=>{
            setLoading(false);
            onDone();
        });
    };
    const handleRemoveJob = ()=>{
        setLoading(true);
        return $b8Rua.removeJobs(jobs.map((o)=>o.job_id)).then((resList)=>{
            const count = resList.filter((o)=>o.state == 'Removed').length;
            enqueueSnackbar(`${count} job${count > 1 ? 's' : ''} removed`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to remove at least one job",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 7000
            });
        }).finally(()=>{
            setLoading(false);
            onDone();
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($01ff23d02e76f25f$var$Root, {
        className: "flex items-center",
        children: [
            jobs.length == 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        component: (0, $lzNIT.Link),
                        variant: "contained",
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c4d0782a0aeb057$exports))), {}),
                        size: "small",
                        to: `/jobs/create-job?tab=editor&start_with_job=${jobs[0].job_id}`,
                        children: "Recreate or edit job"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "vertical",
                        flexItem: true,
                        sx: {
                            margin: '5px 10px'
                        }
                    })
                ]
            }),
            view == 'my-jobs' && jobs.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: `Resubmit Job${jobs.length > 1 ? 's' : ''}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: handleRunJob,
                            className: "running",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e47119fc3016a409$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: `Suspend Job${jobs.length > 1 ? 's' : ''}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>setConfirmSuspend(true),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8cfc9805c04f53ce$exports))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: `Remove Job${jobs.length > 1 ? 's' : ''}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>setConfirmRm(true),
                            className: "danger",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgK54))), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                        orientation: "vertical",
                        flexItem: true,
                        sx: {
                            margin: '5px 10px'
                        }
                    })
                ]
            }),
            jobs.length == 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Download spec",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                    onClick: handleDownload,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {})
                })
            }),
            confirmRm && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: `Are you sure you want to remove ${jobs.length > 1 ? 'these jobs' : 'this job'}?`,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        "Job",
                        jobs.length > 1 ? 's' : '',
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: jobs.map((o)=>o.job_id).join(', ')
                        }),
                        " will be removed!"
                    ]
                }),
                confirmBtnText: "Remove",
                confirmBtnStyle: {
                    background: '#c70000'
                },
                onConfirm: handleRemoveJob,
                onClose: ()=>setConfirmRm(false)
            }),
            confirmSuspend && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: `Are you sure you want to suspend ${jobs.length > 1 ? 'these jobs' : 'this job'}?`,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        "Job",
                        jobs.length > 1 ? 's' : '',
                        " ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: jobs.map((o)=>o.job_id).join(', ')
                        }),
                        " will be suspended!"
                    ]
                }),
                confirmBtnText: "Suspend",
                confirmBtnStyle: {
                    background: '#c70000'
                },
                onConfirm: handleSuspendJob,
                onClose: ()=>setConfirmSuspend(false)
            })
        ]
    });
}
const $01ff23d02e76f25f$var$Root = (0, $lmFrL.default).div`

`;



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $05cdb0e991cfb75f$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $05cdb0e991cfb75f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($05cdb0e991cfb75f$exports, "__esModule", {
    value: true
});
$05cdb0e991cfb75f$exports.default = void 0;

var $05cdb0e991cfb75f$var$_createSvgIcon = $05cdb0e991cfb75f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $05cdb0e991cfb75f$var$_default = $05cdb0e991cfb75f$exports.default = (0, $05cdb0e991cfb75f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 13h2v-2H3zm0 4h2v-2H3zm0-8h2V7H3zm4 4h14v-2H7zm0 4h14v-2H7zM7 7v2h14V7z"
}), 'List');



var $1fa3153f27de5219$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1fa3153f27de5219$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1fa3153f27de5219$exports, "__esModule", {
    value: true
});
$1fa3153f27de5219$exports.default = void 0;

var $1fa3153f27de5219$var$_createSvgIcon = $1fa3153f27de5219$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1fa3153f27de5219$var$_default = $1fa3153f27de5219$exports.default = (0, $1fa3153f27de5219$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'CheckOutlined');


var $1dadb06b242d6f3e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1dadb06b242d6f3e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1dadb06b242d6f3e$exports, "__esModule", {
    value: true
});
$1dadb06b242d6f3e$exports.default = void 0;

var $1dadb06b242d6f3e$var$_createSvgIcon = $1dadb06b242d6f3e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1dadb06b242d6f3e$var$_default = $1dadb06b242d6f3e$exports.default = (0, $1dadb06b242d6f3e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'WarningOutlined');




var $bgK54 = parcelRequire("bgK54");
function $fde46beb58759e1e$export$2e2bcd8739ae039(props) {
    const { counts: counts, state: state, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($fde46beb58759e1e$var$Root, {
        className: "flex justify-between",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($fde46beb58759e1e$var$StyledToggleButtonGroup, {
                "aria-label": "filter by job state",
                value: state,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: "Queued",
                        onClick: ()=>onFilter('Queued'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($05cdb0e991cfb75f$exports))), {
                                className: "queued"
                            }),
                            counts.queued,
                            " queued"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: "Running",
                        onClick: ()=>onFilter('Running'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e47119fc3016a409$exports))), {
                                className: "running"
                            }),
                            counts.running,
                            " running"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: "Completed",
                        onClick: ()=>onFilter('Completed'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1fa3153f27de5219$exports))), {
                                className: "completed"
                            }),
                            counts.completed,
                            " completed"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: "Failed",
                        onClick: ()=>onFilter('Failed'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dadb06b242d6f3e$exports))), {
                                className: "failed"
                            }),
                            counts.failed,
                            " failed"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($fde46beb58759e1e$var$StyledToggleButtonGroup, {
                "aria-label": "filter by job state",
                value: state,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: "Suspended",
                        onClick: ()=>onFilter('Suspended'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8cfc9805c04f53ce$exports))), {
                                className: "muted"
                            }),
                            counts.suspended,
                            " suspended"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                        value: "Removed",
                        onClick: ()=>onFilter('Removed'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgK54))), {
                                className: "muted"
                            }),
                            counts.removed,
                            " removed"
                        ]
                    })
                ]
            })
        ]
    });
}
const $fde46beb58759e1e$var$Root = (0, $lmFrL.default).div`
`;
const $fde46beb58759e1e$var$StyledToggleButtonGroup = (0, $lmFrL.default)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039))`
  svg {
    margin-right: 5px;
  }

  .MuiToggleButtonGroup-root {
  }

  .MuiToggleButton-root {
    color: #444;
    padding-right: 20px;
    border-width: 0 1px 1px 1px;
    border-radius: 0 0 5px 5px;
  }

  & .MuiToggleButton-root.Mui-selected {
  }
`;



var $9bsRS = parcelRequire("9bsRS");

var $b8Rua = parcelRequire("b8Rua");

var $c3pId = parcelRequire("c3pId");
// todo(nc): support jobs view for multiple projects
// import settings from '/components/settings'
// const PROJECT = settings.project
const $3d03a7c5535c78ec$var$user = (0, $c3pId.default).user;
const $3d03a7c5535c78ec$export$fe98a034cfb96d55 = {
    appNames: (appNames, apps)=>appNames?.map((name, i)=>{
            const l = apps.length - 1;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/apps/app/${(apps[i] || '').split(':')[0]}`,
                        children: name
                    }),
                    i < l ? ', ' : ''
                ]
            }, i);
        }),
    apps: (apps)=>apps?.map((app, i)=>{
            const [namespace, nameWithVer] = (app || '').split('/');
            const l = apps.length - 1;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/apps/app/${namespace}/${(nameWithVer || '').split(':')[0]}`,
                        children: nameWithVer
                    }),
                    i < l ? ', ' : ''
                ]
            }, i);
        }),
    nodes: (vsns)=>vsns.map((vsn, i)=>{
            const l = vsns.length - 1;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/nodes/${vsn}`,
                        children: vsn
                    }),
                    i < l ? ', ' : ''
                ]
            }, vsn);
        })
};
const $3d03a7c5535c78ec$var$jobCols = [
    {
        id: 'name',
        label: 'Name',
        format: (val, row)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/jobs/all-jobs?job=${row.id}`,
                children: val
            });
        }
    },
    {
        id: 'id',
        label: 'ID'
    },
    {
        id: 'status',
        label: 'Status',
        format: (val)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                className: val.toLowerCase(),
                children: val || '-'
            });
        },
        width: '100px'
    },
    {
        id: 'user',
        label: 'User'
    },
    {
        id: 'nodes',
        label: 'Nodes',
        format: $3d03a7c5535c78ec$export$fe98a034cfb96d55.nodes
    },
    {
        id: 'nodeCount',
        label: 'Node count',
        hide: true,
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                className: "muted",
                children: obj.nodes.length
            })
    },
    {
        id: 'appNames',
        label: 'App Names',
        format: (appNames, obj)=>$3d03a7c5535c78ec$export$fe98a034cfb96d55.appNames(appNames, obj.apps)
    },
    {
        id: 'apps',
        label: 'ECR App Names',
        format: $3d03a7c5535c78ec$export$fe98a034cfb96d55.apps,
        hide: true
    },
    {
        id: 'appCount',
        label: 'App count',
        hide: true,
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                className: "muted",
                children: obj.apps.length
            })
    },
    {
        id: 'last_submitted',
        label: 'Submitted',
        width: '100px',
        format: (val)=>{
            return (0, $lffEs.relativeTime)(val) || '-';
        }
    },
    {
        id: 'last_updated',
        label: 'Updated',
        width: '100px',
        format: (val)=>{
            return (0, $lffEs.relativeTime)(val) || '-';
        }
    },
    {
        id: 'last_completed',
        label: 'Completed',
        width: '100px',
        format: (val)=>{
            return (0, $lffEs.relativeTime)(val) || '-';
        }
    }
];
// "my jobs" columns are the same as "all jobs", except job details link
const $3d03a7c5535c78ec$var$myJobCols = [
    {
        id: 'name',
        label: 'Name',
        format: (val, row)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/jobs/my-jobs?job=${row.id}`,
                children: val
            });
        }
    },
    ...$3d03a7c5535c78ec$var$jobCols.slice(1)
];
function $3d03a7c5535c78ec$var$jobsToGeos(jobs, nodeDict) {
    return [
        ...new Set(jobs.flatMap((o)=>o.nodes))
    ].map((vsn)=>({
            ...nodeDict[vsn],
            id: vsn,
            vsn: vsn,
            lng: Number(nodeDict[vsn]?.gps_lon),
            lat: Number(nodeDict[vsn]?.gps_lat),
            status: 'reporting'
        }));
}
const $3d03a7c5535c78ec$var$initState = {
    jobs: [],
    pluginEvents: null,
    pluginErrors: null,
    isFiltered: false,
    qJobs: null,
    qNodes: [],
    selectedNodes: [],
    selectedJobs: []
};
const $3d03a7c5535c78ec$var$initCounts = {
    public: null,
    mine: null,
    queued: null,
    running: null,
    completed: null,
    failed: null,
    suspended: null,
    removed: null
};
function $3d03a7c5535c78ec$var$getCounts(jobs, countMine) {
    const publicCount = jobs.length - $3d03a7c5535c78ec$var$filterByState(jobs, [
        'Suspended',
        'Removed'
    ]).length;
    const myJobs = jobs.filter((o)=>o.user == $3d03a7c5535c78ec$var$user);
    jobs = countMine ? myJobs : jobs;
    return {
        public: publicCount,
        mine: myJobs.length - $3d03a7c5535c78ec$var$filterByState(myJobs, [
            'Suspended',
            'Removed'
        ]).length,
        queued: $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Created',
            'Submitted'
        ]).length,
        running: $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Running'
        ]).length,
        completed: $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Completed'
        ]).length,
        failed: $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Failed'
        ]).length,
        suspended: $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Suspended'
        ]).length,
        removed: $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Removed'
        ]).length
    };
}
const $3d03a7c5535c78ec$var$filterByState = (jobs, states)=>jobs.filter((o)=>states.includes(o.state.last_state));
function $3d03a7c5535c78ec$export$2e2bcd8739ae039() {
    const navigate = (0, $aphAM.useNavigate)();
    const { view: view = 'all-jobs' } = (0, $aphAM.useParams)();
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const query = params.get('query') || '' // query string
    ;
    const nodes = params.get('nodes') || '' // vsns
    ;
    const job = params.get('job') || '' // job id
    ;
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [{ jobs: jobs, pluginEvents: pluginEvents, pluginErrors: pluginErrors, isFiltered: isFiltered, qJobs: qJobs, selectedNodes: selectedNodes, selectedJobs: selectedJobs }, setData] = (0, $acw62.useState)($3d03a7c5535c78ec$var$initState);
    // filter for job's state
    const [jobState, setJobState] = (0, $acw62.useState)();
    // additional meta
    const [nodeDict, setNodeDict] = (0, $acw62.useState)(null);
    const [geo, setGeo] = (0, $acw62.useState)();
    const [counts, setCounts] = (0, $acw62.useState)($3d03a7c5535c78ec$var$initCounts);
    // we'll update table columns for each tab
    const [cols, setCols] = (0, $acw62.useState)($3d03a7c5535c78ec$var$jobCols);
    // hack for refreshing map/table
    const [updateMap, setUpdateMap] = (0, $acw62.useState)(0);
    const [updateTable, setUpdateTable] = (0, $acw62.useState)(0);
    // todo(nc): poll data; some optimization is needed
    // const [lastUpdate, setLastUpdate] = useState(null)
    const [error, setError] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (!jobs || !nodeDict) return;
        let qJobs = (0, $52fc2129eac6b28c$export$3c598703d99462f5)(jobs, query);
        if (jobState == 'Queued') qJobs = $3d03a7c5535c78ec$var$filterByState(jobs, [
            'Created',
            'Submitted'
        ]);
        else if (jobState) qJobs = $3d03a7c5535c78ec$var$filterByState(jobs, [
            jobState
        ]);
        // ignore removed jobs by default
        if (jobState !== 'Removed') qJobs = qJobs.filter((o)=>o.state.last_state != 'Removed');
        const qNodes = qJobs.flatMap((o)=>o.nodes);
        setData((prev)=>({
                ...prev,
                isFiltered: query.length > 0 || selectedNodes?.length > 0,
                qJobs: qJobs,
                qNodes: qNodes
            }));
        // update map again
        const geo = $3d03a7c5535c78ec$var$jobsToGeos(qJobs, nodeDict);
        setGeo(geo);
        setUpdateMap((prev)=>prev + 1);
    }, [
        query,
        jobs,
        nodeDict,
        selectedNodes,
        jobState
    ]);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        const filterUser = view == 'my-jobs' && $3d03a7c5535c78ec$var$user;
        // fetch aggregated scheduler data
        const p1 = $b8Rua.getJobs() // {project: PROJECT}
        ;
        // also fetch gps for map
        const p2 = $9bsRS.getNodes();
        Promise.all([
            p1,
            p2
        ]).then(([jobs, nodes])=>{
            const nodeDict = (0, $f1q41.keyBy)(nodes, 'vsn');
            setNodeDict(nodeDict);
            setCounts($3d03a7c5535c78ec$var$getCounts(jobs, view == 'my-jobs'));
            // if 'my jobs', filter vsns to the user's nodes
            if (filterUser) // const nodes = jobs.flatMap(o => o.nodes)
            jobs = jobs.filter((o)=>o.user == $3d03a7c5535c78ec$var$user);
            // create some geo data
            const geo = $3d03a7c5535c78ec$var$jobsToGeos(jobs, nodeDict);
            setData({
                jobs: jobs
            });
            setGeo(geo);
        }).catch((err)=>{
            console.error(err);
            setError(err.message);
        }).finally(()=>setLoading(false));
    }, [
        setLoading,
        view,
        updateTable
    ]);
    // fetch aggreted task event data for timeline (and other stuff later?)
    (0, $acw62.useEffect)(()=>{
        if (view != 'timeline') return;
        setLoading(true);
        $b8Rua.getEvents().then(({ events: events, errors: errors })=>setData((prev)=>({
                    ...prev,
                    pluginEvents: events,
                    pluginErrors: errors
                }))).finally(()=>setLoading(false));
    }, [
        view
    ]);
    // simply update table columns for job lists (for now?)
    (0, $acw62.useEffect)(()=>{
        setCols(view == 'all-jobs' ? $3d03a7c5535c78ec$var$jobCols : $3d03a7c5535c78ec$var$myJobCols);
    }, [
        view
    ]);
    const handleJobSelect = (sel)=>{
        const objs = sel.objs.length ? sel.objs : [];
        const nodes = $3d03a7c5535c78ec$var$jobsToGeos(objs, nodeDict);
        setData((prev)=>({
                ...prev,
                selectedNodes: nodes.length ? nodes : [],
                selectedJobs: objs
            }));
        setUpdateMap((prev)=>prev + 1);
    };
    const handleQuery = ({ query: query })=>{
        if (query) params.set('query', query);
        else params.delete('query');
        setParams(params, {
            replace: true
        });
    };
    const handleCloseDialog = ()=>{
        params.delete('job');
        navigate(`/jobs/${view}?${params.toString()}`, {
            replace: true
        });
    };
    const getSubset = (selectedNodes, nodes)=>{
        const vsns = selectedNodes.map((o)=>o.vsn);
        const subset = nodes.filter((obj)=>vsns.includes(obj.vsn));
        return subset;
    };
    const handleStatusFilter = (state)=>{
        setJobState((prev)=>prev == state ? null : state);
    };
    const handleActionComplete = ()=>{
        setUpdateTable((prev)=>prev + 1) // force re-request
        ;
    };
    // if query param ?job=<job_id> is provided
    const jobDetails = job ? (jobs || []).find((o)=>o.job_id == job) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($3d03a7c5535c78ec$var$Root, {
        className: "flex column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($3d03a7c5535c78ec$var$MapContainer, {
                children: geo && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                    data: selectedNodes?.length ? getSubset(selectedNodes, geo) : geo,
                    updateID: updateMap,
                    showUptime: false
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fde46beb58759e1e$export$2e2bcd8739ae039), {
                counts: counts,
                state: jobState,
                onFilter: handleStatusFilter
            }),
            view == 'all-jobs' && loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eqsnC.default), {}),
            [
                'all-jobs',
                'my-jobs'
            ].includes(view) && qJobs && !loading && /*#__PURE__*/ (0, $ayMG0.jsx)($3d03a7c5535c78ec$var$TableContainer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                    primaryKey: "id",
                    rows: qJobs,
                    columns: cols,
                    enableSorting: true,
                    sort: "-last_submitted",
                    onSearch: handleQuery,
                    onSelect: handleJobSelect,
                    onColumnMenuChange: ()=>{},
                    checkboxes: view == 'my-jobs',
                    emptyNotice: view == 'my-jobs' ? `No ${jobState || 'active'} jobs with your username were found` : `No ${jobState || 'active'} jobs found`,
                    middleComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)($3d03a7c5535c78ec$var$TableOptions, {
                        className: "flex",
                        children: [
                            view == 'my-jobs' && !selectedJobs?.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                component: (0, $lzNIT.Link),
                                to: "/jobs/create-job",
                                variant: "contained",
                                color: "primary",
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ff6af0e7b54a176$export$2e2bcd8739ae039), {}),
                                children: "Create job"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $01ff23d02e76f25f$export$2e2bcd8739ae039), {
                                view: view,
                                jobs: selectedJobs,
                                onDone: handleActionComplete
                            }),
                            isFiltered && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                title: `View timeline${selectedNodes?.length > 1 ? 's' : ''}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    component: (0, $lzNIT.Link),
                                    to: `timeline?nodes=${selectedNodes?.map((o)=>o.vsn).join(',')}`,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $645d3c26402e93bc$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    })
                })
            }),
            view == 'timeline' && pluginEvents && nodeDict && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0b85f1216005eff9$export$2e2bcd8739ae039), {
                children: Object.keys(pluginEvents).filter((vsn)=>nodes ? nodes.includes(vsn) : true).map((vsn, i)=>{
                    const { location: location } = nodeDict[vsn];
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                        className: "title-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                                to: `/nodes/${vsn}`,
                                                children: vsn
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: location
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bc0c95c48ca4029$export$2e2bcd8739ae039), {
                                data: pluginEvents[vsn],
                                errors: pluginErrors
                            })
                        ]
                    }, i);
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error
            }),
            !!jobs.length && jobDetails && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdc2e6d7b93e9128$export$2e2bcd8739ae039), {
                job: jobDetails,
                nodeMetaByVSN: nodeDict,
                handleCloseDialog: handleCloseDialog
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
        ]
    });
}
const $3d03a7c5535c78ec$var$Root = (0, $d8seH.default)('div')`
  width: 100%;
  margin-bottom: 20px;
`;
const $3d03a7c5535c78ec$var$MapContainer = (0, $d8seH.default)('div')`
  width: 100%;
  height:  350px;
  border: 1px solid ${(props)=>props.theme.palette.divider};
`;
const $3d03a7c5535c78ec$var$TableContainer = (0, $d8seH.default)('div')`
  margin-top: 1em;

  & .MuiInputBase-root {
    max-width: 100%;
  }
`;
const $3d03a7c5535c78ec$var$TableOptions = (0, $d8seH.default)('div')`
  margin: 0 20px;
`;



var $hw4Z0 = parcelRequire("hw4Z0");



var $6ami2 = parcelRequire("6ami2");

var $eo4xm = parcelRequire("eo4xm");




var $7cKF8 = parcelRequire("7cKF8");
const $71dc2bf61474117d$var$getTitle = (hardware, description)=>{
    const match = description.match(/^#\s+(.+)\r\n/m);
    const title = match ? match[1] : null;
    return title ? title : hardware;
};
const $71dc2bf61474117d$var$getDescriptionHTML = (description)=>{
    if (!description) return;
    // ignore h1 titles since handled separately for links
    const match = description.match(/^#\s+(.+)\r\n/m);
    const title = match ? match[0] : null;
    const text = description.replace(title, '');
    const intro = text.split(/^\s+\r\n/m)[0];
    if (intro.length < text.length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: (0, $d55025bea272cdc1$exports.marked)(intro)
            }
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        dangerouslySetInnerHTML: {
            __html: (0, $d55025bea272cdc1$exports.marked)(intro)
        }
    });
};
const $71dc2bf61474117d$export$53b3c91859018cd4 = [
    {
        id: 'hw_model',
        label: 'Model',
        width: '250px',
        format: (val, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                            className: "muted",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: obj.manufacturer
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${obj.hw_model}`,
                        children: val
                    })
                ]
            })
    },
    {
        id: 'hardware',
        label: 'Developer Name (UUID)',
        format: (val, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/sensors/${obj.hardware}`,
                children: val
            }),
        hide: true
    },
    {
        id: 'description',
        label: 'Description',
        format: (description, obj)=>{
            const { hardware: hardware } = obj;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex justify-between",
                            children: $71dc2bf61474117d$var$getTitle(hardware, description)
                        })
                    }),
                    $71dc2bf61474117d$var$getDescriptionHTML(description),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($71dc2bf61474117d$var$Tags, {
                        children: obj.capabilities.map((v)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                label: v,
                                icon: (0, $7cKF8.getCapabilityIcon)(v)
                            }, v))
                    })
                ]
            });
        }
    },
    {
        id: 'capabilities',
        label: 'Capabilities',
        format: (val)=>val ? val.join(', ') : '-',
        hide: true
    },
    {
        id: 'nodeCount',
        label: 'Nodes',
        format: (_, obj)=>{
            const count = obj.vsns.length;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: `/nodes?sensor="${encodeURIComponent(obj.hw_model)}"`,
                children: [
                    count,
                    " node",
                    count != 1 ? 's' : ''
                ]
            });
        },
        width: '100px'
    },
    {
        id: 'vsns',
        label: 'Node List',
        format: (0, $3d03a7c5535c78ec$export$fe98a034cfb96d55).nodes,
        hide: true
    }
];
const $71dc2bf61474117d$var$Tags = (0, $lmFrL.default).div`
  margin-bottom: 0.5em;
  .MuiChip-root {
    margin-right: 0.5em;
  }

`;
const $71dc2bf61474117d$var$getCapabilities = (data)=>[
        ...new Set(data.flatMap((obj)=>obj.capabilities))
    ].map((name)=>({
            id: name,
            label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center",
                children: [
                    (0, $7cKF8.getCapabilityIcon)(name),
                    " ",
                    name
                ]
            })
        }));
const $71dc2bf61474117d$var$initialState = {
    capabilities: []
};
function $71dc2bf61474117d$export$2e2bcd8739ae039(props) {
    const { project: project, vsns: vsns } = props;
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const query = params.get('query') || '';
    const [data, setData] = (0, $acw62.useState)();
    const [filteredData, setFilteredData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)();
    const [capabilities, setCapabilities] = (0, $acw62.useState)();
    const [filterState, setFilterState] = (0, $acw62.useState)($71dc2bf61474117d$var$initialState);
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const navigate = (0, $aphAM.useNavigate)();
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $9bsRS.getSensors().then((data)=>{
            setData(data);
            setFilteredData(data);
            const opts = $71dc2bf61474117d$var$getCapabilities(data);
            setCapabilities(opts);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, [
        setLoading,
        project,
        vsns
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!data) return;
        const fs = (0, $e7d96055c3aa1815$export$7351ae98fd71d438)(params, {
            initialState: $71dc2bf61474117d$var$initialState,
            exclude: [
                'query'
            ]
        });
        setFilterState(fs);
        let d = (0, $52fc2129eac6b28c$export$3c598703d99462f5)(data, query);
        d = (0, $626807995b044d88$export$d6ad891437e8c72c)(d, fs);
        setFilteredData(d);
    }, [
        query,
        data,
        params
    ]);
    const handleQuery = ({ query: query })=>{
        if (query) params.set('query', query);
        else params.delete('query');
        setParams(params, {
            replace: true
        });
    };
    const handleFilterChange = (field, vals)=>{
        // MUI seems to result in vals may be string or option; todo(nc): address this?
        const newStr = vals.map((item)=>`"${typeof item == 'string' ? item : item.id}"`).join(',');
        if (!newStr.length) params.delete(field);
        else params.set(field, newStr);
        setParams(params, {
            replace: true
        });
    };
    const handleQueryViewerChange = (field, next)=>{
        if (!next.length) params.delete(field);
        else params.set(field, next.map((str)=>`"${str}"`).join(','));
        setParams(params, {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($71dc2bf61474117d$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            filteredData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                primaryKey: "id",
                storageKey: "/sensors",
                columns: $71dc2bf61474117d$export$53b3c91859018cd4,
                rows: filteredData,
                enableSorting: true,
                sort: "+hw_model",
                search: query,
                onSearch: handleQuery,
                onColumnMenuChange: ()=>{},
                onDoubleClick: (_, row)=>navigate(`/sensors/${row.hw_model}`),
                middleComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)($71dc2bf61474117d$var$FilterControls, {
                    className: "flex items-center",
                    children: [
                        capabilities && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eo4xm.default), {
                            label: "Capabilities",
                            options: capabilities,
                            value: filterState.capabilities,
                            onChange: (vals)=>handleFilterChange('capabilities', vals)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $177e9ab8fdb34313$export$2e2bcd8739ae039), {
                            filterState: filterState,
                            onDelete: handleQueryViewerChange
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error
            })
        ]
    });
}
const $71dc2bf61474117d$var$Root = (0, $lmFrL.default).div`
  margin-top: 1em;

  h1 {
    margin: 0;
  }

  h3 {
    margin: 0 0 .5em 0;
  }
`;
const $71dc2bf61474117d$var$FilterControls = (0, $lmFrL.default).div`
  margin-left: 1.5em;
`;



var $7cKF8 = parcelRequire("7cKF8");

var $9bsRS = parcelRequire("9bsRS");



var $f1q41 = parcelRequire("f1q41");
const $93a51680713d9647$var$fieldSpec = [
    {
        id: 'hardware',
        label: 'Hardware'
    },
    {
        id: 'hw_model',
        label: 'Model',
        helpText: 'The model number of your sensor, without the manufacturer name.'
    },
    /* hide capabilities until updates are supported
    {id: 'capabilities', label: 'Capabilities',  multiple: true,
      helpText: 'Search or type a new capability', placeholder: 'Search...'}, */ {
        id: 'hw_version',
        label: 'Hardware Version'
    },
    {
        id: 'sw_version',
        label: 'Software Version'
    },
    {
        id: 'description',
        label: 'Description',
        type: 'textarea'
    },
    {
        id: 'datasheet',
        label: 'Datasheet Link',
        width: '800px'
    }
];
function $93a51680713d9647$export$2e2bcd8739ae039() {
    const { name: name } = (0, $aphAM.useParams)();
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const { isSuper: isSuper } = (0, $0ad5317c8f9b9985$export$fa63741f3dc98587)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    // form
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [state, setState] = (0, $acw62.useState)();
    const [fields, setFields] = (0, $acw62.useState)($93a51680713d9647$var$fieldSpec);
    const getData = (0, $acw62.useCallback)(()=>{
        $9bsRS.getSensor(name).then((data)=>{
            setData(data);
            setState(data);
        }).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        name,
        setLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        getData();
    }, [
        setLoading,
        getData
    ]);
    // fetch capability options if editing
    (0, $acw62.useEffect)(()=>{
        if (!isEditing) return;
        // fetch and add options to field spec (for the "capabilities" dropdown)
        setLoading(true);
        $9bsRS.getAllSensors().then((sensors)=>{
            const capabilityLists = sensors.map((o)=>o.capabilities);
            const flatList = (0, $f1q41.flatten)(capabilityLists);
            const options = (0, $f1q41.uniq)(flatList);
            const i = fields.findIndex((o)=>o.id == 'capabilities');
            if (i < 0) return;
            fields.splice(i, 1, {
                ...fields[i],
                options: options
            });
            setFields(fields);
        }).finally(()=>setLoading(false));
    }, [
        isEditing,
        setLoading
    ]);
    const handleChange = (name, value)=>{
        setState((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const handleCancel = ()=>{
        setIsEditing(false);
        setState(data);
    };
    const handleSave = ()=>{
        setIsSaving(true);
        $9bsRS.saveSensor(state).then(()=>{
            setIsEditing(false);
            getData();
        }).catch((err)=>setError(err)).finally(()=>setIsSaving(false));
    };
    const { description: description, datasheet: datasheet, capabilities: capabilities, manufacturer: manufacturer, hw_model: hw_model } = data || {};
    const formData = {
        fields: fields,
        data: data,
        state: state,
        isEditing: isEditing
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($93a51680713d9647$var$Root, {
        className: "flex",
        children: [
            (0, $gTmRg.CardViewStyle),
            !isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Sidebar), {
                width: "250px",
                style: {
                    padding: '20px'
                },
                children: data && /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                    className: "list-none no-padding",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Manufacturer"
                                }),
                                manufacturer
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Model"
                                }),
                                hw_model
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Nodes with Sensor"
                                }),
                                (0, $71dc2bf61474117d$export$53b3c91859018cd4).find((o)=>o.id == 'nodeCount').format(null, data)
                            ]
                        }),
                        capabilities?.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    children: "Capabilities"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($93a51680713d9647$var$Capabilities, {
                                    children: capabilities.map((capability)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                            label: capability,
                                            icon: (0, $7cKF8.getCapabilityIcon)(capability)
                                        }, capability))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($93a51680713d9647$var$Main, {
                className: "flex gap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($93a51680713d9647$var$Details, {
                        className: "flex column gap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                className: "flex items-center gap",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dc74b806698c54b$export$2e2bcd8739ae039), {
                                        path: `/sensors/${name}`
                                    }),
                                    isSuper && !isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c4d0782a0aeb057$exports))), {}),
                                        onClick: ()=>setIsEditing(true),
                                        children: "Edit"
                                    }),
                                    isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "outlined",
                                        className: "cancel",
                                        onClick: handleCancel,
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5861ec10399b0856$exports))), {}),
                                        children: "Cancel"
                                    })
                                ]
                            }),
                            isEditing && formData && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86ba48c15c409e47$export$2e2bcd8739ae039), {
                                        ...formData,
                                        onChange: handleChange
                                    }),
                                    isEditing && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap action-btns",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                variant: "contained",
                                                type: "submit",
                                                onClick: handleSave,
                                                disabled: isSaving,
                                                children: isSaving ? 'Saving...' : 'Save'
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                variant: "outlined",
                                                className: "cancel",
                                                onClick: handleCancel,
                                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5861ec10399b0856$exports))), {}),
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isEditing && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                        children: [
                                            description && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: (0, $d55025bea272cdc1$exports.marked)(description)
                                                }
                                            }),
                                            !loading && !description && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "muted",
                                                children: "no description provided"
                                            })
                                        ]
                                    }),
                                    datasheet && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "flex items-end justify-between",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($43c2449ff5c5b42e$exports))), {}),
                                                        "Datasheet"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: datasheet,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: datasheet
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                        children: error.message
                    })
                ]
            })
        ]
    });
}
const $93a51680713d9647$var$Root = (0, $lmFrL.default).div`
`;
const $93a51680713d9647$var$Capabilities = (0, $lmFrL.default).div`
  div {
    margin: 2px;
  }
`;
const $93a51680713d9647$var$Main = (0, $lmFrL.default).div`
  padding: 20px;
  width: 100%;

  .action-btns {
    margin-top: 2rem;
  }
`;
const $93a51680713d9647$var$Details = (0, $lmFrL.default).div`
  width: 100%;
  margin-bottom: 50px;
`;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $85875d7d213afd89$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 6.5c-1.66 0-3 1.34-3 3 0 .07 0 .14.01.21l-2.03.68c-.64-1.21-1.82-2.09-3.22-2.32V5.91C14.04 5.57 15 4.4 15 3c0-1.66-1.34-3-3-3S9 1.34 9 3c0 1.4.96 2.57 2.25 2.91v2.16c-1.4.23-2.58 1.11-3.22 2.32l-2.04-.68C6 9.64 6 9.57 6 9.5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3c1.06 0 1.98-.55 2.52-1.37l2.03.68c-.2 1.29.17 2.66 1.09 3.69l-1.41 1.77Q6.66 17 6 17c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3c0-.68-.22-1.3-.6-1.8l1.41-1.77c1.36.76 3.02.75 4.37 0l1.41 1.77c-.37.5-.59 1.12-.59 1.8 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3c-.44 0-.85.09-1.23.26l-1.41-1.77c.93-1.04 1.29-2.4 1.09-3.69l2.03-.68c.53.82 1.46 1.37 2.52 1.37 1.66 0 3-1.34 3-3S22.66 6.5 21 6.5m-18 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M6 21c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m5-18c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1m1 12c-1.38 0-2.5-1.12-2.5-2.5S10.62 10 12 10s2.5 1.12 2.5 2.5S13.38 15 12 15m6 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m3-8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
}), 'HubOutlined');




var $gOa8m = parcelRequire("gOa8m");

var $ecxdi = parcelRequire("ecxdi");

var $hw4Z0 = parcelRequire("hw4Z0");

var $c3pId = parcelRequire("c3pId");

var $gZwVy = parcelRequire("gZwVy");
const { contactUs: $27766c631fd74b2e$var$contactUs } = (0, $gZwVy.default);
const $27766c631fd74b2e$var$columns = [
    {
        id: 'name',
        label: 'Project Name',
        format: (name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                children: name
            })
    },
    {
        id: 'nodes',
        label: 'Nodes',
        format: (nodes)=>nodes.length
    },
    {
        id: 'members',
        label: 'Team Members',
        format: (members, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: `/user/${(0, $c3pId.default).user}/teams/${obj.name}`,
                children: [
                    members.length,
                    " ",
                    members.length === 1 ? 'member' : 'members'
                ]
            })
    }
];
function $27766c631fd74b2e$export$2e2bcd8739ae039() {
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $ecxdi.listMyProjects().then(({ projects: projects })=>setData(projects)).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        setLoading
    ]);
    // Calculate unique counts
    const uniqueNodes = data ? new Set(data.flatMap((p)=>p.nodes.map((n)=>n.vsn))).size : 0;
    const uniqueMembers = data ? new Set(data.flatMap((p)=>p.members.map((m)=>m.username))).size : 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "no-margin",
                children: "My Projects"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            data && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatsContainer, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatCard, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($27766c631fd74b2e$var$StatIcon, {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdbaae095ceb82e8$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatContent, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($27766c631fd74b2e$var$StatValue, {
                                                children: data.length
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatLabel, {
                                                children: [
                                                    "Project",
                                                    data.length !== 1 ? 's' : ''
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatCard, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($27766c631fd74b2e$var$StatIcon, {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85875d7d213afd89$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatContent, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($27766c631fd74b2e$var$StatValue, {
                                                children: uniqueNodes
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatLabel, {
                                                children: [
                                                    "Unique node",
                                                    uniqueNodes !== 1 ? 's' : ''
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatCard, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($27766c631fd74b2e$var$StatIcon, {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efc7aacb001bb1b7$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatContent, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($27766c631fd74b2e$var$StatValue, {
                                                children: uniqueMembers
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($27766c631fd74b2e$var$StatLabel, {
                                                children: [
                                                    "Team member",
                                                    uniqueMembers !== 1 ? 's' : ''
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                        primaryKey: "name",
                        enableSorting: true,
                        columns: $27766c631fd74b2e$var$columns,
                        rows: data,
                        emptyNotice: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                "You are not part of any projects.",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Please ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: $27766c631fd74b2e$var$contactUs,
                                        children: "contact us"
                                    })
                                }),
                                " if interested in collaborating with Sage."
                            ]
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error.message
            })
        ]
    });
}
const $27766c631fd74b2e$var$Root = (0, $d8seH.default)('div')`
  margin-top: 2rem;
`;
const $27766c631fd74b2e$var$StatsContainer = (0, $d8seH.default)('div')`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
`;
const $27766c631fd74b2e$var$StatCard = (0, $d8seH.default)('div')`
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : '#f8f9fa'};
  border: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
  border-radius: 8px;
  padding: 24px;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;

  /*
  &:hover {
    border-color: ${({ theme: theme })=>theme.palette.primary.main};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  */
`;
const $27766c631fd74b2e$var$StatIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 4em;
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $27766c631fd74b2e$var$StatContent = (0, $d8seH.default)('div')`
  flex: 1;
`;
const $27766c631fd74b2e$var$StatValue = (0, $d8seH.default)('div')`
  font-size: 2em;
  font-weight: bold;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};
  line-height: 1;
  margin-bottom: 4px;
`;
const $27766c631fd74b2e$var$StatLabel = (0, $d8seH.default)('div')`
  font-size: 0.875em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#999' : '#666'};
  font-weight: 500;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");


var $gOa8m = parcelRequire("gOa8m");

var $ecxdi = parcelRequire("ecxdi");

var $hw4Z0 = parcelRequire("hw4Z0");

var $c3pId = parcelRequire("c3pId");

var $gZwVy = parcelRequire("gZwVy");
const { contactUs: $9b1f947cb2d9e882$var$contactUs } = (0, $gZwVy.default);
const $9b1f947cb2d9e882$var$columns = [
    {
        id: 'name',
        label: 'Name',
        format: (name)=>name || '-'
    },
    {
        id: 'username',
        label: 'Username',
        format: (username)=>/*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                children: username
            })
    },
    {
        id: 'projectNames',
        label: 'My Projects(s)',
        format: (projectNames)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: projectNames.map((projectName, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                to: `/user/${(0, $c3pId.default).user}/teams/${encodeURIComponent(projectName)}`,
                                children: projectName
                            }),
                            i < projectNames.length - 1 && ', '
                        ]
                    }, projectName))
            })
    }
];
function $9b1f947cb2d9e882$export$2e2bcd8739ae039() {
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $ecxdi.listMyProjects().then(({ projects: projects })=>{
            // Group members by username and collect all their projects
            const memberMap = new Map();
            projects.forEach((project)=>{
                project.members.forEach((member)=>{
                    if (memberMap.has(member.username)) // Add project to existing member
                    memberMap.get(member.username).projectNames.push(project.name);
                    else // Create new member entry
                    memberMap.set(member.username, {
                        username: member.username,
                        name: member.name,
                        projectNames: [
                            project.name
                        ]
                    });
                });
            });
            setData(Array.from(memberMap.values()));
        }).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        setLoading
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9b1f947cb2d9e882$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "no-margin",
                children: "My Team Members"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                primaryKey: "username",
                enableSorting: true,
                columns: $9b1f947cb2d9e882$var$columns,
                rows: data,
                emptyNotice: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        "You are not part of any projects.",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Please ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: $9b1f947cb2d9e882$var$contactUs,
                                children: "contact us"
                            })
                        }),
                        " if interested in collaborating with Sage."
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error.message
            })
        ]
    });
}
const $9b1f947cb2d9e882$var$Root = (0, $d8seH.default)('div')`
  margin-top: 2rem;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $d8seH = parcelRequire("d8seH");

var $73a253d75369f6df$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $73a253d75369f6df$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($73a253d75369f6df$exports, "__esModule", {
    value: true
});
$73a253d75369f6df$exports.default = void 0;

var $73a253d75369f6df$var$_createSvgIcon = $73a253d75369f6df$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $73a253d75369f6df$var$_default = $73a253d75369f6df$exports.default = (0, $73a253d75369f6df$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1"
}), 'ArrowBackRounded');



var $gOa8m = parcelRequire("gOa8m");

var $ecxdi = parcelRequire("ecxdi");

var $hw4Z0 = parcelRequire("hw4Z0");
const $193d7b6255cae44e$var$columns = [
    {
        id: 'name',
        label: 'Name',
        format: (name)=>name || '-'
    },
    {
        id: 'username',
        label: 'Username',
        format: (username)=>/*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                children: username
            })
    }
];
function $193d7b6255cae44e$export$2e2bcd8739ae039() {
    const { projectName: projectName } = (0, $aphAM.useParams)();
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $ecxdi.listMyProjects().then(({ projects: projects })=>{
            const project = projects.find((p)=>p.name === projectName);
            if (project) setData(project.members);
            else setError(new Error(`Project "${projectName}" not found`));
        }).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        setLoading,
        projectName
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($193d7b6255cae44e$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: `/user/${projectName}/projects`,
                className: "flex items-center gap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73a253d75369f6df$exports))), {}),
                    " Back to Projects"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                className: "no-margin",
                children: [
                    projectName,
                    " Team Members"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                primaryKey: "username",
                enableSorting: true,
                columns: $193d7b6255cae44e$var$columns,
                rows: data,
                emptyNotice: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "No members found for this project."
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error.message
            })
        ]
    });
}
const $193d7b6255cae44e$var$Root = (0, $d8seH.default)('div')`

`;



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $aphAM = parcelRequire("aphAM");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $de7ad96370595041$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2cdd30d893754042$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'AddCircleOutlineRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $6c07e7ecb3e9d607$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39"
}), 'PublicRounded');



var $ayMG0 = parcelRequire("ayMG0");

var $lkxXU = parcelRequire("lkxXU");
var $d8seH = parcelRequire("d8seH");

var $lzNIT = parcelRequire("lzNIT");
function $2f2b9fd9f982590e$export$2e2bcd8739ae039(props) {
    const { items: items } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2f2b9fd9f982590e$var$Root, {
        className: "flex-nowrap",
        children: items.map((item, index)=>{
            if (item.divider) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                sx: {
                    borderWidth: 1
                }
            }, `divider-${index}`);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($2f2b9fd9f982590e$var$Item, {
                to: item.to,
                children: [
                    item.icon,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: item.label
                    })
                ]
            }, item.to);
        })
    });
}
const $2f2b9fd9f982590e$var$Root = (0, $d8seH.default)('div')`
  padding-top: 18px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f8f8f8'};
  max-width: 75px;
`;
const $2f2b9fd9f982590e$var$Item = (0, $d8seH.default)((0, $lzNIT.NavLink))`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px;
  width: 100%;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#bbb' : '#444'};
  font-size: .9em;
  border-right: 3px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'};

  svg {
    font-size: 2.5em;
  }

  :hover{
    text-decoration: none;
  }

  :hover:not(.active) {
    color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#000'};
  }

  &.active {
    border-right: 3px solid ${({ theme: theme })=>theme.palette.primary.main};
    border-top: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#333' : '#eee'};
    border-bottom: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#333' : '#eee'};
    margin-top: -1px;
    margin-bottom: -1px;
    background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : 'rgb(255, 255, 255)'};
    font-weight: 800;
  }

  &.active .MuiSvgIcon-root {
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;



var $c3pId = parcelRequire("c3pId");
const $2f91e9bd3d93eda6$var$getNavItems = ()=>{
    const items = [
        {
            to: 'explore',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6c07e7ecb3e9d607$export$2e2bcd8739ae039), {}),
            label: 'Explore'
        },
        {
            to: 'my-apps',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de7ad96370595041$export$2e2bcd8739ae039), {}),
            label: 'My Apps'
        }
    ];
    if ((0, $c3pId.default).isSignedIn) items.push({
        divider: true
    }, {
        to: '/apps/create-app',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cdd30d893754042$export$2e2bcd8739ae039), {}),
        label: 'Create App'
    });
    return items;
};
function $2f91e9bd3d93eda6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2f91e9bd3d93eda6$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f2b9fd9f982590e$export$2e2bcd8739ae039), {
                items: $2f91e9bd3d93eda6$var$getNavItems()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($2f91e9bd3d93eda6$var$Main, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
            })
        ]
    });
}
const $2f91e9bd3d93eda6$var$Root = (0, $lmFrL.default).div`
  display: flex;
  height: 100%;
`;
const $2f91e9bd3d93eda6$var$Main = (0, $lmFrL.default).div`
  padding: 0 20px;
  flex-grow: 1;
  overflow-y: auto;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $d8seH = parcelRequire("d8seH");

var $aphAM = parcelRequire("aphAM");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5d280ad6f3e31c17$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39"
}), 'Public');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f0c4ddd06d0955be$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72"
}), 'ScheduleRounded');




var $c3pId = parcelRequire("c3pId");
const $20369f58c098d908$var$getNavItems = ()=>{
    const items = [
        {
            to: 'all-jobs',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d280ad6f3e31c17$export$2e2bcd8739ae039), {}),
            label: 'All Jobs'
        },
        {
            to: 'my-jobs',
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0c4ddd06d0955be$export$2e2bcd8739ae039), {}),
            label: 'My Jobs'
        }
    ];
    if ((0, $c3pId.default).isSignedIn) items.push({
        divider: true
    }, {
        to: '/jobs/create-job',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cdd30d893754042$export$2e2bcd8739ae039), {}),
        label: 'Create Job'
    });
    return items;
};
function $20369f58c098d908$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($20369f58c098d908$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f2b9fd9f982590e$export$2e2bcd8739ae039), {
                items: $20369f58c098d908$var$getNavItems()
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($20369f58c098d908$var$Main, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
            })
        ]
    });
}
const $20369f58c098d908$var$Root = (0, $d8seH.default)('div')`
  display: flex;
  height: 100%;
`;
const $20369f58c098d908$var$Main = (0, $d8seH.default)('div')`
  padding: 0 20px;
  flex-grow: 1;
  overflow-y: auto;
`;



/* eslint-disable react/display-name */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $iwiZ3 = parcelRequire("iwiZ3");
var $cFBau = parcelRequire("cFBau");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $gd5y7 = parcelRequire("gd5y7");
var $2esSG = parcelRequire("2esSG");
var $OEVqP = parcelRequire("OEVqP");
var $2iAqv = parcelRequire("2iAqv");
var $e76iu = parcelRequire("e76iu");
var $cX7V2 = parcelRequire("cX7V2");
var $d8seH = parcelRequire("d8seH");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");

var $bcnr1 = parcelRequire("bcnr1");

var $9bsRS = parcelRequire("9bsRS");

var $gTmRg = parcelRequire("gTmRg");

var $gOa8m = parcelRequire("gOa8m");

var $5xexf = parcelRequire("5xexf");

var $lDN4l = parcelRequire("lDN4l");





var $hw4Z0 = parcelRequire("hw4Z0");

var $lffEs = parcelRequire("lffEs");



var $eOilY = parcelRequire("eOilY");


var $hBKHw = parcelRequire("hBKHw");
var $31f660b448822d0e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $31f660b448822d0e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($31f660b448822d0e$exports, "__esModule", {
    value: true
});
$31f660b448822d0e$exports.default = void 0;

var $31f660b448822d0e$var$_createSvgIcon = $31f660b448822d0e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $31f660b448822d0e$var$_default = $31f660b448822d0e$exports.default = (0, $31f660b448822d0e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 8h4V4H4zm6 12h4v-4h-4zm-6 0h4v-4H4zm0-6h4v-4H4zm6 0h4v-4h-4zm6-10v4h4V4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h4v-4h-4z"
}), 'Apps');


var $d07347710572e4cb$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d07347710572e4cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d07347710572e4cb$exports, "__esModule", {
    value: true
});
$d07347710572e4cb$exports.default = void 0;

var $d07347710572e4cb$var$_createSvgIcon = $d07347710572e4cb$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d07347710572e4cb$var$_default = $d07347710572e4cb$exports.default = (0, $d07347710572e4cb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-4.86 8.86-3 3.87L9 13.14 6 17h12z"
}), 'ImageOutlined');


var $622aa5f35d607588$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $622aa5f35d607588$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($622aa5f35d607588$exports, "__esModule", {
    value: true
});
$622aa5f35d607588$exports.default = void 0;

var $622aa5f35d607588$var$_createSvgIcon = $622aa5f35d607588$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $622aa5f35d607588$var$_default = $622aa5f35d607588$exports.default = (0, $622aa5f35d607588$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 3c-4.97 0-9 4.03-9 9v7c0 1.1.9 2 2 2h4v-8H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-4v8h4c1.1 0 2-.9 2-2v-7c0-4.97-4.03-9-9-9"
}), 'Headphones');


var $d67a953a3d28f14e$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $d67a953a3d28f14e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($d67a953a3d28f14e$exports, "__esModule", {
    value: true
});
$d67a953a3d28f14e$exports.default = void 0;

var $d67a953a3d28f14e$var$_createSvgIcon = $d67a953a3d28f14e$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $d67a953a3d28f14e$var$_default = $d67a953a3d28f14e$exports.default = (0, $d67a953a3d28f14e$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M11.15 3.4 7.43 9.48c-.41.66.07 1.52.85 1.52h7.43c.78 0 1.26-.86.85-1.52L12.85 3.4c-.39-.64-1.31-.64-1.7 0"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
        cx: "17.5",
        cy: "17.5",
        r: "4.5"
    }, "1"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M4 21.5h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1"
    }, "2")
], 'CategoryRounded');


var $1afa53983f562acc$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $1afa53983f562acc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($1afa53983f562acc$exports, "__esModule", {
    value: true
});
$1afa53983f562acc$exports.default = void 0;

var $1afa53983f562acc$var$_createSvgIcon = $1afa53983f562acc$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $1afa53983f562acc$var$_default = $1afa53983f562acc$exports.default = (0, $1afa53983f562acc$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.65 6.35c-1.63-1.63-3.94-2.57-6.48-2.31-3.67.37-6.69 3.35-7.1 7.02C3.52 15.91 7.27 20 12 20c3.19 0 5.93-1.87 7.21-4.56.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53-1.13 2.43-3.84 3.97-6.8 3.31-2.22-.49-4.01-2.3-4.48-4.52C5.31 9.44 8.26 6 12 6c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71H19c.55 0 1-.45 1-1V6.41c0-.89-1.08-1.34-1.71-.71z"
}), 'RefreshRounded');


var $0990221504e72a5f$exports = {};
"use strict";
"use client";

var $1jnue = parcelRequire("1jnue");
var $0990221504e72a5f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($0990221504e72a5f$exports, "__esModule", {
    value: true
});
$0990221504e72a5f$exports.default = void 0;

var $0990221504e72a5f$var$_createSvgIcon = $0990221504e72a5f$require$_interopRequireDefault((parcelRequire("7Ekty")));

var $ayMG0 = parcelRequire("ayMG0");
var $0990221504e72a5f$var$_default = $0990221504e72a5f$exports.default = (0, $0990221504e72a5f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m4 14H8V8h8z"
}), 'StopCircle');



var $f1q41 = parcelRequire("f1q41");

var $gZwVy = parcelRequire("gZwVy");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $9Lykx = parcelRequire("9Lykx");
var $imehR = parcelRequire("imehR");
var $6el2W = parcelRequire("6el2W");
var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $acw62 = parcelRequire("acw62");

var $1jJMI = parcelRequire("1jJMI");
var $52FI1 = parcelRequire("52FI1");
var $6zeBo = parcelRequire("6zeBo");
var $agZ85 = parcelRequire("agZ85");
var $eEJPp = parcelRequire("eEJPp");
var $13KXh = parcelRequire("13KXh");
var $3qSdM = parcelRequire("3qSdM");const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;



var $f56pe = parcelRequire("f56pe");
function $6dec2bf07d6d333a$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $6dec2bf07d6d333a$export$2e2bcd8739ae039 = $6dec2bf07d6d333a$var$areArraysEqual;


'use client';
const $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $9e8acd9e5bad7cc4$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $9e8acd9e5bad7cc4$var$asc(a, b) {
    return a - b;
}
function $9e8acd9e5bad7cc4$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $9e8acd9e5bad7cc4$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $9e8acd9e5bad7cc4$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $9e8acd9e5bad7cc4$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($9e8acd9e5bad7cc4$var$getDecimalPrecision(step)));
}
function $9e8acd9e5bad7cc4$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($9e8acd9e5bad7cc4$var$asc);
}
function $9e8acd9e5bad7cc4$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $6zeBo.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $9e8acd9e5bad7cc4$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $6dec2bf07d6d333a$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $9e8acd9e5bad7cc4$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $9e8acd9e5bad7cc4$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
function $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone() {
    if ($9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone = true;
    }
    return $9e8acd9e5bad7cc4$var$cachedSupportsTouchActionNone;
}
function $9e8acd9e5bad7cc4$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $9e8acd9e5bad7cc4$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $acw62.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(-1);
    const [dragging, setDragging] = $acw62.useState(false);
    const moveCount = $acw62.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $acw62.useRef(null);
    const [valueDerived, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($9e8acd9e5bad7cc4$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $1jJMI.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $acw62.useState(-1);
    const sliderRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $52FI1.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $52FI1.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $9e8acd9e5bad7cc4$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $eEJPp.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $acw62.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $9e8acd9e5bad7cc4$var$percentToValue(percent, min, max);
        if (step) newValue = $9e8acd9e5bad7cc4$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $9e8acd9e5bad7cc4$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $9e8acd9e5bad7cc4$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $9e8acd9e5bad7cc4$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $9e8acd9e5bad7cc4$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $9e8acd9e5bad7cc4$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $13KXh.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $9e8acd9e5bad7cc4$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $9e8acd9e5bad7cc4$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $6zeBo.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $6zeBo.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $acw62.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $9e8acd9e5bad7cc4$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $acw62.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $9e8acd9e5bad7cc4$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $9e8acd9e5bad7cc4$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$9e8acd9e5bad7cc4$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $6zeBo.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $9e8acd9e5bad7cc4$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $0acaed42692b8720$export$2e2bcd8739ae039),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $9e8acd9e5bad7cc4$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $c1jOg = parcelRequire("c1jOg");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $PJRTc = parcelRequire("PJRTc");

var $c1jOg = parcelRequire("c1jOg");
const $fef7b1c426e97238$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $c1jOg.default)(Slot);
};
var $fef7b1c426e97238$export$2e2bcd8739ae039 = $fef7b1c426e97238$var$shouldSpreadAdditionalProps;



var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $175610683d4083b7$export$9f59f2622d5cbc2a(slot) {
    return (0, $4Cod0.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $beCSm.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$export$2e2bcd8739ae039 = $175610683d4083b7$var$sliderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1d8e4e584d12bd05$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $5FMfE.default)(open && (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $1d8e4e584d12bd05$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $1d8e4e584d12bd05$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        className: (0, $5FMfE.default)(children.props.className)
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $5FMfE.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $e7d362f04a4204f3$var$Identity(x) {
    return x;
}
const $e7d362f04a4204f3$export$c1a21b3b4da66aa1 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $jTnBY.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $175610683d4083b7$export$2e2bcd8739ae039).thumb}, & .${(0, $175610683d4083b7$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $e7d362f04a4204f3$export$b02fde61a3559c2 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail',
    overridesResolver: (props, styles)=>styles.rail
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $e7d362f04a4204f3$export$105594979f116971 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $aeD7H.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: (0, $aSEG4.lighten)(theme.palette[color].main, 0.62),
                            borderColor: (0, $aSEG4.lighten)(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: (0, $aSEG4.darken)(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: (0, $aSEG4.darken)(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $e7d362f04a4204f3$export$2c1b491743890dec = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $jTnBY.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $175610683d4083b7$export$2e2bcd8739ae039).focusVisible}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 8px ${(0, $aSEG4.alpha)(theme.palette[color].main, 0.16)}`
                            },
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).active}`]: {
                            ...theme.vars ? {
                                boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
                            } : {
                                boxShadow: `0px 0px 0px 14px ${(0, $aSEG4.alpha)(theme.palette[color].main, 0.16)}`
                            }
                        }
                    }
                }))
        ]
    })));
const $e7d362f04a4204f3$export$6453176f504d54f0 = (0, $d8seH.default)((0, $1d8e4e584d12bd05$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel',
    overridesResolver: (props, styles)=>styles.valueLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $175610683d4083b7$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $e7d362f04a4204f3$export$6f85f6a3c5da6f62 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $e7d362f04a4204f3$export$e6cd369965e5aa95 = (0, $d8seH.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $PJRTc.default)(prop) && prop !== 'markLabelActive',
    overridesResolver: (props, styles)=>styles.markLabel
})((0, $aeD7H.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $e7d362f04a4204f3$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $jTnBY.default)(color)}`,
            size && `size${(0, $jTnBY.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $jTnBY.default)(size)}`,
            color && `thumbColor${(0, $jTnBY.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $175610683d4083b7$export$9f59f2622d5cbc2a), classes);
};
const $e7d362f04a4204f3$var$Forward = ({ children: children })=>children;
const $e7d362f04a4204f3$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $58lXc.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $e7d362f04a4204f3$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $e7d362f04a4204f3$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $9e8acd9e5bad7cc4$export$56b2c08e277f365)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $e7d362f04a4204f3$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $e7d362f04a4204f3$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $e7d362f04a4204f3$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $e7d362f04a4204f3$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $e7d362f04a4204f3$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $e7d362f04a4204f3$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $e7d362f04a4204f3$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $e7d362f04a4204f3$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $fef7b1c426e97238$export$2e2bcd8739ae039)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $eD6Co.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $eD6Co.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $eD6Co.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $eD6Co.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $eD6Co.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $eD6Co.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $eD6Co.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $9e8acd9e5bad7cc4$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $c1jOg.default)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $5FMfE.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $c1jOg.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $5FMfE.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $9e8acd9e5bad7cc4$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $e7d362f04a4204f3$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, {
                    ...!(0, $c1jOg.default)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $5FMfE.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $e7d362f04a4204f3$export$2e2bcd8739ae039 = $e7d362f04a4204f3$var$Slider;


var $3bYfT = parcelRequire("3bYfT");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $4063e427fd9f0142$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18c0 .55.45 1 1 1h5v-2H4c-.55 0-1 .45-1 1M3 6c0 .55.45 1 1 1h9V5H4c-.55 0-1 .45-1 1m10 14v-1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1M7 10v1H4c-.55 0-1 .45-1 1s.45 1 1 1h3v1c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1m14 2c0-.55-.45-1-1-1h-9v2h9c.55 0 1-.45 1-1m-5-3c.55 0 1-.45 1-1V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1"
}), 'TuneRounded');



var $f1q41 = parcelRequire("f1q41");
const $93130e1adb27db4f$var$VALUE_INPUT_STEP = 0.00000001;
function $93130e1adb27db4f$export$374633da432e5a39(props) {
    const { onChange: onChange } = props;
    const [rules, setRules] = (0, $acw62.useState)($93130e1adb27db4f$var$getInitialRule(props.rules, props.data));
    (0, $acw62.useEffect)(()=>{
        if (!onChange) return;
        onChange(rules);
    }, [
        rules
    ]);
    const handleUpdateRule = (i, type, name, value)=>{
        setRules((prev)=>{
            const newRule = {
                ...prev[i],
                [name]: [
                    Number(value[0]),
                    Number(value[1])
                ]
            };
            return prev.map((rule, k)=>k == i ? newRule : rule);
        });
    };
    const handleRmRule = (i)=>{
        setRules((prev)=>prev.filter((_, k)=>k != i));
    };
    /* could support multiple filters
  const [logics, setLogics] = useState<BooleanLogic[]>([])

  const handleAddRule = (type: 'cron' | 'condition') => {
    if (rules.length >= 1) {
      setLogics(prev => [...prev, 'and'])
    }

    if (type == 'condition') {
      setRules(prev => [...prev, {name: 'value', op: '>', value: 3}])
    } else {
      throw 'handleAddRule: type of rule (query) not recognized'
    }
  }

  const handleUpdateLogic = (i, value) => {
    setLogics(prev => prev.map((old, k) => k == i ? value : old))
  }
  */ return /*#__PURE__*/ (0, $ayMG0.jsxs)($93130e1adb27db4f$var$RulesRoot, {
        children: [
            rules.map((rule, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($93130e1adb27db4f$var$RuleInput, {
                    className: "flex column gap",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex items-center gap",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                        sx: {
                                            width: 600
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                gutterBottom: true,
                                                children: rule.name
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-center gap",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $imehR.default), {
                                                        value: rule.value[0],
                                                        size: "small",
                                                        onChange: (evt)=>handleUpdateRule(i, 'range', rule.name, [
                                                                evt.target.value,
                                                                rule.value[1]
                                                            ]),
                                                        // onBlur={handleBlur}
                                                        inputProps: {
                                                            step: $93130e1adb27db4f$var$VALUE_INPUT_STEP,
                                                            min: rule.min,
                                                            max: rule.max,
                                                            type: 'number',
                                                            'aria-labelledby': 'input-slider'
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e7d362f04a4204f3$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            width: 400
                                                        },
                                                        getAriaLabel: ()=>'range',
                                                        value: rule.value,
                                                        onChange: (evt, value)=>handleUpdateRule(i, 'range', rule.name, value),
                                                        valueLabelDisplay: "on",
                                                        min: rule.min,
                                                        max: rule.max,
                                                        step: $93130e1adb27db4f$var$VALUE_INPUT_STEP
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $imehR.default), {
                                                        value: rule.value[1],
                                                        size: "small",
                                                        onChange: (evt)=>handleUpdateRule(i, 'range', rule.name, [
                                                                rule.value[0],
                                                                evt.target.value
                                                            ]),
                                                        // onBlur={handleBlur}
                                                        inputProps: {
                                                            step: $93130e1adb27db4f$var$VALUE_INPUT_STEP,
                                                            min: rule.min,
                                                            max: rule.max,
                                                            type: 'number',
                                                            'aria-labelledby': 'input-slider'
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    i < rules.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "and"
                                    }),
                                    i == rules.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("b", {})
                                ]
                            }),
                            rules.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                    onClick: ()=>handleRmRule(i),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65ebd81691801e03$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    })
                }, i)),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
        ]
    });
}
const $93130e1adb27db4f$var$RulesRoot = (0, $lmFrL.default).div`

`;
const $93130e1adb27db4f$var$RuleInput = (0, $lmFrL.default).div`
  .cron-amount {
    width: 100px;
  }
`;
function $93130e1adb27db4f$var$getInitialRule(rules, data) {
    if (rules.length > 0) return rules;
    const min = Number((0, $f1q41.minBy)(data, 'value')['value']);
    const max = Number((0, $f1q41.maxBy)(data, 'value')['value']);
    return [
        {
            name: 'value',
            value: [
                min,
                max
            ],
            min: min,
            max: max
        }
    ];
}
function $93130e1adb27db4f$export$2e2bcd8739ae039(props) {
    const { data: data, rules: rules, className: className, onClear: onClear, onSubmit: onSubmit } = props;
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!anchorEl) return;
    }, [
        anchorEl
    ]);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleRuleChange = (rules)=>{
        onSubmit(rules);
    };
    const handleClear = ()=>{
        onClear();
        handleClose();
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const names = [
        'value'
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                "aria-describedby": id,
                onClick: handleClick,
                className: className,
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4063e427fd9f0142$export$2e2bcd8739ae039), {}),
                children: "Filter Values"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3bYfT.default), {
                    sx: {
                        p: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($93130e1adb27db4f$export$374633da432e5a39, {
                            data: data,
                            rules: rules,
                            names: names,
                            onChange: handleRuleChange
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    onClick: handleClear,
                                    children: "Clear Filters"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    onClick: handleClose,
                                    variant: "contained",
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}





var $df7c2ed07b6a9ba8$exports = {};
/*!
 * jsonurl.js v1.1.8
 * (c) 2024 David MacCormack
 * Released under the MIT License.
 */ !function(e, t) {
    $df7c2ed07b6a9ba8$exports = t();
}($df7c2ed07b6a9ba8$exports, function() {
    "use strict";
    const e = "JSON->URL: expected literal value", t = "JSON->URL: unexpected character", r = "JSON->URL: unexpected end of text inside composite", s = "JSON->URL: unexpected text after composite", i = "JSON->URL: can not represent null with implied strings", n = "JSON->URL: the empty string is not allowed", o = "JSON->URL: invalid escape sequence", a = "JSON->URL: invalid percent-encoded sequence", p = "JSON->URL: expected object value";
    function u(e, t) {
        return void 0 === t ? e : e + " at position " + t;
    }
    const c = 16, l = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        0,
        0,
        6,
        6,
        48,
        10,
        20,
        20,
        6,
        6,
        20,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        20,
        6,
        0,
        48,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0,
        0,
        6,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0,
        6,
        0
    ];
    function h(e) {
        return e > 127 ? 0 : l[e];
    }
    class d {
        constructor(e){
            this.setOrDefault(e, "allowEmptyUnquotedValues"), this.setOrDefault(e, "allowEmptyUnquotedKeys"), this.setOrDefault(e, "AQF"), this.setOrDefault(e, "coerceNullToEmptyString"), this.setOrDefault(e, "ignoreNullArrayMembers"), this.setOrDefault(e, "ignoreNullObjectMembers"), this.setOrDefault(e, "impliedArray"), this.setOrDefault(e, "impliedObject"), this.setOrDefault(e, "impliedStringLiterals"), this.setOrDefault(e, "noEmptyComposite"), this.setOrDefault(e, "wwwFormUrlEncoded");
        }
        setOrDefault(e, t, r) {
            void 0 !== e && t in e ? t in this || (this[t] = e[t]) : void 0 === r || t in this || (this[t] = r);
        }
        setOverride(e, t) {
            void 0 !== e && t in e && (this[t] = e[t]);
        }
        setOrDefaultInt(e, t, r) {
            this.setOrDefault(e, t, void 0 === r ? r : parseInt(r));
        }
        isPresentAndTrue(e) {
            return e in this && this[e];
        }
    }
    class f extends d {
        constructor(e, t){
            super(e), this.setOrDefault(e, "emptyValue"), this.setOrDefault(t, "emptyValue", {}), this.setOverride(e, "getMissingValue"), this.setOrDefaultInt(e, "maxParseChars"), this.setOrDefaultInt(t, "maxParseChars", 32768), this.setOrDefaultInt(e, "maxParseDepth"), this.setOrDefaultInt(t, "maxParseDepth", 32), this.setOrDefaultInt(e, "maxParseValues"), this.setOrDefaultInt(t, "maxParseValues", 4096), this.setOrDefault(e, "nullValue"), this.setOrDefault(t, "nullValue", null);
        }
        getMissingValue(e, t) {
            throw new SyntaxError(u(p, t));
        }
    }
    class m extends d {
        constructor(e){
            super(e);
            const t = !(void 0 === e || !("impliedStringLiterals" in e) || !e.impliedStringLiterals) || void 0;
            this.setOrDefault(e, "allowEmptyUnquotedValues", t), this.setOrDefault(e, "allowEmptyUnquotedKeys", t), this.setOrDefault(e, "callFunctions"), this.setOrDefault(e, "isImplied"), this.setOrDefault(e, "ignoreNullArrayMembers", t), this.setOrDefault(e, "ignoreNullObjectMembers", t), this.setOrDefault(e, "ignoreUndefinedArrayMembers", t), this.setOrDefault(e, "ignoreUndefinedObjectMembers", t), this.isImplied = this.isImplied || this.impliedArray || this.impliedObject;
        }
    }
    const w = /\+/g, y = / /g, x = /(![\s\S]?)/g, A = /^[-A-Za-z0-9._~!$*;@?/ ][-A-Za-z0-9._~!$*;@?/' ]*$/, O = /^[-A-Za-z0-9._~!$*,;@?/(): ]+$/, E = /^-?\d+(?:\.\d+)?(?:[eE][-]?\d+)?$/, g = /^-?\d+(?:\.\d+)?[eE]\+\d+$/, b = /^-?\d+(?:\.\d+)?[eE] \d+$/, S = /[(),:]|%2[04]|%3B/gi, L = {
        "%20": "+",
        "%24": "$",
        "(": "%28",
        ")": "%29",
        ",": "%2C",
        ":": "%3A",
        "%3B": ";"
    }, v = /[!(),:]|%2[01489BC]|%3[AB]/gi, U = {
        "%20": "+",
        "%21": "!!",
        "!": "!!",
        "%24": "$",
        "%28": "!(",
        "(": "!(",
        "%29": "!)",
        ")": "!)",
        "+": "!+",
        "%2B": "!+",
        "%2C": "!,",
        ",": "!,",
        "%3A": "!:",
        ":": "!:",
        "%3B": ";"
    }, V = 40, C = 41, D = 44, j = 58, R = 38, N = 48, J = 65, P = 97, T = new Array(111);
    T[33] = "!", T[40] = "(", T[41] = ")", T[43] = "+", T[44] = ",", T[45] = ",", T[N] = "0", T[N + 1] = "1", T[N + 2] = "2", T[N + 3] = "3", T[N + 4] = "4", T[N + 5] = "5", T[N + 6] = "6", T[N + 7] = "7", T[N + 8] = "8", T[N + 9] = "9", T[58] = ":", T[116] = "t", T[102] = "f", T[110] = "n";
    const F = "", I = "!e", k = " ";
    function M(e, t) {
        const r = t ? v : S, s = t ? U : L;
        return encodeURIComponent(e).replace(r, function(e) {
            const t = s[e];
            return void 0 === t ? e : t;
        });
    }
    function _(e, t) {
        switch(t){
            case N:
                return 0;
            case N + 1:
                return 1;
            case N + 2:
                return 2;
            case N + 3:
                return 3;
            case N + 4:
                return 4;
            case N + 5:
                return 5;
            case N + 6:
                return 6;
            case N + 7:
                return 7;
            case N + 8:
                return 8;
            case N + 9:
                return 9;
            case J:
            case P:
                return 10;
            case J + 1:
            case P + 1:
                return 11;
            case J + 2:
            case P + 2:
                return 12;
            case J + 3:
            case P + 3:
                return 13;
            case J + 4:
            case P + 4:
                return 14;
            case J + 5:
            case P + 5:
                return 15;
            default:
                throw new SyntaxError(u(a, e));
        }
    }
    function q(e) {
        if (e.coerceNullToEmptyString) return B(e, !1);
        if (e.impliedStringLiterals) throw new SyntaxError(i);
        return "null";
    }
    function B(e, t) {
        if (t ? e.allowEmptyUnquotedKeys : e.allowEmptyUnquotedValues) return F;
        if (e.AQF) return I;
        if (e.impliedStringLiterals) throw new SyntaxError(n);
        return "''";
    }
    !function(e) {
        let { toJsonURLText_Array: t, toJsonURLText_Boolean: r, toJsonURLText_Number: s, toJsonURLText_Object: i, toJsonURLText_String: n } = e;
        Object.defineProperty(Array.prototype, "toJsonURLText", {
            value: t
        }), Object.defineProperty(Boolean.prototype, "toJsonURLText", {
            value: r
        }), Object.defineProperty(Number.prototype, "toJsonURLText", {
            value: s
        }), Object.defineProperty(Object.prototype, "toJsonURLText", {
            value: i
        }), Object.defineProperty(String.prototype, "toJsonURLText", {
            value: n
        });
    }({
        toJsonURLText_Array: function() {
            let e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            return this.forEach(function(s) {
                if ("function" == typeof s) {
                    if (!t.callFunctions) return;
                    for(; "function" == typeof s;)s = s();
                }
                if (void 0 === s) {
                    if (t.ignoreUndefinedArrayMembers) return;
                    s = q(t);
                } else if (null === s) {
                    if (t.ignoreNullArrayMembers) return;
                    s = q(t);
                } else s = s.toJsonURLText(t, r + 1);
                void 0 === e ? e = s : !t.wwwFormUrlEncoded || r > 0 ? e += "," + s : e += "&" + s;
            }), !t.isImplied || r > 0 ? void 0 === e ? "()" : "(" + e + ")" : void 0 === e ? F : e;
        },
        toJsonURLText_Boolean: function() {
            return !0 === this ? "true" : "false";
        },
        toJsonURLText_Number: function(e) {
            const t = String(this);
            return e.impliedStringLiterals && -1 !== t.indexOf("+") ? M(t, e) : t;
        },
        toJsonURLText_Object: function() {
            let e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
            const s = Object.keys(this), i = this;
            return s.forEach(function(s) {
                if (null == s) return;
                let n = i[s];
                if ("function" == typeof n) {
                    if (!t.callFunctions) return;
                    for(; "function" == typeof n;)n = n();
                }
                if (void 0 === n) {
                    if (t.ignoreUndefinedObjectMembers) return;
                    n = q(t);
                } else if (null === n) {
                    if (t.ignoreNullObjectMembers) return;
                    n = q(t);
                } else n = n.toJsonURLText(t, r + 1);
                const o = s.toJsonURLText(t, r, !0);
                void 0 === e ? e = !t.wwwFormUrlEncoded || r > 0 ? o + ":" + n : o + "=" + n : !t.wwwFormUrlEncoded || r > 0 ? e += "," + o + ":" + n : e += "&" + o + "=" + n;
            }), !t.isImplied || r > 0 ? (t.noEmptyComposite && void 0 === e && (e = ":"), void 0 === e ? "()" : "(" + e + ")") : void 0 === e ? F : e;
        },
        toJsonURLText_String: function(e, t, r) {
            if (0 === this.length) return B(e, r);
            if (e.impliedStringLiterals) return M(this, e.AQF);
            if ("true" === (s = this) || "false" === s || "null" === s || E.test(s)) return !0 === r ? this : e.AQF ? "!" + this : "'" + this + "'";
            var s;
            if (g.test(this)) return e.AQF ? this.replace("+", "!+") : this.replace("+", "%2B");
            if (b.test(this)) return e.AQF ? "!" + this.replace(k, "+") : "'" + this.replace(k, "+") + "'";
            if (e.AQF) return M(this, !0);
            if (A.test(this)) return -1 == this.indexOf(k) ? this : this.replace(y, "+");
            if (O.test(this)) return -1 == this.indexOf(k) ? "'" + this + "'" : "'" + this.replace(y, "+") + "'";
            let i = M(this);
            return 39 == i.charCodeAt(0) ? "%27" + i.substring(1) : i;
        }
    });
    class $ {
        constructor(e, t, r, s){
            this.text = e, this.pos = this.markPos = t, this.end = r, this.options = s;
        }
        skipAmps() {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            const t = this.text, r = this.end;
            let s = this.pos;
            if (e) for(; s < r && t.charCodeAt(s) === R;)s++;
            else if (s < r && t.charCodeAt(s) === R) {
                for(s++; s < r && t.charCodeAt(s) === R; s++);
                s !== r && s--;
            }
            this.pos = s;
        }
        structChar() {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            if (this.options.wwwFormUrlEncoded) {
                const t = this.text.charCodeAt(this.pos);
                switch(t){
                    case R:
                    case 61:
                        if (e) return;
                        return this.pos++, t;
                }
            }
            const t = this.pos, r = this.ordinal();
            switch(r){
                case D:
                case j:
                    if (e) return void (this.pos = t);
                case V:
                case C:
                    return r;
                default:
                    return void (this.pos = t);
            }
        }
        ordinal(e) {
            return void 0 !== e ? this.text.charCodeAt(e) : this.text.charCodeAt(this.pos++);
        }
        accept(e) {
            const t = this.pos;
            return this.ordinal() === e || (this.pos = t, !1);
        }
        acceptPlus() {
            return 43 == this.text.charCodeAt(this.pos) && (this.pos++, !0);
        }
        done() {
            return this.end <= this.pos;
        }
        validateLiteral(e, r) {
            const s = this.text, i = this.end;
            for(; e < i; e++)switch(h(s.charCodeAt(e)) & r){
                case 0:
                    throw new SyntaxError(u(t, e));
                case c:
                    return e;
                case 8:
                    return e + 1;
                default:
                    continue;
            }
        }
        findLiteralEnd() {
            const e = this.text, t = this.end;
            let r = this.pos;
            const s = 39 === e.charCodeAt(r);
            s && r++;
            const i = s ? 28 : 18;
            if (r = this.validateLiteral(r, i), void 0 !== r) return r;
            if (s) throw new SyntaxError(u("JSON->URL: quoted string still open", r));
            return t;
        }
        isEmptyObject() {
            if (this.options.noEmptyComposite) {
                const e = this.pos;
                if (!this.accept(j)) return !1;
                const t = this.pos, r = this.accept(C);
                return this.pos = r ? t : e, r;
            }
            return !1;
        }
        parseLiteral(e) {
            const t = this.pos, r = this.options, s = this.findLiteralEnd();
            if (void 0 === e && (e = this.ordinal(s) == j), s <= t) return function(e, t) {
                if (t) return F;
                throw new SyntaxError(u(n, e));
            }(t, e ? this.options.allowEmptyUnquotedKeys : this.options.allowEmptyUnquotedValues);
            if (!0 === r.impliedStringLiterals) return this.parseStringLiteral(s, !0);
            const i = this.parseTrueFalseNull(s, e);
            if (void 0 !== i) return i;
            const o = this.parseNumberLiteral(s, e);
            return void 0 !== o ? o : this.parseStringLiteral(s, !1);
        }
        parseDigits(e) {
            let t, r = !1;
            for(; this.pos < e;)switch(this.ordinal()){
                case N:
                case N + 1:
                case N + 2:
                case N + 3:
                case N + 4:
                case N + 5:
                case N + 6:
                case N + 7:
                case N + 8:
                case N + 9:
                    t = this.pos, r = !0;
                    continue;
                default:
                    return this.pos = t, r;
            }
            return this.pos = t, r;
        }
        parseExponentValue(e) {
            return !(e <= this.pos) && (this.acceptPlus() || this.accept(45), this.parseDigits(e));
        }
        parseExponent(e) {
            const t = this.pos;
            switch(this.ordinal()){
                case 69:
                case 101:
                    if (this.parseExponentValue(e)) return !0;
            }
            return this.pos = t, !1;
        }
        parseFraction(e) {
            const t = this.pos;
            return !(e <= t) && (!(!this.accept(46) || !this.parseDigits(e)) || (this.pos = t, !1));
        }
        parseInteger(e) {
            return !(e <= this.pos) && (!!this.accept(N) || this.parseDigits(e));
        }
        parseNumberLiteral(e, t) {
            const r = this.text, s = this.pos;
            if (this.accept(45), this.parseInteger(e) && (this.parseFraction(e), this.parseExponent(e), this.pos === e)) {
                const i = decodeURIComponent(r.substring(s, e));
                return t ? i : Number(i);
            }
            this.pos = s;
        }
        parseStringLiteral(e, t) {
            const r = this.text, s = this.pos;
            let i = t || 39 !== r.charCodeAt(s) ? r.substring(s, e) : r.substring(s + 1, e - 1);
            return i = decodeURIComponent(i.replace(w, k)), this.pos = e, i;
        }
        parseTrueFalseNull(e, t) {
            const r = this.text, s = this.pos;
            let i, n, o, a, p;
            switch(e - s){
                case 4:
                    if (i = r.charCodeAt(s), n = r.charCodeAt(s + 1), o = r.charCodeAt(s + 2), a = r.charCodeAt(s + 3), 116 === i && 114 === n && 117 === o && 101 === a) return this.pos = e, !t || "true";
                    if (110 === i && 117 === n && 108 === o && 108 === a) return this.pos = e, t ? "null" : this.newNullValue();
                    break;
                case 5:
                    if (i = r.charCodeAt(s), n = r.charCodeAt(s + 1), o = r.charCodeAt(s + 2), a = r.charCodeAt(s + 3), p = r.charCodeAt(s + 4), 102 === i && n === P && 108 === o && 115 === a && 101 === p) return this.pos = e, !!t && "false";
            }
        }
        newEmptyValue() {
            const e = this.options;
            if (e.noEmptyComposite) return [];
            const t = e.emptyValue;
            return "function" == typeof t ? t() : t;
        }
        newNullValue() {
            const e = this.options;
            let t = e.nullValue;
            return "function" == typeof t && (t = t()), null == t && e.coerceNullToEmptyString && (t = F), t;
        }
    }
    class Q extends $ {
        constructor(e, t, r, s){
            super(e, t, r, s);
        }
        ordinal(e) {
            const t = e || this.pos, r = this.text.charCodeAt(t);
            let s, i;
            return 37 === r ? (s = function(e, t, r) {
                if (r <= t + 1) throw new SyntaxError(u(a, t));
                return _(t, e.charCodeAt(t)) << 4 | _(t, e.charCodeAt(t + 1));
            }(this.text, t + 1, this.end), i = 3) : (s = r, i = 1), void 0 === e && (this.pos += i), s;
        }
        findLiteralEnd() {
            const e = this.end, r = this.pos, s = this.text;
            let i = r;
            for(;;){
                if (e <= this.pos) return this.pos = r, e;
                switch(50 & h(s.charCodeAt(this.pos))){
                    case 48:
                        if (this.options.wwwFormUrlEncoded) return i = this.pos, this.pos = r, i;
                    case 0:
                        throw new SyntaxError(u(t, i));
                }
                switch(this.ordinal()){
                    case V:
                    case C:
                    case j:
                    case D:
                        return this.pos = r, i;
                    case 33:
                        if (this.pos === e) throw new SyntaxError(u(o, i));
                        this.ordinal(), i = this.pos;
                        break;
                    default:
                        i = this.pos;
                }
            }
        }
        parseStringLiteral(e) {
            const t = this.text, r = this.pos, s = decodeURIComponent(t.substring(r, e).replace(w, function(e, s) {
                return 0 !== s && function(e, t) {
                    return 33 === e.charCodeAt(t - 1) || t > 2 && 37 === e.charCodeAt(t - 3) && e.charCodeAt(t - 2) === N + 2 && e.charCodeAt(t - 1) === N + 1;
                }(t, r + s) ? "+" : k;
            }));
            return this.pos = e, "!e" === s ? F : s.replace(x, function(e, t, s) {
                if (2 === e.length) {
                    const t = e.charCodeAt(1), r = T[t];
                    if (void 0 !== r) return r;
                }
                throw new SyntaxError(u(o, r + s));
            });
        }
    }
    class K extends Array {
        constructor(e){
            super(), this.limits = e, this.parseDepth = 0;
        }
        replaceAndPush(e, t, r) {
            if (this[this.parseDepth] = t, ++this.parseDepth >= this.limits.maxParseDepth) throw new Error(u("JSON->URL: MaxParseDepth exceeded", e));
            this.push(r);
        }
        replace(e) {
            this[this.parseDepth] = e;
        }
        depth() {
            return arguments.length > 0 && void 0 !== arguments[0] && arguments[0] && (this.parseDepth--, this.pop()), this.parseDepth;
        }
    }
    class z extends Array {
        constructor(e){
            super(), this.limits = e, this.numValues = 0;
        }
        popObjectValue(e) {
            let t = this.pop(), r = this.pop(), s = this[this.length - 1];
            return null === t && e.isPresentAndTrue("ignoreNullObjectMembers") || (s[r] = t), s;
        }
        popArrayValue(e) {
            let t = this.pop(), r = this[this.length - 1];
            return null === t && e.isPresentAndTrue("ignoreNullArrayMembers") || r.push(t), r;
        }
        checkValueLimit(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
            if (this.numValues += t, this.numValues > this.limits.maxParseValues + 1) throw new Error(u("JSON->URL: MaxParseValues exceeded", e));
        }
        appendArrayValue(e, t) {
            let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
            this.checkValueLimit(e, r), this.push(t);
        }
    }
    function Z(e) {
        for(; "function" == typeof e;)e = e();
        return e;
    }
    function G(e, t, r, s) {
        return "number" == typeof e ? "number" != typeof t && (r = t) : r = e, (r = Z(r)) instanceof f || (r = new f(r, s)), r;
    }
    function H(e, t, r, s) {
        return s.AQF ? new Q(e, t, r, s) : new $(e, t, r, s);
    }
    function W(e, t) {
        return "number" == typeof e ? e : t;
    }
    function X(i, n, o, a, c) {
        if (void 0 === i) return;
        a = G(n, o, a, c), i = String(i);
        const l = W(n, 0), h = W(o, i.length);
        if (h <= l) {
            if (void 0 !== a.impliedArray) return a.impliedArray;
            if (void 0 !== a.impliedObject) return a.impliedObject;
            throw new SyntaxError(u("JSON->URL: expected value", 0));
        }
        if (h > a.maxParseChars) throw new Error("JSON->URL: MaxParseChars exceeded");
        const d = a.wwwFormUrlEncoded && (a.impliedObject || a.impliedArray), f = new z(a), m = new K(a), w = H(i, l, h, a);
        if (void 0 !== a.impliedObject) f.push(a.impliedObject), m.push(6);
        else if (void 0 !== a.impliedArray) f.push(a.impliedArray), m.push(2);
        else {
            if (w.structChar(!0) !== V) {
                const t = w.parseLiteral(!1);
                if (w.done()) return t;
                throw new SyntaxError(u(e, 0));
            }
            m.push(1);
        }
        for(d && w.skipAmps(!0);;){
            if (w.done()) throw new SyntaxError(u(r, w.pos));
            let i, n, o;
            switch(m[m.depth()]){
                case 1:
                    switch(w.structChar(!0)){
                        case V:
                            f.appendArrayValue(w.pos, []), m.replaceAndPush(w.pos, 3, 1);
                            continue;
                        case C:
                            if (-1 === m.depth(!0)) {
                                if (w.done()) return w.newEmptyValue();
                                throw new SyntaxError(u(s, w.pos));
                            }
                            if (f.appendArrayValue(w.pos, w.newEmptyValue()), 0 === m.depth() && (d && w.skipAmps(), w.done())) {
                                if (a.impliedArray) return f.popArrayValue(a);
                                if (a.impliedObject) return f.popObjectValue(a);
                                throw new SyntaxError(u(r, w.pos));
                            }
                            continue;
                    }
                    switch(f.checkValueLimit(w.pos), n = w.isEmptyObject(), i = n ? {} : w.parseLiteral(), o = w.pos, w.structChar()){
                        case R:
                            if (!a.wwwFormUrlEncoded || m.depth() > 0) throw new SyntaxError(u(t, o));
                        case D:
                            m.replace(2), f.appendArrayValue(o, []), f.push(i), f.popArrayValue(a);
                            continue;
                        case C:
                            switch(n ? f.push({}) : f.appendArrayValue(o, [
                                i
                            ]), m.depth(!0)){
                                case -1:
                                    if (w.pos === h) return f[0];
                                    throw new SyntaxError(u(s, o));
                                case 0:
                                    if (d && w.skipAmps(), w.done()) {
                                        if (a.impliedArray) return f.popArrayValue(a);
                                        if (a.impliedObject) return f.popObjectValue(a);
                                        throw new SyntaxError(u(r, o));
                                    }
                            }
                            continue;
                        case 61:
                            if (!a.wwwFormUrlEncoded || m.depth() > 0) throw new SyntaxError(u(t, o));
                        case j:
                            m.replace(4), f.push({}, i);
                            continue;
                        default:
                            throw new SyntaxError(u(e, o));
                    }
                case 2:
                    if (w.accept(V)) {
                        m.replaceAndPush(w.pos, 3, 1);
                        continue;
                    }
                    if (f.checkValueLimit(w.pos), i = w.parseLiteral(!1), d && w.skipAmps(), w.done()) {
                        if (0 === m.depth() && a.impliedArray) return f.push(i), f.popArrayValue(a);
                        throw new SyntaxError(u(r, h));
                    }
                    m.replace(3), f.push(i);
                    continue;
                case 3:
                    switch(f.popArrayValue(a), w.structChar()){
                        case R:
                            if (!a.wwwFormUrlEncoded || m.depth() > 0) throw new SyntaxError(u(t, w.pos));
                        case D:
                            m.replace(2);
                            continue;
                        case C:
                            switch(m.depth(!0)){
                                case -1:
                                    if (w.done() && !a.impliedArray) return f[0];
                                    throw new SyntaxError(u(s, w.pos));
                                case 0:
                                    if (d && w.skipAmps(), w.done()) {
                                        if (a.impliedArray) return f.popArrayValue(a);
                                        if (a.impliedObject) return f.popObjectValue(a);
                                        throw new SyntaxError(u(r, w.pos));
                                    }
                            }
                            continue;
                    }
                    throw new SyntaxError(u("JSON->URL: expected comma or close paren", w.pos));
                case 4:
                    if (w.accept(V)) {
                        m.replaceAndPush(w.pos, 5, 1);
                        continue;
                    }
                    if (f.checkValueLimit(w.pos), i = w.parseLiteral(!1), d && w.skipAmps(), w.done()) {
                        if (0 === m.depth() && a.impliedObject) return f.push(i), f.popObjectValue(a);
                        throw new SyntaxError(u(r, h));
                    }
                    m.replace(5), f.push(i);
                    continue;
                case 5:
                    switch(f.popObjectValue(a), o = w.pos, w.structChar()){
                        case R:
                            if (!a.wwwFormUrlEncoded || m.depth() > 0) throw new SyntaxError(u(t, o));
                        case D:
                            m.replace(6);
                            continue;
                        case C:
                            switch(m.depth(!0)){
                                case -1:
                                    if (w.done() && !a.impliedObject) return f[0];
                                    throw new SyntaxError(u(s, w.pos));
                                case 0:
                                    if (d && w.skipAmps(), w.done()) {
                                        if (a.impliedArray) return f.popArrayValue(a);
                                        if (a.impliedObject) return f.popObjectValue(a);
                                        throw new SyntaxError(u(s, w.pos));
                                    }
                            }
                            continue;
                    }
                    throw new SyntaxError(u("JSON->URL: expected comma, open paren, or close paren", w.pos));
                case 6:
                    if (i = w.parseLiteral(!0), d && w.skipAmps(), w.done()) {
                        if (a.impliedObject && 0 == m.depth()) return f.push(i, a.getMissingValue(i)), f.popObjectValue(a);
                        throw new SyntaxError(u(r, h));
                    }
                    switch(w.structChar()){
                        case 61:
                            if (!a.wwwFormUrlEncoded || m.depth() > 0) throw new SyntaxError(u(t, w.pos));
                        case j:
                            break;
                        case R:
                            if (!a.wwwFormUrlEncoded || m.depth() > 0) throw new SyntaxError(u(t, w.pos));
                        case D:
                            if (a.impliedObject && 0 == m.depth()) {
                                f.push(i, a.getMissingValue(i)), f.popObjectValue(a);
                                continue;
                            }
                        default:
                            throw new SyntaxError(u(p, w.pos));
                    }
                    m.replace(4), f.push(i);
                    continue;
                default:
                    throw new SyntaxError(u("JSON->URL: internal error", w.pos));
            }
        }
    }
    return class {
        constructor(e){
            for(; "function" == typeof e;)e = e();
            void 0 === e && (e = {}), this.maxParseDepth = "number" == typeof e.maxParseDepth ? parseInt(e.maxParseDepth) : 32, this.maxParseValues = "number" == typeof e.maxParseValues ? parseInt(e.maxParseValues) : 4096, this.maxParseChars = "number" == typeof e.maxParseChars ? parseInt(e.maxParseChars) : 32768, this.emptyValue = void 0 === e.emptyValue ? {} : e.emptyValue, this.nullValue = void 0 === e.nullValue ? null : e.nullValue;
        }
        parseLiteral(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, s = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], i = arguments.length > 4 ? arguments[4] : void 0;
            void 0 !== e && (e = String(e)), void 0 === r && (r = e.length);
            return H(e, t, r, G(i)).parseLiteral(s);
        }
        static parse(e, t, r, s) {
            return X(e, t, r, s, void 0);
        }
        parse(e, t, r, s) {
            return X(e, t, r, s, this);
        }
        static stringify(e, t) {
            if (void 0 !== e) return t = new m(Z(t)), null === e ? q(t) : e.toJsonURLText(t, 0);
        }
    };
});




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $kBtCg = parcelRequire("kBtCg");
var $iAtns = parcelRequire("iAtns");

var $lzNIT = parcelRequire("lzNIT");

var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03mUs = parcelRequire("03mUs");
var $6ami2 = parcelRequire("6ami2");
var $6MV2p = parcelRequire("6MV2p");
var $6Q1H5 = parcelRequire("6Q1H5");
var $9Lykx = parcelRequire("9Lykx");
var $6el2W = parcelRequire("6el2W");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");
var $14H9o = parcelRequire("14H9o");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e52aad574cac22d0$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 14H6l-2 2V4h16z"
}), 'ChatBubbleOutline');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bae8d0b4be16a32a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $84ff3cdf55cb53c7$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), 'Fullscreen');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $cf6866e33a4a25da$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');



var $ifEev = parcelRequire("ifEev");
function $ea6dd3b260bbbc5f$export$4adf5fb5a97d310e({ caption: caption, sx: sx }) {
    let captionText = caption;
    let keywords = [];
    if (caption) {
        const match = caption.match(/^caption:\s*(.*?)\s*keywords:\s*(.*)$/);
        if (match) {
            captionText = match[1];
            keywords = match[2].split(',').map((k)=>k.trim()).filter(Boolean);
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                variant: "body2",
                sx: {
                    whiteSpace: 'pre-line',
                    mb: 1
                },
                children: captionText
            }),
            keywords.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1
                },
                children: keywords.map((kw, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                        label: kw,
                        size: "small",
                        color: "primary"
                    }, idx))
            })
        ]
    });
}
function $ea6dd3b260bbbc5f$export$1b862fb5467a3d94({ obj: obj }) {
    const theme = (0, $14H9o.default)();
    const [showCaption, setShowCaption] = (0, $acw62.useState)(false);
    const [captionAnchor, setCaptionAnchor] = (0, $acw62.useState)(null);
    const [showDetails, setShowDetails] = (0, $acw62.useState)(false);
    const imageContainerRef = (0, $acw62.useState)(null);
    const [fullscreen, setFullscreen] = (0, $acw62.useState)(false);
    const handleDownload = ()=>{
        window.open(obj.link, '_blank', 'noopener,noreferrer');
    };
    // For alt text, parse caption only
    let altText = obj.caption || 'image';
    if (obj.caption) {
        const match = obj.caption.match(/^caption:\s*(.*?)\s*keywords:/);
        if (match) altText = match[1];
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
        ref: (el)=>imageContainerRef[1](el),
        sx: {
            width: {
                xs: 250,
                sm: 300,
                md: 350
            },
            height: {
                xs: 250,
                sm: 300,
                md: 350
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            background: theme.palette.background.paper,
            overflow: 'hidden',
            position: 'relative',
            '&:hover .image-actions': {
                opacity: 1
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: obj.link,
                alt: altText,
                style: {
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    display: 'block',
                    margin: 'auto'
                },
                onClick: ()=>setFullscreen(true)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                className: "image-actions",
                sx: {
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    opacity: 0,
                    transition: 'opacity 0.2s',
                    background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.7)',
                    borderRadius: 2,
                    padding: '4px 12px',
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Download image",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            size: "small",
                            onClick: handleDownload,
                            sx: {
                                color: '#fff'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {
                                fontSize: "small"
                            })
                        })
                    }),
                    obj.caption && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Show caption",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            size: "small",
                            onClick: ()=>{
                                setCaptionAnchor(imageContainerRef[0]);
                                setShowCaption(true);
                            },
                            sx: {
                                color: '#fff'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e52aad574cac22d0$export$2e2bcd8739ae039), {
                                fontSize: "small",
                                sx: {
                                    color: '#fff'
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Full screen",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            size: "small",
                            onClick: ()=>setFullscreen(true),
                            sx: {
                                color: '#fff'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $84ff3cdf55cb53c7$export$2e2bcd8739ae039), {
                                fontSize: "small"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Show all details",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            size: "small",
                            onClick: ()=>{
                                setShowDetails(true);
                            },
                            sx: {
                                color: '#fff'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                open: showCaption,
                anchorEl: captionAnchor,
                onClose: ()=>setShowCaption(false),
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                PaperProps: {
                    sx: {
                        p: 2,
                        minWidth: {
                            xs: 220,
                            sm: 340,
                            md: 400
                        },
                        maxWidth: 800
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ea6dd3b260bbbc5f$export$4adf5fb5a97d310e, {
                    caption: obj.caption
                })
            }),
            showDetails && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ifEev.default), {
                title: "Image Details",
                fullScreen: false,
                cancelBtn: false,
                confirmBtnText: "Close",
                onClose: ()=>setShowDetails(false),
                onConfirm: ()=>setShowDetails(false),
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                    sx: {
                        p: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'center',
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: obj.link,
                                alt: obj.caption || 'image',
                                style: {
                                    maxWidth: '100%',
                                    maxHeight: 300,
                                    borderRadius: 8,
                                    boxShadow: theme.palette.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.5)' : '0 2px 8px rgba(0,0,0,0.13)'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                            component: "ul",
                            sx: {
                                listStyle: 'none',
                                p: 0,
                                m: 0
                            },
                            children: Object.entries(obj).map(([key, value])=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    component: "li",
                                    sx: {
                                        mb: 1,
                                        display: 'flex',
                                        gap: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "subtitle2",
                                            sx: {
                                                minWidth: 120,
                                                color: 'text.secondary'
                                            },
                                            children: key
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                            variant: "body2",
                                            sx: {
                                                wordBreak: 'break-word'
                                            },
                                            children: String(value)
                                        })
                                    ]
                                }, key))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6MV2p.default), {
                open: fullscreen,
                onClose: ()=>setFullscreen(false),
                maxWidth: "lg",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6Q1H5.default), {
                    sx: {
                        p: 0
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: obj.link,
                        alt: altText,
                        style: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain'
                        }
                    })
                })
            })
        ]
    });
}



var $6ami2 = parcelRequire("6ami2");
/**
 * Converts yyyymmdd_hhmmss to Datetime string
 */ function $901f192e8722955f$export$9fc5011a778dc2d8(timestamp) {
    const year = parseInt(timestamp.slice(0, 4));
    const month = parseInt(timestamp.slice(4, 6)) - 1 // Months are zero-indexed
    ;
    const day = parseInt(timestamp.slice(6, 8));
    const hour = parseInt(timestamp.slice(9, 11));
    const minute = parseInt(timestamp.slice(11, 13));
    const second = parseInt(timestamp.slice(13, 15));
    const date = new Date(Date.UTC(year, month, day, hour, minute, second));
    return date.toISOString().replace('T', ' ');
}
function $901f192e8722955f$export$75f4285cc853e8c7(filename) {
    // Remove file extension
    const nameWithoutExt = filename.replace('.jpg', '');
    // Extract datetime (always last two parts: YYYYMMDD_HHMMSS)
    const parts = nameWithoutExt.split('_');
    const datetime = parts.slice(-2).join('_');
    // Check for v4 format (starts with 'scan_')
    if (filename.startsWith('scan_')) {
        const isDebug = parts.includes('debug');
        const pan = Number(parts[1]);
        const tilt = Number(parts[2]);
        const zoom = Number(parts[3]);
        if (isDebug) // scan_015_000_01_debug_20251213_235133.jpg
        return {
            pan: pan,
            tilt: tilt,
            zoom: zoom,
            datetime: datetime,
            isDebug: true,
            version: 'v4'
        };
        else {
            // scan_000_000_01_window_conf0.98_20251213_235020.jpg
            const confidencePart = parts.find((p)=>p.startsWith('conf'));
            const confidence = confidencePart?.replace('conf', '');
            const confIndex = parts.indexOf(confidencePart);
            const label = parts.slice(4, confIndex).join('_');
            return {
                pan: pan,
                tilt: tilt,
                zoom: zoom,
                label: label,
                confidence: confidence,
                datetime: datetime,
                isDebug: false,
                version: 'v4'
            };
        }
    }
    // Check for v3 debug format (starts with 'debug_')
    if (filename.startsWith('debug_')) {
        // debug_135_0_1_20251122_204023.jpg
        const [, pan, tilt, zoom] = parts;
        return {
            pan: Number(pan),
            tilt: Number(tilt),
            zoom: Number(zoom),
            datetime: datetime,
            isDebug: true,
            version: 'v3'
        };
    }
    // Check if first part is numeric (v2 or v3 non-debug)
    const firstPartIsNumeric = /^\d+$/.test(parts[0]);
    if (firstPartIsNumeric) {
        // v2 or v3: 294_15_4_support_hose_conf0.99_20251119_214038.jpg
        const [pan, tilt, zoom] = parts;
        const confidencePart = parts.find((p)=>p.startsWith('conf'));
        const confidence = confidencePart?.replace('conf', '');
        const confIndex = parts.indexOf(confidencePart);
        const label = parts.slice(3, confIndex).join('_');
        return {
            pan: Number(pan),
            tilt: Number(tilt),
            zoom: Number(zoom),
            label: label,
            confidence: confidence,
            datetime: datetime,
            isDebug: false,
            version: confIndex > 3 ? 'v2' : 'v3'
        };
    }
    // v1: traffic_light_conf0.35_20250309_115225.jpg
    const confidencePart = parts.find((p)=>p.startsWith('conf'));
    const confidence = confidencePart?.replace('conf', '');
    const confIndex = parts.indexOf(confidencePart);
    const label = parts.slice(0, confIndex).join('_');
    return {
        label: label,
        confidence: confidence,
        datetime: datetime,
        isDebug: false,
        version: 'v1'
    };
}


function $f5deace1eda9c393$var$groupByDebugSets(records) {
    const items = records.sort((a, b)=>{
        const t1 = (0, $901f192e8722955f$export$75f4285cc853e8c7)(a.meta.filename).datetime;
        const t2 = (0, $901f192e8722955f$export$75f4285cc853e8c7)(b.meta.filename).datetime;
        return (0, $901f192e8722955f$export$9fc5011a778dc2d8)(t1) > (0, $901f192e8722955f$export$9fc5011a778dc2d8)(t2) ? 1 : -1;
    });
    const groups = [];
    let group = [];
    items?.forEach((record)=>{
        const { meta: meta } = record;
        const { filename: filename } = meta;
        const parsed = (0, $901f192e8722955f$export$75f4285cc853e8c7)(filename);
        if (parsed.isDebug) {
            groups.push(group);
            group = [];
            group.push(record);
        } else group.push(record);
    });
    return groups;
}
function $f5deace1eda9c393$var$renderRecord(record, i) {
    const { meta: meta, timestamp: timestamp } = record;
    const { filename: filename, model: model } = meta;
    const { pan: pan, tilt: tilt, zoom: zoom, label: label, confidence: confidence, datetime: datetime, isDebug: isDebug } = (0, $901f192e8722955f$export$75f4285cc853e8c7)(filename);
    const imageTimestamp = (0, $901f192e8722955f$export$9fc5011a778dc2d8)(datetime);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            marginRight: 25,
            marginBottom: 25
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: isDebug ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: "Debug"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: `(${pan}\xb0, ${tilt}\xb0, ${zoom}x)`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    children: "\xa0"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: `${label.replace('_', ' ')}`,
                                    color: "primary",
                                    variant: "filled"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: `(${pan}\xb0, ${tilt}\xb0, ${zoom}x)`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    style: {
                                        marginLeft: 8
                                    },
                                    children: confidence && `${confidence} confidence`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                    className: "muted",
                                    children: model
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea6dd3b260bbbc5f$export$1b862fb5467a3d94), {
                obj: {
                    ...record,
                    link: record.value
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                        className: "muted",
                        children: new Date(timestamp).toLocaleString()
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                        children: new Date(imageTimestamp).toLocaleString()
                    })
                ]
            })
        ]
    }, i);
}
function $f5deace1eda9c393$var$renderGroup(group) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex",
        children: group.map((record, i)=>$f5deace1eda9c393$var$renderRecord(record, i))
    });
}
function $f5deace1eda9c393$export$2e2bcd8739ae039(props) {
    const { data: data, searchString: searchString } = props;
    const groups = $f5deace1eda9c393$var$groupByDebugSets(data);
    if (searchString) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex flex-wrap",
        children: data.map((record, i)=>$f5deace1eda9c393$var$renderRecord(record, i))
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: groups?.map((records, i)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: $f5deace1eda9c393$var$renderGroup(records)
            }, i);
        })
    });
}
function $f5deace1eda9c393$export$3155084617646459(data, searchQuery) {
    const newData = data.filter((record)=>{
        const { meta: meta } = record;
        const { filename: filename } = meta;
        const parsed = (0, $901f192e8722955f$export$75f4285cc853e8c7)(filename);
        return searchQuery.split('|').some((part)=>{
            if (!part.trim().length) return false;
            return parsed.label?.toLowerCase().includes(part.trim().toLowerCase());
        });
    });
    return newData;
}



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e1a958fa419a6ec4$export$2e2bcd8739ae039 = (0, $bbT5Q.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M7 12h2v5H7zm8-5h2v10h-2zm-4 7h2v3h-2zm0-4h2v2h-2z"
    }, "1")
], 'AnalyticsOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $49ccc6ea6bc4b0e2$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $47981a41b7df11ee$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 2v3H5V5zm0 5v4H5v-4zM5 19v-3h14v3z"
}), 'TableRowsOutlined');



var $MZbrQ = parcelRequire("MZbrQ");

function $d5913a3346e5707a$export$2e2bcd8739ae039(props) {
    const { data: data, showViewer: showViewer, onViewModeChange: onViewModeChange } = props;
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const [page, setPage] = (0, $acw62.useState)(0);
    // Initialize query from URL params
    const viewerParamsStr = params.get('viewer-params');
    const initialQuery = viewerParamsStr ? (0, (/*@__PURE__*/$parcel$interopDefault($df7c2ed07b6a9ba8$exports))).parse(viewerParamsStr)?.query || '' : '';
    const [query, setQuery] = (0, $acw62.useState)(initialQuery);
    const [debouncedQuery, setDebouncedQuery] = (0, $acw62.useState)(initialQuery);
    const [filteredData, setFilteredData] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setFilteredData(data);
    }, [
        data
    ]);
    const debouncedSearch = (0, $MZbrQ.default)(()=>{
        setDebouncedQuery(query);
    });
    (0, $acw62.useEffect)(()=>{
        debouncedSearch();
    }, [
        debouncedSearch,
        query
    ]);
    // Update URL params when query changes
    (0, $acw62.useEffect)(()=>{
        if (query) {
            const viewerParams = (0, (/*@__PURE__*/$parcel$interopDefault($df7c2ed07b6a9ba8$exports))).stringify({
                query: query
            });
            setParams((prev)=>{
                const newParams = new URLSearchParams(prev);
                newParams.set('viewer-params', viewerParams);
                return newParams;
            });
        } else setParams((prev)=>{
            const newParams = new URLSearchParams(prev);
            newParams.delete('viewer-params');
            return newParams;
        });
    }, [
        query
    ]);
    (0, $acw62.useEffect)(()=>{
        if (debouncedQuery.trim().length === 0) {
            setFilteredData(data);
            return;
        }
        handleSearch();
    }, [
        debouncedQuery
    ]);
    const handleSearch = ()=>{
        let newData;
        if (0, $f5deace1eda9c393$export$3155084617646459) {
            console.log('using advanced search', debouncedQuery);
            newData = (0, $f5deace1eda9c393$export$3155084617646459)(data, debouncedQuery);
        } else // basic search on filenames
        newData = data.filter((record)=>{
            const { meta: meta } = record;
            const { filename: filename } = meta;
            // Check if label matches search query (case-insensitive)
            return filename.toLowerCase().includes(debouncedQuery.toLowerCase());
        });
        setFilteredData(newData);
        setPage(0);
    };
    const handlePageChange = (event, value)=>{
        setPage(value);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex gap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "show-viewer",
                                        selected: showViewer,
                                        onChange: ()=>onViewModeChange(true),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e1a958fa419a6ec4$export$2e2bcd8739ae039), {}),
                                            "Custom Viewer"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "show-table",
                                        selected: !showViewer,
                                        onChange: ()=>onViewModeChange(false),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47981a41b7df11ee$export$2e2bcd8739ae039), {}),
                                            " Table"
                                        ]
                                    })
                                ]
                            }),
                            showViewer && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                label: "Search for label",
                                variant: "outlined",
                                sx: {
                                    width: 300
                                },
                                value: query,
                                onChange: (e)=>setQuery(e.target.value),
                                placeholder: "Filter groups by label...",
                                InputProps: {
                                    endAdornment: query && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                            onClick: ()=>setQuery(''),
                                            edge: "end",
                                            size: "small",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $49ccc6ea6bc4b0e2$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                }
                            })
                        ]
                    }),
                    showViewer && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kBtCg.default), {
                        rowsPerPageOptions: [
                            20
                        ],
                        count: filteredData?.length,
                        rowsPerPage: 20,
                        page: page,
                        onPageChange: handlePageChange
                    })
                ]
            }),
            showViewer && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5deace1eda9c393$export$2e2bcd8739ae039), {
                data: filteredData.slice(page * 20, (page + 1) * 20),
                searchString: query
            }),
            showViewer && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kBtCg.default), {
                        rowsPerPageOptions: [
                            20
                        ],
                        count: filteredData?.length,
                        rowsPerPage: 20,
                        page: page,
                        onPageChange: handlePageChange
                    })
                ]
            })
        ]
    });
}


const $2c916c2a79797e4e$var$registry = (0, $gZwVy.default).dockerRegistry;
// default app for initial view of data
const $2c916c2a79797e4e$var$defaultPlugin = '.*plugin-iio.*';
const $2c916c2a79797e4e$var$exts = {
    image: [
        '.jpg',
        '.jpeg',
        '.png',
        '.gif'
    ],
    audio: [
        '.flac'
    ],
    video: [
        '.mp4'
    ]
};
const $2c916c2a79797e4e$var$columns = [
    {
        id: 'vsn',
        label: 'Node',
        format: (0, $eOilY.vsn)
    },
    {
        id: 'timestamp',
        label: 'Time'
    },
    {
        id: 'name',
        label: 'Name',
        format: (name)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/data/ontology/${name}`,
                children: name
            })
    },
    {
        id: 'value',
        label: 'Value',
        format: (val, { meta: meta })=>{
            const isInOSN = /^https:\/\/storage.sagecontinuum.org/i.test(val);
            if (!isInOSN) return `${val} ${(0, $854549d671bc593b$export$5aa079670cd594b5)[meta.units] || meta.units || ''}`;
            const suffix = val.slice(val.lastIndexOf('.'));
            if ($2c916c2a79797e4e$var$exts.image.includes(suffix)) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: val,
                        style: {
                            maxWidth: '760px'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {}),
                            href: val,
                            children: val.split('/').pop()
                        })
                    })
                ]
            });
            else if (val.includes('.flac')) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d58c41d80e376ef6$export$2e2bcd8739ae039), {
                        dataURL: val
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {}),
                            href: val,
                            children: val.split('/').pop()
                        })
                    })
                ]
            });
            else if ($2c916c2a79797e4e$var$exts.video.includes(suffix)) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex column",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hBKHw))), {}),
                        href: val,
                        children: val.split('/').pop()
                    })
                })
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: val,
                children: val.split('/').pop()
            });
        }
    },
    {
        id: 'sensor',
        label: 'Sensor'
    },
    {
        id: 'deviceName',
        label: 'Device'
    },
    /* {
  id: 'job',
  label: 'Job',
},*/ {
        id: 'meta',
        label: 'Meta',
        format: (o)=>Object.keys(o).map((k)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: k
                        }),
                        ": ",
                        o[k]
                    ]
                }, `meta-${k}`);
            }),
        hide: true
    }
];
const $2c916c2a79797e4e$var$findColumn = (cols, name)=>cols.findIndex((o)=>o.id == name);
const $2c916c2a79797e4e$var$getUniqueOpts = (data)=>data.sort().filter((v, i, self)=>v && self.indexOf(v) == i).map((v)=>({
            id: v,
            label: v
        }));
const $2c916c2a79797e4e$var$getUniqueNodeOpts = (data, siteIDs)=>data.sort().filter((v, i, self)=>v && self.indexOf(v) == i).map((v)=>({
            id: v,
            label: (0, $eOilY.vsnToDisplayStr)(v, siteIDs[v])
        }));
const $2c916c2a79797e4e$var$sortApps = (apps)=>{
    const ecrApps = apps.filter((str)=>!/\d+\.\d+\.\d+\.\d+:\d+/.test(str));
    const localApps = apps.filter((str)=>/\d+\.\d+\.\d+\.\d+:\d+/.test(str));
    const sortedApps = [
        ...ecrApps.sort(),
        ...localApps.sort()
    ];
    return sortedApps;
};
const $2c916c2a79797e4e$var$getUniqueAppOpts = (data)=>$2c916c2a79797e4e$var$sortApps(data.filter((v, i, self)=>v && self.indexOf(v) == i)).filter((name)=>!name.includes('registry.gitlab.com')).map((v)=>{
        const path = v.replace(`${$2c916c2a79797e4e$var$registry}`, '');
        const label = path.slice(path.lastIndexOf('/') + 1);
        return {
            id: v,
            label: label
        };
    });
const $2c916c2a79797e4e$var$getCurlCmd = (query)=>`curl ${$bcnr1.url}/query -d '${JSON.stringify(query)}'`;
const $2c916c2a79797e4e$var$indent = 4;
const $2c916c2a79797e4e$var$pad = ' '.repeat($2c916c2a79797e4e$var$indent);
const $2c916c2a79797e4e$var$getArgsStr = (obj)=>Object.entries(obj).map(([k, v])=>`${k}="${v}"`).join(',\n' + $2c916c2a79797e4e$var$pad) + ', ';
const $2c916c2a79797e4e$var$getPythonSnippet = (query)=>{
    const { filter: filter = {}, ...rest } = query || {};
    const params = `\n${$2c916c2a79797e4e$var$pad}${$2c916c2a79797e4e$var$getArgsStr(rest)}`;
    const filterParams = JSON.stringify(filter, null, $2c916c2a79797e4e$var$indent).replace(/(.+):/g, $2c916c2a79797e4e$var$pad + '$1:');
    const str = `${params}\n` + `${$2c916c2a79797e4e$var$pad}filter={${filterParams.slice(1, -1)}${$2c916c2a79797e4e$var$pad}}`;
    return `import sage_data_client\n\n` + `df = sage_data_client.query(${str}\n)`;
};
function $2c916c2a79797e4e$var$getAppMenus() {
    return $bcnr1.getPluginCounts({
        start: `-90d`,
        tail: 1
    }).then((data)=>$2c916c2a79797e4e$var$getUniqueAppOpts(data.map((o)=>o.meta.plugin)));
}
async function $2c916c2a79797e4e$var$getFilterMenus({ plugin: plugin, task: task, name: name }, siteIDs) {
    const data = await $bcnr1.getData({
        start: `-1d`,
        tail: 1,
        filter: {
            ...plugin ? {
                plugin: plugin
            } : {},
            ...task ? {
                task: task
            } : {},
            ...name ? {
                name: name
            } : {}
        }
    });
    return {
        nodes: $2c916c2a79797e4e$var$getUniqueNodeOpts(data.map((o)=>o.meta.vsn), siteIDs),
        names: $2c916c2a79797e4e$var$getUniqueOpts(data.map((o)=>o.name)),
        sensors: $2c916c2a79797e4e$var$getUniqueOpts(data.map((o)=>o.meta.sensor)),
        deviceNames: $2c916c2a79797e4e$var$getUniqueOpts(data.map((o)=>o.meta.deviceName)),
        ...plugin ? {} : {
            tasks: $2c916c2a79797e4e$var$getUniqueOpts(data.map((o)=>o.meta.task))
        }
    };
}
const $2c916c2a79797e4e$var$getStartTime = (start)=>{
    if ($2c916c2a79797e4e$var$isDateStr(start)) return new Date(start);
    const amount = Number(start.slice(0, -1)) || 1;
    const unit = start.charAt(start.length - 1);
    const datetime = new Date();
    if (unit == 'm') datetime.setMinutes(datetime.getMinutes() + amount);
    else if (unit == 'h') datetime.setHours(datetime.getHours() + amount);
    else if (unit == 'd') datetime.setDate(datetime.getDate() + amount);
    else if (unit == 'y') datetime.setFullYear(datetime.getFullYear() + amount);
    else {
        alert(`getStartTime: start time not valid.  was start=${start}`);
        return;
    }
    return new Date(datetime);
};
const $2c916c2a79797e4e$var$getEndTime = (start, end)=>{
    if ($2c916c2a79797e4e$var$isDateStr(end)) return new Date(end);
    else if (!end) return new Date();
    const amount = Number(end.slice(0, -1)) || 1;
    const unit = end.charAt(end.length - 1);
    const startTime = new Date(start);
    const endTime = new Date(start);
    if (unit == 'm') endTime.setMinutes(startTime.getMinutes() + amount);
    else if (unit == 'h') endTime.setHours(startTime.getHours() + amount);
    else if (unit == 'd') endTime.setDate(startTime.getDate() + amount);
    else if (unit == 'y') endTime.setFullYear(startTime.getFullYear() + amount);
    else {
        alert(`getEndTime: end time not valid.  was end=${end}`);
        return;
    }
    return new Date(endTime);
};
const $2c916c2a79797e4e$var$isMedia = (type)=>[
        'images',
        'audio'
    ].includes(type);
const $2c916c2a79797e4e$var$isMediaApp = (app)=>/image|audio|video|mobotix|ptzapp-yolo/g.test(app || '');
const $2c916c2a79797e4e$var$isAudioApp = (app)=>/audio/g.test(app || '');
const $2c916c2a79797e4e$var$getRowsPerPage = (app, type)=>{
    if ($2c916c2a79797e4e$var$isAudioApp(app)) return 10;
    else if ($2c916c2a79797e4e$var$isMediaApp(app) || $2c916c2a79797e4e$var$isMedia(type)) return 20;
    else return 100;
};
const $2c916c2a79797e4e$var$isDateStr = (str)=>!!Date.parse(str);
const $2c916c2a79797e4e$var$initMenuState = {
    apps: [],
    tasks: [],
    nodes: [],
    names: [],
    sensors: [],
    deviceNames: []
};
const $2c916c2a79797e4e$var$initFilterState = {
    apps: [
        $2c916c2a79797e4e$var$defaultPlugin
    ],
    tasks: [],
    nodes: [],
    names: [],
    sensors: [],
    deviceNames: []
};
const $2c916c2a79797e4e$var$facetInputs = {
    'apps': [
        'apps',
        'nodes',
        'names',
        'sensors'
    ],
    'names': [
        'names',
        'nodes',
        'sensors',
        'deviceNames'
    ],
    'images': [
        'tasks',
        'nodes'
    ],
    'audio': [
        'tasks',
        'nodes'
    ]
};
const $2c916c2a79797e4e$var$allowMultiSelect = (field)=>[
        'nodes',
        'names',
        'tasks',
        'sensors',
        'deviceNames'
    ].includes(field);
function $2c916c2a79797e4e$export$26893885d9a03bc4(params, includeDefaultApp = true) {
    const init = includeDefaultApp ? {
        ...$2c916c2a79797e4e$var$initFilterState
    } : {
        ...$2c916c2a79797e4e$var$initFilterState,
        apps: []
    };
    for (const [key, val] of params){
        if ([
            'start',
            'page'
        ].includes(key)) continue;
        init[key] = val.split('|');
    }
    return init;
}
const $2c916c2a79797e4e$var$parseOpts = (str)=>(0, (/*@__PURE__*/$parcel$interopDefault($df7c2ed07b6a9ba8$exports))).parse(str);
const $2c916c2a79797e4e$var$encodeOpts = (obj)=>(0, (/*@__PURE__*/$parcel$interopDefault($df7c2ed07b6a9ba8$exports))).stringify(obj);
const $2c916c2a79797e4e$var$defaultChartConfig = {
    type: 'timeseries',
    showLines: true,
    showPoints: false
};
function $2c916c2a79797e4e$var$parseClientSideFilterParams(paramStr) {
    let rules;
    try {
        rules = paramStr ? $2c916c2a79797e4e$var$parseOpts(paramStr) : [];
    } catch (error) {
        alert(`
      Could not parse the "client-side-filters" params.
      Error: ${error}
      Using an empty list instead`);
        rules = [];
    }
    return rules;
}
function $2c916c2a79797e4e$var$parseChartParams(paramStr) {
    let chartOpts;
    try {
        chartOpts = paramStr ? $2c916c2a79797e4e$var$parseOpts(paramStr) : $2c916c2a79797e4e$var$defaultChartConfig;
    } catch  {
        alert('Could not parse the "chart" params.  Using an default chart settings.');
        chartOpts = $2c916c2a79797e4e$var$defaultChartConfig;
    }
    return chartOpts;
}
function $2c916c2a79797e4e$export$2e2bcd8739ae039() {
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const app = params.get('apps');
    const name = params.get('names');
    const node = params.get('nodes');
    const sensor = params.get('sensors');
    const deviceName = params.get('deviceNames') // for lorawan
    ;
    const task = params.get('tasks');
    const type = params.get('type') || 'apps' // for tabs
    ;
    const mimeType = $2c916c2a79797e4e$var$isMedia(type) ? params.get('mimeType') : null // for filtering on ext
    ;
    const cFilters = params.get('client-side-filters');
    const rules = (0, $acw62.useMemo)(()=>$2c916c2a79797e4e$var$parseClientSideFilterParams(cFilters), [
        cFilters
    ]);
    const chartConfig = params.get('chart') // chart config string
    ;
    const chartOpts = (0, $acw62.useMemo)(()=>$2c916c2a79797e4e$var$parseChartParams(chartConfig), [
        chartConfig
    ]);
    const start = params.get('start') || '-30m';
    const end = params.get('end');
    const page = Number(params.get('page')) || 0;
    // update the UI if dates are changed, but not times
    const [timeIsFocused, setTimeIsFocused] = (0, $acw62.useState)();
    const [pendingRange, setPendingRange] = (0, $acw62.useState)();
    const [queryCount, setQueryCount] = (0, $acw62.useState)(0);
    const [prevQuery] = (0, $acw62.useState)(params);
    const [hasViewer, setHasViewer] = (0, $acw62.useState)(false);
    const [showCustomViewer, setShowCustomViewer] = (0, $acw62.useState)(false);
    // only update the range when start, end, or 'refresh' is pressed
    const range = (0, $acw62.useMemo)(()=>[
            $2c916c2a79797e4e$var$getStartTime(start),
            $2c916c2a79797e4e$var$getEndTime(start, end)
        ], [
        start,
        end,
        queryCount
    ]);
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [cols, setCols] = (0, $acw62.useState)($2c916c2a79797e4e$var$columns);
    const [checked, setChecked] = (0, $acw62.useState)({
        relativeTime: true,
        showMeta: false
    });
    const [query, setQuery] = (0, $acw62.useState)();
    const [data, setData] = (0, $acw62.useState)();
    const [filtered, setFiltered] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)();
    const [lastN, setLastN] = (0, $acw62.useState)();
    const [chart, setChart] = (0, $acw62.useState)();
    const [siteIDs, setSiteIDs] = (0, $acw62.useState)();
    // contents of dropdowns
    const [menus, setMenus] = (0, $acw62.useState)($2c916c2a79797e4e$var$initMenuState);
    // selected filters
    const [filters, setFilters] = (0, $acw62.useState)($2c916c2a79797e4e$var$initFilterState);
    // update selected filters whenever url param changes and set page to 0
    (0, $acw62.useEffect)(()=>{
        const includeDefaultApp = [
            'apps'
        ].includes(type);
        const filterState = $2c916c2a79797e4e$export$26893885d9a03bc4(params, includeDefaultApp);
        setFilters(filterState);
        handlePage(0);
    }, [
        app,
        name,
        node,
        sensor,
        deviceName,
        task,
        type,
        mimeType
    ]);
    // update filter menus whenever app or task changes
    (0, $acw62.useEffect)(()=>{
        if (!siteIDs || !app && !task) return;
        $2c916c2a79797e4e$var$getFilterMenus({
            plugin: app,
            task: task,
            name: null
        }, siteIDs).then((menuItems)=>{
            setMenus((prev)=>({
                    ...prev,
                    ...menuItems
                }));
        }).catch((error)=>setError(error.message));
    }, [
        app,
        task,
        siteIDs
    ]);
    // show/hide sensor column if needed
    (0, $acw62.useEffect)(()=>{
        if (menus.sensors.length) setCols((prev)=>{
            const idx = $2c916c2a79797e4e$var$findColumn(prev, 'sensor');
            prev[idx] = {
                ...prev[idx],
                hide: false
            };
            return prev.slice(0);
        });
        else setCols((prev)=>{
            const idx = $2c916c2a79797e4e$var$findColumn(prev, 'sensor');
            prev[idx] = {
                ...prev[idx],
                hide: true
            };
            return prev.slice(0);
        });
    }, [
        menus.sensors
    ]);
    // show/hide deviceName column if needed
    (0, $acw62.useEffect)(()=>{
        if (menus.deviceNames.length) setCols((prev)=>{
            const idx = $2c916c2a79797e4e$var$findColumn(prev, 'deviceName');
            prev[idx] = {
                ...prev[idx],
                hide: false
            };
            return prev.slice(0);
        });
        else setCols((prev)=>{
            const idx = $2c916c2a79797e4e$var$findColumn(prev, 'deviceName');
            prev[idx] = {
                ...prev[idx],
                hide: true
            };
            return prev.slice(0);
        });
    }, [
        menus.deviceNames
    ]);
    // initial loading of everything
    (0, $acw62.useEffect)(()=>{
        const plugin = app || (type == 'apps' ? $2c916c2a79797e4e$var$defaultPlugin : null);
        function fetchAppMenu() {
            $2c916c2a79797e4e$var$getAppMenus().then((data)=>{
                setMenus((prev)=>({
                        ...prev,
                        apps: data
                    }));
            }).catch((error)=>setError(error.message));
        }
        function fetchFilterMenus() {
            if (!plugin && !task && !name) // don't bother fetching filter menus if there's no filter at all
            return;
            $9bsRS.getSiteIDs().then((siteIDs)=>{
                setSiteIDs(siteIDs);
                $2c916c2a79797e4e$var$getFilterMenus({
                    plugin: plugin,
                    task: task,
                    name: name
                }, siteIDs).then((menuItems)=>{
                    setMenus((prev)=>({
                            ...prev,
                            ...menuItems
                        }));
                }).catch((error)=>setError(error.message));
            });
        }
        function fetchData() {
            const query = {
                ...start ? {
                    start: start
                } : {},
                ...end ? {
                    end: end
                } : {},
                filter: {
                    ...plugin ? {
                        plugin: plugin
                    } : {},
                    ...node ? {
                        vsn: node
                    } : {},
                    ...name ? {
                        name: name
                    } : {},
                    ...sensor ? {
                        sensor: sensor
                    } : {},
                    ...task ? {
                        task: task
                    } : {},
                    ...deviceName ? {
                        deviceName: deviceName
                    } : {}
                }
            };
            setQuery(query);
            // cancel old requests
            $bcnr1.abort();
            setLoading(true);
            $bcnr1.getData(query, true).then((data)=>{
                data = data || [];
                // filter image/audio further based on extension if needed
                if (task && mimeType) data = data.filter((o)=>{
                    const val = o.value;
                    const ext = val.slice(val.lastIndexOf('.'));
                    return $2c916c2a79797e4e$var$exts[mimeType].includes(ext);
                });
                // flatten data, and sort
                data = data.map((o)=>({
                        ...o,
                        ...o.meta
                    })).sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
                setData(data);
                updateFilteredData(data, rules);
                // controlle whether to show custom viewer
                const hasViewer = app?.includes('ptzapp-yolo');
                setHasViewer(hasViewer);
                setShowCustomViewer(hasViewer);
                setLoading(false);
            }).catch((error)=>{
                if (error.name == 'AbortError') return;
                setError(error.message);
                setLoading(false);
            });
        }
        // fetch everything
        fetchAppMenu();
        fetchData();
        fetchFilterMenus();
    }, [
        app,
        node,
        name,
        sensor,
        task,
        deviceName,
        type,
        mimeType,
        start,
        end,
        queryCount,
        setLoading // ignore "rules" since done on client side
    ]);
    const updateFilteredData = (data, rules)=>{
        let d = (0, $52fc2129eac6b28c$export$d6ad891437e8c72c)(data, rules);
        // if first 10 values are numerical-ish, then set hasNumericalValues to true
        const hasNumericalValues = d.slice(0, 10).some((o)=>typeof o.value == 'number' || Number.isFinite(Number(o.value)));
        // conditions for showing chart:
        const showChart = hasNumericalValues && d.length > 0;
        setChart(showChart ? d : null);
        // limit amount of data for table
        const total = data.length;
        const limit = 100000;
        if (total > limit) {
            d = d.slice(-limit);
            setLastN({
                total: total,
                limit: limit
            });
        } else setLastN(null);
        setFiltered(d);
    };
    // relative time and show meta checkbox events
    (0, $acw62.useEffect)(()=>{
        setCols((prev)=>{
            let idx;
            if (checked.relativeTime) {
                idx = $2c916c2a79797e4e$var$findColumn(prev, 'timestamp');
                prev[idx] = {
                    ...prev[idx],
                    format: (val)=>(0, $lffEs.relativeTime)(val)
                };
            } else {
                idx = $2c916c2a79797e4e$var$findColumn(prev, 'timestamp');
                prev[idx] = {
                    ...prev[idx],
                    format: (val)=>val
                };
            }
            idx = $2c916c2a79797e4e$var$findColumn(prev, 'meta');
            prev[idx] = {
                ...prev[idx],
                hide: !checked.showMeta
            };
            return prev.slice(0);
        });
    }, [
        checked
    ]);
    const clearParams = ()=>{
        Array.from(params.keys()).forEach((key)=>params.delete(key));
    };
    const handleOptionCheck = (evt, name)=>{
        setChecked((prev)=>({
                ...prev,
                [name]: evt.target.checked
            }));
    };
    const handleMimeCheck = (evt, name)=>{
        if (evt.target.checked) params.set('mimeType', name);
        else params.delete('mimeType');
        setParams(params, {
            replace: true
        });
    };
    const handleFilterChange = (field, val)=>{
        if (!val || Array.isArray(val) && !val.length) params.delete(field);
        else if ($2c916c2a79797e4e$var$allowMultiSelect(field)) {
            // MUI seems to result in vals may be string or option; todo(nc): address this?
            const newStr = val.map((item)=>typeof item == 'string' ? item : item.id).join('|');
            params.set(field, newStr);
        } else params.set(field, val.id);
        setParams(params, {
            replace: true
        });
    };
    const handleQuickRangeChange = (val)=>{
        setPendingRange(null);
        params.delete('end');
        params.set('start', val);
        handlePage(0);
        setParams(params, {
            replace: true
        });
    };
    const handleDatePickerFocus = (evt)=>{
        const { name: name } = evt.target;
        const isTime = [
            'hour12',
            'minute',
            'second',
            'mPM'
        ].includes(name);
        setTimeIsFocused(isTime);
    };
    const handleDatePickerChange = ([start, end])=>{
        if (timeIsFocused) setPendingRange([
            start,
            end
        ]);
        else handleDateUpdate([
            start,
            end
        ]);
    };
    const handleDateUpdate = ([start, end])=>{
        params.set('start', new Date(start).toISOString());
        params.set('end', new Date(end).toISOString());
        setParams(params, {
            replace: true
        });
    };
    const handleRemoveFilters = ()=>{
        clearParams();
        params.set('apps', $2c916c2a79797e4e$var$defaultPlugin);
        setParams(params, {
            replace: true
        });
    };
    const goToTasks = (val, taskQuery)=>{
        clearParams();
        params.set('type', val);
        params.set('tasks', taskQuery);
        params.set('start', '-1h');
        if (val == 'images') params.set('mimeType', 'image');
        setParams(params, {
            replace: true
        });
    };
    const goToNames = (val, nameQuery)=>{
        clearParams();
        params.set('type', val);
        params.set('names', nameQuery);
        params.set('start', '-1h');
        setParams(params, {
            replace: true
        });
    };
    const handleTypeChange = (_, val)=>{
        if (val == 'names') goToNames(val, 'env.temperature');
        else if (val == 'images') goToTasks(val, 'imagesampler-.*');
        else if (val == 'audio') goToTasks(val, 'audio-sampler');
        else handleRemoveFilters();
    };
    const handleQueryViewerChange = (field, next)=>{
        if (!next.length) params.delete(field);
        else params.set(field, next.join('|'));
        setParams(params, {
            replace: true
        });
    };
    const handlePage = (val)=>{
        params.set('page', val);
        setParams(params, {
            replace: true
        });
    };
    const handleRefresh = ()=>{
        if (loading) setParams(prevQuery, {
            replace: true
        });
        else if (pendingRange) {
            handlePage(0);
            handleDateUpdate(pendingRange);
            setPendingRange(null);
        } else setQueryCount((prev)=>prev + 1);
    };
    const handleClientSideFilter = (rules)=>{
        params.set('client-side-filters', $2c916c2a79797e4e$var$encodeOpts(rules));
        setParams(params, {
            replace: true
        });
        updateFilteredData(data, rules);
    };
    const handleClearClientSideFilters = ()=>{
        params.delete('client-side-filters');
        setParams(params, {
            replace: true
        });
        updateFilteredData(data, []);
    };
    const handleChartOptsChange = (val)=>{
        params.set('chart', $2c916c2a79797e4e$var$encodeOpts(val));
        setParams(params);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2c916c2a79797e4e$var$Root, {
        isMedia: $2c916c2a79797e4e$var$isMediaApp(app) || $2c916c2a79797e4e$var$isMedia(type),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Sidebar), {
                    width: "240px",
                    style: {
                        padding: '25px 10px 10px 10px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "shortcuts",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7479184c3cda7f5d$export$2e2bcd8739ae039), {
                                color: "primary",
                                exclusive: true,
                                value: type,
                                onChange: handleTypeChange,
                                "aria-label": "data type",
                                orientation: "vertical",
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "apps",
                                        className: "flex justify-start gap",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($31f660b448822d0e$exports))), {}),
                                            " Apps ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "help-text self-end",
                                                children: "Query by ECR application"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "names",
                                        className: "flex justify-start gap",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d67a953a3d28f14e$exports))), {}),
                                            " Names ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "help-text self-end",
                                                children: "Query by measurement name"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "images",
                                        className: "flex justify-start gap",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d07347710572e4cb$exports))), {}),
                                            " Images ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "help-text self-end",
                                                children: "Query for image samples"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab85d69438d76ec5$export$2e2bcd8739ae039), {
                                        value: "audio",
                                        className: "flex justify-start gap",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($622aa5f35d607588$exports))), {}),
                                            " Audio ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "help-text self-end",
                                                children: "Query for audio samples"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                            children: [
                                (0, $f1q41.capitalize)(type.replace(/s$/, '')),
                                " Filters"
                            ]
                        }),
                        menus && $2c916c2a79797e4e$var$facetInputs[type].map((facet)=>{
                            // if no sensors/deviceNames are associated with the data, don't show sensor input
                            if ([
                                'sensors',
                                'deviceNames'
                            ].includes(facet) && !menus[facet].length) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Fragment), {}, facet);
                            const label = (0, $f1q41.capitalize)(facet);
                            const allowMultiple = $2c916c2a79797e4e$var$allowMultiSelect(facet);
                            let value = allowMultiple ? [] : '';
                            if (allowMultiple && filters[facet]?.length) value = filters[facet];
                            else if (facet == 'apps' && filters[facet]?.length) value = (filters[facet][0] || '').replace(`${$2c916c2a79797e4e$var$registry}/`, '');
                            else if (filters[facet]?.length) value = filters[facet][0];
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($2c916c2a79797e4e$var$Menu, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                    freeSolo: facet !== 'apps',
                                    options: menus[facet],
                                    renderInput: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            ...props,
                                            label: label
                                        }),
                                    PopperComponent: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e76iu.default), {
                                            ...props,
                                            style: {
                                                width: label == 'Apps' ? 350 : 300,
                                                zIndex: 9999
                                            }
                                        }),
                                    value: value,
                                    onChange: (evt, val)=>handleFilterChange(facet, val),
                                    disableCloseOnSelect: allowMultiple,
                                    multiple: allowMultiple,
                                    isOptionEqualToValue: (opt, val)=>val ? opt.id == val : false,
                                    limitTags: 4
                                })
                            }, facet);
                        }),
                        type == 'images' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                checked: mimeType == 'image',
                                onChange: (evt)=>handleMimeCheck(evt, 'image')
                            }),
                            label: ".jpg, .png, etc."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($2c916c2a79797e4e$var$Snippets, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: "API Snippets"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            children: "cURL download"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fdca79f03e679c4$export$39dbc3f558091353), {
                                                theme: (0, $0fdca79f03e679c4$export$d9a33280f07116d9).vsDark,
                                                language: "cmd",
                                                code: $2c916c2a79797e4e$var$getCurlCmd(query),
                                                children: ({ className: className, style: style, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                                        className: className,
                                                        style: {
                                                            ...style,
                                                            fontSize: '.85em'
                                                        },
                                                        children: tokens.map((line, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                ...getLineProps({
                                                                    line: line,
                                                                    key: i
                                                                }),
                                                                children: line.map((token, key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        ...getTokenProps({
                                                                            token: token,
                                                                            key: key
                                                                        })
                                                                    }, key))
                                                            }, i))
                                                    })
                                            }),
                                            tooltip: "Copy curl CMD"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                            children: "Python snippet"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fdca79f03e679c4$export$39dbc3f558091353), {
                                                theme: (0, $0fdca79f03e679c4$export$d9a33280f07116d9).vsDark,
                                                language: "python",
                                                code: $2c916c2a79797e4e$var$getPythonSnippet(query),
                                                children: ({ className: className, style: style, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                                        className: className,
                                                        style: {
                                                            ...style,
                                                            fontSize: '.85em'
                                                        },
                                                        children: tokens.map((line, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                ...getLineProps({
                                                                    line: line,
                                                                    key: i
                                                                }),
                                                                children: line.map((token, key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        ...getTokenProps({
                                                                            token: token,
                                                                            key: key
                                                                        })
                                                                    }, key))
                                                            }, i))
                                                    })
                                            }),
                                            tooltip: "Copy python snippet"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex justify-between text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: "https://pypi.org/project/sage-data-client/",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "install client"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: `${(0, $gZwVy.default).docs}/tutorials/accessing-data`,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "docs"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($2c916c2a79797e4e$var$Main, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-start justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-start query-viewer",
                                    children: [
                                        Object.keys(filters).reduce((acc, k)=>acc + filters[k].length, 0) > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            variant: "outlined",
                                            onClick: handleRemoveFilters,
                                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5861ec10399b0856$exports))), {}),
                                            children: "Clear"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $177e9ab8fdb34313$export$2e2bcd8739ae039), {
                                            filterState: Object.keys(filters).filter((k)=>![
                                                    'start',
                                                    'end',
                                                    'type',
                                                    'client-side-filters'
                                                ].includes(k)).reduce((acc, k)=>({
                                                    ...acc,
                                                    [k]: filters[k].map((s)=>s.replace(`${$2c916c2a79797e4e$var$registry}/`, ''))
                                                }), {}),
                                            onDelete: handleQueryViewerChange,
                                            disableDelete: {
                                                field: 'apps',
                                                filter: $2c916c2a79797e4e$var$defaultPlugin
                                            },
                                            scroll: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bbfb475904626785$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                                            variant: "outlined",
                                            style: {
                                                width: 150
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OEVqP.default), {
                                                    id: "range-label",
                                                    children: "Quick Ranges"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cX7V2.default), {
                                                    labelId: "range-label",
                                                    id: "range",
                                                    value: $2c916c2a79797e4e$var$isDateStr(start) ? 'custom' : start,
                                                    onChange: (evt)=>handleQuickRangeChange(evt.target.value),
                                                    label: "Quick Ranges",
                                                    margin: "dense",
                                                    children: ($2c916c2a79797e4e$var$isDateStr(start) ? Object.keys((0, $lffEs.quickRanges)) : Object.keys((0, $lffEs.quickRanges)).slice(1)).map((k)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                            value: k,
                                                            children: (0, $lffEs.quickRanges)[k]
                                                        }, k))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $55e1f74d050ef4ae$export$2e2bcd8739ae039), {
                                            value: pendingRange || range,
                                            onChange: handleDatePickerChange,
                                            onFocus: handleDatePickerFocus
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: loading ? 'Cancel' : pendingRange ? 'Submit' : 'Refresh',
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                variant: pendingRange ? 'contained' : 'outlined',
                                                color: pendingRange ? 'success' : 'info',
                                                onClick: handleRefresh,
                                                children: loading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {
                                                            size: 25
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0990221504e72a5f$exports))), {
                                                            color: "action"
                                                        })
                                                    ]
                                                }) : pendingRange ? 'Go' : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1afa53983f562acc$exports))), {
                                                    color: "action",
                                                    sx: pendingRange && {
                                                        color: '#f2f2f2'
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        chart && siteIDs && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8c2d9704d1d32119$export$2e2bcd8739ae039), {
                            data: chart,
                            chartOpts: chartOpts,
                            siteIDs: siteIDs,
                            onChange: handleChartOptsChange
                        }),
                        lastN && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                            severity: "info",
                            children: [
                                "There are ",
                                lastN.total.toLocaleString(),
                                " records for this query. Listing the most recent ",
                                lastN.limit.toLocaleString(),
                                " below."
                            ]
                        }),
                        filtered && rules.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                            sx: {
                                width: '70%',
                                margin: '0 auto'
                            },
                            severity: "info",
                            action: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                onClick: handleClearClientSideFilters,
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5861ec10399b0856$exports))), {}),
                                children: "Clear Filters"
                            }),
                            children: [
                                "Data has been filtered from ",
                                data.length.toLocaleString(),
                                " to ",
                                filtered.length.toLocaleString(),
                                ' records (via the "Filter Values" button below)'
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                            children: error
                        }),
                        hasViewer && data && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d5913a3346e5707a$export$2e2bcd8739ae039), {
                                data: data,
                                showViewer: showCustomViewer,
                                onViewModeChange: (val)=>setShowCustomViewer(val)
                            })
                        }),
                        !showCustomViewer && filtered && data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "rowID",
                            enableSorting: true,
                            sort: "-timestamp",
                            columns: cols,
                            rows: filtered,
                            pagination: true,
                            page: page,
                            rowsPerPage: $2c916c2a79797e4e$var$getRowsPerPage(app, type),
                            onPage: handlePage,
                            limit: filtered.length,
                            emptyNotice: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex column items-center gap",
                                children: [
                                    "No recent data found with the selected filters",
                                    type == 'apps' && app && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $16b114de8dc6e3f4$export$2e2bcd8739ae039), {
                                            to: `/apps/app/${app.replace(`${$2c916c2a79797e4e$var$registry}/`, '').split(':')[0]}?tab=data`,
                                            children: [
                                                "View data availability for ",
                                                app.replace(`${$2c916c2a79797e4e$var$registry}/`, '')
                                            ]
                                        })
                                    })
                                ]
                            }),
                            disableRowSelect: ()=>true,
                            enableDownload: true,
                            getDownloadableData: ()=>(0, $52fc2129eac6b28c$export$d6ad891437e8c72c)(data, rules),
                            leftComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                                checked: checked.relativeTime,
                                                onChange: (evt)=>handleOptionCheck(evt, 'relativeTime')
                                            }),
                                            label: "relative time"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            label: "meta",
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                                checked: checked.showMeta,
                                                onChange: (evt)=>handleOptionCheck(evt, 'showMeta')
                                            })
                                        })
                                    ]
                                })
                            }),
                            middleComponent: /*#__PURE__*/ (0, $ayMG0.jsxs)($2c916c2a79797e4e$var$QueryBuilderContainer, {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: filtered && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93130e1adb27db4f$export$2e2bcd8739ae039), {
                                            data: filtered,
                                            rules: rules,
                                            onClear: handleClearClientSideFilters,
                                            onSubmit: handleClientSideFilter
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $2c916c2a79797e4e$var$Root = (0, $d8seH.default)('div')`
  margin-left: 0;

  .filter-title {
    margin: 20px 0px;
  }

  .shortcuts {
    margin-bottom: 30px;
    .help-text {
      display: none;
      font-size: .8em;
      line-height: 1em;
    }

    .MuiButtonBase-root  {
      background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#272727' : '#fff'};
    }

    button:hover .help-text {
      display: block;
    }
  }

  /* remove some styles when displaying media */
  ${(props)=>props.isMedia && `
    tr:nth-child(odd) {
      background: none;
    }
    tr.MuiTableRow-root:hover {
      background-color: initial;
    }
    `}

  .query-viewer {
    overflow: hidden;
  }
`;
const $2c916c2a79797e4e$var$Main = (0, $d8seH.default)('div')`
  position: relative;
  height: 100%;
  margin: 30px 20px 30px 0;
  padding: 0 0 0 20px;
  width: calc(100% - 240px - 20px);

  tr.MuiTableRow-root:hover,
  .MuiTableRow-hover:hover  {
    background-color: none !important;
  }

  .MuiAlert-root {
    margin-bottom: 1em;
  }

  .MuiTablePagination-root {
    border-bottom: 0;
  }
`;
const $2c916c2a79797e4e$var$Menu = (0, $d8seH.default)('div')`
  margin-bottom: 15px;
  // todo(nc): configure more secondary light/dark colors
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#272727' : '#fff'};
`;
const $2c916c2a79797e4e$var$Snippets = (0, $d8seH.default)('div')`
  margin: 40px 0 0px 0;

  > div { margin: 30px 0 0px 0; }
  h4 { margin: 2px 0; }

  /* adjust prism + clipboard styles */
  pre {
    padding: 0;
    margin: 0;
  }

  .clipboard-content {
    padding-bottom: 0;
    pre {
      padding: 10px;

      border: none;
      overflow-x: scroll;
    }
  }

  .MuiButtonBase-root {
    background: rgba(30, 30, 30) !important; // text is behind button
    opacity: 0.8 !important;
    color: #fff;
  }
`;
const $2c916c2a79797e4e$var$QueryBuilderContainer = (0, $d8seH.default)('div')`
  margin-right: 2rem;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");
var $2cPwN = parcelRequire("2cPwN");
var $9Lykx = parcelRequire("9Lykx");
var $hViLc = parcelRequire("hViLc");
var $d8seH = parcelRequire("d8seH");
var $iAtns = parcelRequire("iAtns");

var $gTmRg = parcelRequire("gTmRg");

var $gOa8m = parcelRequire("gOa8m");

var $gZwVy = parcelRequire("gZwVy");
const { imageSearch: $1511e9561b01c45e$var$ENDPOINT } = (0, $gZwVy.default);
async function $1511e9561b01c45e$export$95cf5552bf00b4eb(query) {
    const payload = {
        data: [
            query
        ]
    };
    const response = await fetch(`${$1511e9561b01c45e$var$ENDPOINT}/gradio_api/call/search`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) throw new Error(`POST failed: ${await response.text()}`);
    const data = await response.json();
    const eventId = data.event_id;
    if (!eventId) throw new Error(`No event_id in response: ${JSON.stringify(data)}`);
    return eventId;
}
async function $1511e9561b01c45e$export$d8121d4a0553940e(eventId) {
    const resultsUrl = `${$1511e9561b01c45e$var$ENDPOINT}/gradio_api/call/search/${eventId}`;
    const response = await fetch(resultsUrl, {
        method: 'GET',
        headers: {
            'Accept': 'text/event-stream'
        },
        signal: AbortSignal.timeout(120000) // 120 seconds
    });
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let jsonData = null;
    let buffer = '';
    let done = false;
    while(!done){
        const result = await reader.read();
        done = result.done;
        const value = result.value;
        if (done) break;
        buffer += decoder.decode(value, {
            stream: true
        });
        const lines = buffer.split('\n');
        buffer = lines.pop() // Keep incomplete line for next chunk
        ;
        for (const line of lines)if (line.startsWith('data:')) jsonData = line.slice(5).trim();
    }
    if (!jsonData) throw new Error('No data received from SSE stream.');
    return jsonData;
}



var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $317685f0ee9ebb74$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'ClearOutlined');




var $7L4OA = parcelRequire("7L4OA");

var $f1q41 = parcelRequire("f1q41");


var $ayMG0 = parcelRequire("ayMG0");

var $6ami2 = parcelRequire("6ami2");
function $4dfb82316c0b8daa$export$2e2bcd8739ae039({ label: label, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
        label: label,
        onClick: onClick,
        clickable: true,
        variant: "outlined"
    });
}



const $975da745907a28b3$var$hiddenCols = [
    'explainScore'
];
const $975da745907a28b3$var$numbers = [
    'score',
    'rerank_score',
    'location_lat',
    'location_lon'
];
function $975da745907a28b3$var$getColumns(data) {
    return data.headers.map((label, i)=>{
        const obj = {
            id: label,
            label: label
        };
        if (label == 'caption') obj.width = '50%';
        if (i > 5 || $975da745907a28b3$var$hiddenCols.includes(label)) obj.hide = true;
        if (label == 'link') obj.format = (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: val,
                target: "_blank",
                rel: "noopener noreferrer",
                children: val
            });
        if (label == 'vsn') {
            obj.format = (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                    href: `/nodes/${val}`,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: val
                });
            if ($975da745907a28b3$var$numbers.includes(label)) obj.type = 'number';
        }
        return obj;
    });
}
function $975da745907a28b3$var$getRows(data) {
    return data.data.map((row)=>{
        const rowObj = {};
        data.headers.forEach((header, i)=>{
            rowObj[header] = row[i];
        });
        return rowObj;
    });
}
function $975da745907a28b3$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $aphAM.useLocation)();
    const [query, setQuery] = (0, $acw62.useState)('');
    const [columns, setColumns] = (0, $acw62.useState)(null);
    const [data, setData] = (0, $acw62.useState)(null);
    const [filteredRows, setFilteredRows] = (0, $acw62.useState)([]);
    const [tableQuery] = (0, $acw62.useState)('');
    const [queryTime, setQueryTime] = (0, $acw62.useState)();
    const [page, setPage] = (0, $acw62.useState)(0);
    const [updateID, setUpdateID] = (0, $acw62.useState)(0);
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            setUpdateID((prev)=>prev + 1);
        });
    }, [
        data
    ]);
    const handleSubmit = (q)=>{
        setLoading(true);
        const startTime = performance.now();
        (0, $1511e9561b01c45e$export$95cf5552bf00b4eb)(q || query).then((eventId)=>{
            if (!eventId) throw new Error('No event_id returned from submitImageSearch');
            return (0, $1511e9561b01c45e$export$d8121d4a0553940e)(eventId);
        }).then((jsonData)=>{
            const d = JSON.parse(jsonData)[0];
            const endTime = performance.now();
            const elapsed = (endTime - startTime) / 1000;
            setQueryTime(elapsed);
            setColumns($975da745907a28b3$var$getColumns(d));
            const rows = $975da745907a28b3$var$getRows(d);
            setData(rows);
            setFilteredRows(rows);
            setLoading(false);
        }).catch((err)=>{
            console.error('Error in image search:', err);
            setLoading(false);
        });
    };
    const handleChipClick = (evt)=>{
        const label = evt.target.textContent;
        setQuery(label);
        handleSubmit(label);
    };
    const handleTableSearch = (q)=>{
        setFilteredRows((0, $52fc2129eac6b28c$export$3c598703d99462f5)(data, q.query));
        setUpdateID((prev)=>prev + 1);
    };
    const handlePage = (val)=>{
        setPage(val);
    };
    const mapData = filteredRows ? (0, $f1q41.uniqBy)(filteredRows.map((obj)=>({
            lat: obj.location_lat,
            lng: obj.location_lon,
            vsn: obj.vsn,
            status: 'reporting',
            markerClass: 'blue-marker'
        })), 'vsn') : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($975da745907a28b3$var$Root, {
        className: "flex column gap items-center",
        children: [
            (0, $gTmRg.CardViewStyle),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                sx: {
                    width: '100%',
                    maxWidth: data || loading ? '100%' : 1050,
                    mx: {
                        xs: 1,
                        sm: 3,
                        md: 'auto'
                    },
                    ...data || loading ? {} : {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 130,
                        // Center vertically in viewport
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: '25%',
                        margin: 'auto',
                        height: 130
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($975da745907a28b3$var$Logo, {
                        className: "flex items-center",
                        style: {
                            marginBottom: data ? 0 : 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $57f2839113b57759$export$2e2bcd8739ae039), {
                                beta: false
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($975da745907a28b3$var$ISLogo, {
                                className: "flex column",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Image"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Search"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($975da745907a28b3$var$PromptContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                            className: "flex column items-center",
                            sx: {
                                m: {
                                    xs: 1,
                                    sm: 2
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    className: "flex items-center w-full",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                        style: {
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            handleSubmit();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                placeholder: "Enter a query or description... ",
                                                fullWidth: true,
                                                margin: "normal",
                                                value: query,
                                                onChange: (e)=>setQuery(e.target.value),
                                                sx: {
                                                    minWidth: 200,
                                                    maxWidth: '100%',
                                                    marginRight: 2
                                                },
                                                slotProps: {
                                                    inputLabel: {
                                                        shrink: true
                                                    },
                                                    input: {
                                                        startAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hViLc.default), {
                                                            position: "start",
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee94d57d97760d6e$export$2e2bcd8739ae039), {})
                                                        }),
                                                        endAdornment: query.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                            size: "small",
                                                            onClick: ()=>{
                                                                setQuery('');
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $317685f0ee9ebb74$export$2e2bcd8739ae039), {
                                                                fontSize: "small"
                                                            })
                                                        })
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                variant: "contained",
                                                type: "submit",
                                                size: "medium",
                                                sx: {
                                                    maxWidth: 400,
                                                    minWidth: 120
                                                },
                                                children: "Search"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        gap: 1,
                                        width: '100%',
                                        justifyContent: {
                                            xs: 'flex-start',
                                            sm: 'center'
                                        },
                                        mt: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dfb82316c0b8daa$export$2e2bcd8739ae039), {
                                            label: "Show me images in Hawaii",
                                            onClick: handleChipClick
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dfb82316c0b8daa$export$2e2bcd8739ae039), {
                                            label: "Snowy Mountains",
                                            onClick: handleChipClick
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dfb82316c0b8daa$export$2e2bcd8739ae039), {
                                            label: "Show me clouds in the top camera",
                                            onClick: handleChipClick
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4dfb82316c0b8daa$export$2e2bcd8739ae039), {
                                            label: "W040",
                                            onClick: handleChipClick
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                sx: {
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                    sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 500,
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cPwN.default), {})
                })
            }),
            data && filteredRows && !loading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                noPad: true,
                style: {
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($975da745907a28b3$var$Title, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("h2", {
                            className: "flex items-center justify-between gap",
                            children: [
                                "Images",
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("small", {
                                    className: "muted",
                                    children: [
                                        data.length,
                                        " results",
                                        queryTime ? ` in ${queryTime.toFixed(2)} seconds` : '',
                                        filteredRows.length != data.length ? ` (${filteredRows.length} shown)` : ''
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($975da745907a28b3$var$ScrollableWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($975da745907a28b3$var$TopShadow, {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                sx: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 2,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: 700,
                                    overflowY: 'auto'
                                },
                                children: filteredRows.map((obj, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea6dd3b260bbbc5f$export$1b862fb5467a3d94), {
                                        obj: obj
                                    }, i))
                            })
                        ]
                    })
                ]
            }),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                noPad: true,
                sx: {
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        visibility: mapData.length > 0 ? 'visible' : 'hidden',
                        width: '100%'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                        data: mapData,
                        updateID: updateID
                    })
                })
            }),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                sx: {
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($975da745907a28b3$var$TableContainer, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                        // primaryKey='rowID'
                        columns: columns,
                        rows: filteredRows,
                        pagination: true,
                        page: page,
                        rowsPerPage: 10,
                        onPage: handlePage,
                        limit: filteredRows.length,
                        enableSorting: true,
                        enableDownload: true,
                        sort: "-caption",
                        search: tableQuery,
                        onSearch: handleTableSearch,
                        storageKey: pathname,
                        onColumnMenuChange: ()=>{},
                        middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {}),
                        total: filteredRows.length
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
        ]
    });
}
const $975da745907a28b3$var$Root = (0, $d8seH.default)('div')`
  margin: 1rem 5rem;

  // todo(nc): fix in table component
  [data-testid="SettingsOutlinedIcon"] {
    margin-right: 1rem;
  }
`;
const $975da745907a28b3$var$TableContainer = (0, $d8seH.default)('div')`
  margin: 1rem;
`;
const $975da745907a28b3$var$Title = (0, $d8seH.default)('div')`
  h2 {
    margin:0;
    padding: 1rem 1rem 0 1rem;

    small {
      font-size: 10pt;
    }
  }
`;
const $975da745907a28b3$var$ScrollableWrapper = (0, $d8seH.default)('div')`
  position: relative;
  padding-top: 16px;
`;
const $975da745907a28b3$var$TopShadow = (0, $d8seH.default)('div')`
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 16px;
  pointer-events: none;
  background: ${(props)=>props.theme.palette.background.paper};
  box-shadow: 2px 8px 10px 0px rgba(0, 0, 0, 0.18);
  z-index: 2;
`;
const $975da745907a28b3$var$boxShadow = `
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow:
    0px 2px 4px -1px rgb(0 0 0 / 0%),
    0px 4px 5px 0px rgb(0 0 0 / 0%),
    0px 1px 10px 0px rgb(0 0 0 / 12%);
`;
const $975da745907a28b3$var$PromptContainer = (0, $d8seH.default)('div')`
  ${$975da745907a28b3$var$boxShadow}

  position: sticky;
  z-index: 1;
  border-radius: 10px;
  background: ${(props)=>props.theme.palette.background.paper};
`;
const $975da745907a28b3$var$Logo = (0, $d8seH.default)('div')`
  .logo {
    font-size: 20pt;
  }

  .logo img {
    height: 60px;
  }
`;
const $975da745907a28b3$var$ISLogo = (0, $d8seH.default)('div')`
  font-size: 1.8em;
  font-family: 'Open sans', sans-serif;
  font-weight: 800;
  color: #6d6d6d;
  margin-left: -10px;
  line-height: 1em;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");

var $9bsRS = parcelRequire("9bsRS");


var $gTmRg = parcelRequire("gTmRg");
function $14f76242ad4aa484$export$2e2bcd8739ae039() {
    const { name: name } = (0, $aphAM.useParams)();
    const [data, setData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $9bsRS.getOntology(name).then((data)=>{
            if (!data) {
                setError('not found');
                return;
            }
            setData(data);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, [
        name
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($14f76242ad4aa484$var$Root, {
        children: [
            (0, $gTmRg.CardViewStyle),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "no-margin",
                        children: "Ontology"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: name
                    }),
                    data && /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                        className: "simple key-value",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: data.ontology
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: data.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: "Units"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: data.units
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: data.unit
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: "Source"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: data.source,
                                                    children: data.source
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    error == 'not found' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                        severity: "info",
                        children: [
                            "There is no record for ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: name
                            })
                        ]
                    }),
                    error && error !== 'not found' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                        severity: "error",
                        children: error.message
                    })
                ]
            })
        ]
    });
}
const $14f76242ad4aa484$var$Root = (0, $lmFrL.default).div`
  margin: 2em;
`;



/* eslint-disable react/display-name */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");

var $6ami2 = parcelRequire("6ami2");

var $hw4Z0 = parcelRequire("hw4Z0");

var $gOa8m = parcelRequire("gOa8m");

var $2NJq1 = parcelRequire("2NJq1");





var $gTmRg = parcelRequire("gTmRg");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");


var $gTmRg = parcelRequire("gTmRg");

var $lzNIT = parcelRequire("lzNIT");

function $58198c70596f378b$export$2e2bcd8739ae039(props) {
    const { rows: rows, ...rest } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($58198c70596f378b$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($58198c70596f378b$var$Rows, {
            children: rows.map((row)=>/*#__PURE__*/ (0, $ayMG0.jsx)($58198c70596f378b$var$Row, {
                    data: row,
                    ...rest
                }, row.id))
        })
    });
}
const $58198c70596f378b$var$Root = (0, $lmFrL.default).div`
  margin-top: 5px;
`;
const $58198c70596f378b$var$Rows = (0, $lmFrL.default).div`
  margin-top: 1em;
`;
function $58198c70596f378b$var$Row(props) {
    const { data: data, query: query } = props;
    const { title: title, name: name, notes: notes, tags: tags, metadata_modified: metadata_modified, resources: resources, license_title: license_title } = data;
    return(// @ts-ignore; DataProductSearch is actually deprecated
    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Item), {
        className: "flex column",
        to: `data/product/${name}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Title), {
                children: (0, $ea155c15c24a7a5a$export$4bedd3f7d169f13c).title(title, data)
            }),
            notes && /*#__PURE__*/ (0, $ayMG0.jsxs)($58198c70596f378b$var$Notes, {
                children: [
                    (0, $e11645b86426ecc0$export$2e2bcd8739ae039)(notes.slice(0, 250), query ? query : ''),
                    notes.length > 250 ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            "... ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                to: `data/product/${name}`,
                                children: "read more"
                            })
                        ]
                    }) : ''
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center",
                children: notes && /*#__PURE__*/ (0, $ayMG0.jsx)($58198c70596f378b$var$Keywords, {
                    children: (0, $ea155c15c24a7a5a$export$4bedd3f7d169f13c).tags(tags)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap muted",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($58198c70596f378b$var$Type, {
                        className: "flex",
                        children: (0, $ea155c15c24a7a5a$export$4bedd3f7d169f13c).resources(resources)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            "Updated ",
                            (0, $ea155c15c24a7a5a$export$4bedd3f7d169f13c).time(metadata_modified + 'Z')
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: license_title
                    })
                ]
            })
        ]
    }));
}
const $58198c70596f378b$var$Notes = (0, $lmFrL.default).p`
  margin-bottom: 0px;
`;
const $58198c70596f378b$var$Keywords = (0, $lmFrL.default).p`
  div {
    margin: 2px 3px 2px 0;
  }
`;
const $58198c70596f378b$var$Type = (0, $lmFrL.default).div`
  div {
    margin: 2px 3px 2px 0;
  }
`;





var $gZwVy = parcelRequire("gZwVy");
const $ee7250fdda415ab7$var$url = (0, $gZwVy.default).wifireData;
function $ee7250fdda415ab7$var$handleErrors(res) {
    if (res.ok) return res;
    return res.json().then((errorObj)=>{
        throw Error(errorObj.error.message);
    });
}
function $ee7250fdda415ab7$var$get(endpoint) {
    return fetch(endpoint).then($ee7250fdda415ab7$var$handleErrors).then((res)=>res.json());
}
function $ee7250fdda415ab7$export$d76128d007d19019(args) {
    const { facets: facets, filters: filters, query: query } = args;
    const req = `${$ee7250fdda415ab7$var$url}/action/package_search` + `?facet.field=${JSON.stringify(facets)}` + (query ? `&q=${query}` : '') + `${$ee7250fdda415ab7$var$fqBuilder(filters)}`;
    return $ee7250fdda415ab7$var$get(req);
}
function $ee7250fdda415ab7$export$3972a8b667a037fb(name) {
    const req = `${$ee7250fdda415ab7$var$url}/action/package_show?id=${name}`;
    return $ee7250fdda415ab7$var$get(req);
}
function $ee7250fdda415ab7$export$634fb23fdf93e3e9(name) {
    const req = `${$ee7250fdda415ab7$var$url}/action/package_show?id=${name}`;
    return $ee7250fdda415ab7$var$get(req);
}
/**
 * Return filter query in form:
 *    &fq=name:("filter one" AND "filter two") AND ...
 *
 * @param facets
 * @returns url param string fq portion of solr request
 */ function $ee7250fdda415ab7$var$fqBuilder(facets) {
    const parts = Object.entries(facets).filter(([_, vals])=>vals.length).map(([name, vals])=>`${name}:(${vals.map((v)=>`"${v}"`).join(' AND ')})`);
    return parts.length ? `&fq=${parts.join(' AND ')}` : ``;
}



var $lffEs = parcelRequire("lffEs");

var $cX7V2 = parcelRequire("cX7V2");

var $2iAqv = parcelRequire("2iAqv");

var $gd5y7 = parcelRequire("gd5y7");

var $lmFrL = parcelRequire("lmFrL");
const $ab9a5abe53a36f91$var$Sidebar = (0, $lmFrL.default).div`
  position: sticky;
  top: 60px;
  height: calc(100vh);
  padding-top: 10px;
  width: ${(props)=>props.width || '250px'};
  min-width: ${(props)=>props.width || '250px'};
  border-right: 1px solid #f1f1f1;
  background: #f8f8f8;
  overflow-y: scroll;
`;
const $ab9a5abe53a36f91$export$c86c334a40b43b7c = (0, $lmFrL.default).h2`
  margin-left: 20px;
`;
var $ab9a5abe53a36f91$export$2e2bcd8739ae039 = $ab9a5abe53a36f91$var$Sidebar;



var $1X18x = parcelRequire("1X18x");
const $ea155c15c24a7a5a$export$4bedd3f7d169f13c = {
    title: (val, obj)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
            to: `/data/product/${obj.name}`,
            children: val.replace(`: ${obj.name}`, '')
        });
    },
    resources: (arr)=>arr.map((o)=>o.format).filter((v, i, arr)=>v && arr.indexOf(v) == i).map((format)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1X18x.FileFormatDot), {
                    format: format
                })
            }, format)),
    tags: (obj)=>obj.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: tag.display_name,
                variant: "outlined",
                size: "small"
            }, tag.name)),
    time: (val)=>{
        return $lffEs.msToTimeApprox(Date.now() - new Date(val).getTime());
    }
};
const $ea155c15c24a7a5a$var$columns = [
    {
        id: 'title',
        label: 'Title',
        format: $ea155c15c24a7a5a$export$4bedd3f7d169f13c.title
    },
    {
        id: 'name',
        label: 'Name',
        format: (val)=>val
    },
    {
        id: 'organization',
        label: 'Organization',
        format: (obj)=>obj.name
    },
    {
        id: 'resources',
        label: 'Type',
        format: $ea155c15c24a7a5a$export$4bedd3f7d169f13c.resources
    }
];
const $ea155c15c24a7a5a$var$initFilterState = {
    'organization': [],
    'tags': [],
    'res_format': []
};
const $ea155c15c24a7a5a$var$facetList = Object.keys($ea155c15c24a7a5a$var$initFilterState);
function $ea155c15c24a7a5a$export$2e2bcd8739ae039() {
    const [params, setParams] = (0, $lzNIT.useSearchParams)();
    const query = params.get('query') || '';
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [rows, setRows] = (0, $acw62.useState)(null);
    const [facets, setFacets] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    const [sort] = (0, $acw62.useState)('most_relevant');
    const [filterState, setFilterState] = (0, $acw62.useState)($ea155c15c24a7a5a$var$initFilterState);
    const [viewStyle, setViewStyle] = (0, $acw62.useState)('spacious');
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $ee7250fdda415ab7$export$d76128d007d19019({
            facets: $ea155c15c24a7a5a$var$facetList,
            filters: filterState,
            query: query
        }).then((data)=>{
            const { results: results, search_facets: search_facets } = data.result;
            setRows(results);
            setFacets(search_facets);
        }).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        setLoading,
        query,
        filterState
    ]);
    // todo: refactor into useContext or table componnent?
    const onSearch = ({ query: query })=>{
        if (query) params.set('query', query);
        else params.delete('query');
        setParams(params);
    };
    const handleFilter = (evt, facet, val)=>{
        setFilterState((prev)=>{
            return {
                ...prev,
                [facet]: prev[facet].includes(val) ? prev[facet].filter((v)=>v != val) : [
                    ...prev[facet],
                    val
                ]
            };
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ea155c15c24a7a5a$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                severity: "info",
                style: {
                    borderBottom: '1px solid #f2f2f2'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "Note:"
                    }),
                    " The Data Commons (the view below) is made available solely for ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "demonstration purposes"
                    }),
                    ".  You might consider checking out the ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: "/data",
                        children: "Data Browser"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ab9a5abe53a36f91$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab9a5abe53a36f91$export$c86c334a40b43b7c), {
                                children: "Filters"
                            }),
                            facets && $ea155c15c24a7a5a$var$facetList.map((facet)=>{
                                const { title: title, items: items } = facets[facet];
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b478a515f6547033$export$2e2bcd8739ae039), {
                                    title: title.replace('res_', '').replace(/\b[a-z](?=[a-z]{1})/g, (c)=>c.toUpperCase()),
                                    checked: filterState[facet],
                                    onCheck: (evt, val)=>handleFilter(evt, facet, val),
                                    // @ts-ignore; DataProductSearch is actually deprecated
                                    type: "text",
                                    data: items
                                }, title);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($ea155c15c24a7a5a$var$Main, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Top), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex items-center gap",
                                        style: {
                                            backgroundColor: '#fff'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dc74b806698c54b$export$2e2bcd8739ae039), {
                                                path: "/data/"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $177e9ab8fdb34313$export$2e2bcd8739ae039), {
                                                filterState: filterState
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($ea155c15c24a7a5a$var$Controls, {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex items-ceter gap",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2NJq1.default), {
                                                        onSearch: onSearch,
                                                        width: "300px"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gd5y7.default), {
                                                        variant: "outlined",
                                                        className: "flex self-center",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cX7V2.default), {
                                                            labelId: "namespace-label",
                                                            id: "namespace",
                                                            value: sort,
                                                            onChange: ()=>alert('Sorting is not implemented yet.  Check back later.'),
                                                            variant: "outlined",
                                                            size: "small",
                                                            style: {
                                                                marginTop: '1px'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                    value: 'most_relevant',
                                                                    children: "most relevant"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                    value: 'name_accending',
                                                                    children: "name ascending"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                    value: 'name_decending',
                                                                    children: "name decending"
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2iAqv.default), {
                                                                    value: 'last_mod',
                                                                    children: "last modified"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92699f1d3dbb3eae$export$2e2bcd8739ae039), {
                                                layout: viewStyle,
                                                onClick: (view)=>setViewStyle(view)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            rows && viewStyle == 'compact' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                                primaryKey: "id",
                                enableSorting: true,
                                columns: $ea155c15c24a7a5a$var$columns,
                                rows: rows
                            }),
                            rows && viewStyle == 'spacious' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58198c70596f378b$export$2e2bcd8739ae039), {
                                rows: rows,
                                query: query
                            }),
                            rows && !rows.length && /*#__PURE__*/ (0, $ayMG0.jsxs)($ea155c15c24a7a5a$var$NoneFound, {
                                className: "flex column items-center justify-center muted",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15b87fc16f8d46d$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "No data was found"
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                                children: error
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $ea155c15c24a7a5a$var$Root = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
`;
const $ea155c15c24a7a5a$var$Main = (0, $lmFrL.default).div`
  position: relative;
  height: 100%;
  padding: 0 20px;
  width: 100%;
`;
const $ea155c15c24a7a5a$var$Controls = (0, $lmFrL.default).div`
  background-color: #fff;
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
`;
const $ea155c15c24a7a5a$var$NoneFound = (0, $lmFrL.default).div`
  font-size: 2.0em;
  padding-top: 100px;

  img {
    width: 175px;
    margin-right: 20px;
    filter: drop-shadow(0px 0px 0.3rem #ccc);
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $lmFrL = parcelRequire("lmFrL");

var $6ami2 = parcelRequire("6ami2");

var $df6e7e10a91d8e52$exports = {};
$df6e7e10a91d8e52$exports = import.meta.resolve("8X7Cx");




var $hw4Z0 = parcelRequire("hw4Z0");



var $1X18x = parcelRequire("1X18x");

var $gTmRg = parcelRequire("gTmRg");


var $gOa8m = parcelRequire("gOa8m");
function $4fef0d6ee86b04e1$var$formatNotes(text) {
    text.replace(/http/g, '<br>').replace(/\*/g, "\u2022");
    return text.replace(/\n/g, '<br>').replace(/\*/g, "\u2022");
}
const $4fef0d6ee86b04e1$var$columns = [
    {
        id: 'name',
        label: 'Name',
        format: (val, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: obj.url,
                className: "flex items-center",
                download: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($39562499e45c6466$exports))), {
                        className: "download-icon"
                    }),
                    val
                ]
            })
    },
    {
        id: 'description',
        label: 'Description'
    },
    {
        id: 'created',
        label: 'Created',
        format: (val)=>new Date(val).toLocaleString()
    },
    {
        id: 'format',
        label: 'Format',
        format: (val)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1X18x.FileFormatDot), {
                format: val
            })
    }
];
function $4fef0d6ee86b04e1$export$2e2bcd8739ae039() {
    const { name: name } = (0, $aphAM.useParams)();
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)(null);
    const [doi, setDoi] = (0, $acw62.useState)(null);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        $ee7250fdda415ab7$export$634fb23fdf93e3e9(name).then(({ result: result })=>{
            const doi = result.extras.find((obj)=>obj.key == 'doi').value;
            setDoi(doi);
            setData(result);
        }).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        name,
        setLoading
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4fef0d6ee86b04e1$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($4fef0d6ee86b04e1$var$Main, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($4fef0d6ee86b04e1$var$Sidebar, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: "About"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: "Organization"
                        }),
                        data && data.organization.title,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: "Keywords"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4fef0d6ee86b04e1$var$Keywords, {
                            children: data && data.tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                                    label: tag.display_name
                                }, tag.name))
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: "Last Updated"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                "Updated ",
                                data && (0, $ea155c15c24a7a5a$export$4bedd3f7d169f13c).time(data.metadata_modified + 'Z')
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: "Created"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: data?.metadata_modified + 'Z'
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: "Resource Type"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: data && (0, $ea155c15c24a7a5a$export$4bedd3f7d169f13c).resources(data.resources)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: "License"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: data?.license_title || 'N/A'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($4fef0d6ee86b04e1$var$Details, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Top), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9dc74b806698c54b$export$2e2bcd8739ae039), {
                                path: `/data/${name}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "flex items-center justify-between",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                children: data?.title
                            })
                        }),
                        data && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: $4fef0d6ee86b04e1$var$formatNotes(data.notes)
                            }
                        }),
                        error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                            children: error.message
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex items-end justify-between",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: "Downloads"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex column items-end",
                                    children: doi && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: doi,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($df6e7e10a91d8e52$exports))),
                                                    height: "50"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: doi,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                    children: doi
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                            primaryKey: "name",
                            enableSorting: true,
                            columns: $4fef0d6ee86b04e1$var$columns,
                            rows: data.resources
                        })
                    ]
                })
            ]
        })
    });
}
const $4fef0d6ee86b04e1$var$Root = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;

  .download-icon {
    color: #666;
  }
`;
const $4fef0d6ee86b04e1$var$Sidebar = (0, $lmFrL.default).div`
  position: sticky;
  top: 0;
  height: calc(100vh - 60px);
  width: 300px;
  padding: 0 10px;
`;
const $4fef0d6ee86b04e1$var$Main = (0, $lmFrL.default).div`
  padding: 20px;
  width: 100%;
  display: flex;
`;
const $4fef0d6ee86b04e1$var$Keywords = (0, $lmFrL.default).div`
  div {
    margin: 2px;
  }
`;
const $4fef0d6ee86b04e1$var$Details = (0, $lmFrL.default).div`
  width: 100%;
  margin-bottom: 50px;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("kalwe");
var $jNGAr = parcelRequire("jNGAr");
var $aDtBU = parcelRequire("aDtBU");

var $lkxXU = parcelRequire("lkxXU");
function $f8a27e1b29da9aad$export$2e2bcd8739ae039(props) {
    const { defaultValue: defaultValue, ariaLabel: ariaLabel, tabs: tabs } = props;
    const loc = (0, $aphAM.useLocation)();
    const path = loc.pathname + loc.search;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aDtBU.default), {
            value: path || defaultValue,
            "aria-label": ariaLabel,
            children: tabs.map((obj)=>{
                if (obj == 'divider') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                    orientation: "vertical",
                    style: {
                        height: 30,
                        alignSelf: 'center'
                    }
                }, "divider");
                const { label: label, icon: icon, to: to } = obj;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jNGAr.default), {
                    label: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            icon,
                            "\xa0",
                            label
                        ]
                    }),
                    component: (0, $lzNIT.Link),
                    value: to,
                    to: to
                }, label);
            })
        })
    });
}



var $gTmRg = parcelRequire("gTmRg");



// import DevicesIcon from '@mui/icons-material/DeviceHubRounded'
const $8cea67cf45aa799d$var$tabs = [
    {
        label: 'Account',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a61247555e1f801a$exports))), {}),
        to: '/account/profile'
    },
    {
        label: 'My Nodes',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1cc8fc7ba43458bc$exports))), {}),
        to: '/account/nodes'
    },
    {
        label: 'Access Credentials',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a24499e9cfcadef8$exports))), {}),
        to: '/account/access'
    }
];
function $8cea67cf45aa799d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8cea67cf45aa799d$var$Root, {
        children: [
            (0, $gTmRg.CardViewStyle),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8a27e1b29da9aad$export$2e2bcd8739ae039), {
                        defaultValue: '/accounts/profile',
                        ariaLabel: "my account tabs",
                        tabs: $8cea67cf45aa799d$var$tabs
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {})
                ]
            })
        ]
    });
}
const $8cea67cf45aa799d$var$Root = (0, $lmFrL.default).div`
  margin: 40px 100px 500px 100px;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");




var $ecxdi = parcelRequire("ecxdi");

const $7c6130e916277360$var$fields = [
    {
        id: 'name',
        label: 'Name',
        edit: false
    },
    {
        id: 'username',
        label: 'Username',
        edit: false
    },
    {
        id: 'email',
        label: 'Email',
        edit: false
    },
    {
        id: 'organization',
        label: 'Organization',
        maxLength: 30
    },
    {
        id: 'department',
        label: 'Department',
        maxLength: 30
    },
    {
        id: 'bio',
        label: 'Biography',
        type: 'textarea',
        maxLength: 500
    }
];
function $7c6130e916277360$export$2e2bcd8739ae039() {
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    // presentation
    const [data, setData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)();
    // form
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [state, setState] = (0, $acw62.useState)();
    const getData = (0, $acw62.useCallback)(()=>{
        $ecxdi.getUserInfo().then((data)=>{
            setData(data);
            setState(data);
        }).catch((err)=>setError(err.message)).finally(()=>setLoading(false));
    }, [
        setLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        getData();
    }, [
        setLoading,
        getData
    ]);
    const handleChange = (evt)=>{
        const { name: name, value: value } = evt.target;
        setState((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const handleCancel = ()=>{
        setIsEditing(false);
        setState(data);
    };
    const handleSave = ()=>{
        setIsSaving(true);
        $ecxdi.saveUserInfo(state).then(()=>{
            setIsEditing(false);
            getData();
        }).catch((err)=>setError(err)).finally(()=>setIsSaving(false));
    };
    const formData = {
        fields: $7c6130e916277360$var$fields,
        data: data,
        state: state,
        isEditing: isEditing
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7c6130e916277360$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "no-margin",
                        children: "My Profile"
                    }),
                    isEditing ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "outlined",
                        className: "cancel",
                        onClick: handleCancel,
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5861ec10399b0856$exports))), {}),
                        children: "Cancel"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3c4d0782a0aeb057$exports))), {}),
                        onClick: ()=>setIsEditing(true),
                        children: "Edit"
                    })
                ]
            }),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex column user-info",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86ba48c15c409e47$export$2e2bcd8739ae039), {
                    ...formData,
                    onChange: handleChange
                })
            }),
            isEditing && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                className: "save",
                variant: "contained",
                type: "submit",
                onClick: handleSave,
                disabled: isSaving,
                children: isSaving ? 'Saving...' : 'Save'
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error
            })
        ]
    });
}
const $7c6130e916277360$var$Root = (0, $lmFrL.default).div`
  .user-info {
    margin-top: 2em;
  }

  .delete {
    border-color: #660000;
  }

  [type=submit] {
    margin-top: 2em;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $lmFrL = parcelRequire("lmFrL");



var $gOa8m = parcelRequire("gOa8m");

var $ecxdi = parcelRequire("ecxdi");

var $9bsRS = parcelRequire("9bsRS");

var $hw4Z0 = parcelRequire("hw4Z0");

var $gZwVy = parcelRequire("gZwVy");
const { contactUs: $7dc3874497ed1111$var$contactUs } = (0, $gZwVy.default);
const $7dc3874497ed1111$var$columns = [
    {
        id: 'vsn',
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "Node (VSN)"
        }),
        format: (vsn, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/nodes/${obj.vsn}`,
                children: vsn
            })
    },
    {
        id: 'schedule',
        label: 'Can schedule?',
        format: (yes)=>yes ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f5de08bd86b7f3d6$exports))), {
                className: "success"
            }) : 'no'
    },
    {
        id: 'develop',
        label: 'Shell access?',
        format: (yes)=>yes ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f5de08bd86b7f3d6$exports))), {
                className: "success"
            }) : 'no'
    }
];
function $7dc3874497ed1111$export$2e2bcd8739ae039() {
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [data, setData] = (0, $acw62.useState)();
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setLoading(true);
        Promise.all([
            $ecxdi.listMyNodes(),
            $9bsRS.getNodeDict()
        ]).then(([myNodes, nodeDict])=>setData(myNodes.map((o)=>({
                    ...o,
                    ...nodeDict[o.vsn]
                })))).catch((error)=>setError(error)).finally(()=>setLoading(false));
    }, [
        setLoading
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7dc3874497ed1111$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "no-margin",
                children: "My Node Privileges"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                primaryKey: "vsn",
                enableSorting: true,
                columns: $7dc3874497ed1111$var$columns,
                rows: data,
                emptyNotice: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        "Sorry, you do not have access to any nodes.",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        "Please ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: $7dc3874497ed1111$var$contactUs,
                                children: "contact us"
                            })
                        }),
                        " if interested in collaborating with Sage."
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                children: error.message
            })
        ]
    });
}
const $7dc3874497ed1111$var$Root = (0, $lmFrL.default).div`

`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");
var $iAtns = parcelRequire("iAtns");

var $c3pId = parcelRequire("c3pId");

var $gZwVy = parcelRequire("gZwVy");
const $44605e40f3ad6a49$var$url = (0, $gZwVy.default).deviceRegistration;
const $44605e40f3ad6a49$var$__token = (0, $c3pId.default).token;
const $44605e40f3ad6a49$var$options = {
    headers: $44605e40f3ad6a49$var$__token ? {
        Authorization: `sage ${$44605e40f3ad6a49$var$__token}`
    } : {}
};
function $44605e40f3ad6a49$var$handleRegErrors(res) {
    if (res.ok) return res;
    return res.json().then((errorObj)=>{
        throw Error(errorObj.message);
    });
}
function $44605e40f3ad6a49$export$6503ec6e8aabbaf() {
    return fetch(`${$44605e40f3ad6a49$var$url}/register`, {
        method: 'POST',
        ...$44605e40f3ad6a49$var$options
    }).then($44605e40f3ad6a49$var$handleRegErrors).then((res)=>res.blob());
}


const $195dc6a88faff539$var$idLength = 16;
function $195dc6a88faff539$export$2e2bcd8739ae039() {
    const [form, setForm] = (0, $acw62.useState)({
        deviceID: ''
    });
    const [gotKey, setGotKey] = (0, $acw62.useState)(false);
    const [errMsg, setErrMsg] = (0, $acw62.useState)('');
    const handleRegister = ()=>{
        // todo: actually use device ID
        $44605e40f3ad6a49$export$6503ec6e8aabbaf().then((data)=>{
            setGotKey(true);
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(data);
            a.download = 'registration.zip';
            a.click();
        }).catch((err)=>{
            setGotKey(false);
            setErrMsg(err.message);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($195dc6a88faff539$var$Root, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "flex column gap",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    className: "no-margin",
                    children: "Get development beehive keys for your Waggle device"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Enter your Waggle device ID"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                    id: "nano-id",
                    placeholder: "Nano ID",
                    style: {
                        width: 500
                    },
                    value: form.deviceID,
                    onChange: (evt)=>setForm((prev)=>({
                                ...prev,
                                deviceID: evt.target.value
                            })),
                    required: true,
                    disabled: gotKey,
                    slotProps: {
                        htmlInput: {
                            maxlength: $195dc6a88faff539$var$idLength
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        type: "submit",
                        id: "publish-waggle",
                        style: {
                            width: 120
                        },
                        onClick: handleRegister,
                        disabled: form.deviceID.length != $195dc6a88faff539$var$idLength || gotKey,
                        children: !gotKey ? 'Get Keys' : 'Got Keys!'
                    })
                }),
                gotKey && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    severity: "success",
                    children: "Check your download folder for registration keys!"
                }),
                errMsg && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                    severity: "error",
                    children: errMsg
                })
            ]
        })
    });
}
const $195dc6a88faff539$var$Root = (0, $lmFrL.default).div`

  > div {
    margin-bottom: 2em;
  }

  [type=submit] {
    margin-top: 2em;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iwiZ3 = parcelRequire("iwiZ3");
var $6lXkL = parcelRequire("6lXkL");
var $gd5y7 = parcelRequire("gd5y7");
var $djhCy = parcelRequire("djhCy");
var $imehR = parcelRequire("imehR");
var $d8seH = parcelRequire("d8seH");


var $lDN4l = parcelRequire("lDN4l");

var $3wsqW = parcelRequire("3wsqW");

var $acw62 = parcelRequire("acw62");

var $ecxdi = parcelRequire("ecxdi");
function $f1c6efe91a3c1d80$export$2e2bcd8739ae039(perm) {
    const [hasCapability, setHasCapability] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        $ecxdi.hasCapability(perm).then((res)=>setHasCapability(res)).catch(()=>setHasCapability(false));
    }, [
        perm
    ]);
    return {
        hasCapability: hasCapability
    };
}




var $ecxdi = parcelRequire("ecxdi");

var $c3pId = parcelRequire("c3pId");

var $3X9tg = parcelRequire("3X9tg");

var $gZwVy = parcelRequire("gZwVy");
const { contactUs: $3782c15d916769b6$var$contactUs } = (0, $gZwVy.default);
const $3782c15d916769b6$var$DEV_SCHEDULE_PERMS = [
    'develop',
    'schedule'
];
const $3782c15d916769b6$var$DEV_PERM = 'develop';
const $3782c15d916769b6$var$requestInfo = `Name:
Organization or affiliation:
Short description of the project:
Sponsor:
  [Please provide your PI's name and/or all funding sources associated with this request]
Type of access (check all that apply):
  [ ] Protected file download access
  [ ] Development (shell) access
  [ ] Scheduling access
Nodes:
  [If known, please list the project or nodes you need access to.]
`;
function $3782c15d916769b6$export$2e2bcd8739ae039() {
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [error, setError] = (0, $acw62.useState)(null);
    // form
    const [isSaving, setIsSaving] = (0, $acw62.useState)(false);
    const [state, setState] = (0, $acw62.useState)({
        ssh_public_keys: ''
    });
    const { isApproved: isApproved } = (0, $0467c85c2f7adf78$export$2e2bcd8739ae039)();
    const { hasCapability: isPermitted } = (0, $f1c6efe91a3c1d80$export$2e2bcd8739ae039)($3782c15d916769b6$var$DEV_SCHEDULE_PERMS);
    const { hasCapability: canDev } = (0, $f1c6efe91a3c1d80$export$2e2bcd8739ae039)($3782c15d916769b6$var$DEV_PERM);
    (0, $acw62.useEffect)(()=>{
        if (!isApproved) return;
        setLoading(true);
        $ecxdi.getUserInfo().then(({ ssh_public_keys: ssh_public_keys })=>setState({
                ssh_public_keys: ssh_public_keys
            })).catch((err)=>setError(err.message)).finally(()=>setLoading(false));
    }, [
        isApproved,
        setLoading
    ]);
    const handleChange = (evt)=>{
        const { name: name, value: value } = evt.target;
        setState((prev)=>({
                ...prev,
                [name]: value
            }));
    };
    const handleSave = ()=>{
        setIsSaving(true);
        $ecxdi.saveSSHKey(state).then((data)=>setState(data)).catch((err)=>setError(err.message)).finally(()=>setIsSaving(false));
    };
    const handleCopyToken = ()=>{
        navigator.clipboard.writeText((0, $c3pId.default).token);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($3782c15d916769b6$var$Root, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($3782c15d916769b6$var$CopyToken, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "no-margin",
                        children: "Your Access Token"
                    }),
                    isPermitted || isApproved ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex items-center justify-between gap",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex-grow",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("pre", {
                                    style: {
                                        width: 375
                                    },
                                    children: [
                                        "**************************************",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3wsqW.default), {
                                            tooltip: "Copy token",
                                            onClick: handleCopyToken
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                                    severity: "warning",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: "Note:"
                                        }),
                                        " Treat this token as sensitive information, similar to a username and password. Please ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                href: $3782c15d916769b6$var$contactUs,
                                                children: "contact us"
                                            })
                                        }),
                                        " if you have any questions."
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                        severity: "info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Note:"
                            }),
                            " your account hasn't been approved or you do not have file access, scheduling permissions, or developer access to any nodes.",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            "Once you have permissions, your access token will appear here",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Need developer and/or scheduling access?"
                            }),
                            "  Please follow the rest of the instructions on this page.",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: "Only need file access for protected data?"
                            }),
                            " Please complete the ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: '"Request access"'
                            }),
                            " section below."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "no-margin",
                children: "Update SSH Public Keys"
            }),
            !canDev && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $iwiZ3.default), {
                    severity: "info",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "Note:"
                        }),
                        " you do not have dev access on any nodes.  Please ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: $3782c15d916769b6$var$contactUs,
                                children: "contact us"
                            })
                        }),
                        " if you'd like developer access."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "To create SSH key pair on your machine, use:",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                        content: "ssh-keygen -t ed25519 -f ~/.ssh/sage_key"
                    }),
                    "[Provide a password to secure the key]"
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                children: [
                    "Next, copy the ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                        children: "public key"
                    }),
                    " portion of the key into the input below.",
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                        content: "cat ~/.ssh/sage_key.pub"
                    })
                ]
            }),
            state && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gd5y7.default), {
                className: "flex column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $djhCy.default), {
                        id: "ssk-keys",
                        children: "My SSH Public Keys"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $imehR.default), {
                        placeholder: `sh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIK0LT3jNyfUtkJwxiv/7YfPU4PIOsQzeCVKlLCAfwlg3\\n` + `\n\n(no ssh key provided)`,
                        id: "ssh-keys",
                        "aria-label": "ssh keys",
                        name: "ssh_public_keys",
                        onChange: handleChange,
                        value: state.ssh_public_keys,
                        multiline: true,
                        minRows: 8,
                        style: {
                            width: 800
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                className: "save",
                variant: "contained",
                type: "submit",
                onClick: handleSave,
                disabled: isSaving,
                children: isSaving ? 'Saving...' : 'Save'
            }),
            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                severity: "error",
                children: error
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: "Finish Setup for Node Access"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: "Once you've updated your SSH public key above, you'll need to do the following steps."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                icon: "1",
                label: "Request access"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3X9tg.Step), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "First, ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: $3782c15d916769b6$var$contactUs,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "email us"
                                })
                            }),
                            ' with the subject "Access Request", along with with the following info about your request:'
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                        content: $3782c15d916769b6$var$requestInfo
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                icon: "2",
                label: "Update SSH config"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3X9tg.Step), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "Next, you'll need to update your ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                children: "~/.ssh/config"
                            }),
                            " file to include the following lines:"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                        content: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                "Host waggle-dev-sshd",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "HostName beekeeper.sagecontinuum.org",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "Port 49190",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "User waggle",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "IdentityFile ~/.ssh/sage_key # <---- your private key",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "IdentitiesOnly yes",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                "Host waggle-dev-node-*",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                'ProxyCommand ssh waggle-dev-sshd connect-to-node $(echo %h | sed "s/waggle-dev-node-//" )',
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "User waggle",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "IdentityFile ~/.ssh/sage_key",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "IdentitiesOnly yes",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                '    ',
                                "StrictHostKeyChecking no",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                icon: "3",
                label: "SSH to node"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3X9tg.Step), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "You can access a specific node by its VSN, if you have permissions. For example, you can SSH to node V030 using:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lDN4l.default), {
                        content: 'ssh waggle-dev-node-V030'
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Note that upon first connecting to a node, please check that the fingerprint matches:"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                        children: "ED25519 key fingerprint is SHA256:0EZvahC0dry74dmu7DBjweZwGWMt2zvV7rWZTb3Ao9g."
                    })
                ]
            })
        ]
    });
}
const $3782c15d916769b6$var$Root = (0, $d8seH.default)('div')`
  // todo(nc)
  .delete {
    border-color: #660000;
  }

  [type=submit] {
    margin: 2em 0;
  }

  .clipboard-content {
    overflow-x: auto;
  }


  h3 {
    margin:0;
  }
`;
const $3782c15d916769b6$var$CopyToken = (0, $d8seH.default)('div')`
  margin-bottom: 2em;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $cFBau = parcelRequire("cFBau");
var $03mUs = parcelRequire("03mUs");
var $6lXkL = parcelRequire("6lXkL");

var $acw62 = parcelRequire("acw62");


var $umiYb = parcelRequire("umiYb");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

var $dFNG2 = parcelRequire("dFNG2");

var $dxMBG = parcelRequire("dxMBG");

var $6o2lr = parcelRequire("6o2lr");

var $ayMG0 = parcelRequire("ayMG0");
const $9d2a35bf051ea407$var$defaultTheme = (0, $6o2lr.default)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $dxMBG.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $dFNG2.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $umiYb.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}



var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $1iOpW = parcelRequire("1iOpW");
'use client';
const $2291beb327d500f8$var$Container = (0, $9d2a35bf051ea407$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $d8seH.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $jTnBY.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1iOpW.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $2291beb327d500f8$export$2e2bcd8739ae039 = $2291beb327d500f8$var$Container;


var $2esSG = parcelRequire("2esSG");
var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");


var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $jTnBY = parcelRequire("jTnBY");

var $1Anyj = parcelRequire("1Anyj");

var $kVqvD = parcelRequire("kVqvD");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5f063e1b0f6d278b$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $5f063e1b0f6d278b$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $5f063e1b0f6d278b$export$2e2bcd8739ae039 = $5f063e1b0f6d278b$var$switchClasses;



var $6lpak = parcelRequire("6lpak");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ccc0421702a0be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $jTnBY.default)(edge)}`,
            `size${(0, $jTnBY.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $jTnBY.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $5f063e1b0f6d278b$export$39f6debbec19b3ba), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $56ccc0421702a0be$var$SwitchRoot = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $jTnBY.default)(ownerState.edge)}`],
            styles[`size${(0, $jTnBY.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $56ccc0421702a0be$var$SwitchSwitchBase = (0, $d8seH.default)((0, $kVqvD.default), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $jTnBY.default)(ownerState.color)}`]
        ];
    }
})((0, $aeD7H.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $aeD7H.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $aSEG4.lighten)(theme.palette[color].main, 0.62) : (0, $aSEG4.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).checked} + .${(0, $5f063e1b0f6d278b$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $56ccc0421702a0be$var$SwitchTrack = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})((0, $aeD7H.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $56ccc0421702a0be$var$SwitchThumb = (0, $d8seH.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})((0, $aeD7H.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $56ccc0421702a0be$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $56ccc0421702a0be$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $6lpak.default)('root', {
        className: (0, $5FMfE.default)(classes.root, className),
        elementType: $56ccc0421702a0be$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $6lpak.default)('thumb', {
        className: classes.thumb,
        elementType: $56ccc0421702a0be$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $6lpak.default)('track', {
        className: classes.track,
        elementType: $56ccc0421702a0be$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($56ccc0421702a0be$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $56ccc0421702a0be$export$2e2bcd8739ae039 = $56ccc0421702a0be$var$Switch;


var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");
var $3bYfT = parcelRequire("3bYfT");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ed7b2b659b749647$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3fb6cdd207b8a1a5$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'DragIndicator');



var $5xexf = parcelRequire("5xexf");

var $3X9tg = parcelRequire("3X9tg");

var $gOa8m = parcelRequire("gOa8m");

var $ecxdi = parcelRequire("ecxdi");

var $9bsRS = parcelRequire("9bsRS");

var $7L4OA = parcelRequire("7L4OA");
const $d2a7ba9b3a050904$var$columns = [
    {
        id: 'name',
        label: 'Project'
    },
    {
        id: 'number_of_users',
        label: 'Project Members',
        format: (val)=>`${val} users`
    },
    {
        id: 'number_of_nodes',
        label: 'Nodes',
        format: (val)=>`${val} nodes`
    }
];
/* mock data
const projectsData = [{
  id: 1,
  name: 'Hawaii',
  members: 4,
  nodes: '3 Nodes'
}, {
  id: 2,
  name: 'ARM',
  members: 5,
  nodes: '1 Node'
}, {
  id: 2,
  name: 'Example Project',
  members: 5,
  nodes: '10 Nodes'
}]
*/ const $d2a7ba9b3a050904$var$getProjectSelectionLabel = (project)=>{
    if (project === 'testbed') return 'Select the testbed(s) you would like access to:';
    else if (project === 'add') return 'Select the nodes or project you would like to be added to:';
    else if (project === 'renew') return 'Select the project you would like to be renewed:';
};
// todo: refactor
const $d2a7ba9b3a050904$var$DraggableContainer = (0, $lmFrL.default).div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  cursor: grab;
`;
const $d2a7ba9b3a050904$var$DropIndicator = (0, $lmFrL.default).div`
  height: 2px;
  background-color: #6363eb;
  margin: 5px 0;
  opacity: ${({ isVisible: isVisible })=>isVisible ? 1 : 0};
`;
function $d2a7ba9b3a050904$export$2e2bcd8739ae039() {
    const [formData, setFormData] = (0, $acw62.useState)({
        pi_name: '',
        use_profile_info: false,
        pi_email: '',
        pi_institution: '',
        project_title: '',
        project_website: '',
        project_short_name: '',
        science_field: '',
        related_to_proposal: '',
        justification: '',
        grant_number: '',
        funding_sources: [
            {
                source: '',
                grant_number: ''
            }
        ],
        comments: '',
        selected_nodes: [],
        selected_projects: []
    });
    const [draggedIndex, setDraggedIndex] = (0, $acw62.useState)(null);
    const [draggedOverIndex, setDraggedOverIndex] = (0, $acw62.useState)(null);
    const [reqType, setReqType] = (0, $acw62.useState)(null);
    const [formSpec, setFormSpec] = (0, $acw62.useState)();
    const [nodes, setNodes] = (0, $acw62.useState)([]);
    const [user, setUser] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        (0, $ecxdi.getAllocationFormData)().then((data)=>{
            console.log(data);
            setFormSpec(data);
        }).catch((err)=>{
            // todo
            console.error(err);
        });
        (0, $ecxdi.getUserInfo)().then((data)=>setUser(data)).catch((err)=>{
            console.log('err', err);
        });
        (0, $9bsRS.getNodes)().then((nodes)=>{
            console.log('nodes', nodes);
            setNodes(nodes);
        }).catch((err)=>{
            console.error('Error fetching nodes:', err);
        });
    }, []);
    const handleUseProfileInfo = (evt)=>{
        handleChange(evt);
        setFormData((prev)=>({
                ...prev,
                pi_name: user.name,
                pi_email: user.email
            }));
    };
    const handleChange = (event, index)=>{
        if (index !== undefined) {
            const new_funding_sources = [
                ...formData.funding_sources
            ];
            new_funding_sources[index][event.target.name] = event.target.value;
            setFormData({
                ...formData,
                funding_sources: new_funding_sources
            });
        } else setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    };
    const handle_checkbox_change = (event)=>{
        setFormData({
            ...formData,
            [event.target.name]: event.target.checked
        });
    };
    const add_funding_source = ()=>{
        setFormData({
            ...formData,
            funding_sources: [
                ...formData.funding_sources,
                {
                    source: '',
                    grant_number: ''
                }
            ]
        });
    };
    const remove_funding_source = (index)=>{
        const new_funding_sources = formData.funding_sources.filter((_, i)=>i !== index);
        setFormData({
            ...formData,
            funding_sources: new_funding_sources
        });
    };
    const handleSubmit = ()=>{
        console.log('formState', formData);
    };
    const handle_drag_start = (index)=>{
        setDraggedIndex(index);
    };
    const handle_drag_over = (event, index)=>{
        event.preventDefault();
        setDraggedOverIndex(index);
    };
    const handle_drop = (index)=>{
        if (draggedIndex !== null) {
            const new_funding_sources = [
                ...formData.funding_sources
            ];
            const [dragged_item] = new_funding_sources.splice(draggedIndex, 1);
            new_funding_sources.splice(index, 0, dragged_item);
            setFormData({
                ...formData,
                funding_sources: new_funding_sources
            });
        }
        setDraggedIndex(null);
        setDraggedOverIndex(null);
    };
    // Utility function to pluralize label based on count
    function pluralize(count, singular, plural) {
        return `${count} ${count === 1 ? singular : plural}`;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2291beb327d500f8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
            component: "form",
            // sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate: true,
            autoComplete: "off",
            onSubmit: handleSubmit,
            sx: {
                maxWidth: '100%'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                    children: "Sage Project Allocation and Project Renewal Request"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                    icon: "1",
                    label: "Which type of request would you like to make?"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.Step), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
                        value: reqType,
                        onChange: (evt, val)=>setReqType(val),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                value: "testbed",
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                label: "Request access to developer testbed (most new users start here)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                value: "add",
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                label: "Request access to specific nodes or projects"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                value: "file_access",
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                label: "Requests access to protected data sets"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                value: "renew",
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                label: "Restore expired access/permissions"
                            })
                        ]
                    })
                }),
                formSpec && [
                    'testbed',
                    'add',
                    'renew',
                    'file_access'
                ].includes(reqType) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                            icon: "2",
                            label: $d2a7ba9b3a050904$var$getProjectSelectionLabel(reqType)
                        }),
                        [
                            'testbed'
                        ].includes(reqType) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.Step), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "flex gap",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex column",
                                    style: {
                                        width: '100%'
                                    },
                                    children: nodes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.Step), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                                            primaryKey: "id",
                                            checkboxes: true,
                                            columns: $d2a7ba9b3a050904$var$columns,
                                            rows: reqType == 'testbed' ? formSpec.projects.filter((project)=>project.name.toLowerCase().includes('testbed')) : formSpec.projects
                                        })
                                    })
                                })
                            })
                        }),
                        [
                            'add',
                            'file_access'
                        ].includes(reqType) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.Step), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex gap",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "flex column",
                                        style: {
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                                multiple: true,
                                                loading: !nodes,
                                                options: nodes,
                                                getOptionLabel: (option)=>{
                                                    const main = option.vsn || option.node || String(option);
                                                    return main;
                                                },
                                                renderOption: (props, option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        ...props,
                                                        style: {
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: option.vsn + (option.site_id ? '| ' + option.site_id : '') || option.node || String(option)
                                                            }),
                                                            (option.city || option.state) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                style: {
                                                                    color: '#aaa',
                                                                    fontSize: '0.95em',
                                                                    marginLeft: 12,
                                                                    marginRight: 4,
                                                                    flexShrink: 0
                                                                },
                                                                children: [
                                                                    option.city.split(',')[0],
                                                                    option.city && option.state ? ', ' : '',
                                                                    option.state
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                value: formData.selected_nodes,
                                                onChange: (_, newValue)=>{
                                                    setFormData((prev)=>({
                                                            ...prev,
                                                            selected_nodes: newValue
                                                        }));
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                        ...params,
                                                        label: "Nodes (multiple allowed)",
                                                        margin: "normal",
                                                        fullWidth: true
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    margin: '16px 0',
                                                    fontWeight: 500,
                                                    color: '#888',
                                                    letterSpacing: 1,
                                                    textTransform: 'uppercase'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            flex: 1,
                                                            borderBottom: '1px solid #ddd',
                                                            marginRight: 12
                                                        }
                                                    }),
                                                    "OR",
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        style: {
                                                            flex: 1,
                                                            borderBottom: '1px solid #ddd',
                                                            marginLeft: 12
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                                multiple: true,
                                                loading: !formSpec?.projects,
                                                options: formSpec.projects || [],
                                                getOptionLabel: (option)=>option.name ? `${option.name} (${pluralize(option.number_of_users || 0, 'user', 'users')}, ${pluralize(option.number_of_nodes || 0, 'node', 'nodes')})` : String(option),
                                                value: formData.selected_projects,
                                                onChange: (_, newValue)=>{
                                                    console.log('newValue', newValue);
                                                    setFormData((prev)=>({
                                                            ...prev,
                                                            selected_nodes: newValue.reduce((acc, project)=>project.nodes ? [
                                                                    ...acc,
                                                                    ...project.nodes
                                                                ] : acc, []),
                                                            selected_projects: newValue
                                                        }));
                                                },
                                                renderOption: (props, option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                        ...props,
                                                        style: {
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                children: option.name
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                                style: {
                                                                    color: '#aaa',
                                                                    fontSize: '0.95em',
                                                                    marginLeft: 12,
                                                                    marginRight: 4,
                                                                    flexShrink: 0,
                                                                    whiteSpace: 'nowrap'
                                                                },
                                                                children: [
                                                                    pluralize(option.number_of_users || 0, 'user', 'users'),
                                                                    ", ",
                                                                    pluralize(option.number_of_nodes || 0, 'node', 'nodes')
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                        ...params,
                                                        label: "Projects (multiple allowed)",
                                                        margin: "normal",
                                                        fullWidth: true
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                                variant: "subtitle1",
                                                sx: {
                                                    mt: 2,
                                                    mb: 1
                                                },
                                                children: "Select the permissions you are requesting for these nodes:"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex column gap",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                                            name: "running_apps",
                                                            checked: formData.running_apps,
                                                            onChange: handle_checkbox_change
                                                        }),
                                                        label: "Running apps (Includes SageChat/LLMS)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                                            name: "shell_access",
                                                            checked: formData.shell_access,
                                                            onChange: handle_checkbox_change
                                                        }),
                                                        label: "Shell (SSH Access)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5xexf.default), {
                                                            name: "data_download",
                                                            checked: formData.data_download,
                                                            onChange: handle_checkbox_change
                                                        }),
                                                        label: "Downloading protected data sets (files)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    nodes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                                        data: formData.selected_nodes.length ? formData.selected_nodes : nodes,
                                        markerClass: 'blue-dot',
                                        updateID: JSON.stringify(formData.selected_nodes)
                                    })
                                ]
                            })
                        })
                    ]
                }),
                [
                    'testbed',
                    'add',
                    'file_access'
                ].includes(reqType) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3X9tg.StepTitle), {
                            icon: "3",
                            label: "Project Information"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $3X9tg.Step), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ccc0421702a0be$export$2e2bcd8739ae039), {}),
                                    name: "use_profile_info",
                                    checked: formData.use_profile_info,
                                    onChange: handleUseProfileInfo,
                                    label: "I'm the Principal Investigator (PI)"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        maxWidth: '300px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "PI Name",
                                            name: "pi_name",
                                            margin: "normal",
                                            fullWidth: true,
                                            onChange: handleChange,
                                            disabled: formData.use_profile_info,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            },
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "PI Email",
                                            name: "pi_email",
                                            margin: "normal",
                                            fullWidth: true,
                                            value: formData.pi_email,
                                            onChange: handleChange,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            },
                                            required: true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "PI Institution",
                                            name: "pi_institution",
                                            fullWidth: true,
                                            margin: "normal",
                                            value: formData.pi_institution,
                                            onChange: handleChange,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            },
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03mUs.default), {
                                    sx: {
                                        maxWidth: '50%'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                        label: "Project Title",
                                        name: "project_title",
                                        fullWidth: true,
                                        margin: "normal",
                                        placeholder: "A short description; used to find your project",
                                        value: formData.project_title,
                                        onChange: handleChange,
                                        slotProps: {
                                            inputLabel: {
                                                shrink: true
                                            }
                                        },
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Project Short Name",
                                    name: "project_short_name",
                                    margin: "normal",
                                    value: formData.project_short_name,
                                    onChange: handleChange,
                                    slotProps: {
                                        inputLabel: {
                                            shrink: true
                                        },
                                        htmlInput: {
                                            maxLength: 16
                                        }
                                    },
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03mUs.default), {
                                    sx: {
                                        maxWidth: '400px'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                            label: "Project Website",
                                            name: "project_website",
                                            fullWidth: true,
                                            margin: "normal",
                                            value: formData.project_website,
                                            onChange: handleChange,
                                            slotProps: {
                                                inputLabel: {
                                                    shrink: true
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                            multiple: true,
                                            loading: !formSpec,
                                            options: formSpec?.science_fields || [],
                                            value: formData.science_field ? formData.science_field.split(',').filter(Boolean) : [],
                                            onChange: (_, newValue)=>{
                                                setFormData((prev)=>({
                                                        ...prev,
                                                        science_field: newValue.join(',')
                                                    }));
                                            },
                                            renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    ...params,
                                                    label: "Science field; select all that apply",
                                                    margin: "normal",
                                                    fullWidth: true
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle1",
                                    sx: {
                                        mt: 2,
                                        mb: 1
                                    },
                                    children: "Is this project related to a proposal to be submitted?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
                                    row: true,
                                    name: "related_to_proposal",
                                    value: formData.related_to_proposal,
                                    onChange: (event)=>handleChange(event),
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            value: "Yes",
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                            label: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            value: "No",
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                            label: "No"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle1",
                                    sx: {
                                        mt: 2,
                                        mb: 1
                                    },
                                    children: "Are you interested in using HPC (ACCESS-CI) resources?"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $659f9ff12b4e3755$export$2e2bcd8739ae039), {
                                    row: true,
                                    "aria-required": "true",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            value: "yes",
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                            label: "Yes"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2esSG.default), {
                                            value: "no",
                                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb3af4fea2cad44e$export$2e2bcd8739ae039), {}),
                                            label: "No"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                                    variant: "subtitle1",
                                    sx: {
                                        mt: 2,
                                        mb: 1
                                    },
                                    children: "Please list any applicable project funding sources:"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: formData.funding_sources.map((funding, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                draggedOverIndex === index && /*#__PURE__*/ (0, $ayMG0.jsx)($d2a7ba9b3a050904$var$DropIndicator, {
                                                    isVisible: true
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)($d2a7ba9b3a050904$var$DraggableContainer, {
                                                    draggable: true,
                                                    onDragStart: ()=>handle_drag_start(index),
                                                    onDragOver: (event)=>handle_drag_over(event, index),
                                                    onDrop: ()=>handle_drop(index),
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fb6cdd207b8a1a5$export$2e2bcd8739ae039), {
                                                            sx: {
                                                                opacity: 0.5
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                            label: "Source/Institution",
                                                            name: "source",
                                                            value: funding.source,
                                                            fullWidth: true,
                                                            onChange: (e)=>handleChange(e, index)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                            label: "Grant Number/ID",
                                                            name: "grant_number",
                                                            value: funding.grant_number,
                                                            fullWidth: true,
                                                            onChange: (e)=>handleChange(e, index)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                                            variant: "outlined",
                                                            color: "error",
                                                            onClick: ()=>remove_funding_source(index),
                                                            children: "Remove"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, `funding-${index}`))
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex justify-end",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        variant: "contained",
                                        color: "primary",
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {}),
                                        onClick: add_funding_source,
                                        style: {
                                            marginBottom: 20
                                        },
                                        children: "Add Another Funding Source"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Please provide justification for your access request",
                                    name: "justification",
                                    required: true,
                                    fullWidth: true,
                                    multiline: true,
                                    rows: 4,
                                    margin: "normal",
                                    onChange: handleChange
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                    label: "Do you have any additional comments or questions?",
                                    name: "comments",
                                    fullWidth: true,
                                    multiline: true,
                                    rows: 4,
                                    margin: "normal",
                                    value: formData.comments,
                                    onChange: handleChange,
                                    placeholder: "Any additional information you'd like to provide"
                                })
                            ]
                        })
                    ]
                }),
                reqType && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        placement: "right",
                        title: !formData.pi_name || !formData.pi_email || !formData.project_title ? 'Please fill in all required fields' : 'Submit your request',
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "primary",
                                style: {
                                    marginTop: 20
                                },
                                onClick: handleSubmit,
                                disabled: !reqType || !formData.pi_name || !formData.pi_email || !formData.project_title,
                                children: "Submit!"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
            ]
        })
    });
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");
const $15489347b8d4f86f$var$Container = (0, $d8seH.default)('div')`
  display: flex;
`;
const $15489347b8d4f86f$var$Sidebar = (0, $d8seH.default)('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : 'rgb(255, 255, 255)'};
  border-right: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#ddd'};
  width: ${(props)=>props.width}px;
  overflow-y: hidden;
  padding: 1rem;
  z-index: 9;

  .MuiPaper-root {
    box-shadow: rgb(229 229 229) 2px 3px 9px 1px;
  }
`;
const $15489347b8d4f86f$var$Resizer = (0, $d8seH.default)('div')`
  width: 2px;
  cursor: col-resize;
  background-color: #ccc;
`;
const $15489347b8d4f86f$var$ResizableSidebar = (props)=>{
    const { children: children, sx: sx } = props;
    const [width, setWidth] = (0, $acw62.useState)(330);
    const resizerRef = (0, $acw62.useRef)(null);
    const sidebarRef = (0, $acw62.useRef)(null);
    const onMouseDown = (e)=>{
        e.preventDefault();
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };
    const onMouseMove = (e)=>{
        const newWidth = e.clientX - sidebarRef.current.getBoundingClientRect().left;
        setWidth(newWidth);
    };
    const onMouseUp = ()=>{
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($15489347b8d4f86f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($15489347b8d4f86f$var$Sidebar, {
                ref: sidebarRef,
                width: width,
                sx: sx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        flexGrow: 1
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($15489347b8d4f86f$var$Resizer, {
                ref: resizerRef,
                onMouseDown: onMouseDown
            })
        ]
    });
};
var $15489347b8d4f86f$export$2e2bcd8739ae039 = $15489347b8d4f86f$var$ResizableSidebar;



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $9Lykx = parcelRequire("9Lykx");
var $iAtns = parcelRequire("iAtns");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a605783289b1e7bb$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4"
}), 'ClearRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $835541c908c9e78a$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m3.4 20.4 17.45-7.48c.81-.35.81-1.49 0-1.84L3.4 3.6c-.66-.29-1.39.2-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91"
}), 'SendRounded');


function $9f037fe6473ad5c3$export$2e2bcd8739ae039(props) {
    const { value: value, onChange: onChange, onSubmit: onSubmit, loading: loading } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9f037fe6473ad5c3$var$InputRoot, {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                id: "prompt-input",
                value: value,
                onChange: (evt)=>onChange(evt.target.value),
                slotProps: {
                    input: {
                        endAdornment: !!value.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                            onClick: ()=>onChange(''),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a605783289b1e7bb$export$2e2bcd8739ae039), {
                                fontSize: "small"
                            })
                        })
                    }
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                onClick: onSubmit,
                sx: {
                    marginLeft: '5px'
                },
                color: "primary",
                disabled: loading,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $835541c908c9e78a$export$2e2bcd8739ae039), {})
            })
        ]
    });
}
const $9f037fe6473ad5c3$var$InputRoot = (0, $lmFrL.default).div`
  margin: 25px 0 15px 0;
`;



var $hw4Z0 = parcelRequire("hw4Z0");
const $8bac61b531ddd526$export$be0ed89277983962 = 'Describe what you see in detail.';
const $8bac61b531ddd526$var$getDefaultSpec = (prompt = $8bac61b531ddd526$export$be0ed89277983962, vsn = 'W023')=>`
name: assistant-demo
plugins:
- name: moondream-demo
  pluginSpec:
    image: registry.sagecontinuum.org/seanshahkarami/moondream-demo:0.2.0
    args:
    - --camera
    - top_camera
    - --model
    - moondream-0_5b-int8.mf.gz
    - ${prompt}
    selector:
      zone: core
    resource:
      limit.cpu: "2"
      limit.memory: 4Gi
      request.cpu: "2"
      request.memory: 4Gi
nodeTags: []
nodes:
  ${vsn}: true
scienceRules:
- 'schedule(moondream-demo): True'
successCriteria:
- WallClock(1d)
`;
var $8bac61b531ddd526$export$2e2bcd8739ae039 = $8bac61b531ddd526$var$getDefaultSpec;



var $b8Rua = parcelRequire("b8Rua");

var $gA7Iw = parcelRequire("gA7Iw");

var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $6ami2 = parcelRequire("6ami2");

function $96b39379336a6ea8$export$2e2bcd8739ae039(props) {
    const { onClick: onClick } = props;
    const handleClick = (evt)=>{
        onClick(evt.target.innerText);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($96b39379336a6ea8$var$Root, {
        className: "flex gap",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: (0, $8bac61b531ddd526$export$be0ed89277983962),
                onClick: handleClick
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: "What objects are in the view?",
                onClick: handleClick
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6ami2.default), {
                label: "Is there anything unusual or dangerous?",
                onClick: handleClick
            })
        ]
    });
}
const $96b39379336a6ea8$var$Root = (0, $lmFrL.default).div`

  margin-right: 50px;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $gTmRg = parcelRequire("gTmRg");

var $lkxXU = parcelRequire("lkxXU");
var $9Lykx = parcelRequire("9Lykx");
var $6el2W = parcelRequire("6el2W");
var $cVXaD = parcelRequire("cVXaD");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f02d8a377351c6aa$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1q-.15.15-.15.36M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'EditRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $09178ea933e16267$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 16c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1m2-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m2-4c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1"
}), 'PauseCircleOutlineRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $076527662dc09ecc$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m10.8 15.9 4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1c-.33-.25-.8-.01-.8.4v7c0 .41.47.65.8.4M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'PlayCircleOutlineRounded');



var $b8Rua = parcelRequire("b8Rua");

var $24m81 = parcelRequire("24m81");



var $ioNxW = parcelRequire("ioNxW");
function $fe7d232523124060$export$2e2bcd8739ae039(props) {
    const { value: tasks, onChange: onChange } = props;
    const { enqueueSnackbar: enqueueSnackbar } = (0, $24m81.useSnackbar)();
    const { loading: loading, setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [anchorEl, setAnchorEl] = (0, $acw62.useState)(null);
    const [selectorEl, setSelectorEl] = (0, $acw62.useState)(null);
    const handleChange = async (action, task)=>{
        const { job_id: job_id } = task;
        if (action == 'run') {
            await handleRunJob(job_id);
            return tasks;
        } else if (action == 'suspend') {
            await handleSuspendJob(job_id);
            return tasks;
        } else if (action == 'remove') {
            await handleRemoveJob(task.job_id);
            onChange(tasks.filter((obj)=>obj.job_id != job_id));
        } else throw `action "${action}" not implemented`;
    };
    const handleRunJob = (id)=>{
        setLoading(true);
        return $b8Rua.resubmitJobs(id).then(()=>{
            enqueueSnackbar(`Prompt restarted`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to resubmit at least one prompt",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 7000
            });
        }).finally(()=>{
            setLoading(false);
        });
    };
    const handleSuspendJob = (id)=>{
        setLoading(true);
        return $b8Rua.suspendJob(id).then(()=>{
            enqueueSnackbar(`One prompt suspended`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to suspend prompt",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 5000
            });
        }).finally(()=>{
            setLoading(false);
        });
    };
    const handleRemoveJob = (id)=>{
        setLoading(true);
        return $b8Rua.removeJob(id).then(()=>{
            enqueueSnackbar(`One prompt removed`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to remove prompt",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 7000
            });
        }).finally(()=>{
            setLoading(false);
        });
    };
    const handleOpenDetails = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    // const handleEditNode = (vsn: VSN) => {
    //   onEditNode(vsn)
    // }
    const handleOpenNodeSelector = (event)=>{
        setSelectorEl(event.currentTarget);
    };
    const handleCloseNodeSelector = ()=>{
        setSelectorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'task-meta-info-popover' : undefined;
    const openNodeSelector = Boolean(selectorEl);
    const nodeSelectorId = openNodeSelector ? 'node-selector-popover' : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fe7d232523124060$var$TaskList, {
        className: "list-none no-padding",
        children: tasks.map((task)=>{
            const { fullJobSpec: fullJobSpec } = task;
            const node = Object.keys(fullJobSpec.nodes) // todo(nc): support multiple
            ;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                    style: {
                        paddingBottom: 5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: task.prompt || 'No prompt specified'
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                    title: "Show task details...",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                        onClick: handleOpenDetails,
                                        size: "small",
                                        className: "info-btn",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf6866e33a4a25da$export$2e2bcd8739ae039), {
                                            fontSize: "small",
                                            sx: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "flex column gap-2",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                                            id: id,
                                            open: open,
                                            anchorEl: anchorEl,
                                            onClose: handleClose,
                                            anchorOrigin: {
                                                vertical: 'top',
                                                horizontal: 'right'
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left'
                                            },
                                            sx: {
                                                height: '75%'
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fdca79f03e679c4$export$39dbc3f558091353), {
                                                theme: (0, $0fdca79f03e679c4$export$d9a33280f07116d9).dracula,
                                                language: "json",
                                                code: JSON.stringify(fullJobSpec, null, 2),
                                                children: ({ className: className, style: style, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                                        className: className,
                                                        style: {
                                                            ...style,
                                                            fontSize: '.85em'
                                                        },
                                                        children: tokens.map((line, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                ...getLineProps({
                                                                    line: line,
                                                                    key: i
                                                                }),
                                                                children: line.map((token, key)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                        ...getTokenProps({
                                                                            token: token,
                                                                            key: key
                                                                        })
                                                                    }, key))
                                                            }, i))
                                                    })
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex items-center gap",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: task.state.toLowerCase(),
                                            children: task.state
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                            orientation: "vertical",
                                            flexItem: true,
                                            style: {
                                                margin: '5px'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                    href: `/nodes/${node}`,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: node
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                    onClick: handleOpenNodeSelector,
                                                    size: "small",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f02d8a377351c6aa$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6el2W.default), {
                                                    id: nodeSelectorId,
                                                    open: openNodeSelector,
                                                    anchorEl: selectorEl,
                                                    onClose: handleCloseNodeSelector,
                                                    anchorOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'left'
                                                    },
                                                    sx: {
                                                        height: '75%',
                                                        width: '1200px'
                                                    },
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($fe7d232523124060$var$NodeSelectorContainer, {
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ioNxW.default), {
                                                            selected: [],
                                                            onSelected: ()=>{}
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lkxXU.default), {
                                    orientation: "vertical",
                                    flexItem: true,
                                    style: {
                                        margin: '5px'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        task.state != 'Running' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: `Re-run Prompt`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                onClick: ()=>handleChange('run', task),
                                                size: "small",
                                                disabled: loading,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $076527662dc09ecc$export$2e2bcd8739ae039), {})
                                            })
                                        }),
                                        task.state != 'Suspended' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Suspend",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                onClick: ()=>handleChange('suspend', task),
                                                size: "small",
                                                disabled: loading,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09178ea933e16267$export$2e2bcd8739ae039), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                            title: "Remove",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                onClick: ()=>handleChange('remove', task),
                                                className: "danger",
                                                size: "small",
                                                disabled: loading,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65ebd81691801e03$export$2e2bcd8739ae039), {})
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, task.job_id);
        })
    });
}
const $fe7d232523124060$var$TaskList = (0, $lmFrL.default).ul`
  li {
    margin: 0 0 10px 0;
    position: relative;
  }

  .info-btn {
    position: absolute;
    right: 5px;
    top: 5px;
  }

  // todo: hover animations, etc
  .btn-controls {
    visibility: hidden;
  }

  &:hover .btn-controls {
    visibility: visible;
  }
`;
const $fe7d232523124060$var$NodeSelectorContainer = (0, $lmFrL.default).div`
  margin: 20px;
  width: 1200px;
`;



var $24m81 = parcelRequire("24m81");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $bcnr1 = parcelRequire("bcnr1");

var $7UqNi = parcelRequire("7UqNi");
var $2mdyF = parcelRequire("2mdyF");
var $2gURC = parcelRequire("2gURC");
var $3bYfT = parcelRequire("3bYfT");

var $hbZ6O = parcelRequire("hbZ6O");
/**
 * simple helper to render an object once it's ready (uploaded)
 */ 
var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bcnr1 = parcelRequire("bcnr1");
function $9ad99a66dd462081$export$2e2bcd8739ae039(props) {
    const { url: url, retry: retry } = props;
    const [ready, setReady] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!url || !retry) return;
        $bcnr1.retryHead(url).then((res)=>{
            setReady(true);
        }).catch(()=>{
        // todo: fallback gracefully
        });
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            !retry && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: url
            }),
            ready && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: url
            }),
            retry && !ready && 'loading...'
        ]
    });
}


var $52f57372ac88ecf5$exports = {};
$52f57372ac88ecf5$exports = import.meta.resolve("4efBs");


function $6550ffa141c1bd29$export$ffaef007cc317773(a, b) {
    if (a.timestamp == b.timestamp) {
        if (b.name == 'upload') return -1;
    }
    return a.timestamp.localeCompare(b.timestamp);
}



var $lffEs = parcelRequire("lffEs");
function $dec9e5430a5e540d$var$Response(props) {
    const { record: record, showImage: showImage } = props;
    const { value: value } = record;
    const [expanded, setExpanded] = (0, $acw62.useState)(showImage);
    const handleChange = (_, open)=>{
        setExpanded(open);
    };
    let ele = 'loading...';
    if (typeof value == 'object' && value) ele = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "font-medium no-margin",
                children: value.answer
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "muted text-xs",
                children: (0, $lffEs.relativeTime)(record.timestamp)
            })
        ]
    });
    else if (typeof value == 'string' && value.includes('https://')) ele = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7UqNi.default), {
        expanded: expanded,
        onChange: handleChange,
        className: "upload",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2gURC.default), {
                expandIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hbZ6O))), {}),
                "aria-controls": "panel1-content",
                id: "panel1-header",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bYfT.default), {
                    component: "span",
                    children: "Image"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2mdyF.default), {
                children: expanded && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ad99a66dd462081$export$2e2bcd8739ae039), {
                    url: value,
                    retry: true
                })
            })
        ]
    });
    else ele = value;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: ele
    });
}
var $dec9e5430a5e540d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)(function Feed(props) {
    const { tasks: tasks, isRunning: isRunning } = props;
    const [data, setData] = (0, $acw62.useState)();
    // get history of data
    (0, $acw62.useEffect)(()=>{
        if (!tasks.length) return;
        const { fullJobSpec: fullJobSpec } = tasks[0];
        const { nodes: nodes, plugins: plugins } = fullJobSpec;
        const vsns = Object.keys(nodes);
        // assume one app, for now
        const task = plugins[0].name;
        // first, get previous data
        $bcnr1.getData({
            start: '-1d',
            filter: {
                vsn: vsns.join('|'),
                task: task
            }
        }).then((res)=>{
            let d = res.sort((0, $6550ffa141c1bd29$export$ffaef007cc317773));
            d = res.map((obj)=>{
                try {
                    obj.value = JSON.parse(obj.value);
                } catch (e) {
                // do nothing if not json
                }
                return obj;
            });
            setData(d);
        });
    }, [
        tasks
    ]);
    // once we have historical data, start eventSource streaming
    (0, $acw62.useEffect)(()=>{
        if (!tasks.length) return;
        const { fullJobSpec: fullJobSpec } = tasks[0];
        const { nodes: nodes, plugins: plugins } = fullJobSpec;
        const vsns = Object.keys(nodes);
        // assume one app, for now
        const task = plugins[0].name;
        const eventSource = $bcnr1.createEventSource({
            vsn: vsns.join('|'),
            task: task
        });
        eventSource.onerror = function(e) {
            console.log('err', e);
        };
        eventSource.onmessage = function(e) {
            const obj = JSON.parse(e.data);
            try {
                obj.value = JSON.parse(obj.value);
            } catch (e) {
            // do nothing if not json
            }
            setData((prev)=>[
                    ...prev,
                    obj
                ].sort((0, $6550ffa141c1bd29$export$ffaef007cc317773)));
        };
        return ()=>{
            eventSource.close();
        };
    }, [
        data,
        tasks
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($dec9e5430a5e540d$var$Root, {
        id: "responses",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($dec9e5430a5e540d$var$PromptBubble, {
                    children: tasks[0]?.prompt
                })
            }),
            data?.map((record, i)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "response",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($dec9e5430a5e540d$var$Response, {
                        record: record,
                        showImage: i > data.length - 5 * 2
                    })
                }, i);
            }),
            isRunning && /*#__PURE__*/ (0, $ayMG0.jsxs)($dec9e5430a5e540d$var$LoadingBee, {
                className: "flex column items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($52f57372ac88ecf5$exports)))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Working on a response..."
                    })
                ]
            })
        ]
    });
}, (prev, next)=>JSON.stringify(prev.tasks) == JSON.stringify(next.tasks));
const $dec9e5430a5e540d$var$Root = (0, $lmFrL.default).div`
  max-width: 960px;
  padding: 40px;
  margin-bottom: 170px;

  .response {
    margin-bottom: 10px;

    img {
      max-width: 800px;
    }
  }

  .response .upload {
    margin-bottom: 40px;
  }
`;
const $dec9e5430a5e540d$var$PromptBubble = (0, $lmFrL.default).div`
  background: #c6b9ff;
  padding: 5px;
  margin: 1rem 0;
  border-radius: 5px;
  font-weight: bold;
`;
const $dec9e5430a5e540d$var$LoadingBee = (0, $lmFrL.default).div`
  img {
    max-width: 20%;
  }
`;


const $31ce2fc7a5cf14e5$var$storageKey = 'sage-assistant';
const $31ce2fc7a5cf14e5$var$getTasks = ()=>JSON.parse($gA7Iw.get($31ce2fc7a5cf14e5$var$storageKey));
function $31ce2fc7a5cf14e5$export$2e2bcd8739ae039() {
    const { enqueueSnackbar: enqueueSnackbar } = (0, $24m81.useSnackbar)();
    const [prompt, setPrompt] = (0, $acw62.useState)('');
    const [submitting, setSubmitting] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const [lastUpdate, setLastUpdate] = (0, $acw62.useState)(null);
    const [tasks, setTasks] = (0, $acw62.useState)([]);
    // const [showNodeSelector, setShowNodeSelector] = useState(false)
    // const [loading, setLoading] = useState(false)
    (0, $acw62.useEffect)(()=>{
        let done = false;
        let handle;
        // get latest metrics
        function ping() {
            handle = setTimeout(async ()=>{
                if (done) return;
                // recursive
                updateJobState();
            }, 5000);
        }
        const updateJobState = async ()=>{
            const tasks = $31ce2fc7a5cf14e5$var$getTasks() || [];
            const id = tasks.length ? tasks[0].job_id : null;
            if (!id) return;
            let job;
            try {
                // setLoading(true)
                job = await $b8Rua.getJobStatus(id);
            } catch  {
                console.log('err', job);
                setError(job);
            }
            setLastUpdate(new Date());
            // setLoading(false)
            const oldRecord = tasks.filter((obj)=>obj.job_id != job.job_id);
            const newRecord = {
                job_id: job.job_id,
                job_name: job.name,
                prompt: job.plugins[0]?.plugin_spec?.args.pop(),
                state: job.state.last_state,
                fullJobSpec: job
            };
            const records = [
                ...oldRecord,
                newRecord
            ];
            // LS.set(storageKey, records)
            setTasks(records);
            ping();
        };
        updateJobState();
        return ()=>{
            done = true;
            clearTimeout(handle);
        };
    }, []);
    const handleFeedUpdate = ()=>{
        function updateGradientHeight() {
            const scrollableDiv = document.getElementById('main');
            const gradientBg = document.getElementById('gradientBg');
            // Set gradient height to the full scrollable content height
            gradientBg.style.height = scrollableDiv.scrollHeight + 'px';
        }
        // Run on page load & whenever content changes
        window.onload = updateGradientHeight;
        window.addEventListener('resize', updateGradientHeight);
        new ResizeObserver(updateGradientHeight).observe(document.getElementById('main'));
        function scrollToBottom() {
            const objDiv = document.getElementById('main');
            if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
        }
        new ResizeObserver(scrollToBottom).observe(document.getElementById('main'));
    };
    const handleSubmit = ()=>{
        setSubmitting(true);
        const tasks = $31ce2fc7a5cf14e5$var$getTasks() || [];
        // consider single task for now
        const id = tasks.length ? tasks[0].job_id : null;
        // if job exists, restart it
        if (id) $b8Rua.editJob(id, (0, $8bac61b531ddd526$export$2e2bcd8739ae039)(prompt, 'W027')).then((res)=>{
            const oldRecords = $31ce2fc7a5cf14e5$var$getTasks() || [];
            const newRecord = {
                ...res,
                prompt: prompt
            };
            const records = [
                ...oldRecords,
                newRecord
            ];
            $gA7Iw.set($31ce2fc7a5cf14e5$var$storageKey, records);
            setTasks(records);
            enqueueSnackbar(`Job resubmitted`, {
                variant: 'success'
            });
        }).catch((err)=>{
            enqueueSnackbar(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    "Failed to resubmit at least one job",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    err.message
                ]
            }), {
                variant: 'error',
                autoHideDuration: 7000
            });
        }).finally(()=>{
        // setLoading(false)
        });
        else // otherwise, start a new one
        $b8Rua.submitJob((0, $8bac61b531ddd526$export$2e2bcd8739ae039)(prompt, 'W027')).then((res)=>{
            const oldRecords = $31ce2fc7a5cf14e5$var$getTasks() || [];
            const newRecord = {
                ...res,
                prompt: prompt
            };
            const records = [
                ...oldRecords,
                newRecord
            ];
            $gA7Iw.set($31ce2fc7a5cf14e5$var$storageKey, records);
            setTasks(records);
        }).catch((err)=>setError(err)).finally(()=>setSubmitting(false));
    };
    const handleDefaultPrompt = (val)=>{
        setPrompt(val);
    };
    const handleTaskChange = (tasks)=>{
        $gA7Iw.set($31ce2fc7a5cf14e5$var$storageKey, tasks);
        setTasks(tasks);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($31ce2fc7a5cf14e5$var$Root, {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $15489347b8d4f86f$export$2e2bcd8739ae039), {
                width: 275,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                        className: "flex justify-between items-end",
                        children: [
                            "Tasks",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                                children: lastUpdate?.toLocaleTimeString('en-US')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe7d232523124060$export$2e2bcd8739ae039), {
                        value: tasks,
                        onChange: handleTaskChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($31ce2fc7a5cf14e5$var$Main, {
                className: "flex column items-center w-full",
                id: "main",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($31ce2fc7a5cf14e5$var$Title, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: "SageChat"
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                                children: error.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($31ce2fc7a5cf14e5$var$PromptContainer, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex column",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $96b39379336a6ea8$export$2e2bcd8739ae039), {
                                    onClick: handleDefaultPrompt
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f037fe6473ad5c3$export$2e2bcd8739ae039), {
                                    value: prompt,
                                    onChange: (val)=>setPrompt(val),
                                    onSubmit: handleSubmit,
                                    loading: submitting
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "gradient-bg",
                        id: "gradientBg"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dec9e5430a5e540d$export$2e2bcd8739ae039), {
                        tasks: tasks,
                        onFeedUpdate: handleFeedUpdate,
                        isRunning: !!tasks.find((task)=>task.state == 'Running')
                    })
                ]
            })
        ]
    });
}
const $31ce2fc7a5cf14e5$var$Root = (0, $lmFrL.default).div`
  height: 100%;
//  background: linear-gradient(0deg, #ece3ff 0%, #fefdff 100%);
`;
const $31ce2fc7a5cf14e5$var$boxShadow = `
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow:
    0px 2px 4px -1px rgb(0 0 0 / 0%),
    0px 4px 5px 0px rgb(0 0 0 / 0%),
    0px 1px 10px 0px rgb(0 0 0 / 12%);
`;
const $31ce2fc7a5cf14e5$var$Title = (0, $lmFrL.default).div`
  ${$31ce2fc7a5cf14e5$var$boxShadow}

  position: sticky;
  top: 0;
  z-index: 1;
  width: 100%;
  background: #fff;

  h3 {
    margin: .5rem 1rem;
  }
`;
const $31ce2fc7a5cf14e5$var$Main = (0, $lmFrL.default).div`
  padding: 0 0;
  overflow-y: scroll;

  position: relative; /* Needed for pseudo-element */

  /* Gradient applied dynamically */
  .gradient-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, #faf8ff 0%, #ffffff 100%);
    z-index: -1; /* Place behind content */
  }
`;
const $31ce2fc7a5cf14e5$var$PromptContainer = (0, $lmFrL.default).div`
  ${$31ce2fc7a5cf14e5$var$boxShadow}

  position: sticky;
  top: calc(100% - 200px);
  z-index: 1;

  background: #fff;

  padding: 20px;
  margin: 20px;
  border-radius: 10px;
  background: #fff;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $d8seH = parcelRequire("d8seH");


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $5dd29340d28cbf56$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 13h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1m0 8h6c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1m10 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1M13 4v4c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1"
}), 'DashboardRounded');




var $hw4Z0 = parcelRequire("hw4Z0");
parcelRequire("ayMG0");


var $c3pId = parcelRequire("c3pId");
const $5690f41a9afaa56f$var$isSignedIn = (0, $c3pId.default).isSignedIn;
function $5690f41a9afaa56f$export$2e2bcd8739ae039({ children: children }) {
    if ($5690f41a9afaa56f$var$isSignedIn) return children;
    window.location.href = `${(0, $c3pId.default).url}/?callback=${window.location.href}`;
}



var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f151bb123da2b40c$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 8h4V4H4zm6 12h4v-4h-4zm-6 0h4v-4H4zm0-6h4v-4H4zm6 0h4v-4h-4zm6-10v4h4V4zm-6 4h4V4h-4zm6 6h4v-4h-4zm0 6h4v-4h-4z"
}), 'AppsRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bfb67bbdcacf5fc3$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M13 10H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1m0-4H3c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1M3 16h6c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1m19.21-3.79.09.09c.39.39.39 1.02 0 1.41l-5.58 5.59c-.39.39-1.02.39-1.41 0l-3.09-3.09a.996.996 0 0 1 0-1.41l.09-.09c.39-.39 1.02-.39 1.41 0l2.3 2.3 4.78-4.79c.38-.4 1.02-.4 1.41-.01"
}), 'PlaylistAddCheckRounded');



var $c3pId = parcelRequire("c3pId");
function $e684b54e49027cf9$export$2e2bcd8739ae039({ uniqueNodes: uniqueNodes, totalProjects: totalProjects, uniqueMembers: uniqueMembers, totalApps: totalApps, activeJobs: activeJobs, totalJobs: totalJobs, loading: loading = false }) {
    const formatValue = (value)=>loading || value === undefined ? '...' : value;
    const isLoaded = (value)=>!loading && value !== undefined;
    const jobsLoaded = isLoaded(activeJobs) && isLoaded(totalJobs);
    const hasActiveJobs = jobsLoaded && (activeJobs ?? 0) > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatsContainer, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatsGrid, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatCard, {
                    as: (0, $lzNIT.Link),
                    to: `/user/${(0, $c3pId.default).user}/nodes`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85875d7d213afd89$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatContent, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatValue, {
                                    children: formatValue(uniqueNodes)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatLabel, {
                                    children: [
                                        "My Node",
                                        isLoaded(uniqueNodes) && uniqueNodes !== 1 ? 's' : ''
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatCard, {
                    as: (0, $lzNIT.Link),
                    to: `/user/${(0, $c3pId.default).user}/projects`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdbaae095ceb82e8$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatContent, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatValue, {
                                    children: formatValue(totalProjects)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatLabel, {
                                    children: [
                                        "Project",
                                        isLoaded(totalProjects) && totalProjects !== 1 ? 's' : ''
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatCard, {
                    as: (0, $lzNIT.Link),
                    to: `/user/${(0, $c3pId.default).user}/projects`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efc7aacb001bb1b7$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatContent, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatValue, {
                                    children: formatValue(uniqueMembers)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatLabel, {
                                    children: [
                                        "Team Member",
                                        isLoaded(uniqueMembers) && uniqueMembers !== 1 ? 's' : ''
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatCard, {
                    as: (0, $lzNIT.Link),
                    to: "/apps/my-apps",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f151bb123da2b40c$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatContent, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatValue, {
                                    children: formatValue(totalApps)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatLabel, {
                                    children: [
                                        "App",
                                        isLoaded(totalApps) && totalApps !== 1 ? 's' : ''
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatCard, {
                    as: (0, $lzNIT.Link),
                    to: "/jobs/my-jobs",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfb67bbdcacf5fc3$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($e684b54e49027cf9$var$StatContent, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatValue, {
                                    children: loading || !jobsLoaded ? '...' : hasActiveJobs ? /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$ActiveValue, {
                                        children: activeJobs
                                    }) : totalJobs
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($e684b54e49027cf9$var$StatLabel, {
                                    children: loading || !jobsLoaded ? 'Active Jobs' : hasActiveJobs ? `Active Job${activeJobs !== 1 ? 's' : ''}` : 'Recent Jobs'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $e684b54e49027cf9$var$StatsContainer = (0, $d8seH.default)('div')`
  /* Stats layout */
`;
const $e684b54e49027cf9$var$StatsGrid = (0, $d8seH.default)('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  flex: 1;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
const $e684b54e49027cf9$var$StatCard = (0, $d8seH.default)('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-left: 3px solid ${({ theme: theme })=>theme.palette.primary.main};
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme: theme })=>theme.palette.primary.main};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;
const $e684b54e49027cf9$var$StatIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 3em;
    color: ${({ theme: theme })=>theme.palette.primary.main};
    opacity: 0.9;
  }
`;
const $e684b54e49027cf9$var$StatContent = (0, $d8seH.default)('div')`
  flex: 1;
`;
const $e684b54e49027cf9$var$StatValue = (0, $d8seH.default)('div')`
  font-size: 2em;
  font-weight: bold;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};
  line-height: 1;
  margin-bottom: 0.25rem;
`;
const $e684b54e49027cf9$var$ActiveValue = (0, $d8seH.default)('span')`
  color: ${({ theme: theme })=>theme.palette.success.main};
`;
const $e684b54e49027cf9$var$StatLabel = (0, $d8seH.default)('div')`
  font-size: 0.875em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#999' : '#666'};
  font-weight: 500;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $5RIww = parcelRequire("5RIww");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $df0b33a619f4e8a6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m16.85 6.85 1.44 1.44-4.88 4.88-3.29-3.29a.996.996 0 0 0-1.41 0l-6 6.01c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L9.41 12l3.29 3.29c.39.39 1.02.39 1.41 0l5.59-5.58 1.44 1.44c.31.31.85.09.85-.35V6.5c.01-.28-.21-.5-.49-.5h-4.29c-.45 0-.67.54-.36.85"
}), 'TrendingUpRounded');


function $2de34d652b9d823f$export$2e2bcd8739ae039({ totalApps: totalApps, totalJobs: totalJobs, uniqueNodes: uniqueNodes, totalProjects: totalProjects, loading: loading = false }) {
    const appsCount = totalApps ?? 0;
    const jobsCount = totalJobs ?? 0;
    const nodesCount = uniqueNodes ?? 0;
    const projectsCount = totalProjects ?? 0;
    // Define all achievements
    const allAchievements = [
        {
            id: 'app-creator',
            category: 'apps',
            icon: "\uD83D\uDE80",
            name: 'App Creator',
            description: 'Create your first app',
            progress: appsCount,
            target: 1,
            earned: appsCount >= 1
        },
        {
            id: 'app-master',
            category: 'apps',
            icon: "\u2B50",
            name: 'App Master',
            description: 'Create 5 apps',
            progress: appsCount,
            target: 5,
            earned: appsCount >= 5
        },
        {
            id: 'app-publisher',
            category: 'apps',
            icon: "\uD83D\uDCE6",
            name: 'App Publisher',
            description: 'Create 10 apps',
            progress: appsCount,
            target: 10,
            earned: appsCount >= 10
        },
        {
            id: 'job-runner',
            category: 'jobs',
            icon: "\uD83D\uDD25",
            name: 'Job Runner',
            description: 'Run 10 jobs',
            progress: jobsCount,
            target: 10,
            earned: jobsCount >= 10
        },
        {
            id: 'power-user',
            category: 'jobs',
            icon: "\uD83D\uDC8E",
            name: 'Power User',
            description: 'Run 50 jobs',
            progress: jobsCount,
            target: 50,
            earned: jobsCount >= 50
        },
        {
            id: 'job-expert',
            category: 'jobs',
            icon: "\uD83C\uDFC6",
            name: 'Job Expert',
            description: 'Run 100 jobs',
            progress: jobsCount,
            target: 100,
            earned: jobsCount >= 100
        },
        {
            id: 'network-builder',
            category: 'nodes',
            icon: "\uD83C\uDF10",
            name: 'Network Builder',
            description: 'Access 3+ nodes',
            progress: nodesCount,
            target: 3,
            earned: nodesCount >= 3
        },
        {
            id: 'node-collector',
            category: 'nodes',
            icon: "\uD83C\uDFAF",
            name: 'Node Collector',
            description: 'Access 10+ nodes',
            progress: nodesCount,
            target: 10,
            earned: nodesCount >= 10
        },
        {
            id: 'team-player',
            category: 'projects',
            icon: "\uD83E\uDD1D",
            name: 'Team Player',
            description: 'Join 2+ projects',
            progress: projectsCount,
            target: 2,
            earned: projectsCount >= 2
        },
        {
            id: 'community-builder',
            category: 'projects',
            icon: "\uD83C\uDF1F",
            name: 'Community Builder',
            description: 'Join 5+ projects',
            progress: projectsCount,
            target: 5,
            earned: projectsCount >= 5
        }
    ];
    const [showAllAchievements, setShowAllAchievements] = (0, $acw62.useState)(false);
    // Filter achievements based on toggle
    const highestByCategory = Object.values(allAchievements.reduce((acc, achievement)=>{
        acc[achievement.category] = acc[achievement.category] || [];
        acc[achievement.category].push(achievement);
        return acc;
    }, {})).map((list)=>{
        const sorted = [
            ...list
        ].sort((a, b)=>a.target - b.target);
        const earned = sorted.filter((a)=>a.earned);
        return earned.length > 0 ? earned[earned.length - 1] : sorted[0];
    });
    const displayedAchievements = showAllAchievements ? [
        ...allAchievements
    ].sort((a, b)=>{
        if (a.earned !== b.earned) return a.earned ? -1 : 1;
        return a.target - b.target;
    }) : highestByCategory;
    const earnedCount = loading ? 0 : allAchievements.filter((a)=>a.earned).length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2de34d652b9d823f$var$AchievementsCard, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($2de34d652b9d823f$var$AchievementsHeader, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($2de34d652b9d823f$var$AchievementsTitle, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df0b33a619f4e8a6$export$2e2bcd8739ae039), {}),
                            " Achievements"
                        ]
                    }),
                    !loading && earnedCount < allAchievements.length && !showAllAchievements && /*#__PURE__*/ (0, $ayMG0.jsxs)($2de34d652b9d823f$var$ToggleButton, {
                        onClick: ()=>setShowAllAchievements(true),
                        children: [
                            "Show All (",
                            allAchievements.length - earnedCount,
                            " more)"
                        ]
                    }),
                    !loading && showAllAchievements && /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$ToggleButton, {
                        onClick: ()=>setShowAllAchievements(false),
                        children: "Show Earned"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgesGrid, {
                children: loading ? Array.from({
                    length: 3
                }).map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($2de34d652b9d823f$var$Badge, {
                        earned: false,
                        showAll: false,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgeIcon, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    variant: "circular",
                                    width: 44,
                                    height: 44
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgeName, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    width: 90
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgeProgress, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5RIww.default), {
                                    width: 60
                                })
                            })
                        ]
                    }, `achievement-skeleton-${index}`)) : displayedAchievements.map((achievement)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: achievement.description,
                        placement: "top",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($2de34d652b9d823f$var$Badge, {
                            earned: achievement.earned,
                            showAll: showAllAchievements,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgeIcon, {
                                    children: achievement.icon
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgeName, {
                                    children: achievement.name
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($2de34d652b9d823f$var$BadgeProgress, {
                                    children: `${achievement.progress}/${achievement.target}`
                                })
                            ]
                        })
                    }, achievement.id))
            })
        ]
    });
}
const $2de34d652b9d823f$var$AchievementsCard = (0, $d8seH.default)('div')`
  min-width: 450px;
  max-width: 450px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1200px) {
    min-width: 100%;
    max-width: 100%;
  }
`;
const $2de34d652b9d823f$var$AchievementsHeader = (0, $d8seH.default)('div')`
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const $2de34d652b9d823f$var$ToggleButton = (0, $d8seH.default)('button')`
  padding: 0.4rem 0.8rem;
  background: transparent;
  border: 1.5px solid ${({ theme: theme })=>theme.palette.primary.main};
  border-radius: 6px;
  color: ${({ theme: theme })=>theme.palette.primary.main};
  font-weight: 600;
  font-size: 0.75em;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ theme: theme })=>theme.palette.primary.main};
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
`;
const $2de34d652b9d823f$var$AchievementsTitle = (0, $d8seH.default)('h3')`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 1.1em;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#999' : '#666'};

  svg {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    font-size: 1.2em;
  }
`;
const $2de34d652b9d823f$var$BadgesGrid = (0, $d8seH.default)('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
`;
const $2de34d652b9d823f$var$Badge = (0, $d8seH.default)('div')`
  background: ${({ theme: theme, earned: earned, showAll: showAll })=>showAll ? earned ? theme.palette.mode === 'dark' ? '#1e3a2e' : '#e8f5e9' : theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5' : 'transparent'};
  border: ${({ theme: theme, earned: earned, showAll: showAll })=>showAll ? `2px solid ${earned ? theme.palette.mode === 'dark' ? '#4caf50' : '#4caf50' : theme.palette.mode === 'dark' ? '#333' : '#ddd'}` : 'none'};
  border-radius: 12px;
  padding: 1rem 0.75rem;
  text-align: center;
  transition: all 0.2s ease;
  opacity: ${({ earned: earned, showAll: showAll })=>showAll && !earned ? 0.5 : 1};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;

  &:hover {
    transform: ${({ showAll: showAll })=>showAll ? 'scale(1.05)' : 'scale(1.1)'};
    box-shadow: ${({ showAll: showAll })=>showAll ? '0 4px 12px rgba(0, 0, 0, 0.2)' : 'none'};
    opacity: ${({ earned: earned, showAll: showAll })=>showAll && !earned ? 0.75 : 1};
    border-color: ${({ theme: theme, earned: earned, showAll: showAll })=>showAll ? earned ? theme.palette.success.light : theme.palette.mode === 'dark' ? '#555' : '#aaa' : 'transparent'};
  }
`;
const $2de34d652b9d823f$var$BadgeIcon = (0, $d8seH.default)('div')`
  font-size: 3em;
  line-height: 1;
`;
const $2de34d652b9d823f$var$BadgeName = (0, $d8seH.default)('div')`
  font-weight: 600;
  font-size: 0.85em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};
  line-height: 1.2;
`;
const $2de34d652b9d823f$var$BadgeProgress = (0, $d8seH.default)('div')`
  font-size: 0.8em;
  font-weight: 700;
  color: ${({ theme: theme })=>theme.palette.primary.main};
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $cFBau = parcelRequire("cFBau");
var $6lXkL = parcelRequire("6lXkL");
var $acw62 = parcelRequire("acw62");


var $5FMfE = parcelRequire("5FMfE");

var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");


var $jTnBY = parcelRequire("jTnBY");

var $d8seH = parcelRequire("d8seH");

var $aeD7H = parcelRequire("aeD7H");

var $1Anyj = parcelRequire("1Anyj");

var $1iOpW = parcelRequire("1iOpW");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9901c9510940cf3a$export$b85c003f960b1f3a(slot) {
    return (0, $4Cod0.default)('MuiButtonGroup', slot);
}
const $9901c9510940cf3a$var$buttonGroupClasses = (0, $beCSm.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $9901c9510940cf3a$export$2e2bcd8739ae039 = $9901c9510940cf3a$var$buttonGroupClasses;



var $bwtSM = parcelRequire("bwtSM");

var $3eDio = parcelRequire("3eDio");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1c026d95d0d4d482$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $jTnBY.default)(ownerState.variant)}${(0, $jTnBY.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $1c026d95d0d4d482$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $jTnBY.default)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(orientation)}`,
            `grouped${(0, $jTnBY.default)(variant)}${(0, $jTnBY.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9901c9510940cf3a$export$b85c003f960b1f3a), classes);
};
const $1c026d95d0d4d482$var$ButtonGroupRoot = (0, $d8seH.default)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $1c026d95d0d4d482$var$overridesResolver
})((0, $aeD7H.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / 0.5)` : (0, $aSEG4.alpha)(theme.palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).lastButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $1Anyj.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).firstButton},& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $9901c9510940cf3a$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const $1c026d95d0d4d482$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $1iOpW.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $1c026d95d0d4d482$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1c026d95d0d4d482$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $5FMfE.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bwtSM.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3eDio.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $1c026d95d0d4d482$export$2e2bcd8739ae039 = $1c026d95d0d4d482$var$ButtonGroup;


var $6ami2 = parcelRequire("6ami2");
var $9Lykx = parcelRequire("9Lykx");
var $d8seH = parcelRequire("d8seH");
var $iAtns = parcelRequire("iAtns");
var $cVXaD = parcelRequire("cVXaD");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bd249ba0cb5270d6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 18h6v-2H3zM3 6v2h18V6zm0 7h12v-2H3z"
}), 'Sort');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $28835d6e3f9deba6$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27 1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27zm-1.13 7.37 1.94-5.18 1.94 5.18zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26z"
}), 'SortByAlpha');




var $gTmRg = parcelRequire("gTmRg");



var $lffEs = parcelRequire("lffEs");


function $6f13fbc9b6dae25e$export$daa3c0ea8737c0ef(data, nodes) {
    const userVSNs = new Set(nodes.map((node)=>node.vsn));
    const filteredData = {};
    Object.keys(data).forEach((vsn)=>{
        if (userVSNs.has(vsn)) filteredData[vsn] = data[vsn];
    });
    return filteredData;
}
/**
 * Shortens plugin name to just the app name (removes IP/registry prefix and version)
 * Example: "192.168.1.1:5000/my-app:1.0.0" -> "my-app"
 */ function $6f13fbc9b6dae25e$var$shortenPluginName(plugin) {
    const isIP = /\d+\.\d+\.\d+\.\d+:\d+/.test(plugin);
    return isIP ? plugin.slice(plugin.indexOf('/') + 1).split(':')[0] : plugin.split(':')[0].slice(plugin.lastIndexOf('/') + 1);
}
function $6f13fbc9b6dae25e$export$3b3ea127cbd680d(filteredData) {
    const byNode = {};
    Object.keys(filteredData).forEach((vsn)=>{
        const plugins = filteredData[vsn];
        const aggregated = [];
        // Collect all records across all plugins for this node
        Object.keys(plugins).forEach((pluginName)=>{
            // Shorten plugin names
            const records = plugins[pluginName].map((record)=>({
                    ...record,
                    meta: {
                        ...record.meta,
                        plugin: $6f13fbc9b6dae25e$var$shortenPluginName(record.meta.plugin),
                        origPluginName: record.meta.plugin
                    }
                }));
            aggregated.push(...records);
        });
        // Group by timestamp and sum values
        const byTimestamp = {};
        aggregated.forEach((record)=>{
            const ts = record.timestamp;
            if (!byTimestamp[ts]) byTimestamp[ts] = {
                timestamp: ts,
                value: 0,
                meta: {
                    ...record.meta,
                    apps: {}
                }
            };
            byTimestamp[ts].value += record.value;
            byTimestamp[ts].meta.apps[record.meta.plugin] = (byTimestamp[ts].meta.apps[record.meta.plugin] || 0) + record.value;
        });
        byNode[vsn] = Object.values(byTimestamp);
    });
    return byNode;
}
function $6f13fbc9b6dae25e$export$a468b4c75fba6cd(filteredData) {
    const byApp = {};
    Object.keys(filteredData).forEach((vsn)=>{
        const plugins = filteredData[vsn];
        Object.keys(plugins).forEach((pluginName)=>{
            const shortName = $6f13fbc9b6dae25e$var$shortenPluginName(pluginName);
            if (!byApp[pluginName]) byApp[pluginName] = [];
            plugins[pluginName].forEach((record)=>{
                const existing = byApp[pluginName].find((r)=>r.timestamp === record.timestamp);
                if (existing) {
                    existing.value += record.value;
                    existing.meta.nodes = existing.meta.nodes || {};
                    existing.meta.nodes[vsn] = (existing.meta.nodes[vsn] || 0) + record.value;
                } else byApp[pluginName].push({
                    ...record,
                    meta: {
                        ...record.meta,
                        plugin: shortName,
                        origPluginName: record.meta.plugin,
                        nodes: {
                            [vsn]: record.value
                        }
                    }
                });
            });
        });
    });
    // Sort apps alphabetically by their short name
    const sortedByApp = {};
    Object.keys(byApp).sort((a, b)=>{
        const shortA = $6f13fbc9b6dae25e$var$shortenPluginName(a);
        const shortB = $6f13fbc9b6dae25e$var$shortenPluginName(b);
        return shortA.toLowerCase().localeCompare(shortB.toLowerCase());
    }).forEach((key)=>{
        sortedByApp[key] = byApp[key];
    });
    return sortedByApp;
}
function $6f13fbc9b6dae25e$export$dccb82d53f59869b(data, nodes) {
    const filteredData = $6f13fbc9b6dae25e$export$daa3c0ea8737c0ef(data, nodes);
    const timelineByNode = $6f13fbc9b6dae25e$export$3b3ea127cbd680d(filteredData);
    const timelineByApp = $6f13fbc9b6dae25e$export$a468b4c75fba6cd(filteredData);
    return {
        timelineByNode: timelineByNode,
        timelineByApp: timelineByApp
    };
}




var $ayMG0 = parcelRequire("ayMG0");

var $6lXkL = parcelRequire("6lXkL");
var $cVXaD = parcelRequire("cVXaD");
function $d6b0b0e7cf4ae0e7$export$2e2bcd8739ae039({ projectFilter: projectFilter, onProjectFilterChange: onProjectFilterChange, allNodesCount: allNodesCount, sageNodesCount: sageNodesCount, sgtNodesCount: sgtNodesCount }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
        size: "small",
        variant: "outlined",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Show all nodes",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                    onClick: ()=>onProjectFilterChange('all'),
                    variant: projectFilter === 'all' ? 'contained' : 'outlined',
                    children: [
                        "All (",
                        allNodesCount,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Show (older) Sage nodes",
                placement: "top",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                    onClick: ()=>onProjectFilterChange('SAGE'),
                    variant: projectFilter === 'SAGE' ? 'contained' : 'outlined',
                    children: [
                        "Sage (",
                        sageNodesCount,
                        ")"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                title: "Show (newer) Sage Grande Testbed nodes",
                placement: "top",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6lXkL.default), {
                    onClick: ()=>onProjectFilterChange('SGT'),
                    variant: projectFilter === 'SGT' ? 'contained' : 'outlined',
                    children: [
                        "SGT (",
                        sgtNodesCount,
                        ")"
                    ]
                })
            })
        ]
    });
}


const $9a38e88dd70564f3$var$TAIL_DAYS = '-7d';
const $9a38e88dd70564f3$var$getStartTime = (str)=>str.includes('y') ? (0, $393cfda53f7a350f$export$2e2bcd8739ae039)(new Date(), str.replace(/-|y/g, '')) : (0, $320e4d083cefb0bc$export$2e2bcd8739ae039)(new Date(), str.replace(/-|d/g, ''));
function $9a38e88dd70564f3$export$2e2bcd8739ae039({ allNodes: allNodes, allJobs: allJobs, projectFilter: projectFilter, onProjectFilterChange: onProjectFilterChange, allNodesCount: allNodesCount, sageNodesCount: sageNodesCount, sgtNodesCount: sgtNodesCount }) {
    const [timelineTab, setTimelineTab] = (0, $acw62.useState)('nodes');
    const [timelineFilter, setTimelineFilter] = (0, $acw62.useState)('all');
    const [timelineByNode, setTimelineByNode] = (0, $acw62.useState)(null);
    const [timelineByApp, setTimelineByApp] = (0, $acw62.useState)(null);
    const [loadingTimeline, setLoadingTimeline] = (0, $acw62.useState)(false);
    const [showAll, setShowAll] = (0, $acw62.useState)(false);
    const [selectedApps, setSelectedApps] = (0, $acw62.useState)([]);
    const [selectedNodes, setSelectedNodes] = (0, $acw62.useState)([]);
    const [sortAppsByCount, setSortAppsByCount] = (0, $acw62.useState)(true);
    const [sortNodesByCount, setSortNodesByCount] = (0, $acw62.useState)(true);
    const [opts, setOpts] = (0, $acw62.useState)({
        display: 'nodes',
        colorType: 'density',
        viewType: 'timeline',
        versions: false,
        time: 'hourly',
        start: $9a38e88dd70564f3$var$getStartTime($9a38e88dd70564f3$var$TAIL_DAYS),
        window: $9a38e88dd70564f3$var$TAIL_DAYS
    });
    const handleOptionChange = (name, val)=>{
        if (name === 'time') {
            setOpts((prev)=>({
                    ...prev,
                    time: val
                }));
            return;
        }
        if (name === 'colorType') {
            setOpts((prev)=>({
                    ...prev,
                    colorType: val
                }));
            return;
        }
        if (name === 'window') {
            if (!val) return;
            const nextShowAll = val === 'showAll';
            setShowAll(nextShowAll);
            const start = $9a38e88dd70564f3$var$getStartTime(nextShowAll ? '-20y' : val);
            setOpts((prev)=>({
                    ...prev,
                    ...val && {
                        window: val,
                        start: start
                    },
                    ...nextShowAll && {
                        time: 'daily'
                    }
                }));
            return;
        }
    };
    // Fetch timeline data for user's nodes and apps
    (0, $acw62.useEffect)(()=>{
        if (!allNodes || allNodes.length === 0) return;
        setLoadingTimeline(true);
        const start = opts.start;
        // Determine which nodes to include based on filter
        let nodesToShow = allNodes;
        if (timelineFilter === 'jobs' && allJobs && allJobs.length > 0) {
            // Extract unique VSNs from all jobs
            const jobVSNs = new Set();
            allJobs.forEach((job)=>{
                job.nodes.forEach((vsn)=>jobVSNs.add(vsn));
            });
            nodesToShow = allNodes.filter((node)=>jobVSNs.has(node.vsn));
        }
        // Fetch activity data for filtered nodes
        (0, $1455de3949293917$export$13386e296638fa34)({
            start: start,
            time: opts.time,
            versions: false
        }).then(({ data: data })=>{
            const { timelineByNode: timelineByNode, timelineByApp: timelineByApp } = (0, $6f13fbc9b6dae25e$export$dccb82d53f59869b)(data, nodesToShow);
            // If filtering by jobs, also filter apps
            if (timelineFilter === 'jobs' && allJobs && allJobs.length > 0) {
                // Extract app names from jobs
                const jobApps = new Set();
                allJobs.forEach((job)=>{
                    job.plugins.forEach((plugin)=>{
                        // Extract app name from plugin image
                        const imageParts = plugin.plugin_spec.image.split('/');
                        const appName = imageParts[imageParts.length - 1].split(':')[0];
                        jobApps.add(appName);
                    });
                });
                // Filter apps to only those used in jobs
                const filteredByApp = {};
                Object.keys(timelineByApp).forEach((key)=>{
                    const appName = key.split('/').pop().split(':')[0];
                    if (jobApps.has(appName)) filteredByApp[key] = timelineByApp[key];
                });
                setTimelineByApp(filteredByApp);
            } else setTimelineByApp(timelineByApp);
            setTimelineByNode(timelineByNode);
        }).catch((err)=>{
            console.error('Failed to fetch timeline data:', err);
            setTimelineByNode({});
            setTimelineByApp({});
        }).finally(()=>setLoadingTimeline(false));
    }, [
        allNodes,
        allJobs,
        timelineFilter,
        opts.start,
        opts.time
    ]);
    const TIMELINE_LABEL_WIDTH = 40;
    // Don't render if no nodes after loading
    if (allNodes && allNodes.length === 0) return null;
    const renderContent = ()=>{
        // Show loading skeleton if data hasn't loaded yet
        const isLoading = !allNodes || loadingTimeline || !timelineByNode || !timelineByApp;
        if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a4a018ec5a6eb95$export$2e2bcd8739ae039), {
            includeHeader: false
        });
        let timelineData = timelineTab === 'nodes' ? timelineByNode : timelineByApp;
        // Apply filters to timeline data
        if (timelineTab === 'nodes' && selectedApps.length > 0) {
            // Filter nodes by selected apps
            const filtered = {};
            Object.entries(timelineData || {}).forEach(([node, data])=>{
                const filteredData = data.map((item)=>{
                    const apps = item.meta?.apps || {};
                    const filteredApps = {};
                    let totalValue = 0;
                    Object.entries(apps).forEach(([app, count])=>{
                        if (selectedApps.includes(app)) {
                            filteredApps[app] = count;
                            totalValue += count;
                        }
                    });
                    return totalValue > 0 ? {
                        ...item,
                        value: totalValue,
                        meta: {
                            ...item.meta,
                            apps: filteredApps
                        }
                    } : null;
                }).filter(Boolean);
                if (filteredData.length > 0) filtered[node] = filteredData;
            });
            timelineData = filtered;
        } else if (timelineTab === 'apps' && selectedNodes.length > 0) {
            // Filter apps by selected nodes
            const filtered = {};
            Object.entries(timelineData || {}).forEach(([app, data])=>{
                const filteredData = data.map((item)=>{
                    const nodes = item.meta?.nodes || {};
                    const filteredNodes = {};
                    let totalValue = 0;
                    Object.entries(nodes).forEach(([node, count])=>{
                        if (selectedNodes.includes(node)) {
                            filteredNodes[node] = count;
                            totalValue += count;
                        }
                    });
                    return totalValue > 0 ? {
                        ...item,
                        value: totalValue,
                        meta: {
                            ...item.meta,
                            nodes: filteredNodes
                        }
                    } : null;
                }).filter(Boolean);
                if (filteredData.length > 0) filtered[app] = filteredData;
            });
            timelineData = filtered;
        }
        const hasData = timelineData && Object.keys(timelineData).length > 0;
        // Extract available apps from node timeline data with counts
        const appCounts = new Map();
        if (timelineTab === 'nodes' && timelineByNode) Object.values(timelineByNode).forEach((data)=>{
            data.forEach((item)=>{
                Object.entries(item.meta?.apps || {}).forEach(([app, count])=>{
                    appCounts.set(app, (appCounts.get(app) || 0) + count);
                });
            });
        });
        const availableApps = new Set(appCounts.keys());
        // Sort apps by count or alphabetically
        const sortedApps = Array.from(appCounts.entries()).sort((a, b)=>{
            if (sortAppsByCount) return b[1] - a[1] // Sort by count descending
            ;
            return a[0].localeCompare(b[0]) // Sort alphabetically
            ;
        });
        // Extract available nodes from app timeline data with counts
        const nodeCounts = new Map();
        if (timelineTab === 'apps' && timelineByApp) Object.values(timelineByApp).forEach((data)=>{
            data.forEach((item)=>{
                Object.entries(item.meta?.nodes || {}).forEach(([node, count])=>{
                    nodeCounts.set(node, (nodeCounts.get(node) || 0) + count);
                });
            });
        });
        const availableNodes = new Set(nodeCounts.keys());
        // Sort nodes by count or alphabetically
        const sortedNodes = Array.from(nodeCounts.entries()).sort((a, b)=>{
            if (sortNodesByCount) return b[1] - a[1] // Sort by count descending
            ;
            return a[0].localeCompare(b[0]) // Sort alphabetically
            ;
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$TimelineContainer, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                timelineTab === 'nodes' && availableApps.size > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$FilterChipsContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9a38e88dd70564f3$var$FilterLabel, {
                                            children: "Filter by:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                            multiple: true,
                                            size: "small",
                                            options: sortedApps.map(([app])=>app),
                                            value: selectedApps,
                                            onChange: (_, newValue)=>setSelectedApps(newValue),
                                            limitTags: 5,
                                            getOptionLabel: (option)=>option,
                                            renderOption: (props, option)=>{
                                                const count = appCounts.get(option) || 0;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    ...props,
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        ...props.style
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: option
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontWeight: 600,
                                                                color: '#999',
                                                                marginLeft: '1rem'
                                                            },
                                                            children: count.toLocaleString()
                                                        })
                                                    ]
                                                });
                                            },
                                            renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    ...params,
                                                    placeholder: "Apps",
                                                    InputProps: {
                                                        ...params.InputProps,
                                                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                    title: sortAppsByCount ? 'Sorted by count (click for A-Z)' : 'Sorted A-Z (click for count)',
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                                        size: "small",
                                                                        onClick: ()=>setSortAppsByCount(!sortAppsByCount),
                                                                        sx: {
                                                                            mr: 0.5
                                                                        },
                                                                        children: sortAppsByCount ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd249ba0cb5270d6$export$2e2bcd8739ae039), {
                                                                            fontSize: "small"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28835d6e3f9deba6$export$2e2bcd8739ae039), {
                                                                            fontSize: "small"
                                                                        })
                                                                    })
                                                                }),
                                                                params.InputProps.endAdornment
                                                            ]
                                                        })
                                                    }
                                                }),
                                            renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $acw62.createElement)((0, $6ami2.default), {
                                                        label: option,
                                                        size: "small",
                                                        ...getTagProps({
                                                            index: index
                                                        }),
                                                        key: option
                                                    })),
                                            sx: {
                                                flex: 1
                                            }
                                        })
                                    ]
                                }),
                                timelineTab === 'apps' && availableNodes.size > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$FilterChipsContainer, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9a38e88dd70564f3$var$FilterLabel, {
                                            children: "Filter by:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cFBau.default), {
                                            multiple: true,
                                            size: "small",
                                            options: sortedNodes.map(([node])=>node),
                                            value: selectedNodes,
                                            onChange: (_, newValue)=>setSelectedNodes(newValue),
                                            limitTags: 10,
                                            getOptionLabel: (option)=>option,
                                            renderOption: (props, option)=>{
                                                const count = nodeCounts.get(option) || 0;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                                    ...props,
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        ...props.style
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: option
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            style: {
                                                                fontWeight: 600,
                                                                color: '#999',
                                                                marginLeft: '1rem'
                                                            },
                                                            children: count.toLocaleString()
                                                        })
                                                    ]
                                                });
                                            },
                                            renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                                    ...params,
                                                    placeholder: "Nodes",
                                                    InputProps: {
                                                        ...params.InputProps,
                                                        endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                    title: sortNodesByCount ? 'Sorted by count (click for A-Z)' : 'Sorted A-Z (click for count)',
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9Lykx.default), {
                                                                        size: "small",
                                                                        onClick: ()=>setSortNodesByCount(!sortNodesByCount),
                                                                        sx: {
                                                                            mr: 0.5
                                                                        },
                                                                        children: sortNodesByCount ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd249ba0cb5270d6$export$2e2bcd8739ae039), {
                                                                            fontSize: "small"
                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28835d6e3f9deba6$export$2e2bcd8739ae039), {
                                                                            fontSize: "small"
                                                                        })
                                                                    })
                                                                }),
                                                                params.InputProps.endAdornment
                                                            ]
                                                        })
                                                    }
                                                }),
                                            renderTags: (value, getTagProps)=>value.map((option, index)=>/*#__PURE__*/ (0, $acw62.createElement)((0, $6ami2.default), {
                                                        label: option,
                                                        size: "small",
                                                        ...getTagProps({
                                                            index: index
                                                        }),
                                                        key: option
                                                    })),
                                            sx: {
                                                flex: 1
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "timeline-title flex items-start gap",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    children: (0, $lffEs.getRangeTitle)(opts.window)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39d20adadcde0807$export$2e2bcd8739ae039), {
                                    onChange: handleOptionChange,
                                    opts: opts,
                                    quickRanges: [
                                        '-1y',
                                        '-90d',
                                        '-30d',
                                        '-7d',
                                        '-2d'
                                    ],
                                    showAll: true,
                                    condensed: true,
                                    aggregation: true
                                })
                            ]
                        }),
                        timelineTab === 'nodes' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                            data: timelineData || {},
                            cellUnit: opts.time === 'daily' ? 'day' : 'hour',
                            limitRowCount: 10,
                            startTime: !showAll ? opts.start : null,
                            colorCell: (0, $4cab315b36f812e1$export$80ee56865356b7c3),
                            yFormat: (label)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                    to: `/nodes/${label}`,
                                    children: label
                                }),
                            tooltip: (item)=>{
                                const date = new Date(item.timestamp);
                                const apps = item.meta?.apps || {};
                                const appBreakdown = Object.entries(apps).sort((a, b)=>b[1] - a[1]).map(([app, count])=>`${app}: ${count.toLocaleString()}`).join('<br>');
                                return `
                  <div style="margin-bottom: 5px; font-weight: bold;">
                    ${date.toDateString()} ${date.toLocaleTimeString([], {
                                    timeStyle: 'short'
                                })}
                  </div>
                  <div style="margin-bottom: 8px;">
                    <strong>Total:</strong> ${item.value.toLocaleString()} records
                  </div>
                  <div style="font-size: 0.9em;">
                    <strong>Apps:</strong><br>
                    ${appBreakdown}
                  </div>`;
                            },
                            labelWidth: TIMELINE_LABEL_WIDTH
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66ac2ba2d2031913$export$2e2bcd8739ae039), {
                            data: timelineData || {},
                            cellUnit: opts.time === 'daily' ? 'day' : 'hour',
                            labelWidth: 180,
                            limitRowCount: 10,
                            startTime: !showAll ? opts.start : null,
                            colorCell: (0, $4cab315b36f812e1$export$80ee56865356b7c3),
                            yFormat: (label)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                    to: `/apps?search=${label}`,
                                    children: label.slice(label.lastIndexOf('/') + 1)
                                }),
                            tooltip: (item)=>{
                                const date = new Date(item.timestamp);
                                const nodes = item.meta?.nodes || {};
                                const nodeBreakdown = Object.entries(nodes).sort((a, b)=>b[1] - a[1]).map(([node, count])=>`${node}: ${count.toLocaleString()}`).join('<br>');
                                return `
                  <div style="margin-bottom: 5px; font-weight: bold;">
                    ${date.toDateString()} ${date.toLocaleTimeString([], {
                                    timeStyle: 'short'
                                })}
                  </div>
                  <div style="margin-bottom: 8px;">
                    <strong>Total:</strong> ${item.value.toLocaleString()} records
                  </div>
                  <div style="font-size: 0.9em;">
                    <strong>Nodes:</strong><br>
                    ${nodeBreakdown}
                  </div>`;
                            }
                        })
                    ]
                }),
                !hasData && /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$EmptyState, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9a38e88dd70564f3$var$EmptyIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $645d3c26402e93bc$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "No recent activity in the last 7 days"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                            children: "When apps run on your nodes, their activity will appear here about 15 minutes after the hour"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$WideSection, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$FilterBar, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9a38e88dd70564f3$var$FilterGroup, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6b0b0e7cf4ae0e7$export$2e2bcd8739ae039), {
                                projectFilter: projectFilter,
                                onProjectFilterChange: onProjectFilterChange,
                                allNodesCount: allNodesCount,
                                sageNodesCount: sageNodesCount,
                                sgtNodesCount: sgtNodesCount
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>{
                                            setTimelineTab('nodes');
                                            setSelectedApps([]);
                                            setSelectedNodes([]);
                                        },
                                        variant: timelineTab === 'nodes' ? 'contained' : 'outlined',
                                        children: "By Node"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>{
                                            setTimelineTab('apps');
                                            setSelectedApps([]);
                                            setSelectedNodes([]);
                                        },
                                        variant: timelineTab === 'apps' ? 'contained' : 'outlined',
                                        children: "By App"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9a38e88dd70564f3$var$FilterGroup, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                            size: "small",
                            variant: "outlined",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    onClick: ()=>setTimelineFilter('jobs'),
                                    variant: timelineFilter === 'jobs' ? 'contained' : 'outlined',
                                    children: "My Jobs Only"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                    onClick: ()=>setTimelineFilter('all'),
                                    variant: timelineFilter === 'all' ? 'contained' : 'outlined',
                                    children: "All Accessible Nodes"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                children: renderContent()
            })
        ]
    });
}
const $9a38e88dd70564f3$var$WideSection = (0, $d8seH.default)('div')`
  grid-column: 1 / -1;
  margin-bottom: 2rem;
`;
const $9a38e88dd70564f3$var$FilterBar = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 1.25rem 1.5rem;
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : '#f8f9fa'};
  border: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
  border-radius: 12px 12px 0 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.palette.primary.main};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;
const $9a38e88dd70564f3$var$FilterGroup = (0, $d8seH.default)('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;
const $9a38e88dd70564f3$var$FilterLabel = (0, $d8seH.default)('span')`
  font-weight: 600;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};
`;
const $9a38e88dd70564f3$var$TimelineContainer = (0, $d8seH.default)('div')`
  overflow-x: auto;

  .timeline-title {
    float: left;
    h2 { margin: 0 1em 0 0;}
  }
`;
const $9a38e88dd70564f3$var$EmptyState = (0, $d8seH.default)('div')`
  text-align: center;
  padding: 3rem 1rem;
  color: ${({ theme: theme })=>theme.palette.text.secondary};

  p {
    margin: 1rem 0;
    font-size: 1.1em;
  }

  a {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const $9a38e88dd70564f3$var$EmptyIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 4em;
    opacity: 0.3;
  }
`;
const $9a38e88dd70564f3$var$FilterChipsContainer = (0, $d8seH.default)('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#1e1e1e' : '#f5f5f5'};
  border-radius: 8px;
  .MuiInputBase-root {
    background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : '#fff'};
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $6lXkL = parcelRequire("6lXkL");
var $d8seH = parcelRequire("d8seH");
var $cVXaD = parcelRequire("cVXaD");

var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $e233ff9fb3408a34$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42s1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1"
}), 'ArrowForwardRounded');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a43abd360427dbb3$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8zm4 18H6V4h8v4h4zm-6-3c-1.1 0-2-.9-2-2V9.5c0-.28.22-.5.5-.5s.5.22.5.5V15h2V9.5C13 8.12 11.88 7 10.5 7S8 8.12 8 9.5V15c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2v4c0 1.1-.9 2-2 2"
}), 'FilePresentOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d4b70a94bbd4567b$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7.76 16.24C6.67 15.16 6 13.66 6 12s.67-3.16 1.76-4.24l1.42 1.42C8.45 9.9 8 10.9 8 12s.45 2.1 1.17 2.83zm8.48 0C17.33 15.16 18 13.66 18 12s-.67-3.16-1.76-4.24l-1.42 1.42C15.55 9.9 16 10.9 16 12s-.45 2.1-1.17 2.83zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m8 2c0 2.21-.9 4.21-2.35 5.65l1.42 1.42C20.88 17.26 22 14.76 22 12s-1.12-5.26-2.93-7.07l-1.42 1.42C19.1 7.79 20 9.79 20 12M6.35 6.35 4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.42-1.42C4.9 16.21 4 14.21 4 12s.9-4.21 2.35-5.65"
}), 'SensorsOutlined');


var $bbT5Q = parcelRequire("bbT5Q");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d19193352e994cb9$export$2e2bcd8739ae039 = (0, $bbT5Q.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 4H4c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2m0 14H4V8h16zm-2-1h-6v-2h6zM7.5 17l-1.41-1.41L8.67 13l-2.59-2.59L7.5 9l4 4z"
}), 'TerminalOutlined');



var $eOilY = parcelRequire("eOilY");

var $7cKF8 = parcelRequire("7cKF8");

var $d8seH = parcelRequire("d8seH");
const $2d6ed24491ed0a66$export$d09e9686fc15c753 = (0, $d8seH.default)('div')`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ available: available })=>available ? 1 : 0.3};
  filter: ${({ available: available })=>available ? 'none' : 'grayscale(100%)'};
  cursor: ${({ available: available })=>available ? 'pointer' : 'default'};
  color: ${({ theme: theme, available: available })=>available ? theme.palette.mode === 'dark' ? '#fff' : '#000' : theme.palette.mode === 'dark' ? '#555' : '#aaa'};
  transition: all 0.2s ease;

  svg {
    font-size: 1.5em;
  }

  &:hover {
    color: ${({ theme: theme, available: available })=>available ? theme.palette.primary.main : undefined};
  }
`;
const $2d6ed24491ed0a66$export$5ada0a222b03a722 = (0, $d8seH.default)('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120%;
  height: 2px;
  background-color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#555' : '#aaa'};
  transform: translate(-50%, -50%) rotate(-45deg);
  pointer-events: none;
`;



var $gOa8m = parcelRequire("gOa8m");


var $7L4OA = parcelRequire("7L4OA");

var $gTmRg = parcelRequire("gTmRg");


var $c3pId = parcelRequire("c3pId");
// Mini table columns for quick view
const $0d00c69d97a43e01$var$nodeColumns = [
    {
        id: 'vsn',
        label: 'Node',
        format: (vsn)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/nodes/${vsn}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: vsn
                })
            })
    },
    {
        id: 'city',
        label: 'City'
    },
    {
        id: 'access',
        label: 'Access',
        format: (access = [])=>{
            const hasFiles = access.includes('files');
            const hasDevelop = access.includes('develop');
            const hasSchedule = access.includes('schedule');
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$AccessIconsContainer, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "File (image, audio, etc.) Access",
                        placement: "top",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2d6ed24491ed0a66$export$d09e9686fc15c753), {
                            available: hasFiles,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a43abd360427dbb3$export$2e2bcd8739ae039), {}),
                                !hasFiles && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d6ed24491ed0a66$export$5ada0a222b03a722), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Develop / ssh Remote Access",
                        placement: "top",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2d6ed24491ed0a66$export$d09e9686fc15c753), {
                            available: hasDevelop,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d19193352e994cb9$export$2e2bcd8739ae039), {}),
                                !hasDevelop && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d6ed24491ed0a66$export$5ada0a222b03a722), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                        title: "Job Scheduling Access",
                        placement: "top",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2d6ed24491ed0a66$export$d09e9686fc15c753), {
                            available: hasSchedule,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $645d3c26402e93bc$export$2e2bcd8739ae039), {}),
                                !hasSchedule && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d6ed24491ed0a66$export$5ada0a222b03a722), {})
                            ]
                        })
                    })
                ]
            });
        }
    }
];
const $0d00c69d97a43e01$var$getTitle = (hardware, description)=>{
    const match = description?.match(/^#\s+(.+)\r\n/m);
    const title = match ? match[1] : null;
    return title ? title : hardware;
};
const $0d00c69d97a43e01$var$sensorColumns = [
    {
        id: 'hw_model',
        label: 'Model',
        width: '250px',
        format: (val, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                            className: "muted",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                children: obj.manufacturer
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                        to: `/sensors/${obj.hw_model}`,
                        children: val
                    })
                ]
            })
    },
    {
        id: 'title',
        label: 'Name',
        format: (_, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/sensors/${obj.hw_model}`,
                children: $0d00c69d97a43e01$var$getTitle(obj.hw_model, obj.description)
            })
    },
    {
        id: 'capabilities',
        label: 'Capabilities',
        format: (_, obj)=>{
            // Convert sensor to format expected by SensorIcons (array of sensors)
            const sensorData = [
                {
                    hw_model: obj.hw_model,
                    name: obj.hw_model,
                    serial_no: '',
                    manufacturer: obj.manufacturer || '',
                    capabilities: obj.capabilities || [],
                    is_active: true
                }
            ];
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eOilY.SensorIcons), {
                data: sensorData,
                showOnlyPresent: true
            });
        }
    },
    {
        id: 'vsns',
        label: 'My Nodes',
        format: (vsns, obj)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.Link), {
                to: `/user/${(0, $c3pId.default).user}/nodes?show_all=true&sensor="${obj.hw_model}"`,
                children: [
                    vsns.length,
                    " node",
                    vsns.length !== 1 ? 's' : ''
                ]
            })
    }
];
function $0d00c69d97a43e01$export$2e2bcd8739ae039({ allNodes: allNodes, sensors: sensors, projectFilter: projectFilter, onProjectFilterChange: onProjectFilterChange, onNodeSelect: onNodeSelect, allNodesCount: allNodesCount, sageNodesCount: sageNodesCount, sgtNodesCount: sgtNodesCount }) {
    const [accessFilters, setAccessFilters] = (0, $acw62.useState)(new Set());
    const [sensorCapabilityFilters, setSensorCapabilityFilters] = (0, $acw62.useState)(new Set());
    const [sensorPage, setSensorPage] = (0, $acw62.useState)(0);
    const [sensorSearch, setSensorSearch] = (0, $acw62.useState)('');
    const [nodesTab, setNodesTab] = (0, $acw62.useState)('nodes');
    const [selected, setSelected] = (0, $acw62.useState)([]);
    const toggleAccessFilter = (access)=>{
        setAccessFilters((prev)=>{
            const newFilters = new Set(prev);
            if (newFilters.has(access)) newFilters.delete(access);
            else newFilters.add(access);
            return newFilters;
        });
    };
    const toggleSensorCapabilityFilter = (capability)=>{
        setSensorCapabilityFilters((prev)=>{
            const newFilters = new Set(prev);
            if (newFilters.has(capability)) newFilters.delete(capability);
            else newFilters.add(capability);
            return newFilters;
        });
    };
    // Filter nodes based on project and access filters
    const filteredNodes = allNodes?.filter((node)=>{
        // Access filter - if any access filters are set, node must have ALL selected access types
        if (accessFilters.size > 0) {
            const nodeAccess = node.access || [];
            return Array.from(accessFilters).every((requiredAccess)=>nodeAccess.includes(requiredAccess));
        }
        return true;
    }) || [];
    // Map nodes with required properties
    const mapNodes = filteredNodes.map((node)=>({
            ...node,
            sensor: node.sensors?.map((s)=>s.hw_model) || [],
            // status: 'unknown', // Status could be determined by MapGL from live data; todo(nc)
            elapsedTimes: {} // Will be populated by live data if available
        }));
    // Table nodes (access already included from getUserNodesAndProjects)
    const tableNodes = filteredNodes;
    if (!allNodes || allNodes.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$NodesOverviewSection, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$FilterBar, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$FilterGroup, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d6b0b0e7cf4ae0e7$export$2e2bcd8739ae039), {
                                projectFilter: projectFilter,
                                onProjectFilterChange: onProjectFilterChange,
                                allNodesCount: allNodesCount,
                                sageNodesCount: sageNodesCount,
                                sgtNodesCount: sgtNodesCount
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>setNodesTab('nodes'),
                                        variant: nodesTab === 'nodes' ? 'contained' : 'outlined',
                                        children: "Nodes"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>setNodesTab('sensors'),
                                        variant: nodesTab === 'sensors' ? 'contained' : 'outlined',
                                        children: "Sensors"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$FilterGroup, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$FilterLabel, {
                                children: "Access:"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1c026d95d0d4d482$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>toggleAccessFilter('files'),
                                        variant: accessFilters.has('files') ? 'contained' : 'outlined',
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a43abd360427dbb3$export$2e2bcd8739ae039), {}),
                                        children: "Files"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>toggleAccessFilter('develop'),
                                        variant: accessFilters.has('develop') ? 'contained' : 'outlined',
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d19193352e994cb9$export$2e2bcd8739ae039), {}),
                                        children: "Develop"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                        onClick: ()=>toggleAccessFilter('schedule'),
                                        variant: accessFilters.has('schedule') ? 'contained' : 'outlined',
                                        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $645d3c26402e93bc$export$2e2bcd8739ae039), {}),
                                        children: "Schedule"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gTmRg.Card), {
                style: {
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0
                },
                children: nodesTab === 'nodes' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$NodesGrid, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$SectionHeader, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$SectionTitle, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85875d7d213afd89$export$2e2bcd8739ae039), {}),
                                            " Map"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$MapContainer, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7L4OA.default), {
                                        data: selected.length ? selected : mapNodes,
                                        updateID: `${selected.map((node)=>node.vsn).join(',')}` + `-${filteredNodes.length}-${Array.from(accessFilters).sort().join(',')}`,
                                        markerClass: "blue-dot",
                                        autoFitBounds: true,
                                        mapSettings: {
                                            style: {
                                                height: '400px'
                                            }
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$SectionHeader, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$SectionTitle, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85875d7d213afd89$export$2e2bcd8739ae039), {}),
                                                " My Nodes"
                                            ]
                                        }),
                                        tableNodes && tableNodes.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$ViewAllLink, {
                                            to: `/user/${(0, $c3pId.default).user}/nodes`,
                                            children: [
                                                "View All ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e233ff9fb3408a34$export$2e2bcd8739ae039), {
                                                    fontSize: "small"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                tableNodes && tableNodes.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$ScrollableTableContainer, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                                        primaryKey: "vsn",
                                        columns: $0d00c69d97a43e01$var$nodeColumns,
                                        rows: tableNodes,
                                        onSelect: (state)=>{
                                            const selectedNodes = state.objs;
                                            setSelected(selectedNodes);
                                            onNodeSelect?.(selectedNodes);
                                        }
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$EmptyState, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$EmptyIcon, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85875d7d213afd89$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "No nodes found for this filter"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                            to: "/nodes",
                                            children: "Browse Available Nodes"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : // Sensors Tab Content
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: (()=>{
                        const userVSNs = new Set(allNodes?.map((n)=>n.vsn) || []);
                        const baseSensors = sensors?.filter((s)=>s.vsns.some((vsn)=>userVSNs.has(vsn))).map((s)=>({
                                ...s,
                                vsns: s.vsns.filter((vsn)=>userVSNs.has(vsn))
                            })) || [];
                        // Get all capabilities from user's sensors
                        const allCapabilities = new Set();
                        baseSensors.forEach((sensor)=>{
                            sensor.capabilities?.forEach((cap)=>{
                                const normalizedCap = cap === 'Thermal Camera' ? 'Camera' : cap;
                                allCapabilities.add(normalizedCap);
                            });
                        });
                        let userSensors = [
                            ...baseSensors
                        ];
                        // Apply capability filters
                        if (sensorCapabilityFilters.size > 0) userSensors = userSensors.filter((sensor)=>{
                            const sensorCaps = sensor.capabilities?.map((cap)=>cap === 'Thermal Camera' ? 'Camera' : cap) || [];
                            return Array.from(sensorCapabilityFilters).some((filterCap)=>sensorCaps.includes(filterCap));
                        });
                        // Apply search filter
                        if (sensorSearch) userSensors = (0, $52fc2129eac6b28c$export$3c598703d99462f5)(userSensors, sensorSearch);
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$SectionHeader, {
                                    style: {
                                        marginTop: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$SectionTitle, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4b70a94bbd4567b$export$2e2bcd8739ae039), {}),
                                                " My Sensors"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "flex items-center gap",
                                            children: [
                                                allCapabilities.size > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$CapabilityFilterInline, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$CapabilityFilterLabel, {
                                                            children: "Filter by capability:"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$CapabilityIcons, {
                                                            children: Object.keys((0, $7cKF8.capabilityIcons)).filter((cap)=>allCapabilities.has(cap)).map((capability)=>{
                                                                const Icon = (0, $7cKF8.capabilityIcons)[capability];
                                                                const isSelected = sensorCapabilityFilters.has(capability);
                                                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cVXaD.default), {
                                                                    title: capability,
                                                                    placement: "top",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$CapabilityIconButton, {
                                                                        selected: isSelected,
                                                                        onClick: ()=>toggleSensorCapabilityFilter(capability),
                                                                        children: typeof Icon === 'function' && capability === 'Humidity' ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {}) : typeof Icon === 'function' && capability === 'Precipitation' ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {}) : typeof Icon === 'function' && capability === 'Accelerometer' ? /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                                            fontSize: "small"
                                                                        })
                                                                    })
                                                                }, capability);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                baseSensors.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$ViewAllLink, {
                                                    to: "/sensors",
                                                    children: [
                                                        "View All ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e233ff9fb3408a34$export$2e2bcd8739ae039), {
                                                            fontSize: "small"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                userSensors.length > 0 || baseSensors.length > 0 ? userSensors.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                                    primaryKey: "hw_model",
                                    columns: $0d00c69d97a43e01$var$sensorColumns,
                                    rows: userSensors,
                                    pagination: true,
                                    page: sensorPage,
                                    limit: userSensors.length,
                                    rowsPerPage: 20,
                                    onPage: (newPage)=>setSensorPage(newPage),
                                    enableSorting: true,
                                    search: sensorSearch,
                                    onSearch: ({ query: query })=>setSensorSearch(query),
                                    middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$EmptyState, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$EmptyIcon, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4b70a94bbd4567b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "No sensors found with selected filters"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                            onClick: ()=>{
                                                setSensorCapabilityFilters(new Set());
                                                setSensorSearch('');
                                            },
                                            variant: "outlined",
                                            size: "small",
                                            children: "Clear Filters"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($0d00c69d97a43e01$var$EmptyState, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d00c69d97a43e01$var$EmptyIcon, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4b70a94bbd4567b$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: "No sensors found on your nodes"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                                            to: "/sensors",
                                            children: "Browse All Sensors"
                                        })
                                    ]
                                })
                            ]
                        });
                    })()
                })
            })
        ]
    });
}
const $0d00c69d97a43e01$var$NodesOverviewSection = (0, $d8seH.default)('div')`
  margin-bottom: 2rem;
`;
const $0d00c69d97a43e01$var$FilterBar = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 1.25rem 1.5rem;
  background: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#2a2a2a' : '#f8f9fa'};
  border: 1px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
  border-radius: 12px 12px 0 0;
  border-bottom: 2px solid ${({ theme: theme })=>theme.palette.primary.main};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;
const $0d00c69d97a43e01$var$NodesGrid = (0, $d8seH.default)('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;
const $0d00c69d97a43e01$var$FilterGroup = (0, $d8seH.default)('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;
const $0d00c69d97a43e01$var$FilterLabel = (0, $d8seH.default)('span')`
  font-weight: 600;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};
`;
const $0d00c69d97a43e01$var$MapContainer = (0, $d8seH.default)('div')`
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
`;
const $0d00c69d97a43e01$var$ScrollableTableContainer = (0, $d8seH.default)('div')`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
`;
const $0d00c69d97a43e01$var$SectionHeader = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
`;
const $0d00c69d97a43e01$var$SectionTitle = (0, $d8seH.default)('h2')`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};

  svg {
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $0d00c69d97a43e01$var$ViewAllLink = (0, $d8seH.default)((0, $lzNIT.Link))`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${({ theme: theme })=>theme.palette.primary.main};
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    gap: 0.5rem;
    text-decoration: underline;
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;
const $0d00c69d97a43e01$var$EmptyState = (0, $d8seH.default)('div')`
  text-align: center;
  padding: 3rem 1rem;
  color: ${({ theme: theme })=>theme.palette.text.secondary};

  p {
    margin: 1rem 0;
    font-size: 1.1em;
  }

  a {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const $0d00c69d97a43e01$var$EmptyIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 4em;
    opacity: 0.3;
  }
`;
const $0d00c69d97a43e01$var$AccessIconsContainer = (0, $d8seH.default)('div')`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;
const $0d00c69d97a43e01$var$CapabilityFilterInline = (0, $d8seH.default)('div')`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;
const $0d00c69d97a43e01$var$CapabilityFilterLabel = (0, $d8seH.default)('span')`
  font-weight: 600;
  font-size: 0.9em;
  color: ${({ theme: theme })=>theme.palette.text.primary};
  white-space: nowrap;
`;
const $0d00c69d97a43e01$var$CapabilityIcons = (0, $d8seH.default)('div')`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;
const $0d00c69d97a43e01$var$CapabilityIconButton = (0, $d8seH.default)('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: 2px solid ${({ theme: theme, selected: selected })=>selected ? theme.palette.primary.main : theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
  background: ${({ theme: theme, selected: selected })=>selected ? theme.palette.primary.main : 'transparent'};
  color: ${({ theme: theme, selected: selected })=>selected ? '#fff' : theme.palette.mode === 'dark' ? '#fff' : '#000'};
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    transform: scale(1.1);
    border-color: ${({ theme: theme })=>theme.palette.primary.main};
    background: ${({ theme: theme, selected: selected })=>selected ? theme.palette.primary.dark : theme.palette.action.hover};
  }

  svg {
    font-size: 1.2rem;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");


var $gTmRg = parcelRequire("gTmRg");

var $gOa8m = parcelRequire("gOa8m");

var $eqsnC = parcelRequire("eqsnC");

var $c3pId = parcelRequire("c3pId");
const $10a9248da45984df$var$projectColumns = [
    {
        id: 'name',
        label: 'Project',
        format: (name, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/user/${(0, $c3pId.default).user}/teams/${obj.name}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                    children: name
                })
            })
    },
    {
        id: 'nodes',
        label: 'Nodes',
        format: (nodes)=>nodes.length
    },
    {
        id: 'members',
        label: 'Members',
        format: (members, obj)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/user/${(0, $c3pId.default).user}/teams/${obj.name}`,
                children: members.length
            })
    }
];
function $10a9248da45984df$export$2e2bcd8739ae039({ projects: projects }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($10a9248da45984df$var$Section, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($10a9248da45984df$var$SectionHeader, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($10a9248da45984df$var$SectionTitle, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdbaae095ceb82e8$export$2e2bcd8739ae039), {}),
                                " My Projects"
                            ]
                        }),
                        projects && projects.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($10a9248da45984df$var$ViewAllLink, {
                            to: `/user/${(0, $c3pId.default).user}/projects`,
                            children: [
                                "View All ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e233ff9fb3408a34$export$2e2bcd8739ae039), {
                                    fontSize: "small"
                                })
                            ]
                        })
                    ]
                }),
                !projects ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eqsnC.default), {
                    noSearch: true,
                    rows: 3
                }) : projects.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                    primaryKey: "name",
                    columns: $10a9248da45984df$var$projectColumns,
                    rows: projects,
                    pagination: false,
                    enableSorting: false
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($10a9248da45984df$var$EmptyState, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($10a9248da45984df$var$EmptyIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cdbaae095ceb82e8$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "You're not part of any projects yet"
                        })
                    ]
                })
            ]
        })
    });
}
const $10a9248da45984df$var$Section = (0, $d8seH.default)('div')`
  /* Card styles handled by Card component */
`;
const $10a9248da45984df$var$SectionHeader = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
`;
const $10a9248da45984df$var$SectionTitle = (0, $d8seH.default)('h2')`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};

  svg {
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $10a9248da45984df$var$ViewAllLink = (0, $d8seH.default)((0, $lzNIT.Link))`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${({ theme: theme })=>theme.palette.primary.main};
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    gap: 0.5rem;
    text-decoration: underline;
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;
const $10a9248da45984df$var$EmptyState = (0, $d8seH.default)('div')`
  text-align: center;
  padding: 3rem 1rem;
  color: ${({ theme: theme })=>theme.palette.text.secondary};

  p {
    margin: 1rem 0;
    font-size: 1.1em;
  }

  a {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const $10a9248da45984df$var$EmptyIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 4em;
    opacity: 0.3;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");


var $gTmRg = parcelRequire("gTmRg");

var $gOa8m = parcelRequire("gOa8m");

var $eqsnC = parcelRequire("eqsnC");

const $f44dce222c7c8617$var$appColumns = [
    {
        id: 'name',
        label: 'App',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).name
    },
    {
        id: 'namespace',
        label: 'Namespace'
    },
    {
        id: 'versions',
        label: 'Tags',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).versions
    },
    {
        id: 'time_last_updated',
        label: 'Last Update',
        format: (0, $f446074e335acab0$export$fe98a034cfb96d55).time
    }
];
function $f44dce222c7c8617$export$2e2bcd8739ae039({ apps: apps }) {
    const [page, setPage] = (0, $acw62.useState)(0);
    const [search, setSearch] = (0, $acw62.useState)('');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f44dce222c7c8617$var$Section, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($f44dce222c7c8617$var$SectionHeader, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($f44dce222c7c8617$var$SectionTitle, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f151bb123da2b40c$export$2e2bcd8739ae039), {}),
                                " Recent Apps"
                            ]
                        }),
                        apps && apps.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($f44dce222c7c8617$var$ViewAllLink, {
                            to: "/apps/my-apps",
                            children: [
                                "View All ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e233ff9fb3408a34$export$2e2bcd8739ae039), {
                                    fontSize: "small"
                                })
                            ]
                        })
                    ]
                }),
                !apps ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eqsnC.default), {
                    noSearch: true,
                    rows: 3
                }) : apps.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                    primaryKey: "id",
                    enableSorting: true,
                    sort: "-time_last_updated",
                    columns: $f44dce222c7c8617$var$appColumns,
                    rows: apps,
                    pagination: true,
                    page: page,
                    onPage: (newPage)=>setPage(newPage),
                    rowsPerPage: 10,
                    limit: apps.length,
                    search: search,
                    onSearch: ({ query: query })=>setSearch(query),
                    middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($f44dce222c7c8617$var$EmptyState, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($f44dce222c7c8617$var$EmptyIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f151bb123da2b40c$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "You haven't created any apps yet"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                            to: "/apps/create-app",
                            children: "Create Your First App"
                        })
                    ]
                })
            ]
        })
    });
}
const $f44dce222c7c8617$var$Section = (0, $d8seH.default)('div')`
  /* Card styles handled by Card component */
`;
const $f44dce222c7c8617$var$SectionHeader = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
`;
const $f44dce222c7c8617$var$SectionTitle = (0, $d8seH.default)('h2')`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};

  svg {
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $f44dce222c7c8617$var$ViewAllLink = (0, $d8seH.default)((0, $lzNIT.Link))`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${({ theme: theme })=>theme.palette.primary.main};
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    gap: 0.5rem;
    text-decoration: underline;
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;
const $f44dce222c7c8617$var$EmptyState = (0, $d8seH.default)('div')`
  text-align: center;
  padding: 3rem 1rem;
  color: ${({ theme: theme })=>theme.palette.text.secondary};

  p {
    margin: 1rem 0;
    font-size: 1.1em;
  }

  a {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const $f44dce222c7c8617$var$EmptyIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 4em;
    opacity: 0.3;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $d8seH = parcelRequire("d8seH");


var $gTmRg = parcelRequire("gTmRg");

var $gOa8m = parcelRequire("gOa8m");

var $eqsnC = parcelRequire("eqsnC");

var $lffEs = parcelRequire("lffEs");
const $a2b854cc4e0aede1$var$jobColumns = [
    {
        id: 'name',
        label: 'Job',
        format: (val, row)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                to: `/jobs/my-jobs?job=${row.id}`,
                children: val
            })
    },
    {
        id: 'last_state',
        label: 'Status',
        format: (val)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                className: val.toLowerCase(),
                children: val || '-'
            });
        }
    },
    {
        id: 'nodes',
        label: 'Nodes',
        format: (nodes)=>nodes.length
    },
    {
        id: 'last_submitted',
        label: 'Submitted',
        format: (val)=>(0, $lffEs.relativeTime)(val) || '-'
    }
];
function $a2b854cc4e0aede1$export$2e2bcd8739ae039({ jobs: jobs }) {
    const [page, setPage] = (0, $acw62.useState)(0);
    const [search, setSearch] = (0, $acw62.useState)('');
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a2b854cc4e0aede1$var$Section, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($a2b854cc4e0aede1$var$SectionHeader, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($a2b854cc4e0aede1$var$SectionTitle, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfb67bbdcacf5fc3$export$2e2bcd8739ae039), {}),
                                " Recent Jobs"
                            ]
                        }),
                        jobs && jobs.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($a2b854cc4e0aede1$var$ViewAllLink, {
                            to: "/jobs/my-jobs",
                            children: [
                                "View All ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e233ff9fb3408a34$export$2e2bcd8739ae039), {
                                    fontSize: "small"
                                })
                            ]
                        })
                    ]
                }),
                !jobs ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eqsnC.default), {
                    noSearch: true,
                    rows: 3
                }) : jobs.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gOa8m.default), {
                    primaryKey: "id",
                    enableSorting: true,
                    sort: "-last_submitted",
                    columns: $a2b854cc4e0aede1$var$jobColumns,
                    rows: jobs,
                    pagination: true,
                    page: page,
                    onPage: (newPage)=>setPage(newPage),
                    rowsPerPage: 10,
                    limit: jobs.length,
                    search: search,
                    onSearch: ({ query: query })=>setSearch(query),
                    middleComponent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($a2b854cc4e0aede1$var$EmptyState, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($a2b854cc4e0aede1$var$EmptyIcon, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfb67bbdcacf5fc3$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "You haven't submitted any jobs yet"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                            to: "/jobs/create-job",
                            children: "Create Your First Job"
                        })
                    ]
                })
            ]
        })
    });
}
const $a2b854cc4e0aede1$var$Section = (0, $d8seH.default)('div')`
  /* Card styles handled by Card component */
`;
const $a2b854cc4e0aede1$var$SectionHeader = (0, $d8seH.default)('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#444' : '#e0e0e0'};
`;
const $a2b854cc4e0aede1$var$SectionTitle = (0, $d8seH.default)('h2')`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25em;
  color: ${({ theme: theme })=>theme.palette.mode === 'dark' ? '#fff' : '#333'};

  svg {
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $a2b854cc4e0aede1$var$ViewAllLink = (0, $d8seH.default)((0, $lzNIT.Link))`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${({ theme: theme })=>theme.palette.primary.main};
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    gap: 0.5rem;
    text-decoration: underline;
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;
const $a2b854cc4e0aede1$var$EmptyState = (0, $d8seH.default)('div')`
  text-align: center;
  padding: 3rem 1rem;
  color: ${({ theme: theme })=>theme.palette.text.secondary};

  p {
    margin: 1rem 0;
    font-size: 1.1em;
  }

  a {
    color: ${({ theme: theme })=>theme.palette.primary.main};
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;
const $a2b854cc4e0aede1$var$EmptyIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 4em;
    opacity: 0.3;
  }
`;



var $9bsRS = parcelRequire("9bsRS");

var $atFJM = parcelRequire("atFJM");

var $b8Rua = parcelRequire("b8Rua");

var $c3pId = parcelRequire("c3pId");
function $6a23ed8dc177e518$export$2e2bcd8739ae039() {
    const { setLoading: setLoading } = (0, $c8fd8a7dca6d4c4c$export$d1a23c2d08bafe4a)();
    const [allNodes, setAllNodes] = (0, $acw62.useState)();
    const [projects, setProjects] = (0, $acw62.useState)();
    const [apps, setApps] = (0, $acw62.useState)();
    const [userJobs, setUserJobs] = (0, $acw62.useState)();
    const [allJobs, setAllJobs] = (0, $acw62.useState)();
    const [sensors, setSensors] = (0, $acw62.useState)();
    const [projectFilter, setProjectFilter] = (0, $acw62.useState)('all');
    const [selectedNodes, setSelectedNodes] = (0, $acw62.useState)([]);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!(0, $c3pId.default).isSignedIn) return;
        setLoading(true);
        // Fetch user nodes and projects (includes access info)
        const p1 = $9bsRS.getUserNodesAndProjects().then(({ nodes: nodes, projects: projects })=>{
            setAllNodes(nodes);
            setProjects(projects);
        }).catch((err)=>setError(err));
        // Fetch apps
        const p2 = $atFJM.listApps('mine').then((data)=>setApps(data)).catch((err)=>setError(err));
        // Fetch jobs
        const p3 = $b8Rua.getJobs().then((data)=>{
            const userJobs = data.filter((job)=>job.user === (0, $c3pId.default).user);
            setUserJobs(userJobs);
        }).catch((err)=>setError(err));
        // Fetch sensors - will be filtered by user's nodes after nodes are loaded
        const p4 = $9bsRS.getSensors().then((data)=>setSensors(data)).catch((err)=>setError(err));
        Promise.all([
            p1,
            p2,
            p3,
            p4
        ]).finally(()=>setLoading(false));
    }, [
        setLoading
    ]);
    // Calculate stats
    const uniqueNodes = allNodes?.length;
    const totalProjects = projects?.length;
    const uniqueMembers = projects ? new Set(projects.flatMap((p)=>p.members.map((m)=>m.username))).size : undefined;
    const totalApps = apps?.length;
    const activeJobs = userJobs?.filter((job)=>{
        const status = job.state.last_state?.toLowerCase();
        return status === 'scheduled' || status === 'running';
    }).length;
    const totalJobs = userJobs?.length;
    const statsLoading = [
        uniqueNodes,
        totalProjects,
        uniqueMembers,
        totalApps,
        activeJobs,
        totalJobs
    ].some((value)=>value === undefined);
    const achievementsLoading = [
        totalApps,
        totalJobs,
        uniqueNodes,
        totalProjects
    ].some((value)=>value === undefined);
    const filteredNodes = allNodes?.filter((node)=>{
        if (projectFilter === 'all') return true;
        return node.project?.includes(projectFilter);
    });
    const filteredNodeVSNs = new Set(filteredNodes?.map((node)=>node.vsn) || []);
    const filteredSensors = sensors?.filter((sensor)=>sensor.vsns.some((vsn)=>filteredNodeVSNs.has(vsn)));
    const filteredAllJobs = allJobs?.filter((job)=>job.nodes.some((vsn)=>filteredNodeVSNs.has(vsn)));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($6a23ed8dc177e518$var$Root, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($6a23ed8dc177e518$var$TopSection, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($6a23ed8dc177e518$var$LeftColumn, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($6a23ed8dc177e518$var$Header, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6a23ed8dc177e518$var$HeaderIcon, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5dd29340d28cbf56$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                    className: "no-margin",
                                                    children: "Dashboard"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)($6a23ed8dc177e518$var$Subtitle, {
                                                    children: [
                                                        "Welcome back, ",
                                                        (0, $c3pId.default).user
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                error && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hw4Z0.default), {
                                    children: error.message
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e684b54e49027cf9$export$2e2bcd8739ae039), {
                                    uniqueNodes: uniqueNodes,
                                    totalProjects: totalProjects,
                                    uniqueMembers: uniqueMembers,
                                    totalApps: totalApps,
                                    activeJobs: activeJobs,
                                    totalJobs: totalJobs,
                                    loading: statsLoading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2de34d652b9d823f$export$2e2bcd8739ae039), {
                            totalApps: totalApps,
                            totalJobs: totalJobs,
                            uniqueNodes: uniqueNodes,
                            totalProjects: totalProjects,
                            loading: achievementsLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a38e88dd70564f3$export$2e2bcd8739ae039), {
                    allNodes: selectedNodes.length > 0 ? selectedNodes : filteredNodes,
                    allJobs: filteredAllJobs,
                    projectFilter: projectFilter,
                    onProjectFilterChange: setProjectFilter,
                    allNodesCount: allNodes?.length ?? 0,
                    sageNodesCount: allNodes?.filter((n)=>n.project?.includes('SAGE')).length,
                    sgtNodesCount: allNodes?.filter((n)=>n.project?.includes('SGT')).length
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d00c69d97a43e01$export$2e2bcd8739ae039), {
                    allNodes: filteredNodes,
                    sensors: filteredSensors,
                    projectFilter: projectFilter,
                    onProjectFilterChange: setProjectFilter,
                    onNodeSelect: setSelectedNodes,
                    allNodesCount: allNodes?.length ?? 0,
                    sageNodesCount: allNodes?.filter((n)=>n.project?.includes('SAGE')).length,
                    sgtNodesCount: allNodes?.filter((n)=>n.project?.includes('SGT')).length
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c44972b00cb09b56$export$2e2bcd8739ae039), {
                    columns: {
                        xs: 1,
                        sm: 1,
                        md: 2,
                        lg: 2
                    },
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10a9248da45984df$export$2e2bcd8739ae039), {
                            projects: projects
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f44dce222c7c8617$export$2e2bcd8739ae039), {
                            apps: apps
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a2b854cc4e0aede1$export$2e2bcd8739ae039), {
                            jobs: userJobs
                        })
                    ]
                })
            ]
        })
    });
}
const $6a23ed8dc177e518$var$Root = (0, $d8seH.default)('div')`
  max-width: 1400px;
  margin: 2rem auto;
  padding: 0 2rem;
`;
const $6a23ed8dc177e518$var$TopSection = (0, $d8seH.default)('div')`
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;

  @media (max-width: 1200px) {
    flex-direction: column;
  }
`;
const $6a23ed8dc177e518$var$LeftColumn = (0, $d8seH.default)('div')`
  flex: 1;
`;
const $6a23ed8dc177e518$var$Header = (0, $d8seH.default)('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;
const $6a23ed8dc177e518$var$HeaderIcon = (0, $d8seH.default)('div')`
  svg {
    font-size: 3em;
    color: ${({ theme: theme })=>theme.palette.primary.main};
  }
`;
const $6a23ed8dc177e518$var$Subtitle = (0, $d8seH.default)('p')`
  margin: 0.5rem 0 0 0;
  color: ${({ theme: theme })=>theme.palette.text.secondary};
  font-size: 1.1em;
`;



var $ayMG0 = parcelRequire("ayMG0");

var $lmFrL = parcelRequire("lmFrL");

var $gTmRg = parcelRequire("gTmRg");
function $f3d30a1fbc683787$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3d30a1fbc683787$var$Root, {
        children: [
            (0, $gTmRg.CardViewStyle),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gTmRg.Card), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        children: "Object Storage Example (W06C)"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: "https://storage.sagecontinuum.org/api/v1/data/imagesampler-top-2687/sage-imagesampler-top-0.3.7/000048b02d3ae335/1739206807613290074-sample.jpg"
                    })
                ]
            })
        ]
    });
}
const $f3d30a1fbc683787$var$Root = (0, $lmFrL.default).div`
  margin: 2rem;
  max-width: 400px;

  img {
    max-width: 350px;
  }
`;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $iAtns = parcelRequire("iAtns");

var $6lXkL = parcelRequire("6lXkL");

var $c3pId = parcelRequire("c3pId");
function $d795bcc4d6c6d898$export$2e2bcd8739ae039() {
    const location = (0, $aphAM.useLocation)();
    const params = new URLSearchParams(location.search);
    const [user, setUser] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [token, setToken] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleSignIn = ()=>{
        const redirectPath = params.get('callback');
        setLoading(true);
        setTimeout(()=>{
            setLoading(false);
            (0, $c3pId.default).signIn(user, token);
            window.location.href = redirectPath || '/';
        }, 1000);
    };
    const handleSignOut = ()=>{
        setLoading(true);
        setTimeout(()=>{
            setLoading(false);
            (0, $c3pId.default).signOut();
            window.location.href = '/';
        }, 1000);
    };
    const isValid = ()=>user && token;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d795bcc4d6c6d898$var$Root, {
        className: "flex column items-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                            children: "This is a sign-in page for testing and debugging"
                        }),
                        ".",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        !(0, $c3pId.default).isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                "Go ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                        href: `${(0, $c3pId.default).url}/token`,
                                        target: "__target",
                                        rel: "noreferrer",
                                        children: "here"
                                    })
                                }),
                                " to get a token and paste it below."
                            ]
                        })
                    ]
                }),
                (0, $c3pId.default).isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: "You are already signed in."
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex column",
                    children: !(0, $c3pId.default).isSignedIn ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                id: "sage-debug-username",
                                label: "Username",
                                onChange: (evt)=>setUser(evt.target.value)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iAtns.default), {
                                id: "sage-debug-token",
                                label: "Sage Token",
                                onChange: (evt)=>setToken(evt.target.value),
                                type: "password"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                                variant: "contained",
                                color: "primary",
                                onClick: handleSignIn,
                                disabled: loading || !isValid(),
                                type: "submit",
                                children: loading ? 'Signing in...' : 'Sign In'
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6lXkL.default), {
                        variant: "contained",
                        color: "primary",
                        onClick: handleSignOut,
                        disabled: loading,
                        type: "submit",
                        children: loading ? 'Signing out...' : 'Sign Out'
                    })
                })
            ]
        })
    });
}
const $d795bcc4d6c6d898$var$Root = (0, $lmFrL.default).form`
  margin-top: 100px;
  > div {
    max-width: 325px;
  }
`;



var $ayMG0 = parcelRequire("ayMG0");


var $lmFrL = parcelRequire("lmFrL");
function $b4d72c9948853b06$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($b4d72c9948853b06$var$Root, {
        className: "flex align-center column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "bee",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15b87fc16f8d46d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Page Not Found"
            })
        ]
    });
}
const $b4d72c9948853b06$var$Root = (0, $lmFrL.default).div`
  margin-top: 2em;
  font-size: 2rem;
  text-align: center;
  color: #666;

  .bee svg {
    max-width: 300px;
  }
`;





var $24m81 = parcelRequire("24m81");

var $ijOKP = parcelRequire("ijOKP");
const $1db4fd20a937470c$var$theme = (0, $ijOKP.default)({
    defaultColorScheme: 'light',
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    main: 'rgb(28, 140, 201)'
                },
                secondary: {
                    main: '#8166a0'
                },
                success: {
                    main: '#3ac37e'
                }
            }
        },
        dark: {
            palette: {
                primary: {
                    main: 'rgb(28, 140, 201)'
                },
                secondary: {
                    main: '#8166a0'
                },
                success: {
                    main: '#3ac37e'
                },
                background: {
                    default: '#121212'
                }
            }
        }
    },
    typography: {
        fontFamily: [
            'Roboto'
        ].join(','),
        button: {
            textTransform: 'none',
            fontWeight: 800
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1750
        }
    },
    components: {
        MuiCard: {
            defaultProps: {
                variant: 'outlined'
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: ({ theme: theme })=>({
                        borderBottom: `1px solid ${theme.palette.divider}`
                    })
            }
        },
        MuiTab: {
            styleOverrides: {
                root: ({ theme: theme })=>({
                        fontWeight: 500,
                        '&:not(.Mui-selected):hover': {
                            color: theme.palette.text.primary,
                            opacity: 1
                        }
                    })
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            },
            styleOverrides: {
                root: {
                    textTransform: 'none'
                }
            }
        },
        MuiButton: {
            defaultProps: {
                size: 'small',
                disableRipple: true
            }
        },
        MuiIconButton: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiButtonGroup: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiToggleButtonGroup: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiToggleButton: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiFab: {
            defaultProps: {
                disableRipple: true
            }
        },
        MuiSelect: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
                variant: 'outlined'
            }
        },
        MuiOutlinedInput: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiChip: {
            defaultProps: {
                size: 'small',
                variant: 'outlined'
            }
        },
        MuiRadio: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiMenu: {
            defaultProps: {
                transitionDuration: 50
            }
        },
        MuiIcon: {
            defaultProps: {
                baseClassName: 'material-icons-rounded'
            }
        }
    }
});
var $1db4fd20a937470c$export$2e2bcd8739ae039 = $1db4fd20a937470c$var$theme;




var $c3pId = parcelRequire("c3pId");

var $aQAPf = parcelRequire("aQAPf");

var $iwiZ3 = parcelRequire("iwiZ3");

var $gZwVy = parcelRequire("gZwVy");

const $f3274cded2e13394$var$CreateJob = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("gDTZY")));
const { project: $f3274cded2e13394$var$project } = (0, $aQAPf.default);
const $f3274cded2e13394$var$NavMenu = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $83644c50bf14ec8d$export$698668688a6e8f34), {
        children: [
            (0, $c3pId.default).isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: "Dash",
                to: `/user/${(0, $c3pId.default).user}/dash`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: "Nodes",
                to: (0, $c3pId.default).isSignedIn ? `/user/${(0, $c3pId.default).user}/nodes` : '/nodes'
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: "App Catalog",
                root: "/apps",
                to: "/apps",
                menu: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71802778b2667a33$exports))), {}),
                            to: "/apps/explore",
                            label: "Public Apps"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a61247555e1f801a$exports))), {}),
                            to: "/apps/my-apps",
                            label: "My Apps"
                        }),
                        (0, $c3pId.default).isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a7ni))), {}),
                            to: "/apps/create-app",
                            label: "Create App"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: "Job Status",
                root: "/jobs",
                to: "/jobs",
                menu: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dfa080570050ea5e$exports))), {}),
                            to: "/jobs/all-jobs",
                            label: "Job Status"
                        }),
                        (0, $c3pId.default).isSignedIn && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c12e6d014cf6703a$exports))), {}),
                                    to: "/jobs/my-jobs",
                                    label: "My Jobs"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a7ni))), {}),
                                    to: "/jobs/create-job",
                                    label: "Create Job"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$2e2bcd8739ae039), {
                label: "Data",
                root: "/data",
                to: "/data",
                menu: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c36a0b95bd5999f0$exports))), {}),
                            to: "/data",
                            label: "Data"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1cc5f44952a47e0c$export$6d08773d2e66f8f2), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($45d7836043133042$exports))), {}),
                            to: "/query-browser",
                            label: "Query Browser"
                        })
                    ]
                })
            })
        ]
    });
};
function $f3274cded2e13394$export$2e2bcd8739ae039() {
    const [notice, setNotice] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if ((0, $gZwVy.default).notice) // Use notice from config if available
        setNotice((0, $gZwVy.default).notice);
        else if ((0, $gZwVy.default).noticeURL) // Fetch notice from external URL if provided
        fetch((0, $gZwVy.default).noticeURL).then((res)=>res.json()).then((data)=>{
            if (data.message) setNotice(data);
        }).catch((err)=>console.error('Error fetching notice:', err));
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2BuCw.default), {
        injectFirst: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c4650f6dac4940cb$export$2e2bcd8739ae039), {
            theme: (0, $1db4fd20a937470c$export$2e2bcd8739ae039),
            defaultMode: "light",
            noSsr: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c3dfe91526ac04a1$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $lzNIT.BrowserRouter), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83644c50bf14ec8d$export$2e2bcd8739ae039), {
                            menu: /*#__PURE__*/ (0, $ayMG0.jsx)($f3274cded2e13394$var$NavMenu, {}),
                            hasSignIn: true,
                            hasDocsLink: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0ad5317c8f9b9985$export$86d2c930e35495d7), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24m81.SnackbarProvider), {
                                autoHideDuration: 3000,
                                preventDuplicate: true,
                                maxSnack: 2,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f3274cded2e13394$var$Container, {
                                    children: [
                                        notice && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iwiZ3.default), {
                                            severity: notice.severity || 'info',
                                            onClose: ()=>setNotice(null),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                                children: notice.message
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8fd8a7dca6d4c4c$export$17a35283f282d18), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                        path: "/",
                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                                            to: "nodes",
                                                            replace: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                                        path: "/",
                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $867b44e0261e6ba0$export$2e2bcd8739ae039), {}),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                                                path: "/",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $750b876e77c164e1$export$2e2bcd8739ae039), {}),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "nodes",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4f0e9a82b16d72b$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "nodes/all",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4f0e9a82b16d72b$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "nodes/all/:sageProject?",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4f0e9a82b16d72b$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "nodes/project/:sageProject?",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4f0e9a82b16d72b$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "sensors",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71dc2bf61474117d$export$2e2bcd8739ae039), {
                                                                            project: $f3274cded2e13394$var$project
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "user/:user/dash",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a23ed8dc177e518$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "user/:user/nodes",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4f0e9a82b16d72b$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "user/:user/nodes/project/:sageProject?",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4f0e9a82b16d72b$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "user/:user/projects",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $27766c631fd74b2e$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "user/:user/teams",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b1f947cb2d9e882$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "user/:user/teams/:projectName",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $193d7b6255cae44e$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "sensors/:name",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93a51680713d9647$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "nodes/:vsn",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c17cd402450ea43c$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "/apps",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                                                    to: "/apps/explore",
                                                                    replace: true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                                                path: "apps",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f91e9bd3d93eda6$export$2e2bcd8739ae039), {}),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "explore",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9455821df5564e7d$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "app/*",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4688a1d9d0979e6$export$2e2bcd8739ae039), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "my-apps",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9455821df5564e7d$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "create-app",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $524e274d44800e0c$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "/jobs",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
                                                                    to: "/jobs/all-jobs",
                                                                    replace: true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                                                path: "jobs",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20369f58c098d908$export$2e2bcd8739ae039), {}),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "create-job",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                                                                            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $90dbddc73f95e2b7$export$2e2bcd8739ae039), {}),
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($f3274cded2e13394$var$CreateJob, {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: ":view",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d03a7c5535c78ec$export$2e2bcd8739ae039), {})
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "data",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4cab315b36f812e1$export$2e2bcd8739ae039), {
                                                                    project: $f3274cded2e13394$var$project
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "data/ontology/:name",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14f76242ad4aa484$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "data/product/:name",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fef0d6ee86b04e1$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "query-browser",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2c916c2a79797e4e$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "/labs/image-search",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $975da745907a28b3$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "data-commons-demo",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea155c15c24a7a5a$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aphAM.Route), {
                                                                path: "account",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8cea67cf45aa799d$export$2e2bcd8739ae039), {})
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "profile",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c6130e916277360$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "nodes",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7dc3874497ed1111$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "dev-devices",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $195dc6a88faff539$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                        path: "access",
                                                                        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3782c15d916769b6$export$2e2bcd8739ae039), {})
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "request-allocation",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5690f41a9afaa56f$export$2e2bcd8739ae039), {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2a7ba9b3a050904$export$2e2bcd8739ae039), {})
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "assistant",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31ce2fc7a5cf14e5$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "fiddle/test-download",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3d30a1fbc683787$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "login",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d795bcc4d6c6d898$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Route), {
                                                                path: "*",
                                                                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4d72c9948853b06$export$2e2bcd8739ae039), {})
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $f3274cded2e13394$var$Container = (0, $lmFrL.default).div`
  margin: 60px 0 0 0;
  width: 100%;
`;
/* mocking data example, using msw
async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  const { worker } = await import('/mocks/browser')

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  await worker.start()
}

enableMocking().then(() => {
  ReactDom.render(<Sage />, document.getElementById('app'))
})
*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ (0, $ayMG0.jsx)($f3274cded2e13394$export$2e2bcd8739ae039, {}), document.getElementById('app'));


//# sourceMappingURL=sage.6470590a.js.map
